
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Mgq5A", function(module, exports) {
var $9ba73e942417f85a$export$ab58f948d2b5b95c = /*#__PURE__*/ function(FAILURE_REASON) {
    FAILURE_REASON["API_FAIL"] = "api fail";
    FAILURE_REASON["AUP_VIOLATION"] = "aup violation detected";
    FAILURE_REASON["UNKNOWN"] = "unknown fail";
    FAILURE_REASON["TOKEN_LIMIT"] = "token limit fail";
    FAILURE_REASON["INSERT_FAILURE"] = "insert failure";
    FAILURE_REASON["INPUT_TOO_SHORT"] = "input too short fail";
    FAILURE_REASON["HIPAA_CONTENT"] = "hipaa content fail";
    FAILURE_REASON["RATE_LIMITED"] = "rate limited";
    FAILURE_REASON["INTERNAL_SERVER_ERROR"] = "internal server error";
    FAILURE_REASON["ELEVATE_DISABLED_GENERATE"] = "elevate disabled generate";
    FAILURE_REASON["ADF_STREAMING_ERROR"] = "adf streaming error";
    FAILURE_REASON["NO_TEXTUAL_CONTENT"] = "no textual content";
    FAILURE_REASON["INVALID_JSON"] = "invalid json";
    return FAILURE_REASON;
}({});
module.exports["FAILURE_REASON"] = $9ba73e942417f85a$export$ab58f948d2b5b95c;

});

parcelRegister("aAERY", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $hD7pG = parcelRequire("hD7pG");


var $3ztIq = parcelRequire("3ztIq");


var $2lPWP = parcelRequire("2lPWP");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

class $f930a855a56e9d20$export$7f66e9a3d953663f extends Error {
    constructor(message, position){
        super(`${message} at position ${position}`);
        this.position = position;
    }
}


const $19e2a6b684c245a0$var$codeSpace = 0x20; // " "
const $19e2a6b684c245a0$var$codeNewline = 0xa; // "\n"
const $19e2a6b684c245a0$var$codeTab = 0x9; // "\t"
const $19e2a6b684c245a0$var$codeReturn = 0xd; // "\r"
const $19e2a6b684c245a0$var$codeNonBreakingSpace = 0xa0;
const $19e2a6b684c245a0$var$codeEnQuad = 0x2000;
const $19e2a6b684c245a0$var$codeHairSpace = 0x200a;
const $19e2a6b684c245a0$var$codeNarrowNoBreakSpace = 0x202f;
const $19e2a6b684c245a0$var$codeMediumMathematicalSpace = 0x205f;
const $19e2a6b684c245a0$var$codeIdeographicSpace = 0x3000;
function $19e2a6b684c245a0$export$8a9b6341a7c96bc(char) {
    return /^[0-9A-Fa-f]$/.test(char);
}
function $19e2a6b684c245a0$export$727d9dbc4fbb948f(char) {
    return char >= '0' && char <= '9';
}
function $19e2a6b684c245a0$export$dbbf36b4f6aa0d0f(char) {
    // note that the valid range is between \u{0020} and \u{10ffff},
    // but in JavaScript it is not possible to create a code point larger than
    // \u{10ffff}, so there is no need to test for that here.
    return char >= '\u0020';
}
function $19e2a6b684c245a0$export$86c7871da6bb7199(char) {
    return ',:[]/{}()\n+'.includes(char);
}
function $19e2a6b684c245a0$export$a9f938b686e06012(char) {
    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$';
}
function $19e2a6b684c245a0$export$8a15811e203445b5(char) {
    return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z' || char === '_' || char === '$' || char >= '0' && char <= '9';
}
const $19e2a6b684c245a0$export$c158d3099d715644 = /^(http|https|ftp|mailto|file|data|irc):\/\/$/;
const $19e2a6b684c245a0$export$7a3bbad2a762c5dc = /^[A-Za-z0-9-._~:/?#@!$&'()*+;=]$/;
function $19e2a6b684c245a0$export$5bb406697483408c(char) {
    return ',[]/{}\n+'.includes(char);
}
function $19e2a6b684c245a0$export$b04a8912877de42a(char) {
    return $19e2a6b684c245a0$export$6941feaafb12fc71(char) || $19e2a6b684c245a0$var$regexStartOfValue.test(char);
}
// alpha, number, minus, or opening bracket or brace
const $19e2a6b684c245a0$var$regexStartOfValue = /^[[{\w-]$/;
function $19e2a6b684c245a0$export$d4061b5fcfc97271(char) {
    return char === '\n' || char === '\r' || char === '\t' || char === '\b' || char === '\f';
}
function $19e2a6b684c245a0$export$a1ed01a3e6d5a08c(text, index) {
    const code = text.charCodeAt(index);
    return code === $19e2a6b684c245a0$var$codeSpace || code === $19e2a6b684c245a0$var$codeNewline || code === $19e2a6b684c245a0$var$codeTab || code === $19e2a6b684c245a0$var$codeReturn;
}
function $19e2a6b684c245a0$export$f1a13bc8c1848c88(text, index) {
    const code = text.charCodeAt(index);
    return code === $19e2a6b684c245a0$var$codeSpace || code === $19e2a6b684c245a0$var$codeTab || code === $19e2a6b684c245a0$var$codeReturn;
}
function $19e2a6b684c245a0$export$33a40d1f05d81339(text, index) {
    const code = text.charCodeAt(index);
    return code === $19e2a6b684c245a0$var$codeNonBreakingSpace || code >= $19e2a6b684c245a0$var$codeEnQuad && code <= $19e2a6b684c245a0$var$codeHairSpace || code === $19e2a6b684c245a0$var$codeNarrowNoBreakSpace || code === $19e2a6b684c245a0$var$codeMediumMathematicalSpace || code === $19e2a6b684c245a0$var$codeIdeographicSpace;
}
function $19e2a6b684c245a0$export$6941feaafb12fc71(char) {
    // the first check double quotes, since that occurs most often
    return $19e2a6b684c245a0$export$c90a32a645344adf(char) || $19e2a6b684c245a0$export$c7f0196107e4b230(char);
}
function $19e2a6b684c245a0$export$c90a32a645344adf(char) {
    return char === '"' || char === '\u201c' || char === '\u201d';
}
function $19e2a6b684c245a0$export$5c8e8205aa3e3b6(char) {
    return char === '"';
}
function $19e2a6b684c245a0$export$c7f0196107e4b230(char) {
    return char === "'" || char === '\u2018' || char === '\u2019' || char === '\u0060' || char === '\u00b4';
}
function $19e2a6b684c245a0$export$37fd706cc430e444(char) {
    return char === "'";
}
function $19e2a6b684c245a0$export$5eb0648ae3c2ee22(text, textToStrip) {
    let stripRemainingText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const index = text.lastIndexOf(textToStrip);
    return index !== -1 ? text.substring(0, index) + (stripRemainingText ? '' : text.substring(index + 1)) : text;
}
function $19e2a6b684c245a0$export$eca8654175d9510(text, textToInsert) {
    let index = text.length;
    if (!$19e2a6b684c245a0$export$a1ed01a3e6d5a08c(text, index - 1)) // no trailing whitespaces
    return text + textToInsert;
    while($19e2a6b684c245a0$export$a1ed01a3e6d5a08c(text, index - 1))index--;
    return text.substring(0, index) + textToInsert + text.substring(index);
}
function $19e2a6b684c245a0$export$a4b863a4658d38a8(text, start, count) {
    return text.substring(0, start) + text.substring(start + count);
}
function $19e2a6b684c245a0$export$c5b16edfd4cd7cdf(text) {
    return /[,\n][ \t\r]*$/.test(text);
}


const $50773bd7364e2885$var$controlCharacters = {
    '\b': '\\b',
    '\f': '\\f',
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t'
};
// map with all escape characters
const $50773bd7364e2885$var$escapeCharacters = {
    '"': '"',
    '\\': '\\',
    '/': '/',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
};
function $50773bd7364e2885$export$b7f9abe9df7056b9(text) {
    let i = 0; // current index in text
    let output = ''; // generated output
    parseMarkdownCodeBlock([
        '```',
        '[```',
        '{```'
    ]);
    const processed = parseValue();
    if (!processed) throwUnexpectedEnd();
    parseMarkdownCodeBlock([
        '```',
        '```]',
        '```}'
    ]);
    const processedComma = parseCharacter(',');
    if (processedComma) parseWhitespaceAndSkipComments();
    if ((0, $19e2a6b684c245a0$export$b04a8912877de42a)(text[i]) && (0, $19e2a6b684c245a0$export$c5b16edfd4cd7cdf)(output)) {
        // start of a new value after end of the root level object: looks like
        // newline delimited JSON -> turn into a root level array
        if (!processedComma) // repair missing comma
        output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ',');
        parseNewlineDelimitedJSON();
    } else if (processedComma) // repair: remove trailing comma
    output = (0, $19e2a6b684c245a0$export$5eb0648ae3c2ee22)(output, ',');
    // repair redundant end quotes
    while(text[i] === '}' || text[i] === ']'){
        i++;
        parseWhitespaceAndSkipComments();
    }
    if (i >= text.length) // reached the end of the document properly
    return output;
    throwUnexpectedCharacter();
    function parseValue() {
        parseWhitespaceAndSkipComments();
        const processed = parseObject() || parseArray() || parseString() || parseNumber() || parseKeywords() || parseUnquotedString(false) || parseRegex();
        parseWhitespaceAndSkipComments();
        return processed;
    }
    function parseWhitespaceAndSkipComments() {
        let skipNewline = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        const start = i;
        let changed = parseWhitespace(skipNewline);
        do {
            changed = parseComment();
            if (changed) changed = parseWhitespace(skipNewline);
        }while (changed);
        return i > start;
    }
    function parseWhitespace(skipNewline) {
        const _isWhiteSpace = skipNewline ? (0, $19e2a6b684c245a0$export$a1ed01a3e6d5a08c) : (0, $19e2a6b684c245a0$export$f1a13bc8c1848c88);
        let whitespace = '';
        while(true){
            if (_isWhiteSpace(text, i)) {
                whitespace += text[i];
                i++;
            } else if ((0, $19e2a6b684c245a0$export$33a40d1f05d81339)(text, i)) {
                // repair special whitespace
                whitespace += ' ';
                i++;
            } else break;
        }
        if (whitespace.length > 0) {
            output += whitespace;
            return true;
        }
        return false;
    }
    function parseComment() {
        // find a block comment '/* ... */'
        if (text[i] === '/' && text[i + 1] === '*') {
            // repair block comment by skipping it
            while(i < text.length && !$50773bd7364e2885$var$atEndOfBlockComment(text, i))i++;
            i += 2;
            return true;
        }
        // find a line comment '// ...'
        if (text[i] === '/' && text[i + 1] === '/') {
            // repair line comment by skipping it
            while(i < text.length && text[i] !== '\n')i++;
            return true;
        }
        return false;
    }
    function parseMarkdownCodeBlock(blocks) {
        // find and skip over a Markdown fenced code block:
        //     ``` ... ```
        // or
        //     ```json ... ```
        if (skipMarkdownCodeBlock(blocks)) {
            if ((0, $19e2a6b684c245a0$export$a9f938b686e06012)(text[i])) // strip the optional language specifier like "json"
            while(i < text.length && (0, $19e2a6b684c245a0$export$8a15811e203445b5)(text[i]))i++;
            parseWhitespaceAndSkipComments();
            return true;
        }
        return false;
    }
    function skipMarkdownCodeBlock(blocks) {
        parseWhitespace(true);
        for (const block of blocks){
            const end = i + block.length;
            if (text.slice(i, end) === block) {
                i = end;
                return true;
            }
        }
        return false;
    }
    function parseCharacter(char) {
        if (text[i] === char) {
            output += text[i];
            i++;
            return true;
        }
        return false;
    }
    function skipCharacter(char) {
        if (text[i] === char) {
            i++;
            return true;
        }
        return false;
    }
    function skipEscapeCharacter() {
        return skipCharacter('\\');
    }
    /**
   * Skip ellipsis like "[1,2,3,...]" or "[1,2,3,...,9]" or "[...,7,8,9]"
   * or a similar construct in objects.
   */ function skipEllipsis() {
        parseWhitespaceAndSkipComments();
        if (text[i] === '.' && text[i + 1] === '.' && text[i + 2] === '.') {
            // repair: remove the ellipsis (three dots) and optionally a comma
            i += 3;
            parseWhitespaceAndSkipComments();
            skipCharacter(',');
            return true;
        }
        return false;
    }
    /**
   * Parse an object like '{"key": "value"}'
   */ function parseObject() {
        if (text[i] === '{') {
            output += '{';
            i++;
            parseWhitespaceAndSkipComments();
            // repair: skip leading comma like in {, message: "hi"}
            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
            let initial = true;
            while(i < text.length && text[i] !== '}'){
                let processedComma;
                if (!initial) {
                    processedComma = parseCharacter(',');
                    if (!processedComma) // repair missing comma
                    output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ',');
                    parseWhitespaceAndSkipComments();
                } else {
                    processedComma = true;
                    initial = false;
                }
                skipEllipsis();
                const processedKey = parseString() || parseUnquotedString(true);
                if (!processedKey) {
                    if (text[i] === '}' || text[i] === '{' || text[i] === ']' || text[i] === '[' || text[i] === undefined) // repair trailing comma
                    output = (0, $19e2a6b684c245a0$export$5eb0648ae3c2ee22)(output, ',');
                    else throwObjectKeyExpected();
                    break;
                }
                parseWhitespaceAndSkipComments();
                const processedColon = parseCharacter(':');
                const truncatedText = i >= text.length;
                if (!processedColon) {
                    if ((0, $19e2a6b684c245a0$export$b04a8912877de42a)(text[i]) || truncatedText) // repair missing colon
                    output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ':');
                    else throwColonExpected();
                }
                const processedValue = parseValue();
                if (!processedValue) {
                    if (processedColon || truncatedText) // repair missing object value
                    output += 'null';
                    else throwColonExpected();
                }
            }
            if (text[i] === '}') {
                output += '}';
                i++;
            } else // repair missing end bracket
            output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, '}');
            return true;
        }
        return false;
    }
    /**
   * Parse an array like '["item1", "item2", ...]'
   */ function parseArray() {
        if (text[i] === '[') {
            output += '[';
            i++;
            parseWhitespaceAndSkipComments();
            // repair: skip leading comma like in [,1,2,3]
            if (skipCharacter(',')) parseWhitespaceAndSkipComments();
            let initial = true;
            while(i < text.length && text[i] !== ']'){
                if (!initial) {
                    const processedComma = parseCharacter(',');
                    if (!processedComma) // repair missing comma
                    output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ',');
                } else initial = false;
                skipEllipsis();
                const processedValue = parseValue();
                if (!processedValue) {
                    // repair trailing comma
                    output = (0, $19e2a6b684c245a0$export$5eb0648ae3c2ee22)(output, ',');
                    break;
                }
            }
            if (text[i] === ']') {
                output += ']';
                i++;
            } else // repair missing closing array bracket
            output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ']');
            return true;
        }
        return false;
    }
    /**
   * Parse and repair Newline Delimited JSON (NDJSON):
   * multiple JSON objects separated by a newline character
   */ function parseNewlineDelimitedJSON() {
        // repair NDJSON
        let initial = true;
        let processedValue = true;
        while(processedValue){
            if (!initial) {
                // parse optional comma, insert when missing
                const processedComma = parseCharacter(',');
                if (!processedComma) // repair: add missing comma
                output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, ',');
            } else initial = false;
            processedValue = parseValue();
        }
        if (!processedValue) // repair: remove trailing comma
        output = (0, $19e2a6b684c245a0$export$5eb0648ae3c2ee22)(output, ',');
        // repair: wrap the output inside array brackets
        output = `[\n${output}\n]`;
    }
    /**
   * Parse a string enclosed by double quotes "...". Can contain escaped quotes
   * Repair strings enclosed in single quotes or special quotes
   * Repair an escaped string
   *
   * The function can run in two stages:
   * - First, it assumes the string has a valid end quote
   * - If it turns out that the string does not have a valid end quote followed
   *   by a delimiter (which should be the case), the function runs again in a
   *   more conservative way, stopping the string at the first next delimiter
   *   and fixing the string by inserting a quote there, or stopping at a
   *   stop index detected in the first iteration.
   */ function parseString() {
        let stopAtDelimiter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let stopAtIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        let skipEscapeChars = text[i] === '\\';
        if (skipEscapeChars) {
            // repair: remove the first escape character
            i++;
            skipEscapeChars = true;
        }
        if ((0, $19e2a6b684c245a0$export$6941feaafb12fc71)(text[i])) {
            // double quotes are correct JSON,
            // single quotes come from JavaScript for example, we assume it will have a correct single end quote too
            // otherwise, we will match any double-quote-like start with a double-quote-like end,
            // or any single-quote-like start with a single-quote-like end
            const isEndQuote = (0, $19e2a6b684c245a0$export$5c8e8205aa3e3b6)(text[i]) ? (0, $19e2a6b684c245a0$export$5c8e8205aa3e3b6) : (0, $19e2a6b684c245a0$export$37fd706cc430e444)(text[i]) ? (0, $19e2a6b684c245a0$export$37fd706cc430e444) : (0, $19e2a6b684c245a0$export$c7f0196107e4b230)(text[i]) ? (0, $19e2a6b684c245a0$export$c7f0196107e4b230) : (0, $19e2a6b684c245a0$export$c90a32a645344adf);
            const iBefore = i;
            const oBefore = output.length;
            let str = '"';
            i++;
            while(true){
                if (i >= text.length) {
                    // end of text, we are missing an end quote
                    const iPrev = prevNonWhitespaceIndex(i - 1);
                    if (!stopAtDelimiter && (0, $19e2a6b684c245a0$export$86c7871da6bb7199)(text.charAt(iPrev))) {
                        // if the text ends with a delimiter, like ["hello],
                        // so the missing end quote should be inserted before this delimiter
                        // retry parsing the string, stopping at the first next delimiter
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(true);
                    }
                    // repair missing quote
                    str = (0, $19e2a6b684c245a0$export$eca8654175d9510)(str, '"');
                    output += str;
                    return true;
                }
                if (i === stopAtIndex) {
                    // use the stop index detected in the first iteration, and repair end quote
                    str = (0, $19e2a6b684c245a0$export$eca8654175d9510)(str, '"');
                    output += str;
                    return true;
                }
                if (isEndQuote(text[i])) {
                    // end quote
                    // let us check what is before and after the quote to verify whether this is a legit end quote
                    const iQuote = i;
                    const oQuote = str.length;
                    str += '"';
                    i++;
                    output += str;
                    parseWhitespaceAndSkipComments(false);
                    if (stopAtDelimiter || i >= text.length || (0, $19e2a6b684c245a0$export$86c7871da6bb7199)(text[i]) || (0, $19e2a6b684c245a0$export$6941feaafb12fc71)(text[i]) || (0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i])) {
                        // The quote is followed by the end of the text, a delimiter,
                        // or a next value. So the quote is indeed the end of the string.
                        parseConcatenatedString();
                        return true;
                    }
                    const iPrevChar = prevNonWhitespaceIndex(iQuote - 1);
                    const prevChar = text.charAt(iPrevChar);
                    if (prevChar === ',') {
                        // A comma followed by a quote, like '{"a":"b,c,"d":"e"}'.
                        // We assume that the quote is a start quote, and that the end quote
                        // should have been located right before the comma but is missing.
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(false, iPrevChar);
                    }
                    if ((0, $19e2a6b684c245a0$export$86c7871da6bb7199)(prevChar)) {
                        // This is not the right end quote: it is preceded by a delimiter,
                        // and NOT followed by a delimiter. So, there is an end quote missing
                        // parse the string again and then stop at the first next delimiter
                        i = iBefore;
                        output = output.substring(0, oBefore);
                        return parseString(true);
                    }
                    // revert to right after the quote but before any whitespace, and continue parsing the string
                    output = output.substring(0, oBefore);
                    i = iQuote + 1;
                    // repair unescaped quote
                    str = `${str.substring(0, oQuote)}\\${str.substring(oQuote)}`;
                } else if (stopAtDelimiter && (0, $19e2a6b684c245a0$export$5bb406697483408c)(text[i])) {
                    // we're in the mode to stop the string at the first delimiter
                    // because there is an end quote missing
                    // test start of an url like "https://..." (this would be parsed as a comment)
                    if (text[i - 1] === ':' && (0, $19e2a6b684c245a0$export$c158d3099d715644).test(text.substring(iBefore + 1, i + 2))) while(i < text.length && (0, $19e2a6b684c245a0$export$7a3bbad2a762c5dc).test(text[i])){
                        str += text[i];
                        i++;
                    }
                    // repair missing quote
                    str = (0, $19e2a6b684c245a0$export$eca8654175d9510)(str, '"');
                    output += str;
                    parseConcatenatedString();
                    return true;
                } else if (text[i] === '\\') {
                    // handle escaped content like \n or \u2605
                    const char = text.charAt(i + 1);
                    const escapeChar = $50773bd7364e2885$var$escapeCharacters[char];
                    if (escapeChar !== undefined) {
                        str += text.slice(i, i + 2);
                        i += 2;
                    } else if (char === 'u') {
                        let j = 2;
                        while(j < 6 && (0, $19e2a6b684c245a0$export$8a9b6341a7c96bc)(text[i + j]))j++;
                        if (j === 6) {
                            str += text.slice(i, i + 6);
                            i += 6;
                        } else if (i + j >= text.length) // repair invalid or truncated unicode char at the end of the text
                        // by removing the unicode char and ending the string here
                        i = text.length;
                        else throwInvalidUnicodeCharacter();
                    } else {
                        // repair invalid escape character: remove it
                        str += char;
                        i += 2;
                    }
                } else {
                    // handle regular characters
                    const char = text.charAt(i);
                    if (char === '"' && text[i - 1] !== '\\') {
                        // repair unescaped double quote
                        str += `\\${char}`;
                        i++;
                    } else if ((0, $19e2a6b684c245a0$export$d4061b5fcfc97271)(char)) {
                        // unescaped control character
                        str += $50773bd7364e2885$var$controlCharacters[char];
                        i++;
                    } else {
                        if (!(0, $19e2a6b684c245a0$export$dbbf36b4f6aa0d0f)(char)) throwInvalidCharacter(char);
                        str += char;
                        i++;
                    }
                }
                if (skipEscapeChars) // repair: skipped escape character (nothing to do)
                skipEscapeCharacter();
            }
        }
        return false;
    }
    /**
   * Repair concatenated strings like "hello" + "world", change this into "helloworld"
   */ function parseConcatenatedString() {
        let processed = false;
        parseWhitespaceAndSkipComments();
        while(text[i] === '+'){
            processed = true;
            i++;
            parseWhitespaceAndSkipComments();
            // repair: remove the end quote of the first string
            output = (0, $19e2a6b684c245a0$export$5eb0648ae3c2ee22)(output, '"', true);
            const start = output.length;
            const parsedStr = parseString();
            if (parsedStr) // repair: remove the start quote of the second string
            output = (0, $19e2a6b684c245a0$export$a4b863a4658d38a8)(output, start, 1);
            else // repair: remove the + because it is not followed by a string
            output = (0, $19e2a6b684c245a0$export$eca8654175d9510)(output, '"');
        }
        return processed;
    }
    /**
   * Parse a number like 2.4 or 2.4e6
   */ function parseNumber() {
        const start = i;
        if (text[i] === '-') {
            i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
        }
        // Note that in JSON leading zeros like "00789" are not allowed.
        // We will allow all leading zeros here though and at the end of parseNumber
        // check against trailing zeros and repair that if needed.
        // Leading zeros can have meaning, so we should not clear them.
        while((0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i]))i++;
        if (text[i] === '.') {
            i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
            while((0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i]))i++;
        }
        if (text[i] === 'e' || text[i] === 'E') {
            i++;
            if (text[i] === '-' || text[i] === '+') i++;
            if (atEndOfNumber()) {
                repairNumberEndingWithNumericSymbol(start);
                return true;
            }
            if (!(0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i])) {
                i = start;
                return false;
            }
            while((0, $19e2a6b684c245a0$export$727d9dbc4fbb948f)(text[i]))i++;
        }
        // if we're not at the end of the number by this point, allow this to be parsed as another type
        if (!atEndOfNumber()) {
            i = start;
            return false;
        }
        if (i > start) {
            // repair a number with leading zeros like "00789"
            const num = text.slice(start, i);
            const hasInvalidLeadingZero = /^0\d/.test(num);
            output += hasInvalidLeadingZero ? `"${num}"` : num;
            return true;
        }
        return false;
    }
    /**
   * Parse keywords true, false, null
   * Repair Python keywords True, False, None
   */ function parseKeywords() {
        return parseKeyword('true', 'true') || parseKeyword('false', 'false') || parseKeyword('null', 'null') || // repair Python keywords True, False, None
        parseKeyword('True', 'true') || parseKeyword('False', 'false') || parseKeyword('None', 'null');
    }
    function parseKeyword(name, value) {
        if (text.slice(i, i + name.length) === name) {
            output += value;
            i += name.length;
            return true;
        }
        return false;
    }
    /**
   * Repair an unquoted string by adding quotes around it
   * Repair a MongoDB function call like NumberLong("2")
   * Repair a JSONP function call like callback({...});
   */ function parseUnquotedString(isKey) {
        // note that the symbol can end with whitespaces: we stop at the next delimiter
        // also, note that we allow strings to contain a slash / in order to support repairing regular expressions
        const start = i;
        if ((0, $19e2a6b684c245a0$export$a9f938b686e06012)(text[i])) {
            while(i < text.length && (0, $19e2a6b684c245a0$export$8a15811e203445b5)(text[i]))i++;
            let j = i;
            while((0, $19e2a6b684c245a0$export$a1ed01a3e6d5a08c)(text, j))j++;
            if (text[j] === '(') {
                // repair a MongoDB function call like NumberLong("2")
                // repair a JSONP function call like callback({...});
                i = j + 1;
                parseValue();
                if (text[i] === ')') {
                    // repair: skip close bracket of function call
                    i++;
                    if (text[i] === ';') // repair: skip semicolon after JSONP call
                    i++;
                }
                return true;
            }
        }
        while(i < text.length && !(0, $19e2a6b684c245a0$export$5bb406697483408c)(text[i]) && !(0, $19e2a6b684c245a0$export$6941feaafb12fc71)(text[i]) && (!isKey || text[i] !== ':'))i++;
        // test start of an url like "https://..." (this would be parsed as a comment)
        if (text[i - 1] === ':' && (0, $19e2a6b684c245a0$export$c158d3099d715644).test(text.substring(start, i + 2))) while(i < text.length && (0, $19e2a6b684c245a0$export$7a3bbad2a762c5dc).test(text[i]))i++;
        if (i > start) {
            // repair unquoted string
            // also, repair undefined into null
            // first, go back to prevent getting trailing whitespaces in the string
            while((0, $19e2a6b684c245a0$export$a1ed01a3e6d5a08c)(text, i - 1) && i > 0)i--;
            const symbol = text.slice(start, i);
            output += symbol === 'undefined' ? 'null' : JSON.stringify(symbol);
            if (text[i] === '"') // we had a missing start quote, but now we encountered the end quote, so we can skip that one
            i++;
            return true;
        }
    }
    function parseRegex() {
        if (text[i] === '/') {
            const start = i;
            i++;
            while(i < text.length && (text[i] !== '/' || text[i - 1] === '\\'))i++;
            i++;
            output += `"${text.substring(start, i)}"`;
            return true;
        }
    }
    function prevNonWhitespaceIndex(start) {
        let prev = start;
        while(prev > 0 && (0, $19e2a6b684c245a0$export$a1ed01a3e6d5a08c)(text, prev))prev--;
        return prev;
    }
    function atEndOfNumber() {
        return i >= text.length || (0, $19e2a6b684c245a0$export$86c7871da6bb7199)(text[i]) || (0, $19e2a6b684c245a0$export$a1ed01a3e6d5a08c)(text, i);
    }
    function repairNumberEndingWithNumericSymbol(start) {
        // repair numbers cut off at the end
        // this will only be called when we end after a '.', '-', or 'e' and does not
        // change the number more than it needs to make it valid JSON
        output += `${text.slice(start, i)}0`;
    }
    function throwInvalidCharacter(char) {
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)(`Invalid character ${JSON.stringify(char)}`, i);
    }
    function throwUnexpectedCharacter() {
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)(`Unexpected character ${JSON.stringify(text[i])}`, i);
    }
    function throwUnexpectedEnd() {
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)('Unexpected end of json string', text.length);
    }
    function throwObjectKeyExpected() {
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)('Object key expected', i);
    }
    function throwColonExpected() {
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)('Colon expected', i);
    }
    function throwInvalidUnicodeCharacter() {
        const chars = text.slice(i, i + 6);
        throw new (0, $f930a855a56e9d20$export$7f66e9a3d953663f)(`Invalid unicode character "${chars}"`, i);
    }
}
function $50773bd7364e2885$var$atEndOfBlockComment(text, i) {
    return text[i] === '*' && text[i + 1] === '/';
}


const $c6b4e72a3d0fdb58$var$adfStreamStartingWrappers = [
    '```json',
    '<adf_input>'
];
const $c6b4e72a3d0fdb58$var$adfStreamEndingWrappers = [
    '```',
    '</adf_input>'
];
function $c6b4e72a3d0fdb58$export$9239af86fecd5c3b(content) {
    $c6b4e72a3d0fdb58$var$adfStreamStartingWrappers.forEach((wrapper)=>{
        if (content.startsWith(wrapper)) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        content = content.replace(wrapper, '');
    });
    $c6b4e72a3d0fdb58$var$adfStreamEndingWrappers.forEach((wrapper)=>{
        if (content.endsWith(wrapper)) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        content = content.replace(wrapper, '');
    });
    /**
	 * Special case: if the pattern is at the end (dangling /), we need to escape both quote and slash
	 * "Hello"/ -> "Hello\"\/ (this keeps both chars in the string and keeps string open for jsonrepair)
	 * Pattern: (^|[^\\])"\/"$ captures start or non-backslash char before "/" and at the end of the string
	 * This handles malformed JSON like "Hello"/ -> "Hello\"\/
	 */ // eslint-disable-next-line require-unicode-regexp
    content = content.replace(/(^|[^\\])"\/$/g, '$1\\"\\/');
    /**
	 * For all other cases (not at the end)
	 * Escape unescaped double quotes followed by a forward slash
	 * Pattern: (^|[^\\])"\//g captures start or non-backslash char before "/"
	 * This handles malformed JSON like "Hello"/world" -> "Hello\"/world"
	 * It also ensures we don't capture JSON key/value pairs
	 */ // eslint-disable-next-line require-unicode-regexp
    content = content.replace(/(^|[^\\:])"\//g, '$1\\"/');
    return content;
}


class $aee3606115b2c7e7$export$c1ee0a0b09546958 {
    append(chunk) {
        this.buffer += chunk;
    }
    /**
   * parse will actually repair the json string stored in buffer.
   * It will throw error if it fails to repair the json string.
   * It will return the repaired json string if it succeeds and
   * 	also indicate if the json string has changed.
   */ parse() {
        const sanitizedBuffer = (0, $c6b4e72a3d0fdb58$export$9239af86fecd5c3b)(this.buffer);
        const repairedJsonString = (0, $50773bd7364e2885$export$b7f9abe9df7056b9)(sanitizedBuffer);
        if (repairedJsonString?.length) try {
            const repairedJson = JSON.parse(repairedJsonString);
            const size = repairedJsonString.length;
            const hasChanged = size !== this.prevSize;
            this.prevSize = size;
            return {
                hasChanged: hasChanged,
                repairedJson: repairedJson
            };
        } catch (error) {
            /**
         * If it comes here, it means JSON.parse failed.
         * Ideally, it should not happen, but if there is a bug in the jsonrepair function,
         * 	then it can return invalid json string.
         * We want to capture that, so throwing specific error here.
         */ throw new Error('failed to parse repaired json string returned by jsonrepair.');
        }
        else throw new Error('jsonrepair returned undefined or empty string.');
    }
    reset() {
        this.buffer = '';
        this.prevSize = 0;
    }
    constructor(){
        this.buffer = '';
        this.prevSize = 0;
    }
}


function $14bef4d539870e13$export$fc7f14f8b3a9c1d7(attrRule, attrName, markOrNodeType) {
    if (attrRule.type === 'enum' && attrRule.values && attrRule.values.length > 0) return attrRule.values[0];
    if (attrRule.type === 'number') return attrRule.minimum ?? 0;
    if (attrRule.type === 'string') {
        // If validatorFn is defined, can't provide default
        if (attrRule.validatorFn) return null; // Signal that we can't provide default
        // If pattern is defined, try to match it
        if (attrRule.pattern) {
            // Handle common hex color patterns
            if (attrRule.pattern === '^#[0-9a-fA-F]{6}$') {
                // Using white gray as default color for text
                if (markOrNodeType === 'textColor') return '#172B4D';
                // Using light gray as default color for background
                if (markOrNodeType === 'backgroundColor') return '#DCDFE4';
                // Using black as default color
                return '#000000';
            }
            // Only border has below regex pattern
            if (attrRule.pattern === '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$') // Using subtle gray as default border color
            return '#091E4224';
            if (attrName === 'timestamp') return new Date().getTime().toString();
            else if (attrName === 'shortName') return ':smile:';
            /**
			 * For other patterns, return empty string
			 * Better solution is to use https://github.com/wimpyprogrammer/regex-to-strings
			 * 	and generate one string that matches the pattern
			 */ return null;
        }
        // If minLength is defined, generate string of minimum length
        if (attrRule.minLength && attrRule.minLength > 0) return 'a'.repeat(attrRule.minLength);
        return null;
    }
    if (attrRule.type === 'boolean') return false;
    if (attrRule.type === 'array') {
        if (attrRule.minItems && attrRule.minItems > 0) /**
			 * Generating default value which is useful is not possible
			 * 	based on current validation rules.
			 * So just returning null.
			 */ return null;
        return [];
    }
    return null;
}
function $14bef4d539870e13$export$22eef2421c3aeb33(attrName, value, rule, markOrNodeType) {
    if (rule.type === 'string') {
        if (rule.pattern) {
            const regex = new RegExp(rule.pattern, 'u');
            if (!regex.test(value) && !rule.optional) {
                const defaultedValue = $14bef4d539870e13$export$fc7f14f8b3a9c1d7(rule, attrName, markOrNodeType);
                if (defaultedValue === null) return {
                    isValid: false,
                    error: `Attribute '${attrName}' does not match required pattern`
                };
                return {
                    isValid: true,
                    repairedValue: defaultedValue
                };
            }
            return {
                isValid: true,
                repairedValue: value
            };
        }
        // Only number value is allowed to be converted to string
        const stringValue = typeof value === 'string' || typeof value === 'number' ? value.toString() : undefined;
        if (stringValue && (rule.minLength ? stringValue.length > rule.minLength : true)) return {
            isValid: true,
            repairedValue: stringValue
        };
        else if (!rule.optional) {
            /**
			 * Right now default value is only generated for string type having pattern.
			 * Still calling generateDefaultValueForAttribute, so that in future we can generate default value
			 * 	for other cases, it will be supported automatically.
			 */ const defaultedValue = $14bef4d539870e13$export$fc7f14f8b3a9c1d7(rule, attrName, markOrNodeType);
            if (defaultedValue !== null) return {
                isValid: true,
                repairedValue: defaultedValue
            };
        }
        return {
            isValid: false,
            error: `Attribute '${attrName}' has invalid value and can't be repaired`
        };
    }
    if (rule.type === 'number') {
        const repairedValue = typeof value === 'number' ? value : parseInt(value);
        /**
		 * if mininum or maximum is defined, and repaired value is not number,
		 * 	then set repaired value to minimum or maximum
		 * 	or if repaired value is number and out of range, then set repaired value to minimum or maximum
		 */ if (rule.minimum !== undefined && (isNaN(repairedValue) || repairedValue < rule.minimum)) return {
            isValid: true,
            repairedValue: rule.minimum
        };
        else if (rule.maximum !== undefined && (isNaN(repairedValue) || repairedValue > rule.maximum)) return {
            isValid: true,
            repairedValue: rule.maximum
        };
        else if (!isNaN(repairedValue)) return {
            isValid: true,
            repairedValue: repairedValue
        };
        /**
		 * For layoutColumn width, set default value to 20 in case of invalid value.
		 * Choose 20 as default value because it's the default width for 5 column layout,
		 * 	which is minium width for layoutColumn.
		 *
		 */ if (markOrNodeType === 'layoutColumn' && attrName === 'width') return {
            isValid: true,
            repairedValue: 20
        };
        return {
            isValid: false,
            error: `Failed to repair attribute '${attrName}'`
        };
    }
    if (rule.type === 'boolean') {
        if (typeof value === 'boolean') return {
            isValid: true,
            repairedValue: value
        };
        else if (typeof value === 'string') {
            if ('true'.includes(value)) return {
                isValid: true,
                repairedValue: true
            };
            if ('false'.includes(value)) return {
                isValid: true,
                repairedValue: false
            };
        }
        return {
            isValid: false,
            error: `Attribute '${attrName}' has invalid boolean value '${value}'`
        };
    }
    if (rule.type === 'enum' && rule.values) {
        const enumValue = value;
        if (rule.values.includes(enumValue)) return {
            isValid: true,
            repairedValue: value
        };
        else {
            /**
			 * During streaming enum value may be incomplete, so try to find partial match
			 */ const partialMatches = rule.values.filter((allowedValue)=>allowedValue.startsWith(enumValue));
            if (partialMatches.length > 0) return {
                isValid: true,
                repairedValue: partialMatches[0]
            };
            /**
			 * If no partial match found, then set first value as default
			 */ const defaultEnumValue = rule.values.includes('default') ? 'default' : rule.values[0];
            return {
                isValid: true,
                repairedValue: defaultEnumValue
            };
        }
    }
    if (rule.type === 'array') {
        if (!Array.isArray(value)) return {
            isValid: false,
            error: `Attribute '${attrName}' must be an array`
        };
        const arrayItemType = rule.items?.[0]?.type;
        const invalidItemType = value.some((item)=>typeof item !== arrayItemType);
        if (invalidItemType) return {
            isValid: false,
            error: `Attribute '${attrName}' must have items of type ${arrayItemType}`
        };
        if (rule.minItems !== undefined && value.length < rule.minItems) return {
            isValid: false,
            error: `Attribute '${attrName}' must have at least ${rule.minItems} items`
        };
    }
    if (rule.type === 'object' && typeof value !== 'object') return {
        isValid: false,
        error: `Attribute '${attrName}' must be an object`
    };
    return {
        isValid: true,
        repairedValue: value
    };
}



var $yQ01u = parcelRequire("yQ01u");

const $95af7db310ed4bb5$var$blockCardTyped = (0, $yQ01u.blockCard);
const $95af7db310ed4bb5$var$inlineCardTyped = (0, $yQ01u.inlineCard);
const $95af7db310ed4bb5$var$mediaTyped = (0, $yQ01u.media);
const $95af7db310ed4bb5$export$70a4306b43ad6238 = {
    alignment: $yQ01u.alignment,
    annotation: $yQ01u.annotation,
    backgroundColor: $yQ01u.backgroundColor,
    blockCard: $95af7db310ed4bb5$var$blockCardTyped,
    block_content: $yQ01u.block_content,
    blockRootOnly: $yQ01u.blockRootOnly,
    blockquote: $yQ01u.blockquote,
    blockTaskItem: $yQ01u.blockTaskItem,
    bodiedExtension: $yQ01u.bodiedExtension,
    bodiedExtension_with_marks: $yQ01u.bodiedExtension_with_marks,
    border: $yQ01u.border,
    breakout: $yQ01u.breakout,
    bulletList: $yQ01u.bulletList,
    caption: $yQ01u.caption,
    code: $yQ01u.code,
    codeBlock: $yQ01u.codeBlock,
    codeBlock_root_only: $yQ01u.codeBlock_root_only,
    text_with_no_marks: $yQ01u.text_with_no_marks,
    confluenceInlineComment: $yQ01u.confluenceInlineComment,
    dataConsumer: $yQ01u.dataConsumer,
    date: $yQ01u.date,
    decisionItem: $yQ01u.decisionItem,
    decisionList: $yQ01u.decisionList,
    doc: $yQ01u.doc,
    em: $yQ01u.em,
    embedCard: $yQ01u.embedCard,
    emoji: $yQ01u.emoji,
    expand: $yQ01u.expand,
    expand_root_only: $yQ01u.expand_root_only,
    extension: $yQ01u.extension,
    extensionFrame: $yQ01u.extensionFrame,
    extension_with_marks: $yQ01u.extension_with_marks,
    fragment: $yQ01u.fragment,
    hardBreak: $yQ01u.hardBreak,
    heading: $yQ01u.heading,
    heading_with_alignment: $yQ01u.heading_with_alignment,
    heading_with_indentation: $yQ01u.heading_with_indentation,
    heading_with_no_marks: $yQ01u.heading_with_no_marks,
    indentation: $yQ01u.indentation,
    inlineCard: $95af7db310ed4bb5$var$inlineCardTyped,
    inlineExtension: $yQ01u.inlineExtension,
    inlineExtension_with_marks: $yQ01u.inlineExtension_with_marks,
    inline_content: $yQ01u.inline_content,
    layoutColumn: $yQ01u.layoutColumn,
    layoutSection: $yQ01u.layoutSection,
    layoutSection_full: $yQ01u.layoutSection_full,
    layoutSection_with_single_column: $yQ01u.layoutSection_with_single_column,
    link: $yQ01u.link,
    listItem: $yQ01u.listItem,
    media: $95af7db310ed4bb5$var$mediaTyped,
    mediaGroup: $yQ01u.mediaGroup,
    mediaInline: $yQ01u.mediaInline,
    mediaSingle: $yQ01u.mediaSingle,
    mediaSingle_caption: $yQ01u.mediaSingle_caption,
    mediaSingle_full: $yQ01u.mediaSingle_full,
    mention: $yQ01u.mention,
    multiBodiedExtension: $yQ01u.multiBodiedExtension,
    nestedExpand: $yQ01u.nestedExpand,
    nestedExpand_with_no_marks: $yQ01u.nestedExpand_with_no_marks,
    non_nestable_block_content: $yQ01u.non_nestable_block_content,
    orderedList: $yQ01u.orderedList,
    panel: $yQ01u.panel,
    paragraph: $yQ01u.paragraph,
    paragraph_with_alignment: $yQ01u.paragraph_with_alignment,
    paragraph_with_indentation: $yQ01u.paragraph_with_indentation,
    paragraph_with_no_marks: $yQ01u.paragraph_with_no_marks,
    placeholder: $yQ01u.placeholder,
    rule: $yQ01u.rule,
    status: $yQ01u.status,
    strike: $yQ01u.strike,
    strong: $yQ01u.strong,
    subsup: $yQ01u.subsup,
    table: $yQ01u.table,
    tableCell: $yQ01u.tableCell,
    tableHeader: $yQ01u.tableHeader,
    tableRow: $yQ01u.tableRow,
    taskItem: $yQ01u.taskItem,
    taskList: $yQ01u.taskList,
    text: $yQ01u.text,
    textColor: $yQ01u.textColor,
    text_code_inline: $yQ01u.text_code_inline,
    text_formatted: $yQ01u.text_formatted,
    text_link_inline: $yQ01u.text_link_inline,
    underline: $yQ01u.underline
};


function $1784c64cb85a57c5$export$5a70a9db9005e6b(nodeType) {
    const allowedMarks = new Set();
    // First try to get the main node rule
    const mainNodeRule = (0, $95af7db310ed4bb5$export$70a4306b43ad6238)[nodeType];
    const additionalRules = [];
    const specKeys = Object.keys((0, $95af7db310ed4bb5$export$70a4306b43ad6238));
    specKeys.forEach((specKey)=>{
        if (specKey.startsWith(nodeType) && Array.isArray((0, $95af7db310ed4bb5$export$70a4306b43ad6238)[specKey]) && (0, $95af7db310ed4bb5$export$70a4306b43ad6238)[specKey][0] === nodeType) additionalRules.push((0, $95af7db310ed4bb5$export$70a4306b43ad6238)[specKey]);
    });
    // Extract allowed marks from the node rule
    function extractMarksFromRule(rule) {
        if (!rule) return;
        if ('props' in rule && 'marks' in rule.props && rule.props.marks) extractMarksFromItems(rule.props.marks.items);
        else if (Array.isArray(rule) && rule.length >= 2) {
            // Handle array format [nodeType, { props: { marks: ... } }]
            const additionalSpec = rule[1];
            if (additionalSpec?.props?.marks?.items) extractMarksFromItems(additionalSpec.props.marks.items);
        }
    }
    function extractMarksFromItems(items) {
        if (Array.isArray(items)) items.forEach((item)=>{
            if (typeof item === 'string') allowedMarks.add(item);
            else if (Array.isArray(item)) item.forEach((subItem)=>{
                if (typeof subItem === 'string') allowedMarks.add(subItem);
            });
        });
    }
    extractMarksFromRule(mainNodeRule);
    additionalRules.forEach((rule)=>extractMarksFromRule(rule));
    return Array.from(allowedMarks);
}
/**
 * Infer mark type from attrs if type is missing
 */ function $1784c64cb85a57c5$var$inferMarkTypeFromAttrs(attrs) {
    if (!attrs || typeof attrs !== 'object') return undefined;
    // Check for specific attribute patterns that indicate mark types
    if (attrs.align) return 'alignment';
    if (attrs.annotationType) return 'annotation';
    if (attrs.size) return 'border';
    if (attrs.color) return 'backgroundColor';
    if (attrs.mode) return 'breakout';
    if (attrs.sources) return 'dataConsumer';
    if (attrs.localId && attrs.name !== undefined) return 'fragment';
    if (attrs.level) return 'indentation';
    if (attrs.href || attrs.title || attrs.collection || attrs.occurrenceKey) return 'link';
    if (attrs.type && (attrs.type === 'sub' || attrs.type === 'sup')) return 'subsup';
}
function $1784c64cb85a57c5$var$inferMarkType(markType, allowedMarkTypes, attrs) {
    // Step 1: Try to infer type from attrs
    if (!markType) // Try to infer type from attrs
    markType = $1784c64cb85a57c5$var$inferMarkTypeFromAttrs(attrs);
    // Step 2: Try to infer, assuming type string is incomplete
    if (typeof markType === 'string' && !allowedMarkTypes.includes(markType)) {
        // Try partial matching - find marks that start with the given type
        const partialMatches = allowedMarkTypes.filter((allowedType)=>allowedType.startsWith(markType));
        if (partialMatches.length > 0) markType = partialMatches[0];
    }
    return markType;
}
/**
 * Validate and repair a single mark's attributes
 */ function $1784c64cb85a57c5$var$repairMarkAttrs(markType, attrs) {
    const markRule = (0, $95af7db310ed4bb5$export$70a4306b43ad6238)[markType];
    if (!markRule) return {
        isValid: false,
        error: `Unknown mark type: ${markType}`
    };
    const attrsRule = markRule.props.attrs;
    if (!attrsRule) // Mark doesn't require attributes, not need to repair or validate attrs
    return {
        isValid: true
    };
    // If no attrs provided, try to generate defaults for required attributes
    if (!attrs) {
        const defaultAttrs = {};
        const errors = [];
        for (const [attrName, attrRule] of Object.entries(attrsRule.props))if (!attrRule.optional) {
            const defaultValue = (0, $14bef4d539870e13$export$fc7f14f8b3a9c1d7)(attrRule, attrName, markType);
            if (defaultValue === null) errors.push(`Mark ${markType}: Required attribute '${attrName}' cannot have default value`);
            else defaultAttrs[attrName] = defaultValue;
        }
        if (errors.length > 0) return {
            isValid: false,
            error: errors.join('; ')
        };
        return {
            isValid: true,
            repairedAttrs: defaultAttrs
        };
    }
    const repairedAttrs = {
        ...attrs
    };
    const errors = [];
    // Check all defined attributes in the rule
    for (const [attrName, attrRule] of Object.entries(attrsRule.props)){
        const attrValue = attrs[attrName];
        // Validate and potentially repair attribute value
        const validation = (0, $14bef4d539870e13$export$22eef2421c3aeb33)(attrName, attrValue, attrRule, markType);
        if (validation.isValid) repairedAttrs[attrName] = validation.repairedValue;
        else if (!attrRule.optional) errors.push(validation.error || `Invalid value for attribute '${attrName}'`);
    }
    if (errors.length > 0) return {
        isValid: false,
        error: errors.join('; ')
    };
    return {
        isValid: true,
        repairedAttrs: repairedAttrs
    };
}
/**
 * Validate and repair a single mark
 */ function $1784c64cb85a57c5$var$repairMark(mark, allowedMarkTypes) {
    if (!mark || typeof mark !== 'object') return {
        isValid: false,
        error: 'Mark must be an object'
    };
    let markType = mark.type;
    /**
	 * Step 1: If mark type is undefined or is not allowed,
	 * 	then it may be incomplete, so try to infer type from attrs
	 */ if (!markType || !allowedMarkTypes.includes(markType)) // Try to infer type from attrs
    markType = $1784c64cb85a57c5$var$inferMarkType(markType, allowedMarkTypes, mark.attrs);
    if (!markType) return {
        isValid: false,
        error: `Mark type '${markType}' is invalid and could not be inferred`
    };
    // Step 2: Validate and repairmark attributes
    const attrValidationResult = $1784c64cb85a57c5$var$repairMarkAttrs(markType, mark.attrs);
    if (!attrValidationResult.isValid) return {
        isValid: false,
        error: attrValidationResult.error
    };
    const repairedMark = {
        type: markType
    };
    // Only add attrs if they exist and are not empty
    if (attrValidationResult.repairedAttrs && Object.keys(attrValidationResult.repairedAttrs).length > 0) repairedMark.attrs = attrValidationResult.repairedAttrs;
    return {
        isValid: true,
        repairedMark: repairedMark
    };
}
function $1784c64cb85a57c5$export$fb8ba848cbd161c6(nodeType, marks) {
    /**
	 * Currently makrs are always optional, so if marks are not provided,
	 * 	then simply consider it as valid.
	 */ if (!marks || !Array.isArray(marks)) return {
        repairedMarks: []
    };
    const allowedMarkTypes = $1784c64cb85a57c5$export$5a70a9db9005e6b(nodeType);
    const repairedMarks = [];
    const errors = [];
    for(let i = 0; i < marks.length; i++){
        const mark = marks[i];
        const result = $1784c64cb85a57c5$var$repairMark(mark, allowedMarkTypes);
        if (result.isValid && result.repairedMark) repairedMarks.push(result.repairedMark);
        else errors.push(result.error || `Can' repair mark ${mark.type} for node ${nodeType}`);
    }
    return {
        repairedMarks: repairedMarks,
        errors: errors
    };
}







/**
 * Resolve the actual node spec from a nodeType, handling secondary specs
 */ function $70d7b1d3710e18f8$var$resolveNodeSpec(nodeType) {
    const mainSpec = (0, $95af7db310ed4bb5$export$70a4306b43ad6238)[nodeType];
    if (!mainSpec) return null;
    const nodeSpec = mainSpec;
    // If main spec has attrs, use it directly
    if (nodeSpec.props.attrs) return nodeSpec;
    // If main spec doesn't have attrs, look for secondary specs that extend this nodeType
    for (const [, secondarySpec] of Object.entries((0, $95af7db310ed4bb5$export$70a4306b43ad6238)))if (Array.isArray(secondarySpec)) {
        const [baseNodeType, extendedSpec] = secondarySpec;
        if (baseNodeType === nodeType && extendedSpec.props.attrs) // Found a secondary spec that extends this nodeType and has attrs
        return {
            ...nodeSpec,
            props: {
                ...nodeSpec.props,
                ...extendedSpec.props
            },
            required: extendedSpec.required || nodeSpec.required
        };
    }
    // Return main spec even if it doesn't have attrs
    return nodeSpec;
}
/**
 * Validate attributes against a single attribute group spec
 */ function $70d7b1d3710e18f8$var$validateAttrsAgainstGroup(attrs, attrsGroup, nodeType) {
    // If no attrs provided, try to generate defaults for required attributes
    if (!attrs) {
        const defaultAttrs = {};
        const errors = [];
        for (const [attrName, attrRule] of Object.entries(attrsGroup.props))if (!attrRule.optional) {
            const defaultValue = (0, $14bef4d539870e13$export$fc7f14f8b3a9c1d7)(attrRule, attrName, nodeType);
            if (defaultValue === null) errors.push(`Required attribute '${attrName}' cannot have default value (has validatorFn)`);
            else defaultAttrs[attrName] = defaultValue;
        }
        if (errors.length > 0) return {
            isValid: false,
            error: errors.join('; ')
        };
        return {
            isValid: true,
            repairedAttrs: defaultAttrs
        };
    }
    const repairedAttrs = {
        ...attrs
    };
    const errors = [];
    // Check all defined attributes in the rule
    for (const [attrName, attrRule] of Object.entries(attrsGroup.props)){
        const attrValue = attrs[attrName];
        // Validate and potentially repair attribute value
        const validation = (0, $14bef4d539870e13$export$22eef2421c3aeb33)(attrName, attrValue, attrRule, nodeType);
        if (validation.isValid) repairedAttrs[attrName] = validation.repairedValue;
        else if (!attrRule.optional) errors.push(validation.error || `Invalid value for attribute '${attrName}'`);
    }
    if (errors.length > 0) return {
        isValid: false,
        error: errors.join('; ')
    };
    return {
        isValid: true,
        repairedAttrs: repairedAttrs
    };
}
function $70d7b1d3710e18f8$export$fde9f26eb5c83773(nodeType, attrs) {
    const spec = (0, $95af7db310ed4bb5$export$70a4306b43ad6238)[nodeType];
    if (!spec) return {
        isValid: false,
        error: `Unknown node type: ${nodeType}`
    };
    // Use resolveNodeSpec for main specs to handle attrs resolution
    const resolvedSpec = $70d7b1d3710e18f8$var$resolveNodeSpec(nodeType);
    if (!resolvedSpec) return {
        isValid: false,
        error: `Unable to resolve spec for node type: ${nodeType}`
    };
    const nodeSpec = resolvedSpec;
    const attrsRule = nodeSpec.props.attrs;
    if (!attrsRule) // Node doesn't require attributes
    return {
        isValid: true,
        repairedAttrs: attrs || {}
    };
    // Handle array of attribute groups (multiple possible schemas)
    if (Array.isArray(attrsRule)) {
        const errors = [];
        // Try each attribute group until one succeeds
        for(let i = 0; i < attrsRule.length; i++){
            const attrsGroup = attrsRule[i];
            const result = $70d7b1d3710e18f8$var$validateAttrsAgainstGroup(attrs, attrsGroup, nodeType);
            /**
			 * If validateAttrsAgainstGroup has repaired attrs, then don't return.
			 * Check against next attrsGroup. If last group, then return.
			 */ if (result.isValid && (i === attrsRule.length - 1 || (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(result.repairedAttrs, attrs))) return result;
            else errors.push(result.error || 'Unknown validation error');
        }
        // If none of the attribute groups worked, return combined errors
        return {
            isValid: false,
            error: `Node '${nodeType}' attrs don't match any valid schema: ${errors.join(' | ')}`
        };
    }
    // Handle single attribute group
    return $70d7b1d3710e18f8$var$validateAttrsAgainstGroup(attrs, attrsRule, nodeType);
}


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9cc154d72691fae2$var$DIGITS_ONLY_REGEX = /^\d+$/;
const $9cc154d72691fae2$var$fixTimestamp = (timestamp)=>{
    const currentTime = new Date().getTime().toString();
    if (!timestamp) return currentTime;
    if (typeof timestamp !== 'string') return timestamp;
    if (timestamp.includes('-')) {
        const time = new Date(timestamp).getTime();
        return isNaN(time) ? currentTime : time.toString();
    }
    if (!timestamp.match($9cc154d72691fae2$var$DIGITS_ONLY_REGEX)) return currentTime;
    return timestamp;
};
const $9cc154d72691fae2$export$9c486687c39453a7 = ({ attrs: attrs = {}, ...rest })=>({
        ...rest,
        attrs: {
            ...attrs,
            timestamp: $9cc154d72691fae2$var$fixTimestamp(attrs.timestamp)
        }
    });


const $07edae40dc939565$export$258397c3ff887c2b = (partialNodeJson)=>{
    if (partialNodeJson.attrs?.panelType === 'tip') return {
        ...partialNodeJson,
        attrs: {
            ...partialNodeJson.attrs,
            panelType: 'info'
        }
    };
    return partialNodeJson;
};


const $a0c1a7681045b403$var$nodeTransformers = {
    date: (0, $9cc154d72691fae2$export$9c486687c39453a7),
    panel: (0, $07edae40dc939565$export$258397c3ff887c2b)
};
const $a0c1a7681045b403$export$dd6751dd7e5e8e9a = (type, partialNodeJson)=>{
    const nodeTransformer = $a0c1a7681045b403$var$nodeTransformers[type];
    return nodeTransformer ? nodeTransformer(partialNodeJson) : partialNodeJson;
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6d59a54f85e65dd7$var$DIGITS_ONLY_REGEX = /^\d+$/;
const $6d59a54f85e65dd7$var$isTextblock = (schema, typeName)=>!!typeName && !!schema.nodes[typeName]?.isTextblock;
function $6d59a54f85e65dd7$var$isTextLink(node) {
    const isText = node.type === 'text';
    if (!isText) return false;
    const mark = node.marks?.find((mark)=>mark.type === 'link');
    return !!mark;
}
// these block nodes should be treated as leaf nodes which should be omitted
// because they have src or url attrs that can be null after repair
// We handle tables differently so we also add it to the list
const $6d59a54f85e65dd7$var$leafLikeNodeTypes = [
    'blockCard',
    'embedCard',
    'unsupportedBlock',
    'tableRow'
];
function $6d59a54f85e65dd7$var$countIncompleteRows(node) {
    if (node.type !== 'table') return 0;
    const rows = node.content;
    if (!rows) return 0;
    //
    if (rows.length === 1) return 1;
    // Always ignore the final row if this is the end of the stream
    const rowsWithoutLast = rows.slice(0, rows.length - 1);
    let lastCompleteIndex = -1;
    let incompleteRowCount = 1;
    rowsWithoutLast.forEach((row, index)=>{
        const maxMergedRows = (row.content || []).reduce((max, cell)=>{
            return Math.max(max, typeof cell.attrs?.rowspan === 'number' ? cell.attrs.rowspan : 1);
        }, 1);
        incompleteRowCount = Math.max(incompleteRowCount, maxMergedRows);
        incompleteRowCount--;
        if (incompleteRowCount === 0) lastCompleteIndex = index;
    });
    /**
   * If lastCompleteIndex is -1, it means that no complete row has been found even after
   * trimming the last row.
   *
   * rowsWithoutLast.length - (-1) means that none of the rows are valid, so we actually
   * return the full row length here by doing double negation.
   */ return rowsWithoutLast.length - lastCompleteIndex;
}
function $6d59a54f85e65dd7$var$isLeafLikeBlockNode(node) {
    return node.type.startsWith('media') || node.type.startsWith('extension') || node.type.endsWith('Extension') || /**
   * We want to treat tableRow as a leaf-like node so that we know cells are fully formed.
   * This will avoid any insertion issues while table is being streamed.
   */ $6d59a54f85e65dd7$var$leafLikeNodeTypes.includes(node.type);
}
function $6d59a54f85e65dd7$var$findLastLeafNode(doc) {
    let parent = doc;
    let leaf = doc.content && doc.content[doc.content.length - 1];
    while(leaf && !!leaf.content){
        if ($6d59a54f85e65dd7$var$isLeafLikeBlockNode(leaf)) break;
        parent = leaf;
        leaf = leaf.content[leaf.content.length - 1];
    }
    return {
        parent: parent,
        leaf: leaf
    };
}
/**
 * Generic function to mark a process as failed
 * @param analyticsEventsSessionData - The analytics session data
 * @param processStatus - The specific process status object to update
 * @param error - The error message to record
 */ function $6d59a54f85e65dd7$var$markProcessFailed({ analyticsEventsSessionData: analyticsEventsSessionData, processStatus: processStatus, error: error, stack: stack, validationError: validationError }) {
    processStatus.failed = true;
    processStatus.error = error;
    processStatus.recovered = false;
    processStatus.stack = stack;
    processStatus.validationError = validationError;
    /**
   * If multiple times process fails, only first and last failure will be recorded.
   * If need arise in future, then we can record all failures.
   */ processStatus.lastFailedAtChunk = analyticsEventsSessionData.chunksCount;
    if (processStatus.firstFailedAtChunk === 0) processStatus.firstFailedAtChunk = analyticsEventsSessionData.chunksCount;
}
/**
 * Generic function to mark a process as recovered
 * @param analyticsEventsSessionData - The analytics session data
 * @param processStatus - The specific process status object to update
 */ function $6d59a54f85e65dd7$var$markProcessRecovered({ analyticsEventsSessionData: analyticsEventsSessionData, processStatus: processStatus }) {
    /**
   * If failed and not recovered then only mark it as recovered.
   * If already recovered, then don't mark it as recovered again, otherwise recoveredAtChunk will have wrong value.
   */ if (processStatus.failed && !processStatus.recovered) {
        processStatus.recovered = true;
        processStatus.lastRecoveredAtChunk = analyticsEventsSessionData.chunksCount;
        if (processStatus.firstRecoveredAtChunk === 0) processStatus.firstRecoveredAtChunk = analyticsEventsSessionData.chunksCount;
    }
}
function $6d59a54f85e65dd7$var$markJsonRepairFailed(analyticsEventsSessionData, error) {
    $6d59a54f85e65dd7$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.json.repairJson,
        error: error
    });
}
function $6d59a54f85e65dd7$var$markJsonRepairRecovered(analyticsEventsSessionData) {
    $6d59a54f85e65dd7$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.json.repairJson
    });
}
function $6d59a54f85e65dd7$var$markFailedToRepairADF(analyticsEventsSessionData, error, stack) {
    $6d59a54f85e65dd7$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.failedToRepairADF,
        error: error,
        stack: stack
    });
}
function $6d59a54f85e65dd7$var$markFailedToRepairADFRecovered(analyticsEventsSessionData) {
    $6d59a54f85e65dd7$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.failedToRepairADF
    });
}
function $6d59a54f85e65dd7$var$markTopNodeFailed(analyticsEventsSessionData, error) {
    $6d59a54f85e65dd7$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNode,
        error: error
    });
}
function $6d59a54f85e65dd7$var$markTopNodeRecovered(analyticsEventsSessionData) {
    $6d59a54f85e65dd7$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNode
    });
}
function $6d59a54f85e65dd7$var$markTopNodeValidationFailed(analyticsEventsSessionData, error, validationError) {
    $6d59a54f85e65dd7$var$markProcessFailed({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNodeValidation,
        error: error,
        validationError: validationError
    });
}
function $6d59a54f85e65dd7$var$markTopNodeValidationRecovered(analyticsEventsSessionData) {
    $6d59a54f85e65dd7$var$markProcessRecovered({
        analyticsEventsSessionData: analyticsEventsSessionData,
        processStatus: analyticsEventsSessionData.adf.topNodeValidation
    });
}
const $6d59a54f85e65dd7$var$processStatusDefault = {
    failed: false,
    error: '',
    recovered: false,
    firstFailedAtChunk: 0,
    firstRecoveredAtChunk: 0,
    lastFailedAtChunk: 0,
    lastRecoveredAtChunk: 0
};
const $6d59a54f85e65dd7$var$createDefaultAnalyticsEventsSessionData = ()=>({
        chunksCount: 0,
        json: {
            repairJson: Object.assign({}, $6d59a54f85e65dd7$var$processStatusDefault)
        },
        adf: {
            topNode: Object.assign({}, $6d59a54f85e65dd7$var$processStatusDefault),
            repairInvalidContent: {
                wrappingNodesFoundEvents: [],
                nodeMovedToEndOfPreviousNodeEvents: [],
                invalidWrappingNodesEvents: [],
                wrappingNodesNotFoundEvents: []
            },
            failedToRepairADF: Object.assign({}, $6d59a54f85e65dd7$var$processStatusDefault),
            topNodeValidation: Object.assign({}, $6d59a54f85e65dd7$var$processStatusDefault)
        }
    });
function $6d59a54f85e65dd7$var$isEventForRepairInvalidContentExists(eventsRegistry, eventType, event) {
    return eventsRegistry[eventType].some((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(e, event));
}
class $6d59a54f85e65dd7$export$7e740171e70a13ac {
    setAnalyticsEventMetaData(analyticsEventMetaData) {
        this.analyticsEventMetaData = analyticsEventMetaData;
    }
    fireAnalyticEvent(event) {
        event.data = {
            ...event.data,
            ...this.analyticsEventMetaData
        };
        this.fireAnalyticEventCallback?.(event);
    }
    setInputDocumentTree(slice) {
        if (!slice || slice.size === 0) return;
        const empty = this.schema.topNodeType.createAndFill();
        if (!empty) return;
        try {
            const tr = new (0, $eOaGc.Transform)(empty).replaceRange(0, empty.content.size, slice);
            const json = tr.doc.toJSON();
            const tree = this.getPartialNodeTypeTree(json);
            this.inputDocumentTree = tree;
        } catch  {}
    }
    reset() {
        this.jsonRepair.reset();
        this.lastDoc = this.createDefaultDoc();
        this.analyticsEventMetaData = undefined;
        this.analyticsEventsSessionData = $6d59a54f85e65dd7$var$createDefaultAnalyticsEventsSessionData();
    }
    isInErrorState() {
        const isRepairJsonFailed = this.analyticsEventsSessionData.json.repairJson.failed && !this.analyticsEventsSessionData.json.repairJson.recovered;
        const isFailedToRepairADF = this.analyticsEventsSessionData.adf.failedToRepairADF.failed && !this.analyticsEventsSessionData.adf.failedToRepairADF.recovered;
        const isInvalidTopNode = this.analyticsEventsSessionData.adf.topNode.failed && !this.analyticsEventsSessionData.adf.topNode.recovered;
        const isTopNodeValidationFailed = this.analyticsEventsSessionData.adf.topNodeValidation.failed && !this.analyticsEventsSessionData.adf.topNodeValidation.recovered;
        const result = this.isEmptyLastDoc();
        const emptyLastDoc = result.isEmpty || !!result.deserializationError;
        if (result.deserializationError) this.fireAnalyticEvent({
            type: 'error',
            message: 'Deserializing last doc to node failed in isInErrorState',
            data: {
                error: result.deserializationError
            }
        });
        return isRepairJsonFailed || isFailedToRepairADF || isInvalidTopNode || isTopNodeValidationFailed || emptyLastDoc;
    }
    createDefaultDoc() {
        const defaultDoc = this.schema.topNodeType.createAndFill()?.toJSON();
        return {
            ...defaultDoc,
            version: 1
        };
    }
    /**
   * This method is used to append a chunk to the streamer.
   * It will not process the chunk, you need to call {@link ADFStreamer.processChunk} to process the chunk.
   *
   * This is usefull when you just want to append a chunk to the streamer without processing it.
   *
   * @param chunk - The chunk to append.
   */ appendChunk(chunk) {
        this.jsonRepair.append(chunk);
    }
    /**
   * This method is used to append and process a chunk.
   * @param chunk - The chunk to append and process.
   * @returns The streamer itself.
   */ processChunk(chunk) {
        this.analyticsEventsSessionData.chunksCount++;
        this.jsonRepair.append(chunk);
        try {
            const { hasChanged: hasChanged, repairedJson: repairedJson } = this.jsonRepair.parse();
            if (hasChanged) this.repairADFJson(repairedJson);
            $6d59a54f85e65dd7$var$markJsonRepairRecovered(this.analyticsEventsSessionData);
        } catch (jsonRepairError) {
            $6d59a54f85e65dd7$var$markJsonRepairFailed(this.analyticsEventsSessionData, jsonRepairError instanceof Error ? jsonRepairError.message : 'Unknown error');
        }
        return this;
    }
    /**
   * This method is used to get the last document without the last leaf node.
   * Because the last leaf node may not be complete yet and it will be repaired in the next stream.
   * You still need to call {@link ADFStreamer.getLastDoc} to get the last document after processing the last stream.
   *
   * @example
   *
   * // for loading
   * streamer.processChunk(stream);
   * streamer.getLastDocWithoutLastLeafNode();
   *
   * // for preview
   * streamer.getLastDoc();
   *
   * @returns The last document without the last leaf node.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getLastDocWithoutLastLeafNode() {
        const doc = this.createCopyOfDoc(this.lastDoc);
        const { parent: parent, leaf: leaf } = $6d59a54f85e65dd7$var$findLastLeafNode(doc);
        // bailout if empty content
        if (!leaf) return this.createCopyOfDoc(doc);
        // only keep text leaf node if it is not a link
        const keepTextLeaf = leaf && !!leaf.text && !$6d59a54f85e65dd7$var$isTextLink(leaf);
        if (// empty Paragraph
        $6d59a54f85e65dd7$var$isTextblock(this.schema, leaf.type) || keepTextLeaf) return this.createCopyOfDoc(doc);
        if (parent.type === 'table' && leaf.type === 'tableRow') {
            /**
       * For tables, we want to analyse whether or not the rows are actually complete.
       * This includes checking rows with merged cells.
       * We trim any incomplete rows at the end of the table to maintain structural integrity when streaming.
       */ const incompleteRows = $6d59a54f85e65dd7$var$countIncompleteRows(parent);
            if (!!parent.content) parent.content = parent.content.slice(0, parent.content.length - incompleteRows);
        } else {
            // being cautious here, because it may break the ADF if arbitrarily remove the last leaf node from any parent node
            // - remove last leaf node from paragraph-like parent node
            // - remove block node if its a leaf-like node
            const shouldRemoveLastLeaf = $6d59a54f85e65dd7$var$isLeafLikeBlockNode(leaf) || $6d59a54f85e65dd7$var$isTextblock(this.schema, parent.type);
            if (!!parent.content && parent.content.length > 0 && shouldRemoveLastLeaf) parent.content = parent.content.slice(0, parent.content.length - 1);
        }
        return this.createCopyOfDoc(doc);
    }
    getLastDoc() {
        return this.createCopyOfDoc(this.lastDoc);
    }
    /**
   * The plain-ADF counterpart of {@link getLastDoc}.
   *
   * The streamed document is ProseMirror-shaped: `sanitizeTopNode` promotes `panel` ->
   * `panel_c1` while streaming (gated on the `platform_editor_nest_table_in_panel` experiment)
   * so a valid ProseMirror node can be built when a panel nests a `table`. `panel_c1` is a
   * ProseMirror-only variant and is not a valid ADF node type, so a document containing it fails
   * ADF-spec validation and every offending node is wrapped as `unsupportedBlock`, silently
   * destroying content.
   *
   * This serialises through `JSONTransformer.encode`, the canonical ProseMirror -> ADF
   * serialiser, rather than renaming known node types. That covers every ProseMirror-only
   * construct rather than just container variants — `panel_c1` -> `panel`, a nested `table` back
   * to the `extension` ADF actually stores it as, and marks ADF does not permit on a given node
   * — and it cannot drift as new ProseMirror-only constructs are added.
   *
   * `getLastDoc` stays ProseMirror-shaped for callers that build ProseMirror nodes from it via
   * `Node.fromJSON`. Use this accessor when handing the document to anything that validates or
   * expects plain ADF — `processRawValue` (as `replaceDocument` does), the renderer, or a
   * service boundary. Those consumers apply the matching incoming transforms after validating,
   * so the round trip is lossless.
   *
   * @see EDITOR-8715
   */ getLastAdfDoc() {
        try {
            /**
       * Read `lastDoc` directly rather than through `getLastDoc`: `Node.fromJSON` does not
       * mutate its input and `encode` builds a fresh document, so the deep copy
       * `getLastDoc` makes would be allocated and immediately discarded.
       */ const pmNode = (0, $aPdNQ.Node).fromJSON(this.schema, this.lastDoc);
            return new (0, $2lPWP.JSONTransformer)(this.schema).encode(pmNode);
        } catch (e) {
            /**
       * `lastDoc` is only ever assigned from a ProseMirror node built against this schema, so
       * this should not happen. Fall back to the ProseMirror-shaped document rather than losing
       * it, and report it so the silent fallback is visible. This goes through `getLastDoc` so
       * the caller still gets a copy it cannot mutate internal state through.
       */ this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to serialise last doc to ADF.',
                data: {
                    error: e instanceof Error ? e.message : 'Unknown error',
                    stack: e instanceof Error ? e.stack : undefined
                }
            });
            return this.getLastDoc();
        }
    }
    createCopyOfDoc(doc) {
        /**
     * Some older browsers like chrome 97 doesn't support structuredClone.
     * So using JSON.parse(JSON.stringify()) as a fallback.
     */ if (typeof window !== 'undefined' && typeof window.structuredClone === 'function') return structuredClone(doc);
        else return JSON.parse(JSON.stringify(doc));
    }
    repairADFJson(partialJson) {
        /**
     * No need to wait till we get "type: doc" in the JSON.
     * First node type will always be schema.topNodeType, and can start repairing
     * 	the JSON as soon as there is content in it.
     */ const sanitizedTopNodeResult = this.sanitizeTopNode(partialJson);
        if (sanitizedTopNodeResult.failed) {
            $6d59a54f85e65dd7$var$markTopNodeFailed(this.analyticsEventsSessionData, sanitizedTopNodeResult.error);
            return this.lastDoc;
        }
        if (this.analyticsEventsSessionData.adf.topNode.failed) $6d59a54f85e65dd7$var$markTopNodeRecovered(this.analyticsEventsSessionData);
        const sanitizedTopNode = sanitizedTopNodeResult.sanitizedTopNode;
        try {
            const docRepairResult = this.repairNode({
                partialNodeJson: sanitizedTopNode,
                isTopNode: true
            });
            /**
       * repairNode will be undefined if the node cannot be repaired
       * We only update lastDoc if node is repaired successfully
       */ if (docRepairResult && docRepairResult.node) {
                const currentDoc = docRepairResult.node;
                const { result: result, error: error } = this.validateNodeUsingValidator(currentDoc);
                if (result) {
                    this.lastDoc = currentDoc.toJSON();
                    $6d59a54f85e65dd7$var$markTopNodeValidationRecovered(this.analyticsEventsSessionData);
                } else $6d59a54f85e65dd7$var$markTopNodeValidationFailed(this.analyticsEventsSessionData, error?.errorMessage || 'Invalid top node', error?.validationError);
                $6d59a54f85e65dd7$var$markFailedToRepairADFRecovered(this.analyticsEventsSessionData);
            }
        } catch (e) {
            $6d59a54f85e65dd7$var$markFailedToRepairADF(this.analyticsEventsSessionData, e instanceof Error ? e.message : 'Unknown error', e instanceof Error ? e.stack : undefined);
        }
        return this.lastDoc;
    }
    sanitizeTopNode(partialNodeJson) {
        let sanitizedTopNode = partialNodeJson;
        if (Array.isArray(partialNodeJson)) {
            /**
       * We have observed that LLM sometimes returns invalid adf json
       * 	or sometimes returns top partial node as an array.
       * For example, LLM forgets put curly bracket to close node,
       * 	and when jsonrepair repairs it, it will change top node to be an array.
       * And doc node becomes part of an array along with other nodes.
       *
       * So if we find top partialNodeJson as an array and found topNode (doc)
       * 	in array then move other nodes to topNode and return topNode.
       */ sanitizedTopNode = partialNodeJson.find((node)=>node.type === this.schema.topNodeType.name);
            if (sanitizedTopNode) {
                const otherNodes = partialNodeJson.filter((node)=>node.type !== this.schema.topNodeType.name);
                sanitizedTopNode.content = [
                    ...sanitizedTopNode.content || [],
                    ...otherNodes
                ];
            } else return {
                failed: true,
                error: 'Valid top node not found in array.'
            };
        } else if (typeof partialNodeJson !== 'object' || partialNodeJson === null) return {
            failed: true,
            error: 'Invalid top node.'
        };
        try {
            if ((0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
                const { isTransformed: isTransformed, transformedAdf: transformedAdf } = (0, $hD7pG.transformContainerNodes)(sanitizedTopNode, this.schema);
                if (isTransformed && transformedAdf) sanitizedTopNode = transformedAdf;
            }
        } catch (e) {
            return {
                failed: true,
                error: `Error transforming container nodes: ${e instanceof Error ? e.message : 'Unknown error'}`
            };
        }
        return {
            failed: false,
            sanitizedTopNode: sanitizedTopNode
        };
    }
    repairNode(...args) {
        return (0, $iDrrr.fg)('platform_editor_ai_refactor_repair_method') ? this.repairNodeNew(...args) : this.repairNodeOld(...args);
    }
    repairNodeOld({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        const type = this.inferNodeType({
            partialNodeJson: partialNodeJson,
            parentNodeType: parentNodeType,
            isTopNode: isTopNode
        });
        if (!type) {
            // If type can't be inferred, then we can't repair the node, so skipping it.
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to infer node type.',
                data: {
                    nodeType: partialNodeJson.type ?? 'type is undefined'
                }
            });
            return;
        }
        let marksToUse = partialNodeJson.marks;
        const repairedMarksResult = (0, $1784c64cb85a57c5$export$fb8ba848cbd161c6)(type.name, marksToUse);
        if (repairedMarksResult.repairedMarks && repairedMarksResult.repairedMarks.length > 0) marksToUse = repairedMarksResult.repairedMarks;
        repairedMarksResult.errors && repairedMarksResult.errors.length;
        const maybeMarks = marksToUse ? marksToUse.map((mark)=>this.createMark(mark))// Type guard isn't necessary in newer versions of TypeScript
        .filter((mark)=>mark !== null) : [];
        if (type.name === 'text') /**
       * Empty text node is not allowed in prosemirror.
       * Checkout: https://prosemirror.net/docs/ref/#model.Schema.text
       * That's why when text is not available, we are using space as default.
       */ return {
            node: this.schema.text(partialNodeJson.text ? partialNodeJson.text : ' ', maybeMarks),
            invalidNodes: []
        };
        if (type.name === 'date') {
            const today = new Date().getTime().toString();
            partialNodeJson.attrs = partialNodeJson.attrs || {};
            if (partialNodeJson.attrs.timestamp) {
                if (typeof partialNodeJson.attrs.timestamp === 'string') {
                    if (partialNodeJson.attrs.timestamp.includes('-')) {
                        const d = new Date(partialNodeJson.attrs.timestamp);
                        partialNodeJson.attrs.timestamp = isNaN(d.getTime()) ? today : d.getTime().toString();
                    } else if (!String(partialNodeJson.attrs.timestamp).match($6d59a54f85e65dd7$var$DIGITS_ONLY_REGEX)) partialNodeJson.attrs.timestamp = today;
                }
            } else partialNodeJson.attrs.timestamp = today;
        }
        if (type.name === 'panel' && partialNodeJson.attrs?.panelType === 'tip') partialNodeJson.attrs.panelType = 'info';
        const maybeContent = partialNodeJson.content ? this.repairContent({
            newContent: partialNodeJson.content,
            parentNodeType: type
        }).filter((node)=>!!node).map((node)=>this.schema.nodeFromJSON(node)) : undefined;
        let attrsToUse = partialNodeJson.attrs;
        if ((0, $iDrrr.fg)('platform_editor_ai_repair_attrs_with_validatorspec')) {
            // EDITOR-2316 Send analytic event when repairing of mark happens.
            const repairedAttrsResult = (0, $70d7b1d3710e18f8$export$fde9f26eb5c83773)(type.name, attrsToUse);
            if (repairedAttrsResult.isValid) attrsToUse = repairedAttrsResult.repairedAttrs;
        }
        let node = type.createAndFill(attrsToUse, maybeContent, maybeMarks);
        let invalidNodes = [];
        /**
     * If node is null, then it means content is invalid and fitting wrapping node is not found.
     * We need to repair the content and try again.
     */ if (!node && maybeContent) {
            const { repairedContent: repairedContent, invalidNodes: invalidNodesFromRepairInvalidContent } = this.repairInvalidContent({
                parentNodeType: type,
                maybeContent: maybeContent
            });
            invalidNodes = invalidNodesFromRepairInvalidContent;
            node = type.createAndFill(attrsToUse, repairedContent, maybeMarks);
            if (!node) {
                /**
         * Tried to repair content, but still failed. So need to skip this node.
         */ this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Tried to repair content of node, but failed.',
                    data: {
                        nodeType: type.name ?? 'type is undefined',
                        repairedContentNodeTypeTree: repairedContent.map((node)=>this.getNodeTypeTree(node)),
                        originalNodeTypeTree: this.getPartialNodeTypeTree(partialNodeJson)
                    }
                });
                return;
            }
        }
        return {
            node: node,
            invalidNodes: invalidNodes
        };
    }
    repairNodeNew({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        const type = this.inferNodeType({
            partialNodeJson: partialNodeJson,
            parentNodeType: parentNodeType,
            isTopNode: isTopNode
        });
        if (!type) {
            // If type can't be inferred, then we can't repair the node, so skipping it.
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to infer node type.',
                data: {
                    nodeType: partialNodeJson.type ?? 'type is undefined'
                }
            });
            return;
        }
        let marksToUse = partialNodeJson.marks;
        const repairedMarksResult = (0, $1784c64cb85a57c5$export$fb8ba848cbd161c6)(type.name, marksToUse);
        if (repairedMarksResult.repairedMarks && repairedMarksResult.repairedMarks.length > 0) marksToUse = repairedMarksResult.repairedMarks;
        repairedMarksResult.errors && repairedMarksResult.errors.length;
        const maybeMarks = marksToUse ? marksToUse.map((mark)=>this.createMark(mark))// Type guard isn't necessary in newer versions of TypeScript
        .filter((mark)=>mark !== null) : [];
        if (type.name === 'text') /**
       * Empty text node is not allowed in prosemirror.
       * Checkout: https://prosemirror.net/docs/ref/#model.Schema.text
       * That's why when text is not available, we are using space as default.
       */ return {
            node: this.schema.text(partialNodeJson.text ? partialNodeJson.text : ' ', maybeMarks),
            invalidNodes: []
        };
        const maybeContent = partialNodeJson.content ? this.repairContent({
            newContent: partialNodeJson.content,
            parentNodeType: type
        }).filter((node)=>!!node).map((node)=>this.schema.nodeFromJSON(node)) : undefined;
        let validAttrs = partialNodeJson.attrs;
        if ((0, $iDrrr.fg)('platform_editor_ai_repair_attrs_with_validatorspec')) {
            // EDITOR-2316 Send analytic event when repairing of mark happens.
            const repairedAttrsResult = (0, $70d7b1d3710e18f8$export$fde9f26eb5c83773)(type.name, validAttrs);
            if (repairedAttrsResult.isValid) validAttrs = repairedAttrsResult.repairedAttrs;
        }
        const validNode = {
            ...partialNodeJson,
            attrs: validAttrs
        };
        const supportedNode = (0, $a0c1a7681045b403$export$dd6751dd7e5e8e9a)(type.name, validNode);
        let node = type.createAndFill(supportedNode.attrs, maybeContent, maybeMarks);
        let invalidNodes = [];
        /**
     * If node is null, then it means content is invalid and fitting wrapping node is not found.
     * We need to repair the content and try again.
     */ if (!node && maybeContent) {
            const { repairedContent: repairedContent, invalidNodes: invalidNodesFromRepairInvalidContent } = this.repairInvalidContent({
                parentNodeType: type,
                maybeContent: maybeContent
            });
            invalidNodes = invalidNodesFromRepairInvalidContent;
            node = type.createAndFill(supportedNode.attrs, repairedContent, maybeMarks);
            if (!node) {
                /**
         * Tried to repair content, but still failed. So need to skip this node.
         */ this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Tried to repair content of node, but failed.',
                    data: {
                        nodeType: type.name ?? 'type is undefined',
                        repairedContentNodeTypeTree: repairedContent.map((node)=>this.getNodeTypeTree(node)),
                        originalNodeTypeTree: this.getPartialNodeTypeTree(supportedNode)
                    }
                });
                return;
            }
        }
        return {
            node: node,
            invalidNodes: invalidNodes
        };
    }
    repairInvalidContent({ parentNodeType: parentNodeType, maybeContent: maybeContent }) {
        let currentContentMatch = parentNodeType.contentMatch;
        const invalidNodes = [];
        const repairedContent = [];
        maybeContent.forEach((node, index)=>{
            const nextContentMatch = currentContentMatch.matchType(node.type);
            if (nextContentMatch) {
                /**
         * this node is allowed in the parent node.
         * so continue to the next node.
         */ currentContentMatch = nextContentMatch;
                repairedContent.push(node);
            } else {
                const { taskItem: taskItem, paragraph: paragraph } = this.schema.nodes;
                /**
         * The LLM has been observed to occasionally wrap taskItem content inside a paragraph.
         * Task items support the same content as paragraph so we unwrap the pargaraph into the taskItem..
         */ if (parentNodeType === taskItem && node.type === paragraph) {
                    repairedContent.push(...node.content.content);
                    return;
                }
                /**
         * We've noticed that the LLM occasionally omits closing } or ] brackets,
         * 	causing the node to be incorrectly moved from its parent and placed as a sibling.
         *
         * If node is not valid at this position, then check if it is valid child
         * 	at end in previous node. If it is, then move it to the end of previous node.
         *
         * Use repairedContent instead of maybeContent to avoid duplicate nodes.
         */ if (index > 0 && repairedContent.length > 0) {
                    const previousNode = repairedContent[repairedContent.length - 1];
                    const previousNodeChildCount = previousNode.childCount;
                    if (previousNode.canReplaceWith(previousNodeChildCount, previousNodeChildCount, node.type)) {
                        const previousNodeContent = previousNode.content;
                        const newPreviousNodeContent = previousNodeContent.addToEnd(node);
                        const newPreviousNode = previousNode.copy(newPreviousNodeContent);
                        repairedContent[repairedContent.length - 1] = newPreviousNode;
                        /**
             * During streaming, invalid content will be repaired on processing every chunk.
             * Without checking if event already exists, it will fire multiple events for same node.
             * With duplicate events, analyzing the data will be difficult.
             */ const event = {
                            parentNodeType: parentNodeType.name,
                            previousNodeType: previousNode.type.name,
                            movedNodeType: node.type.name,
                            oldChildIndex: index,
                            childIndexInPreviousNode: previousNodeContent.childCount
                        };
                        if (!$6d59a54f85e65dd7$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'nodeMovedToEndOfPreviousNodeEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.nodeMovedToEndOfPreviousNodeEvents.push(event);
                        return;
                    }
                }
                /**
         * this node is not allwed directly in parent node.
         * so let's check if we wrap this node with other nodes, it can be allowed or not.
         */ const wrappingNodeTypes = currentContentMatch.findWrapping(node.type);
                let currentChildNode = node;
                if (wrappingNodeTypes) {
                    for(let i = wrappingNodeTypes?.length - 1; i >= 0; i--){
                        const wrappingNodeType = wrappingNodeTypes[i];
                        const nextChildNode = wrappingNodeType.createAndFill(null, [
                            currentChildNode
                        ]);
                        if (nextChildNode) currentChildNode = nextChildNode;
                        else {
                            /**
               * This should not happen as prosemirror should never give us such a wrappingNodes
               * so that createAndFill fails.
               * Buf it this happens, we need to fire analytic event, so that we diagnose the issue.
               */ const event = {
                                childNodeType: node.type.name,
                                childIndex: index,
                                wrappingNodeType: wrappingNodeType.name,
                                currentChildNode: currentChildNode.type.name
                            };
                            if (!$6d59a54f85e65dd7$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'invalidWrappingNodesEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.invalidWrappingNodesEvents.push(event);
                            return;
                        }
                    }
                    const event = {
                        childNodeType: node.type.name,
                        childIndex: index,
                        wrappingNodeTypes: wrappingNodeTypes.map((nodeType)=>nodeType.name),
                        parentNodeType: parentNodeType.name
                    };
                    if (!$6d59a54f85e65dd7$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'wrappingNodesFoundEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesFoundEvents.push(event);
                    repairedContent.push(currentChildNode);
                } else {
                    /**
           * this node is not allowed in the parent node as child at any level.
           * For example, a table node can't be a child of a bulletList node at any level.
           *
           * This can happen because sometimes LLM gives us a node that is not allowed in the parent node.
           * Or LLM gives us invalid json, and jsonrepair repairs it in such a way that
           * 	node is shifted and placed in a place where it's not allowed in the parent node.
           *
           * The node is collected into `invalidNodes`, which `repairContent` appends to
           * `repairedContent` as a sibling of the parent. The node is re-parented rather
           * than discarded, which is why this is reported as `info`.
           */ const event = {
                        childNodeType: node.type.name,
                        parentNodeType: parentNodeType.name,
                        childIndex: index
                    };
                    if (!$6d59a54f85e65dd7$var$isEventForRepairInvalidContentExists(this.analyticsEventsSessionData.adf.repairInvalidContent, 'wrappingNodesNotFoundEvents', event)) this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesNotFoundEvents.push(event);
                    invalidNodes.push(node);
                }
            }
        });
        return {
            repairedContent: repairedContent.filter((node)=>!!node),
            invalidNodes: invalidNodes
        };
    }
    inferNodeType({ partialNodeJson: partialNodeJson, parentNodeType: parentNodeType, isTopNode: isTopNode }) {
        /**
     * If type is still not available, and, node has been previously repaired,
     * then just use type of the repaired node.
     * And if node hasn't been repaired, then use default type based on parent node type.
     */ let type = null;
        if (partialNodeJson.type) type = this.schema.nodes[partialNodeJson.type];
        if (!type) {
            if (isTopNode) type = this.schema.topNodeType;
            else if ($6d59a54f85e65dd7$var$isTextblock(this.schema, parentNodeType?.name) || /**
       * codeBlock nodeType returns "unsupportedInline" as defaultType.
       * Because prosemirror never returns text node as defaultType.
       * So overriding "text" as defaultType for codeBlock.
       */ parentNodeType?.name === 'codeBlock' || /**
       * If node has text as child, then use text as defaultType.
       */ typeof partialNodeJson === 'object' && 'text' in partialNodeJson) type = this.schema.nodes.text;
        }
        return type || parentNodeType?.contentMatch.defaultType;
    }
    repairContent({ newContent: newContent, parentNodeType: parentNodeType }) {
        const repairedContent = [];
        newContent.forEach((node, index)=>{
            /**
       * If repairing node fails, then instead of failing processing whole document,
       * 	just skip the node and continue with the next node.
       */ try {
                const nodeRepairResult = this.repairNode({
                    partialNodeJson: node,
                    parentNodeType: parentNodeType
                });
                if (nodeRepairResult?.node) repairedContent.push(nodeRepairResult.node.toJSON());
                if (nodeRepairResult?.invalidNodes && nodeRepairResult?.invalidNodes.length > 0) repairedContent.push(...nodeRepairResult.invalidNodes.map((node)=>node.toJSON()));
            } catch (e) {
                this.fireAnalyticEvent({
                    type: 'error',
                    message: 'Failed to repair node',
                    data: {
                        error: e instanceof Error ? e.message : 'Unknown error',
                        stack: e instanceof Error ? e.stack : undefined,
                        nodeType: node.type ?? 'type is undefined',
                        parentNodeType: parentNodeType.name,
                        childIndex: index
                    }
                });
            }
        });
        return repairedContent;
    }
    validateNodeUsingValidator(node, parentNodeType) {
        const nodes = Object.keys(this.schema.nodes);
        const marks = Object.keys(this.schema.marks);
        const validate = (0, $3ztIq.validator)(nodes, marks, {
            allowPrivateAttributes: true,
            mode: 'strict',
            stage0: (0, $iDrrr.fg)('platform_editor_adf_validator_stage0')
        });
        try {
            const isNestedTable = node.type.name === 'table' && (parentNodeType?.name === 'tableCell' || parentNodeType?.name === 'tableHeader');
            if (isNestedTable) return {
                result: true
            };
            let error;
            const errorCallback = (entity, validationError)=>{
                error = {
                    nodeType: entity.type ?? 'type is undefined',
                    validationError: validationError
                };
                return undefined;
            };
            const validation = validate({
                ...node?.toJSON(),
                /**
         * In the ProseMirror model the doc version is a number, but
         * ADF validator expects a string. We override this manually here as the
         * version number is trivial to doc formation.
         */ ...node.type.name === 'doc' ? {
                    version: '1'
                } : {}
            }, errorCallback);
            if (validation.valid) return {
                result: true,
                entity: validation.entity,
                error: error
            };
            return {
                result: false,
                error: error
            };
        } catch (e) {
            return {
                result: false,
                error: {
                    nodeType: node.type.name,
                    errorMessage: e instanceof Error ? e.message : 'Unknown error'
                }
            };
        }
    }
    createMark(json) {
        if (json.type) {
            const type = this.schema.marks[json.type];
            if (!type) {
                this.fireAnalyticEvent({
                    type: 'info',
                    message: 'Failed to repair mark, type not found',
                    data: {
                        markType: json.type
                    }
                });
                return null;
            }
            return type.create(json.attrs);
        }
        return null;
    }
    getPartialNodeTypeTree(node) {
        const children = node.content;
        return {
            type: node.type,
            content: Array.isArray(children) ? children.map((child)=>this.getPartialNodeTypeTree(child)) : []
        };
    }
    getNodeTypeTree(node) {
        const children = node.content;
        return {
            type: node.type.name,
            content: Array.isArray(children) ? children.map((child)=>this.getNodeTypeTree(child)) : []
        };
    }
    isEmptyLastDoc() {
        try {
            const docNode = this.schema.nodeFromJSON(this.lastDoc);
            return {
                isEmpty: // If doc has no child then it is empty.
                docNode.childCount <= 1 && // By default, lastDoc has empty paragraph as child of doc node.
                docNode.firstChild?.type.name === 'paragraph' && docNode.firstChild?.childCount === 0,
                deserializationError: undefined
            };
        } catch (error) {
            return {
                isEmpty: false,
                deserializationError: error instanceof Error ? error.message : 'Unknown error'
            };
        }
    }
    endStreamingSession({ hasProcessedFinalResponse: hasProcessedFinalResponse, streamEndedWithoutFinalResponse: streamEndedWithoutFinalResponse } = {}) {
        this.fireAnalyticEvent({
            type: 'info',
            message: 'Number of chunks processed',
            data: {
                chunksCount: this.analyticsEventsSessionData.chunksCount,
                inputDocumentTree: this.inputDocumentTree
            }
        });
        if (streamEndedWithoutFinalResponse) this.fireAnalyticEvent({
            type: 'error',
            message: 'Stream ended without final response',
            data: {
                chunksCount: this.analyticsEventsSessionData.chunksCount,
                isEmptyLastDoc: this.isEmptyLastDoc().isEmpty,
                inputDocumentTree: this.inputDocumentTree
            }
        });
        /**
     * When input to LLM is very small, like couple of words,
     * then few stream events are sent which has empty doc,
     * and final response completes doc with transformed couple of words.
     *
     * So firing empty doc event only when final response is processed.
     */ if (hasProcessedFinalResponse) {
            const result = this.isEmptyLastDoc();
            if (result.isEmpty) this.fireAnalyticEvent({
                type: 'error',
                message: 'Top node is empty',
                data: {
                    inputDocumentTree: this.inputDocumentTree
                }
            });
            if (result.deserializationError) this.fireAnalyticEvent({
                type: 'error',
                message: 'Deserializing last doc to node failed',
                data: {
                    error: result.deserializationError
                }
            });
        }
        if (this.analyticsEventsSessionData.json.repairJson.failed) {
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to repair partial JSON using jsonrepair',
                data: {
                    error: this.analyticsEventsSessionData.json.repairJson.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.lastFailedAtChunk,
                    recovered: this.analyticsEventsSessionData.json.repairJson.recovered,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.json.repairJson.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.json.repairJson.lastRecoveredAtChunk
                }
            });
            if (!this.analyticsEventsSessionData.json.repairJson.recovered) this.fireAnalyticEvent({
                type: 'error',
                message: 'Received invalid json',
                data: {
                    error: this.analyticsEventsSessionData.json.repairJson.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.json.repairJson.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.failedToRepairADF.failed) {
            if (this.analyticsEventsSessionData.adf.failedToRepairADF.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Failed to repair ADF json during streaming, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.failedToRepairADF.error,
                    stack: this.analyticsEventsSessionData.adf.failedToRepairADF.stack,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastFailedAtChunk,
                    recovered: this.analyticsEventsSessionData.adf.failedToRepairADF.recovered,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Failed to repair ADF Json',
                data: {
                    error: this.analyticsEventsSessionData.adf.failedToRepairADF.error,
                    stack: this.analyticsEventsSessionData.adf.failedToRepairADF.stack,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.failedToRepairADF.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.topNode.failed) {
            if (this.analyticsEventsSessionData.adf.topNode.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Got invalid top not, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNode.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.lastFailedAtChunk,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNode.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNode.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Invalid top node',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNode.error,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNode.lastFailedAtChunk
                }
            });
        }
        if (this.analyticsEventsSessionData.adf.topNodeValidation.failed) {
            if (this.analyticsEventsSessionData.adf.topNodeValidation.recovered) this.fireAnalyticEvent({
                type: 'info',
                message: 'Top node validation failed, but recovered',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNodeValidation.error,
                    validationError: this.analyticsEventsSessionData.adf.topNodeValidation.validationError,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastFailedAtChunk,
                    firstRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstRecoveredAtChunk,
                    lastRecoveredAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastRecoveredAtChunk
                }
            });
            else this.fireAnalyticEvent({
                type: 'error',
                message: 'Top node validation failed',
                data: {
                    error: this.analyticsEventsSessionData.adf.topNodeValidation.error,
                    validationError: this.analyticsEventsSessionData.adf.topNodeValidation.validationError,
                    firstFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.firstFailedAtChunk,
                    lastFailedAtChunk: this.analyticsEventsSessionData.adf.topNodeValidation.lastFailedAtChunk
                }
            });
        }
        this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesFoundEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Wrapping nodes found',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.nodeMovedToEndOfPreviousNodeEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Node moved to the end of previous node',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.invalidWrappingNodesEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Invalid wrapping nodes found for node.',
                data: {
                    ...event
                }
            });
        });
        this.analyticsEventsSessionData.adf.repairInvalidContent.wrappingNodesNotFoundEvents.forEach((event)=>{
            this.fireAnalyticEvent({
                type: 'info',
                message: 'Wrapping nodes not found.',
                data: {
                    ...event
                }
            });
        });
        // Derive a compact repair-signal summary that callers (e.g. the streaming
        // orchestrator) can use to classify the overall session outcome. Gated
        // behind `platform_editor_ai_normalized_telemetry` so the function is a
        // pure no-op (return `undefined`) for callers when the experiment is
        // off, preserving the original `void`-style behaviour bit-for-bit.
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_normalized_telemetry', 'isEnabled', true)) return undefined;
        const finalJsonInvalid = this.analyticsEventsSessionData.json.repairJson.failed;
        const finalJsonRepaired = finalJsonInvalid && this.analyticsEventsSessionData.json.repairJson.recovered;
        const failedToRepairADFInvalid = this.analyticsEventsSessionData.adf.failedToRepairADF.failed;
        const topNodeValidationInvalid = this.analyticsEventsSessionData.adf.topNodeValidation.failed;
        const finalAdfInvalid = failedToRepairADFInvalid || topNodeValidationInvalid;
        // finalAdfRepaired is true iff every layer that failed also recovered.
        const failedToRepairADFRecovered = failedToRepairADFInvalid ? this.analyticsEventsSessionData.adf.failedToRepairADF.recovered : true;
        const topNodeValidationRecovered = topNodeValidationInvalid ? this.analyticsEventsSessionData.adf.topNodeValidation.recovered : true;
        const finalAdfRepaired = finalAdfInvalid && failedToRepairADFRecovered && topNodeValidationRecovered;
        return {
            finalJsonInvalid: finalJsonInvalid,
            finalJsonRepaired: finalJsonRepaired,
            finalAdfInvalid: finalAdfInvalid,
            finalAdfRepaired: finalAdfRepaired
        };
    }
    constructor(schema, fireAnalyticEvent){
        this.jsonRepair = void 0;
        this.schema = void 0;
        this.lastDoc = void 0;
        this.fireAnalyticEventCallback = void 0;
        this.analyticsEventMetaData = void 0;
        this.inputDocumentTree = void 0;
        this.analyticsEventsSessionData = $6d59a54f85e65dd7$var$createDefaultAnalyticsEventsSessionData();
        this.jsonRepair = new (0, $aee3606115b2c7e7$export$c1ee0a0b09546958)();
        this.schema = schema;
        this.fireAnalyticEventCallback = fireAnalyticEvent;
        this.lastDoc = this.createDefaultDoc();
        this.inputDocumentTree = undefined;
    }
}
module.exports["ADFStreamer"] = $6d59a54f85e65dd7$export$7e740171e70a13ac;

});

parcelRegister("irqyl", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ // eslint-disable-next-line import/order

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $cMyWi = parcelRequire("cMyWi");


var $cRgxl = parcelRequire("cRgxl");


var $cLgZp = parcelRequire("cLgZp");


var $4o0zT = parcelRequire("4o0zT");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $9DPMp = parcelRequire("9DPMp");


var $8lhhf = parcelRequire("8lhhf");


var $26Q4g = parcelRequire("26Q4g");


var $hEuOY = parcelRequire("hEuOY");


var $2lPWP = parcelRequire("2lPWP");














var $iN8Pe = parcelRequire("iN8Pe");

/**
 * [CCI-15904] Meta key carried on a ProseMirror transaction that performs the final AI
 * streaming transformation (i.e. the commit of a single tool-call's content into the doc).
 *
 * The payload allows downstream plugins to:
 *   - know the exact doc range that was replaced (start/end positions in the new doc),
 *   - replay the change (newSlice) for "redo",
 *   - revert the change (originalUserContentSlice) for "undo",
 * without needing to inspect the transaction step-by-step.
 *
 * Set by `buildCommitTransaction` (only when the New AIFC Editor Experience gate is ON).
 * Consumed by the `aiSessionContextPlugin` to maintain `aiContentPositions`.
 */ const $45a530918d906c25$export$fa15c525f457d46f = 'aiFinalStreamingTransformationData';
const $45a530918d906c25$export$ddd5126f1bcc0334 = 'aiContentSegmentData';
const $45a530918d906c25$export$14effd2e9e406215 = 'aiOriginalNodeData';
const $45a530918d906c25$export$3ce83cf64ed42309 = 'captureAbortedToolCallPositions';



var $4TgUg = parcelRequire("4TgUg");


var $C4yPo = parcelRequire("C4yPo");


var $277Za = parcelRequire("277Za");


var $1jz5K = parcelRequire("1jz5K");

const $a9ea1b9d36e0a953$export$6dc7fbb714e86543 = ({ editorView: editorView, targetId: targetId })=>{
    if (!targetId) return null;
    let targetPos;
    editorView.state.doc.descendants((node, pos)=>{
        if (node.attrs.localId === targetId || node.attrs.id === targetId) {
            targetPos = pos;
            return false;
        }
        return true;
    });
    const targetDom = targetPos !== undefined ? editorView.nodeDOM(targetPos) : null;
    return targetDom instanceof HTMLElement ? targetDom : targetDom?.parentElement ?? null;
};
const $a9ea1b9d36e0a953$export$e9bc0794c89ce54d = ({ editorView: editorView, targetId: targetId })=>{
    const target = $a9ea1b9d36e0a953$export$6dc7fbb714e86543({
        editorView: editorView,
        targetId: targetId
    });
    if (!target) return;
    try {
        const editorDocument = editorView.dom.ownerDocument;
        const editorWindow = editorDocument.defaultView;
        const root = (0, $1jz5K.findOverflowScrollParent)(editorView.dom);
        const targetRect = target.getBoundingClientRect();
        const windowRect = {
            bottom: editorWindow?.innerHeight ?? editorDocument.documentElement.clientHeight,
            left: 0,
            right: editorWindow?.innerWidth ?? editorDocument.documentElement.clientWidth,
            top: 0
        };
        const measuredRootRect = root && root !== editorDocument.body ? root.getBoundingClientRect() : windowRect;
        const visibleRootRect = {
            bottom: Math.min(measuredRootRect.bottom, windowRect.bottom),
            left: Math.max(measuredRootRect.left, windowRect.left),
            right: Math.min(measuredRootRect.right, windowRect.right),
            top: Math.max(measuredRootRect.top, windowRect.top)
        };
        return targetRect.bottom > visibleRootRect.top && targetRect.right > visibleRootRect.left && targetRect.top < visibleRootRect.bottom && targetRect.left < visibleRootRect.right;
    } catch  {
        return;
    }
};


/**
 * Whether the frontend (in-editor) Review moment auto-open is enabled.
 *
 * Driven by the `isFrontendReviewMomentEnabled` param on the
 * `platform_editor_ai_new_aifc_editor_experience` experiment. Read via the
 * no-exposure variant (exposure is already logged by `isNewAifcExperienceEnabled`
 * on the same paths). Mirrors `isDiffBasedSegmentingEnabled`.
 */ 
var $mW7G5 = parcelRequire("mW7G5");

function $84d40fd50758b97d$export$8ce0619a5b63e89e() {
    return (0, $mW7G5.expValNoExposure)('platform_editor_ai_new_aifc_editor_experience', 'isFrontendReviewMomentEnabled', false);
}


/**
 * [CCI-15904] New AIFC Editor Experience — eligibility check.
 *
 * Returns true when the user is enrolled in the "New AIFC Editor Experience" — an umbrella
 * experiment that covers the Post Stream Review toolbar and the Full Page Staging Area.
 *
 * AND-gated with `platform_editor_ai_xstate_migration` because the new experience relies on
 * the xstate / orchestrator architecture (e.g. `buildCommitTransaction` only fires there).
 */ 





function $a44d2501b233a83e$export$9fbb7446fea5a4a3() {
    return (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) && (0, $ieeJu.expValEquals)('platform_editor_ai_new_aifc_editor_experience', 'isBackendReviewMomentEnabled', true);
}
function $a44d2501b233a83e$export$4d8717ba02388642() {
    return (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_xstate_migration', 'isEnabled', true) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_new_aifc_editor_experience', 'isBackendReviewMomentEnabled', true);
}


const $d07adef0b9b690ae$var$isEditorAgentMentionsExperimentEnabled = ()=>(0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true);
const $d07adef0b9b690ae$export$e49a2031d0d2ff07 = ({ invokedFrom: invokedFrom, aiOptIn: aiOptIn, aiSessionContextType: aiSessionContextType, configItem: configItem, editorView: editorView, triggeredFor: triggeredFor, isExternal: isExternal = false, withAcceptReject: withAcceptReject = true, withStreamingHighlight: withStreamingHighlight = true, hideLoadingScreen: hideLoadingScreen = false, traceId: traceId, singleInstrumentationId: singleInstrumentationId, isCreate: isCreate, promptVersion: promptVersion, userADFInput: userADFInput, overrideFromPos: overrideFromPos, overrideToPos: overrideToPos, shouldExpandPositions: shouldExpandPositions, beforeTransform: beforeTransform, skipSelectionHighlight: skipSelectionHighlight, preserveModalMountTimestamp: preserveModalMountTimestamp })=>{
    if (!editorView) return;
    const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
        state: editorView.state,
        configItem: configItem,
        lastTriggeredFrom: invokedFrom,
        aiGlobalOptIn: aiOptIn,
        aiSessionContextType: aiSessionContextType,
        triggeredFor: triggeredFor,
        isExternal: isExternal,
        withAcceptReject: withAcceptReject,
        withStreamingHighlight: withStreamingHighlight,
        hideLoadingScreen: hideLoadingScreen,
        traceId: traceId,
        singleInstrumentationId: singleInstrumentationId,
        isCreate: isCreate,
        promptVersion: promptVersion,
        userADFInput: userADFInput,
        overrideFromPos: overrideFromPos,
        overrideToPos: overrideToPos,
        shouldExpandPositions: shouldExpandPositions,
        beforeTransform: beforeTransform,
        skipSelectionHighlight: skipSelectionHighlight,
        preserveModalMountTimestamp: preserveModalMountTimestamp
    });
    openAIModalCommand(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$eb7c7403500d1c40 = ({ editorView: editorView })=>{
    if (!editorView) return;
    const endAIExperienceCommand = (0, $4TgUg.createEndAIExperienceCommand)();
    endAIExperienceCommand(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$254dcf4812f17c19 = ({ editorView: editorView, sessionId: sessionId, traceId: traceId, promptVersion: promptVersion, agentInfo: agentInfo, agentAttribution: agentAttribution, isCreateSession: isCreateSession, isInlineEditSession: isInlineEditSession })=>{
    if (!editorView) return;
    // agentInfo is intentionally gated behind the experiment flag.
    // When the experiment is off, agentInfo is silently discarded so that
    // downstream code never receives agent identity data in the session state.
    const agentInfoForSession = $d07adef0b9b690ae$var$isEditorAgentMentionsExperimentEnabled() ? agentInfo : undefined;
    return (0, $4TgUg.createStartAISessionCommand)(sessionId, traceId, (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined, agentInfoForSession, isCreateSession, isInlineEditSession, agentAttribution)(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$3a08ee9ddec0cdee = ({ api: api, editorView: editorView, sessionId: sessionId, metadata: metadata, baseGenerate: baseGenerate, aiOptIn: aiOptIn })=>{
    if (!editorView) return;
    // Read before the END_SESSION dispatch clears it: a create stream has nothing
    // to review, so the Post Stream Review auto-open below is suppressed.
    const isCreateSession = !!(0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state)?.isCreateSession;
    // Read before the END_SESSION dispatch clears it. On the
    // orchestrated (Rovo-chat) update path the Post Stream Review "Review moment"
    // is only auto-opened for inline edits (Rovo prompts issued from inside the
    // Editor, i.e. `experience === 'inline_edit'`). Non-inline orchestrated updates
    // leave this flag unset, so the auto-open below is suppressed for them.
    const isInlineEditSession = !!(0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state)?.isInlineEditSession;
    // [platform_editor_remove_pause_streaming] When aborting during streaming
    // (e.g. from the Rovo sidebar stop button), dispatch COMPLETE to commit
    // partial content, and endStream to re-enable the editor.
    // For the inline stop path, Loading.tsx dispatches
    // these BEFORE calling abort(), so status is already 'complete' here and
    // this block is skipped.
    if (metadata?.type === 'abort' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) && api) $d07adef0b9b690ae$export$203e4f5cbd70f715({
        api: api,
        editorView: editorView
    });
    const endSessionCommand = (0, $C4yPo.createCommand)((state)=>{
        const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
        const nextSessionId = aiDecorationExperiencePluginState.nextSessionId;
        // If a session which is not the next session is trying to be ended then we should abort trying to end the session.
        // An empty sessionId (from user-initiated stop) bypasses this check
        // since the session ID may not be available in all streaming entry points.
        if (sessionId && sessionId !== nextSessionId) return false;
        return {
            type: 'END_SESSION',
            data: {
                sessionId: undefined,
                type: metadata?.type
            }
        };
    }, (tr)=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) // When the New AIFC Editor Experience is enabled, fire END_SESSION
        // instead of RESET so the `aiContentPositions` array is retained for the
        // Post Stream Review toolbar to navigate.
        tr.setMeta((0, $iN8Pe.aiSessionContextPluginKey), {
            type: (0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)() ? 'END_SESSION' : 'RESET'
        });
        return tr;
    });
    const result = endSessionCommand(editorView.state, editorView.dispatch);
    // After a clean 'finished' stream, auto-open the Post Stream Review modal on the
    // next tick (after END_SESSION commits), gated by `isFrontendReviewMomentEnabled`.
    if ((0, $84d40fd50758b97d$export$8ce0619a5b63e89e)() && result && // Never auto-open the Review moment for a create stream.
    !isCreateSession && // Only auto-open the Review moment for inline edits.
    isInlineEditSession && (0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)() && (metadata?.type === 'finished' || metadata?.type === 'abort' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true)) && baseGenerate && aiOptIn) // Defer so the END_SESSION transaction is committed before reading state.
    Promise.resolve().then(()=>{
        if (!editorView || editorView.isDestroyed) return;
        const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state);
        const reviewSegments = sessionState?.streamReviewSegments ?? [];
        if (reviewSegments.length) {
            const displaySegments = reviewSegments.flatMap((segment)=>segment.diffSegments?.length ? segment.diffSegments : [
                    segment
                ]);
            const desiredIndex = sessionState?.currentStreamReviewSegmentIndex ?? 0;
            const segmentIndex = displaySegments.length > 0 ? Math.max(0, Math.min(desiredIndex, displaySegments.length - 1)) : 0;
            const segment = displaySegments[segmentIndex];
            if (segment) {
                $d07adef0b9b690ae$export$298c2762a7935072({
                    editorView: editorView,
                    baseGenerate: baseGenerate,
                    aiOptIn: aiOptIn,
                    segmentData: {
                        segmentIndex: segmentIndex,
                        positions: {
                            startPos: segment.startPos,
                            endPos: segment.endPos
                        }
                    }
                });
                return;
            }
        }
        const positions = sessionState?.aiContentPositions ?? [];
        if (positions.length) {
            // The Post Stream Review modal opens in AGGREGATE mode by
            // default. In aggregate mode it is:
            //   - anchored below the LAST segment (the most recent change), so the
            //     user lands at the end of the AI's edits, and
            //   - highlighted across ALL segments — we span the highlight from the
            //     earliest segment start to the latest segment end so the whole
            //     reviewed region is visible at once.
            const lastIndex = positions.length - 1;
            const aggregateStart = Math.min(...positions.map((p)=>p.startPos));
            const aggregateEnd = Math.max(...positions.map((p)=>p.endPos));
            $d07adef0b9b690ae$export$298c2762a7935072({
                editorView: editorView,
                baseGenerate: baseGenerate,
                aiOptIn: aiOptIn,
                mode: 'aggregate',
                segmentData: {
                    segmentIndex: lastIndex,
                    positions: {
                        startPos: aggregateStart,
                        endPos: aggregateEnd
                    }
                }
            });
        }
    });
    return result;
};
const $d07adef0b9b690ae$export$298c2762a7935072 = ({ editorView: editorView, aiOptIn: aiOptIn, baseGenerate: baseGenerate, segmentData: segmentData = {
    segmentIndex: 0
}, beforeTransform: beforeTransform, appliedIndexUpdate: appliedIndexUpdate, acceptedUpdate: acceptedUpdate, positionsUpdate: positionsUpdate, mode: mode, preserveModalMountTimestamp: preserveModalMountTimestamp })=>{
    if (!editorView) return;
    const { segmentIndex: segmentIndex, positions: explicitPositions } = segmentData;
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state);
    // Prefer caller-supplied positions when provided (Undo/Redo case).
    // Otherwise fall back to the positions stored on the session-context plugin —
    // the normal path for the initial auto-open and Previous/Next navigation.
    const segment = explicitPositions ?? sessionState?.aiContentPositions?.[segmentIndex];
    if (!segment) return;
    const configItem = baseGenerate ?? (0, $C4yPo.getPluginState)(editorView.state).configItem;
    if (!configItem) return;
    const resolvedAiOptIn = aiOptIn ?? sessionState?.currentStreamReviewAiOptIn;
    if (!resolvedAiOptIn) return;
    $d07adef0b9b690ae$export$e49a2031d0d2ff07({
        editorView: editorView,
        aiOptIn: resolvedAiOptIn,
        configItem: configItem,
        // (afm-ai-pr-review-bot #3) `'postStreamReview'` is now a first-class
        // member of the `InvokedFrom` union (see analyticsFlowTypes.ts), so the
        // `as InvokedFrom` cast that previously bypassed the type system is no
        // longer needed.
        invokedFrom: 'postStreamReview',
        // Anchor the modal at the segment's range — not the user's current selection.
        overrideFromPos: segment.startPos,
        overrideToPos: segment.endPos,
        shouldExpandPositions: false,
        // The Post Stream Review screen handles its own accept / reject (undo / redo
        // against stored slices), and there is no streaming to highlight.
        withAcceptReject: false,
        withStreamingHighlight: false,
        hideLoadingScreen: true,
        aiSessionContextType: {
            type: 'POST_STREAM_REVIEW',
            currentStreamReviewSegmentIndex: segmentIndex,
            aiOptIn: resolvedAiOptIn,
            appliedIndexUpdate: appliedIndexUpdate,
            acceptedUpdate: acceptedUpdate,
            positionsUpdate: positionsUpdate,
            mode: mode
        },
        isExternal: true,
        beforeTransform: beforeTransform,
        // Keep the modal anchored via mount-point decorations, but don't
        // highlight the reviewed text in the Review moment.
        skipSelectionHighlight: true,
        preserveModalMountTimestamp: preserveModalMountTimestamp
    });
};
const $d07adef0b9b690ae$export$955fdaa156e3249e = ({ editorView: editorView, targetId: targetId })=>{
    if (!editorView) return;
    return (0, $4TgUg.createUpdateTargetIdCommand)(targetId)(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$c256c77f565752b8 = ({ editorView: editorView, targetId: targetId })=>{
    if (!editorView) return;
    return (0, $4TgUg.createStageInlineRovoStreamingCommand)(targetId)(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$93371cae6bf62876 = ({ editorView: editorView })=>{
    if (!editorView) return;
    return (0, $4TgUg.createCommitInlineRovoStreamingCommand)()(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$1f0b2dec3e9892b1 = ({ editorView: editorView })=>{
    if (!editorView) return;
    return (0, $4TgUg.createEndInlineRovoStreamingCommand)()(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$3912329751e3609c = ({ editorView: editorView, targetId: targetId })=>{
    if (!editorView) return;
    return (0, $4TgUg.createShowInlineEditReadyCommand)(targetId)(editorView.state, editorView.dispatch);
};
const $d07adef0b9b690ae$export$e9bc0794c89ce54d = ({ editorView: editorView, targetId: targetId })=>{
    if (!editorView) return;
    return (0, $a9ea1b9d36e0a953$export$e9bc0794c89ce54d)({
        editorView: editorView,
        targetId: targetId
    });
};
const $d07adef0b9b690ae$export$159ce495a6d11302 = ({ selection: selection, maxSize: maxSize = 10000 })=>{
    if (!selection) return undefined;
    const { $from: $from, $to: $to } = selection;
    const doc = $from.doc;
    /**
   * Check the from and to positions of the lowest depth level (doc level).
   * If the size is over the threshold, increase the depth.
   */ let depth = 0;
    while(// Check until max depth is reached from the resolved positions
    !isNaN($from.start(depth)) && !isNaN($to.end(depth))){
        const from = $from.start(depth);
        const to = $to.end(depth);
        if (to - from < maxSize) break;
        depth++;
    }
    if (depth === 0) return doc;
    // find a depth that fits and then start looking at siblings n - 1 and n + 1 and so on
    const parentDepth = depth - 1;
    const index = $from.index(parentDepth);
    let from = $from.start(depth);
    let to = $to.end(depth);
    let increment = 1;
    const maxIndex = $from.node(parentDepth).childCount;
    while(// Loop until both ends of the bounds have been reached
    index - increment >= 0 || index + increment <= maxIndex){
        const newFrom = $from.posAtIndex(Math.max(index - increment, 0), parentDepth);
        // We look ahead at the next index as posAtIndex yields the starting position of the node
        const newTo = $to.posAtIndex(Math.min(index + increment + 1, maxIndex), parentDepth);
        let isPositionUpdated = false;
        if (to - newFrom < maxSize) {
            from = newFrom;
            isPositionUpdated = true;
        }
        if (newTo - from < maxSize) {
            to = newTo;
            isPositionUpdated = true;
        }
        if (!isPositionUpdated) break;
        increment++;
    }
    return doc.cut(from, to);
};
const $d07adef0b9b690ae$export$cb4bd847e3d154fe = (options)=>{
    const transformer = new (0, $2lPWP.JSONTransformer)();
    const doc = $d07adef0b9b690ae$export$159ce495a6d11302(options);
    if (doc) return transformer.encode(doc);
};
const $d07adef0b9b690ae$export$3e64d26c171d92fc = (options)=>{
    const doc = $d07adef0b9b690ae$export$159ce495a6d11302(options);
    if (doc) return (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: doc
    })?.markdown ?? '';
};
const $d07adef0b9b690ae$export$99447d9e0d76b7ef = (tr, options)=>{
    if (options?.isFinal) return tr.setMeta('isAIFinalStreamingTransformation', true);
    return tr.setMeta('isAIStreamingTransformation', true);
};
const $d07adef0b9b690ae$export$df225d463d80633a = (tr, segments)=>{
    // Post Stream Review (and therefore segment recording) only exists under the
    // New AIFC Editor Experience. When the gate is OFF there is no PSR, so this
    // is a no-op — handlers can call it unconditionally.
    if (!(0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)()) return tr;
    if (!segments || segments.length === 0) return tr;
    const existing = tr.getMeta((0, $45a530918d906c25$export$ddd5126f1bcc0334));
    const merged = {
        segments: [
            ...existing?.segments ?? [],
            ...segments
        ]
    };
    return tr.setMeta((0, $45a530918d906c25$export$ddd5126f1bcc0334), merged);
};
const $d07adef0b9b690ae$export$ed36a76977c3023b = (tr, originalNode)=>{
    if (!(0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)()) return tr;
    const data = {
        originalNode: originalNode
    };
    return tr.setMeta((0, $45a530918d906c25$export$14effd2e9e406215), data);
};
function $d07adef0b9b690ae$export$203e4f5cbd70f715({ api: api, editorView: editorView }) {
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state);
    if (!sessionState || sessionState.status !== 'streaming') return;
    api.aiExperience.actions.dispatchAIEvent({
        type: 'complete',
        adfResponse: sessionState.adfResponse,
        markdown: sessionState.markdown
    });
    const tr = editorView.state.tr;
    (0, $277Za.endStream)(tr);
    editorView.dispatch(tr);
}






var $7SvWS = parcelRequire("7SvWS");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");








var $97CWy = parcelRequire("97CWy");


var $7qHrr = parcelRequire("7qHrr");

const $359c3648a2c08b84$export$6d92f14e56d09aa = ({ editorView: editorView, api: api, insertedContentNodeTransformer: insertedContentNodeTransformer, payload: payload, positions: positions, scrollIntoView: scrollIntoView = true })=>{
    return ()=>{
        if (payload.mode === 'upload-and-insert-media') // upload-and-insert-media mode — not handled here
        return null;
        const { state: state } = editorView;
        const pmFragment = payload.data.type === 'text/markdown' ? (0, $97CWy.convertMarkdownToProsemirror)({
            markdown: payload.data.content,
            schema: state.schema,
            idMap: {}
        }).pmFragment : (0, $aPdNQ.Fragment).fromJSON(state.schema, payload.data.content);
        if (!pmFragment) return null;
        let tr = payload.placement === 'replace-selection' ? (0, $7qHrr.replaceWithAIContent)({
            editorView: editorView,
            positions: positions,
            pmFragment: pmFragment,
            insertedContentNodeTransformer: insertedContentNodeTransformer,
            options: {
                replaceDocOnEmptySelection: false
            }
        }) : (0, $7qHrr.insertAIContentAtCurrentPosition)({
            editorView: editorView,
            positions: positions,
            pmFragment: pmFragment,
            insertedContentNodeTransformer: insertedContentNodeTransformer
        });
        // Queue URLs for smartlink resolution.
        //
        // Use the transaction's step range (which already reflects all applied
        // steps, including any node transformations performed during insertion)
        // rather than `pmFragment.size`, which is captured before
        // `insertedContentNodeTransformer` may have modified node sizes.
        const stepRange = (0, $7SvWS.getStepRange)(tr);
        const queueCardsFromRangeCommand = api?.card?.commands?.queueCardsFromRange;
        const useScopedQueueCardsFromRange = (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true);
        if (useScopedQueueCardsFromRange && stepRange && queueCardsFromRangeCommand) {
            const updatedTr = queueCardsFromRangeCommand(stepRange.from, stepRange.to, (0, $krYZG.INPUT_METHOD).MANUAL)({
                tr: tr
            });
            if (updatedTr) tr = updatedTr;
        } else if (api?.card?.actions.queueCardsFromChangedTr) // Fallback for older card plugin versions without queueCardsFromRange,
        // or when the transaction has no step range to scope to. The
        // `queueCardsFromChangedTr` action is a no-op when there are no
        // steps, so it is safe to call unconditionally here.
        tr = api.card.actions.queueCardsFromChangedTr(state, tr, (0, $krYZG.INPUT_METHOD).MANUAL);
        (0, $7qHrr.beforeDispatchAIRovoAgentTransaction)(tr);
        if (scrollIntoView) tr.scrollIntoView();
        else tr.setMeta('scrollIntoView', false);
        // keep the user selection if user move the cursor during remixing or
        // select the inserted position so that the floating toolbar don't appear
        if ((payload.placement === 'after-block' || payload.placement === 'replace-selection') && (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading')) {
            const oldBeforeNodeEndPos = positions[1] - 1;
            const oldNode = editorView.state.doc.resolve(positions[1]).nodeBefore;
            if (oldNode) {
                const oldAfterNodeOpenPos = oldBeforeNodeEndPos - oldNode.content.size;
                // get the position of the start and end of the node where Remix is invoked
                const beforeNodeEndPos = tr.mapping.map(oldBeforeNodeEndPos);
                const afterNodeOpenPos = tr.mapping.map(oldAfterNodeOpenPos);
                // get the mapped position after the inserted content
                let to = tr.mapping.map(positions[1]);
                // if the user selection is not within the node, use the mapped position of the user selection
                if (!(tr.mapping.map(editorView.state.selection.from) >= afterNodeOpenPos && tr.mapping.map(editorView.state.selection.to) <= beforeNodeEndPos)) to = tr.mapping.map(editorView.state.selection.to);
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to));
            }
        }
        return tr;
    };
};






var $fRYCB = parcelRequire("fRYCB");


var $kuJJh = parcelRequire("kuJJh");


var $3Bmdi = parcelRequire("3Bmdi");

const $083f95bd26d6fd7e$var$initialState = {
    isWatching: false,
    watchFrom: undefined,
    watchTo: undefined,
    startingAnnotationIds: undefined
};
const $083f95bd26d6fd7e$export$120e869ffea6ac01 = (options)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $3Bmdi.aiAnnotationWatchmenPluginKey),
        state: {
            init: ()=>$083f95bd26d6fd7e$var$initialState,
            apply: (tr, pluginState, _, ns)=>{
                if (!options.onAnnotationsAdded && !options.onAnnotationsRemoved && !options.onAnnotationsChanged) return pluginState;
                const meta = tr.getMeta((0, $3Bmdi.aiAnnotationWatchmenPluginKey));
                const { isWatching: isWatching, watchFrom: watchFrom, watchTo: watchTo, startingAnnotationIds: startingAnnotationIds } = pluginState;
                switch(meta?.action){
                    case (0, $kuJJh.ACTIONS).START_WATCHING_REGION:
                        {
                            const { from: from, to: to } = meta;
                            if (from === undefined || to === undefined) return pluginState;
                            const mappedFrom = tr.mapping.map(from, -1);
                            const mappedTo = tr.mapping.map(to, 1);
                            const ids = (0, $fRYCB.getAnnotationIdsFromRange)({
                                from: mappedFrom,
                                to: mappedTo
                            }, tr.doc, ns.schema);
                            return {
                                isWatching: true,
                                watchFrom: mappedFrom,
                                watchTo: mappedTo,
                                startingAnnotationIds: ids
                            };
                        }
                    case (0, $kuJJh.ACTIONS).END_WATCHING_REGION:
                        {
                            if (watchFrom === undefined || watchTo === undefined) return pluginState;
                            const ids = (0, $fRYCB.getAnnotationIdsFromRange)({
                                from: tr.mapping.map(watchFrom, -1),
                                to: tr.mapping.map(watchTo, 1)
                            }, tr.doc, ns.schema);
                            const removedIds = startingAnnotationIds?.filter((id)=>!ids.includes(id)) ?? [];
                            const addedIds = ids.filter((id)=>!startingAnnotationIds?.includes(id)) ?? [];
                            if (!!options.onAnnotationsRemoved && removedIds?.length) options.onAnnotationsRemoved(removedIds);
                            if (!!options.onAnnotationsAdded && addedIds?.length) options.onAnnotationsAdded(addedIds);
                            if (!!options.onAnnotationsChanged && (removedIds?.length || addedIds?.length)) {
                                const changes = removedIds.map((id)=>({
                                        annotationId: id,
                                        type: 'REMOVED'
                                    })).concat(addedIds.map((id)=>({
                                        annotationId: id,
                                        type: 'ADDED'
                                    })));
                                options.onAnnotationsChanged(changes);
                            }
                            return {
                                isWatching: false,
                                watchFrom: undefined,
                                watchTo: undefined,
                                startingAnnotationIds: undefined
                            };
                        }
                }
                return {
                    isWatching: isWatching,
                    startingAnnotationIds: startingAnnotationIds,
                    watchFrom: watchFrom !== undefined ? tr.mapping.map(watchFrom, -1) : undefined,
                    watchTo: watchTo !== undefined ? tr.mapping.map(watchTo, 1) : undefined
                };
            }
        }
    });
};






var $cI8RZ = parcelRequire("cI8RZ");




const $ad01fea32b311e84$export$d41d542343dd0571 = new (0, $kCECX.PluginKey)('aiAuditLogs');


const $cbab9a749f90a1cc$export$a339266ad71b2447 = 2000;
const $cbab9a749f90a1cc$export$85b84234e02688c1 = 2;


function $315ca3b6b9f31005$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case 'UPDATE_PLUGIN_STATE':
            return {
                ...pluginState,
                'ai-generated-content-inserted': {
                    ...pluginState['ai-generated-content-inserted'],
                    ...action.data['ai-generated-content-inserted']
                },
                'aup-violation': {
                    ...pluginState['aup-violation'],
                    ...action.data['aup-violation']
                }
            };
        default:
            return pluginState;
    }
}


function $2a68ba4eecdcc75b$var$onDocChanged(tr, pluginState) {
    const eventState = pluginState['ai-generated-content-inserted'];
    if (eventState.eventStatus === 'not-sent' && tr.getMeta('isAiContentTransformation')) return {
        ...pluginState,
        'ai-generated-content-inserted': {
            ...eventState,
            eventStatus: 'send-event'
        }
    };
    return pluginState;
}
const $2a68ba4eecdcc75b$export$de5e90bd767c5d82 = (eventData)=>(_state)=>{
        return {
            'ai-generated-content-inserted': {
                eventStatus: 'not-sent',
                retries: 0
            },
            'aup-violation': {
                eventStatus: 'not-sent',
                retries: 0
            },
            maxRetries: (0, $cbab9a749f90a1cc$export$85b84234e02688c1),
            retryDelay: (0, $cbab9a749f90a1cc$export$a339266ad71b2447),
            eventData: eventData
        };
    };
const $2a68ba4eecdcc75b$var$dest = (0, $cI8RZ.pluginFactory)((0, $ad01fea32b311e84$export$d41d542343dd0571), (0, $315ca3b6b9f31005$export$1650419e431d3ba3), {
    onDocChanged: $2a68ba4eecdcc75b$var$onDocChanged
});
const $2a68ba4eecdcc75b$export$656c7661095efe2e = $2a68ba4eecdcc75b$var$dest.createPluginState;
const $2a68ba4eecdcc75b$export$8d4021544bdece00 = $2a68ba4eecdcc75b$var$dest.createCommand;
const $2a68ba4eecdcc75b$export$f05434c51e3762e = $2a68ba4eecdcc75b$var$dest.getPluginState;




var $gcCwL = parcelRequire("gcCwL");


async function $191018c65431c8fe$export$da4c3508f56b63bc(event, view) {
    /**
	 * Always get pluginState from view.state as view.state is always latest state
	 * 	as sendAuditLogEvent is called in recursion and depend on pluginState
	 * 	updated by previous call.
	 */ const pluginState = (0, $2a68ba4eecdcc75b$export$f05434c51e3762e)(view.state);
    const { eventData: eventData, retryDelay: retryDelay } = pluginState;
    const eventState = pluginState[event];
    const entityId = eventData.type === 'page' ? eventData.pageId : eventData.issueId;
    $191018c65431c8fe$export$c16f4f0c4f1ae3d4({
        [event]: {
            retries: eventState.retries + 1
        }
    })(view.state, view.dispatch);
    function retrySendingEvent() {
        if (eventState.retries < pluginState.maxRetries) setTimeout(()=>{
            $191018c65431c8fe$export$da4c3508f56b63bc(event, view);
        }, retryDelay);
    }
    try {
        // API spec is not finalised yet.
        // We may have one or two separate APIs, don't know yet.
        // So below section will be changed once spec is finalised.
        const response = await fetch((0, $gcCwL.convoAIAuditLogApiURL), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                event: event,
                ai_feature_input: {
                    entityId: entityId
                }
            })
        });
        if (response.ok) $191018c65431c8fe$export$c16f4f0c4f1ae3d4({
            [event]: {
                eventStatus: 'event-sent'
            }
        })(view.state, view.dispatch);
        else retrySendingEvent();
    } catch (e) {
        retrySendingEvent();
    }
}
const $191018c65431c8fe$export$c16f4f0c4f1ae3d4 = (pluginState)=>(0, $2a68ba4eecdcc75b$export$8d4021544bdece00)((state)=>{
        return {
            type: 'UPDATE_PLUGIN_STATE',
            data: pluginState
        };
    }, (tr)=>tr.setMeta('addToHistory', false));


const $72f839746c0648a3$export$5c0f6fec45bb2e7b = [
    'ai-generated-content-inserted',
    'aup-violation'
];


const $b9fd7a60437115d0$export$b07b9a8a474c46fb = (options)=>{
    const { dispatch: dispatch, eventData: eventData } = options;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $ad01fea32b311e84$export$d41d542343dd0571),
        state: (0, $2a68ba4eecdcc75b$export$656c7661095efe2e)(dispatch, (0, $2a68ba4eecdcc75b$export$de5e90bd767c5d82)(eventData)),
        view (_view) {
            return {
                update: (view)=>{
                    const pluginState = (0, $2a68ba4eecdcc75b$export$f05434c51e3762e)(view.state);
                    (0, $72f839746c0648a3$export$5c0f6fec45bb2e7b).forEach((event)=>{
                        const eventState = pluginState[event];
                        if (eventState.eventStatus === 'send-event') {
                            (0, $191018c65431c8fe$export$c16f4f0c4f1ae3d4)({
                                [event]: {
                                    eventStatus: 'event-in-progress'
                                }
                            })(view.state, view.dispatch);
                            (0, $191018c65431c8fe$export$da4c3508f56b63bc)(event, view);
                        }
                    });
                }
            };
        }
    });
};









var $bjg0G = parcelRequire("bjg0G");


var $doWyc = parcelRequire("doWyc");




const $3597cc6021decfa3$export$521879fd431ff390 = new (0, $kCECX.PluginKey)('aiExperienceAIButton');


const $8c69998779abdc50$export$e65c99dea6a50353 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $3597cc6021decfa3$export$521879fd431ff390),
        state: {
            init: ()=>({
                    isSelectionValidForAIExperience: true
                }),
            // eslint-disable-next-line @typescript-eslint/max-params
            apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                const toggleAiEntryPoints = tr.getMeta('toggleAiEntryPoints');
                if (typeof toggleAiEntryPoints === 'boolean') return {
                    ..._pluginState,
                    areAiEntryPointsDisabled: toggleAiEntryPoints
                };
                if (tr.selectionSet) {
                    const selection = tr.selection;
                    const { $from: $from } = selection;
                    const parent = $from.parent;
                    const { codeBlock: codeBlock, tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = newEditorState.schema.nodes;
                    const isNodeSelection = selection instanceof (0, $kCECX.NodeSelection);
                    const isSelectionInCodeBlock = parent.type === codeBlock;
                    const isCellSelection = [
                        tableHeader,
                        tableCell,
                        tabeRow,
                        table
                    ].includes(parent.type);
                    // AI button is always disabled for Node selection.
                    // AI button is always disabled for Cell selection.
                    // AI button is always disabled for selection in code block.
                    // For all other selection and empty selections AI button is enabled.
                    let isSelectionValidForAIExperience = true;
                    if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) isSelectionValidForAIExperience = false;
                    let newPluginState = {
                        areAiEntryPointsDisabled: _pluginState?.areAiEntryPointsDisabled,
                        isSelectionValidForAIExperience: isSelectionValidForAIExperience
                    };
                    const getParentSupportedForAIButton = ()=>{
                        const supportedNodesForAI = (0, $doWyc.getSupportedNodesForAIModal)(newEditorState);
                        if (isNodeSelection) return supportedNodesForAI.has(selection.node.type) ? selection.node : undefined;
                        else {
                            const parentNodeFindResult = (0, $bjg0G.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                            return parentNodeFindResult?.node;
                        }
                    };
                    const parentSupportedForAIButton = getParentSupportedForAIButton();
                    const { from: from, to: to } = selection;
                    if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
                        const isTextSelection = selection instanceof (0, $kCECX.TextSelection);
                        const isSelectionValidForAIExperience = !isSelectionInCodeBlock && (isTextSelection || !!parentSupportedForAIButton);
                        const triggeredFor = parentSupportedForAIButton?.type;
                        newPluginState = {
                            areAiEntryPointsDisabled: _pluginState?.areAiEntryPointsDisabled,
                            isSelectionValidForAIExperience: isSelectionValidForAIExperience,
                            triggeredFor: triggeredFor
                        };
                    }
                    return newPluginState;
                }
                return _pluginState;
            }
        }
    });
};












const $d58f4089cc6c0aeb$export$e54fe7f659b58e64 = new (0, $kCECX.PluginKey)('aiEventHub');



var $9XB2W = parcelRequire("9XB2W");

const $3f9da29c050e7e33$var$EventHubEvent = {
    StartPrompt: 'start prompt',
    ReplaceConfluenceTitle: 'replace title in confluence',
    AiExperienceLlmComplete: 'ai experience llm complete'
};
const $3f9da29c050e7e33$var$LINK_SOURCE_TYPE = {
    CONFLUENCE: 'CONFLUENCE_LINK',
    LOOM: 'LOOM_LINK',
    GOOGLE_DOC: 'GOOGLE_DOC_LINK'
};
const $3f9da29c050e7e33$export$4cefcfab1f987be5 = {
    SuggestTitleConfluenceTitleToolbar: 'suggest title in confluence title toolbar',
    SuggestTitle: 'suggest title',
    DraftReply: 'draft reply',
    GenerateEscalationNotes: 'generate escalation notes',
    IncidentSmartComments: 'incident smart comments',
    CustomPrompt: 'custom prompt',
    IssueReformatter: 'issue reformatter',
    DescriptionCompleter: 'description completer',
    Summarize: 'summarize',
    ImproveWriting: 'improve writing',
    MakeShorter: 'make shorter',
    FixSpellingGrammar: 'fix spelling and grammar',
    ChangeToneToProfessional: 'change tone to professional',
    ChangeToneToNeutral: 'change tone to neutral',
    ChangeToneToEmpathetic: 'change tone to empathetic',
    ChangeToneToCasual: 'change tone to casual',
    ChangeToneToEducational: 'change tone to educational',
    DraftReplyPill: 'draft reply pill',
    SuggestComment: 'suggest comment'
};






var $2MofN = parcelRequire("2MofN");


var $hZdqw = parcelRequire("hZdqw");

const $868c3e7a3428b046$export$3ddc9d41f6af5056 = ({ editorView: editorView, dispatch: dispatch, prompt: prompt, adjustSelection: adjustSelection, promptText: promptText })=>{
    const errorEventTr = (0, $hZdqw.addAnalytics)({
        editorState: editorView.state,
        tr: editorView.state.tr,
        payload: {
            action: 'error',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'eventHubPlugin',
            attributes: {
                errorType: 'promptConfigItemNotFound',
                prompt: prompt,
                promptText: promptText,
                adjustSelection: adjustSelection
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        }
    });
    dispatch(errorEventTr);
};
function $868c3e7a3428b046$var$fireSuggestedTitleAnalyticsEvent({ api: api, analyticSourceId: analyticSourceId, additionalAttributes: additionalAttributes }) {
    api?.analytics?.actions.fireAnalyticsEvent({
        action: 'streamingCompleted',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'eventHubPlugin',
        attributes: {
            promptType: (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
            modalHidden: true,
            analyticSourceId: analyticSourceId,
            ...additionalAttributes
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    });
}
const $868c3e7a3428b046$export$268e0492b4645ae4 = ({ api: api, analyticSourceId: analyticSourceId, isDateTimeFormat: isDateTimeFormat })=>{
    $868c3e7a3428b046$var$fireSuggestedTitleAnalyticsEvent({
        api: api,
        analyticSourceId: analyticSourceId,
        additionalAttributes: {
            fallbackSuggestedTitleReturned: true,
            isDateTimeFormat: isDateTimeFormat
        }
    });
};
async function $868c3e7a3428b046$var$hashString(input) {
    const encoder = new TextEncoder();
    const data = encoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}
const $868c3e7a3428b046$export$8e68345bacf55b30 = (configItem)=>configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
const $868c3e7a3428b046$export$544cb5cc4b426cad = async ({ api: api, analyticSourceId: analyticSourceId, suggestedTitle: suggestedTitle })=>{
    const suggestedTitleFingerprint = await $868c3e7a3428b046$var$hashString(suggestedTitle);
    $868c3e7a3428b046$var$fireSuggestedTitleAnalyticsEvent({
        api: api,
        analyticSourceId: analyticSourceId,
        additionalAttributes: {
            fallbackSuggestedTitleReturned: false,
            suggestedTitleFingerprint: suggestedTitleFingerprint
        }
    });
};








function $c2c6d211a4290fa3$export$2c6858d7c847006(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value) {
    return 'selection' in value && typeof value.selection === 'string';
}
function $c2c6d211a4290fa3$export$77a7a46521e984a3(item) {
    return !!item;
}
function $c2c6d211a4290fa3$export$475f2e7e3b5c59c4({ editorView: editorView, positions: positions, isEmpty: isEmpty, item: item }) {
    const { triggers: triggers } = item;
    const doc = editorView.state.doc;
    // Size of the doc with a single empty paragraph is 4
    const docSize = doc.nodeSize - 4;
    const selectionSize = positions[1] - positions[0];
    if (triggers.canShow && !triggers.canShow({
        editorView: editorView,
        docSize: docSize,
        selectionSize: selectionSize
    })) return false;
    const emptyOptions = triggers.empty;
    const emptyEnabled = emptyOptions.enabled;
    const docMinSize = emptyOptions.docMinSize ?? 0;
    const docMaxSize = emptyOptions.docMaxSize ?? Number.MAX_SAFE_INTEGER;
    const selectionOptions = triggers.selection;
    const selectionEnabled = selectionOptions.enabled;
    const selectionMinSize = selectionOptions.selectionMinSize ?? 1;
    const selectionMaxSize = selectionOptions.selectionMaxSize ?? Number.MAX_SAFE_INTEGER;
    if (isEmpty) {
        if (!emptyEnabled || docSize < docMinSize || docSize > docMaxSize) return false;
    } else {
        if (!selectionEnabled || selectionSize < selectionMinSize || selectionSize > selectionMaxSize) return false;
    }
    return true;
}
function $c2c6d211a4290fa3$export$a64e27216c5d7416({ isEmpty: isEmpty, configItem: configItem }) {
    if (!configItem) return [];
    const actions = (isEmpty ? configItem.actions.empty : configItem.actions.selection) ?? [];
    return actions;
}
function $c2c6d211a4290fa3$export$2dd2807afbd4a532({ configItemWithOptions: configItemWithOptions, editorView: editorView, positions: positions, isEmpty: isEmpty }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        if ($c2c6d211a4290fa3$export$475f2e7e3b5c59c4({
            editorView: editorView,
            positions: positions,
            isEmpty: isEmpty,
            item: item
        })) arr.push(item.config);
    });
    return arr;
}
function $c2c6d211a4290fa3$export$2527a005bbcba079({ configItemWithOptions: configItemWithOptions }) {
    const arr = [];
    configItemWithOptions.forEach((item)=>{
        if (!item) return;
        arr.push(item.config);
    });
    return arr;
}
function $c2c6d211a4290fa3$export$d97f37f32ae9d000(configItem, formatMessage) {
    // for agents return the saved agent name in the same language as it was saved
    if (configItem.agent) {
        const presetTitle = `@${configItem.agent.name}`;
        return presetTitle || formatMessage(configItem.title);
    }
    // adding beta label for the translation prompts
    if (configItem.key.startsWith('Translate to')) return formatMessage(configItem.title);
    // for all other items return the i18n-ed title
    return formatMessage(configItem.title);
}
function $c2c6d211a4290fa3$export$4539b8c6808af330(configItem, formatMessage) {
    /**
   * When the config item is silently using agent behind the scenes for prompt
   * then don't show the prompt label
   */ if (!configItem.silentAgentPrompt && configItem.agent) // for agents return the saved agent name in the same language as it was saved
    return `@${configItem.agent.name}`;
    // intentionally fall back to undefined as this value is checked to verify if we need to show the prompt input
    return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
}



var $hXIpv = parcelRequire("hXIpv");


const $aa7765f711bd6a4f$var$getConfigFromProvider = (editorPluginAIProvider, configType, key)=>{
    if (key === (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE) return editorPluginAIProvider.baseGenerate;
    else {
        const configItem = (0, $c2c6d211a4290fa3$export$2527a005bbcba079)({
            configItemWithOptions: editorPluginAIProvider.configItemWithOptions
        }).find((suggestion)=>suggestion.key === key);
        return configItem;
    }
};
const $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection = (adjustSelection)=>{
    switch(adjustSelection){
        case 'fullDocument':
            return 'rangeConfig';
        case 'keepCurrent':
            return 'rangeConfig';
        default:
            return 'emptyConfig';
    }
};
const $aa7765f711bd6a4f$export$bd5d7e8cfaa78c6f = (prompt, editorPluginAIProvider, adjustSelection, additionalPayloadData)=>{
    switch(prompt){
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).SuggestTitleConfluenceTitleToolbar:
            return (0, $hXIpv.suggestTitleForConfluenceTitleToolbar)();
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).SuggestTitle:
            {
                const suggestTitle = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE);
                return suggestTitle;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).DraftReply:
            {
                const draftReply = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE);
                return draftReply;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).GenerateEscalationNotes:
            {
                const generateEscalationNotes = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).GENERATE_ESCALATION_NOTES);
                return generateEscalationNotes;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).IncidentSmartComments:
            {
                const incidentSmartComments = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).INCIDENT_SMART_COMMENTS);
                return $aa7765f711bd6a4f$export$4708d9c8128efb7e(incidentSmartComments, additionalPayloadData);
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).CustomPrompt:
            {
                const freeGenerate = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE);
                return freeGenerate;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).IssueReformatter:
            {
                const issueReformatter = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE);
                return $aa7765f711bd6a4f$export$4ca9d7e8b67397d6(issueReformatter, additionalPayloadData);
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).DescriptionCompleter:
            {
                const descriptionCompleter = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE);
                return $aa7765f711bd6a4f$export$c479c0f686f70979(descriptionCompleter, additionalPayloadData);
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).DraftReplyPill:
            {
                const draftReplyPill = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, 'rangeConfig', (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE);
                return $aa7765f711bd6a4f$export$e6213a58f2a1160d(draftReplyPill, additionalPayloadData);
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).Summarize:
            {
                const summarize = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).SUMMARISE_WRITING);
                return summarize;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ImproveWriting:
            {
                const improveWriting = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).IMPROVE_WRITING);
                return improveWriting;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).MakeShorter:
            {
                const makeShorter = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).MAKE_SHORTER);
                return makeShorter;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).FixSpellingGrammar:
            {
                const fixSpellingGrammar = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR);
                return fixSpellingGrammar;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ChangeToneToProfessional:
            {
                const professionalTone = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL);
                return professionalTone;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ChangeToneToNeutral:
            {
                const neutralTone = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL);
                return neutralTone;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ChangeToneToEmpathetic:
            {
                const empatheticTone = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC);
                return empatheticTone;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ChangeToneToCasual:
            {
                const empatheticTone = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL);
                return empatheticTone;
            }
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).ChangeToneToEducational:
            {
                const empatheticTone = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL);
                return empatheticTone;
            }
        // Added as part of jira-smart-replies-v2 experiment
        case (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).SuggestComment:
            {
                const suggestComment = $aa7765f711bd6a4f$var$getConfigFromProvider(editorPluginAIProvider, $aa7765f711bd6a4f$var$getConfigTypeByAdjustSelection(adjustSelection), (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_COMMENT);
                return $aa7765f711bd6a4f$export$bc108eee7367b3a9(suggestComment, additionalPayloadData);
            }
        default:
            return undefined;
    }
};
const $aa7765f711bd6a4f$export$8aaa839b34c07044 = (configItem, currentEditorView)=>{
    return configItem?.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && currentEditorView.state.doc.textContent.trim() === '';
};
const $aa7765f711bd6a4f$export$4ca9d7e8b67397d6 = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload && additionalPayload?.feature === 'proactive-improve-description') {
        const modifiedConfigItem = {
            ...configItem,
            experienceId: 'jira-work-completer',
            getRequestPayload: (...params)=>{
                const requestPayload = configItem.getRequestPayload?.(...params) || {};
                if (requestPayload.agent_input_context) {
                    // Add additional payload from description completer to agent_input_context
                    const agent_input_context = {
                        ...requestPayload?.agent_input_context,
                        ...additionalPayload
                    };
                    return {
                        ...requestPayload,
                        agent_input_context: agent_input_context
                    };
                }
                return requestPayload;
            }
        };
        return modifiedConfigItem;
    }
    if (configItem?.getRequestPayload && additionalPayload?.feature === 'issue-reformatter' && (0, $iDrrr.fg)('jira-work-sync-desc-comment-summary-ga')) return {
        ...configItem,
        getRequestPayload: (...params)=>{
            const requestPayload = configItem.getRequestPayload?.(...params) || {};
            const aiFeatureInput = requestPayload?.ai_feature_input;
            const existingContext = aiFeatureInput?.context;
            const payload = {
                ai_feature_input: {
                    ...aiFeatureInput,
                    context: {
                        ...existingContext,
                        description: additionalPayload?.additionalInfo
                    }
                }
            };
            return payload;
        }
    };
    return configItem;
};
const $aa7765f711bd6a4f$export$c479c0f686f70979 = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const { source: source } = additionalPayload || {};
        // Use different experienceId for Google Docs
        const experienceId = source === 'GOOGLE_DOC_LINK' ? 'ai-issue-create-google-doc-single' : 'jira-work-completer';
        const modifiedConfigItem = {
            ...configItem,
            endpoint: '/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/link/suggestions/stream',
            experienceId: experienceId,
            getRequestPayload: (params)=>{
                const { context: contextFromPayload, source: source } = additionalPayload || {};
                const { ai_feature_input: input } = configItem.getRequestPayload?.(params) ?? {};
                const { context: context, ...additionalProps } = input ?? {};
                const { summary: summary, description: description } = context;
                // Construct input for AI Work Create API
                const ai_feature_input = {
                    ...additionalProps,
                    source: source,
                    context: {
                        ...contextFromPayload,
                        additional_context: {
                            issue_summary: summary,
                            issue_description: description
                        }
                    }
                };
                return {
                    ai_feature_input: ai_feature_input
                };
            }
        };
        return modifiedConfigItem;
    }
};
const $aa7765f711bd6a4f$export$e6213a58f2a1160d = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const modifiedConfigItem = {
            ...configItem,
            draftReplyMetadata: additionalPayload,
            featureId: 'brainstorm',
            endpoint: '/gateway/api/firebolt/1/agent-response/generate',
            getRequestPayload: (params)=>{
                const payload = additionalPayload || {};
                const { userText: userText } = configItem.getRequestPayload?.(params) ?? {
                    userText: params?.selection || params?.doc
                };
                return {
                    ...payload,
                    ...additionalPayload?.category === 'ENHANCE_REPLY' ? {
                        userText: userText
                    } : {}
                };
            }
        };
        return modifiedConfigItem;
    }
};
const $aa7765f711bd6a4f$export$4708d9c8128efb7e = (configItem, additionalPayload)=>{
    if (configItem?.getRequestPayload) {
        const modifiedConfigItem = {
            ...configItem,
            getRequestPayload: (params)=>{
                const originalPayload = configItem.getRequestPayload?.(params) || {};
                // Override intent with the runtime value from the pill
                return {
                    ...originalPayload,
                    intent: additionalPayload?.replyIntent || 'REQUEST_MORE_INFO',
                    isExternal: additionalPayload?.isExternal
                };
            }
        };
        return modifiedConfigItem;
    }
    return configItem;
};
const $aa7765f711bd6a4f$export$bc108eee7367b3a9 = (configItem, additionalPayload)=>{
    if (!additionalPayload?.commentType || !configItem?.getRequestPayload) return configItem;
    const modifiedConfigItem = {
        ...configItem,
        getRequestPayload: (params)=>{
            const originalPayload = configItem.getRequestPayload?.(params) || {};
            return {
                ...originalPayload,
                ai_feature_input: {
                    ...originalPayload?.ai_feature_input,
                    comment_type: additionalPayload.commentType
                }
            };
        }
    };
    return modifiedConfigItem;
};



var $9qe1v = parcelRequire("9qe1v");

// oxlint-disable-next-line @atlassian/no-restricted-imports

var $f6RxU = parcelRequire("f6RxU");


var $03RpJ = parcelRequire("03RpJ");


var $7ZL6d = parcelRequire("7ZL6d");

const $0a05d8b07618b684$export$922d75f514df28b7 = async ({ node: node, getMentionNameDetails: getMentionNameDetails })=>{
    const mentionMapping = {};
    const findMentions = async (node)=>{
        if (node.type.name === 'mention') {
            const mentionNameDetails = await getMentionNameDetails(node.attrs.id);
            if (mentionNameDetails) mentionMapping[node.attrs.id] = mentionNameDetails.name;
        }
        if (node.content) {
            const promises = [];
            node.content.forEach((child)=>{
                promises.push(findMentions(child));
            });
            await Promise.all(promises);
        }
    };
    await findMentions(node);
    return mentionMapping;
};









var $3cHXJ = parcelRequire("3cHXJ");











var $1w4hj = parcelRequire("1w4hj");


var $55fM8 = parcelRequire("55fM8");







let $41b476478fcdc180$var$mergedNonErrorFallbackState = {};
const $41b476478fcdc180$export$34fee48925e19a88 = (newState)=>{
    for (const [key, value] of Object.entries(newState))if ($41b476478fcdc180$var$mergedNonErrorFallbackState[key] === undefined) $41b476478fcdc180$var$mergedNonErrorFallbackState[key] = value;
    else $41b476478fcdc180$var$mergedNonErrorFallbackState[key] = Math.max($41b476478fcdc180$var$mergedNonErrorFallbackState[key], value);
};
const $41b476478fcdc180$export$d9a76334704d46ad = (editorView, aiSessionId)=>{
    const tr = (0, $hZdqw.addAnalytics)({
        editorState: editorView.state,
        tr: editorView.state.tr,
        payload: {
            action: 'nonErrorFallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'markdownSerializer',
            attributes: {
                aiSessionId: aiSessionId,
                nonErrorFallbackState: $41b476478fcdc180$var$mergedNonErrorFallbackState
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        }
    });
    tr.setMeta('addToHistory', false);
    editorView.dispatch(tr);
    // Reset the merged state
    $41b476478fcdc180$var$mergedNonErrorFallbackState = {};
};
const $41b476478fcdc180$export$2dc9d8571b4d0979 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))($41b476478fcdc180$export$d9a76334704d46ad, 500);





const $be02f84409f29d66$export$19bde12812d70545 = ({ editorView: editorView, slice: slice, node: node })=>{
    const hasContent = node ? (node.content?.size || 0) > 2 : slice ? slice.size >= 1 : false;
    if (hasContent) {
        if (slice?.content?.eq?.(editorView.state.doc.content) || node?.eq?.(editorView.state.doc)) return 'fullDocument';
        else return 'partialSelection';
    }
    return 'none';
};


function $ee54a40df06b2f0a$export$ae9f8b78c9fe6ae0({ slice: slice, node: node, editorView: editorView, convertTo: convertTo, existingIdMap: existingIdMap, updateIdMap: updateIdMap, mentionMap: mentionMap, aiSessionId: aiSessionId }) {
    const fragment = (slice || node).content;
    try {
        // we track whether the context is a whole document or a partial selection
        const contextSelectionScope = (0, $be02f84409f29d66$export$19bde12812d70545)({
            editorView: editorView,
            slice: slice,
            node: node
        });
        if (convertTo === 'markdown-plus') {
            const { markdown: markdown, idMap: idMap, contentStatistics: contentStatistics, fallbackState: fallbackState, nonErrorFallbackState: nonErrorFallbackState } = (0, $9DPMp.convertProsemirrorToMarkdown)({
                editorView: editorView,
                fragment: fragment,
                featureToggles: {
                    markdownPlus: true,
                    markdownPlusExtensions: true,
                    markdownPlusPanels: true,
                    markdownPlusDecisions: true,
                    markdownPlusMentions: (0, $iDrrr.fg)('platform_editor_ai_draft_reply_mentions'),
                    allowAttributesMatchDefault: true
                },
                mentionMap: mentionMap,
                idMap: existingIdMap
            });
            if (!!Object.keys(nonErrorFallbackState).length && aiSessionId) {
                (0, $41b476478fcdc180$export$34fee48925e19a88)(nonErrorFallbackState);
                (0, $41b476478fcdc180$export$2dc9d8571b4d0979)(editorView, aiSessionId);
            }
            if (!!Object.keys(fallbackState).length) {
                const tr = (0, $hZdqw.addAnalytics)({
                    editorState: editorView.state,
                    tr: editorView.state.tr,
                    payload: {
                        action: 'fallback',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'markdownSerializer',
                        attributes: {
                            fallbackState: fallbackState
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    }
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
            }
            // This ID map is used to map the markdown back to the original ProseMirror
            // when we receive transformed content back from the llm.
            updateIdMap({
                idMap: idMap
            });
            return {
                idMap: idMap,
                markdown: markdown,
                contentStatistics: {
                    ...contentStatistics,
                    contextSelectionScope: contextSelectionScope
                }
            };
        }
        const { markdown: markdown, idMap: idMap, contentStatistics: contentStatistics } = (0, $9DPMp.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: fragment,
            featureToggles: {},
            mentionMap: mentionMap,
            idMap: existingIdMap
        });
        return {
            idMap: idMap,
            markdown: markdown,
            contentStatistics: {
                ...contentStatistics,
                contextSelectionScope: contextSelectionScope
            }
        };
    } catch (e) {
        const tr = (0, $hZdqw.addAnalytics)({
            editorState: editorView.state,
            tr: editorView.state.tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownSerializer',
                attributes: {
                    errorType: 'markdownSerializer',
                    errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(e)
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            }
        });
        editorView.dispatch(tr);
        return {
            idMap: {},
            markdown: '',
            contentStatistics: undefined
        };
    }
}






var $ePK6j = parcelRequire("ePK6j");


var $3rWk6 = parcelRequire("3rWk6");

var $9fhVI = parcelRequire("9fhVI");

var $1tdnq = parcelRequire("1tdnq");

var $iscRo = parcelRequire("iscRo");










var $294de0c3b82e849c$export$917a2c609d734ce2 = /*#__PURE__*/ function(SELECTION_CATEGORY) {
    SELECTION_CATEGORY["EMPTY"] = "empty";
    SELECTION_CATEGORY["FULL_DOCUMENT"] = "fullDocument";
    SELECTION_CATEGORY["FULL_SINGLE_BLOCK"] = "fullSingleBlock";
    SELECTION_CATEGORY["PARTIAL_SINGLE_BLOCK"] = "partialSingleBlock";
    SELECTION_CATEGORY["FULL_MULTIPLE_BLOCKS"] = "fullMultipleBlocks";
    SELECTION_CATEGORY["PARTIAL_MULTIPLE_BLOCKS"] = "partialMultipleBlocks";
    return SELECTION_CATEGORY;
}({});


function $3117ebeab67c20f0$var$findFirstDeco(decorationSet, key) {
    const found = decorationSet.find(undefined, undefined, (spec)=>spec.key === key);
    return found.length > 0 ? found[0] : undefined;
}
function $3117ebeab67c20f0$export$8e313fd1eaf35cec({ modalDecorationSet: modalDecorationSet }) {
    if (!modalDecorationSet) return undefined;
    const inlineDecoration = $3117ebeab67c20f0$var$findFirstDeco(modalDecorationSet, 'inlineDecoration');
    if (inlineDecoration) return [
        inlineDecoration.from,
        inlineDecoration.to
    ];
    const startWidget = $3117ebeab67c20f0$var$findFirstDeco(modalDecorationSet, 'generatedStartWidget');
    const endWidget = $3117ebeab67c20f0$var$findFirstDeco(modalDecorationSet, 'generatedEndWidget');
    if (startWidget && endWidget) return [
        startWidget.from,
        endWidget.to
    ];
    return undefined;
}
function $3117ebeab67c20f0$export$385434a4b24ab280(editorView, positions) {
    const { state: state } = editorView;
    return $3117ebeab67c20f0$export$c96ebd9bae9a4b95(state, positions);
}
function $3117ebeab67c20f0$export$c96ebd9bae9a4b95(state, positions) {
    const [start, end] = positions;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $C4yPo.getPluginState)(state);
    const isEmptySelection = start === end;
    // For in-document streaming, somehow during streaming, the position can be larger than the document size
    // So we clamp the position to the document size to quickly bypass the issue
    // In the future, when we refactor the decoration plugin, we should revisit this if needed
    const $start = isInDocumentStreamingEnabled ? state.doc.resolve((0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(start, 1, state.doc.content.size)) : state.doc.resolve(start);
    const $end = isInDocumentStreamingEnabled ? state.doc.resolve((0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(end, 1, state.doc.content.size)) : state.doc.resolve(end);
    const isSameParent = $start.sameParent($end);
    const isBeginningOfDoc = $start.pos === $start.depth;
    const isEndOfDoc = state.doc.nodeSize - $end.pos - 2 === $end.depth;
    const isStartOfParentNode = (0, $iscRo.isSelectionAtStartOfNode)($start, $start.parent);
    const isEndOfParentNode = (0, $1tdnq.isSelectionAtEndOfNode)($end, $end.parent);
    if (isEmptySelection) return (0, $294de0c3b82e849c$export$917a2c609d734ce2).EMPTY;
    if (isBeginningOfDoc && isEndOfDoc) return (0, $294de0c3b82e849c$export$917a2c609d734ce2).FULL_DOCUMENT;
    if (isSameParent) {
        if (isStartOfParentNode && isEndOfParentNode) return (0, $294de0c3b82e849c$export$917a2c609d734ce2).FULL_SINGLE_BLOCK;
        return (0, $294de0c3b82e849c$export$917a2c609d734ce2).PARTIAL_SINGLE_BLOCK;
    }
    if (isStartOfParentNode && isEndOfParentNode) return (0, $294de0c3b82e849c$export$917a2c609d734ce2).FULL_MULTIPLE_BLOCKS;
    return (0, $294de0c3b82e849c$export$917a2c609d734ce2).PARTIAL_MULTIPLE_BLOCKS;
}
function $3117ebeab67c20f0$export$13724218f8b1273e(state, positions) {
    const [start, end] = positions;
    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
        // In-document streaming can leave positions stale relative to the live
        // doc. Clamp to a safe range to avoid ProseMirror crashes inside
        // textBetween / nodesBetween. See getSelectionCategoryUsingState for the
        // same pattern.
        const docSize = state.doc.content.size;
        const safeStart = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(start, 0, docSize);
        const safeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(end, safeStart, docSize);
        const text = state.doc.textBetween(safeStart, safeEnd);
        return text.trim().length > 0;
    } else {
        const text = state.doc.textBetween(start, end);
        return text.trim().length > 0;
    }
}
function $3117ebeab67c20f0$export$208ac2488b55bf9d(state, positions) {
    const [start, end] = positions;
    const nodeCounts = {};
    const countNode = (node)=>{
        // Count the node type
        nodeCounts[node.type.name] = (nodeCounts[node.type.name] ?? 0) + 1;
        // Count each mark on the node
        node.marks.forEach((mark)=>{
            nodeCounts[mark.type.name] = (nodeCounts[mark.type.name] ?? 0) + 1;
        });
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
        // In-document streaming can leave positions stale relative to the live
        // doc. Walking the tree with out-of-range positions crashes inside
        // ProseMirror's nodesBetween on `undefined.nodeSize`, which then trips
        // the surrounding React error boundary (e.g. <AnalyticsBridge>) and
        // unmounts the AI loading UI. Clamp to a safe range first. See
        // getSelectionCategoryUsingState for the same pattern.
        const docSize = state.doc.content.size;
        const safeStart = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(start, 0, docSize);
        const safeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(end, safeStart, docSize);
        state.doc.nodesBetween(safeStart, safeEnd, countNode);
    } else // Walk through the document between the start and end positions
    state.doc.nodesBetween(start, end, countNode);
    return nodeCounts;
}
/**
 * Wraps `content` in `node`'s own type inside a doc, purely so the request builder
 * can encode it with the existing ADF serializer and read the inline content back
 * out. Only that inline content is sent - the wrapper's type, attrs and marks are
 * discarded, since a consumer rebuilds the node it already holds.
 *
 * Returns `undefined` when the schema rejects the content, or when `createAndFill`
 * had to add content to satisfy the schema: a node that is not in the document must
 * never appear in the edges a consumer may write back.
 */ function $3117ebeab67c20f0$var$wrapInlineContentInDoc(state, node, content) {
    const wrapper = node.type.createAndFill(node.attrs, content, node.marks);
    if (!wrapper || !wrapper.content.eq(content)) return undefined;
    return state.schema.nodes.doc.createAndFill(null, wrapper) ?? undefined;
}
function $3117ebeab67c20f0$export$181ec34ff47b499a(state, positions) {
    const [start, end] = positions;
    // Nothing is selected, so there is no edit to describe.
    if (start === end) return undefined;
    // In-document streaming can leave positions stale relative to the live doc.
    // Clamp to a safe range first. See getSelectionCategoryUsingState for the
    // same pattern.
    const docSize = state.doc.content.size;
    const safeStart = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(start, 0, docSize);
    const safeEnd = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(end, safeStart, docSize);
    if (safeStart === safeEnd) return undefined;
    const $start = state.doc.resolve(safeStart);
    const $end = state.doc.resolve(safeEnd);
    const selection = (0, $kCECX.TextSelection).between($start, $end);
    const targetLocalIds = (0, $3rWk6.getLocalIdsFromSelection)(selection) ?? [];
    if (targetLocalIds.length === 0) return undefined;
    // A localId has to identify exactly one node for any of this to be addressable.
    // ADF does not guarantee uniqueness - copying and pasting a node duplicates its
    // localId - and a repeated id would let a consumer resolve the wrong node, and so
    // splice an edge into it. Refuse rather than guess.
    if (new Set(targetLocalIds).size !== targetLocalIds.length) return undefined;
    // Every selected node has to be addressed, not just most of them.
    // getLocalIdsFromSelection skips a node that carries no localId, which would leave
    // the targets describing a subset of what was selected while the generated content
    // covers all of it - so the skipped node's edit would have nowhere to go.
    if (targetLocalIds.length !== (0, $9fhVI.getSliceFromSelection)(selection).childCount) return undefined;
    const selectedText = state.doc.textBetween(safeStart, safeEnd, '\n') || undefined;
    // The edges are only reconstructable by concatenation when the selection begins
    // and ends inside inline content whose containing node is itself an edge target.
    // Otherwise the targets are addressed as whole nodes, so there is no partial
    // content to preserve around the edit.
    const anchorsEdges = $start.parent.isTextblock && $end.parent.isTextblock && targetLocalIds[0] === $start.parent.attrs?.localId && targetLocalIds[targetLocalIds.length - 1] === $end.parent.attrs?.localId;
    if (!anchorsEdges) return {
        selectedText: selectedText,
        targetLocalIds: targetLocalIds
    };
    const prefixDoc = $3117ebeab67c20f0$var$wrapInlineContentInDoc(state, $start.parent, state.doc.slice($start.start(), safeStart).content);
    const suffixDoc = $3117ebeab67c20f0$var$wrapInlineContentInDoc(state, $end.parent, state.doc.slice(safeEnd, $end.end()).content);
    // Both edges or neither: a consumer cannot tell an omitted edge apart from an
    // empty one, so a half-described selection must not be sent.
    if (!prefixDoc || !suffixDoc) return {
        selectedText: selectedText,
        targetLocalIds: targetLocalIds
    };
    return {
        prefixDoc: prefixDoc,
        selectedText: selectedText,
        suffixDoc: suffixDoc,
        targetLocalIds: targetLocalIds
    };
}


/**
 * BE supported markdowns are defined in https://bitbucket.org/atlassian/cc-smarts/src/master/src/main/java/io/atlassian/micros/smarts/model/Markdown.java
 * BE support is based on https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3632267938/Mapping+node+and+mark+names+to+markdown+features
 */ const $65aaf04c409ec10a$var$backEndSupportedMarkdown = {
    blockquote: 'BLOCKQUOTES',
    paragraph: 'PARAGRAPH',
    rule: 'HORIZONTAL_RULE',
    heading: 'HEADING',
    hardbreak: 'HARD_LINE_BREAK',
    codeBlock: 'CODEBLOCKS',
    bulletList: 'BULLET_LISTS',
    orderedList: 'NUMBERED_LISTS',
    media: 'IMAGES',
    table: 'TABLE',
    taskList: 'TASK_LIST',
    code: 'CODE_SPAN',
    em: 'ITALICS',
    strong: 'BOLD',
    link: 'LINK',
    strike: 'STRIKETHROUGH'
};
const $65aaf04c409ec10a$export$64c88b3c322e3de4 = (schema)=>{
    if (!schema?.nodes && !schema?.marks) return [];
    const schemaNodesAndMarks = [
        ...Object.keys(schema.nodes),
        ...Object.keys(schema.marks)
    ];
    return schemaNodesAndMarks.map((nodeOrMark)=>$65aaf04c409ec10a$var$backEndSupportedMarkdown[nodeOrMark]).filter(Boolean);
};


/**
 * Reads the inline ADF content back out of a doc-wrapped edge fragment.
 *
 * `getApplyContext` wraps the fragment in its target node's type so the schema
 * accepts it; only the inline content is sent, since a consumer already holds the
 * target node it will rebuild.
 */ const $2d699f1c77bd9908$var$encodeInlineContent = (serializer, node)=>{
    if (!node) return undefined;
    // An edge with no content either side of the selection encodes to an empty
    // array, which is meaningful - it is not the same as an absent edge.
    return serializer.encode(node, {
        keepNestedTables: true
    }).content?.[0]?.content ?? [];
};
/** Maps apply context to the request body's snake_case convention. */ const $2d699f1c77bd9908$var$buildApplyContextPayload = (applyContext, editorSchema, hasRealTimeCollab)=>{
    // The edges describe content the user did not select, and unlike the prompt
    // input they may be written back to the document. They must therefore be a
    // faithful copy, so they are encoded without the mentionMap: it synthesises
    // attrs.text on a mention that has none, which would hand a consumer a mention
    // whose text did not come from the document. See toJSON's isMentionNode branch.
    const edgeSerializer = new (0, $2lPWP.JSONTransformer)(editorSchema);
    return {
        target_local_ids: applyContext.targetLocalIds,
        has_real_time_collab: hasRealTimeCollab,
        selected_text: applyContext.selectedText,
        prefix_content: $2d699f1c77bd9908$var$encodeInlineContent(edgeSerializer, applyContext.prefixDoc),
        suffix_content: $2d699f1c77bd9908$var$encodeInlineContent(edgeSerializer, applyContext.suffixDoc)
    };
};
const $2d699f1c77bd9908$var$buildContentAri = ({ product: product, objectId: objectId, cloudId: cloudId })=>{
    return `ari:cloud:${product.toLowerCase()}:${cloudId}:content/${objectId}`;
};
const $2d699f1c77bd9908$export$13b228d724f1e48f = ({ context: context, configItem: configItem, mentionMap: mentionMap, updateIdMap: updateIdMap, callback: callback })=>{
    const { aiProvider: aiProvider, userInput: userInput, editorView: editorView, positions: positions, intl: intl, latestPromptResponse: latestPromptResponse } = context;
    const editorSchema = editorView.state.schema;
    const { product: product, objectId: objectId, getChannelVariables: getChannelVariables } = aiProvider;
    const cloudId = getChannelVariables?.('rovo-agent')?.cloudId;
    let contentAri;
    // Currently CC and Jira pass in the objectID. According to the BE implementation this content ari is required.
    // for CC, Jira and Trello. This will make this property optional from FE perspective and if the BE reqruies this
    // then they can return an error when needed. This will unblock all product from adopting this.
    if (objectId !== undefined && cloudId !== undefined) contentAri = $2d699f1c77bd9908$var$buildContentAri({
        product: product,
        objectId: objectId,
        cloudId: cloudId
    });
    const featureId = configItem.featureId;
    if (!featureId) return {
        error: `Unknown feature id: ${configItem.intentSchemaId}`,
        endpoint: configItem.endpoint || (0, $gcCwL.convoAIApiUrl)
    };
    const { experienceId: experienceId, endpoint: endpoint } = configItem;
    const aiSessionId = context.analyticsContext?.aiSessionId;
    const idMap = {};
    // if there is no selection, we want to pass only the doc
    // if there is selection, we want to pass only the selection (if we pass doc and selection, the doc will be ignored by BE)
    let needDoc = context.isEmpty;
    let needSelection = !context.isEmpty;
    if (configItem.alwaysNoDocAndSelection) {
        // for Brainstorm, Jira Draft reply, don't send document (we have history feedback that LLM was using the document too much)
        needDoc = false;
        needSelection = false;
    } else if (configItem.alwaysNeedDoc) {
        // for Jira Improve description
        needDoc = true;
        needSelection = false;
    } else if (configItem.canTogglePageKnowledge) // for Free generate and interrogation
    // For range selection and usePageKnowledge, we're sending both doc and selection
    needDoc = context.usePageKnowledge;
    // Check for experiment first to fire exposure event, otherwise there will be imbalance.
    const isADFPrompt = configItem.adfPrompt;
    let docContent;
    let selectionContent;
    let contentStatistics;
    let applyContextPayload;
    if (isADFPrompt) {
        const serializer = new (0, $2lPWP.JSONTransformer)(editorSchema, mentionMap);
        // Only the ADF prompts are candidates for a backend-applied edit. Applying an
        // edit outside the editor means splicing the generated content into the
        // stored document as ADF, and the markdown prompts return markdown-plus, so
        // there would be nothing to splice.
        const applyContext = (0, $4o0zT.isExperimentEnabled)('platform_editor_quick_actions_be_update') ? (0, $3117ebeab67c20f0$export$181ec34ff47b499a)(editorView.state, positions) : undefined;
        applyContextPayload = applyContext && $2d699f1c77bd9908$var$buildApplyContextPayload(applyContext, editorSchema, context.aiProvider.getHasRealTimeCollab?.() ?? false);
        docContent = needDoc ? JSON.stringify(serializer.encode(editorView.state.doc, {
            keepNestedTables: true
        })) : undefined;
        let contextSelectionScope = 'fullDocument';
        let selectionDoc = null;
        if (needSelection) {
            const docNodeType = editorSchema.nodes.doc;
            const doc = editorView.state.doc;
            const selectionSlice = doc.slice(positions[0], positions[1]);
            const sliceContent = selectionSlice.content;
            callback({
                type: 'update selectionMetaData',
                context: {
                    selectionMetaData: {
                        sliceOpenStart: selectionSlice.openStart,
                        sliceOpenEnd: selectionSlice.openEnd
                    }
                }
            });
            if (docNodeType.validContent(sliceContent)) {
                selectionDoc = docNodeType.createAndFill(null, selectionSlice.content);
                selectionContent = selectionDoc ? JSON.stringify(serializer.encode(selectionDoc, {
                    keepNestedTables: true
                })) : undefined;
            } else {
                const startPos = doc.resolve(positions[0]);
                const endPos = doc.resolve(positions[1]);
                const adfResponseNodeWrappers = [];
                /**
				 * When prosemirror creates slice, it will have node
				 * 	starting from (shared depth + 1) level of start and end position.
				 * So finding parent node that can set as doc content should be
				 * 	start at shared depth level.
				 */ const sameParentDepth = startPos.sharedDepth(endPos.pos);
                let currentDepth = sameParentDepth;
                let docContentNode = selectionSlice.content;
                while(currentDepth > 0){
                    const parentNode = startPos.node(currentDepth);
                    const parentNodeType = parentNode.type;
                    docContentNode = parentNodeType.createAndFill(null, docContentNode);
                    if (docContentNode) {
                        adfResponseNodeWrappers.push(parentNodeType.name);
                        selectionDoc = docNodeType.createAndFill(null, docContentNode);
                        if (selectionDoc) {
                            selectionContent = JSON.stringify(serializer.encode(selectionDoc, {
                                keepNestedTables: true
                            }));
                            break;
                        } else currentDepth--;
                    } else break;
                }
                contextSelectionScope = 'partialSelection';
                callback({
                    type: 'update adfResponseNodeWrappers',
                    context: {
                        adfResponseNodeWrappers: adfResponseNodeWrappers
                    }
                });
            }
        }
        const nodeForStats = needDoc ? editorView.state.doc : selectionDoc;
        if (nodeForStats) {
            const pmStats = new (0, $3cHXJ.ProseMirrorContentStatistics)(nodeForStats);
            contentStatistics = pmStats.collectStatistics();
            contentStatistics = {
                ...contentStatistics,
                contextSelectionScope: contextSelectionScope
            };
        }
    } else {
        const doc = needDoc ? (0, $ee54a40df06b2f0a$export$ae9f8b78c9fe6ae0)({
            node: editorView.state.doc,
            editorView: editorView,
            convertTo: 'markdown-plus',
            existingIdMap: idMap,
            updateIdMap: updateIdMap,
            mentionMap: mentionMap,
            aiSessionId: aiSessionId
        }) : undefined;
        docContent = doc?.markdown;
        const selection = needSelection ? (0, $ee54a40df06b2f0a$export$ae9f8b78c9fe6ae0)({
            slice: editorView.state.doc.slice(positions[0], positions[1]),
            editorView: editorView,
            convertTo: 'markdown-plus',
            existingIdMap: doc?.idMap,
            updateIdMap: updateIdMap,
            mentionMap: mentionMap,
            aiSessionId: aiSessionId
        }) : undefined;
        docContent = doc?.markdown;
        selectionContent = selection?.markdown;
        contentStatistics = doc?.contentStatistics || selection?.contentStatistics;
    }
    const additionalProps = aiProvider.getAdditionalProps && aiProvider.getAdditionalProps?.();
    /**
	 * Whenever configItem has a getRequestPayload, it should be used to build the payload.
	 * Currently it is defined for Jira Improve description, Generate Escalation Notes,
	 * 	Draft reply and Incident Smart Comments.
	 */ const payload = configItem.getRequestPayload?.({
        aiSessionId: aiSessionId,
        contentAri: contentAri,
        locale: intl.locale,
        isEmpty: context.isEmpty,
        doc: docContent,
        selection: selectionContent
    });
    return {
        doc: docContent,
        selection: selectionContent,
        contentStatistics: contentStatistics,
        isConvoAI: true,
        experienceId: experienceId || 'editor',
        endpoint: endpoint || (0, $gcCwL.convoAIApiUrl),
        payload: JSON.stringify(payload || {
            ai_feature_input: {
                feature_args: {
                    // NOTE: we want to ensure we use undefined instead of null. This is because the JSON Serializer will remove props
                    // that are undefined, but will not remove props that are null.
                    user_input: userInput || undefined,
                    // Previously Assistance service sent a `document_title` prop which was used only by jira for situations where nothing was selected
                    // during free generate. This will ensure that the BE has some context about the issue
                    document_title: additionalProps?.issue_summary,
                    selected_context: latestPromptResponse || selectionContent || undefined,
                    document_context: docContent || undefined,
                    supported_markdown_nodes: (0, $65aaf04c409ec10a$export$64c88b3c322e3de4)(editorSchema),
                    output_mime_type: isADFPrompt ? 'text/adf' : 'text/markdown',
                    // for translate
                    transformation_subtype: configItem.lang
                },
                feature: featureId,
                /**
					 * We can still get a response from the server if the contentAri is not valid
					 * but we will get 500, internal server error if the contentAri is undefined.
					 * It is not required for a prompt like improve writing so we can ignore it.
					 * But we should still log an analytics event to track when this occurs.
					 */ content_ari: contentAri,
                ai_session_id: aiSessionId,
                locale: intl.locale,
                apply_context: applyContextPayload
            }
        })
    };
};



var $4AavA = parcelRequire("4AavA");

var $c8cGy = parcelRequire("c8cGy");





function $4f2683ee6f911c05$var$makeAdf({ userInput: userInput = '', userADFInput: userADFInput }) {
    return userADFInput || (0, $4AavA.doc)((0, $c8cGy.paragraph)(userInput));
}
const $4f2683ee6f911c05$export$65177b80f2db004b = ({ context: context, configItem: configItem, mentionMap: mentionMap, updateIdMap: updateIdMap })=>{
    const { editorView: editorView, positions: positions, userInput: userInput, userADFInput: userADFInput } = context;
    const { agent: agent } = configItem;
    const idMap = {};
    const needDoc = context.usePageKnowledge;
    const needSelection = true;
    const doc = needDoc ? (0, $ee54a40df06b2f0a$export$ae9f8b78c9fe6ae0)({
        node: editorView.state.doc,
        editorView: editorView,
        convertTo: 'markdown-plus',
        existingIdMap: idMap,
        updateIdMap: updateIdMap,
        mentionMap: mentionMap
    }) : undefined;
    const selection = needSelection ? (0, $ee54a40df06b2f0a$export$ae9f8b78c9fe6ae0)({
        slice: editorView.state.doc.slice(positions[0], positions[1]),
        editorView: editorView,
        convertTo: 'markdown-plus',
        existingIdMap: doc?.idMap,
        updateIdMap: updateIdMap,
        mentionMap: mentionMap
    }) : undefined;
    return {
        doc: doc?.markdown,
        selection: selection?.markdown,
        contentStatistics: doc?.contentStatistics || selection?.contentStatistics,
        isConvoAI: true,
        experienceId: 'ai-mate',
        endpoint: (0, $gcCwL.convoAIRovoApiURL),
        // For payload spec, see https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3783312372/Actions+Contract+for+Confluence+Content+Suggestion
        payload: JSON.stringify({
            agent_id: agent?.namedId,
            internal_data_sharing_opt_in: true,
            mimeType: 'text/adf',
            content: $4f2683ee6f911c05$var$makeAdf({
                userInput: userInput,
                userADFInput: userADFInput
            }),
            context: {
                // Just the main URL, remove the extra stuff like hashes/query params
                browser_url: window.location.origin + window.location.pathname,
                editor: {
                    document: {
                        type: 'text/markdown',
                        content: doc?.markdown || ''
                    },
                    selection: {
                        type: 'text/markdown',
                        content: selection?.markdown || ''
                    }
                }
            }
        })
    };
};


function $acc1594deac9d985$export$65964063bcedf059({ callback: callback, context: context, configItem: configItem, mentionMap: mentionMap }) {
    // elevate free generate is disabled and returns the pre-configured response immediately
    if (configItem.response) return {
        response: configItem.response
    };
    const updateIdMap = ({ idMap: idMap })=>{
        callback({
            type: 'update idMap',
            context: {
                idMap: idMap
            }
        });
    };
    let requestOptions;
    if (configItem.agent) requestOptions = (0, $4f2683ee6f911c05$export$65177b80f2db004b)({
        context: context,
        configItem: configItem,
        mentionMap: mentionMap,
        updateIdMap: updateIdMap
    });
    else requestOptions = (0, $2d699f1c77bd9908$export$13b228d724f1e48f)({
        context: context,
        configItem: configItem,
        mentionMap: mentionMap,
        updateIdMap: updateIdMap,
        callback: callback
    });
    if ('contentStatistics' in requestOptions && requestOptions.contentStatistics) callback({
        type: 'storeContextStatistics',
        contextStatistics: {
            inputDocument: requestOptions.contentStatistics
        }
    });
    return requestOptions;
}


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead




var $6e6HL = parcelRequire("6e6HL");


var $5PpGs = parcelRequire("5PpGs");

function $72eca8ccfc8df62d$export$46d5228a079b1d3(product) {
    return {
        'X-Product': (0, $5PpGs.mapToAssistanceServiceProduct)(product)
    };
}
function $72eca8ccfc8df62d$export$b3f5e033c954a1b0(experienceId) {
    switch(experienceId){
        case 'ai-mate':
            return {
                'X-Channel-Id': 'editor'
            };
        case 'issue-reformatter':
            return {
                'X-Channel-Id': 'issue-reformatter'
            };
        default:
            return {};
    }
}






var $jTt8P = parcelRequire("jTt8P");

const $04500834e41df1ad$var$punctuationCharacters = [
    '.',
    '!',
    '?'
];
// eslint-disable-next-line require-unicode-regexp
const $04500834e41df1ad$var$FIRST_NON_WHITESPACE_REGEX = /\S/;
// eslint-disable-next-line require-unicode-regexp
const $04500834e41df1ad$var$PARAGRAPH_BREAK_REGEX = /\n\s*$/;
// eslint-disable-next-line require-unicode-regexp
const $04500834e41df1ad$var$SENTENCE_ENDING_PUNCTUATION_REGEX = /[.!?]\s*$/;
const $04500834e41df1ad$var$estimateTextContentLength = (doc, maxLength)=>{
    let totalLength = 0;
    try {
        (0, $jTt8P.traverse)(doc, {
            text: (node)=>{
                totalLength += (node.text || '').length;
                // Early termination if we exceed the threshold
                if (totalLength > maxLength) throw new Error('SIZE_EXCEEDED');
            },
            hardBreak: ()=>{
                totalLength += 1; // Count newlines
                if (totalLength > maxLength) throw new Error('SIZE_EXCEEDED');
            }
        });
    } catch (error) {
        if (error instanceof Error && error.message === 'SIZE_EXCEEDED') return totalLength; // Return the length that exceeded threshold
        // If traversal fails for other reasons, return a conservative estimate
        return maxLength + 1;
    }
    return totalLength;
};
/**
 * Extract plain text from ADF document
 */ const $04500834e41df1ad$var$extractTextFromADF = (doc)=>{
    const result = [];
    (0, $jTt8P.traverse)(doc, {
        text: (node)=>{
            result.push(node.text || '');
        },
        hardBreak: ()=>{
            result.push('\n');
        }
    });
    return result.join('');
};
/**
 * Check if selection starts at a position where capitalization is appropriate
 * (beginning of document, after sentence-ending punctuation, or start of paragraph)
 */ const $04500834e41df1ad$var$startsWithSentence = (fullText, selectionStart)=>{
    // Start of document
    if (selectionStart === 0) return true;
    // Look at the text before the selection
    const beforeSelection = fullText.slice(0, selectionStart);
    // Start of paragraph (preceded only by whitespace/newlines)
    if (beforeSelection.trim().length === 0) return true;
    // Check for paragraph break (newline followed by optional whitespace)
    if ($04500834e41df1ad$var$PARAGRAPH_BREAK_REGEX.test(beforeSelection)) return true;
    // Check for sentence-ending punctuation followed by optional whitespace
    if ($04500834e41df1ad$var$SENTENCE_ENDING_PUNCTUATION_REGEX.test(beforeSelection)) return true;
    return false;
};
/**
 * Check if text ends at a sentence boundary
 */ const $04500834e41df1ad$var$endsAtSentence = (fullText, selectionEnd)=>{
    const afterSelection = fullText.slice(selectionEnd).trim();
    return afterSelection.length === 0;
};
/**
 * Determine if we need to revert inappropriate API capitalization/punctuation changes
 */ const $04500834e41df1ad$var$shouldCorrectCapitalization = (originalText, responseText, fullDocumentText, selectionStart, selectionEnd)=>{
    if (selectionStart === selectionEnd) return {
        shouldCorrectFirst: false,
        shouldCorrectLast: false
    };
    const originalTrimmed = originalText.trim();
    const responseTrimmed = responseText.trim();
    if (!originalTrimmed || !responseTrimmed || originalTrimmed === responseTrimmed) return {
        shouldCorrectFirst: false,
        shouldCorrectLast: false
    };
    const originalFirstChar = originalTrimmed.length > 0 ? $04500834e41df1ad$var$getFirstCharacter(originalTrimmed) : '';
    const responseFirstChar = responseTrimmed.length > 0 ? $04500834e41df1ad$var$getFirstCharacter(responseTrimmed) : '';
    const originalLastChar = originalTrimmed.length > 0 ? $04500834e41df1ad$var$getLastCharacter(originalTrimmed) : '';
    const responseLastChar = responseTrimmed.length > 0 ? $04500834e41df1ad$var$getLastCharacter(responseTrimmed) : '';
    // Check if LLM inappropriately capitalized first character (revert to lowercase)
    const shouldCorrectFirst = Boolean(originalFirstChar && responseFirstChar && originalFirstChar === originalFirstChar.toLowerCase() && // Original was lowercase
    responseFirstChar === responseFirstChar.toUpperCase() && // LLM made it uppercase
    !$04500834e41df1ad$var$startsWithSentence(fullDocumentText, selectionStart));
    // Check if LLM inappropriately added punctuation (remove it)
    const shouldCorrectLast = Boolean(responseLastChar && $04500834e41df1ad$var$punctuationCharacters.includes(responseLastChar) && (!originalLastChar || !$04500834e41df1ad$var$punctuationCharacters.includes(originalLastChar)) && !$04500834e41df1ad$var$endsAtSentence(fullDocumentText, selectionEnd));
    return {
        shouldCorrectFirst: shouldCorrectFirst,
        shouldCorrectLast: shouldCorrectLast
    };
};
/**
 * Get the first character from a string, handling Unicode properly
 */ const $04500834e41df1ad$var$getFirstCharacter = (text)=>{
    const chars = Array.from(text);
    return chars.length > 0 ? chars[0] : '';
};
/**
 * Get the last character from a string, handling Unicode properly
 */ const $04500834e41df1ad$var$getLastCharacter = (text)=>{
    const chars = Array.from(text);
    return chars.length > 0 ? chars[chars.length - 1] : '';
};
/**
 * Replace the first character in a string, handling Unicode properly
 */ const $04500834e41df1ad$var$replaceFirstCharacter = (text, newChar)=>{
    const chars = Array.from(text);
    if (chars.length > 0) {
        chars[0] = newChar;
        return chars.join('');
    }
    return text;
};
/**
 * Check if this is the last text node by comparing the extracted text
 */ const $04500834e41df1ad$var$isLastMeaningfulTextNode = (doc, currentText)=>{
    const fullText = $04500834e41df1ad$var$extractTextFromADF(doc);
    const trimmedFullText = fullText.trimEnd();
    const trimmedCurrentText = currentText.trimEnd();
    // If this node's text appears at the end of the full document text, it's likely the last one
    return trimmedCurrentText.length > 0 && trimmedFullText.endsWith(trimmedCurrentText);
};
/**
 * Revert inappropriate API capitalization and punctuation changes in ADF document
 */ const $04500834e41df1ad$var$applyADFCorrections = (doc, shouldCorrectFirst, shouldCorrectLast)=>{
    let firstTextNodeFound = false;
    let correctedDoc = doc;
    correctedDoc = (0, $jTt8P.traverse)(correctedDoc, {
        text: (node)=>{
            if (!node.text) return node;
            let correctedText = node.text;
            // Revert inappropriate capitalization of first character if this is the first text node
            if (!firstTextNodeFound && shouldCorrectFirst && correctedText.trim().length > 0) {
                // Find the first non-whitespace character and its position
                const firstNonWhitespaceIndex = correctedText.search($04500834e41df1ad$var$FIRST_NON_WHITESPACE_REGEX);
                if (firstNonWhitespaceIndex !== -1) {
                    const beforeChar = correctedText.slice(0, firstNonWhitespaceIndex);
                    const restOfText = correctedText.slice(firstNonWhitespaceIndex);
                    // Use Unicode-safe character extraction
                    const firstChar = $04500834e41df1ad$var$getFirstCharacter(restOfText);
                    if (firstChar && firstChar.toUpperCase() !== firstChar.toLowerCase()) {
                        const correctedFirstChar = firstChar.toLowerCase();
                        const remainingText = $04500834e41df1ad$var$replaceFirstCharacter(restOfText, correctedFirstChar);
                        correctedText = beforeChar + remainingText;
                    }
                }
                firstTextNodeFound = true;
            }
            // Remove inappropriate punctuation only from the last meaningful text node
            if (shouldCorrectLast && $04500834e41df1ad$var$isLastMeaningfulTextNode(doc, node.text)) {
                const trimmedText = correctedText.trimEnd();
                if (trimmedText.length > 0) {
                    const lastChar = $04500834e41df1ad$var$getLastCharacter(trimmedText);
                    if ($04500834e41df1ad$var$punctuationCharacters.includes(lastChar)) {
                        // Use Unicode-safe character removal - remove last character
                        const chars = Array.from(trimmedText);
                        const textWithoutLastChar = chars.slice(0, -1).join('');
                        // Preserve trailing whitespace if any
                        const trailingWhitespace = correctedText.slice(trimmedText.length);
                        const resultText = textWithoutLastChar + trailingWhitespace;
                        correctedText = resultText;
                    }
                }
            }
            // Delete the text node if it becomes empty after corrections
            if (correctedText.trim().length === 0) return false;
            return correctedText !== node.text ? {
                ...node,
                text: correctedText
            } : node;
        }
    });
    return correctedDoc;
};
const $04500834e41df1ad$export$895f42d4e9947fc3 = (adfResponse, selectionContext)=>{
    try {
        // Performance guard: skip processing for documents with large text content
        const MAX_TEXT_LENGTH = 100000; // ~100KB of text
        const estimatedTextLength = $04500834e41df1ad$var$estimateTextContentLength(adfResponse, MAX_TEXT_LENGTH);
        if (estimatedTextLength > MAX_TEXT_LENGTH) return adfResponse;
        // Extract response text from ADF
        const responseText = $04500834e41df1ad$var$extractTextFromADF(adfResponse);
        // Use pre-captured selection context
        const { originalText: originalText, fullDocumentText: fullDocumentText, selectionStart: selectionStart, selectionEnd: selectionEnd } = selectionContext;
        // Determine what corrections are needed
        const { shouldCorrectFirst: shouldCorrectFirst, shouldCorrectLast: shouldCorrectLast } = $04500834e41df1ad$var$shouldCorrectCapitalization(originalText, responseText, fullDocumentText, selectionStart, selectionEnd);
        if (shouldCorrectFirst || shouldCorrectLast) return $04500834e41df1ad$var$applyADFCorrections(adfResponse, shouldCorrectFirst, shouldCorrectLast);
        return adfResponse;
    } catch (error) {
        return adfResponse;
    }
};



var $Mgq5A = parcelRequire("Mgq5A");






var $aAERY = parcelRequire("aAERY");

const $8fd254ba18c3d8f5$var$createFireADFStreamingAnalyticsEvent = ({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, experienceName: experienceName, featureId: featureId, aiSessionId: aiSessionId, aiInteractionID: aiInteractionID, selectionType: selectionType, selectionCategory: selectionCategory, contentStatistics: contentStatistics, streamId: streamId, retryAttemptNumber: retryAttemptNumber, getTraceId: getTraceId })=>(event)=>{
        const commonAttributes = {
            experienceName: experienceName,
            featureId: featureId,
            aiSessionId: aiSessionId,
            aiInteractionID: aiInteractionID,
            selectionType: selectionType,
            selectionCategory: selectionCategory,
            contentStatistics: contentStatistics,
            streamId: streamId,
            retryAttemptNumber: retryAttemptNumber,
            traceId: getTraceId?.(),
            source: {
                type: 'plugin'
            }
        };
        if (event.type === 'error') fireAIAnalyticsEvent({
            payload: {
                action: 'error',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    errorMessage: event.message,
                    errorData: event.data
                }
            }
        });
        else fireAIAnalyticsEvent({
            payload: {
                action: 'info',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'adfStreaming',
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    ...commonAttributes,
                    message: event.message,
                    data: event.data
                }
            }
        });
    };
function $8fd254ba18c3d8f5$export$313ea9e31b82ddc(options) {
    return new (0, $aAERY.ADFStreamer)(options.state.schema, $8fd254ba18c3d8f5$var$createFireADFStreamingAnalyticsEvent({
        fireAIAnalyticsEvent: options.fireAIAnalyticsEvent,
        experienceName: options.experienceName,
        featureId: options.featureId,
        aiSessionId: options.aiSessionId,
        aiInteractionID: options.aiInteractionID,
        selectionType: options.selectionType,
        contentStatistics: options.contentStatistics,
        selectionCategory: options.selectionCategory,
        streamId: options.streamId,
        retryAttemptNumber: options.retryAttemptNumber,
        getTraceId: options.getTraceId
    }));
}


/**
 * Name of the Convo AI final response field indicating the backend already persisted the edit.
 */ const $afcb69ccab894a52$var$APPLIED_SERVER_SIDE_KEY = 'applied_server_side';
function $afcb69ccab894a52$export$bd03e2d18010bd07(data) {
    return typeof data === 'object' && data !== null && data[$afcb69ccab894a52$var$APPLIED_SERVER_SIDE_KEY] === true;
}
function $afcb69ccab894a52$export$18bc670d10d3cd56({ cacheKey: cacheKey, requestOptions: requestOptions, rovoActions: rovoActions }) {
    return {
        type: 'complete',
        appliedServerSide: true,
        markdown: '',
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        rovoActions: rovoActions
    };
}








const $bf2b1ee8ac1223c7$export$76f60e834c48b8d9 = (adf, schema)=>{
    const prosemirrorNode = (0, $aPdNQ.Node).fromJSON(schema, adf);
    return (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: prosemirrorNode
    }).markdown;
};


const $8828eae58e1de5b9$var$DEFAULT_MAX_RETRY_CHECKS = 10;
class $8828eae58e1de5b9$export$f748a1b030d3429f {
    /**
   * Starts a timer to check for errors after the specified delay.
   * When the timer expires, it will attempt a retry if an error is detected.
   *
   * @private
   */ startErrorCheckTimer() {
        this.clearErrorCheckTimer();
        this.errorCheckTimerId = setTimeout(()=>{
            this.attemptRetry();
        }, this.options.delayMs);
    }
    /**
   * Attempts to retry the request if the maximum number of retries hasn't been reached.
   *
   * Checks for errors using the errorChecker function. If an error is detected:
   * - Aborts the current request
   * - Calls the beforeRetryCallback
   * - Starts a new request with retry logic
   * - Increments the retry counter
   *
   * If no error is detected, schedules another error check after the delay period.
   *
   * @private
   */ attemptRetry() {
        if (this.retries < this.options.maxRetries) {
            const hasErrored = this.options.errorChecker();
            /**
       * If errored then abort current request and start a new request.
       */ if (hasErrored) {
                this.callBeforeRetryCallback();
                this.startFetchingWithRetry();
            } else {
                if (this.currentRetryCheck < this.maxRetryChecks) // If not errored then check again after delay.
                this.startErrorCheckTimer();
                this.currentRetryCheck++;
            }
        }
    }
    callBeforeRetryCallback() {
        this.abortController?.abort();
        /**
     * In beforeRetryCallback, retryAttemptCount can be used for various purposes,
     * 	like creating new ADFStreamer instance having retryAttemptCount as a parameter
     * 	to send to analytics.
     * So must update retries before calling beforeRetryCallback.
     */ this.retries++;
        this.options.beforeRetryCallback();
    }
    /**
   * Manually triggers a retry when streaming has ended.
   * This is useful when streaming ends before first check for errors
   * 	or if ADFStreamer is in error state when streaming ends.
   *
   * It will only retry if ADFStreamer is in error state and
   *  the maximum number of retries hasn't been reached.
   *
   * Steps performed:
   * 1. Clears the error checking timer
   * 2. Calls the beforeRetryCallback to prepare for retry
   * 3. Initiates the new request using the fetcher function
   * 4. Increments the retry counter
   *
   * @public
   */ retryOnStreamingEnd() {
        this.clearErrorCheckTimer();
        const hasErrored = this.options.errorChecker();
        if (hasErrored && !this.hasMaxRetryReached()) {
            this.callBeforeRetryCallback();
            this.fetch();
        }
    }
    /**
   * Returns the current number of retry attempts made.
   *
   * @public
   */ getRetryCount() {
        return this.retries;
    }
    /**
   * Checks if the maximum number of retries has been reached.
   *
   * @public
   */ hasMaxRetryReached() {
        return this.retries >= this.options.maxRetries;
    }
    /**
   * Creates a new AbortController, initiates the fetch using the fetcher function.
   *
   * @private
   */ fetch() {
        this.abortController = new AbortController();
        this.options.fetcher(this.abortController, this);
    }
    /**
   * Starts a new fetch operation with retry monitoring enabled.
   *
   * Creates a new AbortController, initiates the fetch using the fetcher function,
   * and starts the error checking timer to monitor for issues during the request.
   */ startFetchingWithRetry() {
        this.currentRetryCheck = 0;
        this.fetch();
        this.startErrorCheckTimer();
    }
    /**
   * Clears the active error checking timer if one exists.
   *
   * This stops any pending error checks and resets the timer ID to null.
   * Used during cleanup or when resetting the retry manager state.
   *
   * @private
   */ clearErrorCheckTimer() {
        if (this.errorCheckTimerId) {
            clearTimeout(this.errorCheckTimerId);
            this.errorCheckTimerId = null;
        }
    }
    /**
   * Resets the retry manager to its initial state.
   *
   * Clears any active error checking timers and resets the retry counter to zero.
   * This allows the retry manager to be reused for new streaming operations.
   *
   * @public
   */ reset() {
        this.clearErrorCheckTimer();
        this.retries = 0;
    }
    /**
   * Creates a new ADFStreamingRetryManager instance.
   *
   * @param options - Configuration options for the retry manager
   * @param options.maxRetries - Maximum number of retry attempts allowed
   * @param options.delayMs - Delay in milliseconds between error checks and retries
   * @param options.beforeRetryCallback - Callback executed before each retry attempt.
   *   Must not throw errors or the fetcher will not be called.
   * @param options.fetcher - Function that initiates the streaming request.
   *   Must not throw errors or subsequent retries won't be triggered.
   *   Receives an AbortController to allow request cancellation.
   * @param options.errorChecker - Function that checks if an error has occurred.
   *   Must not throw errors or the previous request won't be aborted and retry won't be attempted.
   *   Should return true if an error is detected, false otherwise.
   */ constructor(options){
        this.options = options;
        /** Timer ID for the error checking interval, null when no timer is active */ this.errorCheckTimerId = null;
        /** Current number of retry attempts made */ this.retries = 0;
        /** AbortController for the current request, used to cancel ongoing operations */ this.abortController = null;
        /**
     * Maximum number of retry checks after fetching started.
     * This is to prevent infinite loop of checking for errors.
     */ this.maxRetryChecks = $8828eae58e1de5b9$var$DEFAULT_MAX_RETRY_CHECKS;
        this.currentRetryCheck = 0;
        this.maxRetryChecks = options.maxRetryChecks ?? $8828eae58e1de5b9$var$DEFAULT_MAX_RETRY_CHECKS;
    }
}


/**
 * Output formats the backend can report via the stream envelope's `content_format`, matching the
 * `ContentFormat` enum in convo-ai. A closed list so only known values can reach analytics.
 */ const $56a1218bab0b5eeb$var$CONTENT_FORMATS = [
    'adf',
    'html_plus'
];
const $56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_INTERVAL = 250; // 4 re-renders per second
const $56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_INITIAL_CHARS_PER_TICK = 5000;
const $56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_MAX_CHARS_PER_TICK = 10000;
const $56a1218bab0b5eeb$var$ADF_STREAMING_RETRY_MAX_RETRIES = 1;
const $56a1218bab0b5eeb$var$ADF_STREAMING_RETRY_DELAY_MS = 10000;
let $56a1218bab0b5eeb$var$canProcessADFStreaming = false;
let $56a1218bab0b5eeb$var$adfStreamingProcessTimer = null;
function $56a1218bab0b5eeb$var$startADFStreamingProcessTimer() {
    $56a1218bab0b5eeb$var$stopADFStreamingProcessTimer();
    $56a1218bab0b5eeb$var$adfStreamingProcessTimer = setInterval(()=>{
        $56a1218bab0b5eeb$var$canProcessADFStreaming = true;
    }, $56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_INTERVAL);
}
function $56a1218bab0b5eeb$var$stopADFStreamingProcessTimer() {
    if ($56a1218bab0b5eeb$var$adfStreamingProcessTimer) {
        clearInterval($56a1218bab0b5eeb$var$adfStreamingProcessTimer);
        $56a1218bab0b5eeb$var$adfStreamingProcessTimer = null;
    }
}
function $56a1218bab0b5eeb$var$getInputSlice(context) {
    const { editorView: editorView, positions: positions } = context;
    if (!positions || positions.length < 2) return undefined;
    const from = Number(positions[0]);
    const to = Number(positions[1]);
    if (!Number.isFinite(from) || !Number.isFinite(to)) return undefined;
    try {
        return editorView.state.doc.slice(from, to);
    } catch  {
        return undefined;
    }
}
function $56a1218bab0b5eeb$var$parsedHasExpectedKey(key, parsed) {
    if (typeof parsed !== 'object' || parsed === null || !(key in parsed)) return false;
    return true;
}
function $56a1218bab0b5eeb$var$sanitizeErrorContent(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return error.message;
    return `Unknown error: ${error === null ? 'null' : error?.toString()}`;
}
function $56a1218bab0b5eeb$var$handleRequestError(error, endpoint) {
    const isErrorUnknown = $56a1218bab0b5eeb$var$parsedHasExpectedKey('name', error) && error.name === 'AbortError' || $56a1218bab0b5eeb$var$parsedHasExpectedKey('cause', error) && error.cause === 'ConvoAIChannelCreationError';
    // This can be due to code crashes too, but falls back to network errors
    if (!isErrorUnknown) // eslint-disable-next-line no-console
    console.error('Editor AI: startStreamingResponse()', error);
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
            statusCode: $56a1218bab0b5eeb$var$parsedHasExpectedKey('status', error) ? Number(error.status) : 9000,
            errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(error)
        }
    };
}
// For non 200 status codes
// See details https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-codes
async function $56a1218bab0b5eeb$var$handleResponseNotOK({ requestOptions: requestOptions, cacheKey: cacheKey, response: response }) {
    if (response.status === 400) try {
        // Errors with special handling
        // We have soft alignment with the BE that for inputs that are not suitable
        // for prompts -- we want to rely on openai providing a suitable message for
        // the user. And not have manually maintained guards/user feedback messages.
        // https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3573548013/Introducing+AI+Dev+Documentation+TODO+AIFOLLOWUP+audit
        const knownErrors = [
            'INPUT_TOO_SHORT_TO_SUMMARIZE',
            'INPUT_TOO_SHORT_TO_PROCESS',
            'INPUT_EXCEEDS_TOKEN_LIMIT'
        ];
        const { error: error } = await response.json();
        if (error) {
            if (typeof error === 'object' && 'key' in error && knownErrors.includes(error.key)) {
                if (error.key === 'INPUT_EXCEEDS_TOKEN_LIMIT') return {
                    type: 'error',
                    errorInfo: {
                        apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                        failureReason: (0, $Mgq5A.FAILURE_REASON).TOKEN_LIMIT,
                        statusCode: response.status,
                        errorKey: error.key
                    }
                };
                if (error.key === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || error.key === 'INPUT_TOO_SHORT_TO_PROCESS') return {
                    type: 'error',
                    errorInfo: {
                        apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                        failureReason: (0, $Mgq5A.FAILURE_REASON).INPUT_TOO_SHORT,
                        statusCode: response.status,
                        errorKey: error.key
                    }
                };
            }
            return {
                type: 'error',
                errorInfo: {
                    apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                    failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
                    statusCode: response.status,
                    errorContent: 'Unhandled error response received'
                }
            };
        }
    } catch (backendError) {
        return {
            type: 'error',
            errorInfo: {
                apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
                statusCode: response.status,
                errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(backendError)
            }
        };
    }
    // The BE are unable to add the header due to constraints with the service proxy
    // There is a ticket to add this via feature request
    // https://hello.jira.atlassian.cloud/browse/SPSVC-28
    // For now we are just hard coding the value
    if (response.status === 429) {
        const retryAfter = response.headers.get('Retry-After') || '60';
        return {
            type: 'error',
            retryAfter: Number(retryAfter),
            errorInfo: {
                apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $Mgq5A.FAILURE_REASON).RATE_LIMITED,
                statusCode: response.status
            }
        };
    }
    // This status code is being used to indicate that the request was unable to be handled
    // due to the content not meeting the Acceptable Use Policy.
    if (response.status === 451) return {
        type: 'error',
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION,
            statusCode: 451
        }
    };
    if (response.status === 9001) return {
        type: 'error',
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).ELEVATE_DISABLED_GENERATE,
            statusCode: 9001
        }
    };
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
            statusCode: response.status,
            errorContent: `unexpected response status: ${response.status}`
        }
    };
}
function $56a1218bab0b5eeb$var$handleNoResponseBody({ response: response, requestOptions: requestOptions }) {
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
            statusCode: response.status,
            errorContent: 'response.body missing'
        }
    };
}
function $56a1218bab0b5eeb$var$handleLineNoGeneratedContent({ requestOptions: requestOptions, cacheKey: cacheKey, data: data }) {
    const { selection: selection, doc: doc } = requestOptions;
    if (data.error?.statusCode === 429) return {
        type: 'error',
        retryAfter: 60,
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).RATE_LIMITED,
            statusCode: 429
        }
    };
    if (data.error?.key === 'RESPONSE_TOO_SIMILAR') {
        const inputOutputDiffRatio = $56a1218bab0b5eeb$var$parsedHasExpectedKey('meta', data) && $56a1218bab0b5eeb$var$parsedHasExpectedKey('inputOutputDiffRatio', data.meta) ? data['meta']['inputOutputDiffRatio'] : '';
        return {
            type: 'response too similar',
            cacheKey: cacheKey,
            modelInput: {
                selection: selection,
                doc: doc
            },
            inputOutputDiffRatio: inputOutputDiffRatio
        };
    }
    return {
        type: 'error',
        errorInfo: {
            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
            failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
            statusCode: data.error?.statusCode ?? 9002
        }
    };
}
function $56a1218bab0b5eeb$var$handleLineGeneratedContent({ streamContentProcessor: streamContentProcessor, partial: partial, data: data }) {
    partial.content += data['generatedContent'];
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('meta', data) && $56a1218bab0b5eeb$var$parsedHasExpectedKey('inputOutputDiffRatio', data.meta)) partial.meta = {
        inputOutputDiffRatio: data['meta']['inputOutputDiffRatio'],
        loadingStatus: ''
    };
    return {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content,
        ...streamContentProcessor?.(partial.content)
    };
}
function $56a1218bab0b5eeb$var$handleLineConvoAITrace({ partial: partial, data: data }) {
    const loadingStatus = $56a1218bab0b5eeb$var$parsedHasExpectedKey('message', data) && $56a1218bab0b5eeb$var$parsedHasExpectedKey('message_template', data.message) ? data.message.message_template : '';
    partial.meta = {
        inputOutputDiffRatio: '',
        loadingStatus: loadingStatus
    };
}
function $56a1218bab0b5eeb$var$handleLineConvoAIAnswerPart({ partial: partial, data: data, adfStreamer: adfStreamer }) {
    if (adfStreamer) {
        if ($56a1218bab0b5eeb$var$canProcessADFStreaming) {
            adfStreamer.processChunk(data.message.content);
            $56a1218bab0b5eeb$var$canProcessADFStreaming = false;
        } else adfStreamer.appendChunk(data.message.content);
        partial.adfResponse = adfStreamer.getLastDocWithoutLastLeafNode();
        // When adf streaming is enabled, don't need to keep the content in markdown
        partial.content = '';
        partial.meta = {
            inputOutputDiffRatio: '',
            loadingStatus: ''
        };
    } else {
        partial.content += data.message.content;
        partial.meta = {
            inputOutputDiffRatio: '',
            loadingStatus: ''
        };
    }
}
function $56a1218bab0b5eeb$var$processADFStreamingFinalResponse({ content: content, adfStreamer: adfStreamer, partial: partial, context: context }) {
    // Reset the adfStreamer to ensure it starts fresh for the final response to avoid any potential issues
    adfStreamer.reset();
    // `reset` clears the metadata and `setAnalyticsEventMetaData` replaces rather than merges, so
    // the format tag has to be re-applied here or the final-response events lose it.
    adfStreamer.setAnalyticsEventMetaData({
        isFinalResponse: true,
        ...partial.contentFormat && {
            contentFormat: partial.contentFormat
        }
    });
    const rawAdfResponse = adfStreamer.processChunk(content).getLastDoc();
    partial.adfResponse = partial.initialSelectionContext ? (0, $04500834e41df1ad$export$895f42d4e9947fc3)(rawAdfResponse, partial.initialSelectionContext) : rawAdfResponse;
    const inputSlice = $56a1218bab0b5eeb$var$getInputSlice(context);
    adfStreamer.setInputDocumentTree(inputSlice);
    // To fire analytics event for final response, need to end the streaming session
    adfStreamer.endStreamingSession({
        hasProcessedFinalResponse: true
    });
    // When adf streaming is enabled, don't need to keep the content in markdown
    partial.content = '';
}
function $56a1218bab0b5eeb$var$handleLineConvoAIFinalResponse({ requestOptions: requestOptions, cacheKey: cacheKey, data: data, partial: partial, adfStreamer: adfStreamer, context: context }) {
    const { message: message } = data;
    const { selection: selection, doc: doc } = requestOptions;
    function handleResponseTooSimilar(inputOutputDiffRatio) {
        if (adfStreamer) $56a1218bab0b5eeb$var$processADFStreamingFinalResponse({
            content: message.content,
            adfStreamer: adfStreamer,
            partial: partial,
            context: context
        });
        return {
            type: 'response too similar',
            cacheKey: cacheKey,
            modelInput: {
                selection: selection,
                doc: doc
            },
            inputOutputDiffRatio: inputOutputDiffRatio,
            adfResponse: partial.adfResponse
        };
    }
    // if response too similar, early break/return
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('message_metadata', message.message) && $56a1218bab0b5eeb$var$parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) return handleResponseTooSimilar(message.message?.message_metadata?.diff_ratio || '');
    else if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('response_too_similar', data) && data.response_too_similar) // Convo AI has a different structure compared to the Assistance Service
    // If 'response_too_similar' is a direct property of 'data', it indicates a Convo AI response
    return handleResponseTooSimilar($56a1218bab0b5eeb$var$parsedHasExpectedKey('similarity_ratio', data) ? `${data.similarity_ratio}` : '');
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('content', message)) {
        if (adfStreamer) $56a1218bab0b5eeb$var$processADFStreamingFinalResponse({
            content: message.content,
            adfStreamer: adfStreamer,
            partial: partial,
            context: context
        });
        else // Handle New Convo AI response structure
        partial.content = message.content;
        if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('actions', message) && Array.isArray(message.actions)) partial.rovoActions = message.actions || [];
        partial.meta = {
            inputOutputDiffRatio: $56a1218bab0b5eeb$var$parsedHasExpectedKey('similarity_ratio', data) ? `${data.similarity_ratio}` : '',
            loadingStatus: ''
        };
        return;
    }
    // Else handle Assistance Service response structure
    if (adfStreamer) $56a1218bab0b5eeb$var$processADFStreamingFinalResponse({
        content: message.content,
        adfStreamer: adfStreamer,
        partial: partial,
        context: context
    });
    else partial.content = message.message.content;
    partial.rovoActions = message.message.actions || [];
    partial.meta = {
        inputOutputDiffRatio: message.message?.message_metadata?.diff_ratio || '',
        loadingStatus: ''
    };
}
function $56a1218bab0b5eeb$var$handleLineConvoAIError({ requestOptions: requestOptions, cacheKey: cacheKey, data: data }) {
    let statusCode;
    let guard = 'UNHANDLED_ERROR';
    let error;
    let retryAfter;
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('message', data)) {
        // Get status code
        if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('status_code', data.message) && typeof data.message.status_code === 'number') statusCode = data.message.status_code;
        // Get reason
        if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('message_template', data.message)) guard = data.message.message_template;
        // Get error
        if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('content', data.message)) error = data.message.content;
        // Get retryAfter
        if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('headers', data) && $56a1218bab0b5eeb$var$parsedHasExpectedKey('Retry-After', data.headers)) retryAfter = Number(data.headers['Retry-After']);
    }
    let failureReason = (0, $Mgq5A.FAILURE_REASON).API_FAIL;
    if ([
        'RATE_LIMIT',
        'OPENAI_RATE_LIMIT_USER_ABUSE'
    ].includes(guard) && retryAfter) failureReason = (0, $Mgq5A.FAILURE_REASON).RATE_LIMITED;
    else retryAfter = undefined;
    if (guard === 'HIPAA_CONTENT_DETECTED') failureReason = (0, $Mgq5A.FAILURE_REASON).HIPAA_CONTENT;
    if (guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') failureReason = (0, $Mgq5A.FAILURE_REASON).TOKEN_LIMIT;
    const apiName = (0, $gcCwL.getAPIName)(requestOptions.endpoint);
    if (guard === 'ACCEPTABLE_USE_VIOLATIONS') return {
        type: 'error',
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        errorInfo: {
            failureReason: (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION,
            statusCode: statusCode,
            errorKey: guard,
            apiName: apiName,
            errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(error)
        }
    };
    if (retryAfter) return {
        type: 'error',
        retryAfter: retryAfter,
        errorInfo: {
            apiName: apiName,
            failureReason: failureReason,
            statusCode: statusCode,
            errorKey: guard,
            errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(error)
        }
    };
    return {
        type: 'error',
        errorInfo: {
            apiName: apiName,
            failureReason: failureReason,
            statusCode: statusCode,
            errorKey: guard,
            errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(error)
        }
    };
}
/**
 * Records `content_format` the first time it appears and pushes it onto the streamer, so every
 * subsequent ADF analytics event carries the format tag.
 *
 * Values outside {@link CONTENT_FORMATS} are dropped rather than forwarded. The value comes
 * straight off the backend envelope, so without this an unexpected or malformed response could put
 * an arbitrary string into telemetry.
 */ function $56a1218bab0b5eeb$var$recordContentFormat({ data: data, adfStreamer: adfStreamer, partial: partial }) {
    if (partial.contentFormat) return;
    if (!$56a1218bab0b5eeb$var$parsedHasExpectedKey('metadata', data) || !$56a1218bab0b5eeb$var$parsedHasExpectedKey('content_format', data.metadata)) return;
    const reported = data.metadata.content_format;
    const format = $56a1218bab0b5eeb$var$CONTENT_FORMATS.find((known)=>known === reported);
    if (!format) return;
    partial.contentFormat = format;
    adfStreamer?.setAnalyticsEventMetaData({
        contentFormat: format
    });
}
function $56a1218bab0b5eeb$var$handleLineConvoAI(props) {
    const { data: data, adfStreamer: adfStreamer, partial: partial } = props;
    $56a1218bab0b5eeb$var$recordContentFormat(props);
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('type', data)) switch(data.type){
        case 'TRACE':
            $56a1218bab0b5eeb$var$handleLineConvoAITrace(props);
            break;
        case 'ANSWER_PART':
            $56a1218bab0b5eeb$var$handleLineConvoAIAnswerPart(props);
            break;
        case 'FINAL_RESPONSE':
            /**
				 * When final response is received, all chunks received so far are processed.
				 * So, we need to end the streaming session to fire analytics events.
				 *
				 * Final response has all chunks combined, so adfStreamer is reset before
				 * 	processing final response.
				 * After processing final response, we can end the streaming session with
				 * 	isFinalResponse set to true in analytics event meta data.
				 * And will call endStreamingSession() to fire analytics events.
				 */ $56a1218bab0b5eeb$var$stopADFStreamingProcessTimer();
            // Set before the server-side branch below: that path also ends the session, so
            // leaving the flag unset would report every applied-server-side request as truncated.
            partial.hasProcessedFinalResponse = true;
            if ((0, $afcb69ccab894a52$export$bd03e2d18010bd07)(data)) {
                // The backend has already persisted this edit through NCS. Do not turn the raw
                // generated response into a second local editor transaction.
                adfStreamer?.endStreamingSession();
                partial.appliedServerSide = true;
                partial.content = '';
                partial.adfResponse = undefined;
                break;
            }
            const inputSlice = $56a1218bab0b5eeb$var$getInputSlice(props.context);
            adfStreamer?.setInputDocumentTree(inputSlice);
            adfStreamer?.endStreamingSession();
            const error = $56a1218bab0b5eeb$var$handleLineConvoAIFinalResponse(props);
            if (error) return error;
            break;
        case 'ERROR':
            $56a1218bab0b5eeb$var$stopADFStreamingProcessTimer();
            partial.hasReceivedErrorResponse = true;
            return $56a1218bab0b5eeb$var$handleLineConvoAIError(props);
    }
    // If there are any unexpected loading responses, we should return the current data
    return adfStreamer ? {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content,
        adfResponse: partial.adfResponse
    } : {
        type: 'stream',
        loadingStatus: partial.meta.loadingStatus,
        markdown: partial.content
    };
}
function $56a1218bab0b5eeb$var$handleLine(props) {
    if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('generatedContent', props.data)) return $56a1218bab0b5eeb$var$handleLineGeneratedContent(props);
    else if (props.requestOptions.isConvoAI) return $56a1218bab0b5eeb$var$handleLineConvoAI(props);
    else // if not expected response from the API the we have an error
    return {
        type: 'error',
        errorInfo: {
            failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
            apiName: (0, $gcCwL.getAPIName)(props.requestOptions.endpoint),
            statusCode: 9003
        }
    };
}
function $56a1218bab0b5eeb$var$handleLoaded({ requestOptions: requestOptions, cacheKey: cacheKey, context: context, selectionType: selectionType, streamContentProcessor: streamContentProcessor, isComplete: isComplete, partial: partial, schema: schema, isAdfPrompt: isAdfPrompt, adfStreamer: adfStreamer }) {
    const rovoActions = partial.rovoActions || [];
    if (partial.appliedServerSide) return (0, $afcb69ccab894a52$export$18bc670d10d3cd56)({
        cacheKey: cacheKey,
        requestOptions: requestOptions,
        rovoActions: rovoActions
    });
    let markdown;
    let adfResponse;
    if (isAdfPrompt) {
        markdown = (0, $bf2b1ee8ac1223c7$export$76f60e834c48b8d9)(partial.adfResponse || {
            type: 'doc',
            version: 1,
            content: []
        }, schema);
        adfResponse = partial.adfResponse;
    } else markdown = partial.content;
    let processedResponse = {
        markdown: markdown
    };
    if (rovoActions.length > 0) {
        const idealSuggestion = selectionType === 'range' ? 'replace' : 'insert';
        const action = rovoActions.find((x)=>x.data.suggestion === idealSuggestion) ?? rovoActions[0];
        // There is a scenario where we are in selectionType === 'empty'
        // but AI returns replace. In this case, we override the replace
        // suggestion with insert.
        if (selectionType === 'empty' && action.data.suggestion === 'replace') // This should also update the value by reference in rovoActions
        action.data.suggestion = 'insert';
        else if (selectionType === 'range' && action.data.suggestion === 'insert') // This should also update the value by reference in rovoActions
        action.data.suggestion = 'replace';
        markdown += `\n\n---\n\n${action.data.content}`;
    } else if (streamContentProcessor) processedResponse = streamContentProcessor(partial.content);
    if (isComplete) {
        const isCompleted = isComplete();
        if (!isCompleted) return {
            type: 'stream',
            ...processedResponse,
            loadingStatus: partial.meta?.loadingStatus
        };
    }
    /**
	 * The response body has ended. `endStreamingSession` is otherwise only reached from the
	 * `FINAL_RESPONSE` branch, so a stream that stops early flushes no session analytics at all -
	 * not even the chunk count - while still returning `type: 'complete'` to the state machine.
	 *
	 * ConvoAI-only because `hasProcessedFinalResponse` is set by `handleLineConvoAI`, while
	 * `adfStreamer` is built from `isAdfPrompt` alone: an ADF prompt on the `generatedContent` path
	 * would otherwise report every successful request as truncated.
	 */ if (isAdfPrompt && adfStreamer && requestOptions.isConvoAI && !partial.hasProcessedFinalResponse && !partial.hasReceivedErrorResponse) {
        adfStreamer.setInputDocumentTree($56a1218bab0b5eeb$var$getInputSlice(context));
        adfStreamer.endStreamingSession({
            streamEndedWithoutFinalResponse: true
        });
    }
    return {
        type: 'complete',
        ...processedResponse,
        ...adfResponse && {
            adfResponse: adfResponse
        },
        cacheKey: cacheKey,
        modelInput: {
            selection: requestOptions.selection,
            doc: requestOptions.doc
        },
        inputOutputDiffRatio: partial.meta?.inputOutputDiffRatio,
        rovoActions: rovoActions
    };
}
/**
 * Extracts initial selection context for capitalization correction
 */ function $56a1218bab0b5eeb$var$getInitialSelectionContext(context) {
    const doc = context.editorView.state.doc;
    const positionToTextIndex = (proseMirrorPos)=>{
        return doc.textBetween(0, Math.min(proseMirrorPos, doc.content.size), '\n', ' ').length;
    };
    const fullDocumentText = doc.textBetween(0, doc.content.size, '\n', ' ');
    const originalText = doc.textBetween(Math.max(0, context.positions[0]), Math.min(context.positions[1], doc.content.size), '\n', ' ');
    const selectionStart = positionToTextIndex(context.positions[0]);
    const selectionEnd = positionToTextIndex(context.positions[1]);
    return {
        fullDocumentText: fullDocumentText,
        originalText: originalText,
        selectionEnd: selectionEnd,
        selectionStart: selectionStart
    };
}
async function* $56a1218bab0b5eeb$var$streamingBody({ requestOptions: requestOptions, cacheKey: cacheKey, context: context, selectionType: selectionType, streamContentProcessor: streamContentProcessor, isComplete: isComplete, response: response, body: body, adfStreamer: adfStreamer, abortController: abortController, callback: callback }) {
    try {
        const reader = body.getReader();
        const decoder = new TextDecoder('utf-8');
        let buffer = '';
        let done = false;
        const adfPrompt = context?.configItem?.adfPrompt;
        const initialSelectionContext = adfPrompt ? $56a1218bab0b5eeb$var$getInitialSelectionContext(context) : undefined;
        const partial = {
            type: 'markdown',
            content: '',
            meta: {
                inputOutputDiffRatio: ''
            },
            rovoActions: [],
            initialSelectionContext: initialSelectionContext
        };
        while(!done){
            const { value: value, done: doneReading } = await reader.read();
            done = doneReading;
            const chunkValue = decoder.decode(value);
            buffer = buffer + chunkValue;
            // Split the buffer by line breaks
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const lines = buffer.split('\n');
            // Process all complete lines, except for the last one (which might be incomplete)
            while(lines.length > 1){
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const line = lines.shift();
                let data;
                try {
                    data = JSON.parse(line);
                } catch (jsonError) {
                    // Handle invalid JSON - revert content and show error with retry option
                    return yield {
                        type: 'error',
                        errorInfo: {
                            apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                            failureReason: (0, $Mgq5A.FAILURE_REASON).INVALID_JSON,
                            statusCode: response.status,
                            errorContent: `Received invalid json: ${jsonError instanceof Error ? jsonError.message : String(jsonError)}`
                        }
                    };
                }
                if (data.generatedContent === null) return yield $56a1218bab0b5eeb$var$handleLineNoGeneratedContent({
                    requestOptions: requestOptions,
                    cacheKey: cacheKey,
                    context: context,
                    streamContentProcessor: streamContentProcessor,
                    partial: partial,
                    data: data,
                    adfStreamer: adfStreamer,
                    selectionType: selectionType,
                    schema: context.editorView?.state?.schema,
                    isAdfPrompt: !!adfPrompt
                });
                yield $56a1218bab0b5eeb$var$handleLine({
                    requestOptions: requestOptions,
                    cacheKey: cacheKey,
                    context: context,
                    streamContentProcessor: streamContentProcessor,
                    partial: partial,
                    data: data,
                    adfStreamer: adfStreamer,
                    selectionType: selectionType,
                    schema: context.editorView?.state?.schema,
                    isAdfPrompt: !!adfPrompt
                });
                if ($56a1218bab0b5eeb$var$parsedHasExpectedKey('idMap', data) && typeof data.idMap === 'object' && data.idMap !== null && Object.keys(data.idMap).length > 0) callback({
                    type: 'update idMap',
                    context: {
                        idMap: data.idMap
                    }
                });
            }
            // Keep the last (potentially incomplete) line in the buffer
            buffer = lines[0];
        }
        return yield $56a1218bab0b5eeb$var$handleLoaded({
            requestOptions: requestOptions,
            cacheKey: cacheKey,
            context: context,
            selectionType: selectionType,
            streamContentProcessor: streamContentProcessor,
            isComplete: isComplete,
            partial: partial,
            schema: context.editorView?.state?.schema,
            isAdfPrompt: !!adfPrompt,
            adfStreamer: adfStreamer
        });
    } catch (parsingError) {
        /**
		 * Retry Manager will abort request if there are ADF parsing is failing
		 * 	for specified duration and retry attempt has not reached max retries.
		 *
		 * It will abort previous request which will throw AbortError.
		 *
		 * isThisAutomaticRetry will be true if this is retry attempt.
		 */ if (!(abortController.signal.aborted && parsingError instanceof Error && parsingError.name === 'AbortError')) return yield {
            type: 'error',
            errorInfo: {
                apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
                statusCode: response.status,
                errorContent: $56a1218bab0b5eeb$var$sanitizeErrorContent(parsingError)
            }
        };
    }
}
function $56a1218bab0b5eeb$var$makeEndpoint({ endpoint: endpoint, channelId: channelId }) {
    let actualEndpoint = endpoint;
    // Using a stateful endpoint
    if (channelId) actualEndpoint = `${endpoint}/${channelId}/message/stream`;
    return actualEndpoint;
}
function $56a1218bab0b5eeb$var$makeHeaders({ product: product, experienceId: experienceId }) {
    return {
        'Content-Type': 'application/json;charset=UTF-8',
        'X-Experience-Id': experienceId,
        ...(0, $72eca8ccfc8df62d$export$b3f5e033c954a1b0)(experienceId),
        ...(0, $72eca8ccfc8df62d$export$46d5228a079b1d3)(product)
    };
}
async function $56a1218bab0b5eeb$export$209cb5bffda2d239(options) {
    const { abortController: abortController, cacheKey: cacheKey, selectionType: selectionType, product: product, getFetchCustomHeaders: getFetchCustomHeaders, channelId: channelId, callback: callback, streamFlowPacer: streamFlowPacer, streamContentProcessor: streamContentProcessor, isComplete: isComplete, requestOptions: requestOptions, context: context, fireAIAnalyticsEvent: fireAIAnalyticsEvent, aiInteractionID: aiInteractionID } = options;
    if ('response' in requestOptions) {
        callback(requestOptions.response);
        return;
    }
    if ('error' in requestOptions) {
        // eslint-disable-next-line no-console
        console.error('Editor AI: startStreamingResponse()', requestOptions.error);
        callback({
            type: 'error',
            errorInfo: {
                apiName: (0, $gcCwL.getAPIName)(requestOptions.endpoint),
                failureReason: (0, $Mgq5A.FAILURE_REASON).API_FAIL,
                statusCode: 400,
                errorContent: requestOptions.error
            }
        });
        return;
    }
    const { experienceId: experienceId, endpoint: endpoint, payload: payload } = requestOptions;
    // After early return checks above, requestOptions must be the payload-containing variant
    const typedRequestOptions = requestOptions;
    let streamCallback = callback;
    let adfStreamingRetryManager = null;
    // Populated from the response headers below. Deliberately not seeded from
    // context.traceIds, which on a retry still holds the previous attempt's id.
    let currentTraceId;
    function createNewADFStreamer() {
        return (0, $8fd254ba18c3d8f5$export$313ea9e31b82ddc)({
            state: context.editorView.state,
            /*
			 * Remove use of null coalescing operator when last
			 *  experiment for adf streaming is removed.
			 */ fireAIAnalyticsEvent: fireAIAnalyticsEvent ?? (()=>{}),
            experienceName: context.configItem.key,
            featureId: context.configItem.featureId,
            aiSessionId: context.analyticsContext.aiSessionId,
            aiInteractionID: aiInteractionID,
            selectionType: selectionType,
            contentStatistics: typedRequestOptions.contentStatistics,
            selectionCategory: (0, $3117ebeab67c20f0$export$385434a4b24ab280)(context.editorView, context.positions),
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            streamId: (0, $03RpJ.default)(),
            retryAttemptNumber: adfStreamingRetryManager?.getRetryCount() ?? 0,
            getTraceId: ()=>currentTraceId
        });
    }
    const isAdfPrompt = context?.configItem?.adfPrompt;
    let adfStreamer = isAdfPrompt ? createNewADFStreamer() : undefined;
    async function fetcher(abortController, retryManager) {
        try {
            if (streamFlowPacer && (isAdfPrompt || context.aiProvider.isInDocumentStreamingEnabled)) {
                // when we retry after an error, we need to reset
                streamFlowPacer.reset();
                streamFlowPacer.setEmit(callback);
                /**
				 * If AIFC is disabled, then AI response will be shown in LoadingScreen.
				 * GPT models returns very very small chunks (often times 2-3 chars).
				 * This causes too many re-renders of Renderer component in LoadingScreen,
				 * 	which affects performance.
				 *
				 * So using streamFlowPacer to throttle the stream and process chunks in batches.
				 * Currently, it re-render LoadingScreen 4 times per second.
				 */ if (isAdfPrompt && !context.aiProvider.isInDocumentStreamingEnabled) {
                    streamFlowPacer.setTickMs($56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_INTERVAL);
                    streamFlowPacer.setCharsPerTick($56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_INITIAL_CHARS_PER_TICK);
                    streamFlowPacer.setMaxCharsPerTick($56a1218bab0b5eeb$var$ADF_STREAMING_PROCESS_MAX_CHARS_PER_TICK);
                }
                streamFlowPacer.start();
                streamCallback = streamFlowPacer.push;
            }
            if (isAdfPrompt) $56a1218bab0b5eeb$var$startADFStreamingProcessTimer();
            const actualEndpoint = $56a1218bab0b5eeb$var$makeEndpoint({
                endpoint: endpoint,
                channelId: channelId
            });
            const fetchInit = {
                method: 'POST',
                headers: $56a1218bab0b5eeb$var$makeHeaders({
                    product: product,
                    experienceId: experienceId
                }),
                body: payload,
                credentials: 'include',
                signal: abortController.signal,
                mode: 'cors'
            };
            const fetchCustomHeaders = getFetchCustomHeaders?.(endpoint, fetchInit) || {};
            const response = await fetch(actualEndpoint, {
                ...fetchInit,
                headers: {
                    ...fetchInit.headers,
                    ...fetchCustomHeaders
                }
            });
            const traceId = response.headers.get('X-Trace-Id') || response.headers.get('Atl-Traceid');
            if (traceId) {
                currentTraceId = traceId;
                callback({
                    type: 'update traceIds',
                    context: {
                        traceIds: [
                            traceId
                        ]
                    }
                });
            }
            if (!response.ok) return callback(await $56a1218bab0b5eeb$var$handleResponseNotOK({
                requestOptions: typedRequestOptions,
                cacheKey: cacheKey,
                response: response
            }));
            if (!response.body) {
                callback($56a1218bab0b5eeb$var$handleNoResponseBody({
                    requestOptions: typedRequestOptions,
                    response: response
                }));
                return;
            }
            if (context?.configItem?.handleFetchResponse) {
                const data = await response.json();
                context.configItem.handleFetchResponse(data, requestOptions, callback, cacheKey);
                return;
            }
            const streaming = $56a1218bab0b5eeb$var$streamingBody({
                requestOptions: typedRequestOptions,
                cacheKey: cacheKey,
                selectionType: selectionType,
                streamContentProcessor: streamContentProcessor,
                isComplete: isComplete,
                response: response,
                body: response.body,
                context: context,
                adfStreamer: adfStreamer,
                abortController: abortController,
                callback: callback
            });
            for await (const item of streaming){
                streamCallback(item);
                // If we have a response other than stream (which means there is an error), we should stop the streaming
                if (item.type !== 'stream') {
                    /**
					 * When streaming ends, check if ADFStreamer is in error state.
					 * Retry if possible if in error state.
					 */ if (retryManager) {
                        if (adfStreamer?.isInErrorState()) {
                            if (retryManager.hasMaxRetryReached()) callback({
                                type: 'error',
                                errorInfo: {
                                    apiName: (0, $gcCwL.getAPIName)(endpoint),
                                    failureReason: (0, $Mgq5A.FAILURE_REASON).ADF_STREAMING_ERROR
                                }
                            });
                            else retryManager.retryOnStreamingEnd();
                        } else retryManager.reset();
                    }
                    return;
                }
            }
        } catch (error) {
            adfStreamingRetryManager?.reset();
            $56a1218bab0b5eeb$var$stopADFStreamingProcessTimer();
            streamCallback($56a1218bab0b5eeb$var$handleRequestError(error, endpoint));
        }
    }
    /**
	 * When AIFC is enabled, it will stream directly into document.
	 * Currently, automatic retry will only happen when in document streaming is disabled.
	 */ if (isAdfPrompt && !context.aiProvider.isInDocumentStreamingEnabled) {
        adfStreamingRetryManager = new (0, $8828eae58e1de5b9$export$f748a1b030d3429f)({
            maxRetries: $56a1218bab0b5eeb$var$ADF_STREAMING_RETRY_MAX_RETRIES,
            delayMs: $56a1218bab0b5eeb$var$ADF_STREAMING_RETRY_DELAY_MS,
            beforeRetryCallback: ()=>{
                callback({
                    type: 'retry on adf stream errors',
                    adfResponse: (0, $6e6HL.getEmptyADF)()
                });
                adfStreamer?.endStreamingSession();
                adfStreamer?.reset();
                adfStreamer = createNewADFStreamer();
            },
            fetcher: fetcher,
            errorChecker: ()=>{
                return adfStreamer?.isInErrorState() ?? false;
            }
        });
        adfStreamingRetryManager?.startFetchingWithRetry();
    } else await fetcher(abortController);
}


/**
 * Vary prompt request triggered - if latest response exists, we are interrogating,
 * and do not want to use the original config item (i.e. may possibly be summarise/transform)
 *
 * If it is a generate with tag, the response will be captured within
 * the latest "latest response, prompt", flow.
 *
 * REVISIT THIS: analytics is based on the config item, however
 * interrogation analytics uses base generate instead to complete;
 */ function $a1b48c6cfd5555d3$var$getConfigItem({ context: context }) {
    return context.configItem.withContextMutation?.(context.configItem, context) ?? context.configItem;
}
/**
 * Get mention map for the current document
 * We can no longer use the node attrs to get the mention name
 * So we now need to get all the mentions and create a mapping that can be used by the
 * markdown serializer
 */ async function $a1b48c6cfd5555d3$var$_getMentionMap({ context: context }) {
    let mentionMap = {};
    if (context.getMentionNameDetails) mentionMap = await (0, $0a05d8b07618b684$export$922d75f514df28b7)({
        node: context.editorView.state.doc,
        getMentionNameDetails: context.getMentionNameDetails
    });
    return mentionMap;
}
function $a1b48c6cfd5555d3$var$hitCache({ context: context, cacheKey: cacheKey }) {
    const { entries: entries } = context.responseHistory;
    const lastHistoryItem = entries[entries.length - 1];
    return lastHistoryItem && cacheKey === lastHistoryItem.cacheKey && context.promptTrigger !== 'interrogate';
}
function $a1b48c6cfd5555d3$export$ad256dcfbe275ed5({ abortController: providedAbortController, fireAIAnalyticsEvent: fireAIAnalyticsEvent, aiInteractionID: aiInteractionID, streamFlowPacer: streamFlowPacer }) {
    return async function streamingHandler(context, callback) {
        const abortController = providedAbortController ?? new AbortController();
        const { userInput: userInput, configItem: { agent: agent } } = context;
        const configItem = $a1b48c6cfd5555d3$var$getConfigItem({
            context: context
        });
        const mentionMap = await $a1b48c6cfd5555d3$var$_getMentionMap({
            context: context
        });
        const requestOptions = (0, $acc1594deac9d985$export$65964063bcedf059)({
            callback: callback,
            context: context,
            configItem: configItem,
            mentionMap: mentionMap
        });
        const cacheKey = JSON.stringify({
            userInput: userInput,
            agent: agent,
            requestOptions: requestOptions
        });
        if ($a1b48c6cfd5555d3$var$hitCache({
            context: context,
            cacheKey: cacheKey
        })) {
            callback({
                type: 'same cache key'
            });
            return;
        }
        const getFetchCustomHeaders = configItem.getCustomHeaders ? configItem.getCustomHeaders : context.aiProvider.getFetchCustomHeaders;
        await (0, $56a1218bab0b5eeb$export$209cb5bffda2d239)({
            abortController: abortController,
            cacheKey: cacheKey,
            selectionType: context.selectionType,
            product: context.aiProvider.product,
            getFetchCustomHeaders: getFetchCustomHeaders,
            channelId: context.channelId,
            callback: callback,
            requestOptions: requestOptions,
            context: context,
            fireAIAnalyticsEvent: fireAIAnalyticsEvent,
            aiInteractionID: aiInteractionID,
            streamFlowPacer: streamFlowPacer
        });
        // Cleanup function
        return ()=>{
            abortController.abort();
        };
    };
}




const $052bf53787d1c2f9$var$handleFallbackSuggestedTitle = (streamingCallback, api, analyticSourceId, fallbackSuggestedTitle)=>{
    streamingCallback({
        type: 'complete',
        result: fallbackSuggestedTitle
    });
    (0, $868c3e7a3428b046$export$268e0492b4645ae4)({
        api: api,
        analyticSourceId: analyticSourceId,
        isDateTimeFormat: true
    });
};
const $052bf53787d1c2f9$export$20a4431e680ea8af = ({ getIntl: getIntl, editorPluginAIProvider: editorPluginAIProvider, currentEditorView: currentEditorView, configItem: configItem, streamingCallback: streamingCallback, api: api, analyticSourceId: analyticSourceId, initialPrompt: initialPrompt })=>{
    const intl = getIntl();
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const uid = (0, $03RpJ.default)();
    const context = {
        aiProvider: editorPluginAIProvider,
        editorView: currentEditorView,
        configItem: configItem,
        intl: intl,
        // For "custom prompt" flows, the request payload uses `userInput` as the user instruction.
        userInput: initialPrompt,
        promptTrigger: initialPrompt ? 'custom' : undefined,
        positions: [
            0,
            0
        ],
        isEmpty: true,
        selectionType: 'empty',
        usePageKnowledge: true,
        analyticsContext: {
            aiSessionId: uid,
            aiGroupId: uid
        },
        responseHistory: {
            positionFromEnd: 0,
            entries: [],
            totalSize: 0,
            traversals: 0
        }
    };
    streamingCallback({
        type: 'initialising'
    });
    // For proactive title generation project: We carve out a specific scenario when to
    // return a 'fallback title' if no context will be sent with the suggest a title prompt
    // (which would otherwise generate training data gibberish)
    if ((0, $aa7765f711bd6a4f$export$8aaa839b34c07044)(configItem, currentEditorView)) {
        const fallbackTitleMessage = intl.formatMessage((0, $7ZL6d.aiMessages).eventHubfallbackSuggestedTitlePrefix);
        const now = new Date();
        const dateTimeString = (0, $f6RxU.default)(now, 'yyyy-MM-dd HH:mm');
        const fallbackSuggestedTitle = `${fallbackTitleMessage} ${dateTimeString}`;
        $052bf53787d1c2f9$var$handleFallbackSuggestedTitle(streamingCallback, api, analyticSourceId, fallbackSuggestedTitle);
        return;
    }
    const callbackHandler = (0, $a1b48c6cfd5555d3$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: ()=>{},
        streamFlowPacer: null
    });
    callbackHandler(context, (streamData)=>{
        if (streamData) switch(streamData.type){
            case 'stream':
                if (streamData.loadingStatus === 'ANALYSING_QUERY') streamingCallback({
                    type: 'analysingQuery'
                });
                else streamingCallback({
                    type: 'streaming',
                    result: streamData.markdown
                });
                break;
            case 'complete':
                streamingCallback({
                    type: 'complete',
                    result: streamData.markdown
                });
                if ((0, $868c3e7a3428b046$export$8e68345bacf55b30)(configItem)) (0, $868c3e7a3428b046$export$544cb5cc4b426cad)({
                    api: api,
                    analyticSourceId: analyticSourceId,
                    suggestedTitle: streamData.markdown
                });
                break;
            case 'error':
                streamingCallback({
                    type: streamData.type,
                    errorInfo: streamData.errorInfo
                });
                break;
            case 'response too similar':
                streamingCallback({
                    type: streamData.type
                });
                break;
            default:
                break;
        }
    });
};


const $5f01bebad4249f05$export$c83eff15443f700 = (options)=>{
    const { aiGlobalOptIn: aiGlobalOptIn } = options;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $d58f4089cc6c0aeb$export$e54fe7f659b58e64),
        view: (editorView)=>{
            let currentEditorView = editorView;
            const { unsubscribe: unsubscribe } = (0, $9XB2W.eventHub).subscribe({
                event: 'start prompt',
                callback: (data)=>{
                    const editorId = (0, $9qe1v.findEditorIdFromView)(currentEditorView);
                    if (editorId === data.targetEditorId) {
                        const { state: state, dispatch: dispatch } = currentEditorView;
                        let payloadData;
                        if (data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).IssueReformatter) payloadData = data.additionalPayloadDataIssueReformatter;
                        else if (data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).DraftReplyPill) payloadData = data.additionalPayloadData;
                        else if (data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).DescriptionCompleter) payloadData = data.additionalPayloadData;
                        else if (data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).IncidentSmartComments) payloadData = data.additionalPayloadData;
                        else if (data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).SuggestComment) payloadData = data.additionalPayloadData;
                        const configItem = (0, $aa7765f711bd6a4f$export$bd5d7e8cfaa78c6f)(data.prompt, options.editorPluginAIProvider, data.adjustSelection, payloadData);
                        if (!configItem) {
                            (0, $868c3e7a3428b046$export$3ddc9d41f6af5056)({
                                dispatch: dispatch,
                                editorView: currentEditorView,
                                prompt: data.prompt,
                                promptText: data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).CustomPrompt ? data.promptText : undefined,
                                adjustSelection: data.adjustSelection
                            });
                            return;
                        }
                        const params = {
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: data.analyticSourceId,
                            willAISuggestEmoji: data.willAISuggestEmoji,
                            aiGlobalOptIn: aiGlobalOptIn,
                            adjustSelection: data.adjustSelection,
                            initialPrompt: data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).CustomPrompt ? data.promptText : undefined,
                            locale: options.getIntl().locale
                        };
                        if (data.hideModal) (0, $052bf53787d1c2f9$export$20a4431e680ea8af)({
                            getIntl: options.getIntl,
                            currentEditorView: currentEditorView,
                            editorPluginAIProvider: options.editorPluginAIProvider,
                            configItem: configItem,
                            streamingCallback: data.streamingCallback,
                            api: options.api,
                            analyticSourceId: data.analyticSourceId,
                            initialPrompt: data.prompt === (0, $3f9da29c050e7e33$export$4cefcfab1f987be5).CustomPrompt ? data.promptText : undefined
                        });
                        else {
                            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)(params);
                            openAIModalCommand(state, dispatch);
                        }
                    }
                }
            });
            return {
                update: (newEditorView)=>{
                    currentEditorView = newEditorView;
                },
                destroy: ()=>{
                    unsubscribe();
                }
            };
        }
    });
};



var $3AVOh = parcelRequire("3AVOh");








var $jdUP6 = parcelRequire("jdUP6");














var $l2lIz = parcelRequire("l2lIz");





var $9RRio = parcelRequire("9RRio");




const $17972e16fe06d756$export$ade9b71e7e80f74e = new (0, $kCECX.PluginKey)('aiMonitorWatchmen');



var $eOaGc = parcelRequire("eOaGc");




const $721764a998f088d5$var$WHITESPACE_REGEX = /\s+/u;
const $721764a998f088d5$export$4876cc3130d3f820 = (ranges)=>{
    if (!ranges.length) return ranges;
    const sorted = [
        ...ranges
    ].sort((a, b)=>a.from - b.from);
    const out = [];
    let cur = {
        ...sorted[0]
    };
    for(let i = 1; i < sorted.length; i++){
        const r = sorted[i];
        if (r.from <= cur.to) cur.to = Math.max(cur.to, r.to);
        else {
            out.push(cur);
            cur = {
                ...r
            };
        }
    }
    out.push(cur);
    return out;
};
/**
 * Positions are clamped because these ranges are handed to `sumTextCounts`, which calls
 * `doc.textBetween` and throws on out-of-bounds input. This runs inside a plugin `apply`,
 * so a throw would take the editor down; a metric must never be able to do that.
 */ const $721764a998f088d5$var$clampRange = (from, to, docSize)=>({
        from: Math.max(0, Math.min(from, docSize)),
        to: Math.max(0, Math.min(to, docSize))
    });
const $721764a998f088d5$export$cc054888e781965 = (segments, docSize)=>$721764a998f088d5$export$4876cc3130d3f820(segments.map((segment)=>$721764a998f088d5$var$clampRange(segment.startPos, segment.endPos, docSize)).filter((range)=>range.from < range.to));
const $721764a998f088d5$export$14966e72b8b1fc10 = (existingRanges, batchRanges, mapPosition, docSize)=>$721764a998f088d5$export$4876cc3130d3f820([
        ...existingRanges.map(({ from: from, to: to })=>$721764a998f088d5$var$clampRange(mapPosition(from, -1), mapPosition(to, 1), docSize)),
        ...batchRanges.map(({ from: from, to: to })=>$721764a998f088d5$var$clampRange(from, to, docSize))
    ].filter((range)=>range.from < range.to));
const $721764a998f088d5$var$TEXT_BETWEEN_BLOCK = ' ';
const $721764a998f088d5$var$TEXT_BETWEEN_LEAF = ' ';
const $721764a998f088d5$export$8a4da2d583115a0d = (doc, from, to)=>{
    return doc.textBetween(from, to, $721764a998f088d5$var$TEXT_BETWEEN_BLOCK, $721764a998f088d5$var$TEXT_BETWEEN_LEAF);
};
const $721764a998f088d5$var$wordSegmenter = typeof Intl !== 'undefined' && Intl.Segmenter ? new Intl.Segmenter(undefined, {
    granularity: 'word'
}) : null;
const $721764a998f088d5$export$5e9f9da5213092bc = (text)=>{
    const t = text.trim();
    if (!t) return 0;
    try {
        if ($721764a998f088d5$var$wordSegmenter) {
            let c = 0;
            for (const { isWordLike: isWordLike } of $721764a998f088d5$var$wordSegmenter.segment(t))if (isWordLike) c++;
            return c;
        }
    } catch  {}
    return t.split($721764a998f088d5$var$WHITESPACE_REGEX).filter(Boolean).length;
};
const $721764a998f088d5$export$eed38d084e27127a = (doc, ranges)=>{
    let chars = 0;
    let words = 0;
    for (const r of ranges){
        const s = $721764a998f088d5$export$8a4da2d583115a0d(doc, r.from, r.to);
        chars += s.length;
        words += $721764a998f088d5$export$5e9f9da5213092bc(s);
    }
    return {
        chars: chars,
        words: words
    };
};
const $721764a998f088d5$export$5185129806b81f0a = (maps)=>{
    const out = [];
    for (const m of maps)m.forEach((oldStart, oldEnd, newStart, newEnd)=>{
        if (oldStart !== oldEnd || newStart !== newEnd) out.push({
            oldStart: oldStart,
            oldEnd: oldEnd,
            newStart: newStart,
            newEnd: newEnd
        });
    });
    return out;
};
const $721764a998f088d5$export$97c088e92f2198d4 = (maps, sessionRanges)=>{
    if (!sessionRanges.length) return false;
    const key = (a, b, c, d)=>`${a}:${b}:${c}:${d}`;
    const need = new Set(sessionRanges.map((r)=>key(r.newStart, r.newEnd, r.oldStart, r.oldEnd)));
    for (const m of maps)m.forEach((os, oe, ns, ne)=>need.delete(key(os, oe, ns, ne)));
    return need.size === 0;
};
const $721764a998f088d5$export$476c745650a7176c = (maps, undoneRanges)=>{
    if (!undoneRanges.length) return false;
    // A redo is the inverse of an undo, so we check if the transaction
    // restores the exact content that was undone
    const key = (a, b, c, d)=>`${a}:${b}:${c}:${d}`;
    const need = new Set(undoneRanges.map((r)=>key(r.oldStart, r.oldEnd, r.newStart, r.newEnd)));
    for (const m of maps)m.forEach((os, oe, ns, ne)=>need.delete(key(os, oe, ns, ne)));
    return need.size === 0;
};
const $721764a998f088d5$export$e852621173d4215b = (steps, stepMaps, baselineDoc, sessionRangesAfterAI)=>{
    let localDoc = baselineDoc;
    let currentRanges = sessionRangesAfterAI.map((r)=>({
            ...r
        }));
    let deletedChars = 0;
    let deletedWords = 0;
    const touchedIdx = new Set();
    for(let i = 0; i < steps.length; i++){
        const step = steps[i];
        let delFrom = null;
        let delTo = null;
        if (step instanceof (0, $eOaGc.ReplaceStep)) {
            if (typeof step.from === 'number' && typeof step.to === 'number' && step.from < step.to) {
                delFrom = step.from;
                delTo = step.to;
            }
        } else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) {
            const ra = step;
            const deletedSpans = [
                {
                    from: ra.from,
                    to: ra.gapFrom
                },
                {
                    from: ra.gapTo,
                    to: ra.to
                }
            ].filter((s)=>s.from < s.to);
            for (const span of deletedSpans)for(let idx = 0; idx < currentRanges.length; idx++){
                const r = currentRanges[idx];
                const start = Math.max(r.from, span.from);
                const end = Math.min(r.to, span.to);
                if (start < end) {
                    touchedIdx.add(idx);
                    const removed = $721764a998f088d5$export$8a4da2d583115a0d(localDoc, start, end);
                    deletedChars += removed.length;
                    deletedWords += $721764a998f088d5$export$5e9f9da5213092bc(removed);
                }
            }
        }
        if (delFrom != null && delTo != null) for(let idx = 0; idx < currentRanges.length; idx++){
            const r = currentRanges[idx];
            const start = Math.max(r.from, delFrom);
            const end = Math.min(r.to, delTo);
            if (start < end) {
                touchedIdx.add(idx);
                const removed = $721764a998f088d5$export$8a4da2d583115a0d(localDoc, start, end);
                deletedChars += removed.length;
                deletedWords += $721764a998f088d5$export$5e9f9da5213092bc(removed);
            }
        }
        const result = step.apply(localDoc);
        if (result.doc) localDoc = result.doc;
        const map = stepMaps[i];
        if (map) currentRanges = currentRanges.map(({ from: from, to: to })=>({
                from: map.map(from, -1),
                to: map.map(to, 1)
            }));
    }
    return {
        deletedChars: deletedChars,
        deletedWords: deletedWords,
        touched: touchedIdx.size
    };
};
const $721764a998f088d5$export$bfa42147068ddd92 = (state, s, type, newDoc, counts = {}, overHalfDeleted = false)=>{
    const now = performance.now();
    const { removedChars: removedChars, removedWords: removedWords, touched: touched } = counts;
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_discarded_unified_analytic_events')) s.baselineDoc = newDoc;
    return {
        ...state,
        currentSession: (0, $4o0zT.isExperimentEnabled)('platform_editor_discarded_unified_analytic_events') ? type === 'undo' || overHalfDeleted ? null : s : null,
        pendingAnalytics: {
            aiSessionId: s.id,
            nextActionType: type,
            aiOutputChars: s.aiOutputChars,
            aiOutputWords: s.aiOutputWords,
            nextActionRemovedAiChars: removedChars,
            nextActionRemovedAiWords: removedWords,
            nextActionTouchedAiRanges: touched,
            nextActionLatencyMs: Math.round(Math.max(0, now - s.startedAt)),
            aiGroupId: s.aiGroupId,
            experienceName: s.experienceName
        }
    };
};
const $721764a998f088d5$export$f5fff894cf1d5ab = (maps, aiRanges)=>{
    const changed = $721764a998f088d5$export$5185129806b81f0a(maps);
    for(let i = 0; i < changed.length; i++){
        const c = changed[i];
        for(let j = 0; j < aiRanges.length; j++){
            const r = aiRanges[j];
            if (c.oldEnd > r.from && c.oldStart < r.to) return true;
        }
    }
    return false;
};


const $f5926f9d1caeb928$var$META_FLUSH_ANALYTICS = 'AIMonitorWatchmenFlushAnalytics';
const $f5926f9d1caeb928$var$META_DEFERRED_ANALYTICS = 'AIMonitorWatchmenDeferredAnalytics';
const $f5926f9d1caeb928$export$249b63272434dfc7 = 'AIMonitorWatchmenCommonAttributes';
const $f5926f9d1caeb928$var$ACTIONED_EVENT_DELAY = 30000;
/** Synthetic id keeps backend actioned and discarded events queryable. */ const $f5926f9d1caeb928$var$BACKEND_UPDATE_SESSION_ID_PREFIX = 'backendUpdate_';
const $f5926f9d1caeb928$var$BACKEND_UPDATE_EXPERIENCE_NAME = 'backendAgentEdit';
const $f5926f9d1caeb928$var$BACKEND_UPDATE_ACTIONED_TYPE = 'backendPersisted';
/** Prevents a backend session from being counted as both accepted and discarded. */ const $f5926f9d1caeb928$var$acceptIsStillPending = (session)=>session.acceptPendingUntil === undefined || performance.now() < session.acceptPendingUntil;
/**
 * Upserts one session without displacing deferrals from the other route. Successive
 * frontend streams still collapse into one event.
 */ const $f5926f9d1caeb928$var$upsertDeferral = (existing, entry)=>[
        ...(existing ?? []).filter((d)=>{
            if (d.aiSessionId === entry.aiSessionId) return false;
            return entry.isBackendPersisted || d.isBackendPersisted;
        }),
        entry
    ];
const $f5926f9d1caeb928$var$dropPendingBackendSession = (state, sessionId)=>({
        ...state,
        currentSession: null,
        pendingAnalytics: null,
        deferredAnalytics: {
            ...state.deferredAnalytics,
            toDefer: state.deferredAnalytics.toDefer?.filter((entry)=>entry.aiSessionId !== sessionId),
            toDrop: sessionId
        }
    });
const $f5926f9d1caeb928$var$isAppendedToRemoteTransaction = (transaction)=>{
    let origin = transaction.getMeta('appendedTransaction');
    while(origin){
        if (origin.getMeta('isRemote')) return true;
        origin = origin.getMeta('appendedTransaction');
    }
    return false;
};
const $f5926f9d1caeb928$var$initialState = {
    currentSession: null,
    pendingAnalytics: null,
    lastUndoneSession: null,
    deferredAnalytics: {
        deferred: {},
        sessionState: 'notStarted'
    },
    commonAttributes: {}
};
const $f5926f9d1caeb928$export$d5f2dba636afec41 = (api, autoApplyAIChangesEnabled)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $17972e16fe06d756$export$ade9b71e7e80f74e),
        state: {
            init: ()=>$f5926f9d1caeb928$var$initialState,
            apply: (tr, pluginState, _old, newState)=>{
                let sessionStarted = false;
                const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(newState);
                sessionStarted = decorationPluginState?.sessionStarted ?? false;
                const { deferredAnalytics: deferredAnalytics } = pluginState;
                if (sessionStarted && deferredAnalytics.sessionState !== 'inProgress') return {
                    ...pluginState,
                    deferredAnalytics: {
                        ...deferredAnalytics,
                        sessionState: 'inProgress'
                    }
                };
                const sessionEnded = decorationPluginState?.sessionEnded ?? false;
                if (sessionEnded && deferredAnalytics.sessionState === 'inProgress') {
                    if (tr.getMeta((0, $9RRio.aiExperienceDecorationPluginKey))?.data?.type === 'finished') return {
                        ...pluginState,
                        deferredAnalytics: {
                            ...deferredAnalytics,
                            sessionState: 'justEnded'
                        }
                    };
                    else return {
                        ...pluginState,
                        deferredAnalytics: {
                            ...deferredAnalytics,
                            toCancel: decorationPluginState?.singleInstrumentationId
                        }
                    };
                }
                const deferredAnalyticsFromMeta = tr.getMeta($f5926f9d1caeb928$var$META_DEFERRED_ANALYTICS);
                if (deferredAnalyticsFromMeta) return {
                    ...pluginState,
                    deferredAnalytics: deferredAnalyticsFromMeta
                };
                const updatedCommonAttributes = tr.getMeta($f5926f9d1caeb928$export$249b63272434dfc7);
                if (updatedCommonAttributes) return {
                    ...pluginState,
                    commonAttributes: updatedCommonAttributes
                };
                if (tr.getMeta($f5926f9d1caeb928$var$META_FLUSH_ANALYTICS)) return {
                    ...pluginState,
                    pendingAnalytics: null
                };
                const isCollab = Boolean(tr.getMeta('isRemote'));
                const isFinalAI = Boolean(tr.getMeta('isAIFinalStreamingTransformation'));
                const appendedTr = tr.getMeta('appendedTransaction');
                const isIntermediateAI = Boolean(tr.getMeta('isAIStreamingTransformation') || appendedTr && appendedTr.getMeta('isAIStreamingTransformation') && !isFinalAI);
                const aiDecorationExperiencePluginState = api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState;
                const configItemKey = aiDecorationExperiencePluginState?.configItem?.key || '';
                const invokedFrom = aiDecorationExperiencePluginState?.lastTriggeredFrom;
                const experienceName = (0, $l2lIz.convertExperienceName)(configItemKey, invokedFrom);
                // ignore txns that don't change the doc
                if (!tr.docChanged || tr.getMeta('metricsPlugin$')) return pluginState;
                // start a new analytic session when a stream finalizes
                if (isFinalAI) {
                    const changed = (0, $721764a998f088d5$export$5185129806b81f0a)(tr.mapping.maps);
                    const mergedNewRanges = (0, $721764a998f088d5$export$4876cc3130d3f820)(changed.map((r)=>({
                            from: r.newStart,
                            to: r.newEnd
                        })).filter((r)=>r.from < r.to));
                    const { chars: chars, words: words } = (0, $721764a998f088d5$export$eed38d084e27127a)(newState.doc, mergedNewRanges);
                    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(newState);
                    const session = {
                        // If `singleInstrumentationId` exists then we've been invoked by a free gen session,
                        // otherwise we use `interactionSessionId` which comes from quick actions.
                        // If none of these are available we will need to query for the `empty` events
                        // Note we always need a valid ID
                        id: decorationPluginState?.singleInstrumentationId ?? decorationPluginState?.interactionSessionId ?? // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        `empty_${(0, $03RpJ.default)()}`,
                        startedAt: Math.round(performance.now()),
                        ranges: changed,
                        mergedNewRanges: mergedNewRanges,
                        baselineDoc: newState.doc,
                        aiOutputChars: chars,
                        aiOutputWords: words,
                        awaitingNextAction: true,
                        aiGroupId: decorationPluginState?.nextSessionId,
                        experienceName: experienceName
                    };
                    let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                    if (autoApplyAIChangesEnabled()) {
                        /**
             * If traceId is present in decoration plugin state, use it, otherwise use traceIds from common attributes.
             * Currently, traceId is set in decoration plugin state only for freegen.
             * For other prompts, it should be in common attributes.
             */ const traceIds = decorationPluginState?.traceId ? [
                            decorationPluginState.traceId
                        ] : pluginState.commonAttributes.traceIds;
                        const promptVersion = (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? decorationPluginState?.promptVersion : undefined;
                        const actionedPayload = (0, $26Q4g.createUnifiedAnalyticsPayload)({
                            ...pluginState.commonAttributes,
                            action: (0, $krYZG.ACTION).ACTIONED,
                            attributes: {
                                aiResultAction: 'accepted',
                                aiActionedType: 'automaticallyInserted'
                            },
                            interactionID: session.id,
                            experienceName: experienceName,
                            invokedFrom: invokedFrom,
                            aiGroupId: decorationPluginState?.nextSessionId,
                            isPayloadCreate: decorationPluginState?.isCreate,
                            traceIds: traceIds,
                            ...promptVersion ? {
                                promptVersion: promptVersion
                            } : {}
                        });
                        updatedDeferredAnalytics = {
                            ...pluginState.deferredAnalytics,
                            toDefer: $f5926f9d1caeb928$var$upsertDeferral(pluginState.deferredAnalytics.toDefer, {
                                aiSessionId: session.id,
                                payload: actionedPayload,
                                waitForSessionEnd: pluginState.deferredAnalytics.sessionState === 'inProgress'
                            })
                        };
                    }
                    return {
                        ...pluginState,
                        currentSession: session,
                        pendingAnalytics: null,
                        deferredAnalytics: updatedDeferredAnalytics
                    };
                }
                // Backend edits arrive as remote collab steps, so they need an explicit
                // watchmen session to participate in the existing survival metric.
                const agentRemoteEdit = tr.getMeta((0, $jdUP6.AGENT_REMOTE_EDIT_REVIEW_DATA));
                // Upstream BE-streaming and agent-type gates control whether this meta exists.
                // Only the requester's client records because every collaborator gets the steps.
                if (agentRemoteEdit?.isLocalUserRequester) {
                    const batchRanges = (0, $721764a998f088d5$export$cc054888e781965)(agentRemoteEdit.segments, newState.doc.content.size);
                    const activeSession = pluginState.currentSession;
                    // Fold only non-terminal batches while the previous accept is pending.
                    const now = performance.now();
                    // Backend edits are already applied. Do not reuse frontend common attributes,
                    // which may describe an unrelated earlier interaction.
                    const buildActionedPayload = (interactionID)=>(0, $26Q4g.createUnifiedAnalyticsPayload)({
                            action: (0, $krYZG.ACTION).ACTIONED,
                            attributes: {
                                aiResultAction: 'accepted',
                                aiActionedType: $f5926f9d1caeb928$var$BACKEND_UPDATE_ACTIONED_TYPE,
                                aiGroupId: undefined,
                                ...agentRemoteEdit.agentId ? {
                                    agentId: agentRemoteEdit.agentId
                                } : {}
                            },
                            interactionID: interactionID,
                            experienceName: $f5926f9d1caeb928$var$BACKEND_UPDATE_EXPERIENCE_NAME
                        });
                    if (activeSession?.isBackendPersisted && activeSession.awaitingNextAction && activeSession.backendEditComplete !== true && $f5926f9d1caeb928$var$acceptIsStillPending(activeSession)) {
                        const combinedRanges = (0, $721764a998f088d5$export$14966e72b8b1fc10)(activeSession.mergedNewRanges, batchRanges, (pos, bias)=>tr.mapping.map(pos, bias), newState.doc.content.size);
                        if (!combinedRanges.length) return $f5926f9d1caeb928$var$dropPendingBackendSession(pluginState, activeSession.id);
                        const combinedCounts = (0, $721764a998f088d5$export$eed38d084e27127a)(newState.doc, combinedRanges);
                        // Measure survival from the latest batch, matching frontend streaming.
                        return {
                            ...pluginState,
                            currentSession: {
                                ...activeSession,
                                acceptPendingUntil: now + $f5926f9d1caeb928$var$ACTIONED_EVENT_DELAY,
                                backendEditComplete: agentRemoteEdit.complete === true,
                                mergedNewRanges: combinedRanges,
                                baselineDoc: newState.doc,
                                aiOutputChars: combinedCounts.chars,
                                aiOutputWords: combinedCounts.words
                            },
                            deferredAnalytics: {
                                ...pluginState.deferredAnalytics,
                                toDefer: $f5926f9d1caeb928$var$upsertDeferral(pluginState.deferredAnalytics.toDefer, {
                                    aiSessionId: activeSession.id,
                                    isBackendPersisted: true,
                                    payload: buildActionedPayload(activeSession.id),
                                    waitForSessionEnd: false
                                })
                            }
                        };
                    }
                    // A standalone pure deletion leaves no output for the survival metric.
                    if (!batchRanges.length) return pluginState;
                    const { chars: chars, words: words } = (0, $721764a998f088d5$export$eed38d084e27127a)(newState.doc, batchRanges);
                    const session = {
                        // Replace with the originating interaction id once it reaches the step contract.
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        id: `${$f5926f9d1caeb928$var$BACKEND_UPDATE_SESSION_ID_PREFIX}${(0, $03RpJ.default)()}`,
                        startedAt: Math.round(now),
                        acceptPendingUntil: now + $f5926f9d1caeb928$var$ACTIONED_EVENT_DELAY,
                        backendEditComplete: agentRemoteEdit.complete === true,
                        // Remote steps are not in local history, so backend edits cannot be undone here.
                        ranges: [],
                        mergedNewRanges: batchRanges,
                        baselineDoc: newState.doc,
                        aiOutputChars: chars,
                        aiOutputWords: words,
                        awaitingNextAction: true,
                        aiGroupId: undefined,
                        experienceName: $f5926f9d1caeb928$var$BACKEND_UPDATE_EXPERIENCE_NAME,
                        isBackendPersisted: true
                    };
                    return {
                        ...pluginState,
                        currentSession: session,
                        pendingAnalytics: null,
                        deferredAnalytics: {
                            ...pluginState.deferredAnalytics,
                            toDefer: $f5926f9d1caeb928$var$upsertDeferral(pluginState.deferredAnalytics.toDefer, {
                                aiSessionId: session.id,
                                isBackendPersisted: true,
                                payload: buildActionedPayload(session.id),
                                // The FE session lifecycle never starts for this route, so waiting
                                // on it would defer the event forever.
                                waitForSessionEnd: false
                            })
                        }
                    };
                }
                // Editor normalization appended to remote steps is not a user reaction.
                if (pluginState.currentSession?.isBackendPersisted && $f5926f9d1caeb928$var$isAppendedToRemoteTransaction(tr)) {
                    const session = pluginState.currentSession;
                    const mappedRanges = (0, $721764a998f088d5$export$14966e72b8b1fc10)(session.mergedNewRanges, [], (pos, bias)=>tr.mapping.map(pos, bias), newState.doc.content.size);
                    if (!mappedRanges.length) return $f5926f9d1caeb928$var$dropPendingBackendSession(pluginState, session.id);
                    const counts = (0, $721764a998f088d5$export$eed38d084e27127a)(newState.doc, mappedRanges);
                    return {
                        ...pluginState,
                        currentSession: {
                            ...session,
                            aiOutputChars: counts.chars,
                            aiOutputWords: counts.words,
                            baselineDoc: newState.doc,
                            mergedNewRanges: mappedRanges
                        }
                    };
                }
                // observe and classify the very next local user action
                if (pluginState.currentSession && pluginState.currentSession.awaitingNextAction && !isCollab && tr.docChanged) {
                    const s = pluginState.currentSession;
                    const isRegen = isIntermediateAI;
                    if (isRegen) return (0, $721764a998f088d5$export$bfa42147068ddd92)(pluginState, s, 'regen', newState.doc);
                    const isUndo = (0, $721764a998f088d5$export$97c088e92f2198d4)(tr.mapping.maps, s.ranges);
                    if (isUndo) {
                        // Store the undone session for potential redo detection
                        const undoneSession = {
                            aiSessionId: s.id,
                            undoneRanges: s.ranges,
                            aiOutputChars: s.aiOutputChars,
                            aiOutputWords: s.aiOutputWords,
                            aiGroupId: s.aiGroupId,
                            experienceName: s.experienceName,
                            undoneAt: Math.round(performance.now())
                        };
                        let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                        if ($f5926f9d1caeb928$var$acceptIsStillPending(s)) updatedDeferredAnalytics = {
                            ...pluginState.deferredAnalytics,
                            toCancel: s.id,
                            toCancelExperienceName: s.experienceName,
                            toCancelIsBackendPersisted: s.isBackendPersisted
                        };
                        return {
                            ...(0, $721764a998f088d5$export$bfa42147068ddd92)(pluginState, s, 'undo', newState.doc, {
                                removedChars: s.aiOutputChars,
                                removedWords: s.aiOutputWords,
                                touched: s.mergedNewRanges.length
                            }),
                            deferredAnalytics: updatedDeferredAnalytics,
                            lastUndoneSession: undoneSession
                        };
                    }
                    if (!(0, $721764a998f088d5$export$f5fff894cf1d5ab)(tr.mapping.maps, s.mergedNewRanges)) return (0, $721764a998f088d5$export$bfa42147068ddd92)(pluginState, s, 'other', newState.doc);
                    const { deletedChars: deletedChars, deletedWords: deletedWords, touched: touched } = (0, $721764a998f088d5$export$e852621173d4215b)(tr.steps, tr.mapping.maps, s.baselineDoc, s.mergedNewRanges);
                    const isDelete = deletedChars > 0 || deletedWords > 0;
                    const overHalfDeleted = deletedChars >= s.aiOutputChars / 2;
                    let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                    if (overHalfDeleted && $f5926f9d1caeb928$var$acceptIsStillPending(s)) updatedDeferredAnalytics = {
                        ...pluginState.deferredAnalytics,
                        toCancel: s.id,
                        toCancelExperienceName: s.experienceName,
                        toCancelIsBackendPersisted: s.isBackendPersisted
                    };
                    return {
                        ...(0, $721764a998f088d5$export$bfa42147068ddd92)(pluginState, s, isDelete ? 'delete' : 'other', newState.doc, {
                            removedChars: deletedChars,
                            removedWords: deletedWords,
                            touched: touched
                        }, overHalfDeleted),
                        deferredAnalytics: updatedDeferredAnalytics
                    };
                }
                // Check for redo of previously undone AI content
                if (pluginState.lastUndoneSession && !isCollab && tr.docChanged && !isIntermediateAI) {
                    const undoneSession = pluginState.lastUndoneSession;
                    const now = Math.round(performance.now());
                    const timeSinceUndo = now - undoneSession.undoneAt;
                    // Check if this is a redo within a reasonable time window (2000ms like undo)
                    if (timeSinceUndo <= 2000) {
                        const isRedo = (0, $721764a998f088d5$export$476c745650a7176c)(tr.mapping.maps, undoneSession.undoneRanges);
                        if (isRedo) {
                            // Create a mock session for analytics purposes
                            const mockSession = {
                                id: undoneSession.aiSessionId,
                                startedAt: undoneSession.undoneAt,
                                ranges: undoneSession.undoneRanges,
                                mergedNewRanges: undoneSession.undoneRanges.map((r)=>({
                                        from: r.newStart,
                                        to: r.newEnd
                                    })),
                                baselineDoc: newState.doc,
                                aiOutputChars: undoneSession.aiOutputChars,
                                aiOutputWords: undoneSession.aiOutputWords,
                                awaitingNextAction: false,
                                aiGroupId: undoneSession.aiGroupId,
                                experienceName: undoneSession.experienceName
                            };
                            let updatedDeferredAnalytics = pluginState.deferredAnalytics;
                            if (autoApplyAIChangesEnabled()) {
                                /**
                 * If traceId is present in decoration plugin state, use it, otherwise use traceIds from common attributes.
                 * Currently, traceId is set in decoration plugin state only for freegen.
                 * For other prompts, it should be in common attributes.
                 */ const traceIds = decorationPluginState?.traceId ? [
                                    decorationPluginState.traceId
                                ] : pluginState.commonAttributes.traceIds;
                                const promptVersion = (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? decorationPluginState?.promptVersion : undefined;
                                const actionedPayload = (0, $26Q4g.createUnifiedAnalyticsPayload)({
                                    ...pluginState.commonAttributes,
                                    action: (0, $krYZG.ACTION).ACTIONED,
                                    attributes: {
                                        aiResultAction: 'accepted',
                                        aiActionedType: 'automaticallyInserted',
                                        wasRedone: true
                                    },
                                    interactionID: undoneSession.aiSessionId,
                                    experienceName: undoneSession.experienceName,
                                    invokedFrom: invokedFrom,
                                    aiGroupId: undoneSession.aiGroupId,
                                    traceIds: traceIds,
                                    ...promptVersion ? {
                                        promptVersion: promptVersion
                                    } : {}
                                });
                                updatedDeferredAnalytics = {
                                    ...pluginState.deferredAnalytics,
                                    toDefer: $f5926f9d1caeb928$var$upsertDeferral(pluginState.deferredAnalytics.toDefer, {
                                        aiSessionId: undoneSession.aiSessionId,
                                        payload: actionedPayload,
                                        waitForSessionEnd: pluginState.deferredAnalytics.sessionState === 'inProgress'
                                    })
                                };
                            }
                            return {
                                ...(0, $721764a998f088d5$export$bfa42147068ddd92)(pluginState, mockSession, 'redo', newState.doc, {
                                    removedChars: undoneSession.aiOutputChars,
                                    removedWords: undoneSession.aiOutputWords,
                                    touched: undoneSession.undoneRanges.length
                                }),
                                lastUndoneSession: null,
                                // Clear after redo
                                deferredAnalytics: updatedDeferredAnalytics
                            };
                        }
                    } else // Clear expired undone session
                    return {
                        ...pluginState,
                        lastUndoneSession: null
                    };
                }
                return pluginState;
            }
        },
        appendTransaction: (_transactions, _oldState, newState)=>{
            const ps = (0, $17972e16fe06d756$export$ade9b71e7e80f74e).getState(newState);
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(newState);
            const pluginState = ps ?? $f5926f9d1caeb928$var$initialState;
            const deferredAnalytics = pluginState.deferredAnalytics;
            const { toDefer: toDefer, toCancel: toCancel, toDrop: toDrop, sessionState: sessionState } = deferredAnalytics;
            if (toDrop) {
                window.clearTimeout(deferredAnalytics.deferred[toDrop]);
                return newState.tr.setMeta($f5926f9d1caeb928$var$META_DEFERRED_ANALYTICS, {
                    ...deferredAnalytics,
                    deferred: (0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(deferredAnalytics.deferred, [
                        toDrop
                    ]),
                    toDrop: undefined
                });
            }
            const isReady = (entry)=>!entry.waitForSessionEnd || sessionState === 'justEnded';
            const readyDeferrals = (toDefer ?? []).filter(isReady);
            if (readyDeferrals.length) {
                const stillWaiting = (toDefer ?? []).filter((entry)=>!isReady(entry));
                const scheduled = {};
                for (const entry of readyDeferrals){
                    // Re-arming a backend session replaces its previous timer.
                    const previousTimeoutId = deferredAnalytics?.deferred?.[entry.aiSessionId];
                    if (previousTimeoutId !== undefined) window.clearTimeout(previousTimeoutId);
                    scheduled[entry.aiSessionId] = window.setTimeout(()=>api?.analytics?.actions.fireAnalyticsEvent(entry.payload), $f5926f9d1caeb928$var$ACTIONED_EVENT_DELAY);
                }
                const updatedDeferredAnalytics = {
                    ...deferredAnalytics,
                    deferred: {
                        ...deferredAnalytics?.deferred,
                        ...scheduled
                    },
                    toDefer: stillWaiting.length ? stillWaiting : undefined,
                    // Backend deferrals do not participate in the frontend session lifecycle.
                    sessionState: readyDeferrals.some((entry)=>entry.waitForSessionEnd) ? 'notStarted' : sessionState
                };
                return newState.tr.setMeta($f5926f9d1caeb928$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
            }
            if (toCancel) {
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_discarded_unified_analytic_events')) {
                    // Backend discards must not inherit attributes from an earlier frontend session.
                    const discardedPayload = deferredAnalytics.toCancelIsBackendPersisted ? (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        action: (0, $krYZG.ACTION).DISCARDED,
                        interactionID: toCancel,
                        experienceName: deferredAnalytics.toCancelExperienceName,
                        aiGroupId: undefined
                    }) : (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        ...pluginState.commonAttributes,
                        action: (0, $krYZG.ACTION).DISCARDED,
                        interactionID: toCancel,
                        experienceName: pluginState.commonAttributes.experienceName ?? deferredAnalytics.toCancelExperienceName,
                        invokedFrom: pluginState.commonAttributes.invokedFrom,
                        aiGroupId: pluginState.commonAttributes.aiGroupId,
                        traceIds: pluginState.commonAttributes.traceIds,
                        ...pluginState.commonAttributes.promptVersion && (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? {
                            promptVersion: pluginState.commonAttributes.promptVersion
                        } : {}
                    });
                    api?.analytics?.actions.fireAnalyticsEvent(discardedPayload);
                }
                window.clearTimeout(deferredAnalytics.deferred[toCancel]);
                const updatedDeferredAnalytics = {
                    ...deferredAnalytics,
                    deferred: (0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(deferredAnalytics.deferred, [
                        toCancel
                    ]),
                    toCancel: undefined,
                    toCancelExperienceName: undefined,
                    toCancelIsBackendPersisted: undefined
                };
                return newState.tr.setMeta($f5926f9d1caeb928$var$META_DEFERRED_ANALYTICS, updatedDeferredAnalytics);
            }
            if (!ps?.pendingAnalytics) return null;
            const { aiSessionId: aiSessionId, nextActionType: nextActionType, aiOutputChars: aiOutputChars, aiOutputWords: aiOutputWords, nextActionRemovedAiChars: nextActionRemovedAiChars, nextActionRemovedAiWords: nextActionRemovedAiWords, nextActionTouchedAiRanges: nextActionTouchedAiRanges, nextActionLatencyMs: nextActionLatencyMs, aiGroupId: aiGroupId, experienceName: experienceName } = ps.pendingAnalytics;
            const tr = newState.tr.setMeta($f5926f9d1caeb928$var$META_FLUSH_ANALYTICS, true);
            return (0, $hZdqw.addAnalytics)({
                editorState: newState,
                tr: tr,
                payload: {
                    action: 'updated',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiImmediateReaction',
                    attributes: {
                        aiSessionId: aiSessionId,
                        aiGroupId: aiGroupId,
                        nextActionType: nextActionType,
                        aiOutputChars: aiOutputChars,
                        aiOutputWords: aiOutputWords,
                        nextActionRemovedAiChars: nextActionRemovedAiChars,
                        nextActionRemovedAiWords: nextActionRemovedAiWords,
                        nextActionTouchedAiRanges: nextActionTouchedAiRanges,
                        nextActionLatencyMs: nextActionLatencyMs,
                        traceId: decorationPluginState?.traceId,
                        promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? decorationPluginState?.promptVersion : undefined,
                        experienceName: experienceName
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                },
                addToHistory: false
            });
        }
    });
};






var $1UwGp = parcelRequire("1UwGp");







/**
 * @generated SignedSource<<7893131b80ddcfe667c9f81cd23fc7bc>>
 * @relayHash a5874f23bd0d6e4283017003dab0bf6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 87a27a02c8ee4f0ea5900bde73042ea1966cedfb6f25f099fbdf777650e848b0
const $959d4421fc94bb90$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "accountId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ScalarField",
        "name": "picture"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "TelepointerAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "TelepointerAvatarQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "87a27a02c8ee4f0ea5900bde73042ea1966cedfb6f25f099fbdf777650e848b0",
            "metadata": {},
            "name": "TelepointerAvatarQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$959d4421fc94bb90$var$node.hash = "8bd664e0c056a333fbcc592e1be2f7b5";
var $959d4421fc94bb90$export$2e2bcd8739ae039 = $959d4421fc94bb90$var$node;






var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");


var $eFbDl = parcelRequire("eFbDl");


var $jC4nA = parcelRequire("jC4nA");


var $j78zM = parcelRequire("j78zM");


var $6gGPb = parcelRequire("6gGPb");


var $as9lu = parcelRequire("as9lu");

/** Rovo presents under its own brand name, so this label is deliberately not translated. */ const $4ca6eb8d3f45d47e$var$ROVO_LABEL = 'Rovo';
const $4ca6eb8d3f45d47e$var$messages = (0, $kSwu1.defineMessages)({
    externalAgentFallback: {
        id: "editor-plugin-ai.TelepointerAvatar.TelepointerAvatar.externalAgentFallback",
        defaultMessage: "External agent"
    }
});
/**
 * The telepointer badge every state shares: a coloured pill holding a leading icon and
 * optional text. The pill's colour comes from the cursor-line CSS variable the plugin
 * sets, so badge, line and content highlight always share one hue.
 *
 * `isNeutral` switches the text to the default colour for the grey fallback / third-party
 * pill, which is too light to carry inverse text.
 */ const $4ca6eb8d3f45d47e$var$TelepointerBadge = ({ children: children, isNeutral: isNeutral, iconOnly: iconOnly, testId: testId })=>{
    const className = [
        'ai-in-editor-telepointer-badge',
        isNeutral && 'ai-in-editor-telepointer-badge-neutral',
        iconOnly && 'ai-in-editor-telepointer-badge-icon-only'
    ].filter(Boolean).join(' ');
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- The telepointer is imperative ProseMirror DOM styled by global CSS in GlobalWrapper; the badge hooks into that same styling.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: className,
        "data-testid": testId
    }, children));
};
/**
 * The fixed leading slot every badge shares, so the icon or avatar sits at the same size and
 * position across Rovo, fallback, first- and third-party. A first party simply omits the label.
 */ const $4ca6eb8d3f45d47e$var$TelepointerLeading = ({ children: children, isAvatar: isAvatar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- The telepointer is imperative ProseMirror DOM styled by global CSS in GlobalWrapper; the leading slot hooks into that same styling.
        className: isAvatar ? 'ai-in-editor-telepointer-badge-leading ai-in-editor-telepointer-badge-leading-avatar' : 'ai-in-editor-telepointer-badge-leading'
    }, children);
/** The generated / out-of-the-box illustration, used when no account picture is fetched. */ const $4ca6eb8d3f45d47e$var$GeneratedAgentAvatar = ({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId })=>// Decorative: the badge already labels the agent (name text or the accessible fallback
    // label), so the avatar carries no own label to avoid a redundant announcement.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId,
        showBorder: false,
        size: "xsmall"
    });
/** Parses the account id the picture query needs from the identity ARI agentInfo carries. */ const $4ca6eb8d3f45d47e$var$parseIdentityAccountId = (value)=>{
    if (!value) return undefined;
    try {
        return (0, $as9lu.IdentityUserAri).parse(value).userId;
    } catch  {
        return undefined;
    }
};
/**
 * Fetches the agent's account picture and renders it as the avatar. Falls back to the generated
 * illustration when the account has no picture. Mirrors the chat prompt input's `AgentInputHat`,
 * and reuses the account-picture mechanism the original editor telepointer proved works inside
 * the ProseMirror portal.
 */ const $4ca6eb8d3f45d47e$var$FetchedAgentAvatar = ({ accountId: accountId, agentName: agentName, fallback: fallback })=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $959d4421fc94bb90$export$2e2bcd8739ae039), {
        accountId: accountId
    }, {
        fetchPolicy: 'store-or-network'
    });
    const picture = data.user?.picture?.trim();
    if (!picture) return fallback;
    const name = data.user?.name?.trim() || agentName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        imageUrl: picture,
        name: name,
        label: name,
        showBorder: false,
        size: "xsmall"
    });
};
/**
 * The agent's avatar: the real account picture when one can be fetched, otherwise the generated
 * illustration. A Suspense skeleton bridges the fetch, and an error boundary keeps a failed or
 * unavailable fetch from ever breaking the telepointer — it just shows the generated illustration.
 */ const $4ca6eb8d3f45d47e$var$TelepointerAgentAvatar = ({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, agentNamedId: agentNamedId })=>{
    const generated = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$GeneratedAgentAvatar, {
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        agentNamedId: agentNamedId
    });
    const accountId = $4ca6eb8d3f45d47e$var$parseIdentityAccountId(agentIdentityAccountId);
    if (!accountId) return generated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: generated
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eFbDl.default), {
            appearance: "hexagon",
            size: "xsmall"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$FetchedAgentAvatar, {
        accountId: accountId,
        agentName: agentName,
        fallback: generated
    })));
};
/** Neutral badge shown when none of the agent's identifiers are available. */ const $4ca6eb8d3f45d47e$var$AgentFallbackBadge = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerBadge, {
        isNeutral: true,
        testId: "ai-in-editor-telepointer-fallback-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerLeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        color: "currentColor",
        label: ""
    })), label);
const $4ca6eb8d3f45d47e$export$5d20881141a253fa = ({ agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, agentNamedId: agentNamedId, kind: kind })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (kind === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerBadge, {
        testId: "ai-in-editor-telepointer-rovo-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerLeading, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j78zM.RovoHexIcon), {
        label: "",
        size: "xxsmall"
    })), $4ca6eb8d3f45d47e$var$ROVO_LABEL);
    // Resolving the agent is the default, so a caller that supplies identifiers without a
    // treatment still gets an avatar. Any one identifier is enough, which leaves the neutral
    // badge for a genuine absence of all of them. A third party keeps its name and the neutral
    // grey pill; a first party shows the avatar alone on the id-derived accent pill.
    if (kind !== 'fallback' && (agentNamedId || agentIdentityAccountId || agentId)) {
        const isThirdParty = kind === 'agent-third-party';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerBadge, {
            isNeutral: isThirdParty,
            iconOnly: !isThirdParty,
            testId: "ai-in-editor-telepointer-agent-avatar"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerLeading, {
            isAvatar: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$TelepointerAgentAvatar, {
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            agentName: agentName,
            agentNamedId: agentNamedId
        })), isThirdParty ? agentName : null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ca6eb8d3f45d47e$var$AgentFallbackBadge, {
        label: formatMessage($4ca6eb8d3f45d47e$var$messages.externalAgentFallback)
    });
};








const $710cefc8d9f7e5d9$export$1b782d5498130429 = ({ formatMessage: formatMessage, streamingTelepointerIdentity: streamingTelepointerIdentity = 'rovo' })=>{
    const defaultLabel = formatMessage(streamingTelepointerIdentity === 'planner' ? (0, $7ZL6d.aiMessages).aiPlannerTelepointer : (0, $7ZL6d.aiMessages).aiRovoTelepointer);
    return ({ agentName: agentName, isAgentMentionEnabled: isAgentMentionEnabled })=>{
        return isAgentMentionEnabled && agentName ? agentName : defaultLabel;
    };
};





const $0ca5a13529310b54$export$2727940767f36f55 = 'inEditorAITelepointerAvatar';
const $0ca5a13529310b54$export$b3d3cfdedcf26988 = (label)=>{
    const element = document.createElement('span');
    element.setAttribute('data-testid', 'ai-in-editor-telepointer-widget');
    element.className = 'ai-in-editor-telepointer';
    const labelElement = document.createElement('span');
    labelElement.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-label');
    labelElement.className = 'ai-in-editor-telepointer-label';
    labelElement.append(label);
    element.appendChild(labelElement);
    const avatarContainer = document.createElement('span');
    avatarContainer.setAttribute('data-testid', 'ai-in-editor-telepointer-widget-avatar');
    avatarContainer.className = 'ai-in-editor-telepointer-avatar';
    // Hidden by default; shown when AgentAvatar is rendered into it.
    // To show: set style.display = '' (removes inline style, falls back to browser default: 'inline' for <span>)
    avatarContainer.style.display = 'none';
    element.appendChild(avatarContainer);
    return {
        element: element,
        labelElement: labelElement,
        avatarContainer: avatarContainer
    };
};
const $0ca5a13529310b54$export$3f4dbbc6f36d65d4 = (position, element)=>{
    return (0, $8nvEM.Decoration).widget(position, element, {
        side: 0,
        key: 'inEditorAIContentDecoration'
    });
};








const $f7b3f8185a61bfdf$export$bca1edcc67dc7d = new (0, $kCECX.PluginKey)('agentEditChrome');


const $09b9b3d4d1791a71$export$979c77d1226b8abc = (data)=>({ tr: tr })=>tr.setMeta((0, $1UwGp.AGENT_EDIT_CHROME_DATA), data);
const $09b9b3d4d1791a71$export$acd25c3c5225d7cf = (revision)=>({ tr: tr })=>tr.setMeta((0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d), {
            revision: revision,
            type: 'REMOVE'
        });


const $0dcbddb4188b36c8$export$138a61db99ffcc5d = (state, mapping)=>{
    if (!state.ranges.length) return state;
    return {
        ...state,
        ranges: state.ranges.map(({ from: from, to: to })=>({
                from: mapping.map(from, -1),
                to: mapping.map(to, 1)
            })).filter(({ from: from, to: to })=>from < to)
    };
};



const $acff0f75571792c0$var$clampToDoc = (doc, pos)=>Math.min(Math.max(pos, 0), doc.content.size);
const $acff0f75571792c0$var$getBlockContentRange = (doc, blockIndex)=>{
    let offset = 0;
    for(let index = 0; index < blockIndex; index++)offset += doc.child(index).nodeSize;
    const block = doc.child(blockIndex);
    return {
        from: offset + 1,
        to: offset + block.nodeSize - 1
    };
};
const $acff0f75571792c0$export$817de087a4513986 = (doc, ranges)=>{
    if (!doc.childCount) return [];
    const indexedRanges = ranges.map(({ from: from, to: to })=>{
        const start = $acff0f75571792c0$var$clampToDoc(doc, Math.min(from, to));
        const end = $acff0f75571792c0$var$clampToDoc(doc, Math.max(from, to));
        // `to` is exclusive. Probe one position to its left so a range ending exactly at the
        // next block boundary does not accidentally include that next block.
        const endProbe = end > start ? end - 1 : end;
        const startBlockIndex = Math.min(doc.resolve(start).index(0), doc.childCount - 1);
        const endBlockIndex = Math.min(doc.resolve(endProbe).index(0), doc.childCount - 1);
        if (startBlockIndex < 0 || endBlockIndex < 0) return null;
        return {
            from: start,
            to: end,
            startBlockIndex: Math.min(startBlockIndex, endBlockIndex),
            endBlockIndex: Math.max(startBlockIndex, endBlockIndex)
        };
    }).filter((range)=>range !== null).sort((a, b)=>a.startBlockIndex - b.startBlockIndex || a.endBlockIndex - b.endBlockIndex);
    const groups = [];
    indexedRanges.forEach(({ startBlockIndex: startBlockIndex, endBlockIndex: endBlockIndex })=>{
        const current = groups[groups.length - 1];
        if (current && startBlockIndex <= current.endBlockIndex + 1) {
            current.endBlockIndex = Math.max(current.endBlockIndex, endBlockIndex);
            return;
        }
        groups.push({
            startBlockIndex: startBlockIndex,
            endBlockIndex: endBlockIndex
        });
    });
    return groups.map(({ startBlockIndex: startBlockIndex, endBlockIndex: endBlockIndex })=>({
            from: $acff0f75571792c0$var$getBlockContentRange(doc, startBlockIndex).from,
            to: $acff0f75571792c0$var$getBlockContentRange(doc, endBlockIndex).to
        })).filter(({ from: from, to: to })=>to > from);
};


const $3787077a157a33bb$export$a1593a6061bdf824 = {
    ranges: [],
    revision: 0
};
const $3787077a157a33bb$export$6c4a95e0e345b3a6 = (state, action)=>{
    switch(action.type){
        case 'SHOW':
            return {
                ...action.data,
                revision: state.revision + 1
            };
        case 'REMOVE':
            return action.revision === state.revision ? {
                ranges: [],
                revision: state.revision
            } : state;
    }
};


const $d438cc29b9191819$var$LIST_PARENT_TYPES = new Set([
    'bulletList',
    'orderedList',
    'decisionList',
    'taskList'
]);
/** Axe `list` requires every list child to be a list item. A telepointer widget on the list itself would sit beside those items, so place it inside the last item. */ function $d438cc29b9191819$var$telepointerWidgetPos(doc, to) {
    const pos = Math.max(0, Math.min(to, doc.content.size));
    try {
        const $pos = doc.resolve(pos);
        if ($d438cc29b9191819$var$LIST_PARENT_TYPES.has($pos.parent.type.name)) return Math.max($pos.start(), pos - 1);
    } catch  {
        return pos;
    }
    return pos;
}
const $d438cc29b9191819$export$39ba843d91f15fab = ({ api: api, getIntl: getIntl, portalProviderAPI: portalProviderAPI, streamingTelepointerIdentity: streamingTelepointerIdentity })=>{
    const getTelepointerLabel = (0, $710cefc8d9f7e5d9$export$1b782d5498130429)({
        formatMessage: getIntl().formatMessage,
        streamingTelepointerIdentity: streamingTelepointerIdentity
    });
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d),
        state: {
            init: ()=>(0, $3787077a157a33bb$export$a1593a6061bdf824),
            apply: (tr, pluginState)=>{
                // AI writes (stream update, restore, commit) replace a span that often
                // covers earlier tool-call nodes. Mapping through them collapses the
                // union onto the node being written — a merged flash, then one node.
                const isAiWrite = tr.getMeta('isAIRestoreTransaction') || tr.getMeta('isAIStreamingTransformation');
                const mappedState = tr.docChanged && !isAiWrite ? (0, $0dcbddb4188b36c8$export$138a61db99ffcc5d)(pluginState, tr.mapping) : pluginState;
                const data = tr.getMeta((0, $1UwGp.AGENT_EDIT_CHROME_DATA));
                // Accumulate sequential tool-call SHOWs. A later producer that only
                // knows the current node must not wipe already-highlighted ones.
                const action = data ? {
                    data: {
                        ...data,
                        ranges: (0, $acff0f75571792c0$export$817de087a4513986)(tr.doc, [
                            ...mappedState.ranges,
                            ...data.ranges
                        ])
                    },
                    type: 'SHOW'
                } : tr.getMeta((0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d));
                return action ? (0, $3787077a157a33bb$export$6c4a95e0e345b3a6)(mappedState, action) : mappedState;
            }
        },
        props: {
            decorations: (state)=>{
                const pluginState = (0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d).getState(state);
                const autoDismissAfterMs = pluginState?.autoDismissAfterMs ?? (0, $1UwGp.AGENT_EDIT_CHROME_DEFAULT_AUTO_DISMISS_AFTER_MS);
                if (!pluginState?.ranges.length || autoDismissAfterMs <= 0) return (0, $8nvEM.DecorationSet).empty;
                const highlightStyle = [
                    pluginState.highlightBackgroundColor && `--agent-edit-chrome-background-color: ${pluginState.highlightBackgroundColor}`,
                    pluginState.highlightBorderColor && `--agent-edit-chrome-border-color: ${pluginState.highlightBorderColor}`
                ].filter(Boolean).join('; ');
                const decorations = pluginState.ranges.map(({ from: from, to: to })=>(0, $8nvEM.Decoration).inline(from, to, {
                        class: 'ai-in-editor-ai-content',
                        'data-testid': 'agent-edit-chrome-highlight',
                        ...highlightStyle ? {
                            style: highlightStyle
                        } : {}
                    }));
                if (pluginState.telepointerEnabled ?? (0, $1UwGp.AGENT_EDIT_CHROME_DEFAULT_TELEPOINTER_ENABLED)) {
                    const telepointerLabel = pluginState.telepointerLabel ?? getTelepointerLabel({
                        isAgentMentionEnabled: false
                    });
                    pluginState.ranges.forEach(({ to: to }, index)=>{
                        const { avatarContainer: avatarContainer, element: element, labelElement: labelElement } = (0, $0ca5a13529310b54$export$b3d3cfdedcf26988)(telepointerLabel);
                        if (pluginState.agentIdentityAccountId) {
                            const portalKey = `agentEditChromeTelepointerAvatar-${pluginState.revision}-${index}`;
                            labelElement.style.display = 'none';
                            avatarContainer.style.display = '';
                            avatarContainer.dataset.agentEditChromeAvatarPortalKey = portalKey;
                        }
                        decorations.push((0, $8nvEM.Decoration).widget($d438cc29b9191819$var$telepointerWidgetPos(state.doc, to), element, {
                            key: `agent-edit-chrome-${pluginState.revision}-${index}`,
                            side: 0
                        }));
                    });
                }
                return (0, $8nvEM.DecorationSet).create(state.doc, decorations);
            }
        },
        view: ()=>{
            let timeout;
            let revision = 0;
            const renderedAgentIdentityByPortalKey = new Map();
            const removeStaleAvatarPortals = (activePortalKeys = new Set())=>{
                renderedAgentIdentityByPortalKey.forEach((_identity, portalKey)=>{
                    if (!activePortalKeys.has(portalKey)) {
                        portalProviderAPI?.remove(portalKey);
                        renderedAgentIdentityByPortalKey.delete(portalKey);
                    }
                });
            };
            return {
                update: (view)=>{
                    const pluginState = (0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d).getState(view.state);
                    const agentIdentityAccountId = pluginState?.agentIdentityAccountId;
                    // Decorations create the portal containers; synchronize their React avatars after
                    // those containers enter the editor DOM.
                    const activePortalKeys = new Set();
                    if (agentIdentityAccountId && portalProviderAPI) view.dom.querySelectorAll('[data-agent-edit-chrome-avatar-portal-key]').forEach((container)=>{
                        const portalKey = container.dataset.agentEditChromeAvatarPortalKey;
                        if (!portalKey) return;
                        activePortalKeys.add(portalKey);
                        if (renderedAgentIdentityByPortalKey.get(portalKey) !== agentIdentityAccountId) {
                            portalProviderAPI.render(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca6eb8d3f45d47e$export$5d20881141a253fa), {
                                    agentIdentityAccountId: agentIdentityAccountId
                                }), container, portalKey);
                            renderedAgentIdentityByPortalKey.set(portalKey, agentIdentityAccountId);
                        }
                    });
                    removeStaleAvatarPortals(activePortalKeys);
                    // Keep the highlight up across sequential tool calls in the same turn.
                    // Auto-dismiss after a single apply would clear it before the next
                    // commit restamps later nodes.
                    const sessionStatus = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state)?.status;
                    const holdDismiss = sessionStatus === 'streaming' || sessionStatus === 'complete';
                    if (holdDismiss) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = undefined;
                        }
                        if (pluginState) revision = pluginState.revision;
                        return;
                    }
                    // Session ended: dismiss the current treatment after the configured delay.
                    if (!pluginState?.ranges.length) return;
                    if (pluginState.revision === revision && timeout) return;
                    revision = pluginState.revision;
                    if (timeout) clearTimeout(timeout);
                    const scheduledRevision = pluginState.revision;
                    const autoDismissAfterMs = pluginState.autoDismissAfterMs ?? (0, $1UwGp.AGENT_EDIT_CHROME_DEFAULT_AUTO_DISMISS_AFTER_MS);
                    timeout = setTimeout(()=>{
                        api?.core?.actions.execute((0, $09b9b3d4d1791a71$export$acd25c3c5225d7cf)(scheduledRevision));
                    }, Math.max(0, autoDismissAfterMs));
                },
                destroy: ()=>{
                    if (timeout) clearTimeout(timeout);
                    removeStaleAvatarPortals();
                }
            };
        }
    });
};



var $iO5TS = parcelRequire("iO5TS");


var $44cyU = parcelRequire("44cyU");







function $75dc73a214c6bdae$export$c596c00169e22422({ api: api, experienceName: experienceName }) {
    api?.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).DISPLAYED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_QUICK_PROMPT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            experienceName: experienceName
        }
    });
}
function $75dc73a214c6bdae$export$7cad2a9b6222530d({ api: api, experienceName: experienceName, method: method }) {
    api?.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).TRIGGERED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_QUICK_PROMPT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            experienceName: experienceName,
            method: method
        }
    });
}
function $75dc73a214c6bdae$export$48d6055e922d98b1({ api: api, experienceName: experienceName, errorMessage: errorMessage, statusCode: statusCode }) {
    api?.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).API_ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_QUICK_PROMPT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            experienceName: experienceName,
            ...statusCode !== undefined ? {
                statusCode: statusCode
            } : {},
            ...errorMessage !== undefined ? {
                errorMessage: errorMessage
            } : {}
        }
    });
}
function $75dc73a214c6bdae$export$6106882af1d3d655({ api: api, ccSmartsErrorType: ccSmartsErrorType, ccSmartsOk: ccSmartsOk, ccSmartsShouldImprove: ccSmartsShouldImprove, ccSmartsStatus: ccSmartsStatus, convoAiErrorType: convoAiErrorType, convoAiOk: convoAiOk, convoAiShouldImprove: convoAiShouldImprove, convoAiStatus: convoAiStatus, experienceName: experienceName }) {
    api?.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).DIVERGED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_QUICK_PROMPT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            source: 'shouldImproveWritingShadowComparison',
            experienceName: experienceName,
            convoAiOk: convoAiOk,
            ccSmartsOk: ccSmartsOk,
            convoAiStatus: convoAiStatus,
            ccSmartsStatus: ccSmartsStatus,
            convoAiErrorType: convoAiErrorType,
            ccSmartsErrorType: ccSmartsErrorType,
            convoAiShouldImprove: convoAiShouldImprove,
            ccSmartsShouldImprove: ccSmartsShouldImprove
        }
    });
}
function $75dc73a214c6bdae$export$19c5aad04a0b6b57({ api: api, experienceName: experienceName, method: method }) {
    api?.analytics?.actions?.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).DISMISSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_QUICK_PROMPT,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            experienceName: experienceName,
            method: method
        }
    });
}








const $0d7938c2995b09c7$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('aiQuickPromptPlugin');
const $0d7938c2995b09c7$var$MAX_PREVIOUS_SHOWN_TEXTS = 1;
const $0d7938c2995b09c7$export$d4c72bab9d6cc13a = {
    isPromptVisible: false,
    eligibleRange: undefined,
    previousShownTexts: []
};
function $0d7938c2995b09c7$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 'SHOW_PROMPT':
            {
                if (!action.range) return state;
                let previousShownTexts = !!action.shownText?.trim() ? [
                    action.shownText.trim(),
                    ...state.previousShownTexts
                ] : state.previousShownTexts;
                if (previousShownTexts.length > $0d7938c2995b09c7$var$MAX_PREVIOUS_SHOWN_TEXTS) previousShownTexts = previousShownTexts.slice(0, $0d7938c2995b09c7$var$MAX_PREVIOUS_SHOWN_TEXTS);
                return {
                    ...state,
                    isPromptVisible: true,
                    eligibleRange: action.range,
                    previousShownTexts: previousShownTexts
                };
            }
        case 'HIDE_PROMPT':
            if (!state.isPromptVisible && state.eligibleRange === undefined) return state;
            return {
                ...state,
                isPromptVisible: false,
                eligibleRange: undefined
            };
        default:
            return state;
    }
}
const $0d7938c2995b09c7$var$dest = (0, $cI8RZ.pluginFactory)($0d7938c2995b09c7$export$18d4026d1ea86bb1, $0d7938c2995b09c7$export$1650419e431d3ba3, {
    mapping: (tr, pluginState)=>{
        let newState = pluginState;
        if (newState.eligibleRange) {
            const newFrom = tr.mapping.map(newState.eligibleRange.from);
            const newTo = tr.mapping.map(newState.eligibleRange.to);
            if (newFrom !== newState.eligibleRange.from || newTo !== newState.eligibleRange.to) newState = {
                ...newState,
                eligibleRange: {
                    from: newFrom,
                    to: newTo
                }
            };
        }
        return newState;
    },
    // Hide the prompt when the selection changes
    // idleDetector will be stopped in the view update callback
    onSelectionChanged: (_tr, pluginState, editorState)=>{
        let newState = pluginState;
        if (newState.isPromptVisible && newState.eligibleRange) {
            const { from: from, to: to } = newState.eligibleRange;
            const sel = editorState.selection;
            if (sel.from !== from || sel.to !== to) newState = {
                ...newState,
                isPromptVisible: false,
                eligibleRange: undefined
            };
        }
        return newState;
    }
});
const $0d7938c2995b09c7$export$656c7661095efe2e = $0d7938c2995b09c7$var$dest.createPluginState;
const $0d7938c2995b09c7$export$8d4021544bdece00 = $0d7938c2995b09c7$var$dest.createCommand;
const $0d7938c2995b09c7$export$f05434c51e3762e = $0d7938c2995b09c7$var$dest.getPluginState;
const $0d7938c2995b09c7$export$20ce7c88b8f4552b = ({ range: range, shownText: shownText })=>$0d7938c2995b09c7$export$8d4021544bdece00(()=>{
        return {
            type: 'SHOW_PROMPT',
            range: range,
            shownText: shownText
        };
    });
const $0d7938c2995b09c7$export$aac38b1a00f6dfb4 = ()=>$0d7938c2995b09c7$export$8d4021544bdece00({
        type: 'HIDE_PROMPT'
    });


function $f303e3c28f40d0ac$export$e9cb660ee1921103({ aiGlobalOptIn: aiGlobalOptIn, api: api, configItem: configItem, standDownManager: standDownManager }) {
    const keymapObj = {};
    // --- Tab handler ---
    keymapObj['Tab'] = (state, dispatch, view)=>{
        const pluginState = (0, $0d7938c2995b09c7$export$18d4026d1ea86bb1).getState(state);
        if (!pluginState?.isPromptVisible || !pluginState.eligibleRange) return false; // Pass through to next plugin
        if (dispatch && view) {
            const range = pluginState.eligibleRange;
            // - Record this node as triggered so the prompt won't show again
            const $from = state.doc.resolve(range.from);
            const parentNode = $from.node($from.depth);
            const nodeId = parentNode.attrs.localId ? String(parentNode.attrs.localId) : `pos:${range.from}`;
            standDownManager.recordTrigger(nodeId);
            // - Hide the prompt
            (0, $0d7938c2995b09c7$export$aac38b1a00f6dfb4)()(state, dispatch);
            // - Invoke the existing Improve Writing AI action
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: state,
                configItem: configItem,
                lastTriggeredFrom: 'aiQuickPrompt',
                triggerMethod: 'shortcut',
                aiGlobalOptIn: aiGlobalOptIn,
                overrideFromPos: range.from,
                overrideToPos: range.to
            });
            openAIModalCommand(state, dispatch);
            // - Fire analytics: triggered
            (0, $75dc73a214c6bdae$export$7cad2a9b6222530d)({
                api: api,
                experienceName: configItem.key,
                method: 'tab'
            });
        }
        return true; // Handled
    };
    // --- Escape handler ---
    keymapObj['Escape'] = (state, dispatch)=>{
        const pluginState = (0, $0d7938c2995b09c7$export$18d4026d1ea86bb1).getState(state);
        if (!pluginState?.isPromptVisible) return false; // Pass through to next plugin
        if (dispatch) {
            // - Record dismissal for stand-down
            standDownManager.recordDismissal();
            // - Hide the prompt
            (0, $0d7938c2995b09c7$export$aac38b1a00f6dfb4)()(state, dispatch);
            // - Fire analytics: dismissed
            (0, $75dc73a214c6bdae$export$19c5aad04a0b6b57)({
                api: api,
                experienceName: configItem.key,
                method: 'escape'
            });
        }
        return true; // Handled
    };
    return (0, $44cyU.keymap)(keymapObj);
}






var $6SJ6d = parcelRequire("6SJ6d");


var $1hQ0e = parcelRequire("1hQ0e");




const $f9b2516599ed3bb5$export$dd8068d0255817c = (0, $kSwu1.defineMessages)({
    nudgeText: {
        id: "fabric.editor.ai.quickPrompt.nudge",
        defaultMessage: "<code>Tab</code> to improve writing"
    }
});





// eslint-disable-next-line require-unicode-regexp
const $e6aae752c370b71b$var$CREATE_MESSAGE_NODES_CODE_REGEX = /<code>(.*)<\/code>/;
function $e6aae752c370b71b$var$createMessageNodes({ doc: doc, message: message }) {
    const node = doc.createElement('div');
    node.className = 'ai-quick-prompt-message';
    const parts = message.split($e6aae752c370b71b$var$CREATE_MESSAGE_NODES_CODE_REGEX);
    parts.forEach((part)=>{
        if (!part) return;
        const span = doc.createElement('span');
        span.textContent = part;
        if (message.includes(`<code>${part}</code>`)) span.className = 'ai-quick-prompt-code';
        node.appendChild(span);
    });
    return node;
}
function $e6aae752c370b71b$var$createCaretNode({ doc: doc }) {
    const caret = doc.createElement('span');
    caret.className = 'ai-quick-prompt-caret';
    return caret;
}
function $e6aae752c370b71b$var$createMessageContainer({ doc: doc }) {
    const container = doc.createElement('div');
    container.setAttribute('data-testid', 'ai-quick-prompt-placeholder-decoration');
    container.className = 'placeholder-decoration placeholder-decoration-inline ai-quick-prompt-placeholder-decoration placeholder-decoration-fade-in';
    return container;
}
function $e6aae752c370b71b$export$e3ab9ab4756dfe68({ getIntl: getIntl, range: range, state: state }) {
    const widget = ()=>{
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) throw new Error('Document not found');
        const container = $e6aae752c370b71b$var$createMessageContainer({
            doc: doc
        });
        const intl = getIntl();
        const message = intl.formatMessage((0, $f9b2516599ed3bb5$export$dd8068d0255817c).nudgeText);
        container.appendChild($e6aae752c370b71b$var$createCaretNode({
            doc: doc
        }));
        container.appendChild($e6aae752c370b71b$var$createMessageNodes({
            doc: doc,
            message: message
        }));
        return container;
    };
    return (0, $8nvEM.DecorationSet).create(state.doc, [
        (0, $8nvEM.Decoration).widget(range.to, widget, {
            side: 1,
            // After the content
            key: 'ai-quick-prompt-nudge'
        })
    ]);
}



var $cXtTj = parcelRequire("cXtTj");

const $dd69fdb89714dd9b$export$dcf22dd285f74f3d = 2000;
function $dd69fdb89714dd9b$var$isNumber(value) {
    return typeof value === 'number';
}
function $dd69fdb89714dd9b$var$getExperimentValue(key, defaultValue) {
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    return (0, $cXtTj.default).getExperimentValue('platform_editor_ai_quick_prompt_iw_cc', key, defaultValue, {
        typeGuard: $dd69fdb89714dd9b$var$isNumber,
        fireExperimentExposure: false
    });
}
function $dd69fdb89714dd9b$var$getTimeoutMs() {
    return $dd69fdb89714dd9b$var$getExperimentValue('timeout', $dd69fdb89714dd9b$export$dcf22dd285f74f3d);
}
class $dd69fdb89714dd9b$export$6ba4f6b9c75b8f65 {
    /** Abort any in-flight work from the previous idle callback. */ abortInflight() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }
    stop() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.abortInflight();
    }
    /** Reset the idle timer */ reset() {
        if (this.destroyed) return;
        this.stop();
        this.timerId = setTimeout(()=>{
            this.timerId = null;
            this.abortController = new AbortController();
            this.onIdle({
                signal: this.abortController.signal
            });
        }, this.timeoutMs);
    }
    /** Cancel pending timer and clean up */ destroy() {
        this.stop();
        this.destroyed = true;
    }
    constructor(options){
        this.timeoutMs = void 0;
        this.timerId = null;
        this.onIdle = void 0;
        this.destroyed = false;
        this.abortController = null;
        this.timeoutMs = $dd69fdb89714dd9b$var$getTimeoutMs();
        this.onIdle = options.onIdle;
    }
}






const $86e308064135870f$var$MIN_SENTENCE_COUNT = 3;
const $86e308064135870f$var$MIN_CHARACTER_COUNT = 150;
// Regex to check if text ends with a sentence-ending punctuation mark.
// Supports Latin (.!?) and CJK (。！？) end marks, with optional trailing whitespace.
// eslint-disable-next-line require-unicode-regexp
const $86e308064135870f$var$END_MARK_REGEX = /[.!?\u3002\uFF01\uFF1F]\s*$/;
function $86e308064135870f$export$841744c1f55334bc({ text: text, locale: locale }) {
    if (!text) return 0;
    if (typeof Intl !== 'undefined' && Intl.Segmenter) {
        const segmenter = new Intl.Segmenter(locale ?? 'en', {
            granularity: 'sentence'
        });
        const segments = Array.from(segmenter.segment(text));
        return segments.length;
    }
    // Fallback: regex matching sentence-ending punctuation
    // Latin punctuation requires following whitespace or end-of-string.
    // CJK punctuation (。！？) can appear without trailing whitespace.
    // eslint-disable-next-line require-unicode-regexp
    const sentenceEndRegex = /[.!?](?:\s|$)|[\u3002\uFF01\uFF1F]/g;
    const matches = text.match(sentenceEndRegex);
    return matches ? matches.length : 1;
}
function $86e308064135870f$export$268483b508cee1bb({ locale: locale, selection: selection }) {
    const { $to: $to } = selection;
    // Find the node at cursor depth
    const depth = $to.depth;
    const parentNode = $to.node(depth);
    // Only support paragraph for now
    // we can add support for other textblock nodes later if needed by using isTextblock.
    if (parentNode.type.name !== 'paragraph') return;
    // If the selection is not at the end of the node, return null
    if (selection.from !== selection.to || selection.from !== $to.end(depth)) return;
    const text = parentNode.textContent.trim();
    // The paragraph must end with a sentence-ending punctuation mark
    if (!$86e308064135870f$var$END_MARK_REGEX.test(text)) return;
    // Count sentences
    const sentenceCount = $86e308064135870f$export$841744c1f55334bc({
        text: text,
        locale: locale
    });
    // Check thresholds: >= 3 sentences OR >= 150 characters (fallback)
    // The character-count fallback covers cases where sentence counting undercounts
    // (e.g., long run-on sentences, or scripts with non-standard punctuation).
    if (sentenceCount < $86e308064135870f$var$MIN_SENTENCE_COUNT && text.length < $86e308064135870f$var$MIN_CHARACTER_COUNT) return;
    // Return the absolute position range of the node
    const from = $to.start(depth);
    const to = $to.end(depth);
    // Use the paragraph node's localId if available, otherwise fall back to position-based key
    const nodeId = parentNode.attrs.localId ? String(parentNode.attrs.localId) : `pos:${from}`;
    return {
        range: {
            from: from,
            to: to
        },
        text: text,
        nodeId: nodeId
    };
}


const $908fdc0393ec658a$var$TAB_CONFLICT_NODE_TYPES = new Set([
    'table',
    'expand',
    'caption',
    'codeBlock'
]);
function $908fdc0393ec658a$export$36aa946696cb27eb(selection) {
    const { $from: $from } = selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const ancestorTypeName = $from.node(depth).type.name;
        if ($908fdc0393ec658a$var$TAB_CONFLICT_NODE_TYPES.has(ancestorTypeName)) return true;
    }
    return false;
}














const $777e5baa55b80077$var$CONTROL_ROUTING_MODE = 'control';
const $777e5baa55b80077$var$SHADOW_COMPARE_ROUTING_MODE = 'shadow_compare';
const $777e5baa55b80077$var$LIVE_CC_SMARTS_ROUTING_MODE = 'live_cc_smarts';
const $777e5baa55b80077$var$getShouldImproveWritingRoutingMode = ()=>{
    try {
        return (0, $mW7G5.expVal)('cc_smarts_should_improve_writing_migration', 'routingMode', $777e5baa55b80077$var$CONTROL_ROUTING_MODE);
    } catch  {
        // Fall back to convo-ai without reporting an API error.
        return $777e5baa55b80077$var$CONTROL_ROUTING_MODE;
    }
};
const $777e5baa55b80077$var$fetchShouldImproveWritingFromBackend = async (url, { adfContent: adfContent, locale: locale, product: product, signal: signal })=>{
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': 'editor',
                ...(0, $72eca8ccfc8df62d$export$46d5228a079b1d3)(product)
            },
            mode: 'cors',
            credentials: 'include',
            signal: signal,
            body: JSON.stringify({
                ai_feature_input: {
                    locale: locale,
                    adf_content: adfContent
                }
            })
        });
        if (!response.ok) return {
            errorType: 'non_ok_response',
            ok: false,
            shouldImprove: false,
            status: response.status
        };
        const data = await response.json();
        return {
            ok: true,
            shouldImprove: data?.ai_feature_output?.should_improve === true,
            status: response.status
        };
    } catch (error) {
        if (error instanceof Error && error.name === 'AbortError') return {
            errorType: 'aborted',
            ok: false,
            shouldImprove: false
        };
        return {
            errorMessage: error instanceof Error ? error.message : undefined,
            errorType: 'request_failed',
            ok: false,
            shouldImprove: false
        };
    }
};
const $777e5baa55b80077$var$fireVisibleApiError = (result, { api: api, experienceName: experienceName })=>{
    if (result.ok || result.errorType === 'aborted') return;
    (0, $75dc73a214c6bdae$export$48d6055e922d98b1)({
        api: api,
        experienceName: experienceName,
        errorMessage: result.errorMessage,
        statusCode: result.status
    });
};
const $777e5baa55b80077$var$logShadowComparison = (convoAiResult, ccSmartsResult, observabilityContext)=>{
    const responseHealthMatches = convoAiResult.ok === ccSmartsResult.ok && convoAiResult.status === ccSmartsResult.status;
    const shouldImproveMatches = convoAiResult.shouldImprove === ccSmartsResult.shouldImprove;
    if (responseHealthMatches && shouldImproveMatches) return;
    (0, $75dc73a214c6bdae$export$6106882af1d3d655)({
        api: observabilityContext.api,
        experienceName: observabilityContext.experienceName,
        convoAiOk: convoAiResult.ok,
        ccSmartsOk: ccSmartsResult.ok,
        convoAiStatus: convoAiResult.status,
        ccSmartsStatus: ccSmartsResult.status,
        convoAiErrorType: convoAiResult.errorType,
        ccSmartsErrorType: ccSmartsResult.errorType,
        convoAiShouldImprove: convoAiResult.shouldImprove,
        ccSmartsShouldImprove: ccSmartsResult.shouldImprove
    });
};
const $777e5baa55b80077$var$checkShouldImproveWritingWithShadowCompare = async (requestContext, observabilityContext)=>{
    const convoAiPromise = $777e5baa55b80077$var$fetchShouldImproveWritingFromBackend((0, $gcCwL.shouldImproveWritingApiUrl), requestContext);
    const ccSmartsPromise = $777e5baa55b80077$var$fetchShouldImproveWritingFromBackend((0, $gcCwL.shouldImproveWritingCcSmartsApiUrl), requestContext);
    const convoAiResult = await convoAiPromise;
    ccSmartsPromise.then((ccSmartsResult)=>{
        $777e5baa55b80077$var$logShadowComparison(convoAiResult, ccSmartsResult, observabilityContext);
    }).catch(()=>{
    // Shadow analytics must never affect the user-visible convo-ai result.
    });
    $777e5baa55b80077$var$fireVisibleApiError(convoAiResult, observabilityContext);
    return convoAiResult.shouldImprove;
};
async function $777e5baa55b80077$export$6886fb0ad642ed3({ api: api, experienceName: experienceName, locale: locale, product: product, range: range, signal: signal, view: view }) {
    try {
        const { doc: doc, schema: schema } = view.state;
        const $from = doc.resolve(range.from);
        const parentNode = $from.parent;
        const docNode = schema.nodes.doc.createAndFill(null, parentNode);
        if (!docNode) return false;
        const transformer = new (0, $2lPWP.JSONTransformer)();
        const adfContent = JSON.stringify(transformer.encode(docNode));
        const requestContext = {
            adfContent: adfContent,
            locale: locale,
            product: product,
            signal: signal
        };
        const observabilityContext = {
            api: api,
            experienceName: experienceName
        };
        const routingMode = $777e5baa55b80077$var$getShouldImproveWritingRoutingMode();
        if (routingMode === $777e5baa55b80077$var$SHADOW_COMPARE_ROUTING_MODE) return $777e5baa55b80077$var$checkShouldImproveWritingWithShadowCompare(requestContext, observabilityContext);
        const url = routingMode === $777e5baa55b80077$var$LIVE_CC_SMARTS_ROUTING_MODE ? (0, $gcCwL.shouldImproveWritingCcSmartsApiUrl) : (0, $gcCwL.shouldImproveWritingApiUrl);
        const result = await $777e5baa55b80077$var$fetchShouldImproveWritingFromBackend(url, requestContext);
        $777e5baa55b80077$var$fireVisibleApiError(result, observabilityContext);
        return result.shouldImprove;
    } catch (error) {
        (0, $75dc73a214c6bdae$export$48d6055e922d98b1)({
            api: api,
            experienceName: experienceName,
            errorMessage: error instanceof Error ? error.message : undefined
        });
        return false;
    }
}


function $b0351f865e9fddf0$export$d541ca7bbc28c579({ api: api, getIntl: getIntl, standDownManager: standDownManager, view: view }) {
    // - Check if the prompt is already visible
    const pluginState = (0, $0d7938c2995b09c7$export$f05434c51e3762e)(view.state);
    if (pluginState?.isPromptVisible && pluginState.eligibleRange) return;
    // - Check paste options toolbar
    const pasteOptionsToolbarPluginState = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
    if (pasteOptionsToolbarPluginState?.showToolbar) return;
    // - Check if AI is active (running or streaming or showing accept/reject review)
    // If there are multiple sessions, only checking isRunning is not enough.
    const aiState = api?.aiExperience?.sharedState.currentState();
    if (aiState?.aiDecorationExperiencePluginState?.isRunning || aiState?.isStreaming || aiState?.isShowingAcceptRejectScreen) return;
    // - Check stand-down
    if (standDownManager.shouldStandDown()) return;
    // - Check Tab conflict
    if ((0, $908fdc0393ec658a$export$36aa946696cb27eb)(view.state.selection)) return;
    // - Check content eligibility
    const eligibleResult = (0, $86e308064135870f$export$268483b508cee1bb)({
        locale: getIntl().locale,
        selection: view.state.selection
    });
    if (!eligibleResult) return;
    // - Check if the node was already triggered via Tab
    if (standDownManager.wasTriggered(eligibleResult.nodeId)) return;
    // - Check if the eligible text has been shown before
    const trimmedText = eligibleResult.text.trim();
    if (pluginState?.previousShownTexts?.includes(trimmedText)) return;
    return eligibleResult;
}
const $b0351f865e9fddf0$export$87c3e4292e0570f6 = async ({ api: api, configItem: configItem, getIntl: getIntl, product: product, signal: signal, standDownManager: standDownManager, view: view })=>{
    // Run all synchronous guards before the network request
    const eligibleResult = $b0351f865e9fddf0$export$d541ca7bbc28c579({
        api: api,
        getIntl: getIntl,
        standDownManager: standDownManager,
        view: view
    });
    if (!eligibleResult) return;
    // - Check if the content should be improved via API
    const shouldImprove = await (0, $777e5baa55b80077$export$6886fb0ad642ed3)({
        api: api,
        experienceName: configItem.key,
        locale: getIntl().locale,
        product: product,
        range: eligibleResult.range,
        signal: signal,
        view: view
    });
    if (!shouldImprove) return;
    // Re-run all synchronous guards after the network request to guard against
    // race conditions: the user may have moved the cursor, changed the document,
    // or a collab update may have arrived while the request was in-flight.
    const eligibleResultAfterAwait = $b0351f865e9fddf0$export$d541ca7bbc28c579({
        api: api,
        getIntl: getIntl,
        standDownManager: standDownManager,
        view: view
    });
    if (!eligibleResultAfterAwait) return;
    // If the content of the eligible range has changed during the network
    // request, the API response may no longer be relevant — early return.
    if (eligibleResult.text !== eligibleResultAfterAwait.text) return;
    // If the experiment is not enabled, early return
    if (!(0, $ieeJu.expValEquals)('platform_editor_ai_quick_prompt_iw_cc', 'isEnabled', true)) return;
    const trimmedText = eligibleResultAfterAwait.text.trim();
    // - Show the prompt
    // Use the fresh eligible range from after the await (positions may have
    // shifted due to collab updates even when the content is identical).
    (0, $0d7938c2995b09c7$export$20ce7c88b8f4552b)({
        range: eligibleResultAfterAwait.range,
        shownText: trimmedText
    })(view.state, view.dispatch);
    // - Fire analytics: prompt displayed
    (0, $75dc73a214c6bdae$export$c596c00169e22422)({
        api: api,
        experienceName: configItem.key
    });
};



function $47c9c4790f0d713a$export$1c7d49a87561e31f({ api: api, configItem: configItem, dispatch: dispatch, getIntl: getIntl, product: product, standDownManager: standDownManager }) {
    let isCollabDocUpdate = false;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $0d7938c2995b09c7$export$18d4026d1ea86bb1),
        state: (0, $0d7938c2995b09c7$export$656c7661095efe2e)(dispatch, (0, $0d7938c2995b09c7$export$d4c72bab9d6cc13a)),
        appendTransaction: (transactions)=>{
            for (const tr of transactions){
                const isCollab = Boolean(tr.getMeta('isRemote'));
                if (isCollab && !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(tr.before, tr.doc)) isCollabDocUpdate = true;
            }
            return null;
        },
        view (view) {
            const idleDetector = new (0, $dd69fdb89714dd9b$export$6ba4f6b9c75b8f65)({
                onIdle: ({ signal: signal })=>(0, $b0351f865e9fddf0$export$87c3e4292e0570f6)({
                        api: api,
                        configItem: configItem,
                        getIntl: getIntl,
                        product: product,
                        signal: signal,
                        standDownManager: standDownManager,
                        view: view
                    })
            });
            // Stop the idle detector to prevent the prompt from showing after the document is updated by AI
            const unsubscribeAIState = api?.aiExperience?.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                const isNotRunning = prevSharedState?.aiDecorationExperiencePluginState?.isRunning && !nextSharedState?.aiDecorationExperiencePluginState?.isRunning;
                const isSessionEnded = prevSharedState?.aiDecorationExperiencePluginState?.nextSessionId && !nextSharedState?.aiDecorationExperiencePluginState?.nextSessionId;
                if (isNotRunning || isSessionEnded) idleDetector.stop();
            });
            return {
                update (view, prevState) {
                    // When the selection changes (without a document change), stop the idle
                    // detector so the prompt does not appear after the user moves the cursor.
                    // Prompt will be hidden by pluginFactory's onSelectionChanged callback.
                    if (!prevState.selection.eq(view.state.selection)) idleDetector.stop();
                    // When document changes, hide the prompt and reset idle timer
                    // - The plugin factory's onDocChanged callback will be called whenever there is a step,
                    //   - which is not always a document change.
                    // - When `Create with Rovo`, there is a final replaceDocument operation
                    //   - which is making `.eq` return false, so we have to use `areNodesEqualIgnoreAttrs`
                    if (!(0, $6SJ6d.areNodesEqualIgnoreAttrs)(prevState.doc, view.state.doc)) {
                        if (isCollabDocUpdate) isCollabDocUpdate = false;
                        else {
                            const pluginState = (0, $0d7938c2995b09c7$export$18d4026d1ea86bb1).getState(view.state);
                            if (pluginState?.isPromptVisible) // Hide the prompt after a short delay to allow the editor to complete the current state update.
                            // See https://hello.jira.atlassian.cloud/browse/EDITOR-3849
                            setTimeout(()=>{
                                (0, $0d7938c2995b09c7$export$aac38b1a00f6dfb4)()(view.state, view.dispatch);
                            }, 0);
                            idleDetector.reset();
                        }
                    }
                },
                destroy () {
                    unsubscribeAIState?.();
                    idleDetector.destroy();
                }
            };
        },
        props: {
            decorations (state) {
                const pluginState = (0, $0d7938c2995b09c7$export$18d4026d1ea86bb1).getState(state);
                if (pluginState?.isPromptVisible && pluginState.eligibleRange) return (0, $e6aae752c370b71b$export$e3ab9ab4756dfe68)({
                    state: state,
                    range: pluginState.eligibleRange,
                    getIntl: getIntl
                });
                return undefined;
            }
        }
    });
}


function $1e8fb53d14d2e60a$export$90a11d81f952f37f(api) {
    const targetId = api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState.targetId;
    return targetId ? String(targetId) : window.location.origin + window.location.pathname;
}


const $8e17f32d6dcdd797$var$DEFAULT_STORAGE_KEY_PREFIX = 'ai-quick-prompt-standdown';
const $8e17f32d6dcdd797$var$DEFAULT_MAX_DISMISSALS_IN_WINDOW = 1;
const $8e17f32d6dcdd797$var$DEFAULT_WINDOW_MS = 86400000; // 24 hours
class $8e17f32d6dcdd797$export$5e884e16f8eb7ac6 {
    /**
   * Record that the user triggered "improve writing" on a node.
   * Stored in-memory only (resets on page reload).
   */ recordTrigger(nodeId) {
        this.triggeredNodeIds.add(nodeId);
    }
    /**
   * Check if the user has already triggered "improve writing" on a node.
   */ wasTriggered(nodeId) {
        return this.triggeredNodeIds.has(nodeId);
    }
    shouldStandDown() {
        const record = this.pruneExpired(this.readRecord());
        this.writeRecord(record);
        if (record.dismissalTimestamps.length >= this.maxDismissalsInWindow) return true;
        return false;
    }
    recordDismissal() {
        const record = this.readRecord();
        record.dismissalTimestamps.push(Date.now());
        this.writeRecord(record);
    }
    reset() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.removeItem(this.getStorageKey());
        } catch  {
        // Silently ignore storage errors
        }
    }
    getStorageKey() {
        return `${this.storageKeyPrefix}-${(0, $1e8fb53d14d2e60a$export$90a11d81f952f37f)(this.api)}`;
    }
    readRecord() {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const raw = localStorage.getItem(this.getStorageKey());
            if (!raw) return {
                dismissalTimestamps: []
            };
            return JSON.parse(raw);
        } catch  {
            return {
                dismissalTimestamps: []
            };
        }
    }
    writeRecord(record) {
        try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            localStorage.setItem(this.getStorageKey(), JSON.stringify(record));
        } catch  {
        // Silently ignore storage errors (e.g., quota exceeded)
        }
    }
    pruneExpired(record) {
        const cutoff = Date.now() - this.windowMs;
        return {
            dismissalTimestamps: record.dismissalTimestamps.filter((ts)=>ts > cutoff)
        };
    }
    constructor(options){
        this.api = void 0;
        this.storageKeyPrefix = $8e17f32d6dcdd797$var$DEFAULT_STORAGE_KEY_PREFIX;
        this.maxDismissalsInWindow = $8e17f32d6dcdd797$var$DEFAULT_MAX_DISMISSALS_IN_WINDOW;
        this.windowMs = $8e17f32d6dcdd797$var$DEFAULT_WINDOW_MS;
        this.triggeredNodeIds = new Set();
        this.api = options.api;
    }
}


function $0aafbf03d0c51e63$export$4de7211890d36588({ aiGlobalOptIn: aiGlobalOptIn, api: api, product: product }) {
    const configItem = (0, $iO5TS.improveWriting)();
    const standDownManager = new (0, $8e17f32d6dcdd797$export$5e884e16f8eb7ac6)({
        api: api
    });
    return [
        {
            name: 'ai-quick-prompt',
            plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $47c9c4790f0d713a$export$1c7d49a87561e31f)({
                    api: api,
                    configItem: configItem,
                    dispatch: dispatch,
                    getIntl: getIntl,
                    product: product,
                    standDownManager: standDownManager
                })
        },
        {
            name: 'ai-quick-prompt-keymap',
            plugin: ()=>(0, $f303e3c28f40d0ac$export$e9cb660ee1921103)({
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: configItem,
                    standDownManager: standDownManager
                })
        }
    ];
}



var $8dxef = parcelRequire("8dxef");










const $4aa8cb2c5702b563$export$725555b5a77b69ce = new (0, $kCECX.PluginKey)('aiQucikstartCommand');


const $d9513de59461fceb$export$75dff2601176292f = (options)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $4aa8cb2c5702b563$export$725555b5a77b69ce),
        state: {
            init: (_, state)=>({}),
            apply: ()=>{}
        },
        props: {
            handleDOMEvents: {
                keydown (view, event) {
                    const browser = (0, $8dxef.getBrowserInfo)();
                    const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
                    if (metaKey && event.key === "'") {
                        const { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn } = options;
                        const { state: state, dispatch: dispatch } = view;
                        const configItem = editorPluginAIProvider.baseGenerate;
                        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: 'shortcut',
                            triggerMethod: 'shortcut',
                            aiGlobalOptIn: aiGlobalOptIn,
                            locale: options.getIntl().locale
                        });
                        openAIModalCommand(state, dispatch);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};













var $i2EU6 = parcelRequire("i2EU6");



/**
 * Markdown blocks are separated by one or more blank lines. The separator is
 * captured so it can be restored verbatim when blocks are rejoined, rather
 * than being normalised to a fixed number of newlines.
 */ const $9fa3fcf4cc54f7dd$var$BLOCK_SEPARATOR = /((?:\r?\n){2,})/u;
const $9fa3fcf4cc54f7dd$var$isDoc = (adfResponse)=>adfResponse?.type === 'doc' && Array.isArray(adfResponse.content);
/** Splitting on a capturing separator interleaves blocks and separators. */ const $9fa3fcf4cc54f7dd$var$splitBlocks = (markdown)=>markdown.split($9fa3fcf4cc54f7dd$var$BLOCK_SEPARATOR);
const $9fa3fcf4cc54f7dd$var$countMarkdownBlocks = (parts)=>Math.ceil(parts.length / 2);
const $9fa3fcf4cc54f7dd$export$fff40d0cad772fa = ({ adfResponse: adfResponse, markdown: markdown })=>{
    if ($9fa3fcf4cc54f7dd$var$isDoc(adfResponse)) return Math.max(0, adfResponse.content.length - 1);
    if (typeof markdown === 'string') return Math.max(0, $9fa3fcf4cc54f7dd$var$countMarkdownBlocks($9fa3fcf4cc54f7dd$var$splitBlocks(markdown)) - 1);
    return 0;
};
const $9fa3fcf4cc54f7dd$export$96fa9ba16a212ed9 = ({ adfResponse: adfResponse, markdown: markdown }, blockCount)=>{
    if ($9fa3fcf4cc54f7dd$var$isDoc(adfResponse)) return {
        adfResponse: {
            ...adfResponse,
            content: adfResponse.content.slice(0, blockCount)
        }
    };
    if (typeof markdown === 'string') {
        const parts = $9fa3fcf4cc54f7dd$var$splitBlocks(markdown);
        // Each block occupies an even index, with its trailing separator next to
        // it, so N blocks span the first 2N-1 entries.
        return {
            markdown: parts.slice(0, Math.max(0, blockCount * 2 - 1)).join('')
        };
    }
    return {};
};





const $26297e2ea9adfacc$export$ea74cb3f95fdbd46 = ()=>(0, $iDrrr.fg)('platform_editor_ai_quick_actions_buffered_apply');






var $9kYSx = parcelRequire("9kYSx");

function $db676d2be4cae1a7$export$9ea8217d5ec56f82() {
    return new (0, $9kYSx.StreamFlowPacer)({
        tickMs: 41,
        initialCharsPerTick: 8,
        maxCharsPerTick: 1000,
        backlogRampThreshold: 100,
        ramp: {
            initialDelaySec: 6,
            stepDelaySec: 3,
            flushDelaySec: 0.5,
            growthFactor: 1.5
        }
    });
}
function $db676d2be4cae1a7$export$ace1671de29eb5ea() {
    const streamFlowPacerRef = (0, $cozmU.useRef)(null);
    if (!streamFlowPacerRef.current) streamFlowPacerRef.current = $db676d2be4cae1a7$export$9ea8217d5ec56f82();
    // destroy the stream flow pacer when unmounted
    (0, $cozmU.useEffect)(()=>{
        streamFlowPacerRef.current?.destroy();
    }, []);
    return streamFlowPacerRef;
}







var $9ybcs = parcelRequire("9ybcs");





const $7791c10173ad9c87$export$ea01a78091d2ff77 = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'RESET'
    });
const $7791c10173ad9c87$export$7f430c6835f5abe7 = ({ adfResponse: adfResponse, markdown: markdown })=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'STREAM',
        adfResponse: adfResponse,
        markdown: markdown
    });
const $7791c10173ad9c87$export$55e78bff62ceea68 = ({ adfResponse: adfResponse, markdown: markdown, responseTooSimilar: responseTooSimilar, forceAbortedToolCallId: forceAbortedToolCallId })=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'COMPLETE',
        adfResponse: adfResponse,
        markdown: markdown,
        responseTooSimilar: responseTooSimilar,
        forceAbortedToolCallId: forceAbortedToolCallId
    });
const $7791c10173ad9c87$export$e40a87860316fbc4 = ({ errorInfo: errorInfo })=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'ERROR',
        errorInfo: errorInfo
    });
const $7791c10173ad9c87$export$bccaa00f011961e4 = (traceIds)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'UPDATE_TRACE_IDS',
        traceIds: traceIds
    });
const $7791c10173ad9c87$export$bb7a833936265787 = (idMap)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'UPDATE_ID_MAP',
        idMap: idMap
    });
const $7791c10173ad9c87$export$11550f22cf2d0c6c = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'CANCEL_STREAM'
    });
const $7791c10173ad9c87$export$8e01b36b460d89b0 = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'PAUSE_STREAM'
    });
const $7791c10173ad9c87$export$9c4a3e8153b61b0e = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'RESUME_STREAM'
    });
const $7791c10173ad9c87$export$85376b7ae78edde1 = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'SET_HAS_USER_SCROLLED'
    });
const $7791c10173ad9c87$export$a83cc81ac6219ae5 = (userInput)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'START_FREE_GEN_STREAM',
        userInput: userInput
    });
const $7791c10173ad9c87$export$5049e31d43480481 = ()=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'START_AGGREGATE_REWORK'
    });
const $7791c10173ad9c87$export$56546cb942005916 = (segmentIndex)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'UPDATE_STREAM_REVIEW_SEGMENT',
        currentStreamReviewSegmentIndex: segmentIndex
    });
const $7791c10173ad9c87$export$d3258c2d622dcce6 = (index, startPos, endPos)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'UPDATE_AI_CONTENT_POSITION',
        index: index,
        startPos: startPos,
        endPos: endPos
    });
const $7791c10173ad9c87$export$207b82940ed2d27 = (topLevelIndex, startPos, endPos)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'START_SEGMENT_REWORK',
        topLevelIndex: topLevelIndex,
        startPos: startPos,
        endPos: endPos
    });
const $7791c10173ad9c87$export$3e1e4ddb85f3729f = (toolCallId)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'CLEAR_ABORTED_TOOL_CALL_POSITION',
        toolCallId: toolCallId
    });
const $7791c10173ad9c87$export$c4e1fc753f807999 = (segments)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'SET_STREAM_REVIEW_SEGMENTS',
        segments: segments
    });
const $7791c10173ad9c87$export$a8f24a1483956d06 = (range)=>(0, $e9cb9bc0694dd877$export$8d4021544bdece00)({
        type: 'SET_REWORK_HIGHLIGHT_RANGE',
        range: range
    });
const $7791c10173ad9c87$export$6725e2cbda5e459c = (event)=>{
    switch(event.type){
        case 'stream':
            return $7791c10173ad9c87$export$7f430c6835f5abe7(event);
        case 'complete':
            return $7791c10173ad9c87$export$55e78bff62ceea68(event);
        case 'error':
            return $7791c10173ad9c87$export$e40a87860316fbc4(event);
        default:
            $7791c10173ad9c87$var$assertUnreachable(event);
            return undefined;
    }
};
function $7791c10173ad9c87$var$assertUnreachable(_x) {}







/**
 * Apply a display-indexed update over nested stream-review segments.
 *
 * `streamReviewSegments` is stored as top-level entries with optional nested
 * `diffSegments`, while PSR actions (undo/redo/accept/position writeback) address
 * the flattened visible list index. This helper walks entries in that same visible
 * order and applies `transform` to the addressed leaf segment, preserving the
 * original nested shape in state.
 */ const $30eb8b319e5e3080$var$mapDisplaySegments = ({ segments: segments, transform: transform })=>{
    let displayIndex = 0;
    return segments.map((entry)=>{
        if (entry.isAccepted) return entry;
        if (entry.diffSegments?.length) {
            let changed = false;
            const nextDiffSegments = entry.diffSegments.map((diffEntry)=>{
                if (diffEntry.isAccepted) return diffEntry;
                const next = transform(diffEntry, displayIndex);
                displayIndex += 1;
                if (next !== undefined) {
                    changed = true;
                    return next;
                }
                return diffEntry;
            });
            return changed ? {
                ...entry,
                diffSegments: nextDiffSegments
            } : entry;
        }
        const next = transform(entry, displayIndex);
        displayIndex += 1;
        return next !== undefined ? next : entry;
    });
};
function $30eb8b319e5e3080$export$1650419e431d3ba3({ state: state, action: action }) {
    switch(action.type){
        case 'RESET':
            return 0, $e9cb9bc0694dd877$export$d4c72bab9d6cc13a;
        case 'START_SESSION':
            return {
                ...state,
                ...(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_unified_post_apply_chrome') ? {
                    // A new orchestrated session owns a fresh Review Moment working set.
                    // END_SESSION retains these fields long enough to render review and chrome;
                    // do not carry them into the next Rovo frontend update.
                    aiContentPositions: [],
                    streamReviewSegments: undefined,
                    currentStreamReviewMode: undefined,
                    currentStreamReviewSegmentIndex: undefined,
                    currentStreamReviewAiOptIn: undefined,
                    reworkSnapshot: undefined,
                    reworkHighlightRange: undefined
                } : {},
                sessionId: action.sessionId,
                status: 'streaming',
                // Single source of truth read by buildCommitTransaction and endAISession
                // to suppress Post Stream Review for a create stream.
                isCreateSession: action.isCreateSession,
                // Read by endAISession to auto-open Post Stream Review ONLY
                // for inline edits on the orchestrated (Rovo-chat) update path.
                isInlineEditSession: action.isInlineEditSession,
                agentAttribution: action.agentAttribution
            };
        case 'PROMPT':
            return {
                ...state,
                status: 'prompt'
            };
        case 'STREAM':
            // Prevent streaming if the session is in an error state
            if (state.status === 'error') return {
                ...state
            };
            // if the previous state was complete it means we are starting a new stream
            const responseVersion = state.status === 'complete' ? 0 : state.responseVersion + 1;
            return {
                ...state,
                adfResponse: action.adfResponse,
                markdown: action.markdown,
                status: 'streaming',
                responseVersion: responseVersion
            };
        case 'COMPLETE':
            // Prevent completing the session if it is in an error state
            if (state.status === 'error') return {
                ...state
            };
            return {
                ...state,
                adfResponse: action.adfResponse,
                markdown: action.markdown,
                responseTooSimilar: action.responseTooSimilar,
                status: 'complete',
                // If this completion is for a queue-timeout force-finished tool call,
                // remember its id so the next `buildCommitTransaction` persists its
                // positions for resume.
                pendingForceAbortedToolCallId: action.forceAbortedToolCallId
            };
        case 'ERROR':
            return {
                ...state,
                errorInfo: action.errorInfo,
                status: 'error'
            };
        case 'UPDATE_TRACE_IDS':
            return {
                ...state,
                traceIds: action.traceIds
            };
        case 'UPDATE_ID_MAP':
            return {
                ...state,
                idMap: {
                    ...state.idMap,
                    ...action.idMap
                }
            };
        case 'CANCEL_STREAM':
            // Set the cancelRequested flag so the plugin's view.update() can abort the network request.
            // The subsequent RESET action will clear this flag along with the rest of the state.
            return {
                ...state,
                cancelRequested: true
            };
        case 'PAUSE_STREAM':
            return {
                ...state,
                streamPaused: true
            };
        case 'RESUME_STREAM':
            return {
                ...state,
                streamPaused: false
            };
        case 'SET_HAS_USER_SCROLLED':
            return {
                ...state,
                hasUserScrolled: true
            };
        case 'START_FREE_GEN_STREAM':
            return {
                ...state,
                status: 'streaming',
                userInput: action.userInput
            };
        // Start an aggregate rework: begin streaming and clear the stale Post Stream
        // Review state so the rework runs as a fresh session rather than inheriting
        // the previous review's segments/positions.
        case 'START_AGGREGATE_REWORK':
            return {
                ...state,
                status: 'streaming',
                streamReviewSegments: undefined,
                currentStreamReviewMode: undefined,
                currentStreamReviewSegmentIndex: undefined,
                reworkSnapshot: undefined,
                aiContentPositions: undefined
            };
        // [CCI-17658] Per-segment rework: start streaming but preserve
        // aiContentPositions and streamReviewSegments. Snapshot the target
        // segment's range for in-bounds detection after the commit.
        case 'START_SEGMENT_REWORK':
            return {
                ...state,
                status: 'streaming',
                reworkSnapshot: {
                    topLevelIndex: action.topLevelIndex,
                    startPos: action.startPos,
                    endPos: action.endPos
                }
            };
        case 'REWORK_APPEND_SLICE':
            {
                const streamReviewSegments = state.streamReviewSegments ?? [];
                if (action.topLevelIndex < 0 || action.topLevelIndex >= streamReviewSegments.length) return state;
                // [CCI-17658] Append a new coarse entry rather than mapping by
                // topLevelIndex — aiContentPositions and streamReviewSegments are
                // not index-aligned (coarse entries accumulate across all tool calls).
                const newCoarseEntry = {
                    startPos: action.startPos,
                    endPos: action.endPos,
                    slices: [
                        action.originalUserContentSlice,
                        action.newSlice
                    ],
                    appliedIndex: 1
                };
                return {
                    ...state,
                    aiContentPositions: [
                        ...state.aiContentPositions ?? [],
                        newCoarseEntry
                    ],
                    streamReviewSegments: streamReviewSegments.map((entry, i)=>{
                        if (i !== action.topLevelIndex) return entry;
                        // Reworking an undone segment discards the stale forward history:
                        // keep slices [0 .. appliedIndex] and append the new slice as the tail.
                        // e.g. [s1,s2,s3,s4] @1 → [s1,s2,s5] @2. Equivalent to a plain append
                        // when already at the tail.
                        const retainedSlices = entry.slices.slice(0, entry.appliedIndex + 1);
                        return {
                            ...entry,
                            slices: [
                                ...retainedSlices,
                                action.newSlice
                            ],
                            appliedIndex: retainedSlices.length,
                            startPos: action.startPos,
                            endPos: action.endPos,
                            // Diff-level segments are stale after replacing the whole top-level
                            // range with a newly reworked slice; they will be recomputed on reopen.
                            diffSegments: undefined
                        };
                    })
                };
            }
        // [CCI-15904] Ends the AI session but retains aiContentPositions so the
        // Post Stream Review toolbar can navigate them. Resets ephemeral stream
        // state (sessionId, status, adfResponse) but NOT the positions array.
        //
        // (afm-ai-pr-review-bot #8) Also clear `currentStreamReviewSegmentIndex`
        // and `currentStreamReviewAiOptIn` to defend against a brand-new AI
        // session starting before the user closes the post-stream-review
        // toolbar (which would otherwise hit `RESET`). Without clearing,
        // `buildCommitTransaction` could append fresh entries into a new
        // `aiContentPositions` array while the stale index from the previous
        // session points out-of-bounds into the shorter new array.
        case 'END_SESSION':
            {
                // [CCI-17658] For per-segment rework, preserve streamReviewSegments and
                // mode so update() / endAISession can reopen PSR at the correct segment.
                // reworkSnapshot is the authoritative signal that an active per-segment
                // rework is in progress.
                const isPerSegmentRework = !!state.reworkSnapshot;
                return {
                    ...state,
                    sessionId: undefined,
                    status: 'idle',
                    adfResponse: undefined,
                    markdown: undefined,
                    cancelRequested: false,
                    currentStreamReviewSegmentIndex: isPerSegmentRework ? state.currentStreamReviewSegmentIndex : undefined,
                    currentStreamReviewAiOptIn: undefined,
                    currentStreamReviewMode: isPerSegmentRework ? state.currentStreamReviewMode : undefined,
                    streamReviewSegments: isPerSegmentRework ? state.streamReviewSegments : undefined,
                    reworkSnapshot: undefined,
                    pendingForceAbortedToolCallId: undefined,
                    // Drop any lingering rework-range highlight when the session ends.
                    reworkHighlightRange: undefined,
                    // Clear so a subsequent update stream is treated as a normal review session.
                    isCreateSession: undefined,
                    // Clear so a subsequent session starts without a stale
                    // inline-edit flag leaking into its Post Stream Review gating.
                    isInlineEditSession: undefined,
                    agentAttribution: undefined
                };
            }
        case 'POST_STREAM_REVIEW':
            {
                let next = {
                    ...state,
                    status: 'postStreamReview',
                    // Re-opening the review supersedes the rework-range highlight; clear it so
                    // the reworked segment reverts to its normal review decoration.
                    reworkHighlightRange: undefined,
                    currentStreamReviewSegmentIndex: action.currentStreamReviewSegmentIndex,
                    currentStreamReviewMode: action.mode ?? state.currentStreamReviewMode ?? 'aggregate',
                    // Only overwrite the captured aiOptIn when the action provides one — keeps
                    // the originally-captured value across subsequent UPDATE_STREAM_REVIEW_SEGMENT
                    // re-opens (which are also dispatched as POST_STREAM_REVIEW from openAIModal).
                    currentStreamReviewAiOptIn: action.aiOptIn ?? state.currentStreamReviewAiOptIn
                };
                // Apply the optional Undo/Redo applied-index update in the SAME pass, so the
                // modal open and the state change are atomic (no follow-up dispatch). Each
                // `{ index, appliedIndex }` sets that fine `streamReviewSegments` entry's
                // applied slice; aggregate Undo/Redo passes many updates (only the segments
                // it re-applied — skipping accepted / already-in-state ones), step-through
                // passes one.
                if (action.appliedIndexUpdate) {
                    const byIndex = new Map(action.appliedIndexUpdate.updates.map((u)=>[
                            u.index,
                            u.appliedIndex
                        ]));
                    next = {
                        ...next,
                        streamReviewSegments: $30eb8b319e5e3080$var$mapDisplaySegments({
                            segments: next.streamReviewSegments ?? [],
                            transform: (entry, displayIndex)=>{
                                const nextIndex = byIndex.get(displayIndex);
                                return nextIndex === undefined ? undefined : {
                                    ...entry,
                                    appliedIndex: nextIndex
                                };
                            }
                        })
                    };
                }
                // Mark the accepted segment in the same pass as the re-open, so the
                // working set and the new anchor stay consistent.
                if (action.acceptedUpdate) {
                    const { acceptedUpdate: acceptedUpdate } = action;
                    next = {
                        ...next,
                        streamReviewSegments: $30eb8b319e5e3080$var$mapDisplaySegments({
                            segments: next.streamReviewSegments ?? [],
                            transform: (entry, displayIndex)=>displayIndex === acceptedUpdate.index ? {
                                    ...entry,
                                    isAccepted: true
                                } : undefined
                        })
                    };
                }
                // Overwrite the ranges of the segments aggregate Undo/Redo just
                // re-applied with authoritative positions. This runs AFTER the plugin's
                // generic remap (which cannot re-separate collapsed / coincident ranges),
                // so it is the last word on those entries' positions.
                if (action.positionsUpdate) {
                    const byIndex = new Map(action.positionsUpdate.positions.map((p)=>[
                            p.index,
                            p
                        ]));
                    next = {
                        ...next,
                        streamReviewSegments: $30eb8b319e5e3080$var$mapDisplaySegments({
                            segments: next.streamReviewSegments ?? [],
                            transform: (entry, displayIndex)=>{
                                const pos = byIndex.get(displayIndex);
                                return pos ? {
                                    ...entry,
                                    startPos: pos.startPos,
                                    endPos: pos.endPos
                                } : undefined;
                            }
                        })
                    };
                }
                return next;
            }
        case 'UPDATE_STREAM_REVIEW_SEGMENT':
            return {
                ...state,
                currentStreamReviewSegmentIndex: action.currentStreamReviewSegmentIndex
            };
        case 'UPDATE_AI_CONTENT_POSITION':
            {
                const next = (state.aiContentPositions ?? []).map((entry, i)=>i === action.index ? {
                        ...entry,
                        startPos: action.startPos,
                        endPos: action.endPos
                    } : entry);
                return {
                    ...state,
                    aiContentPositions: next
                };
            }
        // Remove a stored aborted tool call once it has been resumed.
        case 'CLEAR_ABORTED_TOOL_CALL_POSITION':
            {
                if (!state.abortedToolCallPositions?.[action.toolCallId]) return state;
                const { [action.toolCallId]: _removed, ...rest } = state.abortedToolCallPositions;
                return {
                    ...state,
                    abortedToolCallPositions: rest
                };
            }
        // Replace the fine step-through segment list (populate on
        // entering step-through, `[]` to clear on returning to aggregate).
        case 'SET_STREAM_REVIEW_SEGMENTS':
            return {
                ...state,
                streamReviewSegments: action.segments
            };
        // Store (or clear) the rework-range highlight, rendered mutually-exclusively
        // with the undone-segment gray.
        case 'SET_REWORK_HIGHLIGHT_RANGE':
            return {
                ...state,
                reworkHighlightRange: action.range ? {
                    startPos: action.range.startPos,
                    endPos: action.range.endPos
                } : undefined
            };
        default:
            return state;
    }
}





/**
 * [CCI-18182] Diff-based segmenting — eligibility check.
 *
 * Whether the Post Stream Review ("Review moment") splits a top-level change into
 * finer diff-level sub-segments (`diffSegments`) instead of segmenting at the
 * top-level node boundary only.
 *
 * This is now driven by the `isDiffBasedSegmentingEnabled` parameter on the
 * umbrella `platform_editor_ai_new_aifc_editor_experience` experiment (replacing
 * the former standalone `platform_editor_ai_diff_based_segmenting` feature gate),
 * so segmentation strategy is scoped to the same experiment that gates the whole
 * New AIFC experience.
 */ 


function $f950c5cf47a566c8$export$73358e70ed9d9f32() {
    return (0, $mW7G5.expValNoExposure)('platform_editor_ai_new_aifc_editor_experience', 'isDiffBasedSegmentingEnabled', false);
}



const $791e08ed291e7d74$export$526acb28b44097de = 'ai-undone-segment-highlight';
const $791e08ed291e7d74$export$5d4e19b46569fdae = 'ai-pre-stream-range-selection';
/**
 * Two ranges overlap when neither ends at or before the other starts. Used to
 * decide when the rework highlight supersedes an undone-segment gray for the
 * same region, so only one decoration ever paints there.
 */ const $791e08ed291e7d74$var$rangesOverlap = (a, b)=>a.startPos < b.endPos && b.startPos < a.endPos;
/**
 * Resolves the entries to shade, mirroring the PostStreamReview screen so the
 * decoration reads the same entries whose `appliedIndex` undo/redo mutates:
 *   - Gate ON + step-through: the flattened `diffSegments` leaves (skip accepted;
 *     fall back to the entry itself when it has no leaves).
 *   - Otherwise: the top-level `streamReviewSegments` (with `isUndoneSegment`
 *     collapsing leaf state for aggregate), falling back to the coarse
 *     `aiContentPositions` only when there are no fine segments yet.
 *
 * Using `aiContentPositions` in aggregate mode was the original bug: undo/redo
 * never writes `appliedIndex` there, so nothing was shaded.
 */ const $791e08ed291e7d74$var$getWorkingSet = (pluginState)=>{
    const topLevel = pluginState.streamReviewSegments;
    // No fine segments yet (e.g. a transient pre-bootstrap state): the coarse
    // commit ranges are all we have.
    if (!topLevel || topLevel.length === 0) return pluginState.aiContentPositions;
    const isStepThrough = pluginState.currentStreamReviewMode === 'stepThrough';
    // Diff-based segmenting ON + step-through: shade the flattened diff-level
    // leaves, matching the screen's `displaySegments` flatten.
    if (isStepThrough && (0, $f950c5cf47a566c8$export$73358e70ed9d9f32)()) return topLevel.filter((entry)=>!entry.isAccepted).flatMap((entry)=>entry.diffSegments ? entry.diffSegments.filter((leaf)=>!leaf.isAccepted) : [
            entry
        ]);
    // Gate OFF (either mode) or gate ON + aggregate: shade the top-level entries.
    return topLevel;
};
/**
 * A segment is "undone" when `appliedIndex === 0` (its original pre-AI content).
 * Accepted segments and zero-width ranges never qualify (nothing to shade, and
 * ProseMirror rejects an empty inline decoration).
 *
 * An aggregate parent carries undo state on its `diffSegments` leaves, so it is
 * "undone" only when every non-accepted leaf is itself undone.
 */ const $791e08ed291e7d74$var$isUndoneSegment = (entry)=>{
    if (entry.isAccepted || entry.endPos <= entry.startPos) return false;
    if (entry.diffSegments && entry.diffSegments.length > 0) {
        const reviewableLeaves = entry.diffSegments.filter((leaf)=>!leaf.isAccepted);
        return reviewableLeaves.length > 0 && reviewableLeaves.every((leaf)=>leaf.appliedIndex === 0);
    }
    return entry.appliedIndex === 0;
};
const $791e08ed291e7d74$export$9f95ee99aceaa7e = (doc, pluginState)=>{
    if (!(0, $a44d2501b233a83e$export$4d8717ba02388642)()) return (0, $8nvEM.DecorationSet).empty;
    const docSize = doc.content.size;
    const decorations = [];
    // The rework-range highlight. Not gated on `postStreamReview` — it must survive
    // the experience teardown that runs on re-prompt submit.
    const highlight = pluginState.reworkHighlightRange;
    let highlightRange;
    if (highlight) {
        const from = Math.max(0, Math.min(highlight.startPos, docSize));
        const to = Math.max(0, Math.min(highlight.endPos, docSize));
        if (from < to) {
            highlightRange = {
                startPos: from,
                endPos: to
            };
            decorations.push((0, $8nvEM.Decoration).inline(from, to, {
                class: $791e08ed291e7d74$export$5d4e19b46569fdae,
                'data-testid': $791e08ed291e7d74$export$5d4e19b46569fdae
            }, {
                key: $791e08ed291e7d74$export$5d4e19b46569fdae
            }));
        }
    }
    // The undone-segment gray only paints while the Post Stream Review toolbar is
    // open, so the decoration is torn down for free when the review closes.
    if (pluginState.status === 'postStreamReview') {
        const workingSet = $791e08ed291e7d74$var$getWorkingSet(pluginState);
        workingSet?.forEach((entry)=>{
            if (!$791e08ed291e7d74$var$isUndoneSegment(entry)) return;
            const from = entry.startPos;
            const to = entry.endPos;
            // Defend against a range that a transient state left outside the current
            // document — an inline decoration outside `[0, docSize]` throws.
            if (from < 0 || to > docSize || from >= to) return;
            // The highlight wins over the gray on the reworked range: skip any undone
            // segment overlapping the highlight so only one decoration renders there.
            if (highlightRange && $791e08ed291e7d74$var$rangesOverlap(highlightRange, {
                startPos: from,
                endPos: to
            })) return;
            decorations.push((0, $8nvEM.Decoration).inline(from, to, {
                class: $791e08ed291e7d74$export$526acb28b44097de,
                'data-testid': $791e08ed291e7d74$export$526acb28b44097de
            }, // Key on the (non-overlapping) range, not the array index: accepting a
            // segment removes it from the front of the working set and would shift
            // every later index, making ProseMirror destroy/recreate all surviving
            // decorations. A position-based key keeps their identity stable.
            {
                key: `${$791e08ed291e7d74$export$526acb28b44097de}-${from}-${to}`
            }));
        });
    }
    if (decorations.length === 0) return (0, $8nvEM.DecorationSet).empty;
    return (0, $8nvEM.DecorationSet).create(doc, decorations);
};
const $791e08ed291e7d74$export$40daf3730d7c63a0 = ()=>{
    let cachedSource;
    let cachedStatus;
    let cachedMode;
    let cachedHighlightRange;
    let cachedDoc;
    let cachedSet = (0, $8nvEM.DecorationSet).empty;
    return (doc, pluginState)=>{
        const hasFineSegments = !!pluginState.streamReviewSegments && pluginState.streamReviewSegments.length > 0;
        const source = hasFineSegments ? pluginState.streamReviewSegments : pluginState.aiContentPositions;
        if (source === cachedSource && pluginState.status === cachedStatus && pluginState.currentStreamReviewMode === cachedMode && pluginState.reworkHighlightRange === cachedHighlightRange && doc === cachedDoc) return cachedSet;
        cachedSet = $791e08ed291e7d74$export$9f95ee99aceaa7e(doc, pluginState);
        cachedSource = source;
        cachedStatus = pluginState.status;
        cachedMode = pluginState.currentStreamReviewMode;
        cachedHighlightRange = pluginState.reworkHighlightRange;
        cachedDoc = doc;
        return cachedSet;
    };
};


// [CCI-17994] How long to wait after the last BE-streaming agent-edit batch before
// opening the Review moment (unless the batch was flagged `complete`, which opens
// immediately). A plain constant — the spike is not gated behind an experiment.
const $e9cb9bc0694dd877$var$AGENT_REVIEW_DEBOUNCE_MS = 100;
const $e9cb9bc0694dd877$export$d4c72bab9d6cc13a = {
    adfResponse: undefined,
    status: 'idle',
    responseVersion: 0,
    streamPaused: false,
    hasUserScrolled: false,
    // [CCI-15904] New AIFC Editor Experience — tracks AI-produced top-level change
    // ranges across a single session for the Post Stream Review toolbar.
    aiContentPositions: [],
    // Positions of tool calls aborted by the queue timeout, keyed by id. Remapped
    // on every doc change and consumed on resume.
    abortedToolCallPositions: {},
    // Id of a tool call awaiting final-position capture in the next
    // buildCommitTransaction; cleared once captured.
    pendingForceAbortedToolCallId: undefined
};
const $e9cb9bc0694dd877$export$3332615281a18d68 = (options)=>{
    const { aiGlobalOptIn: aiGlobalOptIn, api: api, dispatch: dispatch, editorPluginAIProvider: editorPluginAIProvider, getIntl: getIntl, getMentionNameDetails: getMentionNameDetails } = options;
    // Per-plugin-instance memoised provider for the undone-segment
    // gray-background decoration. Created once here so its cache never leaks
    // across editor instances.
    const getUndoneSegmentDecorations = (0, $791e08ed291e7d74$export$40daf3730d7c63a0)();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $iN8Pe.aiSessionContextPluginKey),
        state: {
            init: ()=>$e9cb9bc0694dd877$export$d4c72bab9d6cc13a,
            apply: (tr, pluginState)=>{
                let nextState = pluginState;
                // [CCI-15904] Remap stored AI content positions through tr.mapping on every
                // doc-changing transaction so positions remain accurate across collab edits,
                // undo/redo, and subsequent AI tool-call commits within the same session.
                if (tr.docChanged && nextState.aiContentPositions?.length) {
                    const remapped = nextState.aiContentPositions.map((entry)=>{
                        const mappedStart = tr.mapping.map(entry.startPos, 1);
                        const mappedEnd = tr.mapping.map(entry.endPos, -1);
                        // The start/end biases (start after preceding inserts, end before
                        // following inserts) can cross when content is re-inserted exactly
                        // at the stored range — e.g. undoing a `remove` segment restores the
                        // removed content at that point, pushing `startPos` past `endPos` and
                        // leaving them swapped. Normalise so the lower value is always the
                        // start and the higher value the end, otherwise a subsequent redo
                        // resolves an inverted range and applies at the wrong position.
                        return {
                            ...entry,
                            startPos: Math.min(mappedStart, mappedEnd),
                            endPos: Math.max(mappedStart, mappedEnd)
                        };
                    });
                    nextState = {
                        ...nextState,
                        aiContentPositions: remapped
                    };
                }
                // Remap the fine step-through segments with the SAME bias
                // handling as `aiContentPositions`, so a per-segment undo/redo (which
                // changes the doc) keeps every OTHER fine segment's range accurate. This
                // is what makes per-segment undo/redo correct when one coarse commit was
                // split into multiple fine segments.
                // [CCI-17658] Also remap nested `diffSegments` so diff-level positions
                // stay accurate after doc changes.
                if (tr.docChanged && nextState.streamReviewSegments?.length) {
                    const remapEntry = (entry)=>{
                        const mappedStart = tr.mapping.map(entry.startPos, 1);
                        const mappedEnd = tr.mapping.map(entry.endPos, -1);
                        return {
                            ...entry,
                            startPos: Math.min(mappedStart, mappedEnd),
                            endPos: Math.max(mappedStart, mappedEnd),
                            diffSegments: entry.diffSegments?.map(remapEntry)
                        };
                    };
                    nextState = {
                        ...nextState,
                        streamReviewSegments: nextState.streamReviewSegments.map(remapEntry)
                    };
                }
                // Remap the rework-range highlight on doc change with the same
                // start-after/end-before bias as the other stored ranges.
                if (tr.docChanged && nextState.reworkHighlightRange) {
                    const mappedStart = tr.mapping.map(nextState.reworkHighlightRange.startPos, 1);
                    const mappedEnd = tr.mapping.map(nextState.reworkHighlightRange.endPos, -1);
                    nextState = {
                        ...nextState,
                        reworkHighlightRange: {
                            startPos: Math.min(mappedStart, mappedEnd),
                            endPos: Math.max(mappedStart, mappedEnd)
                        }
                    };
                }
                // Remap stored aborted-tool-call positions on every doc change so a
                // resumed tool call re-applies where it was originally working,
                // accounting for content other tool calls inserted/removed after it was
                // aborted. Same bias as aiContentPositions: start after preceding
                // inserts (1), end before following inserts (-1).
                if (tr.docChanged && nextState.abortedToolCallPositions) {
                    const ids = Object.keys(nextState.abortedToolCallPositions);
                    if (ids.length) {
                        const remappedAborted = {};
                        for (const id of ids){
                            const entry = nextState.abortedToolCallPositions[id];
                            remappedAborted[id] = {
                                startPos: tr.mapping.map(entry.startPos, 1),
                                aiContentEndPos: tr.mapping.map(entry.aiContentEndPos, -1)
                            };
                        }
                        nextState = {
                            ...nextState,
                            abortedToolCallPositions: remappedAborted
                        };
                    }
                }
                // [CCI-15904] Append a new AI content position entry when the transaction
                // carries the AI_FINAL_STREAMING_TRANSFORMATION_DATA meta.
                // Set by `buildCommitTransaction` when the New AIFC Editor Experience gate is ON.
                //
                // We intentionally do NOT gate this on `nextState.sessionId`: for quick actions
                // (Improve writing, Change tone, etc.) `startSession` is never called, so
                // `sessionId` is `undefined` even though `buildCommitTransaction` has fired and
                // `aiContentPositions` must still be populated for the Post Stream Review modal.
                const finalStreamData = tr.getMeta((0, $45a530918d906c25$export$fa15c525f457d46f));
                if (finalStreamData) {
                    const commitStart = finalStreamData.positions.mappedStartPos;
                    const commitEnd = finalStreamData.positions.mappedToPos;
                    const coarseEntry = {
                        startPos: commitStart,
                        endPos: commitEnd,
                        slices: [
                            finalStreamData.originalUserContentSlice,
                            finalStreamData.newSlice
                        ],
                        appliedIndex: 1,
                        kind: finalStreamData.kind
                    };
                    // [CCI-17658] Per-segment rework mutations are now carried on
                    // final-stream meta and reduced through explicit REWORK_* actions.
                    if (finalStreamData.reworkMutation && nextState.streamReviewSegments?.length) {
                        nextState = (0, $30eb8b319e5e3080$export$1650419e431d3ba3)({
                            state: nextState,
                            action: {
                                type: 'REWORK_APPEND_SLICE',
                                topLevelIndex: finalStreamData.reworkMutation.topLevelIndex,
                                startPos: commitStart,
                                endPos: commitEnd,
                                newSlice: finalStreamData.newSlice,
                                originalUserContentSlice: finalStreamData.originalUserContentSlice
                            }
                        });
                        nextState = {
                            ...nextState,
                            replaceNodeOriginalNode: undefined
                        };
                    } else // Fresh session: create a new entry as before.
                    nextState = {
                        ...nextState,
                        aiContentPositions: [
                            ...nextState.aiContentPositions ?? [],
                            coarseEntry
                        ],
                        replaceNodeOriginalNode: undefined
                    };
                }
                // Append coarse AI content position entries recorded by a
                // NON-STREAMABLE command handler (removeNode, setAttrs, move, wrap, ...).
                // These commands mutate the doc directly and never reach
                // `buildCommitTransaction`, so they stamp AI_CONTENT_SEGMENT_DATA instead.
                // Consumed identically to the streamable path so the Post Stream Review
                // modal can navigate / undo / redo them.
                const segmentData = tr.getMeta((0, $45a530918d906c25$export$ddd5126f1bcc0334));
                if (segmentData && segmentData.segments.length > 0) nextState = {
                    ...nextState,
                    aiContentPositions: [
                        ...nextState.aiContentPositions ?? [],
                        // [CCI-17658] Seed each non-streamable segment with [original, AI].
                        ...segmentData.segments.map((segment)=>({
                                startPos: segment.startPos,
                                endPos: segment.endPos,
                                slices: [
                                    segment.originalUserContentSlice,
                                    segment.newSlice
                                ],
                                appliedIndex: 1,
                                kind: segment.kind
                            }))
                    ]
                };
                // [CCI-17994] BE-streaming Review moment: collab-edit's `applyRemoteSteps`
                // recorded a batch of remote agent steps via the neutral
                // `AGENT_REMOTE_EDIT_REVIEW_DATA` meta (editor-common). Append coarse
                // `aiContentPositions` entries exactly like the FE streaming path, so the
                // whole Review moment pipeline is reused. Bump the nonce so `view()` can
                // (re)arm the open debounce (or the already-open PSR screen can append the
                // change).
                //
                // Requester-scoped: agent steps reach every collaborator, so only the
                // requester's client records (and thus opens) the Review moment.
                // `isLocalUserRequester` is fail-closed (`undefined` ⇒ not the requester).
                const agentRemoteEditData = tr.getMeta((0, $jdUP6.AGENT_REMOTE_EDIT_REVIEW_DATA));
                if (agentRemoteEditData && agentRemoteEditData.isLocalUserRequester && agentRemoteEditData.segments.length > 0) nextState = {
                    ...nextState,
                    aiContentPositions: [
                        ...nextState.aiContentPositions ?? [],
                        ...agentRemoteEditData.segments.map((segment)=>({
                                startPos: segment.startPos,
                                endPos: segment.endPos,
                                slices: [
                                    segment.originalSlice,
                                    segment.newSlice
                                ],
                                appliedIndex: 1,
                                kind: segment.kind
                            }))
                    ],
                    agentRemoteEditNonce: (nextState.agentRemoteEditNonce ?? 0) + 1,
                    agentRemoteEditComplete: !!agentRemoteEditData.complete
                };
                // Store the node a `replaceNode` command recorded so
                // `buildMountTransaction` can rebuild an accurate single-node
                // `originalUserContentSlice`. Transient field only — not a reviewable
                // segment, so `aiContentPositions` is untouched.
                const originalNodeData = tr.getMeta((0, $45a530918d906c25$export$14effd2e9e406215));
                if (originalNodeData) nextState = {
                    ...nextState,
                    replaceNodeOriginalNode: originalNodeData.originalNode
                };
                // Persist a force-finished tool call's final positions from the meta
                // stamped by `buildCommitTransaction`. Stored by id (then remapped on
                // every later doc change above); captured exactly once.
                const capturedAbortedPositions = tr.getMeta((0, $45a530918d906c25$export$3ce83cf64ed42309));
                if (capturedAbortedPositions) nextState = {
                    ...nextState,
                    abortedToolCallPositions: {
                        ...nextState.abortedToolCallPositions,
                        [capturedAbortedPositions.toolCallId]: {
                            startPos: capturedAbortedPositions.startPos,
                            aiContentEndPos: capturedAbortedPositions.aiContentEndPos
                        }
                    },
                    pendingForceAbortedToolCallId: undefined
                };
                // Existing behaviour — process dispatched plugin-key actions.
                const meta = tr.getMeta((0, $iN8Pe.aiSessionContextPluginKey));
                if (meta) nextState = (0, $30eb8b319e5e3080$export$1650419e431d3ba3)({
                    state: nextState,
                    action: meta
                });
                if (nextState !== pluginState) dispatch((0, $iN8Pe.aiSessionContextPluginKey), nextState);
                return nextState;
            }
        },
        props: {
            // Shade every undone Post Stream Review segment
            // (`appliedIndex === 0`) with a gray background, so undoing a segment
            // has a visible cue in the document. Derived from this plugin's own
            // state (which `apply()` remaps on every doc change) via a memoised
            // provider, so navigation transactions that don't change the doc reuse
            // the cached set instead of reallocating one on every view update.
            decorations (editorState) {
                const pluginState = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorState);
                if (!pluginState) return null;
                return getUndoneSegmentDecorations(editorState.doc, pluginState);
            }
        },
        /**
		 * When all prompts are migrated to use the orchestrator, this entire view can be removed.
		 */ view: ()=>{
            // Replaced on stop: a stopped stream's request keeps running and pushing into
            // its pacer, which would otherwise emit into the next stream's session.
            // One-chunk apply has nothing to pace, so the response is delivered as soon
            // as the request drains.
            let streamFlowPacer = (0, $26297e2ea9adfacc$export$ea74cb3f95fdbd46)() ? null : (0, $db676d2be4cae1a7$export$9ea8217d5ec56f82)();
            // Owned here so a stop can abort mid-flight — `createStreaming` only returns
            // its abort cleanup once the response has fully drained.
            let abortController = (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) ? new AbortController() : undefined;
            let abortStreaming;
            let hasStartedStreaming = false;
            // Streaming setup is async; if cancel/reset happens before cleanup is available,
            // this "sticky" flag ensures we abort immediately once cleanup resolves.
            // It also guards against late/buffered events reactivating plugin state after cancel/reset.
            let cancelled = false;
            // [CCI-17994] BE-streaming Review moment open debounce. Armed in update()
            // when a remote agent-edit batch is recorded (nonce change); fires
            // `openAgentReview` once the agent settles.
            let agentReviewTimer;
            const clearAgentReviewTimer = ()=>{
                if (agentReviewTimer !== undefined) {
                    clearTimeout(agentReviewTimer);
                    agentReviewTimer = undefined;
                }
            };
            const openAgentReview = (targetView)=>{
                if (targetView.isDestroyed) return;
                // The Review moment reuses the FE streaming screen, which only renders
                // under the New AIFC Editor Experience — so BE review requires those gates
                // on too. Bail (rather than open a broken legacy screen) otherwise.
                if (!(0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)()) return;
                const latest = (0, $iN8Pe.aiSessionContextPluginKey).getState(targetView.state);
                const positions = latest?.aiContentPositions ?? [];
                const baseGenerate = editorPluginAIProvider.baseGenerate;
                if (!positions.length || !baseGenerate) return;
                // Opening the modal sets a `configItem` on the decoration plugin, which the
                // streaming trigger below would otherwise mistake for "start a new stream".
                // Mark streaming as started so that path stays inert for this review-only
                // open (reset by `cancelStreaming` when the review closes and status returns
                // to idle).
                hasStartedStreaming = true;
                // Aggregate over every recorded change, anchored below the last one —
                // mirrors the FE quick-action auto-open.
                const aggregateStart = Math.min(...positions.map((entry)=>entry.startPos));
                const aggregateEnd = Math.max(...positions.map((entry)=>entry.endPos));
                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                    editorView: targetView,
                    baseGenerate: baseGenerate,
                    aiOptIn: aiGlobalOptIn,
                    mode: 'aggregate',
                    segmentData: {
                        segmentIndex: positions.length - 1,
                        positions: {
                            startPos: aggregateStart,
                            endPos: aggregateEnd
                        }
                    }
                });
            };
            const cancelStreaming = ()=>{
                cancelled = true;
                hasStartedStreaming = false;
                if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true)) {
                    streamFlowPacer?.destroy();
                    streamFlowPacer = (0, $26297e2ea9adfacc$export$ea74cb3f95fdbd46)() ? null : (0, $db676d2be4cae1a7$export$9ea8217d5ec56f82)();
                    abortController?.abort();
                    abortController = new AbortController();
                }
                if (abortStreaming) {
                    abortStreaming();
                    abortStreaming = undefined;
                }
            };
            return {
                update (view, previousState) {
                    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
                    const prevSessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(previousState);
                    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
                    const prevDecorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(previousState);
                    // [CCI-17994] BE-streaming Review moment. A remote agent-edit batch was
                    // recorded on this (the requester's) client — the nonce changed. Debounce
                    // so the Review moment opens once the agent settles (no new batch for
                    // `reviewDebounceMs`); a batch flagged terminal by the backend (hybrid)
                    // opens immediately. Placed before the idle-return below because BE
                    // streaming leaves `status` idle (no FE session was ever started).
                    const agentNonce = sessionState?.agentRemoteEditNonce;
                    if (agentNonce !== undefined && agentNonce !== prevSessionState?.agentRemoteEditNonce) {
                        clearAgentReviewTimer();
                        // When the Review moment is already open, a new agent batch is
                        // appended to the LIVE review by the PSR screen (it recomputes
                        // streamReviewSegments off the grown aiContentPositions). Nothing to
                        // open/debounce here — only drive the open when review is not yet showing.
                        if (sessionState?.status !== 'postStreamReview') {
                            if (sessionState?.agentRemoteEditComplete) openAgentReview(view);
                            else agentReviewTimer = setTimeout(()=>{
                                agentReviewTimer = undefined;
                                openAgentReview(view);
                            }, $e9cb9bc0694dd877$var$AGENT_REVIEW_DEBOUNCE_MS);
                        }
                    }
                    // Handle cancel request - detect when cancelRequested flag was just set
                    const cancelJustRequested = sessionState?.cancelRequested && !prevSessionState?.cancelRequested;
                    if (cancelJustRequested) cancelStreaming();
                    // Reset streaming flag and abort any in-flight request when session ends
                    // This handles both explicit cancel and implicit reset
                    if (sessionState?.status === 'idle') {
                        cancelStreaming();
                        return;
                    }
                    // For the fallback free-gen path: reset session state after finalize completes.
                    // The 'complete' event handler defers the reset so buildCommitTransaction can
                    // still read markdown/idMap from session state during the finalize flow.
                    // Once finalize is done (hasFinalStream: true), it's safe to reset.
                    if (sessionState?.status === 'complete' && sessionState?.userInput !== undefined) {
                        const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(view.state);
                        if (streamingState?.hasFinalStream) {
                            api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
                            return;
                        }
                    }
                    // When streamPaused changes, pause or resume the pacer so the discard screen can stop delivery
                    if (sessionState?.streamPaused !== prevSessionState?.streamPaused) {
                        if (sessionState?.streamPaused) streamFlowPacer?.pause();
                        else streamFlowPacer?.resume();
                    }
                    // Detect when we should start streaming:
                    // - configItem just became available (decoration state changed)
                    // - Not a Rovo/orchestrator prompt
                    // - Haven't already started streaming for this session
                    const configItemJustSet = decorationState?.configItem && !prevDecorationState?.configItem;
                    const shouldStartStream = configItemJustSet && decorationState?.positions && !hasStartedStreaming && !(0, $i2EU6.configItemUsesRovo)(decorationState.configItem?.key);
                    // Detect when the fallback free-gen prompt submits user input.
                    // This happens when START_FREE_GEN_STREAM action is dispatched from the PromptScreen
                    // for products that don't have Rovo/onSubmit (e.g. Jira, Bitbucket).
                    const freeGenStreamJustStarted = sessionState?.status === 'streaming' && prevSessionState?.status === 'prompt' && sessionState?.userInput !== undefined && !hasStartedStreaming && decorationState?.configItem && decorationState?.positions;
                    if (!shouldStartStream && !freeGenStreamJustStarted) return;
                    if (!decorationState?.configItem || !decorationState?.positions) return;
                    hasStartedStreaming = true;
                    cancelled = false;
                    // Create the streaming handler
                    // Note: Analytics for streaming is handled separately via the AnalyticsFlow context
                    // in the React layer. This needs fixing
                    const streamingHandler = (0, $a1b48c6cfd5555d3$export$ad256dcfbe275ed5)({
                        abortController: abortController,
                        fireAIAnalyticsEvent: ()=>{},
                        streamFlowPacer: streamFlowPacer
                    });
                    // Build the request context
                    const positions = decorationState.positions;
                    const isEmpty = positions[0] === positions[1];
                    const selectionType = isEmpty ? 'empty' : 'range';
                    const context = {
                        aiProvider: editorPluginAIProvider,
                        intl: getIntl(),
                        editorView: view,
                        positions: positions,
                        isEmpty: isEmpty,
                        selectionType: selectionType,
                        configItem: decorationState.configItem,
                        userInput: freeGenStreamJustStarted ? sessionState?.userInput ?? '' : '',
                        analyticsContext: {
                            aiSessionId: '',
                            aiGroupId: ''
                        },
                        usePageKnowledge: true,
                        getMentionNameDetails: getMentionNameDetails,
                        responseHistory: {
                            entries: [],
                            positionFromEnd: 0,
                            totalSize: 0,
                            traversals: 0
                        }
                    };
                    // Block streaming publishes whole blocks only, so the document snaps forward
                    // a block at a time instead of character by character. The latest chunk is
                    // retained as a fallback for terminal events that arrive without content.
                    const blockStreaming = (0, $26297e2ea9adfacc$export$ea74cb3f95fdbd46)();
                    let resolved = {};
                    let publishedBlocks = 0;
                    // Invoke streaming and bridge events to session context
                    streamingHandler(context, (event)=>{
                        if (cancelled) return;
                        switch(event.type){
                            case 'stream':
                                if (event.adfResponse || event.markdown) {
                                    if (blockStreaming) {
                                        resolved = {
                                            adfResponse: event.adfResponse,
                                            markdown: event.markdown
                                        };
                                        // Publish only whole blocks, so the document snaps forward a
                                        // block at a time rather than character by character. The
                                        // trailing block is withheld until the stream terminates.
                                        const completeBlocks = (0, $9fa3fcf4cc54f7dd$export$fff40d0cad772fa)(resolved);
                                        if (completeBlocks > publishedBlocks) {
                                            publishedBlocks = completeBlocks;
                                            api?.core?.actions.execute((0, $7791c10173ad9c87$export$7f430c6835f5abe7)({
                                                type: 'stream',
                                                ...(0, $9fa3fcf4cc54f7dd$export$96fa9ba16a212ed9)(resolved, completeBlocks)
                                            }));
                                        }
                                        break;
                                    }
                                    api?.core?.actions.execute((0, $7791c10173ad9c87$export$7f430c6835f5abe7)({
                                        type: 'stream',
                                        adfResponse: event.adfResponse,
                                        markdown: event.markdown
                                    }));
                                }
                                break;
                            case 'complete':
                                resolved = blockStreaming ? {
                                    adfResponse: event.adfResponse ?? resolved.adfResponse,
                                    markdown: event.markdown ?? resolved.markdown
                                } : {
                                    adfResponse: event.adfResponse,
                                    markdown: event.markdown
                                };
                                // The finaliser only commits after the session has passed through
                                // `streaming`. A single-block response never reaches a block
                                // boundary mid-stream, so the response is published as one stream
                                // immediately before completing.
                                if (blockStreaming && publishedBlocks === 0 && (resolved.adfResponse || resolved.markdown)) api?.core?.actions.execute((0, $7791c10173ad9c87$export$7f430c6835f5abe7)({
                                    type: 'stream',
                                    adfResponse: resolved.adfResponse,
                                    markdown: resolved.markdown
                                }));
                                if (resolved.adfResponse || resolved.markdown) api?.core?.actions.execute((0, $7791c10173ad9c87$export$55e78bff62ceea68)({
                                    type: 'complete',
                                    adfResponse: resolved.adfResponse,
                                    markdown: resolved.markdown
                                }));
                                // Free-gen path keeps session state alive for the UI layer to reset
                                // after accept/reject.
                                if (!freeGenStreamJustStarted) {
                                    // [CCI-15904] Quick-action path: END_SESSION (retains
                                    // aiContentPositions) + auto-open Post Stream Review modal.
                                    // Only valid when this 'complete' event carried content (otherwise
                                    // stale positions from a prior session could be reused) AND
                                    // baseGenerate is present (needed by SHOW_MODAL). Otherwise fall
                                    // back to RESET so positions don't leak into the next session.
                                    const baseGenerate = editorPluginAIProvider.baseGenerate;
                                    const hasContent = !!(resolved.adfResponse || resolved.markdown);
                                    // Auto-open the Post Stream Review modal, gated by
                                    // `isFrontendReviewMomentEnabled`; otherwise FE edits apply and the
                                    // session resets.
                                    if ((0, $84d40fd50758b97d$export$8ce0619a5b63e89e)() && (0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)() && baseGenerate && hasContent) // Two microtasks: (1) let END_SESSION commit; (2) let the
                                    // reducer apply it before reading aiContentPositions.
                                    (async ()=>{
                                        await Promise.resolve();
                                        if (view.isDestroyed) return;
                                        api?.core?.actions.execute($e9cb9bc0694dd877$export$8d4021544bdece00({
                                            type: 'END_SESSION'
                                        }));
                                        await Promise.resolve();
                                        if (view.isDestroyed) return;
                                        const latestSessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
                                        const reviewSegments = latestSessionState?.streamReviewSegments ?? [];
                                        if (reviewSegments.length) {
                                            const displaySegments = reviewSegments.flatMap((segment)=>segment.diffSegments?.length ? segment.diffSegments : [
                                                    segment
                                                ]);
                                            const desiredIndex = latestSessionState?.currentStreamReviewSegmentIndex ?? 0;
                                            const segmentIndex = displaySegments.length > 0 ? Math.max(0, Math.min(desiredIndex, displaySegments.length - 1)) : 0;
                                            const segment = displaySegments[segmentIndex];
                                            if (segment) {
                                                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                                                    editorView: view,
                                                    baseGenerate: baseGenerate,
                                                    aiOptIn: aiGlobalOptIn,
                                                    segmentData: {
                                                        segmentIndex: segmentIndex,
                                                        positions: {
                                                            startPos: segment.startPos,
                                                            endPos: segment.endPos
                                                        }
                                                    }
                                                });
                                                return;
                                            }
                                        }
                                        if (latestSessionState?.aiContentPositions?.length) (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                                            editorView: view,
                                            baseGenerate: baseGenerate,
                                            aiOptIn: aiGlobalOptIn,
                                            mode: 'aggregate'
                                        });
                                    })();
                                    else api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
                                }
                                break;
                            case 'response too similar':
                                api?.core?.actions.execute((0, $7791c10173ad9c87$export$55e78bff62ceea68)({
                                    type: 'complete',
                                    responseTooSimilar: true
                                }));
                                break;
                            case 'error':
                                if (event.errorInfo) api?.core?.actions.execute((0, $7791c10173ad9c87$export$e40a87860316fbc4)(event));
                                break;
                            case 'update traceIds':
                                if (event.traceIds) api?.core?.actions.execute((0, $7791c10173ad9c87$export$bccaa00f011961e4)(event.traceIds));
                                break;
                            case 'update idMap':
                                if (event.context?.idMap) api?.core?.actions.execute((0, $7791c10173ad9c87$export$bb7a833936265787)(event.context.idMap));
                                break;
                            default:
                                break;
                        }
                    }).then((cleanup)=>{
                        if (!cleanup) return;
                        // If cancel/reset happened before cleanup was available, abort immediately.
                        if (cancelled) {
                            cleanup();
                            abortStreaming = undefined;
                            return;
                        }
                        abortStreaming = cleanup;
                    });
                },
                destroy () {
                    clearAgentReviewTimer();
                    abortStreaming?.();
                    streamFlowPacer?.destroy();
                }
            };
        }
    });
};
const $e9cb9bc0694dd877$export$cfaa4734e6c82b = (state)=>{
    return (0, $iN8Pe.aiSessionContextPluginKey).getState(state);
};
const $e9cb9bc0694dd877$export$8d4021544bdece00 = (action)=>{
    return ({ tr: tr })=>{
        return tr.setMeta((0, $iN8Pe.aiSessionContextPluginKey), action);
    };
};













var $iLrhi = parcelRequire("iLrhi");




const $d89673b86ea8a220$export$6183e81dd2ece439 = new (0, $kCECX.PluginKey)('aiSmartButtonAPI');






const $df9c0a7fc80e5d7e$export$1650419e431d3ba3 = (pluginState)=>{
    return pluginState;
};


const $dd550578280a6550$export$de5e90bd767c5d82 = ()=>{
    return {};
};
const $dd550578280a6550$var$dest = (0, $cI8RZ.pluginFactory)((0, $d89673b86ea8a220$export$6183e81dd2ece439), (0, $df9c0a7fc80e5d7e$export$1650419e431d3ba3), {});
const $dd550578280a6550$export$656c7661095efe2e = $dd550578280a6550$var$dest.createPluginState;
const $dd550578280a6550$export$8d4021544bdece00 = $dd550578280a6550$var$dest.createCommand;
const $dd550578280a6550$export$f05434c51e3762e = $dd550578280a6550$var$dest.getPluginState;






var $320o0 = parcelRequire("320o0");


var $6iWVH = parcelRequire("6iWVH");




function $56efd96c77d8de36$var$convertConfigItemToAction({ config: config, aiGlobalOptIn: aiGlobalOptIn, intl: intl, view: view, isChild: isChild }) {
    return {
        id: config.key.toString(),
        title: intl.formatMessage(config.title),
        description: intl.formatMessage(config.description),
        icon: ()=>config.icon?.({
                formatMessage: intl.formatMessage
            }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                label: "",
                spacing: "spacious"
            }),
        onClick: ()=>{
            view.focus();
            (0, $4TgUg.createOpenAIModalCommand)({
                state: view.state,
                configItem: config,
                lastTriggeredFrom: 'rovoButton',
                aiGlobalOptIn: aiGlobalOptIn,
                locale: intl.locale
            })(view.state, view.dispatch);
        },
        closePanelOnSelection: true,
        handleType: (0, $6iWVH.HandleActionType).Base,
        type: 'ai-action',
        isChild: isChild
    };
}
const $56efd96c77d8de36$export$57ef315382487c5f = ({ intl: intl, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, aiGlobalOptIn: aiGlobalOptIn })=>(view)=>{
        const parentConfigItems = dynamicSurfaceConfigItems.reduce((accumulator, configItem)=>{
            const nestingConfig = configItem.config.nestingConfig;
            if (nestingConfig) {
                if (!accumulator[nestingConfig.id]) accumulator[nestingConfig.id] = [];
                accumulator[nestingConfig.id].push(configItem);
            }
            return accumulator;
        }, {});
        const processedParentConfigItem = [];
        const actions = [];
        dynamicSurfaceConfigItems.forEach(({ config: config })=>{
            if (config.nestingConfig) {
                if (!processedParentConfigItem.includes(config.nestingConfig.id)) {
                    processedParentConfigItem.push(config.nestingConfig.id);
                    const childrenConfigItems = parentConfigItems[config.nestingConfig.id];
                    const childrenActions = childrenConfigItems.map((configItem)=>$56efd96c77d8de36$var$convertConfigItemToAction({
                            config: configItem.config,
                            aiGlobalOptIn: aiGlobalOptIn,
                            intl: intl,
                            view: view,
                            isChild: true
                        }));
                    actions.push({
                        id: config.nestingConfig.id,
                        title: intl.formatMessage(config.nestingConfig.parentTitle),
                        description: intl.formatMessage(config.nestingConfig.parentTitle),
                        icon: ()=>config.nestingConfig?.icon?.({
                                formatMessage: intl.formatMessage
                            }) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                                label: "",
                                spacing: "spacious"
                            }),
                        actionHeading: intl.formatMessage(config.nestingConfig.parentTitle),
                        children: childrenActions,
                        handleType: (0, $6iWVH.HandleActionType).Nested,
                        type: 'ai-action'
                    });
                }
            } else actions.push($56efd96c77d8de36$var$convertConfigItemToAction({
                config: config,
                aiGlobalOptIn: aiGlobalOptIn,
                intl: intl,
                view: view
            }));
        });
        return actions;
    };
function $56efd96c77d8de36$export$7ffd1e30b4d91091(dynamicSurfaceConfigItems) {
    /**
   * Empty document config items are for prompts:
   * - which can run when document is empty. Currently we have only one empty prompt - Brainstorm.
   */ const emptyDocConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const emptyTrigger = configWithOptions.triggers.empty;
        return emptyTrigger && emptyTrigger.enabled && emptyTrigger.docMinSize === 0;
    });
    /**
   * Non empty document, but selection without content config items are for prompts:
   * - which can run only on non-empty documents (e.g improve writing, change tone etc)
   */ const nonEmptyDocConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const emptyTrigger = configWithOptions.triggers.empty;
        return emptyTrigger.enabled && (!emptyTrigger.docMinSize || emptyTrigger.docMinSize >= 0);
    });
    /**
   * Selection with content config items are for prompts:
   * - which can run only on selection (e.g Convert to table, convert to bullet list etc)
   */ const selectionConfigItems = dynamicSurfaceConfigItems.filter((configWithOptions)=>{
        const selectionTrigger = configWithOptions.triggers.selection;
        return selectionTrigger.enabled && (!selectionTrigger.selectionMinSize || selectionTrigger.selectionMinSize >= 0);
    });
    return {
        emptyDocConfigItems: emptyDocConfigItems,
        nonEmptyDocConfigItems: nonEmptyDocConfigItems,
        selectionConfigItems: selectionConfigItems
    };
}
function $56efd96c77d8de36$export$6dd4d7c2a3a49de7({ intl: intl, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, aiGlobalOptIn: aiGlobalOptIn, view: view }) {
    const { emptyDocConfigItems: emptyDocConfigItems, nonEmptyDocConfigItems: nonEmptyDocConfigItems, selectionConfigItems: selectionConfigItems } = $56efd96c77d8de36$export$7ffd1e30b4d91091(dynamicSurfaceConfigItems);
    const emptyDocActions = $56efd96c77d8de36$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: emptyDocConfigItems,
        intl: intl
    })(view);
    const nonEmptyDocActions = $56efd96c77d8de36$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: nonEmptyDocConfigItems,
        intl: intl
    })(view);
    const selectionActions = $56efd96c77d8de36$export$57ef315382487c5f({
        aiGlobalOptIn: aiGlobalOptIn,
        dynamicSurfaceConfigItems: selectionConfigItems,
        intl: intl
    })(view);
    return {
        emptyDocActions: emptyDocActions,
        nonEmptyDocActions: nonEmptyDocActions,
        selectionActions: selectionActions
    };
}
function $56efd96c77d8de36$export$3bfcc298ac0016df({ isEmptyDoc: isEmptyDoc, isEmptySelection: isEmptySelection }, { emptyDocActions: emptyDocActions, nonEmptyDocActions: nonEmptyDocActions, selectionActions: selectionActions }) {
    if (isEmptyDoc) return emptyDocActions;
    else if (isEmptySelection) return nonEmptyDocActions;
    else return selectionActions;
}


const $881b2dad70775fce$export$b43aba46e2a0894 = ({ aiGlobalOptIn: aiGlobalOptIn, aiSmartButtonOptions: aiSmartButtonOptions, dispatch: dispatch, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems, getIntl: getIntl, api: // Optional options
api })=>{
    const intl = getIntl();
    const { removeActions: removeActions, removeContext: removeContext, setActions: setActions, setContext: setContext } = aiSmartButtonOptions.actions;
    function isInEditMode() {
        const editorViewModeState = api?.editorViewMode?.sharedState.currentState();
        const mode = editorViewModeState?.mode;
        const isInEditMode = !!(mode && mode === 'edit');
        return isInEditMode;
    }
    return new (0, $kpCD8.SafePlugin)({
        state: (0, $dd550578280a6550$export$656c7661095efe2e)(dispatch, (0, $dd550578280a6550$export$de5e90bd767c5d82)()),
        key: (0, $d89673b86ea8a220$export$6183e81dd2ece439),
        view: (editorView)=>{
            const { emptyDocActions: emptyDocActions, nonEmptyDocActions: nonEmptyDocActions, selectionActions: selectionActions } = (0, $56efd96c77d8de36$export$6dd4d7c2a3a49de7)({
                aiGlobalOptIn: aiGlobalOptIn,
                dynamicSurfaceConfigItems: dynamicSurfaceConfigItems,
                intl: intl,
                view: editorView
            });
            // Track the edit mode state
            let wasInEditMode = isInEditMode();
            // Track the doc state and selection state to avoid resetting actions unnecessarily
            let wasDocumentEmpty = (0, $iLrhi.isEmptyDocument)(editorView.state.doc);
            let wasSelectionEmpty = editorView.state.selection.empty;
            let wasCleanedUp = false;
            // Register editor actions only in edit page or edit mode of live page.
            if (wasInEditMode) setActions((0, $56efd96c77d8de36$export$3bfcc298ac0016df)({
                isEmptyDoc: (0, $iLrhi.isEmptyDocument)(editorView.state.doc),
                isEmptySelection: editorView.state.selection.empty
            }, {
                emptyDocActions: emptyDocActions,
                nonEmptyDocActions: nonEmptyDocActions,
                selectionActions: selectionActions
            }));
            const reference = intl.formatMessage((0, $7ZL6d.aiMessages).aiSmartButtonDynamicSurfaceSelectedContent);
            /**
			 * On removing reference, focus the editor.
			 */ const onRemoveReference = ()=>{
                editorView.focus();
            };
            function cleanup() {
                removeActions();
                removeContext();
                wasCleanedUp = true;
            }
            return {
                update: (editorView, prevState)=>{
                    const currentEditorState = editorView.state;
                    const currentlyInEditMode = isInEditMode();
                    const switchedFromViewToEdit = !wasInEditMode && currentlyInEditMode;
                    /**
					 * Switching from edit to view mode, we need to remove
					 * 	all actions, context and nudges.
					 */ if (wasInEditMode && !currentlyInEditMode) cleanup();
                    wasInEditMode = currentlyInEditMode;
                    if (!currentlyInEditMode) return;
                    /**
					 * Switching from view mode to edit mode, editor state doesn't change.
					 * But editing actions must be added again as it had been removed
					 * 	when transitioning to edito -> view mode.
					 */ if (currentEditorState.doc.eq(prevState.doc) && currentEditorState.selection.empty === prevState.selection.empty && !switchedFromViewToEdit) return;
                    /**
					 * Update;
					 * - registry of editor actions
					 * - context on selection change
					 * - nudges related stuff
					 * only in edit page or edit mode of live page.
					 */ const isCurrentSelectionEmpty = currentEditorState.selection.empty;
                    const isCurrentDocEmpty = (0, $iLrhi.isEmptyDocument)(currentEditorState.doc);
                    // only reset actions if the selection or document state has changed
                    // this avoids unnecessary re-renders for editor
                    if (wasCleanedUp || isCurrentSelectionEmpty !== wasSelectionEmpty || isCurrentDocEmpty !== wasDocumentEmpty) {
                        setActions((0, $56efd96c77d8de36$export$3bfcc298ac0016df)({
                            isEmptyDoc: isCurrentDocEmpty,
                            isEmptySelection: isCurrentSelectionEmpty
                        }, {
                            emptyDocActions: emptyDocActions,
                            nonEmptyDocActions: nonEmptyDocActions,
                            selectionActions: selectionActions
                        }));
                        wasSelectionEmpty = isCurrentSelectionEmpty;
                        wasDocumentEmpty = isCurrentDocEmpty;
                        wasCleanedUp = false;
                    }
                    /**
					 * Check for dynamic surface context change on every selection change.
					 * Not using onSelectionChanged in pluginFactory because
					 * it will be called only when selection changes by current user.
					 */ if (!currentEditorState.selection.empty) setContext({
                        reference: reference,
                        onRemove: onRemoveReference,
                        sourceId: 'editor'
                    });
                    else removeContext();
                },
                destroy: ()=>{
                    cleanup();
                }
            };
        }
    });
};



var $ldqjS = parcelRequire("ldqjS");


var $2w79Z = parcelRequire("2w79Z");












function $8d596894ab69be92$export$1f64fead470ce6a8(options) {
    return (0, $44cyU.keymap)({
        [`${(0, $ldqjS.space).common}`]: (state, dispatch, view)=>{
            if (!view) return false;
            const { from: from, to: to, $to: $to } = state.selection;
            if (options.editorPluginAIProvider.isInDocumentStreamingEnabled ? from === to && (0, $2w79Z.isEmptyParagraph)($to.parent) && (0, $2w79Z.hasDocAsParent)($to) : (0, $iLrhi.isEmptyDocument)(state.doc)) {
                const { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn } = options;
                const configItem = editorPluginAIProvider.baseGenerate;
                const { ignoredSpaceTriggerSelection: ignoredSpaceTriggerSelection } = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {};
                if (ignoredSpaceTriggerSelection) try {
                    if (state.selection.eq(ignoredSpaceTriggerSelection)) // If there's an ignored selection set for the space trigger, then we want to avoid opening the AI modal
                    // if it's trying to be opened at the same selection again. This is to stop situations where a users
                    // opens by space and immediately presses Esc or space again. We want to allow them to use the editor as normal.
                    return false;
                } catch  {
                // Default to opening the modal as usual.
                }
                const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                    state: state,
                    configItem: configItem,
                    lastTriggeredFrom: 'spaceShortcut',
                    triggerMethod: 'shortcut',
                    aiGlobalOptIn: aiGlobalOptIn,
                    locale: options.getIntl().locale
                });
                // We must delay calling this command so that the experiences is mounted in a new stack, otherwise the keybindings
                // in the react modal will pickup this keypress and cause headaches for key tracking.
                setTimeout(()=>openAIModalCommand(state, dispatch), 0);
                return true;
            }
            return false;
        }
    });
}





















var $dSwlt = parcelRequire("dSwlt");

const $b9d05cd7c3f54216$export$f5369c92191ba6f = (view, event)=>{
    const pluginState = (0, $C4yPo.getPluginState)(view.state);
    // [CCI-15904] When the Post Stream Review modal is open we *want* the
    // AI-generated content decorations to stay around — the modal is anchored to
    // them. Without this guard, every click on a toolbar button (Undo, Redo, Ask
    // Rovo, Take to Staging, etc.) would dispatch endAIExperience and tear the
    // modal down before the button's onClick had a chance to run.
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
    if (sessionState?.status === 'postStreamReview') return false;
    if ((0, $dSwlt.hasGeneratedContentDecorations)(pluginState)) {
        const endAIExperienceCommand = (0, $4TgUg.createEndAIExperienceCommand)();
        endAIExperienceCommand(view.state, view.dispatch);
        return true;
    }
    return false;
};





const $fcfe92bbc4662171$export$6181eb45d9edf6d3 = (getPluginState, api)=>()=>{
        // If the plugin doesn't exist let's avoid running this code.
        if (!api?.selectionMarker) return {};
        let releaseSelectionMarker;
        return {
            update: (editorView)=>{
                const pluginState = getPluginState(editorView.state);
                const modalIsOpen = pluginState.modalDecorationSet !== (0, $8nvEM.DecorationSet).empty;
                if (modalIsOpen && !releaseSelectionMarker) releaseSelectionMarker = api?.selectionMarker?.actions.hideDecoration();
                else if (!modalIsOpen && releaseSelectionMarker) {
                    releaseSelectionMarker();
                    releaseSelectionMarker = undefined;
                }
            },
            destroy: ()=>{
                releaseSelectionMarker?.();
            }
        };
    };


const $a9142d93e9fc312b$export$f99722d744184238 = (options)=>{
    const { dispatch: dispatch, api: api, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, product: product } = options;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $9RRio.aiExperienceDecorationPluginKey),
        state: (0, $C4yPo.createPluginState)(dispatch, (0, $C4yPo.createInitialState)(dispatchAnalyticsEvent, isInDocumentStreamingEnabled, product)),
        props: {
            handleDOMEvents: {
                click: (0, $b9d05cd7c3f54216$export$f5369c92191ba6f)
            },
            decorations: (editorState)=>{
                const pluginState = (0, $C4yPo.getPluginState)(editorState);
                // The re-prompt range highlight is owned by the ai-session-context plugin;
                // this plugin only renders its modal set.
                return pluginState.modalDecorationSet;
            }
        },
        view: (0, $fcfe92bbc4662171$export$6181eb45d9edf6d3)((0, $C4yPo.getPluginState), api)
    });
};









var $5Q6OE = parcelRequire("5Q6OE");







const $f22a2fd66e11ba7d$export$59c835e23d1ad13 = new (0, $kCECX.PluginKey)('ai-document-content-state');
const $f22a2fd66e11ba7d$export$eeb95a60149a8e47 = 'set-consumer-empty-state-override';
const $f22a2fd66e11ba7d$export$ea83d625c73fdf28 = (initialConsumerEmptyStateOverride)=>{
    const isSmartRepliesEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('jira-smart-replies-v2', 'isEnabled', false);
    return new (0, $kpCD8.SafePlugin)({
        key: $f22a2fd66e11ba7d$export$59c835e23d1ad13,
        state: {
            init (_, state) {
                return {
                    hasVisibleContent: (0, $5Q6OE.hasVisibleContent)(state.doc),
                    consumerEmptyStateOverride: isSmartRepliesEnabled ? initialConsumerEmptyStateOverride : undefined
                };
            },
            apply (tr, pluginState, _, newState) {
                if (isSmartRepliesEnabled) {
                    let next = pluginState;
                    const meta = tr.getMeta($f22a2fd66e11ba7d$export$59c835e23d1ad13);
                    if (meta?.type === $f22a2fd66e11ba7d$export$eeb95a60149a8e47 && meta?.value !== next.consumerEmptyStateOverride) next = {
                        ...next,
                        consumerEmptyStateOverride: meta.value
                    };
                    if (tr.docChanged) {
                        const newHasVisibleContent = (0, $5Q6OE.hasVisibleContent)(newState.doc);
                        if (next.hasVisibleContent !== newHasVisibleContent) next = {
                            ...next,
                            hasVisibleContent: newHasVisibleContent
                        };
                    }
                    return next;
                }
                if (!tr.docChanged) return pluginState;
                const newHasVisibleContent = (0, $5Q6OE.hasVisibleContent)(newState.doc);
                if (pluginState.hasVisibleContent !== newHasVisibleContent) return {
                    hasVisibleContent: newHasVisibleContent
                };
                return pluginState;
            }
        }
    });
};








const $d51cfdf6d989cea1$export$519cafec2c63c5bb = new (0, $kCECX.PluginKey)('aiExperienceGetEditorView');


const $101eec5f5ca79486$export$3de1ac9a9cd13933 = ({ setEditorView: setEditorView })=>new (0, $kpCD8.SafePlugin)({
        key: (0, $d51cfdf6d989cea1$export$519cafec2c63c5bb),
        view (editorView) {
            setEditorView(editorView);
            return {};
        }
    });












var $jkcNT = parcelRequire("jkcNT");






var $g8hEw = parcelRequire("g8hEw");


var $a2bT0 = parcelRequire("a2bT0");


var $2yWJZ = parcelRequire("2yWJZ");

/**
 * Applies an alpha to a colour, resilient to its format (hex / rgb / hsl). Mirrors the
 * streamed-content highlight so the telepointer's highlight fill matches it.
 */ const $41f87b82bbd44c62$var$withAlpha = (color, alpha)=>`color-mix(in srgb, ${color} ${alpha * 100}%, transparent)`;
/**
 * The neutral grey the fallback badge paints, shared with the third-party pill. For the initial
 * PR a third party takes the same grey as the fallback (differing only by keeping its avatar and
 * name); per-brand third-party colours are a follow-up.
 */ const $41f87b82bbd44c62$var$NEUTRAL_GRAY = {
    highlightBackgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    highlightBorderColor: "var(--ds-border-accent-gray, #7D818A)",
    // A background token, because this paints the badge fill and the cursor line.
    telepointerLineColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
};
const $41f87b82bbd44c62$export$bdd925339e34f195 = (identity)=>{
    // Rovo always presents as itself, so this badge is fixed rather than identity driven.
    if (identity && (0, $2yWJZ.isDefaultRovoChat)(identity)) return {
        highlightBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        highlightBorderColor: "var(--ds-border-accent-purple, #AF59E1)",
        telepointerAgentKind: 'rovo',
        telepointerLineColor: "var(--ds-rovo-background-brand-bold, #000000)"
    };
    const { agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, isThirdParty: isThirdParty } = identity ?? {};
    // Any one of the three identifiers shared agent-avatar resolution keys on is enough to
    // draw an avatar, which leaves the neutral badge for a complete absence of all of them.
    if (agentNamedId || agentIdentityAccountId || agentId) {
        // A third party keeps the neutral grey pill (plus its avatar and name); only the first
        // party takes an id-derived accent hue.
        if (isThirdParty) return {
            ...$41f87b82bbd44c62$var$NEUTRAL_GRAY,
            telepointerAgentKind: 'agent-third-party'
        };
        // Follow the design: the telepointer takes the agent's own avatar colour, so the badge,
        // cursor line and content highlight always match the avatar. Uses the avatar palette
        // directly (raw hex, exactly as the avatar illustration does).
        const { primary: primary, secondary: secondary } = (0, $a2bT0.getAgentAvatarColor)({
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            agentNamedId: agentNamedId ?? undefined
        });
        return {
            highlightBackgroundColor: $41f87b82bbd44c62$var$withAlpha(secondary, 0.2),
            highlightBorderColor: primary,
            telepointerAgentKind: 'agent',
            telepointerLineColor: primary
        };
    }
    return {
        ...$41f87b82bbd44c62$var$NEUTRAL_GRAY,
        telepointerAgentKind: 'fallback'
    };
};


const $95624cff4026d0c7$export$20fa6d5c5205d623 = ({ agentInfo: agentInfo, useAgentHighlightColor: useAgentHighlightColor })=>{
    if (!useAgentHighlightColor) return {
        class: 'ai-in-editor-ai-content',
        'data-testid': 'ai-in-editor-ai-content'
    };
    // Resolve the highlight from the same source as the badge and cursor line, so both share one
    // hue: a first party takes its avatar colour, a third party and the fallback go neutral grey,
    // and Rovo takes its own accent. Keeps the highlight from leaking the avatar colour onto the
    // neutral third-party / fallback pills. Fill only — the Figma highlight has no underline, so
    // this suppresses the shared `.ai-in-editor-ai-content` rule's dashed border-bottom, which
    // still applies to non-agent streaming and the collab agent-edit-chrome path.
    const { highlightBackgroundColor: highlightBackgroundColor } = (0, $41f87b82bbd44c62$export$bdd925339e34f195)(agentInfo);
    return {
        class: 'ai-in-editor-ai-content',
        'data-testid': 'ai-in-editor-ai-content',
        style: `background-color: ${highlightBackgroundColor}; border-bottom-width: 0;`
    };
};













var $jv11C = parcelRequire("jv11C");














var $8Z43Z = parcelRequire("8Z43Z");








var $2Ldzs = parcelRequire("2Ldzs");


var $1Iyfh = parcelRequire("1Iyfh");








var $jtPcJ = parcelRequire("jtPcJ");


var $bVbtv = parcelRequire("bVbtv");













function $02d337cdf5827f29$export$b26e0d212ef01829({ invokeAttributes: invokeAttributes, canInlineStreamChanges: canInlineStreamChanges, onCommonAttributesUpdated: onCommonAttributesUpdated, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlowRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    if (!analyticsFlowRef.current) analyticsFlowRef.current = (0, $l2lIz.createAnalyticsFlow)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        invokeAttributes: invokeAttributes,
        canInlineStreamChanges: canInlineStreamChanges,
        onCommonAttributesUpdated: onCommonAttributesUpdated,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    });
    return analyticsFlowRef.current;
}
const $02d337cdf5827f29$var$AnalyticsFlowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $02d337cdf5827f29$export$b8f39b5859612546 = $02d337cdf5827f29$var$AnalyticsFlowContext.Provider;
const $02d337cdf5827f29$export$8af1809310de64fa = ()=>{
    const analyticsFlowInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($02d337cdf5827f29$var$AnalyticsFlowContext);
    if (!analyticsFlowInstance) throw new Error('No analyticsFlowInstance available in the context, make sure to have container wrapped with AnalyticsFlowContextProvider');
    return analyticsFlowInstance;
};
function $02d337cdf5827f29$export$f06fb39743945e19({ stepName: stepName, attributes: attributes, needUpdatedArgs: needUpdatedArgs, callerComponent: callerComponent }) {
    const analyticsFlow = $02d337cdf5827f29$export$8af1809310de64fa();
    const argsRef = (0, $cozmU.useRef)({
        stepName: undefined,
        attributes: undefined
    });
    (0, $cozmU.useEffect)(()=>{
        argsRef.current = {
            stepName: stepName,
            attributes: attributes
        };
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        analyticsFlow.fireQueuedStep(stepName, callerComponent);
        return ()=>{
            if (needUpdatedArgs && argsRef.current.stepName) analyticsFlow.enqueueStep({
                stepName: argsRef.current.stepName,
                attributes: argsRef.current.attributes
            });
            else analyticsFlow.enqueueStep({
                stepName: stepName,
                attributes: attributes
            });
        };
    // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return analyticsFlow;
}









var $fpmlf = parcelRequire("fpmlf");

/**
 * Attribution applied to Quick Action edits.
 *
 * PLACEHOLDER - do not enable `platform_editor_ai_quick_actions_agent_attribution` on the
 * back of this value. Consumers read `agentType: 'convo-ai'` with no `agentId` as Rovo Chat,
 * because `agentId` is only populated for Studio agents. Enabling the gate today would
 * attribute Quick Action edits to Rovo.
 *
 * Quick Actions are instead to be identified by a dedicated `agentTrigger` property on the
 * step - `"fe" | "be" | "quick-actions"`, labels TBD - which is independent of agent context
 * and does not map to `AgentContextService`. `agentType` is not suitable because it models the
 * actor, and a Quick Action is not an actor. Once `agentTrigger` exists this constant should
 * be replaced by it.
 *
 * @see https://hello.atlassian.net/wiki/spaces/EDITOR/pages/7556910519
 */ const $0d7305543af23cc5$var$QUICK_ACTION_AGENT_ATTRIBUTION = {
    agentType: 'convo-ai'
};
/**
 * Translation config item keys are built at runtime as `Translate to ${language}` in
 * `prompts/translate/translate.tsx`. Deriving them the same way here keeps this set in sync
 * when a language is added, rather than duplicating the `TRANSLATE_TO_*` enum members.
 */ const $0d7305543af23cc5$var$translationConfigItemKeys = Object.values((0, $fpmlf.SupportedTranslationLanguages)).map((language)=>`Translate to ${language}`);
/**
 * Config items surfaced as Confluence Quick Actions - the selection toolbar transforms that
 * rewrite existing content in place.
 */ const $0d7305543af23cc5$var$QUICK_ACTION_CONFIG_ITEM_KEYS = new Set([
    (0, $2MofN.CONFIG_ITEM_KEYS).IMPROVE_WRITING,
    (0, $2MofN.CONFIG_ITEM_KEYS).ADD_POLISH,
    (0, $2MofN.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
    (0, $2MofN.CONFIG_ITEM_KEYS).MAKE_LONGER,
    (0, $2MofN.CONFIG_ITEM_KEYS).MAKE_SHORTER,
    (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
    (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
    (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
    (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
    (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
    ...$0d7305543af23cc5$var$translationConfigItemKeys
]);
const $0d7305543af23cc5$export$2d2060a8d6bb2ae7 = (configItemKey)=>{
    if (!configItemKey) return false;
    return $0d7305543af23cc5$var$QUICK_ACTION_CONFIG_ITEM_KEYS.has(configItemKey);
};
const $0d7305543af23cc5$export$89a47aaa0c638001 = ({ sessionAgentAttribution: sessionAgentAttribution, configItemKey: configItemKey })=>{
    if (!(0, $iDrrr.fg)('platform_editor_agentic_step_attribution')) return undefined;
    if (sessionAgentAttribution) return sessionAgentAttribution;
    if (!(0, $iDrrr.fg)('platform_editor_ai_quick_actions_agent_attribution')) return undefined;
    return $0d7305543af23cc5$export$2d2060a8d6bb2ae7(configItemKey) ? $0d7305543af23cc5$var$QUICK_ACTION_AGENT_ATTRIBUTION : undefined;
};



var $kEjH6 = parcelRequire("kEjH6");







function $f83a45c4b358acb4$export$d9f6dde98fa84c24({ tr: tr, replacementContent: replacementContent, startPos: startPos }) {
    if (!replacementContent || replacementContent.childCount === 0) return tr;
    const docSize = tr.doc.content.size;
    if (startPos < 0 || startPos > docSize) return tr;
    let cursor = $f83a45c4b358acb4$var$findFirstBlockPos(tr, startPos, replacementContent.firstChild?.type);
    if (cursor === undefined) return tr;
    for(let i = 0; i < replacementContent.childCount; i++){
        const replacementChild = replacementContent.child(i);
        if (cursor < 0 || cursor >= tr.doc.content.size) break;
        let resolved;
        try {
            resolved = tr.doc.resolve(cursor);
        } catch  {
            break;
        }
        const docNode = resolved.nodeAfter;
        if (!docNode) break;
        // Types must match — if the slice landed in a way that makes the
        // shapes diverge we cannot reliably correlate `localId`s and should
        // not blindly rewrite the wrong node.
        if (docNode.type !== replacementChild.type) {
            cursor += docNode.nodeSize;
            continue;
        }
        const replacementLocalId = replacementChild.attrs?.localId;
        const currentLocalId = docNode.attrs?.localId;
        if (typeof replacementLocalId === 'string' && replacementLocalId.length > 0 && currentLocalId !== replacementLocalId && docNode.attrs && 'localId' in docNode.attrs) try {
            tr = tr.setNodeMarkup(cursor, undefined, {
                ...docNode.attrs,
                localId: replacementLocalId
            }, docNode.marks);
        } catch  {
        // Swallow — keep advancing so we still patch the remaining blocks.
        }
        cursor += docNode.nodeSize;
    }
    return tr;
}
/**
 * `replaceRange` typically leaves `startPos` pointing inside the first
 * merged block (e.g. at the start of its text content). Walk up the
 * resolved position to find the opening position of the first node matching
 * `firstChildType`.
 */ function $f83a45c4b358acb4$var$findFirstBlockPos(tr, startPos, firstChildType) {
    const docSize = tr.doc.content.size;
    let resolved;
    try {
        resolved = tr.doc.resolve(Math.min(Math.max(startPos, 0), docSize));
    } catch  {
        return undefined;
    }
    for(let depth = resolved.depth; depth >= 0; depth--){
        const nodeAtDepth = resolved.node(depth);
        if (!nodeAtDepth) continue;
        if (firstChildType && nodeAtDepth.type !== firstChildType) continue;
        if (depth === 0) break;
        return resolved.before(depth);
    }
    // Fall back to the resolved position so the caller's `nodeAfter` lookup
    // can still drive the walk when the first block already sits at this
    // boundary.
    return resolved.pos;
}



var $ix5ay = parcelRequire("ix5ay");


var $80W3l = parcelRequire("80W3l");

const $3ff6a223e7e386eb$export$68178086d03445ca = ({ nodeType: nodeType, schema: schema })=>{
    const { table: table, tableRow: tableRow, tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return [
        table,
        tableRow,
        tableHeader,
        tableCell
    ].includes(nodeType);
};



var $hivdp = parcelRequire("hivdp");

const $213d86ec3834626a$export$f9c4337e36118c2b = (element, scrollContainer)=>{
    let offset = 0;
    let currentElement = element;
    /**
	 * If we've reached the scroll container or the element is null (scrollContainer not found after traversal)
	 * we return the accumulated offset.
	 * This is to avoid calling getBoundingClientRect which can be more expensive.
	 */ while(currentElement && currentElement !== scrollContainer){
        offset += currentElement.offsetTop;
        currentElement = currentElement.offsetParent;
    }
    return offset;
};


const $96ce9ac18a1b3910$var$SCROLL_MARGIN = 32;
function $96ce9ac18a1b3910$export$8c11be8ccd39ce0b({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, -1);
    // if it's AI in-document streaming, the startPos shouldn't change
    // however, when generating table, somehow the mappedPos could be smaller than pos
    // - we insert at the beginning of the doc, pos 1 somehow maps to 0
    // - which we should allow
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos > pos) {
            const adjustedPos = tr.mapping.map(pos - 1, -1) + 1;
            if (adjustedPos === pos) mappedPos = pos;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(mappedPos, 0, tr.doc.content.size);
}
function $96ce9ac18a1b3910$export$3dcc2c094c7e6748({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, 1);
    // if it's AI in-document streaming, the endPos should change
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos === pos) {
            const mappedPosPlus1 = tr.mapping.map(pos + 1, 1);
            // Only subtract 1 if the node size is greater than 1.
            // When nodeSize === 1 (e.g. a rule node), mappedPosPlus1 - pos === 1
            // and subtracting 1 would collapse aiContentEndPos back to startPos,
            // causing the restore transaction to leave AI content in place and
            // the commit transaction to re-insert it (producing a duplicate node).
            if (mappedPosPlus1 - pos > 1) mappedPos = mappedPosPlus1 - 1;
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(mappedPos, 0, tr.doc.content.size);
}
function $96ce9ac18a1b3910$var$getStartOfTableRow({ schema: schema, resolvedPos: resolvedPos }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === schema.nodes.tableRow) return resolvedPos.start(depth);
    }
}
function $96ce9ac18a1b3910$var$getEndOfTableRow({ schema: schema, resolvedPos: resolvedPos }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === schema.nodes.tableRow) {
            const tableNode = resolvedPos.node(depth - 1);
            const tablePos = resolvedPos.start(depth - 1);
            const map = (0, $8Z43Z.TableMap).get(tableNode);
            const { mapByRow: mapByRow } = map;
            const rowIndexContainingCell = mapByRow.findIndex((r)=>r.includes(resolvedPos.start(depth) - tablePos));
            if (rowIndexContainingCell === -1) /**
				 * In the case that we can't find a row containing the cell (this should not occur) we early exit
				 */ return;
            /**
			 * If we've reached the last row, then just return the end of that row
			 * since it won't have further vertically merged cells.
			 */ if (rowIndexContainingCell + 1 === map.height) {
                const $cellPos = resolvedPos.doc.resolve(tablePos + mapByRow[rowIndexContainingCell][0]);
                return $cellPos.end($cellPos.depth);
            }
            for(let i = rowIndexContainingCell + 1; i < map.height; i++){
                // We keep checking the next row to see if there are any duplicate positions
                // If there are, it means that there are vertically merged cells and we want to extend the position
                const rowA = mapByRow[i - 1];
                const rowB = mapByRow[i];
                if (rowA.every((val, idx)=>val !== rowB[idx])) {
                    const $cellPos = resolvedPos.doc.resolve(tablePos + rowA[0]);
                    return $cellPos.end($cellPos.depth);
                }
                /***
				 * If we've reached the end and still encountering merged cells,
				 * we return the last row's end position
				 */ if (i === map.height - 1) {
                    const $cellPos = resolvedPos.doc.resolve(tablePos + rowB[0]);
                    return $cellPos.end($cellPos.depth);
                }
            }
        }
    }
}
/**
 * We want to adjust the streaming position so that we don't break table rows.
 * Here, we extend the position to the end of a table row if the current position is inside a table cell.
 * We only do this if the replacement range spans over more than a cell!
 */ function $96ce9ac18a1b3910$var$adjustStartToPosForTable({ view: view, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const $startPos = view.state.doc.resolve(startPos);
    const $toPos = view.state.doc.resolve(toPos);
    const isSameCell = (0, $hivdp.isWithinSameCell)({
        $from: $startPos,
        $to: $toPos,
        schema: view.state.schema
    });
    const adjustStartPosIfTableRow = !isSameCell ? $96ce9ac18a1b3910$var$getStartOfTableRow({
        schema: view.state.schema,
        resolvedPos: $startPos
    }) : undefined;
    const adjustToPosIfTableRow = !isSameCell ? $96ce9ac18a1b3910$var$getEndOfTableRow({
        schema: view.state.schema,
        resolvedPos: $toPos
    }) : undefined;
    if (adjustStartPosIfTableRow !== undefined) startPos = adjustStartPosIfTableRow;
    if (adjustToPosIfTableRow !== undefined) toPos = Math.min(adjustToPosIfTableRow, userContentEndPos);
    return {
        startPos: startPos,
        toPos: toPos
    };
}
/**
 * Adjusts toPos to account for bodiedSyncBlock nodes during intermediate streaming.
 *
 * During streaming, the pacer may defer emitting a bodiedSyncBlock for a tick.
 * This creates a mismatch: the doc still holds the existing bodiedSyncBlock, but
 * toPos (derived from aiContentEndPos) sits before it.
 *
 * - When the slice does NOT contain a bodiedSyncBlock, we cap toPos so that
 *   replaceRange does not accidentally remove the existing node.
 * - When the slice DOES contain a bodiedSyncBlock, we extend toPos past the
 *   existing node so that replaceRange replaces it rather than inserting a duplicate.
 */ function $96ce9ac18a1b3910$var$adjustStartToPosForSyncBlock({ view: view, fragment: fragment, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const docSize = view.state.doc.content.size;
    // Step 1: Count sync blocks in the slice (the AI-generated fragment)
    let sliceSyncBlockCount = 0;
    fragment.forEach((node)=>{
        if (node.type.name === 'bodiedSyncBlock') sliceSyncBlockCount++;
    });
    // Step 2: Map all sync blocks in the doc with their positions
    const docSyncBlocks = [];
    view.state.doc.content.forEach((node, offset)=>{
        if (node.type.name === 'bodiedSyncBlock') docSyncBlocks.push({
            pos: offset + 1,
            end: offset + 1 + node.nodeSize,
            localId: node.attrs.localId,
            resourceId: node.attrs.resourceId
        });
    });
    if (sliceSyncBlockCount === 0) {
        // Step 3a: Slice has NO sync blocks.
        // We must cap toPos so replaceRange doesn't accidentally delete
        const $start = view.state.doc.resolve(startPos);
        // Case 1: startPos is inside a bodiedSyncBlock.
        // Cap toPos to the end of that block's inner content so
        // replaceRange stays within the block boundary.
        let capped = false;
        for(let d = $start.depth; d > 0; d--)if ($start.node(d).type.name === 'bodiedSyncBlock') {
            const endOfContent = $start.end(d);
            if (toPos > endOfContent) toPos = endOfContent;
            capped = true;
            break;
        }
        // Case 2: startPos is NOT inside a sync block.
        // Find the first sync block ahead of startPos and cap toPos before it.
        if (!capped) view.state.doc.nodesBetween(startPos, Math.min(toPos, docSize), (node, pos)=>{
            if (node.type.name === 'bodiedSyncBlock' && pos >= startPos && pos < toPos) toPos = pos;
            return false;
        });
    } else {
        // Step 3b: Slice HAS sync block(s).
        // We need to make sure toPos covers the corresponding sync blocks
        // in the doc so replaceRange replaces them (not duplicates them).
        //
        // But we must NOT extend past sync blocks the slice doesn't cover,
        // or we'd remove them.
        //
        // Algorithm:
        //   - Count how many doc sync blocks are already within [startPos, toPos)
        //     (these are "covered" — replaceRange already reaches them)
        //   - needToExtendPast = sliceSyncBlockCount - coveredSyncBlocks
        //   - If > 0, scan forward from toPos and extend past that many sync blocks
        //   - If <= 0, no extension needed (all slice sync blocks already covered)
        // Count sync blocks fully covered by the replacement range [startPos, toPos).
        // A sync block is only "covered" if toPos extends past its END.
        // If toPos is in the MIDDLE of a sync block (start < toPos < end),
        // that block is NOT covered — we need to extend toPos past it.
        let coveredSyncBlocks = 0;
        const coveredDetails = [];
        view.state.doc.nodesBetween(startPos, Math.min(toPos, docSize), (node, pos)=>{
            if (node.type.name === 'bodiedSyncBlock') {
                const end = pos + node.nodeSize;
                const fullyCovered = end <= toPos;
                if (fullyCovered) coveredSyncBlocks++;
                coveredDetails.push({
                    pos: pos,
                    end: end,
                    localId: node.attrs.localId,
                    fullyCovered: fullyCovered
                });
            }
            return false;
        });
        const needToExtendPast = sliceSyncBlockCount - coveredSyncBlocks;
        if (needToExtendPast > 0) {
            let remaining = needToExtendPast;
            view.state.doc.nodesBetween(toPos, Math.min(userContentEndPos, docSize), (node, pos)=>{
                if (remaining > 0 && node.type.name === 'bodiedSyncBlock') {
                    const endOfNode = pos + node.nodeSize;
                    if (endOfNode > toPos) toPos = Math.min(endOfNode, userContentEndPos);
                    remaining--;
                }
                return false;
            });
        }
    }
    return {
        startPos: startPos,
        toPos: toPos
    };
}
/**
 * Ensure the fragment is valid, otherwise indicate we received the fragment, but make
 * no updates.
 *
 * @param fragment
 * @returns boolean - true if fragment is healthy (valid), false otherwise
 */ const $96ce9ac18a1b3910$var$fragmentIsHealthy = (fragment)=>{
    let err;
    let isHealthy = true;
    fragment.forEach((node)=>{
        if (!isHealthy) return;
        try {
            node.check();
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            err = e;
            isHealthy = false;
        }
    });
    return {
        isHealthy: isHealthy,
        err: err
    };
};
// if we insert a heading at the beginning of a list item
// we want to insert the heading at the pos right before the list
// if we insert a heading at the end of a list item
// we want to insert the heading at the pos right after the list
function $96ce9ac18a1b3910$var$adjustStartEndPosForEmptySelection({ view: view, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } = view.state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos
    };
    const $start = view.state.doc.resolve(startPos);
    const startParent = $start.parent;
    // we only need to adjust the pos if the parent is list item (orderedList or bulletList), decisionItem, or taskItem
    const inList = startParent.type === paragraph && $start.node($start.depth - 1)?.type === listItem;
    const inTaskItem = startParent.type === taskItem;
    const inDecisionItem = startParent.type === decisionItem;
    const shouldAdjust = inList || inTaskItem || inDecisionItem;
    if (!shouldAdjust) return bailout;
    const $end = view.state.doc.resolve(userContentEndPos);
    const endParent = $end.parent;
    const newNode = fragment.firstChild;
    const oneBlock = fragment.childCount === 1 && newNode && newNode.isBlock;
    const newStartBlock = oneBlock && newNode.type.name !== startParent.type.name;
    const newEndBlock = oneBlock && newNode.type.name !== endParent.type.name;
    let startPosAdjusted = startPos;
    let endPosAdjusted = userContentEndPos;
    if (newStartBlock) // find a potential pos at the beginning of the block
    for(let depth = $start.depth, diff = 1; depth > 0; depth--, diff++, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const before = $start.before(depth);
        if (before + diff !== startPos) break;
    }
    if (newEndBlock) // find a potential pos at the end of the block
    for(let depth = $end.depth, diff = 1; depth > 0; depth--, diff++, endPosAdjusted++){
        const ancestor = $end.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const after = $end.after(depth);
        if (after - diff !== userContentEndPos) break;
    }
    if (startPosAdjusted !== bailout.startPos || endPosAdjusted !== bailout.userContentEndPos) {
        // prefer the end if there is a tie/draw
        // or else if there will be extra list item if insert heading at the beginning of the doc
        const pos = endPosAdjusted - userContentEndPos >= startPos - startPosAdjusted ? endPosAdjusted : startPosAdjusted;
        view.dispatch((0, $80W3l.adjustInitPositions)({
            start: pos,
            end: pos
        })(view.state.tr));
        return {
            startPos: pos,
            userContentEndPos: pos
        };
    }
    return bailout;
}
// if we are at the beginning of a block visually
// we want to move the start pos to the pos right before the block
// for example, if we run Improve Writing with two nodes: expand+paragraph
// we want to move the start pos to the pos right before the expand
// otherwise, there will be an extra empty expand node inserted
function $96ce9ac18a1b3910$var$adjustStartEndPosForRangeSelection({ view: view, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos
    };
    let $start = view.state.doc.resolve(startPos);
    // if the start pos is not at the beginning of its parent, bailout
    // sometimes startPos is 0, in this case $start.depth is 0 and
    // $start.before() will throw an error `There is no position before the top-level node`
    if ($start.depth > 0 && $start.before() !== startPos - 1) return bailout;
    // find the types of the ancestor nodes in the fragment in reverse order
    const types = [];
    let node = fragment.firstChild;
    while(node && node.firstChild){
        types.push(node.type);
        node = node.firstChild;
    }
    types.reverse();
    if (types.length === 1 && types[0] === paragraph) return bailout;
    if ((0, $iDrrr.fg)('platform_editor_ai_replace_table_cell_issue_fix')) {
        /**
		 * If start pos is in a table cell or table header then bailout
		 * 	because adjustments for table cells are handled separately
		 * 	in adjustStartToPosForTable.
		 */ const startPosNodeType = $start.parent.type;
        if (startPosNodeType === tableCell || startPosNodeType === tableHeader) return bailout;
    }
    // go to the innermost ancestor node in the doc
    let startPosAdjusted = startPos;
    node = $start.parent.firstChild;
    while(node && node.firstChild){
        startPosAdjusted++;
        node = node.firstChild;
    }
    // compare every ancestor node outwards
    $start = view.state.doc.resolve(startPosAdjusted);
    for(let i = 0, depth = $start.depth; depth > 0; i++, depth--, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type !== types[i]) break;
        const before = $start.before(depth);
        if (before + 1 !== startPosAdjusted) break;
    }
    // if we found a pos that is before startPos, we need to adjust startPos
    if (startPosAdjusted < bailout.startPos) {
        view.dispatch((0, $80W3l.adjustInitPositions)({
            start: startPosAdjusted,
            end: bailout.userContentEndPos
        })(view.state.tr));
        return {
            startPos: startPosAdjusted,
            userContentEndPos: bailout.userContentEndPos
        };
    }
    return bailout;
}
/**
 * Returns true when `startPos` is a valid spot to perform the
 * "convert list -> task list" position adjustment, i.e.:
 *
 *  1. There is a `listItem` ancestor in the chain.
 *  2. That listItem's parent is a bullet/ordered list, and it is the FIRST
 *     bullet/ordered list in the ancestor chain (i.e. NOT inside a nested
 *     list).
 *  3. The listItem is the FIRST child of its parent list.
 *  4. `startPos` is at the very beginning of the listItem's first paragraph.
 *
 * Conditions (1) & (2) replace the previous `isTopLevelListBeingReplaced`
 * check. Conditions (3) & (4) replace the previous `$start.parentOffset === 0`
 * check, which incorrectly fired for any listItem (2nd, 3rd, …).
 *
 * Examples that return TRUE:
 *  - bulletList -> listItem(idx 0) -> paragraph<startPos>text
 *  - orderedList -> listItem(idx 0) -> paragraph<startPos>
 *
 * Examples that return FALSE:
 *  - bulletList -> listItem(idx 0) -> bulletList -> ...           (nested list)
 *  - bulletList -> listItem(idx 1+) -> paragraph<startPos>...     (non-first item)
 *  - bulletList -> listItem(idx 0) -> paragraph -> text<startPos> (mid-text)
 */ function $96ce9ac18a1b3910$var$isStartAtFirstItemOfTopLevelList(state, startPos) {
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const $start = state.doc.resolve(startPos);
    let listItemDepth = -1; // depth of the nearest (innermost) listItem ancestor
    let listsSeen = 0; // count of bullet/ordered list ancestors
    for(let depth = $start.depth; depth > 0; depth--){
        const node = $start.node(depth);
        // Track only the nearest (innermost) listItem.
        if (node.type === listItem && listItemDepth === -1) {
            listItemDepth = depth;
            continue;
        }
        if (node.type === bulletList || node.type === orderedList) {
            listsSeen++;
            if (listsSeen > 1) // Nested list — not top-level.
            return false;
        }
    }
    // No listItem ancestor at all, or no enclosing list -> not applicable.
    if (listItemDepth === -1 || listsSeen === 0) return false;
    // The list that directly contains the nearest listItem must be a
    // bullet/ordered list, and that listItem must be its FIRST child.
    const parentList = $start.node(listItemDepth - 1);
    if (parentList.type !== bulletList && parentList.type !== orderedList) return false;
    if ($start.index(listItemDepth - 1) !== 0) return false;
    // startPos must be at the very beginning of the listItem's first paragraph.
    // $start.start(listItemDepth) is the position just inside the listItem;
    // +1 skips the opening token of the first child paragraph.
    const firstParagraphStart = $start.start(listItemDepth) + 1;
    return startPos <= firstParagraphStart;
}
function $96ce9ac18a1b3910$export$fa56f7b21d67182b({ fragment: fragment, startPos: startPos, state: state }) {
    const { taskList: taskList } = state.schema.nodes;
    const isFirstChildTaskList = fragment.firstChild?.type === taskList;
    return isFirstChildTaskList && $96ce9ac18a1b3910$var$isStartAtFirstItemOfTopLevelList(state, startPos);
}
/**
 * Adjusts start and end positions when streaming block nodes (e.g., tables, panels) that replace content within list items.
 *
 * When AI streams a block-level node to replace selected content inside list items, we need to adjust
 * the replacement range to prevent empty list items from appearing before and after the inserted block.
 * This function expands the start and end positions to include the surrounding list item structure.
 *
 * @example
 * // Before adjustment: Replacing content inside a list item paragraph
 * // - List item 1
 * // - [Selected content in list item 2]
 * // - List item 2
 * // After streaming a table, without adjustment, would create:
 * // - List item 1
 * // -           <-- empty list item
 * // [Table]
 * // -           <-- empty list item
 * // - List item 2
 *
 * // With adjustment, positions are expanded to replace the entire list item:
 * // - List item 1
 * // [Table]
 * // - List item 2
 *
 * @param params - The adjustment parameters
 * @param params.fragment - The ProseMirror fragment being streamed (contains the AI-generated content)
 * @param params.startPos - The current start position of the replacement range
 * @param params.userContentEndPos - The current end position of the replacement range (original user content)
 * @param params.view - The editor view instance
 * @returns Object containing the adjusted start and end positions, where
 *   `startPos` is moved earlier if at start of list item paragraph, and
 *   `userContentEndPos` is moved later if at end of list item paragraph
 */ function $96ce9ac18a1b3910$var$adjustStartAndUserContentEndPosForList({ fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos, view: view }) {
    const state = view.state;
    const schema = state.schema;
    const { listItem: listItem, paragraph: paragraph } = schema.nodes;
    const doc = state.doc;
    let startPosAdjusted = startPos;
    let userContentEndPosAdjusted = userContentEndPos;
    /**
	 * If first child is empty then don't do any adjustments
	 */ const fragmentFirstNode = fragment.firstChild;
    if (!fragmentFirstNode) return {
        startPos: startPosAdjusted,
        userContentEndPos: userContentEndPosAdjusted
    };
    /**
	 * If first child can be child of list item then no need to adjust positions.
	 * In case of table, layout or panel, first child won't be valid content of list item,
	 * 	thus adjustments will happen to avoid dangling list items.
	 */ const firstChildFragment = (0, $aPdNQ.Fragment).from(fragmentFirstNode);
    const isFirstValidListItemContent = listItem?.validContent(firstChildFragment);
    /**
	 * Task list is valid child of listItem.
	 * We have observed that user rarely use task item in list item.
	 * So most of the time when user want to replace
	 * 	list with task list.
	 * So if first child is task list then should do adjustments.
	 */ const shouldAdjustPositions = !isFirstValidListItemContent || $96ce9ac18a1b3910$export$fa56f7b21d67182b({
        fragment: fragment,
        startPos: startPos,
        state: state
    });
    if (shouldAdjustPositions) {
        const $start = doc.resolve(startPos);
        /**
		 * Adjusting startPos is only necessary when startPos is at the beginning of a paragraph in list item.
		 */ let curParent = $start.node($start.depth);
        let curParentParent = $start.node($start.depth - 1);
        if (curParent.type === paragraph && $start.parentOffset === 0 && curParentParent?.type === listItem) startPosAdjusted -= 2;
        else if (curParent.type === listItem) startPosAdjusted -= 1;
        /**
		 * Adjusting userContentEndPos is only necessary when userContentEndPos is at the end of a paragraph in list item.
		 */ const $userContentEnd = doc.resolve(userContentEndPos);
        curParent = $userContentEnd.node($userContentEnd.depth);
        curParentParent = $userContentEnd.node($userContentEnd.depth - 1);
        if (curParent.type === paragraph && $userContentEnd.parentOffset === curParent.content.size && curParentParent?.type === listItem) userContentEndPosAdjusted += 2;
        else if (curParent.type === listItem) userContentEndPosAdjusted += 1;
    }
    return {
        startPos: startPosAdjusted,
        userContentEndPos: userContentEndPosAdjusted
    };
}
/**
 * When the startPos resolves to the beginning of a text node inside a paragraph
 * or heading, and the replacement fragment's first child is the same block type
 * with block-level marks (e.g. alignment), replaceRange will only merge the
 * inline content — losing the block-level marks/attrs from the replacement node.
 *
 * This adjustment decreases startPos by 1 so it points to the block node itself,
 * allowing replaceRange to replace the entire node (including block-level marks
 * like alignment).
 *
 * If any marks on the replacement node are invalid in the current schema context,
 * ProseMirror will strip them automatically during replaceRange.
 */ function $96ce9ac18a1b3910$var$adjustStartPosForBlockMark({ view: view, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos
    };
    const { paragraph: paragraph, heading: heading } = view.state.schema.nodes;
    if (startPos < 1 || startPos > view.state.doc.content.size) return bailout;
    const $start = view.state.doc.resolve(startPos);
    const parentType = $start.parent.type;
    // Check if startPos is at offset 0 inside a paragraph or heading
    const isInParagraph = paragraph && parentType === paragraph;
    const isInHeading = heading && parentType === heading;
    if (!isInParagraph && !isInHeading || $start.parentOffset !== 0) return bailout;
    // Check that the replacement fragment's first child is the same block type
    const firstChild = fragment.firstChild;
    if (!firstChild || firstChild.type !== parentType) return bailout;
    const replacementMarks = firstChild.marks;
    const replacementHasBlockMarks = replacementMarks && replacementMarks.length > 0;
    if ((0, $iDrrr.fg)('platform_editor_ai_block_mark_removal_fix_legacy')) {
        // CCI-17013: Also adjust when the existing node has block-level marks that
        // differ from the replacement — this covers mark removal (e.g. going from
        // alignment:center back to default/left) and mark changes.
        const existingNode = $start.parent;
        const existingMarks = existingNode.marks;
        const existingHasBlockMarks = existingMarks && existingMarks.length > 0;
        // Neither side has marks — no adjustment needed
        if (!existingHasBlockMarks && !replacementHasBlockMarks) return bailout;
        // Both sides have identical marks — no adjustment needed
        if (existingHasBlockMarks && replacementHasBlockMarks && (0, $aPdNQ.Mark).sameSet(existingMarks, replacementMarks)) return bailout;
    } else {
        // Original guard: only adjust when the replacement carries block-level marks — without this
        // guard the adjustment fires on every same-type streaming replacement,
        // breaking discard/undo position tracking.
        if (!replacementHasBlockMarks) return bailout;
    }
    // Verify the position before is actually the block node's opening position
    if ($start.depth < 1 || $start.before($start.depth) !== startPos - 1) return bailout;
    return {
        startPos: startPos - 1,
        userContentEndPos: userContentEndPos
    };
}
function $96ce9ac18a1b3910$var$adjustSliceOpenStartEnd({ slice: slice, startPos: startPos, toPos: toPos, view: view }) {
    let fragment = slice.content;
    // CCI-16810: ADFStreamer wraps AI-supplied content in a list wrapper (e.g.
    // taskItem inside taskList) to keep the synthesised root doc schema-valid.
    // When the replacement target already sits inside that wrapper, the wrapper
    // becomes a redundant level and ProseMirror inserts it as a nested list.
    // Unwrap it so the inner items merge with the existing list. See the
    // equivalent fix in pure-pm/sliceAdjustments.ts.
    const schema = view.state.schema;
    const docSize = view.state.doc.content.size;
    if (fragment.firstChild && fragment.childCount === 1 && startPos >= 0 && startPos <= docSize && (0, $iDrrr.fg)('platform_editor_ai_task_item_slice_unwrap_fix')) {
        const wrapperFirst = fragment.firstChild;
        const pairs = [
            [
                schema.nodes.taskList,
                schema.nodes.taskItem
            ],
            [
                schema.nodes.decisionList,
                schema.nodes.decisionItem
            ]
        ];
        const matched = pairs.find(([wrapper, item])=>!!wrapper && !!item && wrapperFirst.type === wrapper);
        if (matched) {
            const [, itemType] = matched;
            let allChildrenAreItems = wrapperFirst.childCount > 0;
            wrapperFirst.content.forEach((child)=>{
                if (child.type !== itemType) allChildrenAreItems = false;
            });
            if (allChildrenAreItems) {
                // startPos is already bounds-checked above, so doc.resolve cannot throw.
                const $sp = view.state.doc.resolve(startPos);
                let parentIsSameWrapper = false;
                for(let depth = $sp.depth; depth >= 0; depth--)if ($sp.node(depth).type === wrapperFirst.type) {
                    parentIsSameWrapper = true;
                    break;
                }
                if (parentIsSameWrapper) {
                    // Decrement openStart/openEnd by one (the wrapper depth we
                    // removed). Re-deriving with Slice.maxOpen would over-open
                    // when the original openStart was 0 and could trigger
                    // inline merging at the list boundary. The parallel pure-pm
                    // implementation in sliceAdjustments.ts documents the case
                    // analysis.
                    fragment = wrapperFirst.content;
                    slice = new (0, $aPdNQ.Slice)(fragment, Math.max(0, slice.openStart - 1), Math.max(0, slice.openEnd - 1));
                }
            }
        }
    }
    // if the first node in fragment is different from the existing first node,
    // we need to adjust the slice open start to 0,
    // to avoid merging the first node in fragment with the existing first node,
    // for example, if the first node in fragment is a panel node, we'll lose the panel wrapper
    // (only the panel content is inserted into the doc)
    // but we don't need to do this if both nodes are table nodes
    const firstNode = fragment.firstChild;
    if (firstNode) {
        // bodiedSyncBlock must never be merged — its attrs (localId, resourceId)
        // must come from the streamed response, not the existing doc node.
        if (firstNode.type.name === 'bodiedSyncBlock') slice = new (0, $aPdNQ.Slice)(fragment, 0, slice.openEnd);
        else {
            const firstNodeIsTableNode = (0, $3ff6a223e7e386eb$export$68178086d03445ca)({
                nodeType: firstNode.type,
                schema: view.state.schema
            });
            const startPosTableDepth = (0, $hivdp.getPositionNodeTypeDepth)({
                resolvedPos: view.state.doc.resolve(startPos),
                nodeType: view.state.schema.nodes.table
            });
            const bothTableNodes = firstNodeIsTableNode && !!startPosTableDepth;
            if (!bothTableNodes) {
                const $startPos = view.state.doc.resolve(startPos);
                const existingFirstNode = $startPos.depth >= 1 ? $startPos.node(1) : null;
                if (!existingFirstNode || firstNode.type !== existingFirstNode.type) slice = new (0, $aPdNQ.Slice)(fragment, 0, slice.openEnd);
            }
        }
    }
    // if the last node in fragment is different from the existing last node,
    // we need to adjust the slice open end to 0,
    // to avoid merging the last node in fragment with the existing last node,
    // for example, we've seen during streaming, heading and paragraph are merged together
    // (leading to a very long heading containing the paragraph content)
    // but we don't need to do this if both nodes are table nodes
    const lastNode = fragment.lastChild;
    if (lastNode) {
        // bodiedSyncBlock must never be merged — same reason as above.
        if (lastNode.type.name === 'bodiedSyncBlock') slice = new (0, $aPdNQ.Slice)(fragment, slice.openStart, 0);
        else {
            const lastNodeIsTableNode = (0, $3ff6a223e7e386eb$export$68178086d03445ca)({
                nodeType: lastNode.type,
                schema: view.state.schema
            });
            const toPosTableDepth = (0, $hivdp.getPositionNodeTypeDepth)({
                resolvedPos: view.state.doc.resolve(toPos),
                nodeType: view.state.schema.nodes.table
            });
            const bothTableNodes = lastNodeIsTableNode && !!toPosTableDepth;
            if (!bothTableNodes) {
                const $toPos = view.state.doc.resolve(toPos);
                const existingLastNode = $toPos.depth >= 1 ? $toPos.node(1) : null;
                if (!existingLastNode || lastNode.type !== existingLastNode.type) slice = new (0, $aPdNQ.Slice)(fragment, slice.openStart, 0);
            }
        }
    }
    return slice;
}
const $96ce9ac18a1b3910$export$bab543e64bfa5b68 = ({ api: api, configItem: configItem, isProgrammaticScroll: isProgrammaticScroll, view: view, positions: positions, modalRef: modalRef, aiSessionId: aiSessionId })=>{
    const isSuggestTitle = (0, $bVbtv.isSuggestTitleForConfluence)(configItem);
    const showTelepointer = !isSuggestTitle;
    const [isPaused, setIsPaused] = (0, $cozmU.useState)(true);
    const [_start, setStart] = (0, $cozmU.useState)();
    const scrollParentRef = (0, $cozmU.useRef)(null);
    const originalUserContentSlice = (0, $cozmU.useRef)();
    /**
	 * The AI content slice is used to store the AI content that has been streamed
	 */ const aiContentSlice = (0, $cozmU.useRef)();
    const hasFinalStreamRef = (0, $cozmU.useRef)(false);
    // NOTE: This is not pretty but we still need data from the userflow, so we've decoupled the firing of unified events
    // for AIFC however we still need more data, so we can do this for now until xstate ios removed.
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const commonUnifiedAnalyticsData = analyticsFlow.getUnifiedEventData();
    (0, $cozmU.useEffect)(()=>{
        const dom = view.dom;
        const scrollParent = (0, $1jz5K.findOverflowScrollParent)(dom);
        if (scrollParent) scrollParentRef.current = scrollParent;
    }, [
        view
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (_start !== undefined && scrollParentRef.current) {
            const startCoords = view.coordsAtPos(_start);
            const offsetTop = view.coordsAtPos(0).top;
            const modalHeight = modalRef?.current?.offsetHeight || 0;
            const offsetTopFromScrollContainer = (0, $213d86ec3834626a$export$f9c4337e36118c2b)(view.dom, scrollParentRef.current);
            /**
			 * If the start position is above viewport,
			 * we set the scroll so that the start is at the top of viewport (+ margin)
			 * If the start position is below the viewport,
			 * we set the scroll so that the start is at the bottom of viewport (+ margin)
			 */ const topScrollTop = // offset of view dom from scroll parent
            offsetTopFromScrollContainer + // top - 0.top is height of content
            startCoords.top - offsetTop - // extra margin so text isn't at the very very top
            $96ce9ac18a1b3910$var$SCROLL_MARGIN;
            const bottomScrollTop = // offset of view dom from scroll parent
            offsetTopFromScrollContainer + // bottom - 0.top is height of content
            startCoords.bottom - offsetTop + // extra margin so modal isn't in the way
            modalHeight + // extra margin so text isn't at the very very bottom
            $96ce9ac18a1b3910$var$SCROLL_MARGIN - // subtracting offsetHeight keeps content at the bottom so
            // auto-scrolling is more incremental
            scrollParentRef.current.offsetHeight;
            isProgrammaticScroll.current = true;
            if (scrollParentRef.current.scrollTop > topScrollTop) scrollParentRef.current.scroll({
                top: topScrollTop,
                behavior: 'instant'
            });
            else if (scrollParentRef.current.scrollTop < bottomScrollTop) scrollParentRef.current.scroll({
                top: bottomScrollTop,
                behavior: 'instant'
            });
        }
    }, [
        view,
        _start,
        modalRef,
        isProgrammaticScroll
    ]);
    const isEmptySelection = positions[0] === positions[1];
    const initialStartPos = positions[0];
    const shouldReplaceDoc = isEmptySelection && !configItem.insertOnEmptySelection;
    const [start, end] = shouldReplaceDoc ? [
        1,
        view.state.doc.content.size - 1
    ] : positions;
    /**
	 * we should show highlight when:
	 * - always (yayyyyyyyyy)
	 *
	 * we should not show highlight when:
	 * - suggest title
	 */ const showHighlight = !isSuggestTitle;
    // we don't want to show AI content highlight when we do full page streaming which replaces the whole document
    const showAIContentHighlight = !shouldReplaceDoc;
    (0, $cozmU.useEffect)(()=>{
        if (// we don't need to show loading highlight when we're inserting into the current position such as free generate
        isEmptySelection && configItem.insertOnEmptySelection || !showHighlight) return;
        const min = 80, max = 240;
        const prestreamLoading = setInterval(()=>{
            if (isPaused) return;
            if (((0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state) || {}).aiContentEndPos !== undefined) clearInterval(prestreamLoading);
            else view.dispatch((0, $80W3l.updateLoadingPositions)(view.state.tr));
        }, Math.random() * (max - min) + min);
        return ()=>{
            clearInterval(prestreamLoading);
        };
    }, [
        view,
        isPaused,
        configItem.insertOnEmptySelection,
        isEmptySelection,
        showHighlight
    ]);
    const mountDecorations = (0, $cozmU.useCallback)(()=>{
        const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state) || {
            chunkNumber: 0
        };
        if (pluginState.startPos === undefined) {
            // turn diff off when starting streaming
            if (api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
            (0, $4TgUg.clearSelectionDecorations)(view.state)(view.state, view.dispatch);
            setIsPaused(false);
            /**
			 * Store the original user content slice so that we can restore it
			 * and use it to manipulate the history plugin.
			 */ originalUserContentSlice.current = view.state.doc.slice(start, end);
            const $start = view.state.doc.resolve(start);
            let telepointerPos = $start.pos;
            /**
			 * We position the telepointer to be the beginning of a leaf node so that
			 * it displays inline.
			 */ let node = $start.node()?.firstChild;
            while(node && node.firstChild && !node.isLeaf){
                telepointerPos += 1;
                node = node.firstChild;
            }
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
            view.dispatch((0, $2Ldzs.closeHistory)((0, $80W3l.initPositions)({
                start: start,
                end: end,
                // Old non-unified free-gen path: faded original text.
                showHighlight: !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && showHighlight && decorationPluginState?.withStreamingHighlight !== false,
                // Old non-unified free-gen path: purple AI-content highlight.
                showAIContentHighlight: !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && showAIContentHighlight,
                // Old non-unified free-gen path: telepointer.
                showTelepointer: !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && showTelepointer,
                telepointerPos: telepointerPos
            })((0, $kEjH6.startWatchingAnnotationChanges)({
                from: start,
                to: end
            })(view.state.tr))));
            setStart(start);
            return ()=>{
                setIsPaused(true);
            };
        }
    }, [
        api,
        view,
        start,
        end,
        showHighlight,
        showAIContentHighlight,
        showTelepointer
    ]);
    /**
	 * Caller should dispatch an extra transaction to reset the document back to original state
	 * so that the history plugin can correctly track the difference between the
	 * original document and the final document after streaming.
	 */ const restoreOriginalUserContent = (0, $cozmU.useCallback)((tr)=>{
        const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
        const { startPos: startPos, userContentEndPos: userContentEndPos, streamTimeStamp: streamTimeStamp } = pluginState || {};
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return tr;
        // To review - size should never be -1 but it is sometimes
        if (originalUserContentSlice.current.size === -1) {
            // if the original user content is empty, we need to delete the inserted content
            tr = tr.delete(startPos, userContentEndPos);
            tr = (0, $80W3l.metaTransaction)({
                tr: tr,
                isFinalStream: false,
                stackTime: streamTimeStamp
            });
        } else {
            tr = tr.replaceRange(startPos, userContentEndPos, originalUserContentSlice.current);
            tr = (0, $80W3l.metaTransaction)({
                tr: tr,
                isFinalStream: false,
                stackTime: streamTimeStamp
            });
        }
        return tr;
    }, [
        view
    ]);
    const commitFinalResponse = (0, $cozmU.useCallback)(({ tr: tr, slice: slice })=>{
        const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
        let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
        const streamTimeStamp = pluginState?.streamTimeStamp;
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return tr;
        ({ startPos: startPos, userContentEndPos: userContentEndPos } = $96ce9ac18a1b3910$var$adjustStartAndUserContentEndPosForList({
            view: view,
            fragment: slice.content,
            startPos: startPos,
            userContentEndPos: userContentEndPos
        }));
        ({ startPos: startPos } = $96ce9ac18a1b3910$var$adjustStartPosForBlockMark({
            view: view,
            fragment: slice.content,
            startPos: startPos,
            userContentEndPos: userContentEndPos
        }));
        const { paragraph: paragraph } = tr.doc.type.schema.nodes;
        // If we have a lone paragraph - replaceRange will not replace with a paragraph
        // This can cause issues as we will not be using the same localId as provided
        if (slice.content.firstChild === slice.content.lastChild && slice.content.firstChild?.type === paragraph && tr.selection.$from === tr.selection.$to && (0, $2w79Z.isEmptyParagraph)(tr.selection.$from.parent)) tr = tr.replaceRangeWith(startPos, // End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
        userContentEndPos < startPos ? startPos : userContentEndPos, slice.content.firstChild);
        else {
            tr = tr.replaceRange(startPos, // End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
            userContentEndPos < startPos ? startPos : userContentEndPos, slice);
            // When replaceRange merges inline content into an existing block of the same
            // type, the original block's attrs (including localId) are preserved. If the
            // replacement carries a different localId, patch it here so downstream
            // consumers (collab, comments, etc.) see the intended id. This also handles
            // slices that contain multiple top-level blocks — each replaced block has
            // its localId patched independently.
            tr = (0, $f83a45c4b358acb4$export$d9f6dde98fa84c24)({
                tr: tr,
                replacementContent: slice.content,
                startPos: startPos
            });
        }
        tr = (0, $80W3l.metaTransaction)({
            tr: tr,
            isFinalStream: true,
            stackTime: streamTimeStamp,
            agentAttribution: (0, $0d7305543af23cc5$export$89a47aaa0c638001)({
                sessionAgentAttribution: (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state)?.agentAttribution,
                configItemKey: configItem.key
            })
        });
        tr = tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(tr.selection.to, tr.doc.content.size)));
        // the passed-in slice structure may be different from originalUserContentSlice
        // for a paragraph, the passed-in slice may contain only a text node
        // that's why we cut a new slice here
        const newSlice = tr.doc.slice($96ce9ac18a1b3910$export$8c11be8ccd39ce0b({
            pos: startPos,
            tr: tr
        }), $96ce9ac18a1b3910$export$3dcc2c094c7e6748({
            pos: userContentEndPos,
            tr: tr
        }));
        const isSame = newSlice.eq(originalUserContentSlice.current);
        if (isSame) tr = tr.setMeta('addToHistory', false);
        return tr;
    }, [
        view,
        configItem.key
    ]);
    const posAdjusted = (0, $cozmU.useRef)(false);
    /**
	 * We only add the final transaction to history so user can undo it all at once
	 */ const updateStream = (0, $cozmU.useCallback)(({ fragment: fragment, isFinalStream: isFinalStream = false, hasUserScrolled: // Prevent scroll-jacking by default to be safe
    hasUserScrolled = true })=>{
        try {
            if (isFinalStream) {
                if (hasFinalStreamRef.current) return;
                hasFinalStreamRef.current = true;
            }
            const scrollTop = scrollParentRef.current?.scrollTop;
            if (isSuggestTitle) {
                if ((0, $iDrrr.fg)('platform_editor_ai_suggest_title_actioned_event')) {
                    const actionedUnifiedEventPayload = (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        action: (0, $krYZG.ACTION).ACTIONED,
                        ...commonUnifiedAnalyticsData,
                        interactionID: aiSessionId
                    });
                    const discardedUnifiedEventPayload = (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        action: (0, $krYZG.ACTION).DISCARDED,
                        ...commonUnifiedAnalyticsData,
                        interactionID: aiSessionId
                    });
                    const fireUnifiedAnalyticsEvent = (eventType)=>{
                        api?.analytics?.actions.fireAnalyticsEvent(eventType === 'actioned' ? actionedUnifiedEventPayload : discardedUnifiedEventPayload);
                    };
                    (0, $jtPcJ.replaceConfluenceTitle)({
                        editorView: view,
                        pmFragment: fragment,
                        isFinal: isFinalStream,
                        fireUnifiedAnalyticsEvent: fireUnifiedAnalyticsEvent
                    });
                } else (0, $jtPcJ.replaceConfluenceTitle)({
                    editorView: view,
                    pmFragment: fragment
                });
                if (isFinalStream && originalUserContentSlice.current && // We need to ensure we're not doubling up unified events. The streaming api (ie rovo chat) will also be firing
                // its own unified events. So we basically nuke all unified events from the streaming api.
                commonUnifiedAnalyticsData.invokedFrom !== 'streamingApi' && commonUnifiedAnalyticsData.invokedFrom !== 'confluenceTitleGenOnPaste') // We fire the unified viewed event on the final stream because this is when all the AI content is known to be visible
                // to the user.
                // The view event previously fired in the preview modal. This will no longer occur in AIFC.
                api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).VIEWED,
                    ...commonUnifiedAnalyticsData,
                    interactionID: aiSessionId
                }));
                return;
            }
            const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
            let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
            const { aiContentEndPos: aiContentEndPos, streamTimeStamp: streamTimeStamp } = pluginState || {};
            if (startPos === undefined || userContentEndPos === undefined) return;
            let slice = (0, $aPdNQ.Slice).maxOpen(fragment);
            /**
				 * Occasionally we receive a response with empty content which causes the fragment -> slice
				 * to have a negative size, which causes the experience to break.
				 * Since there's nothing to update, we early exit here if it's not the final stream.
				 *
				 * We also want to early exit if the slice is inherently empty - for non empty selections we use maxOpen
				 * which means even if the fragment has an empty paragraph, the slice will have size 0 since the contents are empty.
				 */ if (slice.size <= 0 && !isFinalStream) return;
            // https://atlassian-2y.sentry.io/issues/6886259844/?project=4505129224110080&query=tags%5Blocation%5D%3Aeditor-ai-streaming-update-stream&referrer=issue-stream
            // we're getting error `Cannot read properties of null (reading 'content')`
            // but we're using Slice.maxOpen(fragment)
            // maybe this will fix the issue
            if (!slice.content.firstChild) slice = (0, $aPdNQ.Slice).empty;
            // If fragment isn't healthy indicate we received the chunk, but do not update positions as we haven't
            // streamed any changes
            const { isHealthy: isHealthy } = $96ce9ac18a1b3910$var$fragmentIsHealthy(fragment);
            if (!isHealthy) {
                // this is used to update the chunk number which is used to validate that the stream was "received" in orchestrator
                view.dispatch((0, $80W3l.updateStreamPositions)({
                    aiContentEndPos: pluginState?.aiContentEndPos,
                    telepointerPos: pluginState?.telepointerPos,
                    isFinalStream: isFinalStream
                })(view.state.tr));
                // const errorMessage = `Unhealthy fragment detected - ${err instanceof Error ? err.message : String(err)}`;
                // For now disable this as it reports a lot of errors for no reason
                // api?.analytics?.actions.fireAnalyticsEvent({
                // 	action: ACTION.ERRORED,
                // 	actionSubject: ACTION_SUBJECT.AI_STREAMING,
                // 	actionSubjectId: ACTION_SUBJECT_ID.UPDATE_STREAM,
                // 	eventType: EVENT_TYPE.OPERATIONAL,
                // 	attributes: {
                // 		errorMessage,
                // 		errorStack: '',
                // 		isFinalStream,
                // 		docSize: view.state.doc.content.size,
                // 		fragmentSize: fragment.size,
                // 		experienceName: fg('platform_editor_ai_streaming_error_experience_name')
                // 			? convertExperienceName(configItem.key.toString())
                // 			: undefined,
                // 	},
                // });
                return;
            }
            // we only need to adjust the pos once
            if (!posAdjusted.current) {
                posAdjusted.current = true;
                if (isEmptySelection) ({ startPos: startPos, userContentEndPos: userContentEndPos } = $96ce9ac18a1b3910$var$adjustStartEndPosForEmptySelection({
                    view: view,
                    fragment: fragment,
                    startPos: startPos,
                    userContentEndPos: userContentEndPos
                }));
                else {
                    ({ startPos: startPos } = $96ce9ac18a1b3910$var$adjustStartEndPosForRangeSelection({
                        view: view,
                        fragment: fragment,
                        startPos: startPos,
                        userContentEndPos: userContentEndPos
                    }));
                    ({ startPos: startPos, userContentEndPos: userContentEndPos } = $96ce9ac18a1b3910$var$adjustStartAndUserContentEndPosForList({
                        view: view,
                        fragment: fragment,
                        startPos: startPos,
                        userContentEndPos: userContentEndPos
                    }));
                }
            }
            // Block mark adjustment — runs on every update (not guarded by
            // posAdjusted) because the first streaming chunk may not yet
            // contain the block marks.
            ({ startPos: startPos } = $96ce9ac18a1b3910$var$adjustStartPosForBlockMark({
                view: view,
                fragment: fragment,
                startPos: startPos,
                userContentEndPos: userContentEndPos
            }));
            let toPos = isFinalStream ? userContentEndPos : Math.min(Math.max(aiContentEndPos || 0, startPos + slice.size + 1), userContentEndPos);
            ({ startPos: startPos, toPos: toPos } = $96ce9ac18a1b3910$var$adjustStartToPosForTable({
                view: view,
                fragment: fragment,
                startPos: startPos,
                toPos: toPos,
                userContentEndPos: userContentEndPos
            }));
            if (!isFinalStream) ({ startPos: startPos, toPos: toPos } = $96ce9ac18a1b3910$var$adjustStartToPosForSyncBlock({
                view: view,
                fragment: fragment,
                startPos: startPos,
                toPos: toPos,
                userContentEndPos: userContentEndPos
            }));
            slice = $96ce9ac18a1b3910$var$adjustSliceOpenStartEnd({
                slice: slice,
                startPos: startPos,
                toPos: toPos,
                view: view
            });
            aiContentSlice.current = slice;
            // we don't want to add every streaming step to history
            let tr = view.state.tr;
            const shouldSkipEmptySliceFinal = isFinalStream && slice.size <= 0;
            if (isFinalStream && originalUserContentSlice.current && !shouldSkipEmptySliceFinal) {
                // we still need this restoration because it will allow
                // Prosemirror to drop fully covered parent nodes of the replaced region
                // if in the future we decide to remove this
                // we may need to revisit the logic to drop fully covered parent nodes
                // otherwise there will be empty parent nodes left in the doc
                view.dispatch(restoreOriginalUserContent(view.state.tr));
                // re-get pos after dispatch
                const _pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
                startPos = _pluginState?.startPos || startPos;
                toPos = _pluginState?.userContentEndPos || toPos;
                // Now we replace it with the AI response
                tr = commitFinalResponse({
                    tr: view.state.tr,
                    slice: slice
                });
                if (// We need to ensure we're not doubling up unified events. The streaming api (ie rovo chat) will also be firing
                // its own unified events. So we basically nuke all unified events from the streaming api.
                commonUnifiedAnalyticsData.invokedFrom !== 'streamingApi') // We fire the unified viewed event on the final stream because this is when all the AI content is known to be visible
                // to the user.
                // The view event previously fired in the preview modal. This will no longer occur in AIFC.
                api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).VIEWED,
                    ...commonUnifiedAnalyticsData,
                    interactionID: aiSessionId
                }));
            } else if (!shouldSkipEmptySliceFinal) {
                tr = view.state.tr// End pos should never be smaller than start pos - for now just clamp it to start (to be reviewed)
                .replaceRange(startPos, toPos < startPos ? startPos : toPos, slice)// Local id updates break streaming as we may be trying
                // to replace a node that's already streamed in with
                // an empty local id -> causing the node to be destroyed and recreated
                // on the final stream we clean it up
                .setMeta('ignoreLocalIdUpdate', true);
                tr = (0, $80W3l.metaTransaction)({
                    tr: tr,
                    isFinalStream: isFinalStream,
                    stackTime: streamTimeStamp,
                    agentAttribution: (0, $0d7305543af23cc5$export$89a47aaa0c638001)({
                        sessionAgentAttribution: (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state)?.agentAttribution,
                        configItemKey: configItem.key
                    })
                });
            } else if (commonUnifiedAnalyticsData.invokedFrom !== 'streamingApi') // For non-streamable commands (e.g. setAttrs, removeNode), the change was already
            // applied by applyCommand. Fire the viewed analytics event since the AI content
            // is visible to the user even though we skip restore+commit.
            api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).VIEWED,
                ...commonUnifiedAnalyticsData,
                interactionID: aiSessionId
            }));
            const mappedStartPos = $96ce9ac18a1b3910$export$8c11be8ccd39ce0b({
                pos: startPos,
                tr: tr
            });
            let mappedToPos = $96ce9ac18a1b3910$export$3dcc2c094c7e6748({
                pos: toPos,
                tr: tr
            });
            let telepointerPos = mappedToPos;
            tr.doc.nodesBetween(mappedStartPos, mappedToPos, (node, pos)=>{
                if (node.isLeaf) telepointerPos = pos + node.nodeSize;
            });
            telepointerPos = Math.min(telepointerPos, mappedToPos);
            view.dispatch((0, $80W3l.updateStreamPositions)({
                aiContentEndPos: toPos,
                telepointerPos: telepointerPos,
                isFinalStream: isFinalStream
            })(tr));
            // Expand all expand and nestedExpand nodes in the actual document after dispatching
            // Set expandedState after dispatch: only view.state.doc has the real nodes, not tr.doc.
            api?.core.actions.execute(api?.expand?.commands.toggleExpandRange(mappedStartPos, Math.min(mappedToPos, view.state.doc.content.size)));
            isProgrammaticScroll.current = true;
            if (!hasUserScrolled && scrollParentRef.current) {
                const modalHeight = modalRef?.current?.offsetHeight || 0;
                // somehow we're getting pos out of range error here
                mappedToPos = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(mappedToPos, 0, view.state.doc.content.size);
                let toPosBottom = view.coordsAtPos(mappedToPos).bottom;
                // somehow this coords could be all 0 when the mappedToPos is the last position of the doc
                if (toPosBottom === 0) toPosBottom = view.coordsAtPos(mappedToPos - 1).bottom;
                const bottomScrollTop = // offset of view dom from scroll parent
                (0, $213d86ec3834626a$export$f9c4337e36118c2b)(view.dom, scrollParentRef.current) + // mappedToPos.bottom - 0.top is height of content
                view.coordsAtPos(mappedToPos).bottom - view.coordsAtPos(0).top + // extra margin so modal isn't in the way
                modalHeight + // extra margin so text isn't at the very very bottom
                $96ce9ac18a1b3910$var$SCROLL_MARGIN - // subtracting offsetHeight keeps content at the bottom so
                // auto-scrolling is more incremental
                scrollParentRef.current.offsetHeight;
                // when isFinalStream is true, scrollParentRef.current.scrollTop is 0,
                // maybe it's because we reset the doc content before committing the final response,
                // but it doesn't affect the result if we adjust the scrollTop
                if (scrollParentRef.current.scrollTop < bottomScrollTop) scrollParentRef.current?.scroll({
                    top: bottomScrollTop,
                    behavior: 'instant'
                });
            } else if (scrollParentRef.current && scrollParentRef.current.scrollTop !== scrollTop) scrollParentRef.current.scroll({
                top: scrollTop,
                behavior: 'instant'
            });
        } catch (error) {
            const errorMessage = (0, $1w4hj.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) {
                errorStack = error.stack || '';
                (0, $jv11C.logException)(error, {
                    location: 'editor-ai-streaming-update-stream',
                    isFinalStream: isFinalStream,
                    docSize: view.state.doc.content.size,
                    fragmentSize: fragment.size
                });
            }
            // https://atlassian-2y.sentry.io/issues/errors-outages/?project=4505129224110080&query=tags%5Blocation%5D%3Aeditor-ai-streaming-update-stream&referrer=issue-list&statsPeriod=14d
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).UPDATE_STREAM,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: errorMessage,
                    errorStack: errorStack,
                    isFinalStream: isFinalStream,
                    docSize: view.state.doc.content.size,
                    fragmentSize: fragment.size,
                    experienceName: (0, $iDrrr.fg)('platform_editor_ai_streaming_error_experience_name') ? (0, $l2lIz.convertExperienceName)(configItem.key.toString()) : undefined
                }
            });
            if (isFinalStream) throw error;
        }
    }, [
        api,
        view,
        modalRef,
        isSuggestTitle,
        restoreOriginalUserContent,
        commitFinalResponse,
        isEmptySelection,
        isProgrammaticScroll,
        commonUnifiedAnalyticsData,
        aiSessionId,
        configItem.key
    ]);
    const discardStream = (0, $cozmU.useCallback)(({ restoreSelection: restoreSelection = true } = {})=>{
        const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
        let { startPos: startPos, userContentEndPos: userContentEndPos } = pluginState || {};
        if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice.current) return;
        try {
            // undo only if we already have streamed AI content
            // which means non need to undo if there is no network response yet or we haven't streamed anything yet
            if (!!aiContentSlice.current) {
                (0, $1Iyfh.undo)(view.state, view.dispatch);
                // re-get pos after dispatch
                const _pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
                startPos = _pluginState?.startPos || startPos;
                userContentEndPos = _pluginState?.userContentEndPos || userContentEndPos;
            }
            let tr = view.state.tr;
            // We close the current history here.
            // We have a new history event when we do the discard, but when we close history we lock in the "mid-stream"
            // rather than an empty undo.
            (0, $2Ldzs.closeHistory)(tr);
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
            // If there was a session, don't restore the selection
            // because there might be multiple streaming updates, so we can't restore the selection
            if (restoreSelection && !decorationPluginState?.sessionEnded) {
                // restore user selection
                let anchor = 1;
                let head = 1;
                if (isEmptySelection) {
                    anchor = initialStartPos;
                    head = anchor;
                } else {
                    anchor = $96ce9ac18a1b3910$export$8c11be8ccd39ce0b({
                        pos: startPos,
                        tr: tr
                    });
                    head = $96ce9ac18a1b3910$export$3dcc2c094c7e6748({
                        pos: userContentEndPos,
                        tr: tr
                    });
                    if (decorationPluginState && decorationPluginState.initialSelection && decorationPluginState.initialSelection.head < decorationPluginState.initialSelection.anchor) [anchor, head] = [
                        head,
                        anchor
                    ];
                }
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, anchor, head));
            }
            // hide the highlight immediately after the stream is discarded
            // this is needed if we need to discard when the response is too similar
            tr = (0, $80W3l.endStream)(tr);
            view.dispatch(tr);
        } catch (error) {
            const errorMessage = (0, $1w4hj.ErrorUtils).extractErrorMessage(error);
            let errorStack = '';
            if (error instanceof Error) {
                errorStack = error.stack || '';
                (0, $jv11C.logException)(error, {
                    location: 'editor-ai-streaming-discard-stream'
                });
            }
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_STREAMING,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DISCARD_STREAM,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: errorMessage,
                    errorStack: errorStack
                }
            });
        } finally{
            // reset the stream state so that we can't discard again
            originalUserContentSlice.current = undefined;
            aiContentSlice.current = undefined;
        }
    }, [
        api,
        view,
        isEmptySelection,
        initialStartPos
    ]);
    return {
        mountDecorations: mountDecorations,
        updateStream: updateStream,
        discardStream: discardStream,
        /**
		 * @private
		 * @deprecated	This method was only added for testing purposes within unified-analytics.tsx
		 * 				and should be removed as soon as we have a better way to emulate multiple
		 * 				"mini-streams" within a session (e.g. during free-gen)
		 */ resetHasFinalStreamRef: ()=>hasFinalStreamRef.current = false
    };
};

















const $ae94e0246d8d345f$var$isAgentMentionsEnabled = ()=>(0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true);
const $ae94e0246d8d345f$var$isTelepointerRedesignEnabled = ()=>$ae94e0246d8d345f$var$isAgentMentionsEnabled() && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_telepointer_redesign');
const $ae94e0246d8d345f$export$1fe5be5b06049a0e = ({ elements: { avatarContainer: avatarContainer, element: element, labelElement: labelElement }, getTelepointerLabel: getTelepointerLabel, portalProviderAPI: portalProviderAPI })=>{
    // null = a badge was rendered then removed; undefined = never rendered.
    let lastRenderedAgentKey = null;
    // Guards the label/avatar display swap so it isn't rewritten on every streaming transaction.
    let showingBadge;
    let lastLineColor = '';
    const update = (agentInfo)=>{
        // The resolver always returns a kind (rovo / agent / fallback), so a presentation means a
        // badge; the redesign gate and an agent-attributed session are the only preconditions.
        const presentation = $ae94e0246d8d345f$var$isTelepointerRedesignEnabled() && agentInfo ? (0, $41f87b82bbd44c62$export$bdd925339e34f195)(agentInfo) : undefined;
        if (presentation && agentInfo) {
            if (showingBadge !== true) {
                showingBadge = true;
                labelElement.style.display = 'none';
                avatarContainer.style.display = '';
                // The redesign cursor line is 2px and the height of the content highlight. Gated with
                // the colour so the off-experiment and agent-edit-chrome lines keep the 1px / 24px
                // default in the shared CSS.
                element.style.setProperty('--agent-edit-chrome-telepointer-line-width', '2px');
                element.style.setProperty('--agent-edit-chrome-telepointer-line-height', '20px');
            }
            // The badge fill and cursor line take the agent's hue from this variable, read by the
            // shared GlobalWrapper CSS — the same pairing the consolidated plugin sets.
            const lineColor = presentation.telepointerLineColor ?? '';
            if (lastLineColor !== lineColor) {
                lastLineColor = lineColor;
                if (lineColor) element.style.setProperty('--agent-edit-chrome-telepointer-line-color', lineColor);
                else element.style.removeProperty('--agent-edit-chrome-telepointer-line-color');
            }
            const { agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentName: agentName, agentNamedId: agentNamedId } = agentInfo;
            const kind = presentation.telepointerAgentKind;
            // Re-render on any change to a badge input, not just the identity account id.
            const agentRenderKey = [
                kind,
                agentNamedId,
                agentIdentityAccountId,
                agentId,
                agentName
            ].join('|');
            if (lastRenderedAgentKey !== agentRenderKey) {
                lastRenderedAgentKey = agentRenderKey;
                portalProviderAPI.render(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca6eb8d3f45d47e$export$5d20881141a253fa), {
                        agentId: agentId,
                        agentIdentityAccountId: agentIdentityAccountId,
                        agentName: agentName,
                        agentNamedId: agentNamedId ?? undefined,
                        kind: kind
                    }), avatarContainer, (0, $0ca5a13529310b54$export$2727940767f36f55));
            }
            return;
        }
        if (showingBadge !== false) {
            showingBadge = false;
            avatarContainer.style.display = 'none';
            labelElement.style.display = '';
            element.style.removeProperty('--agent-edit-chrome-telepointer-line-width');
            element.style.removeProperty('--agent-edit-chrome-telepointer-line-height');
        }
        if (lastLineColor !== '') {
            lastLineColor = '';
            element.style.removeProperty('--agent-edit-chrome-telepointer-line-color');
        }
        if (lastRenderedAgentKey !== null) {
            lastRenderedAgentKey = null;
            portalProviderAPI.remove((0, $0ca5a13529310b54$export$2727940767f36f55));
        }
        const newLabel = getTelepointerLabel({
            agentName: agentInfo?.agentName,
            isAgentMentionEnabled: $ae94e0246d8d345f$var$isAgentMentionsEnabled()
        });
        if (labelElement.textContent !== newLabel) labelElement.textContent = newLabel;
    };
    const destroy = ()=>{
        if (lastRenderedAgentKey !== null) {
            lastRenderedAgentKey = null;
            portalProviderAPI.remove((0, $0ca5a13529310b54$export$2727940767f36f55));
        }
    };
    return {
        destroy: destroy,
        update: update
    };
};


const $c64804cb1104031c$var$initialState = {
    showHighlight: false,
    showAIContentHighlight: false,
    showTelepointer: false,
    isStreaming: false,
    isStreamingFinished: false,
    startPos: undefined,
    loadingPos: undefined,
    userContentEndPos: undefined,
    aiContentEndPos: undefined,
    telepointerPos: undefined,
    isFinalStream: false,
    chunkNumber: 0,
    streamTimeStamp: undefined
};
const $c64804cb1104031c$var$userContentDecorationAttrs = {
    class: 'ai-in-editor-user-content',
    'aria-hidden': 'true',
    'data-testid': 'ai-in-editor-user-content'
};
const $c64804cb1104031c$var$isEditorAgentMentionsTelepointerAvatarEnabled = ()=>(0, $jkcNT.editorExperiment)('platform_editor_agent_mentions', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_telepointer_redesign');
const $c64804cb1104031c$export$465eeb0611517dc = (options)=>{
    const { portalProviderAPI: portalProviderAPI } = options;
    const intl = options.getIntl();
    const getTelepointerLabel = (0, $710cefc8d9f7e5d9$export$1b782d5498130429)({
        formatMessage: intl.formatMessage,
        streamingTelepointerIdentity: options.streamingTelepointerIdentity
    });
    const defaultLabel = getTelepointerLabel({
        isAgentMentionEnabled: false
    });
    // Create the telepointer element — label is mutated per-session to show agent name
    const { element: telepointerElement, labelElement: telepointerLabelElement, avatarContainer: telepointerAvatarContainer } = (0, $0ca5a13529310b54$export$b3d3cfdedcf26988)(defaultLabel);
    const telepointerBadge = (0, $ae94e0246d8d345f$export$1fe5be5b06049a0e)({
        elements: {
            avatarContainer: telepointerAvatarContainer,
            element: telepointerElement,
            labelElement: telepointerLabelElement
        },
        getTelepointerLabel: getTelepointerLabel,
        portalProviderAPI: portalProviderAPI
    });
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $ix5ay.inEditorDirectStreamingPluginKey),
        state: {
            init: ()=>{
                return $c64804cb1104031c$var$initialState;
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $ix5ay.inEditorDirectStreamingPluginKey));
                let newPluginState = pluginState;
                if (meta?.action) switch(meta.action){
                    case (0, $g8hEw.ACTIONS).INIT_POSITIONS:
                        {
                            const { positions: positions, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer } = meta;
                            const { startPos: startPos, userContentEndPos: userContentEndPos, telepointerPos: telepointerPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                showHighlight: showHighlight,
                                showAIContentHighlight: showAIContentHighlight,
                                showTelepointer: showTelepointer,
                                isStreaming: true,
                                isStreamingFinished: false,
                                startPos: startPos,
                                loadingPos: startPos,
                                userContentEndPos: userContentEndPos,
                                telepointerPos: telepointerPos,
                                aiContentEndPos: undefined,
                                streamTimeStamp: Date.now()
                            };
                            break;
                        }
                    case (0, $g8hEw.ACTIONS).ADJUST_INIT_POSITIONS:
                        {
                            const { positions: positions } = meta;
                            const { startPos: startPos, userContentEndPos: userContentEndPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                startPos: startPos,
                                userContentEndPos: userContentEndPos
                            };
                            break;
                        }
                    case (0, $g8hEw.ACTIONS).UPDATE_LOADING_POSITIONS:
                        {
                            const { startPos: startPos, userContentEndPos: userContentEndPos, loadingPos: loadingPos } = pluginState;
                            if (startPos === undefined || userContentEndPos === undefined) break;
                            const max = userContentEndPos;
                            const min = loadingPos || startPos;
                            const eighth = (max - min) / 8;
                            const low = Math.floor(min + eighth);
                            const high = Math.ceil(min + 3 * eighth);
                            const newLoadingPos = Math.ceil(Math.random() * (high - low) + low);
                            newPluginState = {
                                ...newPluginState,
                                loadingPos: tr.mapping.map(newLoadingPos, -1)
                            };
                            break;
                        }
                    case (0, $g8hEw.ACTIONS).UPDATE_STREAM_POSITIONS:
                        {
                            const { positions: positions, isFinalStream: isFinalStream } = meta;
                            const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos } = positions;
                            newPluginState = {
                                ...newPluginState,
                                // when final stream, hide highlight for accept reject screen
                                ...isFinalStream ? {
                                    showHighlight: false,
                                    showAIContentHighlight: false,
                                    showTelepointer: false
                                } : {},
                                loadingPos: undefined,
                                aiContentEndPos: aiContentEndPos,
                                telepointerPos: telepointerPos,
                                isFinalStream: isFinalStream,
                                // when auto accept AI changes is off, isStreaming should be false once we have the final stream
                                // otherwise, ai orchestrator endExperiencePromise will timeout
                                isStreaming: !isFinalStream,
                                isStreamingFinished: isFinalStream,
                                chunkNumber: newPluginState.chunkNumber + 1,
                                // Ensure the streaming timestamp is updated so it's > previous value (for history plugin)
                                streamTimeStamp: newPluginState.streamTimeStamp ? newPluginState.streamTimeStamp + 1 : undefined
                            };
                            break;
                        }
                    case (0, $g8hEw.ACTIONS).END_STREAM:
                        return {
                            ...$c64804cb1104031c$var$initialState,
                            // the telepointer position should be reset on init, however we want to remember the last position until then.
                            telepointerPos: newPluginState.telepointerPos
                        };
                }
                else // These positions will be mapped by the plugin's transaction
                // So we map them only when the transaction is not related to the plugin
                newPluginState = {
                    ...newPluginState,
                    ...newPluginState.loadingPos !== undefined && {
                        loadingPos: tr.mapping.map(newPluginState.loadingPos, -1)
                    },
                    ...newPluginState.telepointerPos !== undefined && {
                        telepointerPos: tr.mapping.map(newPluginState.telepointerPos, -1)
                    }
                };
                newPluginState = {
                    ...newPluginState,
                    ...newPluginState.startPos !== undefined && {
                        startPos: (0, $96ce9ac18a1b3910$export$8c11be8ccd39ce0b)({
                            pos: newPluginState.startPos,
                            tr: tr
                        })
                    },
                    ...newPluginState.userContentEndPos !== undefined && {
                        userContentEndPos: (0, $96ce9ac18a1b3910$export$3dcc2c094c7e6748)({
                            pos: newPluginState.userContentEndPos,
                            tr: tr
                        })
                    },
                    ...newPluginState.aiContentEndPos !== undefined && {
                        aiContentEndPos: (0, $96ce9ac18a1b3910$export$3dcc2c094c7e6748)({
                            pos: newPluginState.aiContentEndPos,
                            tr: tr
                        })
                    }
                };
                return newPluginState;
            }
        },
        props: {
            decorations: (state)=>{
                // Old non-unified free-gen path: do not paint streaming decorations.
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1')) return (0, $8nvEM.DecorationSet).empty;
                const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(state);
                const { showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, loadingPos: loadingPos, isFinalStream: isFinalStream, isStreaming: isStreaming } = pluginState || {};
                // Single getState call for the entire decorations() invocation — this is a hot path
                // called on every ProseMirror state update, so we hoist it and reuse below.
                const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
                // NOTE: Telepointer avatar DOM mutations and React portal renders have been moved
                // to view.update() below to keep decorations() a pure function (no side effects).
                const decorations = [];
                if (!isStreaming || startPos === undefined) {
                    // If streaming stops and theres still and active session, then we need to ensure that the telepointer remains
                    // visible on the page up until the ai session is ended.
                    const { nextSessionId: nextSessionId } = decorationState || {};
                    if (!!nextSessionId && telepointerPos !== undefined) return (0, $8nvEM.DecorationSet).create(state.doc, [
                        (0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement)
                    ]);
                    return (0, $8nvEM.DecorationSet).empty;
                }
                if (showHighlight) {
                    if (loadingPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(startPos, loadingPos, $c64804cb1104031c$var$userContentDecorationAttrs));
                    else if (userContentEndPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(aiContentEndPos || startPos, userContentEndPos, $c64804cb1104031c$var$userContentDecorationAttrs));
                    if (showAIContentHighlight && aiContentEndPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(startPos, aiContentEndPos, (0, $95624cff4026d0c7$export$20fa6d5c5205d623)({
                        agentInfo: decorationState?.agentInfo,
                        useAgentHighlightColor: $c64804cb1104031c$var$isEditorAgentMentionsTelepointerAvatarEnabled()
                    })));
                }
                /**
         * We show the telepointer only when isFinalStream is false.
         * On the final stream, plugin state is reset so isFinalStream will be undefined.
         */ if (isFinalStream === false && showTelepointer) decorations.push((0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(telepointerPos || aiContentEndPos || startPos, telepointerElement));
                else {
                    // If the telepointer is not being shown, and there is a next session id set, then we can renderer a temporary
                    // telepointer ad the current selection position
                    const { nextSessionId: nextSessionId } = decorationState || {};
                    if (!!nextSessionId && telepointerPos !== undefined) decorations.push((0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement));
                }
                if (decorations.length) return (0, $8nvEM.DecorationSet).create(state.doc, decorations);
                return (0, $8nvEM.DecorationSet).empty;
            }
        },
        view () {
            let hasReset = false;
            let wasPreviouslyStreaming = false;
            let cursorHiddenState = false;
            let originalTabIndex;
            let originalOutlineColor;
            let originalOutline;
            return {
                update (view) {
                    // Hoist a single getState call for use throughout this update() invocation.
                    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
                    const pluginState = (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(view.state);
                    const { currentSessionId: currentSessionId } = decorationState || {};
                    const { isStreaming: isStreaming = false, isStreamingFinished: isStreamingFinished = false } = pluginState || {};
                    const isActive = !!currentSessionId || isStreaming || isStreamingFinished;
                    // Update the telepointer badge here in view.update() rather than in decorations() so
                    // DOM mutations and React portal renders stay side-effect-free from the perspective
                    // of ProseMirror's decoration rendering pass.
                    telepointerBadge.update(decorationState?.agentInfo);
                    const editorContentArea = view?.dom.closest('.ak-editor-content-area');
                    if (originalTabIndex === undefined && editorContentArea) {
                        originalTabIndex = editorContentArea.tabIndex;
                        originalOutlineColor = editorContentArea.style.outlineColor;
                        originalOutline = editorContentArea.style.outline;
                    }
                    // Handle cursor visibility
                    if (isActive !== wasPreviouslyStreaming) {
                        if (isActive && !cursorHiddenState) {
                            cursorHiddenState = true;
                            options.api?.core.actions.execute(options.api?.selection?.commands.hideCursor(true));
                        } else if (!isActive && cursorHiddenState) {
                            cursorHiddenState = false;
                            options.api?.core.actions.execute(options.api?.selection?.commands.hideCursor(false));
                        }
                    }
                    // At the start of streaming reset
                    if (isActive && !hasReset) {
                        hasReset = true;
                        options.api?.core?.actions.execute(({ tr: tr })=>{
                            options.api?.trackChanges?.commands.resetBaseline({
                                tr: tr
                            });
                            options.api?.userIntent?.commands.setCurrentUserIntent('aiStreaming')({
                                tr: tr
                            });
                            options.api?.editorDisabled?.commands.toggleDisabled(true)({
                                tr: tr
                            });
                            return tr;
                        });
                        // when we disable editor while streaming, document.body will be focused
                        // we need to focus editor to make pressing esc to work
                        if (editorContentArea) {
                            editorContentArea.tabIndex = -1;
                            editorContentArea.style.outline = 'none';
                            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                            if (editorContentArea && !editorContentArea.contains(document.activeElement)) editorContentArea.focus();
                        }
                    }
                    // When streaming concludes allow for
                    if (!isActive && hasReset) {
                        hasReset = false;
                        options.api?.core?.actions.execute(({ tr: tr })=>{
                            options.api?.userIntent?.commands.setCurrentUserIntent('default')({
                                tr: tr
                            });
                            options.api?.editorDisabled?.commands.toggleDisabled(false)({
                                tr: tr
                            });
                            return tr;
                        });
                        if (editorContentArea) {
                            if (originalTabIndex !== undefined) {
                                if (originalTabIndex === -1) editorContentArea.removeAttribute('tabindex');
                                else editorContentArea.tabIndex = originalTabIndex;
                            }
                            if (originalOutlineColor !== undefined) {
                                editorContentArea.style.outlineColor = originalOutlineColor;
                                if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
                            }
                            if (originalOutline !== undefined) {
                                editorContentArea.style.outline = originalOutline;
                                if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
                            }
                        }
                    }
                    wasPreviouslyStreaming = isActive;
                },
                destroy () {
                    telepointerBadge.destroy();
                }
            };
        }
    });
};






var $amP3t = parcelRequire("amP3t");








var $gCEOR = parcelRequire("gCEOR");


var $8Qy96 = parcelRequire("8Qy96");


var $cg8YD = parcelRequire("cg8YD");


var $6U6f6 = parcelRequire("6U6f6");


var $35sTx = parcelRequire("35sTx");







function $0088d0309d3888e3$export$9bc8c22bfed8132b(prevState, newState) {
    return !prevState.doc.eq(newState.doc);
}
function $0088d0309d3888e3$export$7c8b2b990474e5ed(state, currentLocale) {
    return (0, $6U6f6.getPluginState)(state).locale !== currentLocale;
}
var $0088d0309d3888e3$export$2aad89d71b868151 = /*#__PURE__*/ function(KeydownActionType) {
    KeydownActionType["INSERT"] = "INSERT";
    KeydownActionType["DISMISS"] = "DISMISS";
    return KeydownActionType;
}({});
const $0088d0309d3888e3$export$5f35e2fc4ff3b9a2 = (actionType, triggeredFrom, api)=>{
    return (state, dispatch)=>{
        if (!state || !(0, $6U6f6.getPluginState)(state)) return false;
        if ((0, $6U6f6.getPluginState)(state)?.inlineSuggestion) {
            if (actionType === "INSERT") {
                (0, $35sTx.insertInlineSuggestionWithAnalytics)(api?.analytics?.actions)(triggeredFrom)(state, dispatch);
                return true;
            }
            if (actionType === "DISMISS") {
                (0, $35sTx.clearSuggestionWithAnalytics)(api?.analytics?.actions)(triggeredFrom)(state, dispatch);
                return true;
            }
        }
        return false;
    };
};
const $0088d0309d3888e3$export$c5cb2015ae945fc1 = (oldState, newState, api)=>{
    const { inlineSuggestion: oldInlineSuggestions } = (0, $6U6f6.getPluginState)(oldState);
    const { inlineSuggestion: newInlineSuggestions } = (0, $6U6f6.getPluginState)(newState);
    if (oldInlineSuggestions?.metadata !== newInlineSuggestions?.metadata && newInlineSuggestions !== null) (0, $35sTx.fireNewSuggestionAnalytics)({
        analyticsApi: api?.analytics?.actions,
        state: newState
    });
    return null;
};
function $0088d0309d3888e3$export$f67302dde054579d(event) {
    const relatedTarget = event.relatedTarget || document.activeElement;
    return relatedTarget instanceof Element && Boolean(relatedTarget.closest('[data-editor-popup="true"]'));
}
function $0088d0309d3888e3$export$eca9821f54e86f43(state) {
    const { inlineSuggestion: inlineSuggestion } = (0, $6U6f6.getPluginState)(state);
    return Boolean(inlineSuggestion);
}
function $0088d0309d3888e3$var$isSelectionAtEndOfDocument(state) {
    return state.selection.from === state.doc.nodeSize - 3;
}
function $0088d0309d3888e3$var$hasActiveCompletionHintDecoration(decorationSet) {
    return decorationSet.find().some((deco)=>deco?.spec?.type === (0, $8Qy96.SuggestionManager).DECORATION_TYPES.completionHint);
}
function $0088d0309d3888e3$var$isAtCompletionHintBoundary(selection, inlineSuggestion) {
    return selection.from === inlineSuggestion?.to;
}
function $0088d0309d3888e3$export$4245db1db7843682(state) {
    const { selection: selection } = state;
    if (!selection.empty || !$0088d0309d3888e3$var$isSelectionAtEndOfDocument(state)) return false;
    const { inlineSuggestion: inlineSuggestion, decorationSet: decorationSet } = (0, $6U6f6.getPluginState)(state);
    const hintActive = $0088d0309d3888e3$var$hasActiveCompletionHintDecoration(decorationSet);
    return hintActive && $0088d0309d3888e3$var$isAtCompletionHintBoundary(selection, inlineSuggestion);
}


const $96fc14b0015074c7$export$21cd6432d1e2d949 = (options)=>{
    const { dispatch: dispatch, getIntl: getIntl, api: api } = options;
    const { locale: locale } = getIntl();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $cg8YD.inlineSuggestionPluginKey),
        state: (0, $6U6f6.createPluginState)(dispatch, (0, $6U6f6.createInitialState)({
            locale: locale
        })),
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $6U6f6.getPluginState)(state);
                return decorationSet;
            },
            handleKeyDown: (0, $44cyU.keydownHandler)({
                Enter: (0, $0088d0309d3888e3$export$5f35e2fc4ff3b9a2)((0, $0088d0309d3888e3$export$2aad89d71b868151).INSERT, (0, $amP3t.AI_SUGGESTION_TRIGGERED_FROM).ENTER_BUTTON, api),
                Tab: (0, $0088d0309d3888e3$export$5f35e2fc4ff3b9a2)((0, $0088d0309d3888e3$export$2aad89d71b868151).INSERT, (0, $amP3t.AI_SUGGESTION_TRIGGERED_FROM).TAB_BUTTON, api),
                Escape: (0, $0088d0309d3888e3$export$5f35e2fc4ff3b9a2)((0, $0088d0309d3888e3$export$2aad89d71b868151).DISMISS, (0, $amP3t.AI_SUGGESTION_TRIGGERED_FROM).ESCAPE_BUTTON, api),
                ArrowRight: (0, $0088d0309d3888e3$export$4245db1db7843682)
            }),
            handleDOMEvents: {
                blur: (view, event)=>{
                    if ((0, $0088d0309d3888e3$export$eca9821f54e86f43)(view.state) && !(0, $0088d0309d3888e3$export$f67302dde054579d)(event)) {
                        (0, $gCEOR.clearSuggestion)()(view.state, view.dispatch);
                        return false;
                    }
                }
            }
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    try {
                        const currentState = view.state;
                        if ((0, $0088d0309d3888e3$export$9bc8c22bfed8132b)(prevState, currentState)) (0, $8Qy96.suggestionManager).scheduleScanForSuggestions(view);
                        const currentLocale = getIntl().locale;
                        if ((0, $0088d0309d3888e3$export$7c8b2b990474e5ed)(currentState, currentLocale)) (0, $gCEOR.updateLocale)(currentLocale)(currentState, view.dispatch);
                    } catch (err) {
                    // HOT-118204: swallow uncaught errors for now to prevent collab catchup failures
                    }
                },
                destroy: ()=>{
                    (0, $8Qy96.suggestionManager).cancelSuggestionScans();
                }
            };
        },
        appendTransaction: (_transactions, oldState, newState)=>{
            return (0, $0088d0309d3888e3$export$c5cb2015ae945fc1)(oldState, newState, api);
        }
    });
};











const $b75e4d94e782c254$export$1d8514938d526e53 = (options)=>{
    const { api: api } = options;
    return new (0, $kpCD8.SafePlugin)({
        view () {
            let previousIsRunning = false;
            return {
                update (view) {
                    if (!api?.placeholder || !api?.core) return;
                    const state = view.state;
                    const aiDecorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
                    const currentIsRunning = aiDecorationState?.isRunning ?? false;
                    if (currentIsRunning !== previousIsRunning) {
                        previousIsRunning = currentIsRunning;
                        if (options.editorPluginAIProvider.isInDocumentStreamingEnabled) api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(currentIsRunning));
                        else if ((0, $iLrhi.isEmptyDocument)(state.doc)) api.core.actions.execute(api.placeholder.commands.setPlaceholderHidden(currentIsRunning));
                    }
                }
            };
        }
    });
};




















function $15e427849866f9a2$export$de5e90bd767c5d82() {
    return {
        // Original fields
        showHighlight: false,
        showAIContentHighlight: false,
        showTelepointer: false,
        isStreaming: false,
        isStreamingFinished: false,
        startPos: undefined,
        loadingPos: undefined,
        userContentEndPos: undefined,
        aiContentEndPos: undefined,
        telepointerPos: undefined,
        isFinalStream: false,
        chunkNumber: 0,
        streamTimeStamp: undefined,
        // New fields
        streamPhase: 'idle',
        // Use -1 so that responseVersion 0 > -1 triggers the first update
        // This is important for subsequent streams in the same session where
        // responseVersion resets to 0
        lastProcessedVersion: -1,
        posAdjusted: false,
        hasFinalStream: false,
        originalUserContentSlice: undefined,
        aiContentSlice: undefined,
        scrollTargetPos: undefined,
        isPaused: true,
        streamStartPos: undefined,
        currentSessionId: undefined
    };
}


function $2ee9ebcc666cf053$export$8c11be8ccd39ce0b({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, -1);
    // Special handling for AI streaming transformation
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos > pos) {
            const adjustedPos = tr.mapping.map(pos - 1, -1) + 1;
            if (adjustedPos === pos) mappedPos = pos;
        }
    }
    return mappedPos;
}
function $2ee9ebcc666cf053$export$3dcc2c094c7e6748({ pos: pos, tr: tr }) {
    let mappedPos = tr.mapping.map(pos, 1);
    // Special handling for AI streaming transformation
    if (tr.getMeta('isAIStreamingTransformation')) {
        if (mappedPos === pos) {
            const mappedPosPlus1 = tr.mapping.map(pos + 1, 1);
            // Only subtract 1 if the node size is greater than 1.
            // When nodeSize === 1 (e.g. a rule node), mappedPosPlus1 - pos === 1
            // and subtracting 1 would collapse aiContentEndPos back to startPos,
            // causing the restore transaction to leave AI content in place and
            // the commit transaction to re-insert it (producing a duplicate node).
            if (mappedPosPlus1 - pos > 1) mappedPos = mappedPosPlus1 - 1;
        }
    }
    return mappedPos;
}





function $2af5934346f37a76$export$158e6dc925f36647(state, startPos, endPos) {
    const errors = [];
    const docSize = state.doc.content.size;
    let safeStart = startPos ?? 0;
    let safeEnd = endPos ?? docSize;
    // Validate startPos
    if (startPos === undefined) errors.push('startPos is undefined');
    else {
        if (startPos < 0) {
            errors.push(`startPos ${startPos} is negative`);
            safeStart = 0;
        }
        if (startPos > docSize) {
            errors.push(`startPos ${startPos} exceeds docSize ${docSize}`);
            safeStart = docSize;
        }
    }
    // Validate endPos
    if (endPos === undefined) errors.push('endPos is undefined');
    else {
        if (endPos < 0) {
            errors.push(`endPos ${endPos} is negative`);
            safeEnd = 0;
        }
        if (endPos > docSize) {
            errors.push(`endPos ${endPos} exceeds docSize ${docSize}`);
            safeEnd = docSize;
        }
    }
    // Validate relationship
    if (safeEnd < safeStart) {
        errors.push(`endPos ${safeEnd} is less than startPos ${safeStart}`);
        safeEnd = safeStart;
    }
    return {
        valid: errors.length === 0,
        errors: errors,
        sanitized: {
            startPos: safeStart,
            endPos: safeEnd
        }
    };
}
function $2af5934346f37a76$export$4af2bdeb9a1268d4(pos, docSize) {
    return Math.max(0, Math.min(pos, docSize));
}
function $2af5934346f37a76$export$e6dc95dc82e623ff(from, to, docSize) {
    if (from === undefined || to === undefined) return null;
    const safeFrom = $2af5934346f37a76$export$4af2bdeb9a1268d4(from, docSize);
    const safeTo = $2af5934346f37a76$export$4af2bdeb9a1268d4(to, docSize);
    if (safeFrom > safeTo) return null;
    return {
        from: safeFrom,
        to: safeTo
    };
}


function $a696a92e7b577b0c$export$1056d35c08b77b41(meta, pluginState) {
    switch(meta?.action){
        case (0, $277Za.ACTIONS).INIT_POSITIONS:
            {
                const { start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos, originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos, sessionId: sessionId } = meta;
                return {
                    ...(0, $15e427849866f9a2$export$de5e90bd767c5d82)(),
                    startPos: start,
                    userContentEndPos: end,
                    loadingPos: start,
                    showHighlight: showHighlight,
                    showAIContentHighlight: showAIContentHighlight,
                    showTelepointer: showTelepointer,
                    telepointerPos: telepointerPos,
                    isStreaming: true,
                    chunkNumber: 0,
                    streamTimeStamp: Date.now(),
                    streamPhase: 'mounting',
                    isPaused: false,
                    posAdjusted: false,
                    hasFinalStream: false,
                    currentSessionId: sessionId,
                    ...originalUserContentSlice !== undefined && {
                        originalUserContentSlice: originalUserContentSlice
                    },
                    ...streamStartPos !== undefined && {
                        streamStartPos: streamStartPos
                    }
                };
            }
        case (0, $277Za.ACTIONS).ADJUST_INIT_POSITIONS:
            const { start: start, end: end } = meta;
            return {
                ...pluginState,
                startPos: start,
                userContentEndPos: end
            };
        case (0, $277Za.ACTIONS).UPDATE_LOADING_POSITIONS:
            {
                const { startPos: startPos, userContentEndPos: userContentEndPos, loadingPos: loadingPos } = pluginState;
                if (startPos === undefined || userContentEndPos === undefined) return pluginState;
                const max = userContentEndPos;
                const min = loadingPos ?? startPos;
                if (max <= min) return pluginState;
                // Randomize loading position within 1/8th to 3/8ths of range
                const eighth = (max - min) / 8;
                const low = Math.floor(min + eighth);
                const high = Math.ceil(min + 3 * eighth);
                const newLoadingPos = Math.ceil(Math.random() * (high - low) + low);
                return {
                    ...pluginState,
                    loadingPos: newLoadingPos
                };
            }
        case (0, $277Za.ACTIONS).UPDATE_STREAM_POSITIONS:
            {
                const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream, lastProcessedVersion: lastProcessedVersion, aiContentSlice: aiContentSlice, scrollTargetPos: scrollTargetPos, posAdjusted: posAdjusted, startPos: startPos, userContentEndPos: userContentEndPos } = meta.positions;
                const nextPhase = isFinalStream ? 'finalizing' : 'streaming';
                let newState = {
                    ...pluginState,
                    aiContentEndPos: aiContentEndPos,
                    telepointerPos: telepointerPos,
                    chunkNumber: pluginState.chunkNumber + 1,
                    streamTimeStamp: Date.now(),
                    loadingPos: undefined,
                    streamPhase: nextPhase,
                    // New fields (if provided)
                    ...lastProcessedVersion !== undefined && {
                        lastProcessedVersion: lastProcessedVersion
                    },
                    ...aiContentSlice !== undefined && {
                        aiContentSlice: aiContentSlice
                    },
                    ...scrollTargetPos !== undefined && {
                        scrollTargetPos: scrollTargetPos
                    },
                    ...posAdjusted !== undefined && {
                        posAdjusted: posAdjusted
                    },
                    ...startPos !== undefined && {
                        startPos: startPos
                    },
                    ...userContentEndPos !== undefined && {
                        userContentEndPos: userContentEndPos
                    }
                };
                if (isFinalStream) newState = {
                    ...newState,
                    isFinalStream: true,
                    showHighlight: false,
                    showAIContentHighlight: false,
                    showTelepointer: false,
                    isStreaming: false,
                    isStreamingFinished: true,
                    hasFinalStream: true,
                    scrollTargetPos: undefined
                };
                return newState;
            }
        case (0, $277Za.ACTIONS).END_STREAM:
            return {
                ...(0, $15e427849866f9a2$export$de5e90bd767c5d82)(),
                telepointerPos: pluginState.telepointerPos
            };
        default:
            return pluginState;
    }
}
function $a696a92e7b577b0c$export$38844252556f39ef(tr, pluginState) {
    const docSize = tr.doc.content.size;
    return {
        ...pluginState,
        ...pluginState.startPos !== undefined && {
            startPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
                pos: pluginState.startPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.userContentEndPos !== undefined && {
            userContentEndPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
                pos: pluginState.userContentEndPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.aiContentEndPos !== undefined && {
            aiContentEndPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
                pos: pluginState.aiContentEndPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.loadingPos !== undefined && {
            loadingPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(tr.mapping.map(pluginState.loadingPos, -1), docSize)
        },
        ...pluginState.telepointerPos !== undefined && {
            telepointerPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(tr.mapping.map(pluginState.telepointerPos, -1), docSize)
        },
        ...pluginState.streamStartPos !== undefined && {
            streamStartPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
                pos: pluginState.streamStartPos,
                tr: tr
            }), docSize)
        },
        ...pluginState.scrollTargetPos !== undefined && {
            scrollTargetPos: (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
                pos: pluginState.scrollTargetPos,
                tr: tr
            }), docSize)
        }
    };
}
















const $e5dcc0a4b029642a$var$userContentDecorationAttrs = {
    class: 'ai-in-editor-user-content',
    'aria-hidden': 'true',
    'data-testid': 'ai-in-editor-user-content'
};
function $e5dcc0a4b029642a$export$6e70fb48265e25fd(state, telepointerElement, preloadedDecorationState, useAgentHighlightColor = false) {
    const pluginState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!pluginState) return (0, $8nvEM.DecorationSet).empty;
    // Use the pre-fetched decoration state if provided (avoiding a redundant getState call
    // when the caller already has it), otherwise fetch it here.
    const decorationState = preloadedDecorationState !== undefined ? preloadedDecorationState : (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
    const { showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, loadingPos: loadingPos, isFinalStream: isFinalStream, isStreaming: isStreaming } = pluginState;
    const decorations = [];
    // Old non-unified free-gen path: do not paint streaming decorations.
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') || decorationState?.withStreamingHighlight === false) return (0, $8nvEM.DecorationSet).empty;
    // When not actively streaming, show telepointer if there's an active session with positions set
    if (!isStreaming || startPos === undefined) {
        const { nextSessionId: nextSessionId, positions: positions } = decorationState || {};
        if (nextSessionId && positions) return (0, $8nvEM.DecorationSet).create(state.doc, [
            (0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(positions[0], telepointerElement)
        ]);
        return (0, $8nvEM.DecorationSet).empty;
    }
    // User content highlight (loading state)
    if (showHighlight) {
        if (loadingPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(startPos, loadingPos, $e5dcc0a4b029642a$var$userContentDecorationAttrs));
        else if (userContentEndPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(aiContentEndPos || startPos, userContentEndPos, $e5dcc0a4b029642a$var$userContentDecorationAttrs));
        // AI content highlight (streaming state)
        if (showAIContentHighlight && aiContentEndPos !== undefined) decorations.push((0, $8nvEM.Decoration).inline(startPos, aiContentEndPos, (0, $95624cff4026d0c7$export$20fa6d5c5205d623)({
            agentInfo: decorationState?.agentInfo,
            useAgentHighlightColor: useAgentHighlightColor
        })));
    }
    /**
   * We show the telepointer only when isFinalStream is false.
   * On the final stream, plugin state is reset so isFinalStream will be undefined.
   */ if (isFinalStream === false && showTelepointer) decorations.push((0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(telepointerPos || aiContentEndPos || startPos, telepointerElement));
    else {
        // Between streams: show telepointer if session is active
        const { nextSessionId: nextSessionId } = decorationState || {};
        if (nextSessionId && telepointerPos !== undefined) decorations.push((0, $0ca5a13529310b54$export$3f4dbbc6f36d65d4)(telepointerPos, telepointerElement));
    }
    if (decorations.length) return (0, $8nvEM.DecorationSet).create(state.doc, decorations);
    return (0, $8nvEM.DecorationSet).empty;
}






/* eslint-disable no-console */ 











/* eslint-disable no-console */ 














const $5f3534ff878ff5b8$var$isRootNode = (schema, node)=>node.type === schema.nodes.doc;
const $5f3534ff878ff5b8$export$d53ec95625564c92 = ({ schema: schema, adfResponse: adfResponse, adfResponseNodeWrappers: adfResponseNodeWrappers })=>{
    const initialNode = (0, $aPdNQ.Node).fromJSON(schema, adfResponse);
    // If we're not in the root node make the current node a fragment, otherwise
    // we may lose information about the container while streaming.
    let fragment = !$5f3534ff878ff5b8$var$isRootNode(schema, initialNode) ? (0, $aPdNQ.Fragment).from(initialNode) : initialNode.content;
    const wrappers = adfResponseNodeWrappers ? [
        ...adfResponseNodeWrappers
    ] : [];
    while(wrappers.length > 0){
        const wrapperName = wrappers.pop();
        if (wrapperName && fragment.content.length === 1 && fragment.content[0].type.name === wrapperName) fragment = fragment.content[0].content;
        else break;
    }
    return fragment;
};


function $07d53600ec703275$export$f61de149b3c1af13(schema, adfResponse) {
    if (!adfResponse) return null;
    try {
        const pmNode = (0, $5f3534ff878ff5b8$export$d53ec95625564c92)({
            schema: schema,
            adfResponse: adfResponse
        });
        return pmNode;
    } catch  {
        return null;
    }
}
function $07d53600ec703275$export$6893d1951df87c6d(schema, markdown, idMap, options) {
    if (!markdown) return null;
    try {
        const { pmFragment: pmFragment } = (0, $97CWy.convertMarkdownToProsemirror)({
            schema: schema,
            markdown: markdown,
            idMap: idMap ?? {},
            featureToggles: {
                markdownPlus: true,
                markdownPlusExtensions: true,
                markdownPlusPanels: true,
                markdownPlusDecisions: true,
                markdownPlusMentions: options?.forceMentions || (0, $iDrrr.fg)('platform_editor_ai_draft_reply_mentions'),
                markdownPlusRemoveUnclosedTokens: true,
                allowAttributesMatchDefault: true
            }
        });
        return pmFragment;
    } catch  {
        return (0, $aPdNQ.Fragment).from(schema.nodes.paragraph.create(null, schema.text(markdown)));
    }
}
function $07d53600ec703275$export$e1477e82250928c0(schema, adfResponse, markdown, idMap, options) {
    // 1. Try ADF first
    const adfFragment = $07d53600ec703275$export$f61de149b3c1af13(schema, adfResponse);
    if (adfFragment) return adfFragment;
    // 2. Try experiment-gated markdown conversion (uses feature-gated mentions)
    if ((0, $4o0zT.isExperimentEnabled)('show_mentions_in_suggest_reply')) {
        const mdFragment = $07d53600ec703275$export$6893d1951df87c6d(schema, markdown, idMap);
        if (mdFragment) return mdFragment;
    }
    // 3. Fallback: direct markdown conversion with mentions always enabled
    if (markdown) {
        if (options?.skipIncompleteCustomTags) {
            // Skip conversion if the markdown ends with an incomplete custom tag (e.g. <cust, <custom)
            // to avoid inserting malformed mention/custom nodes during streaming.
            const incompleteCustomTagPattern = new RegExp('<(c(u(s(t(o(m(?!.*<\\/custom>).*?)?)?)?)?)?)?$', 'gu');
            const hasIncompleteCustomTag = !!markdown.match(incompleteCustomTagPattern);
            if (hasIncompleteCustomTag) return null;
        }
        return $07d53600ec703275$export$6893d1951df87c6d(schema, markdown, idMap, {
            forceMentions: true
        });
    }
    return null;
}
function $07d53600ec703275$export$34f795fdad5abc80(fragment) {
    let isHealthy = true;
    fragment.forEach((node)=>{
        if (!isHealthy) return;
        try {
            node.check();
        } catch  {
            isHealthy = false;
        }
    });
    return isHealthy;
}
function $07d53600ec703275$export$2f32690105b9fbe(doc, startPos, endPos) {
    let telepointerPos = endPos;
    try {
        doc.nodesBetween(startPos, endPos, (node, pos)=>{
            if (node.isLeaf) telepointerPos = pos + node.nodeSize;
        });
        telepointerPos = Math.min(telepointerPos, endPos);
    } catch  {
        telepointerPos = endPos;
    }
    return telepointerPos;
}


function $140fa4f6bae32978$export$f6a5c4177d2ebb1b(configItem) {
    if (!configItem) return false;
    return !!configItem.streamsMarkdown;
}
function $140fa4f6bae32978$export$ae12d1bafb9147f0(state, isFinalStream) {
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
    if (!decorationPluginState) return null;
    const { configItem: configItem } = decorationPluginState;
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, markdown: markdown, idMap: idMap, responseVersion: responseVersion } = sessionState;
    if (!configItem || !adfResponse && !markdown || responseVersion == null) return null;
    if (!$140fa4f6bae32978$export$f6a5c4177d2ebb1b(configItem)) return null;
    const fragment = (0, $07d53600ec703275$export$f61de149b3c1af13)(state.schema, adfResponse) ?? ((0, $4o0zT.isExperimentEnabled)('show_mentions_in_suggest_reply') ? (0, $07d53600ec703275$export$6893d1951df87c6d)(state.schema, markdown, idMap) : undefined);
    if (!fragment) return null;
    // Try to update the ProseMirror document's title/heading node.
    // This may return null if no title/heading node exists (e.g., in Confluence
    // where the page title is a separate DOM element outside the editor).
    const docTr = $140fa4f6bae32978$var$replaceTitleOrHeading(state, fragment);
    // Always dispatch updateStreamPositions so the streaming lifecycle progresses,
    // regardless of whether the ProseMirror doc was modified.
    // This ensures handleMarkdownStreaming view handler fires and publishes
    // the eventHub event to update the actual Confluence page title textarea.
    const tr = docTr ?? state.tr;
    return (0, $277Za.updateStreamPositions)({
        aiContentEndPos: 0,
        telepointerPos: 0,
        isFinalStream: isFinalStream,
        lastProcessedVersion: responseVersion
    })(tr);
}
/**
 * Attempts to replace the title or first heading node in the ProseMirror document
 * with the streamed markdown content.
 *
 * Note: This could serve as a provisional approach for when a title node is added
 * to the ADF schema — at that point, the title could be updated directly in the
 * document rather than relying on external eventHub events.
 */ function $140fa4f6bae32978$var$replaceTitleOrHeading(state, fragment) {
    const { doc: doc, schema: schema } = state;
    let titleText = '';
    fragment.forEach((node)=>{
        titleText += node.textContent;
    });
    // Look for title node type
    const titleType = schema.nodes.title;
    if (titleType) {
        let titlePos = null;
        let titleNode = null;
        doc.descendants((node, pos)=>{
            if (node.type === titleType && titlePos === null) {
                titlePos = pos;
                titleNode = node;
                return false;
            }
            return true;
        });
        if (titlePos !== null && titleNode) {
            const tr = state.tr;
            const titleStart = titlePos + 1;
            const titleEnd = titlePos + (titleNode.nodeSize - 1);
            try {
                if (titleText) tr.insertText(titleText, titleStart, titleEnd);
                else tr.delete(titleStart, titleEnd);
                return tr;
            } catch  {
            // Title replacement failed - try fallback
            }
        }
    }
    // Fallback: first heading
    const { heading: heading } = schema.nodes;
    if (heading) {
        let headingPos = null;
        let headingNode = null;
        doc.descendants((node, pos)=>{
            if (node.type === heading && headingPos === null) {
                headingPos = pos;
                headingNode = node;
                return false;
            }
            return true;
        });
        if (headingPos !== null && headingNode) {
            const tr = state.tr;
            const headingStart = headingPos + 1;
            const headingEnd = headingPos + (headingNode.nodeSize - 1);
            try {
                if (titleText) tr.insertText(titleText, headingStart, headingEnd);
                else tr.delete(headingStart, headingEnd);
                return tr;
            } catch  {
            // Heading replacement failed
            }
        }
    }
    return null;
}



























function $54da588a708548b8$export$5cba160ccca2cd8c(state, fireAnalyticsStep) {
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom } = decorationPluginState ?? {};
    if (!positions || !configItem) return null;
    // Defer mounting for rovo prompts until we have the correct positions.
    // Exception: fallback free-gen (userInput is set) already has correct positions
    // from the initial decoration, so we can mount immediately.
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(state);
    const isFallbackFreeGen = sessionState?.userInput !== undefined;
    if ((0, $i2EU6.configItemUsesRovo)(configItem.key) && lastTriggeredFrom && lastTriggeredFrom !== 'streamingApi' && !isFallbackFreeGen) return null;
    const [from, to] = positions;
    const validation = (0, $2af5934346f37a76$export$158e6dc925f36647)(state, from, to);
    const docSize = state.doc.content.size;
    const isEmptySelection = from === to;
    const shouldReplaceDoc = isEmptySelection && !configItem?.insertOnEmptySelection;
    const [start, end] = shouldReplaceDoc ? [
        1,
        Math.max(1, docSize - 1)
    ] : [
        validation.sanitized.startPos,
        validation.sanitized.endPos
    ];
    // Old non-unified free-gen path: telepointer.
    const showTelepointer = !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && !configItem?.streamsMarkdown;
    // Old non-unified free-gen path: faded original text.
    const showHighlight = !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && !configItem?.streamsMarkdown;
    // Old non-unified free-gen path: purple AI-content highlight.
    const showAIContentHighlight = !(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1') && !shouldReplaceDoc;
    // Prefer the exact node a `replaceNode` command recorded (via
    // `recordOriginalNode`) to build `originalUserContentSlice`. `doc.slice` can
    // return a different shape (e.g. listItem children of a bulletList). Falls
    // back to the doc-range slice when no node was recorded or for a whole-doc
    // replace.
    const recordedOriginalNode = shouldReplaceDoc ? undefined : sessionState?.replaceNodeOriginalNode;
    let originalUserContentSlice;
    if (recordedOriginalNode) originalUserContentSlice = new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(recordedOriginalNode), 0, 0);
    else try {
        originalUserContentSlice = state.doc.slice(start, end);
    } catch  {
        return null;
    }
    let telepointerPos = start;
    try {
        const $start = state.doc.resolve(start);
        telepointerPos = $start.pos;
        let node = $start.node()?.firstChild;
        while(node && node.firstChild && !node.isLeaf){
            telepointerPos += 1;
            node = node.firstChild;
        }
    } catch  {
        telepointerPos = start;
    }
    let tr = state.tr;
    tr = (0, $2Ldzs.closeHistory)(tr);
    tr = (0, $kEjH6.startWatchingAnnotationChanges)({
        from: start,
        to: end
    })(tr);
    tr = (0, $277Za.initPositions)({
        start: start,
        end: end,
        showHighlight: showHighlight && decorationPluginState?.withStreamingHighlight !== false,
        showAIContentHighlight: showAIContentHighlight,
        showTelepointer: showTelepointer && decorationPluginState?.withStreamingHighlight !== false,
        telepointerPos: telepointerPos,
        originalUserContentSlice: originalUserContentSlice,
        streamStartPos: start,
        sessionId: decorationPluginState?.currentSessionId
    })(tr);
    fireAnalyticsStep('invoke', 'loading');
    return tr;
}


























function $c5704350eb1dd85c$export$3aa9a34f18a37399({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    const { paragraph: paragraph, heading: heading } = state.schema.nodes;
    // Validate positions
    if (startPos < 1 || startPos > state.doc.content.size) return bailout;
    const $start = state.doc.resolve(startPos);
    const parentType = $start.parent.type;
    // Check if startPos is at offset 0 inside a paragraph or heading (i.e. at the
    // start of the text content within the block node)
    const isInParagraph = paragraph && parentType === paragraph;
    const isInHeading = heading && parentType === heading;
    if (!isInParagraph && !isInHeading || $start.parentOffset !== 0) return bailout;
    // Check that the replacement fragment's first child is the same block type
    const firstChild = fragment.firstChild;
    if (!firstChild || firstChild.type !== parentType) return bailout;
    const replacementMarks = firstChild.marks;
    const replacementHasBlockMarks = replacementMarks && replacementMarks.length > 0;
    // CCI-16807: Also adjust when the existing node has block-level marks that
    // differ from the replacement — this covers mark removal (e.g. going from
    // alignment:center back to default/left) and mark changes.
    const existingNode = $start.parent;
    const existingMarks = existingNode.marks;
    const existingHasBlockMarks = existingMarks && existingMarks.length > 0;
    // Neither side has marks — no adjustment needed
    if (!existingHasBlockMarks && !replacementHasBlockMarks) return bailout;
    // Both sides have identical marks — no adjustment needed
    if (existingHasBlockMarks && replacementHasBlockMarks && existingMarks.length === replacementMarks.length && existingMarks.every((mark, i)=>mark.eq(replacementMarks[i]))) return bailout;
    // Verify the position before is actually the block node's opening position
    if ($start.depth < 1 || $start.before($start.depth) !== startPos - 1) return bailout;
    return {
        startPos: startPos - 1,
        userContentEndPos: userContentEndPos,
        adjusted: true
    };
}
function $c5704350eb1dd85c$export$bbf65721f248cea({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    // Validate positions
    if (startPos < 0 || startPos > state.doc.content.size) return bailout;
    const $start = state.doc.resolve(startPos);
    const startParent = $start.parent;
    const inList = startParent.type === paragraph && $start.depth > 1 && $start.node($start.depth - 1)?.type === listItem;
    const inTaskItem = taskItem && startParent.type === taskItem;
    const inDecisionItem = decisionItem && startParent.type === decisionItem;
    if (!inList && !inTaskItem && !inDecisionItem) return bailout;
    const $end = state.doc.resolve(userContentEndPos);
    const endParent = $end.parent;
    const newNode = fragment.firstChild;
    const oneBlock = fragment.childCount === 1 && newNode && newNode.isBlock;
    const newStartBlock = oneBlock && newNode.type.name !== startParent.type.name;
    const newEndBlock = oneBlock && newNode.type.name !== endParent.type.name;
    let startPosAdjusted = startPos;
    let endPosAdjusted = userContentEndPos;
    if (newStartBlock) for(let depth = $start.depth, diff = 1; depth > 0; depth--, diff++, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const before = $start.before(depth);
        if (before + diff !== startPos) break;
    }
    if (newEndBlock) for(let depth = $end.depth, diff = 1; depth > 0; depth--, diff++, endPosAdjusted++){
        const ancestor = $end.node(depth);
        if (ancestor.type.contentMatch.matchType(newNode.type)) break;
        const after = $end.after(depth);
        if (after - diff !== userContentEndPos) break;
    }
    if (startPosAdjusted !== bailout.startPos || endPosAdjusted !== bailout.userContentEndPos) {
        const pos = endPosAdjusted - userContentEndPos >= startPos - startPosAdjusted ? endPosAdjusted : startPosAdjusted;
        return {
            startPos: pos,
            userContentEndPos: pos,
            adjusted: true
        };
    }
    return bailout;
}
function $c5704350eb1dd85c$export$30fe2235297e05d0({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { paragraph: paragraph, tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    // Validate positions
    if (startPos < 0 || startPos > state.doc.content.size) return bailout;
    let $start = state.doc.resolve(startPos);
    if ($start.depth > 0 && $start.before() !== startPos - 1) return bailout;
    const types = [];
    let node = fragment.firstChild;
    while(node && node.firstChild){
        types.push(node.type);
        node = node.firstChild;
    }
    types.reverse();
    if (types.length === 1 && types[0] === paragraph) return bailout;
    if ((0, $iDrrr.fg)('platform_editor_ai_replace_table_cell_issue_fix')) {
        /**
		 * If start pos is in a table cell or table header then bailout
		 * 	because adjustments for table cells are handled separately
		 * 	in calculateTableAdjustment.
		 */ const startPosNodeType = $start.parent.type;
        if (startPosNodeType === tableCell || startPosNodeType === tableHeader) return bailout;
    }
    let startPosAdjusted = startPos;
    node = $start.parent.firstChild;
    while(node && node.firstChild){
        startPosAdjusted++;
        node = node.firstChild;
    }
    $start = state.doc.resolve(startPosAdjusted);
    for(let i = 0, depth = $start.depth; depth > 0; i++, depth--, startPosAdjusted--){
        const ancestor = $start.node(depth);
        if (ancestor.type !== types[i]) break;
        const before = $start.before(depth);
        if (before + 1 !== startPosAdjusted) break;
    }
    if (startPosAdjusted < bailout.startPos) return {
        startPos: startPosAdjusted,
        userContentEndPos: bailout.userContentEndPos,
        adjusted: true
    };
    return bailout;
}
/**
 * Returns true when `startPos` is a valid spot to perform the
 * "convert list -> task list" position adjustment, i.e.:
 *
 *  1. There is a `listItem` ancestor in the chain.
 *  2. That listItem's parent is a bullet/ordered list, and it is the FIRST
 *     bullet/ordered list in the ancestor chain (i.e. NOT inside a nested
 *     list).
 *  3. The listItem is the FIRST child of its parent list.
 *  4. `startPos` is at the very beginning of the listItem's first paragraph.
 *
 * Conditions (1) & (2) replace the previous `isTopLevelListBeingReplaced`
 * check. Conditions (3) & (4) replace the previous `$start.parentOffset === 0`
 * check, which incorrectly fired for any listItem (2nd, 3rd, …).
 *
 * Examples that return TRUE:
 *  - bulletList -> listItem(idx 0) -> paragraph<startPos>text
 *  - orderedList -> listItem(idx 0) -> paragraph<startPos>
 *
 * Examples that return FALSE:
 *  - bulletList -> listItem(idx 0) -> bulletList -> ...           (nested list)
 *  - bulletList -> listItem(idx 1+) -> paragraph<startPos>...     (non-first item)
 *  - bulletList -> listItem(idx 0) -> paragraph -> text<startPos> (mid-text)
 */ function $c5704350eb1dd85c$var$isStartAtFirstItemOfTopLevelList(state, startPos) {
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const $start = state.doc.resolve(startPos);
    let listItemDepth = -1; // depth of the nearest (innermost) listItem ancestor
    let listsSeen = 0; // count of bullet/ordered list ancestors
    for(let depth = $start.depth; depth > 0; depth--){
        const node = $start.node(depth);
        // Track only the nearest (innermost) listItem.
        if (node.type === listItem && listItemDepth === -1) {
            listItemDepth = depth;
            continue;
        }
        if (node.type === bulletList || node.type === orderedList) {
            listsSeen++;
            if (listsSeen > 1) // Nested list — not top-level.
            return false;
        }
    }
    // No listItem ancestor at all, or no enclosing list -> not applicable.
    if (listItemDepth === -1 || listsSeen === 0) return false;
    // The list that directly contains the nearest listItem must be a
    // bullet/ordered list, and that listItem must be its FIRST child.
    const parentList = $start.node(listItemDepth - 1);
    if (parentList.type !== bulletList && parentList.type !== orderedList) return false;
    if ($start.index(listItemDepth - 1) !== 0) return false;
    // startPos must be at the very beginning of the listItem's first paragraph.
    // $start.start(listItemDepth) is the position just inside the listItem;
    // +1 skips the opening token of the first child paragraph.
    const firstParagraphStart = $start.start(listItemDepth) + 1;
    return startPos <= firstParagraphStart;
}
function $c5704350eb1dd85c$export$fa56f7b21d67182b({ fragment: fragment, startPos: startPos, state: state }) {
    const { taskList: taskList } = state.schema.nodes;
    const isFirstChildTaskList = fragment.firstChild?.type === taskList;
    return isFirstChildTaskList && $c5704350eb1dd85c$var$isStartAtFirstItemOfTopLevelList(state, startPos);
}
function $c5704350eb1dd85c$export$b235a800374c03c3({ state: state, fragment: fragment, startPos: startPos, userContentEndPos: userContentEndPos }) {
    const { listItem: listItem, paragraph: paragraph } = state.schema.nodes;
    const bailout = {
        startPos: startPos,
        userContentEndPos: userContentEndPos,
        adjusted: false
    };
    if (!listItem) return bailout;
    const doc = state.doc;
    const docSize = doc.content.size;
    // Validate positions
    if (startPos < 0 || startPos > docSize || userContentEndPos < 0 || userContentEndPos > docSize) return bailout;
    let startPosAdjusted = startPos;
    let userContentEndPosAdjusted = userContentEndPos;
    const fragmentFirstNode = fragment.firstChild;
    if (!fragmentFirstNode) return bailout;
    /**
	 * If first child can be child of list item then no need to adjust positions.
	 * In case of table, layout or panel, first child won't be valid content of list item,
	 * 	thus adjustments will happen to avoid dangling list items.
	 */ const firstChildFragment = (0, $aPdNQ.Fragment).from(fragmentFirstNode);
    const isFirstValidListItemContent = listItem?.validContent(firstChildFragment);
    /**
	 * Task list is valid child of listItem.
	 * We have observed that user rarely use task item in list item.
	 * So most of the time when user want to replace
	 * 	list with task list.
	 * So if first child is task list then should do adjustments.
	 */ const shouldAdjustPositions = !isFirstValidListItemContent || $c5704350eb1dd85c$export$fa56f7b21d67182b({
        fragment: fragment,
        startPos: startPos,
        state: state
    });
    if (!shouldAdjustPositions) return bailout;
    const $start = doc.resolve(startPos);
    let curParent = $start.node($start.depth);
    let curParentParent = $start.depth > 1 ? $start.node($start.depth - 1) : null;
    if (curParent.type === paragraph && $start.parentOffset === 0 && curParentParent?.type === listItem) startPosAdjusted -= 2;
    else if (curParent.type === listItem) startPosAdjusted -= 1;
    const $userContentEnd = doc.resolve(userContentEndPos);
    curParent = $userContentEnd.node($userContentEnd.depth);
    curParentParent = $userContentEnd.depth > 1 ? $userContentEnd.node($userContentEnd.depth - 1) : null;
    if (curParent.type === paragraph && $userContentEnd.parentOffset === curParent.content.size && curParentParent?.type === listItem) userContentEndPosAdjusted += 2;
    else if (curParent.type === listItem) userContentEndPosAdjusted += 1;
    // Clamp to valid range
    startPosAdjusted = Math.max(0, startPosAdjusted);
    userContentEndPosAdjusted = Math.min(docSize, userContentEndPosAdjusted);
    const adjusted = startPosAdjusted !== startPos || userContentEndPosAdjusted !== userContentEndPos;
    return {
        startPos: startPosAdjusted,
        userContentEndPos: userContentEndPosAdjusted,
        adjusted: adjusted
    };
}



/* eslint-disable no-console */ 





function $da326467db4fc137$export$a0cec308ca83a1dc({ state: state, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const doc = state.doc;
    const schema = state.schema;
    const docSize = doc.content.size;
    const bailout = {
        startPos: startPos,
        toPos: toPos,
        adjusted: false
    };
    if (startPos < 0 || startPos > docSize || toPos < 0 || toPos > docSize) return bailout;
    try {
        const $startPos = doc.resolve(startPos);
        const $toPos = doc.resolve(toPos);
        if ($da326467db4fc137$var$isWithinSameCell($startPos, $toPos, schema)) return bailout;
        const adjustedStartPos = $da326467db4fc137$var$getStartOfTableRow(schema, $startPos);
        const adjustedToPos = $da326467db4fc137$var$getEndOfTableRow(schema, $toPos);
        let newStartPos = startPos;
        let newToPos = toPos;
        let adjusted = false;
        if (adjustedStartPos !== undefined) {
            newStartPos = adjustedStartPos;
            adjusted = true;
        }
        if (adjustedToPos !== undefined) {
            newToPos = Math.min(adjustedToPos, userContentEndPos);
            adjusted = true;
        }
        return {
            startPos: newStartPos,
            toPos: newToPos,
            adjusted: adjusted
        };
    } catch  {
        return bailout;
    }
}
function $da326467db4fc137$var$isWithinSameCell($from, $to, schema) {
    const tableCell = schema.nodes.tableCell;
    const tableHeader = schema.nodes.tableHeader;
    if (!tableCell && !tableHeader) return false;
    let fromCellDepth = -1;
    for(let d = $from.depth; d > 0; d--){
        const node = $from.node(d);
        if (tableCell && node.type === tableCell || tableHeader && node.type === tableHeader) {
            fromCellDepth = d;
            break;
        }
    }
    if (fromCellDepth === -1) return false;
    let toCellDepth = -1;
    for(let d = $to.depth; d > 0; d--){
        const node = $to.node(d);
        if (tableCell && node.type === tableCell || tableHeader && node.type === tableHeader) {
            toCellDepth = d;
            break;
        }
    }
    if (toCellDepth === -1) return false;
    return $from.start(fromCellDepth) === $to.start(toCellDepth);
}
function $da326467db4fc137$var$getStartOfTableRow(schema, resolvedPos) {
    const tableRow = schema.nodes.tableRow;
    if (!tableRow) return undefined;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === tableRow) return resolvedPos.start(depth);
    }
    return undefined;
}
function $da326467db4fc137$var$getEndOfTableRow(schema, resolvedPos) {
    const tableRow = schema.nodes.tableRow;
    if (!tableRow) return undefined;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === tableRow) return resolvedPos.end(depth);
    }
    return undefined;
}
function $da326467db4fc137$export$8461631d8900e59d({ state: state, fragment: fragment, startPos: startPos, toPos: toPos, userContentEndPos: userContentEndPos }) {
    const doc = state.doc;
    const docSize = doc.content.size;
    const bailout = {
        startPos: startPos,
        toPos: toPos,
        adjusted: false
    };
    if (startPos < 0 || startPos > docSize || toPos < 0 || toPos > docSize) return bailout;
    // Count sync blocks in the slice (the AI-generated fragment)
    let sliceSyncBlockCount = 0;
    fragment.forEach((node)=>{
        if (node.type.name === 'bodiedSyncBlock') sliceSyncBlockCount++;
    });
    let newToPos = toPos;
    let adjusted = false;
    try {
        if (sliceSyncBlockCount === 0) {
            // Slice has NO sync blocks — cap toPos so replaceRange doesn't
            // accidentally delete any existing sync block.
            const $start = doc.resolve(startPos);
            // Case 1: startPos is inside a bodiedSyncBlock.
            // Cap toPos to the end of that block's inner content.
            let capped = false;
            for(let d = $start.depth; d > 0; d--)if ($start.node(d).type.name === 'bodiedSyncBlock') {
                const endOfContent = $start.end(d);
                if (newToPos > endOfContent) {
                    newToPos = endOfContent;
                    adjusted = true;
                }
                capped = true;
                break;
            }
            // Case 2: A bodiedSyncBlock starts ahead of startPos.
            // Cap toPos before it.
            if (!capped) doc.nodesBetween(startPos, Math.min(newToPos, docSize), (node, pos)=>{
                if (node.type.name === 'bodiedSyncBlock' && pos >= startPos && pos < newToPos) {
                    newToPos = pos;
                    adjusted = true;
                }
                return false;
            });
        } else {
            // Slice HAS sync block(s) — extend toPos to cover the corresponding
            // sync blocks in the doc so replaceRange replaces them.
            //
            // A sync block is only "covered" if toPos extends past its END.
            let coveredSyncBlocks = 0;
            doc.nodesBetween(startPos, Math.min(newToPos, docSize), (node, pos)=>{
                if (node.type.name === 'bodiedSyncBlock') {
                    const end = pos + node.nodeSize;
                    if (end <= newToPos) coveredSyncBlocks++;
                }
                return false;
            });
            const needToExtendPast = sliceSyncBlockCount - coveredSyncBlocks;
            if (needToExtendPast > 0) {
                let remaining = needToExtendPast;
                doc.nodesBetween(newToPos, Math.min(userContentEndPos, docSize), (node, pos)=>{
                    if (remaining > 0 && node.type.name === 'bodiedSyncBlock') {
                        const endOfNode = pos + node.nodeSize;
                        if (endOfNode > newToPos) newToPos = Math.min(endOfNode, userContentEndPos);
                        remaining--;
                    }
                    return false;
                });
                adjusted = newToPos !== toPos;
            }
        }
    } catch  {
        return bailout;
    }
    return {
        startPos: startPos,
        toPos: newToPos,
        adjusted: adjusted
    };
}
function $da326467db4fc137$export$f7df414f524c21dc({ state: state, slice: slice, startPos: startPos, toPos: toPos }) {
    const doc = state.doc;
    const schema = state.schema;
    let fragment = slice.content;
    const docSize = doc.content.size;
    // CCI-16810: ADFStreamer feeds the streamer a "doc" containing the
    // AI-supplied replacement content. When the supplied content is a child of
    // a wrapper list (e.g. taskItem or decisionItem) but the doc root requires
    // the wrapper (taskList / decisionList) for schema validity, createAndFill
    // wraps the content automatically. If the replacement target already lives
    // inside that wrapper, the wrapper becomes a redundant level — ProseMirror
    // then happily inserts it as a (schema-valid) nested list, producing
    // e.g. `taskList(taskList(taskItem))`.
    //
    // Unwrap the redundant outer wrapper when:
    //   - the fragment's first child is the wrapper type
    //   - the resolved position already sits inside a node of the same type
    //   - that wrapper's children would all be valid children of the existing
    //     parent (we keep this conservative — only the (taskList/taskItem) and
    //     (decisionList/decisionItem) pairs that triggered CCI-16810).
    if (fragment.firstChild && fragment.childCount === 1 && startPos >= 0 && startPos <= docSize && (0, $iDrrr.fg)('platform_editor_ai_task_item_slice_unwrap_fix')) {
        const firstNode = fragment.firstChild;
        const wrapperPairs = [
            [
                schema.nodes.taskList,
                schema.nodes.taskItem
            ],
            [
                schema.nodes.decisionList,
                schema.nodes.decisionItem
            ]
        ];
        const matchedPair = wrapperPairs.find(([wrapper, item])=>!!wrapper && !!item && firstNode.type === wrapper);
        if (matchedPair) {
            const [, itemType] = matchedPair;
            let allChildrenAreItems = firstNode.childCount > 0;
            firstNode.content.forEach((child)=>{
                if (child.type !== itemType) allChildrenAreItems = false;
            });
            if (allChildrenAreItems) {
                // startPos is already bounds-checked above, so doc.resolve cannot throw.
                const $sp = doc.resolve(startPos);
                let parentIsSameWrapper = false;
                for(let depth = $sp.depth; depth >= 0; depth--)if ($sp.node(depth).type === firstNode.type) {
                    parentIsSameWrapper = true;
                    break;
                }
                if (parentIsSameWrapper) {
                    // Strip the outer wrapper so the child item(s) merge with
                    // the existing list instead of nesting under a new one.
                    // We decrement openStart/openEnd by exactly one — the depth
                    // we're removing — rather than re-deriving them via
                    // Slice.maxOpen(fragment). maxOpen would over-open in the
                    // `openStart === 0` case (closed wrapper, self-contained
                    // list) and could cause unintended inline merging at the
                    // list boundary.
                    fragment = firstNode.content;
                    slice = new (0, $aPdNQ.Slice)(fragment, Math.max(0, slice.openStart - 1), Math.max(0, slice.openEnd - 1));
                }
            }
        }
    }
    // If the first node in fragment is different from the existing first node,
    // we need to adjust the slice open start to 0,
    // to avoid merging the first node in fragment with the existing first node,
    // for example, if the first node in fragment is a panel node, we'll lose the panel wrapper
    // (only the panel content is inserted into the doc)
    // but we don't need to do this if both nodes are table nodes
    const firstNode = fragment.firstChild;
    if (firstNode && startPos >= 0 && startPos <= docSize) try {
        // bodiedSyncBlock must never be merged — its attrs (localId, resourceId)
        // must come from the streamed response, not the existing doc node.
        if (firstNode.type.name === 'bodiedSyncBlock') slice = new (0, $aPdNQ.Slice)(fragment, 0, slice.openEnd);
        else {
            const firstNodeIsTable = $da326467db4fc137$var$isTableStructureNode(firstNode.type, schema);
            const $startPos = doc.resolve(startPos);
            const startPosInTable = $da326467db4fc137$var$getNodeTypeDepth($startPos, schema.nodes.table) !== null;
            const bothTableNodes = firstNodeIsTable && startPosInTable;
            if (!bothTableNodes) {
                const existingFirstNode = $startPos.depth >= 1 ? $startPos.node(1) : null;
                if (!existingFirstNode || firstNode.type !== existingFirstNode.type) slice = new (0, $aPdNQ.Slice)(fragment, 0, slice.openEnd);
            }
        }
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
    // On error, don't adjust
    }
    // If the last node in fragment is different from the existing last node,
    // we need to adjust the slice open end to 0,
    // to avoid merging the last node in fragment with the existing last node,
    // for example, we've seen during streaming, heading and paragraph are merged together
    // (leading to a very long heading containing the paragraph content)
    // but we don't need to do this if both nodes are table nodes
    const lastNode = fragment.lastChild;
    if (lastNode && toPos >= 0 && toPos <= docSize) try {
        // bodiedSyncBlock must never be merged — same reason as above.
        if (lastNode.type.name === 'bodiedSyncBlock') slice = new (0, $aPdNQ.Slice)(fragment, slice.openStart, 0);
        else {
            const lastNodeIsTable = $da326467db4fc137$var$isTableStructureNode(lastNode.type, schema);
            const $toPos = doc.resolve(toPos);
            const toPosInTable = $da326467db4fc137$var$getNodeTypeDepth($toPos, schema.nodes.table) !== null;
            const bothTableNodes = lastNodeIsTable && toPosInTable;
            if (!bothTableNodes) {
                const existingLastNode = $toPos.depth >= 1 ? $toPos.node(1) : null;
                if (!existingLastNode || lastNode.type !== existingLastNode.type) slice = new (0, $aPdNQ.Slice)(fragment, slice.openStart, 0);
            }
        }
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
    // On error, don't adjust
    }
    return slice;
}
function $da326467db4fc137$var$isTableStructureNode(nodeType, schema) {
    const { table: table, tableRow: tableRow, tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return [
        table,
        tableRow,
        tableHeader,
        tableCell
    ].includes(nodeType);
}
function $da326467db4fc137$var$getNodeTypeDepth(resolvedPos, nodeType) {
    if (!nodeType) return null;
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === nodeType) return depth;
    }
    return null;
}


function $950ce7663bc9caff$export$13c76c9a18264386(state, fireAnalyticsStep) {
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions } = decorationPluginState ?? {};
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, markdown: markdown, idMap: idMap, responseVersion: responseVersion } = sessionState;
    const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!positions || !streamingState) return null;
    const { startPos: startPos, userContentEndPos: userContentEndPos, aiContentEndPos: aiContentEndPos, posAdjusted: posAdjusted, streamTimeStamp: streamTimeStamp } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined) return $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    // Resolve content using the prioritised conversion chain:
    // ADF → experiment-gated markdown → free-gen markdown fallback (with incomplete tag guard)
    const fragment = (0, $07d53600ec703275$export$e1477e82250928c0)(state.schema, adfResponse, markdown, idMap, {
        skipIncompleteCustomTags: true
    });
    if (!fragment) return $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    let slice = (0, $aPdNQ.Slice).maxOpen(fragment);
    if (!slice.content.firstChild) slice = (0, $aPdNQ.Slice).empty;
    if (slice.size <= 0) return $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    if (!(0, $07d53600ec703275$export$34f795fdad5abc80)(fragment)) return $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    const docSize = state.doc.content.size;
    let workingStartPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(startPos, docSize);
    let workingUserContentEndPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(userContentEndPos, docSize);
    let workingPosAdjusted = posAdjusted;
    // Position adjustments (once per stream)
    if (!posAdjusted) {
        const isEmptySelection = positions[0] === positions[1];
        if (isEmptySelection) {
            const adjustment = (0, $c5704350eb1dd85c$export$bbf65721f248cea)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) {
                workingStartPos = adjustment.startPos;
                workingUserContentEndPos = adjustment.userContentEndPos;
            }
        } else {
            const adjustment = (0, $c5704350eb1dd85c$export$30fe2235297e05d0)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) workingStartPos = adjustment.startPos;
            const listAdjustment = (0, $c5704350eb1dd85c$export$b235a800374c03c3)({
                state: state,
                fragment: fragment,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (listAdjustment.adjusted) {
                workingStartPos = listAdjustment.startPos;
                workingUserContentEndPos = listAdjustment.userContentEndPos;
            }
        }
        workingPosAdjusted = true;
    }
    // Block mark adjustment — runs on every update (not guarded by posAdjusted)
    // because the first streaming chunk may not yet contain the block marks.
    const blockMarkAdjustment = (0, $c5704350eb1dd85c$export$3aa9a34f18a37399)({
        state: state,
        fragment: fragment,
        startPos: workingStartPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (blockMarkAdjustment.adjusted) workingStartPos = blockMarkAdjustment.startPos;
    // Calculate toPos
    let toPos = Math.min(Math.max(aiContentEndPos ?? 0, workingStartPos + slice.size + 1), workingUserContentEndPos);
    // Table adjustment
    const tableAdjustment = (0, $da326467db4fc137$export$a0cec308ca83a1dc)({
        state: state,
        fragment: fragment,
        startPos: workingStartPos,
        toPos: toPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (tableAdjustment.adjusted) {
        workingStartPos = tableAdjustment.startPos;
        toPos = tableAdjustment.toPos;
    }
    // Sync block adjustment
    const syncBlockAdjustment = (0, $da326467db4fc137$export$8461631d8900e59d)({
        state: state,
        fragment: fragment,
        startPos: workingStartPos,
        toPos: toPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (syncBlockAdjustment.adjusted) {
        workingStartPos = syncBlockAdjustment.startPos;
        toPos = syncBlockAdjustment.toPos;
    }
    // Slice adjustment
    slice = (0, $da326467db4fc137$export$f7df414f524c21dc)({
        state: state,
        slice: slice,
        startPos: workingStartPos,
        toPos: toPos
    });
    // Build transaction
    let tr = state.tr;
    const safeToPos = Math.max(workingStartPos, Math.min(toPos, tr.doc.content.size));
    try {
        tr = tr.replaceRange(workingStartPos, safeToPos, slice);
    } catch  {
        return $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion);
    }
    tr = tr.setMeta('ignoreLocalIdUpdate', true);
    tr = (0, $277Za.metaTransaction)({
        tr: tr,
        isFinalStream: false,
        stackTime: streamTimeStamp,
        agentAttribution: (0, $0d7305543af23cc5$export$89a47aaa0c638001)({
            sessionAgentAttribution: sessionState.agentAttribution,
            configItemKey: decorationPluginState?.configItem?.key
        })
    });
    // Map positions AFTER document changes
    const newDocSize = tr.doc.content.size;
    const mappedStartPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
        pos: workingStartPos,
        tr: tr
    }), newDocSize);
    const mappedUserContentEndPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
        pos: workingUserContentEndPos,
        tr: tr
    }), newDocSize);
    const mappedAiContentEndPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
        pos: toPos,
        tr: tr
    }), newDocSize);
    // Calculate telepointer
    const telepointerPos = (0, $07d53600ec703275$export$2f32690105b9fbe)(tr.doc, mappedStartPos, mappedAiContentEndPos);
    // Use original transform with extended payload
    tr = (0, $277Za.updateStreamPositions)({
        aiContentEndPos: mappedAiContentEndPos,
        telepointerPos: telepointerPos,
        isFinalStream: false,
        lastProcessedVersion: responseVersion,
        aiContentSlice: slice,
        scrollTargetPos: mappedAiContentEndPos,
        posAdjusted: workingPosAdjusted,
        startPos: mappedStartPos,
        userContentEndPos: mappedUserContentEndPos
    })(tr);
    // Fire the loading→complete analytics step once (guarded by lastQueuedStep in AnalyticsBridge).
    // This triggers ACTION.INITIATED, the userFlow 'loading' step event, and sets up aiInteractionID
    // for downstream steps. ACTION.VIEWED is NOT tied to this — it fires on 'complete' (after stream ends).
    fireAnalyticsStep('loading', 'complete');
    return tr;
}
function $950ce7663bc9caff$var$buildPositionOnlyUpdate(state, streamingState, responseVersion) {
    const { aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, startPos: startPos, aiContentSlice: aiContentSlice } = streamingState;
    let tr = state.tr;
    tr = (0, $277Za.updateStreamPositions)({
        aiContentEndPos: aiContentEndPos ?? startPos ?? 0,
        telepointerPos: telepointerPos ?? startPos ?? 0,
        isFinalStream: false,
        lastProcessedVersion: responseVersion,
        aiContentSlice: aiContentSlice
    })(tr);
    return tr;
}





function $f9586f0be0265311$export$3174bd35cfffd429(sessionState, prevSessionState, streamingState, autoAcceptAIChanges) {
    if (!sessionState) return null;
    // === DERIVE SESSION TRANSITION INFO ===
    const session = {
        id: sessionState.sessionId,
        status: sessionState.status,
        responseVersion: sessionState.responseVersion,
        changed: sessionState.sessionId !== prevSessionState?.sessionId,
        cleared: !sessionState.sessionId && !!prevSessionState?.sessionId,
        justCompleted: sessionState.status === 'complete' && prevSessionState?.status === 'streaming',
        justErrored: sessionState.status === 'error' && prevSessionState?.status !== 'error',
        isStreaming: sessionState.status === 'streaming'
    };
    // === DERIVE STREAMING STATE INFO ===
    const streaming = {
        phase: streamingState.streamPhase,
        isIdle: streamingState.streamPhase === 'idle',
        isActive: streamingState.streamPhase !== 'idle',
        isProcessing: streamingState.streamPhase === 'mounting' || streamingState.streamPhase === 'streaming',
        canFinalize: streamingState.isStreaming && !streamingState.hasFinalStream && streamingState.streamPhase === 'streaming',
        hasNewContent: sessionState.responseVersion > streamingState.lastProcessedVersion
    };
    // === DECISION TREE (in priority order) ===
    // 1. CLEANUP: Session changed while we were actively streaming
    //    → Need to reset before handling the new session
    if (session.changed && streaming.isActive && autoAcceptAIChanges) return 'cleanup';
    // 2. SESSION CLEARED: No active session anymore
    //    → Nothing to do
    if (session.cleared) return null;
    // 3. ERROR: Session just entered error state while streaming
    //    → Clean up streaming decorations so the error screen can show
    if (session.justErrored && streaming.isActive) return 'cleanup';
    // 4. FINALIZE: Stream just completed and we're ready to finalize
    //    → Commit the final content
    if (session.justCompleted && streaming.canFinalize) return 'finalize';
    // 5. MOUNT: Session is streaming but we haven't started yet
    //    → Initialize streaming decorations
    //    Note: Also handles "deferred mount" when orchestrator updates positions
    if (session.isStreaming && (streaming.isIdle || streamingState.streamPhase === 'finalizing')) return 'mount';
    // 6. UPDATE: We're actively processing and have new content
    //    → Stream the new content into the document
    if (session.isStreaming && streaming.isProcessing && streaming.hasNewContent) return 'update';
    // No action needed
    return null;
}
function $f9586f0be0265311$export$218c70edcbbc64e5(streamingState, sessionState) {
    const isIdle = streamingState.streamPhase === 'idle';
    const noActiveSession = !sessionState?.sessionId;
    const sessionIsIdle = !sessionState || sessionState.status === 'idle';
    // Skip if completely idle with no active session
    if (isIdle && sessionIsIdle && noActiveSession) return true;
    // Skip if stream finalized and session has ended
    const streamFinalized = streamingState.hasFinalStream;
    const sessionComplete = sessionState?.status === 'complete';
    if (streamFinalized && sessionComplete && noActiveSession) return true;
    return false;
}




























function $73b45ebf50366f42$export$c4d4122316c86846(view, restoreSelection = true) {
    // Guard: view must have valid state with plugins (e.g. unit tests may pass a minimal context)
    if (!view?.state?.plugins) return false;
    const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(view.state);
    if (!streamingState) return false;
    let { startPos: startPos, userContentEndPos: userContentEndPos } = streamingState;
    const { originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos } = streamingState;
    const isEmptySelection = startPos === userContentEndPos;
    // Validate we have required state
    if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice) {
        view.dispatch((0, $277Za.endStream)(view.state.tr));
        return false;
    }
    // Step 1: Undo streamed changes
    (0, $1Iyfh.undo)(view.state, view.dispatch);
    // Re-get positions after undo - they may have changed
    const updatedState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(view.state);
    startPos = updatedState?.startPos ?? startPos;
    userContentEndPos = updatedState?.userContentEndPos ?? userContentEndPos;
    // Step 2: Build cleanup transaction
    let tr = (0, $2Ldzs.closeHistory)(view.state.tr);
    // Step 3: Restore selection if requested
    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
    if (restoreSelection && !decorationState?.sessionEnded) {
        const docSize = tr.doc.content.size;
        let anchor;
        let head;
        if (isEmptySelection) {
            anchor = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(streamStartPos ?? startPos, docSize);
            head = anchor;
        } else {
            anchor = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
                pos: startPos,
                tr: tr
            }), docSize);
            head = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
                pos: userContentEndPos,
                tr: tr
            }), docSize);
        }
        // Handle reversed selection
        if (decorationState?.initialSelection && decorationState.initialSelection.head < decorationState.initialSelection.anchor) [anchor, head] = [
            head,
            anchor
        ];
        // TextSelection.create can throw with invalid positions
        try {
            tr = tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, anchor, head));
        } catch  {
        // Positions invalid - keep default selection
        }
    }
    // Step 4: End stream and dispatch
    view.dispatch((0, $277Za.endStream)(tr));
    return true;
}


function $4e8d2a7ea713fead$export$b4e7ecb7c76b6f00() {
    return {
        isDiscardInProgress: false,
        lastSeenSessionId: undefined
    };
}
function $4e8d2a7ea713fead$export$e4f8a57678205f7d(view, state, discardState, fireAnalyticsStep) {
    // Guard: Don't re-enter while we're discarding
    if (discardState.isDiscardInProgress) return;
    const sessionContextState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
    // Use either source so reactive discard works when session context has no sessionId (e.g. orchestrator flow)
    const currentSessionId = sessionContextState?.sessionId ?? decorationState?.currentSessionId;
    // Detect if session was cleared while we were actively streaming
    const wasStreaming = state.streamPhase !== 'idle' && state.isStreaming;
    const sessionCleared = discardState.lastSeenSessionId && !currentSessionId;
    // Update tracking before processing
    discardState.lastSeenSessionId = currentSessionId;
    if (wasStreaming && sessionCleared) {
        discardState.isDiscardInProgress = true;
        try {
            (0, $73b45ebf50366f42$export$c4d4122316c86846)(view, true);
            fireAnalyticsStep?.('discard');
        } catch  {
        // Discard failed - continue
        } finally{
            discardState.isDiscardInProgress = false;
        }
    }
}





function $4d5cc6e7b555001d$export$25dfe1561be19c6b(view, isActive, api, viewState, isFinalizing) {
    if (isFinalizing) return;
    const editorContentArea = view?.dom.closest('.ak-editor-content-area');
    if (viewState.originalTabIndex === undefined && editorContentArea) {
        viewState.originalTabIndex = editorContentArea.tabIndex;
        viewState.originalOutlineColor = editorContentArea.style.outlineColor;
        viewState.originalOutline = editorContentArea.style.outline;
    }
    // === STREAMING STARTED ===
    if (isActive && !viewState.hasActivatedStreaming) {
        viewState.hasActivatedStreaming = true;
        // Hide cursor and set up streaming state
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.selection?.commands.hideCursor?.(true)({
                tr: tr
            });
            api?.trackChanges?.commands.resetBaseline?.({
                tr: tr
            });
            api?.userIntent?.commands.setCurrentUserIntent?.('aiStreaming')({
                tr: tr
            });
            api?.editorDisabled?.commands.toggleDisabled?.(true)({
                tr: tr
            });
            return tr;
        });
        // Focus editor content area to enable keyboard shortcuts (e.g., Esc to cancel)
        if (editorContentArea) {
            editorContentArea.tabIndex = -1;
            editorContentArea.style.outline = 'none';
            const doc = (0, $1hQ0e.getDocument)();
            if (doc && !editorContentArea.contains(doc.activeElement)) editorContentArea.focus();
        }
    }
    // === STREAMING ENDED ===
    if (!isActive && viewState.hasActivatedStreaming) {
        viewState.hasActivatedStreaming = false;
        // Show cursor and restore editor state
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.selection?.commands.hideCursor?.(false)({
                tr: tr
            });
            api?.userIntent?.commands.setCurrentUserIntent?.('default')({
                tr: tr
            });
            api?.editorDisabled?.commands.toggleDisabled?.(false)({
                tr: tr
            });
            return tr;
        });
        // Restore original editor content area state
        if (editorContentArea) $4d5cc6e7b555001d$export$50f5de8099342b42(editorContentArea, viewState.originalTabIndex, viewState.originalOutlineColor, viewState.originalOutline);
    }
}
function $4d5cc6e7b555001d$export$50f5de8099342b42(editorContentArea, originalTabIndex, originalOutlineColor, originalOutline) {
    if (originalTabIndex !== undefined) {
        if (originalTabIndex === -1) editorContentArea.removeAttribute('tabindex');
        else editorContentArea.tabIndex = originalTabIndex;
    }
    if (originalOutlineColor !== undefined) {
        editorContentArea.style.outlineColor = originalOutlineColor;
        if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
    }
    if (originalOutline !== undefined) {
        editorContentArea.style.outline = originalOutline;
        if (editorContentArea.getAttribute('style') === '') editorContentArea.removeAttribute('style');
    }
}
function $4d5cc6e7b555001d$export$d459380d3cf60a30(view, viewState) {
    const editorContentArea = view.dom.closest('.ak-editor-content-area');
    if (editorContentArea) $4d5cc6e7b555001d$export$50f5de8099342b42(editorContentArea, viewState.originalTabIndex, viewState.originalOutlineColor, viewState.originalOutline);
    viewState.originalTabIndex = undefined;
    viewState.originalOutlineColor = undefined;
    viewState.originalOutline = undefined;
}


function $33e4b71203ab572e$export$ed6bcbf8c4a7024f(view, state, prevState, api) {
    if (!state.aiContentEndPos || state.aiContentEndPos === prevState?.aiContentEndPos || state.startPos === undefined) return;
    const { expand: expand, nestedExpand: nestedExpand } = view.state.schema.nodes;
    if (!expand && !nestedExpand) return;
    const startPos = state.startPos;
    const endPos = Math.min(state.aiContentEndPos, view.state.doc.content.size);
    if (startPos >= endPos) return;
    api?.expand?.commands.toggleExpandRange(startPos, endPos);
}













































const $a7e5b62b6ba2f41b$export$4f3fbd2dd64b2dce = (agentInfo)=>{
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_agent_mentions')) return {};
    if ((0, $iDrrr.fg)('platform_editor_agent_mentions_telepointer_avatar') && agentInfo?.agentIdentityAccountId) return {
        agentIdentityAccountId: agentInfo.agentIdentityAccountId
    };
    return agentInfo?.agentName ? {
        telepointerLabel: agentInfo.agentName
    } : {};
};








function $f47cbd333b1ebffc$export$c65b39427bf628b1(tr, state, currentRange) {
    if (!(0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1')) return tr;
    // Do not remap existing highlight ranges through this document write.
    // The replace usually overwrites those positions; mapping would shrink
    // the union down to the node just written. The chrome plugin skips
    // mapping for AI writes and unions this SHOW with the ranges it already has.
    const existing = ((0, $f7b3f8185a61bfdf$export$bca1edcc67dc7d).getState(state)?.ranges ?? []).filter(({ from: from, to: to })=>to > from);
    const fromSession = ((0, $iN8Pe.aiSessionContextPluginKey).getState(state)?.aiContentPositions ?? []).map(({ startPos: from, endPos: to })=>({
            from: from,
            to: to
        })).filter(({ from: from, to: to })=>to > from);
    const current = currentRange && currentRange.to > currentRange.from ? [
        currentRange
    ] : [];
    const ranges = [
        ...existing,
        ...fromSession,
        ...current
    ];
    if (!ranges.length) return tr;
    return tr.setMeta((0, $1UwGp.AGENT_EDIT_CHROME_DATA), {
        ...(0, $1UwGp.getAgentEditChromeDynamicConfig)(),
        ...(0, $a7e5b62b6ba2f41b$export$4f3fbd2dd64b2dce)((0, $9RRio.aiExperienceDecorationPluginKey).getState(state)?.agentInfo),
        ranges: ranges
    });
}


function $bc2517a0813a73b6$export$1695ca555427e313(state) {
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(state);
    if (!sessionState) return null;
    const { adfResponse: adfResponse, markdown: markdown, idMap: idMap, responseVersion: responseVersion } = sessionState;
    const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state);
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
    const { positions: positions } = decorationPluginState ?? {};
    if (!streamingState) return null;
    // When decoration positions are unavailable (e.g. cleared after the restore transaction
    // remapped them away for `replaceNode` commands on empty table cells), we still need to
    // mark the stream as finalised so `isStreaming` returns to `false` and
    // `endExperiencePromise` can resolve. Fall through to `buildCommitStateOnly` which
    // sets `isFinalStream: true` without needing document positions.
    if (!positions) return $bc2517a0813a73b6$var$buildCommitStateOnly(state, streamingState, sessionState.responseVersion);
    // After restore, the document is back to original state
    // Use the positions from streaming state (which were mapped through restore)
    const { startPos: startPos, userContentEndPos: userContentEndPos, originalUserContentSlice: originalUserContentSlice, aiContentSlice: aiContentSlice, posAdjusted: posAdjusted } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined) return $bc2517a0813a73b6$var$buildCommitStateOnly(state, streamingState, responseVersion);
    // Resolve final content using the prioritised conversion chain:
    // ADF → experiment-gated markdown → free-gen markdown fallback
    const finalFragment = (0, $07d53600ec703275$export$e1477e82250928c0)(state.schema, adfResponse, markdown, idMap);
    // IMPORTANT: Prefer the slice adjusted during the update phase when it still matches the
    // final adfResponse. This preserves the existing behavior for edge cases like inserting
    // a heading at the start of a paragraph. If the final response changed after the last
    // stream update, rebuild the slice from the final adfResponse so we don't commit stale
    // streamed content.
    const canReuseStreamedSlice = !!aiContentSlice && !!finalFragment && (0, $07d53600ec703275$export$34f795fdad5abc80)(finalFragment) && aiContentSlice.content.eq(finalFragment);
    let slice = canReuseStreamedSlice ? aiContentSlice : undefined;
    if (!slice) {
        if (!finalFragment || !(0, $07d53600ec703275$export$34f795fdad5abc80)(finalFragment)) return $bc2517a0813a73b6$var$buildCommitStateOnly(state, streamingState, responseVersion);
        slice = (0, $aPdNQ.Slice).maxOpen(finalFragment);
        if (!slice.content.firstChild) slice = (0, $aPdNQ.Slice).empty;
    }
    // Use positions from streaming state
    const docSize = state.doc.content.size;
    let workingStartPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(startPos, docSize);
    let workingUserContentEndPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)(userContentEndPos, docSize);
    /**
	 * If value for tool call is received in one stream then
	 * 	buildUpdateTransaction can be called only once without fragment.
	 * And then buildCommitTransaction will be called for the final value.
	 *
	 * In such a case, adjustments for empty or range selection hasn't been
	 * 	calculated in buildUpdateTransaction.
	 * So if posAdjusted is false, we need to calculate the adjustments for empty or range selection.
	 */ if (!posAdjusted) {
        const isEmptySelection = positions[0] === positions[1];
        if (isEmptySelection) {
            const adjustment = (0, $c5704350eb1dd85c$export$bbf65721f248cea)({
                state: state,
                fragment: slice.content,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) {
                workingStartPos = adjustment.startPos;
                workingUserContentEndPos = adjustment.userContentEndPos;
            }
        } else {
            const adjustment = (0, $c5704350eb1dd85c$export$30fe2235297e05d0)({
                state: state,
                fragment: slice.content,
                startPos: workingStartPos,
                userContentEndPos: workingUserContentEndPos
            });
            if (adjustment.adjusted) workingStartPos = adjustment.startPos;
        }
    }
    // List adjustment (matching original)
    const listAdjustment = (0, $c5704350eb1dd85c$export$b235a800374c03c3)({
        state: state,
        fragment: slice.content,
        startPos: workingStartPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (listAdjustment.adjusted) {
        workingStartPos = listAdjustment.startPos;
        workingUserContentEndPos = listAdjustment.userContentEndPos;
    }
    // Block mark adjustment — when startPos is inside a paragraph/heading's text
    // and the replacement is the same block type with marks, move startPos back
    // to include the block node so block-level marks (e.g. alignment) are applied.
    const blockMarkAdjustment = (0, $c5704350eb1dd85c$export$3aa9a34f18a37399)({
        state: state,
        fragment: slice.content,
        startPos: workingStartPos,
        userContentEndPos: workingUserContentEndPos
    });
    if (blockMarkAdjustment.adjusted) workingStartPos = blockMarkAdjustment.startPos;
    let tr = state.tr;
    const streamTimeStamp = streamingState.streamTimeStamp;
    const safeEndPos = Math.max(workingStartPos, Math.min(workingUserContentEndPos, docSize));
    // Adjust slice openStart/openEnd to prevent unwanted node merging
    // (e.g. losing a panel wrapper when inserting before an existing node)
    slice = (0, $da326467db4fc137$export$f7df414f524c21dc)({
        state: state,
        slice: slice,
        startPos: workingStartPos,
        toPos: safeEndPos
    });
    // Apply final content - matching original commitFinalResponse logic
    try {
        const { paragraph: paragraph } = tr.doc.type.schema.nodes;
        // If we have a lone paragraph - replaceRange will not replace with a paragraph
        const isSingleParagraph = slice.content.firstChild === slice.content.lastChild && slice.content.firstChild?.type === paragraph;
        let requireLocalIdFix = true;
        if (isSingleParagraph && workingStartPos < docSize) {
            const $from = tr.doc.resolve(workingStartPos);
            const isEmptyParagraph = $from.parent.type === paragraph && $from.parent.content.size === 0;
            if (isEmptyParagraph && slice.content.firstChild) {
                tr = tr.replaceRangeWith(workingStartPos, safeEndPos, slice.content.firstChild);
                requireLocalIdFix = false;
            } else tr = tr.replaceRange(workingStartPos, safeEndPos, slice);
        } else tr = tr.replaceRange(workingStartPos, safeEndPos, slice);
        if (requireLocalIdFix) // When replaceRange merges inline content into an existing block of the same
        // type, the original block's attrs (including localId) are preserved. If the
        // replacement carries a different localId, patch it here so downstream
        // consumers (collab, comments, etc.) see the intended id. This also handles
        // slices that contain multiple top-level blocks — each replaced block has
        // its localId patched independently.
        tr = (0, $f83a45c4b358acb4$export$d9f6dde98fa84c24)({
            tr: tr,
            replacementContent: slice.content,
            startPos: workingStartPos
        });
        tr = (0, $277Za.metaTransaction)({
            tr: tr,
            isFinalStream: true,
            stackTime: streamTimeStamp,
            agentAttribution: (0, $0d7305543af23cc5$export$89a47aaa0c638001)({
                sessionAgentAttribution: sessionState.agentAttribution,
                configItemKey: decorationPluginState?.configItem?.key
            })
        });
    } catch  {
        return $bc2517a0813a73b6$var$buildCommitStateOnly(state, streamingState, responseVersion);
    }
    // Set selection at end of inserted content
    try {
        tr = tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(tr.selection.to, tr.doc.content.size)));
    } catch  {
    // Invalid position - keep default selection
    }
    // Skip history if content unchanged
    if (originalUserContentSlice) try {
        const newDocSize = tr.doc.content.size;
        const finalStartPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
            pos: startPos,
            tr: tr
        }), newDocSize);
        const finalEndPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
            pos: userContentEndPos,
            tr: tr
        }), newDocSize);
        const newSlice = tr.doc.slice(finalStartPos, finalEndPos);
        if (newSlice.eq(originalUserContentSlice)) tr = tr.setMeta('addToHistory', false);
    } catch  {
    // Position mapping failed - add to history as normal
    }
    // Map final positions for telepointer
    const finalDocSize = tr.doc.content.size;
    const mappedStartPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$8c11be8ccd39ce0b)({
        pos: startPos,
        tr: tr
    }), finalDocSize);
    const mappedToPos = (0, $2af5934346f37a76$export$4af2bdeb9a1268d4)((0, $2ee9ebcc666cf053$export$3dcc2c094c7e6748)({
        pos: userContentEndPos,
        tr: tr
    }), finalDocSize);
    const telepointerPos = (0, $07d53600ec703275$export$2f32690105b9fbe)(tr.doc, mappedStartPos, mappedToPos);
    tr = (0, $277Za.updateStreamPositions)({
        aiContentEndPos: mappedToPos,
        telepointerPos: telepointerPos,
        isFinalStream: true,
        lastProcessedVersion: responseVersion
    })(tr);
    // [CCI-15904] When the New AIFC Editor Experience gate is ON, stamp this
    // transaction with the data needed by the Post Stream Review toolbar:
    //   - newSlice: the final AI-produced content (for "redo")
    //   - originalUserContentSlice: what was replaced (for "undo")
    //   - positions: where in the new doc the change landed
    // The ai-session-context plugin's apply() reads this meta to append an entry
    // to `aiContentPositions`.
    // Skip recording reviewable `aiContentPositions` for a create stream — there is
    // nothing to review.
    if ((0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)() && originalUserContentSlice && !sessionState.isCreateSession) {
        // [CCI-17658] Determine if this commit intersects the reworked segment.
        // Any overlap merges with the existing segment (append slice); no overlap
        // would start a new review moment (out of scope — tracked in CCI-17980).
        const snap = sessionState.reworkSnapshot;
        const hasValidSnapshot = snap && sessionState.streamReviewSegments?.length && snap.topLevelIndex >= 0 && snap.topLevelIndex < sessionState.streamReviewSegments.length;
        const intersects = hasValidSnapshot && (mappedStartPos <= snap.startPos && mappedToPos >= snap.endPos || mappedStartPos >= snap.startPos && mappedToPos <= snap.endPos || mappedStartPos <= snap.startPos && mappedToPos >= snap.startPos || mappedStartPos <= snap.endPos && mappedToPos >= snap.endPos);
        const reworkMutation = hasValidSnapshot && intersects ? {
            topLevelIndex: snap.topLevelIndex
        } : undefined;
        tr.setMeta((0, $45a530918d906c25$export$fa15c525f457d46f), {
            newSlice: slice,
            originalUserContentSlice: originalUserContentSlice,
            positions: {
                mappedStartPos: mappedStartPos,
                mappedToPos: mappedToPos
            },
            reworkMutation: reworkMutation
        });
    }
    // If this is the terminal write of a tool call force-finished by the queue
    // timeout, stamp its final (doc-mapped) positions. ai-session-context's apply()
    // persists them as `abortedToolCallPositions[toolCallId]` for later resume.
    if (sessionState.pendingForceAbortedToolCallId) tr.setMeta((0, $45a530918d906c25$export$3ce83cf64ed42309), {
        toolCallId: sessionState.pendingForceAbortedToolCallId,
        startPos: mappedStartPos,
        aiContentEndPos: mappedToPos
    });
    tr = (0, $f47cbd333b1ebffc$export$c65b39427bf628b1)(tr, state, {
        from: mappedStartPos,
        to: mappedToPos
    });
    return tr;
}
function $bc2517a0813a73b6$var$buildCommitStateOnly(state, streamingState, responseVersion) {
    let tr = state.tr;
    tr = (0, $277Za.updateStreamPositions)({
        aiContentEndPos: streamingState.aiContentEndPos ?? streamingState.startPos ?? 0,
        telepointerPos: streamingState.telepointerPos ?? streamingState.startPos ?? 0,
        isFinalStream: true,
        lastProcessedVersion: responseVersion
    })(tr);
    const start = streamingState.startPos ?? 0;
    const end = streamingState.aiContentEndPos ?? streamingState.userContentEndPos ?? start;
    tr = (0, $f47cbd333b1ebffc$export$c65b39427bf628b1)(tr, state, {
        from: start,
        to: end
    });
    return tr;
}











function $b6da61900faf6b2e$export$a3c1603642e03c34(state) {
    const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state);
    if (!streamingState) return null;
    const { startPos: startPos, userContentEndPos: userContentEndPos, originalUserContentSlice: originalUserContentSlice } = streamingState;
    if (startPos === undefined || userContentEndPos === undefined || !originalUserContentSlice) return null;
    const streamTimeStamp = Date.now();
    let tr = state.tr;
    try {
        if (originalUserContentSlice.content.size > 0) tr = tr.replaceRange(startPos, userContentEndPos, originalUserContentSlice);
        else // If original was empty, we need to delete the AI content.
        // IMPORTANT: Use replaceRange with Slice.empty instead of delete()
        // because replaceRange properly handles block boundaries.
        // When a block node (e.g., heading) was inserted with openStart=0,
        // positions track content boundaries (inside the block), not node
        // boundaries. Using delete() would merge the block with adjacent content.
        // replaceRange with Slice.empty will delete the appropriate range
        // while preserving the structure of surrounding nodes.
        tr = tr.replaceRange(startPos, userContentEndPos, (0, $aPdNQ.Slice).empty);
        tr = (0, $277Za.metaTransaction)({
            tr: tr,
            isFinalStream: false,
            stackTime: streamTimeStamp
        });
        // Mark as restore transaction so track-changes knows this is part of finalize
        tr = tr.setMeta('isAIRestoreTransaction', true);
        // Don't add to history - the commit transaction will be the undo point
        tr = tr.setMeta('addToHistory', false);
    } catch  {
        return null;
    }
    return tr;
}


function $781df40929564132$export$a3923527de5abc80() {
    return {
        isFinalizingInProgress: false
    };
}
function $781df40929564132$export$21750d5b9a51a4dd(view, state, finalizeState, fireAnalyticsStep) {
    // Guard: Don't re-enter while we're dispatching restore/commit
    if (finalizeState.isFinalizingInProgress) return;
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
    if (!sessionState) return;
    // Check if finalize is needed:
    // - Session status is 'complete'
    // - Streaming state is in 'streaming' phase and actively streaming
    // - Final stream hasn't been applied yet
    const needsFinalize = sessionState.status === 'complete' && state.streamPhase === 'streaming' && state.isStreaming && !state.hasFinalStream;
    if (!needsFinalize) return;
    // Set flag to prevent re-entry during dispatches
    finalizeState.isFinalizingInProgress = true;
    try {
        // DISPATCH 1: Restore original content (streaming → original)
        const restoreTr = (0, $b6da61900faf6b2e$export$a3c1603642e03c34)(view.state);
        if (restoreTr) view.dispatch(restoreTr);
        // DISPATCH 2: Commit final content (original → final)
        const commitTr = (0, $bc2517a0813a73b6$export$1695ca555427e313)(view.state);
        if (commitTr) view.dispatch(commitTr);
        // Fire the 'complete' step with no target so that analyticsFlow sets finished=true
        // and dispatches the 'finished' userFlow event. This is the terminal step in the
        // xstate migration path — the loading step (fired in buildUpdateTransaction) transitions
        // to 'complete', and 'complete' with no target signals end-of-flow.
        fireAnalyticsStep?.('complete');
    } catch  {
    // Finalize failed - continue
    } finally{
        finalizeState.isFinalizingInProgress = false;
    }
}








const $d932759612a99220$var$LOADING_INTERVAL_MIN = 80;
const $d932759612a99220$var$LOADING_INTERVAL_MAX = 240;
function $d932759612a99220$export$46bad72eede9c7b(view, state, viewState) {
    const shouldAnimate = (state.streamPhase === 'mounting' || state.streamPhase === 'streaming') && !state.isPaused && state.aiContentEndPos === undefined;
    if (shouldAnimate && !viewState.loadingTimeout) $d932759612a99220$export$cd27e59e5909a810(view, viewState);
    if (!shouldAnimate && viewState.loadingTimeout) $d932759612a99220$export$b25251fc60891db7(viewState);
}
function $d932759612a99220$export$cd27e59e5909a810(view, viewState) {
    const interval = Math.random() * ($d932759612a99220$var$LOADING_INTERVAL_MAX - $d932759612a99220$var$LOADING_INTERVAL_MIN) + $d932759612a99220$var$LOADING_INTERVAL_MIN;
    viewState.loadingTimeout = window.setTimeout(()=>{
        const state = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(view.state);
        if (!state || state.isPaused || state.aiContentEndPos !== undefined || state.streamPhase === 'idle') {
            viewState.loadingTimeout = undefined;
            return;
        }
        try {
            view.dispatch((0, $277Za.updateLoadingPositions)(view.state.tr));
        } catch  {
        // Loading position update failed - continue
        }
        // Schedule next tick with NEW random interval
        $d932759612a99220$export$cd27e59e5909a810(view, viewState);
    }, interval);
}
function $d932759612a99220$export$b25251fc60891db7(viewState) {
    if (viewState.loadingTimeout) {
        clearTimeout(viewState.loadingTimeout);
        viewState.loadingTimeout = undefined;
    }
}









function $9cbadc5da99f733a$export$a9c3498d757ed5a2() {
    return {
        lastPublishedVersion: null
    };
}
function $9cbadc5da99f733a$export$53e4e5a2e1e4deb8(view, state, markdownStreamingState) {
    // Only process when actively streaming or just finished streaming
    if (!state.isStreaming && !state.isStreamingFinished) return;
    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
    if (!decorationState?.configItem) return;
    // Only handle config items that stream markdown
    if (!decorationState.configItem.streamsMarkdown) return;
    const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(view.state);
    if (!sessionState?.markdown) return;
    // Skip if we already published this version
    if (markdownStreamingState.lastPublishedVersion !== null && sessionState.responseVersion === markdownStreamingState.lastPublishedVersion) return;
    const { onMarkdownStreamUpdate: onMarkdownStreamUpdate } = decorationState.configItem;
    if (!onMarkdownStreamUpdate) return;
    const fragment = (0, $07d53600ec703275$export$6893d1951df87c6d)(view.state.schema, sessionState.markdown, sessionState.idMap);
    if (!fragment) return;
    const isFinal = sessionState.status === 'complete';
    // Delegate to the config item's handler to apply the markdown change.
    // Each config item defines how its streamed markdown is used — e.g. suggest title
    // publishes an eventHub event to update the Confluence page title textarea.
    onMarkdownStreamUpdate({
        editorView: view,
        pmFragment: fragment,
        isFinal: isFinal
    });
    // Track published version to avoid duplicates
    markdownStreamingState.lastPublishedVersion = sessionState.responseVersion ?? null;
}


/**
 * Mutable state container for view-related streaming state.
 * Passed by reference to allow functions to update closure variables.
 */ function $9cf0f59cb73e0da7$export$25cb56651fa39437() {
    return {
        loadingTimeout: undefined,
        originalTabIndex: undefined,
        originalOutlineColor: undefined,
        originalOutline: undefined,
        hasActivatedStreaming: false
    };
}


const $f09efb7a1015ceab$export$465eeb0611517dc = (options)=>{
    const { api: api, canAutoAcceptAIChanges: canAutoAcceptAIChanges, getFireAnalyticsStep: getFireAnalyticsStep, portalProviderAPI: portalProviderAPI } = options;
    const fireAnalyticsStep = (step, targetStep)=>getFireAnalyticsStep?.()?.(step, targetStep);
    const intl = options.getIntl();
    const getTelepointerLabel = (0, $710cefc8d9f7e5d9$export$1b782d5498130429)({
        formatMessage: intl.formatMessage,
        streamingTelepointerIdentity: options.streamingTelepointerIdentity
    });
    const defaultLabel = getTelepointerLabel({
        isAgentMentionEnabled: false
    });
    const isEditorAgentMentionsTelepointerAvatarEnabled = ()=>(0, $jkcNT.editorExperiment)('platform_editor_agent_mentions', true) && (0, $4o0zT.isExperimentEnabled)('platform_editor_agent_telepointer_redesign');
    // Create the telepointer element — label is mutated per-session to show agent name
    const { element: telepointerElement, labelElement: telepointerLabelElement, avatarContainer: telepointerAvatarContainer } = (0, $0ca5a13529310b54$export$b3d3cfdedcf26988)(defaultLabel);
    const telepointerBadge = (0, $ae94e0246d8d345f$export$1fe5be5b06049a0e)({
        elements: {
            avatarContainer: telepointerAvatarContainer,
            element: telepointerElement,
            labelElement: telepointerLabelElement
        },
        getTelepointerLabel: getTelepointerLabel,
        portalProviderAPI: portalProviderAPI
    });
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $9ybcs.purePmInEditorDirectStreamingPluginKey),
        state: {
            init: (0, $15e427849866f9a2$export$de5e90bd767c5d82),
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey));
                // Handle action-based state transformations
                // IMPORTANT: Return early when an action is handled because the positions
                // in the action payload are already mapped (e.g., in buildUpdateTransaction).
                // If we also run mapPositions, we'd double-map and get incorrect results.
                if (meta?.action) {
                    const newState = (0, $a696a92e7b577b0c$export$1056d35c08b77b41)(meta, pluginState);
                    if (newState !== undefined) return newState;
                }
                // Apply position mapping for transactions that don't have a streaming action
                // but do change the document
                if (tr.docChanged && pluginState.isStreaming) return (0, $a696a92e7b577b0c$export$38844252556f39ef)(tr, pluginState);
                return pluginState;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            const streamingState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(newState);
            const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(newState);
            const prevSessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(oldState);
            const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(newState);
            if (!streamingState || !sessionState) return null;
            // Quick bail-out checks
            if ((0, $f9586f0be0265311$export$218c70edcbbc64e5)(streamingState, sessionState)) return null;
            // Determine what action is needed
            const action = (0, $f9586f0be0265311$export$3174bd35cfffd429)(sessionState, prevSessionState, streamingState, false);
            if (!action) return null;
            // Handle markdown streaming separately as it uses a different transaction builder
            // Skip for fallback free-gen (userInput set) — those stream content in-document,
            // not into a title/heading node.
            const isFallbackFreeGen = sessionState.userInput !== undefined;
            const isMarkdownStreaming = decorationState?.configItem && (0, $140fa4f6bae32978$export$f6a5c4177d2ebb1b)(decorationState.configItem);
            if (isMarkdownStreaming && !isFallbackFreeGen && (action === 'update' || action === 'finalize')) return (0, $140fa4f6bae32978$export$ae12d1bafb9147f0)(newState, action === 'finalize');
            switch(action){
                case 'mount':
                    return (0, $54da588a708548b8$export$5cba160ccca2cd8c)(newState, fireAnalyticsStep);
                case 'update':
                    return (0, $950ce7663bc9caff$export$13c76c9a18264386)(newState, fireAnalyticsStep);
                case 'cleanup':
                    // Reset streaming state when session changes mid-stream
                    return (0, $277Za.endStream)(newState.tr);
                // Finalize & Discard are handled in view.update()
                case 'finalize':
                case 'discard':
                default:
                    return null;
            }
        },
        props: {
            decorations (state) {
                const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
                return (0, $e5dcc0a4b029642a$export$6e70fb48265e25fd)(state, telepointerElement, decorationState, isEditorAgentMentionsTelepointerAvatarEnabled());
            }
        },
        view: (editorView)=>{
            // Mutable state containers for view closure variables
            const viewState = (0, $9cf0f59cb73e0da7$export$25cb56651fa39437)();
            const discardState = (0, $4e8d2a7ea713fead$export$b4e7ecb7c76b6f00)();
            const finalizeState = (0, $781df40929564132$export$a3923527de5abc80)();
            const markdownStreamingState = (0, $9cbadc5da99f733a$export$a9c3498d757ed5a2)();
            return {
                update (view, previousState) {
                    const state = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(view.state);
                    const prevState = (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(previousState);
                    if (!state) return;
                    // Hoist a single getState call for use throughout this update() invocation.
                    const decorationState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(view.state);
                    const { currentSessionId: currentSessionId } = decorationState || {};
                    const isActive = !!currentSessionId || state.isStreaming || state.isStreamingFinished;
                    // Update the telepointer badge here in view.update() rather than in decorations() so
                    // DOM mutations and React portal renders stay side-effect-free from the perspective
                    // of ProseMirror's decoration rendering pass.
                    telepointerBadge.update(decorationState?.agentInfo);
                    // Handle discard when session is cleared while streaming
                    (0, $4e8d2a7ea713fead$export$e4f8a57678205f7d)(view, state, discardState, fireAnalyticsStep);
                    // Handle finalize with TWO separate dispatches (matching original implementation)
                    // This is critical for track-changes to work correctly
                    (0, $781df40929564132$export$21750d5b9a51a4dd)(view, state, finalizeState, fireAnalyticsStep);
                    // Handle markdown streaming: publish external events (e.g. update Confluence page title)
                    (0, $9cbadc5da99f733a$export$53e4e5a2e1e4deb8)(view, state, markdownStreamingState);
                    // Detect finalised just completed, and auto accept AI changes is enabled, then we can auto accept the changes
                    const justFinalised = state.hasFinalStream && !prevState?.hasFinalStream;
                    if (justFinalised && canAutoAcceptAIChanges) {
                        api?.aiExperience?.actions.endAIExperience();
                        // Note: endAIExperience dispatches a transaction, which will trigger another update() call
                        // In that subsequent call, currentSessionId will be cleared and isActive will be false
                        return;
                    }
                    if (!api) return;
                    (0, $d932759612a99220$export$46bad72eede9c7b)(view, state, viewState);
                    (0, $33e4b71203ab572e$export$ed6bcbf8c4a7024f)(view, state, prevState, api);
                    (0, $4d5cc6e7b555001d$export$25dfe1561be19c6b)(view, isActive, api, viewState, finalizeState?.isFinalizingInProgress);
                },
                destroy () {
                    (0, $d932759612a99220$export$b25251fc60891db7)(viewState);
                    (0, $4d5cc6e7b555001d$export$d459380d3cf60a30)(editorView, viewState);
                    telepointerBadge.destroy();
                }
            };
        }
    });
};






var $4xV3u = parcelRequire("4xV3u");





var $eLVjp = parcelRequire("eLVjp");




function $6809914780b67d19$export$c72f28d9e4137cea(options) {
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $4xV3u.rovoAgentsPluginKey),
        state: (0, $eLVjp.createPluginState)(options.dispatch, // Initial state
        {
            agents: [],
            enabled: false,
            publish: ()=>{},
            isBrowseModalOpen: false,
            positions: undefined,
            initialised: false
        })
    });
}

















const $864ccf870d57d8f9$export$382457814c88610e = new (0, $kCECX.PluginKey)('aiExperienceSelectionPreview');


const $6e58fac223e0c052$export$6b0a857b1a5189ef = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $864ccf870d57d8f9$export$382457814c88610e),
        state: {
            init: (_, state)=>({
                    selectionPreview: false
                }),
            apply: (tr, _pluginState, _oldEditorState)=>{
                if (tr.getMeta('showSelectionPreview')) return {
                    selectionPreview: true
                };
                if (tr.getMeta('hideSelectionPreview')) return {
                    selectionPreview: false
                };
                return _pluginState;
            }
        },
        props: {
            decorations: (editorState)=>{
                const pluginState = (0, $864ccf870d57d8f9$export$382457814c88610e).getState(editorState);
                if (pluginState.selectionPreview) {
                    const { modalDecorationSet: modalDecorationSet } = (0, $C4yPo.getPluginState)(editorState);
                    const modalDecorations = modalDecorationSet.find(0, editorState.doc.content.size);
                    const existingHighlightDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'inlineDecoration')[0];
                    const nodeDecoration = modalDecorations.filter((x)=>x?.spec?.key === 'ai-nodeDecoration')[0];
                    if (!nodeDecoration && !existingHighlightDecoration) {
                        const highlightDecoration = (0, $4TgUg.createInlineDecoration)(0, editorState.doc.content.size);
                        return (0, $8nvEM.DecorationSet).create(editorState.doc, [
                            highlightDecoration
                        ]);
                    }
                }
                return (0, $8nvEM.DecorationSet).empty;
            }
        }
    });
};









var $iBAu1 = parcelRequire("iBAu1");





function $41b709185dcaae77$export$be187c3e65ffcc8e(oldState, newState) {
    const oldDecoSet = (0, $C4yPo.getPluginState)(oldState)?.modalDecorationSet;
    const newDecoSet = (0, $C4yPo.getPluginState)(newState)?.modalDecorationSet;
    const oldPositions = oldDecoSet ? (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
        modalDecorationSet: oldDecoSet
    }) : undefined;
    const newPositions = newDecoSet ? (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
        modalDecorationSet: newDecoSet
    }) : undefined;
    if (oldPositions && !newPositions || !oldPositions && newPositions) return true;
    if (oldPositions && newPositions) return oldPositions[0] !== newPositions[0] || oldPositions[1] !== newPositions[1];
    return false;
}


/**
 * Clear the selection context when the next user action interaction occurs
 */ const $83c9b92eeb72de8f$var$clearPendingSelectionContext = (view)=>{
    const isPending = (0, $iBAu1.selectionPluginKey).getState(view.state)?.isPendingSelectionContextClear;
    if (isPending) {
        const { dispatch: dispatch, state: state } = view;
        dispatch(state.tr.setMeta((0, $iBAu1.selectionPluginKey), {
            action: 'clearPendingSelectionContext'
        }));
    }
};
const $83c9b92eeb72de8f$export$adbe0f8e0f3704d5 = ({ api: api, editorPluginAIProvider: editorPluginAIProvider })=>{
    let isMouseDown = false;
    let selectionChangedDuringDrag = false;
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $iBAu1.selectionPluginKey),
        state: {
            init: ()=>({
                    nonCursorSelectionChangeCount: 0,
                    lastSelectionContext: undefined,
                    isPendingSelectionContextClear: false
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $iBAu1.selectionPluginKey));
                if (meta?.action === 'incrementNonCursorSelectionChangeCount') return {
                    ...pluginState,
                    nonCursorSelectionChangeCount: pluginState.nonCursorSelectionChangeCount + 1
                };
                else if (meta?.action === 'lastSelectionContextPending') return {
                    ...pluginState,
                    isPendingSelectionContextClear: true
                };
                else if (meta?.action === 'lastSelectionContext') {
                    const selection = meta.selection;
                    return {
                        ...pluginState,
                        isPendingSelectionContextClear: false,
                        lastSelectionContext: selection ? {
                            selectionFragment: api?.selection?.actions?.getSelectionFragment({
                                selection: selection
                            }) ?? null,
                            localIds: api?.selection?.actions?.getSelectionLocalIds({
                                selection: selection
                            }) ?? null,
                            selectionMarkdown: (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
                                node: selection.content().content
                            }).markdown ?? null,
                            startIndex: selection?.$from.parentOffset ?? null,
                            endIndex: selection?.$to.parentOffset ?? null
                        } : undefined
                    };
                } else if (pluginState?.isPendingSelectionContextClear && meta?.action === 'clearPendingSelectionContext') return {
                    ...pluginState,
                    lastSelectionContext: undefined,
                    isPendingSelectionContextClear: false
                };
                return pluginState;
            }
        },
        appendTransaction: (_transactions, oldState, newState)=>{
            const oldSel = oldState.selection;
            const newSel = newState.selection;
            const pseudoSelectionChanged = (0, $41b709185dcaae77$export$be187c3e65ffcc8e)(oldState, newState);
            // Check for pseudo-selection changes first
            if (pseudoSelectionChanged) {
                // If pseudo-selection changed, always count as meaningful
                // unless we are dragging with mouse
                if (isMouseDown) {
                    selectionChangedDuringDrag = true;
                    return null;
                }
                return newState.tr.setMeta((0, $iBAu1.selectionPluginKey), {
                    action: 'incrementNonCursorSelectionChangeCount'
                });
            }
            // If no pseudo-selection change, check actual selection differences
            if (oldSel.eq(newSel)) return null;
            // If both are empty and no pseudo-change
            if (oldSel.empty && newSel.empty) return null;
            // If the mouse is currently down (e.g., during a drag), record that a change occurred
            // but do not increment the counter yet. The increment will happen when the mouse is released.
            if (isMouseDown) {
                selectionChangedDuringDrag = true;
                return null;
            }
            // If the mouse is not down, this change is considered final and should increment
            // the selection change count immediately.
            return newState.tr.setMeta((0, $iBAu1.selectionPluginKey), {
                action: 'incrementNonCursorSelectionChangeCount'
            });
        },
        props: {
            handleDOMEvents: {
                paste: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $83c9b92eeb72de8f$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                compositionstart: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $83c9b92eeb72de8f$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                keydown: editorPluginAIProvider.isInDocumentStreamingEnabled ? (view)=>{
                    $83c9b92eeb72de8f$var$clearPendingSelectionContext(view);
                    return false;
                } : undefined,
                mousedown: (view)=>{
                    if (editorPluginAIProvider.isInDocumentStreamingEnabled) $83c9b92eeb72de8f$var$clearPendingSelectionContext(view);
                    // When the mouse goes down, we start "dragging" mode.
                    isMouseDown = true;
                    selectionChangedDuringDrag = false;
                    return false; // Returning false to allow other handlers
                },
                mouseup: (view)=>{
                    // When the mouse is released, if a selection change happened during dragging,
                    // we increment the counter once.
                    isMouseDown = false;
                    if (selectionChangedDuringDrag) {
                        const { state: state, dispatch: dispatch } = view;
                        dispatch(state.tr.setMeta((0, $iBAu1.selectionPluginKey), {
                            action: 'incrementNonCursorSelectionChangeCount'
                        }));
                        selectionChangedDuringDrag = false;
                    }
                    return false; // Returning false to allow other handlers
                }
            }
        }
    });
};









var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $jgJIe = parcelRequire("jgJIe");









var $93WrI = parcelRequire("93WrI");







var $cFvoT = parcelRequire("cFvoT");


var $7Jde4 = parcelRequire("7Jde4");


var $bltJZ = parcelRequire("bltJZ");











var $iTW08 = parcelRequire("iTW08");

const $f21b1c7001a15609$var$SMALL_WORD_COUNT_THRESHOLD = 5;
const $f21b1c7001a15609$export$531d534682adbee6 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const actions = [
        {
            key: (0, $8i6M6.AI_ASK_ROVO_MENU_ITEM).key,
            label: (0, $7ZL6d.aiMessages).askRovoToolbarIconTitle,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                label: "",
                size: "xxsmall"
            }),
            configItem: editorPluginAIProvider.baseGenerate,
            shouldShowInPrimary: ()=>(0, $ieeJu.expValEquals)('platform_editor_ai_blockmenu_integration', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_blockmenu_integration_jira')
        },
        {
            key: (0, $8i6M6.AI_IMPROVE_WRITING_MENU_ITEM).key,
            label: (0, $93WrI.aiConfigItemMessages).improveWritingTitle,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
                label: "",
                size: "small"
            }),
            configItem: (0, $iO5TS.improveWriting)(),
            shouldShowInPrimary: ({ textLength: textLength, wordCount: wordCount })=>wordCount >= $f21b1c7001a15609$var$SMALL_WORD_COUNT_THRESHOLD && textLength < (0, $8i6M6.AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD) && ((0, $ieeJu.expValEquals)('platform_editor_ai_blockmenu_integration', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_blockmenu_integration_jira'))
        }
    ];
    // When remix experiment is enabled, the Remix action is registered by
    // editor-plugin-malleable-ui (which owns the openRemixModal command).
    // We only skip the polish/improve-formatting action here.
    if (!(0, $ieeJu.expValEquals)('platform_editor_remix_in_block_menu', 'isEnabled', true)) actions.push({
        key: (0, $8i6M6.AI_POLISH_MENU_ITEM).key,
        label: (0, $93WrI.aiConfigItemMessages).improveFormattingTitle,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
            label: "",
            size: "small"
        }),
        configItem: (0, $iTW08.addPolish)(),
        shouldShowInPrimary: ({ textLength: textLength })=>textLength >= (0, $8i6M6.AI_BLOCK_MENU_LARGE_TEXT_THRESHOLD) && ((0, $ieeJu.expValEquals)('platform_editor_ai_blockmenu_integration', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_blockmenu_integration_jira'))
    });
    return actions;
};









var $dVKvM = parcelRequire("dVKvM");




/**
 * Resolves the click handler for a block menu action.
 *
 * - Config item actions open the AI modal via `createOpenAIModalCommand`.
 */ const $3a011768b4fc71fa$var$executeAction = ({ action: action, editorView: editorView, editorPluginAIProvider: editorPluginAIProvider, locale: locale })=>{
    // Custom click actions — invoke the handler directly
    if (action.onClick) {
        action.onClick();
        return true;
    }
    // Config item actions — open the AI modal
    if (editorView && action.configItem) {
        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
            state: editorView.state,
            configItem: action.configItem,
            lastTriggeredFrom: 'blockMenu',
            triggerMethod: 'click',
            aiGlobalOptIn: editorPluginAIProvider.aiGlobalOptIn,
            locale: locale
        });
        openAIModalCommand(editorView.state, editorView.dispatch);
        return true;
    }
    return false;
};
const $3a011768b4fc71fa$export$182dd484b64d536b = ({ action: action, api: api, editorPluginAIProvider: editorPluginAIProvider, getEditorView: getEditorView })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        // Without stopPreservingSelection, the selection preservation plugin will
        // restore the block selection after clearBlockSelection removes it.
        // clearBlockSelection removes the background highlight decoration
        // (ak-editor-selected-node) without affecting the ProseMirror node selection.
        api?.core?.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            api?.selection?.commands?.clearBlockSelection()({
                tr: tr
            });
            return tr;
        });
        $3a011768b4fc71fa$var$executeAction({
            action: action,
            editorView: getEditorView(),
            editorPluginAIProvider: editorPluginAIProvider,
            locale: locale
        });
    }, [
        action,
        api,
        editorPluginAIProvider,
        getEditorView,
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: action.elemBefore,
        onClick: handleClick
    }, formatMessage(action.label));
};


/**
 * Builds the selection context from the current selection or the block that triggered the menu.
 *
 * When a preserved selection exists (e.g., the user selected multiple blocks before
 * opening the menu), the context aggregates text and block types across all selected
 * top-level blocks.
 *
 * Otherwise, falls back to the single block at `menuTriggerByNode.pos`.
 *
 * `getSelectionContext` is invoked once per action, and each action's `isHidden`/
 * `shouldShowInPrimary` predicate can run several times during a single block-menu
 * render pass (the renderer probes `isHidden` for the parent section as well as each
 * item). To avoid recomputing the potentially expensive `getTextInfo` doc walk for the
 * same selection on every call, the result is memoized against the current editor
 * `state` identity via `cache`. The cache is scoped to a single
 * `createAIBlockMenuComponents` call and is invalidated automatically whenever the
 * editor state changes (a new `state` object is produced by every transaction).
 */ const $03b808db02c518a3$var$getSelectionContext = ({ api: api, getEditorView: getEditorView, cache: cache })=>{
    const editorView = getEditorView();
    if (!editorView) return null;
    const { state: state } = editorView;
    // Return the memoized context when it was computed for the current editor state.
    if (cache && cache.state === state) return cache.context;
    const context = $03b808db02c518a3$var$computeSelectionContext({
        api: api,
        editorView: editorView
    });
    // Note: `isHidden`/`shouldShowInPrimary` are invoked synchronously during
    // `BlockMenuComponent`'s render (via `willComponentRender`), so this write
    // technically happens during React's render phase. It is safe as a read-through
    // memo: the cache is keyed on the immutable editor `state` identity, so for a
    // given `state` the computed value is deterministic and re-computing/re-writing
    // it produces the exact same value with no externally-observable side effect.
    // This means React Strict Mode's double-invoke is a no-op here (the second call
    // hits the cache and returns the identical value). We intentionally cache at
    // this level — rather than lifting into component state/`useMemo` — because the
    // same value must be shared across many non-component predicate calls within a
    // single render pass, and `state` identity is the natural, always-correct key.
    if (cache) {
        cache.state = state;
        cache.context = context;
    }
    return context;
};
const $03b808db02c518a3$var$computeSelectionContext = ({ api: api, editorView: editorView })=>{
    const { state: state } = editorView;
    if ((0, $ieeJu.expValEquals)('platform_editor_remix_in_block_menu', 'isEnabled', true)) {
        const textInfo = api?.blockControls?.actions.getTextInfo(editorView) ?? null;
        if (!textInfo) return null;
        return {
            textLength: textInfo.textLength,
            wordCount: (0, $721764a998f088d5$export$5e9f9da5213092bc)(textInfo.textContent)
        };
    }
    // Original inline logic (gate off)
    const blockControlsState = api?.blockControls?.sharedState.currentState();
    const preservedSelection = blockControlsState?.preservedSelection;
    // When a multi-block selection exists, aggregate text metrics across all selected blocks
    if (preservedSelection && preservedSelection.from !== preservedSelection.to) {
        const { from: from, to: to } = preservedSelection;
        const textContent = state.doc.textBetween(from, to, '\n');
        return {
            textLength: textContent.length,
            wordCount: (0, $721764a998f088d5$export$5e9f9da5213092bc)(textContent)
        };
    }
    // Single-block fallback: use the node that triggered the menu
    const pos = blockControlsState?.menuTriggerByNode?.pos;
    if (pos === null || pos === undefined) return null;
    const node = state.doc.nodeAt(pos);
    if (!node) return null;
    return {
        textLength: node.textContent.length,
        wordCount: (0, $721764a998f088d5$export$5e9f9da5213092bc)(node.textContent)
    };
};
/**
 * Determines whether an action should appear in the primary menu by
 * evaluating the action's `shouldShowInPrimary` predicate against the
 * current selection context.
 *
 * Falls back to `true` (show in primary) when selection context is unavailable.
 */ const $03b808db02c518a3$var$shouldShowInPrimary = ({ action: action, api: api, getEditorView: getEditorView, cache: cache })=>{
    const context = $03b808db02c518a3$var$getSelectionContext({
        api: api,
        getEditorView: getEditorView,
        cache: cache
    });
    if (!context) return true;
    return action.shouldShowInPrimary(context);
};
/**
 * Section wrapper for the AI block-menu group. Defined at module scope so it keeps a
 * stable component identity across renders/registrations, allowing React to reconcile
 * (update) rather than remount the section.
 */ const $03b808db02c518a3$var$AIBlockMenuSection = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: true
    }, children);
$03b808db02c518a3$var$AIBlockMenuSection.displayName = 'AIBlockMenuSection';
const $03b808db02c518a3$export$98bff0351f0b74a8 = ({ editorPluginAIProvider: editorPluginAIProvider, getEditorView: getEditorView, api: api })=>{
    const actions = (0, $f21b1c7001a15609$export$531d534682adbee6)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    // Shared, per-editor-state selection-context cache. All AI items' `isHidden`
    // predicates read from the same cache within a render pass, so the potentially
    // expensive `getTextInfo` doc walk runs at most once per editor state instead of
    // once per item (× the extra probes the renderer performs). The cache invalidates
    // itself automatically when the editor state changes.
    const selectionContextCache = {
        state: null,
        context: null
    };
    return [
        // 1. AI section
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.AI_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.AI_MENU_SECTION).key],
            component: $03b808db02c518a3$var$AIBlockMenuSection
        },
        // 2. Primary items — all actions, hidden when shouldShowInPrimary returns false
        ...actions.map((action, index)=>{
            // Create a stable component identity per action (once at registration) so React
            // can reconcile rather than remount the item on subsequent renders.
            const ActionComponent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a011768b4fc71fa$export$182dd484b64d536b), {
                    action: action,
                    api: api,
                    editorPluginAIProvider: editorPluginAIProvider,
                    getEditorView: getEditorView
                });
            ActionComponent.displayName = `AIBlockMenuActionItem(${action.key})`;
            return {
                type: 'block-menu-item',
                key: `ai-${action.key}`,
                parent: {
                    type: 'block-menu-section',
                    key: (0, $8i6M6.AI_MENU_SECTION).key,
                    rank: (0, $cCXFd.AI_MENU_SECTION_RANK)[(0, $8i6M6.AI_MENU_SECTION).key]
                },
                rank: index,
                isHidden: ()=>!$03b808db02c518a3$var$shouldShowInPrimary({
                        action: action,
                        api: api,
                        getEditorView: getEditorView,
                        cache: selectionContextCache
                    }),
                component: ActionComponent
            };
        })
    ];
};


/* ContentComponentWrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $3k5Tv = parcelRequire("3k5Tv");



















const $2702c2980a93d5fd$var$ContentComponentContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2702c2980a93d5fd$export$9bdba9f1d1439b59 = $2702c2980a93d5fd$var$ContentComponentContext.Provider;
const $2702c2980a93d5fd$export$c8b5a1f09cc4bb85 = ()=>{
    const context = (0, $cozmU.useContext)($2702c2980a93d5fd$var$ContentComponentContext);
    if (!context) throw new Error('No Editor view or API available in the context, make sure to have container wrapped with ContentComponentContextProvider');
    return context;
};










var $3z1p5 = parcelRequire("3z1p5");





var $c4mdU = parcelRequire("c4mdU");

var $3JPgn = parcelRequire("3JPgn");


var $eKbTY = parcelRequire("eKbTY");

const $276ad98225f11b6d$export$a3d3d8409c46173b = ()=>{
    return false;
};
















function $5be238e62a535642$export$ce428e3c22a00062({ editorState: editorState }) {
    const pluginState = (0, $cozmU.useMemo)(()=>{
        const rovoAgentsPluginState = (0, $eLVjp.getRovoAgentsPluginState)(editorState);
        return rovoAgentsPluginState;
    }, [
        editorState
    ]);
    return pluginState;
}



// coming soon missing `icon`
const $5d618cff2175ca38$var$favouriteAgentsQuery = `
	query editorPluginAIFavouriteAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...editorPluginAI_getAgentsFragment
				}
			}
		}
	}

	fragment editorPluginAI_getAgentsFragment on AgentStudioAssistant {
		id
		name
		description
		creator {
			id
		}
		creatorType
		# icon
		conversationStarters
		identityAccountId
		externalConfigReference
	}
`;
const $5d618cff2175ca38$var$mapFavouriteToAgent = (favourite)=>{
    return {
        named_id: '',
        creator_type: 'SYSTEM',
        available_plugins: {},
        favourite: true,
        actor_type: 'AGENT',
        user_defined_conversation_starters: [],
        deactivated: false,
        is_default: false,
        ...favourite,
        creator: favourite.creator.id
    };
};
const $5d618cff2175ca38$var$fetchFavouriteAgents = async ({ cloudId: cloudId })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: $5d618cff2175ca38$var$favouriteAgentsQuery,
                variables: {
                    cloudId: cloudId,
                    first: 10,
                    input: {
                        onlyFavouriteAgents: true
                    }
                }
            })
        });
        const responseJson = await response.json();
        if (responseJson.errors) throw new Error(responseJson.errors[0].message);
        const result = responseJson;
        return result.data.agentStudio_getAgents.edges.map((edge)=>$5d618cff2175ca38$var$mapFavouriteToAgent(edge.node));
    } catch  {
        return [];
    }
};
const $5d618cff2175ca38$var$fetchRecommendedAgents = async ({ limit: limit })=>{
    try {
        if ((0, $276ad98225f11b6d$export$a3d3d8409c46173b)()) return Promise.resolve([
            (0, $c4mdU.CommsCrafterAgent),
            (0, $c4mdU.JobWriterAgent),
            (0, $c4mdU.A11yMateAgent)
        ]);
        const response = await fetch(`/gateway/api/assist/rovo/v1/agents/recommend/v2?limit=${limit}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'ai-mate'
            }
        });
        const result = await response.json();
        return result.agents;
    } catch  {
        return [];
    }
};
const $5d618cff2175ca38$export$e37a2e6de6a7fa90 = ({ cloudId: cloudId, editorState: editorState })=>{
    const [state, setState] = (0, $cozmU.useState)({
        data: [],
        loading: true,
        error: null
    });
    const agents = (0, $5be238e62a535642$export$ce428e3c22a00062)({
        editorState: editorState
    });
    const agentsInitialised = (0, $cozmU.useRef)(agents?.initialised);
    const editorAgents = (0, $cozmU.useRef)(agents?.agents);
    agentsInitialised.current = agents?.initialised;
    editorAgents.current = agents?.agents;
    (0, $cozmU.useEffect)(()=>{
        const fetchFavouriteRecommendedAgents = async ()=>{
            if (agentsInitialised.current && editorAgents.current) {
                setState({
                    data: editorAgents.current,
                    loading: false,
                    error: null
                });
                return;
            }
            const favouriteAgents = await $5d618cff2175ca38$var$fetchFavouriteAgents({
                cloudId: cloudId
            });
            if (favouriteAgents.length >= 3) {
                setState({
                    data: favouriteAgents.map((a)=>(0, $3JPgn.getEditorAgent)(a)),
                    loading: false,
                    error: null
                });
                return;
            }
            const recommendedAgents = await $5d618cff2175ca38$var$fetchRecommendedAgents({
                limit: 3 - favouriteAgents.length
            });
            setState({
                data: [
                    ...favouriteAgents ?? [],
                    ...recommendedAgents ?? []
                ].map((a)=>(0, $3JPgn.getEditorAgent)(a)),
                loading: false,
                error: null
            });
        };
        fetchFavouriteRecommendedAgents();
    }, [
        cloudId
    ]);
    return state;
};


const $8c1517f464dc33e9$var$AgentFetcherLegacy = (props)=>{
    const { editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = props;
    const siteId = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agentsFromAssistanceService = (0, $3z1p5.useAgentsList)({
        filter: 'favourites',
        assistanceServiceParams: {
            product: (0, $5PpGs.mapToAssistanceServiceProduct)(editorPluginAIProvider.product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-favourites-fetcher',
            siteId: siteId
        }
    });
    const allAgentsFromAssistanceService = (0, $3z1p5.useAgentsList)({
        assistanceServiceParams: {
            product: (0, $5PpGs.mapToAssistanceServiceProduct)(editorPluginAIProvider.product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-all-fetcher',
            siteId: siteId
        }
    });
    const mockAgentData = (0, $276ad98225f11b6d$export$a3d3d8409c46173b)();
    // Request information about the latest Rovo agents and update the state accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!editorPluginAIProvider.getChannelVariables) // Flag can be on, but off for this specific editor
        // eg. Confluence only wants it on for full page editors, not comment editors
        return;
        // http://localhost:3100 is Playwright/Gemini
        const agents = mockAgentData ? [
            (0, $c4mdU.CommsCrafterAgent),
            (0, $c4mdU.JobWriterAgent),
            (0, $c4mdU.A11yMateAgent)
        ].map((0, $3JPgn.getEditorAgent)) : agentsFromAssistanceService.map((0, $3JPgn.getEditorAgent));
        function getDefaultAgent() {
            const defaultAgent = mockAgentData ? (0, $3JPgn.getEditorAgent)((0, $c4mdU.ChatAgent)) : allAgentsFromAssistanceService.filter((agent)=>agent.is_default).map((0, $3JPgn.getEditorAgent))[0];
            return defaultAgent;
        }
        // Update the plugin state with the latest agents
        const command = (0, $eKbTY.updateAgents)({
            agents: agents,
            defaultAgent: getDefaultAgent()
        });
        command(editorView.state, editorView.dispatch);
    }, [
        editorPluginAIProvider,
        agentsFromAssistanceService,
        allAgentsFromAssistanceService,
        mockAgentData,
        editorView.state,
        editorView.dispatch
    ]);
    return null;
};
const $8c1517f464dc33e9$var$AgentFetcherNew = (props)=>{
    const { editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = props;
    const siteId = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agentsRecommended = (0, $5d618cff2175ca38$export$e37a2e6de6a7fa90)({
        cloudId: siteId,
        editorState: editorView.state
    });
    // Request information about the latest Rovo agents and update the state accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!editorPluginAIProvider.getChannelVariables) // Flag can be on, but off for this specific editor
        // eg. Confluence only wants it on for full page editors, not comment editors
        return;
        const agents = agentsRecommended?.data;
        // Update the plugin state with the latest agents
        if (agentsRecommended.data && !agentsRecommended.loading) {
            const command = (0, $eKbTY.updateAgents)({
                agents: agents,
                defaultAgent: undefined
            });
            command(editorView.state, editorView.dispatch);
        }
    }, [
        editorPluginAIProvider,
        agentsRecommended,
        editorView.state,
        editorView.dispatch
    ]);
    return null;
};
const $8c1517f464dc33e9$export$22e51ab65638ad05 = ({ editorPluginAIProvider: editorPluginAIProvider, editorView: editorView })=>{
    return (0, $iDrrr.fg)('platform_editor_ai_remove_agents_list') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c1517f464dc33e9$var$AgentFetcherNew, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c1517f464dc33e9$var$AgentFetcherLegacy, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 



var $lOiVq = parcelRequire("lOiVq");


var $jyNaC = parcelRequire("jyNaC");

var $6hOaa = parcelRequire("6hOaa");








var $cOvkw = parcelRequire("cOvkw");




function $a971ff574ffb9b5a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a971ff574ffb9b5a$var$highlightStyles = {
    name: "1u69dfm",
    styles: "background-color:var(--ds-background-accent-blue-subtlest, #E9F2FE);border-bottom:var(--ds-border-width-selected, 2px) solid var(--ds-background-accent-blue-subtler, #CFE1FD)"
};
const $a971ff574ffb9b5a$var$nodeHighlightStyles = {
    name: "16xg81e",
    styles: "border:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);box-shadow:0 0 2px 1px var(--ds-background-accent-blue-subtler, #CFE1FD)"
};
// Gray background painted over a Post Stream Review segment that the
// user has undone (`appliedIndex === 0`). Applied by the inline decoration the
// `ai-session-context` plugin emits (class `ai-undone-segment-highlight`), it
// gives an undone segment a visible cue in the document — mirroring the neutral
// shading shown when the Rovo chat opens.
const $a971ff574ffb9b5a$var$undoneSegmentHighlightStyles = {
    name: "exhrl7",
    styles: "background-color:var(--ds-background-neutral, #0515240F)"
};
const $a971ff574ffb9b5a$var$cellHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)($a971ff574ffb9b5a$var$nodeHighlightStyles, " ::after{border-left:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);border-bottom:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);}");
// override standard dropdown max-height 90vh to accomodate for long list of translation languages
const $a971ff574ffb9b5a$var$translationsFloatingToolbarDropdownStyles = {
    name: "735ejv",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{max-height:400px;overflow-x:hidden;[data-testid^='ak-editor-ai-selection-toolbar-translate-button'] [data-item-elem-before]>span{padding:0;}}[data-testid='ak-editor-ai-selection-toolbar-ai-dropdown']>span>span{margin:0;}}"
};
const $a971ff574ffb9b5a$var$dropdownHeadingStyles = {
    name: "1tkipf9",
    styles: "[aria-label='Selection toolbar']{[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']{cursor:default;>span{gap:initial;}[data-item-elem-before]>span{padding:0;}[data-item-title]{text-transform:uppercase;font-size:0.75rem;font-weight:var(--ds-font-weight-bold, 653);color:var(--ds-text, #292A2E);}}[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']:hover{color:var(--ds-text, #292A2E);}}"
};
const $a971ff574ffb9b5a$var$rovoAgentsFloatingToolbarDropdownStyles = {
    name: "1j1boh2",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{[data-testid='ak-editor-ai-selection-toolbar-dropdown-view-all-agents']:not(:only-child){border-block-start:var(--ds-border-width-selected, 2px) solid var(--ds-menu-seperator-color, var(--ds-border, #0B120E24));>span{gap:4px;}}button[data-testid^='ak-editor-ai-selection-toolbar-dropdown-agent'] [data-item-title='true']>span{white-space:normal;}}}"
};
var $a971ff574ffb9b5a$var$_ref = {
    name: "1pr32me",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-100, 8px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg{padding-right:var(--ds-space-050, 4px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button']>span:only-child{svg{padding:0px var(--ds-space-100, 8px);}}"
};
var $a971ff574ffb9b5a$var$_ref2 = {
    name: "2wdbgh",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus{padding:0px var(--ds-space-075, 6px);}button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-075, 6px);span:first-child{margin:0;}span[role='img'],svg{padding:0;}}"
};
const $a971ff574ffb9b5a$var$aiSelectionToolbarButtonStyles = ()=>{
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return $a971ff574ffb9b5a$var$_ref2;
    else return $a971ff574ffb9b5a$var$_ref;
};
const $a971ff574ffb9b5a$var$inlineSuggestionsStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".ak-editor-content-area .", (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS, "{padding:var(--ds-space-100, 8px);border-radius:var(--ds-space-075, 6px);[class$='-DateLozenge']{margin:0;}}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.underline, "{text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--ds-border-accent-blue, #357DE8);}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.highlight, "{background-color:var(--ds-background-selected, #E9F2FE);}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.completionHint, "{color:var(--ds-text, #292A2E);opacity:var(--ds-opacity-disabled, 0.4);pointer-events:none;user-select:none;}");
};
const $a971ff574ffb9b5a$var$userHighlightBackgroundColor = {
    name: "kuiltg",
    styles: ".akEditor div.ProseMirror{.ai-pre-stream-range-selection{background-color:Highlight;color:HighlightText;&.ak-editor-annotation-draft, &.ak-editor-annotation-focus, &.ak-editor-annotation-blur{all:unset;background-color:Highlight;}}.annotationView-content-wrap{color:HighlightText;.ak-editor-annotation-draft, .ak-editor-annotation-focus, .ak-editor-annotation-blur{&:has(.ai-pre-stream-selection-highlight){all:unset;background-color:Highlight;}}}}"
};
const $a971ff574ffb9b5a$var$inEditorStreamingStyles = {
    name: "1bg62ol",
    styles: ".akEditor div.ProseMirror{.ai-modal-mount-point-widget{bottom:0;}tr>.ai-modal-mount-point-widget{display:table-cell;}.ai-pre-stream-empty-selection-caret{content:'';position:relative;border-left:var(--ds-border-width, 1px) solid var(--ds-text, #292A2E);margin-left:-1px;left:0.5px;}.ai-inline-streaming-hidden{display:none;}.ai-in-editor-user-content{opacity:0.2;}.ai-in-editor-ai-content:not(\n\t\t\t.ak-editor-annotation-draft,\n\t\t\t.ak-editor-annotation-focus,\n\t\t\t.ak-editor-annotation-blur\n\t\t){background-color:var(\n\t\t\t\t--agent-edit-chrome-background-color,\n\t\t\t\tvar(--ds-background-accent-purple-subtlest, #F8EEFE)\n\t\t\t);border-bottom-color:var(\n\t\t\t\t--agent-edit-chrome-border-color,\n\t\t\t\tvar(--ds-border-accent-purple, #AF59E1)\n\t\t\t);border-bottom-style:dashed;border-bottom-width:var(--ds-border-width, 1px);}.ai-in-editor-telepointer{position:relative;z-index:1;&>.ai-in-editor-telepointer-avatar{position:absolute;top:-20px;left:var(--ds-space-0, 0px);}.ai-in-editor-telepointer-badge{box-sizing:border-box;display:flex;flex-direction:row;align-items:center;gap:var(--ds-space-050, 4px);height:20px;padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px) var(--ds-space-025, 2px) 5px;border-radius:0 var(--ds-space-050, 4px) var(--ds-space-050, 4px) 0;background:var(\n\t\t\t\t\t--agent-edit-chrome-telepointer-line-color,\n\t\t\t\t\tvar(--ds-background-accent-purple-bolder, #964AC0)\n\t\t\t\t);font-family:var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-regular, 400);font-size:12px;line-height:16px;white-space:pre;color:var(--ds-text-inverse, #FFFFFF);.ai-in-editor-telepointer-badge-leading{display:inline-flex;align-items:center;justify-content:center;flex:none;width:12px;height:12px;}.ai-in-editor-telepointer-badge-leading:not(.ai-in-editor-telepointer-badge-leading-avatar)>*{display:flex;align-items:center;justify-content:center;width:100%;height:100%;}.ai-in-editor-telepointer-badge-leading svg{width:100%;height:100%;}.ai-in-editor-telepointer-badge-leading-avatar{width:16px;height:16px;}}.ai-in-editor-telepointer-badge.ai-in-editor-telepointer-badge-icon-only{padding:var(--ds-space-025, 2px);}.ai-in-editor-telepointer-badge-neutral{color:var(--ds-text, #292A2E);}&>.ai-in-editor-telepointer-label{position:absolute;box-sizing:border-box;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:var(--ds-space-025, 2px);gap:var(--ds-space-075, 6px);height:16px;top:var(--ds-space-0, 0px);left:var(--ds-space-0, 0px);border-radius:0px var(--ds-space-050, 4px) var(--ds-space-050, 4px) 0px;border:solid var(--ds-border-width, 1px) transparent;background:linear-gradient(var(--ds-text, #292A2E), var(--ds-text, #292A2E)) padding-box,conic-gradient(\n\t\t\t\t\t\t\tfrom 270deg at 50% 50%,\n\t\t\t\t\t\t\t#1868db 0deg,\n\t\t\t\t\t\t\t#1868db 115deg,\n\t\t\t\t\t\t\t#fca700 115deg,\n\t\t\t\t\t\t\t#fca700 180deg,\n\t\t\t\t\t\t\t#bf63f3 180deg,\n\t\t\t\t\t\t\t#bf63f3 310deg,\n\t\t\t\t\t\t\t#82b536 310deg,\n\t\t\t\t\t\t\t#82b536 359.96deg,\n\t\t\t\t\t\t\t#1868db 360deg\n\t\t\t\t\t\t) border-box;font-family:var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);font-size:10px;line-height:9px;text-align:center;white-space:pre;color:var(--ds-text-inverse, #FFFFFF);}&::after{content:'';position:absolute;width:var(--agent-edit-chrome-telepointer-line-width, 1px);height:var(--agent-edit-chrome-telepointer-line-height, 24px);top:var(--ds-space-0, 0px);left:var(--ds-space-0, 0px);background:var(--agent-edit-chrome-telepointer-line-color, var(--ds-border-brand, #1868DB));}}}"
};
/**
 * We position it as a table row to ensure it doesn't affect the table layout.
 */ const $a971ff574ffb9b5a$var$modalMountPointTableFix = {
    name: "pxemtm",
    styles: ".akEditor div.ProseMirror{tbody>.ai-modal-mount-point-widget{height:0;display:table-row;border-top-style:solid;border-top-width:var(--ds-border-width, 1px);}}"
};
const $a971ff574ffb9b5a$var$globalStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".akEditor div.ProseMirror{.ai-modal-start-widget,.ai-modal-end-widget{position:relative;&::before{content:'';background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');z-index:1;display:block;position:absolute;top:0;bottom:var(--ds-space-negative-025, -2px);background-repeat:no-repeat;background-position-x:center;background-position-y:center;background-size:contain;aspect-ratio:3/20;}}.ai-modal-start-widget::before{left:0px;margin-left:-0.1em;}.ai-modal-end-widget::before{right:0px;margin-right:-0.1em;}.ai-generated-content-highlight{", $a971ff574ffb9b5a$var$highlightStyles, ";}.ai-undone-segment-highlight{", $a971ff574ffb9b5a$var$undoneSegmentHighlightStyles, ";}.ai-selection-highlight{", $a971ff574ffb9b5a$var$highlightStyles, "&.ak-editor-annotation-draft,&.ak-editor-annotation-focus,&.ak-editor-annotation-blur{all:unset;", $a971ff574ffb9b5a$var$highlightStyles, ";}}.ai-selection-node .pm-table-wrapper{table tr td,table tr th{", (0, $jyNaC.getSelectionStyles)([
        (0, $6hOaa.SelectionStyle).Border,
        (0, $6hOaa.SelectionStyle).Blanket
    ]), ";}}.ai-generated-node-highlight .pm-table-wrapper{table tr td,table tr th{", $a971ff574ffb9b5a$var$cellHighlightStyles, ";}}.annotationView-content-wrap{.ak-editor-annotation-draft,.ak-editor-annotation-focus,.ak-editor-annotation-blur{&:has(.ai-selection-highlight){all:unset;", $a971ff574ffb9b5a$var$highlightStyles, ";}}}}");
};
const $a971ff574ffb9b5a$var$nestedEditorStyles = {
    name: "1w40d4h",
    styles: ".ak-editor-plugin-ai-modal .ak-editor-content-area .ProseMirror{min-height:auto;> p:last-of-type{margin-bottom:0;}}"
};
const $a971ff574ffb9b5a$var$aiCaretBlink = (0, $lOiVq.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $a971ff574ffb9b5a$var$aiQuickPromptStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .placeholder-decoration.placeholder-decoration-inline.ai-quick-prompt-placeholder-decoration': {
        display: 'inline-flex',
        alignItems: 'center',
        width: 'auto',
        verticalAlign: 'middle'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ProseMirror:has(.ai-quick-prompt-placeholder-decoration)': {
        caretColor: 'transparent'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .ai-quick-prompt-caret': {
        display: 'inline-block',
        alignSelf: 'stretch',
        width: '1px',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        marginLeft: '-0.5px',
        animation: `1s ${$a971ff574ffb9b5a$var$aiCaretBlink} step-start infinite`,
        background: `linear-gradient(to top,
				#FCA700 0%,
				#FCA700 20.2%,
				#6A9A23 20.2%,
				#6A9A23 46.6%,
				#1868DB 46.6%,
				#1868DB 70.2%,
				#AF59E0 70.2%,
				#AF59E0 100%)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .ai-quick-prompt-code': {
        display: 'inline-block',
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        border: `1px solid ${"var(--ds-border-bold, #7D818A)"}`,
        paddingLeft: "var(--ds-space-050, 4px)",
        paddingRight: "var(--ds-space-050, 4px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.ProseMirror .ai-quick-prompt-message': {
        display: 'inline-block',
        marginLeft: "var(--ds-space-025, 2px)",
        paddingLeft: "var(--ds-space-025, 2px)",
        paddingRight: "var(--ds-space-050, 4px)",
        paddingTop: "var(--ds-space-025, 2px)",
        paddingBottom: "var(--ds-space-025, 2px)",
        borderRadius: "var(--ds-radius-small, 4px)",
        color: "var(--ds-text-subtle, #505258)",
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    }
});
const $a971ff574ffb9b5a$export$214e018fc3e147ea = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $a971ff574ffb9b5a$var$translationsFloatingToolbarDropdownStyles,
            $a971ff574ffb9b5a$var$rovoAgentsFloatingToolbarDropdownStyles,
            $a971ff574ffb9b5a$var$inlineSuggestionsStyles(),
            $a971ff574ffb9b5a$var$dropdownHeadingStyles,
            $a971ff574ffb9b5a$var$globalStyles(),
            $a971ff574ffb9b5a$var$inEditorStreamingStyles,
            $a971ff574ffb9b5a$var$userHighlightBackgroundColor,
            $a971ff574ffb9b5a$var$aiSelectionToolbarButtonStyles(),
            $a971ff574ffb9b5a$var$nestedEditorStyles,
            $a971ff574ffb9b5a$var$modalMountPointTableFix,
            (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_quick_prompt_iw_cc', 'isEnabled', true) && $a971ff574ffb9b5a$var$aiQuickPromptStyles
        ]
    }), children);
};


/* InlineEditReadyBar.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $iMnC5 = parcelRequire("iMnC5");


var $3sXr4 = parcelRequire("3sXr4");


var $ft2zO = parcelRequire("ft2zO");





const $0a56105b546468e2$var$messages = (0, $kSwu1.defineMessages)({
    ready: {
        id: "fabric.editor.ai.inlineEditReadyBar.ready",
        defaultMessage: "Your edits are ready"
    }
});
const $0a56105b546468e2$var$styles = {
    floatingReadyBar: "_1mT5xdy1CL _0Bm75G5zaO _3OE6xY715P _1VJPcajssS _39xV02E6Kk _4ouGXIHakr _42Yu6BbFo4"
};
const $0a56105b546468e2$export$42cfe4aadba787df = ({ editorView: editorView, targetId: targetId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isVisibilityFixEnabled = (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_5'); // Keep the bar hidden until the gated viewport check completes, preventing an in-view edit from
    // flashing the ready state for one frame.
    const [shouldShowReadyBar, setShouldShowReadyBar] = (0, $cozmU.useState)(!isVisibilityFixEnabled);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        (0, $4TgUg.createDismissInlineEditReadyCommand)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const resolveTarget = (0, $cozmU.useCallback)(()=>(0, $a9ea1b9d36e0a953$export$6dc7fbb714e86543)({
            editorView: editorView,
            targetId: targetId
        }), [
        editorView,
        targetId
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisibilityFixEnabled) {
            setShouldShowReadyBar(true);
            return;
        }
        const target = resolveTarget();
        const editorDocument = editorView.dom.ownerDocument;
        const IntersectionObserver = editorDocument.defaultView?.IntersectionObserver;
        if (!target || !IntersectionObserver) {
            setShouldShowReadyBar(true);
            return;
        }
        const root = (0, $1jz5K.findOverflowScrollParent)(editorView.dom) || editorDocument.body;
        const observer = new IntersectionObserver(([entry])=>{
            if (entry?.isIntersecting) dismiss();
            else setShouldShowReadyBar(true);
        }, {
            root: root === editorDocument.body ? null : root
        });
        observer.observe(target);
        return ()=>observer.disconnect();
    }, [
        dismiss,
        editorView,
        isVisibilityFixEnabled,
        resolveTarget
    ]);
    const handleView = (0, $cozmU.useCallback)(()=>{
        // preserves the edited node id through completion. Fall back to the historical
        // selection-based target if it cannot be resolved or the experiment is disabled.
        try {
            let node = isVisibilityFixEnabled ? resolveTarget() : null;
            if (!node) {
                const { from: from } = editorView.state.selection;
                const domAtPos = editorView.domAtPos(from);
                node = domAtPos.node instanceof HTMLElement ? domAtPos.node : domAtPos.node.parentElement;
            }
            node?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        } catch  {}
        dismiss();
    }, [
        dismiss,
        editorView,
        isVisibilityFixEnabled,
        resolveTarget
    ]);
    if (!shouldShowReadyBar) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0a56105b546468e2$var$styles.floatingReadyBar
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sXr4.RovoThinkingBarWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ft2zO.RovoThinkingReady), {
        onView: handleView,
        onClose: dismiss,
        readyText: formatMessage($0a56105b546468e2$var$messages.ready)
    })));
};






var $1KOhB = parcelRequire("1KOhB");





var $hdBxM = parcelRequire("hdBxM");















const $3bd8f9494e0747d8$export$b4ceb5852b486734 = ({ modalDecorationSet: modalDecorationSet, doc: doc })=>{
    const highlightPositions = (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
        modalDecorationSet: modalDecorationSet
    });
    const preStreamRangeDecoration = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-pre-stream-range-selection')[0];
    const positions = highlightPositions ?? (preStreamRangeDecoration ? [
        preStreamRangeDecoration.from,
        preStreamRangeDecoration.to
    ] : undefined);
    if (!positions) return undefined;
    const contentWithoutParents = doc.slice(positions[0], positions[1], false).content;
    const isSingleInlineCard = contentWithoutParents.childCount === 1 && contentWithoutParents.child(0).type.name === 'inlineCard';
    const usesPreStreamRangeDecoration = !highlightPositions && preStreamRangeDecoration;
    return isSingleInlineCard && usesPreStreamRangeDecoration ? contentWithoutParents : doc.slice(positions[0], positions[1], true).content;
};
const $3bd8f9494e0747d8$export$e4b2c7b98f669fb7 = ({ editorView: editorView, getMentionNameDetails: getMentionNameDetails, editorPluginAIProvider: editorPluginAIProvider, editorApi: editorApi, isViewMode: isViewMode })=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { product: product } = editorPluginAIProvider;
    const publishDocAndSelection = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async ({ doc: doc, selection: selection })=>{
        // This is used as performance optimization since the publish function is called very often
        // and we don't want to block the main thread for this operation.
        // requestIdleCallback is not supported by all browsers, so we fallback to requestAnimationFrame
        const queueTask = window.requestIdleCallback || window.requestAnimationFrame;
        if (!doc || !selection) {
            queueTask(()=>{
                publish({
                    type: 'editor-context-payload',
                    source: 'editor',
                    product: product,
                    data: undefined
                });
            });
            return;
        }
        // Retrieve the modal decoration set from the plugin state to access the selection state,
        // since the editor's selection is cleared when the modal opens.
        const { modalDecorationSet: modalDecorationSet } = (0, $C4yPo.getPluginState)(editorView.state);
        // Initially, assume the selected content from editorView will be used
        let selectionContent = selection.content().content;
        const selectionContentFromDecorations = $3bd8f9494e0747d8$export$b4ceb5852b486734({
            modalDecorationSet: modalDecorationSet,
            doc: doc
        });
        if (selectionContentFromDecorations) selectionContent = selectionContentFromDecorations;
        let mentionMap = {};
        if (getMentionNameDetails) mentionMap = await (0, $0a05d8b07618b684$export$922d75f514df28b7)({
            node: doc,
            getMentionNameDetails: getMentionNameDetails
        });
        const { markdown: selectionMD } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
            node: (0, $aPdNQ.Fragment).from(selectionContent),
            featureToggles: {
                markdownPlus: false
            },
            mentionMap: mentionMap
        });
        queueTask(()=>{
            publish({
                type: 'editor-context-payload',
                source: 'editor',
                product: product,
                data: {
                    document: {
                        type: 'text/adf',
                        content: doc.toJSON()
                    },
                    selection: {
                        type: 'text/markdown',
                        content: selectionMD
                    },
                    ...(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                        isViewMode: isViewMode
                    } : {}
                }
            });
        });
    }, [
        editorView,
        getMentionNameDetails,
        product,
        publish,
        isViewMode
    ]);
    (0, $1KOhB.usePluginStateEffect)(editorApi, [
        'focus'
    ], ({ focusState: focusState })=>{
        // this is the same as onBlur
        if (!focusState?.hasFocus) publishDocAndSelection({
            doc: editorView.state.doc,
            selection: editorView.state.selection
        });
    });
    (0, $1KOhB.usePluginStateEffect)(editorApi, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        // When text is selected or deselected, publish the updated selection context to Rovo
        if ((aiExperienceState?.nonCursorSelectionChangeCount ?? 0) >= 1) publishDocAndSelection({
            doc: editorView.state.doc,
            selection: editorView.state.selection
        });
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            publish({
                type: 'editor-context-payload',
                source: 'editor',
                product: product,
                data: undefined
            });
        };
    }, [
        publish,
        product
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $eKbTY.updatePublish)(publish)(editorView.state, editorView.dispatch);
    }, [
        publish,
        editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
};






var $8lt5O = parcelRequire("8lt5O");




const $5cf769efe8d70c8d$export$aa8f4f6cd586f1c7 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    return !!editorPluginAIProvider.isRovoEnabled && isRovoEnabled && typeof editorPluginAIProvider?.getChannelVariables === 'function';
};
const $5cf769efe8d70c8d$export$83f18c95a94d1b1e = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const isRovoEnabled = $5cf769efe8d70c8d$export$aa8f4f6cd586f1c7({
        editorPluginAIProvider: editorPluginAIProvider
    });
    return isRovoEnabled && !!editorPluginAIProvider.showRovoAgentsInCommandPalette;
};
const $5cf769efe8d70c8d$export$6d436ac1332526a3 = (props)=>{
    const { editorView: editorView, children: children } = props;
    const enabled = $5cf769efe8d70c8d$export$aa8f4f6cd586f1c7({
        editorPluginAIProvider: props.editorPluginAIProvider
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        (0, $eKbTY.updateEnabled)(enabled)(editorView.state, editorView.dispatch);
    }, [
        editorView.dispatch,
        editorView.state,
        enabled
    ]);
    return enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children) : null;
};









const $aa5000cb5a2af7b9$export$4783d4d69ea114f3 = (view)=>({
        syncCommonAttributes: (attributes)=>view.dispatch(view.state.tr.setMeta((0, $f5926f9d1caeb928$export$249b63272434dfc7), attributes))
    });

















































var $c5jT4 = parcelRequire("c5jT4");


var $4aRua = parcelRequire("4aRua");





const $1777869db0801c54$var$knownErrorMessages = {
    [(0, $Mgq5A.FAILURE_REASON).UNKNOWN]: (0, $c5jT4.aiFailedStateMessages).documentInsertError,
    [(0, $Mgq5A.FAILURE_REASON).TOKEN_LIMIT]: (0, $c5jT4.aiFailedStateMessages).tokenLimitExceeded,
    [(0, $Mgq5A.FAILURE_REASON).INSERT_FAILURE]: (0, $c5jT4.aiFailedStateMessages).documentInsertError,
    [(0, $Mgq5A.FAILURE_REASON).INPUT_TOO_SHORT]: (0, $c5jT4.aiFailedStateMessages).inputTooShortError,
    [(0, $Mgq5A.FAILURE_REASON).HIPAA_CONTENT]: (0, $c5jT4.aiFailedStateMessages).hipaaContentError,
    [(0, $Mgq5A.FAILURE_REASON).RATE_LIMITED]: (0, $c5jT4.aiFailedStateMessages).rateLimitEnforced,
    [(0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION]: (0, $c5jT4.aiFailedStateMessages).aupViolationMessage,
    [(0, $Mgq5A.FAILURE_REASON).ELEVATE_DISABLED_GENERATE]: (0, $c5jT4.aiFailedStateMessages).elevateDisabledGenerateError,
    [(0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR]: (0, $c5jT4.aiFailedStateMessages).internalServerError,
    [(0, $Mgq5A.FAILURE_REASON).API_FAIL]: (0, $c5jT4.aiFailedStateMessages).apiError,
    [(0, $Mgq5A.FAILURE_REASON).ADF_STREAMING_ERROR]: (0, $c5jT4.aiFailedStateMessages).adfStreamingError,
    [(0, $Mgq5A.FAILURE_REASON).NO_TEXTUAL_CONTENT]: (0, $c5jT4.aiFailedStateMessages).noTextualContentError,
    [(0, $Mgq5A.FAILURE_REASON).INVALID_JSON]: (0, $c5jT4.aiFailedStateMessages).apiError
};
const $1777869db0801c54$var$aifcKnownErrorMessages = {
    [(0, $Mgq5A.FAILURE_REASON).UNKNOWN]: (0, $c5jT4.aiFailedStateMessages).documentInsertError,
    // no longer used in aifc
    [(0, $Mgq5A.FAILURE_REASON).TOKEN_LIMIT]: (0, $c5jT4.aiFailedStateMessages).aifcTokenLimitExceeded,
    [(0, $Mgq5A.FAILURE_REASON).INSERT_FAILURE]: (0, $c5jT4.aiFailedStateMessages).documentInsertError,
    // no longer used in aifc
    [(0, $Mgq5A.FAILURE_REASON).INPUT_TOO_SHORT]: (0, $c5jT4.aiFailedStateMessages).aifcInputTooShortError,
    [(0, $Mgq5A.FAILURE_REASON).HIPAA_CONTENT]: (0, $c5jT4.aiFailedStateMessages).aifcHipaaContentError,
    [(0, $Mgq5A.FAILURE_REASON).RATE_LIMITED]: (0, $c5jT4.aiFailedStateMessages).aifcRateLimitEnforced,
    [(0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION]: (0, $c5jT4.aiFailedStateMessages).aifcAupViolationMessage,
    [(0, $Mgq5A.FAILURE_REASON).ELEVATE_DISABLED_GENERATE]: (0, $c5jT4.aiFailedStateMessages).elevateDisabledGenerateError,
    // not relevant to aifc
    [(0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR]: (0, $c5jT4.aiFailedStateMessages).aifcInternalServerError,
    [(0, $Mgq5A.FAILURE_REASON).API_FAIL]: (0, $c5jT4.aiFailedStateMessages).aifcApiErrorRetry,
    [(0, $Mgq5A.FAILURE_REASON).ADF_STREAMING_ERROR]: (0, $c5jT4.aiFailedStateMessages).aifcAdfStreamingError,
    [(0, $Mgq5A.FAILURE_REASON).NO_TEXTUAL_CONTENT]: (0, $c5jT4.aiFailedStateMessages).noTextualContentError,
    [(0, $Mgq5A.FAILURE_REASON).INVALID_JSON]: (0, $c5jT4.aiFailedStateMessages).aifcApiErrorRetry
};
const $1777869db0801c54$export$5efe5b9065b71976 = {
    [(0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR]: 'https://status.atlassian.com/',
    [(0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION]: 'https://www.atlassian.com/legal/acceptable-use-policy',
    [(0, $Mgq5A.FAILURE_REASON).RATE_LIMITED]: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/'
};
const $1777869db0801c54$export$71ce55872f13f1f1 = {
    [(0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR]: 'https://rovo.status.atlassian.com/',
    [(0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION]: 'https://www.atlassian.com/legal/acceptable-use-policy',
    // no change
    [(0, $Mgq5A.FAILURE_REASON).RATE_LIMITED]: 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/' // no change
};
const $1777869db0801c54$var$getErrorMessage = (error, isInDocumentStreamingEnabled)=>{
    if (isInDocumentStreamingEnabled) return $1777869db0801c54$var$aifcKnownErrorMessages[error];
    return $1777869db0801c54$var$knownErrorMessages[error];
};
// Use of links in messages is based on guidance at https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
const $1777869db0801c54$var$LinkedMessage = ({ error: error, documentationUrl: documentationUrl })=>{
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const errorMessage = $1777869db0801c54$var$getErrorMessage(error, isInDocumentStreamingEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...errorMessage,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        values: {
            link: (message)=>// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                    href: documentationUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, message)
        }
    });
};
// 500 status codes should not be retryable
const $1777869db0801c54$var$is5xxErrorRange = (statusCode)=>statusCode >= 500 && statusCode < 600;
const $1777869db0801c54$export$27eceeaa1726619e = ({ failureReason: failureReason, statusCode: statusCode = 500 })=>failureReason === (0, $Mgq5A.FAILURE_REASON).ADF_STREAMING_ERROR || failureReason === (0, $Mgq5A.FAILURE_REASON).INVALID_JSON || failureReason === (0, $Mgq5A.FAILURE_REASON).API_FAIL && !$1777869db0801c54$var$is5xxErrorRange(statusCode);
const $1777869db0801c54$export$accc136c77ec5dfa = ({ apiName: apiName, failureReason: failureReason })=>{
    return apiName === 'assistance-service' || failureReason === (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION || failureReason === (0, $Mgq5A.FAILURE_REASON).API_FAIL ? 'apiError' : 'failed';
};
const $1777869db0801c54$export$915e9e7bd4f0f96d = ({ errorKey: errorKey, failureReason: failureReason, statusCode: statusCode })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const isConvoAIServerError = [
        'FEATURE_DISABLED',
        'FEATURE_DISABLED_ON_SITE',
        'NO_AGENT'
    ].includes(errorKey || '');
    // 9001 is a special case for elevate where we disable generate until Q3
    if (statusCode === 9001) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($1777869db0801c54$var$knownErrorMessages['elevate disabled generate']));
    if (statusCode && $1777869db0801c54$var$is5xxErrorRange(statusCode) || isConvoAIServerError || failureReason === (0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1777869db0801c54$var$LinkedMessage, {
        error: (0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR,
        documentationUrl: (isInDocumentStreamingEnabled ? $1777869db0801c54$export$71ce55872f13f1f1 : $1777869db0801c54$export$5efe5b9065b71976)[(0, $Mgq5A.FAILURE_REASON).INTERNAL_SERVER_ERROR]
    });
    if (!failureReason) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($1777869db0801c54$var$knownErrorMessages['unknown fail']));
    if (failureReason === (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1777869db0801c54$var$LinkedMessage, {
        error: (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION,
        documentationUrl: (isInDocumentStreamingEnabled ? $1777869db0801c54$export$71ce55872f13f1f1 : $1777869db0801c54$export$5efe5b9065b71976)[(0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION]
    });
    if (failureReason === (0, $Mgq5A.FAILURE_REASON).RATE_LIMITED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1777869db0801c54$var$LinkedMessage, {
        error: (0, $Mgq5A.FAILURE_REASON).RATE_LIMITED,
        documentationUrl: (isInDocumentStreamingEnabled ? $1777869db0801c54$export$71ce55872f13f1f1 : $1777869db0801c54$export$5efe5b9065b71976)[(0, $Mgq5A.FAILURE_REASON).RATE_LIMITED]
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($1777869db0801c54$var$getErrorMessage(failureReason, isInDocumentStreamingEnabled)));
};






/**
 * Stable identifier surfaced as `callerComponent` on `noEventExistsToBeFired`
 * analytics errors originating from this bridge, so they can be attributed in
 * Databricks rather than showing `callerComponent: undefined`.
 */ const $517a4f713651ad5f$var$CALLER_COMPONENT = 'AnalyticsBridge';
function $517a4f713651ad5f$export$7c274c7fd9279172({ api: api, children: children, uiState: uiState }) {
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const lastQueuedStep = (0, $cozmU.useRef)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const intl = (0, $kSwu1.useIntl)();
    // Track whether the viewed event has already been fired for this session
    // to prevent double-firing on re-renders.
    const hasViewedFired = (0, $cozmU.useRef)(false);
    const { editorView: editorView, canInlineStreamChanges: canInlineStreamChanges } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    // Read decoration state synchronously so that common attributes are
    // available before the first analytics step fires. The hook-based values
    // serve as a reactive fallback for later updates.
    const decorationState = editorView?.state ? (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state) : undefined;
    const { traceId: traceId, promptVersion: promptVersion, configItem: hookConfigItem, initialPositions: hookInitialPositions, sessionStatus: sessionStatus, errorInfo: errorInfo } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            traceId: state.aiExperienceState?.aiDecorationExperiencePluginState.traceId,
            promptVersion: state.aiExperienceState?.aiDecorationExperiencePluginState.promptVersion,
            configItem: state.aiExperienceState?.aiDecorationExperiencePluginState.configItem,
            initialPositions: state.aiExperienceState?.aiDecorationExperiencePluginState.initialPositions,
            sessionStatus: state.aiExperienceState?.aiSessionPluginState?.status,
            errorInfo: state.aiExperienceState?.aiSessionPluginState?.errorInfo
        }));
    const configItem = decorationState?.configItem ?? hookConfigItem;
    const initialPositions = decorationState?.initialPositions ?? hookInitialPositions;
    const isStreaming = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>Boolean(state.aiExperienceState?.isStreaming));
    const isIdle = (0, $cozmU.useRef)(true);
    // Guards against duplicate prompt analytics fires across re-renders.
    const lastFiredSessionStatus = (0, $cozmU.useRef)();
    // Holds a step queued by the ProseMirror plugin whose firing is deferred to a
    // useEffect (see below). Declared here so the error effect can consume/clear it
    // and avoid firing a stale step against an already-flushed queue.
    const pendingStepRef = (0, $cozmU.useRef)(null);
    // Track time spent in loading vs streaming for duration measurements.
    // These persist across screen transitions since this component doesn't unmount.
    const loadingStartTime = (0, $cozmU.useRef)(performance.now());
    const streamingStartTime = (0, $cozmU.useRef)();
    if (!streamingStartTime.current && isStreaming) streamingStartTime.current = performance.now();
    (0, $cozmU.useEffect)(()=>{
        if (uiState === 'idle' && !isIdle.current) {
            loadingStartTime.current = performance.now();
            isIdle.current = true;
            hasViewedFired.current = false;
            lastFiredSessionStatus.current = undefined;
            // Reset the dedup guard so the next session can re-fire the same step
            // (e.g. `invoke`) instead of having it silently dropped.
            lastQueuedStep.current = undefined;
        } else isIdle.current = false;
    }, [
        uiState
    ]);
    // The analyticsFlow instance is recreated per session (keyed on aiSessionId in
    // SessionUIComponent). When it changes, reset the dedup guard so a step already
    // fired against the previous flow can fire again against the new one.
    (0, $cozmU.useEffect)(()=>{
        lastQueuedStep.current = undefined;
    }, [
        analyticsFlow
    ]);
    // Record prompt status; actual analytics fire in the pendingStep effect
    // (the analyticsFlow is recreated when aiSessionId changes, so we cannot
    // enqueue here directly).
    (0, $cozmU.useEffect)(()=>{
        if (sessionStatus === 'prompt' && lastFiredSessionStatus.current !== 'prompt') lastFiredSessionStatus.current = 'prompt';
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sessionStatus
    ]);
    // Fire error analytics (apiError or failed) when entering error status.
    // The analyticsFlow may be recreated between sessions (with a fresh invoke
    // queued), so we flush any queued step first, then enqueue and fire the error.
    (0, $cozmU.useEffect)(()=>{
        if (sessionStatus !== 'error' || !errorInfo || lastFiredSessionStatus.current === 'error') return;
        lastFiredSessionStatus.current = 'error';
        // Consume any step the plugin queued but that the deferred pendingStep
        // effect has not yet processed. If we left it in place, that effect would
        // later run against the queue this error path is about to flush, firing a
        // spurious `noEventExistsToBeFired` error. We take over responsibility for
        // flushing it here and reset the dedup guard so real subsequent steps can
        // still be queued.
        pendingStepRef.current = null;
        lastQueuedStep.current = undefined;
        const stepName = (0, $1777869db0801c54$export$accc136c77ec5dfa)(errorInfo);
        // Flush any previously queued step (e.g. invoke from a recreated flow).
        // Only do this when a step is actually queued: firing against an empty queue
        // emits a spurious `noEventExistsToBeFired` operational error, which is the
        // common case here because `invoke` has usually already fired by the time an
        // error occurs (leaving the recreated flow's queue empty).
        if (analyticsFlow.hasQueuedStep()) analyticsFlow.fireQueuedStep(stepName, $517a4f713651ad5f$var$CALLER_COMPONENT);
        analyticsFlow.enqueueStep({
            stepName: stepName,
            attributes: {
                errorType: errorInfo.failureReason ?? (0, $Mgq5A.FAILURE_REASON).UNKNOWN,
                sawAupViolation: errorInfo.failureReason === (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION,
                ...errorInfo
            }
        }, $517a4f713651ad5f$var$CALLER_COMPONENT);
        analyticsFlow.fireQueuedStep(undefined, $517a4f713651ad5f$var$CALLER_COMPONENT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        sessionStatus,
        errorInfo
    ]);
    (0, $cozmU.useEffect)(()=>{
        const streamingStart = streamingStartTime.current;
        const loadingStart = loadingStartTime.current;
        return ()=>{
            if (!streamingStart) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: streamingStart - loadingStart,
                    timeSpentWithPartialPreview: performance.now() - streamingStart
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync traceId and promptVersion into common attributes when it becomes available from the backend
    (0, $cozmU.useEffect)(()=>{
        if (traceId || promptVersion) analyticsFlow.updateCommonAttributes({
            traceIds: traceId ? [
                traceId
            ] : undefined,
            promptVersion: promptVersion
        });
    }, [
        traceId,
        promptVersion,
        analyticsFlow
    ]);
    // Populate common analytics attributes
    (0, $cozmU.useEffect)(()=>{
        if (!configItem) return;
        const backendModel = configItem.getBackendModel?.();
        const autoAcceptAIChanges = canInlineStreamChanges();
        const isInvokedFromEmptyPage = (0, $iLrhi.isEmptyDocument)(editorView.state.doc);
        const isSmartLinkToolbarExpEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel,
            ...analyticsFlow.getUserFlowCommonAttributes(configItem),
            autoAcceptAIChanges: autoAcceptAIChanges,
            inlineStreamingAvailable: true,
            isInvokedFromEmptyPage: isInvokedFromEmptyPage,
            ...isSmartLinkToolbarExpEnabled && (decorationState?.has3pSources !== undefined || decorationState?.sourceProduct !== undefined) && {
                has3pSources: decorationState?.has3pSources,
                sourceProduct: decorationState?.sourceProduct
            }
        });
        if (initialPositions) {
            const selectionCategory = (0, $3117ebeab67c20f0$export$385434a4b24ab280)(editorView, initialPositions);
            const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.rangeCharWordCount)(editorView.state.doc, initialPositions[0], initialPositions[1]);
            analyticsFlow.updateCommonAttributes({
                selectionCharCount: charCount,
                selectionWordCount: wordCount,
                selectionCategory: selectionCategory
            });
            const selectionNodes = (0, $3117ebeab67c20f0$export$208ac2488b55bf9d)(editorView.state, initialPositions);
            analyticsFlow.updateCommonAttributes({
                selectionNodes: selectionNodes
            });
        }
    }, [
        analyticsFlow,
        configItem,
        initialPositions,
        editorView,
        canInlineStreamChanges,
        decorationState?.has3pSources,
        decorationState?.sourceProduct
    ]);
    const [pendingStepVersion, setPendingStepVersion] = (0, $cozmU.useState)(0);
    const fireAnalyticsStep = (0, $cozmU.useCallback)((step, targetStep)=>{
        if (lastQueuedStep.current !== step) {
            lastQueuedStep.current = step;
            pendingStepRef.current = {
                step: step,
                targetStep: targetStep
            };
            setPendingStepVersion((v)=>v + 1);
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const pendingStep = pendingStepRef.current;
        if (!pendingStep) return;
        pendingStepRef.current = null;
        const { step: step, targetStep: targetStep } = pendingStep;
        // Inject the prompt step into the invoke→loading chain when we came
        // through the prompt screen (replicates: invoke → prompt → loading).
        if (step === 'invoke' && lastFiredSessionStatus.current === 'prompt') {
            lastFiredSessionStatus.current = 'invoke-after-prompt';
            analyticsFlow.fireQueuedStep('prompt', $517a4f713651ad5f$var$CALLER_COMPONENT);
            analyticsFlow.enqueueStep({
                stepName: 'prompt',
                attributes: {
                    experienceName: configItem?.key,
                    featureId: configItem?.featureId,
                    promptTitle: configItem?.promptLabel ? intl.formatMessage(configItem.promptLabel) : undefined,
                    promptType: 'generate',
                    usingCommandPalette: true
                }
            }, $517a4f713651ad5f$var$CALLER_COMPONENT);
            analyticsFlow.fireQueuedStep(targetStep, $517a4f713651ad5f$var$CALLER_COMPONENT);
            return;
        }
        // invoke is already queued on reset
        if (step !== 'invoke') analyticsFlow.enqueueStep({
            stepName: step
        }, $517a4f713651ad5f$var$CALLER_COMPONENT);
        // Fire the unified ACTION.VIEWED event when the stream has completed.
        // In the legacy path, this was handled by useInEditorDirectStreaming on isFinalStream.
        // In the pure-PM path (xstate migration), the streaming happens in ProseMirror plugins
        // without React. handleFinalize fires 'complete' after the stream ends, so we fire
        // ACTION.VIEWED here when the bridge processes the 'complete' step.
        if (step === 'complete' && !hasViewedFired.current) {
            const unifiedEventData = analyticsFlow.getUnifiedEventData();
            const isSmartLinkToolbarExpEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
            if (unifiedEventData.invokedFrom !== 'streamingApi' && unifiedEventData.invokedFrom !== 'confluenceTitleGenOnPaste') {
                hasViewedFired.current = true;
                fireAIAnalyticsEvent({
                    payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        action: (0, $krYZG.ACTION).VIEWED,
                        interactionID: unifiedEventData.interactionID,
                        experienceName: unifiedEventData.experienceName,
                        isProactive: false,
                        invokedFrom: unifiedEventData.invokedFrom,
                        ...isSmartLinkToolbarExpEnabled && {
                            has3pSources: unifiedEventData.has3pSources,
                            sourceProduct: unifiedEventData.sourceProduct
                        },
                        attributes: unifiedEventData.attributes,
                        traceIds: unifiedEventData.traceIds
                    })
                });
            }
        }
        analyticsFlow.fireQueuedStep(targetStep, $517a4f713651ad5f$var$CALLER_COMPONENT);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pendingStepVersion,
        analyticsFlow,
        fireAIAnalyticsEvent,
        configItem,
        intl
    ]);
    // Expose fireAnalyticsStep to the pure-pm plugin via the plugin API (ref so plugin always calls current callback)
    const bridgeRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    (0, $cozmU.useEffect)(()=>{
        bridgeRef.current = {
            fireAnalyticsStep: fireAnalyticsStep
        };
        api?.aiExperience?.actions?.setAnalyticsBridgeRef?.(bridgeRef);
        return ()=>{
            api?.aiExperience?.actions?.setAnalyticsBridgeRef?.(null);
            bridgeRef.current = null;
        };
    }, [
        api,
        fireAnalyticsStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}









var $isuYJ = parcelRequire("isuYJ");







const $417555b7814249e6$var$initialState = {
    discard: false,
    terminated: false,
    showAcceptReject: false
};
function $417555b7814249e6$var$reducer(state, action) {
    switch(action.type){
        case 'discard':
            return {
                ...state,
                discard: true
            };
        case 'cancel':
            return {
                ...state,
                discard: false
            };
        case 'terminate':
            return {
                ...state,
                terminated: true
            };
        case 'reset':
            return {
                discard: false,
                terminated: false,
                showAcceptReject: false
            };
        case 'show-accept-reject':
            return {
                ...state,
                showAcceptReject: true
            };
        default:
            return state;
    }
}
/**
 * LEGACY MODE (xstate) - when feature flag is OFF
 */ const $417555b7814249e6$var$useUIStateLegacy = (api)=>{
    const [localUI, dispatch] = (0, $cozmU.useReducer)($417555b7814249e6$var$reducer, $417555b7814249e6$var$initialState);
    const { nextSessionId: nextSessionId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            nextSessionId: state.aiExperienceState?.aiDecorationExperiencePluginState?.nextSessionId
        }));
    (0, $cozmU.useEffect)(()=>{
        if (!nextSessionId) dispatch({
            type: 'reset'
        });
    }, [
        nextSessionId
    ]);
    if (nextSessionId && !localUI.terminated) {
        if (localUI.discard) return [
            'discard',
            dispatch
        ];
        return [
            'loading',
            dispatch
        ];
    }
    return [
        'idle',
        ()=>{}
    ];
};
/**
 * MIGRATED MODE (ProseMirror native) - when feature flag is ON
 * Uses ai-session-context plugin status as source of truth.
 */ const $417555b7814249e6$var$useUIStateMigrated = (api)=>{
    const [localUI, dispatch] = (0, $cozmU.useReducer)($417555b7814249e6$var$reducer, $417555b7814249e6$var$initialState);
    const { nextSessionId: nextSessionId, status: status, responseTooSimilar: responseTooSimilar, streamsMarkdown: streamsMarkdown, isInlineEditReady: isInlineEditReady } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            nextSessionId: state.aiExperienceState?.aiDecorationExperiencePluginState?.nextSessionId,
            status: state.aiExperienceState?.aiSessionPluginState?.status,
            responseTooSimilar: state.aiExperienceState?.aiSessionPluginState?.responseTooSimilar,
            streamsMarkdown: state.aiExperienceState?.aiDecorationExperiencePluginState?.configItem?.streamsMarkdown,
            isInlineEditReady: state.aiExperienceState?.aiDecorationExperiencePluginState?.isInlineEditReady
        }));
    const isMarkdownStreaming = !!streamsMarkdown;
    // For markdown streaming flows, auto-end the experience when streaming completes.
    // Markdown streaming applies changes outside the ProseMirror document (e.g. updating the
    // Confluence page title via eventHub events), so there's no accept/reject step — the
    // experience should end immediately on completion.
    (0, $cozmU.useEffect)(()=>{
        if (isMarkdownStreaming && status === 'complete') api?.aiExperience?.actions.endAIExperience();
    }, [
        isMarkdownStreaming,
        status,
        api
    ]);
    // After terminating (e.g. discard confirmed), keep UI suppressed until the session fully ends.
    // Otherwise we can briefly show "loading" while `nextSessionId` is still present.
    // Also reset the session context when terminating from an error state — endSession may
    // skip the RESET dispatch when nextSessionId is empty (sessionId mismatch guard).
    (0, $cozmU.useEffect)(()=>{
        if (localUI.terminated && !nextSessionId) {
            if (status === 'error') api?.core?.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $iN8Pe.aiSessionContextPluginKey), {
                    type: 'RESET'
                });
                return tr;
            });
            dispatch({
                type: 'reset'
            });
        }
    }, [
        localUI.terminated,
        nextSessionId,
        status,
        api
    ]);
    const resolveState = ()=>{
        if (localUI.terminated) return 'idle';
        if (isInlineEditReady && status !== 'postStreamReview') return 'idle';
        if (localUI.discard) return 'discard';
        if (status === 'complete' && responseTooSimilar) return 'noImprovement';
        // Active session that's not in error/idle = show loading
        if (nextSessionId && status !== 'error' && status !== 'idle') return 'loading';
        // Error takes priority over acceptReject — if the session errored,
        // show the error screen even if acceptReject was previously requested.
        if (status === 'error') return 'error';
        if (localUI.showAcceptReject && !nextSessionId) return 'acceptReject';
        // [CCI-15904] Post Stream Review takes priority over the default complete/idle
        // mapping — when the session-context plugin has switched to 'postStreamReview',
        // the AI modal should render the PostStreamReviewScreen.
        if (status === 'postStreamReview') return 'postStreamReview';
        // Map plugin status to UI state
        switch(status){
            case 'prompt':
                return 'prompt';
            case 'streaming':
            case 'complete':
                return 'loading';
            case 'idle':
            default:
                return 'idle';
        }
    };
    return [
        resolveState(),
        dispatch
    ];
};
const $417555b7814249e6$export$fe5c3dd398c32c18 = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true), $417555b7814249e6$var$useUIStateMigrated, $417555b7814249e6$var$useUIStateLegacy);

















/* AcceptReject.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");





var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $iInrd = parcelRequire("iInrd");


var $fxbF1 = parcelRequire("fxbF1");


var $4ez2K = parcelRequire("4ez2K");

/* FeedbackForm.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxfrag */ 















var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");








var $9GVkD = parcelRequire("9GVkD");




const $1b0355dda62504ab$var$message = (0, $kSwu1.defineMessages)({
    goodResponse: {
        id: "fabric.editor.ai.components.feedbackForm.goodResponse",
        defaultMessage: "Good response"
    },
    badResponse: {
        id: "fabric.editor.ai.components.feedbackForm.badResponse",
        defaultMessage: "Bad response"
    },
    feedbackSent: {
        id: "fabric.editor.ai.components.feedbackForm.feedbackSent",
        defaultMessage: "Feedback sent"
    }
});
var $1b0355dda62504ab$export$2e2bcd8739ae039 = $1b0355dda62504ab$var$message;


const $29d5f06545812d14$var$iconWrapperStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $29d5f06545812d14$var$hideBackgroundStyles = null;
const $29d5f06545812d14$var$Announcer = ({ message: message, shouldAnnounce: shouldAnnounce })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            "aria-atomic": "true",
            "aria-live": "polite",
            children: shouldAnnounce && message
        })
    });
};
const $29d5f06545812d14$var$FeedbackButton = ({ type: type, onClick: onClick, isPressed: isPressed, isDisabled: isDisabled, flexIconWrapper: flexIconWrapper, largeIconButton: largeIconButton })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const responseLabel = type === 'good' ? formatMessage((0, $1b0355dda62504ab$export$2e2bcd8739ae039).goodResponse) : formatMessage((0, $1b0355dda62504ab$export$2e2bcd8739ae039).badResponse);
    const color = isPressed ? "var(--ds-link-pressed, #1558BC)" : 'currentColor';
    const Icon = (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? ()=>type === 'good' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            color: color
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
            label: "",
            color: color
        }) : ()=>type === 'good' ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: responseLabel,
            color: color
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
            label: responseLabel,
            color: color
        });
    const tooltipOptions = {
        position: 'top',
        content: responseLabel
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            flexIconWrapper && "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            (isPressed || isDisabled) && "_0ubfYR66of"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            testId: `${type}-response-feedback-button`,
            type: "button",
            isDisabled: isDisabled,
            onClick: onClick,
            icon: Icon,
            label: responseLabel,
            appearance: "subtle",
            spacing: largeIconButton ? undefined : 'compact',
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        })
    });
};
const $29d5f06545812d14$export$ce859c56062f484c = ({ onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, isPressed: isPressed, isDisabled: isDisabled, flexIconWrapper: flexIconWrapper, largeIconButton: largeIconButton })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const feedbackWasSentLabel = formatMessage((0, $1b0355dda62504ab$export$2e2bcd8739ae039).feedbackSent);
    const [feedbackSelected, setFeedbackSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((onClick, feedback)=>()=>{
            onClick();
            setFeedbackSelected(feedback);
        }, [
        setFeedbackSelected
    ]);
    const disableButton = !!isPressed || isDisabled || !!feedbackSelected;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)($29d5f06545812d14$var$Announcer, {
                message: feedbackWasSentLabel,
                shouldAnnounce: Boolean(feedbackSelected)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($29d5f06545812d14$var$FeedbackButton, {
                type: "good",
                isPressed: isPressed === 'good',
                isDisabled: disableButton,
                flexIconWrapper: flexIconWrapper,
                largeIconButton: largeIconButton,
                onClick: handleOnClick(onGoodResponseButtonClick, 'good')
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)($29d5f06545812d14$var$FeedbackButton, {
                type: "bad",
                isPressed: isPressed === 'bad',
                isDisabled: disableButton,
                flexIconWrapper: flexIconWrapper,
                largeIconButton: largeIconButton,
                onClick: handleOnClick(onBadResponseButtonClick, 'bad')
            })
        ]
    });
};



var $btrDv = parcelRequire("btrDv");


var $9lgy7 = parcelRequire("9lgy7");




const $9d8a0b2e2e8eb9ea$var$_default_1 = (0, $kSwu1.defineMessages)({
    acceptLabel: {
        id: "fabric.editor.ai.screens.acceptReject.acceptLabel",
        defaultMessage: "Accept"
    },
    rejectLabel: {
        id: "fabric.editor.ai.screens.acceptReject.rejectLabel",
        defaultMessage: "Discard"
    }
});
var $9d8a0b2e2e8eb9ea$export$2e2bcd8739ae039 = $9d8a0b2e2e8eb9ea$var$_default_1;


const $44f24bb9575eaa37$var$styles = {
    container: "_3TGfC9HnLE _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    containerSmall: "_2mHwu85zaO _0aFT5vbt8w _0hPCNLFlnN _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    buttonsWrapper: "_2XsHFMIZbP"
};
const $44f24bb9575eaa37$var$stylesUnbounded = {
    toggleChangesButtonWrapper: "_2yf8qKYbGa"
};
const $44f24bb9575eaa37$var$chromelessWidth = null;
const $44f24bb9575eaa37$var$chromelessStyles = null;
const $44f24bb9575eaa37$export$87eca91cbe06d0c8 = ({ onAccept: onAccept, onReject: onReject, onBadResponseButtonClick: onBadResponseButtonClick, onGoodResponseButtonClick: onGoodResponseButtonClick, isDisplayingChanges: isDisplayingChanges, onToggleChanges: onToggleChanges })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const isSmallChromeless = breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: setBreakpointsElement,
        "data-testid": "accept-reject-screen",
        rainbowBorderAnimation: false,
        rainbowBorder: false,
        disablePadding: true,
        enableMaxWidth: true,
        isAIFC: true,
        className: (0, $hekY6.default)([
            isSmallChromeless ? "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02Mvqk" : "_39xV02Mvqk _2p6ht9DIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            justifyContent: "space-between",
            alignItems: "center",
            xcss: (0, $w6R6I.cx)(isSmallChromeless ? $44f24bb9575eaa37$var$styles.containerSmall : $44f24bb9575eaa37$var$styles.container),
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    gap: "space.050",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                            alignItems: "center",
                            justifyContent: "center",
                            xcss: $44f24bb9575eaa37$var$stylesUnbounded.toggleChangesButtonWrapper,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                                testId: "toggle-changes-button",
                                type: "button",
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))),
                                label: formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel),
                                appearance: "subtle",
                                isTooltipDisabled: false,
                                tooltip: {
                                    position: 'top',
                                    content: formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel)
                                },
                                isSelected: isDisplayingChanges,
                                onClick: onToggleChanges
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $29d5f06545812d14$export$ce859c56062f484c), {
                            onBadResponseButtonClick: onBadResponseButtonClick,
                            onGoodResponseButtonClick: onGoodResponseButtonClick,
                            flexIconWrapper: true,
                            largeIconButton: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    gap: "space.050",
                    xcss: $44f24bb9575eaa37$var$styles.buttonsWrapper,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "subtle",
                            onClick: onReject,
                            children: formatMessage((0, $9d8a0b2e2e8eb9ea$export$2e2bcd8739ae039).rejectLabel)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                            appearance: "primary",
                            onClick: onAccept,
                            autoFocus: true,
                            children: formatMessage((0, $9d8a0b2e2e8eb9ea$export$2e2bcd8739ae039).acceptLabel)
                        })
                    ]
                })
            ]
        })
    });
};











/* Container.tsx generated by @compiled/babel-plugin v2.0.0 */ 






const $29c6ac32a7e58a17$var$slideFadeIn = null;
const $29c6ac32a7e58a17$var$baseLoadingStyles = null;
const $29c6ac32a7e58a17$var$defaultLoadingStyles = null;
const $29c6ac32a7e58a17$var$pageCommentLoadingStyles = null;
const $29c6ac32a7e58a17$var$chromelessCommentLoadingStyles = null;
const $29c6ac32a7e58a17$var$gridDisplayStyles = null;
const $29c6ac32a7e58a17$export$42a852a2b6b56249 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, appearance: appearance }, ref)=>{
    const internalRef = (0, $cozmU.useRef)(null);
    const { wrapperElement: wrapperElement } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    (0, $cozmU.useImperativeHandle)(ref, ()=>internalRef.current);
    const isChromelessComment = appearance === 'chromeless';
    const isPageComment = appearance === 'comment'; // For chromeless editors, add transform to the scroll container to create
    // a new containing block for position: fixed, making fixed positioning
    // relative to the scroll container instead of the viewport
    (0, $cozmU.useEffect)(()=>{
        if (!(isChromelessComment || isPageComment) || !wrapperElement) return;
        const originalTransform = wrapperElement.style.transform; // Adding transform creates a new containing block for fixed positioned descendants
        // This makes position: fixed relative to this container instead of the viewport
        wrapperElement.style.transform = 'translateZ(0)';
        return ()=>{
            wrapperElement.style.transform = originalTransform;
        };
    }, [
        isChromelessComment,
        isPageComment,
        wrapperElement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: internalRef,
        className: (0, $hekY6.default)([
            "_0aFT5vbt8w _1mT5xdy1CL _2XsHFMUgYP _0adFHsUgYP _42Yu6B3fRC _39xV02cI3e _1gBibynkof _0nFVCG2HTN _43vdfT1fFG _3Y6bKpgRhm _1VPqc3YbGa",
            "_3iDTPbgBM8",
            isChromelessComment ? "_0Bm75GgVvo _3OE6xY1Y8M _4ApkO21Y8M _2XsHFMPgdg _0adFHsPgdg _39xV02IZbP" : isPageComment ? "_0Bm75GNHnM _3OE6xY1Y8M _4ApkO21Y8M _39xV02IZbP" : "_0Bm75GNHnM _39xV02IZbP _3OE6xY1Y8M _4ApkO21Y8M"
        ])
    }, children);
});






var $cbY7C = parcelRequire("cbY7C");







const $bb835f24d2d32c51$var$MARKDOWN_LIST_KEYS = [
    '-',
    '*',
    "\u2022"
];
const $bb835f24d2d32c51$var$MODIFIER_KEYS = [
    'Shift',
    'Alt'
];
const $bb835f24d2d32c51$export$27da6e66e88e9ac7 = ({ ref: ref, onDiscard: onDiscard, lastTriggeredFrom: lastTriggeredFrom, editorView: editorView, disableClickOutside: disableClickOutside })=>{
    const canEarlyEscape = (0, $cozmU.useRef)(true);
    const handleEscapeKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (canEarlyEscape.current && event.key !== ' ' && !$bb835f24d2d32c51$var$MARKDOWN_LIST_KEYS.includes(event.key) && !$bb835f24d2d32c51$var$MODIFIER_KEYS.includes(event.key)) canEarlyEscape.current = false;
        if (!(event.key === 'Escape' || canEarlyEscape.current && lastTriggeredFrom === 'spaceShortcut' && (event.key === ' ' || $bb835f24d2d32c51$var$MARKDOWN_LIST_KEYS.includes(event.key)))) return;
        event.preventDefault();
        event.stopPropagation();
        onDiscard?.({
            shouldIgnoreNextSpaceTrigger: event.key === ' ' && lastTriggeredFrom === 'spaceShortcut' || event.key === 'Escape' && lastTriggeredFrom === 'spaceShortcut'
        });
        if (editorView) editorView.focus();
        if ($bb835f24d2d32c51$var$MARKDOWN_LIST_KEYS.includes(event.key) && editorView) {
            editorView.dispatch(editorView.state.tr.insertText(` ${event.key}`));
            return;
        }
        if (event.key === ' ' && lastTriggeredFrom === 'spaceShortcut' && editorView) {
            editorView.dispatch(editorView.state.tr.insertText(' '));
            return;
        }
    }, [
        onDiscard,
        lastTriggeredFrom,
        editorView
    ]);
    const handleEscapeKeyUp = (0, $cozmU.useCallback)((event)=>{
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        if (ref.current?.contains(event.target)) return;
        // When an inline AI session is in progress, do not discard on outside click.
        // The user should be able to open Rovo Chat or other editor-adjacent UI
        // without losing the in-progress inline edit.
        if (editorView) {
            const sessionStatus = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state)?.status;
            if ((sessionStatus === 'prompt' || sessionStatus === 'streaming') && (0, $iDrrr.fg)('cc-maui-phase-3')) return;
        }
        onDiscard?.();
    }, [
        ref,
        onDiscard,
        editorView
    ]);
    // Keyboard listeners own the focus call (focus is required to capture key events).
    // Kept separate from the click listener so toggling `disableClickOutside` mid-session
    // does not re-run this effect and steal focus back to the editor.
    (0, $cozmU.useEffect)(()=>{
        const contentArea = document.querySelector('.ak-editor-content-area');
        if (!contentArea) return;
        // Ensure we focus the content area to capture keyboard events
        contentArea.focus({
            preventScroll: true
        });
        return (0, $cbY7C.bindAll)(contentArea, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        handleEscapeKeyDown,
        handleEscapeKeyUp
    ]);
    // Click-away discard, bound on its own so it can be toggled via disableClickOutside
    // without re-running the focus effect above.
    (0, $cozmU.useEffect)(()=>{
        if (disableClickOutside) return;
        const contentArea = document.querySelector('.ak-editor-content-area');
        if (!contentArea) return;
        return (0, $cbY7C.bindAll)(contentArea, [
            {
                type: 'click',
                listener: handleClickOutside
            }
        ]);
    }, [
        handleClickOutside,
        disableClickOutside
    ]);
};


const $2c400fd4fb69c103$export$fe4c8e5bea1e02f4 = ({ api: api, dispatch: dispatch, appearance: appearance })=>{
    const { isDisplayingChanges: isDisplayingChanges, endExperience: endExperience, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { configItem: configItem, lastTriggeredFrom: lastTriggeredFrom } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            configItem: state.aiExperienceState?.aiDecorationExperiencePluginState?.configItem,
            lastTriggeredFrom: state.aiExperienceState?.aiDecorationExperiencePluginState?.lastTriggeredFrom
        }));
    const product = editorPluginAIProvider.product;
    // preset prompt or base generate / interrogation
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const aiExperienceMetadata = (0, $cozmU.useMemo)(()=>{
        return {
            configItemTitle: configItem?.agent?.name || (0, $l2lIz.convertExperienceName)(configItem?.key?.toString() ?? ''),
            ...configItem?.experienceId && (0, $iDrrr.fg)('thor_support_google_docs_in_description_improver') ? {
                experienceId: configItem?.experienceId
            } : {},
            lastTriggeredFrom: lastTriggeredFrom
        };
    }, [
        configItem,
        lastTriggeredFrom
    ]);
    const onEscDiscard = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'discard'
        });
    }, [
        dispatch
    ]);
    const onToggleChanges = (0, $cozmU.useCallback)(()=>{
        // toggle diff, diff will also be turned off when unmount ExperienceApplication
        const toggleCmd = api?.trackChanges?.commands?.toggleChanges;
        if (toggleCmd) api?.core.actions.execute(toggleCmd);
    }, [
        api
    ]);
    const onAccept = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_CHANGES_ACCEPT_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem?.agent?.name || configItem?.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions?.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
            action: (0, $krYZG.ACTION).ACTIONED,
            interactionID: analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $l2lIz.convertExperienceName)(configItem?.key?.toString() ?? ''),
            isProactive: false,
            attributes: {
                ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                aiResultAction: 'accepted',
                aiActionedType: 'manuallyAccepted'
            },
            invokedFrom: lastTriggeredFrom
        }));
        endExperience();
        dispatch({
            type: 'reset'
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        endExperience,
        analyticsFlow,
        dispatch
    ]);
    const onReject = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_CHANGES_REJECT_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem?.agent?.name || configItem?.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions?.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
            action: (0, $krYZG.ACTION).DISMISSED,
            interactionID: analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $l2lIz.convertExperienceName)(configItem?.key?.toString() ?? ''),
            isProactive: false,
            attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                init: false
            }),
            invokedFrom: lastTriggeredFrom
        }));
        // api?.core.actions.execute(rejectCommand(editorView?.state));
        // discardStream({ view: editorView, restoreSelection: true });
        (0, $73b45ebf50366f42$export$c4d4122316c86846)(editorView, true);
        dispatch({
            type: 'reset'
        });
        endExperience();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        analyticsFlow,
        dispatch,
        endExperience
    ]);
    const fireResponseFeedbackEvent = (0, $cozmU.useCallback)((sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem?.agent?.name || configItem?.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).SUBMITTED,
                interactionID: analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $l2lIz.convertExperienceName)(configItem?.key?.toString() ?? '', lastTriggeredFrom),
                isProactive: false,
                invokedFrom: lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                }
            })
        });
    }, [
        configItem,
        fireAIAnalyticsEvent,
        analyticsFlow,
        lastTriggeredFrom,
        appearance,
        product
    ]);
    const handleFiringFeedbackEvent = (0, $cozmU.useCallback)(async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        });
        // // we need to update the state machine to reflect the user feedback
        // sendToAIExperienceMachine({
        // 	type: 'feedback submitted',
        // 	sentiment: feedbackMetadata.sentiment as 'good' | 'bad',
        // });
        // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    }, [
        fireResponseFeedbackEvent,
        editorPluginAIProvider,
        analyticsFlow
    ]);
    const getAIExperience = (0, $cozmU.useCallback)(()=>({
            ...aiExperienceMetadata
        }), [
        aiExperienceMetadata
    ]);
    const onBadResponseButtonClick = (0, $cozmU.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'bad',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const onGoodResponseButtonClick = (0, $cozmU.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'good',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const acceptRejectScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    (0, $bb835f24d2d32c51$export$27da6e66e88e9ac7)({
        onDiscard: onEscDiscard,
        ref: acceptRejectScreenRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29c6ac32a7e58a17$export$42a852a2b6b56249), {
        ref: acceptRejectScreenRef,
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44f24bb9575eaa37$export$87eca91cbe06d0c8), {
        onAccept: onAccept,
        onReject: onReject,
        onBadResponseButtonClick: onBadResponseButtonClick,
        onGoodResponseButtonClick: onGoodResponseButtonClick,
        isDisplayingChanges: isDisplayingChanges,
        onToggleChanges: onToggleChanges
    }));
};








// eslint-disable-next-line no-restricted-imports



const $2ce115f17ed17fcd$export$c73af7ca4a2501ab = (0, $kSwu1.defineMessages)({
    dialogAriaLabel: {
        id: "fabric.editor.ai.experience.dialogAriaLabel",
        defaultMessage: "Atlassian Intelligence Dialog"
    },
    responseTooSimilarMessage: {
        id: "fabric.editor.ai.experience.responseTooSimilarMessage",
        defaultMessage: "Atlassian Intelligence has no suggestions at this time. Feel free to try a different prompt or content."
    },
    generatingAiResponse: {
        id: "fabric.editor.ai.experience.generatingAiResponse",
        defaultMessage: "Generating"
    },
    discardMessagePrompt: {
        id: "fabric.editor.ai.experience.discardMessagePrompt",
        defaultMessage: "Do you want to discard your prompt?"
    },
    discardMessageResponse: {
        id: "fabric.editor.ai.experience.discardMessageResponse",
        defaultMessage: "Do you want to discard your response?"
    },
    discardStreamingInDocumennt: {
        id: "fabric.editor.ai.experience.discardStreamingInDocumennt",
        defaultMessage: "Cancel request and discard response?"
    },
    loadingTitle: {
        id: "fabric.editor.ai.experience.loadingTitle",
        defaultMessage: "Generating"
    },
    messageTemplateAnalysingQuery: {
        id: "fabric.editor.ai.experience.messageTemplateAnalysingQuery",
        defaultMessage: "Analyzing: Reviewing your question."
    },
    messageTemplateContentSearch: {
        id: "fabric.editor.ai.experience.messageTemplateContentSearch",
        defaultMessage: "Searching: One moment while we search for information."
    },
    messageTemplatePageHydration: {
        id: "fabric.editor.ai.experience.messageTemplatePageHydration",
        defaultMessage: "Searching: One moment while we search the page."
    },
    messageTemplateNextBestTask: {
        id: "fabric.editor.ai.experience.messageTemplateNextBestTask",
        defaultMessage: "Searching: One moment while we search Jira."
    },
    convoAIBeta: {
        id: "fabric.editor.ai.screens.preview.convoAIBeta",
        defaultMessage: "Content generation requests that reference URLs is in beta."
    },
    useRovoOrganisationKnowledgeRightText: {
        id: "fabric.editor.ai.experience.labelRight.rovo",
        defaultMessage: "Rovo"
    },
    useGeneralAiKnowledgeRightText: {
        id: "fabric.editor.ai.experience.labelRight.atlassianIntelligence",
        defaultMessage: "Atlassian Intelligence"
    },
    actionsGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.actions",
        defaultMessage: "Actions"
    },
    atlassianIntelligenceGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence",
        defaultMessage: "Atlassian intelligence"
    },
    knowledgeSourceGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource",
        defaultMessage: "Knowledge source"
    },
    agentsSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.agents",
        defaultMessage: "Agents"
    },
    rovoAgentsCountSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount",
        defaultMessage: "Rovo agents ({numberOfAgents})"
    },
    useRovoAgentsCountSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount",
        defaultMessage: "Use a Rovo agent ({numberOfAgents})"
    },
    rovoAgentsSuggestionGroupHeading: {
        id: "fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents",
        defaultMessage: "Rovo agents"
    },
    useGeneralAiKnowledgeLabel: {
        id: "fabric.editor.ai.experience.useGeneralAiKnowledgeLabel",
        defaultMessage: "Use general knowledge"
    },
    useRovoOrganisationKnowledgeLabel: {
        id: "fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel",
        defaultMessage: "Use knowledge from your organization"
    },
    agentsFooterRightText: {
        id: "fabric.editor.ai.experience.footerRightText.agents",
        defaultMessage: "Powered by Rovo"
    },
    agentsBrowseMore: {
        id: "fabric.editor.ai.experience.browseMore.agents",
        defaultMessage: "Browse Agents"
    },
    showMoreButton: {
        id: "fabric.editor.ai.experience.showMoreButton",
        defaultMessage: "Show more"
    },
    noResultsSuggestion: {
        id: "fabric.editor.ai.experience.noResultsSuggestion",
        defaultMessage: "No results"
    },
    engagementBannerLinksText: {
        id: "fabric.editor.ai.experience.engagementBannerLinksText",
        defaultMessage: "\uD83D\uDE80 You can now paste links \uD83D\uDD17 to Jira and Confluence content in your prompts."
    }
});





















var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");














var $lMGh1 = parcelRequire("lMGh1");


var $1l0kj = parcelRequire("1l0kj");







var $5iPLS = parcelRequire("5iPLS");










const $16cddc6cb5179592$var$message = (0, $kSwu1.defineMessages)({
    cancelLabel: {
        id: "fabric.editor.ai.screens.discard.cancelLabel",
        defaultMessage: "Back"
    },
    discardLabel: {
        id: "fabric.editor.ai.screens.discard.discardLabel",
        defaultMessage: "Discard"
    },
    warningIconLabel: {
        id: "fabric.editor.ai.screens.discard.warningIconLabel",
        defaultMessage: "Warning"
    },
    yesLabel: {
        id: "fabric.editor.ai.screens.discard.yesLabel",
        defaultMessage: "Yes"
    },
    noLabel: {
        id: "fabric.editor.ai.screens.discard.noLabel",
        defaultMessage: "No"
    }
});
var $16cddc6cb5179592$export$2e2bcd8739ae039 = $16cddc6cb5179592$var$message;


const $13bb6e412023db64$var$buttonContainerStyles = null;
const $13bb6e412023db64$var$contentContainerStyles = null;
const $13bb6e412023db64$var$contentContainerStylesSmall = null;
const $13bb6e412023db64$var$contentIconStyles = null;
const $13bb6e412023db64$var$contentInStreamingIconStyles = null;
const $13bb6e412023db64$var$contentInStreamingIconStylesSmall = null;
const $13bb6e412023db64$var$discardFloatingContainerStyle = null;
const $13bb6e412023db64$var$discardFloatingContainerStyleFitContent = null;
const $13bb6e412023db64$var$smallDiscardFloatingContainerStyle = null;
const $13bb6e412023db64$var$styles = {
    buttonContainer: "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT _2mpnYb1Y8M _0RIC7SUofl _2perVWmpvA _2dvbuWDIqT"
};
const $13bb6e412023db64$var$DiscardButtonsContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, isAIFC: isAIFC } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isAIFC) {
        t1 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            xcss: $13bb6e412023db64$var$styles.buttonContainer,
            children: children
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT"
            ]),
            children: children
        });
        $[0] = children;
        $[1] = isAIFC;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, isAIFC: isAIFC })=>isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
        xcss: $13bb6e412023db64$var$styles.buttonContainer,
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT"
        ]),
        children: children
    });
const $13bb6e412023db64$export$453c0e2ebf820c66 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { onCancel: onCancel, onDiscard: onDiscard, text: text, appearance: appearance, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [containerElement, setContainerElement] = (0, $cozmU.useState)(null);
    const [setBreakpointsElement, t1] = (0, $9lgy7.useElementBreakpoints)();
    const { breakpoint: breakpoint } = t1;
    let t2;
    if ($[0] !== setBreakpointsElement) {
        t2 = (element)=>{
            setContainerElement(element);
            setBreakpointsElement(element);
        };
        $[0] = setBreakpointsElement;
        $[1] = t2;
    } else t2 = $[1];
    const setRootContainer = t2;
    let t3;
    let t4;
    if ($[2] !== containerElement) {
        t3 = ()=>{
            if (containerElement) containerElement.scrollIntoView({
                block: "nearest"
            });
        };
        t4 = [
            containerElement
        ];
        $[2] = containerElement;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const t5 = breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2mHwu85zaO _0aFT5vbt8w";
    const t6 = isAIFC && appearance !== "chromeless" && "_2p6ht9DIqT _39xV02E6Kk";
    let t7;
    if ($[5] !== t5 || $[6] !== t6) {
        t7 = (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _1ghwDKVa5s",
            t5,
            t6,
            `discard-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]);
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== appearance || $[9] !== isAIFC) {
        t8 = isAIFC ? appearance === "chromeless" ? {
            right: 0,
            left: 0
        } : {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        };
        $[8] = appearance;
        $[9] = isAIFC;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: t9
        });
        $[13] = t9;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = breakpoint <= (0, $9lgy7.Breakpoint).Small && !isAIFC && "_0hPCNLchRC";
    let t12;
    if ($[15] !== t11) {
        t12 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT",
            t11
        ]);
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    const t13 = isAIFC && "_2Zuz6Q1Y8M _1Znuxb1Y8M _1wydGW1Y8M _0Of8r21Y8M";
    const t14 = breakpoint <= (0, $9lgy7.Breakpoint).Small && !isAIFC && "_2IhTonLl21";
    let t15;
    if ($[17] !== t13 || $[18] !== t14) {
        t15 = (0, $hekY6.default)([
            "_0adFHsFQfX _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _3YEZNOdnbC",
            t13,
            t14
        ]);
        $[17] = t13;
        $[18] = t14;
        $[19] = t15;
    } else t15 = $[19];
    let t16;
    if ($[20] !== formatMessage || $[21] !== isAIFC) {
        t16 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel),
            color: "var(--ds-icon-warning, #E06C00)"
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel),
            color: "var(--ds-icon-warning, #E06C00)"
        });
        $[20] = formatMessage;
        $[21] = isAIFC;
        $[22] = t16;
    } else t16 = $[22];
    let t17;
    if ($[23] !== t15 || $[24] !== t16) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t15,
            children: t16
        });
        $[23] = t15;
        $[24] = t16;
        $[25] = t17;
    } else t17 = $[25];
    let t18;
    if ($[26] !== text) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            as: "p",
            children: text
        });
        $[26] = text;
        $[27] = t18;
    } else t18 = $[27];
    let t19;
    if ($[28] !== t12 || $[29] !== t17 || $[30] !== t18) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t12,
            children: [
                t17,
                t18
            ]
        });
        $[28] = t12;
        $[29] = t17;
        $[30] = t18;
        $[31] = t19;
    } else t19 = $[31];
    const t20 = isAIFC ? (0, $16cddc6cb5179592$export$2e2bcd8739ae039).noLabel : (0, $16cddc6cb5179592$export$2e2bcd8739ae039).cancelLabel;
    let t21;
    if ($[32] !== formatMessage || $[33] !== t20) {
        t21 = formatMessage(t20);
        $[32] = formatMessage;
        $[33] = t20;
        $[34] = t21;
    } else t21 = $[34];
    let t22;
    if ($[35] !== onCancel || $[36] !== t21) {
        t22 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            testId: "cancel-button",
            spacing: "compact",
            onClick: onCancel,
            type: "button",
            appearance: "subtle",
            children: t21
        });
        $[35] = onCancel;
        $[36] = t21;
        $[37] = t22;
    } else t22 = $[37];
    const t23 = isAIFC ? (0, $16cddc6cb5179592$export$2e2bcd8739ae039).yesLabel : (0, $16cddc6cb5179592$export$2e2bcd8739ae039).discardLabel;
    let t24;
    if ($[38] !== formatMessage || $[39] !== t23) {
        t24 = formatMessage(t23);
        $[38] = formatMessage;
        $[39] = t23;
        $[40] = t24;
    } else t24 = $[40];
    let t25;
    if ($[41] !== onDiscard || $[42] !== t24) {
        t25 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            autoFocus: true,
            testId: "discard-button",
            spacing: "compact",
            onClick: onDiscard,
            type: "button",
            appearance: "warning",
            children: t24
        });
        $[41] = onDiscard;
        $[42] = t24;
        $[43] = t25;
    } else t25 = $[43];
    let t26;
    if ($[44] !== isAIFC || $[45] !== t22 || $[46] !== t25) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsxs)($13bb6e412023db64$var$DiscardButtonsContainer, {
            isAIFC: isAIFC,
            children: [
                t22,
                t25
            ]
        });
        $[44] = isAIFC;
        $[45] = t22;
        $[46] = t25;
        $[47] = t26;
    } else t26 = $[47];
    let t27;
    if ($[48] !== appearance || $[49] !== isAIFC || $[50] !== setRootContainer || $[51] !== t10 || $[52] !== t19 || $[53] !== t26 || $[54] !== t7 || $[55] !== t8) {
        t27 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer), {
            ref: setRootContainer,
            "data-testid": "discard-screen",
            className: t7,
            paddingAdjustments: t8,
            rainbowBorder: false,
            appearance: appearance,
            isAIFC: isAIFC,
            children: [
                t10,
                t19,
                t26
            ]
        });
        $[48] = appearance;
        $[49] = isAIFC;
        $[50] = setRootContainer;
        $[51] = t10;
        $[52] = t19;
        $[53] = t26;
        $[54] = t7;
        $[55] = t8;
        $[56] = t27;
    } else t27 = $[56];
    return t27;
} : ({ onCancel: onCancel, onDiscard: onDiscard, text: text, appearance: appearance, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [containerElement, setContainerElement] = (0, $cozmU.useState)(null);
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)();
    const setRootContainer = (element)=>{
        setContainerElement(element);
        setBreakpointsElement(element);
    }; // Scroll the discard screen into view if it's not fully visible
    (0, $cozmU.useEffect)(()=>{
        if (containerElement) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        containerElement.scrollIntoView({
            block: 'nearest'
        });
    }, [
        containerElement
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "discard-screen",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _1ghwDKVa5s",
            breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2mHwu85zaO _0aFT5vbt8w",
            isAIFC && appearance !== 'chromeless' && "_2p6ht9DIqT _39xV02E6Kk",
            `discard-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]),
        paddingAdjustments: isAIFC ? appearance === 'chromeless' ? {
            right: 0,
            left: 0
        } : {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        },
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                children: formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                className: (0, $hekY6.default)([
                    "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT",
                    breakpoint <= (0, $9lgy7.Breakpoint).Small && !isAIFC && "_0hPCNLchRC"
                ]),
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        className: (0, $hekY6.default)([
                            "_0adFHsFQfX _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _3YEZNOdnbC",
                            isAIFC && "_2Zuz6Q1Y8M _1Znuxb1Y8M _1wydGW1Y8M _0Of8r21Y8M",
                            breakpoint <= (0, $9lgy7.Breakpoint).Small && !isAIFC && "_2IhTonLl21"
                        ]),
                        children: isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                            label: formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel),
                            color: "var(--ds-icon-warning, #E06C00)"
                        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                            label: formatMessage((0, $16cddc6cb5179592$export$2e2bcd8739ae039).warningIconLabel),
                            color: "var(--ds-icon-warning, #E06C00)"
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        as: "p",
                        children: text
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)($13bb6e412023db64$var$DiscardButtonsContainer, {
                isAIFC: isAIFC,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        testId: "cancel-button",
                        spacing: "compact",
                        onClick: onCancel,
                        type: "button",
                        appearance: "subtle",
                        children: formatMessage(isAIFC ? (0, $16cddc6cb5179592$export$2e2bcd8739ae039).noLabel : (0, $16cddc6cb5179592$export$2e2bcd8739ae039).cancelLabel)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        autoFocus: true,
                        testId: "discard-button",
                        spacing: "compact",
                        onClick: onDiscard,
                        type: "button",
                        appearance: "warning",
                        children: formatMessage(isAIFC ? (0, $16cddc6cb5179592$export$2e2bcd8739ae039).yesLabel : (0, $16cddc6cb5179592$export$2e2bcd8739ae039).discardLabel)
                    })
                ]
            })
        ]
    });
};






var $5Tn11 = parcelRequire("5Tn11");


var $2zvMw = parcelRequire("2zvMw");


var $6yHkF = parcelRequire("6yHkF");


var $eDWhq = parcelRequire("eDWhq");

const $3637dbfe014bcd34$export$5ddafe3fa55c1ac5 = ()=>{
    const { send: send } = (0, $eDWhq.useRovoContentBridgeAPI)((0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID));
    return {
        abort: ()=>{
            send((0, $6yHkF.InlineInputBoxAbortMessageCommand), {
                receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            });
        }
    };
};

























const $54d2fdcae373a96d$export$b2fa8d4ed6681737 = 32;
function $54d2fdcae373a96d$export$f9c4337e36118c2b(editorDom, scrollContainer) {
    let offset = 0;
    let el = editorDom;
    while(el && el !== scrollContainer){
        if (el instanceof HTMLElement) {
            offset += el.offsetTop;
            el = el.offsetParent;
        } else break;
    }
    return offset;
}
function $54d2fdcae373a96d$export$a5c3a06fac6a7944({ view: view, pos: pos, scrollParent: scrollParent }) {
    const startCoords = view.coordsAtPos(pos);
    const offsetTop = view.coordsAtPos(0).top;
    const offsetTopFromScrollContainer = $54d2fdcae373a96d$export$f9c4337e36118c2b(view.dom, scrollParent);
    return offsetTopFromScrollContainer + startCoords.top - offsetTop - $54d2fdcae373a96d$export$b2fa8d4ed6681737;
}
function $54d2fdcae373a96d$export$201b801367d25dcc({ view: view, pos: pos, scrollParent: scrollParent, modalHeight: modalHeight }) {
    const offsetTop = view.coordsAtPos(0).top;
    const offsetTopFromScrollContainer = $54d2fdcae373a96d$export$f9c4337e36118c2b(view.dom, scrollParent);
    // Handle edge case where coords could be 0 at the last position of doc
    let targetBottom = view.coordsAtPos(pos).bottom;
    if (targetBottom === 0 && pos > 0) targetBottom = view.coordsAtPos(pos - 1).bottom;
    return offsetTopFromScrollContainer + targetBottom - offsetTop + modalHeight + $54d2fdcae373a96d$export$b2fa8d4ed6681737 - scrollParent.offsetHeight;
}
function $54d2fdcae373a96d$export$d393f31eaed8f940({ view: view, startPos: startPos, endPos: endPos, modalHeight: modalHeight }) {
    const scrollParent = (0, $1jz5K.findOverflowScrollParent)(view.dom);
    if (!scrollParent) return;
    // Wrapped in try/catch because positions can be transiently invalid during
    // document mutations / remaps.
    try {
        const size = view.state.doc.content.size;
        const clampedStart = Math.min(Math.max(startPos, 0), size);
        const clampedEnd = Math.min(Math.max(endPos, 0), size);
        // Below the viewport → scroll down so the END sits near the bottom, leaving
        // room for the modal anchored beneath it.
        const bottomScrollTop = $54d2fdcae373a96d$export$201b801367d25dcc({
            view: view,
            pos: clampedEnd,
            scrollParent: scrollParent,
            modalHeight: modalHeight
        });
        if (scrollParent.scrollTop < bottomScrollTop) {
            scrollParent.scroll({
                top: bottomScrollTop,
                behavior: 'instant'
            });
            return;
        }
        // Above the viewport → scroll up so the START sits near the top.
        const topScrollTop = $54d2fdcae373a96d$export$a5c3a06fac6a7944({
            view: view,
            pos: clampedStart,
            scrollParent: scrollParent
        });
        if (scrollParent.scrollTop > topScrollTop) scrollParent.scroll({
            top: topScrollTop,
            behavior: 'instant'
        });
    } catch  {
    // Silently ignore — positions may be invalid during rapid document mutations.
    }
}


const $5191c8b740b4c050$export$d605968e18f8ea5 = ({ api: api, view: view, modalRef: modalRef })=>{
    const scrollParentRef = (0, $cozmU.useRef)(null);
    const isProgrammaticScrollRef = (0, $cozmU.useRef)(false);
    const { streamStartPos: streamStartPos, scrollTargetPos: scrollTargetPos, isStreaming: isStreaming, hasUserScrolled: hasUserScrolled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            hasUserScrolled: state.aiExperienceState?.aiSessionPluginState?.hasUserScrolled,
            streamStartPos: state.aiExperienceState?.streamingState?.streamStartPos,
            scrollTargetPos: state.aiExperienceState?.streamingState?.scrollTargetPos,
            isStreaming: state.aiExperienceState?.isStreaming ?? false
        }));
    (0, $cozmU.useEffect)(()=>{
        if (!view || !isStreaming || hasUserScrolled) return;
        // Find and cache the scroll container
        const scrollParent = (0, $1jz5K.findOverflowScrollParent)(view.dom);
        if (scrollParent) scrollParentRef.current = scrollParent;
        // Only attach scroll listener during active streaming
        if (!scrollParent) return;
        /**
		 * Detects user scrolls by checking if the scroll was programmatic.
		 * - If isProgrammaticScrollRef is true: This scroll was triggered by our code → ignore it
		 * - If isProgrammaticScrollRef is false: This is a user scroll → disable auto-scroll
		 * - Always reset the flag after processing so the next scroll is treated as a user scroll
		 */ const unbind = (0, $cbY7C.bind)(scrollParent, {
            type: 'scroll',
            listener: handleScroll,
            options: {
                passive: true
            }
        });
        function handleScroll() {
            if (!isProgrammaticScrollRef.current) {
                api?.core?.actions.execute((0, $7791c10173ad9c87$export$85376b7ae78edde1)());
                // Early exit once user scroll has been registered.
                unbind();
            }
            isProgrammaticScrollRef.current = false;
        }
        return unbind;
    }, [
        view,
        isStreaming,
        hasUserScrolled,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        const scrollParent = scrollParentRef.current;
        // Bail out early if conditions aren't met for auto-scroll
        if (hasUserScrolled || !scrollParent || !view || streamStartPos === undefined) return;
        // Attempt to perform auto-scroll
        // Wrapped in try-catch because positions may be temporarily invalid during document changes
        try {
            isProgrammaticScrollRef.current = true;
            const modalHeight = modalRef?.current?.offsetHeight || 0;
            // Mark this as a programmatic scroll so the scroll listener doesn't treat it as a user scroll
            // Case 1: Only start position is available → ensure start is visible at top
            if (scrollTargetPos === undefined) {
                const topScrollTop = (0, $54d2fdcae373a96d$export$a5c3a06fac6a7944)({
                    view: view,
                    pos: streamStartPos,
                    scrollParent: scrollParent
                });
                // Only scroll up if needed (don't scroll down, user might be reading above)
                if (scrollParent.scrollTop > topScrollTop) scrollParent.scroll({
                    top: topScrollTop,
                    behavior: 'instant'
                });
                return;
            }
            // Case 2: Both start and target positions available → keep target visible at bottom
            const bottomScrollTop = (0, $54d2fdcae373a96d$export$201b801367d25dcc)({
                view: view,
                pos: scrollTargetPos,
                scrollParent: scrollParent,
                modalHeight: modalHeight
            });
            // Only scroll down if needed (target is below viewport)
            if (scrollParent.scrollTop < bottomScrollTop) scrollParent.scroll({
                top: bottomScrollTop,
                behavior: 'instant'
            });
        } catch  {
        // Silently ignore errors - positions may be invalid during rapid document mutations
        }
    }, [
        streamStartPos,
        scrollTargetPos,
        isStreaming,
        view,
        modalRef,
        hasUserScrolled
    ]);
};



function $cf30fcf8334a283a$export$31f5c3fa05bebb33({ api: api, appearance: appearance, dispatch: dispatch }) {
    const { abort: abort } = (0, $3637dbfe014bcd34$export$5ddafe3fa55c1ac5)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, editorView: editorView } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const aiDecorationExperiencePluginState = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api?.core?.actions.execute((0, $7791c10173ad9c87$export$8e01b36b460d89b0)());
    }, [
        api
    ]);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api?.core?.actions.execute((0, $7791c10173ad9c87$export$9c4a3e8153b61b0e)());
        else api?.aiExperience.actions.getAiExperienceActor()?.send({
            type: 'disable discard'
        });
        dispatch({
            type: 'cancel'
        });
    }, [
        api,
        dispatch
    ]);
    const onDiscard = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'terminate'
        });
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
            const context = api?.aiExperience.actions.getAiExperienceActor().getSnapshot().context;
            const traceIds = aiDecorationExperiencePluginState?.traceId ? [
                aiDecorationExperiencePluginState.traceId
            ] : context?.traceIds;
            /**
       * Introduced in EDF-1443 to track discard event confirmations
       * separately to normal discard events
       */ fireAIAnalyticsEvent({
                // Simplified context from streamingApi to avoid issues
                // To follow-up
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).DISMISSED,
                    interactionID: context?.channelId,
                    experienceName: (0, $l2lIz.convertExperienceName)(context?.configItem.key.toString() ?? ''),
                    isProactive: false,
                    invokedFrom: 'streamingApi',
                    traceIds: traceIds,
                    promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? aiDecorationExperiencePluginState?.promptVersion : undefined
                })
            });
        }
        // Abort any ongoing Rovo requests - this will end the session
        abort();
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
            // Cancel any ongoing non-orchestrator streaming and clear the AI session context
            // This must be done before endAIExperience so the streaming plugin can detect
            // the session was cleared while streaming was in progress
            api?.core?.actions.execute((0, $7791c10173ad9c87$export$11550f22cf2d0c6c)());
            // Then reset the session state
            api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
            // Restore original document content before endAIExperience (which clears streaming state)
            if (editorView) (0, $73b45ebf50366f42$export$c4d4122316c86846)(editorView, true);
        }
        api?.aiExperience.actions.endAIExperience();
    }, [
        api,
        dispatch,
        abort,
        fireAIAnalyticsEvent,
        aiDecorationExperiencePluginState?.traceId,
        aiDecorationExperiencePluginState?.promptVersion,
        editorView
    ]);
    const discardScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    (0, $bb835f24d2d32c51$export$27da6e66e88e9ac7)({
        onDiscard: onCancel,
        ref: discardScreenRef
    });
    (0, $5191c8b740b4c050$export$d605968e18f8ea5)({
        api: api,
        view: editorView,
        modalRef: discardScreenRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29c6ac32a7e58a17$export$42a852a2b6b56249), {
        appearance: appearance,
        ref: discardScreenRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13bb6e412023db64$export$453c0e2ebf820c66), {
        onCancel: onCancel,
        onDiscard: onDiscard,
        text: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardStreamingInDocumennt),
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    }));
}









var $pxBW8 = parcelRequire("pxBW8");



function $d03c04859613e0c5$export$d5b86f1573c0ea10({ api: api, appearance: appearance, dispatch: dispatch }) {
    const errorScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { errorInfo: errorInfo, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, nextSessionId: nextSessionId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        return {
            errorInfo: aiExperienceState?.aiSessionPluginState?.errorInfo || {},
            isInDocumentStreamingEnabled: aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled,
            nextSessionId: aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId
        };
    });
    const onCancel = (0, $cozmU.useCallback)(()=>{
        api?.aiExperience.actions.endSession(nextSessionId || '', {
            type: 'error'
        });
        api?.aiExperience.actions.endAIExperience();
        dispatch({
            type: 'terminate'
        });
    }, [
        api,
        dispatch,
        nextSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29c6ac32a7e58a17$export$42a852a2b6b56249), {
        ref: errorScreenRef,
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pxBW8.ErrorScreen), {
        text: (0, $1777869db0801c54$export$915e9e7bd4f0f96d)(errorInfo),
        onCancel: onCancel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onRetry: ()=>{},
        showRetryButton: false,
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    }));
}






















var $bGNkz = parcelRequire("bGNkz");


var $4x5dF = parcelRequire("4x5dF");
















function $a60c6740285f91ed$export$6ad5d8e31817f39c({ api: api, providerFactory: providerFactory, appearance: appearance, dispatch: dispatch }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mounted: isRovoMounted, streaming: isRovoStreaming } = (0, $bGNkz.useUIStore)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, endExperience: endExperience, canInlineStreamChanges: canInlineStreamChanges, editorView: editorView } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const hideLoadingScreen = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>state.aiExperienceState?.aiDecorationExperiencePluginState.hideLoadingScreen);
    const nextSessionId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>state.aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    // Per-experience override for the loading UI. Confluence's Create with Rovo
    // e.g., blank object experience sets configItem.loadingExperience = 'rovo-thinking-bar'
    // so this loading screen renders the unified RovoThinkingBar.
    const loadingExperience = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>state.aiExperienceState?.aiDecorationExperiencePluginState.configItem?.loadingExperience);
    // Non-null while an existing remix node (e.g. a MAUI app) is being updated.
    // In that background mode the editor stays live, so suppress the click-away
    // discard — a click in the editor must not revert the update. Escape and the
    // Stop button still cancel.
    const inlineRovoStreamingTargetId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>state.aiExperienceState?.aiDecorationExperiencePluginState.inlineRovoStreamingTargetId);
    const loadingScreenRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const isDiscardingRef = (0, $cozmU.useRef)(false);
    const schema = (0, $cozmU.useMemo)(()=>api?.core.sharedState.currentState()?.schema, [
        api
    ]);
    const { abort: abort } = (0, $3637dbfe014bcd34$export$5ddafe3fa55c1ac5)();
    /**
   * [platform_editor_remove_pause_streaming] Stop streaming immediately without
   * asking the discard confirmation question. Leaves any partially streamed
   * content in the page and opens the Post Stream Review toolbar so the user
   * can review, undo, or keep the partial changes.
   */ const onStop = (0, $cozmU.useCallback)(()=>{
        // Log exposure when users click 'cancel' instead of during streaming
        (0, $ieeJu.expValEquals)('platform_editor_remove_pause_streaming', 'isEnabled', true);
        isDiscardingRef.current = true;
        // Commit partial content and reset streaming plugin state
        // (re-enables the editor). If no adfResponse has been received yet,
        // commitPartialStreamAndCleanup is a no-op.
        if (api) {
            // Capture session ID BEFORE commitPartialStreamAndCleanup — it dispatches
            // COMPLETE which triggers handleFinalize → END_SESSION, clearing nextSessionId.
            const activeSessionId = api.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState?.nextSessionId ?? nextSessionId;
            (0, $d07adef0b9b690ae$export$203e4f5cbd70f715)({
                api: api,
                editorView: editorView
            });
            // Always call endSession even if session id is missing/stale so the
            // action-layer abort fallback (and PSR open flow) can still run.
            api.aiExperience.actions.endSession(activeSessionId ?? '', {
                type: 'abort'
            });
        }
        // Abort Rovo orchestrator requests.
        abort();
    }, [
        api,
        abort,
        editorView,
        nextSessionId
    ]);
    const onDiscard = (0, $cozmU.useCallback)(()=>{
        // Log exposure when users click 'cancel' instead of during streaming
        (0, $ieeJu.expValEquals)('platform_editor_remove_pause_streaming', 'isEnabled', true);
        isDiscardingRef.current = true;
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api?.aiExperience.actions.getAiExperienceActor()?.send({
            type: 'enable discard'
        });
        dispatch({
            type: 'discard'
        });
    }, [
        api,
        dispatch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return;
        // turn off diff when loading screen is shown on first render
        if (api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        // clear selection decorations on first render
        (0, $4TgUg.clearSelectionDecorations)(editorView.state)(editorView.state, editorView.dispatch);
        return ()=>{
            if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return;
            // Only transition to accept/reject when the stream completed naturally,
            // not when unmounting because the user navigated to the discard screen.
            if (isDiscardingRef.current) return;
            // [CCI-15904] Skip teardown when transitioning to PostStreamReview —
            // `endExperience()` would wipe the decoration the modal just installed.
            // Proper fix tracked in CCI-16978.
            const sessionContextStatus = editorView.state ? (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state)?.status : undefined;
            if (sessionContextStatus === 'postStreamReview') return;
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state);
            if (canInlineStreamChanges() || !decorationPluginState?.withAcceptReject || decorationPluginState?.configItem?.streamsMarkdown) {
                endExperience();
                dispatch({
                    type: 'reset'
                });
            } else dispatch({
                type: 'show-accept-reject'
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        api,
        canInlineStreamChanges,
        dispatch,
        endExperience
    ]);
    (0, $bb835f24d2d32c51$export$27da6e66e88e9ac7)({
        onDiscard: (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) ? onStop : onDiscard,
        ref: loadingScreenRef,
        disableClickOutside: !!inlineRovoStreamingTargetId && (0, $iDrrr.fg)('platform_editor_ai_remix_background_update')
    });
    (0, $5191c8b740b4c050$export$d605968e18f8ea5)({
        api: api,
        view: editorView,
        modalRef: loadingScreenRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29c6ac32a7e58a17$export$42a852a2b6b56249), {
        ref: loadingScreenRef,
        appearance: appearance
    }, schema && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4x5dF.MemoLoadingScreen), {
        onCancel: (0, $anBbz.expValEqualsNoExposure)('platform_editor_remove_pause_streaming', 'isEnabled', true) ? onStop : onDiscard,
        preview: undefined,
        title: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).loadingTitle),
        providerFactory: providerFactory,
        schema: schema,
        isStreaming: true,
        canInlineStreamChanges: true,
        hideLoadingScreen: isRovoMounted && isRovoStreaming || hideLoadingScreen,
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled,
        loadingExperience: loadingExperience
    }));
}



























var $chu6R = parcelRequire("chu6R");


















const $f3f808a46206eb1d$var$message = (0, $kSwu1.defineMessages)({
    noImprovementMessage: {
        id: "fabric.editor.ai.screens.noImprovement.noImprovementMessage",
        defaultMessage: "No improvements, nice work."
    },
    successIconLabel: {
        id: "fabric.editor.ai.screens.noImprovement.successIconLabel",
        defaultMessage: "Success"
    }
});
var $f3f808a46206eb1d$export$2e2bcd8739ae039 = $f3f808a46206eb1d$var$message;


const $188dcfdb17133909$var$noImprovementFloatingContainerStyle = null;
const $188dcfdb17133909$var$fadeOutStyle = null;
const $188dcfdb17133909$var$noImprovementStyles = {
    container: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _1Znuxb1Y8M _2Zuz6Q1Y8M",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT _0Of8r2gVvo _1Znuxb1Y8M _1wydGWgVvo _2Zuz6Q1Y8M"
};
const $188dcfdb17133909$export$fbc3425fa4d2d058 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { isHidden: isHidden, onceFade: onceFade, appearance: appearance } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [containerElement, setContainerElement] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (element)=>{
            setContainerElement(element);
        };
        $[0] = t1;
    } else t1 = $[0];
    const setRootContainer = t1;
    let t2;
    let t3;
    if ($[1] !== containerElement) {
        t2 = ()=>{
            if (containerElement) containerElement.scrollIntoView({
                block: "nearest"
            });
        };
        t3 = [
            containerElement
        ];
        $[1] = containerElement;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[4] !== containerElement || $[5] !== isHidden || $[6] !== onceFade) {
        t4 = ()=>{
            if (isHidden && onceFade && containerElement) {
                const handleTransitionEnd = (event)=>{
                    if (event.propertyName === "opacity") onceFade();
                };
                const unbind = (0, $cbY7C.bind)(containerElement, {
                    type: "transitionend",
                    listener: handleTransitionEnd
                });
                return unbind;
            }
        };
        t5 = [
            isHidden,
            onceFade,
            containerElement
        ];
        $[4] = containerElement;
        $[5] = isHidden;
        $[6] = onceFade;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = isHidden && "_1YKVNsdnbC";
    let t7;
    if ($[9] !== t6) {
        t7 = (0, $hekY6.default)([
            "_23rrnHQJf1 _1ghwDKVa5s _2p6ht9DIqT _39xV02E6Kk",
            t6,
            (0, $5iPLS.AI_MODAL_SCREEN_CLASS)
        ]);
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== formatMessage) {
        t8 = formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).successIconLabel);
        $[11] = formatMessage;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: t8
        });
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== formatMessage) {
        t10 = formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).successIconLabel);
        $[15] = formatMessage;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== t10) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                label: t10,
                color: "var(--ds-icon-success, #6A9A23)"
            })
        });
        $[17] = t10;
        $[18] = t11;
    } else t11 = $[18];
    let t12;
    if ($[19] !== formatMessage) {
        t12 = formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).noImprovementMessage);
        $[19] = formatMessage;
        $[20] = t12;
    } else t12 = $[20];
    let t13;
    if ($[21] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            children: t12
        });
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t11 || $[24] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            xcss: $188dcfdb17133909$var$noImprovementStyles.content,
            children: [
                t11,
                t13
            ]
        });
        $[23] = t11;
        $[24] = t13;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t14 || $[27] !== t9) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            xcss: $188dcfdb17133909$var$noImprovementStyles.container,
            children: [
                t9,
                t14
            ]
        });
        $[26] = t14;
        $[27] = t9;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== appearance || $[30] !== t15 || $[31] !== t7) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
            ref: setRootContainer,
            "data-testid": "no-improvement-screen",
            className: t7,
            rainbowBorder: false,
            appearance: appearance,
            isAIFC: true,
            children: t15
        });
        $[29] = appearance;
        $[30] = t15;
        $[31] = t7;
        $[32] = t16;
    } else t16 = $[32];
    return t16;
} : ({ isHidden: isHidden, onceFade: onceFade, appearance: appearance })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [containerElement, setContainerElement] = (0, $cozmU.useState)(null);
    const setRootContainer = (element)=>{
        setContainerElement(element);
    }; // Scroll the no improvement screen into view if it's not fully visible
    (0, $cozmU.useEffect)(()=>{
        if (containerElement) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        containerElement.scrollIntoView({
            block: 'nearest'
        });
    }, [
        containerElement
    ]); // Handle fade animation completion
    (0, $cozmU.useEffect)(()=>{
        if (isHidden && onceFade && containerElement) {
            const handleTransitionEnd = (event)=>{
                if (event.propertyName === 'opacity') onceFade();
            };
            const unbind = (0, $cbY7C.bind)(containerElement, {
                type: 'transitionend',
                listener: handleTransitionEnd
            });
            return unbind;
        }
    }, [
        isHidden,
        onceFade,
        containerElement
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "no-improvement-screen",
        className: (0, $hekY6.default)([
            "_23rrnHQJf1 _1ghwDKVa5s _2p6ht9DIqT _39xV02E6Kk",
            isHidden && "_1YKVNsdnbC",
            (0, $5iPLS.AI_MODAL_SCREEN_CLASS)
        ]),
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            xcss: $188dcfdb17133909$var$noImprovementStyles.container,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).successIconLabel)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    xcss: $188dcfdb17133909$var$noImprovementStyles.content,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                                label: formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).successIconLabel),
                                color: "var(--ds-icon-success, #6A9A23)"
                            })
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                            children: formatMessage((0, $f3f808a46206eb1d$export$2e2bcd8739ae039).noImprovementMessage)
                        })
                    ]
                })
            ]
        })
    });
};





function $3009216cdf66bfd7$export$823eaf723be5a1b8({ api: api, appearance: appearance, dispatch: dispatch }) {
    const [isHidden, setIsHidden] = (0, $cozmU.useState)(false);
    const { endExperience: endExperience } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const onceFade = (0, $cozmU.useCallback)(()=>{
        api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
        endExperience();
        dispatch({
            type: 'terminate'
        });
    }, [
        api,
        endExperience,
        dispatch
    ]);
    (0, $cozmU.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setIsHidden(true);
        }, 1000);
        return ()=>clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29c6ac32a7e58a17$export$42a852a2b6b56249), {
        appearance: appearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $188dcfdb17133909$export$fbc3425fa4d2d058), {
        isHidden: isHidden,
        onceFade: onceFade,
        appearance: appearance
    }));
}


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $jw4KW = parcelRequire("jw4KW");













var $cLPXx = parcelRequire("cLPXx");

/**
 * Name of the Statsig dynamic config that consolidates the standalone Review
 * Moment (Post Stream Review) feature flags into a single config. The config
 * holds a string list under its `value` key; a feature is enabled when its
 * token is present in that list. This replaces:
 *   - `platform_editor_review_moment_show_diff_by_default` (feature gate)
 *     → token `'show-diff-by-default'`
 *   - `platform_editor_review_moment_step_through` (experiment)
 *     → token `'step-through'`
 *
 * It also gates the "Accepted" confirmation pills (CCI-19074):
 *   - token `'show-accepted-pill'` → show `AcceptedToast` + `MiniAcceptedToast`
 *
 * Semantics: an absent token (or unset / not-ready config) means the feature is
 * OFF — matching the previous default-off behaviour of both flags. Rollout is
 * an opt-in via the config's `value` list.
 */ const $77d78733cc4ebcfe$var$REVIEW_MOMENT_CONFIG = 'platform_editor_review_moment_config';
const $77d78733cc4ebcfe$export$d20e74f2fe816c36 = {
    showDiffByDefault: 'show-diff-by-default',
    stepThrough: 'step-through',
    showAcceptedPill: 'show-accepted-pill'
};
function $77d78733cc4ebcfe$export$fed1cea426ab8b29() {
    return (0, $cLPXx.dynamicConfigStringListIncludes)($77d78733cc4ebcfe$var$REVIEW_MOMENT_CONFIG, $77d78733cc4ebcfe$export$d20e74f2fe816c36.showDiffByDefault);
}
function $77d78733cc4ebcfe$export$2ae1a40df3c2a2f9() {
    return (0, $cLPXx.dynamicConfigStringListIncludes)($77d78733cc4ebcfe$var$REVIEW_MOMENT_CONFIG, $77d78733cc4ebcfe$export$d20e74f2fe816c36.stepThrough);
}
function $77d78733cc4ebcfe$export$f9e5880031543548() {
    return (0, $cLPXx.dynamicConfigStringListIncludes)($77d78733cc4ebcfe$var$REVIEW_MOMENT_CONFIG, $77d78733cc4ebcfe$export$d20e74f2fe816c36.showAcceptedPill);
}







/* eslint-disable @repo/internal/react/no-class-components */ /* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */ 



































var $9aYkv = parcelRequire("9aYkv");





var $7Y8M5 = parcelRequire("7Y8M5");











var $avQAT = parcelRequire("avQAT");


var $lM3rj = parcelRequire("lM3rj");

// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $c706689b83036a7e$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $c706689b83036a7e$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $c706689b83036a7e$var$akAiModalRegionZIndex = Math.min($c706689b83036a7e$var$MAX_Z_INDEX, Math.max($c706689b83036a7e$var$MIN_Z_INDEX, (0, $7Y8M5.akEditorFloatingPanelZIndex) + 2));
const $c706689b83036a7e$var$errorScreenCSS = null;
const $c706689b83036a7e$var$errorScreenFixedCSS = null;
const $c706689b83036a7e$var$errorScreenCSSUnbounded = null;
const $c706689b83036a7e$export$40729e8ab35829ea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { onCancel: onCancel, text: text, inContentComponent: inContentComponent, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, t1] = (0, $9lgy7.useElementBreakpoints)();
    const { breakpoint: breakpoint } = t1;
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    let t2;
    if ($[0] !== inContentComponent || $[1] !== isAIFC || $[2] !== width) {
        t2 = (node)=>{
            if (inContentComponent && !width && node && node.parentNode instanceof HTMLElement && isAIFC) setWidth(node.parentNode.clientWidth);
        };
        $[0] = inContentComponent;
        $[1] = isAIFC;
        $[2] = width;
        $[3] = t2;
    } else t2 = $[3];
    const onDivRef = t2;
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage((0, $lM3rj.default).ariaErrorTitle);
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: t3
        });
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== breakpoint || $[9] !== isAIFC || $[10] !== text) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorMessage), {
            breakpoint: breakpoint,
            isAIFC: isAIFC,
            children: text
        });
        $[8] = breakpoint;
        $[9] = isAIFC;
        $[10] = text;
        $[11] = t5;
    } else t5 = $[11];
    const t6 = isAIFC ? (0, $lM3rj.default).closeLabel : (0, $lM3rj.default).cancelLabel;
    let t7;
    if ($[12] !== formatMessage || $[13] !== t6) {
        t7 = formatMessage(t6);
        $[12] = formatMessage;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== isAIFC || $[16] !== onCancel || $[17] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
            autoFocus: true,
            testId: "cancel",
            onClick: onCancel,
            appearance: "primary",
            isAIFC: isAIFC,
            children: t7
        });
        $[15] = isAIFC;
        $[16] = onCancel;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isAIFC || $[20] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButtonContainer), {
            isAIFC: isAIFC,
            children: t8
        });
        $[19] = isAIFC;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== breakpoint || $[23] !== isAIFC || $[24] !== setBreakpointsElement || $[25] !== t4 || $[26] !== t5 || $[27] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorFloatingContainer), {
            ref: setBreakpointsElement,
            breakpoint: breakpoint,
            isAIFC: isAIFC,
            children: [
                t4,
                t5,
                t9
            ]
        });
        $[22] = breakpoint;
        $[23] = isAIFC;
        $[24] = setBreakpointsElement;
        $[25] = t4;
        $[26] = t5;
        $[27] = t9;
        $[28] = t10;
    } else t10 = $[28];
    const cnt = t10;
    let t11;
    if ($[29] !== inContentComponent || $[30] !== isAIFC) {
        t11 = inContentComponent && isAIFC && (0, $ieeJu.expValEquals)("platform_editor_ai_xstate_migration", "isEnabled", true);
        $[29] = inContentComponent;
        $[30] = isAIFC;
        $[31] = t11;
    } else t11 = $[31];
    const useFixedPositioning = t11;
    if (inContentComponent && isAIFC) {
        let t12;
        if ($[32] !== cnt || $[33] !== onDivRef || $[34] !== useFixedPositioning || $[35] !== width) {
            t12 = useFixedPositioning ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_1mT5xdy1CL _0Bm75G5zaO _3OE6xYdnbC _39xV02N91d",
                    "_42Yu6BuSvk"
                ]),
                style: {
                    "--_1dsp0pi": (0, $9aYkv.default)($c706689b83036a7e$var$akAiModalRegionZIndex)
                },
                children: cnt
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                ref: onDivRef,
                className: (0, $hekY6.default)([
                    "_1mT5xdWVPG",
                    "_42Yu6BuSvk"
                ]),
                style: {
                    width: width,
                    "--_1dsp0pi": (0, $9aYkv.default)($c706689b83036a7e$var$akAiModalRegionZIndex)
                },
                children: cnt
            });
            $[32] = cnt;
            $[33] = onDivRef;
            $[34] = useFixedPositioning;
            $[35] = width;
            $[36] = t12;
        } else t12 = $[36];
        return t12;
    }
    return cnt;
} : ({ onCancel: onCancel, text: text, inContentComponent: inContentComponent, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)();
    const [width, setWidth] = (0, $cozmU.useState)(undefined); // when this is rendered in the content component, we have to calc it's width
    const onDivRef = (0, $cozmU.useCallback)((node)=>{
        if (inContentComponent && !width && node && node.parentNode instanceof HTMLElement && isAIFC) setWidth(node.parentNode.clientWidth);
    }, [
        inContentComponent,
        width,
        isAIFC
    ]);
    const cnt = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorFloatingContainer), {
        ref: setBreakpointsElement,
        breakpoint: breakpoint,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                children: formatMessage((0, $lM3rj.default).ariaErrorTitle)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorMessage), {
                breakpoint: breakpoint,
                isAIFC: isAIFC,
                children: text
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButtonContainer), {
                isAIFC: isAIFC,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
                    autoFocus: true,
                    testId: 'cancel',
                    onClick: onCancel,
                    appearance: "primary",
                    isAIFC: isAIFC,
                    children: formatMessage(isAIFC ? (0, $lM3rj.default).closeLabel : (0, $lM3rj.default).cancelLabel)
                })
            })
        ]
    }); // On the xstate-migration path, use position: fixed with display: grid so the error
    // screen pins to the viewport bottom and ErrorFloatingContainer's justifySelf/width
    // styles work correctly. This replaces the old position: absolute + JS width approach.
    const useFixedPositioning = inContentComponent && isAIFC && (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true); // when this is rendered in the content component, we have to add a wrapper div to apply some styles like position and zIndex
    // for z-index
    // - this will ensure it's applied properly because passing is via css to ErrorFloatingContainer won't work
    // - the z-index will be compiled to a css custom property, but the css custom property is undefined
    // - normally, the css custom property will be defined on the same dom element
    if (inContentComponent && isAIFC) return useFixedPositioning ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _0Bm75G5zaO _3OE6xYdnbC _39xV02N91d",
            "_42Yu6BuSvk"
        ]),
        style: {
            "--_1dsp0pi": (0, $9aYkv.default)($c706689b83036a7e$var$akAiModalRegionZIndex)
        },
        children: cnt
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: onDivRef,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG",
            "_42Yu6BuSvk"
        ]),
        style: {
            width: width,
            "--_1dsp0pi": (0, $9aYkv.default)($c706689b83036a7e$var$akAiModalRegionZIndex)
        },
        children: cnt
    });
    return cnt;
};


const $126aacb890017ec7$export$8a78f5c7307b478b = 'MarkdownConversionError';
class $126aacb890017ec7$export$6c16da0c287c00c extends Error {
    constructor({ message: message, type: type }){
        super(message);
        this.type = void 0;
        this.name = $126aacb890017ec7$export$8a78f5c7307b478b;
        this.type = type;
    }
}





const $405400f22f07581a$var$getErrorMessage = (error)=>{
    if (error.name === (0, $126aacb890017ec7$export$8a78f5c7307b478b)) return (0, $7ZL6d.aiMessages).markdownErrorMessage;
    return (0, $7ZL6d.aiMessages).cmdPaletteUnhandledErrorMessage;
};
const $405400f22f07581a$export$61f6bd9fac8ed53 = (props)=>{
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // when there is an error, after we resetErrorBoundary the component tree will render again and trigger the error again
    // use this to not render children to prevent the error from being triggered again
    // when we start AI again, parent should use key to reset this component or its ancestor to render children again
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const onError = (error, info)=>{
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-ai-error-boundary'
        });
        if (error.name === (0, $126aacb890017ec7$export$8a78f5c7307b478b)) {
            const errorHasTypeProperty = 'type' in error;
            const errorSubType = errorHasTypeProperty ? error.type : undefined;
            fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: info.componentStack || '',
                        errorType: 'markdownToProseMirrorError',
                        errorSubType: errorSubType,
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
        } else fireAIAnalyticsEvent({
            payload: {
                action: 'unhandledErrorCaught',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    componentStack: info.componentStack || '',
                    errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onError,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        fallbackRender: ({ error: error, resetErrorBoundary: resetErrorBoundary })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c706689b83036a7e$export$40729e8ab35829ea), {
                inContentComponent: props.inContentComponent,
                text: formatMessage($405400f22f07581a$var$getErrorMessage(error)),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCancel: ()=>{
                    props.onCloseFallback();
                    resetErrorBoundary();
                    setHasError(true);
                },
                isAIFC: true
            })
    }, hasError ? null : props.children);
};


/* ModalRegion.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























const $29641a2faeabcff2$export$91249d6c9b15807 = 'ai-height-div';
function $29641a2faeabcff2$export$a5441b49687f80f6({ modalElement: modalElement, editorViewElement: editorViewElement, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const heightDivRef = (0, $cozmU.useRef)(null);
    // listen to changes to modal size
    (0, $cozmU.useEffect)(()=>{
        if (!modalElement) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            if (!heightDivRef.current || !modalElement) return;
            const modalEntry = entries.find((e)=>e.target === modalElement);
            // entry should always exist for modaRef as we're observing on it, this check makes ts happy
            if (!modalEntry) return;
            const modalBottom = // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            modalEntry.target.offsetTop + modalEntry.contentRect.height;
            const editorBottom = editorViewElement.offsetTop + editorViewElement.offsetHeight;
            // The height of the extra div should be expanded to reach
            // the bottom of the modal -- so that no modal content is outside
            // the editor
            const heightToSet = Math.max(modalBottom - editorBottom, 0);
            heightDivRef.current.style.height = `${heightToSet}px`;
        });
        resizeObserver.observe(modalElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        modalElement,
        editorViewElement
    ]);
    // Create an element for adjusting height of editor when modal is visible
    (0, $cozmU.useEffect)(()=>{
        if (heightDivRef.current) // In future react will fire useEffect twice in dev mode
        // this early exit avoids issues with this
        return;
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const newDiv = doc.createElement('div');
        newDiv.className = $29641a2faeabcff2$export$91249d6c9b15807;
        newDiv.style.height = `0px`;
        if (isInDocumentStreamingEnabled) // Position directly after the editor element to avoid
        // selector ambiguity in nested editor scenarios.
        editorViewElement.after(newDiv);
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        editorViewElement.parentNode.appendChild(newDiv);
        heightDivRef.current = newDiv;
        return ()=>{
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) newDiv.parentNode?.removeChild(newDiv);
            else editorViewElement.parentNode?.removeChild(newDiv);
        };
    }, [
        editorViewElement,
        isInDocumentStreamingEnabled
    ]);
}




var $bYPHE = parcelRequire("bYPHE");








const $abec54562d55018e$export$18555b75960797ab = 10;
const $abec54562d55018e$export$5ad3691ad52dacd1 = $abec54562d55018e$export$18555b75960797ab / 2;
function $abec54562d55018e$var$getOffsetParent(element) {
    const offsetParent = element.offsetParent;
    if (offsetParent) return offsetParent;
    // If offsetParent is null, we need to find the nearest ancestor element that has a position value other than static
    let tempOffsetParent = element.parentElement;
    while(tempOffsetParent){
        const position = getComputedStyle(tempOffsetParent).position;
        if (position !== 'static') return tempOffsetParent;
        tempOffsetParent = tempOffsetParent.parentElement;
    }
    return document.body;
}
// Calculate offset for modal positioning
function $abec54562d55018e$var$getModalOffset({ from: from, modalElement: modalElement, direction: direction }) {
    const property = direction === 'top' ? 'offsetTop' : 'offsetLeft';
    let offset = from[property];
    let tempOffsetParent = from.offsetParent;
    const modalOffsetParent = $abec54562d55018e$var$getOffsetParent(modalElement);
    while(tempOffsetParent && tempOffsetParent instanceof HTMLElement && tempOffsetParent !== modalOffsetParent){
        offset += tempOffsetParent[property];
        tempOffsetParent = tempOffsetParent.offsetParent;
    }
    return offset;
}
function $abec54562d55018e$export$f695eeeda1b3ceee({ relativePositionElement: relativePositionElement, modalElement: modalElement }) {
    const offset = $abec54562d55018e$var$getModalOffset({
        from: relativePositionElement,
        modalElement: modalElement,
        direction: 'left'
    });
    // Re-centre the narrower modal only in the New AIFC experience. Gated here (not
    // in the caller) because this helper is shared with the unchanged legacy modal.
    if ((0, $a44d2501b233a83e$export$4d8717ba02388642)()) return `calc(${offset}px + ${$abec54562d55018e$export$5ad3691ad52dacd1}rem)`;
    return offset;
}
/**
 * Extend `bottom` past deleted diff content that would otherwise sit behind the modal. With `smart`
 * diffs, deleted content is anchored below its replacement and can be relocated past the mount
 * point. show-diff's `getDeletedWidgets` action returns each deleted widget with the position it is
 * anchored at; only the closest one within the enclosing top-level node is measured, since anything
 * further belongs to another change and must not drag the modal further down the page.
 */ function $abec54562d55018e$var$extendBottomPastDeletedDiff({ editorView: editorView, getDeletedWidgets: getDeletedWidgets, modalDecorationElement: modalDecorationElement, modalElement: modalElement, bottom: bottom }) {
    let from;
    let to;
    try {
        from = editorView.posAtDOM(modalDecorationElement, 0);
        // Relocation only pushes content out of nodes that cannot host it, so it never escapes the
        // enclosing top-level node.
        const $from = editorView.state.doc.resolve(from);
        to = $from.depth > 0 ? $from.after(1) : editorView.state.doc.content.size;
    } catch  {
        // posAtDOM/resolve throw when the mount point is not currently in the document.
        return bottom;
    }
    // Widgets come back ordered by position, so the first is the closest to the mount point.
    const [closest] = getDeletedWidgets({
        from: from,
        to: to
    });
    if (!closest) return bottom;
    const elementBottom = $abec54562d55018e$var$getModalOffset({
        from: closest.element,
        modalElement: modalElement,
        direction: 'top'
    }) + closest.element.offsetHeight;
    return Math.max(bottom, elementBottom);
}
// Calculate offset top for decorationBottom positioning
function $abec54562d55018e$var$getDecorationBottom({ editorView: editorView, getDeletedWidgets: getDeletedWidgets, modalDecorationElement: modalDecorationElement, modalElement: modalElement }) {
    const offset = $abec54562d55018e$var$getModalOffset({
        from: modalDecorationElement,
        modalElement: modalElement,
        direction: 'top'
    });
    const bottom = offset + modalDecorationElement.offsetHeight;
    // Gated on the same flag as the placement change that causes the overlap: deleted content only
    // renders after the mount point when `smart` diffs place deletions below.
    if (!editorView || !getDeletedWidgets || !(0, $iDrrr.fg)('platform_editor_ai_smart_diff')) return bottom;
    return $abec54562d55018e$var$extendBottomPastDeletedDiff({
        editorView: editorView,
        getDeletedWidgets: getDeletedWidgets,
        modalDecorationElement: modalDecorationElement,
        modalElement: modalElement,
        bottom: bottom
    });
}
function $abec54562d55018e$export$6fabade9f8472f78({ appearance: appearance, modalElement: modalElement, editorRelativeWrapper: editorRelativeWrapper, modalDecorationElement: modalDecorationElement, lastTriggeredFrom: lastTriggeredFrom, editorView: editorView, getDeletedWidgets: getDeletedWidgets }) {
    const isSuggestTitleQuickAction = lastTriggeredFrom === 'confluenceTitleToolbar';
    if (isSuggestTitleQuickAction) return editorRelativeWrapper?.querySelector('.ProseMirror')?.offsetTop || 0;
    const calculatedTop = $abec54562d55018e$var$getDecorationBottom({
        editorView: editorView,
        getDeletedWidgets: getDeletedWidgets,
        modalDecorationElement: modalDecorationElement,
        modalElement: modalElement
    });
    // Clamp AI modal bottom within editor content area in chromeless mode
    // Calculates the bottom limit relative to the modal's offset parent
    if (appearance === 'chromeless') {
        const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
        if (editorContentArea) {
            const modalOffsetParent = $abec54562d55018e$var$getOffsetParent(modalElement);
            const contentAreaRect = editorContentArea.getBoundingClientRect();
            const modalOffsetParentRect = modalOffsetParent.getBoundingClientRect();
            const contentAreaBottom = contentAreaRect.bottom - modalOffsetParentRect.top;
            if (calculatedTop > contentAreaBottom) return contentAreaBottom;
        }
    }
    return calculatedTop;
}
function $abec54562d55018e$export$9e4eede810cdf154(editorView, position) {
    // For in-document streaming, the mount decoration is placed at the end of the document
    // But somehow during streaming, the position can be larger than the document size
    // So we need to clamp the position to the document size
    const resolvedPos = editorView.state.doc.resolve(Math.min(position, editorView.state.doc.content.size));
    const { nodes: nodes, marks: marks } = editorView.state.schema;
    const domAtPos = editorView.domAtPos.bind(editorView);
    /**
   * At the moment, the table node is the only resizable node
   * which can trigger the AI modal.
   */ const resizableNode = (0, $bjg0G.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === nodes.table);
    if (resizableNode) {
        const resizableDomNode = (0, $bjg0G.findDomRefAtPos)(resizableNode.start, domAtPos);
        if (resizableDomNode instanceof HTMLElement) {
            /**
       * At the moment this only resizable tables need to be handled
       * hence why we use the table resizer class name specifically.
       */ const resizableWrapper = resizableDomNode.closest(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
            if (resizableWrapper instanceof HTMLElement) return resizableWrapper;
        }
    }
    const nodeWithBreakout = (0, $bjg0G.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>{
        return currentNode.type === nodes.table && currentNode.attrs.layout !== 'default' || currentNode.marks.some((mark)=>mark.type === marks.breakout);
    });
    if (!nodeWithBreakout) return;
    const domNodeWithBreakout = (0, $bjg0G.findDomRefAtPos)(nodeWithBreakout.start, domAtPos);
    if (!(domNodeWithBreakout instanceof HTMLElement)) return;
    if (!domNodeWithBreakout) return;
    if ([
        nodes.layoutSection,
        nodes.expand
    ].includes(nodeWithBreakout.node.type)) return domNodeWithBreakout.parentElement || undefined;
    if (nodeWithBreakout.node.type === nodes.table) {
        const closest = domNodeWithBreakout.closest(`.${(0, $bYPHE.TableSharedCssClassName).TABLE_CONTAINER}`);
        return closest instanceof HTMLElement ? closest : undefined;
    }
}


// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $a6daee9d675824f6$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $a6daee9d675824f6$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $a6daee9d675824f6$var$akAiModalRegionZIndex = Math.min($a6daee9d675824f6$var$MAX_Z_INDEX, Math.max($a6daee9d675824f6$var$MIN_Z_INDEX, (0, $7Y8M5.akEditorFloatingPanelZIndex) + 2));
var $a6daee9d675824f6$var$MODAL_PINNING = /*#__PURE__*/ function(MODAL_PINNING) {
    MODAL_PINNING[MODAL_PINNING["TOP"] = 1] = "TOP";
    MODAL_PINNING[MODAL_PINNING["NONE"] = 0] = "NONE";
    MODAL_PINNING[MODAL_PINNING["BOTTOM"] = -1] = "BOTTOM";
    return MODAL_PINNING;
}($a6daee9d675824f6$var$MODAL_PINNING || {});
const $a6daee9d675824f6$var$slideFadeIn = null;
const $a6daee9d675824f6$var$modalStyles = null; // Applied via inline `style` (like `left`/`--content-width`) rather than `css()`,
// which cannot take a runtime-gated, constant-derived value. New AIFC width is
// re-centred by `getModalLeft` (utils.ts); legacy width is unchanged.
const $a6daee9d675824f6$var$NEW_AIFC_MODAL_WIDTH = `calc(var(--content-width) - ${(0, $abec54562d55018e$export$18555b75960797ab)}rem)`;
const $a6daee9d675824f6$var$LEGACY_MODAL_WIDTH = 'calc(var(--content-width) + 2rem)';
const $a6daee9d675824f6$var$pinnedTopStyles = null;
const $a6daee9d675824f6$var$pinnedBottomStyles = null;
const $a6daee9d675824f6$var$getModalDecorationElement = (editorView)=>{
    return editorView?.dom.querySelector('.ai-modal-mount-point-widget') || editorView?.dom.querySelector('.ai-selection-node');
};
const $a6daee9d675824f6$export$bd71f7a11db32a15 = ({ isDirectionalPinningEnabled: isDirectionalPinningEnabled, children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, appearance: appearance, endExperience: endExperience, lastTriggeredFrom: lastTriggeredFrom, decorationSet: decorationSet, getDeletedWidgets: getDeletedWidgets, useFullEditorWidthForUnifiedBar: useFullEditorWidthForUnifiedBar = false })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorViewElement = editorView.dom;
    const modalRef = (0, $cozmU.useRef)(null); // Tracks the last vertical position so we can replay the entry fade ONLY when the
    // modal actually moves rows (e.g. an undo/redo that shifts the anchor). Undo/redo
    // re-anchors without remounting, so the mount animation would not otherwise play.
    const prevModalTopRef = (0, $cozmU.useRef)(null);
    const [modalLeft, setModalLeft] = (0, $cozmU.useState)('');
    const [modalTop, setModalTop] = (0, $cozmU.useState)(0);
    const [modalWidth, setModalWidth] = (0, $cozmU.useState)(0);
    const [transition, setTransition] = (0, $cozmU.useState)('');
    const scrollParentRef = (0, $cozmU.useRef)(null);
    const [isPinned, setIsPinned] = (0, $cozmU.useState)(0);
    const [modalHeight, setModalHeight] = (0, $cozmU.useState)(0); // get nearest resizable wrapper or breakout container looking up from the ai decoration position
    const resizableOrBreakoutWrapper = (0, $cozmU.useMemo)(()=>(0, $abec54562d55018e$export$9e4eede810cdf154)(editorView, decoration.to), [
        editorView,
        decoration
    ]);
    const modalDecorationElement = $a6daee9d675824f6$var$getModalDecorationElement(editorView); // We only want modal pinning in full page experiences.
    const isModalPinningEnabled = [
        'full-page',
        'full-width'
    ].includes(appearance); // EDF-161: https://product-fabric.atlassian.net/browse/EDF-161
    // If the editor has a max-height set, we need to set position relative for .ak-editor-content-area
    (0, $cozmU.useEffect)(()=>{
        if (appearance === 'comment') {
            // editorRelativeWrapper is the closest but can be null
            // fallback to modalDecorationElement if editorRelativeWrapper is null
            let editorContentArea = null;
            if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
            else if (modalDecorationElement) editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
            if (editorContentArea) {
                const computedStyle = getComputedStyle(editorContentArea);
                const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                const originalPosition = computedStyle.position;
                if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                return ()=>{
                    if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                };
            }
        }
    }, [
        modalDecorationElement,
        appearance,
        editorRelativeWrapper
    ]); // listen for editor resize and update modal size and position
    (0, $cozmU.useEffect)(()=>{
        const setModalPosition = ()=>{
            if (!modalRef.current || !modalDecorationElement || !modalDecorationElement.offsetParent) // The modalDecorationElement.offsetParent is used when calculating the modal top postion. If it is null
            // the modal will flikcer from top to bottom, because the top position resets to 0.
            return;
            const layoutColumn = modalDecorationElement.closest('[data-layout-column]');
            const useColumnRelative = layoutColumn && !useFullEditorWidthForUnifiedBar;
            const relativePositionElement = useColumnRelative ? layoutColumn : editorViewElement;
            const top = (0, $abec54562d55018e$export$6fabade9f8472f78)({
                appearance: appearance,
                modalElement: modalRef.current,
                editorRelativeWrapper: editorRelativeWrapper,
                modalDecorationElement: modalDecorationElement,
                lastTriggeredFrom: lastTriggeredFrom,
                editorView: editorView,
                getDeletedWidgets: getDeletedWidgets
            });
            const left = (0, $abec54562d55018e$export$f695eeeda1b3ceee)({
                relativePositionElement: relativePositionElement,
                modalElement: modalRef.current
            });
            setModalLeft(left);
            setModalTop(top);
            setModalWidth(relativePositionElement.offsetWidth); //setting width to be animated here to make animation happen only after first positioning
            if (!transition) setTransition('left 0.1s ease-in, left 0.1s ease-in');
        };
        setModalPosition();
        const setModalPositionDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setModalPosition();
        }, 20);
        const resizeObserver = new ResizeObserver(setModalPositionDebounced);
        resizeObserver.observe(editorViewElement);
        const layoutColumn = modalDecorationElement?.closest('[data-layout-column]');
        if (layoutColumn) resizeObserver.observe(layoutColumn);
         // editorViewOffsetParent can be undefined when editor is set to display: none
        // (when Confluence switches to Preview mode)
        const editorViewOffsetParent = editorViewElement.offsetParent;
        if (editorViewOffsetParent) // This resize observer is intended to fix the position of the modal region
        // when the config panel (for extensions or templates) is opened/closed
        resizeObserver.observe(editorViewOffsetParent);
        return ()=>{
            resizeObserver.disconnect(); //clearing any potentially running debounced reposition
            setModalPositionDebounced.cancel();
        }; // no need to rerun due to transition change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorViewElement,
        modalDecorationElement,
        editorRelativeWrapper,
        resizableOrBreakoutWrapper,
        useFullEditorWidthForUnifiedBar,
        getDeletedWidgets
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!modalRef.current) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalRef.current) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        }
        const modalHeightObserver = new ResizeObserver(()=>{
            if (!modalRef.current) return;
            setModalHeight(modalRef.current.offsetHeight);
        });
        modalHeightObserver.observe(modalRef.current);
        return ()=>{
            modalHeightObserver.disconnect();
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (modalHeight && scrollParentRef.current && modalDecorationElement && isModalPinningEnabled && isDirectionalPinningEnabled) {
            const scrollParent = scrollParentRef.current;
            const observer = new IntersectionObserver((entries)=>{
                for (const entry of entries)if (entry.isIntersecting) setIsPinned(0);
                else {
                    // We could be reacting to an element which is no longer in the DOM because prosemirror has removed it,
                    // so we need to check that the target is still the current target.
                    // This is not ideal and can be costly, however it's only a performance issue during the inline streaming
                    // experience, and should have little affect the overall editor experience.
                    const currentTarget = $a6daee9d675824f6$var$getModalDecorationElement(editorView);
                    if (entry.target !== currentTarget) // It's possible for the interaction observer callback to be called early as soon as the prosemirror
                    // widget decoration has been removed. This means the react vdom update lags behind and doesn't disconnect
                    // until a bit latter.
                    return;
                     // somehow, during streaming, the rootBounds and other fields in entry will have all 0, which is really weird!
                    if (!entry.rootBounds || entry.rootBounds.height === 0) {
                        const rect = modalDecorationElement.getBoundingClientRect();
                        const scrollRect = scrollParent.getBoundingClientRect();
                        setIsPinned(rect.bottom < scrollRect.top ? 1 : -1);
                    } else setIsPinned(entry.boundingClientRect.bottom < entry.rootBounds.top ? 1 : -1);
                }
            }, {
                root: scrollParentRef.current,
                /**
         * We set the bottom root margin to account for the modal height (so that the modal does not block content),
         * the top margin and bottom margin of the modal (16px each).
         * We also use the modal decoration's height to figure out the location of the bottom of the mount point widget.
         */ rootMargin: `0px 0px -${modalHeight + 16 + 16 + modalDecorationElement.getBoundingClientRect().height}px 0px`,
                threshold: 0
            }); // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            observer.observe(modalDecorationElement);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        modalHeight,
        editorView,
        modalDecorationElement,
        isModalPinningEnabled,
        isDirectionalPinningEnabled
    ]); // sync modal height with editor content area height
    (0, $29641a2faeabcff2$export$a5441b49687f80f6)({
        modalElement: modalRef.current,
        editorViewElement: editorViewElement,
        isInDocumentStreamingEnabled: true
    }); // Replay the entry fade when the modal MOVES to a new row without remounting
    // (undo/redo re-anchors in place). The first positioning is skipped so this does
    // not double up with the mount animation; an unchanged `modalTop` (e.g. an in-line
    // edit) does nothing, so the modal only fades when it actually moves.
    (0, $cozmU.useEffect)(()=>{
        const el = modalRef.current;
        const prevTop = prevModalTopRef.current;
        prevModalTopRef.current = modalTop; // Skip the initial position and no-op updates (same row).
        if (el === null || prevTop === null || prevTop === modalTop) return;
         // Restart the CSS `slideFadeIn` animation: clear it, force a reflow, restore.
        el.style.animation = 'none'; // Reading a layout property forces the browser to flush the removal so the
        // animation can re-trigger when it is restored below.
        el.offsetHeight;
        el.style.animation = '';
    }, [
        modalTop
    ]); // Check for the modal decoration which is used for positioning
    // If there is none the modal should be removed from the DOM & return early
    // This is intended to make the code more resilient to bugs caused by the
    // editor AI plugin not being reinstantiated correctly when the editor is closed/opened
    // See https://product-fabric.atlassian.net/browse/EDITOR-52
    if (decorationSet === (0, $8nvEM.DecorationSet).empty) {
        endExperience();
        return null;
    }
    const style = {
        ...(!isModalPinningEnabled || isDirectionalPinningEnabled && isPinned === 0) && {
            top: modalTop,
            transition: transition
        },
        left: modalLeft,
        // New AIFC experience uses the narrower width; `getModalLeft` re-centres it.
        width: (0, $a44d2501b233a83e$export$4d8717ba02388642)() ? $a6daee9d675824f6$var$NEW_AIFC_MODAL_WIDTH : $a6daee9d675824f6$var$LEGACY_MODAL_WIDTH,
        '--content-width': `${modalWidth}px`,
        display: modalWidth ? 'block' : 'none'
    };
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_3138425zaO _1mT5xdWVPG _42Yu6BuSvk _0adFHsUgYP _2XsHFMUgYP _1gBibynkof _0nFVCG2HTN _43vdfT1fFG _3Y6bKpgRhm _1VPqc3YbGa",
            isModalPinningEnabled && isDirectionalPinningEnabled && isPinned === 1 && "_1mT5xdy1CL _2IhTondnbC",
            isModalPinningEnabled && (isDirectionalPinningEnabled && isPinned === -1 || !isDirectionalPinningEnabled) && "_1mT5xdy1CL _0Bm75Gey7F _2IhTonZqHV",
            "ak-editor-plugin-ai-modal"
        ]),
        "data-testid": "ai-plugin-modal",
        ref: modalRef,
        // Otherwise, content selection will be prevented in packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
        "data-editor-popup": true,
        style: {
            ...style,
            "--_1dsp0pi": (0, $9aYkv.default)($a6daee9d675824f6$var$akAiModalRegionZIndex)
        }
    }, children);
};



/**
 * Diff-based segmenting for the Post Stream Review (PSR) toolbar.
 *
 * Turns an `originalDoc` + forward `steps` into a flat list of reviewable
 * segments (one per detected change), shaped as `AIContentPositionEntry` so the
 * PSR toolbar can navigate, view-diff and undo/redo each change independently.
 *
 * The heavy lifting — classifying the change set (default `diffType: 'smart'`) —
 * is delegated to `editor-plugin-show-diff`'s generic `computeDiffChanges`
 * utility, so the segments always line up with what the diff overlay renders.
 * This module only owns the AI-specific *shaping*: mapping each `Change` to
 * new-document positions + the slices needed for undo/redo.
 *
 * ── Segment shape ────────────────────────────────────────────────────────────
 *   - `startPos` / `endPos` — the change's range in the NEW (post-steps / live)
 *     doc. In the review moment the live doc equals the stepped doc, so these
 *     are valid live-document positions.
 *   - `originalUserContentSlice` — `originalDoc.slice(fromA, toA)`; restored on
 *     undo via `tr.replaceRange(startPos, endPos, slice)`.
 *   - `newSlice` — `newDoc.slice(fromB, toB)`; re-applied on redo.
 *   - `kind` — `add` (nothing on the original side), `remove` (nothing on the
 *     new side) or `update` (both sides non-empty).
 *
 * ── Known limitation (v1) ────────────────────────────────────────────────────
 * For `smart` changes promoted to sentence level the original-side range is
 * approximated positionally (by sentence index). Whole-block/node promotions and
 * inline/add/remove changes use exact ranges, so undo/redo is exact for those.
 */ /**
 * Generic, editor-state-free diff-change computation.
 *
 * Turns an `originalDoc` + forward `steps` into the classified `Change[]` for the
 * requested `diffType`, plus the reconstructed new document — the same classifier
 * the diff overlay uses (`calculateDiffDecorations` → `getChanges`), exposed as a
 * reusable utility (e.g. to derive reviewable segments without rendering
 * decorations). It runs the requested `diffType` DIRECTLY and does NOT apply the
 * overlay's `platform_editor_ai_smart_diff` gate, so a `smart` result here can
 * differ from what the overlay draws when that gate is off (the overlay falls back
 * to inline); callers that need overlay parity must account for that gate.
 *
 * Pure: no `EditorState`, no transactions, no React. The new document is
 * reconstructed by applying the (simplified) steps to `originalDoc`.
 */ 
var $dFI5z = parcelRequire("dFI5z");


var $j1ahd = parcelRequire("j1ahd");


var $aa9kO = parcelRequire("aa9kO");


var $85Bcz = parcelRequire("85Bcz");


var $bdYmy = parcelRequire("bdYmy");


var $jggTf = parcelRequire("jggTf");


var $ddUGd = parcelRequire("ddUGd");

const $f52df80f2e22994e$export$c596751657400ca4 = ({ originalDoc: originalDoc, steps: steps, diffType: diffType = 'smart', locale: locale = 'en', smartThresholds: smartThresholds })=>{
    if (!steps || steps.length === 0) return {
        changes: [],
        newDoc: originalDoc
    };
    const simplifiedSteps = (0, $jggTf.simplifySteps)(steps, originalDoc);
    let steppedDoc = originalDoc;
    const stepMaps = [];
    try {
        for (const step of simplifiedSteps){
            const result = step.apply(steppedDoc);
            if (result.failed === null && result.doc) {
                stepMaps.push(step.getMap());
                steppedDoc = result.doc;
            }
        }
    } catch  {
        // A step's positions fell outside the current doc — `ReplaceStep.apply`
        // throws a RangeError (rather than returning a failed result) when a
        // position exceeds the doc size. This can happen for pathological or
        // inconsistent step sequences. Bail with no changes rather than letting the
        // error propagate to the caller (which, for the PSR, would crash the
        // toolbar); the consumer then falls back to its non-diff segmenting path.
        return {
            changes: [],
            newDoc: originalDoc
        };
    }
    // This utility does not apply the smart-diff gate (see the file docstring); a caller
    // requesting `smart` is already behind it.
    const { tokenEncoder: tokenEncoder } = (0, $bdYmy.selectTokenEncoder)(diffType === 'smart');
    const changeset = (0, $dFI5z.ChangeSet).create(originalDoc, undefined, tokenEncoder).addSteps(steppedDoc, stepMaps, steppedDoc);
    if (diffType === 'smart') return {
        changes: (0, $ddUGd.classifySmartChanges)({
            changes: (0, $dFI5z.simplifyChanges)(changeset.changes, steppedDoc),
            originalDoc: originalDoc,
            newDoc: steppedDoc,
            locale: locale,
            thresholds: smartThresholds
        }),
        newDoc: steppedDoc
    };
    if (diffType === 'block') return {
        changes: (0, $aa9kO.groupChangesByBlock)(changeset.changes, originalDoc, steppedDoc),
        newDoc: steppedDoc
    };
    if (diffType === 'step') return {
        changes: (0, $j1ahd.diffBySteps)(originalDoc, simplifiedSteps),
        newDoc: steppedDoc
    };
    return {
        changes: (0, $85Bcz.optimizeChanges)((0, $dFI5z.simplifyChanges)(changeset.changes, steppedDoc)),
        newDoc: steppedDoc
    };
};


const $ee2002594e1f6916$export$a3df838cbaca88df = (params)=>{
    const { originalDoc: originalDoc } = params;
    if (!params.steps || params.steps.length === 0) return [];
    const { changes: changes, newDoc: newDoc } = (0, $f52df80f2e22994e$export$c596751657400ca4)(params);
    const maxA = originalDoc.content.size;
    const maxB = newDoc.content.size;
    const segments = [];
    for (const change of changes){
        // Defensively clamp to each doc's bounds — promoted `smart` changes pad
        // ranges with ±1 (block open/close tokens), which can push a change at the
        // very start/end just outside `[0, size]` and make `.slice` throw.
        const fromA = Math.max(0, Math.min(change.fromA, maxA));
        const toA = Math.max(fromA, Math.min(change.toA, maxA));
        const fromB = Math.max(0, Math.min(change.fromB, maxB));
        const toB = Math.max(fromB, Math.min(change.toB, maxB));
        // A change that is empty on BOTH sides carries no content to review.
        if (toA === fromA && toB === fromB) continue;
        const kind = fromA === toA ? 'add' : fromB === toB ? 'remove' : 'update';
        let origSlice;
        let newSlice;
        try {
            origSlice = originalDoc.slice(fromA, toA);
            newSlice = newDoc.slice(fromB, toB);
        } catch  {
            continue;
        }
        // [CCI-17658] Seed the two-slice history [original, AI], AI applied.
        segments.push({
            startPos: fromB,
            endPos: toB,
            slices: [
                origSlice,
                newSlice
            ],
            appliedIndex: 1,
            kind: kind
        });
    }
    return segments;
};


/**
 * Top-level-node segmenting for the Post Stream Review toolbar (the `block` /
 * gate-OFF strategy).
 *
 * Derives segments directly from what the AI committed, rather than the
 * prosemirror-changeset `block` diff (whose grouping mis-attributes the original
 * side of structural edits). Each overlap-merged coarse segment carries
 * `slices[0]` (original) and `slices[appliedIndex]` (current applied) for one
 * edited region; we compare their top-level nodes and emit one segment per
 * added / removed / updated node.
 *
 * The applied slice occupies exactly `[startPos, endPos]`, so each new node's
 * live range is found by walking node sizes from the first node's true live
 * start (`startPos - appliedSlice.openStart`; see the walk below). Removals are
 * zero-width, anchored where the node was removed. Granularity is top-level only.
 */ 


/**
 * [CCI-17658] Small accessors for the `slices[] + appliedIndex` slice-history
 * model on `AIContentPositionEntry` (see `pm-plugins/ai-session-context/types.ts`).
 *
 * They centralise the `noUncheckedIndexedAccess` fallback so callers always get a
 * concrete `Slice`, and encode the undo/redo availability rules in one place.
 *
 *   - `slices[0]`               = original (pre-AI) content.
 *   - `slices[appliedIndex]`    = the content currently at `[startPos, endPos]`.
 *   - undo available            = `appliedIndex > 0`.
 *   - redo available            = `appliedIndex < slices.length - 1`.
 */ 
var $lVJ72 = parcelRequire("lVJ72");




const $7ba54af9843c5cb8$export$dee11abf78a51a07 = (entry)=>entry.slices[0] ?? (0, $aPdNQ.Slice).empty;
const $7ba54af9843c5cb8$export$27c0418cee04b434 = (entry)=>entry.slices[entry.appliedIndex] ?? (0, $aPdNQ.Slice).empty;
const $7ba54af9843c5cb8$export$599958c5ce1f5bfc = (entry)=>entry.appliedIndex > 0;
const $7ba54af9843c5cb8$export$84df6672c946d3cf = (entry)=>entry.appliedIndex < entry.slices.length - 1;
const $7ba54af9843c5cb8$export$3d688fb5f6edd97a = (entry)=>(0, $lVJ72.slicesEqualIgnoringLocalId)($7ba54af9843c5cb8$export$dee11abf78a51a07(entry), $7ba54af9843c5cb8$export$27c0418cee04b434(entry));


/** Wrap a single complete top-level node in a zero-open slice. */ const $3eca34d37a5a6a25$var$wholeNodeSlice = (node)=>new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(node), 0, 0);
/** The top-level nodes carried by a slice, in order. */ const $3eca34d37a5a6a25$var$topLevelNodes = (slice)=>{
    const nodes = [];
    slice.content.forEach((node)=>nodes.push(node));
    return nodes;
};
const $3eca34d37a5a6a25$export$7632b2cf80a07db5 = (coarseSegments)=>{
    const segments = [];
    for (const coarse of coarseSegments){
        // [CCI-17658] Read the coarse entry through its slice history: the original
        // side is `slices[0]`, the "new" side is the currently-applied slice.
        const originalSlice = (0, $7ba54af9843c5cb8$export$dee11abf78a51a07)(coarse);
        const appliedSlice = (0, $7ba54af9843c5cb8$export$27c0418cee04b434)(coarse);
        const originalNodes = $3eca34d37a5a6a25$var$topLevelNodes(originalSlice);
        const newNodes = $3eca34d37a5a6a25$var$topLevelNodes(appliedSlice);
        // Trim the common prefix, then the common suffix, so only the genuinely
        // changed nodes remain in the middle. Node equality is exact (`.eq`), so an
        // attribute-only change (e.g. panel type) still counts as a change.
        let prefix = 0;
        while(prefix < originalNodes.length && prefix < newNodes.length && originalNodes[prefix].eq(newNodes[prefix]))prefix++;
        let suffix = 0;
        while(suffix < originalNodes.length - prefix && suffix < newNodes.length - prefix && originalNodes[originalNodes.length - 1 - suffix].eq(newNodes[newNodes.length - 1 - suffix]))suffix++;
        const originalMiddle = originalNodes.slice(prefix, originalNodes.length - suffix);
        const newMiddle = newNodes.slice(prefix, newNodes.length - suffix);
        // Walk the live-doc cursor through every new node (prefix included) so each
        // changed node lands at its true `[startPos, endPos]`.
        //
        // The cursor base is `startPos - appliedSlice.openStart`, not `startPos`.
        // When the applied slice was inserted with an open left boundary
        // (`openStart > 0` — the pure-add case), the recorded `startPos` was mapped
        // with a `+1`-per-open-level bias, so it sits *inside* the opened boundary.
        // A fully-closed slice's first node begins `openStart` positions earlier, so
        // walking full node sizes from `startPos` overshoots every emitted range by
        // `openStart`. Subtracting it anchors the first node at its true live start;
        // closed slices (`openStart === 0`, the update case) are unaffected.
        let cursor = coarse.startPos - appliedSlice.openStart;
        for(let i = 0; i < prefix; i++)cursor += newNodes[i].nodeSize;
        const paired = Math.min(originalMiddle.length, newMiddle.length);
        // Paired middle nodes → `update` (skip any that happen to be identical).
        for(let i = 0; i < paired; i++){
            const newNode = newMiddle[i];
            const startPos = cursor;
            const endPos = cursor + newNode.nodeSize;
            cursor = endPos;
            if (originalMiddle[i].eq(newNode)) continue;
            segments.push({
                startPos: startPos,
                endPos: endPos,
                slices: [
                    $3eca34d37a5a6a25$var$wholeNodeSlice(originalMiddle[i]),
                    $3eca34d37a5a6a25$var$wholeNodeSlice(newNode)
                ],
                appliedIndex: 1,
                kind: 'update'
            });
        }
        // Extra new nodes → `add`.
        for(let i = paired; i < newMiddle.length; i++){
            const newNode = newMiddle[i];
            const startPos = cursor;
            const endPos = cursor + newNode.nodeSize;
            cursor = endPos;
            segments.push({
                startPos: startPos,
                endPos: endPos,
                slices: [
                    (0, $aPdNQ.Slice).empty,
                    $3eca34d37a5a6a25$var$wholeNodeSlice(newNode)
                ],
                appliedIndex: 1,
                kind: 'add'
            });
        }
        // Extra original nodes → `remove` (zero-width in the live doc, anchored at
        // the cursor — i.e. immediately after the paired/added content).
        for(let i = paired; i < originalMiddle.length; i++)segments.push({
            startPos: cursor,
            endPos: cursor,
            slices: [
                $3eca34d37a5a6a25$var$wholeNodeSlice(originalMiddle[i]),
                (0, $aPdNQ.Slice).empty
            ],
            appliedIndex: 1,
            kind: 'remove'
        });
    }
    return segments.sort((a, b)=>a.startPos - b.startPos);
};


/**
 * Option F — Post Stream Review Undo/Redo transform + authoritative position
 * writeback.
 *
 * The problem this solves: aggregate Undo/Redo used to store `[startPos,endPos]`
 * and remap them through the undo, but that remap is LOSSY for contiguous
 * same-anchor changes (a run of `add`s undone together collapses to one point and
 * cannot be re-separated on redo). Option F never reconstructs positions from a
 * collapsed value. It:
 *
 *   1. processes the touched segments FORWARD, in document `order`;
 *   2. applies each segment's target slice at the right place: a segment that still
 *      holds content is replaced at its own mapped range; a segment whose current
 *      slice is empty (an undone `add`, or an applied `remove`) is a zero-width
 *      insertion point, anchored by `order` within its run (`groupId`) relative to
 *      the already-present siblings — never its own collapsed/inflated stored range,
 *      which for a run of undone adds all points at the same anchor; and
 *   3. records each resulting range from the ACTUAL net document-size change
 *      (`endPos = to + Δsize`), robust to open / smart / rework slices.
 *
 * It is agnostic to the `slices[] + appliedIndex` history: `targetIndexFor`
 * returns the `appliedIndex` each segment should end at, so the same helper drives
 * step-through Undo/Redo (one segment steps by one) and aggregate Undo/Redo (every
 * non-accepted segment to a policy target — e.g. revert-all → 0, reapply-all →
 * latest).
 */ 



const $b7b80dff187eb6b2$export$ff794085dd86337a = (view, segments, targetIndexFor)=>{
    const docSize = view.state.doc.content.size;
    const targets = segments.map((seg, index)=>({
            seg: seg,
            index: index
        })).filter(({ seg: seg, index: index })=>{
        const target = targetIndexFor(seg, index);
        if (seg.isAccepted || target === seg.appliedIndex || target < 0 || target >= seg.slices.length) return false;
        // A present (non-empty) current slice is replaced in place, so its stored
        // range must be valid. An absent current slice is anchored by `order`, so
        // its (unreliable) stored range is neither used nor bounds-checked.
        if ((0, $7ba54af9843c5cb8$export$27c0418cee04b434)(seg).content.size > 0) return seg.startPos >= 0 && seg.endPos >= seg.startPos && seg.endPos <= docSize;
        return true;
    })// FORWARD document order. `order` was stamped while ranges were distinct;
    // fall back to `startPos` for legacy entries without it.
    .sort((a, b)=>(a.seg.order ?? a.seg.startPos) - (b.seg.order ?? b.seg.startPos));
    if (targets.length === 0) return null;
    // Simulate on a throwaway transaction to compute the ops + authoritative
    // ranges. `beforeTransform` replays the SAME (from,to,slice) ops on the
    // command's transaction, so the recorded positions are exact.
    const sim = view.state.tr;
    const ops = [];
    const positions = [];
    const appliedIndexUpdates = [];
    // Segments applied so far in this walk: raw index -> live range + whether it now
    // holds content. Consulted (alongside not-yet-touched siblings) when anchoring an
    // absent segment by order, so same-run siblings applied earlier in this walk count.
    const walk = new Map();
    // Live range + presence of a sibling, accounting for this walk's inserts.
    const liveOf = (otherIndex)=>{
        const applied = walk.get(otherIndex);
        if (applied) return applied;
        const other = segments[otherIndex];
        if ((0, $7ba54af9843c5cb8$export$27c0418cee04b434)(other).content.size === 0) return {
            endPos: 0,
            present: false,
            startPos: 0
        };
        const a = sim.mapping.map(other.startPos, 1);
        const b = sim.mapping.map(other.endPos, -1);
        return {
            endPos: Math.max(a, b),
            present: true,
            startPos: Math.min(a, b)
        };
    };
    // Insertion anchor for an ABSENT segment (empty current slice): right after the
    // furthest-along present sibling in the SAME run (`groupId`) with a smaller
    // `order`; otherwise the segment's own mapped anchor (which places it before any
    // later content already at that anchor). Re-materialises a collapsed run in order
    // without trusting the segment's own collapsed/inflated stored range.
    const anchorForAbsent = (seg, selfIndex)=>{
        const selfOrder = seg.order ?? seg.startPos;
        let anchor = null;
        if (seg.groupId != null) for(let i = 0; i < segments.length; i++){
            const other = segments[i];
            if (i === selfIndex || other.groupId !== seg.groupId) continue;
            if ((other.order ?? other.startPos) >= selfOrder) continue;
            const lr = liveOf(i);
            if (lr.present && (anchor === null || lr.endPos > anchor)) anchor = lr.endPos;
        }
        return anchor ?? sim.mapping.map(seg.startPos, 1);
    };
    for (const { seg: seg, index: index } of targets){
        const target = targetIndexFor(seg, index);
        const slice = seg.slices[target] ?? (0, $aPdNQ.Slice).empty;
        let from;
        let to;
        if ((0, $7ba54af9843c5cb8$export$27c0418cee04b434)(seg).content.size > 0) {
            // Real content in the doc — replace its own mapped range.
            from = sim.mapping.map(seg.startPos, 1);
            to = Math.max(from, sim.mapping.map(seg.endPos, -1));
        } else // Absent (undone `add` / applied `remove`): a zero-width insertion point.
        from = to = anchorForAbsent(seg, index);
        const before = sim.doc.content.size;
        try {
            sim.replaceRange(from, to, slice);
        } catch  {
            continue;
        }
        const endPos = to + (sim.doc.content.size - before);
        ops.push({
            from: from,
            to: to,
            slice: slice
        });
        positions.push({
            index: index,
            startPos: from,
            endPos: endPos
        });
        appliedIndexUpdates.push({
            index: index,
            appliedIndex: target
        });
        walk.set(index, {
            endPos: endPos,
            present: slice.content.size > 0,
            startPos: from
        });
    }
    if (ops.length === 0) return null;
    // Modal anchor, in PRE-transform coordinates (the decoration plugin maps it
    // through `beforeTransform`). For a single op — step-through, or an aggregate
    // toggle that touched one segment — use the op's own range: that is where the
    // content actually lands, whereas the segment's stored range may be collapsed or
    // inflated for an undone `add`. For multiple ops, span the touched segments'
    // stored ranges (for a fully-collapsed run they share one anchor, which maps to
    // the whole re-inserted block).
    const anchor = ops.length === 1 ? {
        startPos: ops[0].from,
        endPos: ops[0].to
    } : {
        startPos: Math.min(...targets.map(({ seg: seg })=>seg.startPos)),
        endPos: Math.max(...targets.map(({ seg: seg })=>seg.endPos))
    };
    const beforeTransform = (tr)=>{
        for (const op of ops)try {
            tr.replaceRange(op.from, op.to, op.slice);
        } catch  {
        // A concurrent edit invalidated the op — skip it (its writeback is
        // harmless: the generic remap still moves the untouched entry).
        }
        return tr;
    };
    return {
        anchor: anchor,
        appliedIndexUpdates: appliedIndexUpdates,
        beforeTransform: beforeTransform,
        positions: positions
    };
};


/**
 * Helpers for the Post Stream Review toolbar's "View changes" button, which drives
 * `editor-plugin-show-diff`'s `showDiff` with `{ originalDoc, steps }` — the
 * pre-edit doc and forward (`original → live`) steps (non-inverted contract).
 *
 * Instead of a JSON tree-diff, we reconstruct the pre-edit doc from stored data:
 * take the live doc, replace the segment range(s) with the stored
 * `originalUserContentSlice` (a throwaway `tr`) to get `originalDoc`, then derive
 * the forward steps as the INVERSE of that transform
 * (`tr.steps.map((s, i) => s.invert(tr.docs[i])).reverse()`). Applying them to
 * `originalDoc` reproduces the live doc exactly, so no bias-sensitive re-mapping
 * of the new range is needed.
 *
 * Pure: never dispatches, mutates state, or opens the modal. The caller forwards
 * the result to `showDiff(...)` with `isInverted: false`.
 */ 
const $4cf7589a720358c3$export$36fcf101941045df = (editorView, segment)=>{
    const { state: state } = editorView;
    const { doc: doc } = state;
    if (!segment?.slices || segment.slices.length === 0 || // `== null` (not `!`): `startPos === 0` is a valid PM document position
    // (the very start of the doc). Using `!startPos` would silently disable
    // View Changes for any segment whose content begins at position 0.
    segment.startPos == null || segment.endPos == null) return null;
    // Bounds check: `tr.replaceRange` would throw on out-of-bounds positions.
    if (segment.startPos < 0 || segment.endPos < segment.startPos || segment.endPos > doc.content.size) return null;
    // Reconstruct the pre-edit doc for this segment as a *throwaway* transform —
    // we never dispatch it. `state.tr` is the canonical way to get a Transform
    // pre-configured with the right schema + doc.
    try {
        const tr = state.tr;
        tr.replaceRange(segment.startPos, segment.endPos, (0, $7ba54af9843c5cb8$export$dee11abf78a51a07)(segment));
        const originalDoc = tr.doc;
        // The forward `original → live` steps are the INVERSE of the reconstruction:
        // invert each step against the doc it applied to and reverse the order.
        // Applying them to `originalDoc` reproduces the live doc EXACTLY
        // (ProseMirror's invert contract), so `showDiff`'s stepped-doc === live
        // check always holds — no bias-sensitive re-mapping of the new range, which
        // mis-brackets zero-width (remove) ranges and ranges adjacent to inserts.
        const steps = tr.steps.map((step, index)=>step.invert(tr.docs[index])).reverse();
        return {
            originalDoc: originalDoc,
            steps: steps
        };
    } catch  {
    // Most likely cause: schema rejected the original slice because the
    // surrounding context has changed in a way that no longer accepts it.
    // We bail out — the caller will leave the button as a no-op.
    // TODO: CCI-15904 - fire a `viewChangesDiffFailed` analytics event from
    // the caller so we can monitor real-world breakage rates.
    }
    return null;
};
const $4cf7589a720358c3$export$397513808d2b4602 = (segments)=>{
    const indexed = segments.map((seg, index)=>({
            seg: seg,
            index: index
        }));
    // Sort by start (then commit order) so overlapping entries sit adjacent.
    indexed.sort((a, b)=>a.seg.startPos - b.seg.startPos || a.index - b.index);
    const merged = [];
    let group = [];
    let groupEnd = -1;
    const flush = ()=>{
        if (group.length === 0) return;
        if (group.length === 1) merged.push(group[0].seg);
        else {
            const earliest = group.reduce((a, b)=>a.index <= b.index ? a : b);
            const latest = group.reduce((a, b)=>a.index >= b.index ? a : b);
            // The net change for the overlap group is earliest-original → latest-applied.
            // Emit a fresh two-slice history with the applied (new) slice selected.
            const originalSlice = (0, $7ba54af9843c5cb8$export$dee11abf78a51a07)(earliest.seg);
            const appliedSlice = (0, $7ba54af9843c5cb8$export$27c0418cee04b434)(latest.seg);
            merged.push({
                startPos: latest.seg.startPos,
                endPos: latest.seg.endPos,
                slices: [
                    originalSlice,
                    appliedSlice
                ],
                appliedIndex: 1,
                kind: originalSlice.content.size === 0 ? 'add' : appliedSlice.content.size === 0 ? 'remove' : 'update'
            });
        }
        group = [];
    };
    for (const item of indexed){
        // A strictly-earlier start that is still before the running group end means
        // the ranges overlap (touching at a boundary — `startPos === groupEnd` — is
        // NOT an overlap; adjacent distinct nodes must stay separate).
        if (group.length > 0 && item.seg.startPos >= groupEnd) flush();
        group.push(item);
        groupEnd = group.length === 1 ? item.seg.endPos : Math.max(groupEnd, item.seg.endPos);
    }
    flush();
    return merged;
};
const $4cf7589a720358c3$export$3a470f2f98a0c36 = (editorView, segments)=>{
    const { state: state } = editorView;
    const { doc: doc } = state;
    const applicable = (segments ?? []).filter((s)=>s && // Only entries currently showing a change (not at their original slice)
        // contribute to the diff; `appliedIndex === 0` already shows the original.
        (0, $7ba54af9843c5cb8$export$599958c5ce1f5bfc)(s) && s.slices && s.startPos != null && s.endPos != null && s.startPos >= 0 && s.endPos >= s.startPos && s.endPos <= doc.content.size);
    if (applicable.length === 0) return null;
    try {
        // Pass 1 — reconstruct the pre-edit doc. Apply originals back-to-front so
        // earlier replaces don't shift the positions of later (earlier-in-doc) ones.
        //
        // This relies on `segments` being DISJOINT — overlapping entries (the same
        // node edited by multiple tool calls) must be collapsed by
        // `mergeOverlappingSegments` before they reach here, otherwise the
        // back-to-front replaces corrupt each other's positions. The Post Stream
        // Review screen does this once when deriving `coarseSegments`.
        const descending = [
            ...applicable
        ].sort((a, b)=>b.startPos - a.startPos);
        const tr = state.tr;
        for (const seg of descending)tr.replaceRange(seg.startPos, seg.endPos, (0, $7ba54af9843c5cb8$export$dee11abf78a51a07)(seg));
        const originalDoc = tr.doc;
        // Pass 2 — forward (original → live) steps are the INVERSE of pass 1: invert
        // each step against the doc it applied to, reversed. Applying them to
        // `originalDoc` reproduces the live doc EXACTLY (PM invert contract).
        //
        // Re-applying each `newSlice` at a re-mapped range (the previous approach)
        // drifts when an inserted segment and an adjacent removal map to coincident
        // positions — the removal's range engulfs the just-inserted content, so the
        // stepped doc ≠ live and `showDiff` renders nothing. The inverse can't drift.
        const steps = tr.steps.map((step, index)=>step.invert(tr.docs[index])).reverse();
        return {
            originalDoc: originalDoc,
            steps: steps
        };
    } catch  {
    // Schema rejection or stale positions — leave View changes as a no-op.
    }
    return null;
};



/* AcceptedToast.tsx generated by @compiled/babel-plugin v2.0.0 */ 








/* icons.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $eh6Ml = parcelRequire("eh6Ml");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $bAKDg = parcelRequire("bAKDg");


var $kUFQ0 = parcelRequire("kUFQ0");




const $1e6ab393bbafb605$export$8effd613cafc3b5b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.75 2.0089L0.750001 6.41575C0.750001 7.24418 1.42158 7.91575 2.25 7.91575L7.54594 7.91574M4.79074 5.16053L7.54594 7.91574L4.79074 10.9209",
        stroke: "#505258",
        "stroke-width": "1.5",
        "stroke-linejoin": "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.25001 2.75H16",
        stroke: "#505258",
        "stroke-width": "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.75001 8C12.4837 8 13.2663 8 16 8",
        stroke: "#505258",
        "stroke-width": "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M4.25001 13.25H16",
        stroke: "#505258",
        "stroke-width": "1.5"
    }));
};


const $bf520c5d07f0f1e1$export$6bbc7e6c4947ba19 = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
const $bf520c5d07f0f1e1$export$42a4add5887bcdcb = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
        label: ""
    });
const $bf520c5d07f0f1e1$export$d23b8760f033769b = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($bAKDg))), {
        label: ""
    });
const $bf520c5d07f0f1e1$export$6781454d37fb126f = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
        label: ""
    });
const $bf520c5d07f0f1e1$export$1b0ad15b32547a2e = ()=>/*#__PURE__*/ $cozmU.createElement((0, $1e6ab393bbafb605$export$8effd613cafc3b5b), null);
const $bf520c5d07f0f1e1$export$f34212d9b63ae998 = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        label: "",
        size: "small"
    });
const $bf520c5d07f0f1e1$export$ebc383bb12048a63 = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        size: "small"
    });





const $5162eb24f9d4c228$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    undo: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.undo",
        defaultMessage: "Undo"
    },
    redo: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.redo",
        defaultMessage: "Redo"
    },
    viewChanges: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.viewChanges",
        defaultMessage: "Compare with original"
    },
    hideChanges: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.hideChanges",
        defaultMessage: "Only show suggestion"
    },
    segmentPosition: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.segmentPosition",
        defaultMessage: "{current} / {total}"
    },
    previousChange: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.previousChange",
        defaultMessage: "Go to previous"
    },
    nextChange: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.nextChange",
        defaultMessage: "Go to next"
    },
    stepThrough: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.stepThrough",
        defaultMessage: "Step through all changes"
    },
    accepted: {
        id: "editor-plugin-ai.SessionUI.screens.PostStreamReview.accepted",
        defaultMessage: "Accepted"
    }
});


const $c746d903466c4e2e$var$ACCEPTED_TOAST_DURATION_MS = 2000; /** Fade-in duration (matches the modal's entrance feel). */ 
const $c746d903466c4e2e$var$FADE_IN_MS = 200; /** Fade-out duration; the teardown fires once it completes. */ 
const $c746d903466c4e2e$var$FADE_OUT_MS = 400; /**
                          * Height (px) of the pill — kept equal to the review toolbar's height (the
                          * `DEFAULT_REVIEW_MODAL_HEIGHT` fallback in `index.tsx`) so the confirmation keeps
                          * the same footprint as the Review moment it replaces.
                          */ 
const $c746d903466c4e2e$var$REVIEW_TOOLBAR_HEIGHT = 56;
const $c746d903466c4e2e$var$fadeIn = null;
const $c746d903466c4e2e$var$fadeOut = null;
const $c746d903466c4e2e$var$shimmer = null; // Full-width row so the (narrow) pill centers horizontally within the ModalRegion
// container, which already sits at the Review moment's top.
const $c746d903466c4e2e$var$rowCSS = null;
const $c746d903466c4e2e$var$pillCSS = null;
const $c746d903466c4e2e$var$pillLeavingCSS = null;
const $c746d903466c4e2e$var$shimmerTextCSS = null; /**
                              * Renders the "Accepted" confirmation pill. `onDone` fires once the pill has
                              * finished its on-screen lifetime (fade-out complete); the caller uses it to tear
                              * the Review moment session down.
                              */ 
function $c746d903466c4e2e$export$8a7e73cd1b8e3baf({ onDone: onDone }) {
    const intl = (0, $kSwu1.useIntl)();
    const [isLeaving, setIsLeaving] = (0, $cozmU.useState)(false); // Read `onDone` through a ref so the lifetime timers are set up exactly once
    // (on mount) and never restart if the callback identity changes.
    const onDoneRef = (0, $cozmU.useRef)(onDone);
    onDoneRef.current = onDone;
    (0, $cozmU.useEffect)(()=>{
        const leaveTimer = setTimeout(()=>setIsLeaving(true), $c746d903466c4e2e$var$ACCEPTED_TOAST_DURATION_MS - $c746d903466c4e2e$var$FADE_OUT_MS);
        const doneTimer = setTimeout(()=>onDoneRef.current(), $c746d903466c4e2e$var$ACCEPTED_TOAST_DURATION_MS);
        return ()=>{
            clearTimeout(leaveTimer);
            clearTimeout(doneTimer);
        };
    }, []);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _39xV02N91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        role: "status",
        "aria-live": "polite",
        "data-testid": "post-stream-review-accepted-toast",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _0bjKvD8fU6 _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VmdCj _24h04i2Njc _1Znuxb5zaO _2Zuz6Q5zaO _0KLXruoI2d _2OUyjtGk8v _1pp6NdYbGa _1gBibyZMPz _0nFVCG2HTN _43vdfT1fFG _3Y6bKpZSoF _442RFUYbGa",
            isLeaving && "",
            isLeaving && "_1gBibyfsJg _0nFVCGpFbM _43vdfTDgop _3Y6bKpgRhm _442RFUYbGa"
        ])
    }, (0, $bf520c5d07f0f1e1$export$6bbc7e6c4947ba19)(), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1kk5Tkf7mX _3CkH9ovuzz _3OqcjTzGaF _02U3A5JxkL _07XDTDJxkL _1CY1NjjOvk _1gBibyvmhm _0nFVCGFSlo _43vdfTHVQb _03m2nySHWH _442RFUYbGa _2ZZlvhy7kJ _2PwI1By7kJ"
        ])
    }, intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).accepted))));
}


/* AskRovo.tsx generated by @compiled/babel-plugin v2.0.0 */ 





















































const $ebb5c44f44233ad5$var$promptEditorWrapperStylesUnbounded = null;
const $ebb5c44f44233ad5$var$promptEditorWrapperStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ebb5c44f44233ad5$var$promptEditorWrapperOverflowStyles = null; // The types PromptEditorType should mirror what is in the editor-ai-injected-editors package
const $ebb5c44f44233ad5$export$b0a649d08575ac09 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { type: type, PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, submit: submit, isAIFC: isAIFC } = t0;
    let t1;
    if ($[0] !== blurInputRef || $[1] !== focusInputRef) {
        t1 = (blur, focus)=>{
            if (blurInputRef) blurInputRef.current = blur;
            if (focusInputRef) focusInputRef.current = focus;
        };
        $[0] = blurInputRef;
        $[1] = focusInputRef;
        $[2] = t1;
    } else t1 = $[2];
    const setFocusHandlers = t1;
    let t2;
    if ($[3] !== clearInputRef) {
        t2 = (clear)=>{
            if (clearInputRef) clearInputRef.current = clear;
        };
        $[3] = clearInputRef;
        $[4] = t2;
    } else t2 = $[4];
    const setClearHandler = t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $03RpJ.default)();
        $[5] = t3;
    } else t3 = $[5];
    const componentId = `${placeholder}-${t3}`;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbgBM8 _1mT5xdRAKS",
            "_3yHL5ISPN1 _1aa6DDdnbC _2xMCTYdnbC _1J4xRHIZbP _0SF6c3dnbC _0ahCu7dnbC",
            "_27LWqD7nsb _3yHL5IoWWg"
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== PromptEditor || $[8] !== autoFocus || $[9] !== componentId || $[10] !== defaultValue || $[11] !== enableLinks || $[12] !== isAIFC || $[13] !== onADFChange || $[14] !== onInputChange || $[15] !== placeholder || $[16] !== setClearHandler || $[17] !== setFocusHandlers || $[18] !== submit || $[19] !== type) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)(PromptEditor, {
            type: type,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            placeholder: placeholder,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            setFocusHandlers: setFocusHandlers,
            setClearHandler: setClearHandler,
            enableLinks: enableLinks,
            submit: submit,
            isAIFC: isAIFC
        }, componentId);
        $[7] = PromptEditor;
        $[8] = autoFocus;
        $[9] = componentId;
        $[10] = defaultValue;
        $[11] = enableLinks;
        $[12] = isAIFC;
        $[13] = onADFChange;
        $[14] = onInputChange;
        $[15] = placeholder;
        $[16] = setClearHandler;
        $[17] = setFocusHandlers;
        $[18] = submit;
        $[19] = type;
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== onBlur || $[22] !== onCompositionEnd || $[23] !== onCompositionStart || $[24] !== onFocus || $[25] !== onKeyDown || $[26] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "ai-experience-prompt-input",
            role: "presentation",
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur,
            onCompositionStart: onCompositionStart,
            onCompositionEnd: onCompositionEnd,
            className: t4,
            children: t5
        });
        $[21] = onBlur;
        $[22] = onCompositionEnd;
        $[23] = onCompositionStart;
        $[24] = onFocus;
        $[25] = onKeyDown;
        $[26] = t5;
        $[27] = t6;
    } else t6 = $[27];
    return t6;
} : ({ type: type, PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, submit: submit, isAIFC: isAIFC })=>{
    const setFocusHandlers = (0, $cozmU.useCallback)((blur, focus)=>{
        if (blurInputRef) blurInputRef.current = blur;
        if (focusInputRef) focusInputRef.current = focus;
    }, [
        blurInputRef,
        focusInputRef
    ]);
    const setClearHandler = (0, $cozmU.useCallback)((clear)=>{
        if (clearInputRef) clearInputRef.current = clear;
    }, [
        clearInputRef
    ]); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const componentId = (0, $cozmU.useMemo)(()=>`${placeholder}-${(0, $03RpJ.default)()}`, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": "ai-experience-prompt-input",
        role: "presentation",
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbgBM8 _1mT5xdRAKS",
            "_3yHL5ISPN1 _1aa6DDdnbC _2xMCTYdnbC _1J4xRHIZbP _0SF6c3dnbC _0ahCu7dnbC",
            "_27LWqD7nsb _3yHL5IoWWg"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(PromptEditor, {
            type: type,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            placeholder: placeholder,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            setFocusHandlers: setFocusHandlers,
            setClearHandler: setClearHandler,
            enableLinks: enableLinks,
            submit: submit,
            isAIFC: isAIFC
        }, componentId)
    });
};

















const $fd5c85d7e46f56f7$export$5bd740881e6fb7a0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (ref, onEscape)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== onEscape || $[1] !== ref) {
        t0 = ()=>{
            const el = ref.current;
            if (!el) return;
            return (0, $cbY7C.bindAll)(el, [
                {
                    type: "keydown",
                    listener: (e)=>{
                        if (e.key !== "Escape") return;
                        e.preventDefault();
                        e.stopPropagation();
                        onEscape();
                    }
                },
                {
                    type: "keyup",
                    listener: $fd5c85d7e46f56f7$var$_temp
                }
            ]);
        };
        t1 = [
            ref,
            onEscape
        ];
        $[0] = onEscape;
        $[1] = ref;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
} : (ref, onEscape)=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        return (0, $cbY7C.bindAll)(el, [
            {
                type: 'keydown',
                listener: (e)=>{
                    if (e.key !== 'Escape') return;
                    e.preventDefault();
                    e.stopPropagation();
                    onEscape();
                }
            },
            {
                type: 'keyup',
                listener: (e_0)=>{
                    if (e_0.key !== 'Escape') return;
                    e_0.preventDefault();
                    e_0.stopPropagation();
                }
            }
        ]);
    }, [
        ref,
        onEscape
    ]);
};
const $fd5c85d7e46f56f7$export$de98eaf87477cf67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (submit, text)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== text) {
        t0 = text?.trim().length;
        $[0] = text;
        $[1] = t0;
    } else t0 = $[1];
    const isDisabled = Boolean(t0 === 0);
    let t1;
    if ($[2] !== isDisabled || $[3] !== submit) {
        t1 = (e)=>{
            if (e.key === "Enter" && !e.shiftKey && !isDisabled) {
                e.preventDefault();
                submit();
            }
        };
        $[2] = isDisabled;
        $[3] = submit;
        $[4] = t1;
    } else t1 = $[4];
    const onKeyDown = t1;
    let t2;
    if ($[5] !== isDisabled || $[6] !== onKeyDown) {
        t2 = {
            isDisabled: isDisabled,
            onKeyDown: onKeyDown
        };
        $[5] = isDisabled;
        $[6] = onKeyDown;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (submit, text)=>{
    const isDisabled = Boolean(text?.trim().length === 0);
    const onKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey && !isDisabled) {
            e.preventDefault();
            submit();
        }
    }, [
        isDisabled,
        submit
    ]);
    return {
        isDisabled: isDisabled,
        onKeyDown: onKeyDown
    };
};
function $fd5c85d7e46f56f7$var$_temp(e_0) {
    if (e_0.key !== "Escape") return;
    e_0.preventDefault();
    e_0.stopPropagation();
}





const $c5d5343f64662501$var$message = (0, $kSwu1.defineMessages)({
    insertMenuTriggerLabel: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel",
        defaultMessage: "Insert rich content"
    },
    insertMenuAddLink: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink",
        defaultMessage: "Add link"
    },
    insertMenuMention: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.mention",
        defaultMessage: "Mention user"
    },
    promptRecord: {
        id: "fabric.editor.ai.screens.prompt.streaming.record",
        defaultMessage: "Record"
    },
    promptSubmit: {
        id: "fabric.editor.ai.screens.prompt.streaming.submit",
        defaultMessage: "Submit"
    },
    promptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.placeholder",
        defaultMessage: "Describe what you want to do"
    },
    inlineCommentPromptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.inlineCommentPlaceholder",
        defaultMessage: "Describe what to do"
    }
});
var $c5d5343f64662501$export$2e2bcd8739ae039 = $c5d5343f64662501$var$message;


const $6593db5854c11409$var$container = {
    padding: "_2Y7lL45zaO _4c065U8HPE"
};
const $6593db5854c11409$export$eddbff457ab4038b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { textInput: textInput, adfInput: adfInput, onTextChange: onTextChange, onADFChange: onADFChange, submit: submit, cancel: cancel, PromptEditor: PromptEditor, appearance: appearance, isAIFC: isAIFC } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const screenRef = (0, $cozmU.useRef)(null);
    (0, $fd5c85d7e46f56f7$export$5bd740881e6fb7a0)(screenRef, cancel);
    const { onKeyDown: onKeyDown } = (0, $fd5c85d7e46f56f7$export$de98eaf87477cf67)(submit, textInput);
    const [setBreakpointsElement, t1] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const { breakpoint: breakpoint } = t1;
    let t2;
    if ($[0] !== breakpoint || $[1] !== intl) {
        t2 = breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? `${intl.formatMessage((0, $c5d5343f64662501$export$2e2bcd8739ae039).inlineCommentPromptPlaceholder)}...` : `${intl.formatMessage((0, $c5d5343f64662501$export$2e2bcd8739ae039).promptPlaceholder)}...`;
        $[0] = breakpoint;
        $[1] = intl;
        $[2] = t2;
    } else t2 = $[2];
    const placeholder = t2;
    let t3;
    if ($[3] !== setBreakpointsElement) {
        t3 = (element)=>{
            screenRef.current = element;
            setBreakpointsElement(element);
        };
        $[3] = setBreakpointsElement;
        $[4] = t3;
    } else t3 = $[4];
    const setRootContainer = t3;
    const t4 = isAIFC ? undefined : onKeyDown;
    let t5;
    if ($[5] !== PromptEditor || $[6] !== adfInput || $[7] !== isAIFC || $[8] !== onADFChange || $[9] !== onTextChange || $[10] !== placeholder || $[11] !== submit || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            xcss: $6593db5854c11409$var$container.padding,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ebb5c44f44233ad5$export$b0a649d08575ac09), {
                autoFocus: true,
                PromptEditor: PromptEditor,
                type: "user-input",
                defaultValue: adfInput,
                onInputChange: onTextChange,
                onADFChange: onADFChange,
                placeholder: placeholder,
                enableLinks: true,
                onKeyDown: t4,
                submit: submit,
                isAIFC: isAIFC
            })
        });
        $[5] = PromptEditor;
        $[6] = adfInput;
        $[7] = isAIFC;
        $[8] = onADFChange;
        $[9] = onTextChange;
        $[10] = placeholder;
        $[11] = submit;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== appearance || $[15] !== isAIFC || $[16] !== setRootContainer || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
            ref: setRootContainer,
            "data-testid": "prompt-form-screen",
            disablePadding: true,
            rainbowBorder: false,
            enableMaxHeight: true,
            appearance: appearance,
            isAIFC: isAIFC,
            children: t5
        });
        $[14] = appearance;
        $[15] = isAIFC;
        $[16] = setRootContainer;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ textInput: textInput, adfInput: adfInput, onTextChange: onTextChange, onADFChange: onADFChange, submit: submit, cancel: cancel, PromptEditor: PromptEditor, appearance: appearance, isAIFC: isAIFC })=>{
    const intl = (0, $kSwu1.useIntl)();
    const screenRef = (0, $cozmU.useRef)(null);
    (0, $fd5c85d7e46f56f7$export$5bd740881e6fb7a0)(screenRef, cancel);
    const { onKeyDown: onKeyDown } = (0, $fd5c85d7e46f56f7$export$de98eaf87477cf67)(submit, textInput);
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const placeholder = breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? `${intl.formatMessage((0, $c5d5343f64662501$export$2e2bcd8739ae039).inlineCommentPromptPlaceholder)}...` : `${intl.formatMessage((0, $c5d5343f64662501$export$2e2bcd8739ae039).promptPlaceholder)}...`;
    const setRootContainer = (element)=>{
        screenRef.current = element;
        setBreakpointsElement(element);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "prompt-form-screen",
        disablePadding: true,
        rainbowBorder: false,
        enableMaxHeight: true,
        appearance: appearance,
        isAIFC: isAIFC,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            xcss: $6593db5854c11409$var$container.padding,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ebb5c44f44233ad5$export$b0a649d08575ac09), {
                autoFocus: true,
                PromptEditor: PromptEditor,
                type: "user-input",
                defaultValue: adfInput,
                onInputChange: onTextChange,
                onADFChange: onADFChange,
                placeholder: placeholder,
                enableLinks: true,
                onKeyDown: isAIFC ? undefined : onKeyDown,
                submit: submit,
                isAIFC: isAIFC
            })
        })
    });
};





















var $7akNQ = parcelRequire("7akNQ");













/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $6cFsl = parcelRequire("6cFsl");

















var $33LwY = parcelRequire("33LwY");








var $aIj6m = parcelRequire("aIj6m");





























var $9jFb0 = parcelRequire("9jFb0");


var $2lEwc = parcelRequire("2lEwc");


var $3MoJD = parcelRequire("3MoJD");


var $i35QN = parcelRequire("i35QN");




const $ab9bf5ae5fbf4637$var$initialState = {
    mode: 'editing',
    modeBeforeHide: null,
    latestTrace: null,
    isCancelling: false,
    error: null,
    agent: null
};
const $ab9bf5ae5fbf4637$var$reducer = (state, action)=>{
    switch(action.type){
        case 'submit':
            return {
                ...state,
                mode: 'thinking',
                latestTrace: null,
                error: null
            };
        case 'trace':
            return {
                ...state,
                latestTrace: action.latestTrace
            };
        case 'cancel':
            return {
                ...state,
                isCancelling: true
            };
        case 'keep':
            return {
                ...state,
                isCancelling: false
            };
        case 'abort':
            return {
                ...state,
                mode: 'editing',
                isCancelling: false,
                latestTrace: null,
                error: null
            };
        case 'complete':
            return {
                ...state,
                mode: action.hideAfterComplete ? 'complete-hidden' : 'editing',
                latestTrace: null,
                error: null
            };
        case 'error':
            return {
                ...state,
                mode: 'error',
                latestTrace: null,
                error: action.error
            };
        case 'success':
            return {
                ...state,
                mode: 'success',
                latestTrace: null,
                error: null
            };
        case 'set-agent':
            return {
                ...state,
                agent: action.agent
            };
        case 'chat-mounted':
            // Already paused — do nothing. Preserve the captured modeBeforeHide.
            if (state.mode === 'hidden') return state;
            return {
                ...state,
                mode: 'hidden',
                modeBeforeHide: state.mode
            };
        case 'chat-unmounted':
            // Not paused — nothing to restore.
            if (state.mode !== 'hidden') return state;
            return {
                ...state,
                mode: state.modeBeforeHide ?? 'editing',
                modeBeforeHide: null
            };
    }
};
const $ab9bf5ae5fbf4637$export$e924b3ae6248b17a = ({ source: source, productKey: productKey, onAbort: onAbort, onError: onError, onSubmit: onSubmit, onComplete: onComplete, onCancel: onCancel, autoClose: autoClose, objectId: objectId, openChatOnError: openChatOnError, creationContextParams: creationContextParams, onBeforeSubmit: onBeforeSubmit, onBeforeComplete: onBeforeComplete, hideAfterComplete: hideAfterComplete })=>{
    (0, $6cFsl.di)((0, $hdBxM.usePublish), (0, $eDWhq.useRovoContentBridgeAPI));
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [{ mode: mode, isCancelling: isCancelling, latestTrace: latestTrace, error: error, agent: agent }, dispatch] = (0, $cozmU.useReducer)($ab9bf5ae5fbf4637$var$reducer, $ab9bf5ae5fbf4637$var$initialState);
    const { mounted: isChatMounted } = (0, $bGNkz.useUIStore)();
    const { ready: ready, send: send } = (0, $eDWhq.useRovoContentBridgeAPI)((0, $2zvMw.ROVO_INLINE_INPUT_BOX_CLIENT_ID), (on)=>{
        on((0, $i35QN.InlineInputBoxTraceMessageCommand), (latestTrace_0)=>{
            dispatch({
                type: 'trace',
                latestTrace: latestTrace_0
            });
        });
        on((0, $2lEwc.InlineInputBoxFinalResponseMessageCommand), ()=>{
            const complete = ()=>{
                dispatch({
                    type: 'complete',
                    hideAfterComplete: hideAfterComplete
                });
                onComplete();
            };
            if (onBeforeComplete) onBeforeComplete(complete);
            else complete();
        });
        on((0, $9jFb0.InlineInputBoxErrorMessageCommand), ({ error: error_0, openChatOnError: shouldOpenChat, conversationId: conversationId })=>{
            if (shouldOpenChat && conversationId) {
                // Abort the inline prompt first (resets mode to 'editing') so that
                // the auto-close effect does not fight with the Side Chat opening.
                dispatch({
                    type: 'abort'
                });
                // Error handoff is not a user cancel: prefer onError so hosts can
                // tear down UI without aborting remix experiences. Kill switch ON
                // restores the legacy onAbort path.
                if (!(0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes') && onError) onError({
                    streamEnded: false
                });
                else onAbort({
                    streamEnded: false
                });
                // Then open the Side Chat to display the error
                publish({
                    type: 'chat-open',
                    source: 'input-prompt-box',
                    data: {
                        channelId: conversationId
                    }
                });
            } else dispatch({
                type: 'error',
                error: error_0.message
            });
        });
    });
    const lastSubmittedInput = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ready();
    }, [
        ready
    ]);
    const abort = (0, $cozmU.useCallback)((endStream = false)=>{
        if (endStream && mode === 'thinking') send((0, $6yHkF.InlineInputBoxAbortMessageCommand), {
            receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
        });
        dispatch({
            type: 'abort'
        });
        onAbort({
            streamEnded: endStream
        });
    }, [
        mode,
        send,
        onAbort
    ]);
    // When `cc-maui-phase-3` is on, hide the inline prompt while keeping the
    // in-flight stream alive when Rovo Chat opens, and restore it when Rovo Chat
    // closes. Otherwise fall back to the legacy auto-close behaviour, which fully
    // aborts the prompt when chat opens.
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('cc-maui-phase-3')) {
            if (isChatMounted && mode !== 'editing' && mode !== 'hidden' && mode !== 'complete-hidden') dispatch({
                type: 'chat-mounted'
            });
            else if (!isChatMounted && mode === 'hidden') dispatch({
                type: 'chat-unmounted'
            });
            return;
        }
        if (isChatMounted && mode !== 'editing' && mode !== 'complete-hidden' && (0, $iDrrr.fg)('platform_inline_rovo_auto_close')) abort();
    }, [
        isChatMounted,
        mode,
        abort
    ]);
    const submit = (params)=>{
        const inlineAgentEditorContextEnabled = (0, $4o0zT.isExperimentEnabled)('platform_inline_rovo_agent_editor_context');
        if (agent?.id) {
            // Always start a new conversation and open the chat when submitting with an agent
            publish({
                type: 'chat-new',
                source: 'ai-mate',
                data: {
                    dialogues: [],
                    prompt: params.prompt,
                    agentId: agent.id,
                    ...inlineAgentEditorContextEnabled && {
                        contentId: objectId,
                        creationContextParams: creationContextParams,
                        mode: {
                            useCurrentPageContext: params.addCurrentPageAsContextUserPreference
                        }
                    }
                }
            });
            // Immediately exit the inline prompt as the sidebar chat should take over
            abort();
            return;
        }
        // Allow the consumer to intercept the submit and handle it differently
        // (e.g. open the Rovo sidebar chat instead of performing an inline AI edit).
        if (onBeforeSubmit?.(params.prompt)) {
            abort();
            return;
        }
        const input = {
            ...params,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            prompt: params.prompt,
            productKey: // TODO: DocNode isn't compatible with the bridge's SerializableValue
            productKey,
            source: source,
            receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
            contentId: objectId,
            agentId: agent?.id,
            openChatOnError: openChatOnError,
            creationContextParams: creationContextParams
        };
        lastSubmittedInput.current = input;
        send((0, $3MoJD.InlineInputBoxSendMessageCommand), input);
        if (isChatMounted && (0, $iDrrr.fg)('platform_inline_rovo_auto_close')) // If the side nav is already open, let the chat take over and close the inline prompt
        abort();
        else {
            // Keep the inline prompt open if the side nav isn't open yet
            dispatch({
                type: 'submit'
            });
            onSubmit?.(()=>{
                // Pass skipWarning since this callback is used by global escape handlers during thinking state
                cancelRef.current({
                    skipWarning: true
                });
            });
        }
    };
    const resubmit = ()=>{
        if (lastSubmittedInput.current) {
            send((0, $3MoJD.InlineInputBoxSendMessageCommand), lastSubmittedInput.current);
            dispatch({
                type: 'submit'
            });
        }
    };
    const keep = (0, $cozmU.useCallback)(()=>{
        dispatch({
            type: 'keep'
        });
    }, []);
    const cancel = (0, $cozmU.useCallback)((options)=>{
        if (!onCancel || mode === 'editing') abort(true);
        else if (isCancelling) keep();
        else if (options?.skipWarning && mode === 'thinking') // When skipWarning is true and in thinking mode, abort immediately without showing warning
        abort(true);
        else {
            dispatch({
                type: 'cancel'
            });
            onCancel();
        }
    }, [
        onCancel,
        mode,
        isCancelling,
        abort,
        keep
    ]);
    const cancelRef = (0, $cozmU.useRef)(cancel);
    (0, $cozmU.useEffect)(()=>{
        cancelRef.current = cancel;
    }, [
        cancel
    ]);
    const setAgent = (agent_0)=>{
        dispatch({
            type: 'set-agent',
            agent: agent_0
        });
    };
    return {
        mode: mode,
        isCancelling: isCancelling,
        latestTrace: latestTrace,
        error: error,
        submit: submit,
        resubmit: resubmit,
        cancel: cancel,
        keep: keep,
        abort: abort,
        autoClose: autoClose ?? true,
        agent: agent,
        setAgent: setAgent
    };
};





















var $l3wuH = parcelRequire("l3wuH");





var $fgCwN = parcelRequire("fgCwN");




const $15988e2f0e3656b6$var$message = (0, $kSwu1.defineMessages)({
    removeAgentLabel: {
        id: "ai-mate.inline-chat-input.remove-agent",
        defaultMessage: "Remove agent"
    }
});
var $15988e2f0e3656b6$export$2e2bcd8739ae039 = $15988e2f0e3656b6$var$message;


const $7196c6d7922df5e6$var$styles = {
    agentHeader: "_2sNsIgEqul _2Y7lL45zaO _4c065U2ADO _39xV02N91d _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _0jFU0VpJKa _0KLXrumhAQ _2C2kUQuMRm _1Lz9louMRm",
    compact: "_2Y7lL48HPE"
};
const $7196c6d7922df5e6$export$24238a3d65fa333 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { agent: agent, removeAgent: removeAgent, compact: compact } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = compact && $7196c6d7922df5e6$var$styles.compact;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $w6R6I.cx)($7196c6d7922df5e6$var$styles.agentHeader, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== agent) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $fgCwN.PromptAgentAvatar), {
            agent: agent
        });
        $[2] = agent;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== agent.name) {
        t4 = /*#__PURE__*/ $cozmU.createElement("span", null, agent.name);
        $[4] = agent.name;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, t3, t4);
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== formatMessage) {
        t6 = formatMessage((0, $15988e2f0e3656b6$export$2e2bcd8739ae039).removeAgentLabel);
        $[9] = formatMessage;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== removeAgent || $[12] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t6,
            appearance: "subtle",
            onClick: removeAgent
        });
        $[11] = removeAgent;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t2 || $[15] !== t5 || $[16] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: t2,
            spread: "space-between",
            alignBlock: "center"
        }, t5, t7);
        $[14] = t2;
        $[15] = t5;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ agent: agent, removeAgent: removeAgent, compact: compact })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($7196c6d7922df5e6$var$styles.agentHeader, compact && $7196c6d7922df5e6$var$styles.compact),
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $fgCwN.PromptAgentAvatar), {
        agent: agent
    }), /*#__PURE__*/ $cozmU.createElement("span", null, agent.name)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $15988e2f0e3656b6$export$2e2bcd8739ae039).removeAgentLabel),
        appearance: "subtle",
        onClick: removeAgent
    }));
};





const $45e141a8abc0ab5e$var$messages = (0, $kSwu1.defineMessages)({
    dialogAriaLabel: {
        id: "ai-mate.chat-input.aria-label",
        defaultMessage: "Rovo chat dialog"
    }
});
var $45e141a8abc0ab5e$export$2e2bcd8739ae039 = $45e141a8abc0ab5e$var$messages;


















var $24dy7 = parcelRequire("24dy7");


var $7vK9E = parcelRequire("7vK9E");




var $doA2E = parcelRequire("doA2E");

const $01c04f02869cc358$var$styles = {
    message: "_1UtDYzy7kJ",
    actions: "_2XsHFMIZbP"
};
const $01c04f02869cc358$export$8c68b6013ae44ca6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { error: error, onClose: onClose, onTryAgain: onTryAgain } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== error?.message_template || $[1] !== formatMessage) {
        t1 = ()=>{
            switch(error?.message_template){
                case "RATE_LIMIT":
                    return formatMessage((0, $doA2E.default).rateLimited, {
                        a: $01c04f02869cc358$var$_temp
                    });
                case "ACCEPTABLE_USE_VIOLATIONS":
                    return formatMessage((0, $doA2E.default).aupViolation, {
                        a: $01c04f02869cc358$var$_temp2
                    });
                case "TOKEN_LIMIT_EXCEEDED":
                    return formatMessage((0, $doA2E.default).tokenLimitExceeded);
            }
            return formatMessage((0, $doA2E.default).unknownError);
        };
        $[0] = error?.message_template;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const renderErrorMessage = t1;
    let t2;
    if ($[3] !== error || $[4] !== formatMessage || $[5] !== onClose || $[6] !== onTryAgain) {
        t2 = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: onClose
            }, formatMessage((0, $doA2E.default).closeButtonLabel)), $01c04f02869cc358$var$canRetry(error) && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: onTryAgain
            }, formatMessage((0, $doA2E.default).retryButtonLabel)));
        $[3] = error;
        $[4] = formatMessage;
        $[5] = onClose;
        $[6] = onTryAgain;
        $[7] = t2;
    } else t2 = $[7];
    const renderButtons = t2;
    let t3;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            color: "var(--ds-icon-danger, #C9372C)",
            spacing: "spacious",
            size: "medium",
            label: ""
        });
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== renderErrorMessage) {
        t4 = renderErrorMessage();
        $[9] = renderErrorMessage;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $01c04f02869cc358$var$styles.message
        }, t3, /*#__PURE__*/ $cozmU.createElement("span", null, t4));
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== renderButtons) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            xcss: $01c04f02869cc358$var$styles.actions
        }, renderButtons());
        $[13] = renderButtons;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ error: error, onClose: onClose, onTryAgain: onTryAgain })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderErrorMessage = ()=>{
        switch(error?.message_template){
            case 'RATE_LIMIT':
                return formatMessage((0, $doA2E.default).rateLimited, {
                    a: (chunks_0)=>{
                        return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
                            href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                            target: "_blank"
                        }, chunks_0);
                    }
                });
            case 'ACCEPTABLE_USE_VIOLATIONS':
                return formatMessage((0, $doA2E.default).aupViolation, {
                    a: (chunks)=>{
                        return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
                            href: "https://www.atlassian.com/legal/acceptable-use-policy",
                            target: "_blank"
                        }, chunks);
                    }
                });
            case 'TOKEN_LIMIT_EXCEEDED':
                return formatMessage((0, $doA2E.default).tokenLimitExceeded);
        }
        return formatMessage((0, $doA2E.default).unknownError);
    };
    const renderButtons = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: onClose
        }, formatMessage((0, $doA2E.default).closeButtonLabel)), $01c04f02869cc358$var$canRetry(error) && /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "default",
            onClick: onTryAgain
        }, formatMessage((0, $doA2E.default).retryButtonLabel)));
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $01c04f02869cc358$var$styles.message
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        spacing: "spacious",
        size: "medium",
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement("span", null, renderErrorMessage())), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $01c04f02869cc358$var$styles.actions
    }, renderButtons()));
};
const $01c04f02869cc358$var$canRetry = (error)=>{
    return error?.message_template !== 'RATE_LIMIT' && error?.message_template !== 'ACCEPTABLE_USE_VIOLATIONS';
};
function $01c04f02869cc358$var$_temp(chunks_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
        target: "_blank"
    }, chunks_0);
}
function $01c04f02869cc358$var$_temp2(chunks) {
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: "https://www.atlassian.com/legal/acceptable-use-policy",
        target: "_blank"
    }, chunks);
}



var $2zysC = parcelRequire("2zysC");
























const $8066124509c7a4ea$var$message = (0, $kSwu1.defineMessages)({
    successMessage: {
        id: "ai-mate.inline-chat-input.success-view.message",
        defaultMessage: "No improvements, nice work."
    }
});
var $8066124509c7a4ea$export$2e2bcd8739ae039 = $8066124509c7a4ea$var$message;


const $58c81a72b5237a22$var$styles = {
    additionalSpacing: "_4c065U1Y8M",
    message: "_1UtDYzy7kJ"
};
const $58c81a72b5237a22$export$be5117c66bf44cb9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            color: "var(--ds-icon-success, #6A9A23)",
            spacing: "spacious",
            size: "medium",
            label: ""
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== formatMessage) {
        t1 = formatMessage((0, $8066124509c7a4ea$export$2e2bcd8739ae039).successMessage);
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $58c81a72b5237a22$var$styles.additionalSpacing
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            xcss: $58c81a72b5237a22$var$styles.message
        }, t0, t1));
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $58c81a72b5237a22$var$styles.additionalSpacing
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $58c81a72b5237a22$var$styles.message
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "spacious",
        size: "medium",
        label: ""
    }), formatMessage((0, $8066124509c7a4ea$export$2e2bcd8739ae039).successMessage)));
};


















var $kb1I3 = parcelRequire("kb1I3");

const $751c72e46bf2056b$export$4d87d729d663f77d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { latestTrace: latestTrace, onCancel: onCancel, onFollow: onFollow, useShortMessages: t1, showProgressBar: t2, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished } = t0;
    const useShortMessages = t1 === undefined ? false : t1;
    const showProgressBar = t2 === undefined ? false : t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("cc-maui-phase-2") && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true);
        $[0] = t3;
    } else t3 = $[0];
    const useRotatingTitle = t3;
    let t4;
    if ($[1] !== latestTrace) {
        t4 = $751c72e46bf2056b$var$latestTraceToStatus(latestTrace);
        $[1] = latestTrace;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== onCancel) {
        t5 = ()=>onCancel({
                skipWarning: true
            });
        $[3] = onCancel;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== isComplete || $[6] !== onCompleteAnimationFinished || $[7] !== onFollow || $[8] !== showProgressBar || $[9] !== t4 || $[10] !== t5 || $[11] !== useShortMessages) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
            status: t4,
            onStop: t5,
            onFollow: onFollow,
            useShortMessages: useShortMessages,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            useRotatingTitle: useRotatingTitle
        });
        $[5] = isComplete;
        $[6] = onCompleteAnimationFinished;
        $[7] = onFollow;
        $[8] = showProgressBar;
        $[9] = t4;
        $[10] = t5;
        $[11] = useShortMessages;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ latestTrace: latestTrace, onCancel: onCancel, onFollow: onFollow, useShortMessages: useShortMessages = false, showProgressBar: showProgressBar = false, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished })=>{
    const useRotatingTitle = (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    return /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
        status: $751c72e46bf2056b$var$latestTraceToStatus(latestTrace),
        onStop: ()=>onCancel({
                skipWarning: true
            }),
        onFollow: onFollow,
        useShortMessages: useShortMessages,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: useRotatingTitle
    });
};
const $751c72e46bf2056b$var$latestTraceToStatus = (latestTrace)=>{
    if (latestTrace?.message_template === 'ACTION_CLASSIFICATION' && (latestTrace?.action_key === 'aifc-adf-update' || latestTrace?.action_key === 'aifc-confluence-whiteboard-update')) return 'editing';
    return 'analyzing';
};


























const $d66aaebe2289e9e4$var$message = (0, $kSwu1.defineMessages)({
    discardMessage: {
        id: "ai-mate.inline-chat-input.warning-view.discard.message",
        defaultMessage: "Cancel request and discard response?"
    },
    deleteMessage: {
        id: "ai-mate.inline-chat-input.warning-view.message",
        defaultMessage: "Delete response?"
    },
    deleteButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.delete-button.label",
        defaultMessage: "Delete"
    },
    keepButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.keep-button.label",
        defaultMessage: "Keep"
    },
    stopMessage: {
        id: "ai-mate.inline-chat-input.warning-view.stop-message",
        defaultMessage: "Stop request?"
    },
    yesButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.yes-button.label",
        defaultMessage: "Yes"
    },
    noButtonLabel: {
        id: "ai-mate.inline-chat-input.warning-view.no-button.label",
        defaultMessage: "No"
    }
});
var $d66aaebe2289e9e4$export$2e2bcd8739ae039 = $d66aaebe2289e9e4$var$message;


const $bf5cdca8d0217417$var$styles = {
    message: "_1UtDYzy7kJ",
    actions: "_2XsHFMIZbP"
};
const $bf5cdca8d0217417$export$1688d93d64f5e437 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onKeep: onKeep, onDelete: onDelete, willDeleteAfterAbort: willDeleteAfterAbort } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== willDeleteAfterAbort) {
        t1 = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                color: "var(--ds-icon-warning, #E06C00)",
                spacing: "spacious",
                size: "medium",
                label: ""
            }), formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).discardMessage : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).stopMessage));
        $[0] = formatMessage;
        $[1] = willDeleteAfterAbort;
        $[2] = t1;
    } else t1 = $[2];
    const renderMessage = t1;
    let t2;
    if ($[3] !== formatMessage || $[4] !== onDelete || $[5] !== onKeep || $[6] !== willDeleteAfterAbort) {
        t2 = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                autoFocus: true,
                appearance: "subtle",
                onClick: onKeep
            }, formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).keepButtonLabel : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).noButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: willDeleteAfterAbort ? "warning" : "default",
                onClick: onDelete
            }, formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).deleteButtonLabel : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).yesButtonLabel)));
        $[3] = formatMessage;
        $[4] = onDelete;
        $[5] = onKeep;
        $[6] = willDeleteAfterAbort;
        $[7] = t2;
    } else t2 = $[7];
    const renderButtons = t2;
    let t3;
    if ($[8] !== renderMessage) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            testId: "inline-chat__warning-view",
            space: "space.100",
            alignBlock: "center",
            xcss: $bf5cdca8d0217417$var$styles.message
        }, renderMessage());
        $[8] = renderMessage;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== renderButtons) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            xcss: $bf5cdca8d0217417$var$styles.actions
        }, renderButtons());
        $[10] = renderButtons;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, t3, t4);
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ onKeep: onKeep, onDelete: onDelete, willDeleteAfterAbort: willDeleteAfterAbort })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderMessage = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            color: "var(--ds-icon-warning, #E06C00)",
            spacing: "spacious",
            size: "medium",
            label: ""
        }), formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).discardMessage : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).stopMessage));
    const renderButtons = ()=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            autoFocus: true,
            appearance: "subtle",
            onClick: onKeep
        }, formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).keepButtonLabel : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).noButtonLabel)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: willDeleteAfterAbort ? 'warning' : 'default',
            onClick: onDelete
        }, formatMessage(willDeleteAfterAbort ? (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).deleteButtonLabel : (0, $d66aaebe2289e9e4$export$2e2bcd8739ae039).yesButtonLabel)));
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        testId: "inline-chat__warning-view",
        space: "space.100",
        alignBlock: "center",
        xcss: $bf5cdca8d0217417$var$styles.message
    }, renderMessage()), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $bf5cdca8d0217417$var$styles.actions
    }, renderButtons()));
};



const $d851aa82264cf4c8$var$PromptViewWithRelay = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("51Y5B")));
const $d851aa82264cf4c8$var$slideFadeIn = null;
const $d851aa82264cf4c8$var$styles = {
    gradientWrapper: "_0bjKvDuMRm _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1gBiby9Fq6 _0nFVCGpCLV _43vdfTHVQb _03m2nySHWH _39xV02715P",
    gradientInner: "_0bjKvDOLYo _4c065UFQfX _2Y7lL4FQfX _0KLXru7Cj1 _07XDTDPvdi",
    wrapper: "_0bjKvDuMRm _2Y7lL45zaO _4c065U8HPE _39xV02E6Kk _0KLXru7Cj1 _2OUyjtGk8v _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w",
    fadeIn: "_1gBibynkof _0nFVCGLrT7 _43vdfTjwM9 _3Y6bKpgRhm _39Ohv4YbGa _1SdfoHYbGa",
    wrapperFlex: "_2mHwu82ADO _39xV02N91d _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuI7V3 _0hPCNLDIqT",
    agentHeaderSpacer: "_313842298P _1wydGWFQfX",
    compactStyle: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _2Y7lL48HPE _4c065U2ADO _39xV02Mvqk",
    fullWidth: "_39xV02N91d",
    thinking: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02715P",
    unifiedOuter: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _0bjKvDuMRm _39xV02715P",
    thinkingWithAnimatedBorder: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02N91d",
    thinkingIsCancelling: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP",
    thinkingUpdatedPadding: "_4c065U2ADO",
    centering: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP",
    frameless: "_0bjKvDdnbC _2Y7lL4Pgdg _4c065UPgdg _0KLXrujOvk _2OUyjtYbGa"
};
const $d851aa82264cf4c8$export$b817d651a700fd8c = (props)=>{
    (0, $6cFsl.di)((0, $ab9bf5ae5fbf4637$export$e924b3ae6248b17a)); // When showMauiMediaPlaceholder is true, defer the completion transition so
    // the progress bar can fill to 100% before the thinking view unmounts.
    const [isProgressBarComplete, setIsProgressBarComplete] = (0, $cozmU.useState)(false);
    const pendingCompleteRef = (0, $cozmU.useRef)(null);
    const { showMauiMediaPlaceholder: showMauiMediaPlaceholder, onBeforeComplete: propsOnBeforeComplete } = props; // Hidden when the media-node overlay is in use.
    const isProgressBarEnabled = !!showMauiMediaPlaceholder && !((0, $iDrrr.fg)('cc-maui-phase-2') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true));
    const onBeforeComplete = (0, $cozmU.useCallback)((complete)=>{
        if (!isProgressBarEnabled) {
            if (propsOnBeforeComplete) propsOnBeforeComplete(complete);
            else complete();
            return;
        } // Defer until the progress bar's fill-to-100% animation finishes.
        const finalComplete = propsOnBeforeComplete ? ()=>propsOnBeforeComplete(complete) : complete;
        pendingCompleteRef.current = finalComplete;
        setIsProgressBarComplete(true);
    }, [
        isProgressBarEnabled,
        propsOnBeforeComplete
    ]);
    const onCompleteAnimationFinished = (0, $cozmU.useCallback)(()=>{
        pendingCompleteRef.current?.();
        pendingCompleteRef.current = null;
        setIsProgressBarComplete(false);
    }, []);
    const { mode: mode, isCancelling: isCancelling, latestTrace: latestTrace, error: error, submit: submit, resubmit: resubmit, cancel: cancel, keep: keep, abort: abort, autoClose: autoClose, agent: agent, setAgent: setAgent } = (0, $ab9bf5ae5fbf4637$export$e924b3ae6248b17a)({
        ...props,
        onBeforeComplete: onBeforeComplete
    });
    const dialogRef = (0, $cozmU.useRef)(null);
    const [isBrowseAgentsModalOpen, setIsBrowseAgentsModalOpen] = (0, $cozmU.useState)(false); /**
                                                                                  * Resolved once here and passed down, so `PromptView` doesn't have to repeat
                                                                                  * the same condition.
                                                                                  *
                                                                                  * `frameless` consumers are excluded unless they opt in. That appearance
                                                                                  * already hides the trailing action cluster, but this selector lives inside
                                                                                  * the editor row, so without the check it would appear for every frameless
                                                                                  * consumer rather than only those designed to surface it.
                                                                                  */ 
    const showInlineAgentSelector = props.agentSelectorLayout === 'inline' && !!props.enableAgents && (props.appearance !== 'frameless' || !!props.showAgentSelectorWhenFrameless); // The selector already shows the selected agent inline, so the header bar
    // above the input would be a duplicate.
    const showAgentHeader = !showInlineAgentSelector;
    const [setBreakpointElement, { isSmall: isSmall }] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const useShortMessages = props.compact && isSmall;
    const setDialogRef = (0, $cozmU.useCallback)((element)=>{
        dialogRef.current = element;
        setBreakpointElement(element);
    }, [
        setBreakpointElement
    ]);
    (0, $cozmU.useEffect)(()=>{
        const onMouseDown = (e)=>{
            // Don't auto-close during thinking mode — the user should use the stop
            // button or Escape key to cancel while a request is in progress.
            // Don't auto-close during error mode — clicking outside the error box
            // should not trigger the warning view.
            if (mode === 'thinking' || // While hidden for Rovo Chat, ignore outside clicks too — we don't
            // want a click to dispatch cancel and put us into the warning view
            // when chat closes.
            mode === 'hidden' || mode === 'complete-hidden' || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_fix_error_discard_screen') && mode === 'error') return;
            const isClickInsideDialog = dialogRef.current?.contains(e.target);
            const isClickInsidePopupMount = props.popupsMountPoint?.contains(e.target);
            if (!isClickInsideDialog && !isClickInsidePopupMount && !isBrowseAgentsModalOpen) {
                if (autoClose) cancel();
            }
        }; // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- pre-existing, keyboard event listener
        return (0, $cbY7C.bind)(document, {
            type: 'mousedown',
            listener: onMouseDown
        });
    }, [
        mode,
        cancel,
        autoClose,
        isBrowseAgentsModalOpen,
        props.popupsMountPoint
    ]);
    const onKeyDown = (e_0)=>{
        if (e_0.key === 'Escape') cancel({
            skipWarning: true
        });
    };
    const willDeleteAfterAbort = props.willDeleteAfterAbort ?? true;
    const renderView = ()=>{
        if (isCancelling) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf5cdca8d0217417$export$1688d93d64f5e437), {
            onKeep: keep,
            onDelete: ()=>abort(true),
            willDeleteAfterAbort: willDeleteAfterAbort
        });
        switch(mode){
            case 'thinking':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $751c72e46bf2056b$export$4d87d729d663f77d), {
                    latestTrace: latestTrace,
                    onCancel: cancel,
                    onFollow: props.onFollow,
                    useShortMessages: useShortMessages,
                    showProgressBar: isProgressBarEnabled,
                    isComplete: isProgressBarComplete,
                    onCompleteAnimationFinished: onCompleteAnimationFinished
                });
            case 'editing':
                {
                    const promptViewProps = {
                        ...props,
                        showLabsLozenge: props._showLabsLozenge,
                        labsLozengeVariant: props._showLabsLozengeVariant,
                        showMauiMediaPlaceholder: props.showMauiMediaPlaceholder,
                        onSubmit: submit,
                        onAgentSelect: setAgent,
                        isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                        setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                        agent: agent,
                        useShortMessages: useShortMessages,
                        appearance: props.appearance,
                        placeholderText: props.placeholderText,
                        showInlineAgentSelector: showInlineAgentSelector
                    };
                    return (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_mention_ask_rovo_jira') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2zysC.PromptView), promptViewProps)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d851aa82264cf4c8$var$PromptViewWithRelay, promptViewProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2zysC.PromptView), promptViewProps);
                }
            case 'error':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $01c04f02869cc358$export$8c68b6013ae44ca6), {
                    error: error,
                    onClose: abort,
                    onTryAgain: resubmit
                });
            case 'success':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $58c81a72b5237a22$export$be5117c66bf44cb9), null);
            default:
                return null;
        }
    }; // When hidden for Rovo Chat or after a host-owned completion, render nothing
    // while keeping the component and its reducer/bridge state mounted.
    if (mode === 'hidden' || mode === 'complete-hidden') return null;
     // The bar is wrapped in the animated gradient border when thinking.
    const isInGradientBorder = mode === 'thinking' && !isCancelling && !isProgressBarEnabled && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true); // Keep the wrapper mounted across `thinking` -> `editing` so only the inner view
    // swaps. Remounting it caused a brief flash at the transition.
    const useStableWrapper = !isCancelling && !isProgressBarEnabled && (mode === 'thinking' || mode === 'editing') && (0, $iDrrr.fg)('platform_editor_ai_stable_thinking_bar_wrapper') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true); // When unified, RovoThinkingBarWrapper supplies the chrome, so the dialog Box
    // drops its own to avoid doubling. Stable-wrapper also routes through here.
    const useUnifiedWrapper = isInGradientBorder || useStableWrapper;
    const bar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: setDialogRef,
        role: "dialog",
        "aria-label": formatMessage((0, $45e141a8abc0ab5e$export$2e2bcd8739ae039).dialogAriaLabel),
        onKeyDown: onKeyDown,
        xcss: (0, $w6R6I.cx)($d851aa82264cf4c8$var$styles.wrapper, mode === 'editing' && $d851aa82264cf4c8$var$styles.fullWidth, mode === 'thinking' && !isCancelling && (!isProgressBarEnabled && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? $d851aa82264cf4c8$var$styles.thinkingWithAnimatedBorder : $d851aa82264cf4c8$var$styles.thinking), mode === 'thinking' && $d851aa82264cf4c8$var$styles.thinkingIsCancelling, mode === 'thinking' && $d851aa82264cf4c8$var$styles.fadeIn, mode === 'thinking' && $d851aa82264cf4c8$var$styles.thinkingUpdatedPadding, props.compact && $d851aa82264cf4c8$var$styles.compactStyle, // Fill the gradient border instead of compactStyle's narrower width.
        isInGradientBorder && $d851aa82264cf4c8$var$styles.fullWidth, $d851aa82264cf4c8$var$styles.centering, // `frameless` strips the dialog chrome so the prompt blends into
        // a parent container that already provides its own framing.
        // Applied last so it wins over wrapper / compact / centering.
        // Also stripped only while the unified RovoThinkingBarWrapper supplies the chrome.
        (props.appearance === 'frameless' || useUnifiedWrapper && mode === 'thinking') && $d851aa82264cf4c8$var$styles.frameless)
    }, showAgentHeader && agent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7196c6d7922df5e6$export$24238a3d65fa333), {
        agent: agent,
        removeAgent: ()=>setAgent(null),
        compact: props.compact
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d851aa82264cf4c8$var$styles.wrapperFlex, showAgentHeader && agent && $d851aa82264cf4c8$var$styles.agentHeaderSpacer)
    }, renderView()));
    if (useUnifiedWrapper) // RovoThinkingBarWrapper supplies the chrome; the outer div only centers and
    // applies the AI modal's 2rem bleed (ModalRegion.tsx) to align with the edges.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- calc() width can't be expressed in cssMap
    , {
        style: props.compact ? {
            width: 'calc(100% - 2rem)'
        } : undefined,
        "data-testid": "thinking-bar-gradient-border",
        className: (0, $hekY6.default)([
            $d851aa82264cf4c8$var$styles.unifiedOuter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: mode === 'thinking'
    }, bar));
    if (isInGradientBorder) {
        // Subtract the AI modal's 2rem bleed (ModalRegion.tsx) so the border lines
        // up with the editor edges instead of overflowing.
        const gradientBorderStyle = {
            background: (0, $aIj6m.ROVO_GRADIENT_BACKGROUND),
            ...props.compact && {
                width: 'calc(100% - 2rem)'
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- gradient background and calc() width can't be expressed in cssMap
        , {
            style: gradientBorderStyle,
            "data-testid": "thinking-bar-gradient-border",
            className: (0, $hekY6.default)([
                $d851aa82264cf4c8$var$styles.gradientWrapper
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIj6m.RovoGradientKeyframesStyle), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $d851aa82264cf4c8$var$styles.gradientInner
            ])
        }, bar));
    }
    if ((0, $iDrrr.fg)('rovo_agents_studio_browse_kit_chat')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33LwY.ModalContextProvider), null, bar);
    return bar;
};



var $irnO2 = parcelRequire("irnO2");


var $iBsvI = parcelRequire("iBsvI");








var $cfQBH = parcelRequire("cfQBH");


var $8gcBG = parcelRequire("8gcBG");


var $85mU8 = parcelRequire("85mU8");

















const $4d766d2c364fa339$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    aifcPromptPlaceholder: {
        id: "editor-plugin-ai.ExperienceApplication.screens-with-logic.aifcPromptPlaceholder",
        defaultMessage: "Describe what to do, / for skills"
    },
    postStreamReviewPromptPlaceholder: {
        id: "editor-plugin-ai.ExperienceApplication.screens-with-logic.postStreamReviewPromptPlaceholder",
        defaultMessage: "Describe a change to keep editing"
    }
});


const $e99c702c191ae5e3$export$ae0d22b72a86bd86 = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSM':
            return 'jsm';
        case 'JPD':
            return 'jpd';
        case 'JSW':
        case 'JWM':
            return 'jira';
        case 'ATLAS':
        case 'TOWNSQUARE':
            return 'atlas';
        case 'BITBUCKET':
            return 'bitbucket';
        default:
            return 'unknown';
    }
};
const $e99c702c191ae5e3$var$backupChannelVariables = {
    cloudId: '',
    orgId: undefined,
    userId: undefined
};
const $e99c702c191ae5e3$var$isMauiAppNode = (node)=>node?.type === 'extension' && node?.attrs != null && 'extensionKey' in node.attrs && node.attrs.extensionKey === 'native-embed:maui';
const $e99c702c191ae5e3$var$isMediaNode = (node)=>{
    if (!node) return false;
    if (node.type === 'media') return true;
    if (node.type === 'mediaSingle' && Array.isArray(node.content) && node.content.length > 0) return node.content[0]?.type === 'media';
    return false;
};
const $e99c702c191ae5e3$var$getSelectionLabsLozengeVariant = (selectionFragment)=>{
    if (!Array.isArray(selectionFragment) || selectionFragment.length === 0) return undefined;
    if (selectionFragment.some((node)=>$e99c702c191ae5e3$var$isMauiAppNode(node)) || selectionFragment.some((node)=>$e99c702c191ae5e3$var$isMediaNode(node))) return 'maui';
    return undefined;
};
function $e99c702c191ae5e3$export$d0c09a27ab507630({ autoClose: autoClose, cancel: cancel, isPostStreamReview: isPostStreamReview = false, onPromptContentChange: onPromptContentChangeProp, openInRovoChatConfig: openInRovoChatConfig, rovoInlineChatAppearance: rovoInlineChatAppearance, showTrailingActions: showTrailingActions }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setIsRovoLoading: setIsRovoLoading, api: api, targetId: targetId, userADFInput: userADFInput, editorPluginAIProvider: editorPluginAIProvider, appearance: appearance, setCancelRovoPrompt: setCancelRovoPrompt, popupsMountPoint: popupsMountPoint, editorView: editorView } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    // Placeholder override (CCI-17295 / CCI-17296). ai-mate stays gate-agnostic —
    // the editor decides whether to supply an override and ai-mate simply prefers
    // it when present, so non-AIFC consumers keep the default placeholder.
    //
    // The Post Stream Review prompt needs its own placeholder ("Describe a change
    // to keep editing"), which takes precedence over the generic
    // AIFC placeholder. PSR identity is signalled explicitly via the
    // `isPostStreamReview` prop rather than inferred from the visual appearance.
    const aifcPlaceholderText = isPostStreamReview ? formatMessage((0, $4d766d2c364fa339$export$defe85febe8b728c).postStreamReviewPromptPlaceholder) : (0, $a44d2501b233a83e$export$4d8717ba02388642)() ? formatMessage((0, $4d766d2c364fa339$export$defe85febe8b728c).aifcPromptPlaceholder) : undefined;
    // Agent selector placement (CCI-17299). Same gate-agnostic split as the
    // placeholder above: the editor owns the rollout decision and ai-mate just
    // honours the prop, so non-AIFC consumers keep the picker inside the `+`
    // popup.
    const agentSelectorLayout = (0, $a44d2501b233a83e$export$4d8717ba02388642)() ? 'inline' : undefined;
    // The selector sits inside the editor row rather than the trailing action
    // cluster, so ai-mate hides it for `frameless` consumers unless they opt in.
    // Post Stream Review opts in (CCI-17298) to reach parity with the standard
    // prompt. Unlike the trailing actions — which PSR reveals only once the user
    // starts composing — the selector stays visible so the active agent is always
    // discoverable.
    const showAgentSelectorWhenFrameless = isPostStreamReview;
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent') || $e99c702c191ae5e3$var$backupChannelVariables, [
        editorPluginAIProvider
    ]);
    const product = editorPluginAIProvider.product;
    const productKey = $e99c702c191ae5e3$export$ae0d22b72a86bd86(product);
    const isPageEditor = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const nextSessionId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    const existingShowLabsLozenge = (0, $cozmU.useMemo)(()=>{
        if (productKey === 'confluence') {
            if (!(0, $iDrrr.fg)('aifc_onboarding_ga_enabled')) return true;
            // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
            if (!(0, $cXtTj.default).getExperimentValue('cc-aifc-databases-experiment', 'isEnabled', false)) return true;
        }
        return false;
    }, [
        productKey
    ]);
    const selectionContext = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.selectionContext ?? null);
    const selectionLabsLozengeVariant = (0, $cozmU.useMemo)(()=>$e99c702c191ae5e3$var$getSelectionLabsLozengeVariant(selectionContext?.selectionFragment ?? null), [
        selectionContext
    ]);
    const isMauiOrMediaSelection = (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && selectionLabsLozengeVariant !== undefined;
    const source = isMauiOrMediaSelection ? 'CONFLUENCE_MAUI_INLINE_EDITOR' : productKey === 'confluence' && isPageEditor ? 'CONFLUENCE_INLINE_EDITOR' : 'INLINE_EDITOR';
    const isMauiInlineRemixEditPrompt = isMauiOrMediaSelection && !isPostStreamReview && !openInRovoChatConfig && rovoInlineChatAppearance === undefined;
    // Keep ai-mate mounted for completion cleanup, but hide the edit prompt while
    // InlineEditReadyBar owns the post-stream UI.
    const shouldHidePromptAfterComplete = isMauiInlineRemixEditPrompt && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6');
    const shouldOpenChatOnError = (source === 'CONFLUENCE_INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' && (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_2', 'isEnabled', true)) && (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    // The Post Stream Review prompt (frameless) hides the LABS lozenge — the
    // design has no badge in that surface — without affecting any other inline
    // chat usage.
    const showLabsLozenge = !isPostStreamReview && (existingShowLabsLozenge && selectionLabsLozengeVariant === undefined || isMauiOrMediaSelection);
    (0, $cozmU.useEffect)(()=>{
        setCancelRovoPrompt?.(undefined);
        return ()=>{
            setIsRovoLoading(false);
        };
    }, [
        setCancelRovoPrompt,
        setIsRovoLoading
    ]);
    const teardownInlineSession = (0, $cozmU.useCallback)(({ streamEnded: streamEnded })=>{
        cancel({
            shouldClearSelectionContext: streamEnded
        });
        setIsRovoLoading(false);
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-phase-2 + cc-maui-experiment); will simplify post-rollout
        editorView && (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)) (0, $4TgUg.createEndInlineRovoStreamingCommand)()(editorView.state, editorView.dispatch);
        // [CCI-17658] Skip reset during per-segment rework — the segment state
        // (streamReviewSegments, aiContentPositions, reworkSnapshot) must survive
        // the Rovo streaming infrastructure's abort/restart cycle.
        if (editorView) {
            const sessionState = (0, $e9cb9bc0694dd877$export$cfaa4734e6c82b)(editorView.state);
            if (!sessionState?.reworkSnapshot) api?.core?.actions?.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
        } else api?.core?.actions?.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
    }, [
        cancel,
        setIsRovoLoading,
        api?.core?.actions,
        editorView
    ]);
    const handleAbort = (0, $cozmU.useCallback)(({ streamEnded: streamEnded })=>{
        teardownInlineSession({
            streamEnded: streamEnded
        });
        if (isMauiOrMediaSelection) {
            (0, $irnO2.remixEditExistingExperience).abort({
                metadata: {
                    reason: 'user_cancel'
                }
            });
            (0, $85mU8.getBrowserBridgeAPI)()?.send((0, $8gcBG.AifcExperienceTrackingCommand), {
                status: 'abort',
                reason: 'user_cancel',
                experienceName: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                senderId: (0, $cfQBH.ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID),
                receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            });
        }
    }, [
        teardownInlineSession,
        isMauiOrMediaSelection
    ]);
    /**
   * Error handoff (openChatOnError): same UI teardown as abort, but do not abort
   * remix experiences. aiMateRemixRegenerate fails via send-message collect;
   * remixEditExistingExperience is failed here because this path previously only aborted it.
   */ const handleError = (0, $cozmU.useCallback)(({ streamEnded: streamEnded })=>{
        teardownInlineSession({
            streamEnded: streamEnded
        });
        if (isMauiOrMediaSelection) (0, $irnO2.remixEditExistingExperience).failure({
            metadata: {
                reason: 'stream_error_open_chat'
            }
        });
    }, [
        teardownInlineSession,
        isMauiOrMediaSelection
    ]);
    const handleBeforeSubmit = (0, $cozmU.useCallback)((prompt)=>{
        if (openInRovoChatConfig?.onBeforeSubmit?.(prompt)) return true;
        if (isMauiOrMediaSelection && !(0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes')) {
            // remixType is 'infographic' for media nodes; for MAUI apps it's
            // only known from the backend response (added via updateAttributes
            // in useEditorRovoBridgeCommandListener when the stream settles).
            const isMediaSelection = selectionContext?.selectionFragment?.some((node)=>node.type === 'mediaSingle' || node.type === 'media');
            const featureArea = (0, $iBsvI.getRemixFeatureArea)({
                remixType: isMediaSelection ? 'infographic' : undefined
            });
            (0, $85mU8.getBrowserBridgeAPI)()?.send((0, $8gcBG.AifcExperienceTrackingCommand), {
                status: 'start',
                experienceName: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                actionId: selectionContext?.localIds?.[0],
                attributes: {
                    regenerateSource: 'inline-existing-node',
                    editSource: 'rovoBar',
                    selectionLocalId: selectionContext?.localIds?.[0],
                    ...featureArea ? {
                        featureArea: featureArea
                    } : {}
                },
                ...isMediaSelection && {
                    remixType: 'infographic'
                },
                senderId: (0, $cfQBH.ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID),
                receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
            });
        }
        return false;
    }, [
        isMauiOrMediaSelection,
        openInRovoChatConfig,
        selectionContext
    ]);
    const onSubmit = (0, $cozmU.useCallback)((cancel)=>{
        // Promote the staged target id (set by the toolbar handler) — this is
        // what triggers the consumer-visible loading overlay. No-op when
        // nothing is staged (e.g. modal opened via a non-toolbar path).
        // `expValEqualsNoExposure` because the toolbar click is the designated
        // `cc-maui-experiment` exposure point.
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-phase-2 + cc-maui-experiment); will simplify post-rollout
        editorView && (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)) (0, $4TgUg.createCommitInlineRovoStreamingCommand)()(editorView.state, editorView.dispatch);
        // Start remixRegenerate when editing an embedded MAUI/media node
        if (isMauiOrMediaSelection) {
            (0, $irnO2.remixEditExistingExperience).start();
            (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).SUBMIT);
            if ((0, $iDrrr.fg)('cc-maui-disable-edit-experience-tracker-fixes')) {
                // remixType is 'infographic' for media nodes; for MAUI apps it's
                // only known from the backend response (added via updateAttributes
                // in useEditorRovoBridgeCommandListener when the stream settles).
                const isMediaSelection = selectionContext?.selectionFragment?.some((node)=>node.type === 'mediaSingle' || node.type === 'media');
                const featureArea = (0, $iBsvI.getRemixFeatureArea)({
                    remixType: isMediaSelection ? 'infographic' : undefined
                });
                (0, $85mU8.getBrowserBridgeAPI)()?.send((0, $8gcBG.AifcExperienceTrackingCommand), {
                    status: 'start',
                    experienceName: (0, $irnO2.ExperienceName).REMIX_REGENERATE,
                    actionId: selectionContext?.localIds?.[0],
                    attributes: featureArea ? {
                        featureArea: featureArea
                    } : {},
                    ...isMediaSelection && {
                        remixType: 'infographic'
                    },
                    senderId: (0, $cfQBH.ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID),
                    receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID)
                });
            }
        }
        editorPluginAIProvider.onSubmit?.();
        setIsRovoLoading(true);
        // Fire prompt event for AIFC. We don't have access to the request id as it's not generated
        // at this point of time and nothing else is available at this stage.
        // For now this will just give us an indication of prompt volume.
        api?.analytics?.actions.fireAnalyticsEvent({
            action: 'prompt',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: {
                aiGroupId: nextSessionId,
                experienceName: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
                actionTaken: '',
                editCount: 0,
                aiSessionId: '',
                inlineStreamingAvailable: true
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
        const cancelRovoPrompt = ()=>{
            cancel();
        };
        // give DOM time to update the screen
        setTimeout(()=>{
            setCancelRovoPrompt?.(()=>cancelRovoPrompt);
        }, 100);
    }, [
        api,
        nextSessionId,
        editorPluginAIProvider,
        setCancelRovoPrompt,
        setIsRovoLoading,
        editorView,
        isMauiOrMediaSelection,
        selectionContext?.localIds,
        selectionContext?.selectionFragment
    ]);
    const shouldShowCompact = (0, $cozmU.useMemo)(()=>{
        if (!width) return false;
        else if ((0, $iDrrr.fg)('platform_maui_jira_ui_fix')) return width <= (0, $9lgy7.Breakpoint).Small * 2;
        return width <= (0, $9lgy7.Breakpoint).Small;
    }, [
        width
    ]);
    const firePromptInputEngaged = (0, $cozmU.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((payload, fireEvent)=>{
        fireEvent?.analytics?.actions.fireAnalyticsEvent({
            action: 'promptInputUpdated',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: {
                aiGroupId: nextSessionId,
                experienceName: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC,
                actionTaken: '',
                editCount: 0,
                aiSessionId: '',
                inlineStreamingAvailable: true,
                characterCount: payload.textLength,
                hasMentionOrInlineCard: payload.hasMentionOrInlineCard
            },
            eventType: (0, $krYZG.EVENT_TYPE).UI
        });
    }, 500)).current;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            firePromptInputEngaged.cancel();
        };
    }, [
        firePromptInputEngaged
    ]);
    const isSmartlinkToolbarInlinePromptAnalyticsEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    const onPromptContentChange = (0, $cozmU.useCallback)((payload)=>{
        // Always forward the raw payload to the parent surface so it can track
        // prompt emptiness (e.g. PSR "press Enter to accept").
        onPromptContentChangeProp?.(payload);
        if (payload.isEmpty && !payload.hasMentionOrInlineCard) return;
        // Only fire the prompt-engaged analytics when its experiment is on. The
        // parent forwarding above is wired independently (e.g. PSR "press Enter to
        // accept"), so gate this to avoid emitting `promptInputUpdated` in that context.
        if (isSmartlinkToolbarInlinePromptAnalyticsEnabled) firePromptInputEngaged(payload, api);
    }, [
        api,
        firePromptInputEngaged,
        onPromptContentChangeProp,
        isSmartlinkToolbarInlinePromptAnalyticsEnabled
    ]);
    // Memoized key forces RovoInlineChatPrompt to remount when the skill selection changes
    const userADFInputKey = (0, $cozmU.useMemo)(()=>userADFInput ? JSON.stringify(userADFInput) : undefined, [
        userADFInput
    ]);
    // If a session is active - we'll show the loading screen elsewhere and we can hide this
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d851aa82264cf4c8$export$b817d651a700fd8c), {
        key: userADFInputKey,
        autoClose: autoClose,
        source: source,
        productKey: productKey,
        siteId: cloudId,
        orgId: orgId,
        objectId: targetId,
        _showLabsLozengeVariant: selectionLabsLozengeVariant,
        showMauiMediaPlaceholder: isMauiOrMediaSelection,
        hideAfterComplete: shouldHidePromptAfterComplete,
        openChatOnError: shouldOpenChatOnError,
        creationContextParams: editorPluginAIProvider.creationContextParams,
        onAbort: handleAbort,
        onError: handleError,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCancel: ()=>{
        /* noop - this is to allow the rovo inline chat to manage cancel behaviour.
       * We shouldn't end the AI experience directly. */ },
        popupsMountPoint: popupsMountPoint,
        // The following nops usages are like this because we want to ensure that only the AI plugin or the Orchestrator
        // are controlling the xstate. We do not want this to end the ai experience directly. Instead the rovo bridge
        // will call the orchestrator which will then end the experience, on both complete and abort.
        // IMPORTANT!! Do not end the AI experience on the complete callback. This can cause problems because the
        // rovo bridge may still have events to stream in the queue, and it's possible that this could result in
        // the experience being ended immediately on mount, which would then unmount the prompt. This is because the rovo bridge
        // can have a final response in its queue which has never fluushed previously, because something else unmounted this
        // component before the final response was flushed.
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onComplete: ()=>{
            setIsRovoLoading(false);
            if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-phase-2 + cc-maui-experiment); will simplify post-rollout
            editorView && (0, $iDrrr.fg)('cc-maui-phase-2') && (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true)) {
                const inlineEditReadyTargetId = (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state)?.inlineRovoStreamingTargetId ?? undefined;
                (0, $4TgUg.createEndInlineRovoStreamingCommand)()(editorView.state, editorView.dispatch);
                // Keep the ready state separate from streaming completion, but carry the
                // edited node id across teardown so visibility and View target the result.
                if (isMauiOrMediaSelection) (0, $4TgUg.createShowInlineEditReadyCommand)(inlineEditReadyTargetId)(editorView.state, editorView.dispatch);
            }
        },
        // When the progress bar killswitch is enabled, the inline chat's
        // onBeforeComplete will delay calling complete() until the progress bar
        // fill-to-100% animation finishes, preventing the UI from flashing the
        // prompt input before the parent unmounts this component.
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onBeforeComplete: isMauiOrMediaSelection ? (complete)=>{
            complete();
        } : undefined,
        onSubmit: onSubmit,
        onBeforeSubmit: handleBeforeSubmit,
        enableAgents: editorPluginAIProvider.isRovoEnabled,
        currentUserId: (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_mention_ask_rovo_jira') ? userId : undefined,
        _showLabsLozenge: showLabsLozenge,
        compact: shouldShowCompact,
        onPromptContentChange: isSmartlinkToolbarInlinePromptAnalyticsEnabled || onPromptContentChangeProp ? onPromptContentChange : undefined,
        defaultValue: userADFInput,
        appearance: rovoInlineChatAppearance,
        showTrailingActions: showTrailingActions,
        shouldRenderInPortal: editorPluginAIProvider.shouldRenderInPortal,
        placeholderText: aifcPlaceholderText,
        agentSelectorLayout: agentSelectorLayout,
        showAgentSelectorWhenFrameless: showAgentSelectorWhenFrameless
    }));
}


/* ActionButtons.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















// (↑ / ↓). The actual key handling lives in `useReviewKeyboardShortcuts`
// (hooks.ts) — keep the bindings in sync.
const $820b95cc5d823d8c$var$previousChangeKeymap = (0, $ldqjS.makeKeyMapWithCommon)('Go to previous', 'ArrowUp');
const $820b95cc5d823d8c$var$nextChangeKeymap = (0, $ldqjS.makeKeyMapWithCommon)('Go to next', 'ArrowDown'); // [CCI-17296] Inline step-through navigation cluster — previous / "N / N"
// counter / next — shown to the left of the action icons when the user is
// stepping through more than one change.
const $820b95cc5d823d8c$var$navigationTrayCSS = null;
const $820b95cc5d823d8c$var$segmentCounterCSS = null;
const $820b95cc5d823d8c$var$actionButtonsCSS = null;
function $820b95cc5d823d8c$export$88c65d2d98aab183({ totalSegments: totalSegments, segmentIndex: segmentIndex, canGoPrevious: canGoPrevious, canGoNext: canGoNext, isStepThroughExpanded: isStepThroughExpanded, onPrevious: onPrevious, onNext: onNext, onToggleStepThrough: onToggleStepThrough }) {
    const intl = (0, $kSwu1.useIntl)(); // Custom tooltip content appending the keyboard shortcut to the nav labels
    // (e.g. "Go to previous ↑"). Memoized so the `tooltip` prop object is stable
    // across renders (`@atlassian/perf-linting/no-unstable-inline-props`). Declared
    // before the early return below to keep hook order stable.
    const previousTooltip = (0, $cozmU.useMemo)(()=>({
            content: /*#__PURE__*/ $cozmU.createElement((0, $ldqjS.ToolTipContent), {
                description: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).previousChange),
                keymap: $820b95cc5d823d8c$var$previousChangeKeymap
            })
        }), [
        intl
    ]);
    const nextTooltip = (0, $cozmU.useMemo)(()=>({
            content: /*#__PURE__*/ $cozmU.createElement((0, $ldqjS.ToolTipContent), {
                description: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).nextChange),
                keymap: $820b95cc5d823d8c$var$nextChangeKeymap
            })
        }), [
        intl
    ]); // [CCI-18590] Step Through Mode is opt-in via the `'step-through'` token of the
    // `platform_editor_review_moment_config` dynamic config. It only renders when the
    // token is enabled — hide the toggle button and the prev/next navigation tray
    // otherwise. Default off so no accidental exposure while the Review moment itself
    // is rolling out, and a future rollout is just adding the token. The rest of the
    // review toolbar (view-changes, undo, redo, accept) is unaffected.
    if (!(0, $77d78733cc4ebcfe$export$2ae1a40df3c2a2f9)()) return null;
     // [CCI-17296] Step-through is only relevant when there is more than one
    // reviewable change.
    const hasMultipleSegments = totalSegments > 1; // Arrows are always enabled when there is more than one segment;
    // navigation wraps around (first <- last, last -> first). Do NOT additionally
    // disable at the ends — `canGoPrevious` / `canGoNext` already encode the
    // wrap-around availability.
    const isPrevDisabled = !canGoPrevious;
    const isNextDisabled = !canGoNext;
    if (!hasMultipleSegments) return null;
     // The navigation and step-through IconButtons opt into tooltips
    // (`isTooltipDisabled` defaults to true); each surfaces its `label` on hover.
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, isStepThroughExpanded && /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "post-stream-review-navigation",
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$f34212d9b63ae998),
        label: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).previousChange),
        isTooltipDisabled: false,
        tooltip: previousTooltip,
        isDisabled: isPrevDisabled,
        onClick: onPrevious,
        testId: "post-stream-review-prev"
    }), /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": "post-stream-review-segment-counter",
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzZpcK _1ANEUSLRg7 _2fwxA5DIqT _4ouGXINHnM"
        ])
    }, intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).segmentPosition, {
        current: segmentIndex + 1,
        total: totalSegments
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$ebc383bb12048a63),
        label: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).nextChange),
        isTooltipDisabled: false,
        tooltip: nextTooltip,
        isDisabled: isNextDisabled,
        onClick: onNext,
        testId: "post-stream-review-next"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$1b0ad15b32547a2e),
        label: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).stepThrough),
        isTooltipDisabled: false,
        isSelected: isStepThroughExpanded,
        "aria-expanded": isStepThroughExpanded,
        onClick: onToggleStepThrough,
        testId: "post-stream-review-step-through"
    }));
}




// prompt surface applies. Re-applying it here keeps the PSR input height in line
// with the standard prompt.
const $1f6111ffcc9c3687$var$askRovoCSS = null;
const $1f6111ffcc9c3687$var$promptSlotCSS = null; // Animated wrapper for the review controls. It collapses its width (grid
// `1fr` → `0fr`, which animates to the content's natural width — no fixed bound
// needed) and fades when the user starts composing a re-prompt, and expands +
// fades back in when the prompt is cleared. The controls are kept mounted (not
// conditionally rendered) so the slide-OUT can play; `visibility` flips only
// after the collapse finishes so they drop out of the tab order / accessibility
// tree while hidden. Motion is disabled under `prefers-reduced-motion`.
const $1f6111ffcc9c3687$var$rightActionsWrapperCSS = null;
const $1f6111ffcc9c3687$var$rightActionsVisibleCSS = null;
const $1f6111ffcc9c3687$var$rightActionsHiddenCSS = null; // The controls row itself. `overflow: hidden` + `min-width: 0` let it be clipped
// as the grid column collapses to `0fr`.
const $1f6111ffcc9c3687$var$rightActionsCSS = null;
function $1f6111ffcc9c3687$export$e93225791a9c1544({ hasRovoPrompt: hasRovoPrompt, hasFallbackPrompt: hasFallbackPrompt, hasInputText: hasInputText, openInRovoChat: openInRovoChat, openInRovoChatConfig: openInRovoChatConfig, cancel: cancel, PromptEditor: PromptEditor, textInput: textInput, onTextChange: onTextChange, onPromptContentChange: onPromptContentChange, submit: submit, appearance: appearance, isAIFC: isAIFC, canUndo: canUndo, canRedo: canRedo, onUndo: onUndo, onRedo: onRedo, canViewChanges: canViewChanges, showDeletedChanges: showDeletedChanges, onViewChanges: onViewChanges, totalSegments: totalSegments, segmentIndex: segmentIndex, canGoPrevious: canGoPrevious, canGoNext: canGoNext, onPrevious: onPrevious, onNext: onNext, isStepThroughExpanded: isStepThroughExpanded, onToggleStepThrough: onToggleStepThrough }) {
    const intl = (0, $kSwu1.useIntl)(); // Custom tooltip content appending the keyboard shortcut to the Undo/Redo
    // labels (e.g. "Undo ⌘Z"). Memoized so the `tooltip` prop object is stable
    // across renders (`@atlassian/perf-linting/no-unstable-inline-props`).
    const undoTooltip = (0, $cozmU.useMemo)(()=>({
            content: /*#__PURE__*/ $cozmU.createElement((0, $ldqjS.ToolTipContent), {
                description: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).undo),
                keymap: (0, $ldqjS.undo)
            })
        }), [
        intl
    ]);
    const redoTooltip = (0, $cozmU.useMemo)(()=>({
            content: /*#__PURE__*/ $cozmU.createElement((0, $ldqjS.ToolTipContent), {
                description: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).redo),
                keymap: (0, $ldqjS.redo)
            })
        }), [
        intl
    ]); // Render the Rovo prompt unless we have a fallback editor to show.
    const shouldRenderFallbackPrompt = !(openInRovoChat && hasRovoPrompt) && hasFallbackPrompt && !!PromptEditor;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "post-stream-review-ask-rovo",
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _2Y7lL45zaO _4c065U8HPE _4ouGXIdnbC _3iDTPbQ4SZ _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC"
        ])
    }, shouldRenderFallbackPrompt && PromptEditor ? /*#__PURE__*/ $cozmU.createElement((0, $6593db5854c11409$export$eddbff457ab4038b), {
        textInput: textInput,
        onTextChange: onTextChange,
        submit: submit,
        cancel: cancel,
        PromptEditor: PromptEditor,
        appearance: appearance,
        isAIFC: isAIFC
    }) : /*#__PURE__*/ $cozmU.createElement((0, $e99c702c191ae5e3$export$d0c09a27ab507630), {
        cancel: cancel,
        openInRovoChatConfig: hasRovoPrompt ? openInRovoChatConfig : undefined,
        autoClose: false,
        isPostStreamReview: true,
        onPromptContentChange: onPromptContentChange,
        rovoInlineChatAppearance: "frameless",
        showTrailingActions: hasInputText
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-hidden": hasInputText || undefined,
        "data-testid": "post-stream-review-controls",
        className: (0, $hekY6.default)([
            "_3iDTPbgBM8 _3YEZNOdnbC _1kOSYtfy2B _3Z9K0wqCfL _0qk6IK1fFG _2Iz54kUiLg",
            hasInputText ? "_2iEGP2VDI5 _1YKVNsdnbC _0fKRyPnQyn _1pp6NdYbGa _3OZqoKAClz" : "_2iEGP2UfmU _1YKVNs7dHp _0fKRyPYvD1 _3OZqoKUiLg"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $820b95cc5d823d8c$export$88c65d2d98aab183), {
        totalSegments: totalSegments,
        segmentIndex: segmentIndex,
        canGoPrevious: canGoPrevious,
        canGoNext: canGoNext,
        isStepThroughExpanded: isStepThroughExpanded,
        onPrevious: onPrevious,
        onNext: onNext,
        onToggleStepThrough: onToggleStepThrough
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$6781454d37fb126f),
        label: intl.formatMessage(showDeletedChanges ? (0, $5162eb24f9d4c228$export$defe85febe8b728c).hideChanges : (0, $5162eb24f9d4c228$export$defe85febe8b728c).viewChanges),
        isTooltipDisabled: false,
        isSelected: showDeletedChanges,
        onClick: onViewChanges,
        isDisabled: !canViewChanges,
        testId: "post-stream-review-view-changes"
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$42a4add5887bcdcb),
        label: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).undo),
        isTooltipDisabled: false,
        tooltip: undoTooltip,
        isDisabled: !canUndo,
        onClick: onUndo,
        testId: "post-stream-review-undo"
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, $bf520c5d07f0f1e1$export$d23b8760f033769b),
        label: intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).redo),
        isTooltipDisabled: false,
        tooltip: redoTooltip,
        isDisabled: !canRedo,
        onClick: onRedo,
        testId: "post-stream-review-redo"
    }))));
}


/**
 * Custom hooks extracted from `PostStreamReviewScreen` to keep the screen
 * component readable and to isolate the subtler effect-timing logic for unit
 * testing.
 */ 










function $a804558cbe043398$export$8deef307be5757ba(screenRef, editorView, close) {
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const handlePointerDown = (event)=>{
            const target = event.target;
            if (!(target instanceof Node)) return;
            if (screenRef.current?.contains(target)) return;
            if (target instanceof Element && target.closest('[data-post-stream-review-portal]')) return;
            // Scope to the content-area wrapper, not `.ProseMirror`, so clicks in the
            // empty space below short content still dismiss. Fall back to the PM node.
            const editorDom = editorView?.dom;
            if (!editorDom) return;
            const editorContentArea = editorDom.closest('.ak-editor-content-area') ?? editorDom;
            if (!editorContentArea.contains(target)) return;
            close();
        };
        const unbind = (0, $cbY7C.bind)(doc, {
            type: 'pointerdown',
            listener: handlePointerDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        screenRef,
        editorView,
        close
    ]);
}
function $a804558cbe043398$export$fbda8a74cef18fab(screenRef, options) {
    const optionsRef = (0, $cozmU.useRef)(options);
    optionsRef.current = options;
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $1hQ0e.getDocument)();
        if (!doc) return;
        const handleKeyDown = (event)=>{
            // Let IME composition through untouched.
            if (event.isComposing) return;
            const target = event.target;
            // Keydown targets we care about are always Elements; narrowing to Element
            // (a Node subtype) makes `contains`/`closest` type-safe below.
            if (!(target instanceof Element)) return;
            // Only react to keystrokes within the toolbar (incl. portalled descendants).
            const insideToolbar = screenRef.current?.contains(target) || !!target.closest('[data-post-stream-review-portal]');
            if (!insideToolbar) return;
            const opts = optionsRef.current;
            // Once accepted, the toolbar is replaced by the "Accepted" pill and the
            // review is tearing down — every shortcut stands down (this also preserves
            // the old Enter-accept gate, which was `!hasInputText && !isAccepted`).
            if (opts.isAccepted) return;
            // Close — bare Escape, regardless of prompt text. The prompt's own Escape
            // `cancel` is a no-op here, so capture-phase preventDefault is what closes.
            if (event.key === 'Escape') {
                if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return;
                event.preventDefault();
                opts.onClose();
                return;
            }
            // Accept — bare Enter (no modifiers), only while the prompt is empty. With
            // typed text the Enter is left for the re-prompt submit.
            if (event.key === 'Enter') {
                if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return;
                if (!opts.isPromptEmpty) return;
                event.preventDefault();
                opts.onAccept();
                return;
            }
            // Navigation — bare ArrowUp / ArrowDown, only while stepping through with
            // an empty prompt. Requires no modifier (no Alt/Cmd/Ctrl/Shift) so it can't
            // collide with an editor/OS Shift+Arrow selection or Alt/Cmd+Arrow combo.
            // While the prompt has text the arrows are left for caret movement.
            if (!event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
                if (!opts.isStepThroughExpanded || !opts.isPromptEmpty) return;
                if (event.key === 'ArrowUp') {
                    if (!opts.canGoPrevious) return;
                    event.preventDefault();
                    opts.onPrevious();
                } else {
                    if (!opts.canGoNext) return;
                    event.preventDefault();
                    opts.onNext();
                }
                return;
            }
            // Undo/redo — require the primary modifier (⌘ on macOS, Ctrl elsewhere).
            const hasPrimaryModifier = event.metaKey || event.ctrlKey;
            if (!hasPrimaryModifier) return;
            // Defer to native text undo/redo while the re-prompt has typed content.
            if (!opts.isPromptEmpty) return;
            const key = event.key.toLowerCase();
            if (key === 'z' && !event.altKey) {
                if (event.shiftKey) {
                    // Redo — Mod-Shift-z.
                    if (!opts.canRedo) return;
                    event.preventDefault();
                    opts.onRedo();
                } else {
                    // Undo — Mod-z.
                    if (!opts.canUndo) return;
                    event.preventDefault();
                    opts.onUndo();
                }
                return;
            }
            // Redo — Ctrl-y (Windows/Linux alias). Cmd+Y is NOT redo on macOS, so
            // require Ctrl specifically and exclude the Cmd modifier.
            if (key === 'y' && event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
                if (!opts.canRedo) return;
                event.preventDefault();
                opts.onRedo();
            }
        };
        const unbind = (0, $cbY7C.bind)(doc, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        screenRef
    ]);
}
function $a804558cbe043398$export$e355b0795926452a(coreActions, hideDiff) {
    const hideOnUnmountRef = (0, $cozmU.useRef)(null);
    hideOnUnmountRef.current = ()=>{
        if (coreActions && hideDiff) coreActions.execute(hideDiff);
    };
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            hideOnUnmountRef.current?.();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
function $a804558cbe043398$export$78f191117ccfb2a2(coreActions, setToggleChangesDisabled) {
    const setDisabledRef = (0, $cozmU.useRef)(null);
    setDisabledRef.current = (isDisabled)=>{
        if (coreActions && setToggleChangesDisabled) coreActions.execute(setToggleChangesDisabled(isDisabled));
    };
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $a44d2501b233a83e$export$9fbb7446fea5a4a3)()) return;
        setDisabledRef.current?.(true);
        return ()=>{
            setDisabledRef.current?.(false);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
function $a804558cbe043398$export$3b6530866c3c332f({ editorView: editorView, segmentIndex: segmentIndex, segments: segments, onScrollToSegment: onScrollToSegment }) {
    const goToSegment = (0, $cozmU.useCallback)((newIndex)=>{
        if (!editorView || !segments || !segments[newIndex]) return;
        Promise.resolve().then(()=>{
            if (editorView && !editorView.isDestroyed) {
                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                    editorView: editorView,
                    segmentData: {
                        segmentIndex: newIndex,
                        positions: {
                            startPos: segments[newIndex].startPos,
                            endPos: segments[newIndex].endPos
                        }
                    }
                });
                onScrollToSegment?.(segments[newIndex].startPos, segments[newIndex].endPos);
            }
        });
    }, [
        editorView,
        segments,
        onScrollToSegment
    ]);
    // Arrows enabled only with more than one segment; navigation wraps around.
    const totalSegments = segments?.length ?? 0;
    const canGoPrevious = totalSegments > 1;
    const canGoNext = totalSegments > 1;
    const goToPrevious = (0, $cozmU.useCallback)(()=>{
        if (totalSegments <= 1) return;
        // Wrap: from 0 -> last.
        const newIndex = (segmentIndex - 1 + totalSegments) % totalSegments;
        goToSegment(newIndex);
    }, [
        segmentIndex,
        totalSegments,
        goToSegment
    ]);
    const goToNext = (0, $cozmU.useCallback)(()=>{
        if (totalSegments <= 1) return;
        // Wrap: from last -> 0.
        const newIndex = (segmentIndex + 1) % totalSegments;
        goToSegment(newIndex);
    }, [
        segmentIndex,
        totalSegments,
        goToSegment
    ]);
    return {
        canGoNext: canGoNext,
        canGoPrevious: canGoPrevious,
        goToNext: goToNext,
        goToPrevious: goToPrevious
    };
}


/* MiniAcceptedToast.tsx generated by @compiled/babel-plugin v2.0.0 */ 








var $9kbTQ = parcelRequire("9kbTQ");









const $6fbef3c055f5b73a$var$MINI_ACCEPTED_DURATION_MS = 1000; /** Delay after the mini appears before the Review moment moves to the next segment. */ 
const $6fbef3c055f5b73a$var$MINI_MOVE_DELAY_MS = 100; /** Half the review toolbar height (`DEFAULT_REVIEW_MODAL_HEIGHT` in `index.tsx`). */ 
const $6fbef3c055f5b73a$var$MINI_ACCEPTED_HEIGHT = 28; /** Sit at the same layer the review modal used (see `ModalRegion`). */ 
const $6fbef3c055f5b73a$var$MINI_ACCEPTED_Z_INDEX = Math.min(500, Math.max(402, (0, $7Y8M5.akEditorFloatingPanelZIndex) + 2)); // Emerges from within the toolbar top, slides up just above it, then fades.
const $6fbef3c055f5b73a$var$slideOutAndFade = null; // Fixed anchor point (its `left`/`top` come from the captured toolbar position).
const $6fbef3c055f5b73a$var$anchorCSS = null;
const $6fbef3c055f5b73a$var$pillCSS = null; /**
                       * Renders the compact "Accepted" confirmation that slides out of the Review moment.
                       *
                       * `onSlideOut` fires a short beat after the mini appears (the caller advances the
                       * Review moment to the next segment then); `onDone` fires once the mini has fully
                       * faded (the caller clears it then).
                       */ 
function $6fbef3c055f5b73a$export$c028f52908afb2f4({ centerX: centerX, anchorY: anchorY, container: container, onSlideOut: onSlideOut, onDone: onDone }) {
    const intl = (0, $kSwu1.useIntl)();
    const anchorRef = (0, $cozmU.useRef)(null);
    const [position, setPosition] = (0, $cozmU.useState)(null);
    const onSlideOutRef = (0, $cozmU.useRef)(onSlideOut);
    onSlideOutRef.current = onSlideOut;
    const onDoneRef = (0, $cozmU.useRef)(onDone);
    onDoneRef.current = onDone;
    (0, $cozmU.useEffect)(()=>{
        const moveTimer = setTimeout(()=>onSlideOutRef.current(), $6fbef3c055f5b73a$var$MINI_MOVE_DELAY_MS);
        const doneTimer = setTimeout(()=>onDoneRef.current(), $6fbef3c055f5b73a$var$MINI_ACCEPTED_DURATION_MS);
        return ()=>{
            clearTimeout(moveTimer);
            clearTimeout(doneTimer);
        };
    }, []); // `centerX`/`anchorY` are viewport coordinates, but the portal container lives
    // inside the editor content area which sets `contain`/`container-type` — that
    // makes it (not the viewport) the containing block for `position: fixed`. So we
    // render the anchor at (0,0), measure where that lands (the containing-block
    // origin), and offset it so its top-left sits at the captured viewport point.
    // Works whether or not a containing block is established.
    (0, $cozmU.useLayoutEffect)(()=>{
        const el = anchorRef.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        setPosition({
            left: centerX - rect.left,
            top: anchorY - rect.top
        });
    }, [
        centerX,
        anchorY
    ]);
    const anchorStyle = (0, $cozmU.useMemo)(()=>({
            left: position ? position.left : 0,
            top: position ? position.top : 0,
            // Hidden until measured so it never flashes at the containing-block origin.
            visibility: position ? 'visible' : 'hidden'
        }), [
        position
    ]);
    if (!container) return null;
    return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ $cozmU.createElement("div", {
        ref: anchorRef,
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _42Yu6BK3fQ _1pp6NdYbGa"
        ]),
        style: {
            ...anchorStyle,
            "--_a71oez": (0, $9aYkv.default)($6fbef3c055f5b73a$var$MINI_ACCEPTED_Z_INDEX)
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        role: "status",
        "aria-live": "polite",
        "data-testid": "post-stream-review-mini-accepted-toast",
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _0bjKvDuMRm _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VcM5X _24h04i2Njc _1Znuxb8HPE _2Zuz6Q8HPE _0KLXruoI2d _2OUyjtGk8v _1kk5Tkf7mX _1UtDYzy7kJ _1ANEUSLRg7 _1VJPcatUk6 _1gBibyir4u _0nFVCGipXj _43vdfT1fFG _3Y6bKpZSoF _442RFUYbGa"
        ])
    }, (0, $bf520c5d07f0f1e1$export$6bbc7e6c4947ba19)(), /*#__PURE__*/ $cozmU.createElement("span", null, intl.formatMessage((0, $5162eb24f9d4c228$export$defe85febe8b728c).accepted)))), container);
}


const $d3300ef204c009dc$var$wrapperCSS = null; /**
                          * Applied to the PSR wrapper while a rework submit is in flight. Visually hides
                          * the modal so the inline prompt's `ThinkingView` does not flash inside the
                          * review toolbar, while keeping the component tree mounted so the Rovo bridge
                          * connection remains alive for the in-flight rework stream.
                          */ 
const $d3300ef204c009dc$var$wrapperHiddenCSS = null; /**
                                * Compact single-row toolbar — see file-level JSDoc for the layout sketch.
                                *
                                * Fills its container (`ModalRegion`) so it tracks the modal width rather than
                                * duplicating a fixed value.
                                */ 
const $d3300ef204c009dc$var$toolbarCSS = null; /**
                          * Fallback height (px) used to reserve room below the review anchor when the
                          * modal DOM node never reports a height (e.g. it stays hidden). The toolbar is a
                          * fixed single row, so this is a safe approximation.
                          */ 
const $d3300ef204c009dc$var$DEFAULT_REVIEW_MODAL_HEIGHT = 56; /**
                                         * `ModalRegion` keeps the modal `display: none` (height 0) until it has measured
                                         * and positioned itself a couple of renders after open. We poll a few frames for
                                         * a real height before scrolling so the reserved room matches the toolbar — else
                                         * the first open under-scrolls and the modal overlaps the last change.
                                         */ 
const $d3300ef204c009dc$var$MODAL_MEASURE_MAX_FRAMES = 2; /** DOM class the modal chrome is rendered with (see `ModalRegion`). */ 
const $d3300ef204c009dc$var$MODAL_CLASS_SELECTOR = '.ak-editor-plugin-ai-modal'; /**
                                                            * Map a visible-list index (into the accepted-filtered `segments`) to its index
                                                            * in the raw `streamReviewSegments`. The reducer addresses the raw array; the UI
                                                            * navigates the filtered one, and the two diverge once anything is accepted.
                                                            * Positional (the Nth non-accepted entry), not `indexOf`, so shared entries
                                                            * can't match the wrong occurrence. Returns `-1` when out of range.
                                                            */ 
/**
 * Selects the first usable decoration to anchor the modal to. Mirrors the helper
 * in `Prompt.tsx` so the modal positioning logic stays consistent across screens.
 */ function $d3300ef204c009dc$var$findModalDecoration(modalDecorationSet) {
    if (!modalDecorationSet) return undefined;
    return modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift() || modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration').shift();
} /**
   * PostStreamReviewScreen — see file-level JSDoc for the full feature description.
   */ 
/**
 * [CCI-17658] Resolve a flat navigation index (into the derived `segments` list)
 * to the containing top-level segment in `streamReviewSegments`. Returns the
 * top-level index and the segment itself, or `undefined` if not found.
 */ function $d3300ef204c009dc$var$resolveTopLevelSegment(flatIndex, streamReviewSegments) {
    // When diff-based segmenting is off, flat index === top-level index.
    if (!(0, $f950c5cf47a566c8$export$73358e70ed9d9f32)()) return streamReviewSegments[flatIndex] ? {
        topLevelIndex: flatIndex,
        topLevelSegment: streamReviewSegments[flatIndex]
    } : undefined;
    let flatCounter = 0;
    for(let i = 0; i < streamReviewSegments.length; i++){
        const entry = streamReviewSegments[i];
        if (entry.isAccepted) continue;
        const visibleDiffCount = entry.diffSegments?.filter((diffSegment)=>!diffSegment.isAccepted).length || 0; // Top-level entries with nested diffs contribute only their visible diff
        // children; if all are accepted they contribute zero display slots.
        // Fallback to 1 means this top-level entry still occupies one step-through item.
        const effectiveCount = entry.diffSegments ? visibleDiffCount : 1;
        if (flatIndex >= flatCounter && flatIndex < flatCounter + effectiveCount) return {
            topLevelIndex: i,
            topLevelSegment: entry
        };
        flatCounter += effectiveCount;
    }
    return undefined;
} // Stamp document reading order (0-based) and a `groupId` per contiguous run onto
// freshly-computed working segments. `computeWorkingSegments` returns segments in
// ascending `startPos`, so the array index IS the reading order; a gap between a
// segment's `startPos` and the previous segment's `endPos` starts a new group.
// Aggregate undo/redo relies on both once live positions collapse to a point. Shared
// by the one-time open bootstrap and the BE-streaming append recompute.
function $d3300ef204c009dc$var$stampOrderAndGroup(computed) {
    let groupId = 0;
    return computed.map((segment, order)=>{
        if (order > 0 && segment.startPos !== computed[order - 1].endPos) groupId += 1;
        return {
            ...segment,
            order: order,
            groupId: groupId
        };
    });
}
function $d3300ef204c009dc$export$1f3531f6185e0ad9({ api: api, dispatch: dispatch, appearance: appearance }) {
    const { editorView: editorView, wrapperElement: wrapperElement, endExperience: endExperience, editorPluginAIProvider: editorPluginAIProvider, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { lastTriggeredFrom: lastTriggeredFrom, modalMountedTimeStamp: modalMountedTimeStamp, modalDecorationSet: modalDecorationSet, aiContentPositions: aiContentPositions, streamReviewSegments: streamReviewSegments, currentStreamReviewSegmentIndex: currentStreamReviewSegmentIndex, currentStreamReviewMode: currentStreamReviewMode, agentRemoteEditNonce: agentRemoteEditNonce, configItem: configItem } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>({
            lastTriggeredFrom: aiExperienceState?.aiDecorationExperiencePluginState.lastTriggeredFrom,
            modalMountedTimeStamp: aiExperienceState?.aiDecorationExperiencePluginState.modalMountedTimeStamp,
            modalDecorationSet: aiExperienceState?.aiDecorationExperiencePluginState.modalDecorationSet,
            aiContentPositions: aiExperienceState?.aiSessionPluginState?.aiContentPositions,
            streamReviewSegments: aiExperienceState?.aiSessionPluginState?.streamReviewSegments,
            currentStreamReviewSegmentIndex: aiExperienceState?.aiSessionPluginState?.currentStreamReviewSegmentIndex,
            currentStreamReviewMode: aiExperienceState?.aiSessionPluginState?.currentStreamReviewMode,
            agentRemoteEditNonce: aiExperienceState?.aiSessionPluginState?.agentRemoteEditNonce,
            configItem: aiExperienceState?.aiDecorationExperiencePluginState.configItem
        })); // Fallback free-gen prompt input (used when product has no Rovo onSubmit).
    const [textInput, setTextInput] = (0, $cozmU.useState)(''); // Whether the prompt currently holds any user input. Tracked separately from
    // `textInput` because the Rovo prompt's text never surfaces here — it only
    // reports emptiness (see `onPromptContentChange`) — while the fallback
    // `PromptScreen` reports the full string (see `onTextChange`). Drives whether
    // Enter accepts (empty) or submits the re-prompt (has text).
    const [hasInputText, setHasInputText] = (0, $cozmU.useState)(false); // Set to true when a rework submit is in progress. Visually hides the PSR
    // wrapper (via `wrapperHiddenCSS`) so the inline prompt's `ThinkingView`
    // spinner does not flash inside the review toolbar during the brief window
    // before `useUIState` resolves to `'loading'` and `RenderScreen` swaps
    // PSR → `LoadingSessionScreen` at the top level.
    const [isReworkSubmitting, setIsReworkSubmitting] = (0, $cozmU.useState)(false);
    const textInputRef = (0, $cozmU.useRef)(textInput);
    textInputRef.current = textInput; // `cancel` is wired into `RovoPromptScreenWithLogic` / `PromptScreen`
    // which can invoke it on benign events (Esc inside the prompt input, click
    // outside the prompt input but still inside the toolbar, etc.). For the
    // Post Stream Review screen we explicitly DO NOT want any of those to tear
    // down the modal — the user is still actively reviewing AI changes and the
    // toolbar must stay anchored until they take an explicit dismiss action.
    const cancel = (0, $cozmU.useCallback)((_options)=>{}, []); // AI content range exposed to Rovo as selection context on rework submit.
    // Populated below (needs the segments/mode) and read via a ref so the earlier
    // submit callbacks can reference it without a declaration-order problem.
    const reworkContextRangeRef = (0, $cozmU.useRef)(null); // Set the Rovo selection context for a rework prompt without installing an
    // editor selection (which would show the floating toolbar). A synthetic
    // `TextSelection` lets the AI selection plugin derive the `SelectionContext`
    // for `getAISelectionContext()` / `ReadContentCommandHandler`; we only
    // `setMeta`, never `setSelection`, so the editor selection is unchanged.
    const setSelectionContextForRework = (0, $cozmU.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        const range = reworkContextRangeRef.current;
        if (!range) return;
        const { state: state } = editorView;
        const clampedFrom = Math.min(range.startPos, state.doc.content.size);
        const clampedTo = Math.min(range.endPos, state.doc.content.size);
        if (clampedFrom >= clampedTo) return;
        const selection = (0, $kCECX.TextSelection).create(state.doc, clampedFrom, clampedTo);
        const tr = state.tr.setMeta((0, $iBAu1.selectionPluginKey), {
            action: 'lastSelectionContext',
            selection: selection
        }); // Paint a highlight over the reworked range so the author sees what the AI is
        // about to work on. Owned by the ai-session-context plugin so it renders
        // mutually-exclusively with the undone-segment gray. `setReworkHighlightRange`
        // is an EditorCommand `({ tr }) => tr`, so applying it folds its meta onto this
        // same transaction. This screen only mounts under the New AIFC Experience.
        (0, $7791c10173ad9c87$export$a8f24a1483956d06)({
            startPos: clampedFrom,
            endPos: clampedTo
        })({
            tr: tr
        });
        editorView.dispatch(tr);
    }, [
        editorView
    ]);
    const onTextChange = (0, $cozmU.useCallback)((input)=>{
        setTextInput(input);
        setHasInputText(input.trim().length > 0);
    }, []); // The Rovo prompt has no `onTextChange`; it reports emptiness via
    // `onPromptContentChange`. A mention/inline card counts as content even when
    // there's no plain text, so Enter submits the re-prompt rather than accepting.
    const onPromptContentChange = (0, $cozmU.useCallback)((payload)=>{
        setHasInputText(!payload.isEmpty || payload.hasMentionOrInlineCard);
    }, []); // Mirror Prompt.tsx — decide Rovo vs fallback prompt presentation.
    const hasRovoPrompt = !!editorPluginAIProvider.onSubmit;
    const { PromptEditor: PromptEditor } = editorPluginAIProvider;
    const hasFallbackPrompt = !hasRovoPrompt && !!PromptEditor;
    const screenRef = (0, $cozmU.useRef)(null);
    const rawSegmentIndex = currentStreamReviewSegmentIndex ?? 0; // The per-tool-call entries with overlaps merged: when the AI edits the SAME
    // node across tool calls the raw ranges overlap, which corrupts reconstruction
    // (out-of-range steps / wrong undo). Merging ONCE here yields disjoint,
    // doc-tiling changes for every consumer — step-through segmenting and all
    // aggregate operations. Memoized so its identity is stable for the deps below.
    const coarseSegments = (0, $cozmU.useMemo)(()=>(0, $4cf7589a720358c3$export$397513808d2b4602)(aiContentPositions ?? []), [
        aiContentPositions
    ]);
    const intl = (0, $kSwu1.useIntl)(); // [CCI-18590] Step Through Mode is opt-in via the `'step-through'` token of the
    // `platform_editor_review_moment_config` dynamic config (default off). Only allow
    // the expanded state when the token is enabled — this also
    // prevents a stale `currentStreamReviewMode === 'stepThrough'` from re-expanding
    // the nav tray or activating keyboard navigation while the feature is gated off.
    const isStepThroughExpanded = (0, $77d78733cc4ebcfe$export$2ae1a40df3c2a2f9)() && currentStreamReviewMode === 'stepThrough'; // Two review modes, driven by the step-through toggle (no separate control):
    //   - AGGREGATE (collapsed, default): View changes / Undo / Redo act on ALL the
    //     still-under-review changes at once, over the fine `visibleSegments`.
    //   - STEP-THROUGH (expanded): navigate the `visibleSegments` one at a time.
    const isAggregate = !isStepThroughExpanded; // Authoritative stream-review storage: top-level segments (with optional nested
    // diff-level sub-segments). This includes accepted entries.
    const allTopLevelSegments = (0, $cozmU.useMemo)(()=>streamReviewSegments ?? [], [
        streamReviewSegments
    ]); // Step-through display list: when diff-based segmenting is ON, flatten nested
    // diff-level entries; otherwise keep top-level entries. Accepted top-level
    // segments are hidden from both modes.
    const displaySegments = (0, $cozmU.useMemo)(()=>{
        const visibleTopLevel = allTopLevelSegments.filter((s)=>!s.isAccepted);
        if (!(0, $f950c5cf47a566c8$export$73358e70ed9d9f32)()) return visibleTopLevel;
        return visibleTopLevel.flatMap((topLevel)=>topLevel.diffSegments ? topLevel.diffSegments.filter((diffSegment)=>!diffSegment.isAccepted) : [
                topLevel
            ]);
    }, [
        allTopLevelSegments
    ]);
    const segmentIndex = displaySegments.length > 0 ? Math.max(0, Math.min(rawSegmentIndex, displaySegments.length - 1)) : 0; // Signature of every displayed segment's `appliedIndex`. Undo/redo/rework change
    // `appliedIndex` in place without moving `segmentIndex` or `displaySegments.length`,
    // so the diff effect below (keyed on the active view) wouldn't otherwise re-fire.
    // This changes on exactly those slice-history steps and is a precise repaint trigger.
    const appliedIndexSignature = (0, $cozmU.useMemo)(()=>displaySegments.map((segment)=>segment.appliedIndex).join(','), [
        displaySegments
    ]);
    const submit = (0, $cozmU.useCallback)(()=>{
        const currentInput = textInputRef.current;
        if (!currentInput?.trim()) return;
        setSelectionContextForRework(); // [CCI-17658] Per-segment rework: preserve segment state and snapshot
        // the active top-level segment for in-bounds detection.
        if (!isAggregate && streamReviewSegments?.length) {
            const resolved = $d3300ef204c009dc$var$resolveTopLevelSegment(segmentIndex, streamReviewSegments);
            if (resolved) {
                api?.core?.actions.execute((0, $7791c10173ad9c87$export$207b82940ed2d27)(resolved.topLevelIndex, resolved.topLevelSegment.startPos, resolved.topLevelSegment.endPos));
                return;
            }
        } // Aggregate rework: start fresh, clearing stale Post Stream Review state.
        api?.core?.actions.execute((0, $7791c10173ad9c87$export$5049e31d43480481)());
    }, [
        api?.core?.actions,
        setSelectionContextForRework,
        isAggregate,
        streamReviewSegments,
        segmentIndex
    ]); // Compute the working segments. Both strategies start from the top-level-node
    // segments (`calculateTopLevelNodeSegments`, one per changed top-level node):
    //   - diff-based segmenting OFF → use those top-level segments as-is.
    //   - diff-based segmenting ON → refine EACH top-level segment INDEPENDENTLY into
    //     granular sub-segments using the same gate-selected diff type as the rendered
    //     overlay (`smart` when enabled, otherwise `inline`). Running smart per segment
    //     keeps its `mergeOverlappingByNewDocRange` scoped to a single node, so distinct
    //     top-level nodes are never collapsed into one segment.
    // [CCI-17658] Compute working segments with diff sub-segments NESTED under
    // their parent top-level segment (not flatMapped). This preserves the grouping
    // needed for per-segment rework targeting: when reworking a diff sub-segment,
    // the parent top-level segment identifies the scope.
    const computeWorkingSegments = (0, $cozmU.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed || coarseSegments.length === 0) return [];
        const topLevelSegments = (0, $3eca34d37a5a6a25$export$7632b2cf80a07db5)(coarseSegments);
        if (!(0, $f950c5cf47a566c8$export$73358e70ed9d9f32)()) // Drop top-level segments that carry no reviewable change
        // (original slice === applied slice), so navigation never stops on a
        // "change" where nothing actually changed.
        return topLevelSegments.filter((segment)=>!(0, $7ba54af9843c5cb8$export$3d688fb5f6edd97a)(segment));
         // Nest diff-level sub-segments under each top-level segment instead of
        // flatMapping them. A top-level segment that can't sub-divide (whole-node
        // add/remove, or a change the diff strategy doesn't surface) keeps
        // `diffSegments` as an empty array.
        return topLevelSegments.reduce((acc, segment)=>{
            const params = (0, $4cf7589a720358c3$export$36fcf101941045df)(editorView, segment);
            if (!params || params.steps.length === 0) {
                // Can't sub-divide (e.g. whole-node add/remove): keep the top-level
                // segment as the reviewable unit — it is a genuine change.
                acc.push(segment);
                return acc;
            }
            const granular = (0, $ee2002594e1f6916$export$a3df838cbaca88df)({
                originalDoc: params.originalDoc,
                steps: params.steps,
                // `computeDiffChanges` intentionally does not gate smart diff itself,
                // so keep this caller aligned with the rendered overlay below.
                diffType: (0, $iDrrr.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'inline',
                locale: intl.locale
            }); // Filter the granular sub-segments down to genuine changes.
            // If none survive, the whole top-level segment carries no change and is
            // dropped; otherwise keep it with only the changed sub-segments nested.
            const changedGranular = granular.filter((sub)=>!(0, $7ba54af9843c5cb8$export$3d688fb5f6edd97a)(sub));
            if (changedGranular.length > 0) acc.push({
                ...segment,
                diffSegments: changedGranular
            });
            else if (granular.length === 0) // The diff strategy surfaced no sub-segments at all: fall back to the
            // top-level segment as the reviewable unit.
            acc.push(segment);
            return acc;
        }, []);
    }, [
        editorView,
        coarseSegments,
        intl.locale
    ]);
    const computeWorkingSegmentsRef = (0, $cozmU.useRef)(computeWorkingSegments); // Keep the ref in sync via a effect rather than assigning during render:
    // mutating a ref in the render body is a render-phase side effect that is unsafe
    // under React concurrent mode (renders can be interrupted/replayed).
    (0, $cozmU.useEffect)(()=>{
        computeWorkingSegmentsRef.current = computeWorkingSegments;
    }, [
        computeWorkingSegments
    ]); // Bootstrap: compute the working segments ONCE when the review opens and
    // publish them to plugin state. Guarded on `segments` being empty so it never
    // re-runs mid-review (which would clobber per-segment undo state) — the plugin
    // keeps positions remapped from there. A fresh AI session clears
    // `streamReviewSegments` (END_SESSION / RESET), so the next open recomputes.
    (0, $cozmU.useEffect)(()=>{
        if (!editorView || editorView.isDestroyed || // Guard on the RAW plugin-state list (not the accepted-filtered
        // `segments`) so accepting every-but-one segment never re-triggers the
        // one-time bootstrap and clobbers per-segment undo/accept state.
        allTopLevelSegments.length > 0 || coarseSegments.length === 0) return;
        const computed = computeWorkingSegmentsRef.current();
        if (computed.length > 0) api?.core?.actions.execute((0, $7791c10173ad9c87$export$c4e1fc753f807999)($d3300ef204c009dc$var$stampOrderAndGroup(computed)));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        coarseSegments,
        allTopLevelSegments.length,
        api
    ]); // [CCI-17994] BE streaming: when a NEW agent-edit batch lands while the Review
    // moment is ALREADY open (the plugin appends a coarse entry to `aiContentPositions`
    // and bumps `agentRemoteEditNonce`), recompute the fine working segments over the
    // grown coarse set and republish, so the new change becomes reviewable in the live
    // review. Keyed on the nonce so it fires exactly once per batch; the one-time
    // bootstrap above still handles the first open. NOTE: this recomputes the full set,
    // so per-segment undo/redo/accept state on existing segments is reset — acceptable
    // while the agent is still streaming (the user has not interacted yet). Preserving
    // that state across appends would require a merge and is a follow-up.
    const prevAgentRemoteEditNonceRef = (0, $cozmU.useRef)(agentRemoteEditNonce);
    (0, $cozmU.useEffect)(()=>{
        if (agentRemoteEditNonce === prevAgentRemoteEditNonceRef.current) return;
        prevAgentRemoteEditNonceRef.current = agentRemoteEditNonce;
        if (!editorView || editorView.isDestroyed || // Only append to an already-bootstrapped, open review; the one-time
        // bootstrap handles the first open.
        allTopLevelSegments.length === 0 || coarseSegments.length === 0) return;
        const recomputed = computeWorkingSegmentsRef.current();
        if (recomputed.length > 0) api?.core?.actions.execute((0, $7791c10173ad9c87$export$c4e1fc753f807999)($d3300ef204c009dc$var$stampOrderAndGroup(recomputed)));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentRemoteEditNonce
    ]);
    const currentSegment = displaySegments[segmentIndex]; // [CCI-17658] Step-through can display diff-level entries, but rework history
    // is tracked on the containing top-level segment. Resolve the active top-level
    // segment once and reuse it for range targeting and undo/redo state.
    const activeTopLevel = (0, $cozmU.useMemo)(()=>!isAggregate && streamReviewSegments?.length ? $d3300ef204c009dc$var$resolveTopLevelSegment(segmentIndex, streamReviewSegments) : undefined, [
        isAggregate,
        streamReviewSegments,
        segmentIndex
    ]);
    const activeStepSegment = activeTopLevel?.topLevelSegment ?? currentSegment; // Total reviewable changes — drives whether the "Step through changes" toggle
    // is offered (ActionButtons hides it for <= 1) and the "N / total" counter.
    const totalSegments = displaySegments.length; // Keep the rework selection-context range in sync with the current view:
    // aggregate = the span of all still-visible (non-accepted) changes
    // (min/max across `segments`); step-through = the active segment's range.
    if (isAggregate) reworkContextRangeRef.current = displaySegments.length ? {
        startPos: Math.min(...displaySegments.map((s)=>s.startPos)),
        endPos: Math.max(...displaySegments.map((s)=>s.endPos))
    } : null;
    else reworkContextRangeRef.current = activeStepSegment ? {
        startPos: activeStepSegment.startPos,
        endPos: activeStepSegment.endPos
    } : null;
     // No effect sets the editor selection while the Review moment is open: a real
    // selection would show the floating toolbar and can't represent edits spanning
    // non-contiguous ranges. Instead the diff overlay is always shown (below), and
    // the Rovo selection context is set only on Ask Rovo submit
    // (`setSelectionContextForRework`), so the toolbar stays hidden.
    // Undo/Redo state is **derived** from each segment's `appliedIndex`, so the
    // correct button state is restored across Prev/Next navigation.
    //   - Aggregate mode acts on ALL still-visible (non-accepted) changes at once,
    //     operating on the fine `segments`: Undo is enabled while ANY visible change
    //     can step back (appliedIndex > 0), Redo while ANY can step forward
    //     (appliedIndex < slices.length - 1).
    //   - Step-through acts on the single active visible segment.
    const canUndo = isAggregate ? displaySegments.some((s)=>(0, $7ba54af9843c5cb8$export$599958c5ce1f5bfc)(s)) : !!currentSegment && (0, $7ba54af9843c5cb8$export$599958c5ce1f5bfc)(currentSegment);
    const canRedo = isAggregate ? displaySegments.some((s)=>(0, $7ba54af9843c5cb8$export$84df6672c946d3cf)(s)) : !!currentSegment && (0, $7ba54af9843c5cb8$export$84df6672c946d3cf)(currentSegment); // Scroll a `[startPos, endPos]` change range into the viewport, deferred one
    // frame so the re-anchored modal has laid out (its height reserves room below
    // the anchor). No-ops when the range is already visible; when it is taller than
    // the viewport it lands on the END (scrolling down) or the START (scrolling up)
    // so the relevant edge is never cut off.
    const scrollRangeIntoViewDeferred = (0, $cozmU.useCallback)((startPos, endPos)=>{
        if (!editorView || editorView.isDestroyed) return;
         // Poll a few frames for the modal to lay out (it is `display: none`,
        // height 0, until `ModalRegion` positions it) so the reserved room below
        // the anchor matches the real toolbar height. Scroll as soon as it has a
        // height, or fall back after the cap so we never wait indefinitely.
        let frames = 0;
        const measureAndScroll = ()=>{
            if (!editorView || editorView.isDestroyed) return;
            const modalEl = editorView.dom.ownerDocument.querySelector($d3300ef204c009dc$var$MODAL_CLASS_SELECTOR);
            const measured = modalEl instanceof HTMLElement ? modalEl.offsetHeight : 0;
            if (measured === 0 && frames < $d3300ef204c009dc$var$MODAL_MEASURE_MAX_FRAMES) {
                frames += 1;
                requestAnimationFrame(measureAndScroll);
                return;
            }
            (0, $54d2fdcae373a96d$export$d393f31eaed8f940)({
                view: editorView,
                startPos: startPos,
                endPos: endPos,
                modalHeight: measured || $d3300ef204c009dc$var$DEFAULT_REVIEW_MODAL_HEIGHT
            });
        };
        requestAnimationFrame(measureAndScroll);
    }, [
        editorView
    ]);
    const onToggleStepThrough = (0, $cozmU.useCallback)(()=>{
        // Compute the next mode from current state and update it with a
        // plain (non-functional) setState so the state updater stays pure. The
        // side-effect (dispatching the modal command) is performed exactly once
        // here, NOT inside the updater — React may invoke functional updaters more
        // than once (e.g. StrictMode dev double-invoke), which would double-dispatch.
        const next = !isStepThroughExpanded;
        if (!editorView || editorView.isDestroyed) return;
         // The working `segments` already live in plugin state (computed on open and
        // shared by both modes), so toggling only re-anchors the modal — no
        // segment (re)computation here.
        if (next) {
            // Entering step-through: start at the first segment.
            const firstSegment = displaySegments[0];
            const startPos = firstSegment?.startPos;
            const endPos = firstSegment?.endPos;
            (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                editorView: editorView,
                mode: 'stepThrough',
                segmentData: {
                    segmentIndex: 0,
                    positions: {
                        startPos: startPos,
                        endPos: endPos
                    }
                },
                // Toggling diff mode never remounts the modal — it re-anchors in place.
                // ModalRegion replays the fade only when the anchor moves to a new row.
                preserveModalMountTimestamp: true
            });
            scrollRangeIntoViewDeferred(startPos, endPos);
        } else {
            // Returning to AGGREGATE mode: re-anchor below the LAST visible segment
            // and span the highlight across ALL still-visible (non-accepted)
            // changes, so accepted segments neither anchor nor widen the span.
            const aggregateStart = displaySegments.length ? Math.min(...displaySegments.map((s)=>s.startPos)) : 0;
            const aggregateEnd = displaySegments.length ? Math.max(...displaySegments.map((s)=>s.endPos)) : 0;
            (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                editorView: editorView,
                mode: 'aggregate',
                segmentData: {
                    segmentIndex: Math.max(0, displaySegments.length - 1),
                    positions: {
                        startPos: aggregateStart,
                        endPos: aggregateEnd
                    }
                },
                // Toggling diff mode never remounts the modal — it re-anchors in place.
                // ModalRegion replays the fade only when the anchor moves to a new row.
                preserveModalMountTimestamp: true
            });
        }
    }, [
        editorView,
        displaySegments,
        isStepThroughExpanded,
        scrollRangeIntoViewDeferred
    ]); // Real teardown: end the experience, wipe the session state, and terminate the
    // UI. Used by the Rovo re-prompt path and, after the "Accepted" pill's lifetime,
    // by `acceptAndConfirm` below.
    const finalizeClose = (0, $cozmU.useCallback)(()=>{
        endExperience({
            shouldClearSelectionContext: true
        });
        api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
        dispatch({
            type: 'terminate'
        });
    }, [
        endExperience,
        api,
        dispatch
    ]);
    const onBeforeSubmitForRovoChat = (0, $cozmU.useCallback)((_prompt)=>{
        setSelectionContextForRework(); // Visually hide PSR immediately so the inline prompt's ThinkingView
        // does not flash inside it while the plugin state transition propagates.
        setIsReworkSubmitting(true); // Per-segment rework: preserve segment state and snapshot the active
        // top-level segment for in-bounds detection.
        let didStartSegmentRework = false;
        if (!isAggregate && streamReviewSegments?.length) {
            const resolved = $d3300ef204c009dc$var$resolveTopLevelSegment(segmentIndex, streamReviewSegments);
            if (resolved) {
                api?.core?.actions.execute((0, $7791c10173ad9c87$export$207b82940ed2d27)(resolved.topLevelIndex, resolved.topLevelSegment.startPos, resolved.topLevelSegment.endPos));
                didStartSegmentRework = true;
            }
        } // Aggregate rework: tear down but preserve selection context
        endExperience({
            shouldClearSelectionContext: false
        }); // Enter streaming immediately so SessionUI swaps PSR -> Loading right away.
        // Aggregate rework clears the stale review state; per-segment already
        // has status: 'streaming' from startSegmentRework above — no need to
        // dispatch again (and startFreeGenStream would set userInput, which
        // triggers update()'s free-gen completion path prematurely).
        if (!didStartSegmentRework) api?.core?.actions.execute((0, $7791c10173ad9c87$export$5049e31d43480481)());
         // Allow default inline prompt submit to continue.
        return false;
    }, [
        setSelectionContextForRework,
        endExperience,
        isAggregate,
        streamReviewSegments,
        segmentIndex,
        api?.core?.actions
    ]);
    const openInRovoChatConfig = (0, $cozmU.useMemo)(()=>({
            onBeforeSubmit: onBeforeSubmitForRovoChat
        }), [
        onBeforeSubmitForRovoChat
    ]); /**
                                     * Undo/Redo for both modes, via the Option F forward-walk (`computeUndoRedo`).
                                     * It applies the slice-replaces, sets each touched segment's `appliedIndex`,
                                     * writes authoritative positions, and re-anchors the modal — all in a SINGLE
                                     * transaction (through `beforeTransform`, which runs at the start of
                                     * `createOpenAIModalCommand`'s transform). That avoids a two-dispatch race and
                                     * a sub-frame window where `canUndo`/`canRedo` or the diff read a stale state.
                                     *
                                     * Positions are derived from the transform itself (never a remapped-then-
                                     * collapsed stored value), so contiguous same-anchor changes re-separate
                                     * correctly on redo. See `computeUndoRedo` for the mechanic.
                                     */ 
    const replaceCurrentSegmentWith = (0, $cozmU.useCallback)((direction)=>{
        // Aggregate mode acts on ALL non-accepted segments and does NOT depend on
        // `currentSegment` (which may be undefined if `segmentIndex` is stale).
        // Only step-through requires a valid `currentSegment`.
        if (!editorView || !isAggregate && !activeStepSegment) return;
         // The `appliedIndex` each segment should end at. Option F is agnostic to
        // WHICH slice — it only positions the replace and records the range:
        //   - AGGREGATE (Semantic X): revert-all → 0, reapply-all → latest slice.
        //     Generalises the old all-at-once toggle; identical to it when every
        //     history is length 2 (no rework).
        //   - STEP-THROUGH: step ONLY the active (raw-indexed) segment by one.
        let targetIndexFor;
        if (isAggregate) targetIndexFor = direction === 'undo' ? ()=>0 : (seg)=>seg.slices.length - 1;
        else {
            // Fast path when diff-based segmentation is OFF: keep the original
            // single-segment replace flow to avoid unnecessary re-anchor churn.
            if (!(0, $f950c5cf47a566c8$export$73358e70ed9d9f32)() && currentSegment) {
                const delta = direction === 'undo' ? -1 : 1;
                const newIndex = currentSegment.appliedIndex + delta;
                const nextSlice = currentSegment.slices[newIndex];
                if (!nextSlice) return;
                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                    editorView: editorView,
                    segmentData: {
                        segmentIndex: segmentIndex,
                        positions: {
                            startPos: currentSegment.startPos,
                            endPos: currentSegment.endPos
                        }
                    },
                    appliedIndexUpdate: {
                        updates: [
                            {
                                index: segmentIndex,
                                appliedIndex: newIndex
                            }
                        ]
                    },
                    // Undo/redo never remounts the modal — it re-anchors in place. When the
                    // change moves the anchor to a new row, ModalRegion slides `top` to it
                    // (CSS transition), so there is no fade in either case.
                    preserveModalMountTimestamp: true,
                    beforeTransform: (tr)=>{
                        try {
                            tr.replaceRange(currentSegment.startPos, currentSegment.endPos, nextSlice);
                        } catch  {}
                        return tr;
                    }
                });
                return;
            } // `computeUndoRedo` addresses the raw array, so translate the visible
            // index — otherwise, after an accept, undo/redo steps the wrong entry.
            const delta = direction === 'undo' ? -1 : 1;
            targetIndexFor = (seg, index)=>index === segmentIndex ? seg.appliedIndex + delta : seg.appliedIndex;
        }
        const plan = (0, $b7b80dff187eb6b2$export$ff794085dd86337a)(editorView, displaySegments, targetIndexFor);
        if (!plan) return;
         // Apply the slice-replaces, set `appliedIndex`, write authoritative
        // positions, and re-anchor the modal — all atomically in ONE transaction.
        (0, $d07adef0b9b690ae$export$298c2762a7935072)({
            editorView: editorView,
            segmentData: {
                segmentIndex: segmentIndex,
                positions: plan.anchor
            },
            appliedIndexUpdate: {
                updates: plan.appliedIndexUpdates
            },
            positionsUpdate: {
                positions: plan.positions
            },
            // Undo/redo never remounts the modal — it re-anchors in place. When the
            // change moves the anchor to a new row, ModalRegion slides `top` to it
            // (CSS transition), so there is no fade in either case.
            preserveModalMountTimestamp: true,
            // Keep Review-moment Undo/Redo OUT of the editor history stack (see the
            // file-level note: undo/redo operate on stored slices, not the history plugin).
            // The slice-replace shares the transaction that re-anchors the modal; marking it
            // addToHistory:false stops prosemirror-history recording it as an entry, so the
            // whole AI session stays a single editor undo point — editor Undo (Cmd/Ctrl+Z)
            // after the review reverts the AI edit as a whole, not each review-moment step.
            // History still maps the changed ranges, keeping the AI-generation entry
            // consistent with the reviewed document.
            beforeTransform: (tr)=>plan.beforeTransform(tr).setMeta('addToHistory', false)
        });
    }, [
        editorView,
        activeStepSegment,
        currentSegment,
        segmentIndex,
        isAggregate,
        displaySegments
    ]); // The diff overlay is always shown; `showDeletedChanges` only toggles DELETED
    // content (via "Compare with original"): `true` shows deletions,
    // `false` => `hideDeletedDiffs: true`. Persists across Prev/Next and mode
    // switches so the user's chosen view is preserved through the review.
    //
    // Whether the review opens in "diff mode" (deletions shown) by default is gated
    // by the `'show-diff-by-default'` token of the `platform_editor_review_moment_config`
    // dynamic config (default off): when the token is off the review opens on the
    // clean (deletions-hidden) view and
    // the user can opt in via "Compare with original".
    const [showDeletedChanges, setShowDeletedChanges] = (0, $cozmU.useState)(()=>(0, $77d78733cc4ebcfe$export$fed1cea426ab8b29)()); // The show/hide-deletions toggle is enabled while any change is still applied
    // (aggregate) / the current segment is applied (per-segment).
    const canViewChanges = canUndo; // Pull the showDiff command bag into locals so the `useCallback` deps array
    // can reference the parent objects instead of destructured leaves (ESLint's
    // `exhaustive-deps` treats `api.showDiff.commands.hideDiff` as depending on
    // the whole `api.showDiff.commands` object).
    const showDiffCommands = api?.showDiff?.commands;
    const coreActions = api?.core?.actions; // Tear down the diff overlay. Used before an undo/redo: the diff must not be
    // painted while the undo/redo transaction is computed, because for a `remove`
    // segment the removed content is rendered as a diff decoration and leaving it
    // visible makes the undo/redo apply at the wrong position. After the modal
    // re-opens, the always-on diff effect re-shows the overlay.
    const hideDiff = (0, $cozmU.useCallback)(()=>{
        if (showDiffCommands?.hideDiff && coreActions) coreActions.execute(showDiffCommands.hideDiff);
    }, [
        showDiffCommands,
        coreActions
    ]); // Whether the review has been accepted and the "Accepted" pill is showing. While
    // true the toolbar is swapped for the pill (see render) and the review effects
    // below stand down; teardown is deferred until the pill finishes (`AcceptedToast`).
    const [isAccepted, setIsAccepted] = (0, $cozmU.useState)(false);
    const isAcceptedRef = (0, $cozmU.useRef)(isAccepted);
    isAcceptedRef.current = isAccepted; // Accept = keep the content already in the document. Hide the diff, show the
    // "Accepted" pill, and defer teardown until it finishes. A repeat dismiss while
    // the pill is up finalises immediately instead of waiting out the timer.
    const acceptAndConfirm = (0, $cozmU.useCallback)(()=>{
        if (isAcceptedRef.current) {
            finalizeClose();
            return;
        } // If every change is undone (no segment can undo, i.e. appliedIndex 0), there's
        // nothing to accept — skip the pill and tear down immediately.
        const hasNetChange = displaySegments.some((segment)=>(0, $7ba54af9843c5cb8$export$599958c5ce1f5bfc)(segment));
        if (!hasNetChange) {
            hideDiff();
            finalizeClose();
            return;
        }
        hideDiff(); // The "Accepted" pill is opt-in (CCI-19074). When disabled, tear down
        // immediately instead of showing `AcceptedToast`; the content is already applied.
        if (!(0, $77d78733cc4ebcfe$export$f9e5880031543548)()) {
            finalizeClose();
            return;
        }
        setIsAccepted(true);
    }, [
        finalizeClose,
        hideDiff,
        displaySegments
    ]); // Click-away accepts and closes the review. Routed through `acceptAndConfirm` so
    // it shows the "Accepted" pill first (or finalises if the pill is already up).
    (0, $a804558cbe043398$export$8deef307be5757ba)(screenRef, editorView, acceptAndConfirm); // The "Mini accepted" pill shown when a single change is accepted while stepping
    // through and more remain. Captures where the Review moment currently sits so the
    // mini can slide out of it while the toolbar re-anchors to the next segment. The
    // incrementing `key` restarts the animation on each successive accept.
    const [miniAccepted, setMiniAccepted] = (0, $cozmU.useState)(null);
    const miniKeyRef = (0, $cozmU.useRef)(0);
    const clearMiniAccepted = (0, $cozmU.useCallback)(()=>setMiniAccepted(null), []); // If the review is being accepted-and-closed (e.g. click-away) while a mini's move
    // is still pending, drop the mini so its deferred `onSlideOut` can't re-anchor the
    // modal during teardown.
    (0, $cozmU.useEffect)(()=>{
        if (isAccepted) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setMiniAccepted(null);
    }, [
        isAccepted
    ]);
    const onUndo = (0, $cozmU.useCallback)(()=>{
        hideDiff();
        replaceCurrentSegmentWith('undo');
    }, [
        hideDiff,
        replaceCurrentSegmentWith
    ]);
    const onRedo = (0, $cozmU.useCallback)(()=>{
        hideDiff();
        replaceCurrentSegmentWith('redo');
    }, [
        hideDiff,
        replaceCurrentSegmentWith
    ]); // Accept the current change (press Enter).
    //   - Aggregate: nothing left to step through, so `acceptAndConfirm()` shows the
    //     "Accepted" pill and then tears down (content is already applied).
    //   - Step-through: mark the current segment accepted and re-anchor at the
    //     next visible segment (wrap last → first). When one change would remain,
    //     switch back to aggregate. The flip and re-anchor commit in one
    //     transaction via `acceptedUpdate`, then the newly-active segment is
    //     scrolled into view so the modal shows at the correct position. When the
    //     last change is accepted, `acceptAndConfirm()` runs the confirmation + close.
    const acceptCurrent = (0, $cozmU.useCallback)(()=>{
        if (!editorView || editorView.isDestroyed) return;
        if (isAggregate) {
            acceptAndConfirm();
            return;
        } // Step-through: need a valid current visible segment to accept.
        if (!currentSegment) return;
         // Index of the accepted segment in the RAW plugin-state array — this is what
        // the reducer's `acceptedUpdate` flips. `segmentIndex` addresses the visible
        // (accepted-filtered) list, so translate it to the raw-array index.
        // Don't paint the diff while the modal re-anchors (mirrors undo/redo); the
        // always-on diff effect re-shows it after the re-open.
        hideDiff(); // The visible list AFTER this accept drops the current segment.
        const remainingVisible = displaySegments.filter((_, i)=>i !== segmentIndex); // Nothing left to review → accept completes the flow, so confirm + close the
        // modal (`hideDiff` already ran above).
        if (remainingVisible.length === 0) {
            acceptAndConfirm();
            return;
        } // A change is being accepted while others remain, so the Review moment stays
        // open and moves on. Build the "advance" step first, then play the "Mini
        // accepted" pill sliding out of the current toolbar and run the advance a beat
        // later (see below).
        let doMove;
        if (remainingVisible.length === 1) {
            // One change left → collapse to AGGREGATE over the single remaining change.
            const startPos = Math.min(...remainingVisible.map((s)=>s.startPos));
            const endPos = Math.max(...remainingVisible.map((s)=>s.endPos));
            doMove = ()=>{
                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                    editorView: editorView,
                    mode: 'aggregate',
                    segmentData: {
                        segmentIndex: 0,
                        positions: {
                            startPos: startPos,
                            endPos: endPos
                        }
                    },
                    acceptedUpdate: {
                        index: segmentIndex
                    }
                });
                scrollRangeIntoViewDeferred(startPos, endPos);
            };
        } else {
            // Advance to the NEXT visible segment (wrap last → first). Because the
            // accepted (current) segment is removed, the target's index in the shrunk
            // list is `segmentIndex % remainingVisible.length` (wraps to 0 when the
            // accepted one was last).
            const nextIndex = segmentIndex % remainingVisible.length;
            const nextSegment = remainingVisible[nextIndex];
            doMove = ()=>{
                (0, $d07adef0b9b690ae$export$298c2762a7935072)({
                    editorView: editorView,
                    segmentData: {
                        segmentIndex: nextIndex,
                        positions: {
                            startPos: nextSegment.startPos,
                            endPos: nextSegment.endPos
                        }
                    },
                    acceptedUpdate: {
                        index: segmentIndex
                    }
                });
                scrollRangeIntoViewDeferred(nextSegment.startPos, nextSegment.endPos);
            };
        } // Play the "Mini accepted" pill sliding out of the current toolbar, then run
        // the advance a beat later (the mini owns that timing). Fall back to an
        // immediate advance when the toolbar element can't be located (e.g. in tests),
        // or when the "Accepted" pill is disabled (opt-in via config — CCI-19074).
        const modalEl = editorView.dom.ownerDocument.querySelector($d3300ef204c009dc$var$MODAL_CLASS_SELECTOR);
        if (!(0, $77d78733cc4ebcfe$export$f9e5880031543548)() || !(modalEl instanceof HTMLElement)) {
            doMove();
            return;
        }
        const rect = modalEl.getBoundingClientRect();
        miniKeyRef.current += 1;
        setMiniAccepted({
            centerX: rect.left + rect.width / 2,
            // Anchor at the toolbar's top edge; the mini slides upward out of it.
            anchorY: rect.top,
            onSlideOut: doMove,
            key: miniKeyRef.current
        });
    }, [
        editorView,
        isAggregate,
        acceptAndConfirm,
        currentSegment,
        hideDiff,
        displaySegments,
        segmentIndex,
        scrollRangeIntoViewDeferred
    ]); // Non-toggling: render the diff overlay for the current view (aggregate = all
    // segments, per-segment = the current segment). `hideDeleted` controls whether
    // deleted content is suppressed. Safe to call when a diff is already shown —
    // `showDiff` replaces the existing decorations.
    const showCurrentDiff = (0, $cozmU.useCallback)((hideDeleted, reveal)=>{
        // Aggregate mode diffs ALL coarse changes and does NOT depend on
        // `currentSegment` (which may be undefined if `segmentIndex` is stale).
        // Only step-through requires a valid `currentSegment`.
        if (!editorView || !isAggregate && !activeStepSegment || !showDiffCommands?.showDiff) return;
         // Aggregate diffs all visible (non-accepted) changes; step-through diffs
        // only the current visible segment.
        const result = isAggregate ? (0, $4cf7589a720358c3$export$3a470f2f98a0c36)(editorView, displaySegments) : (0, $4cf7589a720358c3$export$36fcf101941045df)(editorView, currentSegment);
        if (!result?.steps || result.steps.length === 0 || !result.originalDoc) return;
        coreActions?.execute(showDiffCommands.showDiff({
            originalDoc: result.originalDoc,
            steps: result.steps,
            // The screen owns its own scrolling (`scrollAnchorIntoView` below):
            // show-diff's `scrollIntoView` always force-scrolls to the FIRST
            // change even when it is already on screen, which yanks the page to
            // the top of the review. We keep the modal's current anchor in view
            // instead, only when it is off screen.
            scrollIntoView: false,
            isInverted: false,
            // When `true`, deleted content is suppressed and only added/updated
            // content is highlighted — the default review view. "Compare with
            // original" flips this to `false` to also reveal deletions.
            hideDeletedDiffs: hideDeleted,
            hideAddedDiffsUnderline: hideDeleted,
            // Render the inline add/remove indicators only for the gated cohort.
            // The show-diff plugin also requires its extended experience internally.
            showIndicators: (0, $iDrrr.fg)('platform_editor_diff_plugin_show_indicators'),
            // Keep smart diff opt-in at the call site, matching the other show-diff
            // consumers. This also keeps the requested overlay type aligned with the
            // segment calculation above when the gate is off.
            diffType: (0, $iDrrr.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'inline',
            // Render deleted content AFTER the added/updated content (rather than before
            // it) so reviewers always read the new text first. show-diff splits this
            // across two independent options by change granularity, so BOTH are needed
            // to cover every change the review surface can produce:
            //   - `deletedDiffPlacement: 'bottom'` — node/paragraph-level changes,
            //     which includes whole-node *pure deletions* (the classifier promotes a
            //     removed child to node-level with a zero-width new-doc range).
            //   - `inlineDeletedDiffPlacement: 'after'` — inline- and sentence-level
            //     changes.
            // show-diff gates both behind `platform_editor_ai_smart_diff` +
            // `diffType: 'smart'`, so passing them unconditionally is safe (no-op when
            // the gate is off).
            deletedDiffPlacement: 'bottom',
            inlineDeletedDiffPlacement: 'after',
            reveal: // Only the deliberate "Compare with original" press asks for the reveal. This is also
            // called on every repaint of an already-open diff, which must not replay it.
            reveal
        }));
    }, [
        editorView,
        activeStepSegment,
        currentSegment,
        coreActions,
        showDiffCommands,
        isAggregate,
        displaySegments
    ]); // The change range the modal currently anchors below: the last still-visible
    // (non-accepted) change in aggregate (`segments` is sorted + disjoint, so the
    // last entry is furthest down), or the current segment in step-through.
    const anchoredChange = isAggregate ? displaySegments[displaySegments.length - 1] : currentSegment; // "View changes" toggles whether DELETED content is revealed, reflowing the doc.
    // Step-through re-centres the one reviewed segment (it may be scrolled off). In
    // aggregate the anchor is the LAST change, so scrolling would yank to the bottom;
    // native scroll anchoring holds position, so we deliberately do not scroll.
    const onViewChanges = (0, $cozmU.useCallback)(()=>{
        const next = !showDeletedChanges;
        setShowDeletedChanges(next); // Symmetric: putting the original away animates the same way as bringing it out. The reveal
        // is a cross-fade between two states, so it reads correctly in either direction, and a
        // one-way transition makes the control feel inconsistent.
        showCurrentDiff(!next, {
            mode: 'phased'
        });
        if (!isAggregate && anchoredChange) scrollRangeIntoViewDeferred(anchoredChange.startPos, anchoredChange.endPos);
    }, [
        showDeletedChanges,
        showCurrentDiff,
        anchoredChange,
        isAggregate,
        scrollRangeIntoViewDeferred
    ]); // Always-on diff: re-paint the diff whenever the view changes — open, Prev/Next
    // (`segmentIndex`), aggregate/step-through toggle (`isAggregate`), or when
    // segments first appear. The toggle's DELETED-content visibility PERSISTS across
    // these transitions, so the repaint honours the current
    // `showDeletedChanges` value rather than forcing the clean (deletions-hidden)
    // view. `showDeletedChanges` is intentionally not a dep (the "Compare with
    // original" button drives explicit toggles via `onViewChanges`); it is read via
    // a ref so a newly-navigated view reflects the persisted state without re-firing
    // this effect. `showCurrentDiff` is likewise read via a ref to avoid re-firing on
    // its frequently-changing deps.
    //
    // Note: `isStepThroughExpanded` and `showDeletedChanges` are intentionally not
    // reset on navigation — the step-through tray stays open and the chosen view is
    // preserved while the user steps through changes.
    const showCurrentDiffRef = (0, $cozmU.useRef)(showCurrentDiff);
    showCurrentDiffRef.current = showCurrentDiff;
    const showDeletedChangesRef = (0, $cozmU.useRef)(showDeletedChanges);
    showDeletedChangesRef.current = showDeletedChanges;
    (0, $cozmU.useEffect)(()=>{
        // Once accepted the diff is intentionally hidden (see `acceptAndConfirm`) so the
        // author sees the final clean content under the "Accepted" pill — don't repaint it.
        if (isAccepted || !canViewChanges) return;
         // `showCurrentDiff(hideDeletedDiffs)` — hide deletions unless the user has the
        // toggle on, so the persisted view is reproduced on the newly-navigated segment.
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        showCurrentDiffRef.current(!showDeletedChangesRef.current); // `appliedIndexSignature` re-fires this after an undo/redo/rework so the diff
    // `hideDiff()` tore down is repainted at the new applied slice — unless the
    // segment is now fully undone (`canViewChanges` false), where the gray
    // "undone" decoration takes over.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        segmentIndex,
        isAggregate,
        displaySegments.length,
        appliedIndexSignature,
        canViewChanges,
        isAccepted
    ]); // Aggregate mode anchors the modal below the LAST change, which can sit off
    // screen when the edits span more than a viewport (first open) or after
    // collapsing step-through. Bring that last change into view — but only in
    // aggregate, and only when it is not already visible.
    //
    // Entering step-through deliberately does NOT scroll: the user is already
    // looking at the last change (that is where aggregate is anchored), so the
    // viewport must stay put. Step-through navigation (Prev/Next) drives its own
    // scroll via `useSegmentNavigation`. Keying only on `isAggregate` +
    // `segments.length` (never the debounced `segmentIndex`) means the stale
    // intermediate frame during the mode flip cannot trigger a spurious scroll.
    (0, $cozmU.useEffect)(()=>{
        // No scrolling once accepted — the pill is showing and teardown is imminent.
        if (isAccepted || !isAggregate || displaySegments.length === 0) return;
         // `segments` are sorted by `startPos` and disjoint, so the last visible
        // (non-accepted) entry is furthest down the document — the change the modal
        // anchors below.
        const lastChange = displaySegments[displaySegments.length - 1];
        scrollRangeIntoViewDeferred(lastChange.startPos, lastChange.endPos); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAggregate,
        displaySegments.length,
        scrollRangeIntoViewDeferred,
        isAccepted
    ]);
    (0, $a804558cbe043398$export$e355b0795926452a)(coreActions, showDiffCommands?.hideDiff); // [CCI-18040] The main toolbar's "View changes" button must not be usable while the Review
    // moment owns the diff decorations. Re-enabled automatically when this screen unmounts.
    (0, $a804558cbe043398$export$78f191117ccfb2a2)(coreActions, api?.trackChanges?.commands?.setToggleChangesDisabled); // Navigate the visible `segments` so Prev/Next skip accepted segments.
    const { goToPrevious: goToPrevious, goToNext: goToNext, canGoPrevious: canGoPrevious, canGoNext: canGoNext } = (0, $a804558cbe043398$export$3b6530866c3c332f)({
        editorView: editorView,
        segmentIndex: segmentIndex,
        segments: displaySegments,
        onScrollToSegment: scrollRangeIntoViewDeferred
    }); // [CCI-18059] Toolbar keyboard shortcuts (see `useReviewKeyboardShortcuts` for
    // the bindings). Wires the SAME handlers the buttons / click-away use. Escape
    // maps to `acceptAndConfirm` so it matches clicking outside the toolbar.
    (0, $a804558cbe043398$export$fbda8a74cef18fab)(screenRef, {
        isAccepted: isAccepted,
        isPromptEmpty: !hasInputText,
        onAccept: acceptCurrent,
        onClose: acceptAndConfirm,
        canUndo: canUndo,
        canRedo: canRedo,
        onUndo: onUndo,
        onRedo: onRedo,
        isStepThroughExpanded: isStepThroughExpanded,
        canGoPrevious: canGoPrevious,
        canGoNext: canGoNext,
        onPrevious: goToPrevious,
        onNext: goToNext
    });
    const decoration = $d3300ef204c009dc$var$findModalDecoration(modalDecorationSet);
    if (!decoration || !modalDecorationSet) return null;
     // The editor's plugin-components container (inside `.ak-editor-content-area`, a
    // non-editable wrapper) — the Mini accepted pill portals here rather than into the
    // ProseMirror contentEditable, using the shared editor helper.
    const miniAcceptedContainer = (0, $jw4KW.getPopupContainerFromEditorView)(editorView?.dom);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: screenRef,
        "data-testid": "post-stream-review-session-screen",
        className: (0, $hekY6.default)([
            "_3iDTPbcK7c",
            isReworkSubmitting && "_3iDTPbYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $405400f22f07581a$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6daee9d675824f6$export$bd71f7a11db32a15), {
        lastTriggeredFrom: lastTriggeredFrom,
        key: modalMountedTimeStamp,
        decoration: decoration,
        editorView: editorView,
        editorRelativeWrapper: wrapperElement?.offsetParent,
        endExperience: endExperience,
        appearance: appearance,
        decorationSet: modalDecorationSet,
        getDeletedWidgets: api?.showDiff?.actions?.getDeletedWidgets,
        isDirectionalPinningEnabled: true
    }, isAccepted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c746d903466c4e2e$export$8a7e73cd1b8e3baf), {
        onDone: finalizeClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _0bjKvDuMRm _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXruoI2d _2OUyjtGk8v _24h04i2Njc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1f6111ffcc9c3687$export$e93225791a9c1544), {
        hasRovoPrompt: hasRovoPrompt,
        hasFallbackPrompt: hasFallbackPrompt,
        hasInputText: hasInputText,
        openInRovoChat: configItem?.openInRovoChat,
        openInRovoChatConfig: openInRovoChatConfig,
        cancel: cancel,
        PromptEditor: PromptEditor,
        textInput: textInput,
        onTextChange: onTextChange,
        onPromptContentChange: onPromptContentChange,
        submit: submit,
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled,
        canUndo: canUndo,
        canRedo: canRedo,
        onUndo: onUndo,
        onRedo: onRedo,
        canViewChanges: canViewChanges,
        showDeletedChanges: showDeletedChanges,
        onViewChanges: onViewChanges,
        totalSegments: totalSegments,
        segmentIndex: segmentIndex,
        canGoPrevious: canGoPrevious,
        canGoNext: canGoNext,
        onPrevious: goToPrevious,
        onNext: goToNext,
        isStepThroughExpanded: isStepThroughExpanded,
        onToggleStepThrough: onToggleStepThrough
    })))), miniAccepted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fbef3c055f5b73a$export$c028f52908afb2f4), {
        key: miniAccepted.key,
        centerX: miniAccepted.centerX,
        anchorY: miniAccepted.anchorY,
        container: miniAcceptedContainer,
        onSlideOut: miniAccepted.onSlideOut,
        onDone: clearMiniAccepted
    }));
}


/* Prompt.tsx generated by @compiled/babel-plugin v2.0.0 */ 





















const $a2c35a1320bee46f$var$promptScreenCSS = null;
function $a2c35a1320bee46f$var$findModalDecoration(modalDecorationSet) {
    if (!modalDecorationSet) return undefined;
    return modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift() || modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration').shift();
}
function $a2c35a1320bee46f$export$eee2c979f2d34827({ api: api, dispatch: dispatch, appearance: appearance }) {
    const { editorView: editorView, wrapperElement: wrapperElement, isRovoLoading: isRovoLoading, endExperience: endExperience, editorPluginAIProvider: editorPluginAIProvider, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { lastTriggeredFrom: lastTriggeredFrom, modalMountedTimeStamp: modalMountedTimeStamp, modalDecorationSet: modalDecorationSet, nextSessionId: nextSessionId, configItem: configItem, inlineRovoStreamingTargetId: inlineRovoStreamingTargetId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>({
            lastTriggeredFrom: aiExperienceState?.aiDecorationExperiencePluginState.lastTriggeredFrom,
            modalMountedTimeStamp: aiExperienceState?.aiDecorationExperiencePluginState.modalMountedTimeStamp,
            modalDecorationSet: aiExperienceState?.aiDecorationExperiencePluginState.modalDecorationSet,
            nextSessionId: aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId,
            configItem: aiExperienceState?.aiDecorationExperiencePluginState.configItem,
            inlineRovoStreamingTargetId: aiExperienceState?.aiDecorationExperiencePluginState.inlineRovoStreamingTargetId
        }));
    const isDirectionalPinningEnabled = (0, $cozmU.useMemo)(()=>{
        return !isRovoLoading;
    }, [
        isRovoLoading
    ]);
    const promptScreenRef = (0, $cozmU.useRef)(null); // State for fallback free-gen prompt input (used when onSubmit is not available)
    const [textInput, setTextInput] = (0, $cozmU.useState)('');
    const textInputRef = (0, $cozmU.useRef)(textInput);
    textInputRef.current = textInput;
    const cancel = (0, $cozmU.useCallback)((options)=>{
        endExperience({
            shouldClearSelectionContext: options?.shouldClearSelectionContext,
            shouldIgnoreNextSpaceTrigger: options?.shouldIgnoreNextSpaceTrigger
        });
        api?.core?.actions.execute((0, $7791c10173ad9c87$export$ea01a78091d2ff77)());
        dispatch({
            type: 'terminate'
        });
    }, [
        endExperience,
        api?.core?.actions,
        dispatch
    ]); // Fallback free-gen submit handler — dispatches START_FREE_GEN_STREAM
    // to trigger streaming via the ProseMirror plugin for products without Rovo.
    // Uses ref to always get the latest textInput, avoiding stale closure issues
    // when the submit callback is captured inside the memoized PromptEditor preset.
    const submit = (0, $cozmU.useCallback)(()=>{
        const currentInput = textInputRef.current;
        if (!currentInput?.trim()) return;
        api?.core?.actions.execute((0, $7791c10173ad9c87$export$a83cc81ac6219ae5)(currentInput));
    }, [
        api?.core?.actions
    ]);
    const onTextChange = (0, $cozmU.useCallback)((input)=>{
        setTextInput(input);
    }, []); // Callbacks for the openInRovoChat flow (SmartLink Rovo button). Hoisted before
    // early returns to satisfy React hooks rules and avoid inline object recreation.
    const rovoChatAIFeatureContext = configItem?.rovoChatAIFeatureContext;
    const rovoChatInteractionSource = configItem?.rovoChatInteractionSource;
    const publishChatNew = (0, $cozmU.useCallback)((prompt)=>{
        const publish = (0, $4xV3u.rovoAgentsPluginKey).getState(editorView.state)?.publish;
        if (publish) {
            const payload = {
                type: 'chat-new',
                product: editorPluginAIProvider.product,
                data: {
                    dialogues: [],
                    prompt: prompt,
                    ...rovoChatAIFeatureContext ? {
                        aiFeatureContext: rovoChatAIFeatureContext
                    } : {}
                },
                source: 'editor',
                ...rovoChatInteractionSource ? {
                    interactionSource: rovoChatInteractionSource
                } : {}
            };
            publish(payload);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorView,
        editorPluginAIProvider.product,
        rovoChatAIFeatureContext,
        rovoChatInteractionSource
    ]);
    const onBeforeSubmitForRovoChat = (0, $cozmU.useCallback)((prompt)=>{
        publishChatNew(prompt);
        cancel();
        return true;
    }, [
        publishChatNew,
        cancel
    ]);
    const openInRovoChatConfig = (0, $cozmU.useMemo)(()=>({
            onBeforeSubmit: onBeforeSubmitForRovoChat
        }), [
        onBeforeSubmitForRovoChat
    ]);
    (0, $bb835f24d2d32c51$export$27da6e66e88e9ac7)({
        ref: promptScreenRef,
        onDiscard: cancel,
        lastTriggeredFrom: lastTriggeredFrom,
        editorView: editorView,
        // Keep a background remix update (e.g. a MAUI app) alive when the user clicks
        // in the editor. Escape and the Stop button still cancel.
        disableClickOutside: !!inlineRovoStreamingTargetId && (0, $iDrrr.fg)('platform_editor_ai_remix_background_update')
    }); // Disable remix/AI entry points while a background remix update is in flight so
    // the user cannot start another remix on top of the running one. Re-enabled on
    // cleanup, which runs when the update completes or aborts (the target id clears
    // and this screen unmounts).
    (0, $cozmU.useEffect)(()=>{
        if (!inlineRovoStreamingTargetId || !(0, $iDrrr.fg)('platform_editor_ai_remix_background_update')) return;
        api?.aiExperience?.actions.toggleAiEntryPoints?.(true);
        return ()=>{
            api?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        };
    }, [
        api,
        inlineRovoStreamingTargetId
    ]); // Get decoration for modal positioning
    const decoration = $a2c35a1320bee46f$var$findModalDecoration(modalDecorationSet);
    if (!decoration || !modalDecorationSet) return null;
     // RovoInlineChatPrompt has its own internal logic with a loading screen
    // if a session is active, we'll show our own screen to prevent delay between
    // prompt submission and the rovo loading screen appearing
    if (nextSessionId) return null;
     // Use Rovo prompt when onSubmit is available (Rovo-capable products),
    // otherwise fall back to the standard PromptScreen for products without Rovo.
    const hasRovoPrompt = !!editorPluginAIProvider.onSubmit;
    const { PromptEditor: PromptEditor } = editorPluginAIProvider;
    const hasFallbackPrompt = !hasRovoPrompt && !!PromptEditor; // If neither Rovo prompt nor fallback prompt editor is available, we can't render
    // a prompt screen — fall back to Rovo prompt (which handles its own empty states).
    const renderPromptContent = ()=>{
        // SmartLink Rovo button: use RovoInlineChatPrompt but intercept submit to
        // open Rovo chat sidebar instead of performing an AI inline edit.
        if (configItem?.openInRovoChat && hasRovoPrompt) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e99c702c191ae5e3$export$d0c09a27ab507630), {
            cancel: cancel,
            openInRovoChatConfig: openInRovoChatConfig
        });
        if (hasFallbackPrompt && PromptEditor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6593db5854c11409$export$eddbff457ab4038b), {
            textInput: textInput,
            onTextChange: onTextChange,
            submit: submit,
            cancel: cancel,
            PromptEditor: PromptEditor,
            appearance: appearance,
            isAIFC: isInDocumentStreamingEnabled
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e99c702c191ae5e3$export$d0c09a27ab507630), {
            cancel: cancel
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: promptScreenRef,
        "data-testid": "rovo-prompt-session-screen",
        className: (0, $hekY6.default)([
            "_3iDTPbcK7c"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $405400f22f07581a$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6daee9d675824f6$export$bd71f7a11db32a15), {
        isDirectionalPinningEnabled: isDirectionalPinningEnabled,
        lastTriggeredFrom: lastTriggeredFrom,
        key: modalMountedTimeStamp,
        decoration: decoration,
        editorView: editorView,
        editorRelativeWrapper: wrapperElement?.offsetParent,
        endExperience: endExperience,
        appearance: appearance,
        decorationSet: modalDecorationSet,
        getDeletedWidgets: api?.showDiff?.actions?.getDeletedWidgets
    }, renderPromptContent())));
}


/**
 * RenderScreen is a separate component to prevent unnecessary unmount/remount cycles.
 * Defined outside SessionUIComponent to maintain a stable component reference.
 */ function $685e286e9de8c0bd$var$RenderScreen({ api: api, appearance: appearance, dispatch: dispatch, providerFactory: providerFactory, uiState: uiState }) {
    switch(uiState){
        case 'discard':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf30fcf8334a283a$export$31f5c3fa05bebb33), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'loading':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a60c6740285f91ed$export$6ad5d8e31817f39c), {
                api: api,
                appearance: appearance,
                dispatch: dispatch,
                providerFactory: providerFactory
            });
        case 'error':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d03c04859613e0c5$export$d5b86f1573c0ea10), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'prompt':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2c35a1320bee46f$export$eee2c979f2d34827), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'acceptReject':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c400fd4fb69c103$export$fe4c8e5bea1e02f4), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'noImprovement':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3009216cdf66bfd7$export$823eaf723be5a1b8), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        // [CCI-15904] New AIFC Editor Experience — Post Stream Review floating toolbar.
        case 'postStreamReview':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3300ef204c009dc$export$1f3531f6185e0ad9), {
                api: api,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'idle':
            return null;
    }
}
function $685e286e9de8c0bd$export$83a775c8cee50de8({ api: api, appearance: appearance, providerFactory: providerFactory }) {
    const [uiState, dispatch] = (0, $417555b7814249e6$export$fe5c3dd398c32c18)(api);
    const { canInlineStreamChanges: canInlineStreamChanges, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, editorView: editorView } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { pluginState: pluginState } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>{
        const decorationState = state.aiExperienceState?.aiDecorationExperiencePluginState;
        return {
            pluginState: decorationState
        };
    });
    const monitorWatchmenCommands = (0, $cozmU.useMemo)(()=>(0, $aa5000cb5a2af7b9$export$4783d4d69ea114f3)(editorView), [
        editorView
    ]);
    // Read decoration state synchronously from editorView to ensure invoke
    // attributes are available on the first render. useSharedPluginStateWithSelector
    // may not have the state until a subsequent render, but useCreateAnalyticsFlow
    // captures invokeAttributes at creation time and never re-reads them.
    const decorationState = editorView?.state ? (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state) : undefined;
    const invokeAttributes = (0, $cozmU.useMemo)(()=>({
            invokedFrom: decorationState?.lastTriggeredFrom ?? pluginState?.lastTriggeredFrom,
            invokedFor: decorationState?.triggeredFor?.name ?? pluginState?.triggeredFor?.name ?? 'text',
            triggerMethod: decorationState?.triggerMethod ?? pluginState?.triggerMethod,
            experienceName: decorationState?.configItem?.key ?? pluginState?.configItem?.key,
            featureId: decorationState?.configItem?.featureId ?? pluginState?.configItem?.featureId,
            aiGroupId: decorationState?.currentSessionId ?? pluginState?.currentSessionId,
            aiSessionId: decorationState?.interactionSessionId ?? pluginState?.interactionSessionId ?? '',
            willAISuggestEmoji: decorationState?.willAISuggestEmoji ?? pluginState?.willAISuggestEmoji
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        pluginState,
        decorationState
    ]);
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlowRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const sessionIdRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    if (!analyticsFlowRef.current || invokeAttributes.aiSessionId && sessionIdRef.current !== invokeAttributes.aiSessionId) {
        sessionIdRef.current = invokeAttributes.aiSessionId;
        analyticsFlowRef.current = {
            ...(0, $l2lIz.createAnalyticsFlow)({
                fireAIAnalyticsEvent: fireAIAnalyticsEvent,
                invokeAttributes: invokeAttributes,
                canInlineStreamChanges: canInlineStreamChanges,
                onCommonAttributesUpdated: monitorWatchmenCommands?.syncCommonAttributes,
                isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
            })
        };
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02d337cdf5827f29$export$b8f39b5859612546), {
        value: analyticsFlowRef.current
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $517a4f713651ad5f$export$7c274c7fd9279172), {
        api: api,
        uiState: uiState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($685e286e9de8c0bd$var$RenderScreen, {
        api: api,
        appearance: appearance,
        dispatch: dispatch,
        providerFactory: providerFactory,
        uiState: uiState
    })));
}


/* SessionUIComponentLegacy.tsx generated by @compiled/babel-plugin v2.0.0 */ 





function $c27ae7a9acdaec0a$export$83a775c8cee50de8({ api: api, providerFactory: providerFactory, appearance: appearance }) {
    const [state, dispatch] = (0, $417555b7814249e6$export$fe5c3dd398c32c18)(api);
    switch(state){
        case 'discard':
            return /*#__PURE__*/ $cozmU.createElement((0, $cf30fcf8334a283a$export$31f5c3fa05bebb33), {
                api: api,
                dispatch: dispatch,
                appearance: appearance
            });
        case 'loading':
            return /*#__PURE__*/ $cozmU.createElement((0, $a60c6740285f91ed$export$6ad5d8e31817f39c), {
                api: api,
                providerFactory: providerFactory,
                appearance: appearance,
                dispatch: dispatch
            });
        case 'idle':
        default:
            return null;
    }
}



































/**
 * Resolves the positions at which content should be inserted into the editor
 * for an 'insert' mode editor-suggestion.
 *
 * If explicit positions have been provided (via the `positions` prop), those are
 * used as-is. Otherwise, if the user has never explicitly focused/clicked into
 * the editor, the content is inserted at the end of the document. This ensures
 * that "Insert to page" appends to the end of the page when no cursor has been
 * explicitly placed, while still respecting an explicit click at position 1
 * (the very beginning of the document).
 *
 * @param explicitPositions  - Optional explicit [from, to] positions passed as a prop.
 * @param selectionFrom      - The current `state.selection.from` value.
 * @param selectionTo        - The current `state.selection.to` value.
 * @param docContentSize     - The current `state.doc.content.size` value.
 * @param hasFocused         - Whether the user has explicitly focused/clicked the editor.
 * @returns A [from, to] tuple for use with `insertAIContentAtCurrentPosition`.
 */ function $315999ef28da1a63$export$bb3c451a7dbf05d4(explicitPositions, selectionFrom, selectionTo, docContentSize, hasFocused) {
    if (explicitPositions) return explicitPositions;
    if (!hasFocused) // Insert content at end of doc if cursor isn't focused on page
    return [
        docContentSize,
        docContentSize
    ];
    return [
        selectionFrom,
        selectionTo
    ];
}















let $93800f3d7649cf97$var$lastActiveEditorView = null;
// Tracks whether the user has explicitly clicked into each editor instance at
// least once. Used to determine if insertable content should be appended at page end
const $93800f3d7649cf97$var$focusedEditorViews = new WeakMap();
const $93800f3d7649cf97$export$22ffc20f986d1257 = (editorView)=>!!$93800f3d7649cf97$var$focusedEditorViews.get(editorView);
const $93800f3d7649cf97$export$63e666219b0a303b = (editorView)=>{
    $93800f3d7649cf97$var$lastActiveEditorView = editorView;
};
const $93800f3d7649cf97$export$c9ca68398bbb9d15 = (editorView)=>editorView === $93800f3d7649cf97$var$lastActiveEditorView;
const $93800f3d7649cf97$export$ef11ea3288294174 = (editorView, editorApi, scrollToEnd = false)=>{
    return (tr)=>{
        const { state: state } = editorView;
        let finalTr = tr;
        if (editorApi?.card?.actions.queueCardsFromChangedTr) finalTr = editorApi.card.actions.queueCardsFromChangedTr(state, finalTr, (0, $krYZG.INPUT_METHOD).MANUAL);
        (0, $7qHrr.beforeDispatchAIRovoAgentTransaction)(finalTr);
        // When content is appended to the end of the document (user hasn't clicked
        // into the editor), move the selection to the end so scrollIntoView() brings
        // the new content into view rather than staying at the default cursor (pos 1).
        if (scrollToEnd) try {
            const endPos = finalTr.doc.content.size;
            finalTr.setSelection((0, $kCECX.TextSelection).near(finalTr.doc.resolve(endPos), -1));
        } catch (e) {
            if (!(e instanceof RangeError)) throw e;
            // Use scroll into view as fallback
            finalTr.scrollIntoView();
        }
        else finalTr.scrollIntoView();
        editorView.dispatch(finalTr);
        editorView.focus();
        // Instrumentation to scroll to end if content is appended to page
        if (scrollToEnd) requestAnimationFrame(()=>{
            try {
                const { selection: selection } = editorView.state;
                const domAtEnd = editorView.domAtPos(selection.from);
                const node = domAtEnd.node instanceof Element ? domAtEnd.node : domAtEnd.node.parentElement;
                if (node) node.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                });
            } catch  {
            // domAtPos can throw if the position is out of range; ignore silently.
            }
        });
    };
};
const $93800f3d7649cf97$export$ffc90b19d29ca0a6 = (editorView)=>{
    (0, $cozmU.useEffect)(()=>{
        if ($93800f3d7649cf97$var$lastActiveEditorView === null) $93800f3d7649cf97$export$63e666219b0a303b(editorView);
        let editorIsFocused = false;
        const handleFocus = ()=>{
            editorIsFocused = true;
            $93800f3d7649cf97$export$63e666219b0a303b(editorView);
        };
        const handleBlur = ()=>{
            editorIsFocused = false;
        };
        // Set focusedEditorViews when the user explicitly interacts with the editor.
        const handleClick = ()=>{
            $93800f3d7649cf97$var$focusedEditorViews.set(editorView, true);
        };
        const handleKeydown = ()=>{
            if (editorIsFocused) $93800f3d7649cf97$var$focusedEditorViews.set(editorView, true);
        };
        const editorDom = editorView.dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorDom.addEventListener('focus', handleFocus);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorDom.addEventListener('blur', handleBlur);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorDom.addEventListener('click', handleClick);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorDom.addEventListener('keydown', handleKeydown);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorDom.removeEventListener('focus', handleFocus);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorDom.removeEventListener('blur', handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorDom.removeEventListener('click', handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorDom.removeEventListener('keydown', handleKeydown);
            // Clear the last active editor view on unmount so stale references
            // don't persist after the editor is destroyed.
            if ($93800f3d7649cf97$var$lastActiveEditorView === editorView) $93800f3d7649cf97$var$lastActiveEditorView = null;
            $93800f3d7649cf97$var$focusedEditorViews.delete(editorView);
        };
    }, [
        editorView
    ]);
};


const $31ae21bd6736f6cf$var$topic = {
    topic: 'ai-mate'
};
const $31ae21bd6736f6cf$var$getPmFragmentFromEditorSuggestionPayload = (payload, schema, shouldUseRichContent)=>{
    if (shouldUseRichContent && payload.data.richContent?.type === 'text/adf') try {
        return (0, $aPdNQ.Fragment).fromJSON(schema, payload.data.richContent.content);
    } catch  {
    // Fall back to markdown if this editor schema cannot parse the rich ADF payload.
    }
    return (0, $97CWy.convertMarkdownToProsemirror)({
        markdown: payload.data.content,
        schema: schema,
        idMap: {}
    }).pmFragment;
};
const $31ae21bd6736f6cf$var$moveSelectionToEndOfChangedContent = (tr)=>{
    const stepRange = (0, $7SvWS.getStepRange)(tr);
    if (!stepRange) return tr;
    const selectionPos = Math.min(stepRange.to, tr.doc.content.size);
    try {
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(selectionPos), 1));
    } catch  {
    // Keep the selection chosen by the shared insert utility if this doc shape has no nearby cursor position.
    }
    return tr;
};
const $31ae21bd6736f6cf$var$SubscribeToRovoLegacy = ({ editorView: editorView, product: product, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    const siteId = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agents = (0, $3z1p5.useAgentsList)({
        assistanceServiceParams: {
            product: (0, $5PpGs.mapToAssistanceServiceProduct)(product),
            experienceId: 'ai-mate',
            touchpointSource: 'editor-agent-subscribe-to-rovo',
            siteId: siteId
        }
    });
    (0, $93800f3d7649cf97$export$ffc90b19d29ca0a6)(editorView);
    const callback = (0, $cozmU.useCallback)((payload)=>{
        if (payload.type === 'agent-changed' && onAIProviderChanged) onAIProviderChanged('rovo-chat', payload.data.agent ? {
            type: 'rovo',
            agent: payload.data.agent
        } : undefined);
        if (payload.type === 'editor-suggestion' && (0, $93800f3d7649cf97$export$c9ca68398bbb9d15)(editorView)) {
            const { state: state } = editorView;
            const insertedContentNodeTransformer = editorApi?.aiExperience?.actions?.getInsertedContentNodeTransformer?.();
            const isEditorFocused = (0, $93800f3d7649cf97$export$22ffc20f986d1257)(editorView);
            const dispatchTransaction = (0, $93800f3d7649cf97$export$ef11ea3288294174)(editorView, editorApi, payload.data.mode === 'insert' && !isEditorFocused // Scrolling to the end can only happen in insert mode
            );
            const shouldUseRichContent = (0, $iDrrr.fg)('kd_lumina_insert_replace_response_as_adf');
            switch(payload.data.mode){
                case 'insert':
                    {
                        const pmFragment = $31ae21bd6736f6cf$var$getPmFragmentFromEditorSuggestionPayload(payload, state.schema, shouldUseRichContent);
                        const insertPositions = (0, $315999ef28da1a63$export$bb3c451a7dbf05d4)(positions, state.selection.from, state.selection.to, state.doc.content.size, isEditorFocused);
                        const transaction = (0, $7qHrr.insertAIContentAtCurrentPosition)({
                            editorView: editorView,
                            positions: insertPositions,
                            pmFragment: pmFragment,
                            insertedContentNodeTransformer: insertedContentNodeTransformer
                        });
                        dispatchTransaction(shouldUseRichContent ? $31ae21bd6736f6cf$var$moveSelectionToEndOfChangedContent(transaction) : transaction);
                        break;
                    }
                case 'replace':
                    {
                        const pmFragment = $31ae21bd6736f6cf$var$getPmFragmentFromEditorSuggestionPayload(payload, state.schema, shouldUseRichContent);
                        const transaction = (0, $7qHrr.replaceWithAIContent)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment,
                            insertedContentNodeTransformer: insertedContentNodeTransformer,
                            options: {
                                replaceDocOnEmptySelection: false
                            }
                        });
                        dispatchTransaction(shouldUseRichContent ? $31ae21bd6736f6cf$var$moveSelectionToEndOfChangedContent(transaction) : transaction);
                        break;
                    }
            }
            const matchedAgent = agents.find((agent)=>agent.id === payload.data.agentId);
            if (matchedAgent && onDocChangeByAgent) {
                const agent = (0, $3JPgn.getEditorAgent)(matchedAgent);
                onDocChangeByAgent(agent);
            }
        }
    }, [
        onAIProviderChanged,
        editorView,
        agents,
        onDocChangeByAgent,
        positions,
        editorApi
    ]);
    (0, $hdBxM.useSubscribe)($31ae21bd6736f6cf$var$topic, callback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
};
const $31ae21bd6736f6cf$var$SubscribeToRovoNew = ({ editorView: editorView, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    const siteId = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const agents = (0, $5d618cff2175ca38$export$e37a2e6de6a7fa90)({
        cloudId: siteId,
        editorState: editorView.state
    });
    (0, $93800f3d7649cf97$export$ffc90b19d29ca0a6)(editorView);
    const callback = (0, $cozmU.useCallback)((payload)=>{
        if (payload.type === 'agent-changed' && onAIProviderChanged) onAIProviderChanged('rovo-chat', payload.data.agent ? {
            type: 'rovo',
            agent: payload.data.agent
        } : undefined);
        if (payload.type === 'editor-suggestion' && (0, $93800f3d7649cf97$export$c9ca68398bbb9d15)(editorView)) {
            const { state: state } = editorView;
            const insertedContentNodeTransformer = editorApi?.aiExperience?.actions?.getInsertedContentNodeTransformer?.();
            const isEditorFocused = (0, $93800f3d7649cf97$export$22ffc20f986d1257)(editorView);
            const dispatchTransaction = (0, $93800f3d7649cf97$export$ef11ea3288294174)(editorView, editorApi, payload.data.mode === 'insert' && !isEditorFocused // Scrolling to the end can only happen in insert mode
            );
            const shouldUseRichContent = (0, $iDrrr.fg)('kd_lumina_insert_replace_response_as_adf');
            switch(payload.data.mode){
                case 'insert':
                    {
                        const pmFragment = $31ae21bd6736f6cf$var$getPmFragmentFromEditorSuggestionPayload(payload, state.schema, shouldUseRichContent);
                        const insertPositions = (0, $315999ef28da1a63$export$bb3c451a7dbf05d4)(positions, state.selection.from, state.selection.to, state.doc.content.size, isEditorFocused);
                        const transaction = (0, $7qHrr.insertAIContentAtCurrentPosition)({
                            editorView: editorView,
                            positions: insertPositions,
                            pmFragment: pmFragment,
                            insertedContentNodeTransformer: insertedContentNodeTransformer
                        });
                        dispatchTransaction(shouldUseRichContent ? $31ae21bd6736f6cf$var$moveSelectionToEndOfChangedContent(transaction) : transaction);
                        break;
                    }
                case 'replace':
                    {
                        const pmFragment = $31ae21bd6736f6cf$var$getPmFragmentFromEditorSuggestionPayload(payload, state.schema, shouldUseRichContent);
                        const transaction = (0, $7qHrr.replaceWithAIContent)({
                            editorView: editorView,
                            positions: positions ?? [
                                state.selection.from,
                                state.selection.to
                            ],
                            pmFragment: pmFragment,
                            insertedContentNodeTransformer: insertedContentNodeTransformer,
                            options: {
                                replaceDocOnEmptySelection: false
                            }
                        });
                        dispatchTransaction(shouldUseRichContent ? $31ae21bd6736f6cf$var$moveSelectionToEndOfChangedContent(transaction) : transaction);
                        break;
                    }
            }
            const matchedAgent = agents.data.find((agent)=>agent.id === payload.data.agentId);
            if (matchedAgent && onDocChangeByAgent) onDocChangeByAgent(matchedAgent);
        }
    }, [
        onAIProviderChanged,
        editorView,
        agents,
        onDocChangeByAgent,
        positions,
        editorApi
    ]);
    (0, $hdBxM.useSubscribe)($31ae21bd6736f6cf$var$topic, callback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
};
const $31ae21bd6736f6cf$export$e7460f646530f5b4 = ({ editorView: editorView, product: product, onDocChangeByAgent: onDocChangeByAgent, onAIProviderChanged: onAIProviderChanged, editorPluginAIProvider: editorPluginAIProvider, positions: positions, editorApi: editorApi })=>{
    return (0, $iDrrr.fg)('platform_editor_ai_remove_agents_list') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31ae21bd6736f6cf$var$SubscribeToRovoNew, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView,
        onDocChangeByAgent: onDocChangeByAgent,
        product: product,
        onAIProviderChanged: onAIProviderChanged,
        positions: positions,
        editorApi: editorApi
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31ae21bd6736f6cf$var$SubscribeToRovoLegacy, {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView,
        onDocChangeByAgent: onDocChangeByAgent,
        product: product,
        onAIProviderChanged: onAIProviderChanged,
        positions: positions,
        editorApi: editorApi
    });
};


/* ContentComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































var $banCF = parcelRequire("banCF");


var $cgKJK = parcelRequire("cgKJK");

var $dpSRg = parcelRequire("dpSRg");

var $eXLWP = parcelRequire("eXLWP");




// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead



const $b32c46251ce11948$export$4d16f4ec9dad8b6b = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, $03RpJ.default)();
};






class $cfde210da32c5287$export$645455f759ffd2a2 extends WeakMap {
    getActor(editorView) {
        if (this.has(editorView)) return this.get(editorView);
        return null;
    }
    setActor(editorView, actorRef) {
        this.set(editorView, actorRef);
    }
}


const $a0a3fae6bc11cee3$export$a6342417f9492df1 = new (0, $cfde210da32c5287$export$645455f759ffd2a2)();
// Resets to clean context - all optional properties are ensured to reset via typescript
// Remaining required properties will be reset via `initialise context`.
const $a0a3fae6bc11cee3$var$initialContext = {
    analyticsContext: {
        aiSessionId: '',
        aiGroupId: ''
    },
    positions: [
        0,
        0
    ],
    isEmpty: true,
    selectionType: 'empty',
    markdown: '',
    adfResponse: undefined,
    latestPromptResponse: undefined,
    editCount: 0,
    refinementCount: 0,
    retryPromptCount: 0,
    latestPromptRetried: false,
    userInput: '',
    apiErrorInfo: {},
    responseHistory: {
        positionFromEnd: 0,
        entries: [],
        totalSize: 0,
        traversals: 0
    },
    channelId: undefined,
    usePageKnowledge: true,
    baseGenerate: undefined,
    userADFInput: undefined,
    parentPresetPromptLabel: undefined,
    latestPrompt: undefined,
    promptTrigger: undefined,
    idMap: undefined,
    contextStatistics: undefined,
    loadingStatus: undefined,
    rovoActions: undefined,
    previousAgentId: undefined,
    getMentionNameDetails: undefined,
    onceDiscard: undefined,
    triggeredFor: undefined,
    aiLifeCycleDynamicAttributesGetter: undefined,
    feedbackSubmitted: undefined,
    streamingHandler: undefined,
    traceIds: undefined,
    selectionMetaData: undefined,
    adfResponseNodeWrappers: undefined
};
function $a0a3fae6bc11cee3$export$d89ac572d9ca416a(options) {
    const machine = (0, $cgKJK.createMachine)({
        /** @xstate-layout N4IgpgJg5mDOIC5QEECSACAogDwA5gCcBLMAOwGMx0BZAQ3IAsjSwBiAV1wloBcrcA9rCI8iA0rADaABgC6iUIOGjxCkNkQBGAMwA2ABwA6abukB2TZv37tAVgBMmgCwAaEAE8t2w-oCcm+207bXtA-199AF9ItzQsPEISCio6RmYwQ1geWgI+CHQs3jYAayJyYvQBADMqmXkkECURMVI1DQRNM0cfWxsQ7U1bXVsBt08EEOljMzNbX10nW1mh+ydo2IwcfGIyShp6JhZM7NzIAuy+VlLyyprJTXrFIWbVBvbLeyn7Je1pc1NpJYxohJsZ9E5fNJwU5Zk5dNp1iA4ltErsUgd0oYALYCbgAG3Q9FEADcqIVLnByLR8HU1E0VK03oh7L4LIZnGYbPpHE4WfYzMCEL1fIZTCM5mYQty4YjkQkdsl9mkjjj8YTyCSyRc2FkBAQwABhcR8bA8ADKFyIWTKUjkdOeDLaIPsunshhCFjMul8TmkoRmgpdIrhei6phZcN8ss28qSe1ShwyqtoBKJRFJ5yKHC4RUJMFIPFtj0aDpaToQLMB7K9cOk2iccICge9hhD3u0kIc+jmaxiSJj2zj6OVSdxKfVmszfEMYFjaMMeIEtAgzCgU7Y5AEWNweLAfFpDXpZaZHV0XXdzgbZ6G4N82kFASh7pm-P0XQCQQRfblg7RSsT2JjqmGrplqRQznOyQLkuK6kGu5JsOwpDFKQAgAO6kOgVS0EQeIHk8yjHqA7SrMMhhepCThvjCLq2A+vy2D4DYRJ8VFeqs0bxL+ioJpiybAZOCEQdxlDQcuq7rqwsC0FiVBUowVDFGA7j4SWhGvMRXh2KKzjXiYHp6IKb6aIYthONokpnto3JhpxKIKvGGIqkBE6geuwmolBi7iXB7nebBUBSTw+oyapR4aeoWjgt4LoQqEQzer4-JGb4IpWAYUrUb6X4bFxnmOSOgFqmmGZCbOIkZP5ElCVVcHZtwfDoIwtCkCweKoBAYWlhF7zzCKUL6Jo5i2FYfqSoKVnkfW5hvt60hDDl-Z5Q5w4AfxrmldqHkrWJAV+TBq71bmRAQHQuBdepjKaRWYQ+AN9jgn6gKckZZhOMYDjSD6VhJSNi0-vlq18S5JVgdO5WA7t1VbbVgXUkQWE4XhdqHt1V2RRWQSMYNb6Qh2SV3g+UImboBiQgTrodnZkEFWtIMgZt4EQztsP7T5gUELmeJEFiIiQBdLzoyRTiaLohguvouiWBZwzsSlRhDPMnwmA2MK6NTFX-sDxUM2DGTM0OUO+TVB11TwAhKZh3O8zwiO4QLjonqEVYi-yb2SssvgPqRrZnpYPqct8ksa4DWvOTrglbQb86syb7OsMwuDsLb5sCAUDB6rb2H2yjBGC+Wnz+KKrrmZKA1wg+vJi+Tvgjd8IyDCHK1h6OEduWVNOVab8Ew93rBMLgtC0E1xpkFnSMO0RGNhGLb4mMTwwNvYD6aJChj+H4X0spTUbfgOoe8eH46g+50ded3bMBawyAAKoAAroMSYh4rwLToBAe5gBq-O52p+cnqvKid1vSdF5CGRYK9zyDG7INWw5hPhmCbkOFuRVj661Pp3I2PdwKw1YPqWAggJBUFTgUHmuEciTx6lFZw4teS-Asg4RYy8PBeBbPNKWiwQGb3sEgv8h9W5oMjkzTBsctrwztrufICFWDiP1MFFSv9wpC2ZJ9VsgcFidFASYImQRRSzF+tyEYoR-r72bvw1BAl25RxERfISnNGrWxEBtNg2AhK0CqHwAgAAKAASpgAAKj4gAmgAfWQAAGXCQAeQAOqYAACIAEpr6mOQeY9aJ8O4VSwe5exVBHG21BpQ5RFZXRTFdLCBYI0FjmCMqYdeZ4vrsVZBEXeuV7JpKcgIyxjNwY2PZrkrmZDbbMFBjI3ACM5EEAUcWJRBcvqMXmhZMwfoDDemYeMN6wYAgskls4Pwg1eE8S6RY5xGDsn6ifmANCklmCeIIAIKARRinlg5EYQEtd4Si1sL0UYLCOh1m8A4EIqVFhfX8Ec2m2tBFWOERcsAVybnSKQihdCmFs7I1mWjAucJ3oL1+SNPwugHwjCMIEfQX0IS9Elo4SFQMj49L1ttQ2lySBIu1Hgvc0z0C4AeduHgLynZUTdJ8VeKsqILIfG9MW3xpB0PMsMQY6s97LU6YVDJ6CsmQ1ZdcySkAnG8q3LgAVijsUnhGiZbsKyYSpTMr8L2-yEo+ApWeB6NEAi2DpSgjVQi+nwsRe5XlCK2VBRyLbfUVR0iyQLIK66Sq3T2tAaTOYHqHykzdCs1pP0-htKWh0vhJyfWwr9dq4Nuq7FgEjSwaNPBWCUmpGAWNGMlUimlJyeEb16yaAfMZd0DZrBK1CL6T1Kr83HPVfTX1+tME6vZeBCNUax6sCpMkAkC7q1jybe8H5jEQGsmcF9VZUrfjkW9MKeEvpRaINHZ3b1k7i3Tv9Wy3JlbF0FiOo1dgsBCDoETsnLdUUIhMTfBSn5MwDBprmOvP6z0paryiDezW6T729MfaWgNFaq1gBrR+qgX6f1-sKRAWoprLrzJFsXT5kohidDelKgwpkIwui9P7BD7Tb3Ibbqh5l85NxYixC1fIg9dw8EatI64xRqhVHQGhEQDAR78cEzylMe5GqEYAx0LGaiOwHLMKyCD-zErsh+R2GYNgQyaC9ZxmF3Gz6iT4wJ0gQmVOib1rhkeBZZwmqxWRk88IRX+09IS0w95-ktNFPNMBFL5gQjY3mjjhaUNMrsxkBzSnhOqbcyuygmL7S+bjQNRjnJ-C9F5KsImNDuykoiKNIIuaAZmMS1x5LmC0tOeUyJsTHLstgDwg8PL-8406EYj8nQo0-R3gcIGJpopHAfBFnoUIVmms2aZSuWAVICAQEMKM3WdbSC0AAEa7nflaTbnVSODYxiEb4PhHyuwbAlabrJZuWACAt10PDEMHxW4y9y63zuGDGeto7J2Ac5Auz5q77QBjzXZP6QY8xnBJQfHebwUIzyLA7A2AI172NId+2coS4OttA72-Wmkl3HbXQGLoq1OgIgGF9PoabLoLy7LMo4Osu8+yoQ-vABoDW1WJgG9T67Z4ejWr07XcyX0e0mXmHoH5qzaezGW4VQopwpHalF1PEiuzjABFMGUmwQxXD-IGCKWYD1TC+kcJKOLQuC0Tua+uXXVCEAi2xksOV0u7Vy4t9ZcWXbWIPSsDLdXdNXdapWu7kpIZJe+9tbLh14xeSMUlCLIaehggQu+41l3q3zmQ1EUUOPry9OMViklb4pNUrJUdToYPvpbUWUi5H6Ff2Y+G1L9OWG5enbDfZJjmw3yl6CkZ+RPTdZBq+ldNyDvDKifWOyb3jI4iMVnAQgP669cRVUR9FLQOoXxhDW5ORawXYatmRGov7py+4Ul9sVtPJ6ACnOJ39PC9d3vSShr2VifFkUUO8MUEuCwbsO-U5TJFfJ-AZOxIZG2X9A7XWT-EicMVsL6fZZwP6DZRAL0KYCEOKBYW3bsSzfPYXTvB-EtHaWdN3VGfLZtesDPX4VeMpYYaiElc8RYMbKwIOKuSAotWzGdMtOdacINRFVArwO8KaD5Ng3oOjf5ToepWYXSbsGpV1AQpLYvGgkQl9LDGtSQjoaLd0BYXGNQ2jc3U-L0MwcWf0O8CwZNPHeLAnQvLvGAnaTfCAQw1YaQyUayCEQYPTeEOiRQ8ybwbPD1fweBEdfHH7VwqgtDHaNrZzTrPWQwroGw34DKUmefIYAUQzUmZ1PoPwBwM8PTTQ6PLaEnLw+g6HZkWuIwH0PZXSHwoIHtRYUySWZYRYTsSUCoovYnM7CHHbZAzUQwqURZXkO8XHLeUWabVecWdZEYJKOEF0fotw8CaosnMY2osXGHP4auKiODVYiENo-5UVEUIMZHLIuEXoaIaIIAA */ id: 'AI Experience Machine',
        initial: 'started state',
        types: {
            context: {},
            events: {}
        },
        states: {
            'started state': {
                on: {
                    'kick off': [
                        {
                            target: 'modal active state.experience.error state.active',
                            guard: 'no textual content but prompt requires it',
                            actions: [
                                'updateFailureContextForNoTextualContent'
                            ]
                        },
                        {
                            target: 'modal active state.experience.loading state',
                            guard: 'neither base generate nor custom prompt'
                        },
                        '#AI Experience Machine.modal active state.experience.command palette state'
                    ],
                    'initialise context': {
                        actions: [
                            'initialiseContext'
                        ]
                    }
                }
            },
            'modal active state': {
                type: 'parallel',
                initial: 'experience',
                on: {
                    escape: {
                        target: '#AI Experience Machine.modal active state.discard.active'
                    },
                    storeContextStatistics: {
                        actions: 'storeContextStatistics'
                    }
                },
                states: {
                    experience: {
                        initial: 'command palette state',
                        states: {
                            'loading state': {
                                on: {
                                    complete: {
                                        target: 'review state',
                                        actions: [
                                            'pushToHistory',
                                            'updateMarkdown',
                                            'updateADFResponse',
                                            'clearUserInput',
                                            'updateRovoActions'
                                        ]
                                    },
                                    error: {
                                        target: '#error state.active'
                                    },
                                    'same cache key': {
                                        target: 'review state',
                                        actions: [
                                            'restoreResponseFromHistory',
                                            'clearUserInput'
                                        ]
                                    }
                                },
                                states: {
                                    loading: {
                                        invoke: {
                                            src: (0, $eXLWP.fromCallback)(({ input: context, sendBack: sendBack })=>{
                                                if (context.configItem.key !== (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC && context.streamingHandler) context.streamingHandler(context, sendBack);
                                            }),
                                            input: ({ context: context })=>context
                                        },
                                        on: {
                                            stream: {
                                                target: 'loading',
                                                actions: [
                                                    'updateMarkdown',
                                                    'updateADFResponse',
                                                    'updateLoadingStatus'
                                                ]
                                            },
                                            'update idMap': {
                                                target: 'loading',
                                                actions: 'updateIdMap'
                                            },
                                            'update traceIds': {
                                                target: 'loading',
                                                actions: 'updateTraceIds'
                                            },
                                            error: {
                                                target: '#error state.active'
                                            },
                                            'response too similar': {
                                                target: '#AI Experience Machine.modal active state.experience.review state',
                                                actions: [
                                                    'pushToHistory',
                                                    'clearUserInput',
                                                    'updateADFResponse'
                                                ]
                                            },
                                            'update selectionMetaData': {
                                                target: 'loading',
                                                actions: 'updateSelectionMetaData'
                                            },
                                            'update adfResponseNodeWrappers': {
                                                target: 'loading',
                                                actions: 'updateAdfResponseNodeWrappers'
                                            },
                                            'retry on adf stream errors': {
                                                target: 'loading',
                                                actions: 'retryOnAdfStreamErrors'
                                            }
                                        }
                                    }
                                },
                                initial: 'loading',
                                entry: [
                                    'setLatestPrompt',
                                    'updateChannelId'
                                ],
                                exit: 'clearLoadingStatus'
                            },
                            'review state': {
                                on: {
                                    interrogate: {
                                        target: 'loading state',
                                        actions: [
                                            'clearFromHistory',
                                            'updatePromptContextBasedOnTrigger',
                                            'interrogate'
                                        ]
                                    },
                                    refine: {
                                        target: 'loading state',
                                        actions: [
                                            'clearFromHistory',
                                            'updatePromptContextBasedOnTrigger',
                                            'incrementRefinementCount',
                                            'refine'
                                        ]
                                    },
                                    error: {
                                        target: '#error state.active'
                                    },
                                    'retry prompt': {
                                        target: 'loading state',
                                        actions: [
                                            'updatePromptContextBasedOnTrigger',
                                            'updateUserInput',
                                            'updateUserInputADF',
                                            'clearMarkdown',
                                            'incrementRetryPromptCount',
                                            'clearFromHistory'
                                        ]
                                    },
                                    'edit prompt': {
                                        target: 'command palette state',
                                        actions: [
                                            'editPrompt',
                                            'clearFromHistory'
                                        ]
                                    },
                                    'feedback submitted': {
                                        target: 'review state',
                                        actions: [
                                            'feedbackSubmitted'
                                        ]
                                    }
                                },
                                states: {
                                    preview: {
                                        on: {
                                            'start refinement': 'refinement'
                                        }
                                    },
                                    refinement: {
                                        on: {
                                            'cancel refinement': {
                                                target: '#AI Experience Machine.modal active state.discard.active',
                                                actions: [
                                                    'clearUserInput',
                                                    'clearFocus'
                                                ]
                                            },
                                            'update user input': {
                                                actions: 'updateUserInput'
                                            },
                                            'update user input adf': {
                                                actions: 'updateUserInputADF'
                                            }
                                        }
                                    }
                                },
                                initial: 'preview'
                            },
                            'command palette state': {
                                on: {
                                    'kickoff with command palette input': [
                                        {
                                            target: 'error state.active',
                                            guard: 'no textual content but prompt requires it',
                                            actions: [
                                                'updateFailureContextForNoTextualContent'
                                            ]
                                        },
                                        {
                                            target: 'loading state',
                                            actions: [
                                                'updatePromptContextBasedOnTrigger',
                                                'updateContext',
                                                'resetRefinementCount'
                                            ]
                                        }
                                    ],
                                    'update context': {
                                        target: 'command palette state',
                                        actions: [
                                            'updateContext'
                                        ],
                                        description: `This must be called before 'cancel' transition to make sure the context is updated before the 'if command input is empty' guard is evaluated.`
                                    },
                                    'toggle use page knowledge': {
                                        target: 'command palette state',
                                        actions: 'toggleUsePageKnowledge'
                                    },
                                    'update baseGenerate and configItem': {
                                        target: 'command palette state',
                                        actions: [
                                            'updateBaseGenerateAndConfigItem'
                                        ],
                                        description: `This must be called when agents are loaded and default baseGenerate and configItem needs to be reset`
                                    }
                                },
                                description: `This state creates a nested state machine that handles all the state of the command palette.

  It needs to know the 'userInput', 'baseGenerate' and 'configItem' from the AI Experience State Machine.

  Whenever we exit this state we need to update the AI Experience State Machine's context with the 'updateContext' action.`
                            },
                            //To avoid having to handle errors in every state, all errors are handled here.
                            // All error events are 'error' type with the errorInfo object containing further details.
                            // The experience application will handle the error and display the appropriate error message
                            //based on what has been stored in context on entry to the error state.
                            'error state': {
                                id: 'error state',
                                initial: 'inactive',
                                states: {
                                    inactive: {},
                                    active: {
                                        entry: [
                                            'updateContext',
                                            'storeFailureContext',
                                            'clearLoadingStatus'
                                        ],
                                        exit: [
                                            'clearFailureContext'
                                        ],
                                        on: {
                                            retry: {
                                                target: '#AI Experience Machine.modal active state.experience.loading state.loading'
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    },
                    discard: {
                        initial: 'inactive',
                        states: {
                            inactive: {
                                on: {
                                    'enable discard': {
                                        target: 'active',
                                        actions: 'updateContext'
                                    }
                                }
                            },
                            active: {
                                on: {
                                    'disable discard': {
                                        target: 'inactive',
                                        actions: 'updateContext'
                                    },
                                    escape: 'inactive'
                                }
                            }
                        }
                    }
                }
            }
        },
        context: options.context,
        on: {
            'update positions': {
                actions: 'updatePositions'
            },
            reset: {
                target: '.started state',
                actions: 'resetContext'
            }
        }
    }, {
        actions: {
            updatePositions: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'update positions') return {};
                const isEmpty = event.positions[0] === event.positions[1];
                const selectionType = isEmpty ? 'empty' : 'range';
                return {
                    positions: event.positions,
                    isEmpty: isEmpty,
                    selectionType: selectionType
                };
            }),
            resetContext: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'reset') return {};
                // Reset to initial context
                return $a0a3fae6bc11cee3$var$initialContext;
            }),
            initialiseContext: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'initialise context') return {};
                // Initialise
                return event.context;
            }),
            storeFailureContext: (0, $cgKJK.assign)(({ event: event })=>{
                if ([
                    'error'
                ].includes(event.type) && 'errorInfo' in event) return {
                    apiErrorInfo: event.errorInfo
                };
                return {};
            }),
            updateFailureContextForNoTextualContent: (0, $cgKJK.assign)(()=>{
                return {
                    apiErrorInfo: {
                        failureReason: (0, $Mgq5A.FAILURE_REASON).NO_TEXTUAL_CONTENT
                    }
                };
            }),
            clearFailureContext: (0, $cgKJK.assign)(()=>{
                return {
                    apiErrorInfo: {}
                };
            }),
            updateMarkdown: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'stream' && event.type !== 'complete') return {};
                return {
                    markdown: event.markdown,
                    feedbackSubmitted: undefined
                };
            }),
            updateADFResponse: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'stream' && event.type !== 'complete' && event.type !== 'response too similar') return {};
                return {
                    adfResponse: event.adfResponse
                };
            }),
            updateLoadingStatus: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'stream') return {};
                // If the loading status is empty, we want to clear it from the context
                if (event.loadingStatus === '') return {
                    loadingStatus: undefined
                };
                return {
                    loadingStatus: event.loadingStatus
                };
            }),
            clearLoadingStatus: (0, $cgKJK.assign)(()=>{
                return {
                    loadingStatus: undefined
                };
            }),
            storeContextStatistics: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'storeContextStatistics') return {
                    contextStatistics: event.contextStatistics
                };
                return {};
            }),
            clearMarkdown: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'retry prompt') return {};
                return {
                    markdown: undefined,
                    idMap: undefined,
                    selectionMetaData: undefined,
                    adfResponseNodeWrappers: undefined
                };
            }),
            interrogate: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'interrogate') return {};
                /**
         * Need to wipe out markdown as per user story designs where we don't use
         * the prior response in the latest response
         */ return {
                    markdown: '',
                    adfResponse: undefined,
                    configItem: context.configItem.key !== (0, $2MofN.CONFIG_ITEM_KEYS).ROVO_AGENT ? context.baseGenerate : context.configItem,
                    userInput: event.userInput,
                    userADFInput: event.userADFInput,
                    latestPromptResponse: event.latestPromptResponse
                };
            }),
            refine: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'refine') return {};
                return {
                    markdown: '',
                    configItem: event.configItem,
                    latestPromptResponse: event.latestPromptResponse
                };
            }),
            clearUserInput: (0, $cgKJK.assign)(()=>{
                return {
                    userInput: '',
                    userADFInput: undefined
                };
            }),
            updateUserInput: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'update user input' && event.type !== 'retry prompt') return {};
                return {
                    userInput: event.input
                };
            }),
            updateUserInputADF: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'update user input adf' && event.type !== 'retry prompt') return {};
                return {
                    userADFInput: event.adf
                };
            }),
            updateRovoActions: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'complete') return {};
                // We don't want to update if there are no rovo actions or
                // an agent hasn't been set
                if (!event.rovoActions?.length || !context.configItem.agent) return {
                    rovoActions: {}
                };
                return {
                    rovoActions: event.rovoActions.reduce((prevValue, currentValue)=>{
                        const key = currentValue.data.suggestion === 'insert' ? 'empty' : 'range';
                        prevValue[key] = currentValue.data;
                        return prevValue;
                    }, {})
                };
            }),
            feedbackSubmitted: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'feedback submitted') return {};
                return {
                    feedbackSubmitted: event.sentiment
                };
            }),
            pushToHistory: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'complete' && event.type !== 'response too similar') return {};
                const { cacheKey: cacheKey } = event;
                // Check if the most recent entry is the same as the new event to prevent duplicates
                const entries = context.responseHistory.entries;
                if (entries.length > 0 && entries[entries.length - 1].cacheKey === cacheKey) return {};
                let historyEvent;
                if (event.type === 'complete') historyEvent = {
                    userInput: context.userInput || '',
                    userADFInput: context.userADFInput,
                    configItem: context.configItem,
                    markdown: event.markdown,
                    cacheKey: cacheKey,
                    modelInput: event.modelInput,
                    inputOutputDiffRatio: event.inputOutputDiffRatio,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPrompt: context.latestPrompt
                };
                if (event.type === 'response too similar') historyEvent = {
                    userInput: context.userInput || '',
                    userADFInput: context.userADFInput,
                    configItem: context.configItem,
                    markdown: '',
                    responseTooSimilar: true,
                    cacheKey: cacheKey,
                    modelInput: event.modelInput,
                    inputOutputDiffRatio: event.inputOutputDiffRatio,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPrompt: context.latestPrompt
                };
                if (!historyEvent) return {};
                // Calculate the size of the historyEvent object for analytics
                const historyEventSize = new Blob([
                    JSON.stringify(historyEvent)
                ]).size;
                const totalSize = context.responseHistory.totalSize + historyEventSize;
                // Add the new event to the end of the entries array
                const updatedEntries = [
                    ...entries,
                    historyEvent
                ];
                // Ensure the entries array does not exceed 5 items to limit memory usage
                if (updatedEntries.length > 5) updatedEntries.shift();
                return {
                    responseHistory: {
                        entries: updatedEntries,
                        positionFromEnd: 0,
                        totalSize: // Reset the position
                        totalSize,
                        traversals: context.responseHistory.traversals
                    }
                };
            }),
            restoreResponseFromHistory: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'same cache key') return {};
                const { entries: entries } = context.responseHistory;
                const historyEvent = entries[entries.length - 1];
                if (!historyEvent) return {};
                return {
                    userInput: historyEvent.userInput,
                    userADFInput: historyEvent.userADFInput,
                    markdown: historyEvent.markdown,
                    configItem: historyEvent.configItem,
                    latestPromptResponse: historyEvent.markdown
                };
            }),
            clearFromHistory: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type !== 'retry prompt') return {};
                return {
                    responseHistory: {
                        entries: [],
                        positionFromEnd: 0,
                        totalSize: 0,
                        traversals: 0
                    }
                };
            }),
            setLatestPrompt: (0, $dpSRg.b)(({ enqueue: enqueue, check: check })=>{
                if (check({
                    type: 'is base generate'
                })) enqueue((0, $cgKJK.assign)(({ context: context })=>({
                        latestPrompt: {
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    })));
                else if (check({
                    type: 'has custom prompt'
                })) enqueue((0, $cgKJK.assign)(({ context: context, event: event })=>({
                        latestPrompt: {
                            ...event.type !== 'interrogate' && event.type !== 'refine' && {
                                presetTitle: context.configItem
                            },
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    })));
                else /**
           * Falls through to options which do not take additional
           * user input and is not base generate, e.g.
           * - Improve writing
           * - Summarize
           * Upon interrogation, there may also be user input.
           * We preference showing user input over the preset title for
           * non-partial presets.
           */ enqueue((0, $cgKJK.assign)(({ context: context })=>context?.userInput ? {
                        latestPrompt: {
                            userInput: context?.userInput || '',
                            userADFInput: context?.userADFInput
                        }
                    } : {
                        latestPrompt: {
                            presetTitle: context.configItem
                        }
                    }));
            }),
            clearFocus: ()=>{
                document.activeElement?.blur();
            },
            updateContext: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'kickoff with command palette input' || event.type === 'update context' || event.type === 'enable discard') return {
                    ...event.context
                };
                if (event.type === 'disable discard') return {
                    onceDiscard: undefined
                };
                return {};
            }),
            updateBaseGenerateAndConfigItem: (0, $cgKJK.assign)(({ event: event, context: context })=>{
                if (event.type === 'update baseGenerate and configItem') {
                    /**
           * If user has selected any prompt, then don't change configItem.
           */ if (context.configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE) return {
                        baseGenerate: event.baseGenerate,
                        configItem: event.configItem
                    };
                    else return {
                        baseGenerate: event.baseGenerate
                    };
                }
                return {};
            }),
            updateChannelId: (0, $cgKJK.assign)(({ context: context })=>{
                const { aiProvider: aiProvider, configItem: configItem } = context;
                if (!aiProvider.getChannelVariables || !configItem.agent) return {
                    channelId: undefined,
                    previousAgentId: undefined
                };
                // if agent did not change, we don't need to update channelId preserving the same conversation history
                // as soon as agent changes, we need to recreate channelId to start a new conversation
                if (configItem.agent.id === context.previousAgentId) return {};
                return {
                    channelId: (0, $b32c46251ce11948$export$4d16f4ec9dad8b6b)(),
                    previousAgentId: configItem.agent.id
                };
            }),
            updateIdMap: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type === 'update idMap') return {
                    idMap: {
                        ...context.idMap,
                        ...event.context.idMap
                    }
                };
                return {};
            }),
            updateTraceIds: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'update traceIds') return {
                    traceIds: event.context.traceIds
                };
                return {};
            }),
            updateSelectionMetaData: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'update selectionMetaData') return {
                    selectionMetaData: event.context.selectionMetaData
                };
                return {};
            }),
            updateAdfResponseNodeWrappers: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'update adfResponseNodeWrappers') return {
                    adfResponseNodeWrappers: event.context.adfResponseNodeWrappers
                };
                return {};
            }),
            retryOnAdfStreamErrors: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'retry on adf stream errors') return {
                    adfResponse: event.adfResponse,
                    markdown: ''
                };
                return {};
            }),
            editPrompt: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'edit prompt') return {};
                // from 'neither base generate nor custom prompt'
                const isBaseGenerate = context.configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                // if it's a preset prompt which doesn't need user input (like `Summarize writing`)
                // - we want to reset configItem
                // - we want to reset the user input
                const isPresetPrompt = !isBaseGenerate && !hasCustomPrompt;
                let configItem = context.configItem;
                // if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
                // - we don't want to reset the configItem
                //   - (keep the configItem) so that we can restore the selected parent later in UserInputCommandPaletteWithLogic
                // - we want to reset the user input
                const isSubmenuSelected = Boolean(context.parentPresetPromptLabel);
                // when we add default agent for knowledge source, it doesn't need additional user input because it's triggered from the user input
                // - we want to reset the configItem
                // - we don't want to reset the user input
                const isDefaultAgent = Boolean(context.configItem.agent?.isDefault);
                const resetConfigItem = (isPresetPrompt || isDefaultAgent) && !isSubmenuSelected;
                const resetUserInput = (isPresetPrompt || isSubmenuSelected) && !isDefaultAgent;
                if (resetConfigItem && context.baseGenerate) // from dismissCustomPrompt
                configItem = context.baseGenerate;
                // If we detect a preset prompt, clear everything
                // otherwise preserve what we can.
                return {
                    markdown: undefined,
                    userInput: resetUserInput ? undefined : event.userInput,
                    userADFInput: resetUserInput ? undefined : event.userADFInput,
                    presetTitle: resetUserInput ? undefined : event.presetTitle,
                    configItem: configItem,
                    latestPromptResponse: undefined,
                    editCount: context.editCount + 1,
                    idMap: undefined,
                    selectionMetaData: undefined,
                    adfResponseNodeWrappers: undefined
                };
            }),
            incrementRetryPromptCount: (0, $cgKJK.assign)(({ context: context })=>{
                return {
                    retryPromptCount: context.retryPromptCount + 1
                };
            }),
            incrementRefinementCount: (0, $cgKJK.assign)(({ context: context })=>{
                return {
                    refinementCount: context.refinementCount + 1
                };
            }),
            resetRefinementCount: (0, $cgKJK.assign)(()=>{
                return {
                    refinementCount: 0
                };
            }),
            updatePromptContextBasedOnTrigger: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'interrogate') return {
                    promptTrigger: 'interrogate',
                    latestPromptRetried: false
                };
                if (event.type === 'refine') return {
                    promptTrigger: 'refinementButton',
                    latestPromptRetried: false
                };
                if (event.type === 'retry prompt') return {
                    latestPromptRetried: true
                };
                if (event.type === 'kickoff with command palette input') return {
                    promptTrigger: 'generate',
                    latestPromptRetried: false
                };
                return {};
            }),
            toggleUsePageKnowledge: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type !== 'toggle use page knowledge') return {};
                // This is set to true by default
                return {
                    usePageKnowledge: !context.usePageKnowledge
                };
            })
        },
        guards: {
            ['has custom prompt']: ({ context: context })=>{
                // when we add default agent for knowledge source, it doesn't need additional user input because it's triggered from the user input
                const isDefaultAgent = Boolean(context.configItem.agent?.isDefault);
                if (isDefaultAgent) return false;
                return context.configItem.promptLabel !== undefined;
            },
            ['is base generate']: ({ context: context })=>{
                // Doing configItem direct comparision fails in tests where we mutate or create custom
                // items.
                return context.configItem.title === context.baseGenerate?.title;
            },
            ['neither base generate nor custom prompt']: ({ context: context })=>{
                const isBaseGenerate = context.configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                return !isBaseGenerate && !hasCustomPrompt;
            },
            ['if command input is empty']: ({ context: context })=>{
                return context.userInput?.trim?.()?.length === 0;
            },
            ['no textual content but prompt requires it']: ({ context: context, event: event })=>{
                let configItem = context.configItem;
                if (event.type === 'kickoff with command palette input') configItem = event.context.configItem;
                const requiresTextualContent = configItem.requiresTextualContent;
                const isBaseGenerate = configItem.title === context.baseGenerate?.title;
                const hasCustomPrompt = configItem.promptLabel !== undefined;
                const doesPromptRequireTextualContent = requiresTextualContent && !isBaseGenerate && !hasCustomPrompt;
                if (doesPromptRequireTextualContent) {
                    const state = context.editorView.state;
                    /**
           * If selection is empty then prompt will trigger on the entire document.
           * So checking if doc has textual content.
           */ return !(0, $3117ebeab67c20f0$export$13724218f8b1273e)(state, context.isEmpty ? [
                        0,
                        state.doc.content.size
                    ] : context.positions);
                }
                return false;
            }
        }
    });
    return machine;
}


function $18fb1940e348cb4f$export$519bc24a166a4cfd(options) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $a0a3fae6bc11cee3$export$d89ac572d9ca416a)(options);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const [state, send, actor] = (0, $banCF.useMachine)(machineRef.current);
    (0, $a0a3fae6bc11cee3$export$a6342417f9492df1).setActor(options.context.editorView, actor);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        send: send
    };
}









var $4wH3g = parcelRequire("4wH3g");


const $0e9b55d7410177be$export$62821c88a7188481 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "ZPhfu",
    name: "LoadableBrowseRovoAgentsModal",
    loader: ()=>(parcelRequire("03wtJ")).then((mod)=>mod.default),
    loading: ()=>null
});
const $0e9b55d7410177be$export$3b4439d273b7f3cc = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        $0e9b55d7410177be$export$62821c88a7188481.preload();
    }, []);
    return null;
};




























var $a1L5E = parcelRequire("a1L5E");















const $4d8cf0904a436811$export$cad72db1c520741c = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
null);
const $4d8cf0904a436811$export$28c15afa0bc9f86b = ()=>{
    const contextData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($4d8cf0904a436811$export$cad72db1c520741c);
    if (!contextData) throw new Error('Attempted to access AIExperienceCommonDataContext before its value is set');
    return contextData;
};
















var $flbIU = parcelRequire("flbIU");


var $33Ze6 = parcelRequire("33Ze6");




const $f32dd05596568c69$export$dc3b52bb600cbaa7 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_EDITOR_AGENT,
        title: (0, $flbIU.default).aiButtonTitle,
        description: (0, $flbIU.default).aiUniversalLongCallToAction,
        promptHint: (0, $93WrI.aiConfigItemMessages).freeGeneratePromptHint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                label: "",
                spacing: "spacious"
            }),
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        quickInsertPriority: Number.NEGATIVE_INFINITY,
        canTogglePageKnowledge: false,
        disableInterrogation: ()=>false,
        silentAgentPrompt: true,
        agent: options.agent,
        intentSchemaId: 'DISABLED',
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });
























function $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc({ markdown: markdown, schema: schema, source: source, fireAIAnalyticsEvent: fireAIAnalyticsEvent, idMap: idMap }) {
    try {
        const { pmFragment: pmFragment, htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes, htmlConvertedToNodes: htmlConvertedToNodes, unclosedTokens: unclosedTokens } = (0, $97CWy.convertMarkdownToProsemirror)({
            schema: schema,
            markdown: markdown,
            idMap: idMap,
            featureToggles: {
                markdownPlus: true,
                markdownPlusExtensions: true,
                markdownPlusPanels: true,
                markdownPlusDecisions: true,
                markdownPlusMentions: (0, $iDrrr.fg)('platform_editor_ai_draft_reply_mentions'),
                markdownPlusRemoveUnclosedTokens: true,
                allowAttributesMatchDefault: true
            }
        });
        return {
            pmFragment: pmFragment,
            unclosedTokens: unclosedTokens,
            htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
            htmlConvertedToNodes: htmlConvertedToNodes,
            isTextFallbackUsed: false
        };
    } catch (error) {
        // When convertMarkdownToProsemirror a fragment
        // we log an analytics event to call out that markdown conversion has failed
        fireAIAnalyticsEvent({
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownParser',
                attributes: {
                    source: source,
                    errorType: 'markdownParser',
                    errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            }
        });
        // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
        const fallbackPMFragment = (0, $aPdNQ.Fragment).from(schema.nodes.paragraph.create(null, schema.text(markdown)));
        return {
            pmFragment: fallbackPMFragment,
            unclosedTokens: {},
            htmlConvertedToFallbackNodes: 0,
            htmlConvertedToNodes: 0,
            isTextFallbackUsed: true
        };
    }
}








const $d211ad36412ee080$export$53eb05c40692d65e = (configItem, markdown, editorView, analyticSourceId)=>{
    const sourceEditorId = (0, $9qe1v.findEditorIdFromView)(editorView);
    if (!sourceEditorId) return;
    (0, $9XB2W.eventHub).publishFromEditor({
        event: 'ai experience llm complete',
        data: {
            analyticSourceId: analyticSourceId,
            configItemKey: configItem.key,
            markdown: markdown,
            sourceEditorId: sourceEditorId,
            ...configItem.draftReplyMetadata && {
                draftReplyMetadata: configItem.draftReplyMetadata
            }
        }
    });
};




const $2f49cf037b9198bf$export$1e9814631e2193d4 = (messageTemplate)=>{
    switch(messageTemplate){
        case 'ANALYSING_QUERY':
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).messageTemplateAnalysingQuery;
        case 'CONTENT_SEARCH':
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).messageTemplateContentSearch;
        case 'PAGE_HYDRATION':
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).messageTemplatePageHydration;
        case 'NEXT_BEST_TASK':
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).messageTemplateNextBestTask;
        case 'WRITING':
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).loadingTitle;
        default:
            return (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).generatingAiResponse;
    }
};
const $2f49cf037b9198bf$export$e51701552d28cc4e = ({ status: status, formatMessage: formatMessage })=>{
    const messageTemplate = $2f49cf037b9198bf$export$1e9814631e2193d4(status);
    return formatMessage(messageTemplate);
};










var $b8pma = parcelRequire("b8pma");




const $f66d9f8d20febc7b$var$useUfoLoadingStatus = (loadingStatus)=>{
    const previousStatusRef = (0, $cozmU.useRef)(null);
    // Track if we've ever had a loading status
    (0, $cozmU.useEffect)(()=>{
        if (loadingStatus) previousStatusRef.current = loadingStatus;
    }, [
        loadingStatus
    ]);
    // Simple logic for determining the status
    if (loadingStatus) // If we have a current status, use it directly
    return loadingStatus;
    else if (previousStatusRef.current) // If we had a status before but not anymore, we're rendering
    return 'RENDERING';
    else // If we never had a status, we're pending
    return 'PENDING';
};
var $f66d9f8d20febc7b$export$2e2bcd8739ae039 = $f66d9f8d20febc7b$var$useUfoLoadingStatus;


const $6efe87df395b9950$export$90b9d761c76d339a = ({ loadingStatus: loadingStatus })=>{
    const extendedLoadingStatus = (0, $f66d9f8d20febc7b$export$2e2bcd8739ae039)(loadingStatus);
    if (extendedLoadingStatus) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: `loadingStatus_${extendedLoadingStatus}`,
        key: `loadingStatus_${extendedLoadingStatus}`
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
};











const $5b15a14abf2aa8e2$export$8850f5fc4cad5830 = (markdown)=>{
    markdown = markdown.trim(); // Trim whitespace to ensure quotes at start/end are detected
    const firstChar = markdown.charAt(0);
    const lastChar = markdown.charAt(markdown.length - 1);
    // Check if the first and last characters are matching quotes (either ' or ")
    if (firstChar === '"' && lastChar === '"' || firstChar === "'" && lastChar === "'") // Remove the first and last character
    return markdown.substring(1, markdown.length - 1);
    // Return the original string if no matching outer quotes are found
    return markdown;
};















function $48b5c021b1ae01b8$export$6399b1de54f080ad(latestPrompt) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>{
        return latestPrompt?.presetTitle ? {
            presetTitle: (0, $c2c6d211a4290fa3$export$d97f37f32ae9d000)(latestPrompt.presetTitle, formatMessage),
            userInput: latestPrompt?.userInput,
            userADFInput: latestPrompt?.userADFInput
        } : {
            userInput: latestPrompt?.userInput || '',
            userADFInput: latestPrompt?.userADFInput
        };
    }, [
        latestPrompt,
        formatMessage
    ]);
}












const $a75407f6634c6048$export$6874965a4629d745 = 0.01;
const $a75407f6634c6048$var$TRAILING_NEWLINES_REGEX = /\n+$/u;
const $a75407f6634c6048$export$4ca0a669de074f43 = ({ input: input, output: output })=>{
    // Remove leading and trailing whitespace from both input and output
    input = input.trim();
    output = output.trim();
    // Remove Zero Width Non-Joiner
    input = input.replace(/\u200C/gu, '');
    output = output.replace(/\u200C/gu, '');
    // Remove \n from the end of input and output
    input = input.replace($a75407f6634c6048$var$TRAILING_NEWLINES_REGEX, '');
    output = output.replace($a75407f6634c6048$var$TRAILING_NEWLINES_REGEX, '');
    // If both input and output are empty, return 0 (no difference)
    if (input === '' && output === '') return 0;
    // If either input or output is empty, return 1 (completely different)
    if (input === '' || output === '') return 1;
    /**
	 * Bail out early if the input and output length are so different that even
	 * the longest common subsequence cannot produce a diff ratio less than MAX_DIFF_RATIO
	 * MAX_DIFF_RATIO > 1 - (2 * a) / (a + b)
	 * b > (1 + MAX_DIFF_RATIO) / (1 - MAX_DIFF_RATIO) * a
	 */ const longStringLength = Math.max(input.length, output.length);
    const shortStringLength = Math.min(input.length, output.length);
    if (longStringLength > (1 + $a75407f6634c6048$export$6874965a4629d745) / (1 - $a75407f6634c6048$export$6874965a4629d745) * shortStringLength) return 1;
    // If the string are exactly the same, return 0 (no difference)
    if (input === output) return 0;
    /**
	 * Bail out of calculating the diff ratio if the LCS cannot produce a diff ratio less than MAX_DIFF_RATIO
	 * MAX_DIFF_RATIO > 1 - (2 * lcs) / (a + b)
	 * This is a performance optimization to avoid unnecessary calculations
	 * when the strings are too different.
	 */ const minLcsLength = (1 - $a75407f6634c6048$export$6874965a4629d745) / 2 * (input.length + output.length);
    let isMinLcsPossible = true;
    // Calculate the length of the longest common subsequence (LCS)
    const lcsLength = (a, b)=>{
        const dp = Array.from({
            length: a.length + 1
        }, ()=>Array(b.length + 1).fill(0));
        // Remaining maximum possible LCS at any point
        for(let i = 1; i <= a.length; i++){
            let maxRowLcs = 0; // Tracks the maximum LCS in the current row
            for(let j = 1; j <= b.length; j++){
                if (a[i - 1] === b[j - 1]) dp[i][j] = dp[i - 1][j - 1] + 1;
                else dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
                // Update the maximum LCS found in this row
                maxRowLcs = Math.max(maxRowLcs, dp[i][j]);
            }
            // Estimate the maximum possible LCS length from this point
            const remainingLengthA = a.length - i; // Remaining characters in `a`
            const remainingLengthB = b.length; // All characters in `b` might still match
            const maxPossibleLcs = maxRowLcs + Math.min(remainingLengthA, remainingLengthB);
            // If the maximum possible LCS is less than the required threshold
            if (maxPossibleLcs < minLcsLength) {
                // Update the flag to indicate bailout
                isMinLcsPossible = false;
                // No need to continue further, we can return 0
                return 0;
            }
        }
        return dp[a.length][b.length];
    };
    const lcs = lcsLength(input, output);
    if (!isMinLcsPossible) return 1;
    // Calculate the difference ratio
    const diffRatio = 1 - 2 * lcs / (input.length + output.length);
    return Math.max(0, Math.min(1, diffRatio)); // Ensure the ratio is between 0 and 1
};



const $7cebc0ff804a659b$export$95a358671d66b6a5 = (props)=>{
    const { aiExperienceMachineContext: aiExperienceMachineContext, backendModel: backendModel, discardStream: discardStream } = props;
    const { configItem: configItem, channelId: channelId, responseHistory: history, latestPrompt: latestPrompt, markdown: actualMarkdown, retryPromptCount: retryPromptCount, endExperience: endExperience } = aiExperienceMachineContext;
    const { api: api, isDisplayingChanges: isDisplayingChanges } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, lastTriggeredFrom: lastTriggeredFrom, sendToAIExperienceMachine: sendToAIExperienceMachine } = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const product = editorPluginAIProvider.product;
    // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $48b5c021b1ae01b8$export$6399b1de54f080ad)(latestPrompt);
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const lastHistoryEvent = history.entries[history.positionFromEnd];
    /**
   * We may remove this diff ratio calculation, when we are sure that the backend
   * calculation is working. We will need to have converted to the new ConvoAI endpoint.
   * @see https://hello.jira.atlassian.cloud/browse/AIX-1665
   * @see https://hello.jira.atlassian.cloud/browse/EDITOR-792
   */ const diffRatio = (lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc) && actualMarkdown && (0, $iDrrr.fg)('editor_ai_no_improvement_deadend_fix') ? (0, $a75407f6634c6048$export$4ca0a669de074f43)({
        input: lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc || '',
        output: actualMarkdown
    }) : 1;
    const responseTooSimilar = lastHistoryEvent.responseTooSimilar || diffRatio < (0, $a75407f6634c6048$export$6874965a4629d745);
    const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
    const aiExperienceMetadata = (0, $cozmU.useMemo)(()=>{
        return {
            configItemTitle: configItem.agent?.name || (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
            ...configItem.experienceId && (0, $iDrrr.fg)('thor_support_google_docs_in_description_improver') ? {
                experienceId: configItem.experienceId
            } : {},
            lastTriggeredFrom: lastTriggeredFrom,
            inputOutputDiffRatio: inputOutputDiffRatio,
            backendModel: backendModel
        };
    }, [
        configItem,
        lastTriggeredFrom,
        inputOutputDiffRatio,
        backendModel
    ]);
    let markdown = actualMarkdown || '';
    if (markdown && (0, $bVbtv.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) markdown = (0, $5b15a14abf2aa8e2$export$8850f5fc4cad5830)(markdown);
    const onToggleChanges = (0, $cozmU.useCallback)(()=>{
        // toggle diff, diff will also be turned off when unmount ExperienceApplication
        api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
    }, [
        api
    ]);
    const onAccept = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_CHANGES_ACCEPT_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem.agent?.name || configItem.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
            action: (0, $krYZG.ACTION).ACTIONED,
            interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
            isProactive: false,
            attributes: {
                ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                aiResultAction: 'accepted',
                aiActionedType: 'manuallyAccepted'
            },
            invokedFrom: lastTriggeredFrom,
            traceIds: analyticsFlow.getCommonAttributes().traceIds,
            promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? analyticsFlow.getCommonAttributes().promptVersion : undefined
        }));
        (0, $d211ad36412ee080$export$53eb05c40692d65e)(configItem, actualMarkdown || '', aiExperienceMachineContext.editorView, lastTriggeredFrom ?? '');
        endExperience();
    }, [
        api,
        appearance,
        configItem,
        actualMarkdown,
        aiExperienceMachineContext.editorView,
        lastTriggeredFrom,
        product,
        endExperience,
        channelId,
        analyticsFlow
    ]);
    const onReject = (0, $cozmU.useCallback)(()=>{
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_CHANGES_REJECT_BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                appearance: appearance,
                configItemTitle: configItem.agent?.name || configItem.key,
                lastTriggeredFrom: lastTriggeredFrom,
                product: product
            }
        });
        api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)({
            action: (0, $krYZG.ACTION).DISMISSED,
            interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
            experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
            isProactive: false,
            attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                init: false
            }),
            invokedFrom: lastTriggeredFrom,
            traceIds: analyticsFlow.getCommonAttributes().traceIds,
            promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? analyticsFlow.getCommonAttributes().promptVersion : undefined
        }));
        discardStream?.();
        endExperience();
    }, [
        api,
        appearance,
        configItem,
        lastTriggeredFrom,
        product,
        discardStream,
        endExperience,
        channelId,
        analyticsFlow
    ]);
    const fireResponseFeedbackEvent = (0, $cozmU.useCallback)((sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem.agent?.name || configItem.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    retryPromptCount: retryPromptCount,
                    responseTooSimilar: responseTooSimilar,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).SUBMITTED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                isProactive: false,
                invokedFrom: lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                },
                traceIds: analyticsFlow.getCommonAttributes().traceIds,
                promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? analyticsFlow.getCommonAttributes().promptVersion : undefined
            })
        });
    }, [
        configItem,
        fireAIAnalyticsEvent,
        analyticsFlow,
        channelId,
        lastTriggeredFrom,
        inputOutputDiffRatio,
        retryPromptCount,
        responseTooSimilar,
        appearance,
        product
    ]);
    const handleFiringFeedbackEvent = (0, $cozmU.useCallback)(async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        });
        // we need to update the state machine to reflect the user feedback
        sendToAIExperienceMachine({
            type: 'feedback submitted',
            sentiment: feedbackMetadata.sentiment
        });
        // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    }, [
        fireResponseFeedbackEvent,
        editorPluginAIProvider,
        sendToAIExperienceMachine,
        analyticsFlow
    ]);
    const getAIExperience = (0, $cozmU.useCallback)((hasUserConsent)=>({
            ...aiExperienceMetadata,
            ...hasUserConsent && {
                userPrompt: localizedLatestPrompt.userInput,
                markdownResponse: markdown
            }
        }), [
        aiExperienceMetadata,
        localizedLatestPrompt,
        markdown
    ]);
    const onBadResponseButtonClick = (0, $cozmU.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'bad',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    const onGoodResponseButtonClick = (0, $cozmU.useCallback)(()=>{
        const feedbackMetadata = {
            sentiment: 'good',
            getAIExperience: getAIExperience,
            editorAttributes: {
                appearance: appearance,
                product: product
            }
        };
        // Now deprecated - migrate to handleFeedbackSubmission
        editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
        handleFiringFeedbackEvent(feedbackMetadata);
    }, [
        getAIExperience,
        editorPluginAIProvider.onExperienceEvent,
        handleFiringFeedbackEvent,
        appearance,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44f24bb9575eaa37$export$87eca91cbe06d0c8), {
        onAccept: onAccept,
        onReject: onReject,
        onBadResponseButtonClick: onBadResponseButtonClick,
        onGoodResponseButtonClick: onGoodResponseButtonClick,
        isDisplayingChanges: isDisplayingChanges,
        onToggleChanges: onToggleChanges
    });
};































const $9f3a8a4eac7688e1$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
    const discardPrompt = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardMessagePrompt);
    const discardResponse = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardMessageResponse);
    const discardStreamingInDocumentResponse = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardStreamingInDocumennt);
    if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
    if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardStreamingInDocumentResponse;
    return discardResponse;
};
function $9f3a8a4eac7688e1$export$643e9e046f871343({ state: state, editCount: editCount, retryPromptCount: retryPromptCount, history: history, onceDiscard: onceDiscard, channelId: channelId, streamFlowPacer: streamFlowPacer, discardStream: discardStream, api: api }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const nextSessionId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, configItem: configItem, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, appearance: appearance } = aiExperienceCommonData;
    const inputOutputDiffRatio = (0, $cozmU.useMemo)(()=>{
        const lastHistoryEvent = history.entries[history.positionFromEnd];
        return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
    }, [
        history
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: 'discard',
        callerComponent: 'DiscardScreenWithLogic',
        attributes: {
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            inputOutputDiffRatio: inputOutputDiffRatio,
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    (0, $cozmU.useEffect)(()=>{
        streamFlowPacer?.pause();
        return ()=>{
            streamFlowPacer?.resume();
        };
    }, [
        streamFlowPacer
    ]);
    const { abort: abort } = (0, $3637dbfe014bcd34$export$5ddafe3fa55c1ac5)();
    // If a session is active - we'll show the loading screen elsewhere and we can hide this
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13bb6e412023db64$export$453c0e2ebf820c66), {
        text: $9f3a8a4eac7688e1$export$28146c614df26dc4({
            formatMessage: formatMessage,
            experienceState: state
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCancel: function() {
            sendToAIExperienceMachine({
                type: 'disable discard'
            });
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDiscard: function() {
            /**
     * Introduced in EDF-1443 to track discard event confirmations
     * separately to normal discard events which get tracked
     * earlier in this file
     */ fireAIAnalyticsEvent({
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).DISMISSED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                    traceIds: analyticsFlow.getCommonAttributes().traceIds,
                    promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? analyticsFlow.getCommonAttributes().promptVersion : undefined
                })
            });
            // Abort any ongoing Rovo inline input box operations when discarding
            // Note if Rovo is not being used this will be a no-op
            abort();
            if (onceDiscard) {
                sendToAIExperienceMachine({
                    type: 'disable discard'
                });
                onceDiscard();
            } else {
                discardStream?.();
                endExperience();
            }
        },
        appearance: appearance,
        isAIFC: true
    });
}

























function $2f996e0ad8404319$export$eec2740903046434({ errorInfo: errorInfo }) {
    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f996e0ad8404319$var$ErrorScreenWithLogicXstate, {
        errorInfo: errorInfo
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f996e0ad8404319$var$ErrorScreenWithLogicInner, {
        errorInfo: errorInfo
    });
}
// Outer guard for xstate migration experiment — checks nextSessionId before
// mounting ErrorScreenWithLogicInner so that useAnalyticsFlowEventsQueue is
// never invoked for a component that will immediately return null (which would
// fire a spurious noEventExistsToBeFired → unhandledErrorCaught event with
// errorKey: null).
// When cleaning up platform_editor_ai_xstate_migration, move this into ErrorScreenWithLogic and remove this component.
function $2f996e0ad8404319$var$ErrorScreenWithLogicXstate({ errorInfo: errorInfo }) {
    const { api: api } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const nextSessionId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    if (nextSessionId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2f996e0ad8404319$var$ErrorScreenWithLogicInner, {
        errorInfo: errorInfo
    });
}
function $2f996e0ad8404319$var$ErrorScreenWithLogicInner({ errorInfo: errorInfo }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, editorView: editorView, appearance: appearance } = aiExperienceCommonData;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: (0, $1777869db0801c54$export$accc136c77ec5dfa)(errorInfo),
        callerComponent: 'ErrorScreenWithLogic',
        attributes: {
            errorType: errorInfo.failureReason ?? (0, $Mgq5A.FAILURE_REASON).UNKNOWN,
            sawAupViolation: errorInfo.failureReason === (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION,
            ...errorInfo
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if ((0, $iDrrr.fg)('platform_editor_ai_audit_logs_events')) {
            if (errorInfo.failureReason === (0, $Mgq5A.FAILURE_REASON).AUP_VIOLATION) {
                const command = (0, $191018c65431c8fe$export$c16f4f0c4f1ae3d4)({
                    'aup-violation': {
                        eventStatus: 'send-event'
                    }
                });
                command(editorView.state, editorView.dispatch);
            }
        }
    }, [
        errorInfo.failureReason,
        editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pxBW8.ErrorScreen), {
        text: (0, $1777869db0801c54$export$915e9e7bd4f0f96d)(errorInfo),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCancel: ()=>{
            endExperience();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onRetry: ()=>sendToAIExperienceMachine({
                type: 'retry'
            }),
        showRetryButton: (0, $1777869db0801c54$export$27eceeaa1726619e)(errorInfo),
        appearance: appearance,
        isAIFC: isInDocumentStreamingEnabled
    });
}















function $c4632a2412dddbf8$export$124856cc35c13bde({ errorInfo: errorInfo, contextStatistics: contextStatistics }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience } = aiExperienceCommonData;
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: 'invalidInput',
        callerComponent: 'InvalidInputScreenWithLogic',
        attributes: {
            reason: errorInfo.failureReason ?? (0, $Mgq5A.FAILURE_REASON).UNKNOWN,
            modelIO: {
                contextStatistics: contextStatistics
            }
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $pxBW8.ErrorScreen), {
        text: (0, $1777869db0801c54$export$915e9e7bd4f0f96d)(errorInfo),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCancel: ()=>{
            endExperience();
        },
        isAIFC: isInDocumentStreamingEnabled
    });
}


/* LoadingScreenWithLogic.tsx generated by @compiled/babel-plugin v2.0.0 */ 




















/**
 * This function checks if a given markdown string ends with an incomplete "custom" tag,
 * ensuring that the tag is not closed by either a full closing tag (</custom>) or a self-closing tag (/>).
 *
 * Examples of matches:
 * - "Something something <"
 * - "Something something <c"
 * - "Something something <cust"
 * - "Something something <custom"
 *
 * It will not match strings where the "custom" tag is completed or closed:
 * - "Something something <custom/>"
 * - "Something something </custom>"
 * - Non-custom tags like:
 *   - "<custard"
 *   - "<status"
 */ const $bb827e6786ce28c4$export$bde720e3489117f9 = (markdown)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>|.*\/>).*?)?)?)?)?)?)?$/g);
};












const $ea1e399bb2487613$export$b38eff301cbfa415 = ({ editorPluginAIProvider: editorPluginAIProvider })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let disclaimer;
    const { aiUsageDisclaimer: aiUsageDisclaimer } = editorPluginAIProvider;
    if (aiUsageDisclaimer) disclaimer = {
        text: formatMessage(aiUsageDisclaimer.text),
        tooltip: formatMessage(aiUsageDisclaimer.tooltip),
        url: aiUsageDisclaimer.url
    };
    return disclaimer;
};












function $45c921fe28f84dd0$export$4e4614f0417d7178({ userADFInput: userADFInput }) {
    return (0, $cozmU.useMemo)(()=>{
        const jsonTransformer = new (0, $2lPWP.JSONTransformer)();
        const promptStats = userADFInput ? new (0, $3cHXJ.ProseMirrorContentStatistics)(jsonTransformer.parse(userADFInput)) : undefined;
        return promptStats?.collectStatistics();
    }, [
        userADFInput
    ]);
}







const $8312663103724919$export$e9b50d8f92ed61d4 = 'use-general-ai-knowledge';
const $8312663103724919$export$f94ca114676d6a3f = 'use-rovo-organisation-knowledge';
const $8312663103724919$export$aed4aa2c04f0ff0a = 'tell-ai';
const $8312663103724919$export$ea35400996401183 = 'tell-agent';
const $8312663103724919$export$3cb19042951e1104 = 'agent:browse-more-agents';
const $8312663103724919$export$95f98990d7202b31 = 'show-more';
const $8312663103724919$export$9a9d72a255528f = 32;









/* PreviewRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $eNbr2 = parcelRequire("eNbr2");


var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");




/*
 * This function checks if the current selection is a partial copy of the target element.
 */ function $5fb4c87d7d73c468$export$d109786c97a20f08(targetElement) {
    const selection = window.getSelection();
    const selectionText = selection?.toString();
    // If there is no current selection, we don't want to send the event.
    if (!selectionText) return false;
    // Remove new lines and trailing spaces from the text to compare as innerText may have unecessary newlines.
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPreviewResponseText = targetElement.innerText.replace(/\n/g, '').trim();
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedSelectionText = selectionText.replace(/\n/g, '').trim();
    let isSelectionOutsideTargetElement = false;
    let isSelectionWholeAndMore = false;
    if (selection) {
        const { anchorNode: anchorNode, focusNode: focusNode } = selection;
        // Cases where the selection may be outside the node but are considered a whole copy:
        // Starts and ends outside the node.
        // Note: The anchor and focus nodes might be text nodes, not necessarily elements themselves,
        // but the `contains` method works for any node type.
        const selectionStartsOutside = !targetElement.contains(anchorNode);
        const selectionEndsOutside = !targetElement.contains(focusNode);
        isSelectionOutsideTargetElement = selectionStartsOutside && selectionEndsOutside;
        // Starts outside, ends at the end of the node.
        // OR Ends outside, starts at the start of the node.
        // Verify start and end locations.
        const selectionStartsAtStart = selection.anchorOffset === 0;
        const selectionEndsAtEnd = selection.focusOffset === focusNode?.textContent?.length;
        // Verify if the selection is a whole copy and more.
        const startsOutsideAndEndsAtEnd = selectionStartsOutside && selectionEndsAtEnd;
        const startsAtStartAndEndsOutside = selectionEndsOutside && selectionStartsAtStart;
        if (startsOutsideAndEndsAtEnd || startsAtStartAndEndsOutside) isSelectionWholeAndMore = true;
    }
    if (isSelectionOutsideTargetElement || isSelectionWholeAndMore) return false;
    return strippedPreviewResponseText !== strippedSelectionText;
}
function $5fb4c87d7d73c468$export$60519e70a23320fb(element) {
    const selection = window.getSelection();
    if (!selection?.rangeCount || !selection.toString()) return false;
    const { anchorNode: anchorNode, focusNode: focusNode } = selection;
    if (!anchorNode || !focusNode) return false;
    // if start or end of the selection is within element no need in further checks
    if ([
        anchorNode,
        focusNode
    ].some((node)=>element.contains(node))) return true;
    // detect start and end node based on the direction of the selection
    const isLTRSelection = anchorNode.compareDocumentPosition(focusNode) & Node.DOCUMENT_POSITION_FOLLOWING;
    const startNode = isLTRSelection ? selection.anchorNode : selection.focusNode;
    const endNode = isLTRSelection ? selection.focusNode : selection.anchorNode;
    if (!startNode || !endNode) return false;
    // Check if the selection starts before and ends after the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) return true;
    // Check if the selection starts after and ends before the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) return true;
    return false;
}










const $6d2296260566020a$var$rendererOverrides = null;
const $6d2296260566020a$var$widthOverrides = null;
const $6d2296260566020a$var$mediaOptions = {
    allowLinking: true,
    allowCaptions: true
};
const $6d2296260566020a$export$8ce5f720dc007208 = ({ jsonDocument: jsonDocument, showTelepointer: showTelepointer, providerFactory: providerFactory, schema: schema })=>{
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const experienceType = (0, $l2lIz.convertExperienceName)(aiExperienceCommonData.configItem.key.toString());
    const lastTriggeredFrom = aiExperienceCommonData.lastTriggeredFrom;
    const previewRendererRef = (0, $cozmU.useRef)(null);
    const copiedOnceRef = (0, $cozmU.useRef)(false); // IMPORTANT: the renderer will call providerFactory.destroy() when it unmounts. This is why we need to duplicate
    // the providerFactory and add a heap of subscribers to it. This is to avoid this duplicate provider gettting out of
    // sync with the original providerFactory.
    const dupedProviderFactory = (0, $cozmU.useRef)(new (0, $eNbr2.default)());
    (0, $cozmU.useEffect)(()=>{
        const mentionHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const emojiHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const mediaHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        const extensionHandler = (name, provider)=>{
            dupedProviderFactory.current.setProvider(name, provider);
        };
        providerFactory.subscribe('mentionProvider', mentionHandler);
        providerFactory.subscribe('emojiProvider', emojiHandler);
        providerFactory.subscribe('mediaProvider', mediaHandler);
        providerFactory.subscribe('extensionProvider', extensionHandler);
        return ()=>{
            providerFactory.unsubscribe('mentionProvider', mentionHandler);
            providerFactory.unsubscribe('emojiProvider', emojiHandler);
            providerFactory.unsubscribe('mediaProvider', mediaHandler);
            providerFactory.unsubscribe('extensionProvider', extensionHandler);
        };
    }, [
        providerFactory
    ]); // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const onCopyHandler = (0, $cozmU.useCallback)(async ()=>{
        const previewRendererElement = previewRendererRef.current;
        if (!analyticsFlow || !previewRendererElement) return;
        if (!(0, $5fb4c87d7d73c468$export$60519e70a23320fb)(previewRendererElement)) return;
        if ((0, $5fb4c87d7d73c468$export$d109786c97a20f08)(previewRendererRef.current)) analyticsFlow.addAttributes({
            contentCopiedPartially: true
        });
         // Fire ACTION.ACTIONED event for copy action
        if (fireAIAnalyticsEvent && experienceType) fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).ACTIONED,
                interactionID: analyticsFlow.getLastAiInteractionId(),
                experienceName: experienceType,
                isProactive: false,
                attributes: {
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    aiResultAction: 'copied'
                },
                invokedFrom: lastTriggeredFrom
            })
        });
         // exit if copied already for this preview
        if (copiedOnceRef.current) return;
        analyticsFlow.addAttributes({
            contentCopied: true
        });
        copiedOnceRef.current = true;
    }, [
        analyticsFlow,
        fireAIAnalyticsEvent,
        experienceType,
        lastTriggeredFrom
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(document, {
            type: 'copy',
            listener: onCopyHandler
        });
        return unbind;
    }, [
        onCopyHandler,
        analyticsFlow
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "preview-renderer",
        ref: previewRendererRef,
        className: (0, $hekY6.default)([
            "_3uDt5OzUZr _4mcaqSu7m9 _3g5OLcy7kJ",
            "_1NxhOzTTQh _3PlZvITTQh _2SvtzAAASz"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ $cozmU.createElement((0, $3BY7M.default // EDITOR-1178
    ), {
        // specify the appearance will make the renderer have a max-width of 760px when appearance is full-page
        // but AI modal could be triggered from a resized larger table, which will make the AI modal much wider than 760px
        // we want the renderer be the same wide as the AI modal, so we don't want to limit the renderer width via appearance
        // keep the appearance undefined here for clarity (it's added in EDITOR-1115)
        appearance: undefined,
        document: jsonDocument,
        media: $6d2296260566020a$var$mediaOptions,
        // the nodes and marks the markdown transformer can create.
        // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
        useSpecBasedValidator: true,
        addTelepointer: showTelepointer,
        allowCustomPanels: true,
        allowAnnotations: true,
        allowWrapCodeBlock: true,
        schema: schema,
        dataProviders: dupedProviderFactory.current,
        allowPlaceholderText: true,
        UNSTABLE_allowTableAlignment: true,
        UNSTABLE_allowTableResizing: true
    })));
};


const $1ebb5e0c9114edeb$var$jsonTransformer = new (0, $2lPWP.JSONTransformer)();
function $1ebb5e0c9114edeb$export$f5e3af6d625de7a({ schema: schema, pmFragment: pmFragment, showTelepointer: showTelepointer, providerFactory: providerFactory }) {
    let jsonDocument;
    const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
    // If a failure has occured creating this, we don't know what's happened
    // and so should trigger the error boundary
    if (!prosemirrorDocument) throw new (0, $126aacb890017ec7$export$6c16da0c287c00c)({
        message: 'Unable to transform markdown into a valid prosemirror document',
        type: 'noProseMirrorDoc'
    });
    if (prosemirrorDocument.content.size === 0) throw new (0, $126aacb890017ec7$export$6c16da0c287c00c)({
        message: 'Transforming markdown returns an empty prosemirror document',
        type: 'emptyProseMirrorDoc'
    });
    try {
        // Warning -- this is asserted due to a mismatch in the editor-json-transformer
        // and renderer types.
        // jsonTransformer.encode returns a "JSONDocNode" which _should_ be runtime
        // compatible with DocNode -- but does not have compatible types.
        // See the following files for more details
        // - packages/editor/editor-json-transformer/src/types.ts
        // - packages/editor/adf-schema/src/schema/nodes/doc.ts
        jsonDocument = $1ebb5e0c9114edeb$var$jsonTransformer.encode(prosemirrorDocument);
    } catch  {
        throw new (0, $126aacb890017ec7$export$6c16da0c287c00c)({
            message: 'Unable to transform markdown into a valid prosemirror document',
            type: 'invalidProseMirrorDoc'
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6d2296260566020a$export$8ce5f720dc007208), {
        jsonDocument: jsonDocument,
        showTelepointer: showTelepointer,
        providerFactory: providerFactory
    });
}
function $1ebb5e0c9114edeb$export$5ae44876b720d032({ adfResponse: adfResponse, showTelepointer: showTelepointer, providerFactory: providerFactory, schema: schema }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6d2296260566020a$export$8ce5f720dc007208), {
        schema: schema,
        jsonDocument: adfResponse,
        showTelepointer: showTelepointer,
        providerFactory: providerFactory
    });
}




// the scroll parent element and scrollable content height
const $c0de460a20d92c63$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area'; /**
                                                                    * Scroll margin is used to ensure that the modal won't be
                                                                    * too close to the top of the editor, which may sometimes
                                                                    * cover the modal slightly.
                                                                    */ 
const $c0de460a20d92c63$var$scrollMarginStyles = null;
function $c0de460a20d92c63$export$9c279fd5d5bced59({ mountDecorations: mountDecorations, updateStream: updateStream, parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, refinementCount: refinementCount, latestPromptRetried: latestPromptRetried, markdown: markdown, adfResponse: adfResponse, adfResponseNodeWrappers: adfResponseNodeWrappers, idMap: idMap, contextStatistics: contextStatistics, hideLoadingScreen: hideLoadingScreen, api: api }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { configItem: configItem, editorView: editorView, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, editorPluginAIProvider: editorPluginAIProvider, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll, appearance: appearance } = aiExperienceCommonData;
    const schema = editorView.state.schema;
    const nextSessionId = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>aiExperienceState?.aiDecorationExperiencePluginState.nextSessionId);
    (0, $cozmU.useEffect)(()=>{
        if (mountDecorations) return mountDecorations();
        return ()=>{};
    }, [
        mountDecorations
    ]);
    const { mounted: isRovoMounted, streaming: isRovoStreaming } = (0, $bGNkz.useUIStore)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimer = (0, $ea1e399bb2487613$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const presetPromptLabel = (0, $c2c6d211a4290fa3$export$4539b8c6808af330)(configItem, formatMessage);
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const [preview, setPreview] = (0, $cozmU.useState)();
    const [hasPreview, setHasPreview] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null); // raf is used for debouncing, if useEffect is called
    // multiple times before raf is run this prevents rendering
    // multiple times if we receive streams very quickly
    const raf = (0, $cozmU.useRef)();
    const errorReported = (0, $cozmU.useRef)(false); /**
                                                 * scrollParentRef is for
                                                 * storing the scroll parent element once its found
                                                 * to be re-used in calculations
                                                 */ 
    const scrollParentRef = (0, $cozmU.useRef)(null);
    const initialScrollTop = (0, $cozmU.useRef)(0);
    const modalOffsetTop = (0, $cozmU.useRef)(0);
    const isModalAtTop = (0, $cozmU.useRef)(false);
    const scrollModalAlignBottom = (0, $cozmU.useCallback)((modalEl, scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    const scrollModalToTop = (0, $cozmU.useCallback)((scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current - (0, $8312663103724919$export$9a9d72a255528f),
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Set up ResizeObserver to detect cases where the editor content grows,
     * as it will normally trigger a scroll event due to scrollHeight and scrollTop changes.
     * We set isProgrammaticScroll to true to flag it as a non-user scroll.
     */ const editorContentArea = editorView.dom.closest($c0de460a20d92c63$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
        if (!editorContentArea) return;
        const resizeObserver = new ResizeObserver(()=>{
            isProgrammaticScroll.current = true;
        });
        resizeObserver.observe(editorContentArea);
        return ()=>resizeObserver.unobserve(editorContentArea);
    }, [
        editorView,
        isProgrammaticScroll
    ]); /**
                                           * Editor AI can be invoked directly into this Loading screen.
                                           * ExperienceApplication calls scrollIntoView
                                           *
                                           * We need to check whether scrollIntoView is complete to determine when to track user scrolling for the auto-scroll logic
                                           * that prevents scroll-jacking when a user scrolls away.
                                           */ 
    // const [isScrollIntoViewSettled, setIsScrollIntoViewSettled] = useState(false);
    (0, $cozmU.useEffect)(()=>{
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        const settleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            // setIsScrollIntoViewSettled(true);
            /**
       * Once it's settled, we can unbind
       * as we only need to check when it first loads
       *
       * This is to emulate scrollEnd which is not supported
       * across all browsers at the moment.
       *
       * unbind taken from the bind function below
       */ unbind();
        }, 250);
        const unbind = (0, $cbY7C.bind)(scrollParentEl, {
            type: 'scroll',
            listener: settleScroll
        });
    }, []);
    function scrollModalIntoView() {
        /**
     * Early exits:
     * - If user has manually scrolled, stop auto-scrolling
     * - If modal has reached the top of the editor, no more calculations or scrolling needed
     */ if (isUserScroll.current || isModalAtTop.current) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = scrollParentRef.current;
        if (!scrollParentEl) return;
         // Check if modal is already fully visible
        const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight; /**
                                                                                                              * Check if modal height exceeds scroll parent's height
                                                                                                              * Scroll margin is used to prevent the modal from being scrolled to the top
                                                                                                              * and should match scroll margin in other modals e.g. from
                                                                                                              * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
                                                                                                              */ 
        const isModalFullHeight = scrollParentEl.offsetHeight - (0, $8312663103724919$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalFullyVisible) return;
        if (isModalFullHeight) {
            scrollModalToTop(scrollParentEl);
            isModalAtTop.current = true;
            return;
        }
        scrollModalAlignBottom(modalEl, scrollParentEl);
    }
    const adfResponseRef = (0, $cozmU.useRef)(adfResponse);
    adfResponseRef.current = adfResponse;
    const pmFragmentRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (adfResponseRef.current && updateStream) {
            const pmFragment = (0, $5f3534ff878ff5b8$export$d53ec95625564c92)({
                schema: schema,
                adfResponse: adfResponseRef.current,
                adfResponseNodeWrappers: adfResponseNodeWrappers
            }); // don't update stream if the pmFragment is the same.
            if (!pmFragmentRef.current || !pmFragmentRef.current.eq(pmFragment)) {
                pmFragmentRef.current = pmFragment;
                isProgrammaticScroll.current = true;
                updateStream({
                    fragment: pmFragment,
                    isFinalStream: false,
                    hasUserScrolled: isUserScroll.current
                }); /**
             * Setting hasPreview to true as AI generated content has started streaming in page now.
             * hasPreview is used to set durations (time to receive first chunk and first to remaining chunks).
             */ 
                setHasPreview(true);
            }
            return;
        } // only run the callback if the raf has not been set, and then
        // reset raf to undefined
        if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
            let _preview;
            raf.current = undefined;
            if (adfResponseRef.current) {
                if (updateStream) {
                    const pmFragment = (0, $5f3534ff878ff5b8$export$d53ec95625564c92)({
                        schema: schema,
                        adfResponse: adfResponseRef.current,
                        adfResponseNodeWrappers: adfResponseNodeWrappers
                    });
                    if (!pmFragmentRef.current || !pmFragmentRef.current.eq(pmFragment)) {
                        pmFragmentRef.current = pmFragment;
                        isProgrammaticScroll.current = true;
                        updateStream({
                            fragment: pmFragment,
                            isFinalStream: false,
                            hasUserScrolled: isUserScroll.current
                        });
                    } /**
               * Setting hasPreview to true as AI generated content has started streaming in page now.
               * hasPreview is used to set durations (time to receive first chunk and first to remaining chunks).
               */ 
                    setHasPreview(true);
                } else _preview = (0, $1ebb5e0c9114edeb$export$5ae44876b720d032)({
                    adfResponse: adfResponseRef.current,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            } else if (!markdown || markdown === '') // When there is no streamed preview content -- set the preview to
            // undefined.
            // This allows a nicer loading screen (rather than showing an empty paragraph).
            _preview = undefined;
            else {
                const { pmFragment: pmFragment } = (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
                    markdown: markdown,
                    schema: schema,
                    source: 'loading',
                    fireAIAnalyticsEvent: (event)=>{
                        if (!errorReported.current) {
                            errorReported.current = true;
                            fireAIAnalyticsEvent(event);
                        }
                    },
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    idMap: idMap
                }); /**
               * Hold off on setting the preview if we appear to be receiving
               * a custom tag through our stream. This is to hide raw tags from
               * users until the tags are complete and can be rendered back into nodes.
               */ 
                if ((0, $bb827e6786ce28c4$export$bde720e3489117f9)(markdown)) return;
                if (updateStream) {
                    isProgrammaticScroll.current = true;
                    updateStream({
                        fragment: pmFragment,
                        isFinalStream: false,
                        hasUserScrolled: isUserScroll.current
                    });
                } else _preview = (0, $1ebb5e0c9114edeb$export$f5e3af6d625de7a)({
                    schema: schema,
                    pmFragment: pmFragment,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            }
            if (_preview) {
                setPreview(_preview);
                setHasPreview(true);
                window.requestAnimationFrame(()=>{
                    scrollModalIntoView();
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markdown,
        updateStream,
        adfResponse
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // if the component is unmounted before the raf callback
            // has run, we cancel it
            if (raf.current) window.cancelAnimationFrame(raf.current);
        };
    }, []); // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $48b5c021b1ae01b8$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $45c921fe28f84dd0$export$4e4614f0417d7178)(localizedLatestPrompt);
    const analyticsFlow = (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        needUpdatedArgs: true,
        stepName: 'loading',
        callerComponent: 'LoadingScreenWithLogic',
        attributes: {
            promptType: promptTrigger,
            latestPromptRetried: latestPromptRetried,
            refinementCount: refinementCount,
            modelIO: {
                contextStatistics: contextStatistics,
                userInputCharacterCount: promptStatistics?.totalCharacterCount,
                userInputNodeCounts: promptStatistics?.nodeCounts,
                userInputLinksCount: promptStatistics?.linksCount,
                userInputMentionsCount: promptStatistics?.mentionsCount
            },
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    const previewBecameAvailable = (0, $cozmU.useRef)();
    if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
    (0, $cozmU.useEffect)(()=>{
        const noPreviewAvailable = performance.now();
        return ()=>{
            if (!previewBecameAvailable.current) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                    timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                }
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onCancel = (0, $cozmU.useCallback)(()=>{
        sendToAIExperienceMachine({
            type: 'enable discard'
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const isRovoStreamingActive = isRovoMounted && isRovoStreaming;
    const shouldHideLoadingScreen = isRovoStreamingActive || !!hideLoadingScreen;
    if (nextSessionId) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_1ghwDKVa5s"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4x5dF.MemoLoadingScreen), {
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        presetPromptLabel: presetPromptLabel,
        latestPrompt: localizedLatestPrompt,
        agent: configItem?.agent,
        title: title,
        preview: preview,
        providerFactory: providerFactory,
        disclaimer: disclaimer,
        onCancel: onCancel,
        schema: schema,
        isStreaming: !!adfResponse || !!markdown,
        canInlineStreamChanges: true,
        hideLoadingScreen: shouldHideLoadingScreen,
        appearance: appearance,
        isAIFC: true,
        loadingExperience: configItem?.loadingExperience
    }));
}























function $43b3e7c27d099e87$export$a283bcbda9880df6({ discardStream: discardStream, aiExperienceMachineContext: aiExperienceMachineContext }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, editorView: editorView, appearance: appearance, lastTriggeredFrom: lastTriggeredFrom } = aiExperienceCommonData;
    const { channelId: channelId, configItem: configItem } = aiExperienceMachineContext;
    const [isHidden, setIsHidden] = (0, $cozmU.useState)(false);
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    (0, $cozmU.useEffect)(()=>{
        // We must fire a viewed event to ensure the AI interaction is counted toward MAU stats. Even though nothing has changed on
        // screen we still count this as the user having seen the result.
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).VIEWED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                isProactive: false,
                attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                invokedFrom: lastTriggeredFrom,
                traceIds: analyticsFlow.getCommonAttributes().traceIds,
                promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? analyticsFlow.getCommonAttributes().promptVersion : undefined
            })
        });
        discardStream?.({
            restoreSelection: false
        });
        const timer = setTimeout(()=>{
            setIsHidden(true);
        }, 1000);
        return ()=>clearTimeout(timer);
    }, [
        editorView,
        discardStream,
        channelId,
        configItem,
        lastTriggeredFrom,
        analyticsFlow,
        fireAIAnalyticsEvent
    ]);
    // TODO: EDITOR-1085 - Add analytics for no improvement screen
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $188dcfdb17133909$export$fbc3425fa4d2d058), {
        isHidden: isHidden,
        onceFade: endExperience,
        appearance: appearance
    });
}


/* PreviewScreenWithLogic.tsx generated by @compiled/babel-plugin v2.0.0 */ 





























var $jfFbl = parcelRequire("jfFbl");




const $29bb73df2123f69e$var$toDOM = (fragment, schema)=>{
    return (0, $aPdNQ.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
};
/**
 * Copied and amended from platform/packages/editor/editor-plugin-paste/src/pm-plugins/create-clipboard-text-serializer
 */ function $29bb73df2123f69e$var$clipboardTextSerializer(fragment) {
    let text = '';
    const blockSeparater = '\n\n';
    fragment.nodesBetween(0, fragment.size, (node)=>{
        if (node.type.isBlock) text += blockSeparater;
        if (node.type.name === 'paragraph') return true;
        else if (node.type.name === 'hardBreak') text += '\n';
        else if (node.type.name === 'text') text += node.text;
        else if (node.type.name === 'inlineCard') text += node.attrs.url;
        else if (node.type.name === 'blockCard') text += node.attrs.url;
        else text += node.textBetween(0, node.content.size, '\n\n');
        return false;
    });
    return text.trim();
}
function $29bb73df2123f69e$export$a707cf6ca97554ae({ editorView: editorView, pmFragment: pmFragment }) {
    const transaction = editorView.state.tr;
    const domNode = $29bb73df2123f69e$var$toDOM(pmFragment, editorView.state.schema);
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        /**
		 * ED-18062: override the plain text in
		 * copyHTMLToClipboard using clipboardTextSerializer(pmFragment)
		 * because HTML to plain text is formatted without new lines
		 * in certain nodes such as lists
		 */ (0, $jfFbl.copyHTMLToClipboard)(div, $29bb73df2123f69e$var$clipboardTextSerializer(pmFragment));
    }
    transaction.setMeta('scrollIntoView', false);
    editorView.dispatch(transaction);
}





















var $hQhZW = parcelRequire("hQhZW");








var $dinVW = parcelRequire("dinVW");


var $lpNn5 = parcelRequire("lpNn5");


























var $7ZB0A = parcelRequire("7ZB0A");













parcelRequire("cozmU");







const $b14ed5321423e959$var$styleUnbounded = null;
const $b14ed5321423e959$var$style = null;
const $b14ed5321423e959$export$59451aa6b6270879 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Shortcut(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { shortcut: shortcut } = t0;
    let t1;
    if ($[0] !== shortcut) {
        t1 = (0, $ldqjS.formatShortcut)(shortcut);
        $[0] = shortcut;
        $[1] = t1;
    } else t1 = $[1];
    const formattedShortcut = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_0bjKvDKxmn _1UtDYzZpcK _0KLXruDMqu _1kk5Tku7m9",
            "_0Of8r24Y4b _1Znuxb4Y4b _1wydGW4Y4b _2Zuz6Q4Y4b _2XsHFMZimw"
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== formattedShortcut) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t2,
            children: formattedShortcut
        });
        $[3] = formattedShortcut;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : function Shortcut({ shortcut: shortcut }) {
    const formattedShortcut = (0, $ldqjS.formatShortcut)(shortcut);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _1UtDYzZpcK _0KLXruDMqu _1kk5Tku7m9",
            "_0Of8r24Y4b _1Znuxb4Y4b _1wydGW4Y4b _2Zuz6Q4Y4b _2XsHFMZimw"
        ]),
        children: formattedShortcut
    });
};


/**
 * Checks if a keyboard event matches a given shortcut.
 *
 * @param event - The keyboard event to check.
 * @param shortcut - The shortcut string to match against (e.g., "Ctrl-Shift-A").
 * @returns True if the event matches the shortcut, false otherwise.
 */ function $b2f89faa708f3520$export$b6ac0c7de16a0eb8(event, shortcut) {
    const parts = shortcut.split('-');
    const key = parts.pop();
    const mods = new Set(parts);
    if (event.key !== key) return false;
    if (mods.has('Mod') !== event.metaKey) return false;
    if (mods.has('Shift') !== event.shiftKey) return false;
    if (mods.has('Alt') !== event.altKey) return false;
    if (mods.has('Ctrl') !== event.ctrlKey) return false;
    return true;
}


const $af4ed6779a658b23$var$buttonAutoFocusRingFix = null;
const $af4ed6779a658b23$var$forceFocusRingStyles = null;
const $af4ed6779a658b23$export$3ca6788437e93171 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ButtonWithShortcut(t0) {
    const $ = (0, $bDgLe.c)(29);
    let buttonAutoFocusRing;
    let children;
    let forceFocusRing;
    let onClick;
    let rest;
    let shortcut;
    if ($[0] !== t0) {
        ({ shortcut: shortcut, children: children, forceFocusRing: forceFocusRing, buttonAutoFocusRing: buttonAutoFocusRing, onClick: onClick, ...rest } = t0);
        $[0] = t0;
        $[1] = buttonAutoFocusRing;
        $[2] = children;
        $[3] = forceFocusRing;
        $[4] = onClick;
        $[5] = rest;
        $[6] = shortcut;
    } else {
        buttonAutoFocusRing = $[1];
        children = $[2];
        forceFocusRing = $[3];
        onClick = $[4];
        rest = $[5];
        shortcut = $[6];
    }
    let t1;
    let t2;
    if ($[7] !== onClick || $[8] !== shortcut) {
        t1 = ()=>{
            const listener = (event)=>{
                if (shortcut?.common && (0, $b2f89faa708f3520$export$b6ac0c7de16a0eb8)(event, shortcut.common)) {
                    event.preventDefault();
                    event.stopPropagation();
                    onClick?.();
                }
            };
            return (0, $cbY7C.bind)(document, {
                type: "keydown",
                listener: listener
            });
        };
        t2 = [
            onClick,
            shortcut
        ];
        $[7] = onClick;
        $[8] = shortcut;
        $[9] = t1;
        $[10] = t2;
    } else {
        t1 = $[9];
        t2 = $[10];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    bb0: {
        if (!shortcut) {
            let t4;
            if ($[11] !== children) {
                t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
                    children: children
                });
                $[11] = children;
                $[12] = t4;
            } else t4 = $[12];
            t3 = t4;
            break bb0;
        }
        const browser = (0, $8dxef.getBrowserInfo)();
        const t4 = browser.mac ? shortcut?.mac : shortcut?.windows;
        let t5;
        if ($[13] !== children || $[14] !== t4) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "aria-keyshortcuts": t4,
                children: children
            });
            $[13] = children;
            $[14] = t4;
            $[15] = t5;
        } else t5 = $[15];
        let t6;
        if ($[16] !== shortcut) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b14ed5321423e959$export$59451aa6b6270879), {
                    shortcut: shortcut
                })
            });
            $[16] = shortcut;
            $[17] = t6;
        } else t6 = $[17];
        let t7;
        if ($[18] !== t5 || $[19] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                children: [
                    t5,
                    t6
                ]
            });
            $[18] = t5;
            $[19] = t6;
            $[20] = t7;
        } else t7 = $[20];
        t3 = t7;
    }
    const content = t3;
    const t4 = forceFocusRing && "_0tYP9oXzJH _0oa3uOFQfX";
    const t5 = buttonAutoFocusRing && "_2LFmWgXzJH _09QBVJFQfX";
    let t6;
    if ($[21] !== t4 || $[22] !== t5) {
        t6 = (0, $hekY6.default)([
            t4,
            t5
        ]);
        $[21] = t4;
        $[22] = t5;
        $[23] = t6;
    } else t6 = $[23];
    let t7;
    if ($[24] !== content || $[25] !== onClick || $[26] !== rest || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            onClick: onClick,
            ...rest,
            className: t6,
            children: content
        });
        $[24] = content;
        $[25] = onClick;
        $[26] = rest;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    return t7;
} : function ButtonWithShortcut({ shortcut: shortcut, children: children, forceFocusRing: forceFocusRing, buttonAutoFocusRing: buttonAutoFocusRing, onClick: onClick, ...rest }) {
    (0, $cozmU.useEffect)(()=>{
        const listener = (event)=>{
            if (shortcut?.common && (0, $b2f89faa708f3520$export$b6ac0c7de16a0eb8)(event, shortcut.common)) {
                event.preventDefault();
                event.stopPropagation();
                onClick?.();
            }
        };
        return (0, $cbY7C.bind)(document, {
            type: 'keydown',
            listener: listener
        });
    }, [
        onClick,
        shortcut
    ]);
    const content = (0, $cozmU.useMemo)(()=>{
        if (!shortcut) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {
            children: children
        });
        const browser = (0, $8dxef.getBrowserInfo)();
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    "aria-keyshortcuts": browser.mac ? shortcut?.mac : shortcut?.windows,
                    children: children
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b14ed5321423e959$export$59451aa6b6270879), {
                        shortcut: shortcut
                    })
                })
            ]
        });
    }, [
        shortcut,
        children
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        onClick: onClick,
        ...rest,
        className: (0, $hekY6.default)([
            forceFocusRing && "_0tYP9oXzJH _0oa3uOFQfX",
            buttonAutoFocusRing && "_2LFmWgXzJH _09QBVJFQfX"
        ]),
        children: content
    });
};





















var $fHs3z = parcelRequire("fHs3z");




const $46ace680edf92988$var$message = (0, $kSwu1.defineMessages)({
    copy: {
        id: "fabric.editor.ai.config.item.action.copyResponse",
        defaultMessage: "Copy"
    },
    copied: {
        id: "fabric.editor.ai.config.item.action.responseCopied",
        defaultMessage: "Copied!"
    },
    copiedToClipboard: {
        id: "fabric.editor.ai.config.item.action.responseCopiedToClipboard",
        defaultMessage: "Copied to clipboard"
    }
});
var $46ace680edf92988$export$2e2bcd8739ae039 = $46ace680edf92988$var$message;


const $f4a1f879e9ce5c6d$export$dcd7ef7785e10577 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copy);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    const [tooltip, setTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t1);
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] !== formatMessage || $[3] !== onClick) {
        t2 = (event)=>{
            onClick(event);
            setTooltip(formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copiedToClipboard));
        };
        $[2] = formatMessage;
        $[3] = onClick;
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClick = t2;
    let t3;
    if ($[5] !== formatMessage) {
        t3 = ()=>setTooltip(formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copy));
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    const resetTooltip = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            updateTooltip.current?.();
        };
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== tooltip) {
        t5 = [
            tooltip
        ];
        $[8] = tooltip;
        $[9] = t5;
    } else t5 = $[9];
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(t4, t5);
    let t6;
    if ($[10] !== tooltip) {
        t6 = (t7)=>{
            const { update: update } = t7;
            updateTooltip.current = update;
            return tooltip;
        };
        $[10] = tooltip;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== resetTooltip || $[13] !== t6) {
        t7 = {
            position: "top",
            content: t6,
            onHide: resetTooltip
        };
        $[12] = resetTooltip;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipOptions = t7;
    let t8;
    if ($[15] !== appearance || $[16] !== handleOnClick || $[17] !== spacing || $[18] !== tabIndex || $[19] !== tooltip || $[20] !== tooltipOptions) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            testId: "copy-response-button",
            type: "button",
            onClick: handleOnClick,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            label: tooltip,
            appearance: appearance,
            spacing: spacing,
            tabIndex: tabIndex,
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        });
        $[15] = appearance;
        $[16] = handleOnClick;
        $[17] = spacing;
        $[18] = tabIndex;
        $[19] = tooltip;
        $[20] = tooltipOptions;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
} : ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [tooltip, setTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copy));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        onClick(event);
        setTooltip(formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copiedToClipboard));
    }, [
        onClick,
        formatMessage
    ]);
    const resetTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>setTooltip(formatMessage((0, $46ace680edf92988$export$2e2bcd8739ae039).copy)), [
        formatMessage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltip
    ]);
    const tooltipOptions = {
        position: 'top',
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltip;
        },
        onHide: resetTooltip
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        testId: "copy-response-button",
        type: "button",
        onClick: handleOnClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions
    });
};







var $8W9nI = parcelRequire("8W9nI");


var $hUKxF = parcelRequire("hUKxF");

/* PromptForm.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /** @jsxfrag */ 














var $1HhPq = parcelRequire("1HhPq");








var $gDDkj = parcelRequire("gDDkj");











parcelRequire("cozmU");








var $blZUD = parcelRequire("blZUD");













parcelRequire("cozmU");

const $4b738c5d4441c77c$var$Enter = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "14",
            height: "12",
            viewBox: "0 0 14 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
                fill: "currentColor"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
            fill: "currentColor"
        })
    });
var $4b738c5d4441c77c$export$2e2bcd8739ae039 = $4b738c5d4441c77c$var$Enter;





const $4081a3250bc505d2$var$message = (0, $kSwu1.defineMessages)({
    submitLabel: {
        id: "fabric.editor.ai.screens.prompt.submitLabel",
        defaultMessage: "Submit"
    },
    submitTooltip: {
        id: "fabric.editor.ai.screens.prompt.submitTooltip",
        defaultMessage: "Send to AI"
    }
});
var $4081a3250bc505d2$export$2e2bcd8739ae039 = $4081a3250bc505d2$var$message;


const $16cfa2a0076484b9$export$8b7b7cdfb85d78c5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { disabled: disabled, tabIndex: tabIndex, onClick: onClick, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const icon = isAIFC ? (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))) : (0, $4b738c5d4441c77c$export$2e2bcd8739ae039);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $4081a3250bc505d2$export$2e2bcd8739ae039).submitTooltip);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $4081a3250bc505d2$export$2e2bcd8739ae039).submitLabel);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== disabled || $[5] !== icon || $[6] !== onClick || $[7] !== t2 || $[8] !== tabIndex) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            label: t2,
            onClick: onClick,
            testId: "submit-icon-button",
            isDisabled: disabled,
            icon: icon,
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex
        });
        $[4] = disabled;
        $[5] = icon;
        $[6] = onClick;
        $[7] = t2;
        $[8] = tabIndex;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t1 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: t1,
            hideTooltipOnClick: true,
            position: "top",
            children: t3
        });
        $[10] = t1;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ disabled: disabled, tabIndex: tabIndex, onClick: onClick, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const icon = isAIFC ? (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))) : (0, $4b738c5d4441c77c$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: formatMessage((0, $4081a3250bc505d2$export$2e2bcd8739ae039).submitTooltip),
        hideTooltipOnClick: true,
        position: "top",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            label: formatMessage((0, $4081a3250bc505d2$export$2e2bcd8739ae039).submitLabel),
            onClick: onClick,
            testId: "submit-icon-button",
            isDisabled: disabled,
            icon: icon,
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex
        })
    });
};





const $09f7a5086858ec21$var$message = (0, $kSwu1.defineMessages)({
    logo: {
        id: "fabric.editor.ai.commandPalette.promptForm.logo",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
var $09f7a5086858ec21$export$2e2bcd8739ae039 = $09f7a5086858ec21$var$message;


const $de21edef532dabae$var$commonTextStyles = null;
const $de21edef532dabae$var$formGapStyles = null; // Make form height equals the height of its parent to prevent the form from growing out of the parent
const $de21edef532dabae$var$formHeightStyles = null; // Prevent form inner from growing out of form
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $de21edef532dabae$var$formInnerHeightStyles = null; // input's line-height is 20px, logo/button's height is 24px, need to adjust the height
const $de21edef532dabae$var$nextToInputStyles = null;
const $de21edef532dabae$var$selfStartStyles = null;
const $de21edef532dabae$var$formContainerStyles = null;
const $de21edef532dabae$var$newPaletteStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $de21edef532dabae$var$formStyles = null;
const $de21edef532dabae$var$formPaddingTopStyles = null;
const $de21edef532dabae$var$formInnerStyles = null;
const $de21edef532dabae$var$formInnerPaddingTopStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $de21edef532dabae$var$buttonWrapperStyles = null;
const $de21edef532dabae$export$416523684d97c4ad = ({ type: type = 'user-input', onFormSubmit: onFormSubmit, value: value = '', showButtons: showButtons = true, tag: tag, autoFocus: autoFocus = true, onInputChange: onInputChange, onADFChange: onADFChange, onInputFocus: onInputFocus, onInputBlur: onInputBlur, placeholder: placeholder, focusInputRef: focusInputRef, clearInputRef: clearInputRef, showLogo: showLogo = true, onInputKeyDown: onInputKeyDown, adfValue: adfValue, enableLinks: enableLinks, PromptEditor: PromptEditor, showBack: showBack, onBack: onBack, onInputKeyUp: onInputKeyUp, fireParentActionButton: fireParentActionButton, focusParentActionButton: focusParentActionButton, refinementTagRef: refinementTagRef, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)();
    const blurInputRef = (0, $cozmU.useRef)(undefined);
    const [isComposing, setIsComposing] = (0, $cozmU.useState)(false);
    const [isLozengeSelected, setIsLozengeSelected] = (0, $cozmU.useState)(false);
    const lastAdfValue = (0, $cozmU.useRef)((0, $6e6HL.getEmptyADF)());
    const isPromptInputEmpty = Boolean((0, $1HhPq.isEmpty)(lastAdfValue?.current) && adfValue && (0, $1HhPq.isEmpty)(adfValue));
    const handleOnCompositionStart = (0, $cozmU.useCallback)(()=>{
        setIsComposing(true);
    }, []);
    const handleOnCompositionEnd = (0, $cozmU.useCallback)(()=>{
        setIsComposing(false);
    }, []);
    const handleKeyUp = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (isPromptInputEmpty && focusParentActionButton) focusParentActionButton(true);
        onInputKeyUp && onInputKeyUp(event);
    }, [
        focusParentActionButton,
        onInputKeyUp,
        isPromptInputEmpty
    ]);
    const handleInputFocus = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        setIsLozengeSelected(false);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        /**
     * If the key is printable or escape, we should remove the focus ring
     * that is applied to the parent insert or replace button
     */ if ((event.key.length === 1 || event.key === 'Escape') && focusParentActionButton) focusParentActionButton(false);
        if (event.key === 'Backspace' && onBack) {
            // This shortcuts the default functionality by placing focus on the refinement tag
            // instead of removing the tag
            if (!isLozengeSelected && isPromptInputEmpty && refinementTagRef?.current) {
                refinementTagRef.current.getElementsByTagName('button')[0].focus();
                setIsLozengeSelected(true);
                return;
            }
            event.stopPropagation();
            if (isPromptInputEmpty) onBack();
        }
        if (event.key === 'Enter' && [
            event.altKey,
            event.metaKey,
            event.ctrlKey
        ].every((isPressed)=>!isPressed)) {
            event.stopPropagation(); // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if (isComposing) return;
             // If the prompt input is empty, we should fire the parent action button
            // on Enter, which will either be replace or insert
            if (isPromptInputEmpty && fireParentActionButton) {
                fireParentActionButton();
                return;
            } // Handles a case where the user presses enter if refinement tag's close button or the
            // cancel button is focused
            if ([
                'close-button-refinement-tag',
                'cancel-icon-button',
                'cancel-esc-button',
                'back-icon-button'
            ].includes(target.getAttribute('data-testid') ?? '')) return;
             // Handles every other case that is not a "shift + enter"
            if (!event.shiftKey) {
                event.preventDefault();
                onFormSubmit(value);
            }
        } /**
       * Return focus back to the input if the user is typing
       * and the refinement tag removing button is focused.
       */ 
        if (![
            'Enter',
            'Backspace',
            'Tab'
        ].includes(event.key) && refinementTagRef?.current && refinementTagRef.current.contains(document.activeElement)) document.getElementById('ak-editor-textarea')?.focus();
    }, [
        focusParentActionButton,
        onBack,
        refinementTagRef,
        isLozengeSelected,
        isPromptInputEmpty,
        isComposing,
        fireParentActionButton,
        onFormSubmit,
        value
    ]);
    const onADFChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((input)=>{
        lastAdfValue.current = adfValue ?? (0, $6e6HL.getEmptyADF)();
        if (onADFChange) onADFChange(input);
    }, [
        onADFChange,
        adfValue
    ]);
    const onInputChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((newValue)=>{
        if (onInputChange) onInputChange(newValue);
    }, [
        onInputChange
    ]);
    const handleSubmitClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        onFormSubmit(value);
    }, [
        onFormSubmit,
        value
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // ED-19496: We avoid propagating enter keypresses
    , {
        // since products like Bitbucket might have parent forms
        // that listen for keydown events to trigger form submission
        role: "presentation",
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: setBreakpointElement,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _37wbyuchRC _0hPCNLchRC"
        ]),
        children: [
            showLogo && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_313842Ll21 _1DCdHiLl21 _3iDTPbQ4SZ _0aFT5v1qpb _0adFHs1Y8M _0hPCNLDIqT _4xdlr0IZbP",
                    breakpoint <= (0, $9lgy7.Breakpoint).Small && "_4xdlr0R7aE"
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: formatMessage((0, $09f7a5086858ec21$export$2e2bcd8739ae039).logo),
                    spacing: "spacious"
                })
            }),
            showBack && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gDDkj.BackIconButton), {
                inPromptHeader: true,
                stopPropagation: true,
                onClick: onBack
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: (0, $hekY6.default)([
                    "_1NWIxLdnbC _1B7GoJdnbC _3M1DK5dnbC _2EMd9WdnbC _4saQms7dHp _1XFMfp7dHp _4cw0pkAEMG _1dmVT1Q4SZ _09sIs3bt8w",
                    "_2mHwu81Y8M",
                    showLogo && "_0Of8r2FQfX",
                    "_0jFU0VN91d",
                    type === 'interrogate' && isAIFC && "_0bjKvDKxmn _2V7sgONvrM _3vBAKH9r67 _3hxITi6wH8 _0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE",
                    "ai-modal-prompt-form"
                ]),
                "data-testid": "ai-modal-prompt-form",
                children: [
                    tag,
                    /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                        className: (0, $hekY6.default)([
                            "_2sNsIgmnOE _3W2Oc8wPeg",
                            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ",
                            !!tag && "_0Of8r21Y8M",
                            "_4kiQYAdnbC"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ebb5c44f44233ad5$export$b0a649d08575ac09), {
                                PromptEditor: PromptEditor,
                                type: type,
                                focusInputRef: focusInputRef,
                                blurInputRef: blurInputRef,
                                clearInputRef: clearInputRef,
                                autoFocus: autoFocus,
                                defaultValue: adfValue,
                                onInputChange: onInputChange_,
                                onADFChange: onADFChange_,
                                placeholder: placeholder,
                                onFocus: handleInputFocus,
                                onBlur: onInputBlur,
                                onKeyDown: onInputKeyDown,
                                onCompositionStart: handleOnCompositionStart,
                                onCompositionEnd: handleOnCompositionEnd,
                                enableLinks: enableLinks
                            }),
                            showButtons && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_33tBfP0dzo _3iDTPbQ4SZ _2XsHFM1Y8M"
                                ]),
                                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $16cfa2a0076484b9$export$8b7b7cdfb85d78c5), {
                                    disabled: !value,
                                    onClick: handleSubmitClick,
                                    isAIFC: isAIFC
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};











parcelRequire("cozmU");








var $hz2oZ = parcelRequire("hz2oZ");




const $994c4a197e04e0de$var$message = (0, $kSwu1.defineMessages)({
    retryPrompt: {
        id: "fabric.editor.ai.config.item.action.retryPrompt",
        defaultMessage: "Retry"
    }
});
var $994c4a197e04e0de$export$2e2bcd8739ae039 = $994c4a197e04e0de$var$message;


const $0a36abf44be57c0c$export$6f66175e87cc7542 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage((0, $994c4a197e04e0de$export$2e2bcd8739ae039).retryPrompt);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    const tooltip = t2;
    let t3;
    if ($[2] !== tooltip) {
        t3 = {
            position: "top",
            hideTooltipOnClick: true,
            content: tooltip
        };
        $[2] = tooltip;
        $[3] = t3;
    } else t3 = $[3];
    const tooltipOptions = t3;
    let t4;
    if ($[4] !== appearance || $[5] !== isDisabled || $[6] !== onClick || $[7] !== spacing || $[8] !== tabIndex || $[9] !== tooltip || $[10] !== tooltipOptions) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            testId: "retry-prompt-button",
            type: "button",
            onClick: onClick,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
            label: tooltip,
            appearance: appearance,
            spacing: spacing,
            tabIndex: tabIndex,
            isTooltipDisabled: false,
            tooltip: tooltipOptions,
            isDisabled: isDisabled
        });
        $[4] = appearance;
        $[5] = isDisabled;
        $[6] = onClick;
        $[7] = spacing;
        $[8] = tabIndex;
        $[9] = tooltip;
        $[10] = tooltipOptions;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltip = formatMessage((0, $994c4a197e04e0de$export$2e2bcd8739ae039).retryPrompt);
    const tooltipOptions = {
        position: 'top',
        hideTooltipOnClick: true,
        content: tooltip
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        testId: "retry-prompt-button",
        type: "button",
        onClick: onClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        isDisabled: isDisabled
    });
};


/* ActionButtonsLayout.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 


parcelRequire("cozmU");
















const $f8c0a67f4617c01f$export$1ca3f17e50a1bf69 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsFlexElementWrapped() {
    const $ = (0, $bDgLe.c)(5);
    const [element, setElement] = (0, $cozmU.useState)(null);
    const [result, setResult] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== element) {
        t0 = ()=>{
            if (!element) return;
            const updateResult = (entries)=>{
                for (const entry of entries){
                    const firstChild = entry.target.firstElementChild;
                    if (!(firstChild instanceof HTMLElement)) {
                        setResult(false);
                        return;
                    }
                    const firstChildTop = firstChild.offsetTop;
                    const isInTwoLine = Array.from(entry.target.children).some((child)=>child instanceof HTMLElement && child.offsetTop !== firstChildTop);
                    setResult(isInTwoLine);
                }
            };
            const resizeObserver = new ResizeObserver(updateResult);
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t1 = [
            element
        ];
        $[0] = element;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== result) {
        t2 = [
            setElement,
            result
        ];
        $[3] = result;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function useIsFlexElementWrapped() {
    const [element, setElement] = (0, $cozmU.useState)(null);
    const [result, setResult] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!element) return;
        const updateResult = (entries)=>{
            for (const entry of entries){
                const firstChild = entry.target.firstElementChild;
                if (!(firstChild instanceof HTMLElement)) {
                    setResult(false);
                    return;
                }
                const firstChildTop = firstChild.offsetTop;
                // Check that all elements in the same row, if not, set result to true.
                // We can't check the first and last element because the may have different visual position,
                // because of order CCS property.
                const isInTwoLine = Array.from(entry.target.children).some((child)=>child instanceof HTMLElement && child.offsetTop !== firstChildTop);
                setResult(isInTwoLine);
            }
        };
        const resizeObserver = new ResizeObserver(updateResult);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return [
        setElement,
        result
    ];
};





const $18022fc6571f7d62$var$message = (0, $kSwu1.defineMessages)({
    logoAltText: {
        id: "fabric.editor.ai.screens.prompt.logoAltText",
        defaultMessage: "Atlassian Intelligence Logo"
    },
    logoText: {
        id: "fabric.editor.ai.screens.prompt.logoText",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.preview.cancelLabel",
        defaultMessage: "Cancel"
    },
    discardLabel: {
        id: "fabric.editor.ai.screens.preview.discardLabel",
        defaultMessage: "Discard"
    },
    defaultInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultAIPlaceholder",
        defaultMessage: "Tell AI what to do next"
    },
    defaultRovoInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder",
        defaultMessage: "Tell Rovo what to do next"
    },
    placeholderWithAgent: {
        id: "fabric.editor.ai.screens.preview.placeholderWithAgent",
        defaultMessage: "Ask {agentName} what to do next"
    },
    disclaimer: {
        id: "fabric.editor.ai.screens.preview.disclaimer",
        defaultMessage: "Information quality may vary."
    },
    disclaimerLink: {
        id: "fabric.editor.ai.screens.preview.disclaimerLink",
        defaultMessage: "Learn why"
    },
    previewScreenLabel: {
        id: "fabric.editor.ai.experience.previewScreenLabel",
        defaultMessage: "Preview"
    },
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineButton",
        defaultMessage: "Refine"
    },
    highlightDifferencesLabel: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesLabel.non-final",
        defaultMessage: "Highlight differences"
    },
    highlightDifferencesDisabledTooltip: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip.non-final",
        defaultMessage: "This feature is not available for this AI generated response."
    },
    actionButtonsAccessibleLabel: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel",
        defaultMessage: "Actions for AI generated content"
    },
    actionButtonsTryAgain: {
        id: "fabric.editor.ai.screens.preview.actionButtonsTryAgain",
        defaultMessage: "Try again"
    },
    actionButtonsAccept: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccept",
        defaultMessage: "Accept"
    }
});
var $18022fc6571f7d62$export$2e2bcd8739ae039 = $18022fc6571f7d62$var$message;


const $cfdccabea9eca74e$var$container = null;
const $cfdccabea9eca74e$var$secondLevelContainer = null;
const $cfdccabea9eca74e$var$compactSecondaryButtonsContainer = null;
function $cfdccabea9eca74e$export$6a458a35d6b615d0({ cancelButton: cancelButton, primaryButtons: primaryButtons, secondaryButtons: secondaryButtons }) {
    // The Discard button should be the last when there are two lines of buttons.
    //
    // We can't do it just by CSS (for example, by order prop), because CSS order doesn't
    // affect the tab order.
    // And we can't use tabindex, because tabindex is global and change order of all elements.
    // That's why we need to render the Discard button in different places in the DOM,
    // based on the number of lines. Stupid but works=(
    //
    // Also, we can't determinate the line count based on container width
    // because the amount buttons can be different.
    // That's why we use the useIsFlexElementWrapped hook to determine the line count.
    //
    // See more why CSS order and tabindex don't work: https://tink.uk/flexbox-the-keyboard-navigation-disconnect/
    const [setRootContainerElement, isRootContainerWrapped] = (0, $f8c0a67f4617c01f$export$1ca3f17e50a1bf69)();
    const [setSecondLevelContainerElement, isSecondLevelContainerWrapped] = (0, $f8c0a67f4617c01f$export$1ca3f17e50a1bf69)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: setRootContainerElement,
        role: "group",
        "aria-label": formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).actionButtonsAccessibleLabel),
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuz9WS _0Of8r2Pgdg"
        ]),
        children: [
            !isRootContainerWrapped && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
                ]),
                children: secondaryButtons
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                ref: setSecondLevelContainerElement,
                className: (0, $hekY6.default)([
                    "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuz9WS _0Of8r2Pgdg",
                    "_2XsHFMIZbP"
                ]),
                children: [
                    !isSecondLevelContainerWrapped && cancelButton,
                    primaryButtons && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _37wbyuz9WS _0Of8r2Pgdg"
                        ]),
                        children: primaryButtons
                    }),
                    isSecondLevelContainerWrapped && cancelButton
                ]
            }),
            isRootContainerWrapped && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
                ]),
                children: secondaryButtons
            })
        ]
    });
}


/* RefineDropdown.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 









var $3vgx3 = parcelRequire("3vgx3");




const $c014071856ef5337$var$message = (0, $kSwu1.defineMessages)({
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineDropdown.refineButton",
        defaultMessage: "Refine"
    }
});
var $c014071856ef5337$export$2e2bcd8739ae039 = $c014071856ef5337$var$message;


/* RefineDropdownItems.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 


parcelRequire("cozmU");








var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");




function $58765a947509a6b7$export$99f30ba596e90ddb({ items: items, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
        children: items.map((item)=>/*#__PURE__*/ (0, $8aG6j.jsx)($58765a947509a6b7$var$Item, {
                item: item,
                onItemClick: onItemClick,
                currentOpenedSubMenu: currentOpenedSubMenu,
                onSubMenuOpenChanged: onSubMenuOpenChanged
            }, item.title.id))
    });
}
function $58765a947509a6b7$var$Item({ item: item, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if ('children' in item && item.children) {
        const handleOpenChange = ({ isOpen: isOpen })=>{
            onSubMenuOpenChanged?.(item, isOpen);
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            placement: "right-start",
            shouldRenderToParent: true,
            isOpen: currentOpenedSubMenu === item,
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default // Ignored via go/ees005
                ), {
                    ...triggerProps,
                    ref: triggerRef,
                    elemBefore: item.icon,
                    elemAfter: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        size: "small"
                    }),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        children: formatMessage(item.title)
                    })
                }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)($58765a947509a6b7$export$99f30ba596e90ddb, {
                    items: item.children,
                    onItemClick: onItemClick
                })
            })
        });
    }
    const handleItemClick = ()=>{
        onItemClick();
        item.onClick?.();
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        elemBefore: item.icon,
        onClick: handleItemClick,
        children: formatMessage(item.title)
    });
}


function $4a391d19365ed731$export$892617147bbb1d94({ items: items, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpened, setIsOpened] = (0, $cozmU.useState)(false);
    const [currentOpenedSubMenu, setCurrentOpenedSubMenu] = (0, $cozmU.useState)(null);
    const handleOpenChange = (0, $cozmU.useCallback)(({ isOpen: isOpen })=>{
        isOpen && onClick && onClick();
        setIsOpened(isOpen);
        if (!isOpen) setCurrentOpenedSubMenu(null);
    }, [
        onClick
    ]);
    const handleItemClick = (0, $cozmU.useCallback)(()=>{
        setIsOpened(false);
        setCurrentOpenedSubMenu(null);
    }, []);
    const handleSubMenuOpenChanged = (0, $cozmU.useCallback)((subMenu, isOpen)=>{
        setCurrentOpenedSubMenu((current)=>{
            // Close the current opened sub menu if it's not the same as the one that was clicked
            if (current === subMenu && !isOpen) return null;
            return subMenu;
        });
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        trigger: formatMessage((0, $c014071856ef5337$export$2e2bcd8739ae039).refineButton),
        testId: "refine-dropdown",
        shouldRenderToParent: true,
        isOpen: isOpened,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $58765a947509a6b7$export$99f30ba596e90ddb), {
            items: items,
            onItemClick: handleItemClick,
            currentOpenedSubMenu: currentOpenedSubMenu,
            onSubMenuOpenChanged: handleSubMenuOpenChanged
        })
    });
}



const $1b507768313d7680$var$previewContainerPaddingStyles = null;
const $1b507768313d7680$var$columnLayout = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $1b507768313d7680$var$interrogationWrapper = null;
const $1b507768313d7680$var$defaultPaddingStyles = null;
const $1b507768313d7680$var$previewContainerPaddingCompact = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $1b507768313d7680$var$previewContainerBorders = null;
const $1b507768313d7680$var$previewFloatingContainerStyle = null;
const $1b507768313d7680$var$mapActionAppearanceToButtonAppearance = {
    primary: 'primary',
    secondary: 'default',
    cancel: 'subtle'
};
const $1b507768313d7680$export$9f3706359963c421 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(107);
    const { parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, staticPromptTitle: staticPromptTitle, staticInsertedPrompt: staticInsertedPrompt, latestPrompt: latestPrompt, preview: preview, disableActions: t1, disableInterrogation: t2, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onBack: onBack, onClose: onClose, showBack: t3, applications: applications, isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, PromptEditor: PromptEditor, clearInputRef: clearInputRef, providerFactory: providerFactory, schema: schema, disclaimer: disclaimer, agent: agent, onRefinementClick: onRefinementClick, refineDropdownItems: refineDropdownItems, hideHorizontalRule: t4, showBetaLozenge: t5, isClearTitle: t6, canInlineStreamChanges: canInlineStreamChanges, isAIFC: isAIFC } = t0;
    const disableActions = t1 === undefined ? false : t1;
    const disableInterrogation = t2 === undefined ? false : t2;
    const showBack = t3 === undefined ? true : t3;
    const hideHorizontalRule = t4 === undefined ? false : t4;
    const showBetaLozenge = t5 === undefined ? false : t5;
    const isClearTitle = t6 === undefined ? false : t6;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [forceFocusRing, setForceFocusRing] = (0, $cozmU.useState)(true);
    const presetTitleString = staticPromptTitle ?? latestPrompt?.presetTitle;
    const promptString = staticInsertedPrompt ?? latestPrompt?.userInput;
    let t7;
    if ($[0] !== applications) {
        t7 = ()=>{
            if (!applications) return;
            setForceFocusRing(false);
            applications[applications.length - 1].onClick();
        };
        $[0] = applications;
        $[1] = t7;
    } else t7 = $[1];
    const firePrimaryApplication = t7;
    let t8;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>{
            setForceFocusRing(false);
        };
        $[2] = t8;
    } else t8 = $[2];
    const onInterrogateBlur = t8;
    let t9;
    if ($[3] !== onInputFocus) {
        t9 = ()=>{
            setForceFocusRing(true);
            if (onInputFocus) onInputFocus();
        };
        $[3] = onInputFocus;
        $[4] = t9;
    } else t9 = $[4];
    const handleOnInputFocus = t9;
    const focusInputRef = (0, $cozmU.useRef)(undefined);
    let t10;
    if ($[5] !== agent || $[6] !== formatMessage) {
        t10 = agent ? formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).placeholderWithAgent, {
            agentName: agent.name
        }) : formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).defaultRovoInputPlaceholder);
        $[5] = agent;
        $[6] = formatMessage;
        $[7] = t10;
    } else t10 = $[7];
    const initialPlaceholder = t10;
    const isViewingLatestResponse = !disableActions && !disableInterrogation;
    let t11;
    if ($[8] !== onBadResponseButtonClick || $[9] !== onGoodResponseButtonClick) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $29d5f06545812d14$export$ce859c56062f484c), {
            onBadResponseButtonClick: onBadResponseButtonClick,
            onGoodResponseButtonClick: onGoodResponseButtonClick
        });
        $[8] = onBadResponseButtonClick;
        $[9] = onGoodResponseButtonClick;
        $[10] = t11;
    } else t11 = $[10];
    const feedbackForm = t11;
    let t12;
    if ($[11] !== disableActions || $[12] !== feedbackForm || $[13] !== isAIFC || $[14] !== onCopy || $[15] !== onRetry) {
        t12 = !disableActions && (isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                onCopy && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4a1f879e9ce5c6d$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                }),
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0a36abf44be57c0c$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0a36abf44be57c0c$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                }),
                onCopy && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4a1f879e9ce5c6d$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                })
            ]
        }));
        $[11] = disableActions;
        $[12] = feedbackForm;
        $[13] = isAIFC;
        $[14] = onCopy;
        $[15] = onRetry;
        $[16] = t12;
    } else t12 = $[16];
    const secondaryButtons = t12;
    let t13;
    if ($[17] !== applications || $[18] !== disableActions || $[19] !== formatMessage || $[20] !== onCancel) {
        t13 = onCancel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            testId: "discard-button",
            onClick: onCancel,
            type: "button",
            appearance: disableActions ? "primary" : "subtle",
            autoFocus: disableActions || applications.length === 0,
            children: formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).discardLabel)
        }) : undefined;
        $[17] = applications;
        $[18] = disableActions;
        $[19] = formatMessage;
        $[20] = onCancel;
        $[21] = t13;
    } else t13 = $[21];
    const cancelButton = t13;
    let primaryButtons;
    if ($[22] !== agent || $[23] !== applications || $[24] !== disableActions || $[25] !== forceFocusRing || $[26] !== onRefinementClick || $[27] !== refineDropdownItems) {
        primaryButtons = !disableActions && applications.map((t14, index)=>{
            const { onClick: onClick, label: label, appearance: appearance, shortcut: shortcut, isDisabled: isDisabled, tooltip: tooltip } = t14;
            const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af4ed6779a658b23$export$3ca6788437e93171), {
                onClick: onClick,
                type: "button",
                shortcut: shortcut,
                autoFocus: appearance === "primary",
                forceFocusRing: index === applications.length - 1 && forceFocusRing,
                buttonAutoFocusRing: index === applications.length - 1 && !forceFocusRing,
                appearance: $1b507768313d7680$var$mapActionAppearanceToButtonAppearance[appearance],
                isDisabled: isDisabled,
                children: label
            }, label);
            if (tooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: tooltip,
                position: "top",
                children: button
            }, `${label}-tooltip`);
            return button;
        });
        if (primaryButtons && !agent && refineDropdownItems) {
            let t15;
            if ($[29] !== onRefinementClick || $[30] !== refineDropdownItems) {
                t15 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4a391d19365ed731$export$892617147bbb1d94), {
                    items: refineDropdownItems,
                    onClick: onRefinementClick
                }, "refine-dropdown");
                $[29] = onRefinementClick;
                $[30] = refineDropdownItems;
                $[31] = t15;
            } else t15 = $[31];
            primaryButtons.unshift(t15);
        }
        $[22] = agent;
        $[23] = applications;
        $[24] = disableActions;
        $[25] = forceFocusRing;
        $[26] = onRefinementClick;
        $[27] = refineDropdownItems;
        $[28] = primaryButtons;
    } else primaryButtons = $[28];
    if (isAIFC) {
        if ($[32] !== applications || $[33] !== disableActions || $[34] !== formatMessage) {
            const primaryAction = applications.find($1b507768313d7680$var$_temp);
            if (primaryAction) {
                const t14 = (0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(primaryAction?.label);
                let t15;
                if ($[36] !== formatMessage) {
                    t15 = formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).actionButtonsAccept);
                    $[36] = formatMessage;
                    $[37] = t15;
                } else t15 = $[37];
                const acceptButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af4ed6779a658b23$export$3ca6788437e93171), {
                    onClick: primaryAction?.onClick,
                    type: "button",
                    shortcut: primaryAction?.shortcut,
                    autoFocus: true,
                    appearance: "primary",
                    isDisabled: primaryAction?.isDisabled,
                    children: t15
                }, t14);
                let t16;
                if ($[38] !== acceptButton || $[39] !== disableActions) {
                    t16 = !disableActions && [
                        acceptButton
                    ];
                    $[38] = acceptButton;
                    $[39] = disableActions;
                    $[40] = t16;
                } else t16 = $[40];
                primaryButtons = t16;
            }
            $[32] = applications;
            $[33] = disableActions;
            $[34] = formatMessage;
            $[35] = primaryButtons;
        } else primaryButtons = $[35];
    }
    let t14;
    if ($[41] !== cancelButton || $[42] !== primaryButtons || $[43] !== secondaryButtons) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfdccabea9eca74e$export$6a458a35d6b615d0), {
            cancelButton: cancelButton,
            secondaryButtons: secondaryButtons,
            primaryButtons: primaryButtons
        });
        $[41] = cancelButton;
        $[42] = primaryButtons;
        $[43] = secondaryButtons;
        $[44] = t14;
    } else t14 = $[44];
    const actionButtons = t14;
    const t15 = hideHorizontalRule ? "_0Of8r2Pgdg" : !isAIFC && "_2bqfgdOeNX _1x1D3gOeNX";
    let t16;
    if ($[45] !== t15) {
        t16 = (0, $hekY6.default)([
            "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
            t15
        ]);
        $[45] = t15;
        $[46] = t16;
    } else t16 = $[46];
    const t17 = isAIFC && "_0Of8r2gVvo";
    let t18;
    if ($[47] !== t17) {
        t18 = (0, $hekY6.default)([
            t17
        ]);
        $[47] = t17;
        $[48] = t18;
    } else t18 = $[48];
    let t19;
    if ($[49] !== preview || $[50] !== t18) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t18,
            children: preview
        });
        $[49] = preview;
        $[50] = t18;
        $[51] = t19;
    } else t19 = $[51];
    let t20;
    if ($[52] !== actionButtons || $[53] !== t19) {
        t20 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.200",
            children: [
                t19,
                actionButtons
            ]
        });
        $[52] = actionButtons;
        $[53] = t19;
        $[54] = t20;
    } else t20 = $[54];
    let t21;
    if ($[55] !== t16 || $[56] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t16,
            children: t20
        });
        $[55] = t16;
        $[56] = t20;
        $[57] = t21;
    } else t21 = $[57];
    const generatedContentPreview = t21;
    let t22;
    if ($[58] !== PromptEditor || $[59] !== clearInputRef || $[60] !== firePrimaryApplication || $[61] !== handleOnInputFocus || $[62] !== initialPlaceholder || $[63] !== inputADFValue || $[64] !== inputValue || $[65] !== isAIFC || $[66] !== isInputActive || $[67] !== isViewingLatestResponse || $[68] !== onADFChange || $[69] !== onInputChange || $[70] !== onSubmit) {
        t22 = isViewingLatestResponse && PromptEditor && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
                "_4kiQYAQOM0 _24h04i2Njc _08F4HEdnbC _1YtDsOdnbC _2mDS1WdnbC _2NmEMhdnbC"
            ]),
            children: isViewingLatestResponse && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $de21edef532dabae$export$416523684d97c4ad), {
                type: "interrogate",
                showButtons: isInputActive,
                autoFocus: true,
                placeholder: `${initialPlaceholder}${isAIFC ? "..." : ""}`,
                value: inputValue,
                adfValue: inputADFValue,
                onFormSubmit: onSubmit,
                onInputChange: onInputChange,
                onADFChange: onADFChange,
                onInputFocus: handleOnInputFocus,
                focusInputRef: focusInputRef,
                clearInputRef: clearInputRef,
                PromptEditor: PromptEditor,
                enableLinks: true,
                fireParentActionButton: firePrimaryApplication,
                focusParentActionButton: setForceFocusRing,
                showLogo: false,
                onInputBlur: onInterrogateBlur,
                isAIFC: isAIFC
            })
        });
        $[58] = PromptEditor;
        $[59] = clearInputRef;
        $[60] = firePrimaryApplication;
        $[61] = handleOnInputFocus;
        $[62] = initialPlaceholder;
        $[63] = inputADFValue;
        $[64] = inputValue;
        $[65] = isAIFC;
        $[66] = isInputActive;
        $[67] = isViewingLatestResponse;
        $[68] = onADFChange;
        $[69] = onInputChange;
        $[70] = onSubmit;
        $[71] = t22;
    } else t22 = $[71];
    const promptForm = t22;
    let t23;
    if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            "preview-screen"
        ]);
        $[72] = t23;
    } else t23 = $[72];
    let t24;
    if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w",
            `preview-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]);
        $[73] = t24;
    } else t24 = $[73];
    let t25;
    if ($[74] !== formatMessage) {
        t25 = formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).previewScreenLabel);
        $[74] = formatMessage;
        $[75] = t25;
    } else t25 = $[75];
    let t26;
    if ($[76] !== t25) {
        t26 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: t25
        });
        $[76] = t25;
        $[77] = t26;
    } else t26 = $[77];
    let t27;
    if ($[78] !== agent || $[79] !== childShortTitle || $[80] !== isAIFC || $[81] !== isClearTitle || $[82] !== latestPrompt?.userADFInput || $[83] !== onBack || $[84] !== onClose || $[85] !== onEditPromptClick || $[86] !== parentPresetPromptLabel || $[87] !== presetTitleString || $[88] !== promptString || $[89] !== providerFactory || $[90] !== schema || $[91] !== showBack) {
        t27 = !isAIFC && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hUKxF.LatestPromptHeader), {
            parentPresetPromptLabel: parentPresetPromptLabel,
            childShortTitle: childShortTitle,
            prompt: promptString,
            promptADF: latestPrompt?.userADFInput,
            presetTitle: presetTitleString,
            agent: agent,
            providerFactory: providerFactory,
            schema: schema,
            onEditPromptClick: onEditPromptClick,
            showBack: showBack,
            onBack: onBack,
            onClose: onClose,
            isClearTitle: isClearTitle
        });
        $[78] = agent;
        $[79] = childShortTitle;
        $[80] = isAIFC;
        $[81] = isClearTitle;
        $[82] = latestPrompt?.userADFInput;
        $[83] = onBack;
        $[84] = onClose;
        $[85] = onEditPromptClick;
        $[86] = parentPresetPromptLabel;
        $[87] = presetTitleString;
        $[88] = promptString;
        $[89] = providerFactory;
        $[90] = schema;
        $[91] = showBack;
        $[92] = t27;
    } else t27 = $[92];
    const t28 = !isAIFC && promptForm;
    const t29 = agent ? "rovo" : "atlassian-intelligence";
    const t30 = isAIFC && canInlineStreamChanges;
    let t31;
    if ($[93] !== disclaimer || $[94] !== feedbackForm || $[95] !== isAIFC || $[96] !== showBetaLozenge || $[97] !== t29 || $[98] !== t30) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8W9nI.Footer), {
            brand: t29,
            disclaimer: disclaimer,
            showDisclaimer: true,
            showBetaLozenge: showBetaLozenge,
            showFeedback: t30,
            feedbackForm: feedbackForm,
            isAIFC: isAIFC
        });
        $[93] = disclaimer;
        $[94] = feedbackForm;
        $[95] = isAIFC;
        $[96] = showBetaLozenge;
        $[97] = t29;
        $[98] = t30;
        $[99] = t31;
    } else t31 = $[99];
    let t32;
    if ($[100] !== generatedContentPreview || $[101] !== isAIFC || $[102] !== t26 || $[103] !== t27 || $[104] !== t28 || $[105] !== t31) {
        t32 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t23,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer), {
                disablePadding: true,
                "data-testid": "preview-screen",
                className: t24,
                rainbowBorder: false,
                isAIFC: isAIFC,
                children: [
                    t26,
                    t27,
                    generatedContentPreview,
                    t28,
                    t31
                ]
            })
        });
        $[100] = generatedContentPreview;
        $[101] = isAIFC;
        $[102] = t26;
        $[103] = t27;
        $[104] = t28;
        $[105] = t31;
        $[106] = t32;
    } else t32 = $[106];
    return t32;
} : ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, staticPromptTitle: staticPromptTitle, staticInsertedPrompt: staticInsertedPrompt, latestPrompt: latestPrompt, preview: preview, disableActions: disableActions = false, disableInterrogation: disableInterrogation = false, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onBack: onBack, onClose: onClose, showBack: showBack = true, applications: applications, isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, PromptEditor: PromptEditor, clearInputRef: clearInputRef, providerFactory: providerFactory, schema: schema, disclaimer: disclaimer, agent: agent, onRefinementClick: onRefinementClick, refineDropdownItems: refineDropdownItems, hideHorizontalRule: hideHorizontalRule = false, showBetaLozenge: showBetaLozenge = false, isClearTitle: isClearTitle = false, canInlineStreamChanges: canInlineStreamChanges, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [forceFocusRing, setForceFocusRing] = (0, $cozmU.useState)(true);
    const presetTitleString = staticPromptTitle ?? latestPrompt?.presetTitle;
    const promptString = staticInsertedPrompt ?? latestPrompt?.userInput;
    const firePrimaryApplication = ()=>{
        if (!applications) return;
        setForceFocusRing(false);
        applications[applications.length - 1].onClick();
    };
    const onInterrogateBlur = (0, $cozmU.useCallback)(()=>{
        setForceFocusRing(false);
    }, []);
    const handleOnInputFocus = (0, $cozmU.useCallback)(()=>{
        setForceFocusRing(true);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const focusInputRef = (0, $cozmU.useRef)(undefined);
    const initialPlaceholder = agent ? formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).placeholderWithAgent, {
        agentName: agent.name
    }) : formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).defaultRovoInputPlaceholder); // This is used to determine when to disable a number of features to prevent
    // the user from performing actions on previous responses
    const isViewingLatestResponse = !disableActions && !disableInterrogation;
    const feedbackForm = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $29d5f06545812d14$export$ce859c56062f484c), {
            onBadResponseButtonClick: onBadResponseButtonClick,
            onGoodResponseButtonClick: onGoodResponseButtonClick
        });
    }, [
        onBadResponseButtonClick,
        onGoodResponseButtonClick
    ]);
    const actionButtons = (0, $cozmU.useMemo)(()=>{
        const secondaryButtons = !disableActions && (isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                onCopy && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4a1f879e9ce5c6d$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                }),
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0a36abf44be57c0c$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $0a36abf44be57c0c$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                }),
                onCopy && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f4a1f879e9ce5c6d$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                })
            ]
        }));
        const cancelButton = onCancel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            testId: "discard-button",
            onClick: onCancel,
            type: "button",
            appearance: disableActions ? 'primary' : 'subtle',
            autoFocus: disableActions || applications.length === 0,
            children: formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).discardLabel)
        }) : undefined;
        let primaryButtons = !disableActions && applications.map(({ onClick: onClick, label: label, appearance: appearance, shortcut: shortcut, isDisabled: isDisabled, tooltip: tooltip }, index)=>{
            const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af4ed6779a658b23$export$3ca6788437e93171), {
                onClick: onClick,
                type: "button",
                shortcut: shortcut,
                autoFocus: appearance === 'primary',
                forceFocusRing: index === applications.length - 1 && forceFocusRing,
                buttonAutoFocusRing: index === applications.length - 1 && !forceFocusRing,
                appearance: $1b507768313d7680$var$mapActionAppearanceToButtonAppearance[appearance],
                isDisabled: isDisabled,
                children: label
            }, label);
            if (tooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: tooltip,
                position: "top",
                children: button
            }, `${label}-tooltip`);
            return button;
        });
        if (primaryButtons && !agent && refineDropdownItems) primaryButtons.unshift(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4a391d19365ed731$export$892617147bbb1d94), {
            items: refineDropdownItems,
            onClick: onRefinementClick
        }, "refine-dropdown"));
        if (isAIFC) {
            // still brittle, assumes only 1 primary
            const primaryAction = applications.find((action)=>action.appearance === 'primary');
            if (primaryAction) {
                const acceptButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $af4ed6779a658b23$export$3ca6788437e93171), {
                    onClick: primaryAction?.onClick,
                    type: "button",
                    shortcut: primaryAction?.shortcut,
                    autoFocus: true,
                    appearance: "primary",
                    isDisabled: primaryAction?.isDisabled,
                    children: formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).actionButtonsAccept)
                }, (0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(primaryAction?.label));
                primaryButtons = !disableActions && [
                    acceptButton
                ];
            }
        }
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cfdccabea9eca74e$export$6a458a35d6b615d0), {
            cancelButton: cancelButton,
            secondaryButtons: secondaryButtons,
            primaryButtons: primaryButtons
        });
    }, [
        disableActions,
        feedbackForm,
        onRetry,
        onCopy,
        onCancel,
        applications,
        formatMessage,
        agent,
        refineDropdownItems,
        isAIFC,
        forceFocusRing,
        onRefinementClick
    ]);
    const generatedContentPreview = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
            hideHorizontalRule ? "_0Of8r2Pgdg" : !isAIFC && "_2bqfgdOeNX _1x1D3gOeNX"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        isAIFC && "_0Of8r2gVvo"
                    ]),
                    children: preview
                }),
                actionButtons
            ]
        })
    });
    const promptForm = isViewingLatestResponse && PromptEditor && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE",
            "_4kiQYAQOM0 _24h04i2Njc _08F4HEdnbC _1YtDsOdnbC _2mDS1WdnbC _2NmEMhdnbC"
        ]),
        children: isViewingLatestResponse && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $de21edef532dabae$export$416523684d97c4ad), {
            type: "interrogate",
            showButtons: isInputActive,
            autoFocus: true,
            placeholder: `${initialPlaceholder}${isAIFC ? '...' : ''}`,
            value: inputValue,
            adfValue: inputADFValue,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onFormSubmit: onSubmit,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            onInputFocus: handleOnInputFocus,
            focusInputRef: focusInputRef,
            clearInputRef: clearInputRef,
            PromptEditor: PromptEditor,
            enableLinks: true,
            fireParentActionButton: firePrimaryApplication,
            focusParentActionButton: setForceFocusRing,
            showLogo: false,
            onInputBlur: onInterrogateBlur,
            isAIFC: isAIFC
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ , {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            "preview-screen"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer), {
            disablePadding: true,
            "data-testid": "preview-screen",
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5vbt8w",
                `preview-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
            ]),
            rainbowBorder: false,
            isAIFC: isAIFC,
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $18022fc6571f7d62$export$2e2bcd8739ae039).previewScreenLabel)
                }),
                !isAIFC && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hUKxF.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: promptString,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: presetTitleString,
                    agent: agent,
                    providerFactory: providerFactory,
                    schema: schema,
                    onEditPromptClick: onEditPromptClick,
                    showBack: showBack,
                    onBack: onBack,
                    onClose: onClose,
                    isClearTitle: isClearTitle
                }),
                generatedContentPreview,
                !isAIFC && promptForm,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8W9nI.Footer), {
                    brand: agent ? 'rovo' : 'atlassian-intelligence',
                    disclaimer: disclaimer,
                    showDisclaimer: true,
                    showBetaLozenge: showBetaLozenge,
                    showFeedback: isAIFC && canInlineStreamChanges,
                    feedbackForm: feedbackForm,
                    isAIFC: isAIFC
                })
            ]
        })
    });
};
function $1b507768313d7680$var$_temp(action) {
    return action.appearance === "primary";
}










function $7a9ec6fe4c18e2ae$export$2eadb01b889bdc4() {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)((history)=>{
        const title = history.entries[0].configItem.title;
        const name = title ? formatMessage(title) : '';
        const dialogues = history.entries.map((entry, index)=>{
            const configItemTitle = formatMessage(entry.configItem.title);
            let humanMessage = entry.userInput;
            // The first message should show the config item title
            if (index === 0) humanMessage = `${configItemTitle}\n\n${humanMessage}`;
            // Use the config item title as fallback if the human message is empty
            humanMessage = humanMessage.trim() || configItemTitle;
            return {
                agent_message: {
                    content: entry.markdown
                },
                human_message: {
                    content: humanMessage
                }
            };
        });
        return {
            name: name,
            dialogues: dialogues
        };
    }, [
        formatMessage
    ]);
}









/**
 * Check if the element has a modal above it.
 *
 * This implementation is dangerous because it relies on the DOM structure of the modal.
 */ function $d566c2a1407b9634$var$isElementHasModalAbove(element) {
    if (!element) return false;
    const elementPortal = element.closest('.atlaskit-portal');
    if (!elementPortal) // If element is not in the modal, we can safely assume that the modal is above
    // if there is a focus guard in the document.
    return !!document.querySelector('[data-focus-guard="true"]');
    // Check all siblings of the element to see if there is a focus guard.
    // If there is a focus guard, it means that the modal is above the current modal.
    let sibling = elementPortal.nextElementSibling;
    while(sibling){
        if (sibling.querySelector('[data-focus-guard="true"]')) return true;
        sibling = sibling.nextElementSibling;
    }
    return false;
}
const $d566c2a1407b9634$export$aa79b0abe3dfeaba = ({ disabled: disabled, userInput: userInput, onCancel: onCancel, onDiscard: onDiscard, modalRef: modalRef })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (disabled) return;
        if (!modalRef) return;
        const handleOutsideClick = (event)=>{
            // It's a really bad idea to check DOM, but we don't have any better way to determinate if
            // the Feedback modal is open or not.
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // FIXME: It should be removed and replaced with solution based on the state of the modal and `disabled` prop.
            if ($d566c2a1407b9634$var$isElementHasModalAbove(modalRef.current)) return;
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                if (!userInput) onCancel();
                else onDiscard();
            }
        };
        return (0, $cbY7C.bind)(document, {
            type: 'mousedown',
            listener: handleOutsideClick
        });
    }, [
        disabled,
        userInput,
        onCancel,
        onDiscard,
        modalRef
    ]);
};
















function $a0bc851fc153e218$export$f332b66be3f378cc(promptTrigger, history) {
    const isPreConfiguredPrompt = promptTrigger !== 'generate'; // like immediate 'improve writing' from toolbar
    const isInitialPrompt = history?.entries?.length === 1;
    return isPreConfiguredPrompt && isInitialPrompt;
}







function $886bb49e2e7a4b11$export$705df12804ca7004({ aiExperienceMachineContext: aiExperienceMachineContext, isInputActive: isInputActive, backendModel: backendModel, rovoAction: rovoAction, rovoPublish: rovoPublish }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isEmpty: isEmpty, parentPresetPromptLabel: parentPresetPromptLabel, latestPrompt: latestPrompt, markdown: actualMarkdown, adfResponse: adfResponse, configItem: configItem, userInput: actualUserInput, userADFInput: actualUserADFInput, editCount: editCount, retryPromptCount: retryPromptCount, refinementCount: refinementCount, idMap: idMap, responseHistory: history, contextStatistics: contextStatistics, promptTrigger: promptTrigger, channelId: channelId, selectionMetaData: selectionMetaData } = aiExperienceMachineContext;
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, endExperience: endExperience, positions: positions, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, lastTriggeredFrom: lastTriggeredFrom, modalRef: modalRef, triggeredFor: triggeredFor, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, canInlineStreamChanges: canInlineStreamChanges } = aiExperienceCommonData;
    const disclaimer = (0, $ea1e399bb2487613$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    }); /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ 
    const childShortTitle = parentPresetPromptLabel && configItem.nestingConfig ? formatMessage(configItem.nestingConfig.shortTitle) : '';
    const userInput = actualUserInput || '';
    const userADFInput = actualUserADFInput;
    const schema = editorView.state.schema;
    const product = editorPluginAIProvider.product; /**
                                                   * Please check with Ethan/PM upon removing onExperienceEvent
                                                   * calls, to confirm it is no longer used in any ongoing experiments.
                                                   */ 
    (0, $cozmU.useEffect)(()=>{
        editorPluginAIProvider.onExperienceEvent?.REVIEW_STATE_ENTERED();
    }, [
        editorPluginAIProvider
    ]);
    const clearInputRef = (0, $cozmU.useRef)();
    const lastHistoryEvent = history.entries[history.positionFromEnd]; /**
                                                                      * We may remove this diff ratio calculation, when we are sure that the backend
                                                                      * calculation is working. We will need to have converted to the new ConvoAI endpoint.
                                                                      * @see https://hello.jira.atlassian.cloud/browse/AIX-1665
                                                                      * @see https://hello.jira.atlassian.cloud/browse/EDITOR-792
                                                                      */ 
    const diffRatio = (lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc) && actualMarkdown && (0, $iDrrr.fg)('editor_ai_no_improvement_deadend_fix') ? (0, $a75407f6634c6048$export$4ca0a669de074f43)({
        input: lastHistoryEvent.modelInput.selection || lastHistoryEvent.modelInput.doc || '',
        output: actualMarkdown
    }) : 1;
    const responseTooSimilar = lastHistoryEvent.responseTooSimilar || diffRatio < (0, $a75407f6634c6048$export$6874965a4629d745);
    const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
    let markdown = actualMarkdown || '';
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const enqueuedPreviewStep = (0, $cozmU.useRef)(false);
    const errorReported = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    if (markdown && (0, $bVbtv.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) markdown = (0, $5b15a14abf2aa8e2$export$8850f5fc4cad5830)(markdown);
    let previewToUse;
    let pmFragment = (0, $aPdNQ.Fragment).empty;
    let pmFragmentPreviewData;
    if (adfResponse) {
        pmFragment = (0, $aPdNQ.Node).fromJSON(schema, adfResponse).content;
        previewToUse = (0, $1ebb5e0c9114edeb$export$5ae44876b720d032)({
            adfResponse: adfResponse,
            showTelepointer: false,
            providerFactory: providerFactory,
            schema: schema
        });
    } else {
        pmFragmentPreviewData = (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
            markdown: markdown,
            schema: schema,
            source: 'preview',
            fireAIAnalyticsEvent: (event)=>{
                if (!errorReported.current) {
                    errorReported.current = true;
                    fireAIAnalyticsEvent(event);
                }
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            idMap: idMap
        });
        pmFragment = pmFragmentPreviewData?.pmFragment || (0, $aPdNQ.Fragment).empty;
        previewToUse = getPreviewElement(pmFragment);
    }
    const preview = previewToUse;
    (0, $d566c2a1407b9634$export$aa79b0abe3dfeaba)({
        modalRef: modalRef,
        userInput: userInput,
        onCancel: ()=>sendToAIExperienceMachine({
                type: 'enable discard'
            }),
        onDiscard: ()=>sendToAIExperienceMachine({
                type: 'enable discard'
            })
    }); /**
       * gets preview JSX element based on fragment
       */ 
    function getPreviewElement(pmFragment) {
        if (responseTooSimilar) {
            const responseTooSimilarMessage = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).responseTooSimilarMessage);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                as: "p"
            }, responseTooSimilarMessage);
        }
        return (0, $1ebb5e0c9114edeb$export$f5e3af6d625de7a)({
            schema: schema,
            pmFragment: pmFragment,
            showTelepointer: false,
            providerFactory: providerFactory
        });
    } // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $48b5c021b1ae01b8$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $45c921fe28f84dd0$export$4e4614f0417d7178)(localizedLatestPrompt);
    (0, $cozmU.useEffect)(()=>{
        analyticsFlow.fireQueuedStep('preview');
        let modelIO;
        const stats = new (0, $3cHXJ.ProseMirrorContentStatistics)(pmFragment);
        const contentStatistics = stats.collectStatistics();
        if (adfResponse) modelIO = {
            selectionSize: lastHistoryEvent.modelInput.selection?.length,
            outputUnclosedTokens: {},
            outputHTMLConvertedToNodes: 0,
            outputHTMLConvertedToFallbackNodes: 0,
            isTextFallbackUsed: false,
            previewNodeCounts: contentStatistics.nodeCounts,
            previewMarkCounts: contentStatistics.markCounts,
            previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
            userInputCharacterCount: promptStatistics?.totalCharacterCount,
            userInputNodeCounts: promptStatistics?.nodeCounts,
            userInputLinksCount: promptStatistics?.linksCount,
            userInputMentionsCount: promptStatistics?.mentionsCount
        };
        else if (pmFragmentPreviewData) modelIO = {
            selectionSize: lastHistoryEvent.modelInput.selection?.length,
            nodesConvertedToHTMLInput: idMap ? Object.keys(idMap).length : undefined,
            outputUnclosedTokens: pmFragmentPreviewData.unclosedTokens,
            outputHTMLConvertedToNodes: pmFragmentPreviewData.htmlConvertedToNodes,
            outputHTMLConvertedToFallbackNodes: pmFragmentPreviewData.htmlConvertedToFallbackNodes,
            isTextFallbackUsed: pmFragmentPreviewData.isTextFallbackUsed,
            previewNodeCounts: contentStatistics.nodeCounts,
            previewMarkCounts: contentStatistics.markCounts,
            previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
            userInputCharacterCount: promptStatistics?.totalCharacterCount,
            userInputNodeCounts: promptStatistics?.nodeCounts,
            userInputLinksCount: promptStatistics?.linksCount,
            userInputMentionsCount: promptStatistics?.mentionsCount
        };
        analyticsFlow.addAttributes({
            editCount: editCount,
            responseTooSimilar: responseTooSimilar,
            modelIO: {
                contextStatistics: contextStatistics,
                ...modelIO
            },
            inputOutputDiffRatio: inputOutputDiffRatio
        });
        analyticsFlow.updateCommonAttributes({
            isStreamingEnded: true
        });
        return ()=>{
            // We only want to enqueue the preview step if it hasn't been enqueued
            // already. This is to handle the case where the user clicks on an
            // ai action button where we manually enqueue the analytics event,
            // and then seperately fire a complete step.
            if (enqueuedPreviewStep.current === false) analyticsFlow.enqueueStep({
                stepName: 'preview',
                attributes: undefined
            });
        }; // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireDismissEvent = (0, $cozmU.useCallback)(()=>{
        // Introduced in EDF-1443 to track Retry events as AI response dismissal
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).DISMISSED,
                attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                    init: false
                }),
                experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                isProactive: false,
                isStreamingEnded: analyticsFlow.getCommonAttributes().isStreamingEnded
            })
        });
    }, [
        analyticsFlow,
        aiExperienceCommonData.lastTriggeredFrom,
        channelId,
        configItem.key,
        fireAIAnalyticsEvent,
        lastTriggeredFrom
    ]);
    const fireResponseFeedbackEvent = (sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItem.agent?.name || configItem.key,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    retryPromptCount: retryPromptCount,
                    responseTooSimilar: responseTooSimilar,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).SUBMITTED,
                interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString(), lastTriggeredFrom),
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: {
                    aiFeedbackResult: sentiment === 'good' ? 'up' : 'down',
                    ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    })
                }
            })
        });
    };
    const handleFiringFeedbackEvent = async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        }); // we need to update the state machine to reflect the user feedback
        sendToAIExperienceMachine({
            type: 'feedback submitted',
            sentiment: feedbackMetadata.sentiment
        }); // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    };
    const onEditPromptClick = (0, $cozmU.useCallback)(()=>{
        const { userInput: userInput, userADFInput: userADFInput, presetTitle: presetTitle } = localizedLatestPrompt;
        analyticsFlow.addAttributes({
            actionTaken: 'edit-prompt'
        });
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'editPromptButton',
                attributes: {
                    experienceType: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                    editCount: editCount
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
        fireDismissEvent();
        sendToAIExperienceMachine({
            type: 'edit prompt',
            userInput: userInput,
            userADFInput: userADFInput,
            presetTitle: presetTitle
        });
    }, [
        configItem.key,
        localizedLatestPrompt,
        analyticsFlow,
        fireAIAnalyticsEvent,
        editCount,
        fireDismissEvent,
        sendToAIExperienceMachine
    ]);
    const discardWithoutWarning = (0, $cozmU.useCallback)(()=>{
        if ((0, $a0bc851fc153e218$export$f332b66be3f378cc)(promptTrigger, history)) {
            endExperience();
            return;
        }
        const { presetTitle: presetTitle } = localizedLatestPrompt;
        sendToAIExperienceMachine({
            type: 'edit prompt',
            userInput: '',
            userADFInput: undefined,
            presetTitle: presetTitle
        });
    }, [
        endExperience,
        history,
        localizedLatestPrompt,
        promptTrigger,
        sendToAIExperienceMachine
    ]);
    const onBack = (0, $cozmU.useCallback)(()=>{
        sendToAIExperienceMachine({
            type: 'enable discard',
            context: {
                onceDiscard: discardWithoutWarning
            }
        });
    }, [
        sendToAIExperienceMachine,
        discardWithoutWarning
    ]);
    const aiExperienceMetadata = {
        configItemTitle: configItem.agent?.name || (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
        ...configItem.experienceId && (0, $iDrrr.fg)('thor_support_google_docs_in_description_improver') ? {
            experienceId: configItem.experienceId
        } : {},
        lastTriggeredFrom: lastTriggeredFrom,
        inputOutputDiffRatio: inputOutputDiffRatio,
        backendModel: backendModel
    };
    const getAIExperience = (hasUserConsent)=>({
            ...aiExperienceMetadata,
            ...hasUserConsent && {
                userPrompt: localizedLatestPrompt.userInput,
                markdownResponse: markdown
            }
        });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        /**
     * When userInput is empty, we need to clear interrogate editor
     *  as setting empty userInput as defaultValue won't clear editor.
     */ if (!userInput) clearInputRef.current?.();
    }, [
        userInput
    ]);
    const onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((inputValue)=>{
        sendToAIExperienceMachine({
            type: 'update user input',
            input: inputValue
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const onADFChange = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((inputValue)=>{
        sendToAIExperienceMachine({
            type: 'update user input adf',
            adf: inputValue
        });
    }, [
        sendToAIExperienceMachine
    ]);
    const disableInterrogation = configItem.disableInterrogation?.() || editorPluginAIProvider.disableInterrogation || history.positionFromEnd > 0;
    const onCancelClick = (0, $cozmU.useCallback)(()=>{
        if (userInput) {
            fireDismissEvent();
            sendToAIExperienceMachine({
                type: 'cancel refinement'
            });
        } else {
            fireDismissEvent();
            discardWithoutWarning();
        }
    }, [
        userInput,
        discardWithoutWarning,
        fireDismissEvent,
        sendToAIExperienceMachine
    ]);
    const onRetryPromptClick = (0, $cozmU.useCallback)(()=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'retryPromptButton',
                attributes: {
                    experienceType: (0, $l2lIz.convertExperienceName)(configItem.key.toString())
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
        fireDismissEvent();
        sendToAIExperienceMachine({
            type: 'retry prompt',
            input: localizedLatestPrompt.userInput,
            adf: localizedLatestPrompt.userADFInput
        });
    }, [
        configItem.key,
        fireAIAnalyticsEvent,
        fireDismissEvent,
        localizedLatestPrompt.userADFInput,
        localizedLatestPrompt.userInput,
        sendToAIExperienceMachine
    ]);
    const [hasClicked, setHasClicked] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const onActionButtonClick = (0, $cozmU.useCallback)(({ runFn: runFn, analyticsTitle: analyticsTitle, preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete })=>{
        // We add this condition to ensure we don't run the action multiple times
        // if the user double-clicks quickly (e.g., on slower machines, the re-render
        // might not happen fast enough to disable the button before the second click).
        // Once hasClicked is true, subsequent clicks in the same component lifetime
        // will be ignored—unless we explicitly reset the state after an error, etc.
        if (!hasClicked) try {
            setHasClicked(true);
            analyticsFlow.addAttributes({
                actionTaken: analyticsTitle
            });
            analyticsFlow.enqueueStep({
                stepName: 'preview'
            }); // We set this to true to prevent the preview step from being
            // enqueued again on unmount
            // Note -- in future -- we expect the complete step to be deprecated
            // an replaced with a "content highlighted" step
            enqueuedPreviewStep.current = true;
            analyticsFlow.fireQueuedStep('complete');
            const beforeActionRun = performance.now();
            runFn();
            (0, $d211ad36412ee080$export$53eb05c40692d65e)(configItem, actualMarkdown || '', editorView, lastTriggeredFrom ?? '');
            analyticsFlow.enqueueStep({
                stepName: 'complete',
                attributes: {
                    actionTaken: analyticsTitle,
                    duration: Math.round(performance.now() - beforeActionRun),
                    editCount: editCount,
                    retryPromptCount: retryPromptCount,
                    promptType: promptTrigger,
                    refinementCount: refinementCount,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
                }
            }); /**
             * Please check with Ethan/PM upon removing onExperienceEvent
             * calls, to confirm it is no longer used in any ongoing experiments.
             */ 
            editorPluginAIProvider.onExperienceEvent?.EXPERIENCE_COMPLETE();
            endExperience({
                preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
            });
        } catch (error) {
            setHasClicked(false);
            fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        errorType: 'actionRunError',
                        actionTitle: analyticsTitle,
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
            sendToAIExperienceMachine({
                type: 'error',
                errorInfo: {
                    failureReason: (0, $Mgq5A.FAILURE_REASON).UNKNOWN
                }
            });
        }
    }, [
        hasClicked,
        analyticsFlow,
        configItem,
        actualMarkdown,
        editorView,
        lastTriggeredFrom,
        editorPluginAIProvider,
        editCount,
        retryPromptCount,
        promptTrigger,
        refinementCount,
        inputOutputDiffRatio,
        includeKnowledgeFromCurrentPage,
        endExperience,
        fireAIAnalyticsEvent,
        sendToAIExperienceMachine
    ]);
    const mapMarkdownAction = (0, $cozmU.useCallback)((action)=>{
        // For Rovo actions, we only generate a fragment from the suggested content (without bot pleasantries)
        const contentFragment = action.isRovoAgentAction && rovoAction ? (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
            markdown: rovoAction.content || '',
            schema: schema,
            source: 'rovo-action',
            // TODO: EDF-1044 - fix markdownParser failed events
            fireAIAnalyticsEvent: ()=>{},
            // Won't be expecting Markdown Plus
            idMap: {}
        }).pmFragment : pmFragment;
        const { isDisabled: isDisabled, tooltip: tooltip } = action.getDisabledState?.({
            markdown: markdown,
            formatMessage: formatMessage
        }) ?? {};
        return {
            label: formatMessage(action.title),
            appearance: action.appearance,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>{
                        action.run({
                            editorView: editorView,
                            positions: positions,
                            markdown: markdown,
                            pmFragment: contentFragment,
                            triggeredFor: triggeredFor,
                            selectionMetaData: selectionMetaData
                        });
                        if (configItem.agent && editorPluginAIProvider.onDocChangeByAgent) editorPluginAIProvider.onDocChangeByAgent(configItem.agent);
                    },
                    analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : ''
                });
            },
            isDisabled: isDisabled || hasClicked,
            tooltip: tooltip,
            icon: action.icon
        };
    }, [
        rovoAction,
        schema,
        pmFragment,
        markdown,
        formatMessage,
        hasClicked,
        onActionButtonClick,
        editorView,
        positions,
        triggeredFor,
        configItem.agent,
        editorPluginAIProvider,
        selectionMetaData
    ]);
    const mapAgentAction = (0, $cozmU.useCallback)((action)=>{
        return {
            label: formatMessage(action.title),
            appearance: action.appearance,
            icon: action.icon,
            shortcut: action.shortcut,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>action.run({
                            channelId: channelId,
                            publish: rovoPublish
                        }),
                    analyticsTitle: typeof action.title.defaultMessage === 'string' ? action.title.defaultMessage : '',
                    preserveEditorSelectionOnComplete: action.preserveEditorSelectionOnComplete
                });
            }
        };
    }, [
        channelId,
        formatMessage,
        onActionButtonClick,
        rovoPublish
    ]);
    const createGenericActionPayload = (0, $7a9ec6fe4c18e2ae$export$2eadb01b889bdc4)();
    const mapGenericChatAction = (0, $cozmU.useCallback)(({ title: title, appearance: appearance, icon: icon, shortcut: shortcut, run: run, preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete })=>{
        return {
            label: formatMessage(title),
            appearance: appearance,
            icon: icon,
            shortcut: shortcut,
            onClick: ()=>{
                onActionButtonClick({
                    runFn: ()=>run({
                            publish: rovoPublish,
                            ...createGenericActionPayload(history)
                        }),
                    analyticsTitle: typeof title.defaultMessage === 'string' ? title.defaultMessage : '',
                    preserveEditorSelectionOnComplete: preserveEditorSelectionOnComplete
                });
            }
        };
    }, [
        createGenericActionPayload,
        formatMessage,
        history,
        onActionButtonClick,
        rovoPublish
    ]); // We need to use actions from the first config item in history,
    // because during refinement, the user might have selected a different
    // config item, that will have different actions.
    const firstConfigItemActions = (0, $c2c6d211a4290fa3$export$a64e27216c5d7416)({
        isEmpty: isEmpty,
        configItem: history.entries[0]?.configItem
    });
    const applications = (0, $cozmU.useMemo)(()=>{
        let actions = (0, $c2c6d211a4290fa3$export$a64e27216c5d7416)({
            isEmpty: isEmpty,
            configItem: configItem
        });
        actions = firstConfigItemActions || actions;
        return actions.map((action)=>{
            if (action.type === 'agent') return mapAgentAction(action);
            if (action.type === 'generic-chat') return mapGenericChatAction(action);
            return mapMarkdownAction(action);
        });
    }, [
        isEmpty,
        configItem,
        firstConfigItemActions,
        mapMarkdownAction,
        mapAgentAction,
        mapGenericChatAction
    ]);
    const refineDropdownItems = (0, $cozmU.useMemo)(()=>{
        const allRefineSuggestions = (0, $c2c6d211a4290fa3$export$2527a005bbcba079)({
            configItemWithOptions: editorPluginAIProvider.configItemWithOptions
        }).filter((suggestion)=>suggestion.showInRefineDropdown);
        const result = [];
        const parentForNesting = {};
        const handleClickAnalytics = ({ newConfigItem: newConfigItem })=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'refinementOption',
                    attributes: {
                        experienceType: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                        refinementType: (0, $l2lIz.convertExperienceName)(newConfigItem.key.toString())
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                }
            });
        };
        const handleClick = (configItem)=>()=>{
                handleClickAnalytics({
                    newConfigItem: configItem
                });
                let latestPromptResponse = markdown;
                if (configItem.adfPrompt) {
                    if (adfResponse) latestPromptResponse = JSON.stringify(adfResponse);
                    else {
                        const { pmFragment: pmFragment } = (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
                            markdown: markdown,
                            schema: schema,
                            source: 'markdown-to-adf-conversion-for-refinement',
                            fireAIAnalyticsEvent: (event)=>{
                                if (!errorReported.current) {
                                    errorReported.current = true;
                                    fireAIAnalyticsEvent(event);
                                }
                            },
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            idMap: idMap
                        });
                        const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
                        if (prosemirrorDocument) {
                            const serializer = new (0, $2lPWP.JSONTransformer)(schema);
                            latestPromptResponse = JSON.stringify(serializer.encode(prosemirrorDocument, {
                                keepNestedTables: true
                            }));
                        }
                    }
                }
                sendToAIExperienceMachine({
                    type: 'refine',
                    configItem: configItem,
                    latestPromptResponse: // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    latestPromptResponse
                });
            };
        for (const suggestion of allRefineSuggestions){
            const { nestingConfig: nestingConfig } = suggestion;
            if (!nestingConfig) result.push({
                title: suggestion.title,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, suggestion.icon?.({
                    formatMessage: formatMessage
                })),
                onClick: handleClick(suggestion)
            });
            else {
                const parentKey = nestingConfig.parentTitle.id ?? JSON.stringify(nestingConfig.parentTitle);
                if (!parentForNesting[parentKey]) {
                    const icon = nestingConfig.icon || suggestion.icon;
                    const parent = {
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, " ", icon?.({
                            formatMessage: formatMessage
                        }), " "),
                        title: nestingConfig.parentTitle,
                        children: []
                    };
                    result.push(parent);
                    parentForNesting[parentKey] = parent;
                }
                parentForNesting[parentKey].children?.push({
                    title: suggestion.nestingConfig?.shortTitle ?? suggestion.title,
                    onClick: handleClick(suggestion)
                });
            }
        }
        return result;
    }, [
        adfResponse,
        idMap,
        schema,
        configItem.key,
        editorPluginAIProvider.configItemWithOptions,
        fireAIAnalyticsEvent,
        formatMessage,
        markdown,
        sendToAIExperienceMachine
    ]);
    const refinementButtonClick = (0, $cozmU.useCallback)(()=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'refinementButton',
                attributes: {
                    experienceType: (0, $l2lIz.convertExperienceName)(configItem.key.toString())
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
    }, [
        configItem.key,
        fireAIAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b507768313d7680$export$9f3706359963c421), {
        key: configItem.key,
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        latestPrompt: localizedLatestPrompt,
        preview: preview,
        disableActions: !!responseTooSimilar,
        inputValue: userInput,
        inputADFValue: userADFInput,
        isInputActive: isInputActive,
        onCancel: onCancelClick,
        onInputChange: onInputChange,
        onADFChange: onADFChange,
        onInputFocus: ()=>{
            sendToAIExperienceMachine({
                type: 'start refinement'
            });
        },
        onInputBlur: ()=>{
            if (!userInput) sendToAIExperienceMachine({
                type: 'cancel refinement'
            });
        },
        onSubmit: ()=>{
            /**
     * Do we really need to pass userInput and userADFInput
     *  on firing interrogate event.
     * We should have latest userInput and userADFInput
     *  set by onInputChange and onADFChange.
     */ sendToAIExperienceMachine({
                type: 'interrogate',
                userInput: userInput,
                userADFInput: userADFInput,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                latestPromptResponse: markdown
            });
        },
        onCopy: ()=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'copyButton',
                    attributes: {
                        experienceType: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                        editCount: editCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                }
            }); // Fire ACTION.ACTIONED event for copy action
            fireAIAnalyticsEvent({
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).ACTIONED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: {
                        ...analyticsFlow.getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        aiResultAction: 'copied'
                    },
                    invokedFrom: lastTriggeredFrom
                })
            });
            analyticsFlow.addAttributes({
                contentCopied: true
            });
            (0, $29bb73df2123f69e$export$a707cf6ca97554ae)({
                editorView: editorView,
                pmFragment: pmFragment
            });
        },
        onRetry: !configItem.agent ? onRetryPromptClick : undefined,
        onGoodResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'good',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            }; // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onBadResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'bad',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            }; // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onEditPromptClick: onEditPromptClick,
        onBack: onBack,
        applications: applications,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        clearInputRef: clearInputRef,
        disclaimer: disclaimer,
        providerFactory: providerFactory,
        schema: schema,
        disableInterrogation: disableInterrogation,
        agent: configItem.agent,
        onRefinementClick: refinementButtonClick,
        refineDropdownItems: refineDropdownItems,
        canInlineStreamChanges: canInlineStreamChanges()
    });
}






















/*
 * !!! Please see for more details:
 * https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3732210222/Dev+Documentation+Editor+AI+Command+Palette#Current-Implementation
 *
 * This file contains the state machine that models the command palette.
 *
 *
 * If you modify this machine in any way, please look at the visual editor
 * and make sure that it is clear and readable.
 *
 * Include a screenshot of the visual editor in your pull request.
 *
 * If you add a new state to the machine -- you will need to update the
 * CommandPaletteState union type.
 *
 * If you add a new transition to the machine -- you will need to update the
 * CommandPaletteEvent union type.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-imports



const $f55ec69fa40c5766$export$43aa9d313c05e1e6 = ({ context: context })=>(0, $cgKJK.createMachine)({
        /** @xstate-layout N4IgpgJg5mDOIC5QGMD2BbdBDAdhABAA5YA2YALuWPrOVlftsgBYCWOYAxKjgCpgAPcgFEcVAE6QA2gAYAuolCFUsVuVY9FIAYgBsAdgCsAOgBMAZkMBOKzJm7zVgBymrAGhABPRAFoLx8ydzU10nK30XJyDDXQBfWI80TFwCYjJKalp6aiY2DmNicXVSIklYChowMmR1HnwU-CTsPHxUQlqcWHwSVloaOipjHFQiLCLWEsIyivLqqgIAMwBXEhJW9o1O7t7ybhwABTHikn3p8gBlKrAa6XktZVUOrR0EABYnXWMnV9eZV-0ZE4ZABGQKWDzeN6g4yGfTmYGhYH6XRWUxOQzxRIYZqpUgUBhZBi5dhgApHCZrKZwGZXGqbeotJoNNodLo9PqE0nDUbjSZnSpzSD4SQkbIEFmbNk7PaHXknM6XQUQWQKJAgB5qTbPRBo4FmMJWXTAmTmV7mULuLyIIKfQym+zA9HGwyuTEgJktNL4zIDHJYFgksly0rU8gC64dBkED3ijY8KUc31B44h8ph2YRoXciXx7a0GXk0inUMAJTA6FQADdbqqlCpNZo1S8gZ8WzJ9K9QnZ9PpgRC9DITOZkXaTfDDDFXm6Y6N0gTfYx-XlSYUU1S0+G6XUGjOc1t2emk6uKamaUr8Nm4-vpTxZcdi2myxXq8rgbX1fWnk3EMCkXr7LYjqvIY-xIuY-YILog4BCO5hjsCE66FOCTutiDRehk-TZIuAb5MefKhpukY7mhLR7gmh7ZMY7CaqQvT0JsnAqvcn5at+CC-k4MIuu2VhgcagIQQ4MgBHaxpGoODjAshWLJJ6eKYZyOHLsmJ7rmeEb0iRcmxqyeaUYMNHHPRHRMW+LGPGxoAvKYjrGHCZoAqYvZwc5+gQXBrzGIOnZRO2Pw9vEKHDBAcBaDOGHzthxIcBZDY4NqCA+D8MJmvYILvHx1ivBBthfH8KKvL+PwIaC06kbic4+tFS6BvhlL8hmW44FGjQVesekHlhVBxV+1mIOYxjASijhOoCvyGOiEFIlxnmhGatl2KYPzlTps7et1fq4SuhYNYRTXEYy7Xkfpm1DCM9WnumtLzPgyyrB1kr6b1VnaIgRUiaavzAfCpggmiOVWggIQmEC-wyKYrgITEHarTi62KQuMU7cG6nXXMWlHWtJ1dZy508mujU3UKIpio9uYHi9jb9Qg8JWMY0kdo6SK9iChi5YaxhGj2E62FYE0yaha2RdVRK1Xhu1XURmPRsdV4UWdl1o0RWYjDjOxUwl7GdqYMK2fz4Rjoa5jgUDk265YcH88aQRhMCcPoQpUVi9tqkERuB0y212Py6deNGRSJmvRqfVvQghh6sNVijRH432B5IL5eDwJooYJoOMh8RAA */ states: {
            'partial preset selection and command options list state': {
                states: {
                    'no partial preset selected full options list': {
                        description: `If no partial preset is selected and there is no text input:
- Show the full options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'no partial preset selected related options list': {
                        description: `If no partial preset is selected and the user has entered text:
- Show the related options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'partial preset selected no options list': {
                        on: {
                            onPartialPresetRemoved: [
                                {
                                    target: 'no partial preset selected related options list',
                                    guard: 'hasInputText',
                                    actions: 'partialPresetRemoved'
                                },
                                {
                                    target: 'no partial preset selected full options list',
                                    actions: 'partialPresetRemoved'
                                }
                            ]
                        },
                        description: `If a partial preset is already selected:
- Don't show the options list
- Show the selected preset`
                    },
                    initialisation: {
                        always: [
                            {
                                target: 'partial preset selected no options list',
                                guard: 'hasInitialPreset'
                            },
                            'no partial preset selected full options list'
                        ]
                    }
                },
                initial: 'initialisation'
            }
        },
        context: context,
        types: {
            events: {}
        },
        type: 'parallel',
        id: 'command palette state machine',
        on: {
            onTextEntered: {
                actions: 'updateTextInput'
            },
            onADFEntered: {
                actions: 'updateADFInput'
            },
            updateBaseGenerateAndConfigItem: {
                actions: 'updateBaseGenerateAndConfigItem'
            }
        }
    }, {
        guards: {
            /*
				 * There are test cases for this guard in the test suite.
				 * They ensure that the guard is working as expected as
				 * the simulation is not able to test this.
				 */ ['hasInputText']: ({ context: context })=>{
                // context.textInput can be undefined, an empty string, or a non-empty string
                // empty strings are considered to be false in this guard
                return !!context.textInput;
            },
            ['hasInitialPreset']: ({ context: context })=>{
                const hasInitialPreset = context.presetPromptLabel !== undefined;
                return hasInitialPreset;
            }
        },
        actions: {
            updateTextInput: (0, $cgKJK.assign)(({ event: event })=>{
                if ('onTextEntered' === event.type) {
                    if ('input' in event) return {
                        textInput: event.input
                    };
                    return {
                        textInput: ''
                    };
                }
                return {};
            }),
            updateADFInput: (0, $cgKJK.assign)(({ event: event })=>{
                if ('onADFEntered' === event.type) {
                    if ('adf' in event) return {
                        adfInput: event.adf
                    };
                    return {
                        adfInput: undefined
                    };
                }
                return {};
            }),
            partialPresetSelected: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'onPartialPresetSelected') return {
                    configItem: event.configItem,
                    presetPromptLabel: event.presetPromptLabel
                };
                return {};
            }),
            partialPresetRemoved: (0, $cgKJK.assign)(({ context: context, event: event })=>{
                if (event.type === 'onPartialPresetRemoved') return {
                    configItem: context.baseGenerate,
                    presetPromptLabel: undefined
                };
                return {
                    presetPromptLabel: undefined
                };
            }),
            removeInputText: (0, $cgKJK.assign)(()=>{
                return {
                    textInput: '',
                    adfInput: undefined
                };
            }),
            updateBaseGenerateAndConfigItem: (0, $cgKJK.assign)(({ event: event })=>{
                if (event.type === 'updateBaseGenerateAndConfigItem') return {
                    configItem: event.configItem,
                    baseGenerate: event.baseGenerate
                };
                return {};
            })
        }
    });


function $d1ad659707a9aa19$export$6d6b44d5fef51d81({ startingConfig: startingConfig, startingPresetPromptLabel: startingPresetPromptLabel, baseGenerate: baseGenerate, startingUserInput: startingUserInput, startingUserADFInput: startingUserADFInput }) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $f55ec69fa40c5766$export$43aa9d313c05e1e6)({
        context: {
            textInput: startingUserInput,
            adfInput: startingUserADFInput,
            configItem: startingConfig,
            presetPromptLabel: startingPresetPromptLabel,
            baseGenerate: baseGenerate
        }
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const [state, send] = (0, $banCF.useMachine)(machineRef.current);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (baseGenerate) send({
            type: 'updateBaseGenerateAndConfigItem',
            baseGenerate: baseGenerate,
            configItem: startingConfig
        });
    }, [
        baseGenerate,
        startingConfig,
        send
    ]);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        // Out of the box -- the type of the event received by the xstate send
        // will allow any "payload".
        // ie. `send("correct event type", {incorrect: "event payload"})`
        //
        // To avoid related issues -- we've limited the type to only allow
        // sending the full event.
        // ie. `send({type: "correct event type", correct: "event payload"})`
        send: send
    };
}






const $d454423c63fdffbe$var$usePromptLogic = (ctx, ai, userADFInputOverride)=>{
    const { context: { textInput: textInput, adfInput: adfInput }, send: send } = (0, $d1ad659707a9aa19$export$6d6b44d5fef51d81)({
        baseGenerate: ctx.baseGenerate,
        startingUserInput: ctx.userInput,
        startingUserADFInput: userADFInputOverride ?? ctx.userADFInput,
        startingConfig: ctx.configItem
    });
    const adfRef = (0, $cozmU.useRef)(undefined);
    const textInputRef = (0, $cozmU.useRef)(undefined);
    const onTextChange = (0, $cozmU.useCallback)((input)=>{
        send({
            type: 'onTextEntered',
            input: input
        });
        textInputRef.current = input;
    }, [
        send
    ]);
    const onADFChange = (0, $cozmU.useCallback)((adf)=>{
        send({
            type: 'onADFEntered',
            adf: adf
        });
        adfRef.current = adf;
    }, [
        send
    ]);
    const submit = (0, $cozmU.useCallback)(()=>{
        const adfInput = adfRef.current;
        const textInput = textInputRef.current;
        if (!textInput?.trim()) return;
        ai.sendToAIExperienceMachine({
            type: 'kickoff with command palette input',
            context: {
                configItem: ctx.configItem,
                userInput: textInput,
                userADFInput: adfInput
            }
        });
    }, [
        ctx.configItem,
        ai
    ]);
    const cancel = (0, $cozmU.useCallback)((options)=>{
        ai.endExperience({
            shouldClearSelectionContext: options?.shouldClearSelectionContext
        });
    }, [
        ai
    ]);
    const discard = (0, $cozmU.useCallback)(()=>{
        ai.sendToAIExperienceMachine({
            type: 'update context',
            context: {
                configItem: ctx.configItem,
                userInput: textInput || '',
                userADFInput: adfInput
            }
        });
        ai.sendToAIExperienceMachine({
            type: 'enable discard'
        });
    }, [
        adfInput,
        ai,
        ctx.configItem,
        textInput
    ]);
    return {
        textInput: textInput,
        adfInput: adfInput,
        onTextChange: onTextChange,
        onADFChange: onADFChange,
        submit: submit,
        cancel: cancel,
        discard: discard
    };
};
const $d454423c63fdffbe$var$usePromptAnalytics = (ctx)=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: 'prompt',
        callerComponent: 'PromptScreenWithLogic',
        attributes: {
            experienceName: ctx.configItem.key,
            featureId: ctx.configItem.featureId,
            promptTitle: ctx.configItem.promptLabel ? intl.formatMessage(ctx.configItem.promptLabel) : undefined,
            promptType: 'generate',
            usingCommandPalette: true,
            retryPromptCount: ctx.retryPromptCount,
            editCount: ctx.editCount
        }
    });
};
const $d454423c63fdffbe$export$771b2fc999b0757c = ({ context: context, userADFInput: userADFInputProp })=>{
    const ai = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { textInput: textInput, adfInput: adfInput, onTextChange: onTextChange, onADFChange: onADFChange, submit: submit, cancel: cancel } = $d454423c63fdffbe$var$usePromptLogic(context, ai, userADFInputProp);
    $d454423c63fdffbe$var$usePromptAnalytics(context);
    (0, $d566c2a1407b9634$export$aa79b0abe3dfeaba)({
        modalRef: ai.modalRef,
        onCancel: ()=>{
            // We let the RovoPromptScreenWithLogic handle aborts
            if (!ai.editorPluginAIProvider.onSubmit) cancel();
        },
        onDiscard: ()=>{}
    });
    // Callbacks for the openInRovoChat flow (SmartLink Rovo button). These must be
    // defined at the top level (before any early return) to satisfy React hooks rules.
    const rovoChatAIFeatureContext = context.configItem.rovoChatAIFeatureContext;
    const rovoChatInteractionSource = context.configItem.rovoChatInteractionSource;
    const { editorView: editorView } = ai;
    const editorProduct = ai.editorPluginAIProvider.product;
    const publishChatNew = (0, $cozmU.useCallback)((prompt)=>{
        const publish = (0, $4xV3u.rovoAgentsPluginKey).getState(editorView.state)?.publish;
        if (publish) {
            const payload = {
                type: 'chat-new',
                product: editorProduct,
                data: {
                    dialogues: [],
                    prompt: prompt,
                    ...rovoChatAIFeatureContext ? {
                        aiFeatureContext: rovoChatAIFeatureContext
                    } : {}
                },
                source: 'editor',
                ...rovoChatInteractionSource ? {
                    interactionSource: rovoChatInteractionSource
                } : {}
            };
            publish(payload);
        }
    }, [
        editorView,
        editorProduct,
        rovoChatAIFeatureContext,
        rovoChatInteractionSource
    ]);
    const onBeforeSubmitForRovoChat = (0, $cozmU.useCallback)((prompt)=>{
        publishChatNew(prompt);
        cancel();
        return true;
    }, [
        publishChatNew,
        cancel
    ]);
    const openInRovoChatConfig = (0, $cozmU.useMemo)(()=>({
            onBeforeSubmit: onBeforeSubmitForRovoChat
        }), [
        onBeforeSubmitForRovoChat
    ]);
    // When openInRovoChat is true, intercept the submit to open the Rovo chat
    // sidebar instead of performing an AI edit. The SmartLink Rovo button only
    // appears in Rovo-enabled products (onSubmit is always set).
    if (context.configItem.openInRovoChat) {
        if (ai.editorPluginAIProvider.onSubmit) {
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e99c702c191ae5e3$export$d0c09a27ab507630), {
                cancel: cancel,
                openInRovoChatConfig: openInRovoChatConfig
            });
        }
        return null;
    }
    if (ai.editorPluginAIProvider.onSubmit) {
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e99c702c191ae5e3$export$d0c09a27ab507630), {
            cancel: cancel
        });
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6593db5854c11409$export$eddbff457ab4038b), {
        textInput: textInput,
        adfInput: adfInput,
        onTextChange: onTextChange,
        onADFChange: onADFChange,
        submit: submit,
        cancel: cancel,
        PromptEditor: ai.editorPluginAIProvider.PromptEditor,
        appearance: ai.appearance,
        isAIFC: isInDocumentStreamingEnabled
    });
};


function $5028c8006c71f51b$export$501630857d1b4132(props) {
    const { api: api } = props;
    /**
   * Note -- because we are on an old version of xstate -- when adding new states
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineState` type in the
   * `get-experience-service.ts` file
   **/ const state = props.state;
    /**
   * Note -- because we are on an old version of xstate -- when adding new events
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineEvent` type in the
   * `get-experience-service.ts` file
   **/ const context = props.context;
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { mountDecorations: mountDecorations, updateStream: updateStream, discardStream: discardStream } = (0, $96ce9ac18a1b3910$export$bab543e64bfa5b68)({
        api: api,
        configItem: props.context.configItem,
        isProgrammaticScroll: aiExperienceCommonData.isProgrammaticScroll,
        positions: props.context.positions,
        view: props.context.editorView,
        modalRef: props.modalRef,
        aiSessionId: aiExperienceCommonData.aiSessionId
    });
    const autoAcceptAIChanges = aiExperienceCommonData.canInlineStreamChanges();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const send = aiExperienceCommonData.sendToAIExperienceMachine;
        if (send && state === 'started state') send({
            type: 'kick off'
        });
    }, [
        state,
        aiExperienceCommonData.sendToAIExperienceMachine
    ]);
    /**
   * Used to pass the backendModel to analytics and
   * feedback submission metadata
   */ const backendModel = context?.configItem?.getBackendModel?.(!!context?.latestPromptResponse);
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel,
            channelId: context.channelId,
            ...analyticsFlow.getUserFlowCommonAttributes(context.configItem),
            autoAcceptAIChanges: autoAcceptAIChanges,
            inlineStreamingAvailable: true
        });
    }, [
        analyticsFlow,
        backendModel,
        context.channelId,
        context.configItem,
        autoAcceptAIChanges
    ]);
    const aiLifeCycleDynamicAttributesGetter = context.aiLifeCycleDynamicAttributesGetter;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (aiLifeCycleDynamicAttributesGetter) analyticsFlow.registerAiLifeCycleDynamicAttributesGetter(aiLifeCycleDynamicAttributesGetter);
    }, [
        analyticsFlow,
        aiLifeCycleDynamicAttributesGetter
    ]);
    // Note -- the intention is to move the creation of the state machine higher
    // and for the ExperienceApplication (react component that appears in the modal)
    // to only be started once the machine is in the modal active state.
    if (state === 'started state') return null;
    const isModalActiveState = typeof state !== 'string' && state['modal active state'];
    if (!isModalActiveState) throw new Error('AI machine state is not: modal active state or modal error state');
    const experienceState = state['modal active state']['experience'];
    const isLastResponseTooSimilar = context.responseHistory.entries[context.responseHistory.entries.length - 1]?.responseTooSimilar;
    // We use the FG directly here rather then canInlineStreamChanges() because this new screen will be shown regardless if
    // the fallback modal is shown or not.
    if (isLastResponseTooSimilar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43b3e7c27d099e87$export$a283bcbda9880df6), {
        discardStream: discardStream,
        aiExperienceMachineContext: context
    });
    if (typeof experienceState !== 'string' && 'error state' in experienceState && experienceState['error state'] === 'active') {
        if (context.apiErrorInfo.failureReason === (0, $Mgq5A.FAILURE_REASON).NO_TEXTUAL_CONTENT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4632a2412dddbf8$export$124856cc35c13bde), {
            errorInfo: context.apiErrorInfo,
            contextStatistics: context.contextStatistics
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f996e0ad8404319$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f3a8a4eac7688e1$export$643e9e046f871343), {
        state: experienceState,
        channelId: context.channelId,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        history: context.responseHistory,
        latestPrompt: context.latestPrompt,
        onceDiscard: context.onceDiscard,
        streamFlowPacer: props.streamFlowPacer,
        discardStream: discardStream,
        api: api
    });
    if (typeof experienceState === 'string' && experienceState === 'command palette state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d454423c63fdffbe$export$771b2fc999b0757c), {
        context: context,
        userADFInput: props.userADFInput
    });
    if (typeof experienceState === 'object' && 'loading state' in experienceState) {
        const loadingState = experienceState['loading state'];
        if (loadingState === 'loading') {
            /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ const childShortTitle = context.parentPresetPromptLabel && context.configItem.nestingConfig ? formatMessage(context.configItem.nestingConfig.shortTitle) : '';
            const loadingMessage = (0, $2f49cf037b9198bf$export$e51701552d28cc4e)({
                status: context?.loadingStatus,
                formatMessage: formatMessage
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0de460a20d92c63$export$9c279fd5d5bced59), {
                mountDecorations: mountDecorations,
                updateStream: updateStream,
                parentPresetPromptLabel: context.parentPresetPromptLabel,
                childShortTitle: childShortTitle,
                title: loadingMessage ? loadingMessage : formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).loadingTitle),
                markdown: context.markdown,
                adfResponse: context.adfResponse,
                adfResponseNodeWrappers: context.adfResponseNodeWrappers,
                latestPrompt: context.latestPrompt,
                promptTrigger: context.promptTrigger,
                refinementCount: context.refinementCount,
                latestPromptRetried: context.latestPromptRetried,
                idMap: context.idMap,
                contextStatistics: context.contextStatistics,
                hideLoadingScreen: aiExperienceCommonData.hideLoadingScreen,
                api: api
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6efe87df395b9950$export$90b9d761c76d339a), {
                loadingStatus: context.loadingStatus
            }));
        }
    }
    if (typeof experienceState !== 'string' && 'review state' in experienceState) {
        if (updateStream) {
            let pmFragment;
            if (context.adfResponse) pmFragment = (0, $5f3534ff878ff5b8$export$d53ec95625564c92)({
                schema: context.editorView.state.schema,
                adfResponse: context.adfResponse,
                adfResponseNodeWrappers: context.adfResponseNodeWrappers
            });
            else pmFragment = (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
                markdown: context.markdown || '',
                schema: context.editorView.state.schema,
                source: 'preview',
                fireAIAnalyticsEvent: ()=>{},
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                idMap: context.idMap
            }).pmFragment;
            if (pmFragment) // TODO: EDITOR-1814 - this should be in useEffect
            updateStream?.({
                fragment: pmFragment,
                hasUserScrolled: aiExperienceCommonData.isUserScroll.current,
                isFinalStream: true
            });
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(context.editorView.state);
            const pmStats = new (0, $3cHXJ.ProseMirrorContentStatistics)(pmFragment);
            const contentStatistics = pmStats.collectStatistics();
            // when auto accept is on, end immediately
            // when auto accept is off
            // - if it's staging first-time streaming, withAcceptReject is false, end immediately
            if (autoAcceptAIChanges || !decorationPluginState?.withAcceptReject || context.configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE) {
                analyticsFlow.addAttributes({
                    modelIO: {
                        contextStatistics: context.contextStatistics,
                        previewMarkCounts: contentStatistics.markCounts,
                        previewNodeCounts: contentStatistics.nodeCounts,
                        previewTotalCharacterCounts: contentStatistics.totalCharacterCount
                    }
                });
                (0, $d211ad36412ee080$export$53eb05c40692d65e)(context.configItem, context.markdown || '', context.editorView, aiExperienceCommonData.lastTriggeredFrom ?? '');
                context.endExperience();
                return null;
            } else // if there is nextSessionId, it means there is an ai session running
            // - we don't show the accept reject screen
            // if there is no nextSessionId, it means the ai session ended or there is no ai session at all (such as IW)
            // - then we can show the accept reject screen
            return decorationPluginState?.nextSessionId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cebc0ff804a659b$export$95a358671d66b6a5), {
                aiExperienceMachineContext: context,
                backendModel: backendModel,
                discardStream: discardStream
            });
        } else {
            const action = context.rovoActions ? context.rovoActions[context.selectionType] : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $886bb49e2e7a4b11$export$705df12804ca7004), {
                aiExperienceMachineContext: context,
                isInputActive: experienceState['review state'] === 'refinement',
                backendModel: backendModel,
                rovoAction: action,
                rovoPublish: publish
            });
        }
    }
    throw new Error('unhandled state');
}
function $5028c8006c71f51b$var$canReplaceBaseGenerate(aiProvider) {
    return aiProvider.isRovoEnabled && aiProvider.useFreeGenerateEditorAgent;
}
function $5028c8006c71f51b$var$useScrollDetection({ modalRef: modalRef }) {
    const isUserScroll = (0, $cozmU.useRef)(false);
    /**
   * isProgrammaticScroll is set to true initially
   * to detect any initial changes on render which affect
   * scroll position. There will be multiple scroll events
   * within a single user scroll so it will be set to false
   * accordingly within a single scroll action.
   */ const isProgrammaticScroll = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        const modalEl = modalRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        isUserScroll.current = false;
        const unbind = (0, $cbY7C.bind)(scrollParentEl, {
            type: 'scroll',
            listener: ()=>{
                if (!isProgrammaticScroll.current) {
                    isUserScroll.current = true;
                    unbind();
                }
                isProgrammaticScroll.current = false;
            }
        });
        return ()=>{
            unbind();
        };
    }, [
        modalRef
    ]);
    return {
        isUserScroll: isUserScroll,
        isProgrammaticScroll: isProgrammaticScroll
    };
}
function $5028c8006c71f51b$var$focusEditor(editorView, { focusEditorContentArea: focusEditorContentArea } = {
    focusEditorContentArea: false
}) {
    if (!editorView.hasFocus()) editorView.focus();
    // when we disable editor while streaming, document.body will be focused
    // we need to focus editor to make pressing esc to work
    const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
    if (editorContentArea && !editorContentArea.contains(document.activeElement) && focusEditorContentArea) editorContentArea.focus();
}
function $5028c8006c71f51b$var$focusEditorContentArea(editorView) {
    // if it's already focused, do nothing
    const editorContentArea = editorView?.dom.closest('.ak-editor-content-area');
    if (editorContentArea?.contains(document.activeElement)) return;
    editorView.focus();
    // if the editor is currently disabled, the above focus call may fail (browser dependent)
    if (editorView.hasFocus()) return;
    if (editorContentArea && !editorContentArea?.contains(document.activeElement)) editorContentArea?.focus();
}
// document.body will be focused when we switch from one screen to another
// (can be triggered by clicking button or pressing Esc key)
// which will make pressing Esc not working because we're listening Esc on editor
// so we should focus editor when it's not focused
function $5028c8006c71f51b$var$useFocusEditor({ modalRef: modalRef, editorView: editorView, state: state, cancelRovoPrompt: cancelRovoPrompt }) {
    // state is not stable, but we want to run the effect when we switch screen, so use str as the dependency
    const stateStr = JSON.stringify(state);
    (0, $cozmU.useEffect)(()=>{
        if (!modalRef.current) return;
        const modalHasFocus = modalRef.current.contains(document.activeElement);
        if (!modalHasFocus && stateStr.indexOf('modal active state') !== -1) $5028c8006c71f51b$var$focusEditorContentArea(editorView);
    }, [
        modalRef,
        editorView,
        stateStr
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (cancelRovoPrompt) $5028c8006c71f51b$var$focusEditorContentArea(editorView);
    }, [
        cancelRovoPrompt,
        editorView
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state);
            // InlineEditReadyBar is an out-of-editor affordance; refocusing the editor
            // during teardown can scroll the edited node back into view.
            if (decorationPluginState?.isInlineEditReady && (0, $4o0zT.isExperimentEnabled)('cc_maui_polish_changes_batch_6')) return;
            editorView.focus();
        }, [
        editorView
    ]);
}
function $5028c8006c71f51b$var$ExperienceApplicationStateWrapper(props) {
    const { api: api, editorView: editorView, endExperience: endExperience } = props;
    const intl = (0, $kSwu1.useIntl)();
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { cancelRovoPrompt: cancelRovoPrompt } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const positions = props.positions;
    const isEmpty = positions[0] === positions[1];
    const selectionType = isEmpty ? 'empty' : 'range';
    /**
   * baseGenerate configItem is used as default configItem in command palette.
   * Currently for every product, "freeGenarete" is used as baseGenerate.
   * Recently, "useFreeGenerateEditorAgent" is introduced to allow
   * 	freeGenerateEditorAgent configItem to be used as baseGenerate.
   *  freeGenerateEditorAgent is like freeGeneerate, but it uses
   * 	rovo agent instead of standard AI prompt.
   *
   * Can't set "freeGenerateEditorAgent" directly as baseGenerate in prebuilt config,
   * 	because creating configItem requires agent to be passed in.
   * But agents are not available at compile time or event when plugin is loaded.
   * So we need to swap baseGenerate here.
   */ let configItem = props.configItem;
    let baseGenerate = props.editorPluginAIProvider.baseGenerate;
    if (props.defaultAgent && $5028c8006c71f51b$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
        baseGenerate = (0, $f32dd05596568c69$export$dc3b52bb600cbaa7)({
            agent: props.defaultAgent,
            product: props.editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (props.configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE) configItem = baseGenerate;
    }
    const { isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll } = $5028c8006c71f51b$var$useScrollDetection({
        modalRef: modalRef
    });
    const streamFlowPacerRef = (0, $db676d2be4cae1a7$export$ace1671de29eb5ea)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const streamingHandler = (0, $a1b48c6cfd5555d3$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        aiInteractionID: analyticsFlow.getLastAiInteractionId(),
        streamFlowPacer: streamFlowPacerRef.current
    });
    const { send: send, state: state, context: context } = props;
    // Send this synchronously
    (0, $cozmU.useLayoutEffect)(()=>{
        send({
            type: 'initialise context',
            context: {
                analyticsContext: props.analyticsContext,
                aiProvider: props.editorPluginAIProvider,
                intl: intl,
                editorView: props.editorView,
                positions: positions,
                isEmpty: isEmpty,
                selectionType: selectionType,
                baseGenerate: baseGenerate,
                configItem: configItem,
                aiLifeCycleDynamicAttributesGetter: props.editorPluginAIProvider?.aiLifeCycleDynamicAttributesGetter,
                markdown: '',
                latestPromptResponse: undefined,
                editCount: 0,
                refinementCount: 0,
                retryPromptCount: 0,
                latestPromptRetried: false,
                userInput: '',
                apiErrorInfo: {},
                responseHistory: {
                    positionFromEnd: 0,
                    entries: [],
                    totalSize: 0,
                    traversals: 0
                },
                channelId: undefined,
                getMentionNameDetails: props.getMentionNameDetails,
                triggeredFor: props.triggeredFor,
                usePageKnowledge: true,
                endExperience: props.endExperience,
                streamingHandler: streamingHandler
            }
        });
        return ()=>{
            send({
                type: 'reset'
            });
        };
    // This must ONLY run on mount/unmount to replicate the `useRef` behaviour of setting up the
    // machine once. If this re-runs it will reset our current state machine
    // Long term we should refactor this the react lifecycle isn't tied to xstate
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (props.defaultAgent && $5028c8006c71f51b$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
            const newBaseGenerate = (0, $f32dd05596568c69$export$dc3b52bb600cbaa7)({
                agent: props.defaultAgent,
                product: props.editorPluginAIProvider.product,
                isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
            });
            send({
                type: 'update baseGenerate and configItem',
                baseGenerate: newBaseGenerate,
                configItem: newBaseGenerate
            });
        }
    }, [
        props.defaultAgent,
        props.editorPluginAIProvider,
        send
    ]);
    const [start, end] = props.positions;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Note -- the intention is to have the state machine created at a higher
        // level, and have the positions updated without being passed into this react
        // component.
        send({
            type: 'update positions',
            positions: [
                start,
                end
            ]
        });
    // Separate start/end as React will recognise tuples recreated
    // as a change, even if the values don't change
    }, [
        send,
        start,
        end
    ]);
    $5028c8006c71f51b$var$useFocusEditor({
        modalRef: modalRef,
        editorView: editorView,
        state: state,
        cancelRovoPrompt: cancelRovoPrompt
    });
    const { lastTriggeredFrom: lastTriggeredFrom } = props;
    // By default when the experience is mounted we allow for an early escape attempt via space or other keys. If any other
    // key is pressed, we disable this early escape behaviour to allow for normal editor usage.
    const canEarlyEscape = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ function handleEscapeKeyDown(event) {
            /**
       * These are the keys that can be used to trigger lists when typing
       * in the Editor using markdown syntax.
       * • uses Opt+8 in Mac
       */ const MARKDOWN_LIST_KEYS = [
                '-',
                '*',
                "\u2022"
            ];
            const MODIFIER_KEYS = [
                'Shift',
                'Alt'
            ];
            // If any key other than the chosen keys are pressed, we cannot early escape so we will disable that behaviour
            if (canEarlyEscape.current && event.key !== ' ' && !MARKDOWN_LIST_KEYS.includes(event.key) && !MODIFIER_KEYS.includes(event.key)) canEarlyEscape.current = false;
            if (!(event.key === 'Escape' || canEarlyEscape.current && lastTriggeredFrom === 'spaceShortcut' && (event.key === ' ' || MARKDOWN_LIST_KEYS.includes(event.key)))) return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            event.preventDefault();
            event.stopPropagation();
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            // in command palette screen, AI modal renders RovoInlineChatPrompt component
            // and cancelRovoPrompt is from it
            if (experience === 'command palette state') {
                if (cancelRovoPrompt) cancelRovoPrompt();
                else endExperience({
                    shouldIgnoreNextSpaceTrigger: event.key === ' ' && lastTriggeredFrom === 'spaceShortcut' || event.key === 'Escape' && lastTriggeredFrom === 'spaceShortcut'
                });
                if (MARKDOWN_LIST_KEYS.includes(event.key)) {
                    editorView.dispatch(editorView.state.tr.insertText(` ${event.key}`));
                    return;
                }
                if (event.key === ' ' && lastTriggeredFrom === 'spaceShortcut') {
                    editorView.dispatch(editorView.state.tr.insertText(' '));
                    return;
                }
                return;
            }
            const isLoading = 'loading state' in experience && experience['loading state'] === 'loading';
            const isPreview = 'review state' in experience && experience['review state'] === 'preview';
            // pressing ESC in loading or accept/reject screen should show the discard screen
            if (isLoading || isPreview) {
                // don't use `send({ type: 'escape' })` here because it will transition to `command palette state`
                if (modalActiveState?.discard === 'active') send({
                    type: 'disable discard'
                });
                else send({
                    type: 'enable discard'
                });
            }
        }
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ function handleEscapeKeyUp(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            event.preventDefault();
            event.stopPropagation();
        }
        function handleClickOutside(event) {
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            // If nextSessionId exists, let the SessionUIComponent manage the escape behaviour
            if (api?.aiExperience.sharedState.currentState()?.aiDecorationExperiencePluginState.nextSessionId) return;
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            const isPreview = typeof experience === 'object' && 'review state' in experience && experience['review state'] === 'preview';
            // click outside of the accept/reject screen should show the discard screen
            if (isPreview && modalRef.current && event.target && !modalRef.current.contains(event.target) && modalActiveState?.discard === 'inactive') send({
                type: 'enable discard'
            });
        }
        // initially, editor is focused
        // when AI modal is loading and user presses ESC
        // we will show the AI modal discard screen
        // which will make AI modal to be auto focused
        // now if user presses ESC again,
        // we will return to the AI modal loading screen
        // so whenever user presses ESC, either the AI modal or the editor is focused
        // so the listener should be attached to the common ancestor of the AI Modal and the editor
        const node = editorView.dom.closest('.ak-editor-content-area');
        if (!node) return;
        return (0, $cbY7C.bindAll)(node, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            },
            {
                type: 'click',
                listener: handleClickOutside
            }
        ]);
    }, [
        modalRef,
        state,
        send,
        context.promptTrigger,
        context.responseHistory,
        endExperience,
        editorView,
        cancelRovoPrompt,
        api,
        lastTriggeredFrom
    ]);
    const [isMounted, setIsMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        (0, $cozmU.startTransition)(()=>{
            setIsMounted(true);
        });
    }, [
        modalRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        if (isMounted) modalRef.current?.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
    }, [
        isMounted,
        modalRef
    ]);
    const aiExperienceCommonData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            appearance: props.appearance,
            // configItem can be changed within state machine, so always get it from machine context.
            configItem: context.configItem,
            editorPluginAIProvider: props.editorPluginAIProvider,
            endExperience: props.endExperience,
            lastTriggeredFrom: props.lastTriggeredFrom,
            providerFactory: props.providerFactory,
            editorView: props.editorView,
            positions: props.positions,
            triggerMethod: props.triggerMethod,
            triggeredFor: props.triggeredFor,
            sendToAIExperienceMachine: send,
            modalRef: modalRef,
            isUserScroll: isUserScroll,
            isProgrammaticScroll: isProgrammaticScroll,
            engagementPlatformApi: props.engagementPlatformApi,
            includeKnowledgeFromCurrentPage: context.usePageKnowledge,
            canInlineStreamChanges: props.canInlineStreamChanges,
            hideLoadingScreen: props.hideLoadingScreen,
            aiSessionId: props.interactionSessionId
        }), [
        context.configItem,
        context.usePageKnowledge,
        props.editorView,
        props.editorPluginAIProvider,
        props.appearance,
        props.endExperience,
        props.lastTriggeredFrom,
        props.providerFactory,
        props.positions,
        props.triggerMethod,
        props.triggeredFor,
        props.engagementPlatformApi,
        props.canInlineStreamChanges,
        send,
        modalRef,
        isUserScroll,
        isProgrammaticScroll,
        props.hideLoadingScreen,
        props.interactionSessionId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const traceIds = props.traceId ? [
            props.traceId
        ] : context.traceIds;
        const promptVersion = (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? props.promptVersion : undefined;
        if (traceIds) analyticsFlow.updateCommonAttributes({
            traceIds: traceIds,
            promptVersion: promptVersion
        });
    }, [
        analyticsFlow,
        props.traceId,
        context.traceIds,
        props.promptVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // We set these to ensure that when focus initially moves to
        // an element within the modal, that context about the modal
        // (e.g. "Atlassian Intelligence Dialog") is announced too
        role: "dialog",
        // ED-19787
        // We would like to use aria-labelledBy so we can label this
        // dynamically for each screen, however it's not working as expected
        // in Chrome and Firefox (works in Safari). For now we'll use the dialog
        // role and make the first element of each screen a screen-reader accessible
        // heading for the experience.
        "aria-label": intl.formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).dialogAriaLabel),
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d8cf0904a436811$export$cad72db1c520741c).Provider, {
        value: aiExperienceCommonData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5028c8006c71f51b$export$501630857d1b4132, {
        api: api,
        state: state,
        context: context,
        initialPrompt: props.initialPrompt,
        userADFInput: props.userADFInput,
        modalRef: modalRef,
        streamFlowPacer: streamFlowPacerRef.current
    })));
}
function $5028c8006c71f51b$export$8b0e36b4d2610ae7(props) {
    const { api: api, editorView: editorView, canInlineStreamChanges: canInlineStreamChanges } = props;
    const monitorWatchmenCommands = (0, $cozmU.useMemo)(()=>(0, $aa5000cb5a2af7b9$export$4783d4d69ea114f3)(editorView), [
        editorView
    ]);
    const analyticsFlow = (0, $02d337cdf5827f29$export$b26e0d212ef01829)({
        invokeAttributes: {
            invokedFrom: props.lastTriggeredFrom,
            invokedFor: props.triggeredFor ? props.triggeredFor.name : 'text',
            triggerMethod: props.triggerMethod,
            experienceName: props.configItem.key,
            featureId: props.configItem.featureId,
            aiGroupId: props.aiGroupId,
            aiSessionId: props.interactionSessionId,
            willAISuggestEmoji: props.willAISuggestEmoji
        },
        canInlineStreamChanges: props.canInlineStreamChanges,
        isInDocumentStreamingEnabled: true,
        onCommonAttributesUpdated: monitorWatchmenCommands?.syncCommonAttributes
    });
    // initialPositions is updated many times during in-doc streaming,
    // but we only want to update the common analytics attributes once,
    // so we check if they've already been updated
    const commonAnalyticsAttributesUpdatedRef = (0, $cozmU.useRef)(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (commonAnalyticsAttributesUpdatedRef.current) return;
        commonAnalyticsAttributesUpdatedRef.current = true;
        const isInvokedFromEmptyPage = (0, $iLrhi.isEmptyDocument)(props.editorView.state.doc);
        analyticsFlow.updateCommonAttributes({
            isInvokedFromEmptyPage: isInvokedFromEmptyPage,
            /**
       * Confidence score will be used passed in analytics events.
       * It is currently only set when "Improve writing" is triggered from the
       * 	"Improve writing" nudge.
       */ nudgeMetrics: props.nudgeMetrics
        });
        if (props.initialPositions) {
            const selectionCategory = (0, $3117ebeab67c20f0$export$385434a4b24ab280)(props.editorView, props.initialPositions);
            const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.rangeCharWordCount)(props.editorView.state.doc, props.initialPositions[0], props.initialPositions[1]);
            analyticsFlow.updateCommonAttributes({
                selectionCharCount: charCount,
                selectionWordCount: wordCount
            });
            analyticsFlow.updateCommonAttributes({
                isInvokedFromEmptyPage: isInvokedFromEmptyPage,
                selectionCategory: selectionCategory
            });
            const selectionNodes = (0, $3117ebeab67c20f0$export$208ac2488b55bf9d)(props.editorView.state, props.initialPositions);
            analyticsFlow.updateCommonAttributes({
                selectionNodes: selectionNodes
            });
        }
    }, [
        analyticsFlow,
        props.editorView,
        props.initialPositions,
        props.nudgeMetrics
    ]);
    // finish analytics flow and fire remaining steps on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            // have to postpone until animation frame to make sure we end analytics flow after child components unmount
            // which is where we enqueue last events
            window.requestAnimationFrame(()=>{
                // Only flush when a step is queued: on the XState path the plugin may have already
                // drained the terminal step, so an unconditional flush would fire an empty queue
                // (spurious `noEventExistsToBeFired`). `callerComponent` keeps any residual attributable.
                if (analyticsFlow.hasQueuedStep()) analyticsFlow.fireQueuedStep(undefined, 'ExperienceApplicationUnmount');
            });
        };
    }, [
        analyticsFlow
    ]);
    // This makes sure that the selection preview is hidden when the experience is unmounted
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            const tr = props.editorView.state.tr;
            tr.setMeta('hideSelectionPreview', true);
            props.editorView.dispatch(tr);
        };
    }, [
        props.editorView
    ]);
    // focus editor when the AI modal is unmounted
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $5028c8006c71f51b$var$focusEditor(editorView);
            // when we set the selection with AI modal open,
            // prosemirror won't update the selection because editor is not focused
            // and when the selection is empty in a paragraph,
            // the cursor may be (randomly) placed somewhere else within the paragraph when we focus the editor
            // so we need to re-set the selection after we focus the editor to make prosemirror update the selection correctly
            // and we have to set the selection to somewhere else first
            // because prosemirror will skip the selection update if the selection doesn't change
            // https://hello.jira.atlassian.cloud/browse/EDITOR-1269
            if (editorView.state.selection instanceof (0, $kCECX.TextSelection) && editorView.state.selection.empty && editorView.state.selection.$to.parent.isTextblock && editorView.state.selection.$to.parent.childCount > 0) {
                const to = editorView.state.selection.to;
                let tr = editorView.state.tr;
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, 0));
                tr.setMeta('addToHistory', false).setMeta('scrollIntoView', false);
                editorView.dispatch(tr);
                tr = editorView.state.tr;
                tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to));
                tr.setMeta('addToHistory', false).setMeta('scrollIntoView', false);
                editorView.dispatch(tr);
            }
        };
    }, [
        editorView
    ]);
    // turn diff off when unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const autoAcceptAIChanges = canInlineStreamChanges();
            if (!autoAcceptAIChanges && api?.trackChanges?.sharedState.currentState()?.isDisplayingChanges) api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        };
    }, [
        api,
        canInlineStreamChanges
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $405400f22f07581a$export$61f6bd9fac8ed53), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCloseFallback: ()=>{
            props.endExperience();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02d337cdf5827f29$export$b8f39b5859612546), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "EditorAICommandPalette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5028c8006c71f51b$var$ExperienceApplicationStateWrapper, {
        ...props,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        analyticsContext: {
            aiSessionId: analyticsFlow.aiSessionId,
            aiGroupId: props.aiGroupId ?? analyticsFlow.aiSessionId
        }
    }))));
}








const $96172548d1818417$export$2dda1e4a1d1f6a81 = ()=>{
    const { aiOptIn: aiOptIn, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, api: api, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, getMentionNameDetails: getMentionNameDetails, canInlineStreamChanges: canInlineStreamChanges, isRovoLoading: isRovoLoading } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { aiDecorationExperiencePluginState: aiDecorationExperiencePluginState, rovoAgentsPluginState: rovoAgentsPluginState, editorViewModeMode: editorViewModeMode, isInlineEditReady: isInlineEditReady, inlineEditReadyTargetId: inlineEditReadyTargetId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience',
        'editorViewMode'
    ], (states)=>({
            aiDecorationExperiencePluginState: states.aiExperienceState?.aiDecorationExperiencePluginState,
            rovoAgentsPluginState: states.aiExperienceState?.rovoAgentsPluginState,
            editorViewModeMode: states.editorViewModeState?.mode,
            isInlineEditReady: states.aiExperienceState?.aiDecorationExperiencePluginState?.isInlineEditReady,
            inlineEditReadyTargetId: states.aiExperienceState?.aiDecorationExperiencePluginState?.inlineEditReadyTargetId
        }));
    const { isRunning: isRunning } = aiDecorationExperiencePluginState || {};
    const isDecorationSetEmpty = !aiDecorationExperiencePluginState || aiDecorationExperiencePluginState.modalDecorationSet === (0, $8nvEM.DecorationSet).empty;
    const isViewMode = editorViewModeMode === 'view';
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state);
    const intl = (0, $kSwu1.useIntl)();
    const endExperience = (0, $cozmU.useCallback)((options)=>{
        // after AI start, there is a chance that the plugin state is not updated yet
        // so we need to check if the plugin state is running before ending the experience
        if (!isRunning) return;
        if (editorPluginAIProvider.onAIProviderChanged) editorPluginAIProvider.onAIProviderChanged('command-palette');
        const state = (0, $C4yPo.getPluginState)(editorView.state);
        const decoSet = (0, $dSwlt.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $4TgUg.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext, options?.shouldIgnoreNextSpaceTrigger);
        endAIExperienceCommand(editorView.state, editorView.dispatch);
    }, [
        editorView,
        isRunning,
        editorPluginAIProvider
    ]);
    (0, $cozmU.useEffect)(()=>{
        /**
     * When isDecorationSetEmpty changes from false to true,
     * we need to end the experience as that ensures all the different AI plugins
     * are ended.
     */ if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        isDecorationSetEmpty) endExperience();
    }, [
        isDecorationSetEmpty,
        endExperience
    ]);
    const { send: send, state: state, context: context } = (0, $18fb1940e348cb4f$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: {
                aiSessionId: '',
                aiGroupId: ''
            },
            aiProvider: editorPluginAIProvider,
            intl: intl,
            editorView: editorView,
            positions: [
                0,
                0
            ],
            isEmpty: true,
            selectionType: 'empty',
            configItem: editorPluginAIProvider?.baseGenerate,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            usePageKnowledge: true,
            endExperience: endExperience
        }
    });
    /**
   * We only want to enable directional modal pinning when in the
   * prompt input state.
   */ const isDirectionalPinningEnabled = !isRovoLoading && typeof state === 'object' && state['modal active state']['experience'] === 'command palette state'; // We use this point to render the modal if needed instead of decorators
    // The reason this is preferrable is it has access to mount points
    // where decorators are rendered with a mount point within the Editor content
    // and longer modals get clipped as a result.
    const renderModalRegion = ()=>{
        // If there are no active decorations -- then we don't want to render the ai experience.
        if (isDecorationSetEmpty) return null;
        if ((0, $dSwlt.hasGeneratedContentDecorations)(aiDecorationExperiencePluginState)) return null;
         // Get positions from state (calculated by reducer) when feature flag is enabled,
        // otherwise calculate positions inline
        let positions;
        let decoration;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
            positions = aiDecorationExperiencePluginState?.positions;
            if (!positions) return null;
             // Get decoration for modal positioning
            decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
            if (!decoration) {
                const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
                decoration = nodeDecorations.shift();
            }
        } else {
            // Original implementation: calculate positions inline
            // Prioritise getting position from inlineDecoration,
            // otherwise get decoration position from start or end widget
            decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
            if (decoration) {
                // when there is decoration, it means it's text selection
                // we need to use the initial positions
                // as the decoration positions are not accurate when there the selection is empty
                if (!aiDecorationExperiencePluginState?.initialPositions) return null;
                positions = aiDecorationExperiencePluginState?.initialPositions;
            } else {
                const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
                if (nodeDecorations.length > 0) {
                    const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
                    const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
                    positions = [
                        startPos,
                        endPos
                    ];
                }
                decoration = nodeDecorations.shift();
            }
        }
        if (!decoration) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6daee9d675824f6$export$bd71f7a11db32a15), {
            isDirectionalPinningEnabled: isDirectionalPinningEnabled,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            key: aiDecorationExperiencePluginState.modalMountedTimeStamp,
            decoration: decoration,
            editorView: editorView,
            editorRelativeWrapper: wrapperElement?.offsetParent,
            endExperience: endExperience,
            appearance: appearance,
            decorationSet: aiDecorationExperiencePluginState.modalDecorationSet,
            getDeletedWidgets: api?.showDiff?.actions?.getDeletedWidgets,
            useFullEditorWidthForUnifiedBar: !!aiDecorationExperiencePluginState.inlineRovoStreamingTargetId
        }, aiDecorationExperiencePluginState.configItem && editorView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5028c8006c71f51b$export$8b0e36b4d2610ae7), {
            api: api,
            context: context,
            send: send,
            state: state,
            configItem: aiDecorationExperiencePluginState.configItem,
            editorPluginAIProvider: editorPluginAIProvider,
            endExperience: endExperience,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            positions: positions,
            editorView: editorView,
            providerFactory: providerFactory,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            triggerMethod: aiDecorationExperiencePluginState.triggerMethod,
            appearance: appearance,
            initialPrompt: aiDecorationExperiencePluginState?.initialPrompt,
            userADFInput: aiDecorationExperiencePluginState?.userADFInput,
            getMentionNameDetails: getMentionNameDetails,
            triggeredFor: aiDecorationExperiencePluginState.triggeredFor,
            engagementPlatformApi: api?.engagementPlatform?.actions,
            initialPositions: aiDecorationExperiencePluginState?.initialPositions,
            nudgeMetrics: aiDecorationExperiencePluginState.nudgeMetrics,
            defaultAgent: rovoAgentsPluginState?.defaultAgent,
            canInlineStreamChanges: canInlineStreamChanges,
            hideLoadingScreen: decorationPluginState?.hideLoadingScreen,
            aiGroupId: aiDecorationExperiencePluginState?.currentSessionId,
            interactionSessionId: aiDecorationExperiencePluginState?.interactionSessionId,
            willAISuggestEmoji: aiDecorationExperiencePluginState?.willAISuggestEmoji,
            traceId: aiDecorationExperiencePluginState?.traceId,
            promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? aiDecorationExperiencePluginState?.promptVersion : undefined
        }));
    };
    const getPositions = ()=>{
        return (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
            modalDecorationSet: aiDecorationExperiencePluginState?.modalDecorationSet
        });
    };
    const renderedSubscribeToRovo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ae21bd6736f6cf$export$e7460f646530f5b4), {
        editorApi: api,
        positions: getPositions(),
        editorView: editorView,
        product: editorPluginAIProvider.product,
        onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
        onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
        editorPluginAIProvider: editorPluginAIProvider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $iDrrr.fg)('platform_editor_ai_remove_agents_list') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5cf769efe8d70c8d$export$6d436ac1332526a3), {
        editorView: editorView,
        editorPluginAIProvider: editorPluginAIProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bd8f9494e0747d8$export$e4b2c7b98f669fb7), {
        editorView: editorView,
        getMentionNameDetails: getMentionNameDetails,
        editorPluginAIProvider: editorPluginAIProvider,
        editorApi: api,
        isViewMode: isViewMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8c1517f464dc33e9$export$22e51ab65638ad05), {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }), renderedSubscribeToRovo), isInlineEditReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a56105b546468e2$export$42cfe4aadba787df), {
        editorView: editorView,
        targetId: inlineEditReadyTargetId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $405400f22f07581a$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, renderModalRegion(), rovoAgentsPluginState?.isBrowseModalOpen && !(0, $iDrrr.fg)('platform_editor_ai_remove_agents_list') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e9b55d7410177be$export$62821c88a7188481), {
        editorView: editorView,
        aiGlobalOptIn: aiOptIn,
        editorPluginAIProvider: editorPluginAIProvider,
        startingConfig: aiDecorationExperiencePluginState?.configItem,
        positions: rovoAgentsPluginState?.positions
    })));
};


const $c1bd390bf1a072c6$var$useSharedPluginStateNoDebounce = (api)=>{
    const [state, setState] = (0, $cozmU.useState)(api?.aiExperience?.sharedState.currentState()?.aiDecorationExperiencePluginState.modalMountedTimeStamp);
    (0, $cozmU.useLayoutEffect)(()=>{
        const unsub = api?.aiExperience?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
            if (prevSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp !== nextSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp) setState(nextSharedState?.aiDecorationExperiencePluginState.modalMountedTimeStamp);
        });
        return ()=>{
            unsub?.();
        };
    }, [
        api
    ]);
    return state;
};
const $c1bd390bf1a072c6$var$SubscribeToRovoWithPositions = ()=>{
    const { api: api, editorView: editorView, editorPluginAIProvider: editorPluginAIProvider } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { modalDecorationSet: modalDecorationSet } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (state)=>({
            modalDecorationSet: state.aiExperienceState?.aiDecorationExperiencePluginState.modalDecorationSet
        }));
    const positions = (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
        modalDecorationSet: modalDecorationSet
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ae21bd6736f6cf$export$e7460f646530f5b4), {
        editorApi: api,
        positions: positions,
        editorView: editorView,
        product: editorPluginAIProvider.product,
        onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
        onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
        editorPluginAIProvider: editorPluginAIProvider
    });
};
const $c1bd390bf1a072c6$export$d1314adfeea5c2b2 = (props)=>{
    const modalMountedTimeStamp = $c1bd390bf1a072c6$var$useSharedPluginStateNoDebounce(props.api);
    const { targetId: targetId, isDisplayingChanges: isDisplayingChanges, isRunning: isRunning, editorViewModeMode: editorViewModeMode, userADFInput: userADFInput, isInlineEditReady: isInlineEditReady, inlineEditReadyTargetId: inlineEditReadyTargetId } = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.api, [
        'aiExperience',
        'trackChanges',
        'editorViewMode'
    ], (state)=>({
            targetId: state.aiExperienceState?.aiDecorationExperiencePluginState.targetId,
            isDisplayingChanges: state.trackChangesState?.isDisplayingChanges,
            isRunning: state.aiExperienceState?.aiDecorationExperiencePluginState.isRunning,
            editorViewModeMode: state.editorViewModeState?.mode,
            userADFInput: state.aiExperienceState?.aiDecorationExperiencePluginState.userADFInput,
            isInlineEditReady: state.aiExperienceState?.aiDecorationExperiencePluginState?.isInlineEditReady,
            inlineEditReadyTargetId: state.aiExperienceState?.aiDecorationExperiencePluginState?.inlineEditReadyTargetId
        }));
    const isViewMode = editorViewModeMode === 'view';
    const endExperience = (0, $cozmU.useCallback)((options)=>{
        // after AI start, there is a chance that the plugin state is not updated yet
        // so we need to check if the plugin state is running before ending the experience
        if (!isRunning) return;
        const state = (0, $C4yPo.getPluginState)(props.editorView.state);
        const decoSet = (0, $dSwlt.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $4TgUg.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext, options?.shouldIgnoreNextSpaceTrigger);
        endAIExperienceCommand(props.editorView.state, props.editorView.dispatch);
    }, [
        props.editorView,
        isRunning
    ]); /**
                                      * This is to detect the state of the Rovo prompt and loading screens
                                      * from RovoInlineChatPrompt used in RovoPromptScreenWithLogic,
                                      * as it does not respect the state value from XState.
                                      */ 
    const [isRovoLoading, setIsRovoLoading] = (0, $cozmU.useState)(false); /**
                                                              * Stores Rovo's cancel function from onSubmit callback so ExperienceApplication's
                                                              * ESC handler can call it. Needed because editor loses focus when disabled during
                                                              * streaming, breaking normal ESC handling.
                                                              */ 
    const [cancelRovoPrompt, setCancelRovoPrompt] = (0, $cozmU.useState)(); /* reset the component when start AI again, so that the error boundary will also be reset */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a971ff574ffb9b5a$export$214e018fc3e147ea), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2702c2980a93d5fd$export$9bdba9f1d1439b59 // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        value: {
            ...props,
            isRovoLoading: isRovoLoading,
            setIsRovoLoading: setIsRovoLoading,
            targetId: targetId,
            isDisplayingChanges: isDisplayingChanges,
            setCancelRovoPrompt: setCancelRovoPrompt,
            cancelRovoPrompt: cancelRovoPrompt,
            endExperience: endExperience,
            userADFInput: userADFInput
        }
    }, !(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96172548d1818417$export$2dda1e4a1d1f6a81), {
        key: modalMountedTimeStamp
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c27ae7a9acdaec0a$export$83a775c8cee50de8), {
        api: props.api,
        providerFactory: props.providerFactory,
        appearance: props.appearance
    })), (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !(0, $iDrrr.fg)('platform_editor_ai_remove_agents_list') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5cf769efe8d70c8d$export$6d436ac1332526a3), {
        editorView: props.editorView,
        editorPluginAIProvider: props.editorPluginAIProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bd8f9494e0747d8$export$e4b2c7b98f669fb7), {
        editorView: props.editorView,
        getMentionNameDetails: props.getMentionNameDetails,
        editorPluginAIProvider: props.editorPluginAIProvider,
        editorApi: props.api,
        isViewMode: isViewMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8c1517f464dc33e9$export$22e51ab65638ad05), {
        editorPluginAIProvider: props.editorPluginAIProvider,
        editorView: props.editorView
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c1bd390bf1a072c6$var$SubscribeToRovoWithPositions, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $685e286e9de8c0bd$export$83a775c8cee50de8), {
        api: props.api,
        providerFactory: props.providerFactory,
        appearance: props.appearance
    }), isInlineEditReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a56105b546468e2$export$42cfe4aadba787df), {
        editorView: props.editorView,
        targetId: inlineEditReadyTargetId
    }))));
};


/* ContentComponentWrapperLegacy.tsx generated by @compiled/babel-plugin v2.0.0 */ 






/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 



















function $9efbc1f6470a3ad1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9efbc1f6470a3ad1$var$highlightStyles = {
    name: "1u69dfm",
    styles: "background-color:var(--ds-background-accent-blue-subtlest, #E9F2FE);border-bottom:var(--ds-border-width-selected, 2px) solid var(--ds-background-accent-blue-subtler, #CFE1FD)"
};
const $9efbc1f6470a3ad1$var$nodeHighlightStyles = {
    name: "16xg81e",
    styles: "border:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);box-shadow:0 0 2px 1px var(--ds-background-accent-blue-subtler, #CFE1FD)"
};
const $9efbc1f6470a3ad1$var$cellHighlightStyles = /*#__PURE__*/ (0, $lOiVq.css)($9efbc1f6470a3ad1$var$nodeHighlightStyles, " ::after{border-left:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);border-bottom:var(--ds-border-width, 1px) solid var(--ds-background-accent-blue-subtle, #669DF1);}");
// override standard dropdown max-height 90vh to accomodate for long list of translation languages
const $9efbc1f6470a3ad1$var$translationsFloatingToolbarDropdownStyles = {
    name: "735ejv",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{max-height:400px;overflow-x:hidden;[data-testid^='ak-editor-ai-selection-toolbar-translate-button'] [data-item-elem-before]>span{padding:0;}}[data-testid='ak-editor-ai-selection-toolbar-ai-dropdown']>span>span{margin:0;}}"
};
const $9efbc1f6470a3ad1$var$dropdownHeadingStyles = {
    name: "1tkipf9",
    styles: "[aria-label='Selection toolbar']{[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']{cursor:default;>span{gap:initial;}[data-item-elem-before]>span{padding:0;}[data-item-title]{text-transform:uppercase;font-size:0.75rem;font-weight:var(--ds-font-weight-bold, 653);color:var(--ds-text, #292A2E);}}[data-testid^='ak-editor-ai-selection-toolbar-dropdown-heading']:hover{color:var(--ds-text, #292A2E);}}"
};
const $9efbc1f6470a3ad1$var$rovoAgentsFloatingToolbarDropdownStyles = {
    name: "1j1boh2",
    styles: "[aria-label='Annotation toolbar'],[aria-label='Selection toolbar']{[data-role='droplistContent']{[data-testid='ak-editor-ai-selection-toolbar-dropdown-view-all-agents']:not(:only-child){border-block-start:var(--ds-border-width-selected, 2px) solid var(--ds-menu-seperator-color, var(--ds-border, #0B120E24));>span{gap:4px;}}button[data-testid^='ak-editor-ai-selection-toolbar-dropdown-agent'] [data-item-title='true']>span{white-space:normal;}}}"
};
var $9efbc1f6470a3ad1$var$_ref = {
    name: "1pr32me",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-100, 8px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg{padding-right:var(--ds-space-050, 4px);}button[data-testid='ak-editor-ai-selection-toolbar-ai-button']>span:only-child{svg{padding:0px var(--ds-space-100, 8px);}}"
};
var $9efbc1f6470a3ad1$var$_ref2 = {
    name: "2wdbgh",
    styles: "button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus{padding:0px var(--ds-space-075, 6px);}button[data-testid='ak-editor-annotation-toolbar-create-button'],button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,button[data-testid='ak-editor-annotation-toolbar-create-button']:focus{padding:0px var(--ds-space-075, 6px);span:first-child{margin:0;}span[role='img'],svg{padding:0;}}"
};
const $9efbc1f6470a3ad1$var$aiSelectionToolbarButtonStyles = ()=>{
    if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    return $9efbc1f6470a3ad1$var$_ref2;
    else return $9efbc1f6470a3ad1$var$_ref;
};
const $9efbc1f6470a3ad1$var$inlineSuggestionsStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".ak-editor-content-area .", (0, $cOvkw.InlineSuggestionToolbar).INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS, "{padding:var(--ds-space-100, 8px);border-radius:var(--ds-space-075, 6px);[class$='-DateLozenge']{margin:0;}}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.underline, "{text-decoration-line:underline;text-decoration-style:dashed;text-decoration-color:var(--ds-border-accent-blue, #357DE8);}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.highlight, "{background-color:var(--ds-background-selected, #E9F2FE);}.", (0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.completionHint, "{color:var(--ds-text, #292A2E);opacity:var(--ds-opacity-disabled, 0.4);pointer-events:none;user-select:none;}");
};
const $9efbc1f6470a3ad1$var$userHighlightBackgroundColor = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.akEditor div.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ai-pre-stream-range-selection': {
            backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '&.ak-editor-annotation-draft, &.ak-editor-annotation-focus, &.ak-editor-annotation-blur': {
                all: 'unset',
                backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.annotationView-content-wrap': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
            '.ak-editor-annotation-draft, .ak-editor-annotation-focus, .ak-editor-annotation-blur': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
                '&:has(.ai-pre-stream-selection-highlight)': {
                    all: 'unset',
                    backgroundColor: `rgb(from ${"var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)"} r g b / 0.5)`
                }
            }
        }
    }
});
const $9efbc1f6470a3ad1$var$globalStyles = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)(".akEditor div.ProseMirror{.ai-modal-start-widget,.ai-modal-end-widget{position:relative;&::before{content:'';background-image:url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');z-index:1;display:block;position:absolute;top:0;bottom:var(--ds-space-negative-025, -2px);background-repeat:no-repeat;background-position-x:center;background-position-y:center;background-size:contain;aspect-ratio:3/20;}}.ai-modal-start-widget::before{left:0px;margin-left:-0.1em;}.ai-modal-end-widget::before{right:0px;margin-right:-0.1em;}.ai-generated-content-highlight{", $9efbc1f6470a3ad1$var$highlightStyles, ";}.ai-selection-highlight{", $9efbc1f6470a3ad1$var$highlightStyles, "&.ak-editor-annotation-draft,&.ak-editor-annotation-focus,&.ak-editor-annotation-blur{all:unset;", $9efbc1f6470a3ad1$var$highlightStyles, ";}}.ai-selection-node .pm-table-wrapper{table tr td,table tr th{", (0, $jyNaC.getSelectionStyles)([
        (0, $6hOaa.SelectionStyle).Border,
        (0, $6hOaa.SelectionStyle).Blanket
    ]), ";}}.ai-generated-node-highlight .pm-table-wrapper{table tr td,table tr th{", $9efbc1f6470a3ad1$var$cellHighlightStyles, ";}}.annotationView-content-wrap{.ak-editor-annotation-draft,.ak-editor-annotation-focus,.ak-editor-annotation-blur{&:has(.ai-selection-highlight){all:unset;", $9efbc1f6470a3ad1$var$highlightStyles, ";}}}}");
};
const $9efbc1f6470a3ad1$export$214e018fc3e147ea = ({ children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lOiVq.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $9efbc1f6470a3ad1$var$translationsFloatingToolbarDropdownStyles,
            $9efbc1f6470a3ad1$var$rovoAgentsFloatingToolbarDropdownStyles,
            $9efbc1f6470a3ad1$var$inlineSuggestionsStyles(),
            $9efbc1f6470a3ad1$var$dropdownHeadingStyles,
            $9efbc1f6470a3ad1$var$globalStyles(),
            $9efbc1f6470a3ad1$var$userHighlightBackgroundColor,
            $9efbc1f6470a3ad1$var$aiSelectionToolbarButtonStyles()
        ]
    }), children);
};


/* ContentComponentLegacy.tsx generated by @compiled/babel-plugin v2.0.0 */ 

























































































const $899ed9a93707b513$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
    const discardPrompt = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardMessagePrompt);
    const discardResponse = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).discardMessageResponse);
    if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
    if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardResponse;
    return discardResponse;
};
function $899ed9a93707b513$export$643e9e046f871343({ state: state, editCount: editCount, retryPromptCount: retryPromptCount, history: history, onceDiscard: onceDiscard, channelId: channelId, streamFlowPacer: streamFlowPacer }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, configItem: configItem, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, appearance: appearance } = aiExperienceCommonData;
    const inputOutputDiffRatio = (0, $cozmU.useMemo)(()=>{
        const lastHistoryEvent = history.entries[history.positionFromEnd];
        return history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
    }, [
        history
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: 'discard',
        callerComponent: 'DiscardScreenWithLogicLegacy',
        attributes: {
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            inputOutputDiffRatio: inputOutputDiffRatio,
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage
        }
    });
    (0, $cozmU.useEffect)(()=>{
        streamFlowPacer?.pause();
        return ()=>{
            streamFlowPacer?.resume();
        };
    }, [
        streamFlowPacer
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13bb6e412023db64$export$453c0e2ebf820c66), {
        text: $899ed9a93707b513$export$28146c614df26dc4({
            formatMessage: formatMessage,
            experienceState: state
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCancel: function() {
            sendToAIExperienceMachine({
                type: 'disable discard'
            });
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDiscard: function() {
            /**
     * Introduced in EDF-1443 to track discard event confirmations
     * separately to normal discard events which get tracked
     * earlier in this file
     */ fireAIAnalyticsEvent({
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).DISMISSED,
                    interactionID: channelId ?? analyticsFlow.getLastAiInteractionId(),
                    experienceName: (0, $l2lIz.convertExperienceName)(configItem.key.toString()),
                    isProactive: false,
                    attributes: analyticsFlow.getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                    // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
                    isStreamingEnded: !!analyticsFlow.getCommonAttributes().isStreamingEnded
                })
            });
            if (onceDiscard) {
                sendToAIExperienceMachine({
                    type: 'disable discard'
                });
                onceDiscard();
            } else endExperience();
        },
        appearance: appearance
    });
}




/* LoadingScreenWithLogicLegacy.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































// the scroll parent element and scrollable content height
const $7fdc9bbcae929a4d$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area'; /**
                                                                    * Scroll margin is used to ensure that the modal won't be
                                                                    * too close to the top of the editor, which may sometimes
                                                                    * cover the modal slightly.
                                                                    */ 
const $7fdc9bbcae929a4d$var$scrollMarginStyles = null;
function $7fdc9bbcae929a4d$export$9c279fd5d5bced59({ updateStream: updateStream, parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, refinementCount: refinementCount, latestPromptRetried: latestPromptRetried, markdown: markdown, adfResponse: adfResponse, idMap: idMap, contextStatistics: contextStatistics, hideLoadingScreen: hideLoadingScreen }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { configItem: configItem, editorView: editorView, providerFactory: providerFactory, sendToAIExperienceMachine: sendToAIExperienceMachine, editorPluginAIProvider: editorPluginAIProvider, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage, isUserScroll: isUserScroll, isProgrammaticScroll: isProgrammaticScroll, appearance: appearance } = aiExperienceCommonData;
    const schema = editorView.state.schema;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimer = (0, $ea1e399bb2487613$export$b38eff301cbfa415)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const presetPromptLabel = (0, $c2c6d211a4290fa3$export$4539b8c6808af330)(configItem, formatMessage);
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const [preview, setPreview] = (0, $cozmU.useState)();
    const [hasPreview, setHasPreview] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null); // raf is used for debouncing, if useEffect is called
    // multiple times before raf is run this prevents rendering
    // multiple times if we receive streams very quickly
    const raf = (0, $cozmU.useRef)();
    const errorReported = (0, $cozmU.useRef)(false); /**
                                                 * scrollParentRef is for
                                                 * storing the scroll parent element once its found
                                                 * to be re-used in calculations
                                                 */ 
    const scrollParentRef = (0, $cozmU.useRef)(null);
    const initialScrollTop = (0, $cozmU.useRef)(0);
    const modalOffsetTop = (0, $cozmU.useRef)(0);
    const isModalAtTop = (0, $cozmU.useRef)(false);
    const scrollModalAlignBottom = (0, $cozmU.useCallback)((modalEl, scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    const scrollModalToTop = (0, $cozmU.useCallback)((scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current - (0, $8312663103724919$export$9a9d72a255528f),
            behavior: 'instant'
        });
    }, [
        isProgrammaticScroll
    ]);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Set up ResizeObserver to detect cases where the editor content grows,
     * as it will normally trigger a scroll event due to scrollHeight and scrollTop changes.
     * We set isProgrammaticScroll to true to flag it as a non-user scroll.
     */ const editorContentArea = editorView.dom.closest($7fdc9bbcae929a4d$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
        if (!editorContentArea) return;
        const resizeObserver = new ResizeObserver(()=>{
            isProgrammaticScroll.current = true;
        });
        resizeObserver.observe(editorContentArea);
        return ()=>resizeObserver.unobserve(editorContentArea);
    }, [
        editorView,
        isProgrammaticScroll
    ]); /**
                                           * Editor AI can be invoked directly into this Loading screen.
                                           * ExperienceApplication calls scrollIntoView
                                           *
                                           * We need to check whether scrollIntoView is complete to determine when to track user scrolling for the auto-scroll logic
                                           * that prevents scroll-jacking when a user scrolls away.
                                           */ 
    const [isScrollIntoViewSettled, setIsScrollIntoViewSettled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        const settleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setIsScrollIntoViewSettled(true); /**
                                         * Once it's settled, we can unbind
                                         * as we only need to check when it first loads
                                         *
                                         * This is to emulate scrollEnd which is not supported
                                         * across all browsers at the moment.
                                         *
                                         * unbind taken from the bind function below
                                         */ 
            unbind();
        }, 250);
        const unbind = (0, $cbY7C.bind)(scrollParentEl, {
            type: 'scroll',
            listener: settleScroll
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Setup init values to calculate scroll distance and
     * scroll the modal into view if it is not already visible.
     */ const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        scrollParentRef.current = scrollParentEl; // Calculate the offset of the modal from the top of editor
        modalOffsetTop.current = modalEl.getBoundingClientRect().top - scrollParentEl.getBoundingClientRect().top; // Calculate initial scroll position of editor
        initialScrollTop.current = scrollParentEl.scrollTop; // Calculate position of the bottom of the modal from top of editor
        const modalBottomOffsetTop = modalOffsetTop.current + modalEl.scrollHeight;
        if (modalBottomOffsetTop < 0) // Edge case: if modal above the top of the editor
        scrollModalToTop(scrollParentEl);
        else if (modalOffsetTop.current > scrollParentEl.offsetHeight) /**
       * Edge case: if modal is below the bottom of the editor
       * Call scrollModalAlignBottom to move modal into view.
       */ scrollModalAlignBottom(modalEl, scrollParentEl);
        const unbind = (0, $cbY7C.bind)(scrollParentEl, {
            type: 'scroll',
            listener: ()=>{
                if (isScrollIntoViewSettled && !isProgrammaticScroll.current) {
                    isUserScroll.current = true;
                    unbind();
                }
                isProgrammaticScroll.current = false;
            }
        });
        return ()=>{
            unbind();
        };
    }, [
        scrollModalToTop,
        scrollModalAlignBottom,
        isScrollIntoViewSettled,
        isProgrammaticScroll,
        isUserScroll
    ]);
    function scrollModalIntoView() {
        /**
     * Early exits:
     * - If user has manually scrolled, stop auto-scrolling
     * - If modal has reached the top of the editor, no more calculations or scrolling needed
     */ if (isUserScroll.current || isModalAtTop.current) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = scrollParentRef.current;
        if (!scrollParentEl) return;
         // Check if modal is already fully visible
        const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight; /**
                                                                                                              * Check if modal height exceeds scroll parent's height
                                                                                                              * Scroll margin is used to prevent the modal from being scrolled to the top
                                                                                                              * and should match scroll margin in other modals e.g. from
                                                                                                              * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
                                                                                                              */ 
        const isModalFullHeight = scrollParentEl.offsetHeight - (0, $8312663103724919$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalFullyVisible) return;
        if (isModalFullHeight) {
            scrollModalToTop(scrollParentEl);
            isModalAtTop.current = true;
            return;
        }
        scrollModalAlignBottom(modalEl, scrollParentEl);
    }
    const adfResponseRef = (0, $cozmU.useRef)(adfResponse);
    adfResponseRef.current = adfResponse;
    (0, $cozmU.useEffect)(()=>{
        // only run the callback if the raf has not been set, and then
        // reset raf to undefined
        if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
            let _preview;
            raf.current = undefined;
            if (adfResponseRef.current) _preview = (0, $1ebb5e0c9114edeb$export$5ae44876b720d032)({
                adfResponse: adfResponseRef.current,
                showTelepointer: true,
                providerFactory: providerFactory
            });
            else if (!markdown || markdown === '') // When there is no streamed preview content -- set the preview to
            // undefined.
            // This allows a nicer loading screen (rather than showing an empty paragraph).
            _preview = undefined;
            else {
                const { pmFragment: pmFragment } = (0, $f29bf620c0b9ffee$export$a08e8b3dacf7ffcc)({
                    markdown: markdown,
                    schema: schema,
                    source: 'loading',
                    fireAIAnalyticsEvent: (event)=>{
                        if (!errorReported.current) {
                            errorReported.current = true;
                            fireAIAnalyticsEvent(event);
                        }
                    },
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    idMap: idMap
                }); /**
               * Hold off on setting the preview if we appear to be receiving
               * a custom tag through our stream. This is to hide raw tags from
               * users until the tags are complete and can be rendered back into nodes.
               */ 
                if ((0, $bb827e6786ce28c4$export$bde720e3489117f9)(markdown)) return;
                _preview = (0, $1ebb5e0c9114edeb$export$f5e3af6d625de7a)({
                    schema: schema,
                    pmFragment: pmFragment,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
            }
            if (_preview) {
                setPreview(_preview);
                setHasPreview(true);
                window.requestAnimationFrame(()=>{
                    scrollModalIntoView();
                });
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markdown,
        updateStream,
        adfResponse
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // if the component is unmounted before the raf callback
            // has run, we cancel it
            if (raf.current) window.cancelAnimationFrame(raf.current);
        };
    }, []); // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $48b5c021b1ae01b8$export$6399b1de54f080ad)(latestPrompt);
    const promptStatistics = (0, $45c921fe28f84dd0$export$4e4614f0417d7178)(localizedLatestPrompt);
    const analyticsFlow = (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        needUpdatedArgs: true,
        stepName: 'loading',
        callerComponent: 'LoadingScreenWithLogicLegacy',
        attributes: {
            promptType: promptTrigger,
            latestPromptRetried: latestPromptRetried,
            refinementCount: refinementCount,
            modelIO: {
                contextStatistics: contextStatistics,
                userInputCharacterCount: promptStatistics?.totalCharacterCount,
                userInputNodeCounts: promptStatistics?.nodeCounts,
                userInputLinksCount: promptStatistics?.linksCount,
                userInputMentionsCount: promptStatistics?.mentionsCount
            },
            includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage,
            // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
            isStreamingEnded: false
        }
    });
    const previewBecameAvailable = (0, $cozmU.useRef)();
    if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
    (0, $cozmU.useEffect)(()=>{
        const noPreviewAvailable = performance.now();
        return ()=>{
            if (!previewBecameAvailable.current) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                    timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                }
            });
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_1ghwDKVa5s"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4x5dF.LoadingScreen), {
        parentPresetPromptLabel: parentPresetPromptLabel,
        childShortTitle: childShortTitle,
        presetPromptLabel: presetPromptLabel,
        latestPrompt: localizedLatestPrompt,
        agent: configItem?.agent,
        title: title,
        preview: preview,
        providerFactory: providerFactory,
        disclaimer: disclaimer,
        onCancel: ()=>{
            sendToAIExperienceMachine({
                type: 'enable discard'
            });
        },
        schema: schema,
        isStreaming: !!adfResponse || !!markdown,
        canInlineStreamChanges: true,
        hideLoadingScreen: !!hideLoadingScreen,
        appearance: appearance
    }));
}















var $4EPzQ = parcelRequire("4EPzQ");






var $6TaGl = parcelRequire("6TaGl");








var $hq9Cp = parcelRequire("hq9Cp");





























var $lnOAf = parcelRequire("lnOAf");


var $I7hWB = parcelRequire("I7hWB");






















parcelRequire("cozmU");
















const $192e8eb6b6b4a66f$var$lozengeContainerStyleBig = {
    default: "_2mHwu82ADO _3iDTPbQ4SZ _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0hPCNLDIqT"
};
const $192e8eb6b6b4a66f$var$lozengeContainerStyle = {
    default: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
};
const $192e8eb6b6b4a66f$export$1c1a126042a474aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { onFormSubmit: onFormSubmit, inputValue: inputValue, suggestions: suggestions, setSuggestion: setSuggestion, showButton: showButton } = t0;
    const highlightedSuggestion = suggestions.find($192e8eb6b6b4a66f$var$_temp);
    const [setBreakpointsElement, t1] = (0, $9lgy7.useElementBreakpoints)();
    const { breakpoint: breakpoint } = t1;
    let t2;
    if ($[0] !== breakpoint) {
        t2 = (s)=>{
            if (!s.length) return 0;
            const isSmall = breakpoint <= (0, $9lgy7.Breakpoint).Small;
            const first = s[0];
            if (first.value === "Brainstorm") return 1;
            const isTopLevel = !first.nestingConfig || first.label === first.nestingConfig.parentTitle;
            if (isTopLevel) return isSmall ? 1 : 3;
            return isSmall ? 1 : s.length;
        };
        $[0] = breakpoint;
        $[1] = t2;
    } else t2 = $[1];
    const howManySuggestionsToDisplay = t2;
    const T0 = (0, $1l0kj.Inline);
    const t3 = "space-between";
    const t4 = $192e8eb6b6b4a66f$var$lozengeContainerStyleBig;
    const T1 = (0, $1l0kj.Inline);
    const t5 = $192e8eb6b6b4a66f$var$lozengeContainerStyle;
    const t6 = !inputValue && suggestions.filter($192e8eb6b6b4a66f$var$_temp2).slice(0, howManySuggestionsToDisplay(suggestions)).map((suggestion_1)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            spacing: "compact",
            onClick: ()=>suggestion_1.onSelect(),
            onMouseEnter: ()=>suggestion_1.onSuggestionFocused(),
            onMouseLeave: ()=>setSuggestion(highlightedSuggestion ? highlightedSuggestion : suggestion_1),
            children: suggestion_1.label
        }, `${suggestion_1.value}-button`));
    let t7;
    if ($[2] !== T1 || $[3] !== t5.default || $[4] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)(T1, {
            xcss: t5.default,
            children: t6
        });
        $[2] = T1;
        $[3] = t5.default;
        $[4] = t6;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== inputValue || $[7] !== onFormSubmit || $[8] !== showButton) {
        t8 = showButton && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
            spacing: "compact",
            label: "send-icon-command-palette-lozenge",
            isDisabled: inputValue === "",
            onClick: ()=>{
                onFormSubmit(inputValue);
            }
        });
        $[6] = inputValue;
        $[7] = onFormSubmit;
        $[8] = showButton;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== T0 || $[11] !== setBreakpointsElement || $[12] !== t4.default || $[13] !== t7 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)(T0, {
            ref: setBreakpointsElement,
            spread: t3,
            xcss: t4.default,
            children: [
                t7,
                t8
            ]
        });
        $[10] = T0;
        $[11] = setBreakpointsElement;
        $[12] = t4.default;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    return t9;
} : ({ onFormSubmit: onFormSubmit, inputValue: inputValue, suggestions: suggestions, setSuggestion: setSuggestion, showButton: showButton })=>{
    const highlightedSuggestion = suggestions.find((suggestion)=>suggestion.value === 'Brainstorm');
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)(); /**
                                 * This is a quick spike intermediate solution to determine how many suggestions to display
                                 */ 
    const howManySuggestionsToDisplay = (s)=>{
        if (!s.length) return 0;
        const isSmall = breakpoint <= (0, $9lgy7.Breakpoint).Small;
        const first = s[0];
        if (first.value === 'Brainstorm') return 1;
        const isTopLevel = !first.nestingConfig || first.label === first.nestingConfig.parentTitle;
        if (isTopLevel) return isSmall ? 1 : 3;
        return isSmall ? 1 : s.length;
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        ref: setBreakpointsElement,
        spread: "space-between",
        xcss: $192e8eb6b6b4a66f$var$lozengeContainerStyleBig.default,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                xcss: $192e8eb6b6b4a66f$var$lozengeContainerStyle.default,
                children: !inputValue && // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
                suggestions.filter((suggestion_0)=>suggestion_0.value !== 'tell-ai' && suggestion_0.value !== 'show-more').slice(0, howManySuggestionsToDisplay(suggestions)).map((suggestion_1)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                        spacing: "compact",
                        onClick: ()=>suggestion_1.onSelect(),
                        onMouseEnter: ()=>suggestion_1.onSuggestionFocused(),
                        onMouseLeave: ()=>setSuggestion(highlightedSuggestion ? highlightedSuggestion : suggestion_1),
                        children: suggestion_1.label
                    }, `${suggestion_1.value}-button`))
            }),
            showButton && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($blZUD))),
                spacing: "compact",
                label: "send-icon-command-palette-lozenge",
                isDisabled: inputValue === '',
                onClick: ()=>{
                    onFormSubmit(inputValue);
                }
            })
        ]
    });
};
function $192e8eb6b6b4a66f$var$_temp(suggestion) {
    return suggestion.value === "Brainstorm";
}
function $192e8eb6b6b4a66f$var$_temp2(suggestion_0) {
    return suggestion_0.value !== "tell-ai" && suggestion_0.value !== "show-more";
}





/* UsePageKnowledgeToggleFooter.tsx generated by @compiled/babel-plugin v2.0.0 */ 


parcelRequire("cozmU");











var $c0A7H = parcelRequire("c0A7H");


var $161op = parcelRequire("161op");

const $a999f260782bce94$var$footerStyles = {
    default: "_2mHwu81Y8M _3iDTPbQ4SZ _0Of8r2gVvo _2Zuz6QgVvo _1ZnuxbgVvo _1wydGWgVvo _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _0hPCNLDIqT"
};
const $a999f260782bce94$var$labelStyles = null;
function $a999f260782bce94$export$c486b1aa62224a41({ onChange: onChange, isChecked: isChecked }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const TOGGLE_ID = 'page-knowledge-toggle';
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $a999f260782bce94$var$footerStyles.default,
        backgroundColor: "elevation.surface",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $c0A7H.default), {
                id: TOGGLE_ID,
                testId: TOGGLE_ID,
                onChange: onChange,
                isChecked: isChecked
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
                htmlFor: TOGGLE_ID,
                className: (0, $hekY6.default)([
                    "_1UtDYzZpcK"
                ]),
                children: formatMessage((0, $161op.default).usePageKnowledgeToggleLabel)
            })
        ]
    });
}




var $bDDw8 = parcelRequire("bDDw8");











































parcelRequire("cozmU");







const $1162cfcdbbc7d12a$var$stickySuggestionsGroupHeadingStyles = null;
const $1162cfcdbbc7d12a$var$suggestionsGroupHeadingStyles = null;
const $1162cfcdbbc7d12a$var$groupHeadingStyles = null;
const $1162cfcdbbc7d12a$export$b7bc1538a6ef0630 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { id: id, heading: heading } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            (0, $iDrrr.fg)("ai-smart-button-team-25") ? "_12pLkPmnOE _38a1a82Njc _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _1dmVT1Q4SZ _3gZsD78HPE _4GiLnv5zaO _27WIHE5zaO _11DXJJ1Y8M _2yzFFQf7mX _4vhRtvKGUX" : "_12pLkP7NXe _38a1a82Njc _1dmVT1Q4SZ _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _3gZsD78HPE _27WIHE8HPE _11DXJJ1Y8M _4GiLnv8HPE _4CI8LVmb2E _1yGjhvAv7U _4vhRtvZpcK",
            "_1mT5xdHE3j _39xV02OLYo _2IhTondnbC _0KLXrulfZc _42Yu6B7dHp"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading || $[2] !== id) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("h3", {
            id: id,
            "data-testid": id,
            className: t1,
            children: heading
        });
        $[1] = heading;
        $[2] = id;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ id: id, heading: heading })=>{
    /* Using h3, as the parent element can potentially put in a h2 heading above suggestions
   * TODO: EDF-2349 - double check in branch deploy when migrating to compiled to see if passing in
   * styles directly to css prop in h3 (instead of using classname and nested selector) is still overridden
   * by Confluence styles, or whether compiled migration mitigates that
   */ return /*#__PURE__*/ (0, $8aG6j.jsx)("h3", {
        id: id,
        "data-testid": id,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('ai-smart-button-team-25') ? "_12pLkPmnOE _38a1a82Njc _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _1dmVT1Q4SZ _3gZsD78HPE _4GiLnv5zaO _27WIHE5zaO _11DXJJ1Y8M _2yzFFQf7mX _4vhRtvKGUX" : "_12pLkP7NXe _38a1a82Njc _1dmVT1Q4SZ _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _3gZsD78HPE _27WIHE8HPE _11DXJJ1Y8M _4GiLnv8HPE _4CI8LVmb2E _1yGjhvAv7U _4vhRtvZpcK",
            "_1mT5xdHE3j _39xV02OLYo _2IhTondnbC _0KLXrulfZc _42Yu6B7dHp"
        ]),
        children: heading
    });
};



























var $9KSWX = parcelRequire("9KSWX");






















const $a13d4ac91e417573$export$77af5b11f07c3aed = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { alt: alt, isDisabled: t1, isSelected: t2, className: className, size: t3, isPadded: t4, style: t5 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const isSelected = t2 === undefined ? false : t2;
    const size = t3 === undefined ? 24 : t3;
    const isPadded = t4 === undefined ? true : t4;
    let t6;
    if ($[0] !== t5) {
        t6 = t5 === undefined ? {} : t5;
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const style = t6;
    const stroke = isDisabled ? "var(--ds-icon-disabled, #080F214A)" : isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
    const t7 = alt === "" ? "presentation" : undefined;
    let t8;
    if ($[2] !== className || $[3] !== size || $[4] !== style || $[5] !== t7) {
        t8 = {
            width: size,
            height: size,
            className: className,
            role: t7,
            xmlns: "http://www.w3.org/2000/svg",
            style: style
        };
        $[2] = className;
        $[3] = size;
        $[4] = style;
        $[5] = t7;
        $[6] = t8;
    } else t8 = $[6];
    const commonProps = t8;
    const t9 = isPadded ? "0 0 24 24" : "0 0 16 16";
    let t10;
    if ($[7] !== alt) {
        t10 = alt && /*#__PURE__*/ (0, $8aG6j.jsx)("title", {
            children: alt
        });
        $[7] = alt;
        $[8] = t10;
    } else t10 = $[8];
    let t11;
    if ($[9] !== isPadded || $[10] !== stroke) {
        t11 = isPadded ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M14.5 14.5L17.5 17.5",
                    stroke: stroke,
                    strokeWidth: "1.5",
                    strokeLinecap: "square"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M9.5 14.5L6.5 17.5",
                    stroke: stroke,
                    strokeWidth: "1.5",
                    strokeLinecap: "square"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M9.5 9.5L6.5 6.5",
                    stroke: stroke,
                    strokeWidth: "1.5",
                    strokeLinecap: "square"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M14.5 9.5L17.5 6.5",
                    stroke: stroke,
                    strokeWidth: "1.5",
                    strokeLinecap: "square"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M12.0001 16V19",
                    stroke: stroke,
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M8.00012 12L5.00012 12",
                    stroke: stroke,
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M12.0001 8.00002L12.0001 4.99999",
                    stroke: stroke,
                    strokeWidth: "1.5"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M16.0002 12L19.0002 12",
                    stroke: stroke,
                    strokeWidth: "1.5"
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.24999 4V1H8.74999V4H7.24999ZM5.46966 6.53033L1.46966 2.53033L2.53032 1.46967L6.53032 5.46967L5.46966 6.53033ZM9.46966 5.46967L13.4697 1.46967L14.5303 2.53033L10.5303 6.53033L9.46966 5.46967ZM0.999992 7.25H3.99999V8.75H0.999992V7.25ZM12 7.25H15V8.75H12V7.25ZM1.46966 13.4697L5.46966 9.46967L6.53032 10.5303L2.53032 14.5303L1.46966 13.4697ZM13.4697 14.5303L9.46966 10.5303L10.5303 9.46967L14.5303 13.4697L13.4697 14.5303ZM7.24999 15V12H8.74999V15H7.24999Z",
            fill: "currentColor"
        });
        $[9] = isPadded;
        $[10] = stroke;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== commonProps || $[13] !== t10 || $[14] !== t11 || $[15] !== t9) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            ...commonProps,
            viewBox: t9,
            children: [
                t10,
                t11
            ]
        });
        $[12] = commonProps;
        $[13] = t10;
        $[14] = t11;
        $[15] = t9;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : ({ alt: alt, isDisabled: isDisabled = false, isSelected: isSelected = false, className: className, size: size = 24, isPadded: isPadded = true, style: style = {} })=>{
    const stroke = isDisabled ? "var(--ds-icon-disabled, #080F214A)" : isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
    const commonProps = {
        width: size,
        height: size,
        className: className,
        role: alt === '' ? 'presentation' : undefined,
        xmlns: 'http://www.w3.org/2000/svg',
        style: style
    };
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        ...commonProps,
        viewBox: isPadded ? '0 0 24 24' : '0 0 16 16',
        children: [
            alt && /*#__PURE__*/ (0, $8aG6j.jsx)("title", {
                children: alt
            }),
            isPadded ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M14.5 14.5L17.5 17.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M9.5 14.5L6.5 17.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M9.5 9.5L6.5 6.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M14.5 9.5L17.5 6.5",
                        stroke: stroke,
                        strokeWidth: "1.5",
                        strokeLinecap: "square"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M12.0001 16V19",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M8.00012 12L5.00012 12",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M12.0001 8.00002L12.0001 4.99999",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        d: "M16.0002 12L19.0002 12",
                        stroke: stroke,
                        strokeWidth: "1.5"
                    })
                ]
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.24999 4V1H8.74999V4H7.24999ZM5.46966 6.53033L1.46966 2.53033L2.53032 1.46967L6.53032 5.46967L5.46966 6.53033ZM9.46966 5.46967L13.4697 1.46967L14.5303 2.53033L10.5303 6.53033L9.46966 5.46967ZM0.999992 7.25H3.99999V8.75H0.999992V7.25ZM12 7.25H15V8.75H12V7.25ZM1.46966 13.4697L5.46966 9.46967L6.53032 10.5303L2.53032 14.5303L1.46966 13.4697ZM13.4697 14.5303L9.46966 10.5303L10.5303 9.46967L14.5303 13.4697L13.4697 14.5303ZM7.24999 15V12H8.74999V15H7.24999Z",
                fill: "currentColor"
            })
        ]
    }));
};





const $440a108957c13b90$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    tellAILabel: {
        id: "fabric.editor.ai.ui.components.suggestions.tellAILabel",
        defaultMessage: "Tell AI"
    },
    tellAgentLabel: {
        id: "fabric.editor.ai.ui.components.suggestions.tellAgentLabel",
        defaultMessage: "Tell Agent"
    },
    suggestionStatusBeta: {
        id: "fabric.editor.ai.ui.components.suggestions.betaLozenge",
        defaultMessage: "BETA"
    },
    suggestionStatusNew: {
        id: "fabric.editor.ai.ui.components.suggestions.newLozenge",
        defaultMessage: "NEW"
    }
});


const $d92b2ebd84590792$var$contentStyles = {
    default: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _0QpwdFIZbP _1T2N03wPeg _4ouGXI8i9X _39HuIbz8Lp _1ANEUSLRg7"
};
const $d92b2ebd84590792$var$chevronIconStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d92b2ebd84590792$var$descriptionStylesUnbounded = null;
const $d92b2ebd84590792$var$descriptionStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d92b2ebd84590792$var$enterStylesUnbounded = null;
const $d92b2ebd84590792$var$enterStyles = null;
const $d92b2ebd84590792$var$statusStyles = {
    default: "_2Zuz6Q1Y8M"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d92b2ebd84590792$var$suggestionButtonStylesUnbounded = null;
const $d92b2ebd84590792$var$suggestionButtonStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d92b2ebd84590792$var$suggestionItemStylesUnbounded = null;
const $d92b2ebd84590792$var$suggestionItemStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $d92b2ebd84590792$var$suggestionIconStylesUnbounded = null;
const $d92b2ebd84590792$var$suggestionIconStyles = null;
const $d92b2ebd84590792$var$suggestionListItemStyles = null;
const $d92b2ebd84590792$var$tellAILabelStyles = null;
const $d92b2ebd84590792$var$rovoSuggestionButtonStyles = null;
const $d92b2ebd84590792$var$rovoSuggestionIconStyles = null; // Height of ListHeading component, used to calculate the scroll position.
// Kind of a hack, but it's the easiest way to get the height of the sticky group header.
const $d92b2ebd84590792$var$STICKY_GROUP_HEADER_HEIGHT = 32;
const $d92b2ebd84590792$var$ensureElementIsVisibleInScrollContainer = (listItem, stickyHeaderHeight)=>{
    // ensure the structure of suggestions li element > ul (position relative) > scrollable div (overflow auto)
    const scrollContainer = listItem.offsetParent?.parentElement;
    if (!scrollContainer || scrollContainer.tagName !== 'DIV') return;
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const itemRect = listItem.getBoundingClientRect(); // if highlighted item is above/below the current scroll viewport
    const itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
    if (itemNotVisible) // Can't use item.scrollIntoView() because it moves the whole page too
    scrollContainer.scrollTo({
        top: listItem.offsetTop - stickyHeaderHeight,
        behavior: 'smooth'
    });
};
const $d92b2ebd84590792$var$statusLozengeMessages = {
    beta: (0, $440a108957c13b90$export$defe85febe8b728c).suggestionStatusBeta,
    new: (0, $440a108957c13b90$export$defe85febe8b728c).suggestionStatusNew
};
const $d92b2ebd84590792$var$suggestionIconContainerStylesUnbounded = null;
const $d92b2ebd84590792$var$suggestionIconContainerStyles = null;
const $d92b2ebd84590792$var$suggestionIconContainerBorderStyles = null;
const $d92b2ebd84590792$export$a7b06bfba60a8a78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(61);
    const { suggestion: suggestion, customLabel: customLabel, highlighted: highlighted, setSuggestion: setSuggestion, hasGroupHeading: hasGroupHeading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const listItemRef = (0, $cozmU.useRef)(null);
    const hasChildren = suggestion.childSuggestions && suggestion.childSuggestions.length;
    let t1;
    if ($[0] !== setSuggestion || $[1] !== suggestion) {
        t1 = (eventName)=>{
            if (setSuggestion) setSuggestion(suggestion, eventName);
        };
        $[0] = setSuggestion;
        $[1] = suggestion;
        $[2] = t1;
    } else t1 = $[2];
    const updateSuggestion = t1;
    let t2;
    if ($[3] !== suggestion || $[4] !== updateSuggestion) {
        t2 = ()=>{
            updateSuggestion("focus");
            suggestion.onSuggestionFocused();
        };
        $[3] = suggestion;
        $[4] = updateSuggestion;
        $[5] = t2;
    } else t2 = $[5];
    const onFocus = t2;
    let t3;
    if ($[6] !== updateSuggestion) {
        t3 = ()=>{
            updateSuggestion("mousemove");
        };
        $[6] = updateSuggestion;
        $[7] = t3;
    } else t3 = $[7];
    const onMouseMove = t3;
    let t4;
    let t5;
    if ($[8] !== hasGroupHeading || $[9] !== highlighted) {
        t4 = ()=>{
            if (highlighted && listItemRef.current && !listItemRef.current.matches(":hover")) $d92b2ebd84590792$var$ensureElementIsVisibleInScrollContainer(listItemRef.current, hasGroupHeading ? $d92b2ebd84590792$var$STICKY_GROUP_HEADER_HEIGHT : 0);
        };
        t5 = [
            listItemRef,
            highlighted,
            hasGroupHeading
        ];
        $[8] = hasGroupHeading;
        $[9] = highlighted;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    bb0: {
        if (hasChildren && !highlighted) {
            let t7;
            let t8;
            if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
                t7 = (0, $hekY6.default)([
                    "_0Of8r2Pgdg _1wydGWPgdg _2Zuz6Q1Y8M _1Znuxb1Y8M"
                ]);
                t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    size: "small"
                });
                $[12] = t7;
                $[13] = t8;
            } else {
                t7 = $[12];
                t8 = $[13];
            }
            let t9;
            if ($[14] !== t7) {
                t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: t7,
                    children: t8
                });
                $[14] = t7;
                $[15] = t9;
            } else t9 = $[15];
            t6 = t9;
            break bb0;
        }
        t6 = null;
    }
    const chevronRight = t6;
    let t7;
    if ($[16] !== formatMessage || $[17] !== suggestion.statusLozengeType) {
        t7 = suggestion.statusLozengeType && ($d92b2ebd84590792$var$statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage($d92b2ebd84590792$var$statusLozengeMessages[suggestion.statusLozengeType]) : null);
        $[16] = formatMessage;
        $[17] = suggestion.statusLozengeType;
        $[18] = t7;
    } else t7 = $[18];
    const statusLozengeText = t7;
    let t8;
    if ($[19] !== customLabel || $[20] !== formatMessage || $[21] !== suggestion.label) {
        t8 = customLabel ? customLabel : typeof suggestion.label === "string" ? suggestion.label : formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAILabel);
        $[19] = customLabel;
        $[20] = formatMessage;
        $[21] = suggestion.label;
        $[22] = t8;
    } else t8 = $[22];
    const ariaLabel = t8;
    let t9;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $hekY6.default)([
            "_1LMyvKYbGa _313842Pgdg"
        ]);
        $[23] = t9;
    } else t9 = $[23];
    const t10 = suggestion.onSelect;
    const t11 = suggestion.testId || (customLabel ? "tell-ai" : suggestion.label);
    let t12;
    if ($[24] !== suggestion.value) {
        t12 = (0, $hekY6.default)([
            "_2sNsIgmnOE _39xV02N91d _4kiQYAUF4f _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _313842Pgdg _3iDTPbQ4SZ _0aFT5v1qpb _37wbyu7p2s _0hPCNLDIqT _2fwxA5ecOK _1kk5Tku7m9 _1UtDYzy7kJ",
            "_30huDKdnbC _0bjKvDdnbC _2mHwu874nF _2uo31fYbGa _2C2kUQdnbC _1Lz9lodnbC _1FjTCx7zJH _14CzSFN4oS _2BZEPjo126 _3FwPiYXzJH _343g2kLl21 _374piqVrZW _03MxTtot27 _3NZ5zAsyl5",
            (0, $iDrrr.fg)("ai-smart-button-team-25") && "_2mHwu88HPE _39xV02N91d _2Zuz6QkG2W _1ZnuxbkG2W _0Of8r2gVvo _1wydGWgVvo _313842Pgdg _1DCdHiPgdg _2XsHFMPgdg _0adFHsPgdg _3iDTPbQ4SZ _37wbyu7p2s _0hPCNLDIqT _2fwxA5ecOK _1kk5Tku7m9 _1UtDYzy7kJ",
            (0, $iDrrr.fg)("ai-smart-button-team-25") && "_30huDKdnbC _2uo31fYbGa _4kiQYAS40j _1FjTCx7zJH _14CzSFN4oS _2BZEPjo126 _3FwPiYXzJH _343g2kLl21 _374piqVrZW _03MxTtot27 _3NZ5zAsyl5",
            suggestion.value.includes("agent:") && "_4kiQYA298P"
        ]);
        $[24] = suggestion.value;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== suggestion.hideIcon || $[27] !== suggestion.icon || $[28] !== suggestion.isAgent || $[29] !== suggestion.value) {
        t13 = !suggestion.hideIcon && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VoWWg _39xV02oWWg",
                "_2crE4roWWg _1aUa7rSPN1",
                (0, $iDrrr.fg)("ai-smart-button-team-25") && "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
                (0, $iDrrr.fg)("ai-smart-button-team-25") && "_0jFU0VVa5s _39xV02Va5s",
                !suggestion.isAgent && (0, $iDrrr.fg)("ai-smart-button-team-25") && "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
                suggestion.value.includes("agent:") && "_0jFU0VUofl _39xV02Uofl"
            ]),
            children: suggestion.icon || ((0, $iDrrr.fg)("ai-smart-button-team-25") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                spacing: "spacious",
                label: ""
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a13d4ac91e417573$export$77af5b11f07c3aed), {
                className: "default-icon",
                alt: ""
            }))
        });
        $[26] = suggestion.hideIcon;
        $[27] = suggestion.icon;
        $[28] = suggestion.isAgent;
        $[29] = suggestion.value;
        $[30] = t13;
    } else t13 = $[30];
    let t14;
    if ($[31] !== customLabel || $[32] !== suggestion.label) {
        t14 = !customLabel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            children: suggestion.label
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_1kk5Tkf7mX _0adFHs1Y8M"
                    ]),
                    children: customLabel
                }),
                ' "',
                suggestion.label,
                '"'
            ]
        });
        $[31] = customLabel;
        $[32] = suggestion.label;
        $[33] = t14;
    } else t14 = $[33];
    let t15;
    if ($[34] !== statusLozengeText) {
        t15 = statusLozengeText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            alignItems: "center",
            xcss: $d92b2ebd84590792$var$statusStyles.default,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                appearance: "discovery",
                children: statusLozengeText
            })
        });
        $[34] = statusLozengeText;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== t14 || $[37] !== t15) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            alignItems: "center",
            children: [
                t14,
                t15
            ]
        });
        $[36] = t14;
        $[37] = t15;
        $[38] = t16;
    } else t16 = $[38];
    let t17;
    if ($[39] !== suggestion.description) {
        t17 = suggestion.description && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _0QpwdFIZbP _1T2N03wPeg _4ouGXI8i9X _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzKGUX _3iDTPbvbI6",
                "_26BoRwEbN9"
            ]),
            children: suggestion.description
        });
        $[39] = suggestion.description;
        $[40] = t17;
    } else t17 = $[40];
    let t18;
    if ($[41] !== t16 || $[42] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            direction: "column",
            xcss: $d92b2ebd84590792$var$contentStyles.default,
            children: [
                t16,
                t17
            ]
        });
        $[41] = t16;
        $[42] = t17;
        $[43] = t18;
    } else t18 = $[43];
    let t19;
    if ($[44] !== suggestion.rightText) {
        t19 = suggestion.rightText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text.subtlest",
            children: suggestion.rightText
        });
        $[44] = suggestion.rightText;
        $[45] = t19;
    } else t19 = $[45];
    let t20;
    if ($[46] !== suggestion.value) {
        t20 = suggestion.value !== "no-suggestions" && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa _0jFU0VSPN1 _39xV02SPN1 _1UtDYzZpcK _0KLXruo126",
                "_0bjKvDzXzM _1h2CcLccYA _27M2T3DIqT _4cVsumDIqT"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4b738c5d4441c77c$export$2e2bcd8739ae039), {})
        });
        $[46] = suggestion.value;
        $[47] = t20;
    } else t20 = $[47];
    let t21;
    if ($[48] !== ariaLabel || $[49] !== chevronRight || $[50] !== highlighted || $[51] !== onFocus || $[52] !== onMouseMove || $[53] !== suggestion.onSelect || $[54] !== t11 || $[55] !== t12 || $[56] !== t13 || $[57] !== t18 || $[58] !== t19 || $[59] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: listItemRef,
            className: t9,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
                type: "button",
                onClick: t10,
                onMouseMove: onMouseMove,
                "data-testid": t11,
                "data-highlighted": highlighted,
                "aria-label": ariaLabel,
                onFocus: onFocus,
                className: t12,
                children: [
                    t13,
                    t18,
                    t19,
                    t20,
                    chevronRight
                ]
            })
        });
        $[48] = ariaLabel;
        $[49] = chevronRight;
        $[50] = highlighted;
        $[51] = onFocus;
        $[52] = onMouseMove;
        $[53] = suggestion.onSelect;
        $[54] = t11;
        $[55] = t12;
        $[56] = t13;
        $[57] = t18;
        $[58] = t19;
        $[59] = t20;
        $[60] = t21;
    } else t21 = $[60];
    return t21;
} : ({ suggestion: suggestion, customLabel: customLabel, highlighted: highlighted, setSuggestion: setSuggestion, hasGroupHeading: hasGroupHeading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const listItemRef = (0, $cozmU.useRef)(null);
    const hasChildren = (0, $cozmU.useMemo)(()=>{
        return suggestion.childSuggestions && suggestion.childSuggestions.length;
    }, [
        suggestion.childSuggestions
    ]);
    const updateSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((eventName)=>{
        if (setSuggestion) setSuggestion(suggestion, eventName);
    }, [
        setSuggestion,
        suggestion
    ]);
    const onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        updateSuggestion('focus');
        suggestion.onSuggestionFocused();
    }, [
        updateSuggestion,
        suggestion
    ]);
    const onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        updateSuggestion('mousemove');
    }, [
        updateSuggestion
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If the item is highlighted and not hovered, scroll it into view
        if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) $d92b2ebd84590792$var$ensureElementIsVisibleInScrollContainer(listItemRef.current, hasGroupHeading ? $d92b2ebd84590792$var$STICKY_GROUP_HEADER_HEIGHT : 0);
    }, [
        listItemRef,
        highlighted,
        hasGroupHeading
    ]);
    const chevronRight = (0, $cozmU.useMemo)(()=>{
        if (hasChildren && !highlighted) return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0Of8r2Pgdg _1wydGWPgdg _2Zuz6Q1Y8M _1Znuxb1Y8M"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)",
                size: "small"
            })
        });
        return null;
    }, [
        hasChildren,
        highlighted
    ]);
    const statusLozengeText = suggestion.statusLozengeType && ($d92b2ebd84590792$var$statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage($d92b2ebd84590792$var$statusLozengeMessages[suggestion.statusLozengeType]) : null);
    const ariaLabel = customLabel ? customLabel : typeof suggestion.label === 'string' ? suggestion.label : formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAILabel);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: listItemRef,
        className: (0, $hekY6.default)([
            "_1LMyvKYbGa _313842Pgdg"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("button", {
            type: "button",
            onClick: suggestion.onSelect,
            onMouseMove: onMouseMove,
            "data-testid": suggestion.testId || (customLabel ? `tell-ai` : suggestion.label),
            "data-highlighted": highlighted,
            "aria-label": ariaLabel,
            onFocus: onFocus,
            className: (0, $hekY6.default)([
                "_2sNsIgmnOE _39xV02N91d _4kiQYAUF4f _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _313842Pgdg _3iDTPbQ4SZ _0aFT5v1qpb _37wbyu7p2s _0hPCNLDIqT _2fwxA5ecOK _1kk5Tku7m9 _1UtDYzy7kJ",
                "_30huDKdnbC _0bjKvDdnbC _2mHwu874nF _2uo31fYbGa _2C2kUQdnbC _1Lz9lodnbC _1FjTCx7zJH _14CzSFN4oS _2BZEPjo126 _3FwPiYXzJH _343g2kLl21 _374piqVrZW _03MxTtot27 _3NZ5zAsyl5",
                (0, $iDrrr.fg)('ai-smart-button-team-25') && "_2mHwu88HPE _39xV02N91d _2Zuz6QkG2W _1ZnuxbkG2W _0Of8r2gVvo _1wydGWgVvo _313842Pgdg _1DCdHiPgdg _2XsHFMPgdg _0adFHsPgdg _3iDTPbQ4SZ _37wbyu7p2s _0hPCNLDIqT _2fwxA5ecOK _1kk5Tku7m9 _1UtDYzy7kJ",
                (0, $iDrrr.fg)('ai-smart-button-team-25') && "_30huDKdnbC _2uo31fYbGa _4kiQYAS40j _1FjTCx7zJH _14CzSFN4oS _2BZEPjo126 _3FwPiYXzJH _343g2kLl21 _374piqVrZW _03MxTtot27 _3NZ5zAsyl5",
                suggestion.value.includes('agent:') && "_4kiQYA298P"
            ]),
            children: [
                !suggestion.hideIcon && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VoWWg _39xV02oWWg",
                        "_2crE4roWWg _1aUa7rSPN1",
                        (0, $iDrrr.fg)('ai-smart-button-team-25') && "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
                        (0, $iDrrr.fg)('ai-smart-button-team-25') && "_0jFU0VVa5s _39xV02Va5s",
                        !suggestion.isAgent && (0, $iDrrr.fg)('ai-smart-button-team-25') && "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
                        suggestion.value.includes('agent:') && "_0jFU0VUofl _39xV02Uofl"
                    ]),
                    children: suggestion.icon || ((0, $iDrrr.fg)('ai-smart-button-team-25') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
                        spacing: "spacious",
                        label: ""
                    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a13d4ac91e417573$export$77af5b11f07c3aed), {
                        className: "default-icon",
                        alt: ''
                    }))
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    direction: "column",
                    xcss: $d92b2ebd84590792$var$contentStyles.default,
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                            alignItems: "center",
                            children: [
                                !customLabel ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    children: suggestion.label
                                }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                                            className: (0, $hekY6.default)([
                                                "_1kk5Tkf7mX _0adFHs1Y8M"
                                            ]),
                                            children: customLabel
                                        }),
                                        ' "',
                                        suggestion.label,
                                        '"'
                                    ]
                                }),
                                statusLozengeText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                                    alignItems: "center",
                                    xcss: $d92b2ebd84590792$var$statusStyles.default,
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                                        appearance: "discovery",
                                        children: statusLozengeText
                                    })
                                })
                            ]
                        }),
                        suggestion.description && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                            className: (0, $hekY6.default)([
                                "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2sNsIg7NXe _0QpwdFIZbP _1T2N03wPeg _4ouGXI8i9X _39HuIbz8Lp _1ANEUSLRg7 _1UtDYzKGUX _3iDTPbvbI6",
                                "_26BoRwEbN9"
                            ]),
                            children: suggestion.description
                        })
                    ]
                }),
                suggestion.rightText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: suggestion.rightText
                }),
                suggestion.value !== 'no-suggestions' && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbYbGa _0jFU0VSPN1 _39xV02SPN1 _1UtDYzZpcK _0KLXruo126",
                        "_0bjKvDzXzM _1h2CcLccYA _27M2T3DIqT _4cVsumDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4b738c5d4441c77c$export$2e2bcd8739ae039), {})
                }),
                chevronRight
            ]
        })
    });
};



const $f3206b6186a9646a$var$suggestionsContainerStylesUnbounded = null;
const $f3206b6186a9646a$var$suggestionsContainerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $f3206b6186a9646a$var$suggestionsHeadingStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $f3206b6186a9646a$var$suggestionsGroupStyles = null;
const $f3206b6186a9646a$var$suggestionsScrollerPostGAStyles = {
    default: "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _2WAcuGIZbP"
};
const $f3206b6186a9646a$var$suggestionsContainerTeam25Styles = null;
function $f3206b6186a9646a$export$5b54ed2fa23d62e9(output, suggestion) {
    let suggestionGroup;
    if (typeof suggestion.groupHeading === 'function') suggestionGroup = suggestion.groupHeading();
    else suggestionGroup = suggestion.groupHeading || '';
    let existingRecordIndex = output.findIndex((s)=>s.groupHeading === suggestionGroup); // If the group doesn't exist, create it
    if (existingRecordIndex === -1) {
        const suggestionsLength = output.push({
            groupHeading: suggestionGroup,
            suggestions: []
        });
        existingRecordIndex = suggestionsLength - 1;
    }
    output[existingRecordIndex].suggestions.push(suggestion);
    return output;
}
const $f3206b6186a9646a$export$7463f42be087e7d6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { suggestionsHeading: suggestionsHeading, suggestions: suggestions, value: value, setSuggestion: setSuggestion, hideGroupHeading: hideGroupHeading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const ignoreMouseMoveRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    let t1;
    if ($[0] !== setSuggestion) {
        t1 = (suggestion, eventName)=>{
            if (!setSuggestion) return;
            if (eventName === "mousemove" && ignoreMouseMoveRef.current) return;
            setSuggestion(suggestion);
        };
        $[0] = setSuggestion;
        $[1] = t1;
    } else t1 = $[1];
    const smoothSetSuggestion = t1;
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (!scrollerRef.current) return;
            const allowMouseTracking = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
                ignoreMouseMoveRef.current = false;
            }, 75);
            const onScrollEvent = ()=>{
                ignoreMouseMoveRef.current = true;
                allowMouseTracking();
            };
            const scroller = scrollerRef.current;
            scroller.addEventListener("scroll", onScrollEvent);
            scroller.addEventListener("scrollend", onScrollEvent);
            return ()=>{
                scroller.removeEventListener("scroll", onScrollEvent);
                scroller.removeEventListener("scrollend", onScrollEvent);
            };
        };
        t3 = [
            scrollerRef
        ];
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t2, t3);
    let t4;
    if ($[4] !== formatMessage) {
        t4 = formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAILabel);
        $[4] = formatMessage;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== formatMessage) {
        t5 = formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAgentLabel);
        $[6] = formatMessage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            "tell-ai": t4,
            "tell-agent": t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const customLabelMap = t6;
    let t7;
    if ($[11] !== customLabelMap || $[12] !== hideGroupHeading || $[13] !== smoothSetSuggestion || $[14] !== value) {
        t7 = (suggestionGroup)=>{
            const groupHeadingId = `list-heading-${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(suggestionGroup.groupHeading)}`;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    suggestionGroup.groupHeading && !hideGroupHeading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1162cfcdbbc7d12a$export$b7bc1538a6ef0630), {
                        id: groupHeadingId,
                        heading: suggestionGroup.groupHeading
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
                        "aria-labelledby": groupHeadingId,
                        "data-testid": `suggestion-group-${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(suggestionGroup.groupHeading || "Atlassian intelligence")}`,
                        className: (0, $hekY6.default)([
                            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC"
                        ]),
                        children: suggestionGroup.suggestions.map((suggestion_0)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $d92b2ebd84590792$export$a7b06bfba60a8a78), {
                                suggestion: suggestion_0,
                                customLabel: customLabelMap[suggestion_0.value] || undefined,
                                highlighted: suggestion_0.value === value,
                                setSuggestion: smoothSetSuggestion,
                                hasGroupHeading: !!suggestionGroup.groupHeading && !hideGroupHeading
                            }, suggestion_0.value))
                    }, (0, $4o0zT.isExperimentEnabled)("platform_editor_fix_missing_suggestions_key") ? undefined : `group_${suggestionGroup.groupHeading}`)
                ]
            }, (0, $4o0zT.isExperimentEnabled)("platform_editor_fix_missing_suggestions_key") ? `group_${suggestionGroup.groupHeading}` : undefined);
        };
        $[11] = customLabelMap;
        $[12] = hideGroupHeading;
        $[13] = smoothSetSuggestion;
        $[14] = value;
        $[15] = t7;
    } else t7 = $[15];
    const mapSuggestionsCallback = t7;
    let t8;
    if ($[16] !== mapSuggestionsCallback || $[17] !== suggestions) {
        t8 = (suggestions || []).reduce($f3206b6186a9646a$export$5b54ed2fa23d62e9, []).map(mapSuggestionsCallback);
        $[16] = mapSuggestionsCallback;
        $[17] = suggestions;
        $[18] = t8;
    } else t8 = $[18];
    const renderedGroupSuggestions = t8;
    if (!renderedGroupSuggestions.length) return null;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = {
            borderTop: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)"
        };
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== suggestionsHeading) {
        t10 = suggestionsHeading && /*#__PURE__*/ (0, $8aG6j.jsx)("h2", {
            className: (0, $hekY6.default)([
                "_12pLkP7NXe _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _3gZsD7gVvo _27WIHE8HPE _11DXJJgVvo _4GiLnv8HPE _4CI8LVmb2E _1yGjhvAv7U _4vhRtvZpcK"
            ]),
            children: suggestionsHeading
        });
        $[20] = suggestionsHeading;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            (0, $iDrrr.fg)("ai-smart-button-team-25") && "_1LMyvKYbGa _1mT5xdRAKS _39xV02N91d _0jFU0VN91d _2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg _1wydGW8HPE",
            !(0, $iDrrr.fg)("ai-smart-button-team-25") && "_1LMyvKYbGa _39xV02N91d _0jFU0VN91d _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _3iDTPbvbI6 _1mT5xdRAKS",
            !(0, $iDrrr.fg)("ai-smart-button-team-25") && "_4zeWN6OLYo _2AnQIlOLYo _2YIu6KOLYo _1h1IrNOLYo"
        ]);
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== renderedGroupSuggestions || $[24] !== t11) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "editor-plugin-ai-suggestion-list",
            id: "suggestion-list",
            className: t11,
            children: renderedGroupSuggestions
        });
        $[23] = renderedGroupSuggestions;
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== t10 || $[27] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            testId: "suggestions-container",
            xcss: $f3206b6186a9646a$var$suggestionsScrollerPostGAStyles.default,
            ref: scrollerRef,
            style: t9,
            children: [
                t10,
                t12
            ]
        });
        $[26] = t10;
        $[27] = t12;
        $[28] = t13;
    } else t13 = $[28];
    return t13;
} : ({ suggestionsHeading: suggestionsHeading, suggestions: suggestions, value: value, setSuggestion: setSuggestion, hideGroupHeading: hideGroupHeading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); /**
                  * While scrolling with the mouse, the setSuggestion() function can still be
                  * called by the mousemove event in ListItem.
                  *
                  * So while the scrolling is happening, another scrollTo() is started and
                  * conflicts with the current scrolling momentum, causing the experience to
                  * jitter and feel clunky.
                  *
                  * While scrolling with just the mouse, this is the order of events:
                  * - (multiple) scroll
                  * - mousemove
                  * - (multiple) scroll
                  * - mousemove
                  * - scrollend
                  *
                  * However, if the user leaves the cursor over the list while navigating with
                  * the keyboard and it scrolls to ensure items are visible, the order of
                  * events is:
                  * - (multiple) on scroll
                  * - scrollend
                  * - mousemove
                  *
                  * So to avoid the mousemove from triggering a change, we set a flag to
                  * ignore mousemove events until a bit after its over.
                  */ 
    const ignoreMouseMoveRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false);
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const smoothSetSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((suggestion, eventName)=>{
        if (!setSuggestion) return;
         // Ignore mousemove
        if (eventName === 'mousemove' && ignoreMouseMoveRef.current) return;
        setSuggestion(suggestion);
    }, [
        setSuggestion
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!scrollerRef.current) return;
         // Debounced handler to restore tracking after scrolling
        const allowMouseTracking = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            ignoreMouseMoveRef.current = false;
        }, 75);
        const onScrollEvent = ()=>{
            ignoreMouseMoveRef.current = true;
            allowMouseTracking();
        };
        const scroller = scrollerRef.current;
        scroller.addEventListener('scroll', onScrollEvent);
        scroller.addEventListener('scrollend', onScrollEvent);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollEvent);
            scroller.removeEventListener('scrollend', onScrollEvent);
        };
    }, [
        scrollerRef
    ]);
    const renderedGroupSuggestions = (0, $cozmU.useMemo)(()=>{
        const customLabelMap = {
            'tell-ai': formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAILabel),
            'tell-agent': formatMessage((0, $440a108957c13b90$export$defe85febe8b728c).tellAgentLabel)
        };
        const mapSuggestionsCallback = (suggestionGroup)=>{
            const groupHeadingId = `list-heading-${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(suggestionGroup.groupHeading)}`;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    suggestionGroup.groupHeading && !hideGroupHeading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1162cfcdbbc7d12a$export$b7bc1538a6ef0630), {
                        id: groupHeadingId,
                        heading: suggestionGroup.groupHeading
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("ul", {
                        "aria-labelledby": groupHeadingId,
                        "data-testid": `suggestion-group-${(0, (/*@__PURE__*/$parcel$interopDefault($hQhZW)))(suggestionGroup.groupHeading || 'Atlassian intelligence')}`,
                        className: (0, $hekY6.default)([
                            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC"
                        ]),
                        children: suggestionGroup.suggestions.map((suggestion_0)=>{
                            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d92b2ebd84590792$export$a7b06bfba60a8a78), {
                                suggestion: suggestion_0,
                                customLabel: customLabelMap[suggestion_0.value] || undefined,
                                highlighted: suggestion_0.value === value,
                                setSuggestion: smoothSetSuggestion,
                                hasGroupHeading: !!suggestionGroup.groupHeading && !hideGroupHeading
                            }, suggestion_0.value);
                        })
                    }, (0, $4o0zT.isExperimentEnabled)('platform_editor_fix_missing_suggestions_key') ? undefined : `group_${suggestionGroup.groupHeading}`)
                ]
            }, (0, $4o0zT.isExperimentEnabled)('platform_editor_fix_missing_suggestions_key') ? `group_${suggestionGroup.groupHeading}` : undefined);
        };
        return (suggestions || [] // Group suggestions by heading to make mapping to components easier later on
        ).reduce($f3206b6186a9646a$export$5b54ed2fa23d62e9, []).map(mapSuggestionsCallback);
    }, [
        formatMessage,
        smoothSetSuggestion,
        suggestions,
        value,
        hideGroupHeading
    ]);
    if (!renderedGroupSuggestions.length) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        testId: "suggestions-container",
        xcss: $f3206b6186a9646a$var$suggestionsScrollerPostGAStyles.default,
        ref: scrollerRef,
        style: {
            borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
        },
        children: [
            suggestionsHeading && /*#__PURE__*/ (0, $8aG6j.jsx)("h2", {
                className: (0, $hekY6.default)([
                    "_12pLkP7NXe _1NWIxLPgdg _1B7GoJPgdg _3M1DK5Pgdg _2EMd9WPgdg _3gZsD7gVvo _27WIHE8HPE _11DXJJgVvo _4GiLnv8HPE _4CI8LVmb2E _1yGjhvAv7U _4vhRtvZpcK"
                ]),
                children: suggestionsHeading
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                "data-testid": "editor-plugin-ai-suggestion-list",
                id: "suggestion-list",
                className: (0, $hekY6.default)([
                    (0, $iDrrr.fg)('ai-smart-button-team-25') && "_1LMyvKYbGa _1mT5xdRAKS _39xV02N91d _0jFU0VN91d _2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg _1wydGW8HPE",
                    !(0, $iDrrr.fg)('ai-smart-button-team-25') && "_1LMyvKYbGa _39xV02N91d _0jFU0VN91d _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _3iDTPbvbI6 _1mT5xdRAKS",
                    !(0, $iDrrr.fg)('ai-smart-button-team-25') && "_4zeWN6OLYo _2AnQIlOLYo _2YIu6KOLYo _1h1IrNOLYo"
                ]),
                children: renderedGroupSuggestions
            })
        ]
    });
};



var $eVwUu = parcelRequire("eVwUu");










parcelRequire("cozmU");













parcelRequire("cozmU");










const $8af04c251d31625a$var$announcementStyles = {
    default: "_0bjKvDKxmn _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE _0KLXru94rk _1UtDYzJejw"
};
const $8af04c251d31625a$export$73d84e9e372a2734 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnnouncementBannerItem(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { text: text, onClose: onClose } = t0;
    let t1;
    if ($[0] !== onClose) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: "Close",
            spacing: "compact",
            appearance: "subtle",
            onClick: onClose
        });
        $[0] = onClose;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== text) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            xcss: $8af04c251d31625a$var$announcementStyles.default,
            alignItems: "center",
            justifyContent: "space-between",
            gap: "space.050",
            children: [
                text,
                t1
            ]
        });
        $[2] = t1;
        $[3] = text;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function AnnouncementBannerItem({ text: text, onClose: onClose }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
        xcss: $8af04c251d31625a$var$announcementStyles.default,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.050",
        children: [
            text,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: 'Close',
                spacing: "compact",
                appearance: "subtle",
                onClick: onClose
            })
        ]
    });
};


const $77008daeee5173a0$var$boxStyles = {
    default: "_0Of8r22ADO _2Zuz6Q2ADO _1Znuxb2ADO _1wydGW2ADO _2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $77008daeee5173a0$export$ea375d4903c4f3dc = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnnouncementBanners(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { banners: banners } = t0;
    if (banners.length === 0) return null;
    let t1;
    if ($[0] !== banners) {
        t1 = banners.map($77008daeee5173a0$var$_temp);
        $[0] = banners;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $77008daeee5173a0$var$boxStyles.default,
            direction: "column",
            gap: "space.100",
            children: t1
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function AnnouncementBanners({ banners: banners }) {
    if (banners.length === 0) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        xcss: $77008daeee5173a0$var$boxStyles.default,
        direction: "column",
        gap: "space.100",
        children: banners.map((banner)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8af04c251d31625a$export$73d84e9e372a2734), {
                text: banner.text,
                onClose: banner.onClose
            }, banner.id))
    });
};
function $77008daeee5173a0$var$_temp(banner) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8af04c251d31625a$export$73d84e9e372a2734), {
        text: banner.text,
        onClose: banner.onClose
    }, banner.id);
}


/**
 * This function will return the next suggestion to highlight based on the
 * direction requested.
 *
 * It determines the next suggestion based off the position of the current
 * suggestion in the suggestions list and the direction requested.
 *
 * If the current suggestion is the first item in the list and the requested
 * direction is up, it will wrap around and return the last item. Similarly,
 * requesting down from the last item will wrap return the first item.
 *
 * - If the current suggestion is not found in the suggestions list, it will
 * default to the first suggestion.
 * - If the suggestions list is empty, it will return an empty string.
 * - If the direction is not recognised, it will throw an error.
 *
 * @param suggestions An array of suggestion values to cycle through.
 * @param current Value of the current suggestion highlighted.
 * @param direction Are we moving up or down the list of suggestions?
 * @returns string The next suggestion value to highlight, depending on the direction requested.
 */ const $bc3d3fe1ca26d872$export$98f66d46dcfe73ca = (suggestions, current, direction)=>{
    const currentIndex = suggestions.indexOf(current);
    const { length: length } = suggestions;
    // Got nothing to do
    if (length === 0) return '';
    if (direction === 'ArrowUp') {
        /**
       * Visualisation of what the scenarios are covering
       * - Left = out of bounds negative indexes
       * - Right = out of bounds positive indexes
       * - 0-9 = example of valid suggestion indexes
       *       Array items
       * -----[0123456789]++++++
       * <----DCB------>A-->
               Scenarios
       */ // A: Out of bounds
        if (currentIndex > length - 1) return suggestions[0];
        else if (currentIndex > 0) return suggestions[currentIndex - 1];
        else if (currentIndex === 0) return suggestions[length - 1];
        else return suggestions[0];
    } else if (direction === 'ArrowDown') {
        /**
       * Visualisation of what the scenarios are covering
       * - Left = out of bounds negative indexes
       * - Right = out of bounds positive indexes
       * - 0-9 = example of valid suggestion indexes
       *       Array items
       * -----[0123456789]++++++
       * <----BC------->A-->
               Scenarios
       */ // A: Last item or out of bounds
        if (currentIndex >= length - 1) return suggestions[0];
        else if (currentIndex < 0) return suggestions[0];
        else if (currentIndex < length - 1) return suggestions[currentIndex + 1];
    } else throw new Error('Unknown direction');
    return '';
};





const $fb63fb9e22513dca$var$message = (0, $kSwu1.defineMessages)({
    footerText: {
        id: "fabric.editor.ai.screens.UserInputCommamdPalette.footerText",
        defaultMessage: "Atlassian Intelligence"
    },
    suggestionsUpdated: {
        id: "fabric.editor.ai.experience.suggestionsUpdated",
        defaultMessage: "{numberOfSuggestions} suggestions available for typed text"
    },
    rovoProductLabel: {
        id: "fabric.editor.ai.experience.rovoAgents.productLabel",
        defaultMessage: "Rovo"
    },
    rovoProductLogoAltText: {
        id: "fabric.editor.ai.experience.rovoAgents.productLogoAltText",
        defaultMessage: "Rovo Logo"
    },
    rovoAgentsPalettePlaceholder: {
        id: "fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder",
        defaultMessage: "Tell Agent to write anything or choose from the below"
    },
    commandPaletteAriaName: {
        id: "fabric.editor.ai.experience.commandPaletteAriaName",
        defaultMessage: "Atlassian Intelligence"
    },
    commandPaletteV2Placeholder: {
        id: "fabric.editor.ai.experience.commandPaletteV2Placeholder",
        defaultMessage: "Tell AI what to do ..."
    }
});
var $fb63fb9e22513dca$export$2e2bcd8739ae039 = $fb63fb9e22513dca$var$message;


function $88666ecf9fff103f$export$e68d35e32242c79b(output, suggestion) {
    const { nestingConfig: nestingConfig } = suggestion;
    if (nestingConfig) {
        const existingIndex = output.findIndex((s)=>s.nestingConfig?.parentTitle === nestingConfig.parentTitle);
        if (existingIndex === -1) {
            const parentNestingConfig = {
                ...nestingConfig
            };
            delete parentNestingConfig.shortTitle;
            output.push({
                ...suggestion,
                testId: nestingConfig.parentTestId,
                label: nestingConfig.parentTitle || '',
                nestingConfig: parentNestingConfig,
                childSuggestions: [
                    suggestion
                ],
                value: suggestion.nestingConfig?.parentTitle || ''
            });
        } else output[existingIndex].childSuggestions?.push(suggestion);
    } else output.push(suggestion);
    return output;
}


const $bf161c1ff1d9bdff$var$columnLayout = null; /**
                            * Scroll margin is used to ensure that the modal won't be
                            * too close to the top of the editor, which may sometimes
                            * cover the modal slightly.
                            */ 
const $bf161c1ff1d9bdff$var$scrollMarginStyles = null;
const $bf161c1ff1d9bdff$var$caretHiddenStyle = null;
const $bf161c1ff1d9bdff$var$PromptHeaderWrapperStyles = {
    default: "_0Of8r28HPE _1Znuxb8HPE _2Zuz6Q8HPE _1wydGW8HPE _4kiQYAdnbC _3YEZNOdnbC"
};
const $bf161c1ff1d9bdff$var$PromptHeaderWrapperTeam25Styles = {
    default: "_2Y7lL45zaO _4c065U8HPE _4kiQYAdnbC _3YEZNOdnbC"
};
const $bf161c1ff1d9bdff$var$userInputFloatingContainerStyle = null;
const $bf161c1ff1d9bdff$export$9491b5d7f967f421 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(113);
    const { appearance: appearance, inputValue: inputValue, inputADFValue: inputADFValue, onInputUpdate: onInputUpdate, onADFUpdate: onADFUpdate, presetPromptLabel: presetPromptLabel, onSubmit: onSubmit, onEscapeKeyPressed: onEscapeKeyPressed, onRefinementTagRemove: onRefinementTagRemove, onBack: onBack, placeholder: placeholder, getSuggestions: getSuggestions, suggestionsHeading: suggestionsHeading, focusInputRef: focusInputRef, PromptEditor: PromptEditor, agent: agent, hideLegacySubmitCancelButtons: hideLegacySubmitCancelButtons, announcementBanners: announcementBanners, pageKnowledgeProps: pageKnowledgeProps, isAIFC: isAIFC } = t0;
    const promptWithSuggestionsRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isCaretHidden, setIsCaretHidden] = (0, $cozmU.useState)(false);
    const [isShowingMoreSuggestions, setIsShowingMoreSuggestions] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== onEscapeKeyPressed) {
        t1 = ()=>{
            const { current: element } = promptWithSuggestionsRef;
            if (!element) return;
            const handleEscapeKeyDown = (event)=>{
                if (event.key === "Escape") {
                    event.preventDefault();
                    event.stopPropagation();
                    onEscapeKeyPressed();
                }
            };
            const handleEscapeKeyUp = $bf161c1ff1d9bdff$var$_temp;
            return (0, $cbY7C.bindAll)(element, [
                {
                    type: "keydown",
                    listener: handleEscapeKeyDown
                },
                {
                    type: "keyup",
                    listener: handleEscapeKeyUp
                }
            ]);
        };
        t2 = [
            promptWithSuggestionsRef,
            onEscapeKeyPressed
        ];
        $[0] = onEscapeKeyPressed;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== getSuggestions) {
        t3 = (input, presetLabel)=>{
            let nestedSuggestions = getSuggestions(input) ?? [];
            nestedSuggestions = nestedSuggestions.reduce((0, $88666ecf9fff103f$export$e68d35e32242c79b), []);
            if (presetLabel) nestedSuggestions = nestedSuggestions.find((s)=>s.nestingConfig?.parentTitle === presetLabel)?.childSuggestions ?? [];
            const showMoreSuggestionIndex = nestedSuggestions.findIndex($bf161c1ff1d9bdff$var$_temp2);
            if (showMoreSuggestionIndex !== -1) {
                const originalOnSelect = nestedSuggestions[showMoreSuggestionIndex].onSelect;
                nestedSuggestions[showMoreSuggestionIndex].onSelect = ()=>{
                    originalOnSelect();
                    setIsShowingMoreSuggestions(true);
                };
            }
            return nestedSuggestions;
        };
        $[3] = getSuggestions;
        $[4] = t3;
    } else t3 = $[4];
    const getNestedSuggestions = t3;
    let t4;
    bb0: {
        if (agent) {
            let t5;
            if ($[5] !== agent || $[6] !== getSuggestions || $[7] !== inputValue) {
                t5 = getSuggestions(inputValue, agent);
                $[5] = agent;
                $[6] = getSuggestions;
                $[7] = inputValue;
                $[8] = t5;
            } else t5 = $[8];
            t4 = t5;
            break bb0;
        }
        if (!inputValue.length) {
            let t5;
            if ($[9] !== getNestedSuggestions || $[10] !== inputValue || $[11] !== presetPromptLabel) {
                t5 = getNestedSuggestions(inputValue, presetPromptLabel);
                $[9] = getNestedSuggestions;
                $[10] = inputValue;
                $[11] = presetPromptLabel;
                $[12] = t5;
            } else t5 = $[12];
            t4 = t5;
            break bb0;
        }
        let t5;
        if ($[13] !== getSuggestions || $[14] !== inputValue) {
            t5 = getSuggestions(inputValue) ?? [];
            $[13] = getSuggestions;
            $[14] = inputValue;
            $[15] = t5;
        } else t5 = $[15];
        t4 = t5;
    }
    const suggestions = t4;
    let t5;
    bb1: {
        if (isAIFC) {
            let t6;
            if ($[16] !== getNestedSuggestions || $[17] !== presetPromptLabel) {
                t6 = getNestedSuggestions("", presetPromptLabel);
                $[16] = getNestedSuggestions;
                $[17] = presetPromptLabel;
                $[18] = t6;
            } else t6 = $[18];
            t5 = t6;
            break bb1;
        }
        let t6;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = [];
            $[19] = t6;
        } else t6 = $[19];
        t5 = t6;
    }
    const allSuggestions = t5;
    const hideNestedTag = presetPromptLabel && !!suggestions.length;
    const agentRefinementTagProps = (0, $eVwUu.useAgentRefinementTagProps)(agent);
    const refinementTagRef = (0, $cozmU.useRef)(null);
    let t6;
    if ($[20] !== agentRefinementTagProps || $[21] !== onRefinementTagRemove || $[22] !== presetPromptLabel) {
        t6 = presetPromptLabel === undefined ? undefined : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bDDw8.RefinementTag), {
            ...agentRefinementTagProps,
            label: presetPromptLabel,
            ref: refinementTagRef,
            onClick: onRefinementTagRemove
        });
        $[20] = agentRefinementTagProps;
        $[21] = onRefinementTagRemove;
        $[22] = presetPromptLabel;
        $[23] = t6;
    } else t6 = $[23];
    const tag = t6;
    let t7;
    if ($[24] !== suggestions) {
        t7 = suggestions || [];
        $[24] = suggestions;
        $[25] = t7;
    } else t7 = $[25];
    let t8;
    if ($[26] !== t7) {
        t8 = t7.map($bf161c1ff1d9bdff$var$_temp3);
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    const suggestionValues = t8;
    const [currentSuggestion, _setCurrentSuggestion] = (0, $cozmU.useState)(suggestionValues.length > 0 ? suggestionValues[0] : "");
    let t9;
    if ($[28] !== suggestions) {
        t9 = (suggestion_1)=>{
            const suggestionObject = suggestions.find((s_0)=>s_0.value === suggestion_1);
            suggestionObject?.onSuggestionFocused();
        };
        $[28] = suggestions;
        $[29] = t9;
    } else t9 = $[29];
    const handleSuggestionChanged = t9;
    let t10;
    if ($[30] !== handleSuggestionChanged) {
        t10 = (newValue)=>{
            handleSuggestionChanged(newValue);
            _setCurrentSuggestion(newValue);
        };
        $[30] = handleSuggestionChanged;
        $[31] = t10;
    } else t10 = $[31];
    const setCurrentSuggestion = t10;
    let t11;
    let t12;
    if ($[32] !== currentSuggestion || $[33] !== setCurrentSuggestion || $[34] !== suggestionValues) {
        t11 = ()=>{
            if (suggestionValues.includes(currentSuggestion) || suggestionValues.length === 0) return;
            setCurrentSuggestion(suggestionValues[0]);
        };
        t12 = [
            currentSuggestion,
            suggestionValues,
            setCurrentSuggestion
        ];
        $[32] = currentSuggestion;
        $[33] = setCurrentSuggestion;
        $[34] = suggestionValues;
        $[35] = t11;
        $[36] = t12;
    } else {
        t11 = $[35];
        t12 = $[36];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[37] !== inputValue.length || $[38] !== isShowingMoreSuggestions || $[39] !== suggestionValues) {
        bb2: {
            let t14;
            if ($[41] !== suggestionValues) {
                t14 = suggestionValues.filter($bf161c1ff1d9bdff$var$_temp4);
                $[41] = suggestionValues;
                $[42] = t14;
            } else t14 = $[42];
            const allSuggestions_0 = t14;
            if (isShowingMoreSuggestions || inputValue.length > 0) {
                t13 = allSuggestions_0;
                break bb2;
            }
            const agentSuggestions = suggestionValues.filter($bf161c1ff1d9bdff$var$_temp5);
            if (agentSuggestions.length === 0 || allSuggestions_0.length <= 9 || allSuggestions_0.length - agentSuggestions.length <= 4) {
                t13 = allSuggestions_0;
                break bb2;
            }
            let remainingSuggestions = 9 - agentSuggestions.length - 1;
            if (remainingSuggestions < 4) remainingSuggestions = 4;
            t13 = [
                ...suggestionValues.slice(0, remainingSuggestions),
                "show-more",
                ...agentSuggestions
            ];
        }
        $[37] = inputValue.length;
        $[38] = isShowingMoreSuggestions;
        $[39] = suggestionValues;
        $[40] = t13;
    } else t13 = $[40];
    const visibleSuggestionValues = t13;
    let t14;
    if ($[43] !== suggestions || $[44] !== visibleSuggestionValues) {
        let t15;
        if ($[46] !== visibleSuggestionValues) {
            t15 = (suggestion_4)=>visibleSuggestionValues.includes(suggestion_4.value);
            $[46] = visibleSuggestionValues;
            $[47] = t15;
        } else t15 = $[47];
        t14 = suggestions.filter(t15);
        $[43] = suggestions;
        $[44] = visibleSuggestionValues;
        $[45] = t14;
    } else t14 = $[45];
    const output = t14;
    const visibleSuggestions = output;
    let t15;
    if ($[48] !== currentSuggestion || $[49] !== setCurrentSuggestion || $[50] !== visibleSuggestionValues) {
        t15 = (event_1)=>{
            if (event_1.metaKey || event_1.ctrlKey || event_1.altKey || event_1.shiftKey) return;
            if (visibleSuggestionValues.length <= 1) return;
            bb149: switch(event_1.key){
                case "ArrowUp":
                case "ArrowDown":
                    {
                        setIsCaretHidden(true);
                        const nextSuggestion = (0, $bc3d3fe1ca26d872$export$98f66d46dcfe73ca)(visibleSuggestionValues, currentSuggestion, event_1.key);
                        setCurrentSuggestion(nextSuggestion);
                        event_1.preventDefault();
                        event_1.stopPropagation();
                        break bb149;
                    }
                default:
                    return;
            }
        };
        $[48] = currentSuggestion;
        $[49] = setCurrentSuggestion;
        $[50] = visibleSuggestionValues;
        $[51] = t15;
    } else t15 = $[51];
    const onArrowKeyDown = t15;
    let t16;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setIsCaretHidden(false);
        }, 300);
        $[52] = t16;
    } else t16 = $[52];
    const debouncedSetIsCaretHidden = t16;
    let t17;
    if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = ()=>{
            debouncedSetIsCaretHidden();
        };
        $[53] = t17;
    } else t17 = $[53];
    const onArrowKeyUp = t17;
    let t18;
    if ($[54] !== setCurrentSuggestion) {
        t18 = (suggestion_5)=>{
            setCurrentSuggestion(suggestion_5.value);
        };
        $[54] = setCurrentSuggestion;
        $[55] = t18;
    } else t18 = $[55];
    const setSuggestion = t18;
    let t19;
    if ($[56] !== currentSuggestion || $[57] !== onSubmit || $[58] !== setCurrentSuggestion || $[59] !== suggestions) {
        t19 = ()=>{
            if (currentSuggestion === "" || suggestions?.length === 0) {
                onSubmit();
                return;
            }
            const suggestion_7 = (suggestions || []).find((suggestion_6)=>suggestion_6.value === currentSuggestion);
            if (suggestion_7) suggestion_7.onSelect();
            setCurrentSuggestion("");
        };
        $[56] = currentSuggestion;
        $[57] = onSubmit;
        $[58] = setCurrentSuggestion;
        $[59] = suggestions;
        $[60] = t19;
    } else t19 = $[60];
    const onFormSubmit = t19;
    const showLegacySubmitCancelButtons = !hideLegacySubmitCancelButtons && Boolean(presetPromptLabel && !agent);
    let t20;
    bb3: {
        const defaultPlaceholder = placeholder;
        if (agent) {
            let t21;
            if ($[61] !== formatMessage) {
                t21 = formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).rovoAgentsPalettePlaceholder);
                $[61] = formatMessage;
                $[62] = t21;
            } else t21 = $[62];
            t20 = t21;
            break bb3;
        }
        if (tag) {
            t20 = defaultPlaceholder;
            break bb3;
        }
        t20 = defaultPlaceholder;
    }
    const promptPlaceholder = t20;
    let t21;
    if ($[63] !== formatMessage || $[64] !== isAIFC || $[65] !== promptPlaceholder) {
        t21 = isAIFC ? formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).commandPaletteV2Placeholder) : promptPlaceholder;
        $[63] = formatMessage;
        $[64] = isAIFC;
        $[65] = promptPlaceholder;
        $[66] = t21;
    } else t21 = $[66];
    const t22 = hideNestedTag ? undefined : tag;
    const t23 = !!presetPromptLabel;
    let t24;
    if ($[67] !== PromptEditor || $[68] !== focusInputRef || $[69] !== inputADFValue || $[70] !== inputValue || $[71] !== isAIFC || $[72] !== onADFUpdate || $[73] !== onArrowKeyDown || $[74] !== onBack || $[75] !== onFormSubmit || $[76] !== onInputUpdate || $[77] !== showLegacySubmitCancelButtons || $[78] !== t21 || $[79] !== t22 || $[80] !== t23) {
        t24 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            testId: "prompt-header-wrapper",
            xcss: (0, $iDrrr.fg)("ai-smart-button-team-25") ? $bf161c1ff1d9bdff$var$PromptHeaderWrapperTeam25Styles.default : $bf161c1ff1d9bdff$var$PromptHeaderWrapperStyles.default,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $de21edef532dabae$export$416523684d97c4ad), {
                type: "user-input",
                showButtons: showLegacySubmitCancelButtons,
                placeholder: t21,
                value: inputValue,
                adfValue: inputADFValue,
                onFormSubmit: onFormSubmit,
                onInputChange: onInputUpdate,
                onADFChange: onADFUpdate,
                tag: t22,
                focusInputRef: focusInputRef,
                showLogo: false,
                onInputKeyDown: onArrowKeyDown,
                onInputKeyUp: onArrowKeyUp,
                PromptEditor: PromptEditor,
                enableLinks: true,
                showBack: t23,
                onBack: onBack,
                refinementTagRef: refinementTagRef,
                isAIFC: isAIFC
            })
        });
        $[67] = PromptEditor;
        $[68] = focusInputRef;
        $[69] = inputADFValue;
        $[70] = inputValue;
        $[71] = isAIFC;
        $[72] = onADFUpdate;
        $[73] = onArrowKeyDown;
        $[74] = onBack;
        $[75] = onFormSubmit;
        $[76] = onInputUpdate;
        $[77] = showLegacySubmitCancelButtons;
        $[78] = t21;
        $[79] = t22;
        $[80] = t23;
        $[81] = t24;
    } else t24 = $[81];
    const promptForm = t24;
    const t25 = isCaretHidden && "_3U2PsZjOvk";
    let t26;
    if ($[82] !== t25) {
        t26 = (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            "_1ghwDKVa5s",
            t25,
            `user-input-command-palette-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]);
        $[82] = t25;
        $[83] = t26;
    } else t26 = $[83];
    let t27;
    if ($[84] !== formatMessage) {
        t27 = formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).commandPaletteAriaName);
        $[84] = formatMessage;
        $[85] = t27;
    } else t27 = $[85];
    let t28;
    if ($[86] !== t27) {
        t28 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
            size: "large",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                children: t27
            })
        });
        $[86] = t27;
        $[87] = t28;
    } else t28 = $[87];
    let t29;
    if ($[88] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg"
        ]);
        $[88] = t29;
    } else t29 = $[88];
    let t30;
    if ($[89] !== agent || $[90] !== allSuggestions || $[91] !== announcementBanners || $[92] !== appearance || $[93] !== currentSuggestion || $[94] !== formatMessage || $[95] !== inputValue || $[96] !== isAIFC || $[97] !== onFormSubmit || $[98] !== pageKnowledgeProps || $[99] !== presetPromptLabel || $[100] !== setSuggestion || $[101] !== suggestions || $[102] !== suggestionsHeading || $[103] !== visibleSuggestions) {
        t30 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $192e8eb6b6b4a66f$export$1c1a126042a474aa), {
            onFormSubmit: onFormSubmit,
            inputValue: inputValue,
            suggestions: allSuggestions,
            setSuggestion: setSuggestion,
            showButton: !!!presetPromptLabel
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                announcementBanners && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $77008daeee5173a0$export$ea375d4903c4f3dc), {
                    banners: announcementBanners
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lnOAf.AssistiveText), {
                    assistiveText: formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).suggestionsUpdated, {
                        numberOfSuggestions: visibleSuggestions.length
                    }),
                    isInFocus: visibleSuggestions.length > 0,
                    id: "suggestions-updated",
                    "data-testid": "suggestions-updated"
                }),
                suggestions || inputValue ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f3206b6186a9646a$export$7463f42be087e7d6), {
                    appearance: appearance,
                    suggestions: visibleSuggestions,
                    suggestionsHeading: suggestionsHeading,
                    value: currentSuggestion,
                    setSuggestion: setSuggestion,
                    hideGroupHeading: !!agent
                }) : null,
                pageKnowledgeProps?.isVisible && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a999f260782bce94$export$c486b1aa62224a41), {
                    onChange: pageKnowledgeProps.onToggle,
                    isChecked: pageKnowledgeProps.isEnabled
                })
            ]
        });
        $[89] = agent;
        $[90] = allSuggestions;
        $[91] = announcementBanners;
        $[92] = appearance;
        $[93] = currentSuggestion;
        $[94] = formatMessage;
        $[95] = inputValue;
        $[96] = isAIFC;
        $[97] = onFormSubmit;
        $[98] = pageKnowledgeProps;
        $[99] = presetPromptLabel;
        $[100] = setSuggestion;
        $[101] = suggestions;
        $[102] = suggestionsHeading;
        $[103] = visibleSuggestions;
        $[104] = t30;
    } else t30 = $[104];
    let t31;
    if ($[105] !== isAIFC || $[106] !== promptForm || $[107] !== t30) {
        t31 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer), {
            disablePadding: true,
            "data-testid": "prompt-form-screen",
            rainbowBorder: false,
            enableMaxHeight: true,
            isAIFC: isAIFC,
            className: t29,
            children: [
                promptForm,
                t30
            ]
        });
        $[105] = isAIFC;
        $[106] = promptForm;
        $[107] = t30;
        $[108] = t31;
    } else t31 = $[108];
    let t32;
    if ($[109] !== t26 || $[110] !== t28 || $[111] !== t31) {
        t32 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            ref: promptWithSuggestionsRef,
            "data-testid": "user-input-command-palette-screen",
            className: t26,
            children: [
                t28,
                t31
            ]
        });
        $[109] = t26;
        $[110] = t28;
        $[111] = t31;
        $[112] = t32;
    } else t32 = $[112];
    return t32;
} : ({ appearance: appearance, inputValue: inputValue, inputADFValue: inputADFValue, onInputUpdate: onInputUpdate, onADFUpdate: onADFUpdate, presetPromptLabel: presetPromptLabel, onSubmit: onSubmit, onEscapeKeyPressed: onEscapeKeyPressed, onRefinementTagRemove: onRefinementTagRemove, onBack: onBack, placeholder: placeholder, getSuggestions: getSuggestions, suggestionsHeading: suggestionsHeading, focusInputRef: focusInputRef, PromptEditor: PromptEditor, agent: agent, hideLegacySubmitCancelButtons: hideLegacySubmitCancelButtons, announcementBanners: announcementBanners, pageKnowledgeProps: pageKnowledgeProps, isAIFC: isAIFC })=>{
    const promptWithSuggestionsRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // There is a situation when using the arrow keys to navigate through the suggestions
    // where Prosemirror will move the caret to the end of the prompt input's placeholder
    // as the placeholder is done via a content-editable bit of text. This solution allows
    // the caret to not jump around while pressing 'down' while not having to edit the core
    // functionality of Prosemirror.
    const [isCaretHidden, setIsCaretHidden] = (0, $cozmU.useState)(false);
    const [isShowingMoreSuggestions, setIsShowingMoreSuggestions] = (0, $cozmU.useState)(false); /**
                                                                                    * Scroll prompt into view as suggestions are not always fully visible
                                                                                    * when PromptInput is autofocused.
                                                                                    *
                                                                                    * Note: We use useLayoutEffect here vs useEffect as it is synchronous and operates
                                                                                    * after the DOM has been updated with all mutations etc. This is important as
                                                                                    * Safari has a bug where it can not correctly calculate scroll positions and glitches
                                                                                    * out causing all content to disappear without it.
                                                                                    *
                                                                                    * Performance implications should be minimal as we are not affecting the rendering
                                                                                    * of content, but rather using it for calculations and triggering scroll events.
                                                                                    *
                                                                                    * https://kentcdodds.com/blog/useeffect-vs-uselayouteffect
                                                                                    *
                                                                                    * ᕕ( ᐛ )ᕗ
                                                                                    */ 
    (0, $cozmU.useLayoutEffect)(()=>{
        // Add event listener to handle escape key press
        const { current: element } = promptWithSuggestionsRef; // If the element is not mounted, do nothing
        if (!element) return;
         /**
       * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
       * other escape key handlers will not override this behaviour.
       * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
       */ 
        const handleEscapeKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onEscapeKeyPressed();
            }
        }; /**
        * Handle KeyUp event to prevent unexpected escape behaviours when
        * there are other escape handlers outside of component (e.g. in product)
        */ 
        const handleEscapeKeyUp = (event_0)=>{
            if (event_0.key !== 'Escape') return;
            event_0.preventDefault();
            event_0.stopPropagation();
        };
        return (0, $cbY7C.bindAll)(element, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        promptWithSuggestionsRef,
        onEscapeKeyPressed
    ]);
    const getNestedSuggestions = (0, $cozmU.useCallback)((input, presetLabel)=>{
        let nestedSuggestions = getSuggestions(input) ?? [];
        nestedSuggestions = nestedSuggestions.reduce((0, $88666ecf9fff103f$export$e68d35e32242c79b), []);
        if (presetLabel) nestedSuggestions = nestedSuggestions.find((s)=>s.nestingConfig?.parentTitle === presetLabel)?.childSuggestions ?? [];
        const showMoreSuggestionIndex = nestedSuggestions.findIndex((suggestion)=>suggestion.value === 'show-more');
        if (showMoreSuggestionIndex !== -1) {
            const originalOnSelect = nestedSuggestions[showMoreSuggestionIndex].onSelect;
            nestedSuggestions[showMoreSuggestionIndex].onSelect = ()=>{
                originalOnSelect();
                setIsShowingMoreSuggestions(true);
            };
        }
        return nestedSuggestions;
    }, [
        getSuggestions
    ]);
    const suggestions = (0, $cozmU.useMemo)(()=>{
        if (agent) return getSuggestions(inputValue, agent);
        if (!inputValue.length) return getNestedSuggestions(inputValue, presetPromptLabel);
        return getSuggestions(inputValue) ?? [];
    }, [
        agent,
        getSuggestions,
        getNestedSuggestions,
        inputValue,
        presetPromptLabel
    ]);
    const allSuggestions = (0, $cozmU.useMemo)(()=>{
        if (isAIFC) return getNestedSuggestions('', presetPromptLabel);
        return [];
    }, [
        getNestedSuggestions,
        presetPromptLabel,
        isAIFC
    ]);
    const hideNestedTag = (0, $cozmU.useMemo)(()=>{
        return presetPromptLabel && !!suggestions.length;
    }, [
        suggestions,
        presetPromptLabel
    ]);
    const agentRefinementTagProps = (0, $eVwUu.useAgentRefinementTagProps)(agent);
    const refinementTagRef = (0, $cozmU.useRef)(null);
    const tag = (0, $cozmU.useMemo)(()=>{
        return presetPromptLabel === undefined ? undefined : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bDDw8.RefinementTag // Ignored via go/ees005
        ), {
            ...agentRefinementTagProps,
            label: presetPromptLabel,
            ref: refinementTagRef,
            onClick: onRefinementTagRemove
        });
    }, [
        agentRefinementTagProps,
        presetPromptLabel,
        onRefinementTagRemove,
        refinementTagRef
    ]);
    const suggestionValues = (0, $cozmU.useMemo)(()=>{
        return (suggestions || []).map((suggestion_0)=>suggestion_0.value);
    }, [
        suggestions
    ]);
    const [currentSuggestion, _setCurrentSuggestion] = (0, $cozmU.useState)(suggestionValues.length > 0 ? suggestionValues[0] : ''); /**
                                                                                                                                * Handles the behaviour for when a user changes the suggestion.
                                                                                                                                *
                                                                                                                                * At the moment this is used to highlight the entire editor document for
                                                                                                                                * relevant suggestions.
                                                                                                                                */ 
    const handleSuggestionChanged = (0, $cozmU.useCallback)((suggestion_1)=>{
        const suggestionObject = suggestions.find((s_0)=>s_0.value === suggestion_1);
        suggestionObject?.onSuggestionFocused();
    }, [
        suggestions
    ]);
    const setCurrentSuggestion = (0, $cozmU.useCallback)((newValue)=>{
        handleSuggestionChanged(newValue);
        _setCurrentSuggestion(newValue);
    }, [
        _setCurrentSuggestion,
        handleSuggestionChanged
    ]); // Select first option by default
    (0, $cozmU.useEffect)(()=>{
        if (suggestionValues.includes(currentSuggestion) || suggestionValues.length === 0) return;
        setCurrentSuggestion(suggestionValues[0]);
    }, [
        currentSuggestion,
        suggestionValues,
        setCurrentSuggestion
    ]); // Calculate visible suggestions list
    const visibleSuggestionValues = (0, $cozmU.useMemo)(()=>{
        const allSuggestions_0 = suggestionValues.filter((suggestion_2)=>suggestion_2 !== 'show-more');
        if (isShowingMoreSuggestions || inputValue.length > 0) return allSuggestions_0;
        const agentSuggestions = suggestionValues.filter((suggestion_3)=>suggestion_3.startsWith('agent:'));
        const minNumOfGeneralSuggestions = 4;
        const maximumResultCount = 9;
        if (agentSuggestions.length === 0 || allSuggestions_0.length <= maximumResultCount || // If we only have the min. number of suggestions,
        // we return the full list because we don't need to show the show more button
        allSuggestions_0.length - agentSuggestions.length <= minNumOfGeneralSuggestions) return allSuggestions_0;
         // The maximum number of suggestions is 8 when agents are present
        // We take the extra 1 so that we can put the show more button in place
        // of the last expected suggestion.
        let remainingSuggestions = maximumResultCount - agentSuggestions.length - 1; // If the user favourites enough agents, the resulting count will be negative and
        // force the entire list to show. We want to encourage it to limit the slicing to 1
        // item in this case.
        if (remainingSuggestions < minNumOfGeneralSuggestions) remainingSuggestions = minNumOfGeneralSuggestions;
        return [
            ...suggestionValues.slice(0, remainingSuggestions),
            'show-more',
            ...agentSuggestions
        ];
    }, [
        inputValue.length,
        isShowingMoreSuggestions,
        suggestionValues
    ]);
    const visibleSuggestions = (0, $cozmU.useMemo)(()=>{
        const output = suggestions.filter((suggestion_4)=>visibleSuggestionValues.includes(suggestion_4.value));
        return output;
    }, [
        suggestions,
        visibleSuggestionValues
    ]);
    const onArrowKeyDown = (0, $cozmU.useCallback)((event_1)=>{
        // Ignore if any key modifiers are held
        if (event_1.metaKey || event_1.ctrlKey || event_1.altKey || event_1.shiftKey) return;
         // If theres one or fewer suggestions, no need to navigate and allow normal
        // multiline text traversal
        if (visibleSuggestionValues.length <= 1) return;
        switch(event_1.key){
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    setIsCaretHidden(true);
                    const nextSuggestion = (0, $bc3d3fe1ca26d872$export$98f66d46dcfe73ca)(visibleSuggestionValues, currentSuggestion, event_1.key);
                    setCurrentSuggestion(nextSuggestion);
                    event_1.preventDefault();
                    event_1.stopPropagation();
                    break;
                }
            default:
                return;
        }
    }, [
        currentSuggestion,
        setCurrentSuggestion,
        visibleSuggestionValues
    ]);
    const debouncedSetIsCaretHidden = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setIsCaretHidden(false);
        }, 300), []);
    const onArrowKeyUp = (0, $cozmU.useCallback)(()=>{
        debouncedSetIsCaretHidden();
    }, [
        debouncedSetIsCaretHidden
    ]);
    const setSuggestion = (0, $cozmU.useCallback)((suggestion_5)=>{
        setCurrentSuggestion(suggestion_5.value);
    }, [
        setCurrentSuggestion
    ]);
    const onFormSubmit = (0, $cozmU.useCallback)(()=>{
        if (currentSuggestion === '' || suggestions?.length === 0) {
            onSubmit();
            return;
        }
        const suggestion_7 = (suggestions || []).find((suggestion_6)=>suggestion_6.value === currentSuggestion);
        if (suggestion_7) suggestion_7.onSelect();
        setCurrentSuggestion('');
    }, [
        currentSuggestion,
        suggestions,
        setCurrentSuggestion,
        onSubmit
    ]); // if a refinement tag like brainstorm was selected, we continue showing these legacy buttons
    const showLegacySubmitCancelButtons = !hideLegacySubmitCancelButtons && Boolean(presetPromptLabel && !agent);
    const promptPlaceholder = (0, $cozmU.useMemo)(()=>{
        const defaultPlaceholder = placeholder;
        if (agent) return formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).rovoAgentsPalettePlaceholder);
        if (tag) return defaultPlaceholder;
        return defaultPlaceholder;
    }, [
        agent,
        formatMessage,
        placeholder,
        tag
    ]);
    const promptForm = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        testId: "prompt-header-wrapper",
        xcss: (0, $iDrrr.fg)('ai-smart-button-team-25') ? $bf161c1ff1d9bdff$var$PromptHeaderWrapperTeam25Styles.default : $bf161c1ff1d9bdff$var$PromptHeaderWrapperStyles.default,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $de21edef532dabae$export$416523684d97c4ad), {
            type: "user-input",
            showButtons: showLegacySubmitCancelButtons,
            placeholder: isAIFC ? formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).commandPaletteV2Placeholder) : promptPlaceholder,
            value: inputValue,
            adfValue: inputADFValue,
            onFormSubmit: onFormSubmit,
            onInputChange: onInputUpdate,
            onADFChange: onADFUpdate,
            tag: hideNestedTag ? undefined : tag,
            focusInputRef: focusInputRef,
            showLogo: false,
            onInputKeyDown: onArrowKeyDown,
            onInputKeyUp: onArrowKeyUp,
            PromptEditor: PromptEditor,
            enableLinks: true,
            showBack: !!presetPromptLabel,
            onBack: onBack,
            refinementTagRef: refinementTagRef,
            isAIFC: isAIFC
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        ref: promptWithSuggestionsRef,
        "data-testid": "user-input-command-palette-screen",
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            "_1ghwDKVa5s",
            isCaretHidden && "_3U2PsZjOvk",
            `user-input-command-palette-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: "large",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).commandPaletteAriaName)
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $btrDv.FloatingContainer // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ), {
                disablePadding: true,
                "data-testid": "prompt-form-screen",
                rainbowBorder: false,
                enableMaxHeight: true,
                isAIFC: isAIFC,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _0aFT5vbt8w _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg"
                ]),
                children: [
                    promptForm,
                    isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $192e8eb6b6b4a66f$export$1c1a126042a474aa), {
                        onFormSubmit: onFormSubmit,
                        inputValue: inputValue,
                        suggestions: allSuggestions,
                        setSuggestion: setSuggestion,
                        showButton: !!!presetPromptLabel
                    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                        children: [
                            announcementBanners && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $77008daeee5173a0$export$ea375d4903c4f3dc), {
                                banners: announcementBanners
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lnOAf.AssistiveText), {
                                assistiveText: formatMessage((0, $fb63fb9e22513dca$export$2e2bcd8739ae039).suggestionsUpdated, {
                                    numberOfSuggestions: visibleSuggestions.length
                                }),
                                isInFocus: visibleSuggestions.length > 0,
                                id: "suggestions-updated",
                                "data-testid": "suggestions-updated"
                            }),
                            suggestions || inputValue ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f3206b6186a9646a$export$7463f42be087e7d6), {
                                appearance: appearance,
                                suggestions: visibleSuggestions,
                                suggestionsHeading: suggestionsHeading,
                                value: currentSuggestion,
                                setSuggestion: setSuggestion,
                                hideGroupHeading: !!agent
                            }) : null,
                            pageKnowledgeProps?.isVisible && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a999f260782bce94$export$c486b1aa62224a41), {
                                onChange: pageKnowledgeProps.onToggle,
                                isChecked: pageKnowledgeProps.isEnabled
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
function $bf161c1ff1d9bdff$var$_temp(event_0) {
    if (event_0.key !== "Escape") return;
    event_0.preventDefault();
    event_0.stopPropagation();
}
function $bf161c1ff1d9bdff$var$_temp2(suggestion) {
    return suggestion.value === "show-more";
}
function $bf161c1ff1d9bdff$var$_temp3(suggestion_0) {
    return suggestion_0.value;
}
function $bf161c1ff1d9bdff$var$_temp4(suggestion_2) {
    return suggestion_2 !== "show-more";
}
function $bf161c1ff1d9bdff$var$_temp5(suggestion_3) {
    return suggestion_3.startsWith("agent:");
}





































var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $dSCNl = parcelRequire("dSCNl");




const $5a75e9639a524770$var$_default_1 = (0, $kSwu1.defineMessages)({
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-1",
        defaultMessage: "Summarize this pull request."
    },
    bitbucketPullRequestsPrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-3",
        defaultMessage: "Summarize the comments on this pull request."
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-1",
        defaultMessage: "Explain this file."
    },
    bitbucketRepositorySourcePrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW
    confluencePageViewPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT
    confluencePageEditPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-1",
        defaultMessage: "Find Jira work items that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-2",
        defaultMessage: "What Jira work items are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-3",
        defaultMessage: "What Jira work items have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-4",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-1",
        defaultMessage: "Are there any similar Jira work items to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-3",
        defaultMessage: "What labels could I add to this work item?"
    },
    jiraIssueViewPrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA PROJECT
    jiraProjectPrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-2",
        defaultMessage: "Are any Jira work items blocked?"
    },
    jiraProjectPrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-3",
        defaultMessage: "List Jira work items that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-4",
        defaultMessage: "How many work items are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-5",
        defaultMessage: "Has `person` commented on any Jira work items in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-6",
        defaultMessage: "What Jira work items are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-7",
        defaultMessage: "What Jira work items have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-10",
        defaultMessage: "Find and group similar Jira work items."
    },
    jiraProjectPrompt10: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-11",
        defaultMessage: "Are there any Jira work items not connected to a parent work item?"
    },
    jiraProjectPrompt11: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-12",
        defaultMessage: "Take `Jira work item` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-13",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraProjectPrompt13: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-14",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-15",
        defaultMessage: "What should I work on next?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-7",
        defaultMessage: "What should I work on next?"
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    // LLM LABELS
    // CONFLUENCE_HOME
    confluenceHomeLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-1",
        defaultMessage: "About this space"
    },
    confluenceHomeLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-2",
        defaultMessage: "Insights on this space"
    },
    confluenceHomeLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-3",
        defaultMessage: "Space suggestion"
    },
    // CONFLUENCE_PAGE_VIEW
    confluencePageLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-1",
        defaultMessage: "About this page"
    },
    confluencePageLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-2",
        defaultMessage: "More from this page"
    },
    confluencePageLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-3",
        defaultMessage: "Insights on this page"
    },
    confluencePageLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-3",
        defaultMessage: "Page suggestion"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1",
        defaultMessage: "About this whiteboard"
    },
    confluenceWhiteboardLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2",
        defaultMessage: "More from this whiteboard"
    },
    confluenceWhiteboardLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3",
        defaultMessage: "Insights on this whiteboard"
    },
    // JIRA ISSUE VIEW
    jiraIssueLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-1",
        defaultMessage: "About this work item"
    },
    jiraIssueLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-2",
        defaultMessage: "More from this work item"
    },
    jiraIssueLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-3",
        defaultMessage: "Insights on this work item"
    },
    jiraIssueLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-4",
        defaultMessage: "Work item suggestion"
    },
    // JIRA PROJECT
    jiraProjectLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-1",
        defaultMessage: "About this project"
    },
    jiraProjectLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-2",
        defaultMessage: "Insights on this project"
    },
    jiraProjectLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-3",
        defaultMessage: "More from this project"
    },
    jiraProjectLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-4",
        defaultMessage: "Project suggestion"
    },
    // UNKNOWN
    unknownLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.unknown-llm-label-1",
        defaultMessage: "Suggestion"
    },
    jiraHomePrompt1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh",
        defaultMessage: "Find Jira work items that have been updated this week."
    },
    jiraHomePrompt2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh",
        defaultMessage: "What Jira work items are the highest priority?"
    },
    jiraHomePrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh",
        defaultMessage: "What Jira work items have comments mentioning me?"
    },
    jiraHomePrompt4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraIssueViewPrompt1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh",
        defaultMessage: "Are there any similar Jira work items to this one?"
    },
    jiraIssueViewPrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh",
        defaultMessage: "What labels could I add to this work item?"
    },
    jiraProjectPrompt2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh",
        defaultMessage: "Are any Jira work items blocked?"
    },
    jiraProjectPrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh",
        defaultMessage: "List Jira work items that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh",
        defaultMessage: "How many work items are assigned to `person`?"
    },
    jiraProjectPrompt5IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh",
        defaultMessage: "Has `person` commented on any Jira work items in this sprint?"
    },
    jiraProjectPrompt6IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh",
        defaultMessage: "What Jira work items are unassigned?"
    },
    jiraProjectPrompt7IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh",
        defaultMessage: "What Jira work items have been open the longest?"
    },
    jiraProjectPrompt9IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh",
        defaultMessage: "Find and group similar Jira work items."
    },
    jiraProjectPrompt10IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh",
        defaultMessage: "Are there any Jira work items not connected to a parent work item?"
    },
    jiraProjectPrompt11IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh",
        defaultMessage: "Take `Jira work item` description and align it to best-practice."
    },
    jiraProjectPrompt12IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraProjectPrompt13IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh",
        defaultMessage: "Create a description template for user stories."
    },
    jiraIssueLLMLabel1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh",
        defaultMessage: "About this work item"
    },
    jiraIssueLLMLabel2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh",
        defaultMessage: "More from this work item"
    },
    jiraIssueLLMLabel3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh",
        defaultMessage: "Insights on this work item"
    },
    jiraIssueLLMLabel4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh",
        defaultMessage: "Work item suggestion"
    }
});
var $5a75e9639a524770$export$2e2bcd8739ae039 = $5a75e9639a524770$var$_default_1;



var $cVsLo = parcelRequire("cVsLo");

const $5eadfa012a102291$export$7ac3a88d34a76e7 = (arr)=>{
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [
            arr[j],
            arr[i]
        ];
    }
    return arr;
};









const $a0a86a6cd3285d4d$export$16170b6653b94b8e = {
    [(0, $cVsLo.PageContextType).CONFLUENCE_HOME]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomeLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomeLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomeLLMLabel3
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel3
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel4
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel3
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel3
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageLLMLabel4
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_HOME]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel3
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel4
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueLLMLabel3
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueLLMLabel4
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_PROJECT]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel1
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel2
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel3
        },
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectLLMLabel4
        }
    ],
    [(0, $cVsLo.PageContextType).UNKNOWN]: [
        {
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).unknownLLMLabel1
        }
    ]
};



const $ec7cb3d0ca18468b$export$7f12a4d44b4b382b = (pageContextType)=>{
    /**
   * To avoid repetition, this function shuffles the labels array
   * and for every function call, it always get the next one in the shuffled array.
   *
   * Using `useMemo`, this function will reset the labelsShuffled when pageContextType changes.
   * so it will always randomise the correct labels for the current pageContextType.
   */ const getLLMLabel = (0, $cozmU.useMemo)(()=>{
        const labelsByPageType = (0, $a0a86a6cd3285d4d$export$16170b6653b94b8e)[pageContextType];
        if (!labelsByPageType) return ()=>({
                labelText: undefined,
                currentLabelIndex: -1
            });
        const shuffledLabels = (0, $5eadfa012a102291$export$7ac3a88d34a76e7)(labelsByPageType);
        let labelIndex = 0;
        return ()=>{
            const currentLabelIndex = labelIndex;
            const labelText = shuffledLabels[labelIndex];
            // make sure the index loops back to the beginning of the array
            labelIndex = (labelIndex + 1) % shuffledLabels.length;
            return {
                labelText: labelText,
                currentLabelIndex: currentLabelIndex
            };
        };
    }, [
        pageContextType
    ]);
    return {
        getLLMLabel: getLLMLabel
    };
};



var $iGU0L = parcelRequire("iGU0L");

const $bf5a144e395ed2fe$var$PAGE_TYPE_CONVERSATION_STARTERS = {
    [(0, $cVsLo.PageContextType).BITBUCKET_PULL_REQUEST]: [
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt3
        }
    ],
    [(0, $cVsLo.PageContextType).BITBUCKET_REPOSITORY_SOURCE]: [
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt3
        }
    ],
    [(0, $cVsLo.PageContextType).BITBUCKET]: [
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).bitbucketPrompt3
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_HOME]: [
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt11
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_PAGE_VIEW]: [
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageViewPrompt6
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_WHITEBOARD]: [
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceWhiteboardPrompt4
        }
    ],
    [(0, $cVsLo.PageContextType).CONFLUENCE_PAGE_EDIT]: [
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluencePageEditPrompt4
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_HOME]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt6
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_ISSUE_VIEW]: [
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraIssueViewPrompt4
        }
    ],
    [(0, $cVsLo.PageContextType).JIRA_PROJECT]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraProjectPrompt14
        }
    ],
    [(0, $cVsLo.PageContextType).ATLAS_HOME]: [
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).atlasHomePrompt7
        }
    ],
    [(0, $cVsLo.PageContextType).UNKNOWN]: [
        {
            labelType: 'find-information',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $5a75e9639a524770$export$2e2bcd8739ae039).unknownPrompt3
        }
    ],
    [(0, $cVsLo.PageContextType).ADMIN_HUB]: []
};
const $bf5a144e395ed2fe$var$getRandomStarters = (starters, num)=>{
    // Return the first `num` items
    return (0, $5eadfa012a102291$export$7ac3a88d34a76e7)(starters).slice(0, num);
};
const $bf5a144e395ed2fe$var$getConversationStarterLimit = (isFullscreen)=>isFullscreen ? 6 : 3;
const $bf5a144e395ed2fe$export$640585e02de0f425 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onError: onError, onSuccess: onSuccess, onInit: onInit })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageContextType = (0, $iGU0L.usePageContextType)();
    const { fullScreen: fullScreen } = (0, $dSCNl.useUIConfig)();
    const [didTimeOut, setDidTimeOut] = (0, $cozmU.useState)(false);
    const [starters, setStarters] = (0, $cozmU.useState)(new Array(3).fill(null));
    const timeoutRef = (0, $cozmU.useRef)(null);
    const cancelTimeout = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }, []);
    const staticContextualConversationStarters = (0, $cozmU.useMemo)(()=>{
        const contextualStarters = $bf5a144e395ed2fe$var$PAGE_TYPE_CONVERSATION_STARTERS[pageContextType].map((starter)=>{
            return {
                labelType: starter.labelType,
                message: formatMessage(starter.message),
                type: 'static'
            };
        });
        const conversationStarterLimit = $bf5a144e395ed2fe$var$getConversationStarterLimit(fullScreen ?? false);
        // We don't need to shuffle the starters when the page context type is unknown
        const staticContextualStarters = pageContextType === (0, $cVsLo.PageContextType).UNKNOWN ? contextualStarters.slice(0, conversationStarterLimit) : $bf5a144e395ed2fe$var$getRandomStarters(contextualStarters, conversationStarterLimit);
        return staticContextualStarters;
    }, [
        pageContextType,
        fullScreen,
        formatMessage
    ]);
    const { getLLMLabel: getLLMLabel } = (0, $ec7cb3d0ca18468b$export$7f12a4d44b4b382b)(pageContextType);
    const { mutate: getDynamicContextualStarters, error: error, isSubmitting: isSubmitting } = (0, $kuIhJ.useMutation)({
        mutationFn: async ({ fallbackStarters: fallbackStarters, userDefinedStarters: userDefinedStarters = [], locationUrl: browser_url })=>{
            onInit?.();
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                name: (0, $irnO2.ExperienceName).FETCH_CONTEXTUAL_STARTERS
            });
            setDidTimeOut(false);
            setStarters([
                ...userDefinedStarters,
                ...fallbackStarters.slice(0, 1),
                ...new Array(3).fill(null)
            ].slice(0, 3));
            beginTimeout(userDefinedStarters, fallbackStarters);
            return await assistanceService.generateContextualStarters({
                browser_url: browser_url
            });
        },
        onSuccess: async (responseData)=>{
            onSuccess?.();
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_CONTEXTUAL_STARTERS
            });
            let updatedStarters = [
                ...starters
            ];
            if (didTimeOut) return;
            cancelTimeout();
            responseData?.conversation_starters.map(({ text: responseStarter })=>{
                const index = updatedStarters.indexOf(null);
                const starterAlreadyExists = updatedStarters.some((starter)=>starter?.message === responseStarter);
                // If there is a null value in the starters array AND the new starter we get from the backend
                // does not already exist in the array, replace the null value with the new starter
                if (index !== -1 && !starterAlreadyExists) {
                    updatedStarters[index] = {
                        message: responseStarter,
                        type: 'llm-generated',
                        labelType: 'llm-generated',
                        llmLabel: getLLMLabel().labelText
                    };
                    setStarters(updatedStarters);
                }
            });
        },
        onError: (error)=>{
            onError?.(error);
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                error: error
            });
        }
    });
    const beginTimeout = (0, $cozmU.useCallback)((userDefinedStarters, fallbackStarters)=>{
        timeoutRef.current = window.setTimeout(()=>{
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                reason: 'timeout'
            });
            setDidTimeOut(true);
            const conversationStarterLimit = $bf5a144e395ed2fe$var$getConversationStarterLimit(fullScreen ?? false);
            setStarters([
                ...userDefinedStarters,
                ...fallbackStarters
            ].slice(0, conversationStarterLimit));
        }, 2000);
        return cancelTimeout;
    }, [
        cancelTimeout,
        experienceTracker,
        fullScreen
    ]);
    return {
        getDynamicContextualStarters: getDynamicContextualStarters,
        starters: starters,
        error: error,
        // TODO - Implement appropriate request abort logic for useMutation, much like useStreamingMutation has, this is a stop gap
        isMutating: didTimeOut ? false : isSubmitting,
        staticContextualConversationStarters: staticContextualConversationStarters,
        cancelTimeout: cancelTimeout
    };
});



















var $a9aSv = parcelRequire("a9aSv");













const $e87284724efec10d$var$styles = {
    wrapper: "_2YLqiK1Y8M _0jFU0VN91d _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
};
const $e87284724efec10d$var$CustomGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const t0 = props.primaryColor || "#0C66E4";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M10.512 1.06137C11.1247 0.713259 11.8753 0.713259 12.488 1.06137L21.488 6.17501C22.1136 6.53043 22.5 7.19446 22.5 7.91392V18.0861C22.5 18.8055 22.1136 19.4696 21.488 19.825L12.488 24.9386C11.8753 25.2867 11.1247 25.2867 10.512 24.9386L1.51198 19.825C0.886437 19.4696 0.5 18.8055 0.5 18.0861V7.91392C0.5 7.19446 0.886437 6.53043 1.51198 6.17501L10.512 1.06137Z",
            fill: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props.excludeOverlay || $[3] !== props.primaryColor) {
        t2 = !props.primaryColor && !props.excludeOverlay && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("path", {
            d: "M15.3711 9.12845C15.7263 9.30173 16.1726 9.00581 16.3843 9.37104C16.1136 9.2564 16.1496 10.7306 16.5959 10.3814C16.6497 10.1521 16.7793 10.1801 16.551 10.1015C16.9344 10.0988 16.5779 9.84556 16.5907 9.80957C16.7998 9.80424 16.5266 9.68161 16.7254 9.72427C16.8408 9.70027 16.5035 9.39637 16.7318 9.47768C16.8049 9.14711 17.1615 9.14976 17.0819 8.94849C17.0858 9.08578 18.2708 9.11778 17.9425 8.59261C17.7347 8.60328 17.7617 8.36068 17.7309 8.67659C17.668 8.28471 17.5283 8.67658 17.4949 8.66725C17.4641 8.44731 17.4026 8.75122 17.4115 8.53662C17.3808 8.42066 17.1807 8.79121 17.2204 8.54861C16.5292 8.36067 17.096 8.15807 16.6972 7.75019C16.6574 7.56092 16.7549 6.94644 16.3278 7.00376C15.7661 7.17171 16.4214 8.22072 16.088 8.40333C15.9392 8.54195 15.7276 8.71656 15.4467 8.59793C15.3082 8.59527 15.13 9.1831 15.3698 9.12979L15.3711 9.12845Z",
            fill: "#579DFF"
        }), /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.3218 15.6931L14.5291 14.9004C12.9326 16.1142 11.4765 17.4318 10.1783 18.8662C8.3402 17.3566 6.68445 15.6005 5.18662 13.6303L11.4518 7.36515C12.9665 10.1168 15.0426 12.0855 17.5196 13.4953L15.3218 15.6931ZM10.7452 13.7518L10.7452 15.6016L10.7454 15.6016L11.6857 15.6016L11.6857 13.7518L13.4285 13.7518L11.2154 11.5387L9.00236 13.7518L10.7452 13.7518ZM14.5291 14.9007L15.3217 15.6934L11.2855 19.7296C10.9092 19.4518 10.5403 19.1639 10.1783 18.8665C11.4764 17.4323 12.9325 16.1146 14.5291 14.9007Z",
            fill: "#CCE0FF"
        }));
        $[2] = props.excludeOverlay;
        $[3] = props.primaryColor;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t1 || $[7] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "23",
            height: "26",
            viewBox: "0 0 23 26",
            fill: "none",
            ...props
        }, t1, t2);
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "23",
        height: "26",
        viewBox: "0 0 23 26",
        fill: "none",
        ...props
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M10.512 1.06137C11.1247 0.713259 11.8753 0.713259 12.488 1.06137L21.488 6.17501C22.1136 6.53043 22.5 7.19446 22.5 7.91392V18.0861C22.5 18.8055 22.1136 19.4696 21.488 19.825L12.488 24.9386C11.8753 25.2867 11.1247 25.2867 10.512 24.9386L1.51198 19.825C0.886437 19.4696 0.5 18.8055 0.5 18.0861V7.91392C0.5 7.19446 0.886437 6.53043 1.51198 6.17501L10.512 1.06137Z",
        fill: props.primaryColor || '#0C66E4'
    }), !props.primaryColor && !props.excludeOverlay && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M15.3711 9.12845C15.7263 9.30173 16.1726 9.00581 16.3843 9.37104C16.1136 9.2564 16.1496 10.7306 16.5959 10.3814C16.6497 10.1521 16.7793 10.1801 16.551 10.1015C16.9344 10.0988 16.5779 9.84556 16.5907 9.80957C16.7998 9.80424 16.5266 9.68161 16.7254 9.72427C16.8408 9.70027 16.5035 9.39637 16.7318 9.47768C16.8049 9.14711 17.1615 9.14976 17.0819 8.94849C17.0858 9.08578 18.2708 9.11778 17.9425 8.59261C17.7347 8.60328 17.7617 8.36068 17.7309 8.67659C17.668 8.28471 17.5283 8.67658 17.4949 8.66725C17.4641 8.44731 17.4026 8.75122 17.4115 8.53662C17.3808 8.42066 17.1807 8.79121 17.2204 8.54861C16.5292 8.36067 17.096 8.15807 16.6972 7.75019C16.6574 7.56092 16.7549 6.94644 16.3278 7.00376C15.7661 7.17171 16.4214 8.22072 16.088 8.40333C15.9392 8.54195 15.7276 8.71656 15.4467 8.59793C15.3082 8.59527 15.13 9.1831 15.3698 9.12979L15.3711 9.12845Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3218 15.6931L14.5291 14.9004C12.9326 16.1142 11.4765 17.4318 10.1783 18.8662C8.3402 17.3566 6.68445 15.6005 5.18662 13.6303L11.4518 7.36515C12.9665 10.1168 15.0426 12.0855 17.5196 13.4953L15.3218 15.6931ZM10.7452 13.7518L10.7452 15.6016L10.7454 15.6016L11.6857 15.6016L11.6857 13.7518L13.4285 13.7518L11.2154 11.5387L9.00236 13.7518L10.7452 13.7518ZM14.5291 14.9007L15.3217 15.6934L11.2855 19.7296C10.9092 19.4518 10.5403 19.1639 10.1783 18.8665C11.4764 17.4323 12.9325 16.1146 14.5291 14.9007Z",
        fill: "#CCE0FF"
    })));
};
const $e87284724efec10d$var$CustomIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement($e87284724efec10d$var$CustomGlyph, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($e87284724efec10d$var$CustomGlyph, props);
};
const $e87284724efec10d$export$e331edd80bbc26a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e87284724efec10d$var$styles.wrapper
        }, /*#__PURE__*/ $cozmU.createElement($e87284724efec10d$var$CustomIcon, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e87284724efec10d$var$styles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement($e87284724efec10d$var$CustomIcon, props));
};


const $4ec33d64b083ebd1$export$f317c01730aa6ce0 = (agent, length = 3)=>{
    return new Array(length).fill(null).map((_, index)=>{
        return {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            value: `agent:${agent.id}:${(0, $03RpJ.default)()}:dummy`,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                width: `${index % 2 !== 0 ? 205 : 180}px`,
                height: "18px",
                borderRadius: "var(--ds-radius-xsmall, 2px)",
                isShimmering: true
            }),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e87284724efec10d$export$e331edd80bbc26a2), {
                label: '',
                excludeOverlay: true,
                size: "large",
                width: 32,
                height: 32,
                primaryColor: "var(--ds-skeleton, #0515240F)"
            }),
            groupHeading: '',
            onSelect: ()=>{},
            onSuggestionFocused: ()=>{}
        };
    });
};



const $402e9e60f0934298$var$experienceName = 'Rovo agent conversation starters';
const $402e9e60f0934298$var$suggestionCount = 3;
function $402e9e60f0934298$export$552fd0249f716349({ handleHighlight: handleHighlight, configItem: configItem, onConversationStarterSelected: onConversationStarterSelected, product: product, editorPluginAIProvider: editorPluginAIProvider }) {
    let agent;
    /**
   * When agent is silently used behind scenes for prompt then don't show agent starter.
   * That's why don't assign agent from configItem to agent variable.
   */ if (!configItem.silentAgentPrompt) agent = configItem.agent;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const siteId = (0, $cozmU.useMemo)(()=>editorPluginAIProvider?.getChannelVariables?.('rovo-agent')?.cloudId || '', [
        editorPluginAIProvider
    ]);
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const [lastAiInteractionID, setLastAiInteractionID] = (0, $cozmU.useState)('');
    const getAiLifeCycleDynamicAttributes = analyticsFlow.getAiLifeCycleDynamicAttributes;
    const userDefinedAgentStarters = (0, $cozmU.useMemo)(()=>{
        if (!agent) return [];
        return agent.conversationStarters.filter((conversationStarter)=>{
            return conversationStarter.type === 'user-defined';
        });
    }, [
        agent
    ]);
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const onInit = (0, $cozmU.useCallback)(()=>{
        setHasError(false);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const aiId = (0, $03RpJ.default)();
        setLastAiInteractionID(aiId);
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).INITIATED,
                interactionID: aiId,
                experienceName: $402e9e60f0934298$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: getAiLifeCycleDynamicAttributes?.({
                    init: true
                })
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        fireAIAnalyticsEvent,
        getAiLifeCycleDynamicAttributes
    ]);
    const onError = (0, $cozmU.useCallback)((error)=>{
        setHasError(true);
        fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).ERROR,
                interactionID: lastAiInteractionID,
                experienceName: $402e9e60f0934298$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: {
                    aiErrorMessage: error.message,
                    aiErrorCode: 500,
                    ...getAiLifeCycleDynamicAttributes?.({
                        init: false
                    })
                }
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        fireAIAnalyticsEvent,
        lastAiInteractionID,
        getAiLifeCycleDynamicAttributes
    ]);
    const { getDynamicContextualStarters: getDynamicContextualStarters, starters: contextualStarters, isMutating: isMutating } = (0, $bf5a144e395ed2fe$export$640585e02de0f425)({
        onInit: onInit,
        onError: onError,
        assistanceServiceParams: {
            touchpointSource: 'editor-ai-conversation-starters',
            product: (0, $5PpGs.mapToAssistanceServiceProduct)(product),
            experienceId: 'ai-mate',
            siteId: siteId
        }
    });
    const isPending = (0, $cozmU.useMemo)(()=>{
        return isMutating || contextualStarters.some((cs)=>!cs) && userDefinedAgentStarters.length < $402e9e60f0934298$var$suggestionCount;
    }, [
        isMutating,
        contextualStarters,
        userDefinedAgentStarters
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (agent && userDefinedAgentStarters.length < $402e9e60f0934298$var$suggestionCount) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        getDynamicContextualStarters({
            locationUrl: window.location.href,
            fallbackStarters: agent.conversationStarters.map((conversationStarter)=>{
                if (typeof conversationStarter.message !== 'string') conversationStarter.message = formatMessage(conversationStarter.message);
                return conversationStarter;
            })
        });
    }, [
        agent,
        getDynamicContextualStarters,
        formatMessage,
        userDefinedAgentStarters
    ]);
    const starters = (0, $cozmU.useMemo)(()=>{
        if (!agent) return [];
        let conversationStarters = userDefinedAgentStarters;
        if (isPending) return (0, $4ec33d64b083ebd1$export$f317c01730aa6ce0)(agent, $402e9e60f0934298$var$suggestionCount);
        if (conversationStarters.length < $402e9e60f0934298$var$suggestionCount) {
            // The linter was being very agressive about this typing for some reason
            // so I had to comfort it and make sure it was aware this variable definitely did
            // not contain nulls.
            // See: How to win friends and influence people by Dale Carnegie
            const nonNullContextualStarters = contextualStarters.filter((conversationStarter)=>conversationStarter !== null);
            const availableContextualStarters = nonNullContextualStarters.slice(0, $402e9e60f0934298$var$suggestionCount - conversationStarters.length);
            conversationStarters = [
                ...conversationStarters,
                ...availableContextualStarters
            ];
        }
        return conversationStarters.map(({ message: conversationStarter }, index)=>{
            const translatedMessage = typeof conversationStarter === 'string' ? conversationStarter : formatMessage(conversationStarter);
            return {
                value: `agent:${agent.id}:${index}:${translatedMessage}`,
                label: translatedMessage,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creatorType) : agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon
                }),
                groupHeading: '',
                onSelect: ()=>{
                    onConversationStarterSelected(translatedMessage);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                },
                ...(0, $iDrrr.fg)('ai-smart-button-team-25') && {
                    isAgent: true
                }
            };
        });
    }, [
        agent,
        isPending,
        userDefinedAgentStarters,
        contextualStarters,
        formatMessage,
        onConversationStarterSelected,
        handleHighlight,
        configItem
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isPending && !hasError && starters.length) fireAIAnalyticsEvent({
            payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                action: (0, $krYZG.ACTION).VIEWED,
                interactionID: lastAiInteractionID,
                experienceName: $402e9e60f0934298$var$experienceName,
                isProactive: false,
                invokedFrom: aiExperienceCommonData.lastTriggeredFrom,
                attributes: getAiLifeCycleDynamicAttributes?.({
                    init: true
                })
            })
        });
    }, [
        aiExperienceCommonData.lastTriggeredFrom,
        isPending,
        hasError,
        starters,
        fireAIAnalyticsEvent,
        lastAiInteractionID,
        getAiLifeCycleDynamicAttributes
    ]);
    return {
        starters: starters
    };
}








function $324d48021e8bcfc4$export$f8e8298e44ec1284() {
    const { engagementPlatformApi: engagementPlatformApi } = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    if (!engagementPlatformApi) return {
        startMessage: ()=>{
            return Promise.resolve(false);
        },
        stopMessage: ()=>{
            return Promise.resolve(false);
        }
    };
    return engagementPlatformApi;
}


function $df616d6c6209e634$export$a1cbeeef2ea2e5f5(messageId, text) {
    const { stopMessage: stopMessage, startMessage: startMessage } = (0, $324d48021e8bcfc4$export$f8e8298e44ec1284)();
    const [isStarted, setIsStarted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        startMessage(messageId).then((isStarted)=>{
            setIsStarted(isStarted);
        });
    }, [
        messageId,
        startMessage
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        // We should hide message immediately without waiting for EngagementPlatform response
        setIsStarted(false);
        stopMessage(messageId);
    }, [
        messageId,
        stopMessage
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (isStarted) return {
            id: messageId,
            text: text,
            onClose: handleClose
        };
        return undefined;
    }, [
        messageId,
        text,
        handleClose,
        isStarted
    ]);
}












const $be6eb63036cf47d8$export$4b8c026161f470e2 = ({ hasInput: hasInput, suggestions: suggestions, agentVisible: agentVisible, nestedMenuSelected: nestedMenuSelected })=>{
    const { sendToAIExperienceMachine: sendToAIExperienceMachine, includeKnowledgeFromCurrentPage: includeKnowledgeFromCurrentPage } = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const pageKnowledgeIsVisible = (0, $cozmU.useMemo)(()=>{
        /**
     * Simplify the logic to not rely on the group heading copy and rely on constant values.
     */ if ((0, $iDrrr.fg)('ai-smart-button-team-25')) {
            const isGeneralAISuggestionRemaining = [
                (0, $8312663103724919$export$aed4aa2c04f0ff0a),
                (0, $8312663103724919$export$ea35400996401183),
                (0, $8312663103724919$export$e9b50d8f92ed61d4),
                (0, $8312663103724919$export$f94ca114676d6a3f)
            ].includes(suggestions[0]?.value);
            return !!(agentVisible || isGeneralAISuggestionRemaining && !nestedMenuSelected);
        }
        const hasGeneralAiSuggestions = suggestions[0]?.groupHeading === (0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).atlassianIntelligenceGroupHeading.defaultMessage;
        return !!(agentVisible || hasInput && !hasGeneralAiSuggestions && !nestedMenuSelected);
    }, [
        agentVisible,
        nestedMenuSelected,
        hasInput,
        suggestions
    ]);
    const pageKnowledgeProps = (0, $cozmU.useMemo)(()=>{
        return {
            isEnabled: !!includeKnowledgeFromCurrentPage,
            isVisible: pageKnowledgeIsVisible,
            onToggle: ()=>sendToAIExperienceMachine({
                    type: 'toggle use page knowledge'
                })
        };
    }, [
        includeKnowledgeFromCurrentPage,
        pageKnowledgeIsVisible,
        sendToAIExperienceMachine
    ]);
    return pageKnowledgeProps;
};






var $1o3CH = parcelRequire("1o3CH");

const $3ec2f021d93adf90$var$prefix = 'editor-ai.submit-prompt';
const $3ec2f021d93adf90$var$useUfoPromptTracing = ()=>{
    const ufoAtlassianIntelligenceTracing = (0, $1o3CH.default)(`${$3ec2f021d93adf90$var$prefix}.atlassian-intelligence`);
    const ufoRovoTracing = (0, $1o3CH.default)(`${$3ec2f021d93adf90$var$prefix}.rovo`);
    return (0, $cozmU.useCallback)((agent)=>{
        const tracing = agent === 'rovo' ? ufoRovoTracing : ufoAtlassianIntelligenceTracing;
        tracing();
    }, [
        ufoAtlassianIntelligenceTracing,
        ufoRovoTracing
    ]);
};
var $3ec2f021d93adf90$export$2e2bcd8739ae039 = $3ec2f021d93adf90$var$useUfoPromptTracing;



var $9uQOV = parcelRequire("9uQOV");



var $kkhvT = parcelRequire("kkhvT");





function $49aca019497307ab$export$751495e555be6bbc({ context: experienceAppContext, initialPrompt: initialPrompt }) {
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { appearance: appearance, editorPluginAIProvider: editorPluginAIProvider, endExperience: endExperience, sendToAIExperienceMachine: sendToAIExperienceMachine, modalRef: modalRef } = aiExperienceCommonData;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { configItem: startingConfig, baseGenerate: baseGenerate, userInput: startingUserInput, userADFInput: startingUserADFInput, parentPresetPromptLabel: parentPresetPromptLabel, editCount: editCount, positions: positions, editorView: editorView, isEmpty: isEmpty, latestPromptResponse: latestPromptResponse, aiProvider: aiProvider } = experienceAppContext;
    const [initialPromptTriggered, setInitialPromptTriggered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const ufoSubmitTracing = (0, $3ec2f021d93adf90$export$2e2bcd8739ae039)();
    // if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
    // we want to use startingConfig and parentPresetPromptLabel to restore the selected parent
    const { context: commandPaletteContext, send: sendToCommandPalette } = (0, $d1ad659707a9aa19$export$6d6b44d5fef51d81)({
        baseGenerate: baseGenerate,
        startingConfig: startingConfig,
        startingPresetPromptLabel: parentPresetPromptLabel || (0, $c2c6d211a4290fa3$export$4539b8c6808af330)(startingConfig, formatMessage),
        startingUserInput: startingUserInput,
        startingUserADFInput: startingUserADFInput
    });
    const { textInput: textInput, adfInput: adfInput, configItem: configItem, presetPromptLabel: presetPromptLabel } = commandPaletteContext;
    // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
    const isParentWithNestedSubmenusSelected = Boolean(presetPromptLabel && configItem.nestingConfig);
    const rovoAgentsPluginState = (0, $5be238e62a535642$export$ce428e3c22a00062)({
        editorState: editorView.state
    });
    const { isBrowseModalOpen: isBrowseModalOpen = false } = rovoAgentsPluginState ?? {};
    (0, $d566c2a1407b9634$export$aa79b0abe3dfeaba)({
        disabled: isBrowseModalOpen,
        modalRef: modalRef,
        onCancel: ()=>aiExperienceCommonData.endExperience(),
        onDiscard: ()=>{
            sendToAIExperienceMachine({
                type: 'update context',
                context: {
                    configItem: configItem,
                    userInput: textInput || '',
                    userADFInput: adfInput
                }
            });
            sendToAIExperienceMachine({
                type: 'enable discard'
            });
        }
    });
    const focusInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined);
    const handleCancel = ()=>{
        endExperience();
    };
    const kickoffAiExperience = (0, $cozmU.useCallback)(({ configItem: configItem, userInput: userInput, userADFInput: userADFInput })=>{
        // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
        // we need the parentPresetPromptLabel to restore the selected parent later when we edit prompt in `Preview` screen (onEditPromptClick)
        const parentPresetPromptLabel = isParentWithNestedSubmenusSelected ? presetPromptLabel : '';
        sendToAIExperienceMachine({
            type: 'kickoff with command palette input',
            context: {
                parentPresetPromptLabel: parentPresetPromptLabel,
                configItem: configItem,
                userInput: userInput,
                userADFInput: userADFInput
            }
        });
    }, [
        isParentWithNestedSubmenusSelected,
        presetPromptLabel,
        sendToAIExperienceMachine
    ]);
    const onPartialPresetSelected = (0, $cozmU.useCallback)((configItem, { presetPromptLabel: presetPromptLabel } = {})=>{
        // If partial prompt is selected we want to update the command palette
        // And focus the text input
        sendToCommandPalette({
            type: 'onPartialPresetSelected',
            configItem: configItem,
            presetPromptLabel: presetPromptLabel ?? (0, $c2c6d211a4290fa3$export$4539b8c6808af330)(configItem, formatMessage)
        });
        focusInputRef.current?.();
    }, [
        sendToCommandPalette,
        formatMessage
    ]);
    const getPromptTitle = (0, $cozmU.useCallback)((configItem)=>{
        if (configItem.agent?.creatorType === 'CUSTOMER') return undefined;
        if (configItem.agent?.creatorType === 'SYSTEM') return configItem.agent?.name;
        return configItem.promptLabel ? formatMessage(configItem.promptLabel) : undefined;
    }, [
        formatMessage
    ]);
    const analyticsFlow = (0, $02d337cdf5827f29$export$f06fb39743945e19)({
        stepName: 'prompt',
        callerComponent: 'UserInputCommandPaletteWithLogic',
        attributes: {
            experienceName: configItem.key,
            featureId: configItem.featureId,
            promptTitle: getPromptTitle(configItem),
            promptType: 'generate',
            usingCommandPalette: true,
            retryPromptCount: experienceAppContext.retryPromptCount,
            editCount: editCount
        }
    });
    const isRovoEnabled = (0, $5cf769efe8d70c8d$export$83f18c95a94d1b1e)({
        editorPluginAIProvider: editorPluginAIProvider
    });
    const updateAnalytics = (0, $cozmU.useCallback)((configItem)=>{
        /**
     * Update the backendModel common attribute whenever the configItem changes
     */ analyticsFlow.updateCommonAttributes({
            backendModel: configItem?.getBackendModel?.(!!latestPromptResponse),
            ...analyticsFlow.getUserFlowCommonAttributes(configItem)
        });
        const attributes = {
            experienceName: configItem.key,
            featureId: configItem.featureId,
            promptTitle: getPromptTitle(configItem)
        };
        let inputNodeCount = {};
        let characterCount = 0;
        if (adfInput) {
            inputNodeCount = (0, $4EPzQ.reduce)(adfInput, (accum, node)=>{
                if (node.type === 'text') characterCount = characterCount + (node.text ?? '').length;
                accum[node.type] = (accum[node.type] ?? 0) + 1;
                node?.marks?.forEach((mark)=>{
                    accum[mark.type] = (accum[mark.type] ?? 0) + 1;
                });
                return accum;
            }, {});
            attributes.inputNodeCount = inputNodeCount;
            attributes.characterCount = characterCount;
        }
        // update experiencename and title as it changes on selecting suggestion
        analyticsFlow.addAttributes(attributes);
    }, [
        analyticsFlow,
        latestPromptResponse,
        getPromptTitle,
        adfInput
    ]);
    const updateTextInput = (0, $cozmU.useCallback)((textInputValue)=>{
        sendToCommandPalette({
            type: 'onTextEntered',
            input: textInputValue
        });
    }, [
        sendToCommandPalette
    ]);
    const updateADFInput = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((text)=>{
        sendToCommandPalette({
            type: 'onADFEntered',
            adf: text
        });
    }, [
        sendToCommandPalette
    ]);
    const onSubmit = (0, $cozmU.useCallback)(({ configItem: _configItem } = {})=>{
        // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
        // they can only trigger the AI experience by selecting a submenu (which can be triggered by pressing enter)
        if (isParentWithNestedSubmenusSelected) return;
        // Register interaction with UFO
        ufoSubmitTracing(!!_configItem?.agent ? 'rovo' : 'atlassian-intelligence');
        kickoffAiExperience({
            configItem: _configItem || commandPaletteContext.configItem,
            userInput: commandPaletteContext.textInput || '',
            userADFInput: commandPaletteContext.adfInput
        });
    }, [
        isParentWithNestedSubmenusSelected,
        kickoffAiExperience,
        commandPaletteContext.configItem,
        commandPaletteContext.textInput,
        commandPaletteContext.adfInput,
        ufoSubmitTracing
    ]);
    const __getSuggestions = (0, $cozmU.useMemo)(()=>{
        const getConfigItems = ()=>{
            return (0, $c2c6d211a4290fa3$export$2dd2807afbd4a532)({
                configItemWithOptions: editorPluginAIProvider.configItemWithOptions,
                editorView: editorView,
                positions: positions,
                isEmpty: isEmpty
            });
        };
        return getConfigItems;
    }, [
        editorView,
        positions,
        isEmpty,
        editorPluginAIProvider.configItemWithOptions
    ]);
    /**
   * This function is responsible for highlighting the entire document
   * when particular prompts are selected.
   *
   * This only happens if the user has not already made a selection.
   *
   * Currently all prompts highlight the whole document except partial prompts like:
   * - Brainstorm
   * - Ask Search
   */ const handleHighlight = (0, $cozmU.useCallback)(({ configItem: configItem, promptLabel: promptLabel })=>{
        // Remove all decorations if the prompt is 'Tell AI' or that it is not defined (brainstorm)
        if (configItem.promptLabel !== undefined && !configItem.agent || promptLabel === (0, $8312663103724919$export$aed4aa2c04f0ff0a) || promptLabel === (0, $8312663103724919$export$e9b50d8f92ed61d4) || promptLabel === (0, $8312663103724919$export$f94ca114676d6a3f) || promptLabel === (0, $8312663103724919$export$3cb19042951e1104)) {
            const removeTransaction = editorView.state.tr;
            removeTransaction.setMeta('hideSelectionPreview', true);
            editorView.dispatch(removeTransaction);
            return;
        }
        // Highlight the entire document for all other prompts
        const setTransaction = editorView.state.tr;
        setTransaction.setMeta('showSelectionPreview', true);
        editorView.dispatch(setTransaction);
    }, [
        editorView
    ]);
    const onConversationStarterSelected = (0, $cozmU.useCallback)((conversationStarter)=>{
        const userADFInput = (0, $4AavA.doc)((0, $c8cGy.paragraph)(conversationStarter));
        handleHighlight({
            configItem: configItem
        });
        updateAnalytics(configItem);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onPartialPresetSelected(configItem, {
            presetPromptLabel: `@${configItem.agent.name}`
        });
        kickoffAiExperience({
            userInput: conversationStarter,
            configItem: configItem,
            userADFInput: userADFInput
        });
    }, [
        handleHighlight,
        updateAnalytics,
        onPartialPresetSelected,
        kickoffAiExperience,
        configItem
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialPrompt && !initialPromptTriggered) {
            if (configItem.agent) onConversationStarterSelected(initialPrompt);
            else if (!experienceAppContext.latestPrompt) {
                const userADFInput = (0, $4AavA.doc)((0, $c8cGy.paragraph)(initialPrompt));
                updateADFInput(userADFInput);
                updateTextInput(initialPrompt);
                // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
                setInitialPromptTriggered(true);
                kickoffAiExperience({
                    userInput: initialPrompt,
                    configItem: configItem,
                    userADFInput: userADFInput
                });
            }
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setInitialPromptTriggered(true);
        }
    }, [
        initialPrompt,
        onConversationStarterSelected,
        initialPromptTriggered,
        configItem,
        experienceAppContext.latestPrompt,
        updateADFInput,
        updateTextInput,
        kickoffAiExperience
    ]);
    const { starters: agentConversationStarters } = (0, $402e9e60f0934298$export$552fd0249f716349)({
        handleHighlight: handleHighlight,
        configItem: configItem,
        onConversationStarterSelected: onConversationStarterSelected,
        product: editorPluginAIProvider.product,
        editorPluginAIProvider: editorPluginAIProvider
    });
    const getSuggestions = (0, $cozmU.useCallback)((inputValue, agent)=>{
        // if like Brainstorm, return nothing
        if (presetPromptLabel && !configItem.nestingConfig && !agent) return [];
        /**
     * knowledge source
     */ function makeUseRovoOrganisationKnowledgeSuggestion(defaultAgent) {
            const agentConfigItem = (0, $kkhvT.createAgentConfigItem)(defaultAgent, editorPluginAIProvider);
            return {
                testId: (0, $8312663103724919$export$f94ca114676d6a3f),
                value: (0, $8312663103724919$export$f94ca114676d6a3f),
                label: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).useRovoOrganisationKnowledgeLabel),
                groupHeading: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).knowledgeSourceGroupHeading),
                rightText: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).useRovoOrganisationKnowledgeRightText),
                hideIcon: true,
                onSelect: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                    updateAnalytics(agentConfigItem);
                    onSubmit({
                        configItem: agentConfigItem
                    });
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem,
                        promptLabel: (0, $8312663103724919$export$f94ca114676d6a3f)
                    });
                }
            };
        }
        // If the user input has more than 3 words, we should show all Rovo Agents suggestions,
        // and suggestions should run free prompt, instead of showing starters.
        // See https://product-fabric.atlassian.net/browse/EDF-1700 for details.
        const isRovoAgentsSuggestionsShouldRunFreePrompt = inputValue.trim().split(' ').length > 3;
        function getRovoAgentsGroupHeading() {
            const matchedAgentCount = getSuggestions(textInput || '').filter((suggestion)=>suggestion.isAgent).length;
            if (matchedAgentCount === 0) return formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).rovoAgentsSuggestionGroupHeading);
            else if (isRovoAgentsSuggestionsShouldRunFreePrompt) return formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).useRovoAgentsCountSuggestionGroupHeading, {
                numberOfAgents: matchedAgentCount.toString()
            });
            else return formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).rovoAgentsCountSuggestionGroupHeading, {
                numberOfAgents: matchedAgentCount.toString()
            });
        }
        function makeKnowledgeSourceSuggestions() {
            const useRovoOrganisationKnowledgeSuggestions = // When showRovoAgentsInCommandPalette is false, don't show "Use knowledge from your organization" suggestion
            !aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !rovoAgentsPluginState?.defaultAgent || !aiProvider.getChannelVariables || agent ? [] : // pass defaultAgent to avoid ts check again
            [
                makeUseRovoOrganisationKnowledgeSuggestion(rovoAgentsPluginState.defaultAgent)
            ];
            const actions = (0, $c2c6d211a4290fa3$export$a64e27216c5d7416)({
                isEmpty: isEmpty,
                configItem: configItem
            });
            if (isRovoEnabled && !configItem.agent && !actions.find((action)=>action.type === 'generic-chat')) {
                const chatAction = (0, $9uQOV.createContinueInChat)({
                    appearance: 'secondary',
                    product: editorPluginAIProvider.product,
                    actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
                    factoryOptions: {
                        product: editorPluginAIProvider.product,
                        isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
                    }
                });
                actions.unshift(chatAction);
            }
            const knowledgeSourceSuggestions = [
                {
                    testId: (0, $8312663103724919$export$e9b50d8f92ed61d4),
                    value: (0, $8312663103724919$export$e9b50d8f92ed61d4),
                    label: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).useGeneralAiKnowledgeLabel),
                    groupHeading: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).knowledgeSourceGroupHeading),
                    rightText: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).useGeneralAiKnowledgeRightText),
                    hideIcon: true,
                    onSelect: ()=>{
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                        onSubmit();
                    },
                    onSuggestionFocused: ()=>{
                        handleHighlight({
                            configItem: configItem,
                            promptLabel: (0, $8312663103724919$export$e9b50d8f92ed61d4)
                        });
                    }
                },
                ...useRovoOrganisationKnowledgeSuggestions
            ];
            return knowledgeSourceSuggestions;
        }
        // use this flag to determine if we should show the knowledge source suggestions instead of the 'Tell AI' suggestion
        const showKnowledgeSourceSuggestionsInsteadOfTellAI = // When showRovoAgentsInCommandPalette is false, don't show "Use knowledge from your organization" suggestion
        aiProvider.showRovoAgentsInCommandPalette && rovoAgentsPluginState?.enabled && rovoAgentsPluginState?.defaultAgent && aiProvider.getChannelVariables && !agent && !presetPromptLabel;
        /**
     * do not show TELL_AI
     * - if there is no user input
     * - if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
     *   - they can only trigger the AI experience by selecting a submenu (which can be triggered by pressing enter)
     * Also when configItem.silentAgentPrompt is true, it means rovo agent is used in normal AI prompt.
     */ const tellAIPromptLabel = agent && !configItem.silentAgentPrompt ? (0, $8312663103724919$export$ea35400996401183) : (0, $8312663103724919$export$aed4aa2c04f0ff0a);
        const tellAiSuggestionBase = {
            value: tellAIPromptLabel,
            label: inputValue,
            hideIcon: true,
            onSelect: ()=>{
                handleHighlight({
                    configItem: configItem
                });
                updateAnalytics(configItem);
                onSubmit();
            },
            onSuggestionFocused: ()=>{
                handleHighlight({
                    configItem: configItem,
                    promptLabel: tellAIPromptLabel
                });
            }
        };
        const rovoSuggestionWithFallback = rovoAgentsPluginState?.enabled && rovoAgentsPluginState?.defaultAgent && aiProvider.getChannelVariables ? makeUseRovoOrganisationKnowledgeSuggestion(rovoAgentsPluginState.defaultAgent) : tellAiSuggestionBase;
        rovoSuggestionWithFallback.value = tellAIPromptLabel;
        rovoSuggestionWithFallback.label = inputValue;
        const tellAiSuggestion = !inputValue || isParentWithNestedSubmenusSelected ? [] : showKnowledgeSourceSuggestionsInsteadOfTellAI ? makeKnowledgeSourceSuggestions() : [
            tellAiSuggestionBase
        ];
        const showMoreText = formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).showMoreButton);
        const showMoreSuggestion = [
            {
                value: (0, $8312663103724919$export$95f98990d7202b31),
                label: showMoreText,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                    spacing: "spacious",
                    label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? '' : showMoreText
                }),
                onSelect: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                    updateAnalytics(configItem);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem,
                        promptLabel: showMoreText
                    });
                }
            }
        ];
        // The browse agents option is only available when using the new <BrowseAgentsModal>
        // component as we need to use its state to send the selected agent to the command palette
        const browseAgentsSuggestion = // Don't show browse agents suggestion when showRovoAgentsInCommandPalette is false
        !aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : {
            value: (0, $8312663103724919$export$3cb19042951e1104),
            label: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).agentsBrowseMore),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: (0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026') ? '' : 'browse-more-agents'
            }),
            groupHeading: getRovoAgentsGroupHeading,
            onSelect: ()=>{
                (0, $eKbTY.openBrowseAgentsModal)(true, positions)(editorView.state, editorView.dispatch);
            },
            onSuggestionFocused: ()=>{
                handleHighlight({
                    configItem: configItem,
                    promptLabel: (0, $8312663103724919$export$3cb19042951e1104)
                });
            }
        };
        /**
     * If an agent is selected, we want to show the agents conversation starters
     * as suggestions in the command palette with the 'Tell Agent' suggestion
     * when there is user input.
     *
     * But when configItem.silentAgentPrompt is true, it means rovo agent is used in normal AI prompt.
     * So don't show the agent conversation starters.
     */ if (agent && !configItem.silentAgentPrompt) {
            if (agentConversationStarters.filter((configItem)=>typeof configItem.label !== 'string').length) return agentConversationStarters;
            const filteredAgentSuggestions = agentConversationStarters.filter((configItem)=>configItem.label.toLowerCase().includes((inputValue || '').toLowerCase()));
            return filteredAgentSuggestions;
        }
        /**
     * If an agent is not selected, we want to show the suggestions
     */ const output = __getSuggestions({
            inputValue: inputValue
        }).map((configItem)=>{
            let icon = configItem.icon?.({
                formatMessage: formatMessage
            });
            // Show the icon for the parent config item if it exists
            if (configItem.nestingConfig && configItem.nestingConfig.icon && !presetPromptLabel && !inputValue) icon = configItem.nestingConfig.icon?.({
                formatMessage: formatMessage
            });
            const actions = (0, $c2c6d211a4290fa3$export$a64e27216c5d7416)({
                isEmpty: isEmpty,
                configItem: configItem
            });
            if (isRovoEnabled && !configItem.agent && !actions.find((action)=>action.type === 'generic-chat')) {
                const chatAction = (0, $9uQOV.createContinueInChat)({
                    appearance: 'secondary',
                    product: editorPluginAIProvider.product,
                    actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
                    factoryOptions: {
                        product: editorPluginAIProvider.product,
                        isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
                    }
                });
                actions.unshift(chatAction);
            }
            return {
                icon: icon,
                label: configItem.nestingConfig && presetPromptLabel ? formatMessage(configItem.nestingConfig.shortTitle) : (0, $c2c6d211a4290fa3$export$d97f37f32ae9d000)(configItem, formatMessage),
                statusLozengeType: configItem.statusLozengeType,
                value: configItem.key,
                nestingConfig: configItem.nestingConfig ? {
                    parentTestId: configItem.nestingConfig.parentTestId,
                    parentTitle: formatMessage(configItem.nestingConfig.parentTitle)
                } : undefined,
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                },
                onSelect: ()=>{
                    // A config item nested parent will have matching config but no prompt label
                    // will be selected
                    if (configItem.nestingConfig && !presetPromptLabel && !inputValue) onPartialPresetSelected(configItem, {
                        presetPromptLabel: formatMessage(configItem.nestingConfig.parentTitle)
                    });
                    else {
                        handleHighlight({
                            configItem: configItem
                        });
                        updateAnalytics(configItem);
                        // If full prompt is selected we want to kickoff the AI experience
                        if (!configItem.promptLabel) kickoffAiExperience({
                            userInput: '',
                            userADFInput: undefined,
                            configItem: configItem
                        });
                        else onPartialPresetSelected(configItem);
                    }
                }
            };
        }).concat(showMoreSuggestion).concat(!agent ? tellAiSuggestion : [])/**
     * Only show the agents if the user hasn't already selected an agent
     */ .concat(!aiProvider.showRovoAgentsInCommandPalette || !rovoAgentsPluginState?.enabled || !aiProvider.getChannelVariables || agent ? [] : rovoAgentsPluginState.agents.map((agent)=>{
            const agentConfigItem = (0, $kkhvT.createAgentConfigItem)(agent, editorPluginAIProvider);
            return {
                value: `agent:${agent.id}`,
                label: agent.name,
                description: agent.description ?? '',
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, editorPluginAIProvider.isRovoEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e9b55d7410177be$export$3b4439d273b7f3cc), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creatorType) : agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon
                })),
                groupHeading: getRovoAgentsGroupHeading,
                isAgent: true,
                onSelect: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                    updateAnalytics(agentConfigItem);
                    onPartialPresetSelected(agentConfigItem, {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        presetPromptLabel: `@${agentConfigItem.agent.name}`
                    });
                    if (isRovoAgentsSuggestionsShouldRunFreePrompt) kickoffAiExperience({
                        userInput: inputValue,
                        userADFInput: undefined,
                        configItem: agentConfigItem
                    });
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                }
            };
        })).concat(agent ? tellAiSuggestion : []).filter((suggestion)=>{
            if (!suggestion) return false;
            if (typeof suggestion.label !== 'string') return false;
            // Since we move `.concat(tellAiSuggestion)` above, we need to update the filter logic to include these suggestions
            if (suggestion.value === (0, $8312663103724919$export$e9b50d8f92ed61d4) || suggestion.value === (0, $8312663103724919$export$f94ca114676d6a3f)) return true;
            // if the user selects a parent with nesting submenus (`Change tone` or `Translate`)
            // ignore those that don't belong to the parent
            if (isParentWithNestedSubmenusSelected && suggestion.nestingConfig?.parentTitle !== presetPromptLabel) return false;
            // If Rovo Agents should process the user input and run free prompt,
            // show all agents suggestions.
            if (suggestion?.isAgent && isRovoAgentsSuggestionsShouldRunFreePrompt) return true;
            // text filter
            const searchValues = [
                suggestion.label.toLowerCase()
            ];
            searchValues.push((suggestion.description ?? '').toLowerCase());
            if (suggestion?.isAgent) searchValues.push('rovo', 'agent');
            return searchValues.join(' ').includes((inputValue || '').toLowerCase());
        }).concat(!isParentWithNestedSubmenusSelected ? browseAgentsSuggestion : []).map((suggestion)=>{
            if (!suggestion.groupHeading) // If the suggestion is in a submenu, we want to show the parent title as the group heading
            suggestion.groupHeading = isParentWithNestedSubmenusSelected && configItem?.nestingConfig?.parentTitle ? formatMessage(configItem.nestingConfig.parentTitle) : (0, $iDrrr.fg)('ai-smart-button-team-25') ? formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).actionsGroupHeading) : formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).atlassianIntelligenceGroupHeading);
            return suggestion;
        });
        if (output.length) return output;
        return isParentWithNestedSubmenusSelected ? [
            {
                value: 'no-suggestions',
                label: formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).noResultsSuggestion),
                hideIcon: true,
                icon: undefined,
                onSelect: ()=>{},
                onSuggestionFocused: ()=>{}
            }
        ] : [];
    }, [
        presetPromptLabel,
        configItem,
        rovoAgentsPluginState?.enabled,
        rovoAgentsPluginState?.defaultAgent,
        rovoAgentsPluginState?.agents,
        aiProvider.getChannelVariables,
        aiProvider.showRovoAgentsInCommandPalette,
        isParentWithNestedSubmenusSelected,
        formatMessage,
        __getSuggestions,
        editorPluginAIProvider,
        handleHighlight,
        updateAnalytics,
        onSubmit,
        textInput,
        positions,
        editorView,
        isEmpty,
        agentConversationStarters,
        onPartialPresetSelected,
        kickoffAiExperience,
        isRovoEnabled
    ]);
    const aiToolbarButtonPulseAnnouncement = (0, $df616d6c6209e634$export$a1cbeeef2ea2e5f5)('cc-editor-ai_ai-toolbar-button-pulse', formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).engagementBannerLinksText));
    (0, $cozmU.useEffect)(()=>{
        if (aiProvider.onAIProviderChanged) aiProvider.onAIProviderChanged('command-palette', configItem.agent ? {
            type: 'rovo',
            agent: configItem.agent
        } : undefined);
    }, [
        configItem.agent,
        aiProvider
    ]);
    const removeRefinementTag = (0, $cozmU.useCallback)(()=>{
        // Set experienceName and promptTitle to default values
        analyticsFlow.addAttributes({
            experienceName: baseGenerate?.key,
            featureId: baseGenerate?.featureId,
            promptTitle: baseGenerate ? (0, $c2c6d211a4290fa3$export$4539b8c6808af330)(baseGenerate, formatMessage) : ''
        });
        analyticsFlow.updateCommonAttributes({
            backendModel: baseGenerate?.getBackendModel?.(!!latestPromptResponse)
        });
        sendToCommandPalette({
            type: 'onPartialPresetRemoved'
        });
        focusInputRef.current?.();
    }, [
        analyticsFlow,
        baseGenerate,
        formatMessage,
        latestPromptResponse,
        sendToCommandPalette
    ]);
    const onBack = (0, $cozmU.useCallback)(()=>{
        removeRefinementTag();
        updateTextInput('');
        updateADFInput();
    }, [
        removeRefinementTag,
        updateTextInput,
        updateADFInput
    ]);
    const pageKnowledgeProps = (0, $be6eb63036cf47d8$export$4b8c026161f470e2)({
        hasInput: !!(textInput || adfInput),
        suggestions: getSuggestions(textInput || ''),
        agentVisible: !!agentConversationStarters.length,
        nestedMenuSelected: isParentWithNestedSubmenusSelected
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf161c1ff1d9bdff$export$9491b5d7f967f421), {
        appearance: appearance,
        presetPromptLabel: presetPromptLabel,
        inputValue: textInput || '',
        inputADFValue: adfInput,
        onInputUpdate: updateTextInput,
        onADFUpdate: updateADFInput,
        onEscapeKeyPressed: handleCancel,
        onSubmit: onSubmit,
        onRefinementTagRemove: removeRefinementTag,
        onBack: onBack,
        placeholder: configItem.promptHint ? formatMessage(configItem.promptHint) : '',
        getSuggestions: getSuggestions,
        focusInputRef: focusInputRef,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        agent: /**
     * When editor rovo agent is used behind the scenes for prompt, then don't pass agent.
     */ !configItem.silentAgentPrompt ? configItem.agent : undefined,
        hideLegacySubmitCancelButtons: isParentWithNestedSubmenusSelected,
        announcementBanners: aiToolbarButtonPulseAnnouncement ? [
            aiToolbarButtonPulseAnnouncement
        ] : undefined,
        pageKnowledgeProps: pageKnowledgeProps
    }));
}


function $879cf065fd9eac44$export$501630857d1b4132(props) {
    const { api: api } = props;
    /**
   * Note -- because we are on an old version of xstate -- when adding new states
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineState` type in the
   * `get-experience-service.ts` file
   **/ const state = props.state;
    /**
   * Note -- because we are on an old version of xstate -- when adding new events
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineEvent` type in the
   * `get-experience-service.ts` file
   **/ const context = props.context;
    const aiExperienceCommonData = (0, $4d8cf0904a436811$export$28c15afa0bc9f86b)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const autoAcceptAIChanges = aiExperienceCommonData.canInlineStreamChanges();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const send = aiExperienceCommonData.sendToAIExperienceMachine;
        if (send && state === 'started state') send({
            type: 'kick off'
        });
    }, [
        state,
        aiExperienceCommonData.sendToAIExperienceMachine
    ]);
    /**
   * Used to pass the backendModel to analytics and
   * feedback submission metadata
   */ const backendModel = context?.configItem?.getBackendModel?.(!!context?.latestPromptResponse);
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel,
            channelId: context.channelId,
            ...analyticsFlow.getUserFlowCommonAttributes(context.configItem),
            autoAcceptAIChanges: autoAcceptAIChanges,
            inlineStreamingAvailable: false
        });
    }, [
        analyticsFlow,
        backendModel,
        context.channelId,
        context.configItem,
        autoAcceptAIChanges
    ]);
    const aiLifeCycleDynamicAttributesGetter = context.aiLifeCycleDynamicAttributesGetter;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (aiLifeCycleDynamicAttributesGetter) analyticsFlow.registerAiLifeCycleDynamicAttributesGetter(aiLifeCycleDynamicAttributesGetter);
    }, [
        analyticsFlow,
        aiLifeCycleDynamicAttributesGetter
    ]);
    // Note -- the intention is to move the creation of the state machine higher
    // and for the ExperienceApplication (react component that appears in the modal)
    // to only be started once the machine is in the modal active state.
    if (state === 'started state') return null;
    const isModalActiveState = typeof state !== 'string' && state['modal active state'];
    if (!isModalActiveState) throw new Error('AI machine state is not: modal active state or modal error state');
    const experienceState = state['modal active state']['experience'];
    if (typeof experienceState !== 'string' && 'error state' in experienceState && experienceState['error state'] === 'active') {
        if (context.apiErrorInfo.failureReason === (0, $Mgq5A.FAILURE_REASON).NO_TEXTUAL_CONTENT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4632a2412dddbf8$export$124856cc35c13bde), {
            errorInfo: context.apiErrorInfo,
            contextStatistics: context.contextStatistics
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2f996e0ad8404319$export$eec2740903046434), {
            errorInfo: context.apiErrorInfo
        });
    }
    if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $899ed9a93707b513$export$643e9e046f871343), {
        state: experienceState,
        channelId: context.channelId,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        history: context.responseHistory,
        latestPrompt: context.latestPrompt,
        onceDiscard: context.onceDiscard,
        streamFlowPacer: props.streamFlowPacer,
        api: api
    });
    if (typeof experienceState === 'string' && experienceState === 'command palette state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $49aca019497307ab$export$751495e555be6bbc), {
        context: context,
        initialPrompt: props.initialPrompt
    });
    if (typeof experienceState === 'object' && 'loading state' in experienceState) {
        const loadingState = experienceState['loading state'];
        if (loadingState === 'loading') {
            /**
       * Short title for the submenu if the user selects a submenu via a parent (`Change tone` -> `Neutral`)
       * If the user selects a submenu directly, this will be empty (search and select `Change tone to Neutral`)
       */ const childShortTitle = context.parentPresetPromptLabel && context.configItem.nestingConfig ? formatMessage(context.configItem.nestingConfig.shortTitle) : '';
            const loadingMessage = (0, $2f49cf037b9198bf$export$e51701552d28cc4e)({
                status: context?.loadingStatus,
                formatMessage: formatMessage
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fdc9bbcae929a4d$export$9c279fd5d5bced59), {
                parentPresetPromptLabel: context.parentPresetPromptLabel,
                childShortTitle: childShortTitle,
                title: loadingMessage ? loadingMessage : formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).loadingTitle),
                markdown: context.markdown,
                adfResponse: context.adfResponse,
                latestPrompt: context.latestPrompt,
                promptTrigger: context.promptTrigger,
                refinementCount: context.refinementCount,
                latestPromptRetried: context.latestPromptRetried,
                idMap: context.idMap,
                contextStatistics: context.contextStatistics,
                hideLoadingScreen: aiExperienceCommonData.hideLoadingScreen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6efe87df395b9950$export$90b9d761c76d339a), {
                loadingStatus: context.loadingStatus
            }));
        }
    }
    if (typeof experienceState !== 'string' && 'review state' in experienceState) {
        const action = context.rovoActions ? context.rovoActions[context.selectionType] : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $886bb49e2e7a4b11$export$705df12804ca7004), {
            aiExperienceMachineContext: context,
            isInputActive: experienceState['review state'] === 'refinement',
            backendModel: backendModel,
            rovoAction: action,
            rovoPublish: publish
        });
    }
    throw new Error('unhandled state');
}
function $879cf065fd9eac44$var$canReplaceBaseGenerate(aiProvider) {
    return aiProvider.isRovoEnabled && aiProvider.useFreeGenerateEditorAgent;
}
function $879cf065fd9eac44$var$focusEditor(editorView) {
    if (!editorView.hasFocus()) editorView.focus();
}
// document.body will be focused when we switch from one screen to another
// (can be triggered by clicking button or pressing Esc key)
// which will make pressing Esc not working because we're listening Esc on editor
// so we should focus editor when it's not focused
function $879cf065fd9eac44$var$useFocusEditor({ editorView: editorView, cancelRovoPrompt: cancelRovoPrompt }) {
    (0, $cozmU.useEffect)(()=>{
        if (cancelRovoPrompt) $879cf065fd9eac44$var$focusEditor(editorView);
    }, [
        cancelRovoPrompt,
        editorView
    ]);
}
function $879cf065fd9eac44$var$ExperienceApplicationStateWrapper(props) {
    const { api: api, editorView: editorView, endExperience: endExperience } = props;
    const intl = (0, $kSwu1.useIntl)();
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const positions = props.positions;
    const isEmpty = positions[0] === positions[1];
    const selectionType = isEmpty ? 'empty' : 'range';
    /**
   * baseGenerate configItem is used as default configItem in command palette.
   * Currently for every product, "freeGenarete" is used as baseGenerate.
   * Recently, "useFreeGenerateEditorAgent" is introduced to allow
   * 	freeGenerateEditorAgent configItem to be used as baseGenerate.
   *  freeGenerateEditorAgent is like freeGeneerate, but it uses
   * 	rovo agent instead of standard AI prompt.
   *
   * Can't set "freeGenerateEditorAgent" directly as baseGenerate in prebuilt config,
   * 	because creating configItem requires agent to be passed in.
   * But agents are not available at compile time or event when plugin is loaded.
   * So we need to swap baseGenerate here.
   */ let configItem = props.configItem;
    let baseGenerate = props.editorPluginAIProvider.baseGenerate;
    if (props.defaultAgent && $879cf065fd9eac44$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
        baseGenerate = (0, $f32dd05596568c69$export$dc3b52bb600cbaa7)({
            agent: props.defaultAgent,
            product: props.editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (props.configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE) configItem = baseGenerate;
    }
    const isUserScroll = (0, $cozmU.useRef)(false);
    const isProgrammaticScroll = (0, $cozmU.useRef)(true);
    const streamFlowPacerRef = (0, $db676d2be4cae1a7$export$ace1671de29eb5ea)();
    const analyticsFlow = (0, $02d337cdf5827f29$export$8af1809310de64fa)();
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const streamingHandler = (0, $a1b48c6cfd5555d3$export$ad256dcfbe275ed5)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        aiInteractionID: analyticsFlow.getLastAiInteractionId(),
        streamFlowPacer: streamFlowPacerRef.current
    });
    const { context: context, state: state, send: send } = (0, $18fb1940e348cb4f$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: props.analyticsContext,
            aiProvider: props.editorPluginAIProvider,
            intl: intl,
            editorView: props.editorView,
            positions: positions,
            isEmpty: isEmpty,
            selectionType: selectionType,
            baseGenerate: baseGenerate,
            configItem: configItem,
            aiLifeCycleDynamicAttributesGetter: props.editorPluginAIProvider?.aiLifeCycleDynamicAttributesGetter,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            getMentionNameDetails: props.getMentionNameDetails,
            triggeredFor: props.triggeredFor,
            usePageKnowledge: true,
            endExperience: props.endExperience,
            streamingHandler: streamingHandler
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (props.defaultAgent && $879cf065fd9eac44$var$canReplaceBaseGenerate(props.editorPluginAIProvider)) {
            const newBaseGenerate = (0, $f32dd05596568c69$export$dc3b52bb600cbaa7)({
                agent: props.defaultAgent,
                product: props.editorPluginAIProvider.product,
                isInDocumentStreamingEnabled: props.editorPluginAIProvider.isInDocumentStreamingEnabled
            });
            send({
                type: 'update baseGenerate and configItem',
                baseGenerate: newBaseGenerate,
                configItem: newBaseGenerate
            });
        }
    }, [
        props.defaultAgent,
        props.editorPluginAIProvider,
        send
    ]);
    const [start, end] = props.positions;
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        // Note -- the intention is to have the state machine created at a higher
        // level, and have the positions updated without being passed into this react
        // component.
        send({
            type: 'update positions',
            positions: [
                start,
                end
            ]
        });
    // Separate start/end as React will recognise tuples recreated
    // as a change, even if the values don't change
    }, [
        send,
        start,
        end
    ]);
    $879cf065fd9eac44$var$useFocusEditor({
        editorView: editorView
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ function handleEscapeKeyDown(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
            const modalActiveState = state?.['modal active state'];
            const experience = modalActiveState?.experience;
            if (typeof experience === 'object' && 'loading state' in experience && experience['loading state'] === 'loading') {
                if (modalActiveState?.discard === 'active') send({
                    type: 'disable discard'
                });
                else send({
                    type: 'enable discard'
                });
            } else {
                if ((0, $a0bc851fc153e218$export$f332b66be3f378cc)(context.promptTrigger, context.responseHistory)) {
                    endExperience();
                    return;
                }
                send({
                    type: 'escape'
                });
            }
        }
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ function handleEscapeKeyUp(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
        }
        // initially, editor is focused
        // when AI modal is loading and user presses ESC
        // we will show the AI modal discard screen
        // which will make AI modal to be auto focused
        // now if user presses ESC again,
        // we will return to the AI modal loading screen
        // so whenever user presses ESC, either the AI modal or the editor is focused
        // so the listener should be attached to the common ancestor of the AI Modal and the editor
        const node = modalRef.current;
        if (!node) return;
        return (0, $cbY7C.bindAll)(node, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        modalRef,
        state,
        send,
        context.promptTrigger,
        context.responseHistory,
        endExperience,
        editorView,
        api
    ]);
    const [isMounted, setIsMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        (0, $cozmU.startTransition)(()=>{
            setIsMounted(true);
        });
    }, [
        modalRef
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!modalRef.current) return;
        if (isMounted) modalRef.current?.scrollIntoView({
            block: 'nearest',
            behavior: 'auto'
        });
    }, [
        isMounted,
        modalRef
    ]);
    const aiExperienceCommonData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            appearance: props.appearance,
            // configItem can be changed within state machine, so always get it from machine context.
            configItem: context.configItem,
            editorPluginAIProvider: props.editorPluginAIProvider,
            endExperience: props.endExperience,
            lastTriggeredFrom: props.lastTriggeredFrom,
            providerFactory: props.providerFactory,
            editorView: props.editorView,
            positions: props.positions,
            triggerMethod: props.triggerMethod,
            triggeredFor: props.triggeredFor,
            sendToAIExperienceMachine: send,
            modalRef: modalRef,
            isUserScroll: isUserScroll,
            isProgrammaticScroll: isProgrammaticScroll,
            engagementPlatformApi: props.engagementPlatformApi,
            includeKnowledgeFromCurrentPage: context.usePageKnowledge,
            canInlineStreamChanges: props.canInlineStreamChanges,
            hideLoadingScreen: props.hideLoadingScreen,
            aiSessionId: props.interactionSessionId
        }), [
        context.configItem,
        context.usePageKnowledge,
        props.editorView,
        props.editorPluginAIProvider,
        props.appearance,
        props.endExperience,
        props.lastTriggeredFrom,
        props.providerFactory,
        props.positions,
        props.triggerMethod,
        props.triggeredFor,
        props.engagementPlatformApi,
        props.canInlineStreamChanges,
        send,
        modalRef,
        isUserScroll,
        isProgrammaticScroll,
        props.hideLoadingScreen,
        props.interactionSessionId
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            traceIds: context.traceIds
        });
    }, [
        analyticsFlow,
        context.traceIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // We set these to ensure that when focus initially moves to
        // an element within the modal, that context about the modal
        // (e.g. "Atlassian Intelligence Dialog") is announced too
        role: "dialog",
        // ED-19787
        // We would like to use aria-labelledBy so we can label this
        // dynamically for each screen, however it's not working as expected
        // in Chrome and Firefox (works in Safari). For now we'll use the dialog
        // role and make the first element of each screen a screen-reader accessible
        // heading for the experience.
        // aria-label={intl.formatMessage(experienceMessages.dialogAriaLabel)}
        "aria-label": intl.formatMessage((0, $2ce115f17ed17fcd$export$c73af7ca4a2501ab).dialogAriaLabel),
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4d8cf0904a436811$export$cad72db1c520741c).Provider, {
        value: aiExperienceCommonData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($879cf065fd9eac44$export$501630857d1b4132, {
        api: api,
        state: state,
        context: context,
        initialPrompt: props.initialPrompt,
        modalRef: modalRef,
        streamFlowPacer: streamFlowPacerRef.current
    })));
}
function $879cf065fd9eac44$export$8b0e36b4d2610ae7(props) {
    const analyticsFlow = (0, $02d337cdf5827f29$export$b26e0d212ef01829)({
        invokeAttributes: {
            invokedFrom: props.lastTriggeredFrom,
            invokedFor: props.triggeredFor ? props.triggeredFor.name : 'text',
            triggerMethod: props.triggerMethod,
            experienceName: props.configItem.key,
            featureId: props.configItem.featureId,
            aiGroupId: props.aiGroupId,
            aiSessionId: props.interactionSessionId,
            willAISuggestEmoji: props.willAISuggestEmoji
        },
        canInlineStreamChanges: ()=>false,
        isInDocumentStreamingEnabled: false
    });
    // initialPositions is updated many times during in-doc streaming,
    // but we only want to update the common analytics attributes once,
    // so we check if they've already been updated
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const isInvokedFromEmptyPage = (0, $iLrhi.isEmptyDocument)(props.editorView.state.doc);
        analyticsFlow.updateCommonAttributes({
            isInvokedFromEmptyPage: isInvokedFromEmptyPage,
            /**
       * Confidence score will be used passed in analytics events.
       * It is currently only set when "Improve writing" is triggered from the
       * 	"Improve writing" nudge.
       */ nudgeMetrics: props.nudgeMetrics
        });
        if (props.initialPositions) {
            const selectionCategory = (0, $3117ebeab67c20f0$export$385434a4b24ab280)(props.editorView, props.initialPositions);
            analyticsFlow.updateCommonAttributes({
                isInvokedFromEmptyPage: isInvokedFromEmptyPage,
                selectionCategory: selectionCategory
            });
        }
    }, [
        analyticsFlow,
        props.editorView,
        props.initialPositions,
        props.nudgeMetrics
    ]);
    // finish analytics flow and fire remaining steps on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            // have to postpone until animation frame to make sure we end analytics flow after child components unmount
            // which is where we enqueue last events
            window.requestAnimationFrame(()=>{
                analyticsFlow.fireQueuedStep();
            });
        };
    }, [
        analyticsFlow
    ]);
    // This makes sure that the selection preview is hidden when the experience is unmounted
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            const tr = props.editorView.state.tr;
            tr.setMeta('hideSelectionPreview', true);
            props.editorView.dispatch(tr);
        };
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $405400f22f07581a$export$61f6bd9fac8ed53), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCloseFallback: ()=>{
            props.endExperience();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02d337cdf5827f29$export$b8f39b5859612546), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "EditorAICommandPalette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($879cf065fd9eac44$var$ExperienceApplicationStateWrapper, {
        ...props,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        analyticsContext: {
            aiSessionId: analyticsFlow.aiSessionId,
            aiGroupId: props.aiGroupId ?? analyticsFlow.aiSessionId
        }
    }))));
}


/* eslint-disable @repo/internal/react/no-class-components */ /* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */ 






















const $7483cb76c54ec498$export$61f6bd9fac8ed53 = (props)=>{
    const fireAIAnalyticsEvent = (0, $hZdqw.useFireAIAnalyticsEvent)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7483cb76c54ec498$var$ExperienceApplicationErrorBoundaryClass, {
        ...props,
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        formatMessage: formatMessage
    });
};
class $7483cb76c54ec498$var$ExperienceApplicationErrorBoundaryClass extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    shouldRecover() {
        return this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-ai-error-boundary'
        });
        if (error.name === (0, $126aacb890017ec7$export$8a78f5c7307b478b)) {
            const errorHasTypeProperty = 'type' in error;
            const errorSubType = errorHasTypeProperty ? error.type : undefined;
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack || '',
                        errorType: 'markdownToProseMirrorError',
                        errorSubType: errorSubType,
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $7ZL6d.aiMessages).markdownErrorMessage)
            });
        } else {
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack || '',
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $7ZL6d.aiMessages).unhandledErrorMessage)
            });
        }
    }
    render() {
        if (this.shouldRecover()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c706689b83036a7e$export$40729e8ab35829ea), {
            text: this.state.fallbackMessage,
            onCancel: this.props.onCloseFallback
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.getFallbackMessage = (descriptor)=>{
            return this.props.formatMessage(descriptor);
        };
        this.state = {
            errorCaptured: false,
            fallbackMessage: this.getFallbackMessage((0, $7ZL6d.aiMessages).unhandledErrorMessage)
        };
    }
}


/* ModalRegionLegacy.tsx generated by @compiled/babel-plugin v2.0.0 */ 






















// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $d67739b9f0c0db36$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $d67739b9f0c0db36$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $d67739b9f0c0db36$var$akAiModalRegionZIndex = Math.min($d67739b9f0c0db36$var$MAX_Z_INDEX, Math.max($d67739b9f0c0db36$var$MIN_Z_INDEX, (0, $7Y8M5.akEditorFloatingPanelZIndex) + 2));
const $d67739b9f0c0db36$var$slideFadeIn = null;
const $d67739b9f0c0db36$var$modalStyles = null;
const $d67739b9f0c0db36$var$getModalDecorationElement = (editorView)=>{
    return editorView?.dom.querySelector('.ai-modal-end-widget') || editorView?.dom.querySelector('.ai-selection-node');
};
const $d67739b9f0c0db36$export$bd71f7a11db32a15 = ({ children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, appearance: appearance, endExperience: endExperience, lastTriggeredFrom: lastTriggeredFrom, decorationSet: decorationSet, autoScroll: autoScroll })=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorViewElement = editorView.dom;
    const modalRef = (0, $cozmU.useRef)(null); // Widened to match `getModalLeft`'s `number | string` return; legacy always
    // takes the numeric branch, so behaviour is unchanged.
    const [modalLeft, setModalLeft] = (0, $cozmU.useState)(0);
    const [modalTop, setModalTop] = (0, $cozmU.useState)(0);
    const [modalWidth, setModalWidth] = (0, $cozmU.useState)(0);
    const [transition, setTransition] = (0, $cozmU.useState)('');
    const scrollParentRef = (0, $cozmU.useRef)(null); // get nearest resizable wrapper or breakout container looking up from the ai decoration position
    const resizableOrBreakoutWrapper = (0, $cozmU.useMemo)(()=>(0, $abec54562d55018e$export$9e4eede810cdf154)(editorView, decoration.to), [
        editorView,
        decoration
    ]);
    const modalDecorationElement = $d67739b9f0c0db36$var$getModalDecorationElement(editorView); // EDF-161: https://product-fabric.atlassian.net/browse/EDF-161
    // If the editor has a max-height set, we need to set position relative for .ak-editor-content-area
    (0, $cozmU.useEffect)(()=>{
        if (appearance === 'comment') {
            // editorRelativeWrapper is the closest but can be null
            // fallback to modalDecorationElement if editorRelativeWrapper is null
            let editorContentArea = null;
            if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
            else if (modalDecorationElement) editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
            if (editorContentArea) {
                const computedStyle = getComputedStyle(editorContentArea);
                const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                const originalPosition = computedStyle.position;
                if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                return ()=>{
                    if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                };
            }
        }
    }, [
        modalDecorationElement,
        appearance,
        editorRelativeWrapper
    ]); // listen for editor resize and update modal size and position
    (0, $cozmU.useEffect)(()=>{
        const setModalPosition = ()=>{
            if (!modalRef.current || !modalDecorationElement || !modalDecorationElement.offsetParent) // The modalDecorationElement.offsetParent is used when calculating the modal top postion. If it is null
            // the modal will flikcer from top to bottom, because the top position resets to 0.
            return;
            let relativePositionElement = editorViewElement; // When layout resizes / breakout changes, resizableOrBreakoutWrapper remounts
            // We need to wait for resizableOrBreakoutWrapper to update before we can calculate modal positions
            // Return if resizableOrBreakoutWrapper doesn't exist in view as it hasn't been updated yet to avoid flickering
            if (resizableOrBreakoutWrapper && !editorViewElement.contains(resizableOrBreakoutWrapper)) return;
             // position relative to breakout element when its available, or otherwise relative to editor view
            relativePositionElement = resizableOrBreakoutWrapper || editorViewElement;
            const top = (0, $abec54562d55018e$export$6fabade9f8472f78)({
                appearance: appearance,
                modalElement: modalRef.current,
                editorRelativeWrapper: editorRelativeWrapper,
                modalDecorationElement: modalDecorationElement,
                lastTriggeredFrom: lastTriggeredFrom,
                editorView: editorView
            });
            const left = (0, $abec54562d55018e$export$f695eeeda1b3ceee)({
                relativePositionElement: relativePositionElement,
                modalElement: modalRef.current
            });
            setModalLeft(left);
            setModalTop(top);
            setModalWidth(relativePositionElement.offsetWidth); //setting width to be animated here to make animation happen only after first positioning
            if (!transition) setTransition('all 0.1s ease-in');
        };
        setModalPosition();
        const setModalPositionDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setModalPosition();
        }, 20);
        const resizeObserver = new ResizeObserver(setModalPositionDebounced);
        resizeObserver.observe(editorViewElement); // editorViewOffsetParent can be undefined when editor is set to display: none
        // (when Confluence switches to Preview mode)
        const editorViewOffsetParent = editorViewElement.offsetParent;
        if (editorViewOffsetParent) // This resize observer is intended to fix the position of the modal region
        // when the config panel (for extensions or templates) is opened/closed
        resizeObserver.observe(editorViewOffsetParent);
         // listen to any changes in the resizableOrBreakoutWrapper if modal was triggered in
        // layout or table with breakout / resizable table
        if (resizableOrBreakoutWrapper) resizeObserver.observe(resizableOrBreakoutWrapper);
        return ()=>{
            resizeObserver.disconnect(); //clearing any potentially running debounced reposition
            setModalPositionDebounced.cancel();
        }; // no need to rerun due to transition change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorViewElement,
        modalDecorationElement,
        editorRelativeWrapper,
        resizableOrBreakoutWrapper
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!modalRef.current) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalRef.current) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!autoScroll || !modalTop) return;
        const modalEl = modalRef.current;
        if (!modalEl || !modalDecorationElement) return;
        if (!scrollParentRef.current) {
            const scrollParentEl = (0, $1jz5K.findOverflowScrollParent)(modalEl) || null;
            if (!scrollParentEl) return;
            scrollParentRef.current = scrollParentEl;
        } // The following values are all absoltue values this way they can all be easily compared to one another.
        const viewportTop = scrollParentRef.current.scrollTop;
        const viewportBottom = scrollParentRef.current.scrollTop + (scrollParentRef.current.offsetHeight - (0, $8312663103724919$export$9a9d72a255528f));
        const modalTippyTop = Math.max(0, modalTop - modalDecorationElement.offsetHeight);
        const modalBottom = modalTop + modalEl.offsetHeight; // Check if modal is already fully visible within the viewport.
        const isModalWithinViewport = modalTippyTop >= viewportTop && modalBottom <= viewportBottom;
        const isModalAboveViewport = modalTippyTop < viewportTop; // We should be able to surmise that if the modal is not within the viewport or above it, then it's below it.
        /**
     * Check if modal height exceeds scroll parent's height
     * Scroll margin is used to prevent the modal from being scrolled to the top
     * and should match scroll margin in other modals e.g. from
     * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
     */ const isModalFullHeight = scrollParentRef.current.offsetHeight - (0, $8312663103724919$export$9a9d72a255528f) < modalEl.scrollHeight;
        if (isModalWithinViewport) // If the model fits in the view then we should not scroll at all
        return;
        if (isModalFullHeight || isModalAboveViewport) {
            // If the modal is bigger then the viewport, or above it, then we will scroll to the top of it
            scrollParentRef.current.scroll({
                top: Math.max(0, modalTippyTop - (0, $8312663103724919$export$9a9d72a255528f)),
                behavior: 'instant'
            });
            return;
        } // If the modal is not within the viewport, or above it, then it must off the bottom or below it. So we will
        // want to scroll the page down, just enough to bring the bottom of the modal into view. This should just be
        // a matter of gettting the delta between the btm of the modal and the btm of the viewport and adding that
        // onto the current viewport top.
        scrollParentRef.current.scroll({
            top: viewportTop + Math.max(modalBottom - viewportBottom, 0) + (0, $8312663103724919$export$9a9d72a255528f),
            behavior: 'instant'
        });
    }, [
        autoScroll,
        modalTop,
        modalDecorationElement
    ]);
    // sync modal height with editor content area height
    (0, $29641a2faeabcff2$export$a5441b49687f80f6)({
        modalElement: modalRef.current,
        editorViewElement: editorViewElement,
        isInDocumentStreamingEnabled: false
    }); // Check for the modal decoration which is used for positioning
    // If there is none the modal should be removed from the DOM & return early
    // This is intended to make the code more resilient to bugs caused by the
    // editor AI plugin not being reinstantiated correctly when the editor is closed/opened
    // See https://product-fabric.atlassian.net/browse/EDITOR-52
    if (decorationSet === (0, $8nvEM.DecorationSet).empty) {
        endExperience();
        return null;
    }
    const style = {
        top: modalTop,
        transition: transition,
        left: modalLeft,
        '--content-width': `${modalWidth}px`,
        display: modalWidth ? 'block' : 'none'
    };
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_3138425zaO _1mT5xdWVPG _42Yu6BuSvk _0adFHsUgYP _2XsHFMUgYP _39xV02dUXO _1gBibynkof _0nFVCG2HTN _43vdfT1fFG _3Y6bKpgRhm _1VPqc3YbGa",
            "ak-editor-plugin-ai-modal"
        ]),
        "data-testid": "ai-plugin-modal",
        ref: modalRef,
        // Otherwise, content selection will be prevented in packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
        "data-editor-popup": true,
        style: {
            ...style,
            "--_1dsp0pi": (0, $9aYkv.default)($d67739b9f0c0db36$var$akAiModalRegionZIndex)
        }
    }, children);
};





const $3184e366183ecce7$export$2dda1e4a1d1f6a81 = ()=>{
    const { aiOptIn: aiOptIn, editorPluginAIProvider: editorPluginAIProvider, editorView: editorView, api: api, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, getMentionNameDetails: getMentionNameDetails, canInlineStreamChanges: canInlineStreamChanges, isRovoLoading: isRovoLoading } = (0, $2702c2980a93d5fd$export$c8b5a1f09cc4bb85)();
    const { aiDecorationExperiencePluginState: aiDecorationExperiencePluginState, rovoAgentsPluginState: rovoAgentsPluginState, editorViewModeMode: editorViewModeMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience',
        'editorViewMode'
    ], (states)=>({
            aiDecorationExperiencePluginState: states.aiExperienceState?.aiDecorationExperiencePluginState,
            rovoAgentsPluginState: states.aiExperienceState?.rovoAgentsPluginState,
            editorViewModeMode: states.editorViewModeState?.mode
        }));
    const isDecorationSetEmpty = !aiDecorationExperiencePluginState || aiDecorationExperiencePluginState.modalDecorationSet === (0, $8nvEM.DecorationSet).empty;
    const isViewMode = editorViewModeMode === 'view';
    const decorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(editorView.state);
    const intl = (0, $kSwu1.useIntl)();
    const endExperience = (0, $cozmU.useCallback)((options)=>{
        if (editorPluginAIProvider.onAIProviderChanged) editorPluginAIProvider.onAIProviderChanged('command-palette');
        const state = (0, $C4yPo.getPluginState)(editorView.state);
        const decoSet = (0, $dSwlt.hasGeneratedContentDecorations)(state) || options?.preserveEditorSelectionOnComplete ? state.modalDecorationSet : undefined;
        const endAIExperienceCommand = (0, $4TgUg.createEndAIExperienceCommand)(decoSet, options?.preserveEditorSelectionOnComplete, options?.shouldClearSelectionContext);
        endAIExperienceCommand(editorView.state, editorView.dispatch);
        editorView.focus();
    }, [
        editorView,
        editorPluginAIProvider
    ]);
    const { send: send, state: state, context: context } = (0, $18fb1940e348cb4f$export$519bc24a166a4cfd)({
        context: {
            analyticsContext: {
                aiSessionId: '',
                aiGroupId: ''
            },
            aiProvider: editorPluginAIProvider,
            intl: intl,
            editorView: editorView,
            positions: [
                0,
                0
            ],
            isEmpty: true,
            selectionType: 'empty',
            configItem: editorPluginAIProvider?.baseGenerate,
            markdown: '',
            latestPromptResponse: undefined,
            editCount: 0,
            refinementCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: [],
                totalSize: 0,
                traversals: 0
            },
            channelId: undefined,
            usePageKnowledge: true,
            endExperience: endExperience
        }
    });
    /**
   * We only want to enable directional modal pinning when in the
   * prompt input state.
   */ const isDirectionalPinningEnabled = !isRovoLoading && typeof state === 'object' && state['modal active state']['experience'] === 'command palette state'; // We use this point to render the modal if needed instead of decorators
    // The reason this is preferrable is it has access to mount points
    // where decorators are rendered with a mount point within the Editor content
    // and longer modals get clipped as a result.
    const renderModalRegion = ()=>{
        // If there are no active decorations -- then we don't want to render the ai experience.
        if (isDecorationSetEmpty) return null;
        if ((0, $dSwlt.hasGeneratedContentDecorations)(aiDecorationExperiencePluginState)) return null;
         // Prioritise getting position from inlineDecoration,
        // otherwise get decoration position from start or end widget
        let positions;
        let decoration = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration').shift() || aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration').shift();
        if (decoration) {
            // when there is decoration, it means it's text selection
            // we need to use the initial positions
            // as the decoration positions are not accurate when there the selection is empty
            if (!aiDecorationExperiencePluginState?.initialPositions) return null;
            positions = aiDecorationExperiencePluginState?.initialPositions;
        } else {
            const nodeDecorations = aiDecorationExperiencePluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
            if (nodeDecorations.length > 0) {
                const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
                const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
                positions = [
                    startPos,
                    endPos
                ];
            }
            decoration = nodeDecorations.shift();
        }
        if (!decoration) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d67739b9f0c0db36$export$bd71f7a11db32a15), {
            isDirectionalPinningEnabled: isDirectionalPinningEnabled,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            key: aiDecorationExperiencePluginState.modalMountedTimeStamp,
            decoration: decoration,
            editorView: editorView,
            editorRelativeWrapper: wrapperElement?.offsetParent,
            endExperience: endExperience,
            appearance: appearance,
            decorationSet: aiDecorationExperiencePluginState.modalDecorationSet
        }, aiDecorationExperiencePluginState.configItem && editorView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $879cf065fd9eac44$export$8b0e36b4d2610ae7), {
            api: api,
            context: context,
            send: send,
            state: state,
            configItem: aiDecorationExperiencePluginState.configItem,
            editorPluginAIProvider: editorPluginAIProvider,
            endExperience: endExperience,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            positions: positions,
            editorView: editorView,
            providerFactory: providerFactory,
            lastTriggeredFrom: aiDecorationExperiencePluginState.lastTriggeredFrom,
            triggerMethod: aiDecorationExperiencePluginState.triggerMethod,
            appearance: appearance,
            initialPrompt: aiDecorationExperiencePluginState?.initialPrompt,
            getMentionNameDetails: getMentionNameDetails,
            triggeredFor: aiDecorationExperiencePluginState.triggeredFor,
            engagementPlatformApi: api?.engagementPlatform?.actions,
            initialPositions: aiDecorationExperiencePluginState?.initialPositions,
            nudgeMetrics: aiDecorationExperiencePluginState.nudgeMetrics,
            defaultAgent: rovoAgentsPluginState?.defaultAgent,
            canInlineStreamChanges: canInlineStreamChanges,
            hideLoadingScreen: decorationPluginState?.hideLoadingScreen,
            aiGroupId: aiDecorationExperiencePluginState?.currentSessionId,
            interactionSessionId: aiDecorationExperiencePluginState?.interactionSessionId,
            willAISuggestEmoji: aiDecorationExperiencePluginState?.willAISuggestEmoji
        }));
    };
    const getPositions = ()=>{
        return (0, $3117ebeab67c20f0$export$8e313fd1eaf35cec)({
            modalDecorationSet: aiDecorationExperiencePluginState?.modalDecorationSet
        });
    };
    const renderedSubscribeToRovo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31ae21bd6736f6cf$export$e7460f646530f5b4), {
        editorApi: api,
        positions: getPositions(),
        editorView: editorView,
        product: editorPluginAIProvider.product,
        onDocChangeByAgent: editorPluginAIProvider.onDocChangeByAgent,
        onAIProviderChanged: editorPluginAIProvider.onAIProviderChanged,
        editorPluginAIProvider: editorPluginAIProvider
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5cf769efe8d70c8d$export$6d436ac1332526a3), {
        editorView: editorView,
        editorPluginAIProvider: editorPluginAIProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3bd8f9494e0747d8$export$e4b2c7b98f669fb7), {
        editorView: editorView,
        getMentionNameDetails: getMentionNameDetails,
        editorPluginAIProvider: editorPluginAIProvider,
        editorApi: api,
        isViewMode: isViewMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8c1517f464dc33e9$export$22e51ab65638ad05), {
        editorPluginAIProvider: editorPluginAIProvider,
        editorView: editorView
    }), renderedSubscribeToRovo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7483cb76c54ec498$export$61f6bd9fac8ed53), {
        inContentComponent: true,
        onCloseFallback: endExperience
    }, renderModalRegion(), rovoAgentsPluginState?.isBrowseModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0e9b55d7410177be$export$62821c88a7188481), {
        editorView: editorView,
        aiGlobalOptIn: aiOptIn,
        editorPluginAIProvider: editorPluginAIProvider,
        startingConfig: aiDecorationExperiencePluginState?.configItem,
        positions: rovoAgentsPluginState?.positions
    })));
};


const $c997f1dd36211338$export$d1314adfeea5c2b2 = (props)=>{
    const aiDecorationExperiencePluginState = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState);
    const modalMountedTimeStamp = aiDecorationExperiencePluginState?.modalMountedTimeStamp; /**
                                                                                           * This is to detect the state of the Rovo prompt and loading screens
                                                                                           * from RovoInlineChatPrompt used in RovoPromptScreenWithLogic,
                                                                                           * as it does not respect the state value from XState.
                                                                                           */ 
    const [isRovoLoading, setIsRovoLoading] = (0, $cozmU.useState)(false); /* reset the component when start AI again, so that the error boundary will also be reset */ 
    return /*#__PURE__*/ $cozmU.createElement((0, $9efbc1f6470a3ad1$export$214e018fc3e147ea), null, /*#__PURE__*/ $cozmU.createElement((0, $2702c2980a93d5fd$export$9bdba9f1d1439b59), {
        value: {
            ...props,
            isRovoLoading: isRovoLoading,
            setIsRovoLoading: setIsRovoLoading
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $3184e366183ecce7$export$2dda1e4a1d1f6a81), {
        key: modalMountedTimeStamp
    })));
};


/* StreamingContentComponent.tsx generated by @compiled/babel-plugin v2.0.0 */ 



const $7fb8868443a415ff$export$87f8e9111167b374 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $a971ff574ffb9b5a$export$214e018fc3e147ea), null, null);















var $3IBFJ = parcelRequire("3IBFJ");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");

var $bFSJa = parcelRequire("bFSJa");


var $cVdVi = parcelRequire("cVdVi");







var $3CdTA = parcelRequire("3CdTA");

var $74BSk = parcelRequire("74BSk");









var $2xJ2w = parcelRequire("2xJ2w");

















var $7vVCw = parcelRequire("7vVCw");


var $lQkyl = parcelRequire("lQkyl");


var $ddlQ3 = parcelRequire("ddlQ3");























var $f0b2F = parcelRequire("f0b2F");

const $8962f518f849d920$var$ATLASSIAN_PRODUCTS = new Set([
    'jira',
    'confluence',
    'bitbucket',
    'trello',
    'loom',
    'townsquare',
    'compass',
    'mercury',
    'atlas',
    'watermelon',
    'canvas',
    'rovo'
]);
const $8962f518f849d920$var$getHostnameFromUrl = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return '';
    }
};
const $8962f518f849d920$export$1a1507613ebdd5e0 = ({ details: details, smartlinkUrl: smartlinkUrl })=>{
    const objectProviderKey = details?.meta?.key?.toLowerCase() ?? '';
    const hasObjectProviderKey = objectProviderKey.length > 0;
    const isThirdPartyNonPublic = !Array.from($8962f518f849d920$var$ATLASSIAN_PRODUCTS).some((product)=>objectProviderKey.includes(product)) && !objectProviderKey.includes('public');
    const sourceProduct = hasObjectProviderKey ? objectProviderKey.split('-')[0] : null;
    const has3pSources = hasObjectProviderKey ? isThirdPartyNonPublic : false;
    // Extract the human-readable name from the SmartLink's JSON-LD data (the
    // `name` field on BaseData). Fall back to the URL hostname so the Rovo chat
    // context banner always has a non-empty label.
    const smartlinkData = details?.data;
    const smartlinkName = typeof smartlinkData?.name === 'string' && smartlinkData.name ? smartlinkData.name : $8962f518f849d920$var$getHostnameFromUrl(smartlinkUrl);
    return {
        has3pSources: has3pSources,
        smartlinkName: smartlinkName,
        sourceProduct: sourceProduct
    };
};


















var $f6j4r = parcelRequire("f6j4r");







const $7dfcec7fc3b4e630$export$d10faabbe9a379d9 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SUMMARIZE_SMART_LINK,
        title: (0, $93WrI.aiConfigItemMessages).summarizeWritingtitle,
        description: (0, $93WrI.aiConfigItemMessages).summarizeWritingDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6j4r.SummarizeIcon), null),
        showInRefineDropdown: false,
        insertOnEmptySelection: true,
        // intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
        intentSchemaId: 'summarize_smartlink_intent_schema.json',
        featureId: 'smartlink_summarize',
        adfPrompt: true,
        getRequestPayload: ({ locale: locale, aiSessionId: aiSessionId, contentAri: contentAri })=>({
                ai_feature_input: {
                    feature: 'smartlink_summarize',
                    feature_args: {
                        smartlink_url: options.smartlinkUrl
                    },
                    locale: locale,
                    ai_session_id: aiSessionId,
                    content_ari: contentAri
                }
            }),
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });


const $b6b61001640e68cf$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM = (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK_SUMMARIZE_BUTTON;
const $b6b61001640e68cf$export$b8ae96bfb00513fa = (options)=>(0, $7dfcec7fc3b4e630$export$d10faabbe9a379d9)(options);
function $b6b61001640e68cf$export$ab1472fec20613b2({ aiGlobalOptIn: aiGlobalOptIn, decorateDeselectTransaction: decorateDeselectTransaction, fireAnalyticsEvent: fireAnalyticsEvent, has3pSources: has3pSources, lastTriggeredFrom: lastTriggeredFrom = 'floatingToolbar', locale: locale, nodeRange: nodeRange, nodeType: nodeType, openSmartLinkSummarizePopup: openSmartLinkSummarizePopup, smartlinkUrl: smartlinkUrl, sourceProduct: sourceProduct, triggeredForMark: triggeredForMark, triggerMethod: triggerMethod = 'click' }) {
    return (state, dispatch, view)=>{
        fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK_SUMMARIZE_BUTTON,
            attributes: {
                sourceProduct: sourceProduct,
                has3pSources: has3pSources
            }
        });
        if (openSmartLinkSummarizePopup) {
            const { from: from, to: to } = nodeRange ?? state.selection;
            if (dispatch) {
                const deselectAt = Math.min(to + 1, state.doc.content.size);
                let tr = state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(deselectAt), 1));
                if (decorateDeselectTransaction) tr = decorateDeselectTransaction(tr);
                dispatch(tr);
            }
            openSmartLinkSummarizePopup({
                from: from,
                to: to,
                smartlinkUrl: smartlinkUrl,
                sourceProduct: sourceProduct,
                has3pSources: has3pSources,
                ...lastTriggeredFrom === $b6b61001640e68cf$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM ? {
                    invokedFrom: lastTriggeredFrom
                } : {}
            });
            return false;
        }
        const configItem = (0, $7dfcec7fc3b4e630$export$d10faabbe9a379d9)({
            smartlinkUrl: smartlinkUrl
        });
        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            aiGlobalOptIn: aiGlobalOptIn,
            locale: locale,
            triggeredFor: nodeType,
            sourceProduct: sourceProduct,
            has3pSources: has3pSources,
            triggeredForMark: triggeredForMark
        });
        openAIModalCommand(state, dispatch, view);
        return false;
    };
}
function $b6b61001640e68cf$export$7d548412b4a0df2({ editorView: editorView, ...commandOptions }) {
    const command = $b6b61001640e68cf$export$ab1472fec20613b2(commandOptions);
    command(editorView.state, editorView.dispatch, editorView);
}


const $5a9079f1f87c72e1$var$SMART_LINK_NODE_NAMES = new Set([
    'embedCard',
    'blockCard',
    'inlineCard'
]);
const $5a9079f1f87c72e1$var$getPastedSmartLinkNodeType = (state, pasteStartPos)=>{
    const { schema: schema, doc: doc } = state;
    const fallback = schema.nodes.inlineCard;
    if (pasteStartPos === undefined || pasteStartPos < 0 || pasteStartPos >= doc.content.size) return fallback;
    const node = doc.nodeAt(pasteStartPos);
    if (!node || !$5a9079f1f87c72e1$var$SMART_LINK_NODE_NAMES.has(node.type.name)) return fallback;
    return node.type;
};
const $5a9079f1f87c72e1$export$2d9e93e9ea435064 = ({ aiGlobalOptIn: aiGlobalOptIn, api: api, smartCardClientRef: smartCardClientRef })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const currentPastedLink = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin',
        'paste'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        const lastContentPasted = states.pasteState?.lastContentPasted;
        return {
            pasteEndPos: pluginState?.pasteEndPos ?? lastContentPasted?.pasteEndPos,
            pasteStartPos: pluginState?.pasteStartPos ?? lastContentPasted?.pasteStartPos,
            url: (0, $cVdVi.getSingleSmartLinkUrlFromSlice)(lastContentPasted?.pastedSlice)
        };
    });
    const pastedUrl = currentPastedLink.url;
    const [smartLinkDetails, setSmartLinkDetails] = (0, $cozmU.useState)();
    // Resolve the pasted Smart Link so summarize analytics can report the source
    // product and whether the content comes from a third-party provider.
    (0, $cozmU.useEffect)(()=>{
        // Clear stale metadata so a new paste never reports the previous link's provider.
        setSmartLinkDetails(undefined);
        const client = smartCardClientRef?.current;
        if (!pastedUrl || !client) return;
        let cancelled = false;
        client.fetchData(pastedUrl).then((response)=>{
            if (!cancelled) setSmartLinkDetails(response);
        }).catch(()=>{
        // Resolution failures shouldn't block summarize; skip 3p metadata.
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        pastedUrl,
        smartCardClientRef
    ]);
    const smartLinkMetadata = (0, $cozmU.useMemo)(()=>pastedUrl && smartLinkDetails ? (0, $8962f518f849d920$export$1a1507613ebdd5e0)({
            details: smartLinkDetails,
            smartlinkUrl: pastedUrl
        }) : undefined, [
        pastedUrl,
        smartLinkDetails
    ]);
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        if (!editorView || !currentPastedLink.url) return;
        const isKeyboardTrigger = 'key' in event;
        const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
        // The pasted Smart Link may resolve from inlineCard into a block-level
        // embedCard/blockCard, so use the actual node type at the paste position.
        const nodeType = $5a9079f1f87c72e1$var$getPastedSmartLinkNodeType(editorView.state, currentPastedLink.pasteStartPos);
        if (!nodeType) return;
        (0, $b6b61001640e68cf$export$ab1472fec20613b2)({
            aiGlobalOptIn: aiGlobalOptIn,
            decorateDeselectTransaction: api?.card?.actions.hideLinkToolbar,
            fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
            lastTriggeredFrom: 'pasteActionsMenu',
            locale: locale,
            nodeRange: currentPastedLink.pasteStartPos !== undefined && currentPastedLink.pasteEndPos !== undefined ? {
                from: currentPastedLink.pasteStartPos,
                to: currentPastedLink.pasteEndPos
            } : undefined,
            nodeType: nodeType,
            smartlinkUrl: currentPastedLink.url,
            sourceProduct: smartLinkMetadata?.sourceProduct,
            has3pSources: smartLinkMetadata?.has3pSources,
            triggeredForMark: editorView.state.schema.marks.link,
            triggerMethod: triggerMethod
        })(editorView.state, editorView.dispatch, editorView);
    }, [
        aiGlobalOptIn,
        api,
        currentPastedLink,
        editorView,
        locale,
        smartLinkMetadata
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "ai-paste-menu__smart-link-add-summary",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
            size: "medium",
            label: ""
        }),
        onClick: handleClick
    }, formatMessage({
        defaultMessage: "Add summary",
        id: "fabric.editor.ai.aiPasteMenu.addSummary"
    }));
};


const $de6b53764cd2bd07$var$SMART_LINK_NODE_NAMES = new Set([
    'embedCard',
    'blockCard',
    'inlineCard'
]);
const $de6b53764cd2bd07$var$getHostnameFromUrl = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
const $de6b53764cd2bd07$var$addPolishWithImproveFormatting = ()=>{
    const item = (0, $iTW08.addPolish)();
    // addPolish() already sets the title to improveFormattingTitle; only the description differs here.
    item.description = (0, $93WrI.aiConfigItemMessages).improveFormattingDescription;
    return item;
};
const $de6b53764cd2bd07$var$AIPasteMenuItem = ({ aiGlobalOptIn: aiGlobalOptIn, api: api, configItem: configItem, icon: icon, testId: testId })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, pastedSmartLinkUrl: pastedSmartLinkUrl } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin',
        'paste'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            pasteStartPos: pluginState?.pasteStartPos ?? 0,
            pasteEndPos: pluginState?.pasteEndPos ?? 0,
            pastedSmartLinkUrl: (0, $cVdVi.getSingleSmartLinkUrlFromSlice)(states.pasteState?.lastContentPasted?.pastedSlice)
        };
    });
    const label = formatMessage(configItem.title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: testId,
        elemBefore: icon,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onClick: (event)=>{
            if (!editorView) return;
            const isKeyboardTrigger = 'key' in event;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const docSize = editorView.state.doc.content.size;
            const nodeAtPasteStartNode = pasteStartPos >= 0 && pasteStartPos <= docSize ? editorView.state.doc.nodeAt(pasteStartPos) : undefined;
            const hasValidOverrideRange = pasteStartPos >= 0 && pasteStartPos <= docSize && pasteEndPos >= pasteStartPos && pasteEndPos <= docSize;
            let safeOverrideFromPos = pasteStartPos;
            let safeOverrideToPos = pasteEndPos;
            if (!hasValidOverrideRange) {
                if (nodeAtPasteStartNode) {
                    safeOverrideFromPos = pasteStartPos;
                    safeOverrideToPos = Math.min(pasteStartPos + nodeAtPasteStartNode.nodeSize, docSize);
                } else {
                    safeOverrideFromPos = editorView.state.selection.from;
                    safeOverrideToPos = editorView.state.selection.to;
                }
            }
            const pastedSmartLinkNode = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) && pastedSmartLinkUrl && nodeAtPasteStartNode && $de6b53764cd2bd07$var$SMART_LINK_NODE_NAMES.has(nodeAtPasteStartNode.type.name) ? nodeAtPasteStartNode : undefined;
            const smartLinkUrl = pastedSmartLinkNode && typeof pastedSmartLinkUrl === 'string' ? pastedSmartLinkUrl : undefined;
            const overrideFromPos = pastedSmartLinkNode ? pasteStartPos : safeOverrideFromPos;
            const overrideToPos = pastedSmartLinkNode ? pasteStartPos + pastedSmartLinkNode.nodeSize : safeOverrideToPos;
            const configItemForSelection = smartLinkUrl ? {
                ...configItem,
                openInRovoChat: true,
                rovoChatAIFeatureContext: {
                    projectContext: {
                        projectId: smartLinkUrl,
                        projectName: $de6b53764cd2bd07$var$getHostnameFromUrl(smartLinkUrl),
                        projectUrl: smartLinkUrl
                    }
                }
            } : configItem;
            // Set the editor selection to the pasted content range before opening the
            // AI modal. This ensures that Rovo uses the pasted content as context
            // rather than the entire page, matching the behaviour of the smartlink
            // toolbar version. See: open-remix-modal.ts for the same pattern.
            const pasteSelection = pastedSmartLinkNode ? (0, $kCECX.NodeSelection).create(editorView.state.doc, overrideFromPos) : (0, $kCECX.TextSelection).create(editorView.state.doc, overrideFromPos, overrideToPos);
            const selectionTr = editorView.state.tr.setSelection(pasteSelection);
            editorView.dispatch(selectionTr);
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItemForSelection,
                lastTriggeredFrom: 'pasteActionsMenu',
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale,
                overrideFromPos: overrideFromPos,
                overrideToPos: overrideToPos,
                shouldExpandPositions: false
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, label);
};
const $de6b53764cd2bd07$var$AIPasteMenuSection = ({ children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        title: intl.formatMessage((0, $3IBFJ.pasteOptionsToolbarMessages).pasteMenuActionsTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "menu"
    }, children));
};
const $de6b53764cd2bd07$export$7dcbffc05d21be5a = 'ai-paste-menu';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY = (0, $3nacY.AI_PASTE_MENU_SECTION).key;
const $de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY = 'ai-paste-menu-improve-writing';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY = 'ai-paste-menu-fix-spelling-and-grammar';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY = 'ai-paste-menu-add-polish';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY = 'ai-paste-menu-make-shorter';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_LONGER_KEY = 'ai-paste-menu-make-longer';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_REMIX_KEY = 'ai-paste-menu-remix';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_SUMMARY_KEY = 'ai-paste-menu-add-summary';
const $de6b53764cd2bd07$var$AI_PASTE_MENU_ASK_ROVO_KEY = 'ai-paste-menu-ask-rovo';
const $de6b53764cd2bd07$export$ca6df04620e79a79 = [
    'codeBlock',
    'heading'
];
const $de6b53764cd2bd07$export$bc7d0546d8387be1 = ()=>{
    const raw = (0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu', 'excludedNodes', '');
    if (!raw) return $de6b53764cd2bd07$export$ca6df04620e79a79;
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0 && parsed.every((n)=>typeof n === 'string')) return parsed;
    } catch  {
    // Invalid JSON – fall through to default.
    }
    return $de6b53764cd2bd07$export$ca6df04620e79a79;
};
const $de6b53764cd2bd07$export$1dd4f74662071fa7 = [
    {
        button: $de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY,
        charMinThreshold: 100,
        rank: 2
    },
    {
        button: $de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY,
        charMinThreshold: 100,
        rank: 3
    },
    {
        button: $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY,
        charMinThreshold: 100,
        charMaxThreshold: 600,
        rank: 4
    },
    {
        button: $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY,
        charMinThreshold: 601,
        rank: 1
    }
];
const $de6b53764cd2bd07$var$isAIPasteMenuButtonConfig = (value)=>typeof value === 'object' && value !== null && typeof value.button === 'string' && typeof value.charMinThreshold === 'number' && (typeof value.charMaxThreshold === 'number' || value.charMaxThreshold === undefined) && typeof value.rank === 'number';
const $de6b53764cd2bd07$export$87db0edb358e0b12 = ()=>{
    const raw = (0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu', 'menuConfig', '');
    if (!raw) return $de6b53764cd2bd07$export$1dd4f74662071fa7;
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length > 0 && parsed.every($de6b53764cd2bd07$var$isAIPasteMenuButtonConfig)) return parsed;
    } catch  {
    // Invalid JSON – fall through to default.
    }
    return $de6b53764cd2bd07$export$1dd4f74662071fa7;
};
/**
 * Returns true when the pasted text does not look like prose — i.e. it contains
 * no whitespace AND is entirely ASCII characters (after trimming).
 *
 * Text without spaces that is all-ASCII is very likely a URL, file path, token,
 * hash, or variable name — content where AI writing suggestions (improve writing,
 * fix spelling, etc.) would not be useful.
 *
 * We require all-ASCII because many natural languages (Chinese, Japanese, Thai,
 * Lao, Khmer, etc.) do not use spaces between words, so a no-whitespace check
 * alone would incorrectly flag those as non-prose.
 */ const $de6b53764cd2bd07$var$hasTableNode = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};
const $de6b53764cd2bd07$export$71535a792a9ee562 = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};
const $de6b53764cd2bd07$export$28b4a677d2c0d8b0 = ({ aiGlobalOptIn: aiGlobalOptIn, api: api, getAppearance: getAppearanceProp, appearance: appearanceAtRegistration, product: product, smartCardClientRef: smartCardClientRef })=>{
    /**
   * Hides the component when the pasted URL is inaccessible.
   * Falls back to hidden when the SmartCard client is not available.
   */ const smartlinkAsyncHidden = async (context)=>{
        const { pastedUrl: pastedUrl } = context;
        if (!pastedUrl) return false;
        const isEnabled = (0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true);
        const smartCardClient = smartCardClientRef?.current;
        if (!isEnabled || !smartCardClient) return true;
        try {
            const response = await smartCardClient.fetchData(pastedUrl);
            return response.meta?.access !== 'granted';
        } catch  {
            // Network / auth errors → hide
            return true;
        }
    };
    const getAppearance = ()=>getAppearanceProp?.() ?? api?.core?.sharedState.currentState()?.appearance ?? appearanceAtRegistration;
    const activeConfig = $de6b53764cd2bd07$export$87db0edb358e0b12();
    const getPlaintextLength = ()=>{
        const state = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
        return state?.plaintextLength ?? 0;
    };
    const getAncestorNodeNames = ()=>{
        const state = api?.pasteOptionsToolbarPlugin?.sharedState.currentState();
        return state?.pasteAncestorNodeNames ?? [];
    };
    const getPastedText = ()=>{
        const state = api?.paste?.sharedState.currentState();
        return state?.lastContentPasted?.text;
    };
    const getPastedSlice = ()=>{
        const state = api?.paste?.sharedState.currentState();
        return state?.lastContentPasted?.pastedSlice;
    };
    const configByKey = Object.fromEntries(activeConfig.map((c)=>[
            c.button,
            c
        ]));
    /** V1 (pre-rules) visibility check. Pure config + shared-state logic. */ const makeIsHidden = (key)=>()=>{
            const config = configByKey[key];
            if (!config) return true;
            const length = getPlaintextLength();
            const ancestorNodeNames = getAncestorNodeNames();
            const belowMin = length < config.charMinThreshold;
            const aboveMax = config.charMaxThreshold !== undefined && length > config.charMaxThreshold;
            const inDisabledNode = ancestorNodeNames.some((name)=>$de6b53764cd2bd07$export$bc7d0546d8387be1().includes(name));
            const pastedText = getPastedText();
            const notProse = pastedText !== undefined && $de6b53764cd2bd07$export$71535a792a9ee562(pastedText);
            const containsTable = $de6b53764cd2bd07$var$hasTableNode(getPastedSlice());
            return belowMin || aboveMax || inDisabledNode || notProse || containsTable;
        };
    /**
   * V2-capable isHidden factory — the single place where the v2 rules
   * registry is consulted.
   *
   * Accepts the same `key` string as `makeIsHidden` and encapsulates all
   * per-button rules logic internally.  When the v2 experiment gate is on
   * and the rules registry is available, the appropriate rule set for `key`
   * is used.  When v2 is off (or rules are unavailable), falls back to
   * `makeIsHidden(key)` for buttons that existed in v1, or `() => true` for
   * new v2-only buttons (Make Longer, Remix, Ask Rovo).
   */ const rules = [
        'hasAltAiActions',
        'hasSpellingAndGrammar'
    ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control')) ? api?.pasteOptionsToolbarPlugin?.actions.getPasteMenuRules() : undefined;
    const makeIsHiddenV2 = (key)=>{
        if (!rules) {
            // v2 off — fall back to v1 for buttons that existed pre-v2.
            const v1Keys = new Set([
                $de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY,
                $de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY,
                $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY,
                $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY
            ]);
            return v1Keys.has(key) ? makeIsHidden(key) : ()=>true;
        }
        const { allRules: allRules, minCharsRule: minCharsRule, maxCharsRule: maxCharsRule, excludedAncestorRule: excludedAncestorRule, notProseRule: notProseRule, containsTableRule: containsTableRule, isSingleLinkRule: isSingleLinkRule, notSingleLinkRule: notSingleLinkRule, hideIfSingleNodeRule: hideIfSingleNodeRule, hideIfMixedNodesRule: hideIfMixedNodesRule } = rules;
        const disabled = excludedAncestorRule($de6b53764cd2bd07$export$bc7d0546d8387be1());
        // isComment, isChromeless and variant must be re-evaluated on every isHidden()
        // call so appearance changes are reflected without re-registering components.
        const getIsComment = ()=>getAppearance() === 'comment';
        const getIsChromeless = ()=>getAppearance() === 'chromeless';
        const getVariant = ()=>(0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
        switch(key){
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY:
                if (product === 'CONFLUENCE') return ()=>{
                    const isComment = getIsComment();
                    const variant = getVariant();
                    if (isComment) {
                        // Confluence Comments:
                        // Story 5.1 (single-node, medium, hasAltAiActions): show
                        // Story 5.2 (mixed-node, medium, hasSpellingAndGrammar): show (replaces Remix)
                        // Story 5.2 (mixed-node, medium, hasAltAiActions): show
                        // Story 5.4 (mixed-node, large, hasAltAiActions): show (replaces Remix)
                        if ([
                            'hasAltAiActions'
                        ].includes(variant)) // hasAltAiActions: single-node medium + mixed-node medium/large
                        return allRules(minCharsRule(100), isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                        else if ([
                            'hasSpellingAndGrammar'
                        ].includes(variant)) // hasSpellingAndGrammar: single-node medium + mixed-node medium (replaces Remix).
                        // Story 5.1 + 5.2: 100–599 chars only (large content shows Fix Spelling instead).
                        return allRules(minCharsRule(100), maxCharsRule(599), isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                        return true;
                    }
                    // Non-comment Confluence (full-page etc.)
                    if ([
                        'hasAltAiActions'
                    ].includes(variant)) // Story 5.1 (single-node, medium): show
                    // Story 5.2 (mixed-node, medium): show
                    // Story 5.3 (single-node, large): show
                    // Story 5.4 (mixed-node, large): hide (Remix takes over)
                    return minCharsRule(100)() || hideIfMixedNodesRule() && maxCharsRule(599)() || isSingleLinkRule() || disabled() || notProseRule() || containsTableRule();
                    // hasSpellingAndGrammar non-comment: single-node only (mixed-node defers to Fix Spelling).
                    return allRules(minCharsRule(100), maxCharsRule(601), hideIfMixedNodesRule, isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                };
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY:
                if (product === 'CONFLUENCE') return ()=>{
                    const isComment = getIsComment();
                    const variant = getVariant();
                    if (![
                        'hasSpellingAndGrammar'
                    ].includes(variant)) return true;
                    if (isComment) // Confluence Comments hasSpellingAndGrammar:
                    // Story 5.1 (single-node, medium): show
                    // Story 5.2 (mixed-node, medium): show (replaces Remix)
                    // Story 5.3 (single-node, large): show
                    // Story 5.4 (mixed-node, large): show (replaces Remix)
                    // → no node-type restriction, no max char limit
                    return allRules(minCharsRule(configByKey[key]?.charMinThreshold ?? 100), isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                    // Non-comment Confluence (full-page etc.):
                    // Medium mixed-node (100–599): Fix Spelling shown.
                    // Large mixed-node (≥600): Fix Spelling hidden (Ask Rovo takes over).
                    return minCharsRule(configByKey[key]?.charMinThreshold ?? 100)() || hideIfMixedNodesRule() && !minCharsRule(600)() || isSingleLinkRule() || disabled() || notProseRule() || containsTableRule();
                };
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY:
                if (product === 'CONFLUENCE') return allRules(minCharsRule(100), isSingleLinkRule, disabled, notProseRule, containsTableRule);
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY:
                // Hidden in v2.
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_LONGER_KEY:
                if (product === 'CONFLUENCE') return ()=>{
                    const isComment = getIsComment();
                    const variant = getVariant();
                    if ([
                        'hasAltAiActions'
                    ].includes(variant)) {
                        if (isComment) // Confluence Comments hasAltAiActions:
                        // Story 5.1 (single-node, medium): Make Longer shown
                        // Story 5.2 (mixed-node, medium): Make Longer shown (replaces Remix)
                        // → both single and mixed-node, medium only (< 600)
                        return allRules(minCharsRule(100), maxCharsRule(599), isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                        // Non-comment Confluence: Story 5.1 — single-node medium only.
                        return allRules(minCharsRule(100), maxCharsRule(599), hideIfMixedNodesRule, isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                    }
                    return true;
                };
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_REMIX_KEY:
                if (product === 'CONFLUENCE') return ()=>{
                    const isComment = getIsComment();
                    // Remix is hidden in Confluence Comments — the existing action buttons
                    // (Improve Writing / Fix Spelling / Make Longer) cover its role there.
                    if (isComment) return true;
                    // Non-comment Confluence: Stories 5.2 + 5.4 — mixed-node (medium and large).
                    return allRules(minCharsRule(100), hideIfSingleNodeRule, isSingleLinkRule, disabled, notProseRule, containsTableRule)();
                };
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_SUMMARY_KEY:
                if (product === 'CONFLUENCE') return ()=>{
                    if (!(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                    return getIsChromeless() || rules.notSingleLinkRule();
                };
                return ()=>true;
            case $de6b53764cd2bd07$var$AI_PASTE_MENU_ASK_ROVO_KEY:
                if (product === 'CONFLUENCE') // Ask Rovo is shown for: (1) single-link paste (regardless of length),
                // or (2) large prose paste (≥ 600 chars).
                return ()=>{
                    if (!notSingleLinkRule()) {
                        // IS a single link.
                        if (getIsChromeless() || !(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                        return allRules(disabled)();
                    }
                    // Not a single link — apply full large-paste rules (no single-link gate needed).
                    return allRules(minCharsRule(600), disabled, notProseRule, containsTableRule, isSingleLinkRule)();
                };
                return ()=>true;
            default:
                return ()=>true;
        }
    };
    return [
        {
            type: 'menu-section',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
            parents: [
                {
                    type: (0, $3nacY.PASTE_MENU).type,
                    key: (0, $3nacY.PASTE_MENU).key,
                    rank: (0, $hVLmg.PASTE_MENU_RANK)[$de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY]
                }
            ],
            component: $de6b53764cd2bd07$var$AIPasteMenuSection
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_SUMMARY_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    rank: 0
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_SUMMARY_KEY),
            isAsyncHidden: smartlinkAsyncHidden,
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a9079f1f87c72e1$export$2d9e93e9ea435064), {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    smartCardClientRef: smartCardClientRef
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    rank: configByKey[$de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY]?.rank ?? 0
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_IMPROVE_WRITING_KEY),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: (0, $iO5TS.improveWriting)(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
                        size: "small",
                        label: ""
                    }),
                    testId: "ai-paste-menu__improve-writing"
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    rank: configByKey[$de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY]?.rank ?? 0
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_FIX_SPELLING_KEY),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: (0, $iO5TS.fixSpellingAndGrammar)(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($74BSk))), {
                        size: "small",
                        label: ""
                    }),
                    testId: "ai-paste-menu__fix-spelling-and-grammar"
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    rank: configByKey[$de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY]?.rank ?? 0
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_ADD_POLISH_KEY),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: $de6b53764cd2bd07$var$addPolishWithImproveFormatting(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
                        size: "small",
                        label: ""
                    }),
                    testId: "ai-paste-menu__add-polish"
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    rank: configByKey[$de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY]?.rank ?? 0
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_SHORTER_KEY),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: (0, $ddlQ3.makeShorter)(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3CdTA))), {
                        size: "small",
                        label: ""
                    }),
                    testId: "ai-paste-menu__make-shorter"
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_LONGER_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    // Rank 5 — shown after Make Shorter (rank 4) in the menu.
                    rank: 5
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_MAKE_LONGER_KEY),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: (0, $lQkyl.makeLonger)(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2xJ2w))), {
                        size: "small",
                        label: ""
                    }),
                    testId: "ai-paste-menu__make-longer"
                })
        },
        {
            type: 'menu-item',
            key: $de6b53764cd2bd07$var$AI_PASTE_MENU_ASK_ROVO_KEY,
            parents: [
                {
                    type: 'menu-section',
                    key: $de6b53764cd2bd07$var$AI_PASTE_MENU_SECTION_KEY,
                    // Rank 7 — shown last in the menu.
                    rank: 7
                }
            ],
            isHidden: makeIsHiddenV2($de6b53764cd2bd07$var$AI_PASTE_MENU_ASK_ROVO_KEY),
            isAsyncHidden: smartlinkAsyncHidden,
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de6b53764cd2bd07$var$AIPasteMenuItem, {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: (0, $7vVCw.freeGenerate)(),
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                        size: "xxsmall",
                        label: ""
                    }),
                    testId: "ai-paste-menu__ask-rovo"
                })
        }
    ];
};










var $gWsFk = parcelRequire("gWsFk");





function $70f7b3d6cdb6c831$export$f3e5bb240cf24df5({ configItems: configItems, formatMessage: formatMessage, aiGlobalOptIn: aiGlobalOptIn, editorView: editorView, locale: locale }) {
    const aiPriorities = 9000;
    const dispatch = editorView.dispatch;
    return configItems.map((configItem)=>{
        const title = (0, $c2c6d211a4290fa3$export$d97f37f32ae9d000)(configItem, formatMessage);
        return {
            priority: configItem.quickInsertPriority ?? aiPriorities,
            categories: [
                'AI'
            ],
            title: title,
            description: formatMessage(configItem.description || configItem.title),
            keywords: [
                'ai',
                'generate',
                'rovo',
                title
            ],
            icon: ()=>{
                return configItem.icon ? configItem.icon({
                    formatMessage: formatMessage
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWsFk.default), {
                    label: "",
                    size: "small"
                });
            },
            action: (insert, editorState)=>{
                // We set the openAIModalCommand to run on the next tick -- as it then
                // performs additional transactions to update the document
                requestAnimationFrame(()=>{
                    const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                        state: editorView.state,
                        configItem: configItem,
                        lastTriggeredFrom: 'quickInsert',
                        aiGlobalOptIn: aiGlobalOptIn,
                        locale: locale
                    });
                    openAIModalCommand(editorView.state, dispatch);
                });
                // Insert empty string to remove the typeahead raw text
                // close the quick insert immediately
                const transaction = insert('');
                return transaction;
            },
            isDisabledOffline: true
        };
    });
}






var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");





const $ab6f91f3c5ceb49f$export$5ed2f115affe57ec = (api)=>api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled ?? false;
const $ab6f91f3c5ceb49f$export$ecc687026405e0d = (api)=>{
    const { areAiEntryPointsDisabled: areAiEntryPointsDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>({
            areAiEntryPointsDisabled: aiExperienceState?.areAiEntryPointsDisabled ?? false
        }));
    return areAiEntryPointsDisabled;
};



var $jaFVy = parcelRequire("jaFVy");







const $b4ff18a85268a6fc$export$e88aad14c693b98e = (api)=>(0, $jkcNT.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $jaFVy.isOfflineMode)(api?.connectivity?.sharedState?.currentState()?.mode);
const $b4ff18a85268a6fc$export$a935cc97724bad0a = (api)=>{
    const { isOffline: isOffline } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], ({ connectivityState: connectivityState })=>({
            isOffline: (0, $jkcNT.editorExperiment)('platform_editor_offline_editing_web', true) && (0, $jaFVy.isOfflineMode)(connectivityState?.mode)
        }));
    return isOffline;
};


const $6aeabd96dd732741$export$9db4ba93eaa44d11 = (api)=>{
    return (0, $b4ff18a85268a6fc$export$e88aad14c693b98e)(api) || (0, $ab6f91f3c5ceb49f$export$5ed2f115affe57ec)(api);
};
const $6aeabd96dd732741$export$1698a5865a7021f3 = (api)=>{
    const isOffline = (0, $b4ff18a85268a6fc$export$a935cc97724bad0a)(api);
    const areAiEntryPointsDisabled = (0, $ab6f91f3c5ceb49f$export$ecc687026405e0d)(api);
    return isOffline || areAiEntryPointsDisabled;
};









var $I2MTF = parcelRequire("I2MTF");


var $9wgTc = parcelRequire("9wgTc");


const $f8c480b765b7cd57$export$c536bf788ca59c97 = ({ aiGlobalOptIn: aiGlobalOptIn, api: api, configItem: configItem })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { editorView: editorView, isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const item = (0, $cozmU.useMemo)(()=>(0, $70f7b3d6cdb6c831$export$f3e5bb240cf24df5)({
            aiGlobalOptIn: aiGlobalOptIn,
            configItems: [
                configItem
            ],
            editorView: editorView,
            formatMessage: intl.formatMessage,
            locale: intl.locale
        }).at(0), [
        aiGlobalOptIn,
        configItem,
        editorView,
        intl.formatMessage,
        intl.locale
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>item?.action(insert, editorView.state, source), [
        item
    ]);
    if (!item) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I2MTF.QuickInsertMenuItem), {
        iconBefore: item.icon?.(),
        isDisabled: isOffline,
        onSelect: onSelect,
        title: item.title
    });
};


const $e1bc3d5de5289282$export$c65b56a2d1ac69f4 = ({ aiGlobalOptIn: aiGlobalOptIn, api: api, editorPluginAIProvider: editorPluginAIProvider, getEditorView: getEditorView, isRovoAvailable: isRovoAvailable })=>{
    const components = [];
    if (isRovoAvailable) components.push({
        key: (0, $dCkbP.ASK_ROVO_MENU_ITEM).key,
        type: (0, $dCkbP.ASK_ROVO_MENU_ITEM).type,
        parents: [
            {
                key: (0, $dCkbP.ROVO_SECTION).key,
                type: (0, $dCkbP.ROVO_SECTION).type,
                rank: (0, $dXqu3.ROVO_SECTION_RANK)[(0, $dCkbP.ASK_ROVO_MENU_ITEM).key]
            }
        ],
        match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>{
            const title = (0, $c2c6d211a4290fa3$export$d97f37f32ae9d000)(editorPluginAIProvider.baseGenerate, formatMessage);
            return {
                description: formatMessage(editorPluginAIProvider.baseGenerate.description ?? editorPluginAIProvider.baseGenerate.title),
                keywords: [
                    'ai',
                    'generate',
                    'rovo',
                    title
                ],
                title: title
            };
        }),
        component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8c480b765b7cd57$export$c536bf788ca59c97), {
                aiGlobalOptIn: aiGlobalOptIn,
                api: api,
                configItem: editorPluginAIProvider.baseGenerate
            }),
        isHidden: ()=>(0, $6aeabd96dd732741$export$9db4ba93eaa44d11)(api)
    });
    if (editorPluginAIProvider.isInDocumentStreamingEnabled) return components;
    (editorPluginAIProvider.configItemWithOptions ?? []).filter((0, $c2c6d211a4290fa3$export$77a7a46521e984a3)).forEach((item)=>{
        components.push({
            key: `quick-insert-ai-${item.config.key}`,
            type: 'menu-item',
            parents: [
                {
                    key: (0, $dCkbP.ROVO_SECTION).key,
                    type: (0, $dCkbP.ROVO_SECTION).type,
                    rank: item.config.quickInsertPriority ?? 9000
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>{
                const title = (0, $c2c6d211a4290fa3$export$d97f37f32ae9d000)(item.config, formatMessage);
                return {
                    description: formatMessage(item.config.description ?? item.config.title),
                    keywords: [
                        'ai',
                        'generate',
                        'rovo',
                        title
                    ],
                    title: title
                };
            }),
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8c480b765b7cd57$export$c536bf788ca59c97), {
                    aiGlobalOptIn: aiGlobalOptIn,
                    api: api,
                    configItem: item.config
                }),
            isHidden: ()=>{
                const editorView = getEditorView();
                return (0, $6aeabd96dd732741$export$9db4ba93eaa44d11)(api) || !editorView || !(0, $c2c6d211a4290fa3$export$475f2e7e3b5c59c4)({
                    editorView: editorView,
                    positions: [
                        0,
                        0
                    ],
                    isEmpty: true,
                    item: item
                });
            }
        });
    });
    return components;
};






var $g6uqx = parcelRequire("g6uqx");































/* floating-toolbar-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 














var $gnAkm = parcelRequire("gnAkm");




var $4hfky = parcelRequire("4hfky");

var $huoxr = parcelRequire("huoxr");





var $5AKbu = parcelRequire("5AKbu");





var $a6nzD = parcelRequire("a6nzD");

var $kwf4Z = parcelRequire("kwf4Z");

var $cE5a1 = parcelRequire("cE5a1");


var $7CFSN = parcelRequire("7CFSN");


var $7sJoX = parcelRequire("7sJoX");





























var $1jIs1 = parcelRequire("1jIs1");





















const $b0039ce3bd4500e0$export$c7750a1fc252fe45 = ({ resolveIfMissing: resolveIfMissing = false, smartlinkUrl: smartlinkUrl })=>{
    const { store: store, connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const [isResolving, setIsResolving] = (0, $cozmU.useState)(false);
    const smartLinkState = store?.getState()[smartlinkUrl];
    const { status: status, details: details } = smartLinkState || {};
    // For plain hyperlinks, the URL is not yet in the SmartLink store (only card
    // components trigger resolution automatically). We trigger resolution on mount
    // so we can check access permissions before showing AI buttons.
    (0, $cozmU.useEffect)(()=>{
        if (!resolveIfMissing || smartLinkState || !smartlinkUrl) return;
        setIsResolving(true);
        connections.client.fetchData(smartlinkUrl).then((response)=>{
            store?.dispatch({
                type: 'resolved',
                url: smartlinkUrl,
                payload: response
            });
            setIsResolving(false);
        }).catch(()=>{
        // If resolution fails, buttons won't render — correct behavior
        // for inaccessible URLs.
        });
    }, [
        connections.client,
        resolveIfMissing,
        smartLinkState,
        smartlinkUrl,
        store
    ]);
    const isResolvedWithAccess = status === 'resolved' && details?.meta?.access === 'granted';
    const metadata = (0, $cozmU.useMemo)(()=>details ? (0, $8962f518f849d920$export$1a1507613ebdd5e0)({
            details: details,
            smartlinkUrl: smartlinkUrl
        }) : undefined, [
        details,
        smartlinkUrl
    ]);
    return {
        details: details,
        isLoading: isResolving,
        isResolvedWithAccess: isResolvedWithAccess,
        metadata: metadata
    };
};



/* toolbar.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $4XbfY = parcelRequire("4XbfY");







var $2urSQ = parcelRequire("2urSQ");

















var $is7KY = parcelRequire("is7KY");













var $p6OqS = parcelRequire("p6OqS");

var $6Jphz = parcelRequire("6Jphz");

var $dQeg1 = parcelRequire("dQeg1");

var $5VSNw = parcelRequire("5VSNw");



var $4WfQc = parcelRequire("4WfQc");







var $iJUbs = parcelRequire("iJUbs");

var $8px0e = parcelRequire("8px0e");

var $97uS1 = parcelRequire("97uS1");



var $7T88d = parcelRequire("7T88d");

var $6t3CY = parcelRequire("6t3CY");









var $gk3KR = parcelRequire("gk3KR");

var $lslMH = parcelRequire("lslMH");





var $a1ZzW = parcelRequire("a1ZzW");










parcelRequire("cozmU");


var $4Uejl = parcelRequire("4Uejl");

const $f46fce050a35b657$export$9942248a1ae255c2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const resizing = (0, $4Uejl.useResizing)(props);
    let t1;
    if ($[3] !== children || $[4] !== resizing) {
        t1 = children(resizing);
        $[3] = children;
        $[4] = resizing;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: t1
        });
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ({ children: children, ...props })=>{
    const resizing = (0, $4Uejl.useResizing)(props);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children(resizing)
    });
};





























var $3N2DH = parcelRequire("3N2DH");











var $dFWys = parcelRequire("dFWys");
















const $69b8e45da20fb0f1$export$80f4f0d1d6bfe69e = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
    }));
};











const $5aa5f5e1ddfb0f02$var$getIssueType = (issueType)=>{
    switch(issueType){
        case 'bug':
            return 'Bug';
        case 'story':
            return 'Story';
        case 'epic':
            return 'Epic';
        case 'task':
        default:
            return 'Task';
    }
};
const $5aa5f5e1ddfb0f02$export$74b0275d64d18c50 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE,
        title: (0, $93WrI.aiConfigItemMessages).improveDescription,
        description: (0, $93WrI.aiConfigItemMessages).reformatWithTemplateDescription,
        icon: ({ formatMessage: formatMessage })=>options.isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
                label: formatMessage((0, $93WrI.aiConfigItemMessages).improveDescription),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69b8e45da20fb0f1$export$80f4f0d1d6bfe69e), null),
        endpoint: (0, $gcCwL.jiraIssueReformatterApiURL),
        experienceId: 'issue-reformatter',
        intentSchemaId: 'issue_reformatter_intent_schema.json',
        featureId: 'issue_reformatter',
        alwaysNeedDoc: true,
        getRequestPayload: ({ locale: locale, doc: doc })=>{
            // additional props come from Issue View
            const additionalProps = options.getAdditionalProps?.() || {};
            const { issue_id: issue_id, issue_summary: issue_summary, project_id: project_id, issue_type_label: issue_type_label, linked_urls: linked_urls, linked_confluence_page_urls: linked_confluence_page_urls } = additionalProps;
            const shouldIncludeConfluenceUrls = linked_confluence_page_urls && linked_confluence_page_urls.length > 0;
            // all context is required except linked_urls and linked_confluence_page_urls
            const context = {
                project_id: project_id,
                // Only include issue_id in the context payload when it is provided, so the
                // reformatter backend only receives it for users in the experiment.
                ...issue_id !== undefined ? {
                    issue_id: issue_id
                } : {},
                summary: issue_summary,
                description: doc,
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                ...{
                    links: linked_urls
                } ?? [],
                ...shouldIncludeConfluenceUrls ? {
                    linked_confluence_page_urls: linked_confluence_page_urls
                } : {}
            };
            const issue_type = $5aa5f5e1ddfb0f02$var$getIssueType(issue_type_label);
            // see https://hello.atlassian.net/wiki/spaces/AIDO/pages/5306581134/PWDC+Issue+Reformatter+API+Contracts
            const ai_feature_input = {
                source: 'JIRA',
                locale: locale,
                context: context,
                response_type: 'NO_SCHEMA',
                suggested_issues_config: {
                    use_template: true,
                    max_issues: 1,
                    suggested_issue_field_types: [
                        {
                            issue_type: issue_type,
                            fields: [
                                {
                                    field_name: 'Description',
                                    field_type: 'Paragraph'
                                }
                            ]
                        }
                    ]
                }
            };
            return {
                ai_feature_input: ai_feature_input
            };
        },
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>'assistance-service'
    });
const $5aa5f5e1ddfb0f02$export$b8d167b10029e62f = (options)=>({
        config: $5aa5f5e1ddfb0f02$export$74b0275d64d18c50(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });












var $9pamm = parcelRequire("9pamm");


var $2aMCF = parcelRequire("2aMCF");



/**
 * What this file does:
 * It's a helper "component" to render AI sections based on the page mode
 * i.e live view mode or live edit mode
 */ 








const $118cfcd04e63ee9b$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $118cfcd04e63ee9b$export$f5cfdae51cfc6704 = ({ api: api, children: children, hasSeparator: hasSeparator })=>{
    const { editorViewMode: editorViewMode } = $118cfcd04e63ee9b$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit' || editorViewMode === undefined;
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
        hasSeparator: hasSeparator
    }, children);
};
const $118cfcd04e63ee9b$export$b6c70219ecf96242 = ({ api: api, children: children, hasSeparator: hasSeparator })=>{
    const { editorViewMode: editorViewMode } = $118cfcd04e63ee9b$var$usePluginState(api);
    const isView = editorViewMode === 'view';
    if (!isView) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
        hasSeparator: hasSeparator
    }, children);
};








const $b8903342d9d7f24a$export$3a340db26fb18948 = ({ api: api, state: state, enabled: enabled, actionSubjectId: actionSubjectId })=>{
    const shouldFireEvent = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || !state) return;
        const shouldFire = shouldFireEvent.current;
        if (shouldFire) {
            const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.selectionCharWordCount)(state);
            (0, $hZdqw.fireButtonViewedAnalyticsEvent)({
                api: api,
                actionSubjectId: actionSubjectId,
                attributes: {
                    selectionCharCount: charCount,
                    selectionWordCount: wordCount
                }
            });
            shouldFireEvent.current = false;
        }
    }, [
        actionSubjectId,
        api,
        enabled,
        state
    ]);
};



const $09278ecf5feb6845$var$SMART_LINK_ROVO_BUTTON_INVOKED_FROM = (0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE);
const $09278ecf5feb6845$var$rovoButtonStyles = {
    container: "_0RIC7SVa5s",
    heroLabelWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _2fwxA57p2s _1ANEUSLRg7"
};
const $09278ecf5feb6845$var$RovoSplitButtonWrapper = ({ isNewToolbarEnabled: isNewToolbarEnabled, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled, children: children })=>!isNewToolbarEnabled && isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $09278ecf5feb6845$var$rovoButtonStyles.container
    }, children) : children; // Component for Primary Toolbar AI Section with conditional rendering
const $09278ecf5feb6845$var$PrimaryToolbarAISection = ({ api: api, children: children, editorAppearance: editorAppearance, hasSeparator: hasSeparator = false })=>{
    const { editorAppearance: currentAppearance } = (0, $bFSJa.useEditorToolbar)(); // Only show for the specified editor appearance
    if (currentAppearance !== editorAppearance) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $118cfcd04e63ee9b$export$f5cfdae51cfc6704), {
        api: api,
        hasSeparator: hasSeparator ? (0, $cE5a1.SeparatorPosition).END : undefined
    }, children);
};
const $09278ecf5feb6845$var$RovoButton = ({ aiGlobalOptIn: aiGlobalOptIn, isNewToolbarEnabled: isNewToolbarEnabled, editorPluginAIProvider: { baseGenerate: baseGenerate, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }, parents: parents, api: api, triggeredFor: triggeredFor })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const isDisabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const { editorView: editorView, editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)(); // This component gets registered twice, once for the full size toolbar and once for the display small toolbar
    // We need to exclude the display small toolbar from the analytics to prevent double counting
    const onDisplaySmall = parents.some((parent)=>parent.key === (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key);
    (0, $b8903342d9d7f24a$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled && !onDisplaySmall,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON
    });
    const browser = (0, $8dxef.getBrowserInfo)();
    const metaKey = browser.mac ? "\u2318" : 'Ctrl';
    const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
    let buttonTitle = ''; // Determine button title based on toolbar location and editor appearance
    if (onPrimaryToolbar) // Primary toolbar: Only show entry-point text in full-page editor when AIFC patch beta is enabled.
    {
        if (editorAppearance === 'full-page' && isInDocumentStreamingEnabled) buttonTitle = formatMessage((0, $flbIU.default).aiUniversalShortCallToAction);
         // For comment editor or when AIFC patch beta is disabled, show no text
    } else // Inline/floating toolbar: show "Ask Rovo".
    buttonTitle = formatMessage((0, $7ZL6d.aiMessages).askRovoToolbarIconTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoSplitButtonWrapper, {
        isNewToolbarEnabled: isNewToolbarEnabled,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $7ZL6d.aiMessages).askRovoToolbarIconTooltipQuickCommand, {
            key: metaKey
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5VSNw.AIChatIcon), {
            label: formatMessage((0, $7ZL6d.aiMessages).askRovoToolbarIconTitle)
        }),
        testId: "editor-toolbar__ask-rovo",
        ignoreInteractionDisabled: true,
        isDisabled: isDisabled,
        onClick: (event)=>{
            if (!editorView) return;
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click'; // Fire analytics event for button click
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                }
            });
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: baseGenerate,
                lastTriggeredFrom: onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar',
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale,
                triggeredFor: triggeredFor
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, buttonTitle)));
};
const $09278ecf5feb6845$var$AskRovoChatButton = ({ api: api, editorPluginAIProvider: editorPluginAIProvider })=>{
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { product: product } = editorPluginAIProvider;
    const selection = editorView?.state.selection;
    const { selectedContentADF: selectedContentADF, hasSmartLinkSelection: hasSmartLinkSelection } = (0, $cozmU.useMemo)(()=>{
        if (!selection) return {
            selectedContentADF: (0, $6e6HL.getEmptyADF)(),
            hasSmartLinkSelection: false
        };
        let hasSmartLinkSelection = false;
        const selectedContent = (0, $aPdNQ.Fragment).from(selection.content().content);
        const doc = (0, $4XbfY.defaultSchema).nodes.doc.create({}, selectedContent);
        try {
            doc.descendants((node)=>{
                if ([
                    'inlineCard',
                    'blockCard',
                    'embedCard'
                ].includes(node.type.name)) {
                    hasSmartLinkSelection = true;
                    return false;
                }
                return true;
            });
        } catch  {
            hasSmartLinkSelection = false;
        }
        return {
            selectedContentADF: new (0, $2lPWP.JSONTransformer)().encode(doc),
            hasSmartLinkSelection: hasSmartLinkSelection
        };
    }, [
        selection
    ]);
    const handleClickChat = ()=>{
        // set the selection to the end of the current selection to remove the selection toolbar
        if (editorView?.dispatch) {
            const tr = editorView.state.tr;
            tr.setSelection((0, $kCECX.TextSelection).create(editorView.state.doc, Math.min(editorView.state.selection.to, editorView.state.doc.content.size)));
            editorView.dispatch(tr);
        }
        api?.core.actions.blur(); // open rovo chat with the selected content
        publish({
            type: 'chat-new',
            source: 'editor',
            product: product,
            ...hasSmartLinkSelection ? {
                interactionSource: $09278ecf5feb6845$var$SMART_LINK_ROVO_BUTTON_INVOKED_FROM
            } : {},
            data: {
                dialogues: []
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3N2DH.RovoChatHighlightActions), {
        selectedContent: selectedContentADF,
        product: product.toLowerCase(),
        onClickChat: handleClickChat
    });
};
const $09278ecf5feb6845$export$4b24d5b721b89a5c = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const isInDocumentStreamingEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $b8903342d9d7f24a$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_DEFINITIONS_DEFINE_BUTTON
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $7ZL6d.aiMessages).DefineDropdownIconTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        isDisabled: api?.aiDefinitions?.actions.selectionExceedsMaxWordCount() || false,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: "",
            size: "small"
        }),
        onClick: ()=>{
            api?.aiDefinitions?.actions.openReadingAidsPopup();
        }
    }, formatMessage((0, $7ZL6d.aiMessages).DefineDropdownIconTitle)));
}; // Reusable hero prompt button that extracts details from heroConfigItem
const $09278ecf5feb6845$export$9041c40b25483898 = ({ aiGlobalOptIn: aiGlobalOptIn, parents: parents, api: api, heroConfigItem: heroConfigItem, emptyStateHeroConfigItem: emptyStateHeroConfigItem, isIconOnly: isIconOnly = false })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const disabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const hasVisibleContent = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const consumerEmptyStateOverride = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.consumerEmptyStateOverride);
    const isInDocumentStreamingEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $b8903342d9d7f24a$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON
    });
    const showEmptyStateHero = consumerEmptyStateOverride === undefined ? !hasVisibleContent : consumerEmptyStateOverride;
    const resolvedHero = emptyStateHeroConfigItem && showEmptyStateHero && ((0, $2pQiO.UNSAFE_expValNoExposure)('jira-smart-replies-v2', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('bbc-auto-generate-pr-description', 'isEnabled', false)) ? emptyStateHeroConfigItem : heroConfigItem;
    const configItem = resolvedHero.config;
    const title = formatMessage(configItem.title);
    const name = configItem.key.toLowerCase().split('_').join('-').split(' ').join('-');
    const testId = `editor-toolbar__${name}`;
    const enabledOnEmptyDoc = resolvedHero.triggers.empty.docMinSize === 0 && resolvedHero.triggers.empty.enabled;
    const isSuggestReplyConfigItemEnabled = resolvedHero.config.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_RESPONSE;
    let isDisabled = disabled || !hasVisibleContent;
    isDisabled = disabled || !hasVisibleContent && !enabledOnEmptyDoc; // Specific to JSM - Suggest Reply Hero Prompt
    if (isSuggestReplyConfigItemEnabled) isDisabled = disabled || !!hasVisibleContent;
    const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
    if ((0, $2pQiO.UNSAFE_expValNoExposure)('jira-smart-replies-v2', 'isEnabled', false)) {
        const Icon = configItem.icon ? configItem.icon({
            formatMessage: formatMessage
        }) : null;
        const heroPromptButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            isDisabled: isDisabled,
            iconBefore: Icon,
            label: title,
            testId: testId,
            onClick: (event)=>{
                if (!editorView) return;
                const state = editorView.state;
                const { selection: selection } = state;
                const selectionCategory = selection && (0, $3117ebeab67c20f0$export$c96ebd9bae9a4b95)(state, [
                    selection.from,
                    selection.to
                ]);
                const hasPartialNonDocumentSelection = selectionCategory !== (0, $294de0c3b82e849c$export$917a2c609d734ce2).EMPTY && selectionCategory !== (0, $294de0c3b82e849c$export$917a2c609d734ce2).FULL_DOCUMENT;
                const isImproveDescriptionHero = resolvedHero.config.key === (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE;
                const resolvedConfigItem = isImproveDescriptionHero && hasPartialNonDocumentSelection && (0, $iDrrr.fg)('use_improve_writing_on_partial_text_selection') ? (0, $iO5TS.improveWriting)() : resolvedHero.config;
                const lastTriggeredFrom = onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar';
                const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
                const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
                const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                    state: editorView.state,
                    configItem: resolvedConfigItem,
                    lastTriggeredFrom: lastTriggeredFrom,
                    triggerMethod: triggerMethod,
                    aiGlobalOptIn: aiGlobalOptIn,
                    locale: locale
                });
                openAIModalCommand(editorView.state, editorView.dispatch);
            }
        }, !isIconOnly && (emptyStateHeroConfigItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f46fce050a35b657$export$9942248a1ae255c2), {
            dimension: "width",
            duration: "var(--ds-duration-medium, 200ms)",
            easing: "var(--ds-easing-inout-bold, cubic-bezier(0.4, 0, 0, 1))"
        }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                ref: ref,
                xcss: $09278ecf5feb6845$var$rovoButtonStyles.heroLabelWrapper
            }, title)) : title));
        return isIconOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: title
        }, heroPromptButton) : heroPromptButton;
    }
    const IconComponent = configItem.icon ? configItem.icon({
        formatMessage: formatMessage
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        isDisabled: isDisabled,
        iconBefore: IconComponent,
        label: title,
        testId: testId,
        onClick: (event)=>{
            if (!editorView) return;
            const state = editorView.state;
            const { selection: selection } = state;
            const selectionCategory = selection && (0, $3117ebeab67c20f0$export$c96ebd9bae9a4b95)(state, [
                selection.from,
                selection.to
            ]);
            const hasPartialNonDocumentSelection = selectionCategory !== (0, $294de0c3b82e849c$export$917a2c609d734ce2).EMPTY && selectionCategory !== (0, $294de0c3b82e849c$export$917a2c609d734ce2).FULL_DOCUMENT;
            const isImproveDescriptionHero = resolvedHero.config.key === (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE;
            const resolvedConfigItem = isImproveDescriptionHero && hasPartialNonDocumentSelection && (0, $iDrrr.fg)('use_improve_writing_on_partial_text_selection') ? (0, $iO5TS.improveWriting)() : resolvedHero.config;
            const lastTriggeredFrom = onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar';
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: resolvedConfigItem,
                lastTriggeredFrom: lastTriggeredFrom,
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, !isIconOnly && title);
}; // Legacy version with conditional logic (will be removed when platform_editor_ai_aifc_streaming is cleaned up)
const $09278ecf5feb6845$export$2df6fac7793eedd9 = ({ aiGlobalOptIn: aiGlobalOptIn, parents: parents, shouldShowImproveDescription: shouldShowImproveDescription, getAdditionalProps: getAdditionalProps, api: api, isIconOnly: isIconOnly = false })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const disabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const hasVisibleContent = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const isInDocumentStreamingEnabled = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.aiDecorationExperiencePluginState.isInDocumentStreamingEnabled);
    (0, $b8903342d9d7f24a$export$3a340db26fb18948)({
        api: api,
        state: editorView?.state,
        enabled: isInDocumentStreamingEnabled,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON
    });
    const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
    const onJiraDescriptionPrimaryToolbar = shouldShowImproveDescription && onPrimaryToolbar;
    const title = formatMessage(onJiraDescriptionPrimaryToolbar ? (0, $93WrI.aiConfigItemMessages).improveDescription : (0, $7ZL6d.aiMessages).improveWritingToolbarIconTitle);
    const testId = onJiraDescriptionPrimaryToolbar ? 'editor-toolbar__improve-description' : 'editor-toolbar__improve-writing';
    const isDisabled = disabled || !hasVisibleContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        isDisabled: isDisabled,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
            label: title,
            size: "small"
        }),
        testId: testId,
        onClick: (event)=>{
            if (!editorView) return;
            const configItem = onJiraDescriptionPrimaryToolbar ? (0, $5aa5f5e1ddfb0f02$export$74b0275d64d18c50)({
                getAdditionalProps: getAdditionalProps
            }) : (0, $iO5TS.improveWriting)();
            const lastTriggeredFrom = onPrimaryToolbar ? 'mainToolbar' : 'floatingToolbar';
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItem,
                lastTriggeredFrom: lastTriggeredFrom,
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, !isIconOnly && title);
};
const $09278ecf5feb6845$var$RovoMenu = ({ children: children, isNewToolbarEnabled: isNewToolbarEnabled, api: api, parents: parents, testId: testId, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const hasVisibleContent = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'aiExperience'
    ], (states)=>states.aiExperienceState?.hasVisibleContent);
    const disabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const isDisabled = disabled || !hasVisibleContent;
    const onClick = (_event, isOpen)=>{
        if (!editorView) return;
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).CLICKED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_MORE_ROVO_OPTIONS,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents),
                opened: isOpen
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoSplitButtonWrapper, {
        isNewToolbarEnabled: isNewToolbarEnabled,
        isInDocumentStreamingEnabled: isInDocumentStreamingEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwf4Z.ToolbarDropdownMenuProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8px0e.MoreItemsIcon), {
            label: formatMessage((0, $7ZL6d.aiMessages).moreRovoOptionsMenuLabel)
        }),
        testId: testId ?? 'editor-toolbar__ask-rovo-menu',
        isDisabled: isDisabled,
        onClick: onClick
    }, children)));
};
const $09278ecf5feb6845$var$RovoPromptNestedMenu = ({ itemKey: itemKey, icon: icon, messageDescriptor: messageDescriptor, children: children, api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "small",
            label: (0, $ieeJu.expValEquals)('jira_editor_a11y_toolbar_fixes', 'isEnabled', true) ? '' : formatMessage(messageDescriptor)
        }),
        text: formatMessage(messageDescriptor),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97uS1.NestedDropdownRightIcon), {
            label: (0, $ieeJu.expValEquals)('jira_editor_a11y_toolbar_fixes', 'isEnabled', true) ? '' : formatMessage(messageDescriptor)
        }),
        testId: `dropdown-item__${itemKey}`,
        onClick: ()=>{
            const actionSubjectId = itemKey === (0, $3nacY.CHANGE_TONE_NESTED_MENU).key ? (0, $krYZG.ACTION_SUBJECT_ID).AI_CHANGE_TONE : itemKey === (0, $3nacY.TRANSLATE_NESTED_MENU).key ? (0, $krYZG.ACTION_SUBJECT_ID).AI_TRANSLATE : undefined;
            if (!actionSubjectId) return;
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR_DROPDOWN_MENU_ITEM,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                attributes: {
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                }
            });
        }
    }, children);
};
const $09278ecf5feb6845$var$RovoPromptItem = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, itemKey: itemKey, icon: icon, messageDescriptor: messageDescriptor, configItem: configItem, parents: parents, onClick: onClick, triggeredFor: triggeredFor })=>{
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const isDisabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const Icon = icon;
    const onPrimaryToolbar = parents.at(0)?.key === (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "small",
            label: (0, $ieeJu.expValEquals)('jira_editor_a11y_toolbar_fixes', 'isEnabled', true) ? '' : formatMessage(messageDescriptor)
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null),
        testId: `dropdown-item__${itemKey}`,
        isDisabled: isDisabled,
        onClick: (event)=>{
            if (onClick) return onClick();
            if (!editorView) return;
            const isKeyboardTrigger = event?.nativeEvent?.detail === 0;
            const triggerMethod = isKeyboardTrigger ? 'keyboard' : 'click';
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: editorView.state,
                configItem: configItem,
                lastTriggeredFrom: onPrimaryToolbar ? 'primaryToolbar' : 'floatingToolbar',
                triggerMethod: triggerMethod,
                aiGlobalOptIn: aiGlobalOptIn,
                locale: locale,
                triggeredFor: triggeredFor
            });
            openAIModalCommand(editorView.state, editorView.dispatch);
        }
    }, formatMessage(messageDescriptor));
};
const $09278ecf5feb6845$export$611b6feb29f5c606 = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, shouldShowImproveDescription: shouldShowImproveDescription, getAdditionalProps: getAdditionalProps, isNewToolbarEnabled: isNewToolbarEnabled, api: api, isRovoAvailable: isRovoAvailable })=>{
    const breakpointPreset = api?.toolbar?.actions.getBreakpointPreset();
    const heroGroupKey = editorPluginAIProvider.heroConfigItem && editorPluginAIProvider.isInDocumentStreamingEnabled ? (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key : (0, $3nacY.IMPROVE_WRITING_GROUP).key;
    return [
        // AI SECTION
        {
            type: (0, $3nacY.AI_SECTION).type,
            key: (0, $3nacY.AI_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_SECTION).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $118cfcd04e63ee9b$export$f5cfdae51cfc6704), {
                    api: api,
                    hasSeparator: (0, $cE5a1.SeparatorPosition).END
                }, children)
        },
        // AI SECTION FOR FULL PAGE PRIMARY TOOLBAR
        {
            type: (0, $3nacY.AI_SECTION).type,
            key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
            parents: [
                ...!editorPluginAIProvider.hidePrimaryToolbarButton && !editorPluginAIProvider.isInDocumentStreamingEnabled && // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                !(!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true)) ? [
                    {
                        type: 'toolbar',
                        key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "full-page"
                }, children)
        },
        // AI SECTION FOR COMMENT PRIMARY TOOLBAR
        {
            type: (0, $3nacY.AI_SECTION).type,
            key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
            parents: [
                ...!editorPluginAIProvider.hidePrimaryToolbarButton ? [
                    {
                        type: 'toolbar',
                        key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "comment"
                }, children)
        },
        // AI SECTION FOR FULL PAGE PRIMARY TOOLBAR AIFC (only Rovo button with "Write")
        {
            type: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).type,
            key: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).key,
            parents: [
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                ...!editorPluginAIProvider.hidePrimaryToolbarButton && editorPluginAIProvider.isInDocumentStreamingEnabled && // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                !(!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true)) ? [
                    {
                        type: 'toolbar',
                        key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_SECTION).key]
                    }
                ] : []
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$PrimaryToolbarAISection, {
                    api: api,
                    editorAppearance: "full-page",
                    hasSeparator: true
                }, children)
        },
        // AI VIEW SECTION
        {
            type: (0, $3nacY.AI_VIEW_SECTION).type,
            key: (0, $3nacY.AI_VIEW_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_VIEW_SECTION).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $118cfcd04e63ee9b$export$b6c70219ecf96242), {
                    api: api,
                    hasSeparator: (0, $cE5a1.SeparatorPosition).END
                }, children)
        },
        {
            type: (0, $3nacY.AI_VIEW_SECTION).type,
            key: (0, $3nacY.AI_VIEW_SECTION).key,
            parents: [
                ...editorPluginAIProvider.hidePrimaryToolbarButton ? [] : [
                    {
                        type: 'toolbar',
                        key: (0, $3nacY.TOOLBARS).PRIMARY_TOOLBAR,
                        rank: (0, $hVLmg.TOOLBAR_RANK)[(0, $3nacY.AI_VIEW_SECTION).key]
                    }
                ]
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $118cfcd04e63ee9b$export$b6c70219ecf96242), {
                    api: api
                }, children)
        },
        // ROVO GROUP
        {
            type: (0, $3nacY.ROVO_GROUP).type,
            key: (0, $3nacY.ROVO_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION).key,
                    // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                    rank: !editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true) ? 400 : (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                    above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
        },
        // ROVO GROUP DISPLAY SMALL
        {
            type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
            key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key]
                },
                {
                    type: (0, $3nacY.AI_SECTION).type,
                    key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                    below: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
        },
        // ROVO HERO BUTTON
        {
            type: (0, $3nacY.ROVO_HERO_BUTTON).type,
            key: (0, $3nacY.ROVO_HERO_BUTTON).key,
            parents: [
                ...isRovoAvailable ? [
                    {
                        type: (0, $3nacY.ROVO_GROUP).type,
                        key: (0, $3nacY.ROVO_GROUP).key,
                        rank: (0, $hVLmg.ROVO_GROUP_RANK)[(0, $3nacY.ROVO_HERO_BUTTON).key]
                    },
                    {
                        type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                        key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                        rank: (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.ROVO_HERO_BUTTON).key]
                    }
                ] : []
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoButton, {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    parents: parents,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    api: api
                })
        },
        // ROVO GROUP FOR PRIMARY TOOLBAR AIFC
        {
            type: (0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).type,
            key: (0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children)
        },
        {
            type: (0, $3nacY.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).type,
            key: (0, $3nacY.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key,
            parents: [
                ...isRovoAvailable ? [
                    {
                        type: (0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).type,
                        key: (0, $3nacY.ROVO_GROUP_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.ROVO_GROUP_RANK)[(0, $3nacY.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]
                    }
                ] : []
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoButton, {
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    parents: parents,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    api: api
                })
        },
        {
            type: (0, $3nacY.ROVO_MENU).type,
            key: (0, $3nacY.ROVO_MENU).key,
            parents: [
                // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                ...!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true) ? [] : isRovoAvailable ? [
                    {
                        type: (0, $3nacY.ROVO_GROUP).type,
                        key: (0, $3nacY.ROVO_GROUP).key,
                        rank: (0, $hVLmg.ROVO_GROUP_RANK)[(0, $3nacY.ROVO_MENU).key]
                    }
                ] : [
                    {
                        type: 'group',
                        key: heroGroupKey,
                        rank: (0, $hVLmg.ROVO_GROUP_RANK)[(0, $3nacY.ROVO_MENU).key]
                    }
                ]
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoMenu, {
                    api: api,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
                    parents: parents,
                    testId: "editor-toolbar__ask-rovo-menu"
                }, children)
        },
        {
            type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
            key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_MENU).type,
                    key: (0, $3nacY.ROVO_MENU).key,
                    rank: (0, $hVLmg.ROVO_MENU_RANK)[(0, $3nacY.ROVO_PROMPT_MENU_SECTION).key]
                }
            ]
        },
        // ROVO MENU DISPLAY SMALL + MENU SECTION
        {
            type: (0, $3nacY.ROVO_MENU_DISPLAY_SMALL).type,
            key: (0, $3nacY.ROVO_MENU_DISPLAY_SMALL).key,
            parents: [
                // when platform_editor_toolbar_aifc experiment is running, the test cohort should receive the same AI button layout
                ...!editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $jkcNT.editorExperiment)('platform_editor_toolbar_aifc', true) ? [] : [
                    {
                        type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                        key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                        rank: (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.ROVO_MENU_DISPLAY_SMALL).key]
                    }
                ]
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoMenu, {
                    api: api,
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    parents: parents,
                    testId: "editor-toolbar__ask-rovo-menu-display-small"
                }, children)
        },
        {
            type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
            key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_MENU_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_MENU_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_MENU_RANK)[(0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]
                }
            ]
        },
        // FROM HERE ONWARDS ARE MENU ITEMS
        ...editorPluginAIProvider.heroConfigItem && editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            // New dynamic implementation: uses heroConfigItem
            {
                type: (0, $3nacY.HERO_PROMPT_MENU_ITEM).type,
                key: (0, $3nacY.HERO_PROMPT_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    if (!editorPluginAIProvider.heroConfigItem) return null;
                    const configItem = editorPluginAIProvider.heroConfigItem.config;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $3nacY.HERO_PROMPT_MENU_ITEM).key,
                        icon: $09278ecf5feb6845$var$createHeroPromptIcon(configItem),
                        messageDescriptor: configItem.title,
                        configItem: configItem,
                        parents: parents
                    });
                }
            }
        ] : editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            // Previous implementation: hardcoded improve writing
            {
                type: (0, $3nacY.IMPROVE_WRITING_MENU_ITEM).type,
                key: (0, $3nacY.IMPROVE_WRITING_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.IMPROVE_WRITING_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $3nacY.IMPROVE_WRITING_MENU_ITEM).key,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))),
                        messageDescriptor: (0, $7ZL6d.aiMessages).improveWritingToolbarIconTitle,
                        configItem: (0, $iO5TS.improveWriting)(),
                        parents: parents
                    })
            }
        ] : [],
        {
            type: (0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).type,
            key: (0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.SPELLING_AND_GRAMMAR_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($74BSk))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).spellingAndGrammarToolbarDropdownIconTitle,
                    configItem: (0, $iO5TS.fixSpellingAndGrammar)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.CHANGE_TONE_NESTED_MENU).type,
            key: (0, $3nacY.CHANGE_TONE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.CHANGE_TONE_NESTED_MENU).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.CHANGE_TONE_NESTED_MENU).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptNestedMenu, {
                    itemKey: (0, $3nacY.CHANGE_TONE_NESTED_MENU).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).changeToneToolbarDropdownIconTitle,
                    api: api,
                    parents: parents
                }, children)
        },
        {
            type: (0, $3nacY.CHANGE_TONE_MENU_SECTION).type,
            key: (0, $3nacY.CHANGE_TONE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.CHANGE_TONE_NESTED_MENU).type,
                    key: (0, $3nacY.CHANGE_TONE_NESTED_MENU).key,
                    rank: (0, $hVLmg.CHANGE_TONE_MENU_RANK)[(0, $3nacY.CHANGE_TONE_MENU_SECTION).key]
                }
            ]
        },
        {
            type: (0, $3nacY.MORE_PROFESSIONAL_MENU_ITEM).type,
            key: (0, $3nacY.MORE_PROFESSIONAL_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $3nacY.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $hVLmg.CHANGE_TONE_MENU_SECTION_RANK)[(0, $3nacY.MORE_PROFESSIONAL_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.MORE_PROFESSIONAL_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
                    configItem: (0, $dFWys.changeToneToProfessional)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.MORE_CASUAL_MENU_ITEM).type,
            key: (0, $3nacY.MORE_CASUAL_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $3nacY.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $hVLmg.CHANGE_TONE_MENU_SECTION_RANK)[(0, $3nacY.MORE_CASUAL_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.MORE_CASUAL_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Jphz))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).moreCasualToneToolbarDropdownIconTitle,
                    configItem: (0, $dFWys.changeToneToCasual)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.MORE_EMPATHETIC_MENU_ITEM).type,
            key: (0, $3nacY.MORE_EMPATHETIC_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.CHANGE_TONE_MENU_SECTION).type,
                    key: (0, $3nacY.CHANGE_TONE_MENU_SECTION).key,
                    rank: (0, $hVLmg.CHANGE_TONE_MENU_SECTION_RANK)[(0, $3nacY.MORE_EMPATHETIC_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.MORE_EMPATHETIC_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($4WfQc))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
                    configItem: (0, $dFWys.changeToneToEmpathetic)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.MAKE_SHORTER_MENU_ITEM).type,
            key: (0, $3nacY.MAKE_SHORTER_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.MAKE_SHORTER_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.MAKE_SHORTER_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.MAKE_SHORTER_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($3CdTA))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).makeShorterToolbarDropdownIconTitle,
                    configItem: (0, $ddlQ3.makeShorter)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.MAKE_LONGER_MENU_ITEM).type,
            key: (0, $3nacY.MAKE_LONGER_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.MAKE_LONGER_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.MAKE_LONGER_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.MAKE_LONGER_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($2xJ2w))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).makeLongerToolbarDropdownIconTitle,
                    configItem: (0, $lQkyl.makeLonger)(),
                    parents: parents
                })
        },
        {
            type: (0, $3nacY.TRANSLATE_NESTED_MENU).type,
            key: (0, $3nacY.TRANSLATE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.TRANSLATE_NESTED_MENU).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.TRANSLATE_NESTED_MENU).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptNestedMenu, {
                    itemKey: (0, $3nacY.TRANSLATE_NESTED_MENU).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iJUbs))),
                    messageDescriptor: (0, $7ZL6d.aiMessages).translateOptionsIconLabel,
                    api: api,
                    parents: parents
                }, children)
        },
        {
            type: (0, $3nacY.TRANSLATE_MENU_SECTION).type,
            key: (0, $3nacY.TRANSLATE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.TRANSLATE_NESTED_MENU).type,
                    key: (0, $3nacY.TRANSLATE_NESTED_MENU).key,
                    rank: (0, $hVLmg.TRANSLATE_MENU_RANK)[(0, $3nacY.TRANSLATE_MENU_SECTION).key]
                }
            ]
        },
        // Dynamic translation language menu items
        ...$09278ecf5feb6845$var$getTranslationLanguagesToolbarItems(api, aiGlobalOptIn),
        // DEFINE MENU ITEM
        ...editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            {
                type: (0, $3nacY.DEFINE_MENU_ITEM).type,
                key: (0, $3nacY.DEFINE_MENU_ITEM).key,
                parents: [
                    {
                        type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                        key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                        rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.DEFINE_MENU_ITEM).key]
                    },
                    {
                        type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                        key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                        rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.DEFINE_MENU_ITEM).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    if (!Boolean(api?.aiDefinitions)) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        itemKey: (0, $3nacY.DEFINE_MENU_ITEM).key,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))),
                        messageDescriptor: (0, $7ZL6d.aiMessages).DefineDropdownIconTitle,
                        onClick: ()=>{
                            api?.aiDefinitions?.actions.openReadingAidsPopup();
                        },
                        parents: parents
                    });
                }
            }
        ] : [],
        // HERO BUTTON (with its own group based on heroConfigItem or legacy implementation)
        ...isNewToolbarEnabled && editorPluginAIProvider.heroConfigItem && editorPluginAIProvider.isInDocumentStreamingEnabled ? [
            // New dynamic implementation: uses heroConfigItem
            {
                type: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).type,
                key: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key,
                parents: [
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key]
                    },
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key]
                    },
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key]
                    }
                ],
                component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                        above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
            },
            {
                type: (0, $3nacY.HERO_PROMPT_BUTTON).type,
                key: (0, $3nacY.HERO_PROMPT_BUTTON).key,
                parents: [
                    {
                        type: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).type,
                        key: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key,
                        rank: (0, $hVLmg.HERO_PROMPT_BUTTON_GROUP_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON).key]
                    },
                    ...!isRovoAvailable || Boolean(editorPluginAIProvider.emptyStateHeroConfigItem) && (0, $2pQiO.UNSAFE_expValNoExposure)('jira-smart-replies-v2', 'isEnabled', false) ? [
                        {
                            type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                            key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                            rank: !isRovoAvailable ? (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.ROVO_HERO_BUTTON).key] : (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON).key]
                        }
                    ] : []
                ],
                component: ({ parents: parents })=>editorPluginAIProvider.heroConfigItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$export$9041c40b25483898, {
                        aiGlobalOptIn: aiGlobalOptIn,
                        parents: parents,
                        api: api,
                        heroConfigItem: editorPluginAIProvider.heroConfigItem,
                        emptyStateHeroConfigItem: editorPluginAIProvider.emptyStateHeroConfigItem,
                        isIconOnly: parents.some((parent)=>parent.key === (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key)
                    }) : null
            }
        ] : isNewToolbarEnabled ? [
            {
                type: 'group',
                key: 'improve-writing-group',
                parents: [
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.IMPROVE_WRITING_GROUP).key]
                    },
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION_FULL_PAGE_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.IMPROVE_WRITING_GROUP).key]
                    },
                    {
                        type: (0, $3nacY.AI_SECTION).type,
                        key: (0, $3nacY.AI_SECTION_COMMENT_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.IMPROVE_WRITING_GROUP).key]
                    }
                ],
                component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                        above: breakpointPreset === 'jsm-comment' ? 'sm' : 'lg'
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
            },
            {
                type: (0, $3nacY.IMPROVE_WRITING_BUTTON).type,
                key: (0, $3nacY.IMPROVE_WRITING_BUTTON).key,
                parents: [
                    {
                        type: (0, $3nacY.IMPROVE_WRITING_GROUP).type,
                        key: (0, $3nacY.IMPROVE_WRITING_GROUP).key,
                        rank: (0, $hVLmg.IMPROVE_WRITING_GROUP_RANK)[(0, $3nacY.IMPROVE_WRITING_BUTTON).key]
                    },
                    ...!isRovoAvailable ? [
                        {
                            type: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).type,
                            key: (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key,
                            rank: (0, $hVLmg.ROVO_GROUP_DISPLAY_SMALL_RANK)[(0, $3nacY.ROVO_HERO_BUTTON).key]
                        }
                    ] : []
                ],
                component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$export$2df6fac7793eedd9, {
                        aiGlobalOptIn: aiGlobalOptIn,
                        parents: parents,
                        shouldShowImproveDescription: shouldShowImproveDescription,
                        getAdditionalProps: getAdditionalProps,
                        api: api,
                        isIconOnly: parents.some((parent)=>parent.key === (0, $3nacY.ROVO_GROUP_DISPLAY_SMALL).key)
                    })
            }
        ] : [],
        ...isNewToolbarEnabled && editorPluginAIProvider.isInDocumentStreamingEnabled && (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true) ? [
            {
                type: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).type,
                key: 'hero-prompt-button-group-primary',
                parents: [
                    {
                        type: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).type,
                        key: (0, $3nacY.AI_SECTION_PRIMARY_TOOLBAR).key,
                        rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON_GROUP).key]
                    }
                ],
                component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                        above: "lg"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children))
            },
            {
                type: (0, $3nacY.HERO_PROMPT_BUTTON).type,
                key: 'hero-prompt-button-primary',
                parents: [
                    {
                        type: (0, $3nacY.HERO_PROMPT_BUTTON_GROUP).type,
                        key: 'hero-prompt-button-group-primary',
                        rank: (0, $hVLmg.HERO_PROMPT_BUTTON_GROUP_RANK)[(0, $3nacY.HERO_PROMPT_BUTTON).key]
                    }
                ],
                component: ({ parents: parents })=>{
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const heroConfigItem = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
                            config: {
                                ...(0, $iTW08.addPolish)(),
                                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
                                        label: "",
                                        size: "small"
                                    })
                            },
                            triggers: (0, $iTW08.addPolishWithOptions)({
                                isInDocumentStreamingEnabled: true
                            }).triggers
                        }), []);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$export$9041c40b25483898, {
                        aiGlobalOptIn: aiGlobalOptIn,
                        parents: parents,
                        api: api,
                        heroConfigItem: heroConfigItem,
                        emptyStateHeroConfigItem: editorPluginAIProvider.emptyStateHeroConfigItem,
                        isIconOnly: false
                    });
                }
            }
        ] : [],
        {
            type: (0, $3nacY.ROVO_GROUP_VIEW).type,
            key: (0, $3nacY.ROVO_GROUP_VIEW).key,
            parents: [
                {
                    type: (0, $3nacY.AI_VIEW_SECTION).type,
                    key: (0, $3nacY.AI_VIEW_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.ROVO_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.ROVO_HERO_BUTTON).type,
            key: (0, $3nacY.ROVO_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_GROUP_VIEW).type,
                    key: (0, $3nacY.ROVO_GROUP_VIEW).key,
                    rank: (0, $hVLmg.ROVO_GROUP_RANK)[(0, $3nacY.ROVO_HERO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$AskRovoChatButton, {
                    api: api,
                    editorPluginAIProvider: editorPluginAIProvider
                })
        },
        // DEFINE GROUP + DEFINE BUTTON
        {
            type: (0, $3nacY.DEFINE_GROUP).type,
            key: (0, $3nacY.DEFINE_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.AI_VIEW_SECTION).type,
                    key: (0, $3nacY.AI_VIEW_SECTION).key,
                    rank: (0, $hVLmg.AI_SECTION_RANK)[(0, $3nacY.DEFINE_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                if (!Boolean(api?.aiDefinitions)) return null;
                return api?.aiDefinitions?.actions.selectionExceedsMaxWordCount() ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7T88d.Show), {
                    above: "lg"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children));
            }
        },
        {
            type: (0, $3nacY.DEFINE_BUTTON).type,
            key: (0, $3nacY.DEFINE_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.DEFINE_GROUP).type,
                    key: (0, $3nacY.DEFINE_GROUP).key,
                    rank: (0, $hVLmg.DEFINE_GROUP_RANK)[(0, $3nacY.DEFINE_BUTTON).key]
                }
            ],
            component: ()=>{
                if (!Boolean(api?.aiDefinitions)) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$export$4b24d5b721b89a5c, {
                    api: api
                });
            }
        },
        {
            type: (0, $3nacY.ADD_POLISH_MENU_ITEM).type,
            key: (0, $3nacY.ADD_POLISH_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.ADD_POLISH_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).type,
                    key: (0, $3nacY.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key,
                    rank: (0, $hVLmg.ROVO_PROMPT_MENU_SECTION_RANK)[(0, $3nacY.ADD_POLISH_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: (0, $3nacY.ADD_POLISH_MENU_ITEM).key,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))),
                    messageDescriptor: (0, $93WrI.aiConfigItemMessages).improveFormattingTitle,
                    configItem: (0, $iTW08.addPolish)(),
                    parents: parents
                })
        }
    ];
};
const $09278ecf5feb6845$var$getTranslationLanguagesToolbarItems = (api, aiGlobalOptIn)=>{
    const translationConfigItemsMap = (0, $9pamm.createTranslationConfigItems)();
    return (0, $2aMCF.getSortedSupportedTranslationLanguages)().map((lang, index)=>({
            type: 'menu-item',
            key: `${lang}-language-menu-item`,
            parents: [
                {
                    type: (0, $3nacY.TRANSLATE_MENU_SECTION).type,
                    key: (0, $3nacY.TRANSLATE_MENU_SECTION).key,
                    rank: (index + 1) * 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($09278ecf5feb6845$var$RovoPromptItem, {
                    api: api,
                    aiGlobalOptIn: aiGlobalOptIn,
                    itemKey: `${lang}-language-menu-item`,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iJUbs))),
                    messageDescriptor: (0, $2urSQ.aiLanguageMessages)[lang],
                    configItem: translationConfigItemsMap[lang],
                    parents: parents
                })
        }));
};
const $09278ecf5feb6845$var$createHeroPromptIcon = (configItem)=>{
    const IconComponent = Object.assign(()=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        if (configItem.icon) {
            const iconElement = configItem.icon({
                formatMessage: formatMessage
            });
            if (iconElement) return iconElement;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
            label: formatMessage(configItem.title),
            size: "small"
        });
    }, {
        displayName: 'HeroPromptIcon'
    });
    return IconComponent;
};









var $3fO5l = parcelRequire("3fO5l");


var $1TvTa = parcelRequire("1TvTa");


var $4THFE = parcelRequire("4THFE");


var $5ZtfK = parcelRequire("5ZtfK");


var $dimUV = parcelRequire("dimUV");


var $2hwiA = parcelRequire("2hwiA");


var $d4GYd = parcelRequire("d4GYd");













const $5fd694e8edbc1cc4$export$846b21b062f23785 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SMARTLINK_DRAFT_CONTENT,
        title: (0, $7ZL6d.aiMessages).smartlinkSummarizeChanges,
        description: (0, $7ZL6d.aiMessages).smartlinkSummarizeChanges,
        showInRefineDropdown: false,
        insertOnEmptySelection: true,
        // intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
        intentSchemaId: 'smartlink_draft_content_intent_schema.json',
        featureId: 'smartlink_draft_content',
        adfPrompt: true,
        getRequestPayload: ({ locale: locale, aiSessionId: aiSessionId, contentAri: contentAri })=>({
                ai_feature_input: {
                    feature: 'smartlink_draft_content',
                    feature_args: {
                        smartlink_url: options.smartlinkUrl,
                        smartlink_action_type: options.actionType
                    },
                    locale: locale,
                    ai_session_id: aiSessionId,
                    content_ari: contentAri
                }
            }),
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });











const $f8aef71ea75f9565$export$2ec4c25107de36b3 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SMARTLINK_EXTRACT_ACTIONS,
        title: (0, $7ZL6d.aiMessages).smartlinkAddDecisions,
        description: (0, $7ZL6d.aiMessages).smartlinkAddDecisions,
        showInRefineDropdown: false,
        insertOnEmptySelection: true,
        // intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
        intentSchemaId: 'smartlink_extract_actions_intent_schema.json',
        featureId: 'smartlink_extract_actions',
        adfPrompt: true,
        getRequestPayload: ({ locale: locale, aiSessionId: aiSessionId, contentAri: contentAri })=>({
                ai_feature_input: {
                    feature: 'smartlink_extract_actions',
                    feature_args: {
                        smartlink_url: options.smartlinkUrl,
                        smartlink_action_type: options.actionType
                    },
                    locale: locale,
                    ai_session_id: aiSessionId,
                    content_ari: contentAri
                }
            }),
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });











const $ff151698a1c93666$export$b45be00386dc2609 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SMARTLINK_EXTRACT_LIST,
        title: (0, $7ZL6d.aiMessages).smartlinkListKeyTopics,
        description: (0, $7ZL6d.aiMessages).smartlinkListKeyTopics,
        showInRefineDropdown: false,
        insertOnEmptySelection: true,
        // intentSchemaId is not being passed to the backend. it's used in `request-options-convo-ai.ts` for error logging
        intentSchemaId: 'smartlink_extract_list_intent_schema.json',
        featureId: 'smartlink_extract_list',
        adfPrompt: true,
        getRequestPayload: ({ locale: locale, aiSessionId: aiSessionId, contentAri: contentAri })=>({
                ai_feature_input: {
                    feature: 'smartlink_extract_list',
                    feature_args: {
                        smartlink_url: options.smartlinkUrl,
                        smartlink_action_type: options.actionType
                    },
                    locale: locale,
                    ai_session_id: aiSessionId,
                    content_ari: contentAri
                }
            }),
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });


const $05d8c4e6f1eb0d83$var$actionLabels = {
    list_key_topics: (0, $7ZL6d.aiMessages).smartlinkListKeyTopics,
    list_key_themes: (0, $7ZL6d.aiMessages).smartlinkListKeyThemes,
    extract_insights: (0, $7ZL6d.aiMessages).smartlinkExtractInsights,
    extract_user_quotes: (0, $7ZL6d.aiMessages).smartlinkExtractUserQuotes,
    add_decisions: (0, $7ZL6d.aiMessages).smartlinkAddDecisions,
    define_action_items: (0, $7ZL6d.aiMessages).smartlinkDefineActionItems,
    summarize_changes: (0, $7ZL6d.aiMessages).smartlinkSummarizeChanges,
    add_related_work_items: (0, $7ZL6d.aiMessages).smartlinkAddRelatedWorkItems,
    list_todos: (0, $7ZL6d.aiMessages).smartlinkListTodos
};
const $05d8c4e6f1eb0d83$export$a93c358eeacdad48 = (details)=>{
    // `meta` has a [k: string]: any index signature, so direct access is safe without casting.
    const metaKey = details?.meta?.key;
    const resourceType = details?.meta?.resourceType;
    const metaProduct = details?.meta?.product;
    // Cast to BaseData (the common base for non-collection responses) to access typed properties.
    const data = details?.data;
    const dataType = data?.['@type'];
    // schema:fileFormat only exists on Document, which extends BaseData.
    const fileFormat = data?.['schema:fileFormat'];
    // generator is typed as Primitives.Object | Primitives.Link on BaseData.
    // Primitives.Link can be a string or LinkModel (which has href). Only Object has name.
    const generator = data?.generator;
    const generatorName = generator && typeof generator !== 'string' && !('href' in generator) ? generator.name : undefined;
    const hasType = (type)=>Array.isArray(dataType) ? dataType.includes(type) : dataType === type;
    // all Confluence content types share meta.product === 'confluence'
    if (metaProduct === 'confluence') {
        if (resourceType === 'whiteboard') return [
            'list_key_themes',
            'add_decisions',
            'define_action_items'
        ];
        if (resourceType === 'database') return [
            'extract_insights'
        ];
        // page, live-page, blog, and any other Confluence page-like resource types
        return [
            'summarize_changes',
            'list_key_topics'
        ];
    }
    switch(metaKey){
        case 'jira-object-provider':
            return [
                'add_related_work_items'
            ];
        case 'loom-object-provider':
            return [
                'extract_user_quotes',
                'add_decisions',
                'define_action_items'
            ];
        case 'trello-object-provider':
            return [
                'list_todos'
            ];
        case 'miro-object-provider':
            return [
                'list_key_themes'
            ];
        case 'google-object-provider':
            if (hasType('schema:SpreadsheetDigitalDocument')) return [
                'extract_insights'
            ];
            // TextDigitalDocument (Google Docs) and other Google doc types
            return [
                'list_key_topics'
            ];
        case 'onedrive-object-provider':
        case 'sharepoint-object-provider':
            if (fileFormat?.includes('spreadsheetml') || fileFormat?.includes('ms-excel')) return [
                'extract_insights'
            ];
            // wordprocessingml, ms-word, presentationml, and other Office file types
            return [
                'list_key_topics'
            ];
        case 'figma-object-provider':
            return [
                'summarize_changes'
            ];
        case 'slack-object-provider':
            return [
                'add_decisions',
                'define_action_items'
            ];
        default:
            // fallback: use generator.name for providers without a confirmed meta.key.
            if (generatorName === 'Zoom') return [
                'extract_user_quotes',
                'add_decisions',
                'define_action_items'
            ];
            if (generatorName === 'Microsoft Teams' || generatorName === 'Google Chat') return [
                'add_decisions',
                'define_action_items'
            ];
            if (generatorName === 'MURAL') return [
                'list_key_themes'
            ];
            if (generatorName === 'Notion') return [
                'list_key_topics'
            ];
            if (generatorName === 'Smartsheet') return [
                'extract_insights'
            ];
            return [];
    }
};
const $05d8c4e6f1eb0d83$var$getConfigItem = (actionKey, smartlinkUrl)=>{
    switch(actionKey){
        case 'list_key_topics':
        case 'list_key_themes':
        case 'extract_insights':
        case 'extract_user_quotes':
        case 'add_related_work_items':
        case 'list_todos':
            return (0, $ff151698a1c93666$export$b45be00386dc2609)({
                smartlinkUrl: smartlinkUrl,
                actionType: actionKey
            });
        case 'add_decisions':
        case 'define_action_items':
            return (0, $f8aef71ea75f9565$export$2ec4c25107de36b3)({
                smartlinkUrl: smartlinkUrl,
                actionType: actionKey
            });
        case 'summarize_changes':
            return (0, $5fd694e8edbc1cc4$export$846b21b062f23785)({
                smartlinkUrl: smartlinkUrl,
                actionType: actionKey
            });
        default:
            {
                // exhaustiveness check — TypeScript will error here if a new SmartLinkActionKey
                // is added without a corresponding case above.
                const _ = actionKey;
                return _;
            }
    }
};
// icon render functions for each smartlink action key
const $05d8c4e6f1eb0d83$var$ACTION_KEY_ICONS = {
    list_key_topics: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
            label: "",
            size: "small"
        }),
    list_key_themes: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
            label: "",
            size: "small"
        }),
    extract_insights: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1TvTa))), {
            label: "",
            size: "small"
        }),
    extract_user_quotes: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
            label: "",
            size: "small"
        }),
    add_decisions: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dimUV))), {
            label: "",
            size: "small"
        }),
    define_action_items: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hwiA))), {
            label: "",
            size: "small"
        }),
    summarize_changes: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            size: "small"
        }),
    add_related_work_items: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4THFE))), {
            label: "",
            size: "small"
        }),
    list_todos: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hwiA))), {
            label: "",
            size: "small"
        })
};
const $05d8c4e6f1eb0d83$export$6ff0e2bc14bad0fc = ({ aiGlobalOptIn: aiGlobalOptIn, details: details, intl: intl, nodeType: nodeType, smartlinkUrl: smartlinkUrl, testIdPrefix: testIdPrefix, triggeredForMark: triggeredForMark, view: view })=>{
    const clickHandler = (actionKey)=>{
        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
            state: view.state,
            configItem: $05d8c4e6f1eb0d83$var$getConfigItem(actionKey, smartlinkUrl),
            lastTriggeredFrom: 'floatingToolbar',
            triggerMethod: 'click',
            aiGlobalOptIn: aiGlobalOptIn,
            locale: intl.locale,
            triggeredFor: nodeType,
            triggeredForMark: triggeredForMark
        });
        openAIModalCommand(view.state, view.dispatch, view);
    };
    const actionKeys = $05d8c4e6f1eb0d83$export$a93c358eeacdad48(details);
    // render action items for known providers; return empty for unknown ones.
    if (actionKeys.length > 0) return actionKeys.map((actionKey)=>({
            icon: $05d8c4e6f1eb0d83$var$ACTION_KEY_ICONS[actionKey](),
            label: intl.formatMessage($05d8c4e6f1eb0d83$var$actionLabels[actionKey]),
            testId: `${testIdPrefix}-smartlink-dropdown-${actionKey}`,
            onClick: ()=>clickHandler(actionKey)
        }));
    // in future, if we decide to add generic actions for unknown providers, we can add them here
    return [];
};


const $bcebd4bbcac9e623$var$rovoButtonIconStyles = {
    root: "_0LQT5EgVvo _03SyCPFQfX",
    imageToolbarIcon: "_3iDTPbccYA _0LQT5E1Y8M _03SyCPFQfX",
    smallerRovoIcon: "_3iDTPbccYA _1VJPcaTCRo _0yKXXaDIqT"
};
const $bcebd4bbcac9e623$export$ef1d0b9899d7de5 = `ak-editor-ai-selection-toolbar-ai-button`;
const $bcebd4bbcac9e623$var$SMART_LINK_ROVO_BUTTON_INVOKED_FROM = (0, $1jIs1.SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE);
const $bcebd4bbcac9e623$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM = (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK_SUMMARIZE_BUTTON;
const $bcebd4bbcac9e623$var$ATLASSIAN_PRODUCTS = new Set([
    'jira',
    'confluence',
    'bitbucket',
    'trello',
    'loom',
    'townsquare',
    'compass',
    'mercury',
    'atlas',
    'watermelon',
    'canvas',
    'rovo'
]);
const $bcebd4bbcac9e623$var$isPasteActionsMenuV2Enabled = ()=>[
        'hasAltAiActions',
        'hasSpellingAndGrammar'
    ].includes((0, $mW7G5.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control'));
const $bcebd4bbcac9e623$export$a3e7258dd93ab690 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn, icon: icon, title: title, tooltip: tooltip, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount, onClick: onClick, disabled: disabled, openInRovoChat: openInRovoChat, rovoChatAIFeatureContext: rovoChatAIFeatureContext })=>{
    let didMouseEnter = false;
    const browser = (0, $8dxef.getBrowserInfo)();
    const metaKey = browser.mac ? "\u2318" : 'Ctrl';
    const Icon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "small"
        });
    return {
        type: 'button',
        isRadioButton: false,
        pulse: pulse,
        showTitle: true,
        testId: $bcebd4bbcac9e623$export$ef1d0b9899d7de5,
        icon: icon ?? Icon,
        ...!hideTitle && {
            title: intl.formatMessage(title ?? (0, $7ZL6d.aiMessages).aiToolbarTitle)
        },
        ariaLabel: intl.formatMessage(title ?? (0, $7ZL6d.aiMessages).aiToolbarTitle),
        tooltipContent: intl.formatMessage(tooltip ?? (0, $flbIU.default).aiUniversalShortCallToAction, {
            key: metaKey
        }),
        onMount: onMount,
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, _view)=>{
            const configItem = openInRovoChat ? {
                ...rangeBaseGenerate,
                openInRovoChat: true,
                rovoChatAIFeatureContext: rovoChatAIFeatureContext
            } : rangeBaseGenerate;
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: state,
                configItem: configItem,
                lastTriggeredFrom: 'floatingToolbar',
                // ED-18194 Added analytics for floating toolbar to determine
                // the % of users who click the button vs shift tab to it
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn,
                triggeredFor: triggeredFor,
                locale: intl.locale
            });
            openAIModalCommand(state, dispatch);
            if (onClick) onClick();
            return false;
        },
        disabled: disabled
    };
};
const $bcebd4bbcac9e623$export$c93a3969a7894772 = ({ intl: intl, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn, disabled: disabled, onMount: onMount, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled })=>{
    let didMouseEnter = false;
    return {
        type: 'button',
        isRadioButton: false,
        showTitle: true,
        testId: `${$bcebd4bbcac9e623$export$ef1d0b9899d7de5}-improve-writing`,
        ariaLabel: intl.formatMessage((0, $7ZL6d.aiMessages).improveWritingToolbarIconTitle),
        icon: (0, $iDrrr.fg)('ai-smart-button-team-25') || (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))) : undefined,
        ...!hideTitle && {
            title: intl.formatMessage((0, $7ZL6d.aiMessages).improveWritingToolbarIconTitle)
        },
        tooltipContent: isInDocumentStreamingEnabled ? undefined : intl.formatMessage((0, $7ZL6d.aiMessages).improveWritingToolbarIconTooltip),
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, _view)=>{
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: state,
                configItem: (0, $iO5TS.improveWriting)(),
                lastTriggeredFrom: 'floatingToolbar',
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn,
                locale: intl.locale
            });
            openAIModalCommand(state, dispatch);
            return false;
        },
        disabled: disabled,
        onMount: onMount
    };
};
const $bcebd4bbcac9e623$export$183405c494408cb4 = (target = 'default')=>{
    switch(target){
        case 'remix-app':
            return {
                title: (0, $7ZL6d.aiMessages).askRovoToolbarRemixAppTitle,
                tooltip: (0, $7ZL6d.aiMessages).askRovoToolbarRemixAppTooltipQuickCommand
            };
        case 'image':
            return {
                title: (0, $7ZL6d.aiMessages).askRovoToolbarImageTitle,
                tooltip: (0, $7ZL6d.aiMessages).askRovoToolbarImageTooltipQuickCommand
            };
        case 'default':
        default:
            return {
                title: (0, $7ZL6d.aiMessages).askRovoToolbarIconTitle,
                tooltip: (0, $7ZL6d.aiMessages).askRovoToolbarIconTooltipQuickCommand
            };
    }
};
const $bcebd4bbcac9e623$export$b8d5d3cc3902e265 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, aiGlobalOptIn: aiGlobalOptIn, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount, onClick: onClick, disabled: disabled, openInRovoChat: openInRovoChat, rovoChatAIFeatureContext: rovoChatAIFeatureContext, target: target = 'default' })=>{
    const { title: title, tooltip: tooltip } = $bcebd4bbcac9e623$export$183405c494408cb4(target);
    const shouldUseImageToolbarSpacing = target === 'image' && (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_3', 'isEnabled', true);
    const Icon = shouldUseImageToolbarSpacing ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bcebd4bbcac9e623$var$rovoButtonIconStyles.imageToolbarIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "xxsmall"
        })) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "xxsmall"
        });
    return $bcebd4bbcac9e623$export$a3e7258dd93ab690({
        intl: intl,
        rangeBaseGenerate: rangeBaseGenerate,
        hideTitle: false,
        aiGlobalOptIn: aiGlobalOptIn,
        icon: Icon,
        title: title,
        tooltip: tooltip,
        triggeredFor: triggeredFor,
        pulse: pulse,
        onMount: onMount,
        onClick: onClick,
        disabled: disabled,
        openInRovoChat: openInRovoChat,
        rovoChatAIFeatureContext: rovoChatAIFeatureContext
    });
}; // Renderer component to allow React hooks for memoization
const $bcebd4bbcac9e623$var$RovoSplitButtonRenderer = ({ view: view, api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, onMount: onMount })=>{
    const registeredComponents = api?.toolbar?.actions.getComponents?.();
    const components = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>registeredComponents ?? (0, $09278ecf5feb6845$export$611b6feb29f5c606)({
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn,
            isNewToolbarEnabled: false,
            api: api
        }), [
        registeredComponents,
        editorPluginAIProvider,
        aiGlobalOptIn,
        api
    ]);
    const toolbarConfig = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            type: 'toolbar',
            key: (0, $3nacY.TOOLBARS).INLINE_TEXT_TOOLBAR,
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
        }), []);
    const fallbacks = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            group: (0, $5AKbu.ToolbarButtonGroup),
            section: (0, $cE5a1.ToolbarSection),
            menuSection: (0, $jgJIe.ToolbarDropdownItemSection)
        }), []);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        onMount?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFSJa.EditorToolbarProvider), {
        editorView: view ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnAkm.EditorToolbarUIProvider), {
        api: api
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7CFSN.ToolbarModelRenderer), {
        toolbar: toolbarConfig,
        components: components,
        fallbacks: fallbacks
    })));
};
const $bcebd4bbcac9e623$export$a85fdf32e150e9f2 = (props)=>{
    const { intl: intl, rangeBaseGenerate: rangeBaseGenerate, aiGlobalOptIn: aiGlobalOptIn, editorPluginAIProvider: editorPluginAIProvider, disabled: disabled, api: api, triggeredFor: triggeredFor, pulse: pulse, onMount: onMount } = props;
    return {
        type: 'custom',
        fallback: [
            $bcebd4bbcac9e623$export$b8d5d3cc3902e265({
                intl: intl,
                rangeBaseGenerate: rangeBaseGenerate,
                aiGlobalOptIn: props.aiGlobalOptIn,
                triggeredFor: triggeredFor,
                pulse: pulse,
                onMount: onMount,
                disabled: disabled
            })
        ],
        render: (view)=>{
            if (!view) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bcebd4bbcac9e623$var$RovoSplitButtonRenderer, {
                onMount: onMount,
                view: view,
                api: api,
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiGlobalOptIn
            });
        }
    };
};
const $bcebd4bbcac9e623$export$f871051616837c84 = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, disabled: disabled, has3pSources: has3pSources, intl: intl, nodeType: nodeType, rangeBaseGenerate: rangeBaseGenerate, smartlinkName: smartlinkName, smartlinkUrl: smartlinkUrl, sourceProduct: sourceProduct, triggeredForMark: triggeredForMark })=>{
    const RovoButtonIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bcebd4bbcac9e623$var$rovoButtonIconStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bcebd4bbcac9e623$var$rovoButtonIconStyles.smallerRovoIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "xxsmall"
        })));
    return {
        type: 'button',
        isRadioButton: false,
        disabled: disabled,
        showTitle: true,
        testId: `${$bcebd4bbcac9e623$export$ef1d0b9899d7de5}-smartlink`,
        icon: RovoButtonIcon,
        title: intl.formatMessage((0, $flbIU.default).rovoButtonTitle),
        ariaLabel: intl.formatMessage((0, $flbIU.default).rovoButtonTitle),
        tooltipContent: intl.formatMessage((0, $flbIU.default).rovoButtonTitle),
        onMount: ()=>{},
        onClick: (state, dispatch, _view)=>{
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK_ROVO_BUTTON,
                attributes: {
                    sourceProduct: sourceProduct,
                    has3pSources: has3pSources
                }
            }); // Open the same prompt input as getAIExperienceButton(), but with
            // openInRovoChat: true so that submitting the prompt opens the Rovo
            // chat sidebar instead of performing an AI edit on the document.
            // rovoChatAIFeatureContext carries the smartlink entity context so that
            // the Rovo sidebar shows a context banner for the linked resource.
            const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                state: state,
                configItem: {
                    ...rangeBaseGenerate,
                    openInRovoChat: true,
                    rovoChatInteractionSource: $bcebd4bbcac9e623$var$SMART_LINK_ROVO_BUTTON_INVOKED_FROM,
                    rovoChatAIFeatureContext: smartlinkName ? {
                        projectContext: {
                            projectId: smartlinkUrl,
                            projectName: smartlinkName,
                            projectUrl: smartlinkUrl
                        }
                    } : undefined
                },
                lastTriggeredFrom: $bcebd4bbcac9e623$var$SMART_LINK_ROVO_BUTTON_INVOKED_FROM,
                triggerMethod: 'click',
                aiGlobalOptIn: aiGlobalOptIn,
                triggeredForMark: triggeredForMark,
                triggeredFor: nodeType,
                locale: intl.locale
            });
            openAIModalCommand(state, dispatch);
            return false;
        }
    };
};
const $bcebd4bbcac9e623$export$90102ae51106249a = ({ api: api, disabled: disabled, intl: intl, aiGlobalOptIn: aiGlobalOptIn, nodeType: nodeType, nodeRange: nodeRange, smartlinkUrl: smartlinkUrl, sourceProduct: sourceProduct, has3pSources: has3pSources, triggeredForMark: triggeredForMark })=>{
    return {
        type: 'button',
        isRadioButton: false,
        disabled: disabled,
        showTitle: true,
        testId: `${$bcebd4bbcac9e623$export$ef1d0b9899d7de5}-smartlink-summarize`,
        icon: (0, $f6j4r.SummarizeIcon),
        title: intl.formatMessage((0, $7ZL6d.aiMessages).summarizeToolbarDropdownIconTitle),
        ariaLabel: intl.formatMessage((0, $7ZL6d.aiMessages).summarizeToolbarDropdownIconTitle),
        tooltipContent: intl.formatMessage((0, $7ZL6d.aiMessages).summarizeToolbarDropdownIconTitle),
        onMount: ()=>{},
        onClick: (state, dispatch, _view)=>{
            if ($bcebd4bbcac9e623$var$isPasteActionsMenuV2Enabled()) return (0, $b6b61001640e68cf$export$ab1472fec20613b2)({
                aiGlobalOptIn: aiGlobalOptIn,
                decorateDeselectTransaction: api?.card?.actions.hideLinkToolbar,
                fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
                has3pSources: has3pSources,
                lastTriggeredFrom: $bcebd4bbcac9e623$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM,
                locale: intl.locale,
                nodeRange: nodeRange,
                nodeType: nodeType,
                openSmartLinkSummarizePopup: api?.aiDefinitions?.actions.openSmartLinkSummarizePopup,
                smartlinkUrl: smartlinkUrl,
                sourceProduct: sourceProduct,
                triggeredForMark: triggeredForMark,
                triggerMethod: 'click'
            })(state, dispatch, _view);
            api?.analytics?.actions.fireAnalyticsEvent({
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                eventType: (0, $krYZG.EVENT_TYPE).UI,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SMART_LINK_SUMMARIZE_BUTTON,
                attributes: {
                    sourceProduct: sourceProduct,
                    has3pSources: has3pSources
                }
            });
            if (api?.aiDefinitions?.actions.openSmartLinkSummarizePopup) {
                // Prefer the smartlink's own range (passed in from the descriptor
                // builder, where it's already known) over `state.selection` —
                // the toolbar can be shown via hover/focus without the selection
                // covering the node, in which case `state.selection` would point
                // at unrelated content.
                const { from: from, to: to } = nodeRange ?? state.selection; // Deselect the smartlink node before opening the popup so the
                // smartlink floating toolbar closes immediately. Clamp the target
                // position to the document end — `to + 1` would overshoot when a
                // blockCard sits at the very end of the doc.
                if (dispatch) {
                    const deselectAt = Math.min(to + 1, state.doc.content.size);
                    let tr = state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(deselectAt), 1));
                    if (api.card?.actions.hideLinkToolbar) tr = api.card.actions.hideLinkToolbar(tr);
                    dispatch(tr);
                }
                api.aiDefinitions.actions.openSmartLinkSummarizePopup({
                    from: from,
                    to: to,
                    smartlinkUrl: smartlinkUrl,
                    sourceProduct: sourceProduct,
                    has3pSources: has3pSources,
                    invokedFrom: $bcebd4bbcac9e623$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM
                });
                return false;
            } else {
                const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
                    state: state,
                    configItem: (0, $7dfcec7fc3b4e630$export$d10faabbe9a379d9)({
                        smartlinkUrl: smartlinkUrl
                    }),
                    lastTriggeredFrom: $bcebd4bbcac9e623$var$SMART_LINK_SUMMARIZE_BUTTON_INVOKED_FROM,
                    triggerMethod: 'click',
                    aiGlobalOptIn: aiGlobalOptIn,
                    locale: intl.locale,
                    triggeredFor: nodeType,
                    sourceProduct: sourceProduct,
                    has3pSources: has3pSources,
                    triggeredForMark: triggeredForMark
                });
                openAIModalCommand(state, dispatch);
            }
            return false;
        }
    };
};
/**
 * Renders the SmartLink AI buttons (Rovo + Summarize) only when the SmartLink
 * for the given URL has been resolved.
 */ const $bcebd4bbcac9e623$var$LegacySmartLinkAIButtonsRenderer = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, disabled: disabled, intl: intl, isHyperlink: isHyperlink, nodeType: nodeType, nodeRange: nodeRange, rangeBaseGenerate: rangeBaseGenerate, smartlinkUrl: smartlinkUrl, view: view })=>{
    const { store: store, connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const [hyperlinkResolved, setHyperlinkResolved] = (0, $cozmU.useState)(false); // For plain hyperlinks, the URL is not yet in the SmartLink store (only card
    // components trigger resolution automatically). We trigger resolution on mount
    // so we can check access permissions before showing AI buttons.
    (0, $cozmU.useEffect)(()=>{
        if (!isHyperlink) return;
        const existing = store?.getState()[smartlinkUrl];
        if (existing) {
            setHyperlinkResolved(true);
            return;
        }
        connections.client.fetchData(smartlinkUrl).then((response)=>{
            store?.dispatch({
                type: 'resolved',
                url: smartlinkUrl,
                payload: response
            });
            setHyperlinkResolved(true);
        }).catch(()=>{
        // for inaccessible URLs.
        });
    }, [
        isHyperlink,
        smartlinkUrl,
        store,
        connections.client
    ]);
    const smartLinkState = store?.getState()[smartlinkUrl];
    const { status: status, details: details } = smartLinkState || {};
    const objectProviderKey = details?.meta?.key?.toLowerCase() ?? '';
    const hasObjectProviderKey = objectProviderKey.length > 0;
    const isThirdPartyNonPublic = !Array.from($bcebd4bbcac9e623$var$ATLASSIAN_PRODUCTS).some((product)=>objectProviderKey.includes(product)) && !objectProviderKey.includes('public');
    const has3pSources = hasObjectProviderKey ? isThirdPartyNonPublic : false;
    const sourceProduct = hasObjectProviderKey ? objectProviderKey.split('-')[0] : null;
    const isResolved = status === 'resolved' && details?.meta?.access === 'granted'; // For hyperlinks, wait for resolution to complete before deciding
    if (isHyperlink && !hyperlinkResolved) return null;
    if (!isResolved) return null;
    const triggeredForMark = isHyperlink ? view.state.schema.marks.link : undefined;
    const getHostnameFromUrl = (url)=>{
        try {
            return new URL(url).hostname;
        } catch  {
            return '';
        }
    }; // Re-use the existing descriptor-based helpers to keep all button config in
    // one place, then pass each field to the FloatingToolbarButton React component
    // the same way the Toolbar's own `case 'button':` branch does it.
    // Extract the human-readable name from the SmartLink's JSON-LD data (the
    // `name` field on BaseData). Fall back to the URL hostname so the Rovo chat
    // context banner always has a non-empty label.
    const smartlinkData = details?.data;
    const smartlinkName = typeof smartlinkData?.name === 'string' && smartlinkData.name ? smartlinkData.name : getHostnameFromUrl(smartlinkUrl);
    const rovoDescriptor = $bcebd4bbcac9e623$export$f871051616837c84({
        api: api,
        aiGlobalOptIn: aiGlobalOptIn,
        disabled: disabled,
        has3pSources: has3pSources,
        intl: intl,
        nodeType: nodeType,
        rangeBaseGenerate: rangeBaseGenerate,
        smartlinkName: smartlinkName,
        smartlinkUrl: smartlinkUrl,
        sourceProduct: sourceProduct,
        triggeredForMark: triggeredForMark
    });
    const summarizeDescriptor = $bcebd4bbcac9e623$export$90102ae51106249a({
        api: api,
        aiGlobalOptIn: aiGlobalOptIn,
        disabled: disabled,
        intl: intl,
        nodeType: nodeType,
        nodeRange: nodeRange,
        smartlinkUrl: smartlinkUrl,
        sourceProduct: sourceProduct,
        has3pSources: has3pSources,
        triggeredForMark: triggeredForMark
    });
    const dispatchCommand = (cmd)=>{
        cmd(view.state, view.dispatch, view);
    };
    const isSmartlinkToolbarV2ExpEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_smartlink_toolbar_v2_exp');
    const dropdownItems = isSmartlinkToolbarV2ExpEnabled ? (0, $05d8c4e6f1eb0d83$export$6ff0e2bc14bad0fc)({
        aiGlobalOptIn: aiGlobalOptIn,
        details: details,
        intl: intl,
        nodeType: nodeType,
        smartlinkUrl: smartlinkUrl,
        testIdPrefix: $bcebd4bbcac9e623$export$ef1d0b9899d7de5,
        triggeredForMark: triggeredForMark,
        view: view
    }) : [];
    const RovoIcon = rovoDescriptor.icon;
    const SummarizeButtonIcon = summarizeDescriptor.icon;
    const shouldShowDropdown = isSmartlinkToolbarV2ExpEnabled && dropdownItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        testId: rovoDescriptor.testId,
        title: rovoDescriptor.title,
        ariaLabel: rovoDescriptor.ariaLabel,
        tooltipContent: rovoDescriptor.tooltipContent,
        disabled: rovoDescriptor.disabled,
        icon: RovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RovoIcon, {
            label: ""
        }) : undefined,
        onMount: rovoDescriptor.onMount,
        onClick: ()=>dispatchCommand(rovoDescriptor.onClick)
    }, rovoDescriptor.showTitle && rovoDescriptor.title), shouldShowDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwf4Z.ToolbarDropdownMenuProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }),
        testId: `${$bcebd4bbcac9e623$export$ef1d0b9899d7de5}-smartlink-rovo-chevron`,
        isDisabled: disabled,
        label: intl.formatMessage((0, $7ZL6d.aiMessages).rovoToolbarDropdownChevronLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, dropdownItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            key: item.testId,
            elemBefore: item.icon,
            isDisabled: disabled,
            onClick: item.onClick,
            testId: item.testId
        }, item.label))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        testId: summarizeDescriptor.testId,
        title: summarizeDescriptor.title,
        ariaLabel: summarizeDescriptor.ariaLabel,
        tooltipContent: summarizeDescriptor.tooltipContent,
        disabled: summarizeDescriptor.disabled,
        icon: SummarizeButtonIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SummarizeButtonIcon, {
            label: ""
        }) : undefined,
        onMount: summarizeDescriptor.onMount,
        onClick: ()=>dispatchCommand(summarizeDescriptor.onClick)
    }, summarizeDescriptor.showTitle && summarizeDescriptor.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        fullHeight: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')
    }));
};
const $bcebd4bbcac9e623$var$RefactoredSmartLinkAIButtonsRenderer = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, disabled: disabled, intl: intl, isHyperlink: isHyperlink, nodeType: nodeType, nodeRange: nodeRange, rangeBaseGenerate: rangeBaseGenerate, smartlinkUrl: smartlinkUrl, view: view })=>{
    const { details: details, isLoading: isLoading, isResolvedWithAccess: isResolvedWithAccess, metadata: metadata } = (0, $b0039ce3bd4500e0$export$c7750a1fc252fe45)({
        resolveIfMissing: Boolean(isHyperlink),
        smartlinkUrl: smartlinkUrl
    }); // For hyperlinks, wait for resolution to complete before deciding
    if (isHyperlink && isLoading) return null;
    if (!isResolvedWithAccess || !metadata) return null;
    const triggeredForMark = isHyperlink ? view.state.schema.marks.link : undefined; // Re-use the existing descriptor-based helpers to keep all button config in
    // one place, then pass each field to the FloatingToolbarButton React component
    // the same way the Toolbar's own `case 'button':` branch does it.
    const rovoDescriptor = $bcebd4bbcac9e623$export$f871051616837c84({
        api: api,
        aiGlobalOptIn: aiGlobalOptIn,
        disabled: disabled,
        has3pSources: metadata.has3pSources,
        intl: intl,
        nodeType: nodeType,
        rangeBaseGenerate: rangeBaseGenerate,
        smartlinkName: metadata.smartlinkName,
        smartlinkUrl: smartlinkUrl,
        sourceProduct: metadata.sourceProduct,
        triggeredForMark: triggeredForMark
    });
    const summarizeDescriptor = $bcebd4bbcac9e623$export$90102ae51106249a({
        api: api,
        aiGlobalOptIn: aiGlobalOptIn,
        disabled: disabled,
        intl: intl,
        nodeType: nodeType,
        nodeRange: nodeRange,
        smartlinkUrl: smartlinkUrl,
        sourceProduct: metadata.sourceProduct,
        has3pSources: metadata.has3pSources,
        triggeredForMark: triggeredForMark
    });
    const dispatchCommand = (cmd)=>{
        cmd(view.state, view.dispatch, view);
    };
    const isSmartlinkToolbarV2ExpEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_smartlink_toolbar_v2_exp');
    const dropdownItems = isSmartlinkToolbarV2ExpEnabled ? (0, $05d8c4e6f1eb0d83$export$6ff0e2bc14bad0fc)({
        aiGlobalOptIn: aiGlobalOptIn,
        details: details,
        intl: intl,
        nodeType: nodeType,
        smartlinkUrl: smartlinkUrl,
        testIdPrefix: $bcebd4bbcac9e623$export$ef1d0b9899d7de5,
        triggeredForMark: triggeredForMark,
        view: view
    }) : [];
    const RovoIcon = rovoDescriptor.icon;
    const SummarizeButtonIcon = summarizeDescriptor.icon;
    const shouldShowDropdown = isSmartlinkToolbarV2ExpEnabled && dropdownItems.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        testId: rovoDescriptor.testId,
        title: rovoDescriptor.title,
        ariaLabel: rovoDescriptor.ariaLabel,
        tooltipContent: rovoDescriptor.tooltipContent,
        disabled: rovoDescriptor.disabled,
        icon: RovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RovoIcon, {
            label: ""
        }) : undefined,
        onMount: rovoDescriptor.onMount,
        onClick: ()=>dispatchCommand(rovoDescriptor.onClick)
    }, rovoDescriptor.showTitle && rovoDescriptor.title), shouldShowDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwf4Z.ToolbarDropdownMenuProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6nzD.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: "",
            size: "small"
        }),
        testId: `${$bcebd4bbcac9e623$export$ef1d0b9899d7de5}-smartlink-rovo-chevron`,
        isDisabled: disabled,
        label: intl.formatMessage((0, $7ZL6d.aiMessages).rovoToolbarDropdownChevronLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, dropdownItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
            key: item.testId,
            elemBefore: item.icon,
            isDisabled: disabled,
            onClick: item.onClick,
            testId: item.testId
        }, item.label))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hfky.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        testId: summarizeDescriptor.testId,
        title: summarizeDescriptor.title,
        ariaLabel: summarizeDescriptor.ariaLabel,
        tooltipContent: summarizeDescriptor.tooltipContent,
        disabled: summarizeDescriptor.disabled,
        icon: SummarizeButtonIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SummarizeButtonIcon, {
            label: ""
        }) : undefined,
        onMount: summarizeDescriptor.onMount,
        onClick: ()=>dispatchCommand(summarizeDescriptor.onClick)
    }, summarizeDescriptor.showTitle && summarizeDescriptor.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huoxr.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        fullHeight: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')
    }));
};
const $bcebd4bbcac9e623$var$SmartLinkAIButtonsRenderer = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, disabled: disabled, intl: intl, isHyperlink: isHyperlink, nodeType: nodeType, nodeRange: nodeRange, rangeBaseGenerate: rangeBaseGenerate, smartlinkUrl: smartlinkUrl, view: view })=>{
    const Component = $bcebd4bbcac9e623$var$isPasteActionsMenuV2Enabled() ? $bcebd4bbcac9e623$var$RefactoredSmartLinkAIButtonsRenderer : $bcebd4bbcac9e623$var$LegacySmartLinkAIButtonsRenderer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        api: api,
        aiGlobalOptIn: aiGlobalOptIn,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        disabled: disabled,
        intl: intl,
        isHyperlink: isHyperlink,
        nodeType: nodeType,
        nodeRange: nodeRange,
        rangeBaseGenerate: rangeBaseGenerate,
        smartlinkUrl: smartlinkUrl,
        view: view
    });
}; /**
    * Returns a FloatingToolbarCustom item that conditionally injects the SmartLink
    * Rovo button and Summarize button into the card floating toolbar — but only
    * when the SmartLink is in a 'resolved' state.
    *
    * The `type: 'custom'` item's `render` function runs inside React (called by
    * the Toolbar component in editor-plugin-floating-toolbar), so it is safe to
    * use React hooks inside SmartLinkAIButtonsRenderer. The resolved-state gate
    * therefore happens at React render time rather than at toolbar-config-build
    * time (which runs outside React in the FloatingToolbarHandler).
    *
    * `fallback: []` means nothing is shown if React hasn't mounted yet, matching
    * the pattern used by getAskRovoAiSplitButton in this file.
    */ 
const $bcebd4bbcac9e623$export$7ee1c1f7c78c3501 = ({ api: api, aiGlobalOptIn: aiGlobalOptIn, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, disabled: disabled, intl: intl, isHyperlink: isHyperlink, nodeType: nodeType, nodeRange: nodeRange, rangeBaseGenerate: rangeBaseGenerate, smartlinkUrl: smartlinkUrl })=>({
        type: 'custom',
        fallback: [],
        render: (view)=>{
            if (!view) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bcebd4bbcac9e623$var$SmartLinkAIButtonsRenderer, {
                view: view,
                intl: intl,
                api: api,
                aiGlobalOptIn: aiGlobalOptIn,
                isHyperlink: isHyperlink,
                smartlinkUrl: smartlinkUrl,
                nodeType: nodeType,
                nodeRange: nodeRange,
                rangeBaseGenerate: rangeBaseGenerate,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
                disabled: disabled
            });
        }
    });



const $98e7d47b5e3ff1fa$var$getAIButton = ({ intl: intl, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, nodeType: nodeType, disabled: disabled, api: api, state: state })=>{
    const isAIEnabled = aiGlobalOptIn.status === 'enabled';
    if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
        const handleAiButtonMount = ()=>{
            const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.selectionCharWordCount)(state);
            (0, $hZdqw.fireButtonViewedAnalyticsEvent)({
                api: api,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                attributes: {
                    selectionCharCount: charCount,
                    selectionWordCount: wordCount
                }
            });
        };
        return (0, $bcebd4bbcac9e623$export$a85fdf32e150e9f2)({
            intl: intl,
            rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: nodeType,
            disabled: disabled,
            editorPluginAIProvider: editorPluginAIProvider,
            api: api,
            onMount: handleAiButtonMount
        });
    }
    if (isAIEnabled && (0, $iDrrr.fg)('ai-smart-button-team-25') || (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $bcebd4bbcac9e623$export$b8d5d3cc3902e265)({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: nodeType,
        disabled: disabled
    });
    return (0, $bcebd4bbcac9e623$export$a3e7258dd93ab690)({
        intl: intl,
        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
        hideTitle: true,
        aiGlobalOptIn: aiGlobalOptIn,
        triggeredFor: nodeType,
        disabled: disabled
    });
};
const $98e7d47b5e3ff1fa$export$add2b8f99d5aac = ({ aiGlobalOptIn: aiGlobalOptIn, editorPluginAIProvider: editorPluginAIProvider, api: api })=>// eslint-disable-next-line @typescript-eslint/max-params
    (state, intl, _providerFactory, processedConfigs)=>{
        const aiDecorationPluginState = (0, $9RRio.aiExperienceDecorationPluginKey).getState(state);
        const aiModalDecorationSet = aiDecorationPluginState?.modalDecorationSet ?? (0, $8nvEM.DecorationSet).empty;
        const isAIModalOpen = aiModalDecorationSet !== (0, $8nvEM.DecorationSet).empty;
        if (isAIModalOpen && editorPluginAIProvider.isInDocumentStreamingEnabled) return {
            title: '',
            visible: false,
            items: [],
            nodeType: Object.values(state.schema.nodes).reduce((acc, cur)=>{
                if (cur.isBlock) acc.push(cur);
                return acc;
            }, [])
        };
        // Following line is to ensure that the inline suggestion toolbar is always shown when the AI modal is open
        const suggestionToolbar = (0, $cOvkw.InlineSuggestionToolbar).maybeBuild(state, api);
        if (suggestionToolbar) return suggestionToolbar;
        /**
   * Add AI button in nodes supported (currently only table is supported).
   * List of supported node can be found in implementation of getSupportedNodesForAIModal.
   */ const { selection: selection } = state;
        const { from: from, to: to } = selection;
        const isNodeSelection = selection instanceof (0, $kCECX.NodeSelection);
        const isCellSelection = selection.toJSON().type === 'cell';
        const getParentSupportedForAIButton = ()=>{
            const supportedNodesForAI = (0, $doWyc.getSupportedNodesForAIModal)(state);
            if (isNodeSelection) {
                if (!supportedNodesForAI.has(selection.node.type)) return undefined;
                const nodeFrom = selection.from;
                return {
                    node: selection.node,
                    from: nodeFrom,
                    to: nodeFrom + selection.node.nodeSize
                };
            } else {
                const parentNodeFindResult = (0, $bjg0G.findParentNode)((node)=>supportedNodesForAI.has(node.type))(selection);
                if (!parentNodeFindResult) return undefined;
                // `findParentNode` returns `pos` as the position *before* the node;
                // the node range therefore spans [pos, pos + nodeSize].
                return {
                    node: parentNodeFindResult.node,
                    from: parentNodeFindResult.pos,
                    to: parentNodeFindResult.pos + parentNodeFindResult.node.nodeSize
                };
            }
        };
        const disabled = (0, $6aeabd96dd732741$export$9db4ba93eaa44d11)(api);
        const parentSupportedForAIButtonInfo = getParentSupportedForAIButton();
        const parentSupportedForAIButton = parentSupportedForAIButtonInfo?.node;
        const isAIEnabled = aiGlobalOptIn.status === 'enabled';
        if ((from === to || isNodeSelection || isCellSelection) && parentSupportedForAIButton) {
            const canAddAIButton = isNodeSelection || parentSupportedForAIButton;
            const nodeType = parentSupportedForAIButton?.type;
            if (canAddAIButton && nodeType) {
                const aiIconButton = $98e7d47b5e3ff1fa$var$getAIButton({
                    intl: intl,
                    editorPluginAIProvider: editorPluginAIProvider,
                    aiGlobalOptIn: aiGlobalOptIn,
                    nodeType: nodeType,
                    disabled: disabled,
                    api: api,
                    state: state
                });
                const separator = {
                    type: 'separator',
                    fullHeight: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')
                };
                const addAIButtonToConfig = (title)=>{
                    const toolbarConfig = processedConfigs?.find((config)=>config.title === title);
                    const items = Array.isArray(toolbarConfig?.items) ? toolbarConfig?.items : [];
                    if (toolbarConfig && items.length) {
                        const withAIItems = isAIEnabled && (0, $iDrrr.fg)('ai-smart-button-team-25') || (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? [
                            aiIconButton,
                            separator,
                            ...items
                        ] : [
                            ...items.slice(0, items.length - 3),
                            aiIconButton,
                            separator,
                            ...items.slice(items.length - 3, items.length)
                        ];
                        /**
           * Updating items of table, panel, layout or expand config item.
           * Injecting updated items in same config object.
           */ toolbarConfig.items = withAIItems;
                        return toolbarConfig;
                    }
                };
                /**
       * Here we are updating items of table, panel, expand, layout and card
       * 	floaingToolbarConfig.
       * This will only work when editor-plugin-ai is added after these plugins.
       * Proper solution will be implemented when outcome
       * 	of https://hello.atlassian.net/wiki/spaces/EDITOR/pages/4166466469/Editor+RFC+058+Easier+way+to+insert+items+in+floating+toolbar
       *  RFC is finalised.
       */ if (editorPluginAIProvider.product === 'CONFLUENCE' && (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)) {
                    const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
                    const isSmartLinkCardNode = (nodeType)=>nodeType === inlineCard || nodeType === blockCard || nodeType === embedCard;
                    const smartlinkUrl = typeof parentSupportedForAIButton?.attrs?.url === 'string' ? parentSupportedForAIButton.attrs.url : undefined;
                    if (smartlinkUrl && isAIEnabled && isSmartLinkCardNode(nodeType)) {
                        const cardConfig = processedConfigs?.find((config)=>{
                            const configNodeTypes = Array.isArray(config.nodeType) ? config.nodeType : [
                                config.nodeType
                            ];
                            return configNodeTypes.some((nt)=>isSmartLinkCardNode(nt));
                        });
                        if (cardConfig) {
                            // When the SmartLink is not yet resolved the renderer returns null
                            // and no AI buttons or separator appear.
                            const smartLinkAIButtons = (0, $bcebd4bbcac9e623$export$7ee1c1f7c78c3501)({
                                api: api,
                                aiGlobalOptIn: aiGlobalOptIn,
                                areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)),
                                disabled: disabled,
                                intl: intl,
                                nodeType: nodeType,
                                // Anchor downstream actions (e.g. Summarize) against the actual
                                // smartlink node range — the toolbar is shown for *this* node,
                                // which isn't necessarily the current text selection (e.g. when
                                // the toolbar appears via hover/focus).
                                nodeRange: parentSupportedForAIButtonInfo ? {
                                    from: parentSupportedForAIButtonInfo.from,
                                    to: parentSupportedForAIButtonInfo.to
                                } : undefined,
                                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                                smartlinkUrl: smartlinkUrl
                            });
                            if (!smartLinkAIButtons) return cardConfig;
                            const prependButton = (existingItems)=>[
                                    smartLinkAIButtons,
                                    ...existingItems
                                ];
                            if (typeof cardConfig.items === 'function') {
                                const originalItemsFn = cardConfig.items;
                                // when 'Edit link' is active, the card plugin returns a single item (the link
                                // picker). in that case we don't need to prepend AI buttons
                                cardConfig.items = (node)=>{
                                    const resolvedItems = originalItemsFn(node);
                                    return resolvedItems.length > 1 ? prependButton(resolvedItems) : resolvedItems;
                                };
                            } else if (Array.isArray(cardConfig.items) && cardConfig.items.length) cardConfig.items = prependButton(cardConfig.items);
                            return cardConfig;
                        }
                    }
                }
                if (!editorPluginAIProvider.isInDocumentStreamingEnabled) return addAIButtonToConfig('Table floating controls');
            }
        }
        // Plain hyperlink support: detect link marks at the cursor position
        // and inject AI buttons into the hyperlink floating toolbar.
        // Hyperlinks are marks on text nodes, not standalone nodes, so they
        // aren't in getSupportedNodesForAIModal and are handled separately.
        // Allow hyperlink handling when there is no supported parent node, or when the
        // parent is a table (hyperlinks can exist inside table cells). SmartLink card
        // nodes are handled earlier in this function and must not re-enter here.
        const parentIsTable = parentSupportedForAIButton?.type === state.schema.nodes.table;
        if (from === to && (!parentSupportedForAIButton || parentIsTable) && isAIEnabled && editorPluginAIProvider.product === 'CONFLUENCE' && (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)) {
            const linkAtCursor = (0, $doWyc.getLinkMarkAtCursor)(state, from);
            const hyperlinkUrl = linkAtCursor?.url;
            if (hyperlinkUrl && linkAtCursor?.parentNode) {
                const hyperlinkConfig = processedConfigs?.find((config)=>{
                    const nodeTypes = Array.isArray(config.nodeType) ? config.nodeType : [
                        config.nodeType
                    ];
                    return nodeTypes.includes(linkAtCursor.parentNode.type);
                });
                if (hyperlinkConfig) {
                    const smartLinkAIButtons = (0, $bcebd4bbcac9e623$export$7ee1c1f7c78c3501)({
                        api: api,
                        aiGlobalOptIn: aiGlobalOptIn,
                        areAnyNewToolbarFlagsEnabled: (0, $g6uqx.areToolbarFlagsEnabled)(Boolean(api?.toolbar)),
                        disabled: disabled,
                        intl: intl,
                        isHyperlink: true,
                        nodeType: linkAtCursor.parentNode.type,
                        // Anchor downstream actions against the link mark's range, not
                        // the current text selection — the toolbar follows the link mark.
                        nodeRange: linkAtCursor.markRange,
                        rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                        smartlinkUrl: hyperlinkUrl
                    });
                    if (!smartLinkAIButtons) return hyperlinkConfig;
                    const prependButton = (existingItems)=>[
                            smartLinkAIButtons,
                            ...existingItems
                        ];
                    if (Array.isArray(hyperlinkConfig.items) && hyperlinkConfig.items.length > 1) // EDIT mode has multiple toolbar items; INSERT/EDIT_INSERTED mode has
                    // a single custom item (the link picker). Only prepend in EDIT mode.
                    hyperlinkConfig.items = prependButton(hyperlinkConfig.items);
                    return hyperlinkConfig;
                }
            }
        }
        return;
    };






var $4Qu9h = parcelRequire("4Qu9h");




/* AtlassianIntelligenceToolbarButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $aiL0G = parcelRequire("aiL0G");





var $5aXzT = parcelRequire("5aXzT");


var $ldbHR = parcelRequire("ldbHR");










const $c8bf2b5132f0d901$export$cf19468c196a204d = (ButtonWrapper)=>{
    const [toolbarMutationCount, setToolbarMutationCount] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        if (!ButtonWrapper) return;
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                const { addedNodes: addedNodes, removedNodes: removedNodes } = mutation;
                // This was required when enrolling this package into JFE local consumption
                const isRelevantMutation = [
                    ...addedNodes,
                    ...removedNodes
                ].some((node)=>node.nodeType === 1 && node.nodeName === 'DIV');
                if (isRelevantMutation) setToolbarMutationCount(toolbarMutationCount + 1);
            });
        });
        const mainToolBar = document.querySelector(`[data-testid="ak-editor-main-toolbar"]`);
        if (mainToolBar) observer.observe(mainToolBar, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        toolbarMutationCount,
        ButtonWrapper
    ]);
    return toolbarMutationCount;
};


const $437a2553f3ac8a35$var$rovoIconContainerStyle = null;
const $437a2553f3ac8a35$var$wrapperStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $437a2553f3ac8a35$var$wrapperStylesUnbounded = null; // This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $437a2553f3ac8a35$var$AI_BUTTON_WIDTH_BREAKPOINT = 1076;
const $437a2553f3ac8a35$var$shouldShowSeparator = (node)=>{
    if (!node) return false;
     // NOTE: Compiled CSS results in the previous sibling being a style tag rather then what was previously expected to be
    // another span/div tag. This is a temporary fix to ensure the separator is shown correctly.
    // As noted in the SSR compiled doco here (https://compiledcssinjs.com/docs/server-side-rendering) style elements are
    // inlined in the dom markup.
    const element = node.previousElementSibling?.tagName === 'STYLE' ? node.previousElementSibling?.previousElementSibling : node.previousElementSibling;
    const prevSeparator = element?.querySelector(`:scope > span:last-child:empty`);
    const prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
    return !prevSeparatorVisible;
};
const $437a2553f3ac8a35$var$WriteAIButton = ({ api: api, onClick: onClick, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = formatMessage((0, $flbIU.default).aiUniversalDescriptor);
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const shouldShowLabel = width ? width >= $437a2553f3ac8a35$var$AI_BUTTON_WIDTH_BREAKPOINT : true;
    return /*#__PURE__*/ $cozmU.createElement((0, $ldbHR.default), {
        onClick: onClick,
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).AI,
        "aria-label": title,
        testId: "atlassian-intelligence-toolbar-button",
        title: title,
        iconBefore: /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_4ouGXIey7F _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $5VSNw.AIChatIcon), {
            label: "atlassian-intelligence-toolbar-button-icon"
        })),
        disabled: isDisabled
    }, shouldShowLabel && formatMessage((0, $flbIU.default).aiUniversalShortCallToAction));
};
const $437a2553f3ac8a35$export$d680bd36e1545039 = ({ onClick: onClick, disabled: disabled, ButtonWrapper: ButtonWrapper, api: api, view: view })=>{
    const [showSeparator, setShowSeperator] = (0, $cozmU.useState)(false);
    const callbackRef = (node)=>{
        const result = $437a2553f3ac8a35$var$shouldShowSeparator(node);
        setShowSeperator(result);
    };
    const aiButton = /*#__PURE__*/ $cozmU.createElement($437a2553f3ac8a35$var$WriteAIButton, {
        api: api,
        view: view,
        onClick: onClick,
        isDisabled: disabled
    });
    const toolbarMutationCount = (0, $c8bf2b5132f0d901$export$cf19468c196a204d)(ButtonWrapper);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        ref: callbackRef,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _2XsHFMdnbC _4ouGXIIZbP",
            "_1Fbn34Q4SZ _4zT8tSQ4SZ _4EWkALQ4SZ _3qgovSYbGa _3azl20YbGa"
        ])
    }, showSeparator && /*#__PURE__*/ $cozmU.createElement((0, $5aXzT.ToolbarSeparator), null), ButtonWrapper ? /*#__PURE__*/ $cozmU.createElement(ButtonWrapper, {
        key: `${toolbarMutationCount}-key-wrapper`
    }, aiButton) : aiButton);
};



const $ebb8ba60d451c990$var$PrimaryToolbarComponent = ({ editorView: editorView, api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, disabled: disabled })=>{
    const aiButtonState = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'aiExperience.aiButtonState');
    const isAiEntryPointDisabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const onClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        const configItem = editorPluginAIProvider.baseGenerate;
        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: aiButtonState?.triggeredFor
        });
        openAIModalCommand(state, dispatch);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $437a2553f3ac8a35$export$d680bd36e1545039), {
        api: api,
        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
        onClick: onClick,
        disabled: disabled || isAiEntryPointDisabled || !aiButtonState?.isSelectionValidForAIExperience,
        view: editorView
    });
};
const $ebb8ba60d451c990$export$1867437946169f9f = ({ api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>({ editorView: editorView, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebb8ba60d451c990$var$PrimaryToolbarComponent, {
            editorView: editorView,
            api: api,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn,
            disabled: disabled
        });
    };













const $c3203dd2c1d7fba4$var$PrimaryToolbarLegacyComponent = ({ api: api, editorView: editorView, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>{
    const aiButtonState = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'aiExperience.aiButtonState');
    const isAiEntryPointDisabled = (0, $6aeabd96dd732741$export$1698a5865a7021f3)(api);
    const onClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        const configItem = editorPluginAIProvider.baseGenerate;
        const openAIModalCommand = (0, $4TgUg.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'mainToolbar',
            aiGlobalOptIn: aiGlobalOptIn,
            triggeredFor: aiButtonState?.triggeredFor
        });
        openAIModalCommand(state, dispatch);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $437a2553f3ac8a35$export$d680bd36e1545039), {
        ButtonWrapper: editorPluginAIProvider?.AIButtonWrapper,
        onClick: onClick,
        disabled: isAiEntryPointDisabled || !aiButtonState?.isSelectionValidForAIExperience,
        view: editorView
    });
};
const $c3203dd2c1d7fba4$export$d26e7f34c50ada62 = ({ api: api, editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn })=>({ editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3203dd2c1d7fba4$var$PrimaryToolbarLegacyComponent, {
            api: api,
            editorView: editorView,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiGlobalOptIn
        });
    };



















const $b17ad13bcbcb2df1$export$50f5e6709d50619a = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn, api: api })=>(state, intl)=>{
        if (editorPluginAIProvider.disableAISelectionToolbar) return;
        const disabled = (0, $6aeabd96dd732741$export$9db4ba93eaa44d11)(api);
        const isAiButtonPulse = api?.engagementPlatform?.sharedState.currentState()?.messageStates['cc-editor-ai_ai-toolbar-button-pulse'];
        const handleAiButtonMount = ()=>{
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
                const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.selectionCharWordCount)(state);
                (0, $hZdqw.fireButtonViewedAnalyticsEvent)({
                    api: api,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_ASK_ROVO_BUTTON,
                    attributes: {
                        selectionCharCount: charCount,
                        selectionWordCount: wordCount
                    }
                });
            }
            // Multiple calls to startMessage with the same message key will not result in multiple messages being shown.
            // That's why we can call it here without worrying about it being called multiple times.
            api?.engagementPlatform?.actions.startMessage('cc-editor-ai_ai-toolbar-button-pulse');
        };
        let handleImproveWritingButtonMount;
        if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
            const { charCount: charCount, wordCount: wordCount } = (0, $hZdqw.selectionCharWordCount)(state);
            handleImproveWritingButtonMount = ()=>{
                (0, $hZdqw.fireButtonViewedAnalyticsEvent)({
                    api: api,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_HERO_PROMPT_BUTTON,
                    attributes: {
                        selectionCharCount: charCount,
                        selectionWordCount: wordCount
                    }
                });
            };
        }
        const improveWritingBtn = (0, $bcebd4bbcac9e623$export$c93a3969a7894772)({
            intl: intl,
            hideTitle: false,
            aiGlobalOptIn: aiGlobalOptIn,
            disabled: disabled,
            onMount: handleImproveWritingButtonMount,
            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
        });
        if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
            const aIButton = (0, $bcebd4bbcac9e623$export$a85fdf32e150e9f2)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                aiGlobalOptIn: aiGlobalOptIn,
                disabled: disabled,
                editorPluginAIProvider: editorPluginAIProvider,
                api: api,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount
            });
            return {
                rank: 10,
                isToolbarAbove: true,
                items: [
                    aIButton,
                    improveWritingBtn
                ]
            };
        }
        if ((0, $iDrrr.fg)('ai-smart-button-team-25') || (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) {
            const askAIButton = (0, $bcebd4bbcac9e623$export$b8d5d3cc3902e265)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                aiGlobalOptIn: aiGlobalOptIn,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount,
                disabled: disabled
            });
            const separator = {
                type: 'separator',
                fullHeight: true
            };
            /**
			 * We want to show AI button on left most side of floating toolbar.
			 * Higher the rank, the more left it will be.
			 * We are setting rank to 10 to show AI button on left most side.
			 */ return {
                rank: 10,
                isToolbarAbove: true,
                items: [
                    improveWritingBtn,
                    askAIButton,
                    ...(0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? [
                        separator
                    ] : []
                ]
            };
        } else {
            const aiExperienceBtn = (0, $bcebd4bbcac9e623$export$a3e7258dd93ab690)({
                intl: intl,
                rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                hideTitle: true,
                aiGlobalOptIn: aiGlobalOptIn,
                title: (0, $7ZL6d.aiMessages).tryAIToolbarIconTitle,
                tooltip: (0, $7ZL6d.aiMessages).tryAIToolbarIconTooltip,
                pulse: isAiButtonPulse,
                onMount: handleAiButtonMount,
                disabled: disabled
            });
            return {
                rank: -10,
                isToolbarAbove: true,
                items: [
                    improveWritingBtn,
                    aiExperienceBtn
                ]
            };
        }
    };





// eslint-disable-next-line @typescript-eslint/consistent-type-imports



// eslint-disable-next-line @typescript-eslint/consistent-type-imports



const $935d0249792d789f$export$da9fe52c4382b67d = (0, $cgKJK.createMachine)({
    /** @xstate-layout N4IgpgJg5mDOIC5QFEIEsAuB7ATgBQBsBXKNAOwEEBJAYgGUAVCgJQYH1q3kANPZZqsgByAYWQBtAAwBdRKAAOWWJjRYyckAA9EAWgCMkgKwAOAHQBmAEzHJAFmOWrtgGx7LAGhABPXc9OWATlsAdj1zY2cAy2dDMOMAX3jPVExcQhJyalNqAAIAWSwIAEMCHKKAYww0ADcwGk4RAHkhBmF2KiE6flaAESlZJBBFZSq1DW0EHXtg0z1bEODDcwDJZ0tDTx8EPWMzG0t14xMdw0MYxOT0bHxiUkoqbKp8wpKyypq6vMaeigAZNh6VDoIhYPWQfRkGmGKjGgwmOmCtkM-ii6xMKyRRk2uj0zhmlkkK0swRW5nCkiMFxAKWu6TuWVyBWKpQqVVqNC+P3+HQAan8qD9ev0oUoYeo4bpzCZTMFzLY9EtjMFic5drZsZM9FFZrtLEjlUjzJFnFSaWlbpkHrkRGoMGAyBgcgAJNBQAAWBFdbrtEHoyF+yBEDCozTYIidFCEAHFwcLBtDRuLQBN7KYzs41qtJNYAgEMxr9HoZWtbOZJFLVnLYsFEkkQGRCnANGabhl7iKRqok1ocQY-FYbPZHHrXB5vL5s6Y8UFgs5bI4DAk6y26ZbTEIsDlcmBNPIwDg0PbymA3mywB2xeNfLj-MFFkrjCs1htx5Nln49CSXEsAm5c7ZTSuc02wZJ4mVeVkPgvRMr0mVw-GJe9gkfVZ1g1ZxzBlAJFkMQIkSiZxJBrZcgNbekrSeG0HXtR0XXdT13R9aCu1gnR4NvWcwnlAlcT0DVoksUwHEkT9Vi1O9sPMWt4iAA */ id: 'EditorPluginAI',
    description: `This machine models the high level functionality of the EditorPluginAI.

Currently this logic is split across prosemirror, xstate, and elsewhere.

The intention is to migrate to a single source of truth, backed by a state machine.`,
    states: {
        'No AI experience active': {
            description: `When an Editor is first started up with an editor-plugin-ai EditorPlugin - it will start in this state.

This state will be returned to when an ai experience is either discarded or completed.`
        },
        'AI Modal active': {
            on: {
                AI_CONTENT_INSERTED: 'AI Content Highlighted',
                MODAL_DISCARDED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when a user makes an explicit decision to clear the modal.`
                },
                MODAL_INVALIDATED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when an AI experience is ended due to the modal no longer being valid.

For example, if it's been linked to a selection, and another user collaborating on the document deletes the selected content.

In future we might expect this to go to an alternate state.`
                }
            },
            description: `Currently there is a seperate xstate state machine which is run when the ai modal is active.
Over time we can expect to link these state machines.`
        },
        'AI Content Highlighted': {
            on: {
                SELECTION_CHANGED: {
                    target: 'No AI experience active',
                    description: `This transition models when a user interacts with a document following the insertion of content via AI.`
                }
            },
            description: `Following content being inserted, the inserted content is highlighted so the user is able to understand the impact of inserting the generated content into the document.

This highlight is persisted either until the user changes makes a selection change in the document or the content is removed from the document (ie. via collab editing sessions)`
        }
    },
    on: {
        START_AI_EXPERIENCE: {
            target: '#EditorPluginAI.AI Modal active',
            description: `We expect AI Experiences to be started in a variety of ways including;
- via the slash command/typeahead
- via the toolbar quick insert menu
- via the toolbar ai button
- via external actions (ie. atlas have a button outside the editor which starts an ai experience)

Only one AI experience can be active at a single time in an Editor.  If another AI experience is active when the user starts a new AI experience, the prior experience is replaced/reset with the new experience details.`
        }
    },
    initial: 'No AI experience active'
});


/**
 * Weakmap cache for caching an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
 * per EditorView.
 *
 * It contains a convenience function for returning an actor if it exists in the cache (`getActor`)
 */ class $c6ad19d1da9c8f1d$var$AIActorCache extends WeakMap {
    /**
   * Returns an actor if it exists in the cache or creates and starts a new one.
   *
   * @param editorView
   * @returns [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
   */ getActor(editorView) {
        if (this.has(editorView)) return this.get(editorView);
        const editorPluginAIActor = (0, $cgKJK.createActor)((0, $935d0249792d789f$export$da9fe52c4382b67d));
        editorPluginAIActor.start();
        $c6ad19d1da9c8f1d$export$eca6b7572eaa53aa.set(editorView, editorPluginAIActor);
        return editorPluginAIActor;
    }
}
const $c6ad19d1da9c8f1d$export$eca6b7572eaa53aa = new $c6ad19d1da9c8f1d$var$AIActorCache();



/**
 * Bridges the SmartCard React context into plugin-registration code.
 * `isAsyncHidden` runs outside of React (registered once at plugin init),
 * so it cannot call hooks. This component keeps a mutable ref up-to-date
 * so the async check can reach `client.fetchData` without needing context access.
 */ const $96fe6c416d971b16$var$SmartCardClientSync = ({ clientRef: clientRef })=>{
    const smartCardContext = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    (0, $cozmU.useEffect)(()=>{
        clientRef.current = smartCardContext?.connections?.client;
    }, [
        clientRef,
        smartCardContext?.connections?.client
    ]);
    return null;
};
const $96fe6c416d971b16$export$7825a101a7e6b70b = ({ config: config, api: api })=>{
    const editorPluginAIProvider = config;
    const aiGlobalOptIn = config.aiGlobalOptIn;
    let editorView;
    let insertedContentNodeTransformer;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    // Determine wehther or not a preview modal will be shown, if it is then the user must manually accept/reject the changes.
    // if canInlineStreamChanges() => true, then the preview will not be shown and the changes will be applied automatically
    // If the canInlineStreamChanges() => false, then the changes will not be applied automatically, and the user will have to accept/reject the changes.
    const canInlineStreamChanges = ()=>{
        // The plugin can be passed a user prefs callback which could contain a setting which would disable in-document streaming.
        // We will default to true if this setting is not provided.
        const { isInDocumentStreamingAllowed: isInDocumentStreamingAllowed = true } = editorPluginAIProvider?.getUserPreferences?.() ?? {};
        return(// We only allow auto-accepting AI changes if the in-document streaming feature flag is enabled
        !!editorPluginAIProvider.isInDocumentStreamingEnabled && isInDocumentStreamingAllowed);
    };
    let providerFactory;
    const setProviderFactory = (newProviderFactory)=>{
        providerFactory = newProviderFactory;
    };
    let mentionProvider;
    let analyticsBridgeRef = null;
    /**
   * Helper function to retrieve the name details for a mention from the mentionProvider
   * @param id - The mention ID to resolve
   * @returns The mention name details or undefined if not found
   * @example
   * ```ts
   * const mentionDetails = await getMentionNameDetails('user-123');
   * ```
   */ const getMentionNameDetails = async (id)=>{
        if (!mentionProvider || !(0, $cRgxl.isResolvingMentionProvider)(mentionProvider)) return;
        const nameDetails = mentionProvider.resolveMentionName(id);
        if ((0, $cLgZp.isPromise)(nameDetails)) {
            const mention = await nameDetails;
            return mention;
        }
        return nameDetails;
    };
    const setMentionProvider = ()=>{
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                mentionProvider = provider;
                providerFactory.unsubscribe('mentionProvider', handler);
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    };
    const setMediaProvider = ()=>{
        if (editorPluginAIProvider?.providers?.mediaProvider) providerFactory.setProvider('mediaProvider', Promise.resolve(editorPluginAIProvider.providers.mediaProvider));
    };
    const setEmojiProvider = ()=>{
        const { emojiProvider: emojiProvider } = api?.emoji?.sharedState.currentState() || {};
        if (!!emojiProvider) providerFactory.setProvider('emojiProvider', Promise.resolve(emojiProvider));
        else {
            const unsub = api?.emoji?.sharedState.onChange((sharedState)=>{
                if (!!sharedState.nextSharedState?.emojiProvider) {
                    providerFactory.setProvider('emojiProvider', Promise.resolve(sharedState.nextSharedState.emojiProvider));
                    unsub?.();
                }
            });
        }
    };
    const setExtensionProvider = ()=>{
        const { extensionProvider: extensionProvider } = api?.extension?.sharedState.currentState() || {};
        if (!!extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
        else {
            const unsub = api?.extension?.sharedState.onChange((sharedState)=>{
                if (!!sharedState.nextSharedState?.extensionProvider) {
                    providerFactory.setProvider('extensionProvider', Promise.resolve(sharedState.nextSharedState.extensionProvider));
                    unsub?.();
                }
            });
        }
    };
    const aiOptIn = aiGlobalOptIn || {
        status: 'enabled',
        triggerOptInFlow: ()=>{}
    };
    const isFullEditorAIExperience = editorPluginAIProvider.experienceMode !== 'streaming-only';
    const isRovoAvailable = editorPluginAIProvider.isRovoEnabled === true || editorPluginAIProvider.aiGlobalOptIn?.status === 'disabled-opt-in';
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    const quickInsert = (intl)=>{
        if ((0, $6aeabd96dd732741$export$9db4ba93eaa44d11)(api)) return [];
        const configItems = [];
        if (!editorPluginAIProvider.disableQuickInsert) {
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
                if (isRovoAvailable) configItems.push(editorPluginAIProvider.baseGenerate);
            } else configItems.push(...isRovoAvailable ? [
                editorPluginAIProvider.baseGenerate
            ] : [], ...(0, $c2c6d211a4290fa3$export$2dd2807afbd4a532)({
                configItemWithOptions: editorPluginAIProvider.configItemWithOptions,
                // The editor view will always be available when quick insert items are being created
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                editorView: editorView,
                positions: [
                    0,
                    0
                ],
                isEmpty: true
            }));
        }
        const quickInsertItems = (0, $70f7b3d6cdb6c831$export$f3e5bb240cf24df5)({
            configItems: configItems,
            formatMessage: intl.formatMessage,
            aiGlobalOptIn: aiOptIn,
            // The editor view will always be available when quick insert items are being created
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            editorView: editorView,
            locale: intl.locale
        });
        return quickInsertItems;
    };
    quickInsert.disableMemo = true;
    if (isFullEditorAIExperience && !editorPluginAIProvider.disableQuickInsert && isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $e1bc3d5de5289282$export$c65b56a2d1ac69f4)({
        aiGlobalOptIn: aiOptIn,
        api: api,
        editorPluginAIProvider: editorPluginAIProvider,
        getEditorView: ()=>editorView,
        isRovoAvailable: isRovoAvailable
    }));
    if (isFullEditorAIExperience && isToolbarAIFCEnabled) {
        const shouldShowImproveDescription = config.configItemWithOptions?.[0]?.config?.key === (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE;
        api?.toolbar?.actions.registerComponents((0, $09278ecf5feb6845$export$611b6feb29f5c606)({
            aiGlobalOptIn: aiOptIn,
            editorPluginAIProvider: editorPluginAIProvider,
            shouldShowImproveDescription: shouldShowImproveDescription,
            getAdditionalProps: config.getAdditionalProps,
            isNewToolbarEnabled: true,
            api: api,
            isRovoAvailable: isRovoAvailable
        }));
    } else if (isFullEditorAIExperience) {
        if (!editorPluginAIProvider?.hidePrimaryToolbarButton) api?.primaryToolbar?.actions.registerComponent({
            name: 'aiExperience',
            component: (0, $ebb8ba60d451c990$export$1867437946169f9f)({
                api: api,
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiOptIn
            })
        });
    }
    if (isFullEditorAIExperience && (0, $iDrrr.fg)('platform_editor_ai_in_blockmenu')) api?.blockMenu?.actions.registerBlockMenuComponents((0, $03b808db02c518a3$export$98bff0351f0b74a8)({
        editorPluginAIProvider: editorPluginAIProvider,
        getEditorView: ()=>editorView,
        api: api
    }));
    // Tracks the live editor appearance so paste-menu rules can read it lazily.
    // Updated on every contentComponent render (which the framework calls whenever
    // appearance changes) so no product plumbing is needed.
    let currentAppearance;
    // Use a ref to store the client as SmartCardContext is only available on through hooks
    // 		and this plugin is outside of a React component.
    const aiSmartCardClientRef = {
        current: undefined
    };
    const shouldRegisterAIPasteMenu = editorPluginAIProvider?.isInDocumentStreamingEnabled && isFullEditorAIExperience && (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true);
    if (shouldRegisterAIPasteMenu) api?.uiControlRegistry?.actions.register((0, $de6b53764cd2bd07$export$28b4a677d2c0d8b0)({
        aiGlobalOptIn: aiOptIn,
        api: api,
        getAppearance: ()=>currentAppearance ?? api?.core?.sharedState.currentState()?.appearance,
        product: editorPluginAIProvider.product,
        smartCardClientRef: aiSmartCardClientRef
    }));
    return {
        name: 'aiExperience',
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'ai-content-state',
                    plugin: ()=>(0, $f22a2fd66e11ba7d$export$ea83d625c73fdf28)(editorPluginAIProvider.initialConsumerEmptyStateOverride)
                },
                {
                    name: 'ai-experience-actor',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // This sets up an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api) using
                                // the editor-plugin-ai machine and starts it up.
                                const editorPluginAIActor = (0, $c6ad19d1da9c8f1d$export$eca6b7572eaa53aa).getActor(editorView);
                                return {
                                    destroy: ()=>{
                                        // This cleansup any listeners from the actor -- to ensure we don't leak memory.
                                        editorPluginAIActor?.stop();
                                        (0, $c6ad19d1da9c8f1d$export$eca6b7572eaa53aa).delete(editorView);
                                    }
                                };
                            }
                        })
                },
                {
                    name: 'aiExperience',
                    plugin: (options)=>{
                        const payload = {
                            action: 'init',
                            actionSubject: 'editor',
                            actionSubjectId: 'editorPluginAI',
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                            attributes: {
                                aiGlobalOptIn: aiOptIn?.status
                            }
                        };
                        // @ts-expect-error - This prevent type errors when trying to pass EditorPluginAI payload to AnalyticsEventPayload
                        options.dispatchAnalyticsEvent(payload);
                        return (0, $a9142d93e9fc312b$export$f99722d744184238)({
                            dispatchAnalyticsEvent: options.dispatchAnalyticsEvent,
                            dispatch: options.dispatch,
                            api: api,
                            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
                            product: editorPluginAIProvider.product
                        });
                    }
                },
                {
                    name: 'ai-experience-get-editor-view-and-provider-factory',
                    plugin: (options)=>{
                        setProviderFactory(options.providerFactory);
                        setMentionProvider();
                        setMediaProvider();
                        setEmojiProvider();
                        setExtensionProvider();
                        return (0, $101eec5f5ca79486$export$3de1ac9a9cd13933)({
                            setEditorView: setEditorView
                        });
                    }
                }
            ];
            if (isFullEditorAIExperience) plugins.push({
                name: 'ai-experience-ai-button',
                plugin: ()=>(0, $8c69998779abdc50$export$e65c99dea6a50353)()
            }, {
                name: 'ai-experience-selection-preview',
                plugin: ()=>(0, $6e58fac223e0c052$export$6b0a857b1a5189ef)()
            });
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) plugins.push({
                name: 'ai-session-context',
                plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $e9cb9bc0694dd877$export$3332615281a18d68)({
                        aiGlobalOptIn: aiOptIn,
                        api: api,
                        dispatch: dispatch,
                        editorPluginAIProvider: editorPluginAIProvider,
                        getIntl: getIntl,
                        getMentionNameDetails: getMentionNameDetails
                    })
            });
            if (isFullEditorAIExperience && (editorPluginAIProvider.product === 'CONFLUENCE' || editorPluginAIProvider.product === 'JSW' || editorPluginAIProvider.product === 'JSM' || editorPluginAIProvider.product === 'JPD' || editorPluginAIProvider.product === 'JWM')) plugins.push({
                name: 'inline-suggestions',
                plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $96fc14b0015074c7$export$21cd6432d1e2d949)({
                        dispatch: dispatch,
                        getIntl: getIntl,
                        api: api
                    })
            });
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) plugins.push({
                name: 'ai-experience-placeholder-controller',
                plugin: ()=>(0, $b75e4d94e782c254$export$1d8514938d526e53)({
                        api: api,
                        editorPluginAIProvider: editorPluginAIProvider
                    })
            });
            plugins.push({
                name: 'ai-event-hub',
                plugin: ({ getIntl: getIntl })=>(0, $5f01bebad4249f05$export$c83eff15443f700)({
                        aiGlobalOptIn: aiOptIn,
                        editorPluginAIProvider: editorPluginAIProvider,
                        getIntl: getIntl,
                        api: api
                    })
            });
            if (isFullEditorAIExperience && editorPluginAIProvider.isRovoEnabled) {
                plugins.push({
                    name: 'editor-ai-rovo-agents',
                    plugin: (options)=>(0, $6809914780b67d19$export$c72f28d9e4137cea)(options)
                });
                plugins.push({
                    name: 'ai-experience-selection',
                    plugin: ()=>(0, $83c9b92eeb72de8f$export$adbe0f8e0f3704d5)({
                            api: api,
                            editorPluginAIProvider: editorPluginAIProvider
                        })
                });
            }
            if (editorPluginAIProvider.auditLogSettings && editorPluginAIProvider.auditLogSettings.enabled && (0, $iDrrr.fg)('platform_editor_ai_audit_logs_events')) {
                const eventData = editorPluginAIProvider.auditLogSettings.eventData;
                plugins.push({
                    name: 'ai-audit-log',
                    plugin: ({ dispatch: dispatch })=>(0, $b9fd7a60437115d0$export$b07b9a8a474c46fb)({
                            dispatch: dispatch,
                            eventData: eventData
                        })
                });
            }
            const { aiSmartButtonOptions: aiSmartButtonOptions, dynamicSurfaceConfigItems: dynamicSurfaceConfigItems } = editorPluginAIProvider;
            if (isFullEditorAIExperience && aiSmartButtonOptions && dynamicSurfaceConfigItems && (0, $iDrrr.fg)('ai-smart-button-team-25')) plugins.push({
                name: 'ai-smart-button-api',
                plugin: ({ getIntl: getIntl, dispatch: dispatch })=>(0, $881b2dad70775fce$export$b43aba46e2a0894)({
                        aiGlobalOptIn: aiOptIn,
                        aiSmartButtonOptions: aiSmartButtonOptions,
                        api: api,
                        dispatch: dispatch,
                        dynamicSurfaceConfigItems: dynamicSurfaceConfigItems,
                        getIntl: getIntl,
                        product: editorPluginAIProvider.product,
                        getMentionNameDetails: getMentionNameDetails
                    })
            });
            if (isFullEditorAIExperience) plugins.push({
                name: 'ai-quickstart-command',
                plugin: ({ getIntl: getIntl })=>(0, $d9513de59461fceb$export$75dff2601176292f)({
                        aiGlobalOptIn: aiOptIn,
                        editorPluginAIProvider: editorPluginAIProvider,
                        getIntl: getIntl
                    })
            });
            if (editorPluginAIProvider.isInDocumentStreamingEnabled) {
                const canAutoAcceptAIChanges = canInlineStreamChanges();
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) plugins.push({
                    name: 'pure-pm-in-editor-direct-streaming',
                    plugin: ({ getIntl: getIntl, portalProviderAPI: portalProviderAPI })=>(0, $f09efb7a1015ceab$export$465eeb0611517dc)({
                            getIntl: getIntl,
                            api: api,
                            canAutoAcceptAIChanges: canAutoAcceptAIChanges,
                            getFireAnalyticsStep: ()=>analyticsBridgeRef?.current?.fireAnalyticsStep,
                            portalProviderAPI: portalProviderAPI,
                            streamingTelepointerIdentity: editorPluginAIProvider.streamingTelepointerIdentity
                        })
                });
                else plugins.push({
                    name: 'in-editor-direct-streaming',
                    plugin: ({ getIntl: getIntl, portalProviderAPI: portalProviderAPI })=>(0, $c64804cb1104031c$export$465eeb0611517dc)({
                            getIntl: getIntl,
                            api: api,
                            portalProviderAPI: portalProviderAPI,
                            streamingTelepointerIdentity: editorPluginAIProvider.streamingTelepointerIdentity
                        })
                });
                plugins.push({
                    name: 'ai-annotation-watchmen',
                    plugin: ()=>(0, $083f95bd26d6fd7e$export$120e869ffea6ac01)({
                            onAnnotationsRemoved: editorPluginAIProvider.onAnnotationsRemoved
                        })
                });
                plugins.push({
                    name: 'ai-monitor-watchmen',
                    plugin: ()=>(0, $f5926f9d1caeb928$export$d5f2dba636afec41)(api, canInlineStreamChanges)
                });
                if (isFullEditorAIExperience && editorPluginAIProvider.product === 'CONFLUENCE') /**
           * We don't want to show the space shortcut plugin if the user has opted out of AI
           * This will prevent admins who opted out of AI from triggering the opt in flow
           * with the space shortcut.
           */ {
                    if (aiOptIn?.status === 'enabled' && isRovoAvailable || !(0, $ieeJu.expValEquals)('platform_editor_ai_aifc_space_shortcut_patch', 'isEnabled', true)) plugins.push({
                        name: 'ai-space-shortcut',
                        plugin: ({ getIntl: getIntl })=>(0, $8d596894ab69be92$export$1f64fead470ce6a8)({
                                aiGlobalOptIn: aiOptIn,
                                editorPluginAIProvider: editorPluginAIProvider,
                                getIntl: getIntl
                            })
                    });
                }
                if (isFullEditorAIExperience && editorPluginAIProvider.enableQuickPrompt && ((0, $iDrrr.fg)('platform_editor_ai_quick_prompt_iw_cc_load_2') ? aiOptIn?.status === 'enabled' : true) && (0, $iDrrr.fg)('platform_editor_ai_quick_prompt_iw_cc_load')) plugins.push(...(0, $0aafbf03d0c51e63$export$4de7211890d36588)({
                    aiGlobalOptIn: aiOptIn,
                    api: api,
                    product: editorPluginAIProvider.product
                }));
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_ai_unified_post_apply_chrome') || (0, $4o0zT.isExperimentEnabled)('platform_editor_ai_streaming_ux_experience_m1')) plugins.push({
                    name: 'agent-edit-chrome',
                    plugin: ({ getIntl: getIntl, portalProviderAPI: portalProviderAPI })=>(0, $d438cc29b9191819$export$39ba843d91f15fab)({
                            api: api,
                            getIntl: getIntl,
                            portalProviderAPI: portalProviderAPI,
                            streamingTelepointerIdentity: editorPluginAIProvider.streamingTelepointerIdentity
                        })
                });
            }
            return plugins;
        },
        actions: {
            openAIModal: ({ invokedFrom: invokedFrom, configItem: configItem = editorPluginAIProvider.baseGenerate, withAcceptReject: withAcceptReject, withStreamingHighlight: withStreamingHighlight, skipSelectionHighlight: skipSelectionHighlight, hideLoadingScreen: hideLoadingScreen, traceId: traceId, singleInstrumentationId: singleInstrumentationId, isCreate: isCreate, promptVersion: promptVersion, userADFInput: userADFInput, overrideFromPos: overrideFromPos, overrideToPos: overrideToPos })=>{
                (0, $d07adef0b9b690ae$export$e49a2031d0d2ff07)({
                    invokedFrom: invokedFrom,
                    editorView: editorView,
                    aiOptIn: aiOptIn,
                    configItem: configItem,
                    withAcceptReject: withAcceptReject,
                    withStreamingHighlight: withStreamingHighlight,
                    skipSelectionHighlight: skipSelectionHighlight,
                    isExternal: true,
                    hideLoadingScreen: hideLoadingScreen,
                    traceId: traceId,
                    singleInstrumentationId: singleInstrumentationId,
                    isCreate: isCreate,
                    promptVersion: promptVersion,
                    userADFInput: userADFInput,
                    overrideFromPos: // Forward override positions so a resumed (aborted) tool call re-applies
                    // at its stored/mapped range, not the current selection / end of doc.
                    overrideFromPos,
                    overrideToPos: overrideToPos
                });
            },
            handleSkillSelected: (slashCommand, skill)=>{
                if (!editorView) return;
                (0, $d07adef0b9b690ae$export$e49a2031d0d2ff07)({
                    invokedFrom: 'quickInsert',
                    editorView: editorView,
                    aiOptIn: aiOptIn,
                    configItem: editorPluginAIProvider.baseGenerate,
                    isExternal: true,
                    userADFInput: (0, $8lhhf.createSkillAdf)(skill)
                });
            },
            endAIExperience: ()=>{
                (0, $d07adef0b9b690ae$export$eb7c7403500d1c40)({
                    editorView: editorView
                });
            },
            getAbortedToolCallPosition: (toolCallId)=>{
                if (!editorView) return undefined;
                const sessionState = (0, $iN8Pe.aiSessionContextPluginKey).getState(editorView.state);
                return sessionState?.abortedToolCallPositions?.[toolCallId];
            },
            clearAbortedToolCallPosition: (toolCallId)=>{
                if (!editorView) return;
                const command = (0, $7791c10173ad9c87$export$3e1e4ddb85f3729f)(toolCallId);
                const tr = command({
                    tr: editorView.state.tr
                });
                if (tr) editorView.dispatch(tr);
            },
            getAiExperienceActor: ()=>{
                if (!editorView) throw new Error('editorView is not defined');
                const actor = (0, $a0a3fae6bc11cee3$export$a6342417f9492df1).getActor(editorView);
                if (!actor) throw new Error('No cached item found');
                return actor;
            },
            getAISelectionContext: ()=>{
                const selection = api?.selection?.sharedState.currentState()?.selection;
                const selectionContent = selection?.content().content;
                const selectionFragment = api?.selection?.actions.getSelectionFragment() ?? null;
                const additionalNodeContext = api?.aiSelectionContext?.actions.getAdditionalContextForFragments(selectionFragment ?? []);
                return api?.aiExperience?.sharedState.currentState()?.selectionContext ?? {
                    selectionFragment: selectionFragment,
                    localIds: api?.selection?.actions.getSelectionLocalIds() ?? null,
                    selectionMarkdown: selectionContent ? (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
                        node: selectionContent
                    })?.markdown : null,
                    startIndex: selection?.$from.parentOffset ?? null,
                    endIndex: selection?.$to.parentOffset ?? null,
                    additionalNodeContext: additionalNodeContext
                };
            },
            getPartialDocumentFromSelection: (maxSize)=>{
                return (0, $d07adef0b9b690ae$export$cb4bd847e3d154fe)({
                    selection: editorView?.state.selection,
                    maxSize: maxSize
                });
            },
            getPartialMarkdownFromSelection: (maxSize)=>{
                return (0, $d07adef0b9b690ae$export$3e64d26c171d92fc)({
                    selection: editorView?.state.selection,
                    maxSize: maxSize
                });
            },
            getAskRovoFloatingToolbarButton: (options)=>{
                // We don't support ask rovo actions on other products just yet
                if (config.product.toLowerCase() !== 'confluence' && !(config.product.toLowerCase() === 'jsw' && [
                    'image',
                    'remix-app'
                ].includes(options.target ?? '') && (0, $iDrrr.fg)('platform_editor_maui_jira_updates_1')) && (0, $iDrrr.fg)('platform_editor_maui_jira_updates')) return undefined;
                return (0, $bcebd4bbcac9e623$export$b8d5d3cc3902e265)({
                    intl: options.intl,
                    rangeBaseGenerate: editorPluginAIProvider.baseGenerate,
                    aiGlobalOptIn: aiOptIn,
                    triggeredFor: options.triggeredFor,
                    disabled: options.disabled ?? false,
                    openInRovoChat: options.openInRovoChat,
                    rovoChatAIFeatureContext: options.rovoChatAIFeatureContext,
                    target: options.target
                });
            },
            getSummariseSmartlinkFloatingToolbarButton: (options)=>{
                return (0, $bcebd4bbcac9e623$export$90102ae51106249a)({
                    api: api,
                    intl: options.intl,
                    aiGlobalOptIn: aiOptIn,
                    smartlinkUrl: options.smartlinkUrl,
                    nodeType: options.triggeredFor ?? editorView?.state.schema.nodes.extension ?? {},
                    disabled: options.disabled ?? false
                });
            },
            startSession: (sessionId, traceId, promptVersion, agentInfo, isCreateSession, isInlineEditSession, agentAttribution)=>{
                api?.core?.actions.execute(api?.history?.commands?.startHistorySlice('ai'));
                (0, $d07adef0b9b690ae$export$254dcf4812f17c19)({
                    editorView: editorView,
                    sessionId: sessionId,
                    traceId: traceId,
                    promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined,
                    agentInfo: agentInfo,
                    isCreateSession: isCreateSession,
                    isInlineEditSession: isInlineEditSession,
                    agentAttribution: agentAttribution
                });
            },
            endSession: (sessionId, metadata)=>{
                // [CCI-15904] Pass `editorPluginAIProvider.baseGenerate` + `aiOptIn` so
                // that, when the New AIFC Editor Experience is enabled and the session
                // ended cleanly, `endAISession` can auto-open the Post Stream Review
                // modal through the canonical `openAIModal` entry point.
                (0, $d07adef0b9b690ae$export$3a08ee9ddec0cdee)({
                    api: api,
                    editorView: editorView,
                    sessionId: sessionId,
                    metadata: metadata,
                    baseGenerate: editorPluginAIProvider.baseGenerate,
                    aiOptIn: aiOptIn
                });
                api?.core?.actions.execute(api?.history?.commands?.endHistorySlice('ai'));
            },
            updateTargetId: (targetId)=>{
                (0, $d07adef0b9b690ae$export$955fdaa156e3249e)({
                    editorView: editorView,
                    targetId: targetId
                });
            },
            stageInlineRovoStreaming: (targetId)=>{
                (0, $d07adef0b9b690ae$export$c256c77f565752b8)({
                    editorView: editorView,
                    targetId: targetId
                });
            },
            commitInlineRovoStreaming: ()=>{
                (0, $d07adef0b9b690ae$export$93371cae6bf62876)({
                    editorView: editorView
                });
            },
            endInlineRovoStreaming: ()=>{
                (0, $d07adef0b9b690ae$export$1f0b2dec3e9892b1)({
                    editorView: editorView
                });
            },
            showInlineEditReady: (targetId)=>{
                (0, $d07adef0b9b690ae$export$3912329751e3609c)({
                    editorView: editorView,
                    targetId: targetId
                });
            },
            isInlineEditTargetInView: (targetId)=>{
                return (0, $d07adef0b9b690ae$export$e9bc0794c89ce54d)({
                    editorView: editorView,
                    targetId: targetId
                });
            },
            dispatchAIEvent: (event)=>{
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) api?.core.actions.execute((0, $7791c10173ad9c87$export$6725e2cbda5e459c)(event));
                else {
                    const normalisedEvent = (0, $hEuOY.normaliseAIExperienceEvent)(event);
                    api?.aiExperience?.actions.getAiExperienceActor()?.send(normalisedEvent);
                }
            },
            tagAsAIStreamingTransformation: $d07adef0b9b690ae$export$99447d9e0d76b7ef,
            recordAIContentSegments: $d07adef0b9b690ae$export$df225d463d80633a,
            recordOriginalNode: $d07adef0b9b690ae$export$ed36a76977c3023b,
            registerInsertedContentNodeTransformer: (transformer)=>{
                insertedContentNodeTransformer = transformer;
            },
            getInsertedContentNodeTransformer: ()=>insertedContentNodeTransformer,
            fireUnifiedAnalyticsEvent: (payload)=>{
                api?.analytics?.actions.fireAnalyticsEvent((0, $26Q4g.createUnifiedAnalyticsPayload)(payload));
            },
            setAnalyticsBridgeRef: (ref)=>{
                analyticsBridgeRef = ref;
            },
            toggleAiEntryPoints: (disable)=>{
                if (!editorView) return;
                const currentState = api?.aiExperience?.sharedState.currentState()?.areAiEntryPointsDisabled;
                const nextDisabledState = disable ?? !currentState;
                const tr = editorView.state.tr.setMeta('toggleAiEntryPoints', nextDisabledState);
                editorView.dispatch(tr);
            },
            setConsumerEmptyStateOverride: (value)=>{
                if (!editorView || !(0, $2pQiO.UNSAFE_expValNoExposure)('jira-smart-replies-v2', 'isEnabled', false)) return;
                const tr = editorView.state.tr.setMeta((0, $f22a2fd66e11ba7d$export$59c835e23d1ad13), {
                    type: (0, $f22a2fd66e11ba7d$export$eeb95a60149a8e47),
                    value: value
                });
                editorView.dispatch(tr);
            }
        },
        commands: {
            insertContent: (payload, positions)=>{
                if (!editorView) throw new Error('editorView is not defined');
                // Ensure the editor is focused so when we insert it scrolls to the
                // insertion
                api?.core.actions.focus({
                    scrollIntoView: false
                });
                return (0, $359c3648a2c08b84$export$6d92f14e56d09aa)({
                    editorView: editorView,
                    api: api,
                    insertedContentNodeTransformer: insertedContentNodeTransformer,
                    payload: payload,
                    positions: positions,
                    scrollIntoView: (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? false : undefined
                });
            }
        },
        getSharedState (state) {
            if (!state) return {
                areAiEntryPointsDisabled: false,
                nonCursorSelectionChangeCount: 0,
                aiButtonState: {
                    triggeredFor: undefined,
                    isSelectionValidForAIExperience: true
                },
                aiDecorationExperiencePluginState: {
                    isRunning: false,
                    interactionSessionId: undefined,
                    modalDecorationSet: (0, $8nvEM.DecorationSet).empty,
                    configItem: undefined,
                    lastTriggeredFrom: undefined,
                    modalMountedTimeStamp: undefined,
                    triggerMethod: undefined,
                    initialPrompt: undefined,
                    userADFInput: undefined,
                    willAISuggestEmoji: undefined,
                    triggeredFor: undefined,
                    initialPositions: undefined,
                    nudgeMetrics: undefined,
                    hideLoadingScreen: false,
                    targetId: undefined,
                    inlineRovoStreamingTargetId: null,
                    pendingInlineRovoStreamingTargetId: null,
                    isInlineEditReady: false,
                    inlineEditReadyTargetId: undefined,
                    isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled,
                    traceId: undefined,
                    product: editorPluginAIProvider.product
                },
                rovoAgentsPluginState: {
                    positions: undefined,
                    isBrowseModalOpen: false
                },
                isStreaming: false,
                isShowingAcceptRejectScreen: false,
                chunkNumber: 0,
                selectionContext: undefined,
                hasVisibleContent: false,
                consumerEmptyStateOverride: undefined,
                aiSessionPluginState: (0, $e9cb9bc0694dd877$export$d4c72bab9d6cc13a)
            };
            return {
                areAiEntryPointsDisabled: ((0, $3597cc6021decfa3$export$521879fd431ff390).getState(state) ?? {}).areAiEntryPointsDisabled ?? false,
                nonCursorSelectionChangeCount: ((0, $iBAu1.selectionPluginKey).getState(state) ?? {})?.nonCursorSelectionChangeCount,
                aiButtonState: {
                    triggeredFor: ((0, $3597cc6021decfa3$export$521879fd431ff390).getState(state) ?? {}).triggeredFor,
                    isSelectionValidForAIExperience: ((0, $3597cc6021decfa3$export$521879fd431ff390).getState(state) ?? {}).isSelectionValidForAIExperience
                },
                aiDecorationExperiencePluginState: {
                    isRunning: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).isRunning ?? false,
                    modalDecorationSet: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).modalDecorationSet ?? (0, $8nvEM.DecorationSet).empty,
                    configItem: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).configItem,
                    lastTriggeredFrom: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).lastTriggeredFrom,
                    modalMountedTimeStamp: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).modalMountedTimeStamp,
                    triggerMethod: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).triggerMethod,
                    initialPrompt: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).initialPrompt,
                    userADFInput: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).userADFInput,
                    willAISuggestEmoji: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).willAISuggestEmoji,
                    triggeredFor: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).triggeredFor,
                    initialPositions: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).initialPositions,
                    positions: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).positions,
                    nudgeMetrics: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).nudgeMetrics,
                    currentSessionId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).currentSessionId,
                    nextSessionId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).nextSessionId,
                    sessionStarted: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).sessionStarted,
                    interactionSessionId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).interactionSessionId,
                    hideLoadingScreen: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).hideLoadingScreen,
                    targetId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).targetId,
                    inlineRovoStreamingTargetId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).inlineRovoStreamingTargetId ?? null,
                    isInlineEditReady: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).isInlineEditReady ?? false,
                    inlineEditReadyTargetId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).inlineEditReadyTargetId,
                    isInDocumentStreamingEnabled: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).isInDocumentStreamingEnabled,
                    traceId: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).traceId,
                    product: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).product,
                    promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).promptVersion : undefined
                },
                rovoAgentsPluginState: {
                    positions: ((0, $4xV3u.rovoAgentsPluginKey).getState(state) ?? {}).positions,
                    isBrowseModalOpen: ((0, $4xV3u.rovoAgentsPluginKey).getState(state) ?? {}).isBrowseModalOpen ?? false,
                    defaultAgent: ((0, $4xV3u.rovoAgentsPluginKey).getState(state) ?? {}).defaultAgent
                },
                isStreaming: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) ? (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.isStreaming ?? false : (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(state)?.isStreaming ?? false,
                isShowingAcceptRejectScreen: ((0, $9RRio.aiExperienceDecorationPluginKey).getState(state) ?? {}).isShowingAcceptRejectScreen ?? false,
                chunkNumber: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) ? (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.chunkNumber ?? 0 : (0, $ix5ay.inEditorDirectStreamingPluginKey).getState(state)?.chunkNumber ?? 0,
                // Streaming plugin state for React hooks (scroll, mount effects, etc.)
                streamingState: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true) ? {
                    streamStartPos: (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.streamStartPos,
                    scrollTargetPos: (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.scrollTargetPos,
                    streamPhase: (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.streamPhase,
                    currentSessionId: (0, $9ybcs.purePmInEditorDirectStreamingPluginKey).getState(state)?.currentSessionId
                } : undefined,
                selectionContext: (0, $iBAu1.selectionPluginKey).getState(state)?.lastSelectionContext ?? undefined,
                hasVisibleContent: (0, $f22a2fd66e11ba7d$export$59c835e23d1ad13).getState(state)?.hasVisibleContent ?? false,
                consumerEmptyStateOverride: (0, $f22a2fd66e11ba7d$export$59c835e23d1ad13).getState(state)?.consumerEmptyStateOverride,
                aiSessionPluginState: (0, $iN8Pe.aiSessionContextPluginKey).getState(state) ?? (0, $e9cb9bc0694dd877$export$d4c72bab9d6cc13a)
            };
        },
        pluginsOptions: {
            ...isFullEditorAIExperience && !isToolbarAIFCEnabled && {
                selectionToolbar: (0, $b17ad13bcbcb2df1$export$50f5e6709d50619a)({
                    aiGlobalOptIn: aiOptIn,
                    editorPluginAIProvider: editorPluginAIProvider,
                    api: api
                })
            },
            ...isFullEditorAIExperience && {
                ...isRegisteredSlashCommandEnabled ? {} : {
                    quickInsert: quickInsert
                },
                floatingToolbar: (0, $98e7d47b5e3ff1fa$export$add2b8f99d5aac)({
                    aiGlobalOptIn: aiOptIn,
                    editorPluginAIProvider: editorPluginAIProvider,
                    api: api
                })
            }
        },
        contentComponent: isFullEditorAIExperience ? ({ editorView: editorView, wrapperElement: wrapperElement, appearance: appearance, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint })=>{
            // Keep the paste-menu appearance getter in sync with the editor's live appearance.
            currentAppearance = appearance;
            if (!editorView) return null;
            // We're going to use a different collection of components for the AIFC experience. This should allow for
            // a better SoC and easier cleanup in the future and it will provide clear separation between the two, old/new experiences.
            // This also means we do not need to reference the AIFC feature flag in multiple places throughout the UI.
            const C = editorPluginAIProvider.isInDocumentStreamingEnabled ? (0, $c1bd390bf1a072c6$export$d1314adfeea5c2b2) : (0, $c997f1dd36211338$export$d1314adfeea5c2b2);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, shouldRegisterAIPasteMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($96fe6c416d971b16$var$SmartCardClientSync, {
                clientRef: aiSmartCardClientRef
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
                aiOptIn: aiOptIn,
                api: api,
                editorView: editorView,
                wrapperElement: wrapperElement,
                appearance: appearance,
                editorPluginAIProvider: editorPluginAIProvider,
                providerFactory: providerFactory,
                getMentionNameDetails: getMentionNameDetails,
                canInlineStreamChanges: canInlineStreamChanges,
                isInDocumentStreamingEnabled: !!editorPluginAIProvider.isInDocumentStreamingEnabled,
                popupsMountPoint: popupsMountPoint,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                endExperience: ()=>{}
            }));
        } : (0, $7fb8868443a415ff$export$87f8e9111167b374),
        primaryToolbarComponent: isFullEditorAIExperience && !api?.primaryToolbar && !editorPluginAIProvider.hidePrimaryToolbarButton ? (0, $c3203dd2c1d7fba4$export$d26e7f34c50ada62)({
            api: api,
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: aiOptIn
        }) : undefined
    };
};


const $4498dd2adafca39b$export$9cf35b434a79b498 = (0, $96fe6c416d971b16$export$7825a101a7e6b70b);
module.exports["aiPlugin"] = $4498dd2adafca39b$export$9cf35b434a79b498;

});

parcelRegister("hEuOY", function(module, exports) {
function $77e49242eabbd0c5$export$f5f3c97efd684238(event) {
    switch(event.type){
        case 'complete':
            return {
                markdown: '',
                cacheKey: '',
                modelInput: {},
                ...event
            };
        case 'stream':
            return {
                markdown: '',
                ...event
            };
        case 'error':
            return {
                cacheKey: '',
                modelInput: {},
                ...event
            };
    }
}
module.exports["normaliseAIExperienceEvent"] = $77e49242eabbd0c5$export$f5f3c97efd684238;

});

parcelRegister("4TgUg", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $krYZG = parcelRequire("krYZG");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $8nvEM = parcelRequire("8nvEM");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $jH9cM = parcelRequire("jH9cM");


var $i2EU6 = parcelRequire("i2EU6");


var $bVbtv = parcelRequire("bVbtv");


var $doWyc = parcelRequire("doWyc");


var $l2lIz = parcelRequire("l2lIz");


var $hZdqw = parcelRequire("hZdqw");




const $86d2b8ca92bd29e9$export$aaeb49e5d4e17100 = ()=>(0, $iDrrr.fg)('platform_editor_ai_suppress_streaming_greyout');



var $kEjH6 = parcelRequire("kEjH6");


var $iN8Pe = parcelRequire("iN8Pe");


var $80W3l = parcelRequire("80W3l");


var $8HW7o = parcelRequire("8HW7o");


var $8Z43Z = parcelRequire("8Z43Z");


var $hivdp = parcelRequire("hivdp");

function $5b9ec773a9de8641$var$getWordsFromTextUsingSegmenter(text, locale) {
    const segmenter = new Intl.Segmenter(locale, {
        granularity: 'word'
    });
    const segments = Array.from(segmenter.segment(text));
    const words = segments.filter((segment)=>segment.isWordLike);
    return words.map((word)=>({
            text: word.segment,
            index: word.index
        }));
}
function $5b9ec773a9de8641$var$getWordsFromTextUsingRegex(text) {
    const result = [];
    const regex = /\S+/gu;
    const matches = text.matchAll(regex);
    for (const match of matches)result.push({
        text: match[0],
        index: match.index
    });
    return result;
}
function $5b9ec773a9de8641$var$getWordsFromText(text, locale) {
    if (Intl.Segmenter) return $5b9ec773a9de8641$var$getWordsFromTextUsingSegmenter(text, locale);
    return $5b9ec773a9de8641$var$getWordsFromTextUsingRegex(text);
}
const $5b9ec773a9de8641$var$expandSelectionToCompleteWords = (selectionPositions, { locale: locale })=>{
    const startPos = selectionPositions.startPos.pos;
    const endPos = selectionPositions.endPos.pos;
    const doc = selectionPositions.startPos.doc;
    let newStartPos = startPos;
    let newEndPos = endPos;
    let startPosTextNode;
    let endPosTextNode;
    let startPosTextNodePos;
    let endPosTextNodePos;
    doc.nodesBetween(startPos, endPos, (node, nodePos)=>{
        if (!startPosTextNode && node.isText) {
            startPosTextNode = node;
            startPosTextNodePos = nodePos;
        }
        if (node.isText) {
            endPosTextNode = node;
            endPosTextNodePos = nodePos;
        }
    });
    if (startPosTextNode && startPosTextNode.isText && startPosTextNode.text && startPosTextNodePos) {
        const words = $5b9ec773a9de8641$var$getWordsFromText(startPosTextNode.text, locale);
        const startPosInText = startPos - startPosTextNodePos;
        const selectionStartWord = words.find((word)=>word.index < startPosInText && word.index + word.text.length > startPosInText);
        newStartPos = selectionStartWord ? selectionStartWord.index + startPosTextNodePos : startPos;
    }
    if (endPosTextNode && endPosTextNode.isText && endPosTextNode.text && endPosTextNodePos) {
        const words = $5b9ec773a9de8641$var$getWordsFromText(endPosTextNode.text, locale);
        const endPosInText = endPos - endPosTextNodePos;
        const selectionEndWord = words.find((word)=>word.index < endPosInText && word.index + word.text.length > endPosInText);
        newEndPos = selectionEndWord ? selectionEndWord.index + selectionEndWord.text.length + endPosTextNodePos : endPos;
    }
    return {
        startPos: doc.resolve(newStartPos),
        endPos: doc.resolve(newEndPos)
    };
};
/**
 * If selection starts in caption, we need to wrap it into a valid media parent node as
 * it is the only way to inject it back into the doc.
 */ const $5b9ec773a9de8641$var$expandSelectionToMediaIfInCaption = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    if (startPos.parent.type.name === 'caption') return {
        startPos: doc.resolve(startPos.start(Math.max(startPos.depth - 1, 1))),
        endPos: doc.resolve(endPos.end(Math.max(endPos.depth, 1)))
    };
    return selectionPositions;
};
/**
 * This transformer will expand the selection to the nearest ancestor block.
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/5422770750/Selection+Streaming
 */ const $5b9ec773a9de8641$var$expandSelectionToCommonBlockAncestor = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    if (startPos.parent !== endPos.parent) {
        // We want to quickly scan the range and check that the range encapsulates only specific items. If it doesn't
        // then we want to expand the selection to the nearest ancestor block.
        let expandRange = false;
        doc.nodesBetween(startPos.pos, endPos.pos, (node)=>{
            // We only want to expand the selection if the selection contains anything other than an inline element or a paragraph
            // This means this is a list of what is acceptable to be in a selection and not trigger an expansion of the selection.
            if (!(node.isInline || node.type.name === 'paragraph')) expandRange = true;
            return !expandRange;
        });
        if (expandRange) {
            const nodeRange = startPos.blockRange(endPos);
            if (!!nodeRange) return {
                startPos: doc.resolve(nodeRange.start),
                endPos: doc.resolve(nodeRange.end)
            };
        }
    }
    return selectionPositions;
};
const $5b9ec773a9de8641$var$expandSelectionToNearestBlockNode = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    const { paragraph: paragraph, tableRow: tableRow } = doc.type.schema.nodes;
    if (startPos.parent !== endPos.parent) {
        /**
		 * We treat cells as a defining range so if the selection starts and ends in the same cell,
		 * we simply expand to the start and end of the position's blocks.
		 */ const isSameCell = (0, $hivdp.isWithinSameCell)({
            $from: startPos,
            $to: endPos,
            schema: doc.type.schema
        });
        if (isSameCell) return {
            startPos: doc.resolve(startPos.start()),
            endPos: doc.resolve(endPos.end())
        };
        // We want to quickly scan the range and check that the range encapsulates only specific items. If it doesn't
        // then we want to expand the selection to the nearest ancestor block.
        let expandRange = false;
        doc.nodesBetween(startPos.pos, endPos.pos, (node)=>{
            // We only want to expand the selection if the selection contains anything other than an inline element or a paragraph
            // This means this is a list of what is acceptable to be in a selection and not trigger an expansion of the selection.
            if (!(node.isInline || node.type === paragraph)) expandRange = true;
            return !expandRange;
        });
        if (expandRange) {
            let newStartPos = doc.resolve(startPos.start(Math.max(startPos.depth - 1, 1)));
            let newEndPos = doc.resolve(endPos.end());
            /**
			 * If we are expanding the range, if either end are inside a table we want to expand to the full row.
			 * This is important for streaming stability as it simplifies some of the conditions for streaming.
			 */ const startPosTableRowDepth = (0, $hivdp.getPositionNodeTypeDepth)({
                resolvedPos: newStartPos,
                nodeType: tableRow
            });
            if (startPosTableRowDepth) // Extend by -1 to fully include the table row
            newStartPos = doc.resolve(newStartPos.start(startPosTableRowDepth) - 1);
            const endPosTableRowDepth = (0, $hivdp.getPositionNodeTypeDepth)({
                resolvedPos: newEndPos,
                nodeType: tableRow
            });
            if (endPosTableRowDepth) // Extend by +1 to fully include the table row
            newEndPos = doc.resolve(newEndPos.end(endPosTableRowDepth) + 1);
            return {
                startPos: newStartPos,
                endPos: newEndPos
            };
        }
    }
    return selectionPositions;
};
const $5b9ec773a9de8641$var$lookBackwardsForUnmergedRow = (mapByRow, startingIndex)=>{
    for(let i = startingIndex; i > 0; i--){
        // We keep checking the next row to see if there are any duplicate positions
        // If there are, it means that there are vertically merged cells and we want to extend the position
        const rowA = mapByRow[i - 1];
        const rowB = mapByRow[i];
        if (rowA.every((val, idx)=>val !== rowB[idx])) return i;
    }
    return 0;
};
const $5b9ec773a9de8641$var$lookAheadForUnmergedRow = (mapByRow, startingIndex)=>{
    for(let i = startingIndex; i < mapByRow.length - 1; i++){
        // We keep checking the next row to see if there are any duplicate positions
        // If there are, it means that there are vertically merged cells and we want to extend the position
        const rowA = mapByRow[i];
        const rowB = mapByRow[i + 1];
        if (rowA.every((val, idx)=>val !== rowB[idx])) return i;
    }
    /**
	 * If the table is one row high OR everything is merged, we just return the last row
	 */ return mapByRow.length - 1;
};
const $5b9ec773a9de8641$var$getCellPosFromDirectDescendant = (schema, $pos)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    for(let depth = $pos.depth; depth > 0; depth--){
        if ([
            tableCell,
            tableHeader
        ].includes($pos.node(depth).type)) return $pos.start(depth - 1);
    }
};
/**
 * Transforms a CellSelection's positions into normal ProseMirror positions.
 */ const $5b9ec773a9de8641$var$transformCellSelectionToTextRange = (selectionPositions, context)=>{
    let selection = context.selection;
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const { doc: doc } = startPos;
    const { table: table, tableRow: tableRow } = doc.type.schema.nodes;
    if (!(selection instanceof (0, $8HW7o.CellSelection)) && [
        table,
        tableRow
    ].includes(startPos.node(startPos.sharedDepth(endPos.pos)).type)) {
        /**
		 * If a selection spans across the same table, we want to convert it into a CellSelection.
		 * CellSelections aren't always created when dragging across cells with multiple child blocks for some reason...
		 */ const anchorCellPos = $5b9ec773a9de8641$var$getCellPosFromDirectDescendant(doc.type.schema, startPos);
        const headCellPos = $5b9ec773a9de8641$var$getCellPosFromDirectDescendant(doc.type.schema, endPos);
        if (anchorCellPos && headCellPos) selection = (0, $8HW7o.CellSelection).create(doc, anchorCellPos, headCellPos);
    }
    if (selection instanceof (0, $8HW7o.CellSelection)) {
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        if ($headCell.pos === $anchorCell.pos) /**
			 * If the selection is a single cell selection, use the inner positions
			 */ return {
            startPos: doc.resolve($anchorCell.pos + 1),
            endPos: doc.resolve($anchorCell.pos + ($anchorCell.nodeAfter?.nodeSize || 0) - 1)
        };
        const tableNode = $anchorCell.node(-1);
        const tablePos = $anchorCell.start(-1);
        const map = (0, $8Z43Z.TableMap).get(tableNode);
        const { mapByRow: mapByRow } = map;
        const rowIndexContainingAnchorCell = mapByRow.findIndex((r)=>r.includes($anchorCell.pos - tablePos));
        const rowIndexContainingHeadCell = mapByRow.findIndex((r)=>r.includes($headCell.pos - tablePos));
        let smallerRowIndex = Math.min(rowIndexContainingAnchorCell, rowIndexContainingHeadCell);
        let largerRowIndex = Math.max(rowIndexContainingAnchorCell, rowIndexContainingHeadCell);
        if (smallerRowIndex === -1 || largerRowIndex === -1) // we should always be able to find the rows, but if not, we return the original positions
        return selectionPositions;
        smallerRowIndex = $5b9ec773a9de8641$var$lookBackwardsForUnmergedRow(mapByRow, smallerRowIndex);
        largerRowIndex = $5b9ec773a9de8641$var$lookAheadForUnmergedRow(mapByRow, largerRowIndex);
        const startingCellIndex = Math.min(...mapByRow[smallerRowIndex]);
        const endingCellIndex = Math.max(...mapByRow[largerRowIndex]);
        const { map: allCells } = map;
        const veryFirstCellIndex = allCells[0];
        const veryLastCellIndex = allCells[allCells.length - 1];
        const entireTableSelected = startingCellIndex === veryFirstCellIndex && endingCellIndex === veryLastCellIndex;
        if (entireTableSelected) {
            const tableStart = doc.resolve(tablePos - 1);
            return {
                startPos: tableStart,
                endPos: doc.resolve(tableStart.pos + tableNode.nodeSize)
            };
        }
        const startingCellPos = doc.resolve(tablePos + startingCellIndex);
        const endingCellPos = doc.resolve(tablePos + endingCellIndex);
        return {
            startPos: doc.resolve(startingCellPos.start(startingCellPos.depth + 1)),
            endPos: doc.resolve(endingCellPos.end(endingCellPos.depth))
        };
    }
    return selectionPositions;
};
/**
 * We need to expand any selections that cross over to multiple columns as the
 * layout plugin automatically repairs columns, but this can mean replacing a user's
 * column outside the selection to make room for the AI generated column.
 */ const $5b9ec773a9de8641$var$expandSelectionToEntireLayout = (selectionPositions)=>{
    const { startPos: startPos, endPos: endPos } = selectionPositions;
    const doc = startPos.doc;
    const { layoutColumn: layoutColumn } = doc.type.schema.nodes;
    const startPosLayoutColumnDepth = (0, $hivdp.getPositionNodeTypeDepth)({
        resolvedPos: startPos,
        nodeType: layoutColumn
    });
    const endPosLayoutColumnDepth = (0, $hivdp.getPositionNodeTypeDepth)({
        resolvedPos: endPos,
        nodeType: layoutColumn
    });
    // If both are in layoutColumn, check if they're in the same layoutColumn
    if (startPosLayoutColumnDepth && endPosLayoutColumnDepth) {
        // Check if both positions are within the same layoutColumn by comparing
        // the start position of the layoutColumn at that depth
        const startLayoutColumnStart = startPos.start(startPosLayoutColumnDepth);
        const endLayoutColumnStart = endPos.start(endPosLayoutColumnDepth);
        if (startLayoutColumnStart === endLayoutColumnStart) // Both are in the same layoutColumn, don't expand
        return selectionPositions;
    }
    let newStartPos = startPos;
    let newEndPos = endPos;
    // If startPos is in layoutColumn, extend to start of layoutSection
    if (startPosLayoutColumnDepth && startPos.node(startPosLayoutColumnDepth - 1).childCount > 1) newStartPos = doc.resolve(startPos.start(startPosLayoutColumnDepth - 1));
    // If endPos is in layoutColumn, extend to end of layoutSection
    if (endPosLayoutColumnDepth && endPos.node(endPosLayoutColumnDepth - 1).childCount > 1) newEndPos = doc.resolve(endPos.end(endPosLayoutColumnDepth - 1));
    return {
        startPos: newStartPos,
        endPos: newEndPos
    };
};
const $5b9ec773a9de8641$var$selectionTransformer = (transformers)=>(selectionPositions, context)=>{
        return transformers.reduce((newSelectionPositions, transformer)=>transformer(newSelectionPositions, context), selectionPositions);
    };
function $5b9ec773a9de8641$export$188100af2e354326({ selectionPositions: selectionPositions, context: context, options: options }) {
    /**
	 * If there is no selection then don't expand it
	 */ if (selectionPositions.startPos.pos === selectionPositions.endPos.pos) return [
        selectionPositions.startPos.pos,
        selectionPositions.endPos.pos
    ];
    const { startPos: startPos, endPos: endPos } = $5b9ec773a9de8641$var$selectionTransformer([
        /**
			 * Keep transformCellSelectionToTextRange first as it converts CellSelection into regular positions.
			 * This allows further transformations to happen if desired.
			 */ (!options || options.shouldTransformCellSelectionToTextRange) && $5b9ec773a9de8641$var$transformCellSelectionToTextRange,
        (!options || options.shouldExpandSelectionToCompleteWords) && $5b9ec773a9de8641$var$expandSelectionToCompleteWords,
        (!options || options.shouldExpandSelectionToMediaIfInCaption) && $5b9ec773a9de8641$var$expandSelectionToMediaIfInCaption,
        (!options || options.shouldExpandSelectionToNearestBlockNode) && $5b9ec773a9de8641$var$expandSelectionToNearestBlockNode,
        (!options || options.shouldExpandSelectionToCommonBlockAncestor) && $5b9ec773a9de8641$var$expandSelectionToCommonBlockAncestor,
        (!options || options.shouldExpandSelectionToEntireLayout) && $5b9ec773a9de8641$var$expandSelectionToEntireLayout
    ].filter((transformers)=>!!transformers))(selectionPositions, context);
    // Bound the positions by min and max
    const [min, max] = [
        0,
        startPos.doc.content.size
    ];
    return [
        Math.max(min, startPos.pos),
        Math.min(max, endPos.pos)
    ];
}



var $277Za = parcelRequire("277Za");


var $iBAu1 = parcelRequire("iBAu1");


var $C4yPo = parcelRequire("C4yPo");

const $2332289c5e9e2339$export$6428b9f2a07e29a5 = (isInDocumentStreamingEnabled)=>(pos, type, key)=>{
        const widgetSpanElement = document.createElement('span');
        // Firefox needs content inside the span in order to add height to the element.
        // Otherwise, the height is set to 0 which prevents the start and
        // end widgets from rendering correctly and produces incorrect measurements
        // when we need to determine where to place the modal under the content.
        // Zero width spaces have been known to introduce some strange selection
        // behaviour in the Editor, however this approach works for our use case
        // in the ai-plugin where we do not expect users to be making selections
        // over ai-highlighted content in the same way they select regular content
        // in the Editor, this is also not intended to be a permanent fix post EAP.
        if (!isInDocumentStreamingEnabled) widgetSpanElement.appendChild(document.createTextNode('\u200b'));
        widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
        widgetSpanElement.className = `ai-modal-${type}-widget`;
        widgetSpanElement.contentEditable = 'false';
        return (0, $8nvEM.Decoration).widget(pos, widgetSpanElement, {
            side: type === 'start' ? 1 : -1,
            key: key ?? `${type}WidgetDecoration`
        });
    };
/**
 * Keeps the modal mount point out of table structure.
 *
 * The mount point is an inline `<span>`. As a direct child of a `<tr>` the browser wraps it
 * in an anonymous table cell, which renders as a blank column and collapses a real cell to
 * roughly a pixel. CSS cannot prevent this — the anonymous box comes from the parent's
 * box-tree fixup — so the position itself has to move.
 *
 * This happens whenever the anchor is a whole node, such as a diff segment for an
 * attribute-only cell edit. `Selection.near` resolves to the nearest text position, putting
 * the widget inside a paragraph where it is an ordinary inline node.
 */ const $2332289c5e9e2339$var$toTableSafeMountPos = (doc, pos)=>{
    const clamped = Math.max(0, Math.min(pos, doc.content.size));
    if (!(0, $iDrrr.fg)('platform_editor_ai_smart_diff')) return clamped;
    const $pos = doc.resolve(clamped);
    if ($pos.parent.inlineContent) return clamped;
    // Only relocate when the anchor sits directly in table structure — a `<span>` child of a
    // `<tr>`/table is what triggers the anonymous-cell fixup. For any other block parent (expand,
    // list, panel, doc root) the inline widget is harmless, and moving it there would mis-place the
    // modal mount point (e.g. node conversions inside an expand).
    const parentType = $pos.parent.type.name;
    if (parentType !== 'tableRow' && parentType !== 'table') return clamped;
    return (0, $kCECX.Selection).near($pos, -1).from;
};
const $2332289c5e9e2339$export$846ae3cda2c26d54 = (pos, doc)=>{
    const widgetSpanElement = document.createElement('span');
    widgetSpanElement.setAttribute('data-testid', `ai-modal-mount-point-widget`);
    widgetSpanElement.className = `ai-modal-mount-point-widget`;
    widgetSpanElement.contentEditable = 'false';
    return (0, $8nvEM.Decoration).widget(doc ? $2332289c5e9e2339$var$toTableSafeMountPos(doc, pos) : pos, widgetSpanElement, {
        side: 1,
        key: 'modalMountPointDecoration'
    });
};
const $2332289c5e9e2339$export$1690e22aee311809 = (from, to)=>{
    return (0, $8nvEM.Decoration).inline(from, to, {
        class: 'ai-selection-highlight',
        'data-testid': 'ai-selection-highlight'
    }, {
        key: 'inlineDecoration'
    });
};
const $2332289c5e9e2339$export$ee67e3280dab453d = (from, to, isInDocumentStreamingEnabled)=>{
    const startWidgetDecoration = $2332289c5e9e2339$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(from, 'start', 'generatedStartWidget');
    const highlightInlineDecoration = (0, $8nvEM.Decoration).inline(from, to, {
        class: 'ai-generated-content-highlight',
        'data-testid': 'ai-generated-content-highlight'
    }, {
        key: 'generatedInlineDecoration'
    });
    const endWidgetDecoration = $2332289c5e9e2339$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(to, 'end', 'generatedEndWidget');
    return [
        startWidgetDecoration,
        highlightInlineDecoration,
        endWidgetDecoration
    ];
};
const $2332289c5e9e2339$export$50894b1f0083184 = (from, to)=>{
    return (0, $8nvEM.Decoration).node(from, to, {
        class: 'ai-selection-node',
        'data-testid': 'ai-selection-node'
    }, {
        key: 'ai-nodeDecoration'
    });
};
const $2332289c5e9e2339$export$21c5d318062e995c = (from, to)=>{
    return (0, $8nvEM.Decoration).node(from, to, {
        class: 'ai-generated-node-highlight',
        'data-testid': 'ai-generated-node-highlight'
    }, {
        key: 'generatedNodeDecoration'
    });
};
function $2332289c5e9e2339$var$getInitialPositions(selection) {
    switch(true){
        case selection instanceof (0, $kCECX.AllSelection):
            return {
                startPos: selection.from + 1,
                endPos: selection.to - 1
            };
        default:
            return {
                startPos: selection.from,
                endPos: selection.to
            };
    }
}
const $2332289c5e9e2339$export$4379c9f48a526c4d = ({ state: state })=>{
    const { selection: selection } = state;
    let from, to;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        from = selection.from;
        to = selection.to;
    } else if ((0, $doWyc.isCellSelection)(state)) {
        const findResult = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.table)(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    } else {
        const { selection: selection } = state;
        const supportedNodes = (0, $doWyc.getSupportedNodesForAIModal)(state);
        const findResult = (0, $bjg0G.findParentNode)((node)=>supportedNodes.has(node.type))(selection);
        if (findResult) {
            const { depth: depth } = findResult;
            from = selection.$from.before(depth);
            to = selection.$from.after(depth);
        }
    }
    if (from !== undefined && to !== undefined) return [
        $2332289c5e9e2339$export$50894b1f0083184(from, to)
    ];
    return [];
};
const $2332289c5e9e2339$export$8b0c0139da7bc378 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, initialPositions: initialPositions })=>{
    /**
   * We add selection highlight decoration based on the current selection state of the document and the config item in the command palette
   * If the selection is empty and the document is not empty -> we decorate the entire document unless the config item specifies otherwise
   */ let useCurrentSelectionForHighlight = true;
    // when clicking `browse agents` then selecting an agent, the state.selection is already cleared
    // so we need to use initialPositions to check if the selection is empty
    if (initialPositions[0] === initialPositions[1] && state.doc.content.size !== 0) useCurrentSelectionForHighlight = !!configItem.doNotHighlightDocWhenSelectionIsEmpty;
    /**
   * EXPERIMENTAL: For experimental flow where 'Suggest title' in
   * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
   * Forces whole document selection, even if an existing selection exists.
   */ if ((0, $bVbtv.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) useCurrentSelectionForHighlight = false;
    const { startPos: startPos, endPos: endPos } = useCurrentSelectionForHighlight ? {
        startPos: initialPositions[0],
        endPos: initialPositions[1]
    } : $2332289c5e9e2339$var$getInitialPositions(new (0, $kCECX.AllSelection)(state.doc));
    let decorations = [];
    const { isInDocumentStreamingEnabled: isInDocumentStreamingEnabled } = (0, $C4yPo.getPluginState)(state);
    const startWidgetDecoration = $2332289c5e9e2339$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(initialPositions[0], 'start');
    const endWidgetDecoration = $2332289c5e9e2339$export$6428b9f2a07e29a5(isInDocumentStreamingEnabled)(initialPositions[1], 'end');
    decorations = initialPositions[0] === initialPositions[1] ? [
        endWidgetDecoration
    ] : [
        startWidgetDecoration,
        endWidgetDecoration
    ];
    decorations.push($2332289c5e9e2339$export$1690e22aee311809(startPos, endPos));
    return decorations;
};
function $2332289c5e9e2339$var$createEmptySelectionDecoration(startPos) {
    const widgetSpanElement = document.createElement('span');
    widgetSpanElement.setAttribute('data-testid', 'ai-pre-stream-empty-selection-caret');
    widgetSpanElement.className = 'ai-pre-stream-empty-selection-caret';
    widgetSpanElement.contentEditable = 'false';
    return (0, $8nvEM.Decoration).widget(startPos, widgetSpanElement, {
        side: 1,
        key: 'ai-pre-stream-empty-selection-caret'
    });
}
const $2332289c5e9e2339$export$2640287a220c13b0 = ({ state: state, configItem: configItem, initialPositions: initialPositions, skipSelectionHighlight: skipSelectionHighlight = false })=>{
    // We add selection highlight decoration based on the current selection of the document
    // when clicking `browse agents` then selecting an agent, the state.selection is cleared
    // so we need to use initialPositions to get the selection positions
    const startPos = initialPositions[0];
    const endPos = initialPositions[1];
    const isEmptySelection = startPos === endPos;
    const isSuggestTitle = (0, $bVbtv.isSuggestTitleForConfluence)(configItem);
    const needSelectionDecoration = !isSuggestTitle;
    const decorations = [];
    if (needSelectionDecoration) {
        if (isEmptySelection) // Caret is purely visual — skip when highlight is disabled.
        {
            if (!skipSelectionHighlight) decorations.push($2332289c5e9e2339$var$createEmptySelectionDecoration(startPos));
        } else {
            // Only the inline decoration highlights text; the mount-point range
            // decoration below is invisible and always required as the anchor.
            if (!skipSelectionHighlight) {
                const preStreamRangeDecorations = (0, $8nvEM.Decoration).inline(startPos, endPos, {
                    class: 'ai-pre-stream-range-selection',
                    'data-testid': 'ai-pre-stream-range-selection'
                }, {
                    key: 'ai-pre-stream-range-selection'
                });
                decorations.push(preStreamRangeDecorations);
            }
            const mountPointRangeDecorations = (0, $8nvEM.Decoration).inline(startPos, endPos, {}, {
                key: 'modalMountPointRangeDecoration'
            });
            decorations.push(mountPointRangeDecorations);
        }
    }
    /**
   * Set the mount point of the widget to be directly after the endPos so that
   * replace steps during streaming will not remove the decoration as
   * that would unmount the modal + state machine
   */ const mountPos = isSuggestTitle ? 1 : isEmptySelection && !configItem.insertOnEmptySelection ? state.doc.content.size : Math.min(endPos, state.doc.content.size);
    const mountPointDecoration = $2332289c5e9e2339$export$846ae3cda2c26d54(mountPos, state.doc);
    decorations.push(mountPointDecoration);
    return decorations;
};
const $2332289c5e9e2339$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn, aiSessionContextType: aiSessionContextType, initialPrompt: initialPrompt, triggeredFor: triggeredFor, triggeredForMark: triggeredForMark, nudgeMetrics: /**
   * Nudge metrics will be used passed in analytics events.
   * It includes detailed metrics for improve writing nudge.
   * It is currently only set when "Improve writing" is triggered from the
   * "Improve writing" nudge.
   */ nudgeMetrics, locale: locale, isExternal: isExternal = false, withAcceptReject: withAcceptReject = true, withStreamingHighlight: withStreamingHighlight = true, hideLoadingScreen: hideLoadingScreen = false, traceId: traceId, singleInstrumentationId: singleInstrumentationId, isCreate: isCreate, overrideFromPos: overrideFromPos, overrideToPos: overrideToPos, shouldExpandPositions: shouldExpandPositions = true, promptVersion: promptVersion, has3pSources: has3pSources, sourceProduct: sourceProduct, userADFInput: userADFInput, willAISuggestEmoji: willAISuggestEmoji, beforeTransform: beforeTransform, skipSelectionHighlight: skipSelectionHighlight = false, preserveModalMountTimestamp: preserveModalMountTimestamp = false })=>{
    /**
   * WARNING: Do not remove the isFedRamp check.
   * This is to ensure that AI functionality is not enabled in FedRamp environments.
   */ if (aiGlobalOptIn.status === 'disabled' || (0, $jH9cM.isFedRamp)()) /**
     * If the user has opted out of AI, or if user is in FedRamp environment,
     * do not show the modal it's unclear how this function would be triggered as
     * all entry points should be removed already
     */ return ()=>false;
    if (aiGlobalOptIn.status === 'disabled-opt-in') {
        aiGlobalOptIn.triggerOptInFlow();
        return (0, $C4yPo.createCommand)({}, (tr)=>{
            (0, $hZdqw.addAnalytics)({
                editorState: state,
                tr: tr,
                payload: {
                    action: 'triggerOptInFlow',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiGlobalOptIn',
                    attributes: {
                        experienceType: (0, $l2lIz.convertExperienceName)(configItem.key),
                        lastTriggeredFrom: lastTriggeredFrom,
                        selectionType: state.selection.empty ? 'empty' : 'range'
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).UI
                }
            });
            return tr;
        });
    }
    const usePositionOverride = overrideFromPos !== undefined && overrideToPos !== undefined;
    const from = usePositionOverride ? overrideFromPos : state.selection.from;
    const to = usePositionOverride ? overrideToPos : state.selection.to;
    // The grey-out dims the source content for the duration of the session. It
    // reads as progress only while the response arrives progressively, so it is
    // dropped ahead of the block-level backend streaming experience.
    const streamingHighlight = (0, $86d2b8ca92bd29e9$export$aaeb49e5d4e17100)() ? false : withStreamingHighlight;
    const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
    const decorationPluginStateInitialPositions = aiDecorationExperiencePluginState.initialPositions;
    // For external commands respect the current selection
    let initialPositions = isExternal && aiDecorationExperiencePluginState.isInDocumentStreamingEnabled ? [
        from,
        to
    ] : decorationPluginStateInitialPositions || [
        from,
        to
    ];
    const adfStreamingEnabled = configItem.adfPrompt;
    const isSmartLinkNode = triggeredFor?.name === 'inlineCard' || triggeredFor?.name === 'blockCard' || triggeredFor?.name === 'embedCard';
    const isNativeEmbed = triggeredFor?.name === 'extension' && state.selection instanceof (0, $kCECX.NodeSelection) && state.selection.node.attrs?.extensionKey?.includes('native-embed') && (0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience');
    const isHyperlink = triggeredForMark?.name === 'link' && (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    const isAnyLink = isSmartLinkNode || isHyperlink;
    const isBlockSmartLink = (triggeredFor?.name === 'blockCard' || triggeredFor?.name === 'embedCard') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    // For smart link nodes, hyperlinks, and native embeds, we shift the initialPositions to after the parent block
    // (e.g. paragraph) containing the link, or after the block node itself.
    // This to make sure that the streaming content is inserted below the link/embed rather than replacing it.
    if (isNativeEmbed) {
        // extension nodes are block-level: selection.to already points after the node, use it directly.
        const afterNodePos = initialPositions[1];
        initialPositions = [
            afterNodePos,
            afterNodePos
        ];
    } else if (isAnyLink && (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)) {
        // blockCard/embedCard: position is already after the card; inlineCard/hyperlink: use .after() to move past the containing paragraph.
        // Depth 0 means we're already at the top level (e.g. pasted link resolved to an embed), so skip .after() to avoid "no position after the top-level node".
        const $endPos = state.doc.resolve(initialPositions[1]);
        const afterParagraphPos = isBlockSmartLink || $endPos.depth === 0 ? initialPositions[1] : $endPos.after();
        initialPositions = [
            afterParagraphPos,
            afterParagraphPos
        ];
    }
    // No need to expand selection for block nodes, smart link nodes, or hyperlinks
    if (shouldExpandPositions && !triggeredFor?.isBlock && !isAnyLink && (adfStreamingEnabled || aiDecorationExperiencePluginState.isInDocumentStreamingEnabled)) {
        // For external commands respect the current selection
        if (isExternal) {
            const [start, end] = (0, $5b9ec773a9de8641$export$188100af2e354326)({
                selectionPositions: {
                    startPos: state.selection.$from,
                    endPos: state.selection.$to
                },
                /**
         * Currently locale is optional because making it mandatory will require
         * 	big changes across many files and change in public api as well.
         * So we will currently fallback to "en-GB" if it is not provided.
         */ context: {
                    locale: locale ?? 'en-GB',
                    selection: state.selection
                },
                options: {
                    shouldExpandSelectionToCompleteWords: true,
                    shouldExpandSelectionToMediaIfInCaption: true,
                    shouldExpandSelectionToNearestBlockNode: true,
                    shouldTransformCellSelectionToTextRange: true
                }
            });
            initialPositions = [
                start,
                end
            ];
        } else {
            const selectionPositions = decorationPluginStateInitialPositions ? {
                startPos: state.doc.resolve(decorationPluginStateInitialPositions[0]),
                endPos: state.doc.resolve(decorationPluginStateInitialPositions[1])
            } : usePositionOverride && overrideFromPos !== undefined && overrideToPos !== undefined ? {
                startPos: state.doc.resolve(overrideFromPos),
                endPos: state.doc.resolve(overrideToPos)
            } : {
                startPos: state.selection.$from,
                endPos: state.selection.$to
            };
            const [start, end] = (0, $5b9ec773a9de8641$export$188100af2e354326)({
                selectionPositions: selectionPositions,
                /**
         * Currently locale is optional because making it mandatory will require
         * 	big changes across many files and change in public api as well.
         * So we will currently fallback to "en-GB" if it is not provided.
         */ context: {
                    locale: locale ?? 'en-GB',
                    selection: state.selection
                },
                options: {
                    shouldExpandSelectionToCompleteWords: true,
                    shouldExpandSelectionToMediaIfInCaption: true,
                    shouldExpandSelectionToNearestBlockNode: true,
                    shouldTransformCellSelectionToTextRange: true,
                    shouldExpandSelectionToEntireLayout: aiDecorationExperiencePluginState.isInDocumentStreamingEnabled
                }
            });
            initialPositions = [
                start,
                end
            ];
        }
    }
    let modalDecorationSet = (0, $8nvEM.DecorationSet).empty;
    if (triggeredFor?.isBlock && !isBlockSmartLink && !isHyperlink && !isNativeEmbed) {
        // First get the positions that the decorations will be added to the document at
        const decorations = $2332289c5e9e2339$export$4379c9f48a526c4d({
            state: state
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    } else {
        // skipSelectionHighlight keeps the invisible mount-point decorations for
        // anchoring but drops the visible highlight (Post Stream Review modal).
        const decorations = aiDecorationExperiencePluginState.isInDocumentStreamingEnabled ? $2332289c5e9e2339$export$2640287a220c13b0({
            state: state,
            configItem: configItem,
            initialPositions: initialPositions,
            skipSelectionHighlight: skipSelectionHighlight
        }) : $2332289c5e9e2339$export$8b0c0139da7bc378({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: lastTriggeredFrom,
            initialPositions: initialPositions
        });
        if (decorations.length) modalDecorationSet = modalDecorationSet.add(state.doc, decorations);
    }
    // This "command" is later picked up by a state reducer
    const action = {
        type: 'SHOW_MODAL',
        data: {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            interactionSessionId: (0, $03RpJ.default)(),
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            modalDecorationSet: modalDecorationSet,
            configItem: configItem,
            // Omit the timestamp to preserve the mount key (reposition without remount).
            modalMountedTimeStamp: preserveModalMountTimestamp ? undefined : Date.now(),
            initialPrompt: initialPrompt,
            userADFInput: userADFInput,
            triggeredFor: triggeredFor,
            triggeredForMark: triggeredForMark,
            initialPositions: initialPositions,
            initialSelection: aiDecorationExperiencePluginState.initialSelection || state.selection,
            nudgeMetrics: nudgeMetrics,
            withAcceptReject: withAcceptReject,
            withStreamingHighlight: streamingHighlight,
            hideLoadingScreen: hideLoadingScreen,
            traceId: traceId,
            singleInstrumentationId: singleInstrumentationId,
            isCreate: isCreate,
            promptVersion: promptVersion,
            has3pSources: has3pSources,
            sourceProduct: sourceProduct,
            willAISuggestEmoji: willAISuggestEmoji
        }
    };
    if (aiDecorationExperiencePluginState.isInDocumentStreamingEnabled) return (0, $C4yPo.createCommand)(action, (tr)=>{
        // Apply caller edits first so later logic (e.g. the selection-clearing
        // block) sees the mutated doc. `initialPositions` predate that edit, so
        // map them through its steps before resolving them below — otherwise an
        // Undo/Redo that shrinks the doc resolves an out-of-range position and
        // throws. No-op when `beforeTransform` makes no doc changes.
        let bookmarkPositions = initialPositions;
        if (beforeTransform) {
            const stepsBeforeTransform = tr.steps.length;
            tr = beforeTransform(tr);
            const beforeTransformMapping = tr.mapping.slice(stepsBeforeTransform);
            bookmarkPositions = [
                beforeTransformMapping.map(initialPositions[0], 1),
                beforeTransformMapping.map(initialPositions[1], -1)
            ];
        }
        // This is a special use case where we want to clear the selection locally, but inform the collab users that a selection
        // range was selected. The useSelectionBookmarkForRemote will be sent to collab users instead of the local setSelection.
        // We don't want to have a selection range in the editor when we start replacing the content with AI generated content.
        // This is because the FocusLock will keep draging focus away which will break selection ranges.
        // See: https://hello.jira.atlassian.cloud/browse/EDITOR-1090 for more details.
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if ((!triggeredFor?.isBlock || isBlockSmartLink || isHyperlink || isNativeEmbed) && to !== from) {
            tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to));
            // There will be weird selection highlight if we don't clear the selection manually
            // see https://hello.jira.atlassian.cloud/browse/EDITOR-1405
            const domSelection = window.getSelection();
            if (domSelection) domSelection.removeAllRanges();
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) // the orchestrator can send COMPLETE -> COMPLETE so we do this to reset the streaming state
        // and handle new content on the second COMPLETE
        //
        // When `aiSessionContextType` is provided (currently only by
        // `openPostStreamReviewModal`), use it verbatim so the SessionUI lands
        // directly in the Post Stream Review screen instead of the prompt / stream
        // loading flow.
        tr.setMeta((0, $iN8Pe.aiSessionContextPluginKey), aiSessionContextType ?? {
            type: !isExternal && (0, $i2EU6.configItemUsesRovo)(configItem.key) || // Extenal applications can use `openAIModal` without
            (0, $i2EU6.configItemUsesFreeGen)(configItem.key) && isExternal ? 'PROMPT' : 'STREAM'
        });
        // when ai orchestrator endStreamCommand timeout, we need endStream to reset streaming state
        let endStreamCommand = (0, $80W3l.endStream);
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) endStreamCommand = (0, $277Za.endStream);
        return endStreamCommand(tr).setMeta('useSelectionBookmarkForRemote', (0, $kCECX.TextSelection).between(tr.doc.resolve(bookmarkPositions[0]), tr.doc.resolve(bookmarkPositions[1])).getBookmark()).setMeta((0, $iBAu1.selectionPluginKey), {
            action: 'lastSelectionContext',
            selection: selection
        }).setMeta('scrollIntoView', false);
    });
    else // Clear the selection after opening the modal to hide annotation toolbar
    return (0, $C4yPo.createCommand)(action, (tr)=>{
        // See comment on the streaming branch above.
        if (beforeTransform) tr = beforeTransform(tr);
        const selection = tr.selection;
        const { to: to, from: from } = selection;
        if ((!triggeredFor?.isBlock || isBlockSmartLink || isHyperlink || isNativeEmbed) && to !== from) tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to));
        // Same intent as streaming path, but only when Maui inline Rovo UX needs selectionContext
        // (cc-maui-experiment). Avoids persisting context for all non-streaming AI opens.
        if ((0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) return tr.setMeta((0, $iBAu1.selectionPluginKey), {
            action: 'lastSelectionContext',
            selection: selection
        });
        return tr;
    });
};
const $2332289c5e9e2339$export$d547a4e9ddb6b51 = (modalDecorationSet, preserveEditorSelectionOnComplete, shouldClearSelectionContext, shouldIgnoreNextSpaceTrigger)=>{
    return (0, $C4yPo.createCommand)((state)=>{
        if (modalDecorationSet && !preserveEditorSelectionOnComplete) return {
            type: 'END_EXPERIENCE',
            data: {
                modalDecorationSet: modalDecorationSet,
                ignoredSpaceTriggerSelection: shouldIgnoreNextSpaceTrigger ? state.selection : undefined
            }
        };
        return {
            type: 'END_EXPERIENCE',
            data: {
                ignoredSpaceTriggerSelection: shouldIgnoreNextSpaceTrigger ? state.selection : undefined
            }
        };
    }, (tr, state)=>{
        if (preserveEditorSelectionOnComplete) {
            const inlineDeco = modalDecorationSet?.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration')?.[0];
            if (inlineDeco) tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, inlineDeco.from, Math.min(inlineDeco.to, tr.doc.content.size)));
        }
        const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
        if (aiDecorationExperiencePluginState.isInDocumentStreamingEnabled) {
            if (shouldClearSelectionContext === false) tr.setMeta((0, $iBAu1.selectionPluginKey), {
                action: 'lastSelectionContextPending'
            });
            else tr.setMeta((0, $iBAu1.selectionPluginKey), {
                action: 'lastSelectionContext',
                selection: undefined
            });
            let endStreamCommand = (0, $80W3l.endStream);
            if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) endStreamCommand = (0, $277Za.endStream);
            return endStreamCommand((0, $kEjH6.endWatchingAnnotationChanges)(tr));
        }
        return tr;
    });
};
const $2332289c5e9e2339$export$c93852418d091f41 = (state)=>{
    const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
    const modalDecorationSet = aiDecorationExperiencePluginState.modalDecorationSet;
    const selectionDecorations = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-pre-stream-range-selection' || spec.key === 'ai-pre-stream-empty-selection-caret');
    return (0, $C4yPo.createCommand)({
        type: 'UPDATE_MODAL_DECORATION_SET',
        data: {
            modalDecorationSet: modalDecorationSet.remove(selectionDecorations)
        }
    });
};
const $2332289c5e9e2339$export$e580b88af920547a = (state, endWidgetDecorationPosition)=>{
    const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
    const modalDecorationSet = aiDecorationExperiencePluginState.modalDecorationSet;
    const decorationWidget = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'endWidgetDecoration');
    let updated = modalDecorationSet.remove(decorationWidget);
    const updatedEndWidgetDecoration = $2332289c5e9e2339$export$6428b9f2a07e29a5(aiDecorationExperiencePluginState.isInDocumentStreamingEnabled)(endWidgetDecorationPosition, 'end');
    updated = updated.add(state.doc, [
        updatedEndWidgetDecoration
    ]);
    return (0, $C4yPo.createCommand)({
        type: 'UPDATE_MODAL_DECORATION_SET',
        data: {
            modalDecorationSet: updated
        }
    });
};
const $2332289c5e9e2339$export$5df233d57d4cef3c = (sessionId, traceId, promptVersion, agentInfo, isCreateSession, isInlineEditSession, agentAttribution)=>{
    return (0, $C4yPo.createCommand)({
        type: 'START_SESSION',
        data: {
            sessionId: sessionId,
            traceId: traceId,
            promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? promptVersion : undefined,
            agentInfo: agentInfo,
            agentAttribution: agentAttribution
        }
    }, (tr)=>{
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) tr.setMeta((0, $iN8Pe.aiSessionContextPluginKey), {
            type: 'START_SESSION',
            sessionId: sessionId,
            isCreateSession: isCreateSession,
            isInlineEditSession: isInlineEditSession,
            agentAttribution: agentAttribution
        });
        return tr;
    });
};
const $2332289c5e9e2339$export$785a49ccc46447ff = (sessionId)=>{
    return (0, $C4yPo.createCommand)((state)=>{
        const aiDecorationExperiencePluginState = (0, $C4yPo.getPluginState)(state);
        const nextSessionId = aiDecorationExperiencePluginState.nextSessionId;
        // If a sessions which is not the next session is trying to be ended then we should abort trying to end the session.
        if (sessionId !== nextSessionId) return false;
        return {
            type: 'END_SESSION',
            data: {
                sessionId: undefined
            }
        };
    });
};
const $2332289c5e9e2339$export$39f1b50f1a2d2906 = (targetId)=>{
    return (0, $C4yPo.createCommand)({
        type: 'UPDATE_TARGET_ID',
        data: {
            targetId: targetId
        }
    });
};
const $2332289c5e9e2339$export$d8e7ca2a77f99042 = ()=>{
    return (0, $C4yPo.createCommand)({
        type: 'END_INLINE_ROVO_STREAMING'
    });
};
const $2332289c5e9e2339$export$745ae727cdfb0835 = (targetId)=>{
    return (0, $C4yPo.createCommand)({
        type: 'STAGE_INLINE_ROVO_STREAMING',
        data: {
            targetId: targetId
        }
    });
};
const $2332289c5e9e2339$export$4922ec812818240a = ()=>{
    return (0, $C4yPo.createCommand)({
        type: 'COMMIT_INLINE_ROVO_STREAMING'
    });
};
const $2332289c5e9e2339$export$a3db82f0ba5af70a = (targetId)=>{
    return (0, $C4yPo.createCommand)({
        type: 'SHOW_INLINE_EDIT_READY',
        data: {
            targetId: targetId
        }
    });
};
const $2332289c5e9e2339$export$64c35a33b2476aeb = ()=>{
    return (0, $C4yPo.createCommand)({
        type: 'DISMISS_INLINE_EDIT_READY'
    });
};
module.exports["createWidgetDecoration"] = $2332289c5e9e2339$export$6428b9f2a07e29a5;
module.exports["createModalMountPointDecoration"] = $2332289c5e9e2339$export$846ae3cda2c26d54;
module.exports["createInlineDecoration"] = $2332289c5e9e2339$export$1690e22aee311809;
module.exports["createGeneratedContentDecorations"] = $2332289c5e9e2339$export$ee67e3280dab453d;
module.exports["createGeneratedNodeDecorations"] = $2332289c5e9e2339$export$21c5d318062e995c;
module.exports["createOpenAIModalCommand"] = $2332289c5e9e2339$export$2c80ad35b3530be1;
module.exports["createEndAIExperienceCommand"] = $2332289c5e9e2339$export$d547a4e9ddb6b51;
module.exports["clearSelectionDecorations"] = $2332289c5e9e2339$export$c93852418d091f41;
module.exports["createStartAISessionCommand"] = $2332289c5e9e2339$export$5df233d57d4cef3c;
module.exports["createUpdateTargetIdCommand"] = $2332289c5e9e2339$export$39f1b50f1a2d2906;
module.exports["createEndInlineRovoStreamingCommand"] = $2332289c5e9e2339$export$d8e7ca2a77f99042;
module.exports["createStageInlineRovoStreamingCommand"] = $2332289c5e9e2339$export$745ae727cdfb0835;
module.exports["createCommitInlineRovoStreamingCommand"] = $2332289c5e9e2339$export$4922ec812818240a;
module.exports["createShowInlineEditReadyCommand"] = $2332289c5e9e2339$export$a3db82f0ba5af70a;
module.exports["createDismissInlineEditReadyCommand"] = $2332289c5e9e2339$export$64c35a33b2476aeb;

});

parcelRegister("2MofN", function(module, exports) {
// NOTE: The `TRANSLATE_TO_*` member values below intentionally duplicate the
// string values of `SupportedTranslationLanguages` (in `./prompts/translate/types`).
// Under TypeScript's `--isolatedDeclarations`, enum member initializers cannot
// reference external symbols (TS9020), so we cannot write
// `TRANSLATE_TO_FRENCH = \`Translate to ${SupportedTranslationLanguages.French}\``.
// If you add or change a `SupportedTranslationLanguages` value, update the
// matching `TRANSLATE_TO_*` entry here as well. The runtime construction in
// `./prompts/translate/translate.tsx` (`\`Translate to ${language}\``) must
// produce the same strings as these enum values.
var $f6741e9a00157656$export$a48b28ab7ec6401c = /*#__PURE__*/ function(CONFIG_ITEM_KEYS) {
    CONFIG_ITEM_KEYS["ADD_STRUCTURE"] = "Add structure";
    CONFIG_ITEM_KEYS["BRAINSTORM"] = "Brainstorm";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_CASUAL"] = "Change tone to casual";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EDUCATIONAL"] = "Change tone to educational";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_EMPATHETIC"] = "Change tone to empathetic";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_NEUTRAL"] = "Change tone to neutral";
    CONFIG_ITEM_KEYS["CHANGE_TONE_TO_PROFESSIONAL"] = "Change tone to professional";
    CONFIG_ITEM_KEYS["CREATE_PULL_REQUEST_DESCRIPTION"] = "Create pull request description";
    CONFIG_ITEM_KEYS["DESCRIBE_YOUR_PULL_REQUEST"] = "Describe your pull request";
    CONFIG_ITEM_KEYS["FIND_ACTION_ITEMS"] = "Find action items";
    CONFIG_ITEM_KEYS["FIX_SPELLING_AND_GRAMMAR"] = "Fix spelling & grammar";
    CONFIG_ITEM_KEYS["FREE_GENERATE"] = "AI (Atlassian Intelligence)";
    CONFIG_ITEM_KEYS["FREE_GENERATE_EDITOR_AGENT"] = "AI (Atlassian Intelligence) Editor Agent";
    CONFIG_ITEM_KEYS["FREE_GENERATE_AIFC"] = "AI (Atlassian Intelligence) AIFC";
    CONFIG_ITEM_KEYS["IMPROVE_WRITING"] = "Improve writing";
    CONFIG_ITEM_KEYS["MAKE_SHORTER"] = "Make shorter";
    CONFIG_ITEM_KEYS["ROVO_AGENT"] = "Rovo agent";
    CONFIG_ITEM_KEYS["SHORTEN_UPDATE"] = "Shorten update";
    CONFIG_ITEM_KEYS["SUGGEST_A_TITLE"] = "Suggest a title";
    CONFIG_ITEM_KEYS["SUGGEST_RESPONSE"] = "Draft a Reply";
    CONFIG_ITEM_KEYS["DRAFT_REPLY_PILL"] = "Draft a Reply Pill";
    CONFIG_ITEM_KEYS["GENERATE_ESCALATION_NOTES"] = "Generate escalation notes";
    CONFIG_ITEM_KEYS["INCIDENT_SMART_COMMENTS"] = "Incident smart comments";
    CONFIG_ITEM_KEYS["SUGGEST_A_COMMENT"] = "Suggest a comment";
    CONFIG_ITEM_KEYS["SUGGEST_A_REPLY"] = "Suggest a reply";
    CONFIG_ITEM_KEYS["SUMMARISE_WRITING"] = "Summarize writing";
    CONFIG_ITEM_KEYS["SUMMARIZE_SMART_LINK"] = "Summarize smart link";
    CONFIG_ITEM_KEYS["MAKE_LONGER"] = "Make longer";
    CONFIG_ITEM_KEYS["REPHRASE"] = "Rephrase";
    CONFIG_ITEM_KEYS["ADD_INTRODUCTION"] = "Add introduction";
    CONFIG_ITEM_KEYS["ADD_CONCLUSION"] = "Add conclusion";
    CONFIG_ITEM_KEYS["CONVERT_TO_BULLETED_LIST"] = "Convert to bulleted list";
    CONFIG_ITEM_KEYS["CONVERT_TO_TABLE"] = "Convert to table";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_SIMPLIFIED"] = "Translate to chineseSimplified";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_CHINESE_TRADITIONAL"] = "Translate to chineseTraditional";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_CZECH"] = "Translate to czech";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_DANISH"] = "Translate to danish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_DUTCH"] = "Translate to dutch";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_ENGLISH"] = "Translate to english";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_FINNISH"] = "Translate to finnish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_FRENCH"] = "Translate to french";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_GERMAN"] = "Translate to german";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_HUNGARIAN"] = "Translate to hungarian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_ITALIAN"] = "Translate to italian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_JAPANESE"] = "Translate to japanese";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_KOREAN"] = "Translate to korean";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_NORWEGIAN"] = "Translate to norwegian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_POLISH"] = "Translate to polish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_PORTUGUESE_BRAZILIAN"] = "Translate to portugueseBrazilian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_RUSSIAN"] = "Translate to russian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_SPANISH"] = "Translate to spanish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_SWEDISH"] = "Translate to swedish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_TURKISH"] = "Translate to turkish";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_THAI"] = "Translate to thai";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_UKRAINIAN"] = "Translate to ukrainian";
    CONFIG_ITEM_KEYS["TRANSLATE_TO_VIETNAMESE"] = "Translate to vietnamese";
    CONFIG_ITEM_KEYS["EXPERIMENTAL_PROMPT_PLACEHOLDER"] = "Experimental prompt placeholder";
    CONFIG_ITEM_KEYS["ADD_POLISH"] = "Add polish";
    CONFIG_ITEM_KEYS["SMARTLINK_EXTRACT_ACTIONS"] = "Smartlink extract actions";
    CONFIG_ITEM_KEYS["SMARTLINK_EXTRACT_LIST"] = "Smartlink extract list";
    CONFIG_ITEM_KEYS["SMARTLINK_DRAFT_CONTENT"] = "Smartlink draft content";
    return CONFIG_ITEM_KEYS;
}({});
module.exports["CONFIG_ITEM_KEYS"] = $f6741e9a00157656$export$a48b28ab7ec6401c;

});

parcelRegister("gcCwL", function(module, exports) {
// Note -- when updating this function -- also update
// the one used in packages/editor/editor-plugin-ai/examples/utils/getDevFetchCustomHeaders.ts
function $3daa872c01250b9b$export$bd1a8b310b130c9d() {
    const currentHost = window.location.origin;
    switch(true){
        case currentHost === 'https://statlas.prod.atl-paas.net':
            // Update this to add custom headers when run in atlaskit branch deploys
            // ie.
            // {
            //   'X-CloudID': 'Magic string'
            // }
            return {};
        default:
            return {};
    }
}
function $3daa872c01250b9b$export$9167f99f9be83b24() {
    const { origin: origin = '', port: port = '', hostname: hostname = '' } = typeof window.location !== 'undefined' ? window.location : {};
    if (hostname === 'localhost' && port !== '8081' || [
        'atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'statlas.prod.atl-paas.net',
        'atlaskit.atlassian.com'
    ].some((h)=>hostname === h)) return 'https://pug.jira-dev.com';
    return origin;
}
const $3daa872c01250b9b$export$4388fb67ca0987b2 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
const $3daa872c01250b9b$export$fab0701b0fe45e18 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/stream`;
const $3daa872c01250b9b$export$d744f6960955edc2 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/assist/api/ai/v2/ai-feature/editor-ai/should-improve-writing`;
const $3daa872c01250b9b$export$78d8c862f80ca37a = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/ai/v2/ai-feature/editor-ai/should-improve-writing`;
const $3daa872c01250b9b$export$90e6b91c68d8e307 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/assist/rovo/v1/editor/conversation`; // + `/${channelID}/message/stream` at the end;
const $3daa872c01250b9b$export$603c96e42632fe6 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/ai/v2/ai-feature/audit-logs`;
const $3daa872c01250b9b$export$73e2b01807265672 = `${$3daa872c01250b9b$export$9167f99f9be83b24()}/gateway/api/assist/ai/v2/ai-feature/jira/issue/source-type/work-item/suggestions/stream`;
const $3daa872c01250b9b$export$8ee8ab4f2557589a = (endpoint)=>{
    switch(endpoint){
        case $3daa872c01250b9b$export$4388fb67ca0987b2:
            return 'assistance-service';
        case $3daa872c01250b9b$export$fab0701b0fe45e18:
            return 'convo-ai';
        case $3daa872c01250b9b$export$90e6b91c68d8e307:
            return 'rovo-agent';
        case $3daa872c01250b9b$export$603c96e42632fe6:
            return 'audit-logs';
        case $3daa872c01250b9b$export$73e2b01807265672:
            return 'jira-issue-reformatter';
        default:
            return 'unknown-api';
    }
};
module.exports["_getFetchCustomHeaders"] = $3daa872c01250b9b$export$bd1a8b310b130c9d;
module.exports["convoAIApiUrl"] = $3daa872c01250b9b$export$fab0701b0fe45e18;
module.exports["shouldImproveWritingApiUrl"] = $3daa872c01250b9b$export$d744f6960955edc2;
module.exports["shouldImproveWritingCcSmartsApiUrl"] = $3daa872c01250b9b$export$78d8c862f80ca37a;
module.exports["convoAIRovoApiURL"] = $3daa872c01250b9b$export$90e6b91c68d8e307;
module.exports["convoAIAuditLogApiURL"] = $3daa872c01250b9b$export$603c96e42632fe6;
module.exports["jiraIssueReformatterApiURL"] = $3daa872c01250b9b$export$73e2b01807265672;
module.exports["getAPIName"] = $3daa872c01250b9b$export$8ee8ab4f2557589a;

});

parcelRegister("hXIpv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");





var $UL6rM = parcelRequire("UL6rM");

const $477ea3b67256a90b$export$2f25f69a3a44bbd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $33Ze6 = parcelRequire("33Ze6");


var $jtPcJ = parcelRequire("jtPcJ");


var $2MofN = parcelRequire("2MofN");

const $4981f06f2eea25cf$export$f5df73dd633122b = (_options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, $93WrI.aiConfigItemMessages).suggestTitleTitle,
        description: (0, $93WrI.aiConfigItemMessages).suggestTitleDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $477ea3b67256a90b$export$2f25f69a3a44bbd), null),
        intentSchemaId: 'suggest_title_intent_schema.json',
        featureId: 'suggest_title',
        streamsMarkdown: true,
        onMarkdownStreamUpdate: (0, $jtPcJ.replaceConfluenceTitle),
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'secondary'
                }),
                (0, $33Ze6.createInsertAtTop)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $4981f06f2eea25cf$export$42af4e6510e5964c = (options)=>({
        config: $4981f06f2eea25cf$export$f5df73dd633122b(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $4981f06f2eea25cf$export$eb5de8f75f72ed26 = (_options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE,
        title: (0, $93WrI.aiConfigItemMessages).suggestTitleTitle,
        description: (0, $93WrI.aiConfigItemMessages).suggestTitleDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $477ea3b67256a90b$export$2f25f69a3a44bbd), null),
        intentSchemaId: 'suggest_title_intent_schema.json',
        featureId: 'suggest_title',
        streamsMarkdown: true,
        onMarkdownStreamUpdate: (0, $jtPcJ.replaceConfluenceTitle),
        actions: {
            empty: [
                (0, $33Ze6.createReplaceExistingConfluenceTitle)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createReplaceExistingConfluenceTitle)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $4981f06f2eea25cf$export$c844ceeb1848ab8d = (options)=>({
        config: $4981f06f2eea25cf$export$eb5de8f75f72ed26(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["suggestTitleWithOptions"] = $4981f06f2eea25cf$export$42af4e6510e5964c;
module.exports["suggestTitleForConfluenceTitleToolbar"] = $4981f06f2eea25cf$export$eb5de8f75f72ed26;
module.exports["suggestTitleForConfluenceTitleToolbarWithOptions"] = $4981f06f2eea25cf$export$c844ceeb1848ab8d;

});

parcelRegister("93WrI", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ca3f4ef56cdd68e4$export$e990f5ed7dd48de5 = (0, $kSwu1.defineMessages)({
    // Agent config messages
    agentConfigTitle: {
        id: "fabric.editor.ai.config.item.agent.title",
        defaultMessage: "Atlassian Intelligence Rovo Agent"
    },
    agentConfigDescription: {
        id: "fabric.editor.ai.config.item.range.agent.description",
        defaultMessage: "No description"
    },
    agentConfigPromptHint: {
        id: "fabric.editor.ai.config.item.range.agent.prompt.hint",
        defaultMessage: "Tell the Agent to write anything or choose from below"
    },
    // Config action messages
    configActionInsert: {
        id: "fabric.editor.ai.config.item.action.insert",
        defaultMessage: "Insert"
    },
    configActionInsertAtTop: {
        id: "fabric.editor.ai.config.item.action.insertAtTop",
        defaultMessage: "Insert at top"
    },
    configActionInsertBelow: {
        id: "fabric.editor.ai.config.item.action.insertBelow",
        defaultMessage: "Insert below"
    },
    configActionInsertBelowOriginal: {
        id: "fabric.editor.ai.config.item.action.insertBelowOriginal",
        defaultMessage: "Insert below original"
    },
    configActionReplace: {
        id: "fabric.editor.ai.config.item.action.replace",
        defaultMessage: "Replace"
    },
    configActionReplaceTitle: {
        id: "fabric.editor.ai.config.item.action.replaceTitle",
        defaultMessage: "Replace title"
    },
    configActionReplaceTitleTooLongDisabledTooltip: {
        id: "fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip",
        defaultMessage: "Title cannot exceed {maxLength} characters"
    },
    configActionContinueInChatLabel: {
        id: "fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel",
        defaultMessage: "Open in Chat"
    },
    configActionContinueChatLabel: {
        id: "fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel",
        defaultMessage: "Continue in chat"
    },
    configActionEdit: {
        id: "fabric.editor.ai.config.item.action.edit",
        defaultMessage: "Edit"
    },
    // Atlas shorten update messages
    atlasShortenUpdatetitle: {
        id: "fabric.editor.ai.config.item.atlas-shorten-update.title",
        defaultMessage: "Shorten update"
    },
    atlasShortenUpdateDescription: {
        id: "fabric.editor.ai.config.item.atlas-shorten-update.description",
        defaultMessage: "Shortens the content to make it more concise"
    },
    // Brainstorm messages
    brainstormTitle: {
        id: "fabric.editor.ai.config.item.brainstorm.title",
        defaultMessage: "Brainstorm"
    },
    brainstormDescription: {
        id: "fabric.editor.ai.config.item.brainstorm.description",
        defaultMessage: "Generates a list of ideas for a topic you provide"
    },
    brainstormPromptLabel: {
        id: "fabric.editor.ai.config.item.brainstorm.promptLabel",
        defaultMessage: "Brainstorm"
    },
    brainstormPromptHint: {
        id: "fabric.editor.ai.config.item.brainstorm.promptHint",
        defaultMessage: "Tell me the topic..."
    },
    // Adjust Length
    adjustLengthNestingParentTitle: {
        id: "fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle",
        defaultMessage: "Adjust length"
    },
    adjustLengthNestingParentShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle",
        defaultMessage: "Length"
    },
    // Change tone messages
    changeToneNestingParentTitlePostGA: {
        id: "fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA",
        defaultMessage: "Change tone to ..."
    },
    changeToneNeutralToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.title",
        defaultMessage: "Change tone to neutral"
    },
    changeToneNeutralToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle",
        defaultMessage: "Neutral"
    },
    changeToneNeutralToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.description",
        defaultMessage: "Changes the tone of the content to neutral"
    },
    changeToneNeutralToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Neutral"
    },
    changeToneProfessionalToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.title",
        defaultMessage: "Change tone to professional"
    },
    changeToneProfessionalToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle",
        defaultMessage: "Professional"
    },
    changeToneProfessionalToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.description",
        defaultMessage: "Changes the tone of the content to professional"
    },
    changeToneProfessionalToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Professional"
    },
    changeToneCasualToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.title",
        defaultMessage: "Change tone to casual"
    },
    changeToneCasualToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.shortTitle",
        defaultMessage: "Casual"
    },
    changeToneCasualToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.description",
        defaultMessage: "Changes the tone of the content to casual"
    },
    changeToneCasualToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Casual"
    },
    changeToneEducationalToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.title",
        defaultMessage: "Change tone to educational"
    },
    changeToneEducationalToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle",
        defaultMessage: "Educational"
    },
    changeToneEducationalToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.description",
        defaultMessage: "Changes the tone of the content to educational"
    },
    changeToneEducationalToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Educational"
    },
    changeToneEmpatheticToneTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.title",
        defaultMessage: "Change tone to empathetic"
    },
    changeToneEmpatheticToneShortTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle",
        defaultMessage: "Empathetic"
    },
    changeToneEmpatheticToneDescription: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.description",
        defaultMessage: "Changes the tone of the content to empathetic"
    },
    changeToneEmpatheticToneSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title",
        defaultMessage: "Empathetic"
    },
    // Convert to bullet list messages
    convertToBulletListTitle: {
        id: "fabric.editor.ai.config.item.convertToBulletList.title",
        defaultMessage: "Convert to bulleted list"
    },
    convertToBulletListDescription: {
        id: "fabric.editor.ai.config.item.convertToBulletList.description",
        defaultMessage: "Reformats content to a bulleted list"
    },
    // Convert to table messages
    convertToTableTitle: {
        id: "fabric.editor.ai.config.item.convertToTable.title",
        defaultMessage: "Convert to table"
    },
    convertToTableDescription: {
        id: "fabric.editor.ai.config.item.convertToTable.description",
        defaultMessage: "Reformats content to a table with headings"
    },
    // Draft reply messages
    draftReplyTitle: {
        id: "fabric.editor.ai.config.item.draftReply.title",
        defaultMessage: "Draft reply"
    },
    draftReplyDescription: {
        id: "fabric.editor.ai.config.item.draftReply.description",
        defaultMessage: "Drafts a reply based on issues similar to the one you\u2019re working on"
    },
    // Draft reply pill messages
    draftReplyHeroPromptTitle: {
        id: "fabric.editor.ai.config.item.draftReply.heroPromptTitle",
        defaultMessage: "Suggest reply"
    },
    draftReplyHeroPromptDescription: {
        id: "fabric.editor.ai.config.item.draftReply.heroPromptDescription",
        defaultMessage: "Enhances the reply based on issues similar to the one you\u2019re working on"
    },
    // Generate Escalation Notes messages
    generateEscalationNotesTitle: {
        id: "fabric.editor.ai.config.item.generateEscalationNotes.title",
        defaultMessage: "Generate escalation notes"
    },
    generateEscalationNotesDescription: {
        id: "fabric.editor.ai.config.item.generateEscalationNotes.description",
        defaultMessage: "Generates escalation notes based on the issue context"
    },
    // Enhance messages
    improveWritingTitle: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title",
        defaultMessage: "Improve writing"
    },
    fixSpellingGrammarTitle: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title",
        defaultMessage: "Fix spelling & grammar"
    },
    improveWritingDescription: {
        id: "fabric.editor.ai.config.item.enhance.improveWriting.description",
        defaultMessage: "Enhances clarity, structure, and tone for better engagement and comprehension"
    },
    fixSpellingGrammarDescription: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description",
        defaultMessage: "Fixes spelling and grammar mistakes"
    },
    fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title",
        defaultMessage: "Spelling & grammar"
    },
    // Find action items messages
    findActionItemsTitle: {
        id: "fabric.editor.ai.config.item.findActionItems.title",
        defaultMessage: "Find action items"
    },
    findActionItemsDescription: {
        id: "fabric.editor.ai.config.item.findActionItems.description",
        defaultMessage: "Finds action items in the content you provide"
    },
    // Free generate messages
    freeGeneratePromptHint: {
        id: "fabric.editor.ai.config.item.generateContent.promptHint",
        defaultMessage: "Write with AI or select from below"
    },
    freeGenerateRovoPromptHint: {
        id: "fabric.editor.ai.config.item.generateContent.rovoPromptHint",
        defaultMessage: "Write with Rovo or select from below"
    },
    // Free generate disabled messages
    freeGenerateDisabledPromptHint: {
        id: "fabric.editor.ai.config.item.freeGenerate.disabled.promptHint",
        defaultMessage: "Select from below (free generate is disabled in Elevate at this time)"
    },
    // Improve description messages
    reformatWithTemplateDescription: {
        id: "fabric.editor.ai.config.item.improveDescription.default.description",
        defaultMessage: "Restructure the issue description based on the issue type"
    },
    improveDescription: {
        id: "fabric.editor.ai.config.item.improveDescription.default.title.experiment.one",
        defaultMessage: "Improve description"
    },
    // Remix messages
    remixTitle: {
        id: "fabric.editor.ai.config.item.remix.title",
        defaultMessage: "Remix"
    },
    // Make longer messages
    makeLongerTitle: {
        id: "fabric.editor.ai.config.item.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeLongerDescription: {
        id: "fabric.editor.ai.config.item.makeLonger.description",
        defaultMessage: "Expands the content based on the context you provide"
    },
    // Make shorter messages
    makeShorterTitle: {
        id: "fabric.editor.ai.config.item.shorten.title",
        defaultMessage: "Make shorter"
    },
    makeShorterDescription: {
        id: "fabric.editor.ai.config.item.shorten.description",
        defaultMessage: "Shortens the content to make it more concise"
    },
    makeShorterSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title",
        defaultMessage: "Make shorter"
    },
    // PR Description messages
    prDescriptionTitle: {
        id: "fabric.editor.ai.config.item.bb.pr.description.title",
        defaultMessage: "Create pull request description"
    },
    prDescriptionDescription: {
        id: "fabric.editor.ai.config.item.bb.pr.description.description",
        defaultMessage: "Creates a pull request description with a summary of changes"
    },
    // Rephrase messages
    rephraseTitle: {
        id: "fabric.editor.ai.config.item.rephrase.title",
        defaultMessage: "Rephrase"
    },
    rephraseDescription: {
        id: "fabric.editor.ai.config.item.rephrase.description",
        defaultMessage: "Creates a suggestion for rewriting your sentences"
    },
    // Suggest a comment messages
    suggestCommentTitle: {
        id: "fabric.editor.ai.config.item.suggestComment.title",
        defaultMessage: "Suggest a comment"
    },
    suggestCommentDescription: {
        id: "fabric.editor.ai.config.item.suggestComment.description",
        defaultMessage: "Get an AI-suggested comment based on this work item"
    },
    // Suggest a reply messages
    suggestReplyTitle: {
        id: "fabric.editor.ai.config.item.suggestReply.title",
        defaultMessage: "Suggest a reply"
    },
    suggestReplyDescription: {
        id: "fabric.editor.ai.config.item.suggestReply.description",
        defaultMessage: "Get an AI-suggested reply to this comment"
    },
    // Suggest title messages
    suggestTitleTitle: {
        id: "fabric.editor.ai.config.item.suggest.title",
        defaultMessage: "Suggest a title"
    },
    suggestTitleDescription: {
        id: "fabric.editor.ai.config.item.suggest.description",
        defaultMessage: "Suggests a title for content you provide"
    },
    // Summarize writing messages
    summarizeWritingtitle: {
        id: "fabric.editor.ai.config.item.summarize.title",
        defaultMessage: "Summarize writing"
    },
    summarizeWritingDescription: {
        id: "fabric.editor.ai.config.item.summarize.description",
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points"
    },
    summarizeWritingSelectionToolbarDropdownItemTitle: {
        id: "fabric.editor.ai.config.item.summarize.dropdownItem.title",
        defaultMessage: "Summarize writing"
    },
    addPolishDescription: {
        id: "fabric.editor.ai.config.item.addPolish.description",
        defaultMessage: "Polishes the content to make it more polished"
    },
    improveFormattingTitle: {
        id: "fabric.editor.ai.config.item.improveFormatting.title",
        defaultMessage: "Improve formatting"
    },
    improveFormattingDescription: {
        id: "fabric.editor.ai.config.item.improveFormatting.description",
        defaultMessage: "Improves the formatting and presentation of your content"
    }
});
module.exports["aiConfigItemMessages"] = $ca3f4ef56cdd68e4$export$e990f5ed7dd48de5;

});

parcelRegister("33Ze6", function(module, exports) {

var $93WrI = parcelRequire("93WrI");


var $8tXCb = parcelRequire("8tXCb");


var $hZ5o2 = parcelRequire("hZ5o2");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $9XB2W = parcelRequire("9XB2W");


var $9qe1v = parcelRequire("9qe1v");


var $cozmU = parcelRequire("cozmU");


var $8F1y0 = parcelRequire("8F1y0");

const $a6418f38d85834f5$export$d91f61e80e507e8e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8F1y0))), {
        label: "",
        spacing: "spacious"
    });






var $3AeSY = parcelRequire("3AeSY");

const $792b86b726fc5e98$export$d8090035f79e82b5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3AeSY))), {
        label: "",
        spacing: "spacious"
    });



var $7qHrr = parcelRequire("7qHrr");

const $e532a25fa3bb821c$export$9e309baaf0e9d41b = ({ appearance: appearance, insertedContentNodeTransformer: insertedContentNodeTransformer })=>({
        type: 'markdown',
        title: (0, $93WrI.aiConfigItemMessages).configActionInsertAtTop,
        appearance: appearance,
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            const slice = new (0, $aPdNQ.Slice)(pmFragment, 0, 0);
            transaction.replace(0, 0, slice);
            (0, $7qHrr.beforeDispatchAITransaction)(transaction, state, insertedContentNodeTransformer);
            editorView.dispatch(transaction);
        },
        icon: (0, $792b86b726fc5e98$export$d8090035f79e82b5)
    });
const $e532a25fa3bb821c$export$2a99e23257616a3 = ({ appearance: appearance, insertedContentNodeTransformer: insertedContentNodeTransformer, factoryOptions: factoryOptions })=>({
        type: 'markdown',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $93WrI.aiConfigItemMessages).configActionInsertBelowOriginal : (0, $93WrI.aiConfigItemMessages).configActionInsertBelow,
        appearance: appearance,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, triggeredFor: triggeredFor }) {
            const { state: state } = editorView;
            const transaction = state.tr;
            if ((0, $8tXCb.fragmentContainsNodeType)(pmFragment, state.schema.nodes.table) && (0, $7qHrr.shouldInsertAfterTable)({
                selection: state.selection,
                tableSchema: state.schema.nodes.table
            }) && (0, $hZ5o2.isNestedTablesSupported)(state.schema)) (0, $7qHrr.insertContentAfterTable)({
                pmFragment: pmFragment,
                transaction: transaction
            });
            else if (triggeredFor?.isBlock) {
                const insertPos = positions[1];
                (0, $bjg0G.safeInsert)(pmFragment, insertPos)(transaction);
                (0, $7qHrr.beforeDispatchingTransactionForBlocks)(pmFragment, transaction, editorView.state);
            } else {
                let insertPos;
                /* eslint-disable no-unused-vars */ try {
                    insertPos = state.doc.resolve(positions[1]).after();
                } catch (error) {
                    insertPos = positions[1];
                }
                /* eslint-enable no-unused-vars */ (0, $bjg0G.safeInsert)(pmFragment, insertPos)(transaction);
            }
            (0, $7qHrr.beforeDispatchAITransaction)(transaction, state, insertedContentNodeTransformer);
            editorView.dispatch(transaction);
        },
        icon: (0, $a6418f38d85834f5$export$d91f61e80e507e8e)
    });
const $e532a25fa3bb821c$export$6641dbc1b651cf28 = ({ appearance: appearance, insertedContentNodeTransformer: insertedContentNodeTransformer, isRovoAgentAction: isRovoAgentAction, title: title = (0, $93WrI.aiConfigItemMessages).configActionInsert })=>({
        type: 'markdown',
        title: title,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
            const tr = (0, $7qHrr.insertAIContentAtCurrentPosition)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                insertedContentNodeTransformer: insertedContentNodeTransformer
            });
            if (isRovoAgentAction) (0, $7qHrr.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        },
        icon: (0, $a6418f38d85834f5$export$d91f61e80e507e8e)
    });
const $e532a25fa3bb821c$export$ab7194c13d7567bc = ({ appearance: appearance, insertedContentNodeTransformer: insertedContentNodeTransformer, isRovoAgentAction: isRovoAgentAction })=>({
        type: 'markdown',
        title: (0, $93WrI.aiConfigItemMessages).configActionReplace,
        appearance: appearance,
        isRovoAgentAction: isRovoAgentAction,
        run ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, triggeredFor: triggeredFor }) {
            const tr = triggeredFor?.isBlock ? (0, $7qHrr.replaceWithAIContentForBlock)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                insertedContentNodeTransformer: insertedContentNodeTransformer
            }) : (0, $7qHrr.replaceWithAIContent)({
                editorView: editorView,
                positions: positions,
                pmFragment: pmFragment,
                selectionMetaData: selectionMetaData,
                insertedContentNodeTransformer: insertedContentNodeTransformer
            });
            if (isRovoAgentAction) (0, $7qHrr.beforeDispatchAIRovoAgentTransaction)(tr);
            editorView.dispatch(tr);
        }
    });
const $e532a25fa3bb821c$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({
        type: 'markdown',
        title: (0, $93WrI.aiConfigItemMessages).configActionReplaceTitle,
        appearance: appearance,
        getDisabledState: ({ markdown: markdown, formatMessage: formatMessage })=>{
            const responseLength = markdown?.length ?? 0;
            // Source: next/packages/editor-title/src/EditorTitle.tsx
            const MAX_TITLE_LENGTH = 255;
            if (responseLength >= MAX_TITLE_LENGTH) return {
                isDisabled: true,
                tooltip: formatMessage((0, $93WrI.aiConfigItemMessages).configActionReplaceTitleTooLongDisabledTooltip, {
                    maxLength: MAX_TITLE_LENGTH
                })
            };
            return {
                isDisabled: false
            };
        },
        run ({ editorView: editorView, pmFragment: pmFragment }) {
            const fragmentToInsert = pmFragment;
            let textContent = '';
            fragmentToInsert.forEach((node)=>{
                textContent += node.textContent;
            });
            const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
            if (confluenceTitle) {
                const sourceEditorId = (0, $9qe1v.findEditorIdFromView)(editorView);
                if (sourceEditorId) (0, $9XB2W.eventHub).publishFromEditor({
                    event: 'replace title in confluence',
                    data: {
                        analyticSourceId: 'confluenceTitleToolbar',
                        sourceEditorId: sourceEditorId,
                        title: textContent
                    }
                });
                confluenceTitle.scrollIntoView();
            }
        }
    });
module.exports["createInsertAtTop"] = $e532a25fa3bb821c$export$9e309baaf0e9d41b;
module.exports["createInsertBelow"] = $e532a25fa3bb821c$export$2a99e23257616a3;
module.exports["createInsertAtCurrentPosition"] = $e532a25fa3bb821c$export$6641dbc1b651cf28;
module.exports["createReplace"] = $e532a25fa3bb821c$export$ab7194c13d7567bc;
module.exports["createReplaceExistingConfluenceTitle"] = $e532a25fa3bb821c$export$bac6a2ed25caf91c;

});

parcelRegister("5PpGs", function(module, exports) {
const $53f51bb6cc7b0554$export$9611928cf0c457d7 = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSW':
            return 'jira-software';
        case 'JWM':
            return 'jira-core';
        case 'JSM':
            return 'jsm';
        case 'JPD':
            return 'jpd';
        case 'CSM':
            return 'csm';
        case 'ATLAS':
            return 'atlas';
        case 'JIRA_FAMILY':
            return 'jira';
        case 'BITBUCKET':
            return 'bitbucket';
        case 'TRELLO':
            return 'trello';
        case 'ELEVATE':
            return 'elevate';
        case 'RECRUIT':
            return 'recruit';
        case 'MERCURY':
            return 'mercury';
        case 'TOWNSQUARE':
            return 'townsquare';
        case 'ADMINHUB':
            return 'admin-hub';
        case 'GOAL':
            return 'goal';
        case 'PROJECT':
            return 'project';
        default:
            return 'unknown';
    }
};
module.exports["mapToAssistanceServiceProduct"] = $53f51bb6cc7b0554$export$9611928cf0c457d7;

});

parcelRegister("iO5TS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");


var $cFvoT = parcelRequire("cFvoT");





var $74BSk = parcelRequire("74BSk");

const $7b3b134bb629d8b5$export$34a519f008c9006c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($74BSk))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });








const $e041f82b903fbc15$export$1be00499caf729a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $3c01574b22fc1734$export$144a75c8acc1ab6b = (options)=>{
    const featureId = 'improve_writing_adf_gpt41mini';
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).IMPROVE_WRITING,
        title: (0, $93WrI.aiConfigItemMessages).improveWritingTitle,
        description: (0, $93WrI.aiConfigItemMessages).improveWritingDescription,
        icon: ({ formatMessage: formatMessage })=>options?.isInDocumentStreamingEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))), {
                label: formatMessage((0, $93WrI.aiConfigItemMessages).improveWritingTitle),
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e041f82b903fbc15$export$1be00499caf729a1), null),
        intentSchemaId: 'improve_quality_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        requiresTextualContent: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        canToggleDiffPreview: true
    };
};
const $3c01574b22fc1734$export$d332380ea195650 = (options)=>({
        config: $3c01574b22fc1734$export$144a75c8acc1ab6b(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $3c01574b22fc1734$export$f6fbbd65001c33d0 = ()=>{
    const featureId = 'fix_spelling_grammar_adf_gpt41mini';
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FIX_SPELLING_AND_GRAMMAR,
        title: (0, $93WrI.aiConfigItemMessages).fixSpellingGrammarTitle,
        description: (0, $93WrI.aiConfigItemMessages).fixSpellingGrammarDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b3b134bb629d8b5$export$34a519f008c9006c), null),
        intentSchemaId: 'grammar_spelling_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        requiresTextualContent: true,
        actions: {
            empty: [
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    };
};
const $3c01574b22fc1734$export$76de7c1ccbf13f30 = (options)=>({
        config: $3c01574b22fc1734$export$f6fbbd65001c33d0(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["improveWriting"] = $3c01574b22fc1734$export$144a75c8acc1ab6b;
module.exports["improveWritingWithOptions"] = $3c01574b22fc1734$export$d332380ea195650;
module.exports["fixSpellingAndGrammar"] = $3c01574b22fc1734$export$f6fbbd65001c33d0;
module.exports["fixSpellingAndGrammarWithOptions"] = $3c01574b22fc1734$export$76de7c1ccbf13f30;

});

parcelRegister("9kYSx", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

var $jTt8P = parcelRequire("jTt8P");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");

const $afac6c02555bf4f5$var$DEFAULT_TARGET_COMPLETION_MS = 2000;
const $afac6c02555bf4f5$var$DEFAULT_ADJUST_INTERVAL_MS = 1000;
class $afac6c02555bf4f5$var$Count {
    eq(other) {
        return this.chars === other.chars && this.length === other.length;
    }
    sub(other) {
        return new $afac6c02555bf4f5$var$Count(this.chars - other.chars, this.length - other.length);
    }
    gte(other) {
        return this.chars >= other.chars && this.length >= other.length;
    }
    constructor(chars, length){
        this.chars = chars;
        this.length = length;
    }
}
class $afac6c02555bf4f5$export$1511b8f647c790e {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setEmit(emit) {
        this.emit = emit;
    }
    setTickMs(tickMs) {
        this.cfg.tickMs = tickMs;
    }
    setCharsPerTick(charsPerTick) {
        this.charsPerTick = charsPerTick;
    }
    setMaxCharsPerTick(maxCharsPerTick) {
        this.cfg.maxCharsPerTick = maxCharsPerTick;
    }
    /**
   * you need to call setEmit before calling start
   *
   * @example
   * streamFlowPacer.setEmit();
   * streamFlowPacer.start();
   */ start() {
        if (this.destroyed) return;
        if (this.emit) this.timer = setInterval(()=>this.tick(), this.cfg.tickMs);
    }
    pause() {
        this.paused = true;
        this.stop();
    }
    resume() {
        this.paused = false;
        this.start();
    }
    destroy() {
        this.reset();
        this.destroyed = true;
    }
    onComplete(handler) {
        this.onCompleteHandlers.push(handler);
    }
    /**
   * Register a handler that fires exactly once per stream, when the pacer
   * finishes draining and emits a `complete` / `response too similar` terminal
   * event. The handler receives the timing gap (in milliseconds) between when
   * the backend finished streaming (the terminal event was pushed) and when the
   * pacer actually finished draining, plus useful context for analytics.
   */ onPacerCompletionGap(handler) {
        this.onPacerCompletionGapHandlers.push(handler);
    }
    reset() {
        this.stop();
        this.emit = null;
        this.streamEvt = null;
        this.terminalEvt = null;
        this.charsPerTick = this.cfg.initialCharsPerTick;
        this.delivered = new $afac6c02555bf4f5$var$Count(0, 0);
        this.prevTickTime = 0;
        this.currTickTime = 0;
        this.ticksSinceRamp = 0;
        this.ramped = 0;
        this.paused = false;
        this.destroyed = false;
        this.onCompleteHandlers.length = 0;
        this.onPacerCompletionGapHandlers.length = 0;
        this.ticksSinceAdjust = 0;
        this.hasAdjusted = false;
        this.terminalPushedAt = null;
        this.backlogCharsAtTerminal = 0;
    }
    isRunning() {
        return this.timer !== null;
    }
    stop() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
    tick() {
        this.prevTickTime = this.currTickTime;
        this.currTickTime = Date.now();
        if (this.paused || !(this.streamEvt || this.terminalEvt)) return;
        if ((0, $iDrrr.fg)('platform_editor_ai_streaming_backlog_pacing')) this.maybeAdjustForBacklog();
        else this.maybeRamp();
        this.deliverChunk();
        this.maybeFlushTerminal();
    }
    /**
   * Backlog-driven pacing. On a fixed cadence (`adjustIntervalMs`, default 1s)
   * recompute the minimum `charsPerTick` needed to drain the current backlog
   * within `targetCompletionMs` (default 2s) and raise `charsPerTick` to it.
   *
   * This runs independently of whether the terminal/complete event has arrived,
   * so the pacer keeps up while the backend is still streaming fast and finishes
   * promptly once the backend stops. `charsPerTick` is never decreased, so a
   * normal/slow stream keeps its smooth typewriter feel.
   */ maybeAdjustForBacklog() {
        const adjustIntervalMs = this.cfg.adjustIntervalMs ?? $afac6c02555bf4f5$var$DEFAULT_ADJUST_INTERVAL_MS;
        const ticksPerAdjust = Math.max(1, Math.round(adjustIntervalMs / this.cfg.tickMs));
        // Adjust on the very first eligible tick (so we start converging immediately
        // rather than waiting a whole interval), then on every `ticksPerAdjust`
        // cadence thereafter.
        if (this.hasAdjusted && this.ticksSinceAdjust < ticksPerAdjust) {
            this.ticksSinceAdjust++;
            return;
        }
        this.ticksSinceAdjust = 0;
        this.hasAdjusted = true;
        const required = this.computeDeadlineCharsPerTick();
        if (required > this.charsPerTick) this.charsPerTick = required;
    }
    /**
   * Minimum `charsPerTick` required to drain the current backlog within
   * `targetCompletionMs`, based on how many ticks fit in that window.
   */ computeDeadlineCharsPerTick() {
        const backlogChars = this.backlog().chars;
        if (backlogChars <= 0) return this.charsPerTick;
        const targetCompletionMs = this.cfg.targetCompletionMs ?? $afac6c02555bf4f5$var$DEFAULT_TARGET_COMPLETION_MS;
        const ticksRemaining = Math.max(1, Math.floor(targetCompletionMs / this.cfg.tickMs));
        return Math.ceil(backlogChars / ticksRemaining);
    }
    deliverChunk() {
        if (!this.streamEvt) return;
        const total = this.semanticLen(this.streamEvt);
        if (this.delivered.gte(total)) return;
        let slice;
        if (this.prevTickTime > 0 && this.currTickTime > 0 && this.currTickTime - this.prevTickTime >= 3000) // If it's been more than 3 seconds since last tick,
        // assume the tab is in background, so we flush everything
        slice = this.sliceStreamEvt(this.streamEvt, -1);
        else if (this.delivered.chars >= total.chars && this.delivered.length < total.length) // No more text chars can be found we should flush the entire latest response
        slice = this.sliceStreamEvt(this.streamEvt, -1);
        else slice = this.sliceStreamEvt(this.streamEvt, Math.min(this.delivered.chars + this.charsPerTick, total.chars));
        if (!slice) return;
        this.emit?.(slice);
        this.delivered = this.semanticLen(slice);
        if (this.delivered.eq(total) && !!this.onCompleteHandlers.length && !(0, $ieeJu.expValEquals)('platform_editor_fix_ai_streaming_race', 'isEnabled', true)) {
            this.onCompleteHandlers.forEach((handler)=>handler());
            this.onCompleteHandlers.length = 0;
        }
    }
    canFlushTerminal() {
        if (!this.terminalEvt) return false;
        // For "complete" we must wait until every char is flushed
        // For mock, the final response can be less than the sum of previous responses, so backlog can be negative
        if (this.terminalEvt.type === 'complete' || this.terminalEvt.type === 'response too similar') return this.backlog().chars <= 0;
        // All other terminal kinds (error, abort, etc.) bypass the backlog
        return true;
    }
    maybeFlushTerminal() {
        if (!this.canFlushTerminal()) return;
        if (this.terminalEvt) {
            const terminalEvt = this.terminalEvt;
            this.emit?.(terminalEvt);
            if ((0, $ieeJu.expValEquals)('platform_editor_fix_ai_streaming_race', 'isEnabled', true)) {
                this.onCompleteHandlers.forEach((handler)=>handler());
                this.onCompleteHandlers.length = 0;
            }
            this.firePacerCompletionGap(terminalEvt);
            this.destroy();
        }
    }
    /**
   * Fire the completion-gap analytics callback once, capturing the lag between
   * the backend finishing its stream and the pacer finishing draining it. Must
   * be called before `destroy()`/`reset()` clears the captured timing state.
   */ firePacerCompletionGap(terminalEvt) {
        if (!this.onPacerCompletionGapHandlers.length || this.terminalPushedAt === null) return;
        const info = {
            backendEndToPacerCompleteMs: Date.now() - this.terminalPushedAt,
            backlogCharsAtBackendEnd: this.backlogCharsAtTerminal,
            charsPerTickAtComplete: this.charsPerTick,
            terminalType: terminalEvt.type
        };
        this.onPacerCompletionGapHandlers.forEach((handler)=>handler(info));
        this.onPacerCompletionGapHandlers.length = 0;
    }
    maybeRamp() {
        if (!this.shouldRamp()) {
            this.ticksSinceRamp++;
            return;
        }
        this.charsPerTick = Math.min(Math.ceil(this.charsPerTick * this.cfg.ramp.growthFactor), this.cfg.maxCharsPerTick);
        this.ticksSinceRamp = 0;
        this.ramped++;
    }
    shouldRamp() {
        const wait = this.secondsToTicks(this.getRampDelay(this.cfg.ramp, this.ramped, this.terminalEvt));
        return (this.backlog().chars > this.cfg.backlogRampThreshold || this.terminalEvt?.type === 'response too similar') && this.ticksSinceRamp >= wait && this.charsPerTick < this.cfg.maxCharsPerTick;
    }
    backlog() {
        if (!this.streamEvt) return new $afac6c02555bf4f5$var$Count(0, 0);
        const result = this.semanticLen(this.streamEvt);
        return result.sub(this.delivered);
    }
    getRampDelay(rampConfig, rampedCnt, response) {
        if (response?.type === 'response too similar') return rampConfig.flushDelaySec;
        return rampedCnt > 0 ? rampConfig.stepDelaySec : rampConfig.initialDelaySec;
    }
    secondsToTicks(sec) {
        return sec * 1000 / this.cfg.tickMs;
    }
    semanticLen(evt) {
        if (!!evt.markdown && typeof evt.markdown === 'string') return new $afac6c02555bf4f5$var$Count(evt.markdown.length, evt.markdown.length);
        return this.adfTextLen(evt.adfResponse);
    }
    /**
   *
   * @param evt
   * @param chars
   * @returns
   */ sliceStreamEvt(evt, chars) {
        if (evt.adfResponse) {
            if (chars < 0) return {
                ...evt,
                adfResponse: this.filterIncompleteNodes(evt.adfResponse)
            };
            return {
                ...evt,
                adfResponse: this.truncateAdf(evt.adfResponse, chars)
            };
        }
        if (evt.markdown?.length) return {
            ...evt,
            markdown: evt.markdown.slice(0, chars < 0 ? undefined : chars)
        };
        return null;
    }
    adfTextLen(root) {
        if (!root) return new $afac6c02555bf4f5$var$Count(0, 0);
        const { chars: chars, length: length } = (0, $4EPzQ.reduce)(root, (result, node)=>node.type === 'text' && typeof node.text === 'string' ? {
                chars: result.chars + node.text.length,
                length: result.length + node.text.length + 2
            } : {
                chars: result.chars,
                length: result.length + 2
            }, {
            chars: 0,
            length: 0
        });
        return new $afac6c02555bf4f5$var$Count(chars, length);
    }
    /**
   * Sometimes the localID is a UUID with 36 characters (8-4-4-4-12 with dashes).
   * Sometimes it's a 12 character string.
   * So we validate the length and the presence of dashes.
   */ static isValidLocalId(value) {
        return typeof value === 'string' && (value.includes('-') ? value.length >= 36 : value.length === 12);
    }
    /**
   * Lightweight filter for the flush path (chars < 0).
   * Drops bodiedSyncBlock nodes with invalid localId.
   * This is used to ensure the structure is not emitted until the localId is complete.
   */ filterIncompleteNodes(root) {
        return (0, $jTt8P.traverse)(root, {
            bodiedSyncBlock: (node)=>{
                if (node.type === 'bodiedSyncBlock') {
                    if (!this.processedSyncBlockLocalId.includes(node.attrs?.localId)) return false;
                    return;
                }
            }
        });
    }
    truncateAdf(root, budget) {
        let remaining = Math.max(0, budget);
        /**
     * Some older browsers like chrome 97 doesn't support structuredClone.
     * So using JSON.parse(JSON.stringify()) as a fallback.
     */ const clone = typeof window !== 'undefined' && typeof window.structuredClone === 'function' ? structuredClone(root) : JSON.parse(JSON.stringify(root));
        let lastTableRowLocalId;
        let remainingMergedRows = 1;
        return (0, $jTt8P.traverse)(clone, {
            any: (node, parent)=>{
                //Drop bodiedSyncBlock nodes with invalid localId.
                if (node.type === 'bodiedSyncBlock') {
                    if (!this.processedSyncBlockLocalId.includes(node.attrs?.localId)) {
                        //if it has an invalid local id, we mark it as pending
                        if (!$afac6c02555bf4f5$export$1511b8f647c790e.isValidLocalId(node.attrs?.localId)) return false;
                        else {
                            this.processedSyncBlockLocalId.push(node.attrs?.localId);
                            return;
                        }
                    // we've seen this before, we are emitting it
                    } else return;
                }
                if (node.type === 'tableCell' || node.type === 'tableHeader') // merge information is stored inside cells, so we keep track of the largest rowspan we encounter
                remainingMergedRows = Math.max(remainingMergedRows, node.attrs?.rowspan || 1);
                // We subtract the 'merged rows' count as we encounter rows
                if (remainingMergedRows > 0 && node.type === 'tableRow') remainingMergedRows--;
                if (node.type === 'tableRow') /**
           * Upon parsing a table row, we mark it as seen using the localId
           * so we can check when descending into the node whether to keep the row structure
           * or drop it entirely (if no chars are remaining when entering a table row)
           */ lastTableRowLocalId = node.attrs?.localId;
                if (remaining === 0) {
                    if (node.type === 'tableRow') {
                        if (remainingMergedRows === 0) return false;
                        return;
                    }
                    let ancestor = parent;
                    while(ancestor){
                        if (ancestor?.node?.type === 'tableRow') {
                            if (// if we're in the middle of a table row that has been parsed, we want to keep the rest of the cells
                            ancestor.node?.attrs?.localId === lastTableRowLocalId || // if there are still merged rows to be processed, we want to keep the following rows and cells too
                            remainingMergedRows > 0) {
                                if (node.type === 'tableCell' || node.type === 'tableHeader') /**
                   * We return all cells in the current row that's being streamed to
                   * ensure the table row structure is maintained.
                   * We also keep table cell structures if there are still merged rows to be processed.
                   */ return {
                                    ...node,
                                    content: [
                                        {
                                            type: 'paragraph',
                                            content: []
                                        }
                                    ]
                                };
                                // keep empty paragraphs to make tableCell and tableHeader valid
                                if (node.type === 'paragraph' && node.content?.length === 0) return;
                                return false;
                            }
                            return false;
                        }
                        ancestor = ancestor.parent;
                    }
                    return false;
                }
                if (node.type !== 'text' || typeof node.text !== 'string') return;
                if (node.text.length <= remaining) {
                    remaining -= node.text.length;
                    return;
                }
                const text = node.text.slice(0, remaining);
                remaining = 0;
                return {
                    ...node,
                    text: text
                };
            }
        });
    }
    constructor(cfg){
        this.cfg = cfg;
        this.push = (evt)=>{
            if (evt.type === 'stream') this.streamEvt = evt;
            else {
                this.terminalEvt = evt;
                // Record when the backend finished streaming (terminal event arrived) so we
                // can measure the gap until the pacer actually finishes draining. Only the
                // first terminal event is recorded for a given stream.
                if (this.terminalPushedAt === null) {
                    this.terminalPushedAt = Date.now();
                    this.backlogCharsAtTerminal = this.backlog().chars;
                }
            }
        };
        this.timer = null;
        this.streamEvt = null;
        this.terminalEvt = null;
        this.charsPerTick = void 0;
        this.delivered = new $afac6c02555bf4f5$var$Count(0, 0);
        this.prevTickTime = 0;
        this.currTickTime = 0;
        this.ticksSinceRamp = 0;
        this.ramped = 0;
        this.paused = false;
        this.destroyed = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.emit = null;
        this.onCompleteHandlers = [];
        this.onPacerCompletionGapHandlers = [];
        this.processedSyncBlockLocalId = [];
        // Number of ticks since the backlog-based deadline adjustment last ran.
        this.ticksSinceAdjust = 0;
        // Whether the backlog-based deadline adjustment has run at least once for the
        // current stream (so the first adjustment can fire immediately).
        this.hasAdjusted = false;
        // Timestamp (ms) when the backend's terminal event was first pushed. `null`
        // until a terminal event arrives.
        this.terminalPushedAt = null;
        // Backlog (chars) at the moment the backend's terminal event arrived.
        this.backlogCharsAtTerminal = 0;
        this.charsPerTick = cfg.initialCharsPerTick;
    }
}
module.exports["StreamFlowPacer"] = $afac6c02555bf4f5$export$1511b8f647c790e;

});

parcelRegister("iTW08", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");


var $7Jde4 = parcelRequire("7Jde4");


var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $f230909c1ab903f4$export$aa2f740770614b48 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).ADD_POLISH,
        title: (0, $93WrI.aiConfigItemMessages).improveFormattingTitle,
        description: (0, $93WrI.aiConfigItemMessages).addPolishDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
                label: ""
            }),
        showInRefineDropdown: true,
        /**
   * Polish prompt doesn't exist in assistance-service, so using shorten_intent_schema.json.
   * Once migration to convo-ai is complete, we will remove intentShemaId option.
   */ intentSchemaId: 'shorten_intent_schema.json',
        featureId: 'add_polish_adf',
        adfPrompt: true,
        requiresTextualContent: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $f230909c1ab903f4$export$2e578cc386d5ec11 = (options)=>({
        config: $f230909c1ab903f4$export$aa2f740770614b48(),
        triggers: {
            empty: {
                enabled: options?.isInDocumentStreamingEnabled ?? false,
                docMinSize: 1
            },
            selection: {
                enabled: options?.isInDocumentStreamingEnabled ?? false,
                selectionMinSize: 1
            }
        }
    });
module.exports["addPolish"] = $f230909c1ab903f4$export$aa2f740770614b48;
module.exports["addPolishWithOptions"] = $f230909c1ab903f4$export$2e578cc386d5ec11;

});

parcelRegister("3JPgn", function(module, exports) {
// Entry file
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8nzB4 = parcelRequire("8nzB4");


var $c4mdU = parcelRequire("c4mdU");

const $78c4264d4616da32$export$c1402aba00d7d987 = (agent)=>{
    const { id: id, name: name, description: description, named_id: named_id, creator_type: creator_type, system_prompt_template: system_prompt_template, creator: creator, visibility: visibility, is_default: is_default, identity_account_id: identity_account_id, icon: icon } = agent;
    return {
        id: id,
        name: name,
        description: description,
        namedId: named_id,
        creatorType: creator_type,
        systemPromptTemplate: system_prompt_template,
        creator: creator ?? undefined,
        visibility: visibility,
        isDefault: is_default,
        identityAccountId: identity_account_id,
        icon: icon,
        conversationStarters: (0, $8nzB4.getConversationStarters)({
            isAgentDefault: is_default,
            userDefinedConversationStarters: agent.user_defined_conversation_starters?.map((starter)=>{
                return {
                    message: starter,
                    type: 'user-defined'
                };
            })
        }).combinedConversationStarters,
        externalConfigReference: agent.external_config_reference
    };
};
module.exports["getEditorAgent"] = $78c4264d4616da32$export$c1402aba00d7d987;

});

parcelRegister("eKbTY", function(module, exports) {

var $eLVjp = parcelRequire("eLVjp");


var $lVanm = parcelRequire("lVanm");

const $6be3733e2abcc015$export$457e869d5657c541 = ({ agents: agents, defaultAgent: defaultAgent })=>(0, $eLVjp.createCommand)(()=>{
        return {
            type: (0, $lVanm.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                // Exclude the default agent from the list of agents
                // See https://product-fabric.atlassian.net/browse/EDF-881
                agents: agents.filter((agent)=>agent.namedId !== 'ai_mate_agent'),
                defaultAgent: defaultAgent,
                initialised: true
            }
        };
    });
const $6be3733e2abcc015$export$fdede0d4e32ae86b = (open, rawPositions)=>{
    // Convert rawPositions into a structured format if provided.
    // This ensures that when the browse agents modal is closed,
    // the selection is restored correctly.
    const positions = rawPositions && {
        startPos: rawPositions[0],
        endPos: rawPositions[1]
    };
    return (0, $eLVjp.createCommand)(()=>{
        return {
            type: (0, $lVanm.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                isBrowseModalOpen: open,
                positions: positions
            }
        };
    });
};
const $6be3733e2abcc015$export$1fed3848898af3ea = (publish)=>{
    return (0, $eLVjp.createCommand)(()=>{
        return {
            type: (0, $lVanm.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                publish: publish
            }
        };
    });
};
const $6be3733e2abcc015$export$5947fe5279aaebd6 = (enabled)=>{
    return (0, $eLVjp.createCommand)(()=>{
        return {
            type: (0, $lVanm.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                enabled: enabled
            }
        };
    });
};
module.exports["updateAgents"] = $6be3733e2abcc015$export$457e869d5657c541;
module.exports["openBrowseAgentsModal"] = $6be3733e2abcc015$export$fdede0d4e32ae86b;
module.exports["updatePublish"] = $6be3733e2abcc015$export$1fed3848898af3ea;
module.exports["updateEnabled"] = $6be3733e2abcc015$export$5947fe5279aaebd6;

});

parcelRegister("cOvkw", function(module, exports) {
/* floating-toolbar.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $amP3t = parcelRequire("amP3t");


var $hBYtq = parcelRequire("hBYtq");


var $35sTx = parcelRequire("35sTx");


var $8Qy96 = parcelRequire("8Qy96");


var $6U6f6 = parcelRequire("6U6f6");

/* utils.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $kSwu1 = parcelRequire("kSwu1");


var $a2viN = parcelRequire("a2viN");


var $efgwK = parcelRequire("efgwK");

const $2e06a7ac4c6b07a3$var$nodeRenderers = {
    date: (node, intl)=>{
        const displayString = (0, $efgwK.timestampToString)(node.attrs.timestamp, intl);
        return /*#__PURE__*/ $cozmU.createElement((0, $a2viN.Date), {
            value: node.attrs.timestamp
        }, displayString);
    }
};
const $2e06a7ac4c6b07a3$export$fcbd2f181368d6ad = ({ node: node })=>{
    const intl = (0, $kSwu1.useIntl)();
    const render = $2e06a7ac4c6b07a3$var$nodeRenderers[node.type.name];
    return render ? render(node, intl) : /*#__PURE__*/ $cozmU.createElement("span", null, node.type.name);
};


function $33248790237bdf41$var$_defineProperty(e, r, t) {
    return (r = $33248790237bdf41$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $33248790237bdf41$var$_toPropertyKey(t) {
    var i = $33248790237bdf41$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $33248790237bdf41$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $33248790237bdf41$var$styles = {
    pressable: "_0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg"
};
class $33248790237bdf41$export$e510567c2b33e62 {
    static shouldShow(suggestion, selection) {
        return suggestion.from <= selection.from && suggestion.to >= selection.to;
    }
    static createToolbarItem(inlineSuggestion, api) {
        return {
            type: 'custom',
            render: (view)=>{
                if (!view || !inlineSuggestion.suggestedNode) return null;
                return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
                    xcss: $33248790237bdf41$var$styles.pressable,
                    onClick: ()=>{
                        (0, $35sTx.insertInlineSuggestionWithAnalytics)(api?.analytics?.actions)((0, $amP3t.AI_SUGGESTION_TRIGGERED_FROM).TOOLBAR)(view.state, view.dispatch);
                        view.focus();
                    }
                }, /*#__PURE__*/ $cozmU.createElement((0, $2e06a7ac4c6b07a3$export$fcbd2f181368d6ad), {
                    node: inlineSuggestion.suggestedNode
                }));
            },
            fallback: []
        };
    }
    static buildToolbarConfig(inlineSuggestion, state, api) {
        const { paragraph: paragraph, heading: heading, taskItem: taskItem, decisionItem: decisionItem, caption: caption } = state.schema.nodes;
        return {
            title: 'Inline suggestions',
            getDomRef: ()=>{
                const anchor = document.querySelector(`.${(0, $8Qy96.SuggestionManager).INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor}`);
                return anchor instanceof HTMLElement ? anchor : undefined;
            },
            nodeType: [
                paragraph,
                heading,
                taskItem,
                decisionItem,
                caption
            ].filter((nodeType)=>!!nodeType),
            items: [
                this.createToolbarItem(inlineSuggestion, api)
            ],
            align: 'left',
            className: this.INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS
        };
    }
    static maybeBuild(state, api) {
        if (!state || !(0, $6U6f6.getPluginState)(state)) return undefined;
        const { inlineSuggestion: inlineSuggestion } = (0, $6U6f6.getPluginState)(state);
        if (!inlineSuggestion) return undefined;
        if (this.shouldShow(inlineSuggestion, state.selection)) return this.buildToolbarConfig(inlineSuggestion, state, api);
        return undefined;
    }
}
$33248790237bdf41$var$_defineProperty($33248790237bdf41$export$e510567c2b33e62, "INLINE_SUGGESTION_FLOATING_TOOLBAR_CLASS", 'proactive-ai-inline-suggestion-floating-toolbar');
module.exports["InlineSuggestionToolbar"] = $33248790237bdf41$export$e510567c2b33e62;

});

parcelRegister("pxBW8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9GVkD = parcelRequire("9GVkD");


var $9lgy7 = parcelRequire("9lgy7");


var $avQAT = parcelRequire("avQAT");


var $lM3rj = parcelRequire("lM3rj");

const $8c509bcf9490faf5$export$42f84e610f279c31 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { onCancel: onCancel, onRetry: onRetry, text: text, showRetryButton: t1, appearance: appearance, isAIFC: isAIFC } = t0;
    const showRetryButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, t2] = (0, $9lgy7.useElementBreakpoints)();
    const { breakpoint: breakpoint } = t2;
    let t3;
    if ($[0] !== formatMessage) {
        t3 = formatMessage((0, $lM3rj.default).ariaErrorTitle);
        $[0] = formatMessage;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            children: t3
        });
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== breakpoint || $[5] !== isAIFC || $[6] !== text) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorMessage), {
            breakpoint: breakpoint,
            isAIFC: isAIFC,
            children: text
        });
        $[4] = breakpoint;
        $[5] = isAIFC;
        $[6] = text;
        $[7] = t5;
    } else t5 = $[7];
    const t6 = onRetry && showRetryButton ? "subtle" : "primary";
    const t7 = isAIFC ? (0, $lM3rj.default).closeLabel : (0, $lM3rj.default).cancelLabel;
    let t8;
    if ($[8] !== formatMessage || $[9] !== t7) {
        t8 = formatMessage(t7);
        $[8] = formatMessage;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== isAIFC || $[12] !== onCancel || $[13] !== t6 || $[14] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
            autoFocus: true,
            testId: "cancel-button",
            onClick: onCancel,
            appearance: t6,
            isAIFC: isAIFC,
            children: t8
        });
        $[11] = isAIFC;
        $[12] = onCancel;
        $[13] = t6;
        $[14] = t8;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== formatMessage || $[17] !== isAIFC || $[18] !== onRetry || $[19] !== showRetryButton) {
        t10 = onRetry && showRetryButton && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
            testId: "retry",
            onClick: onRetry,
            appearance: "primary",
            isAIFC: isAIFC,
            children: formatMessage((0, $lM3rj.default).retryLabel)
        });
        $[16] = formatMessage;
        $[17] = isAIFC;
        $[18] = onRetry;
        $[19] = showRetryButton;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isAIFC || $[22] !== t10 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorButtonContainer), {
            isAIFC: isAIFC,
            children: [
                t9,
                t10
            ]
        });
        $[21] = isAIFC;
        $[22] = t10;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== appearance || $[26] !== breakpoint || $[27] !== isAIFC || $[28] !== setBreakpointsElement || $[29] !== t11 || $[30] !== t4 || $[31] !== t5) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorFloatingContainer), {
            ref: setBreakpointsElement,
            breakpoint: breakpoint,
            appearance: appearance,
            isAIFC: isAIFC,
            children: [
                t4,
                t5,
                t11
            ]
        });
        $[25] = appearance;
        $[26] = breakpoint;
        $[27] = isAIFC;
        $[28] = setBreakpointsElement;
        $[29] = t11;
        $[30] = t4;
        $[31] = t5;
        $[32] = t12;
    } else t12 = $[32];
    return t12;
} : ({ onCancel: onCancel, onRetry: onRetry, text: text, showRetryButton: showRetryButton = true, appearance: appearance, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorFloatingContainer), {
        ref: setBreakpointsElement,
        breakpoint: breakpoint,
        appearance: appearance,
        isAIFC: isAIFC,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                children: formatMessage((0, $lM3rj.default).ariaErrorTitle)
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorMessage), {
                breakpoint: breakpoint,
                isAIFC: isAIFC,
                children: text
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $avQAT.ErrorButtonContainer), {
                isAIFC: isAIFC,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
                        autoFocus: true,
                        testId: "cancel-button",
                        onClick: onCancel,
                        appearance: onRetry && showRetryButton ? 'subtle' : 'primary',
                        isAIFC: isAIFC,
                        children: formatMessage(isAIFC ? (0, $lM3rj.default).closeLabel : (0, $lM3rj.default).cancelLabel)
                    }),
                    onRetry && showRetryButton && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $avQAT.ErrorButton), {
                        testId: 'retry',
                        onClick: onRetry,
                        appearance: "primary",
                        isAIFC: isAIFC,
                        children: formatMessage((0, $lM3rj.default).retryLabel)
                    })
                ]
            })
        ]
    });
};
module.exports["ErrorScreen"] = $8c509bcf9490faf5$export$42f84e610f279c31;

});

parcelRegister("4x5dF", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ieeJu = parcelRequire("ieeJu");


var $9GVkD = parcelRequire("9GVkD");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");


var $2diYd = parcelRequire("2diYd");


var $5iPLS = parcelRequire("5iPLS");










parcelRequire("cozmU");

const $1e8d08ca6097ff19$var$Loading = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== props.alt) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("title", {
            children: props.alt
        });
        $[0] = props.alt;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "5.5",
            cy: "12.5",
            r: "1.5",
            fill: "var(--ds-text-brand, #1868DB)",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                attributeName: "cy",
                values: "11;13;13;13;13;13;13;11",
                dur: "1s",
                repeatCount: "indefinite",
                begin: "0s"
            })
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "11.5",
            cy: "10.5",
            r: "1.5",
            fill: "var(--ds-text-brand, #1868DB)",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                attributeName: "cy",
                values: "11;13;13;13;13;13;13;11",
                dur: "1s",
                repeatCount: "indefinite",
                begin: "0.2s"
            })
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
            cx: "17.5",
            cy: "12.5",
            r: "1.5",
            fill: "var(--ds-text-brand, #1868DB)",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                attributeName: "cy",
                values: "11;13;13;13;13;13;13;11",
                dur: "1s",
                repeatCount: "indefinite",
                begin: "0.4s"
            })
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t0) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3
            ]
        });
        $[5] = t0;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("title", {
                children: props.alt
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "5.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "11.5",
                cy: "10.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.2s"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("circle", {
                cx: "17.5",
                cy: "12.5",
                r: "1.5",
                fill: "var(--ds-text-brand, #1868DB)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("animate", {
                    attributeName: "cy",
                    values: "11;13;13;13;13;13;13;11",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.4s"
                })
            })
        ]
    });
};
var $1e8d08ca6097ff19$export$2e2bcd8739ae039 = $1e8d08ca6097ff19$var$Loading;











parcelRequire("cozmU");








var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $1pTZX = parcelRequire("1pTZX");




const $99212fcc428f13d7$var$message = (0, $kSwu1.defineMessages)({
    labelCancel: {
        id: "fabric.editor.ai.components.cancelEscButton.cancelLabel",
        defaultMessage: "Cancel"
    },
    labelEsc: {
        id: "fabric.editor.ai.components.cancelEscButton.escLabel",
        defaultMessage: "Esc"
    }
});
var $99212fcc428f13d7$export$2e2bcd8739ae039 = $99212fcc428f13d7$var$message;


const $db9e051bc110b7c2$var$escTextStylesUnbounded = null; // no tokens for 3px exist, so using raw values
const $db9e051bc110b7c2$var$escTextStyles = null;
const $db9e051bc110b7c2$export$d17714f4f279b358 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onCancel: onCancel, autoFocus: autoFocus, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== autoFocus || $[1] !== formatMessage || $[2] !== isAIFC || $[3] !== onCancel) {
        t1 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            label: formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelCancel),
            icon: $db9e051bc110b7c2$var$_temp,
            shape: "default",
            onClick: onCancel,
            autoFocus: autoFocus,
            appearance: "subtle"
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $ad7Ou.default), {
            autoFocus: autoFocus,
            testId: "cancel-esc-button",
            type: "button",
            onClick: onCancel,
            children: [
                formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelCancel),
                /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0bjKvDKxmn _1UtDYzZpcK _0KLXruDMqu _1kk5Tku7m9",
                        "_0Of8r24Y4b _1Znuxb4Y4b _1wydGW4Y4b _2Zuz6Q4Y4b _2XsHFMyrFs"
                    ]),
                    children: formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelEsc)
                })
            ]
        });
        $[0] = autoFocus;
        $[1] = formatMessage;
        $[2] = isAIFC;
        $[3] = onCancel;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ onCancel: onCancel, autoFocus: autoFocus, isAIFC: isAIFC })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        label: formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelCancel),
        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
        shape: "default",
        onClick: onCancel,
        autoFocus: autoFocus,
        appearance: "subtle"
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $ad7Ou.default), {
        autoFocus: autoFocus,
        testId: "cancel-esc-button",
        type: "button",
        onClick: onCancel,
        children: [
            formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelCancel),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_0bjKvDKxmn _1UtDYzZpcK _0KLXruDMqu _1kk5Tku7m9",
                    "_0Of8r24Y4b _1Znuxb4Y4b _1wydGW4Y4b _2Zuz6Q4Y4b _2XsHFMyrFs"
                ]),
                children: formatMessage((0, $99212fcc428f13d7$export$2e2bcd8739ae039).labelEsc)
            })
        ]
    });
};
function $db9e051bc110b7c2$var$_temp() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1pTZX))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
}



var $btrDv = parcelRequire("btrDv");


var $8W9nI = parcelRequire("8W9nI");


var $hUKxF = parcelRequire("hUKxF");


var $9lgy7 = parcelRequire("9lgy7");




const $4e4d07b06896ad4f$var$message = (0, $kSwu1.defineMessages)({
    iconAltText: {
        id: "fabric.editor.ai.screens.loading.iconAltText",
        defaultMessage: "Generating icon"
    },
    liveRegionDescription: {
        id: "fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription",
        defaultMessage: "Live updating content:"
    },
    loadingAriaTitle: {
        id: "fabric.editor.ai.experience.loadingAriaTitle",
        defaultMessage: "Generating"
    },
    loadingAriaNewTitle: {
        id: "fabric.editor.ai.experience.loadingAriaNewTitle",
        defaultMessage: "Rovo is working"
    },
    loadingAnalyzing: {
        id: "fabric.editor.ai.experience.loadingAnalyzing",
        defaultMessage: "Rovo is analyzing"
    },
    inlineCommentLoadingAnalyzing: {
        id: "fabric.editor.ai.experience.inlineCommentLoadingAnalyzing",
        defaultMessage: "Analyzing"
    },
    loadingEditingTitle: {
        id: "fabric.editor.ai.experience.loadingEditingTitle",
        defaultMessage: "Rovo is editing"
    },
    inlineCommentLoadingEditingTitle: {
        id: "fabric.editor.ai.experience.inlineCommentLoadingEditingTitle",
        defaultMessage: "Editing"
    },
    loadingShortening: {
        id: "fabric.editor.ai.experience.loadingShortening",
        defaultMessage: "Rovo is shortening"
    },
    loadingLengthening: {
        id: "fabric.editor.ai.experience.loadingLengthening",
        defaultMessage: "Rovo is lengthening"
    },
    loadingChangingTone: {
        id: "fabric.editor.ai.experience.loadingChangingTone",
        defaultMessage: "Rovo is changing the tone"
    },
    loadingFixingSpellingAndGrammar: {
        id: "fabric.editor.ai.experience.loadingFixingSpellingAndGrammar",
        defaultMessage: "Rovo is fixing spelling and grammar"
    },
    loadingTranslating: {
        id: "fabric.editor.ai.experience.loadingTranslating",
        defaultMessage: "Rovo is translating"
    },
    loadingPolishing: {
        id: "fabric.editor.ai.experience.loadingPolishing",
        defaultMessage: "Rovo is polishing"
    },
    loadingSummarizing: {
        id: "fabric.editor.ai.experience.loadingSummarizing",
        defaultMessage: "Rovo is summarizing"
    }
});
var $4e4d07b06896ad4f$export$2e2bcd8739ae039 = $4e4d07b06896ad4f$var$message;



const $3402a35598afe228$export$90359a624c464c3b = (title, formatMessage)=>{
    if (!title) return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingEditingTitle);
    if (title.includes('Translate')) return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingTranslating);
    if (title.includes('Change tone')) return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingChangingTone);
    switch(title){
        case 'Make shorter':
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingShortening);
        case 'Make longer':
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingLengthening);
        case 'Fix spelling & grammar':
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingFixingSpellingAndGrammar);
        case 'Add polish':
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingPolishing);
        case 'Summarize':
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingSummarizing);
        default:
            return formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingEditingTitle);
    }
};


const $ee5375fa6731ef17$var$defaultPaddingStyles = null;
const $ee5375fa6731ef17$var$loadingPaddingStyles = null;
const $ee5375fa6731ef17$var$chromelessLoadingPaddingStyles = null;
const $ee5375fa6731ef17$var$defaultPaddingNoInlineStreamChangesStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ee5375fa6731ef17$var$previewContainer = null;
const $ee5375fa6731ef17$var$layoutStyles = null;
const $ee5375fa6731ef17$var$layoutStylesPatchGa = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ee5375fa6731ef17$var$logoStyles = null;
const $ee5375fa6731ef17$var$titleLayoutStyles = null;
const $ee5375fa6731ef17$var$commonTextStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $ee5375fa6731ef17$var$titleStyles = [
    $ee5375fa6731ef17$var$titleLayoutStyles,
    $ee5375fa6731ef17$var$commonTextStyles
];
const $ee5375fa6731ef17$var$previewLoadingScreenStyles = null; /**
                                          * Could be either:
                                          * - userInput only (free form generate / interrogate)
                                          * - presetTitle only (summarize)
                                          * - both presetTitle and userInput (brainstorm)
                                          */ 
const $ee5375fa6731ef17$export$e2b0760399e6dece = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(61);
    const { parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, preview: preview, providerFactory: providerFactory, schema: schema, onCancel: onCancel, agent: agent, disclaimer: disclaimer, isStreaming: isStreaming, canInlineStreamChanges: canInlineStreamChanges, hideLoadingScreen: hideLoadingScreen, appearance: appearance, isAIFC: isAIFC, loadingExperience: loadingExperience } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, t1] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const { breakpoint: breakpoint } = t1;
    let t2;
    if ($[0] !== setBreakpointsElement) {
        t2 = (element)=>{
            setBreakpointsElement(element);
        };
        $[0] = setBreakpointsElement;
        $[1] = t2;
    } else t2 = $[1];
    const setRootContainer = t2;
    let t3;
    if ($[2] !== isAIFC) {
        t3 = (t4)=>{
            const { agent: agent_0, disclaimer: disclaimer_0 } = t4;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8W9nI.Footer), {
                brand: agent_0 ? "rovo" : "atlassian-intelligence",
                disclaimer: disclaimer_0,
                showDisclaimer: true,
                isAIFC: isAIFC
            });
        };
        $[2] = isAIFC;
        $[3] = t3;
    } else t3 = $[3];
    const CommonFooter = t3;
    latestPrompt?.presetTitle;
    const t4 = isAIFC ? appearance === "chromeless" ? "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q2ADO _1Znuxb2ADO" : "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO" : "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE";
    let t5;
    if ($[4] !== t4) {
        t5 = (0, $hekY6.default)([
            t4,
            "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _0hPCNLDIqT _3TGfC9HnLE",
            "_37wbyuI7V3"
        ]);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== breakpoint || $[7] !== formatMessage || $[8] !== isAIFC || $[9] !== isStreaming || $[10] !== latestPrompt?.presetTitle || $[11] !== loadingExperience || $[12] !== onCancel || $[13] !== title) {
        t6 = isAIFC ? loadingExperience === "rovo-thinking-bar" ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb1I3.RovoThinkingBar), {
            status: "analyzing",
            onStop: onCancel,
            useRotatingTitle: true,
            showProgressBar: true
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2diYd.RovoThinkingIndicator), {
                    title: isStreaming ? breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).inlineCommentLoadingEditingTitle) : (0, $3402a35598afe228$export$90359a624c464c3b)(latestPrompt?.presetTitle, formatMessage) : formatMessage(breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? (0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).inlineCommentLoadingAnalyzing : (0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAnalyzing),
                    icon: true,
                    animation: true
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $db9e051bc110b7c2$export$d17714f4f279b358), {
                    onCancel: onCancel,
                    isAIFC: true
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    "data-testid": "loading-icon",
                    className: (0, $hekY6.default)([
                        "_0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1e8d08ca6097ff19$export$2e2bcd8739ae039), {
                        alt: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).iconAltText)
                    })
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    className: (0, $hekY6.default)([
                        "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
                        "_2sNsIgmnOE _3W2Oc8wPeg"
                    ]),
                    children: title
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $db9e051bc110b7c2$export$d17714f4f279b358), {
                    autoFocus: true,
                    onCancel: onCancel,
                    isAIFC: isAIFC
                })
            ]
        });
        $[6] = breakpoint;
        $[7] = formatMessage;
        $[8] = isAIFC;
        $[9] = isStreaming;
        $[10] = latestPrompt?.presetTitle;
        $[11] = loadingExperience;
        $[12] = onCancel;
        $[13] = title;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t5,
            children: t6
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const LoadingAnimationSection = t7;
    let t8;
    if ($[18] !== formatMessage || $[19] !== isAIFC) {
        t8 = (t9)=>{
            const { preview: preview_0 } = t9;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                        children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAriaTitle)
                    }),
                    preview_0 && (isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                        "data-testid": "adf-content-live-region",
                        "aria-atomic": "false",
                        "aria-live": "polite",
                        className: (0, $hekY6.default)([
                            "_0Of8r28HPE _2Zuz6Q8HPE _1Znuxb8HPE"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                                testId: "description",
                                children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).liveRegionDescription)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                className: (0, $hekY6.default)([
                                    "_0Of8r2gVvo"
                                ]),
                                children: preview_0
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                        "data-testid": "adf-content-live-region",
                        "aria-atomic": "false",
                        "aria-live": "polite",
                        className: (0, $hekY6.default)([
                            "_2bqfgdOeNX _1x1D3gOeNX",
                            "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                                testId: "description",
                                children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).liveRegionDescription)
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                children: preview_0
                            })
                        ]
                    }))
                ]
            });
        };
        $[18] = formatMessage;
        $[19] = isAIFC;
        $[20] = t8;
    } else t8 = $[20];
    const LiveRegion = t8;
    if (hideLoadingScreen && canInlineStreamChanges && isAIFC) return null;
    if (canInlineStreamChanges && isAIFC) {
        const t9 = isStreaming ? "editing" : "analyzing";
        const t10 = breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless;
        const t11 = loadingExperience === "rovo-thinking-bar";
        const t12 = loadingExperience === "rovo-thinking-bar";
        let t13;
        if ($[21] !== onCancel || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9) {
            t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3sXr4.RovoThinkingBarWrapper), {
                isThinking: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb1I3.RovoThinkingBar), {
                    status: t9,
                    onStop: onCancel,
                    useShortMessages: t10,
                    useRotatingTitle: t11,
                    showProgressBar: t12
                })
            });
            $[21] = onCancel;
            $[22] = t10;
            $[23] = t11;
            $[24] = t12;
            $[25] = t9;
            $[26] = t13;
        } else t13 = $[26];
        let t14;
        if ($[27] !== appearance || $[28] !== isAIFC || $[29] !== setRootContainer || $[30] !== t13) {
            t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
                ref: setRootContainer,
                "data-testid": "loading-screen",
                className: `loading-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`,
                rainbowBorder: false,
                disablePadding: true,
                enableMaxWidth: true,
                appearance: appearance,
                isAIFC: isAIFC,
                isPositionalOnly: true,
                children: t13
            });
            $[27] = appearance;
            $[28] = isAIFC;
            $[29] = setRootContainer;
            $[30] = t13;
            $[31] = t14;
        } else t14 = $[31];
        return t14;
    }
    const t9 = !isAIFC;
    const t10 = !isAIFC;
    let t11;
    if ($[32] !== isAIFC) {
        t11 = isAIFC && (0, $ieeJu.expValEquals)("cc-maui-experiment", "isEnabled", true);
        $[32] = isAIFC;
        $[33] = t11;
    } else t11 = $[33];
    const t12 = isAIFC && canInlineStreamChanges;
    let t13;
    if ($[34] !== CommonFooter || $[35] !== LiveRegion || $[36] !== LoadingAnimationSection || $[37] !== agent || $[38] !== canInlineStreamChanges || $[39] !== childShortTitle || $[40] !== disclaimer || $[41] !== formatMessage || $[42] !== hideLoadingScreen || $[43] !== isAIFC || $[44] !== latestPrompt?.presetTitle || $[45] !== latestPrompt?.userADFInput || $[46] !== latestPrompt?.userInput || $[47] !== parentPresetPromptLabel || $[48] !== preview || $[49] !== providerFactory || $[50] !== schema) {
        t13 = isAIFC ? canInlineStreamChanges ? !hideLoadingScreen && LoadingAnimationSection : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $8aG6j.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAriaTitle)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hUKxF.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: latestPrompt?.userInput,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: latestPrompt?.presetTitle,
                    providerFactory: providerFactory,
                    schema: schema,
                    agent: agent,
                    showBack: true
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $8aG6j.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        });
        $[34] = CommonFooter;
        $[35] = LiveRegion;
        $[36] = LoadingAnimationSection;
        $[37] = agent;
        $[38] = canInlineStreamChanges;
        $[39] = childShortTitle;
        $[40] = disclaimer;
        $[41] = formatMessage;
        $[42] = hideLoadingScreen;
        $[43] = isAIFC;
        $[44] = latestPrompt?.presetTitle;
        $[45] = latestPrompt?.userADFInput;
        $[46] = latestPrompt?.userInput;
        $[47] = parentPresetPromptLabel;
        $[48] = preview;
        $[49] = providerFactory;
        $[50] = schema;
        $[51] = t13;
    } else t13 = $[51];
    let t14;
    if ($[52] !== appearance || $[53] !== isAIFC || $[54] !== setRootContainer || $[55] !== t10 || $[56] !== t11 || $[57] !== t12 || $[58] !== t13 || $[59] !== t9) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
            ref: setRootContainer,
            "data-testid": "loading-screen",
            className: `loading-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`,
            rainbowBorderAnimation: t9,
            rainbowBorder: t10,
            rovoGradientBorder: t11,
            disablePadding: true,
            enableMaxWidth: t12,
            appearance: appearance,
            isAIFC: isAIFC,
            children: t13
        });
        $[52] = appearance;
        $[53] = isAIFC;
        $[54] = setRootContainer;
        $[55] = t10;
        $[56] = t11;
        $[57] = t12;
        $[58] = t13;
        $[59] = t9;
        $[60] = t14;
    } else t14 = $[60];
    return t14;
} : ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, title: title, latestPrompt: latestPrompt, preview: preview, providerFactory: providerFactory, schema: schema, onCancel: onCancel, agent: agent, disclaimer: disclaimer, isStreaming: isStreaming, canInlineStreamChanges: canInlineStreamChanges, hideLoadingScreen: hideLoadingScreen, appearance: appearance, isAIFC: isAIFC, loadingExperience: loadingExperience })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $9lgy7.useElementBreakpoints)((0, $9lgy7.Breakpoint).SmallChromeless);
    const setRootContainer = (element)=>{
        setBreakpointsElement(element);
    };
    const CommonFooter = ({ agent: agent_0, disclaimer: disclaimer_0 })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8W9nI.Footer), {
            brand: agent_0 ? 'rovo' : 'atlassian-intelligence',
            disclaimer: disclaimer_0,
            showDisclaimer: true,
            isAIFC: isAIFC
        });
    const LoadingAnimationSection = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                isAIFC ? appearance === 'chromeless' ? "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q2ADO _1Znuxb2ADO" : "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO" : "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
                "_3iDTPbQ4SZ _0aFT5v1qpb _37wbyuecOK _0hPCNLDIqT _3TGfC9HnLE",
                "_37wbyuI7V3"
            ]),
            children: isAIFC ? loadingExperience === 'rovo-thinking-bar' ? /**
     * Create with Rovo blank-object experience: the unified RovoThinkingBar
     * provides its own thinking indicator (with rotating titles), a rainbow
     * progress bar, and a stop button.
     */ /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb1I3.RovoThinkingBar), {
                status: "analyzing",
                onStop: onCancel,
                useRotatingTitle: true,
                showProgressBar: true
            }) : /**
     * If aifc is on, we show the new loading modal
     */ /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2diYd.RovoThinkingIndicator), {
                        title: isStreaming ? breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).inlineCommentLoadingEditingTitle) : (0, $3402a35598afe228$export$90359a624c464c3b)(latestPrompt?.presetTitle, formatMessage) : formatMessage(breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless ? (0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).inlineCommentLoadingAnalyzing : (0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAnalyzing),
                        icon: true,
                        animation: true
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $db9e051bc110b7c2$export$d17714f4f279b358), {
                        onCancel: onCancel,
                        isAIFC: true
                    })
                ]
            }) : /**
     * Old loading modal
     */ /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        "data-testid": "loading-icon",
                        className: (0, $hekY6.default)([
                            "_0adFHsFQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1e8d08ca6097ff19$export$2e2bcd8739ae039), {
                            alt: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).iconAltText)
                        })
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG",
                            "_2sNsIgmnOE _3W2Oc8wPeg"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $db9e051bc110b7c2$export$d17714f4f279b358), {
                        autoFocus: true,
                        onCancel: onCancel,
                        isAIFC: isAIFC
                    })
                ]
            })
        }), [
        isStreaming,
        breakpoint,
        formatMessage,
        latestPrompt?.presetTitle,
        onCancel,
        title,
        isAIFC,
        appearance,
        loadingExperience
    ]);
    const LiveRegion = ({ preview: preview_0 })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAriaTitle)
                }),
                preview_0 && (isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    "data-testid": "adf-content-live-region",
                    "aria-atomic": "false",
                    "aria-live": "polite",
                    className: (0, $hekY6.default)([
                        "_0Of8r28HPE _2Zuz6Q8HPE _1Znuxb8HPE"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                            testId: "description",
                            children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).liveRegionDescription)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            className: (0, $hekY6.default)([
                                "_0Of8r2gVvo"
                            ]),
                            children: preview_0
                        })
                    ]
                }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                    "data-testid": "adf-content-live-region",
                    "aria-atomic": "false",
                    "aria-live": "polite",
                    className: (0, $hekY6.default)([
                        "_2bqfgdOeNX _1x1D3gOeNX",
                        "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                            testId: "description",
                            children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).liveRegionDescription)
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                            children: preview_0
                        })
                    ]
                }))
            ]
        });
    };
    if (hideLoadingScreen && canInlineStreamChanges && isAIFC) return null;
    if (canInlineStreamChanges && isAIFC) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "loading-screen",
        className: `loading-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`,
        rainbowBorder: false,
        disablePadding: true,
        enableMaxWidth: true,
        appearance: appearance,
        isAIFC: isAIFC,
        isPositionalOnly: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3sXr4.RovoThinkingBarWrapper), {
            isThinking: true,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb1I3.RovoThinkingBar), {
                status: isStreaming ? 'editing' : 'analyzing',
                onStop: onCancel,
                useShortMessages: breakpoint <= (0, $9lgy7.Breakpoint).SmallChromeless,
                useRotatingTitle: loadingExperience === 'rovo-thinking-bar',
                showProgressBar: loadingExperience === 'rovo-thinking-bar'
            })
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: setRootContainer,
        "data-testid": "loading-screen",
        className: `loading-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`,
        rainbowBorderAnimation: !isAIFC,
        rainbowBorder: !isAIFC,
        rovoGradientBorder: isAIFC && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true),
        disablePadding: true,
        enableMaxWidth: isAIFC && canInlineStreamChanges,
        appearance: appearance,
        isAIFC: isAIFC,
        children: isAIFC ? canInlineStreamChanges ? /**
     * inline streaming route
     */ !hideLoadingScreen && LoadingAnimationSection : /**
     * fall back modal
     */ /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $8aG6j.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                    children: formatMessage((0, $4e4d07b06896ad4f$export$2e2bcd8739ae039).loadingAriaTitle)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hUKxF.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: latestPrompt?.userInput,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: latestPrompt?.presetTitle,
                    providerFactory: providerFactory,
                    schema: schema,
                    agent: agent,
                    showBack: true
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)(LiveRegion, {
                    preview: preview
                }),
                LoadingAnimationSection,
                /*#__PURE__*/ (0, $8aG6j.jsx)(CommonFooter, {
                    agent: agent,
                    disclaimer: disclaimer
                })
            ]
        })
    });
};
const $ee5375fa6731ef17$export$f7ad13998187cb81 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($ee5375fa6731ef17$export$e2b0760399e6dece);
module.exports["LoadingScreen"] = $ee5375fa6731ef17$export$e2b0760399e6dece;
module.exports["MemoLoadingScreen"] = $ee5375fa6731ef17$export$f7ad13998187cb81;

});

parcelRegister("cLPXx", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");

function $39f5ee7aa8d32454$var$isStringList(value) {
    return Array.isArray(value) && value.every((item)=>typeof item === 'string');
}
const $39f5ee7aa8d32454$var$STRING_LIST_CONFIG_KEY = 'value';
function $39f5ee7aa8d32454$export$f1de66450aeccbb6(configName, token) {
    if (!(0, $cXtTj.default).initializeCompleted()) return false;
    try {
        // Dynamic configs are exposed through the same client surface as experiments.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const config = (0, $cXtTj.default).getExperiment(configName);
        const listCandidate = config.value[$39f5ee7aa8d32454$var$STRING_LIST_CONFIG_KEY];
        if (!$39f5ee7aa8d32454$var$isStringList(listCandidate)) return false;
        return listCandidate.includes(token);
    } catch  {
        return false;
    }
}
module.exports["dynamicConfigStringListIncludes"] = $39f5ee7aa8d32454$export$f1de66450aeccbb6;

});

parcelRegister("j1ahd", function(module, exports) {

var $dFI5z = parcelRequire("dFI5z");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");


var $8Rpmh = parcelRequire("8Rpmh");


var $iK8jT = parcelRequire("iK8jT");


var $85Bcz = parcelRequire("85Bcz");

const $77c6f9f7c3b6c582$var$WORD_CHAR_REGEX = RegExp("[\\p{L}\\p{N}_]", "u");
const $77c6f9f7c3b6c582$var$PUNCTUATION_REGEX = RegExp("\\p{P}", "u");
const $77c6f9f7c3b6c582$var$WHITESPACE_REGEX = /\s/u;
const $77c6f9f7c3b6c582$var$mapPosition = (mapping, pos)=>mapping.map(pos);
/**
 * Build a per-content-offset view of the textblock's characters.
 *
 * Returns an array `chars` whose length is `parent.content.size`. For every
 * offset that lies inside a text node, `chars[offset]` is the character at
 * that offset; for every offset that lies inside (or on the edge of) a
 * non-text inline node — hardBreak, mention, emoji, date, etc. — the entry
 * is `null`.
 *
 * Using doc positions to index `parent.textContent` is wrong because
 * `textContent` strips non-text inline nodes, so every such node shifts the
 * lookup off by its size. This per-offset view restores a 1:1 mapping between
 * doc positions inside the textblock and the character (or "no character",
 * i.e. a hard word boundary) at that position.
 */ const $77c6f9f7c3b6c582$var$buildCharsByOffset = (parent)=>{
    const chars = new Array(parent.content.size).fill(null);
    parent.content.forEach((child, offset)=>{
        if (!child.isText) return;
        const text = child.text ?? '';
        for(let i = 0; i < text.length; i++)chars[offset + i] = text[i];
    });
    return chars;
};
/**
 * Given a ProseMirror doc and a position range [from, to], expand
 * both endpoints outward to the nearest word boundaries.
 *
 * A "word character" is any Unicode letter/number or underscore. Punctuation is
 * treated as part of the same token only when it is sandwiched between two
 * non-whitespace characters, so contractions like "You'll", accented words like
 * "l'été", and punctuation-joined tokens like "deep-sea" or "foo/bar" stay
 * intact without treating standalone punctuation as a general word character.
 * Expansion stops at whitespace, standalone punctuation, the boundary of any
 * non-text inline node (hardBreak, mention, emoji, date, etc.), or the
 * textblock edges.
 *
 * If `from` and `to` resolve into different parent nodes, or if the
 * parent is not a textblock, the range is returned unchanged.
 */ const $77c6f9f7c3b6c582$var$expandToWordBoundaries = (doc, from, to)=>{
    const $from = doc.resolve(from);
    // Only expand inside a textblock.
    if (!$from.parent.isTextblock) return {
        from: from,
        to: to
    };
    // When `from !== to`, verify both ends are in the same textblock.
    if (from !== to) {
        const $to = doc.resolve(to);
        if ($from.parent !== $to.parent) return {
            from: from,
            to: to
        };
    }
    const parent = $from.parent;
    const parentStart = $from.start(); // absolute position of the first character in the textblock
    // Per-offset view of the textblock so we don't conflate the inline
    // positions of non-text nodes (hardBreak, mention, emoji, date, etc.)
    // with the characters returned by `parent.textContent`.
    const chars = $77c6f9f7c3b6c582$var$buildCharsByOffset(parent);
    // Convert absolute doc positions to zero-based content offsets.
    let fromIdx = from - parentStart;
    let toIdx = to - parentStart;
    // Base word chars are Unicode letters/numbers/underscore. Punctuation only
    // counts when it is surrounded by non-whitespace characters, e.g. in
    // "You'll", "deep-sea", or "foo/bar". `null` still behaves like a hard
    // boundary because only string neighbors qualify.
    const isWordCharAt = (idx)=>{
        if (idx < 0 || idx >= chars.length) return false;
        const ch = chars[idx];
        if (typeof ch !== 'string') return false;
        const prev = chars[idx - 1];
        const next = chars[idx + 1];
        return $77c6f9f7c3b6c582$var$WORD_CHAR_REGEX.test(ch) || $77c6f9f7c3b6c582$var$PUNCTUATION_REGEX.test(ch) && typeof prev === 'string' && typeof next === 'string' && !$77c6f9f7c3b6c582$var$WHITESPACE_REGEX.test(prev) && !$77c6f9f7c3b6c582$var$WHITESPACE_REGEX.test(next);
    };
    // Detect whether the position sits mid-word: there is a word character
    // on both sides of the position (or, for a non-empty range, on the
    // outer side of each endpoint).
    const isMidWord = (idx)=>idx > 0 && idx < chars.length && isWordCharAt(idx - 1) && isWordCharAt(idx);
    // For a zero-width range (pure insertion / deletion point), only expand
    // if the point is mid-word — i.e. both the char before and after are
    // word characters. Otherwise the point is already at a word boundary.
    if (from === to) {
        if (!isMidWord(fromIdx)) return {
            from: from,
            to: to
        };
        // Expand both directions from the mid-word point.
        while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
        while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
        return {
            from: parentStart + fromIdx,
            to: parentStart + toIdx
        };
    }
    // Non-empty range: expand each endpoint outward if it is mid-word.
    // Expand left only if `from` is truly mid-word: the character at `from`
    // (inside the range) and the character before `from` are both word chars.
    if (fromIdx > 0 && fromIdx < chars.length && isWordCharAt(fromIdx) && isWordCharAt(fromIdx - 1)) while(fromIdx > 0 && isWordCharAt(fromIdx - 1))fromIdx--;
    // Expand right only if `to` is truly mid-word: the character just before
    // `to` (last char of the range) and the character at `to` are both word chars.
    if (toIdx > 0 && toIdx < chars.length && isWordCharAt(toIdx - 1) && isWordCharAt(toIdx)) while(toIdx < chars.length && isWordCharAt(toIdx))toIdx++;
    return {
        from: parentStart + fromIdx,
        to: parentStart + toIdx
    };
};
/**
 * Compare marks between two nodes
 * We have to check each child because adding a mark splits text into multiple nodes
 */ const $77c6f9f7c3b6c582$var$hasSameChildMarks = (left, right)=>{
    if (left.childCount !== right.childCount) return false;
    for(let index = 0; index < left.childCount; index++){
        if (!(0, $aPdNQ.Mark).sameSet(left.child(index).marks, right.child(index).marks)) return false;
    }
    return true;
};
const $77c6f9f7c3b6c582$var$createMapping = (maps)=>{
    const mapping = new (0, $eOaGc.Mapping)();
    for (const map of maps)mapping.appendMap(map);
    return mapping;
};
const $77c6f9f7c3b6c582$var$createSpans = (length, data = null)=>length > 0 ? [
        {
            length: length,
            data: data
        }
    ] : [];
const $77c6f9f7c3b6c582$var$mergeOverlappingByNewDocRange = (changes)=>{
    if (changes.length <= 1) return changes;
    const sortedChanges = [
        ...changes
    ].sort((left, right)=>left.fromB - right.fromB);
    const merged = [];
    let current = {
        ...sortedChanges[0]
    };
    for(let i = 1; i < sortedChanges.length; i++){
        const next = sortedChanges[i];
        const currentIdentity = (0, $8Rpmh.getAttributionKey)([
            ...current.deleted,
            ...current.inserted
        ][0]?.data);
        const nextIdentity = (0, $8Rpmh.getAttributionKey)([
            ...next.deleted,
            ...next.inserted
        ][0]?.data);
        const isOverlapping = next.fromB <= current.toB && currentIdentity === nextIdentity;
        if (isOverlapping) current = {
            fromA: Math.min(current.fromA, next.fromA),
            toA: Math.max(current.toA, next.toA),
            fromB: Math.min(current.fromB, next.fromB),
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            merged.push(current);
            current = {
                ...next
            };
        }
    }
    merged.push(current);
    return merged;
};
/**
 * This function checks whether to do granular diffing.
 * We should do granular diffing if:
 * - The step is a replace step
 * - The step is not open
 * - The replaced slice is not open
 * - The replaced slice has only one child
 * - The replacing slice has only one child
 * - The replaced slice and replacing slice have the same text content
 * - The replaced slice and replacing slice have the same child marks (if text content is equal)
 */ const $77c6f9f7c3b6c582$var$shouldCheckGranularDiff = (step, before, from, to)=>{
    if (!(step instanceof (0, $eOaGc.ReplaceStep))) return false;
    if (step.slice.openStart !== 0 || step.slice.openEnd !== 0) return false;
    const replacedSlice = before.slice(from, to);
    const replacingSlice = step.slice;
    if (replacedSlice.openStart !== 0 || replacedSlice.openEnd !== 0 || replacedSlice.content.childCount !== 1 || replacingSlice.content.childCount !== 1) return false;
    const replacedNode = replacedSlice.content.firstChild;
    const replacingNode = replacingSlice.content.firstChild;
    if (replacedNode?.type.name !== replacingNode?.type.name || !replacedNode?.type.isTextblock) return false;
    if (!(0, $aPdNQ.Mark).sameSet(replacedNode?.marks ?? [], replacingNode?.marks ?? [])) return false;
    const isTextContentEqual = replacedNode?.textContent === replacingNode?.textContent;
    return !isTextContentEqual || isTextContentEqual && $77c6f9f7c3b6c582$var$hasSameChildMarks(replacedNode, replacingNode);
};
const $77c6f9f7c3b6c582$export$3dfa1fc8b4a78d32 = (originalDoc, steps, stepAttributions)=>{
    const changes = [];
    let currentDoc = originalDoc;
    const successfulStepMaps = [];
    const rangedSteps = [];
    for (const [stepIndex, step] of steps.entries()){
        const before = currentDoc;
        const result = step.apply(currentDoc);
        if (result.failed !== null || !result.doc) continue;
        const stepMap = step.getMap();
        const rangeStep = step;
        if (typeof rangeStep.from === 'number' && typeof rangeStep.to === 'number') rangedSteps.push({
            before: before,
            doc: result.doc,
            from: rangeStep.from,
            to: rangeStep.to,
            mapIndex: successfulStepMaps.length,
            stepAttribution: stepAttributions?.[stepIndex] ? {
                ...stepAttributions[stepIndex],
                stepIndex: stepIndex
            } : null,
            step: step,
            stepMap: stepMap
        });
        successfulStepMaps.push(stepMap);
        currentDoc = result.doc;
    }
    for (const rangedStep of rangedSteps){
        // Mapping from original -> doc before this step.
        const originalToBeforeStep = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(0, rangedStep.mapIndex));
        const beforeStepToOriginal = originalToBeforeStep.invert();
        const fromA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.from);
        const toA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, rangedStep.to);
        // Map the step range into final steppedDoc coordinates.
        const fromAfterStep = rangedStep.stepMap.map(rangedStep.from, -1);
        const toAfterStep = rangedStep.stepMap.map(rangedStep.to, 1);
        const afterStepToFinal = $77c6f9f7c3b6c582$var$createMapping(successfulStepMaps.slice(rangedStep.mapIndex + 1));
        const fromB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, fromAfterStep);
        const toB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, toAfterStep);
        if ($77c6f9f7c3b6c582$var$shouldCheckGranularDiff(rangedStep.step, rangedStep.before, rangedStep.from, rangedStep.to)) {
            const granularStepChanges = (0, $dFI5z.ChangeSet).create(rangedStep.before, undefined, (0, $iK8jT.attrAwareTokenEncoder)).addSteps(rangedStep.doc, [
                rangedStep.stepMap
            ], null);
            // `simplifyChanges` reads text using `Change.fromB`/`toB`, which are
            // positions in the post-step doc (the "B" doc). Passing the pre-step
            // doc (`startDoc`) misreads characters and produces mid-word cuts
            // (e.g. "deep-s|ea") because word-boundary detection runs against the
            // wrong text/positions. Use the post-step doc here.
            const optimizedGranularStepChanges = (0, $85Bcz.optimizeChanges)((0, $dFI5z.simplifyChanges)(granularStepChanges.changes, rangedStep.doc));
            for (const granularChange of optimizedGranularStepChanges){
                // Expand each granular change to the nearest word boundaries in
                // both the pre-step doc (A-side) and the post-step doc (B-side).
                // This ensures that a mid-word edit like "sanitised" → "sanitized"
                // shows as deleting the whole original word and inserting the whole
                // new word, rather than a single-character swap.
                const expandedA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, granularChange.fromA, granularChange.toA);
                const expandedB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, granularChange.fromB, granularChange.toB);
                // When one side expanded further than the other (e.g. a space
                // was inserted mid-word: "altogether" → "all together"), the
                // less-expanded side must grow to match — otherwise the renderer
                // shows a partial word as plain text next to a deletion/insertion.
                // We compare left and right deltas independently so partial
                // expansion on one side doesn't prevent the other side from
                // being pulled out further.
                const aLeftDelta = granularChange.fromA - expandedA.from;
                const aRightDelta = expandedA.to - granularChange.toA;
                const bLeftDelta = granularChange.fromB - expandedB.from;
                const bRightDelta = expandedB.to - granularChange.toB;
                let finalA = expandedA;
                let finalB = expandedB;
                // If A expanded further on either side, nudge B outward
                // by the excess and re-expand to snap to word boundaries.
                if (aLeftDelta > bLeftDelta || aRightDelta > bRightDelta) {
                    const extraLeft = Math.max(0, aLeftDelta - bLeftDelta);
                    const extraRight = Math.max(0, aRightDelta - bRightDelta);
                    finalB = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.doc, Math.max(expandedB.from - extraLeft, 0), expandedB.to + extraRight);
                }
                // If B expanded further on either side, nudge A outward.
                if (bLeftDelta > aLeftDelta || bRightDelta > aRightDelta) {
                    const extraLeft = Math.max(0, bLeftDelta - aLeftDelta);
                    const extraRight = Math.max(0, bRightDelta - aRightDelta);
                    finalA = $77c6f9f7c3b6c582$var$expandToWordBoundaries(rangedStep.before, Math.max(expandedA.from - extraLeft, 0), expandedA.to + extraRight);
                }
                const granularFromA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.from);
                const granularToA = $77c6f9f7c3b6c582$var$mapPosition(beforeStepToOriginal, finalA.to);
                const granularFromB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.from);
                const granularToB = $77c6f9f7c3b6c582$var$mapPosition(afterStepToFinal, finalB.to);
                changes.push({
                    fromA: granularFromA,
                    toA: granularToA,
                    fromB: granularFromB,
                    toB: granularToB,
                    deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, granularToA - granularFromA), rangedStep.stepAttribution),
                    inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, granularToB - granularFromB), rangedStep.stepAttribution)
                });
            }
            continue;
        }
        changes.push({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            deleted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toA - fromA), rangedStep.stepAttribution),
            inserted: $77c6f9f7c3b6c582$var$createSpans(Math.max(0, toB - fromB), rangedStep.stepAttribution)
        });
    }
    return $77c6f9f7c3b6c582$var$mergeOverlappingByNewDocRange(changes);
};
module.exports["diffBySteps"] = $77c6f9f7c3b6c582$export$3dfa1fc8b4a78d32;

});

parcelRegister("8Rpmh", function(module, exports) {

var $6e6qw = parcelRequire("6e6qw");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $kNwwQ = parcelRequire("kNwwQ");

/** Maps the shared 18-slot telepointer palette onto the ten bolder diff colours. */ const $6bf3aed8cd6c2de3$var$HASHED_PARTICIPANT_COLOR_SCHEMES = [
    ...(0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES),
    'blue',
    'red',
    'orange',
    'yellow',
    'green',
    'teal',
    'purple',
    'magenta'
];
const $6bf3aed8cd6c2de3$var$getAvailableColor = (hashedColor, allocatedColors)=>{
    const startIndex = (0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES).indexOf(hashedColor);
    for(let offset = 0; offset < (0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES).length; offset++){
        const color = (0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES)[(startIndex + offset) % (0, $kNwwQ.PARTICIPANT_COLOR_SCHEMES).length];
        if (color && !allocatedColors.has(color)) return color;
    }
    return hashedColor;
};
/**
 * Normalise the attribution identity once so a valid lookup key always has a valid participant
 * colour seed. `userId` is primary; `agentId`, or `agentType` as its fallback, separates shared
 * users. The colour seed matches collaboration: the user ID for a human and the agent ID for an
 * agent. The agent-type fallback includes the user so different users' agents do not collapse onto
 * one colour when NCS omits an agent ID.
 */ const $6bf3aed8cd6c2de3$var$getAttributionIdentity = (attribution)=>{
    const userId = attribution?.userId?.trim();
    const agentId = attribution?.agentId?.trim();
    const agentType = attribution?.agentType?.trim();
    let colorSeed;
    if (agentId) colorSeed = agentId;
    else if (agentType) colorSeed = userId ? `user:${userId}|agent:type:${agentType}` : `agent:type:${agentType}`;
    else if (userId) colorSeed = userId;
    else return undefined;
    const agentIdentity = agentId || (agentType ? `type:${agentType}` : '');
    return {
        colorSeed: colorSeed,
        key: `user:${userId ?? ''}|agent:${agentIdentity}`
    };
};
const $6bf3aed8cd6c2de3$export$7aee360da07f170a = (attribution)=>$6bf3aed8cd6c2de3$var$getAttributionIdentity(attribution)?.key;
const $6bf3aed8cd6c2de3$export$95deeb00fa20610f = (contributors)=>{
    if (!contributors?.length) return undefined;
    const resolved = {};
    for (const { attribution: attribution, connectedTo: connectedTo, ...tagContributor } of contributors){
        const key = $6bf3aed8cd6c2de3$export$7aee360da07f170a(attribution);
        if (!key) continue;
        const connectedToKey = connectedTo ? $6bf3aed8cd6c2de3$export$7aee360da07f170a(connectedTo) : undefined;
        resolved[key] = {
            ...tagContributor,
            ...connectedToKey ? {
                connectedToKey: connectedToKey
            } : {}
        };
    }
    return Object.keys(resolved).length > 0 ? resolved : undefined;
};
const $6bf3aed8cd6c2de3$export$c90eefe4090dfa0a = ()=>(0, $iDrrr.fg)('confluence_ncs_step_diffing_version_history') && (0, $4o0zT.isExperimentEnabled)('platform_editor_show_diff_color_scheme_refactor');
const $6bf3aed8cd6c2de3$export$8cdc32db6efd404c = (stepAttributions)=>{
    if (!$6bf3aed8cd6c2de3$export$c90eefe4090dfa0a() || !stepAttributions?.length) return false;
    // Colour whenever a step names an identifiable actor; a single actor still surfaces its
    // participant colour. Only bail when nothing is attributable, so the attributed changeset is
    // not built for a diff with no identities to colour.
    return stepAttributions.some((attribution)=>$6bf3aed8cd6c2de3$export$7aee360da07f170a(attribution) !== undefined);
};
const $6bf3aed8cd6c2de3$export$5cb251c786ce3b3 = (stepAttributions, contributors)=>$6bf3aed8cd6c2de3$export$c90eefe4090dfa0a() && Boolean(stepAttributions?.some((attribution)=>$6bf3aed8cd6c2de3$export$7aee360da07f170a(attribution) !== undefined)) && contributors !== undefined && Object.keys(contributors).length > 0;
const $6bf3aed8cd6c2de3$export$ca8adcc84293a10f = (stepAttributions)=>{
    const colors = new Map();
    const allocatedColors = new Set();
    for (const attribution of stepAttributions){
        const identity = $6bf3aed8cd6c2de3$var$getAttributionIdentity(attribution);
        if (!identity || colors.has(identity.key)) continue;
        const { index: index } = (0, $6e6qw.getParticipantColor)(identity.colorSeed);
        const hashedColor = $6bf3aed8cd6c2de3$var$HASHED_PARTICIPANT_COLOR_SCHEMES[index];
        if (!hashedColor) continue;
        const participantColorScheme = $6bf3aed8cd6c2de3$var$getAvailableColor(hashedColor, allocatedColors);
        colors.set(identity.key, participantColorScheme);
        allocatedColors.add(participantColorScheme);
    }
    return colors;
};
const $6bf3aed8cd6c2de3$var$getLatestAttribution = (changes)=>{
    const data = changes.flatMap((change)=>[
            ...change.deleted,
            ...change.inserted
        ]).map((span)=>span.data).filter((value)=>typeof value === 'object' && value !== null && 'stepIndex' in value && typeof value.stepIndex === 'number');
    return data.reduce((latest, attribution)=>!latest || attribution.stepIndex > latest.stepIndex ? attribution : latest, undefined);
};
const $6bf3aed8cd6c2de3$var$rangesOverlap = (fromA, toA, fromB, toB)=>fromA < toB && fromB < toA;
const $6bf3aed8cd6c2de3$var$changesOverlap = (change, attributedChange)=>{
    const insertedOverlap = change.inserted.length > 0 && attributedChange.inserted.length > 0 && $6bf3aed8cd6c2de3$var$rangesOverlap(change.fromB, change.toB, attributedChange.fromB, attributedChange.toB);
    const deletedOverlap = change.deleted.length > 0 && attributedChange.deleted.length > 0 && $6bf3aed8cd6c2de3$var$rangesOverlap(change.fromA, change.toA, attributedChange.fromA, attributedChange.toA);
    return insertedOverlap || deletedOverlap;
};
const $6bf3aed8cd6c2de3$var$getAttributionKeyForChanges = (changes)=>$6bf3aed8cd6c2de3$export$7aee360da07f170a($6bf3aed8cd6c2de3$var$getLatestAttribution(changes));
const $6bf3aed8cd6c2de3$export$2a41eda1036123f = (change, attributedChanges)=>$6bf3aed8cd6c2de3$var$getAttributionKeyForChanges([
        change
    ]) ?? $6bf3aed8cd6c2de3$var$getAttributionKeyForChanges(attributedChanges.filter((attributedChange)=>$6bf3aed8cd6c2de3$var$changesOverlap(change, attributedChange)));
const $6bf3aed8cd6c2de3$export$52c1882e368c40cb = (change, attributedChanges, attributionColors, fallback)=>{
    const key = $6bf3aed8cd6c2de3$export$2a41eda1036123f(change, attributedChanges);
    return key ? attributionColors.get(key) ?? fallback : fallback;
};
module.exports["getAttributionKey"] = $6bf3aed8cd6c2de3$export$7aee360da07f170a;
module.exports["resolveContributors"] = $6bf3aed8cd6c2de3$export$95deeb00fa20610f;
module.exports["areAttributionColorGatesEnabled"] = $6bf3aed8cd6c2de3$export$c90eefe4090dfa0a;
module.exports["isAttributionColoringEnabled"] = $6bf3aed8cd6c2de3$export$8cdc32db6efd404c;
module.exports["isContributorTagsEnabled"] = $6bf3aed8cd6c2de3$export$5cb251c786ce3b3;
module.exports["createAttributionColorMap"] = $6bf3aed8cd6c2de3$export$ca8adcc84293a10f;
module.exports["getAttributionKeyForChange"] = $6bf3aed8cd6c2de3$export$2a41eda1036123f;
module.exports["getColorSchemeForChange"] = $6bf3aed8cd6c2de3$export$52c1882e368c40cb;

});

parcelRegister("kNwwQ", function(module, exports) {
/** Schemes consumers may explicitly request through the show-diff API. */ const $aacd558dfb64426d$export$b7ce9368a8894dcc = [
    'red',
    'blue',
    'green',
    'yellow',
    'purple',
    'magenta',
    'teal',
    'orange',
    'lime',
    'gray'
];
module.exports["PARTICIPANT_COLOR_SCHEMES"] = $aacd558dfb64426d$export$b7ce9368a8894dcc;

});

parcelRegister("hbVVb", function(module, exports) {
/**
 * Single source of truth for which attributes of a node type represent a
 * meaningful change. Shared by `attrAwareTokenEncoder` (changeset detection)
 * and `getAttrChangeRanges` (decoration rendering) so the two stages agree.
 */ // `localId` is editor bookkeeping rather than user-visible content. Suggestions can regenerate it,
// so treating it as a diff would create phantom changes.
const $39a02c9041d1602e$var$DEFAULT_EXCLUDED_ATTRS = [
    'localId'
];
const $39a02c9041d1602e$export$762395f6a491f1b3 = {
    tableCell: {
        include: [
            'background',
            'colspan',
            'rowspan'
        ]
    },
    tableHeader: {
        include: [
            'background',
            'colspan',
            'rowspan'
        ]
    },
    // Inline nodes whose identity is their attrs.
    date: {
        include: [
            'timestamp'
        ]
    },
    emoji: {
        include: [
            'shortName',
            'id',
            'text'
        ]
    },
    mention: {
        include: [
            'id',
            'text'
        ]
    },
    status: {
        include: [
            'text',
            'color'
        ]
    },
    taskItem: {
        include: [
            'state'
        ]
    },
    // Media: id/collection/url identify the image.
    media: {
        include: [
            'id',
            'collection',
            'url'
        ]
    },
    // Panel: type/colour/icon change is formatting-only but reviewable. Keyed by base
    // node type — the encoder normalises variants (e.g. `panel_c1`) to `panel` first.
    panel: {
        include: [
            'panelType',
            'panelColor',
            'panelIcon',
            'panelIconId',
            'panelIconText'
        ]
    },
    // Extensions: any attribute change is meaningful except localId.
    extension: {
        exclude: [
            'localId'
        ]
    },
    inlineExtension: {
        exclude: [
            'localId'
        ]
    },
    bodiedExtension: {
        exclude: [
            'localId'
        ]
    }
};
const $39a02c9041d1602e$export$6404b24962416feb = (nodeTypeName, attrName)=>{
    const rule = $39a02c9041d1602e$export$762395f6a491f1b3[nodeTypeName];
    if (!rule) return !$39a02c9041d1602e$var$DEFAULT_EXCLUDED_ATTRS.includes(attrName);
    return 'include' in rule ? rule.include.includes(attrName) : !rule.exclude.includes(attrName);
};
const $39a02c9041d1602e$export$5d67a46589f86149 = (nodeTypeName)=>{
    const rule = $39a02c9041d1602e$export$762395f6a491f1b3[nodeTypeName];
    return rule && 'include' in rule ? rule.include : undefined;
};
const $39a02c9041d1602e$export$d5be866ccadce5da = (nodeTypeName)=>{
    const attrs = $39a02c9041d1602e$export$5d67a46589f86149(nodeTypeName);
    if (!attrs) throw new Error(`diffableAttrs: expected an include rule for "${nodeTypeName}"`);
    return attrs;
};
const $39a02c9041d1602e$export$f92117fae319c7fd = (nodeTypeName, attrs)=>{
    const rule = $39a02c9041d1602e$export$762395f6a491f1b3[nodeTypeName];
    if (!rule) return Object.keys(attrs).filter((name)=>!$39a02c9041d1602e$var$DEFAULT_EXCLUDED_ATTRS.includes(name)).sort();
    if ('include' in rule) return rule.include;
    return Object.keys(attrs).filter((name)=>!rule.exclude.includes(name)).sort();
};
module.exports["isDiffableAttr"] = $39a02c9041d1602e$export$6404b24962416feb;
module.exports["getRequiredIncludedDiffableAttrs"] = $39a02c9041d1602e$export$d5be866ccadce5da;
module.exports["getDiffableAttrNames"] = $39a02c9041d1602e$export$f92117fae319c7fd;

});

parcelRegister("85Bcz", function(module, exports) {
function $1958099bac1d5a54$export$e2f3b3d89f27d105(changes) {
    if (changes.length <= 1) return changes;
    const optimized = [];
    let current = {
        ...changes[0]
    };
    for(let i = 1; i < changes.length; i++){
        const next = changes[i];
        // Check if changes are adjacent or very close (within 2 positions)
        const isAdjacent = next.fromB <= current.toB + 2;
        if (isAdjacent) current = {
            fromA: current.fromA,
            toA: Math.max(current.toA, next.toA),
            fromB: current.fromB,
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            optimized.push(current);
            current = {
                ...next
            };
        }
    }
    optimized.push(current);
    return optimized;
}
module.exports["optimizeChanges"] = $1958099bac1d5a54$export$e2f3b3d89f27d105;

});

parcelRegister("aa9kO", function(module, exports) {
function $b0bf35342ffa1121$export$db7650118b60a5b3(doc, from, to) {
    return {
        from: doc.resolve(from).before(1),
        to: doc.resolve(to).after(1)
    };
}
function $b0bf35342ffa1121$export$a0c7c7ce83d8783e(changes, docA, docB) {
    const groups = new Map();
    for (const change of changes){
        const blockA = $b0bf35342ffa1121$export$db7650118b60a5b3(docA, change.fromA, change.toA);
        const blockB = $b0bf35342ffa1121$export$db7650118b60a5b3(docB, change.fromB, change.toB);
        if (!groups.has(blockB.from)) groups.set(blockB.from, {
            fromB: blockB.from,
            toB: blockB.to,
            fromA: blockA ? blockA.from : change.fromA,
            toA: blockA ? blockA.to : change.toA,
            changed: []
        });
        const group = groups.get(blockB.from);
        if (group) group.changed = [
            ...group.changed,
            ...change.inserted,
            ...change.deleted
        ];
    }
    return Array.from(groups.values()).sort((a, b)=>a.fromB - b.fromB).map(({ fromA: fromA, toA: toA, fromB: fromB, toB: toB, changed: changed })=>({
            fromA: fromA,
            toA: toA,
            fromB: fromB,
            toB: toB,
            /**
			 * We add all changes (both deleted and inserted) as that will
			 * inform the calculateDiffDecorations function that changes should be rendered
			 * (even if the change is only one of the two).
			 */ deleted: changed,
            inserted: changed
        }));
}
module.exports["groupChangesByBlock"] = $b0bf35342ffa1121$export$a0c7c7ce83d8783e;

});

parcelRegister("bdYmy", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $iK8jT = parcelRequire("iK8jT");


var $bvvw1 = parcelRequire("bvvw1");

/** Mirrors the library's private (unexported) `typeID` so node-end tokens match. */ const $fda2338d30bc9179$var$typeID = (type)=>{
    const cache = type.schema.cached.changeSetIDs || (type.schema.cached.changeSetIDs = Object.create(null));
    let id = cache[type.name];
    if (id == null) cache[type.name] = id = Object.keys(type.schema.nodes).indexOf(type.name) + 1;
    return id;
};
const $fda2338d30bc9179$export$36bde69393396671 = {
    encodeCharacter: (char, marks)=>(0, $bvvw1.encodeCharacterWithMarks)(char, marks),
    encodeNodeStart: (node)=>node.type.name,
    encodeNodeEnd: (node)=>-$fda2338d30bc9179$var$typeID(node.type),
    compareTokens: (a, b)=>a === b
};


const $2ec0a21a41e7850f$export$6991afd49847a25b = (useAttrAwareEncoder)=>{
    if (useAttrAwareEncoder) return {
        tokenEncoder: (0, $iK8jT.attrAwareTokenEncoder),
        shouldHideMarkOnlyDeletions: false
    };
    if ((0, $iDrrr.fg)('platform_editor_diff_inline_mark_changes')) return {
        tokenEncoder: (0, $fda2338d30bc9179$export$36bde69393396671),
        shouldHideMarkOnlyDeletions: true
    };
    return {
        tokenEncoder: undefined,
        shouldHideMarkOnlyDeletions: false
    };
};
module.exports["selectTokenEncoder"] = $2ec0a21a41e7850f$export$6991afd49847a25b;

});

parcelRegister("jggTf", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $6SJ6d = parcelRequire("6SJ6d");


var $eOaGc = parcelRequire("eOaGc");


var $8Rpmh = parcelRequire("8Rpmh");

/**
 * Attempts to merge two consecutive ReplaceStep operations.
 * This merges steps where:
 * - Both steps replace content at the same starting position
 * - The second step's range encompasses the first step's range
 * - The second step has content to insert
 * Returns null if steps cannot be merged.
 */ function $c2a675ff129cc20a$var$mergeReplaceSteps(step1, step2) {
    if (!(step1 instanceof (0, $eOaGc.ReplaceStep)) || !(step2 instanceof (0, $eOaGc.ReplaceStep))) return null;
    // Confirm the step overlaps exactly with the previous
    const step2Length = step2.to - step2.from;
    if (step1.from === step2.from && step2.to >= step1.to && step2.slice.size >= step2Length && step2Length === step1.slice.size && step2.slice.size >= step1.slice.size && step1.slice.openEnd === step2.slice.openEnd && step1.slice.openStart === step2.slice.openStart) return new (0, $eOaGc.ReplaceStep)(step1.from, step1.to, step2.slice);
    return null;
}
function $c2a675ff129cc20a$export$320ba57788df881b(steps, originalDoc) {
    const stepsToFilter = $c2a675ff129cc20a$var$removeUnusedSteps(steps, originalDoc);
    return stepsToFilter// Remove steps that don't affect document structure or content
    .filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)))// Merge consecutive steps where possible
    .reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        const merged = lastStep?.merge?.(step) ?? $c2a675ff129cc20a$var$mergeReplaceSteps(lastStep, step);
        if (merged) acc[acc.length - 1] = merged;
        else acc.push(step);
        return acc;
    }, []);
}
const $c2a675ff129cc20a$var$mergeAttributions = (first, second)=>{
    if (!first) return second;
    if (!second) return first;
    return {
        ...first,
        ...second,
        wasOffline: first.wasOffline === true || second.wasOffline === true ? true : second.wasOffline ?? first.wasOffline
    };
};
function $c2a675ff129cc20a$export$464a93d7ed92dcba(steps, stepAttributions, originalDoc) {
    const stepsToFilter = $c2a675ff129cc20a$var$removeUnusedAttributedSteps(steps.map((step, index)=>({
            step: step,
            stepAttribution: stepAttributions[index]
        })), originalDoc);
    return stepsToFilter.filter(({ step: step })=>!(step instanceof (0, $l5rX3.AnalyticsStep))).reduce((acc, current)=>{
        const previous = acc[acc.length - 1];
        const isSameIdentity = previous && (0, $8Rpmh.getAttributionKey)(previous.stepAttribution) === (0, $8Rpmh.getAttributionKey)(current.stepAttribution);
        const merged = isSameIdentity ? previous.step.merge?.(current.step) ?? $c2a675ff129cc20a$var$mergeReplaceSteps(previous.step, current.step) : null;
        if (merged) acc[acc.length - 1] = {
            step: merged,
            stepAttribution: $c2a675ff129cc20a$var$mergeAttributions(previous.stepAttribution, current.stepAttribution)
        };
        else acc.push(current);
        return acc;
    }, []);
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $c2a675ff129cc20a$var$removeUnusedAttributedSteps(stepsWithAttribution, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const stepWithAttribution of stepsWithAttribution){
        const { step: step } = stepWithAttribution;
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(stepWithAttribution);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}
/**
 * Does a first pass to remove steps that don't impact the document
 */ function $c2a675ff129cc20a$var$removeUnusedSteps(steps, originalDoc) {
    const finalSteps = [];
    let firstPassDoc = originalDoc;
    for (const step of steps){
        const result = step.apply(firstPassDoc);
        if (result.failed === null && result.doc && !(0, $6SJ6d.areNodesEqualIgnoreAttrs)(firstPassDoc, result.doc, [
            'localId'
        ])) {
            finalSteps.push(step);
            firstPassDoc = result.doc;
        }
    }
    return finalSteps;
}
module.exports["simplifySteps"] = $c2a675ff129cc20a$export$320ba57788df881b;
module.exports["simplifyStepsWithAttribution"] = $c2a675ff129cc20a$export$464a93d7ed92dcba;

});

parcelRegister("ddUGd", function(module, exports) {

var $ekAyE = parcelRequire("ekAyE");

// A character is treated as part of a word unless it is whitespace or common punctuation.
// We deliberately avoid Unicode property escapes (`\p{...}`) and the `u` flag here: the `u`
// flag is only valid when targeting es6+, and the declaration-generation build config for
// this package targets an older lib, which rejects it with TS1501. This negated approach
// keeps word segmentation reasonable across scripts (any non-punctuation, non-space glyph
// counts as a word char) without needing Unicode-aware regex.
const $225246a57078976f$var$NON_WORD_CHARS = " 	\n\r\f\v.,;:!?\u2026\u3002\uFF01\uFF1F\u3001\"'`\u201C\u201D\u2018\u2019()[]{}<>/\\|@#$%^&*-+=~";
const $225246a57078976f$var$NON_WORD_CHAR_SET = new Set($225246a57078976f$var$NON_WORD_CHARS.split(''));
const $225246a57078976f$var$isWordChar = (ch)=>!$225246a57078976f$var$NON_WORD_CHAR_SET.has(ch);
// Whitespace is checked via a Set rather than a regex to avoid both the `require-unicode-regexp`
// lint rule and the TS1501 error the `u` flag triggers under this package's build lib target.
const $225246a57078976f$var$WHITESPACE_CHAR_SET = new Set([
    ' ',
    '\t',
    '\n',
    '\r',
    '\f',
    '\v',
    '\u00a0'
]);
const $225246a57078976f$var$isWhitespaceChar = (ch)=>$225246a57078976f$var$WHITESPACE_CHAR_SET.has(ch);
// Sentence terminators used by the regex fallback. We intentionally keep this small and
// conservative — the Intl.Segmenter path is the source of truth when available.
const $225246a57078976f$var$SENTENCE_TERMINATORS = new Set([
    '.',
    '!',
    '?',
    "\u2026",
    "\u3002",
    "\uFF01",
    "\uFF1F"
]);
const $225246a57078976f$export$48178c209e718bdd = (parent)=>{
    const chars = Array.from({
        length: parent.content.size
    }, ()=>null);
    parent.content.forEach((child, offset)=>{
        if (!child.isText) return;
        const text = child.text ?? '';
        for(let i = 0; i < text.length; i++)chars[offset + i] = text[i];
    });
    return chars;
};
const $225246a57078976f$var$getSegmenterCtor = ()=>{
    if (typeof Intl === 'undefined') return undefined;
    const ctor = Intl.Segmenter;
    return typeof ctor === 'function' ? ctor : undefined;
};
let $225246a57078976f$var$cachedLocale;
let $225246a57078976f$var$cachedSentenceSegmenter;
let $225246a57078976f$var$cachedWordSegmenter;
const $225246a57078976f$var$getSegmenters = (locale)=>{
    const Ctor = $225246a57078976f$var$getSegmenterCtor();
    if (!Ctor) return undefined;
    if ($225246a57078976f$var$cachedLocale !== locale || !$225246a57078976f$var$cachedSentenceSegmenter || !$225246a57078976f$var$cachedWordSegmenter) {
        $225246a57078976f$var$cachedLocale = locale;
        $225246a57078976f$var$cachedSentenceSegmenter = new Ctor(locale, {
            granularity: 'sentence'
        });
        $225246a57078976f$var$cachedWordSegmenter = new Ctor(locale, {
            granularity: 'word'
        });
    }
    return {
        sentence: $225246a57078976f$var$cachedSentenceSegmenter,
        word: $225246a57078976f$var$cachedWordSegmenter
    };
};
/**
 * Convert a char-view into a plain string plus an index map back to content offsets.
 *
 * Opaque inline tokens (`null`) are represented in the string by a single sentinel
 * character (Unicode Object Replacement Character, U+FFFC) so that:
 * - the segmenter treats them as a word-like glyph rather than whitespace/punctuation;
 * - they never look like a sentence terminator.
 * `indexMap[j]` gives the content offset of string index `j`.
 */ const $225246a57078976f$var$OBJECT_REPLACEMENT = '\uFFFC';
const $225246a57078976f$var$flattenChars = (chars)=>{
    let text = '';
    const indexMap = [];
    for(let offset = 0; offset < chars.length; offset++){
        const ch = chars[offset];
        text += ch === null ? $225246a57078976f$var$OBJECT_REPLACEMENT : ch;
        indexMap.push(offset);
    }
    return {
        text: text,
        indexMap: indexMap
    };
};
const $225246a57078976f$var$stringIndexToOffset = (indexMap, strIdx, fallback)=>{
    if (strIdx < 0) return fallback;
    if (strIdx >= indexMap.length) // One-past-the-end maps to the offset after the last char.
    return indexMap.length > 0 ? indexMap[indexMap.length - 1] + 1 : fallback;
    return indexMap[strIdx];
};
const $225246a57078976f$export$37d9b8fca7e28693 = (chars, locale)=>{
    if (chars.length === 0) return [];
    const { text: text, indexMap: indexMap } = $225246a57078976f$var$flattenChars(chars);
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    if (segmenters) {
        const spans = [];
        for (const seg of segmenters.sentence.segment(text)){
            const startOffset = $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index, 0);
            const endOffset = $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index + seg.segment.length, chars.length);
            if (endOffset > startOffset) spans.push({
                from: startOffset,
                to: endOffset
            });
        }
        return spans.length > 0 ? spans : [
            {
                from: 0,
                to: chars.length
            }
        ];
    }
    // Regex fallback: split after a sentence terminator followed by whitespace/EOL.
    // A `null` (OBJECT_REPLACEMENT) is never a terminator.
    const spans = [];
    let start = 0;
    for(let i = 0; i < chars.length; i++){
        const ch = chars[i];
        if (ch !== null && $225246a57078976f$var$SENTENCE_TERMINATORS.has(ch)) {
            // Consume trailing spaces as part of this sentence.
            let end = i + 1;
            while(end < chars.length && chars[end] !== null && $225246a57078976f$var$isWhitespaceChar(chars[end]))end++;
            spans.push({
                from: start,
                to: end
            });
            start = end;
        }
    }
    if (start < chars.length) spans.push({
        from: start,
        to: chars.length
    });
    return spans.length > 0 ? spans : [
        {
            from: 0,
            to: chars.length
        }
    ];
};
const $225246a57078976f$export$5e9f9da5213092bc = (chars, span, locale)=>{
    const slice = chars.slice(span.from, span.to);
    if (slice.length === 0) return 0;
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    const { text: text } = $225246a57078976f$var$flattenChars(slice);
    if (segmenters) {
        let count = 0;
        for (const seg of segmenters.word.segment(text))// Object-replacement sentinel is word-like; count it.
        if (seg.isWordLike || seg.segment.includes($225246a57078976f$var$OBJECT_REPLACEMENT)) count++;
        return count;
    }
    // Regex fallback: a run of word chars OR a single opaque token is one word.
    let count = 0;
    let inWord = false;
    for (const ch of slice){
        if (ch === null) {
            count++;
            inWord = false;
            continue;
        }
        if ($225246a57078976f$var$isWordChar(ch)) {
            if (!inWord) {
                count++;
                inWord = true;
            }
        } else inWord = false;
    }
    return count;
};
const $225246a57078976f$export$df862e795a1833f8 = (chars, span, locale)=>{
    const segmenters = $225246a57078976f$var$getSegmenters(locale);
    const slice = chars.slice(span.from, span.to);
    const { text: text, indexMap: indexMap } = $225246a57078976f$var$flattenChars(slice);
    const spans = [];
    if (segmenters) {
        for (const seg of segmenters.word.segment(text))if (seg.isWordLike || seg.segment.includes($225246a57078976f$var$OBJECT_REPLACEMENT)) {
            const from = span.from + $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index, 0);
            const to = span.from + $225246a57078976f$var$stringIndexToOffset(indexMap, seg.index + seg.segment.length, slice.length);
            spans.push({
                from: from,
                to: to
            });
        }
        return spans;
    }
    let wordStart = -1;
    for(let i = 0; i < slice.length; i++){
        const ch = slice[i];
        if (ch === null) {
            if (wordStart !== -1) {
                spans.push({
                    from: span.from + wordStart,
                    to: span.from + i
                });
                wordStart = -1;
            }
            spans.push({
                from: span.from + i,
                to: span.from + i + 1
            });
        } else if ($225246a57078976f$var$isWordChar(ch)) {
            if (wordStart === -1) wordStart = i;
        } else if (wordStart !== -1) {
            spans.push({
                from: span.from + wordStart,
                to: span.from + i
            });
            wordStart = -1;
        }
    }
    if (wordStart !== -1) spans.push({
        from: span.from + wordStart,
        to: span.from + slice.length
    });
    return spans;
};


/**
 * Configurable thresholds for the `smart` diffType.
 *
 * See docs/smart-diff-design.md §3 and §6 for the exact semantics of each level.
 */ const $087e793972840e8d$export$fd5c9e9a18faa986 = {
    sentence: {
        ratio: 0.4,
        minChanged: 2
    },
    paragraph: {
        ratio: 0.4,
        minChanged: 2
    },
    node: {
        ratio: 0.6,
        textBearingRatio: 0.6
    }
};
const $087e793972840e8d$export$fe359b9dc54dc4e0 = (overrides)=>{
    if (!overrides) return $087e793972840e8d$export$fd5c9e9a18faa986;
    return {
        sentence: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.sentence,
            ...overrides.sentence
        },
        paragraph: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.paragraph,
            ...overrides.paragraph
        },
        node: {
            ...$087e793972840e8d$export$fd5c9e9a18faa986.node,
            ...overrides.node
        }
    };
};


const $2be352b0f93592ab$export$c15105fe770d78d4 = ({ changes: changes, originalDoc: originalDoc, newDoc: newDoc, locale: locale, thresholds: overrides })=>{
    if (changes.length === 0) return changes;
    const thresholds = (0, $087e793972840e8d$export$fe359b9dc54dc4e0)(overrides);
    const groups = $2be352b0f93592ab$var$groupByTopLevelBlock(changes, originalDoc, newDoc);
    const result = [];
    for (const group of groups)result.push(...$2be352b0f93592ab$var$classifyBlockGroup(group, originalDoc, newDoc, locale, thresholds));
    // Clamp to valid bounds (defensive) and coalesce overlaps.
    const maxA = originalDoc.content.size;
    const maxB = newDoc.content.size;
    const clamped = result.map((change)=>$2be352b0f93592ab$var$clampChange(change, maxA, maxB)).filter((change)=>change !== null);
    return (0, $ekAyE.mergeOverlappingByNewDocRange)(clamped);
};
/**
 * Group changes by the top-level block (direct child of doc) they touch, aligning the A-side
 * and B-side blocks a change covers. A single change can span MULTIPLE top-level blocks (e.g.
 * a ReplaceStep whose slice contains several nodes); we enumerate every block it overlaps on
 * both sides (`topLevelBlocksInRange`) and create one group per aligned block, so added/removed
 * blocks in a multi-node replacement are never dropped. Unlike `groupChangesByBlock`, we KEEP
 * each group's constituent raw changes so intra-block density can be measured.
 */ const $2be352b0f93592ab$var$groupByTopLevelBlock = (changes, docA, docB)=>{
    const groups = new Map();
    const ensureGroup = (blockA, blockB, anchors)=>{
        if (!blockA && !blockB) return null;
        // Key by both sides so an added block (blockA=null) on the B side and a deleted block
        // (blockB=null) on the A side each get their own group.
        const key = `${blockB ? blockB.from : 'x'}:${blockA ? blockA.from : 'x'}`;
        let group = groups.get(key);
        if (!group) {
            group = {
                blockA: blockA,
                blockB: blockB,
                changes: [],
                ...anchors
            };
            groups.set(key, group);
        }
        return group;
    };
    for (const change of changes){
        // A single change (e.g. a ReplaceStep whose slice spans several nodes) can cover MULTIPLE
        // top-level blocks on either side. Resolving only the block at `fromB` would silently drop
        // the extra blocks (e.g. an added table after a replaced paragraph). So we enumerate every
        // top-level block the change overlaps on BOTH sides and create a group per aligned block.
        const blocksB = $2be352b0f93592ab$var$topLevelBlocksInRange(docB, change.fromB, change.toB);
        const blocksA = $2be352b0f93592ab$var$topLevelBlocksInRange(docA, change.fromA, change.toA);
        // Simple, common case: exactly one block on each side (or one side empty).
        if (blocksB.length <= 1 && blocksA.length <= 1) {
            const group = ensureGroup(blocksA[0] ?? null, blocksB[0] ?? null);
            group?.changes.push(change);
            continue;
        }
        // Multi-block span: align blocks positionally by index. The first `min(len)` blocks are
        // REPLACEMENTS (paired A↔B). Extra B-blocks are PURE INSERTIONS and extra A-blocks are
        // PURE DELETIONS — and, crucially, these must NOT reuse the raw change's full A/B range
        // (that range covers the paired blocks too, so an added block would claim the original
        // content already owned by a paired replacement, rendering it deleted twice). Instead we
        // anchor a pure insertion's A side (and a pure deletion's B side) as ZERO-WIDTH at the
        // end of the last paired block on the opposite side.
        const paired = Math.min(blocksA.length, blocksB.length);
        for(let i = 0; i < paired; i++){
            const group = ensureGroup(blocksA[i], blocksB[i]);
            group?.changes.push(change);
        }
        // Anchor for extras = end of the last paired block on the opposite side (or the start of
        // the span if there were no paired blocks).
        const anchorA = paired > 0 ? blocksA[paired - 1].to : change.fromA;
        const anchorB = paired > 0 ? blocksB[paired - 1].to : change.fromB;
        for(let i = paired; i < blocksB.length; i++){
            const group = ensureGroup(null, blocksB[i], {
                anchorA: anchorA
            });
            group?.changes.push(change);
        }
        for(let i = paired; i < blocksA.length; i++){
            const group = ensureGroup(blocksA[i], null, {
                anchorB: anchorB
            });
            group?.changes.push(change);
        }
    }
    return Array.from(groups.values()).sort((a, b)=>(a.blockB?.from ?? a.blockA?.from ?? 0) - (b.blockB?.from ?? b.blockA?.from ?? 0));
};
/**
 * Enumerate the top-level blocks (direct children of doc) whose outer range overlaps
 * `[from, to)`. Returns each as a BlockRef. Used to split a change that spans several blocks.
 */ const $2be352b0f93592ab$var$topLevelBlocksInRange = (doc, from, to)=>{
    const lo = Math.min(Math.max(from, 0), doc.content.size);
    const hi = Math.min(Math.max(to, lo), doc.content.size);
    const refs = [];
    let offset = 0;
    for(let i = 0; i < doc.childCount; i++){
        const node = doc.child(i);
        const blockFrom = offset;
        const blockTo = offset + node.nodeSize;
        // Non-empty range: standard half-open overlap test.
        if (lo < hi) {
            if (blockFrom < hi && blockTo > lo) refs.push({
                node: node,
                from: blockFrom,
                to: blockTo
            });
        } else if (blockFrom < lo && lo < blockTo) // Zero-width range (an insertion anchor): only match a block whose INTERIOR strictly
        // contains the point. A point sitting exactly on a top-level block boundary
        // (`blockFrom === lo`, i.e. between two sibling blocks) is a pure insertion BETWEEN
        // blocks — it must resolve to NO block, otherwise `groupByTopLevelBlock` pairs the
        // insertion with the following block and `classifyBlockGroup` converts the insert into a
        // whole-block replacement, fabricating a phantom deletion of that untouched block.
        // Interior points (a nested insertion inside a container being edited) still resolve
        // their container so the classifier can recurse into it.
        refs.push({
            node: node,
            from: blockFrom,
            to: blockTo
        });
        offset = blockTo;
    }
    return refs;
};
const $2be352b0f93592ab$var$clampChange = (change, maxA, maxB)=>{
    const fromA = Math.max(0, Math.min(change.fromA, maxA));
    const toA = Math.max(fromA, Math.min(change.toA, maxA));
    const fromB = Math.max(0, Math.min(change.fromB, maxB));
    const toB = Math.max(fromB, Math.min(change.toB, maxB));
    if (toA === fromA && toB === fromB) return null;
    return {
        ...change,
        fromA: fromA,
        toA: toA,
        fromB: fromB,
        toB: toB
    };
};
const $2be352b0f93592ab$var$TEXT_BLOCK_TYPES = new Set([
    'paragraph',
    'heading'
]);
/**
 * Rigid children cannot be individually deleted+re-inserted without breaking their parent's
 * structure — promoting one escalates to its structural unit (see classifyContainer):
 *   layoutColumn → layoutSection, tableCell/tableHeader → tableRow → table.
 */ const $2be352b0f93592ab$var$RIGID_CHILD_TYPES = new Set([
    'layoutColumn',
    'tableCell',
    'tableHeader'
]);
/**
 * Emit a single whole-block (node-level) change covering both sides of a group. Used for
 * structural / node-type replacements and for containers dense enough to replace wholesale.
 */ const $2be352b0f93592ab$var$wholeBlockChange = (blockA, blockB, changes, anchors)=>{
    // Pure insertion (blockA === null): the A side must be a ZERO-WIDTH anchor, never the raw
    // change's A range (which spans sibling blocks that were separately replaced). Same for a
    // pure deletion's B side. Falling back to the change coords is the last-resort path when no
    // anchor was supplied (single-block insert/delete, where the coords are already zero-width).
    const fromA = blockA ? blockA.from : anchors?.anchorA ?? changes[0].fromA;
    const toA = blockA ? blockA.to : anchors?.anchorA ?? changes[changes.length - 1].toA;
    const fromB = blockB ? blockB.from : anchors?.anchorB ?? changes[0].fromB;
    const toB = blockB ? blockB.to : anchors?.anchorB ?? changes[changes.length - 1].toB;
    return (0, $ekAyE.makePromotedChange)(fromA, toA, fromB, toB, 'node');
};
/**
 * Classify one block group. This is the single recursive decision point:
 *  - one side missing (pure insert/delete)   → whole block
 *  - node type changed (para→panel, list→table, heading→para, …) → whole block
 *  - text-bearing block                       → sentence / paragraph / inline
 *  - container                                → recurse into children (with rigid escalation)
 */ const $2be352b0f93592ab$var$classifyBlockGroup = (group, originalDoc, newDoc, locale, thresholds)=>{
    const { blockA: blockA, blockB: blockB, changes: changes, anchorA: anchorA, anchorB: anchorB } = group;
    // Pure insertion or deletion of a whole block.
    if (!blockA || !blockB) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes, {
            anchorA: anchorA,
            anchorB: anchorB
        })
    ];
    // Node-type / structural change: the whole block was replaced. No further analysis — this
    // is what makes list→table, paragraph→panel, heading→paragraph "just work".
    if (blockA.node.type.name !== blockB.node.type.name) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    // A meaningful attribute-only change is represented by a node-boundary token. Text analysis
    // starts inside the block, so it cannot associate that token with a sentence and would otherwise
    // drop the change. Promote the block before choosing text or container granularity.
    if (!blockA.node.sameMarkup(blockB.node)) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    // Text-bearing block → sentence / paragraph / inline.
    if ($2be352b0f93592ab$var$TEXT_BLOCK_TYPES.has(blockB.node.type.name)) return $2be352b0f93592ab$var$classifyTextblock(blockA, blockB, changes, locale, thresholds);
    // Container block → measure changed-child density, promote whole container or recurse.
    return $2be352b0f93592ab$var$classifyContainer(blockA, blockB, changes, originalDoc, newDoc, locale, thresholds);
};
/**
 * Sentence- and paragraph-level classification for a single text-bearing block.
 */ const $2be352b0f93592ab$var$classifyTextblock = (blockA, blockB, changes, locale, thresholds)=>{
    const charsB = (0, $225246a57078976f$export$48178c209e718bdd)(blockB.node);
    const sentencesB = (0, $225246a57078976f$export$37d9b8fca7e28693)(charsB, locale);
    const charsA = (0, $225246a57078976f$export$48178c209e718bdd)(blockA.node);
    const sentencesA = (0, $225246a57078976f$export$37d9b8fca7e28693)(charsA, locale);
    // Block content starts one position after the block's outer start (open token).
    const contentStartB = blockB.from + 1;
    // Map each change to the sentence indices (new-doc offset space) it overlaps.
    const changedSentenceIdx = new Set();
    const perSentenceChanges = new Map();
    for (const change of changes){
        const fromOff = change.fromB - contentStartB;
        const toOff = change.toB - contentStartB;
        for(let s = 0; s < sentencesB.length; s++){
            const sentence = sentencesB[s];
            if ((0, $ekAyE.rangesOverlap)(fromOff, Math.max(toOff, fromOff + 1), sentence.from, sentence.to)) {
                changedSentenceIdx.add(s);
                let list = perSentenceChanges.get(s);
                if (!list) {
                    list = [];
                    perSentenceChanges.set(s, list);
                }
                list.push(change);
            }
        }
    }
    // Level 2: paragraph promotion.
    const sentenceDenom = Math.max(sentencesA.length, sentencesB.length, 1);
    const sentencesChanged = changedSentenceIdx.size;
    if (sentencesChanged >= thresholds.paragraph.minChanged && sentencesChanged / sentenceDenom >= thresholds.paragraph.ratio) return [
        (0, $ekAyE.makePromotedChange)(blockA.from, blockA.to, blockB.from, blockB.to, 'paragraph')
    ];
    // Level 1: per-sentence promotion (else keep inline changes).
    const contentStartA = blockA.from + 1;
    const out = [];
    for (const [sIdx, sentenceChanges] of perSentenceChanges.entries()){
        const sentence = sentencesB[sIdx];
        const wordsNew = (0, $225246a57078976f$export$5e9f9da5213092bc)(charsB, sentence, locale);
        const sentA = sentencesA[sIdx];
        const wordsOld = sentA ? (0, $225246a57078976f$export$5e9f9da5213092bc)(charsA, sentA, locale) : 0;
        const wordSpans = (0, $225246a57078976f$export$df862e795a1833f8)(charsB, sentence, locale);
        let wordsChanged = 0;
        for (const w of wordSpans){
            const overlaps = sentenceChanges.some((c)=>(0, $ekAyE.rangesOverlap)(c.fromB - contentStartB, Math.max(c.toB - contentStartB, c.fromB - contentStartB + 1), w.from, w.to));
            if (overlaps) wordsChanged++;
        }
        const wordDenom = Math.max(wordsOld, wordsNew, 1);
        if (wordsChanged >= thresholds.sentence.minChanged && wordsChanged / wordDenom >= thresholds.sentence.ratio) {
            const fromB = contentStartB + sentence.from;
            const toB = contentStartB + sentence.to;
            const fromA = sentA ? contentStartA + sentA.from : sentenceChanges[0].fromA;
            const toA = sentA ? contentStartA + sentA.to : sentenceChanges[0].toA;
            out.push((0, $ekAyE.makePromotedChange)(fromA, toA, fromB, toB, 'sentence'));
        } else out.push(...sentenceChanges);
    }
    return out;
};
/** Resolve the direct children of a container node (whose OUTER start is `blockFrom`). */ const $2be352b0f93592ab$var$childRefs = (block)=>{
    const refs = [];
    let offset = block.from + 1; // content starts after the container's open token
    block.node.forEach((child, _, index)=>{
        refs.push({
            node: child,
            from: offset,
            to: offset + child.nodeSize,
            index: index
        });
        offset += child.nodeSize;
    });
    return refs;
};
/** Which direct-child indices of `block` are touched by any of `changes` (new-doc coords). */ const $2be352b0f93592ab$var$changedChildIndices = (block, children, changes)=>{
    const changed = new Set();
    for (const child of children){
        const touched = changes.some((c)=>(0, $ekAyE.rangesOverlap)(c.fromB, Math.max(c.toB, c.fromB + 1), child.from, child.to));
        if (touched) changed.add(child.index);
    }
    return changed;
};
/**
 * Align a container's A-side and B-side direct children via an LCS over their serialized
 * content. This is essential because index alignment (`childrenA[childB.index]`) breaks the
 * moment a child is inserted or removed: every child after the insertion/deletion point would
 * be mis-paired, causing added items to be classified against the wrong (or a B-side) original
 * child — which corrupts the A-side coordinates and makes one list's deletions surface under a
 * different block. The LCS pairs identical children as "matched" (unchanged, skipped later),
 * leaving genuinely added children as B-only and removed children as A-only.
 */ const $2be352b0f93592ab$var$alignChildren = (childrenA, childrenB)=>{
    const keyA = childrenA.map((c)=>JSON.stringify(c.node.toJSON()));
    const keyB = childrenB.map((c)=>JSON.stringify(c.node.toJSON()));
    const n = childrenA.length;
    const m = childrenB.length;
    // LCS length table.
    const lcs = Array.from({
        length: n + 1
    }, ()=>Array.from({
            length: m + 1
        }, ()=>0));
    for(let i = n - 1; i >= 0; i--)for(let j = m - 1; j >= 0; j--)lcs[i][j] = keyA[i] === keyB[j] ? lcs[i + 1][j + 1] + 1 : Math.max(lcs[i + 1][j], lcs[i][j + 1]);
    // Backtrack. Identical children become matched anchors. Runs of non-identical children
    // between anchors are "zipped" positionally into modified pairs (a & b), with any leftover
    // B children as pure insertions and leftover A children as pure deletions. Zipping avoids
    // treating a MODIFIED child (whose content merely differs) as a delete+insert — that pairing
    // lets the recursion diff inside the child (inline/sentence) instead of replacing it whole.
    const out = [];
    let i = 0;
    let j = 0;
    // Pending runs of unmatched children on each side, flushed (zipped) at each anchor / at end.
    let runA = [];
    let runB = [];
    const flushRuns = ()=>{
        const shared = Math.min(runA.length, runB.length);
        for(let k = 0; k < shared; k++)out.push({
            a: runA[k],
            b: runB[k]
        });
        for(let k = shared; k < runA.length; k++)out.push({
            a: runA[k],
            b: null
        });
        for(let k = shared; k < runB.length; k++)out.push({
            a: null,
            b: runB[k]
        });
        runA = [];
        runB = [];
    };
    while(i < n && j < m){
        if (keyA[i] === keyB[j]) {
            flushRuns();
            out.push({
                a: childrenA[i],
                b: childrenB[j]
            });
            i++;
            j++;
        } else if (lcs[i + 1][j] >= lcs[i][j + 1]) {
            runA.push(childrenA[i]);
            i++;
        } else {
            runB.push(childrenB[j]);
            j++;
        }
    }
    while(i < n){
        runA.push(childrenA[i]);
        i++;
    }
    while(j < m){
        runB.push(childrenB[j]);
        j++;
    }
    flushRuns();
    return out;
};
/**
 * Container classification with the rigid-child escalation rules:
 *  - list:         replace whole list if changed items / items ≥ node.ratio, else recurse
 *                  into each changed listItem's content.
 *  - table:        replace whole table if changed cells / cells ≥ node.ratio; else, for each
 *                  changed ROW, replace the row if changed cells / row-cells ≥ node.ratio,
 *                  else recurse into each changed cell's content.
 *  - layout:       replace whole section if changed columns / columns ≥ node.ratio, else
 *                  recurse into each changed column's content.
 *  - generic (panel/expand/quote/...): replace whole block if changed children / children ≥
 *                  node.ratio, else recurse into each changed child.
 */ const $2be352b0f93592ab$var$classifyContainer = (blockA, blockB, changes, originalDoc, newDoc, locale, thresholds)=>{
    const typeName = blockB.node.type.name;
    // Tables need cell-level counting across rows; handle them specially.
    if (typeName === 'table') return $2be352b0f93592ab$var$classifyTable(blockA, blockB, changes, originalDoc, newDoc, locale, thresholds);
    // Container's own markup changed (same type, differing attrs) — e.g. a panel type
    // change. It touches no inner child, so the child-density check below would drop it.
    // Promote the whole container to a before/after change. (Table cells take the
    // `classifyChild` path, not this one.)
    if (!blockA.node.sameMarkup(blockB.node)) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    const childrenB = $2be352b0f93592ab$var$childRefs(blockB);
    const childrenA = $2be352b0f93592ab$var$childRefs(blockA);
    const changed = $2be352b0f93592ab$var$changedChildIndices(blockB, childrenB, changes);
    const denom = Math.max(childrenA.length, childrenB.length, 1);
    if (changed.size / denom >= thresholds.node.ratio) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    // Below threshold → recurse per child, using an LCS alignment so inserted/removed children
    // do not mis-pair (which previously corrupted A-side coordinates and leaked one block's
    // deletions into another). Each alignment entry is one of:
    //   - matched (a & b): recurse to classify any intra-child changes (skipped if identical);
    //   - added (b only):  a pure insertion, with a zero-width A anchor near its position;
    //   - removed (a only): a pure deletion, with a zero-width B anchor near its position.
    const alignment = $2be352b0f93592ab$var$alignChildren(childrenA, childrenB);
    const out = [];
    // Running A/B anchors from the last matched pair, so pure insert/delete get sensible
    // zero-width coordinates on the opposite side.
    let lastMatchedAEnd = blockA.from + 1;
    let lastMatchedBEnd = blockB.from + 1;
    for (const { a: a, b: b } of alignment){
        if (a && b) {
            lastMatchedAEnd = a.to;
            lastMatchedBEnd = b.to;
            // Identical content is left as-is by the LCS; if a change still overlaps this pair
            // (e.g. marks), recurse to classify it.
            const childChanges = changes.filter((c)=>(0, $ekAyE.rangesOverlap)(c.fromB, Math.max(c.toB, c.fromB + 1), b.from, b.to));
            if (childChanges.length === 0) continue;
            out.push(...$2be352b0f93592ab$var$classifyChild(a, b, childChanges, originalDoc, newDoc, locale, thresholds));
            continue;
        }
        if (b && !a) {
            // Added child: pure insertion. Anchor the (empty) A side at the last matched A end.
            out.push((0, $ekAyE.makePromotedChange)(lastMatchedAEnd, lastMatchedAEnd, b.from, b.to, 'node'));
            lastMatchedBEnd = b.to;
            continue;
        }
        if (a && !b) {
            // Removed child: pure deletion. Anchor the (empty) B side at the last matched B end.
            out.push((0, $ekAyE.makePromotedChange)(a.from, a.to, lastMatchedBEnd, lastMatchedBEnd, 'node'));
            lastMatchedAEnd = a.to;
        }
    }
    return out;
};
/**
 * Classify a table: replace the whole table when changed-cells/total-cells ≥ node.ratio;
 * otherwise for each changed row, replace the row when its own changed-cells/row-cells ≥
 * node.ratio, else recurse into each changed cell.
 */ const $2be352b0f93592ab$var$classifyTable = (blockA, blockB, changes, originalDoc, newDoc, locale, thresholds)=>{
    const rowsB = $2be352b0f93592ab$var$childRefs(blockB);
    const rowsA = $2be352b0f93592ab$var$childRefs(blockA);
    // Total cell counts across the whole table.
    let totalCellsB = 0;
    let changedCellsB = 0;
    const perRowChangedCells = new Map();
    for (const row of rowsB){
        const cells = $2be352b0f93592ab$var$childRefs(row);
        totalCellsB += cells.length;
        const changedCells = $2be352b0f93592ab$var$changedChildIndices(row, cells, changes);
        if (changedCells.size > 0) {
            perRowChangedCells.set(row.index, changedCells);
            changedCellsB += changedCells.size;
        }
    }
    let totalCellsA = 0;
    for (const row of rowsA)totalCellsA += row.node.childCount;
    const cellDenom = Math.max(totalCellsA, totalCellsB, 1);
    // Whole-table replacement.
    if (changedCellsB / cellDenom >= thresholds.node.ratio) return [
        $2be352b0f93592ab$var$wholeBlockChange(blockA, blockB, changes)
    ];
    const out = [];
    // LCS-align rows (mirrors classifyContainer) so an inserted/deleted row does not mis-pair
    // every subsequent row by index (which would corrupt the row-level A coordinates).
    const rowAlignment = $2be352b0f93592ab$var$alignChildren(rowsA, rowsB);
    let lastMatchedRowAEnd = blockA.from + 1;
    let lastMatchedRowBEnd = blockB.from + 1;
    for (const { a: rowA, b: rowB } of rowAlignment){
        // Added row: pure insertion (only if it actually carries changes).
        if (rowB && !rowA) {
            if ((perRowChangedCells.get(rowB.index)?.size ?? 0) > 0) out.push((0, $ekAyE.makePromotedChange)(lastMatchedRowAEnd, lastMatchedRowAEnd, rowB.from, rowB.to, 'node'));
            lastMatchedRowBEnd = rowB.to;
            continue;
        }
        // Removed row: pure deletion.
        if (rowA && !rowB) {
            out.push((0, $ekAyE.makePromotedChange)(rowA.from, rowA.to, lastMatchedRowBEnd, lastMatchedRowBEnd, 'node'));
            lastMatchedRowAEnd = rowA.to;
            continue;
        }
        if (!rowA || !rowB) continue;
        lastMatchedRowAEnd = rowA.to;
        lastMatchedRowBEnd = rowB.to;
        const changedCells = perRowChangedCells.get(rowB.index);
        if (!changedCells || changedCells.size === 0) continue;
        const cellsB = $2be352b0f93592ab$var$childRefs(rowB);
        // Row-level replacement.
        if (changedCells.size / Math.max(rowA.node.childCount, cellsB.length, 1) >= thresholds.node.ratio) {
            out.push((0, $ekAyE.makePromotedChange)(rowA.from, rowA.to, rowB.from, rowB.to, 'node'));
            continue;
        }
        // Else recurse into each changed cell's content (cell is never replaced alone). Cells are
        // positionally aligned within a matched row (table columns are fixed, so a cell at index i
        // on the B side corresponds to index i on the A side).
        const cellsA = $2be352b0f93592ab$var$childRefs(rowA);
        for (const cellB of cellsB){
            if (!changedCells.has(cellB.index)) continue;
            const cellA = cellsA[cellB.index] ?? null;
            const cellChanges = changes.filter((c)=>(0, $ekAyE.rangesOverlap)(c.fromB, Math.max(c.toB, c.fromB + 1), cellB.from, cellB.to));
            out.push(...$2be352b0f93592ab$var$classifyChild(cellA, cellB, cellChanges, originalDoc, newDoc, locale, thresholds));
        }
    }
    return out;
};
/**
 * Recurse into a rigid/structural child (listItem, layoutColumn, tableCell/tableHeader) or a
 * plain child block. Rigid children are containers of blocks: we recurse into THEIR children
 * (paragraphs, nested lists, …) so we never delete+replace the rigid child itself. A plain
 * text-bearing or container child is classified directly.
 */ const $2be352b0f93592ab$var$classifyChild = (childA, childB, changes, originalDoc, newDoc, locale, thresholds)=>{
    if (changes.length === 0) return [];
    const typeName = childB.node.type.name;
    const asBlock = (ref)=>ref ? {
            node: ref.node,
            from: ref.from,
            to: ref.to
        } : null;
    // Structurally-rigid wrapper (layoutColumn / tableCell / tableHeader): the wrapper itself is
    // NEVER a whole-block result — deleting+re-inserting a single column or cell would break the
    // parent layout/table structure. We only reach here because the parent already decided NOT
    // to promote wholesale, so we bypass `classifyContainer` (which could promote the whole
    // wrapper when it is internally dense) and classify EACH of the wrapper's direct children on
    // its own. This keeps the diff strictly inside the wrapper (inline / sentence / paragraph,
    // or a nested container such as a list inside a table cell).
    if ($2be352b0f93592ab$var$RIGID_CHILD_TYPES.has(typeName)) {
        const blockB = asBlock(childB);
        if (!blockB) return [];
        const wrapperA = asBlock(childA);
        const childrenB = $2be352b0f93592ab$var$childRefs(blockB);
        const childrenA = wrapperA ? $2be352b0f93592ab$var$childRefs(wrapperA) : [];
        const out = [];
        // An attribute-only change on the wrapper itself (e.g. a table cell's
        // `background`) sits on the node boundary, not inside any inner child, so the
        // recursion below would emit nothing and the change would be dropped. Emit a
        // whole-wrapper change instead, which also subsumes any inner content change.
        if (wrapperA && !wrapperA.node.sameMarkup(blockB.node)) {
            out.push((0, $ekAyE.makePromotedChange)(wrapperA.from, wrapperA.to, blockB.from, blockB.to, 'node'));
            return out;
        }
        // LCS-align inner children (mirrors classifyContainer) so a paragraph inserted/deleted
        // inside the cell/column does not mis-pair every subsequent inner child by index. We never
        // promote the wrapper itself here — we only classify each inner child.
        const alignment = $2be352b0f93592ab$var$alignChildren(childrenA, childrenB);
        let lastMatchedAEnd = wrapperA ? wrapperA.from + 1 : blockB.from + 1;
        let lastMatchedBEnd = blockB.from + 1;
        for (const { a: a, b: b } of alignment){
            if (a && b) {
                lastMatchedAEnd = a.to;
                lastMatchedBEnd = b.to;
                const innerChanges = changes.filter((c)=>(0, $ekAyE.rangesOverlap)(c.fromB, Math.max(c.toB, c.fromB + 1), b.from, b.to));
                if (innerChanges.length === 0) continue;
                out.push(...$2be352b0f93592ab$var$classifyChild(a, b, innerChanges, originalDoc, newDoc, locale, thresholds));
                continue;
            }
            if (b && !a) {
                // Added inner child: pure insertion, zero-width A anchor at the last matched A end.
                out.push((0, $ekAyE.makePromotedChange)(lastMatchedAEnd, lastMatchedAEnd, b.from, b.to, 'node'));
                lastMatchedBEnd = b.to;
                continue;
            }
            if (a && !b) {
                // Removed inner child: pure deletion, zero-width B anchor at the last matched B end.
                out.push((0, $ekAyE.makePromotedChange)(a.from, a.to, lastMatchedBEnd, lastMatchedBEnd, 'node'));
                lastMatchedAEnd = a.to;
            }
        }
        return out;
    }
    // A `listItem` CAN be replaced wholesale (delete + re-insert at the same position does not
    // break the list's structure), so per the spec it uses the normal container rule: promote
    // the whole item when its own content is dense enough, else recurse into its children.
    if (typeName === 'listItem') {
        const blockB = asBlock(childB);
        const blockAItem = asBlock(childA);
        // Pure deletion of the item: emit the whole A-side item as deleted (zero-width B anchor at
        // the item's own B-less position — anchored at the A start for lack of parent context).
        if (!blockB) return blockAItem ? [
            (0, $ekAyE.makePromotedChange)(blockAItem.from, blockAItem.to, blockAItem.from, blockAItem.from, 'node')
        ] : [];
        // Pure insertion of the item: emit the whole B-side item as inserted with a ZERO-WIDTH A
        // anchor. (Using `blockB` as the A side would make the LCS compare the item against itself
        // and drop the insertion.)
        if (!blockAItem) return [
            (0, $ekAyE.makePromotedChange)(blockB.from, blockB.from, blockB.from, blockB.to, 'node')
        ];
        return $2be352b0f93592ab$var$classifyContainer(blockAItem, blockB, changes, originalDoc, newDoc, locale, thresholds);
    }
    // Plain child block: classify as its own group (text or nested container).
    return $2be352b0f93592ab$var$classifyBlockGroup({
        blockA: asBlock(childA),
        blockB: asBlock(childB),
        changes: changes
    }, originalDoc, newDoc, locale, thresholds);
};
module.exports["classifySmartChanges"] = $2be352b0f93592ab$export$c15105fe770d78d4;

});

parcelRegister("ekAyE", function(module, exports) {
const $5a823ae841a62560$export$c71ba38a098bdec3 = (length, data = null)=>length > 0 ? [
        {
            length: length,
            data: data
        }
    ] : [];
const $5a823ae841a62560$export$71d4e291db87dd0a = (fromA, toA, fromB, toB, level)=>{
    const data = level ? {
        smartLevel: level
    } : null;
    // `deleted` and `inserted` must be independent arrays: downstream code may mutate one
    // side (push/splice), which would silently corrupt the other if they shared a reference.
    return {
        fromA: fromA,
        toA: toA,
        fromB: fromB,
        toB: toB,
        deleted: $5a823ae841a62560$export$c71ba38a098bdec3(Math.max(0, toA - fromA), data),
        inserted: $5a823ae841a62560$export$c71ba38a098bdec3(Math.max(0, toB - fromB), data)
    };
};
const $5a823ae841a62560$export$bd99dc0a81d559c2 = (change)=>{
    const spans = [
        ...change.inserted,
        ...change.deleted
    ];
    for (const span of spans){
        const data = span.data;
        if (data && typeof data === 'object' && 'smartLevel' in data) return data.smartLevel;
    }
    return undefined;
};
/** True when a change has no original-side (deleted) content — a pure insertion. */ const $5a823ae841a62560$var$isPureInsertion = (change)=>change.toA <= change.fromA;
const $5a823ae841a62560$export$866b12e69287308f = (changes)=>{
    if (changes.length <= 1) return changes;
    const sorted = [
        ...changes
    ].sort((l, r)=>l.fromB - r.fromB);
    const merged = [];
    let current = {
        ...sorted[0]
    };
    for(let i = 1; i < sorted.length; i++){
        const next = sorted[i];
        const bOverlaps = next.fromB <= current.toB;
        // A ranges may be unioned only if they touch, or if either side contributes no A content.
        const aMergeable = $5a823ae841a62560$var$isPureInsertion(current) || $5a823ae841a62560$var$isPureInsertion(next) || $5a823ae841a62560$export$8f43b23b5d8de905(current.fromA, current.toA, next.fromA, next.toA) || next.fromA <= current.toA; // adjacency (sorted by B, A usually monotonic)
        if (bOverlaps && aMergeable) current = {
            fromA: Math.min(current.fromA, next.fromA),
            toA: Math.max(current.toA, next.toA),
            fromB: Math.min(current.fromB, next.fromB),
            toB: Math.max(current.toB, next.toB),
            deleted: [
                ...current.deleted,
                ...next.deleted
            ],
            inserted: [
                ...current.inserted,
                ...next.inserted
            ]
        };
        else {
            merged.push(current);
            current = {
                ...next
            };
        }
    }
    merged.push(current);
    return merged;
};
const $5a823ae841a62560$export$8f43b23b5d8de905 = (aFrom, aTo, bFrom, bTo)=>aFrom < bTo && bFrom < aTo;
module.exports["makePromotedChange"] = $5a823ae841a62560$export$71d4e291db87dd0a;
module.exports["smartChangeLevel"] = $5a823ae841a62560$export$bd99dc0a81d559c2;
module.exports["mergeOverlappingByNewDocRange"] = $5a823ae841a62560$export$866b12e69287308f;
module.exports["rangesOverlap"] = $5a823ae841a62560$export$8f43b23b5d8de905;

});

parcelRegister("doA2E", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bf98d11c5fdd996e$var$message = (0, $kSwu1.defineMessages)({
    closeButtonLabel: {
        id: "ai-mate.inline-chat-input.error-view.close-button.label",
        defaultMessage: "Close"
    },
    retryButtonLabel: {
        id: "ai-mate.inline-chat-input.error-view.retry-button.label",
        defaultMessage: "Try again"
    },
    rateLimited: {
        id: "ai-mate.inline-chat-input.error-view.message.rate-limited",
        defaultMessage: "You\u2019ve reached the maximum number of requests. Try again later. <a>Excessive use of AI</a>."
    },
    aupViolation: {
        id: "ai-mate.inline-chat-input.error-view.message.aup-violation",
        defaultMessage: "Content does not comply with our <a>Acceptable Use Policy</a>."
    },
    tokenLimitExceeded: {
        id: "ai-mate.inline-chat-input.error-view.message.token-limit-exceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    unknownError: {
        id: "ai-mate.inline-chat-input.error-view.message.unknown-error",
        defaultMessage: "An unknown error occurred."
    }
});
var $bf98d11c5fdd996e$export$2e2bcd8739ae039 = $bf98d11c5fdd996e$var$message;
module.exports["default"] = $bf98d11c5fdd996e$export$2e2bcd8739ae039;

});

parcelRegister("2zysC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $krYZG = parcelRequire("krYZG");


var $faAj4 = parcelRequire("faAj4");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $kCECX = parcelRequire("kCECX");


var $f6cdQ = parcelRequire("f6cdQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a1L5E = parcelRequire("a1L5E");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $ljEF1 = parcelRequire("ljEF1");


var $fJ1pJ = parcelRequire("fJ1pJ");


var $bgSPm = parcelRequire("bgSPm");


var $4hbTS = parcelRequire("4hbTS");


var $irnO2 = parcelRequire("irnO2");


var $hlvTd = parcelRequire("hlvTd");


var $iuCeV = parcelRequire("iuCeV");


var $iDlFY = parcelRequire("iDlFY");


var $8VrqA = parcelRequire("8VrqA");


var $d5gEx = parcelRequire("d5gEx");


var $YooNh = parcelRequire("YooNh");


var $8ICFm = parcelRequire("8ICFm");


var $cH7ad = parcelRequire("cH7ad");











var $4o0zT = parcelRequire("4o0zT");


var $4y2BX = parcelRequire("4y2BX");


const $3befc6b2946e1176$var$ComposableEditorWithSkillsV2Lazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("7tj1Z")).then((mod)=>({
            default: mod.ComposableEditorWithSkills
        })));
const $3befc6b2946e1176$export$48f1a0a0937ec5aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if ((0, $4o0zT.isExperimentEnabled)("platform_editor_insert_menu_ai")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3befc6b2946e1176$var$ComposableEditorWithSkillsV2Lazy, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4y2BX.ComposableEditorWithSkills), props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    if ((0, $4o0zT.isExperimentEnabled)('platform_editor_insert_menu_ai')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3befc6b2946e1176$var$ComposableEditorWithSkillsV2Lazy, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4y2BX.ComposableEditorWithSkills), props);
};



var $b8kYV = parcelRequire("b8kYV");


var $aJU2k = parcelRequire("aJU2k");


var $a6scT = parcelRequire("a6scT");








var $hekY6 = parcelRequire("hekY6");











var $7sJoX = parcelRequire("7sJoX");


var $j78zM = parcelRequire("j78zM");


var $hBYtq = parcelRequire("hBYtq");





var $fgCwN = parcelRequire("fgCwN");




const $c6ee670ecaf15855$var$message = (0, $kSwu1.defineMessages)({
    selectAgentLabel: {
        id: "ai-mate.inline-chat-input.agent-selector.select-agent",
        defaultMessage: "Select agent, current agent is {agentName}"
    },
    defaultAgentName: {
        id: "ai-mate.inline-chat-input.agent-selector.default-agent-name",
        defaultMessage: "Rovo"
    }
});
var $c6ee670ecaf15855$export$2e2bcd8739ae039 = $c6ee670ecaf15855$var$message;



const $a47b6b8d439115fa$var$LazyAgentMenu = /*#__PURE__*/ (0, $cozmU.lazy)(async ()=>({
        default: (await (parcelRequire("8NROu"))).AgentMenu
    }));
const $a47b6b8d439115fa$var$styles = {
    trigger: "_2mHwu81Y8M _0bjKvD8fU6 _2Y7lL41Y8M _4c065U1Y8M _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC _4xdlr0DIqT _2xTnZxgVvo _0GTcwR5UaJ _0KLXru66of _1UtDYzZpcK _0wOv4Q7zJH _1eOmH6o126 _3gzVzLN4oS",
    triggerNudgedForEditorPadding: "_1mT5xdRAKS _2I62gz5UaJ",
    icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
    expandingRegion: "_3iDTPbgBM8 _1kOSYtGkTF _3Z9K0w2HTN _0qk6IK1fFG _2Iz54kUiLg",
    expanded: "_2iEGP2UfmU _1YKVNs7dHp",
    collapsed: "_2iEGP2VDI5 _1YKVNsdnbC",
    expandingContent: "_2mHwu81Y8M _4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1ANEUSLRg7"
};
const $a47b6b8d439115fa$export$8320f9b7f97e17d0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { agent: agent, onAgentSelect: onAgentSelect, assistanceServiceParams: assistanceServiceParams, siteId: siteId, isDisabled: isDisabled, compact: compact, shouldRenderInPortal: shouldRenderInPortal } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isPointerOver, setIsPointerOver] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const [hasOpened, setHasOpened] = (0, $cozmU.useState)(false);
    const isExpanded = isOpen || isPointerOver || isFocused;
    let t1;
    if ($[0] !== agent?.name || $[1] !== formatMessage) {
        t1 = agent?.name ?? formatMessage((0, $c6ee670ecaf15855$export$2e2bcd8739ae039).defaultAgentName);
        $[0] = agent?.name;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    const agentName = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (event)=>{
            try {
                setIsFocused(event.currentTarget.matches(":focus-visible"));
            } catch  {
                setIsFocused(false);
            }
        };
        $[3] = t2;
    } else t2 = $[3];
    const handleFocus = t2;
    let t3;
    if ($[4] !== onAgentSelect) {
        t3 = (selectedAgent)=>{
            onAgentSelect(selectedAgent ?? null);
            setIsOpen(false);
        };
        $[4] = onAgentSelect;
        $[5] = t3;
    } else t3 = $[5];
    const handleAgentSelect = t3;
    let t4;
    if ($[6] !== agent || $[7] !== agentName || $[8] !== compact || $[9] !== formatMessage || $[10] !== isDisabled || $[11] !== isExpanded || $[12] !== isOpen) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ...triggerProps,
                xcss: (0, $w6R6I.cx)($a47b6b8d439115fa$var$styles.trigger, !compact && $a47b6b8d439115fa$var$styles.triggerNudgedForEditorPadding),
                testId: "inline-chat-prompt-agent-selector",
                isDisabled: isDisabled,
                "aria-label": formatMessage((0, $c6ee670ecaf15855$export$2e2bcd8739ae039).selectAgentLabel, {
                    agentName: agentName
                }),
                "aria-expanded": isOpen,
                "aria-haspopup": "menu",
                onClick: ()=>{
                    setHasOpened(true);
                    setIsOpen($a47b6b8d439115fa$var$_temp);
                },
                onMouseEnter: ()=>setIsPointerOver(true),
                onMouseLeave: ()=>setIsPointerOver(false),
                onFocus: handleFocus,
                onBlur: ()=>setIsFocused(false)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    $a47b6b8d439115fa$var$styles.icon
                ])
            }, agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgCwN.PromptAgentAvatar), {
                agent: agent
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j78zM.RovoHexIcon), {
                label: "",
                size: "xsmall"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "aria-hidden": "true",
                "data-expanded": isExpanded,
                "data-testid": "inline-chat-prompt-agent-selector-label",
                className: (0, $hekY6.default)([
                    $a47b6b8d439115fa$var$styles.expandingRegion,
                    isExpanded ? $a47b6b8d439115fa$var$styles.expanded : $a47b6b8d439115fa$var$styles.collapsed
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    $a47b6b8d439115fa$var$styles.expandingContent
                ])
            }, agentName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: ""
            }))));
        $[6] = agent;
        $[7] = agentName;
        $[8] = compact;
        $[9] = formatMessage;
        $[10] = isDisabled;
        $[11] = isExpanded;
        $[12] = isOpen;
        $[13] = t4;
    } else t4 = $[13];
    const renderTrigger = t4;
    if (!hasOpened) {
        let t5;
        if ($[14] !== renderTrigger) {
            t5 = renderTrigger();
            $[14] = renderTrigger;
            $[15] = t5;
        } else t5 = $[15];
        return t5;
    }
    let t5;
    if ($[16] !== renderTrigger) {
        t5 = renderTrigger();
        $[16] = renderTrigger;
        $[17] = t5;
    } else t5 = $[17];
    const t6 = agent ?? undefined;
    let t7;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[18] = t7;
    } else t7 = $[18];
    const t8 = !shouldRenderInPortal;
    let t9;
    if ($[19] !== assistanceServiceParams || $[20] !== handleAgentSelect || $[21] !== isOpen || $[22] !== renderTrigger || $[23] !== siteId || $[24] !== t6 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a47b6b8d439115fa$var$LazyAgentMenu, {
            selectedAgent: t6,
            isAgentDropdownOpen: isOpen,
            setIsAgentDropdownOpen: setIsOpen,
            onClose: t7,
            trigger: renderTrigger,
            placement: "top-start",
            shouldRenderToParent: t8,
            siteId: siteId,
            assistanceServiceParams: assistanceServiceParams,
            onAgentSelect: handleAgentSelect,
            touchpointSource: "inline-chat-prompt-agent-selector",
            autofocus: true,
            createConversationOptimistically: $a47b6b8d439115fa$var$_temp2
        });
        $[19] = assistanceServiceParams;
        $[20] = handleAgentSelect;
        $[21] = isOpen;
        $[22] = renderTrigger;
        $[23] = siteId;
        $[24] = t6;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== t5 || $[28] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t5
        }, t9));
        $[27] = t5;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    return t10;
} : ({ agent: agent, onAgentSelect: onAgentSelect, assistanceServiceParams: assistanceServiceParams, siteId: siteId, isDisabled: isDisabled, compact: compact, shouldRenderInPortal: shouldRenderInPortal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isPointerOver, setIsPointerOver] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false); // `AgentMenu` pulls in Relay and the agent permission controllers, so it is
    // only mounted once the user actually opens the menu. Until then the trigger
    // renders on its own and the prompt pays nothing for it.
    const [hasOpened, setHasOpened] = (0, $cozmU.useState)(false); // Keep the label expanded while the menu is open so the trigger doesn't
    // collapse out from under the popup when the pointer moves into it.
    const isExpanded = isOpen || isPointerOver || isFocused;
    const agentName = agent?.name ?? formatMessage((0, $c6ee670ecaf15855$export$2e2bcd8739ae039).defaultAgentName); /**
                                                                              * Only keyboard focus should expand the trigger. Closing the menu returns
                                                                              * focus here, so treating every focus as an expand left the label stuck open
                                                                              * after picking an agent with the mouse.
                                                                              */ 
    const handleFocus = (0, $cozmU.useCallback)((event)=>{
        try {
            setIsFocused(event.currentTarget.matches(':focus-visible'));
        } catch  {
            // `:focus-visible` is unsupported in some test environments.
            setIsFocused(false);
        }
    }, []);
    const handleAgentSelect = (0, $cozmU.useCallback)((selectedAgent)=>{
        // `AgentMenu` passes `undefined` for its "Chat with Rovo" item, which is
        // how the user gets back to the default assistant. Coerced to `null` so
        // the controller clears the selection rather than ignoring it.
        onAgentSelect(selectedAgent ?? null);
        setIsOpen(false);
    }, [
        onAgentSelect
    ]);
    const renderTrigger = (0, $cozmU.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...triggerProps,
            xcss: (0, $w6R6I.cx)($a47b6b8d439115fa$var$styles.trigger, !compact && $a47b6b8d439115fa$var$styles.triggerNudgedForEditorPadding),
            testId: "inline-chat-prompt-agent-selector",
            isDisabled: isDisabled,
            "aria-label": formatMessage((0, $c6ee670ecaf15855$export$2e2bcd8739ae039).selectAgentLabel, {
                agentName: agentName
            }),
            "aria-expanded": isOpen,
            "aria-haspopup": "menu",
            onClick: ()=>{
                setHasOpened(true);
                setIsOpen((open)=>!open);
            },
            onMouseEnter: ()=>setIsPointerOver(true),
            onMouseLeave: ()=>setIsPointerOver(false),
            onFocus: handleFocus,
            onBlur: ()=>setIsFocused(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $a47b6b8d439115fa$var$styles.icon
            ])
        }, agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fgCwN.PromptAgentAvatar), {
            agent: agent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j78zM.RovoHexIcon), {
            label: "",
            size: "xsmall"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            // jsdom can't resolve — this makes the state assertable in tests.
            "data-expanded": isExpanded,
            "data-testid": "inline-chat-prompt-agent-selector-label",
            className: (0, $hekY6.default)([
                $a47b6b8d439115fa$var$styles.expandingRegion,
                isExpanded ? $a47b6b8d439115fa$var$styles.expanded : $a47b6b8d439115fa$var$styles.collapsed
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $a47b6b8d439115fa$var$styles.expandingContent
            ])
        }, agentName, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: ""
        })))), [
        agent,
        agentName,
        compact,
        formatMessage,
        handleFocus,
        isDisabled,
        isExpanded,
        isOpen
    ]);
    if (!hasOpened) return renderTrigger();
    return(// `AgentMenu` calls `useRelayEnvironment()`. The inline prompt is only
    // wrapped in a Relay provider on the agent-mentions path, so without this
    // the menu would throw for every other consumer. The conditional provider
    // reuses an ancestor environment when one already exists.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: renderTrigger()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a47b6b8d439115fa$var$LazyAgentMenu, {
        selectedAgent: agent ?? undefined,
        isAgentDropdownOpen: isOpen,
        setIsAgentDropdownOpen: setIsOpen,
        onClose: ()=>setIsOpen(false),
        trigger: renderTrigger,
        placement: "top-start",
        shouldRenderToParent: !shouldRenderInPortal,
        siteId: siteId,
        assistanceServiceParams: assistanceServiceParams,
        onAgentSelect: handleAgentSelect,
        touchpointSource: "inline-chat-prompt-agent-selector",
        autofocus: true // `onAgentSelect` takes precedence over starting a new conversation,
        ,
        // which is Rovo Chat behaviour and not meaningful for the inline prompt.
        createConversationOptimistically: ()=>{}
    }))));
};
function $a47b6b8d439115fa$var$_temp(open) {
    return !open;
}
function $a47b6b8d439115fa$var$_temp2() {}


















var $9KSWX = parcelRequire("9KSWX");




var $4aRua = parcelRequire("4aRua");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");










const $12bb3b2b2e063e09$export$36be37b392de5213 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { darkMode: t1 } = t0;
    const darkMode = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== darkMode) {
        t2 = darkMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "8",
            viewBox: "0 0 10 8",
            fill: "none",
            "data-testid": "confluence-labs-icon-dark"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_1466_13761)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
            fill: "white"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_1466_13761"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "8.25276",
            height: "7.89",
            fill: "white",
            transform: "translate(0.9375 0.0625)"
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "10",
            height: "8",
            viewBox: "0 0 10 8",
            fill: "none",
            "data-testid": "confluence-labs-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_1352_45568)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
            fill: "#1E1F21"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_1352_45568"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "8.25276",
            height: "7.89",
            fill: "white",
            transform: "translate(0.9375 0.0625)"
        }))));
        $[0] = darkMode;
        $[1] = t2;
    } else t2 = $[1];
    return t2;
} : ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "confluence-labs-icon-dark"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1466_13761)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1466_13761"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "confluence-labs-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1352_45568)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
        fill: "#1E1F21"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1352_45568"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "8.25276",
        height: "7.89",
        fill: "white",
        transform: "translate(0.9375 0.0625)"
    }))));
};


const $f837a03f954dcc0a$var$i18n = (0, $kSwu1.defineMessages)({
    tooltip: {
        id: "ai-common.confluence-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $f837a03f954dcc0a$var$lozengeStyles = {
    lozenge: "_0bjKvDKxmn _2Y7lL41Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    tooltip: "_0bjKvDKxmn _2sNsIg7NXe _24h04i2Njc _1EqgXl3ScF _0KLXrugozt _1UtDYze5R3 _2I62gzPgdg _3iC0zdPgdg _3zvHkHwPeg _0xmtkoFQfX _46hvQmFQfX _03SyCPgVvo _0LQT5EgVvo _1T2N03wPeg"
};
const $f837a03f954dcc0a$var$gradientWaveKeyframes = null;
const $f837a03f954dcc0a$var$lozengeAnimatedBorder = null;
const $f837a03f954dcc0a$var$textContainerStyles = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $f837a03f954dcc0a$var$CustomTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomTooltip(t0, ref) {
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f837a03f954dcc0a$var$lozengeStyles.tooltip
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B9Aq.default), {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            $f837a03f954dcc0a$var$lozengeStyles.tooltip
        ])
    }, children);
});
const $f837a03f954dcc0a$var$LozengeSurface = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { variant: variant, colorMode: colorMode } = t0;
    if (variant === "maui") {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                appearance: "discovery",
                testId: "maui-labs-lozenge"
            }, "Labs");
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $f837a03f954dcc0a$var$lozengeStyles.lozenge,
            "_0bjKvDKxmn _2Y7lL41Y8M _1mT5xdRAKS _0KLXru66of _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _42Yu6BdnbC _4jFnWednbC _1OimfuKxmn _2DOjOvHZdu _1F91ciHZdu _0uxO31HZdu _1UtDrQHZdu _4eDJc6ftom _2OUbymteVz _3Ku51Iogpp _3dCYwDWVPG _34UJl7zGaF _2wDIRleai3 _2bDXQqstGY _2COm2lk2L1 _0UsFEzYbGa _3qT6l0vQQr"
        ]);
        $[1] = t1;
    } else t1 = $[1];
    const t2 = colorMode === "dark";
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12bb3b2b2e063e09$export$36be37b392de5213), {
            darkMode: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_26BoRw70UD _41LZZBAv7U"
        ]);
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: "small",
            weight: "semibold",
            color: "color.text"
        }, "Labs");
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t4;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t3 || $[9] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            grow: "hug",
            space: "space.025",
            alignBlock: "center"
        }, t3, t6);
        $[8] = t3;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t1 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-labs-lozenge-variant": "default",
            "data-testid": "labs-lozenge",
            className: t1
        }, t7);
        $[11] = t1;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ variant: variant, colorMode: colorMode })=>{
    if (variant === 'maui') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "discovery",
        testId: "maui-labs-lozenge"
    }, "Labs");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-labs-lozenge-variant": "default",
        "data-testid": "labs-lozenge",
        className: (0, $hekY6.default)([
            $f837a03f954dcc0a$var$lozengeStyles.lozenge,
            "_0bjKvDKxmn _2Y7lL41Y8M _1mT5xdRAKS _0KLXru66of _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _42Yu6BdnbC _4jFnWednbC _1OimfuKxmn _2DOjOvHZdu _1F91ciHZdu _0uxO31HZdu _1UtDrQHZdu _4eDJc6ftom _2OUbymteVz _3Ku51Iogpp _3dCYwDWVPG _34UJl7zGaF _2wDIRleai3 _2bDXQqstGY _2COm2lk2L1 _0UsFEzYbGa _3qT6l0vQQr"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        grow: "hug",
        space: "space.025",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12bb3b2b2e063e09$export$36be37b392de5213), {
        darkMode: colorMode === 'dark'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_26BoRw70UD _41LZZBAv7U"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        weight: "semibold",
        color: "color.text"
    }, "Labs"))));
};
const $f837a03f954dcc0a$export$8c4514d5420b4a89 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { variant: t1 } = t0;
    const variant = t1 === undefined ? "default" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($f837a03f954dcc0a$var$i18n.tooltip);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== colorMode || $[3] !== variant) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f837a03f954dcc0a$var$LozengeSurface, {
            variant: variant,
            colorMode: colorMode
        });
        $[2] = colorMode;
        $[3] = variant;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            component: $f837a03f954dcc0a$var$CustomTooltip,
            content: t2
        }, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ variant: variant = 'default' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        component: $f837a03f954dcc0a$var$CustomTooltip,
        content: formatMessage($f837a03f954dcc0a$var$i18n.tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f837a03f954dcc0a$var$LozengeSurface, {
        variant: variant,
        colorMode: colorMode
    }));
};





const $b6ac7ea22ecea738$var$message = (0, $kSwu1.defineMessages)({
    sendButtonLabel: {
        id: "ai-mate.inline-chat-input.send-button.label",
        defaultMessage: "Submit"
    },
    chatInputAssistiveLabel: {
        id: "ai-mate.inline-chat-input.chat-input-assistive-label",
        defaultMessage: "Describe what you want to do..."
    },
    chatInputAssistiveLabelShort: {
        id: "ai-mate.inline-chat-input.chat-input-assistive-label.short",
        defaultMessage: "Describe what to do..."
    }
});
var $b6ac7ea22ecea738$export$2e2bcd8739ae039 = $b6ac7ea22ecea738$var$message;






var $cXtTj = parcelRequire("cXtTj");


var $aW7DE = parcelRequire("aW7DE");

const $fe33a1c51fbf98e7$var$hasMentionOrInlineCard = (doc)=>{
    let hasMentionOrCard = false;
    doc.descendants((node)=>{
        if (node.type.name === 'mention' || node.type.name === 'inlineCard' || node.type.name === 'inlineExtension') {
            hasMentionOrCard = true;
            return false;
        }
        return true;
    });
    return hasMentionOrCard;
};
const $fe33a1c51fbf98e7$export$874d5786bac2d187 = ({ assistiveLabel: assistiveLabel, defaultValue: defaultValue, mentionResource: mentionResource, onPromptContentChange: onPromptContentChange, popupsMountPoint: popupsMountPoint, preset: preset, setHasMentionOrInlineCard: setHasMentionOrInlineCard, setInputValue: setInputValue, stableOnSave: stableOnSave })=>{
    const sharedEditorProps = (0, $cozmU.useMemo)(()=>{
        return {
            assistiveLabel: assistiveLabel,
            minHeight: 20,
            shouldFocus: true,
            preset: preset,
            mentionProvider: mentionResource,
            maxHeight: 200,
            appearance: 'chromeless',
            popupsMountPoint: popupsMountPoint ?? undefined,
            defaultValue: defaultValue
        };
    }, [
        assistiveLabel,
        defaultValue,
        mentionResource,
        popupsMountPoint,
        preset
    ]);
    const stableEditorPropsLatest = {
        onPromptContentChange: onPromptContentChange,
        setHasMentionOrInlineCard: setHasMentionOrInlineCard,
        setInputValue: setInputValue
    };
    const stableEditorPropsLatestRef = (0, $cozmU.useRef)(stableEditorPropsLatest);
    stableEditorPropsLatestRef.current = stableEditorPropsLatest;
    const stableOnChange = (0, $cozmU.useCallback)((ev, meta)=>{
        const hasMentionOrCard = $fe33a1c51fbf98e7$var$hasMentionOrInlineCard(ev.state.doc);
        const latest = stableEditorPropsLatestRef.current;
        if (!meta.isDirtyChange) latest.setHasMentionOrInlineCard(hasMentionOrCard);
        latest.setInputValue((0, $aW7DE.getActualTextContent)(ev.state.doc));
        latest.onPromptContentChange?.({
            textLength: ev.state.doc.textContent.length,
            isEmpty: ev.state.doc.textContent.trim().length === 0,
            hasMentionOrInlineCard: hasMentionOrCard
        });
    // Intentional empty deps: mutable values are always read from stableEditorPropsLatestRef at call time.
    }, []);
    const stableEditorProps = (0, $cozmU.useMemo)(()=>{
        return {
            ...sharedEditorProps,
            onSave: stableOnSave,
            onChange: stableOnChange
        };
    }, [
        sharedEditorProps,
        stableOnChange,
        stableOnSave
    ]);
    // Keep the control path un-memoized so experiment-off preserves the existing editor prop/callback churn baseline.
    const controlEditorProps = {
        ...sharedEditorProps,
        onSave: (view)=>stableOnSave(view),
        onChange: (ev_0, meta_0)=>{
            const hasMentionOrCard_0 = $fe33a1c51fbf98e7$var$hasMentionOrInlineCard(ev_0.state.doc);
            if (!meta_0.isDirtyChange) setHasMentionOrInlineCard(hasMentionOrCard_0);
            setInputValue((0, $aW7DE.getActualTextContent)(ev_0.state.doc));
            onPromptContentChange?.({
                textLength: ev_0.state.doc.textContent.length,
                isEmpty: ev_0.state.doc.textContent.trim().length === 0,
                hasMentionOrInlineCard: hasMentionOrCard_0
            });
        }
    };
    return (0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false) === true ? stableEditorProps : controlEditorProps;
};


function $ed9ea009f0515a7e$export$719653a92abebf55(doc) {
    return Boolean(doc?.content?.some((block)=>'content' in block && Array.isArray(block.content) && block.content.some((node)=>node != null && node?.type === 'inlineExtension' && node?.attrs?.extensionType === 'com.atlassian.rovo.skill')));
}


const $4d4955659f8b6613$var$STORE_KEY = 'inline_prompt_view';
const $4d4955659f8b6613$var$styles = {
    stack: "_39xV02N91d _1DCdHiB0rP",
    stackWithoutContexts: "_3iDTPbcK7c",
    editorWrapper: "_1EqgXlN91d _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r21Y8M _1DCdHi5UaJ _2O5VijJTZ4",
    editorWrapperCompact: "_17l6pcPgdg _1bai7xPgdg _18dMy2Pgdg _1VNMKDPgdg",
    actions: "_2mHwu82ADO _37wbyuF05b _2O5Vij7dHp",
    labsLozenge: "_4xdlr0DIqT"
};
const $4d4955659f8b6613$var$PromptViewInternal = ({ productKey: productKey, siteId: siteId, orgId: orgId, source: source, onSubmit: onSubmit, actions: actions, onAgentSelect: onAgentSelect, isBrowseAgentsModalOpen: isBrowseAgentsModalOpen, setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen, enableAgents: enableAgents = false, currentUserId: currentUserId, agentSource: agentSource, onAgentSelected: onAgentSelected, showLabsLozenge: showLabsLozenge = false, labsLozengeVariant: labsLozengeVariant = 'default', showMauiMediaPlaceholder: showMauiMediaPlaceholder = false, agent: agent, popupsMountPoint: popupsMountPoint, useShortMessages: useShortMessages = false, compact: compact = false, onPromptContentChange: onPromptContentChange, defaultValue: defaultValue, appearance: appearance = 'default', showTrailingActions: showTrailingActions = false, shouldRenderInPortal: shouldRenderInPortal, showInlineAgentSelector: showInlineAgentSelector = false, placeholderText: placeholderTextOverride })=>{
    (0, $6cFsl.di)((0, $jlRK6.ComposableEditor), (0, $iDlFY.useEditorPlaceholder), (0, $ljEF1.useEditorPreset), (0, $aJU2k.useChatModeStoreActions), (0, $d5gEx.AtlassianRelayEnvironmentProvider));
    const saveRef = (0, $cozmU.useRef)();
    const [inputValue, setInputValue] = (0, $cozmU.useState)('');
    const [hasMentionOrInlineCard, setHasMentionOrInlineCard] = (0, $cozmU.useState)(false);
    const defaultHasSkill = (0, $cozmU.useMemo)(()=>(0, $ed9ea009f0515a7e$export$719653a92abebf55)(defaultValue), [
        defaultValue
    ]);
    const [hasSkill, setHasSkill] = (0, $cozmU.useState)(defaultHasSkill);
    (0, $cozmU.useEffect)(()=>{
        if (defaultHasSkill) setHasSkill(true);
    }, [
        defaultHasSkill
    ]);
    const submitButtonRef = (0, $cozmU.useRef)(null);
    const { value: mentionResourceOverride } = (0, $fJ1pJ.useRovoMentionProvider)();
    const { placeholder: placeholder, clearPlaceholder: clearPlaceholder } = (0, $iDlFY.useEditorPlaceholder)();
    const { highlightActionsEditorPlaceholder: highlightActionsEditorPlaceholder, clearHighlightActionsEditorPlaceholder: clearHighlightActionsEditorPlaceholder } = (0, $8VrqA.useHighlightActionsEditorPlaceholder)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const placeholderText = placeholderTextOverride ?? (showMauiMediaPlaceholder ? formatMessage((0, $b6ac7ea22ecea738$export$2e2bcd8739ae039).chatInputAssistiveLabel) : undefined);
    const assistanceServiceParams = {
        siteId: siteId,
        experienceId: 'ai-mate',
        product: productKey,
        touchpointSource: source
    };
    const { files: files, clearAttachments: clearAttachments, anyFilesUploading: anyFilesUploading } = (0, $YooNh.useConversationFiles)({
        assistanceServiceParams: assistanceServiceParams,
        key: $4d4955659f8b6613$var$STORE_KEY
    });
    const { getChatMode: getChatMode, resetReasoningMode: resetReasoningMode, setWebSearchEnabled: setWebSearchEnabled } = (0, $aJU2k.useChatModeStoreActions)();
    const mentionResource = (0, $8ICFm.useChatMentionResource)({
        productKey: productKey,
        siteId: siteId,
        orgId: orgId,
        currentUserId: currentUserId,
        mentionResourceOverride: mentionResourceOverride,
        enableAgents: enableAgents,
        agentSource: agentSource,
        onAgentSelected: onAgentSelected
    }); // In the platform_editor_rovo_editor_mention_node_avatar control this returns undefined, so no
    // provider is constructed and the editor preset remains unchanged.
    const mentionNodeDataProvider = (0, $bgSPm.useRovoMentionNodeDataProvider)({
        mentionResource: mentionResource,
        agentSource: agentSource
    });
    const inputExceedsMaxLimit = inputValue.length > (0, $ljEF1.MAX_CHARACTERS_INPUT);
    const isEmpty = inputValue.trim().length === 0;
    const isSendDisabled = inputExceedsMaxLimit || anyFilesUploading || isEmpty && !hasMentionOrInlineCard && !hasSkill;
    const handleSubmit = (0, $cozmU.useCallback)(async ()=>{
        const value = await actions.getValue();
        if (isSendDisabled) return;
        const { deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, webSearchEnabled: webSearchEnabled, appFilters: appFilters } = getChatMode($4d4955659f8b6613$var$STORE_KEY);
        const validFiles = files.filter((file)=>!file.error);
        onSubmit({
            prompt: value,
            deepResearchEnabled: deepResearchEnabled,
            thinkDeeperEnabled: thinkDeeperEnabled,
            fastModeEnabled: fastModeEnabled,
            webSearchEnabled: webSearchEnabled,
            appFilters: appFilters,
            files: validFiles,
            addCurrentPageAsContextUserPreference: true
        }); // Clean up
        actions.clear();
        clearAttachments($4d4955659f8b6613$var$STORE_KEY);
        resetReasoningMode($4d4955659f8b6613$var$STORE_KEY);
        setWebSearchEnabled($4d4955659f8b6613$var$STORE_KEY, false);
    }, [
        actions,
        clearAttachments,
        files,
        getChatMode,
        isSendDisabled,
        onSubmit,
        resetReasoningMode,
        setWebSearchEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // Reset attachments on unmount
            clearAttachments($4d4955659f8b6613$var$STORE_KEY);
        };
    }, [
        clearAttachments
    ]);
    saveRef.current = handleSubmit;
    const stableOnSave = (0, $cozmU.useCallback)(()=>saveRef.current?.(), []); // Enable People/Agents section split in the @mention typeahead
    const enableAgentSectioning = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_mention_ask_rovo_jira');
    const { editorApi: editorApi, preset: preset } = (0, $ljEF1.useEditorPreset)({
        onSave: stableOnSave,
        arrowKeyPluginConfig: {
            userMessages: []
        },
        productKey: productKey,
        siteId: siteId,
        useShortMessages: useShortMessages,
        placeholderText: placeholderText,
        enableAgentSectioning: enableAgentSectioning,
        ...mentionNodeDataProvider ? {
            mentionNodeDataProvider: mentionNodeDataProvider
        } : {}
    });
    const closeTypeAhead = (0, $cozmU.useCallback)(()=>{
        editorApi?.typeAhead?.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        editorApi?.typeAhead?.actions
    ]);
    const openMentionTypeAhead = (0, $cozmU.useCallback)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.mention?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.mention?.actions
    ]);
    const openLinkTypeAhead = (0, $cozmU.useCallback)(()=>{
        closeTypeAhead();
        const command = editorApi?.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        editorApi?.core.actions.execute(command);
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.hyperlink?.commands
    ]);
    const openAddTypeAhead = (0, $cozmU.useCallback)(()=>{
        closeTypeAhead(); // Small delay to ensure the editor regains focus after closing the dropdown menu
        // This prevents the typeahead from immediately closing in Safari
        // Original root cause research: https://product-fabric.atlassian.net/browse/AFC-550
        requestAnimationFrame(()=>{
            editorApi?.core.actions.focus();
            editorApi?.quickInsert?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        });
    }, [
        closeTypeAhead,
        editorApi?.core.actions,
        editorApi?.quickInsert?.actions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!!placeholder && !!editorApi) {
            actions.clear();
            actions.focus();
            closeTypeAhead();
            actions.appendText(placeholder.prompt);
            editorApi?.core.actions.execute(({ tr: tr })=>{
                const maxPos = tr.doc.content.size;
                const startPos = Math.min(placeholder.selectionStartIndex, maxPos);
                const endPos = Math.min(placeholder.selectionEndIndex, maxPos);
                const transaction = tr.setSelection((0, $kCECX.TextSelection).between(tr.doc.resolve(startPos), tr.doc.resolve(endPos)));
                return transaction;
            });
            switch(placeholder.type){
                case 'person':
                    openMentionTypeAhead();
                    break;
                case 'link':
                    openLinkTypeAhead();
                    break;
            }
            clearPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearPlaceholder,
        closeTypeAhead,
        editorApi?.core.actions,
        openLinkTypeAhead,
        openMentionTypeAhead,
        placeholder
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!!highlightActionsEditorPlaceholder && !!editorApi) {
            actions.clear();
            actions.focus();
            closeTypeAhead();
            editorApi.core.actions.replaceDocument(highlightActionsEditorPlaceholder);
            editorApi?.core.actions.execute(({ tr: tr_0 })=>{
                const lastNode = tr_0.doc.lastChild;
                if (lastNode) {
                    const lastNodePos = tr_0.doc.resolve(tr_0.doc.content.size - lastNode.nodeSize);
                    const endPos_0 = tr_0.doc.resolve(tr_0.doc.content.size);
                    const transaction_0 = tr_0.setSelection((0, $kCECX.TextSelection).between(lastNodePos, endPos_0));
                    return transaction_0;
                }
                return null;
            }); // This is a workaround to avoid the focus being lost in Jira (and Jira sub-products)
            if (productKey === 'jira' || productKey === 'jsm' || productKey === 'jpd') requestAnimationFrame(()=>{
                setTimeout(()=>{
                    actions.focus();
                }, 1500);
            });
            clearHighlightActionsEditorPlaceholder();
        }
    }, [
        editorApi,
        actions,
        clearHighlightActionsEditorPlaceholder,
        closeTypeAhead,
        highlightActionsEditorPlaceholder,
        productKey
    ]);
    const isConversationAgentic = enableAgents && !!agent; // Minimal extension provider that only registers the skill chip node renderer.
    // Passed to the Suspense fallback editor so skill chips in `defaultValue` ADF
    // render immediately without waiting for the skills Relay query to resolve.
    const skillTagFallbackProvider = (0, $a6scT.useSkillTagExtensionProvider)(siteId);
    const assistiveLabel = (0, $cozmU.useMemo)(()=>formatMessage(useShortMessages ? (0, $b6ac7ea22ecea738$export$2e2bcd8739ae039).chatInputAssistiveLabelShort : (0, $b6ac7ea22ecea738$export$2e2bcd8739ae039).chatInputAssistiveLabel), [
        formatMessage,
        useShortMessages
    ]);
    const editorProps = (0, $fe33a1c51fbf98e7$export$874d5786bac2d187)({
        assistiveLabel: assistiveLabel,
        defaultValue: defaultValue,
        mentionResource: mentionResource,
        onPromptContentChange: onPromptContentChange,
        popupsMountPoint: popupsMountPoint,
        preset: preset,
        setHasMentionOrInlineCard: setHasMentionOrInlineCard,
        setInputValue: setInputValue,
        stableOnSave: stableOnSave
    });
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, mentionNodeDataProvider && /*#__PURE__*/ $cozmU.createElement((0, $4hbTS.RovoMentionNodeDataProviderConnector), {
        mentionNodeDataProvider: mentionNodeDataProvider,
        mentionResource: mentionResource
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($4d4955659f8b6613$var$styles.stack, files.length === 0 && $4d4955659f8b6613$var$styles.stackWithoutContexts)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($4d4955659f8b6613$var$styles.editorWrapper, compact && $4d4955659f8b6613$var$styles.editorWrapperCompact)
    }, showInlineAgentSelector && /*#__PURE__*/ $cozmU.createElement((0, $a47b6b8d439115fa$export$8320f9b7f97e17d0), {
        agent: agent,
        onAgentSelect: onAgentSelect,
        assistanceServiceParams: assistanceServiceParams,
        siteId: siteId,
        shouldRenderInPortal: shouldRenderInPortal,
        compact: compact
    }), /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallbackRender: ({ error: error })=>/*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_INLINE_EDITOR
            }), /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceFailure), {
                error: error,
                name: (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS
            }), /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
                extensionProviders: skillTagFallbackProvider,
                ...editorProps
            })),
        onError: (error_0)=>{
            (0, $hlvTd.logException)({
                exception: error_0,
                name: (0, $irnO2.ExperienceName).LOAD_INLINE_EDITOR,
                tags: {
                    siteId: siteId
                }
            });
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_INLINE_EDITOR
    }), /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceStart), {
        name: (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS
    }), /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $a1L5E.default), {
        name: "inline-chat-prompt-input-skills"
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $jlRK6.ComposableEditor), {
            extensionProviders: skillTagFallbackProvider,
            ...editorProps
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $3befc6b2946e1176$export$48f1a0a0937ec5aa), {
        editorApi: editorApi,
        isSpecialistPromptInput: isConversationAgentic,
        promptHasSkill: hasSkill,
        enableSkills: true,
        siteId: siteId,
        ...editorProps
    }), /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS
    })))), /*#__PURE__*/ $cozmU.createElement((0, $iuCeV.ExperienceSuccess), {
        name: (0, $irnO2.ExperienceName).LOAD_INLINE_EDITOR
    }))), /*#__PURE__*/ $cozmU.createElement((0, $b8kYV.InputContextListDisplay), {
        attachtmentsStoreKey: $4d4955659f8b6613$var$STORE_KEY
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $4d4955659f8b6613$var$styles.actions
    }, showLabsLozenge && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $4d4955659f8b6613$var$styles.labsLozenge
    }, /*#__PURE__*/ $cozmU.createElement((0, $f837a03f954dcc0a$export$8c4514d5420b4a89), {
        variant: labsLozengeVariant
    })), (appearance !== 'frameless' || showTrailingActions) && /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $cH7ad.ChatInputActionButtons), {
        siteId: siteId,
        attachmentsAndCurrentPageAsContextStoreKey: $4d4955659f8b6613$var$STORE_KEY,
        isDisabled: false,
        useCurrentPageContext: false,
        onLinkTypeAheadClick: openLinkTypeAhead,
        onMentionTypeAheadClick: openMentionTypeAhead,
        onAddTypeAheadClick: openAddTypeAhead,
        assistanceServiceParams: assistanceServiceParams,
        placement: "bottom-end",
        onMenuOpen: closeTypeAhead,
        // places at once — the standalone left selector owns it there.
        onAgentSelect: enableAgents && !showInlineAgentSelector ? onAgentSelect : undefined,
        isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
        setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
        shouldRenderInPortal: shouldRenderInPortal
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        isTooltipDisabled: false,
        appearance: "primary",
        shape: (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_xstate_migration', 'isEnabled', true) && (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_new_aifc_editor_experience', 'isEnabled', true) ? 'default' : 'circle',
        ref: submitButtonRef,
        onClick: ()=>saveRef.current?.(),
        type: "submit",
        isDisabled: isSendDisabled,
        interactionName: "ai-mate.send-message-button",
        icon: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
                ...iconProps,
                label: ''
            }),
        label: formatMessage((0, $b6ac7ea22ecea738$export$2e2bcd8739ae039).sendButtonLabel)
    }))));
};
const $4d4955659f8b6613$export$5f6ebec06531be50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $faAj4.default), {
            render: (actions)=>/*#__PURE__*/ $cozmU.createElement($4d4955659f8b6613$var$PromptViewInternal, {
                    ...props,
                    actions: actions
                })
        }));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d7j1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $faAj4.default), {
        render: (actions)=>/*#__PURE__*/ $cozmU.createElement($4d4955659f8b6613$var$PromptViewInternal, {
                ...props,
                actions: actions
            })
    }));
};
module.exports["PromptView"] = $4d4955659f8b6613$export$5f6ebec06531be50;

});

parcelRegister("7tj1Z", function(module, exports) {

let $570a0106159a1488$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $570a0106159a1488$var$load("g3ng1").then(()=>parcelRequire('bff3j'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("8NROu", function(module, exports) {

let $668ca48bed1da947$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $668ca48bed1da947$var$load("6wr18"),
    $668ca48bed1da947$var$load("ffEVr"),
    $668ca48bed1da947$var$load("5ns6c")
]).then(()=>parcelRequire('8mNoz'));

});

parcelRegister("51Y5B", function(module, exports) {

let $3a9ba83dc9cf8158$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3a9ba83dc9cf8158$var$load("eLOQ2"),
    $3a9ba83dc9cf8158$var$load("a5GLg")
]).then(()=>parcelRequire('8xX63'));

});

parcelRegister("03wtJ", function(module, exports) {

let $00a97983151b4cae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $00a97983151b4cae$var$load("1XZ0m"),
    $00a97983151b4cae$var$load("5tJYH"),
    $00a97983151b4cae$var$load("huBNP"),
    $00a97983151b4cae$var$load("9BBvG"),
    $00a97983151b4cae$var$load("cYv6T"),
    $00a97983151b4cae$var$load("amIJr"),
    $00a97983151b4cae$var$load("4ZzjZ"),
    $00a97983151b4cae$var$load("3cJjP"),
    $00a97983151b4cae$var$load("dgWVQ"),
    $00a97983151b4cae$var$load("11yNG"),
    $00a97983151b4cae$var$load("gQYVn"),
    $00a97983151b4cae$var$load("9RGBF"),
    $00a97983151b4cae$var$load("2iL13"),
    $00a97983151b4cae$var$load("cpTbC"),
    $00a97983151b4cae$var$load("fhT77"),
    $00a97983151b4cae$var$load("jvUhP"),
    $00a97983151b4cae$var$load("7sOKp"),
    $00a97983151b4cae$var$load("7Ysw6"),
    $00a97983151b4cae$var$load("3xL2F"),
    $00a97983151b4cae$var$load("kMyku"),
    $00a97983151b4cae$var$load("hG1ar"),
    $00a97983151b4cae$var$load("2GC7K"),
    $00a97983151b4cae$var$load("cklhl"),
    $00a97983151b4cae$var$load("kobFT"),
    $00a97983151b4cae$var$load("701fE"),
    $00a97983151b4cae$var$load("8qNIV"),
    $00a97983151b4cae$var$load("gpIIT"),
    $00a97983151b4cae$var$load("cHAvQ"),
    $00a97983151b4cae$var$load("5d2zd"),
    $00a97983151b4cae$var$load("frCen"),
    $00a97983151b4cae$var$load("407Jg"),
    $00a97983151b4cae$var$load("3BeCY"),
    $00a97983151b4cae$var$load("hUZCM"),
    $00a97983151b4cae$var$load("7zQG2"),
    $00a97983151b4cae$var$load("1HPRy"),
    $00a97983151b4cae$var$load("6vqGz"),
    $00a97983151b4cae$var$load("fibpY"),
    $00a97983151b4cae$var$load("4O6U4"),
    $00a97983151b4cae$var$load("f4Nog"),
    $00a97983151b4cae$var$load("6wr18"),
    $00a97983151b4cae$var$load("gD63g"),
    $00a97983151b4cae$var$load("hhss7"),
    $00a97983151b4cae$var$load("ffEVr"),
    $00a97983151b4cae$var$load("gqGHu"),
    $00a97983151b4cae$var$load("8exG0"),
    $00a97983151b4cae$var$load("6KunA")
]).then(()=>parcelRequire('8we9n'));

});

parcelRegister("flbIU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $015d1e2b209412a3$var$message = (0, $kSwu1.defineMessages)({
    aiUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalLongCallToAction",
        defaultMessage: "Let Atlassian Intelligence assist your writing"
    },
    rovoUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.rovoUniversalLongCallToAction",
        defaultMessage: "Collaborate with AI"
    },
    aiUniversalShortCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalShortCallToAction",
        defaultMessage: "Write"
    },
    aiProactiveButtonLabel: {
        id: "fabric.editor.ai.shared.aiProactiveButtonLabel",
        defaultMessage: "Suggestions"
    },
    aiProactiveDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptor.non-final",
        defaultMessage: "{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}"
    },
    aiProactiveCloseDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final",
        defaultMessage: "Close suggested edits"
    },
    aiUniversalDescriptor: {
        id: "fabric.editor.ai.shared.aiUniversalDescriptor",
        defaultMessage: "Writing assistant"
    },
    aiButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.aiButtonTitle",
        defaultMessage: "AI (Atlassian Intelligence)"
    },
    rovoButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.rovoButtonTitle",
        defaultMessage: "Ask Rovo"
    },
    betaLabel: {
        id: "fabric.editor.ai.shared.betaLabel",
        defaultMessage: "Beta"
    }
});
var $015d1e2b209412a3$export$2e2bcd8739ae039 = $015d1e2b209412a3$var$message;
module.exports["default"] = $015d1e2b209412a3$export$2e2bcd8739ae039;

});

parcelRegister("kkhvT", function(module, exports) {
// import React from 'react';

var $93WrI = parcelRequire("93WrI");


var $33Ze6 = parcelRequire("33Ze6");


var $9uQOV = parcelRequire("9uQOV");


var $2MofN = parcelRequire("2MofN");

const $53140d1bda1aa18c$export$23164faf8d4f39a5 = (agent, editorPluginAIProvider)=>{
    const continueInChat = (0, $9uQOV.createContinueInChatForAgent)({
        appearance: 'secondary',
        agent: agent,
        product: editorPluginAIProvider.product,
        actionSideEffect: editorPluginAIProvider.actionSideEffects?.['continueInChat'],
        actionOverride: editorPluginAIProvider.actionOverrides?.['continueInChat'],
        factoryOptions: {
            product: editorPluginAIProvider.product,
            isInDocumentStreamingEnabled: editorPluginAIProvider.isInDocumentStreamingEnabled
        }
    });
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).ROVO_AGENT,
        title: (0, $93WrI.aiConfigItemMessages).agentConfigTitle,
        description: (0, $93WrI.aiConfigItemMessages).agentConfigDescription,
        statusLozengeType: 'beta',
        promptHint: (0, $93WrI.aiConfigItemMessages).agentConfigPromptHint,
        // Required, since hasInitialPreset guard in palette state machine
        // checks this property for whether to transition to 'preset label'
        // (agent palette mode) during initialisation.
        promptLabel: {
            defaultMessage: agent?.name,
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            id: `fabric.editor.ai.config.item.range.agent.${agent?.name.toLocaleLowerCase().replace(/\s+/g, '.') || 'label'}`
        },
        disableInterrogation: ()=>false,
        agent: agent,
        intentSchemaId: 'DISABLED',
        getBackendModel: ()=>'assistance-service',
        actions: {
            empty: [
                continueInChat,
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ],
            selection: [
                continueInChat,
                (0, $33Ze6.createReplace)({
                    appearance: 'primary',
                    isRovoAgentAction: true
                })
            ]
        }
    };
};
module.exports["createAgentConfigItem"] = $53140d1bda1aa18c$export$23164faf8d4f39a5;

});

parcelRegister("7vVCw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");


var $gWsFk = parcelRequire("gWsFk");


var $flbIU = parcelRequire("flbIU");


var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $8426b3be421e6a28$export$647e613dda1ecf45 = (options)=>{
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE,
        title: (0, $flbIU.default).rovoButtonTitle,
        description: (0, $flbIU.default).rovoUniversalLongCallToAction,
        promptHint: (0, $93WrI.aiConfigItemMessages).freeGenerateRovoPromptHint,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWsFk.default), {
                label: "",
                size: "small"
            }),
        doNotHighlightDocWhenSelectionIsEmpty: true,
        insertOnEmptySelection: true,
        agentId: 'editor_agent',
        canTogglePageKnowledge: true,
        quickInsertPriority: Number.NEGATIVE_INFINITY,
        intentSchemaId: 'custom_free_generate_intent_schema.json',
        featureId: 'free_generate',
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        withContextMutation: (configItem, { latestPromptResponse: latestPromptResponse })=>{
            return latestPromptResponse ? {
                ...configItem,
                intentSchemaId: 'custom_with_interrogation_intent_schema.json',
                featureId: 'interrogation'
            } : configItem;
        }
    };
};
module.exports["freeGenerate"] = $8426b3be421e6a28$export$647e613dda1ecf45;

});

parcelRegister("lQkyl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");


var $ggncV = parcelRequire("ggncV");




const $efc556a6b4ad5837$export$ffe14b080d2065b6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M5 5.75L19 5.75M5 9.91667L19 9.91667M5 14.0833L19 14.0833M5 18.25L12 18.25",
        stroke: "currentColor",
        strokeWidth: "1.5"
    }));
};



var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $97f263a958f93429$var$intentSchemaId = 'make_longer.json';
const $97f263a958f93429$export$11363e713b339cda = (options)=>{
    const featureId = 'make_longer_adf_gpt41mini';
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).MAKE_LONGER,
        title: (0, $93WrI.aiConfigItemMessages).makeLongerTitle,
        description: (0, $93WrI.aiConfigItemMessages).makeLongerDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $efc556a6b4ad5837$export$ffe14b080d2065b6), null),
        statusLozengeType: 'beta',
        intentSchemaId: $97f263a958f93429$var$intentSchemaId,
        featureId: featureId,
        adfPrompt: true,
        requiresTextualContent: true,
        getBackendModel: ()=>'assistance-service',
        showInRefineDropdown: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        get nestingConfig () {
            if (options?.isInDocumentStreamingEnabled) return {
                id: 'adjust-length',
                parentTestId: 'adjust-length',
                parentTitle: (0, $93WrI.aiConfigItemMessages).adjustLengthNestingParentTitle,
                shortTitle: (0, $93WrI.aiConfigItemMessages).adjustLengthNestingParentShortTitle,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggncV))), {
                        label: "",
                        spacing: "spacious"
                    })
            };
            return undefined;
        }
    };
};
const $97f263a958f93429$export$5f725895b60131b1 = (options)=>({
        config: $97f263a958f93429$export$11363e713b339cda(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["makeLonger"] = $97f263a958f93429$export$11363e713b339cda;
module.exports["makeLongerWithOptions"] = $97f263a958f93429$export$5f725895b60131b1;

});

parcelRegister("ggncV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e112a62be5bd8d1f06680fabda61649>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd70247d1a2f352b$var$_react = $bd70247d1a2f352b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $bd70247d1a2f352b$var$_baseNew = $bd70247d1a2f352b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $bd70247d1a2f352b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextAdjustLength".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-adjust-length
 * Usage guidance:
 * Reserved for accessing text length generative AI actions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd70247d1a2f352b$var$TextAdjustLengthIcon = (props)=>/*#__PURE__*/ $bd70247d1a2f352b$var$_react.default.createElement($bd70247d1a2f352b$var$_baseNew.default, Object.assign({
        name: "TextAdjustLengthIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M3.25 1c.199 0 .39.08.53.22l2.5 2.5-1.06 1.06L4 3.56v8.88l1.22-1.22 1.06 1.06-2.5 2.5a.75.75 0 0 1-1.06 0l-2.5-2.5 1.06-1.06 1.22 1.22V3.56L1.28 4.78.22 3.72l2.5-2.5.114-.094A.75.75 0 0 1 3.25 1M13 11.5V13H8v-1.5zm3-4.25v1.5H8v-1.5zM16 3v1.5H8V3z"/>`
    }, props));
$bd70247d1a2f352b$var$TextAdjustLengthIcon.displayName = 'TextAdjustLengthIcon';
var $bd70247d1a2f352b$var$_default = module.exports.default = $bd70247d1a2f352b$var$TextAdjustLengthIcon;

});

parcelRegister("ddlQ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");


var $ggncV = parcelRequire("ggncV");


var $SMY7j = parcelRequire("SMY7j");


var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $d7728dadcdce0e92$export$1792ed3292533f02 = (options)=>{
    const featureId = 'make_shorter_adf_gpt41mini';
    return {
        key: (0, $2MofN.CONFIG_ITEM_KEYS).MAKE_SHORTER,
        title: (0, $93WrI.aiConfigItemMessages).makeShorterTitle,
        description: (0, $93WrI.aiConfigItemMessages).makeShorterDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $SMY7j.MakeShorterIcon), null),
        showInRefineDropdown: true,
        intentSchemaId: 'shorten_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        requiresTextualContent: true,
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        },
        get nestingConfig () {
            if (options?.isInDocumentStreamingEnabled) return {
                id: 'adjust-length',
                parentTestId: 'adjust-length',
                parentTitle: (0, $93WrI.aiConfigItemMessages).adjustLengthNestingParentTitle,
                shortTitle: (0, $93WrI.aiConfigItemMessages).adjustLengthNestingParentShortTitle,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ggncV))), {
                        label: "",
                        spacing: "spacious"
                    })
            };
            return undefined;
        }
    };
};
const $d7728dadcdce0e92$export$cf8706c71bd8ab7d = (options)=>({
        config: $d7728dadcdce0e92$export$1792ed3292533f02(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["makeShorter"] = $d7728dadcdce0e92$export$1792ed3292533f02;
module.exports["makeShorterWithOptions"] = $d7728dadcdce0e92$export$cf8706c71bd8ab7d;

});

parcelRegister("SMY7j", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3CdTA = parcelRequire("3CdTA");

const $6212e80f4f57259e$export$bd44f97e799f79a6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3CdTA))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
module.exports["MakeShorterIcon"] = $6212e80f4f57259e$export$bd44f97e799f79a6;

});

parcelRegister("2urSQ", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $kSwu1 = parcelRequire("kSwu1");

const $8dade287feb545df$export$b71056f6af7927e9 = (0, $kSwu1.defineMessages)({
    // Language Messages
    nestingParentTitle: {
        id: "fabric.editor.ai.config.item.translate.nestingParentTitle.ga",
        defaultMessage: "Translate"
    },
    nestingParentTitlePostGA: {
        id: "fabric.editor.ai.config.item.translate.nestingParentTitlePostGA",
        defaultMessage: "Translate to ..."
    },
    chineseSimplified: {
        id: "fabric.editor.ai.config.item.translate.chineseSimplified",
        defaultMessage: "Chinese (Simplified)"
    },
    chineseTraditional: {
        id: "fabric.editor.ai.config.item.translate.chineseTraditional",
        defaultMessage: "Chinese (Traditional)"
    },
    czech: {
        id: "fabric.editor.ai.config.item.translate.czech",
        defaultMessage: "Czech"
    },
    danish: {
        id: "fabric.editor.ai.config.item.translate.danish",
        defaultMessage: "Danish"
    },
    dutch: {
        id: "fabric.editor.ai.config.item.translate.dutch",
        defaultMessage: "Dutch"
    },
    english: {
        id: "fabric.editor.ai.config.item.translate.english",
        defaultMessage: "English"
    },
    finnish: {
        id: "fabric.editor.ai.config.item.translate.finnish",
        defaultMessage: "Finnish"
    },
    french: {
        id: "fabric.editor.ai.config.item.translate.french",
        defaultMessage: "French"
    },
    german: {
        id: "fabric.editor.ai.config.item.translate.german",
        defaultMessage: "German"
    },
    hungarian: {
        id: "fabric.editor.ai.config.item.translate.hungarian",
        defaultMessage: "Hungarian"
    },
    italian: {
        id: "fabric.editor.ai.config.item.translate.italian",
        defaultMessage: "Italian"
    },
    japanese: {
        id: "fabric.editor.ai.config.item.translate.japanese",
        defaultMessage: "Japanese"
    },
    korean: {
        id: "fabric.editor.ai.config.item.translate.korean",
        defaultMessage: "Korean"
    },
    norwegian: {
        id: "fabric.editor.ai.config.item.translate.norwegian",
        defaultMessage: "Norwegian"
    },
    polish: {
        id: "fabric.editor.ai.config.item.translate.polish",
        defaultMessage: "Polish"
    },
    portugueseBrazilian: {
        id: "fabric.editor.ai.config.item.translate.portugueseBrazilian",
        defaultMessage: "Portuguese (Brazilian)"
    },
    russian: {
        id: "fabric.editor.ai.config.item.translate.russian",
        defaultMessage: "Russian"
    },
    spanish: {
        id: "fabric.editor.ai.config.item.translate.spanish",
        defaultMessage: "Spanish"
    },
    swedish: {
        id: "fabric.editor.ai.config.item.translate.swedish",
        defaultMessage: "Swedish"
    },
    turkish: {
        id: "fabric.editor.ai.config.item.translate.turkish",
        defaultMessage: "Turkish"
    },
    thai: {
        id: "fabric.editor.ai.config.item.translate.thai",
        defaultMessage: "Thai"
    },
    ukrainian: {
        id: "fabric.editor.ai.config.item.translate.ukrainian",
        defaultMessage: "Ukrainian"
    },
    vietnamese: {
        id: "fabric.editor.ai.config.item.translate.vietnamese",
        defaultMessage: "Vietnamese"
    },
    // Translate to messages
    chineseSimplifiedTitle: {
        id: "fabric.editor.ai.config.item.translateTo.chineseSimplified.title",
        defaultMessage: "Translate to Chinese (Simplified)"
    },
    chineseSimplifiedDescription: {
        id: "fabric.editor.ai.config.item.translateTo.chineseSimplified.description",
        defaultMessage: "Translates the text you're working on to Chinese (Simplified)"
    },
    chineseTraditionalTitle: {
        id: "fabric.editor.ai.config.item.translateTo.chineseTraditional.title",
        defaultMessage: "Translate to Chinese (Traditional)"
    },
    chineseTraditionalDescription: {
        id: "fabric.editor.ai.config.item.translateTo.chineseTraditional.description",
        defaultMessage: "Translates the text you're working on to Chinese (Traditional)"
    },
    czechTitle: {
        id: "fabric.editor.ai.config.item.translateTo.czech.title",
        defaultMessage: "Translate to Czech"
    },
    czechDescription: {
        id: "fabric.editor.ai.config.item.translateTo.czech.description",
        defaultMessage: "Translates the text you're working on to Czech"
    },
    danishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.danish.title",
        defaultMessage: "Translate to Danish"
    },
    danishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.danish.description",
        defaultMessage: "Translates the text you're working on to Danish"
    },
    dutchTitle: {
        id: "fabric.editor.ai.config.item.translateTo.dutch.title",
        defaultMessage: "Translate to Dutch"
    },
    dutchDescription: {
        id: "fabric.editor.ai.config.item.translateTo.dutch.description",
        defaultMessage: "Translates the text you're working on to Dutch"
    },
    englishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.english.title",
        defaultMessage: "Translate to English"
    },
    englishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.english.description",
        defaultMessage: "Translates the text you're working on to English"
    },
    finnishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.finnish.title",
        defaultMessage: "Translate to Finnish"
    },
    finnishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.finnish.description",
        defaultMessage: "Translates the text you're working on to Finnish"
    },
    frenchTitle: {
        id: "fabric.editor.ai.config.item.translateTo.french.title",
        defaultMessage: "Translate to French"
    },
    frenchDescription: {
        id: "fabric.editor.ai.config.item.translateTo.french.description",
        defaultMessage: "Translates the text you're working on to French"
    },
    germanTitle: {
        id: "fabric.editor.ai.config.item.translateTo.german.title",
        defaultMessage: "Translate to German"
    },
    germanDescription: {
        id: "fabric.editor.ai.config.item.translateTo.german.description",
        defaultMessage: "Translates the text you're working on to German"
    },
    hungarianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.hungarian.title",
        defaultMessage: "Translate to Hungarian"
    },
    hungarianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.hungarian.description",
        defaultMessage: "Translates the text you're working on to Hungarian"
    },
    italianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.italian.title",
        defaultMessage: "Translate to Italian"
    },
    italianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.italian.description",
        defaultMessage: "Translates the text you're working on to Italian"
    },
    japaneseTitle: {
        id: "fabric.editor.ai.config.item.translateTo.japanese.title",
        defaultMessage: "Translate to Japanese"
    },
    japaneseDescription: {
        id: "fabric.editor.ai.config.item.translateTo.japanese.description",
        defaultMessage: "Translates the text you're working on to Japanese"
    },
    koreanTitle: {
        id: "fabric.editor.ai.config.item.translateTo.korean.title",
        defaultMessage: "Translate to Korean"
    },
    koreanDescription: {
        id: "fabric.editor.ai.config.item.translateTo.korean.description",
        defaultMessage: "Translates the text you're working on to Korean"
    },
    norwegianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.norwegian.title",
        defaultMessage: "Translate to Norwegian"
    },
    norwegianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.norwegian.description",
        defaultMessage: "Translates the text you're working on to Norwegian"
    },
    polishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.polish.title",
        defaultMessage: "Translate to Polish"
    },
    polishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.polish.description",
        defaultMessage: "Translates the text you're working on to Polish"
    },
    portugueseBrazilianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title",
        defaultMessage: "Translate to Portuguese (Brazilian)"
    },
    portugueseBrazilianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description",
        defaultMessage: "Translates the text you're working on to Portuguese (Brazilian)"
    },
    russianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.russian.title",
        defaultMessage: "Translate to Russian"
    },
    russianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.russian.description",
        defaultMessage: "Translates the text you're working on to Russian"
    },
    spanishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.spanish.title",
        defaultMessage: "Translate to Spanish"
    },
    spanishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.spanish.description",
        defaultMessage: "Translates the text you're working on to Spanish"
    },
    swedishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.swedish.title",
        defaultMessage: "Translate to Swedish"
    },
    swedishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.swedish.description",
        defaultMessage: "Translates the text you're working on to Swedish"
    },
    turkishTitle: {
        id: "fabric.editor.ai.config.item.translateTo.turkish.title",
        defaultMessage: "Translate to Turkish"
    },
    turkishDescription: {
        id: "fabric.editor.ai.config.item.translateTo.turkish.description",
        defaultMessage: "Translates the text you're working on to Turkish"
    },
    thaiTitle: {
        id: "fabric.editor.ai.config.item.translateTo.thai.title",
        defaultMessage: "Translate to Thai"
    },
    thaiDescription: {
        id: "fabric.editor.ai.config.item.translateTo.thai.description",
        defaultMessage: "Translates the text you're working on to Thai"
    },
    ukrainianTitle: {
        id: "fabric.editor.ai.config.item.translateTo.ukrainian.title",
        defaultMessage: "Translate to Ukrainian"
    },
    ukrainianDescription: {
        id: "fabric.editor.ai.config.item.translateTo.ukrainian.description",
        defaultMessage: "Translates the text you're working on to Ukrainian"
    },
    vietnameseTitle: {
        id: "fabric.editor.ai.config.item.translateTo.vietnamese.title",
        defaultMessage: "Translate to Vietnamese"
    },
    vietnameseDescription: {
        id: "fabric.editor.ai.config.item.translateTo.vietnamese.description",
        defaultMessage: "Translates the text you're working on to Vietnamese"
    }
});
module.exports["aiLanguageMessages"] = $8dade287feb545df$export$b71056f6af7927e9;

});

parcelRegister("dFWys", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");

var $7ZL6d = parcelRequire("7ZL6d");


var $hjuSl = parcelRequire("hjuSl");





var $6Jphz = parcelRequire("6Jphz");

const $c6dd91e41e7e944d$export$8b4784439604ca83 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Jphz))), {
        color: "currentColor",
        label: "",
        spacing: "spacious"
    });






var $k9qmp = parcelRequire("k9qmp");

const $17d8dea606214972$export$61c3f03f8b900938 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9qmp))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });






var $4WfQc = parcelRequire("4WfQc");

const $d993628383d02109$export$e378d926184098e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4WfQc))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });






var $BeiRH = parcelRequire("BeiRH");

const $7aaf518a19622656$export$53c14326c671fdf0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($BeiRH))), {
        color: "currentColor",
        label: "",
        spacing: "spacious"
    });






var $p6OqS = parcelRequire("p6OqS");

const $69a82d37e9cd0266$export$d11b06b5c6e28f63 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

function $15639de5f61747a2$var$createChangeToneOption({ key: key, title: title, description: description, intentSchemaId: intentSchemaId, featureId: featureId, icon: icon, shortTitle: shortTitle, adfPrompt: adfPrompt, factoryOptions: factoryOptions }) {
    return {
        key: key,
        title: title,
        description: description,
        icon: icon,
        showInRefineDropdown: true,
        intentSchemaId: intentSchemaId,
        featureId: featureId,
        adfPrompt: adfPrompt,
        requiresTextualContent: adfPrompt,
        nestingConfig: {
            id: 'change-tone-to',
            parentTestId: 'change-tone-to',
            parentTitle: (0, $7ZL6d.aiMessages).changeToneToolbarDropdownIconTitle,
            shortTitle: shortTitle,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hjuSl))), {
                    label: "",
                    spacing: "spacious"
                })
        },
        actions: {
            empty: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: factoryOptions
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: factoryOptions
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    };
}
const $15639de5f61747a2$export$6f5f338379adfef = (options)=>{
    const featureId = 'change_tone_neutral';
    return $15639de5f61747a2$var$createChangeToneOption({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_NEUTRAL,
        title: (0, $93WrI.aiConfigItemMessages).changeToneNeutralToneTitle,
        shortTitle: (0, $93WrI.aiConfigItemMessages).changeToneNeutralToneShortTitle,
        description: (0, $93WrI.aiConfigItemMessages).changeToneNeutralToneDescription,
        intentSchemaId: 'change_tone_neutral_intent_schema.json',
        featureId: featureId,
        adfPrompt: false,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aaf518a19622656$export$53c14326c671fdf0), null),
        factoryOptions: options
    });
};
const $15639de5f61747a2$export$13defcd58be14c80 = (options)=>({
        config: $15639de5f61747a2$export$6f5f338379adfef(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $15639de5f61747a2$export$9db9bd2fafdb3554 = (options)=>{
    const featureId = 'change_tone_professional_adf_gpt41mini';
    return $15639de5f61747a2$var$createChangeToneOption({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_PROFESSIONAL,
        title: (0, $7ZL6d.aiMessages).moreProfessionalToneToolbarDropdownIconTitle,
        shortTitle: (0, $93WrI.aiConfigItemMessages).changeToneProfessionalToneShortTitle,
        description: (0, $93WrI.aiConfigItemMessages).changeToneProfessionalToneDescription,
        intentSchemaId: 'change_tone_professional_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69a82d37e9cd0266$export$d11b06b5c6e28f63), null),
        factoryOptions: options
    });
};
const $15639de5f61747a2$export$12bb87036588b312 = (options)=>({
        config: $15639de5f61747a2$export$9db9bd2fafdb3554(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $15639de5f61747a2$export$86a519e0af50dd89 = (options)=>{
    const featureId = 'change_tone_casual_adf_gpt41mini';
    return $15639de5f61747a2$var$createChangeToneOption({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_CASUAL,
        title: (0, $7ZL6d.aiMessages).moreCasualToneToolbarDropdownIconTitle,
        shortTitle: (0, $93WrI.aiConfigItemMessages).changeToneCasualToneShortTitle,
        description: (0, $93WrI.aiConfigItemMessages).changeToneCasualToneDescription,
        intentSchemaId: 'change_tone_business_casual_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6dd91e41e7e944d$export$8b4784439604ca83), null),
        factoryOptions: options
    });
};
const $15639de5f61747a2$export$124661226d751077 = (options)=>({
        config: $15639de5f61747a2$export$86a519e0af50dd89(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $15639de5f61747a2$export$693b6bda4adcfa2a = (options)=>{
    const featureId = 'change_tone_educational_adf_gpt41mini';
    return $15639de5f61747a2$var$createChangeToneOption({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EDUCATIONAL,
        title: (0, $93WrI.aiConfigItemMessages).changeToneEducationalToneTitle,
        shortTitle: (0, $93WrI.aiConfigItemMessages).changeToneEducationalToneShortTitle,
        description: (0, $93WrI.aiConfigItemMessages).changeToneEducationalToneDescription,
        intentSchemaId: 'change_tone_educational_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17d8dea606214972$export$61c3f03f8b900938), null),
        factoryOptions: options
    });
};
const $15639de5f61747a2$export$bc06489e9b94a1b8 = (options)=>({
        config: $15639de5f61747a2$export$693b6bda4adcfa2a(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $15639de5f61747a2$export$a20a30955e450d41 = (options)=>{
    const featureId = 'change_tone_empathetic_adf_gpt41mini';
    return $15639de5f61747a2$var$createChangeToneOption({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).CHANGE_TONE_TO_EMPATHETIC,
        title: (0, $7ZL6d.aiMessages).moreEmpatheticToneToolbarDropdownIconTitle,
        shortTitle: (0, $93WrI.aiConfigItemMessages).changeToneEmpatheticToneShortTitle,
        description: (0, $93WrI.aiConfigItemMessages).changeToneEmpatheticToneDescription,
        intentSchemaId: 'change_tone_empathetic_intent_schema.json',
        featureId: featureId,
        adfPrompt: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d993628383d02109$export$e378d926184098e), null),
        factoryOptions: options
    });
};
const $15639de5f61747a2$export$6c0e9fb8d5e538d3 = (options)=>({
        config: $15639de5f61747a2$export$a20a30955e450d41(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
module.exports["changeToneToNeutral"] = $15639de5f61747a2$export$6f5f338379adfef;
module.exports["changeToneToProfessional"] = $15639de5f61747a2$export$9db9bd2fafdb3554;
module.exports["changeToneToProfessionalWithOptions"] = $15639de5f61747a2$export$12bb87036588b312;
module.exports["changeToneToCasual"] = $15639de5f61747a2$export$86a519e0af50dd89;
module.exports["changeToneToCasualWithOptions"] = $15639de5f61747a2$export$124661226d751077;
module.exports["changeToneToEducational"] = $15639de5f61747a2$export$693b6bda4adcfa2a;
module.exports["changeToneToEducationalWithOptions"] = $15639de5f61747a2$export$bc06489e9b94a1b8;
module.exports["changeToneToEmpathetic"] = $15639de5f61747a2$export$a20a30955e450d41;
module.exports["changeToneToEmpatheticWithOptions"] = $15639de5f61747a2$export$6c0e9fb8d5e538d3;

});

parcelRegister("9pamm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2urSQ = parcelRequire("2urSQ");





var $iJUbs = parcelRequire("iJUbs");

const $82779730cf5d9e91$export$d1fe1d52e2885c4e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iJUbs))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });



var $33Ze6 = parcelRequire("33Ze6");


var $2aMCF = parcelRequire("2aMCF");

const $e812f4c3aba3ebae$var$supportedTranslationLanguages = (0, $2aMCF.getSortedSupportedTranslationLanguages)();
const $e812f4c3aba3ebae$export$e74e7aa094cc7ad6 = (options)=>{
    const featureId = 'translate_adf_gpt41mini';
    const translationConfigItems = $e812f4c3aba3ebae$var$supportedTranslationLanguages.map((language)=>{
        const lang = (0, $2urSQ.aiLanguageMessages)[language];
        if (!lang) return false;
        const configItem = {
            key: `Translate to ${language}`,
            title: (0, $2urSQ.aiLanguageMessages)[`${language}Title`],
            description: (0, $2urSQ.aiLanguageMessages)[`${language}Description`],
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82779730cf5d9e91$export$d1fe1d52e2885c4e), null),
            showInRefineDropdown: (0, $2aMCF.isRefinementSupport)(language),
            nestingConfig: {
                id: 'translate-to',
                parentTestId: 'translate-to',
                parentTitle: (0, $2urSQ.aiLanguageMessages).nestingParentTitlePostGA,
                shortTitle: lang,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82779730cf5d9e91$export$d1fe1d52e2885c4e), null)
            },
            intentSchemaId: 'translate_intent_schema.json',
            featureId: featureId,
            adfPrompt: true,
            requiresTextualContent: true,
            lang: lang.defaultMessage,
            actions: {
                empty: [
                    (0, $33Ze6.createInsertBelow)({
                        appearance: 'secondary',
                        factoryOptions: options
                    }),
                    (0, $33Ze6.createReplace)({
                        appearance: 'primary'
                    })
                ],
                selection: [
                    (0, $33Ze6.createInsertBelow)({
                        appearance: 'secondary',
                        factoryOptions: options
                    }),
                    (0, $33Ze6.createReplace)({
                        appearance: 'primary'
                    })
                ]
            }
        };
        return [
            language,
            configItem
        ];
    }).filter(Boolean);
    return Object.fromEntries(translationConfigItems);
};
const $e812f4c3aba3ebae$export$c9f99cf066285ff1 = (options)=>Object.values($e812f4c3aba3ebae$export$e74e7aa094cc7ad6(options));
const $e812f4c3aba3ebae$export$f79e42233d7b78a9 = (options)=>$e812f4c3aba3ebae$export$c9f99cf066285ff1(options).map((config)=>({
            config: config,
            triggers: {
                empty: {
                    enabled: true,
                    docMinSize: 1
                },
                selection: {
                    enabled: true
                }
            }
        }));
const $e812f4c3aba3ebae$export$58be4f46859bb368 = (options)=>$e812f4c3aba3ebae$export$c9f99cf066285ff1(options).map((config)=>({
            config: config,
            triggers: {
                empty: {
                    enabled: false
                },
                selection: {
                    enabled: true
                }
            }
        }));
module.exports["createTranslationConfigItems"] = $e812f4c3aba3ebae$export$e74e7aa094cc7ad6;
module.exports["translationConfigItemWithOptions"] = $e812f4c3aba3ebae$export$f79e42233d7b78a9;
module.exports["translationConfigItemWithOptionsEnabledForSelectionOnly"] = $e812f4c3aba3ebae$export$58be4f46859bb368;

});

parcelRegister("2aMCF", function(module, exports) {

var $fpmlf = parcelRequire("fpmlf");

const $9fe7ff8bf26aa9c8$export$a288aff1b8104a05 = ()=>{
    return 0, $fpmlf.supportedTranslationLanguagesPopularOrder;
};
const $9fe7ff8bf26aa9c8$export$f54f1bab33a30a3f = (latestPrompt)=>typeof latestPrompt?.presetTitle?.title?.defaultMessage === 'string' && latestPrompt?.presetTitle?.title?.defaultMessage?.includes('Translate to');
const $9fe7ff8bf26aa9c8$export$9429b43310621fcf = (language)=>(0, $fpmlf.refinementSupportedTranslationLanguages).includes(language);
module.exports["getSortedSupportedTranslationLanguages"] = $9fe7ff8bf26aa9c8$export$a288aff1b8104a05;
module.exports["isRefinementSupport"] = $9fe7ff8bf26aa9c8$export$9429b43310621fcf;

});

parcelRegister("67wrw", function(module, exports) {
/* prompt.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $7ZL6d = parcelRequire("7ZL6d");


var $gWBVp = parcelRequire("gWBVp");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");


var $kCECX = parcelRequire("kCECX");


var $f6cdQ = parcelRequire("f6cdQ");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $at1wf = parcelRequire("at1wf");

/* AddItemButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $hekY6 = parcelRequire("hekY6");





var $jLnA6 = parcelRequire("jLnA6");





var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $krYZG = parcelRequire("krYZG");


var $6keIx = parcelRequire("6keIx");


var $gFEZF = parcelRequire("gFEZF");


var $kTb7m = parcelRequire("kTb7m");


var $g9ioO = parcelRequire("g9ioO");









const $77bf060bfae202f8$var$message = (0, $kSwu1.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.addButton.label",
        defaultMessage: "Add"
    },
    insertMenuTriggerLabel: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.triggerLabel",
        defaultMessage: "Insert rich content"
    },
    insertMenuUpload: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.upload",
        defaultMessage: "Upload file"
    },
    insertMenuAddLink: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.addLink",
        defaultMessage: "Add link"
    },
    insertMenuMention: {
        id: "fabric.editor.ai.screens.prompt.streaming.insertMenu.mention",
        defaultMessage: "Mention user"
    },
    promptRecord: {
        id: "fabric.editor.ai.screens.prompt.streaming.record",
        defaultMessage: "Record"
    },
    promptSubmit: {
        id: "fabric.editor.ai.screens.prompt.streaming.submit",
        defaultMessage: "Submit"
    },
    promptPlaceholder: {
        id: "fabric.editor.ai.screens.prompt.streaming.placeholder",
        defaultMessage: "Describe what you want to do"
    }
});
var $77bf060bfae202f8$export$2e2bcd8739ae039 = $77bf060bfae202f8$var$message;






var $9DHhW = parcelRequire("9DHhW");


var $fdQKX = parcelRequire("fdQKX");

function $c23d6b3ad07ff44c$export$eed8c476984ddfad() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useMemo)(()=>(0, $fdQKX.fireAnalyticsEvent)(createAnalyticsEvent), [
        createAnalyticsEvent
    ]);
}


const $e36b0c785ff8a212$var$insertMenu = {
    menuWidth: "_4ouGXIe7g8"
};
const $e36b0c785ff8a212$var$insertMenuItem = {
    grow: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG"
};
const $e36b0c785ff8a212$var$rotatedIcon = {
    rotated: "_23rrnHSf8K _1VJPcawquS",
    base: "_23rrnHSf8K _1VJPcaunCX"
};
const $e36b0c785ff8a212$var$shortcutLabel = null;
const $e36b0c785ff8a212$export$6cb731ac7be1981a = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fireAnalyticsEvent = (0, $c23d6b3ad07ff44c$export$eed8c476984ddfad)();
    const isToolbarAIFCEnabled = Boolean(editorApi?.toolbar);
    const handleLinkClick = (0, $cozmU.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const handleMentionClick = (0, $cozmU.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const INSERT_ITEMS = [
        {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            message: 'insertMenuAddLink',
            onClick: ()=>handleLinkClick()
        },
        {
            Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g9ioO))),
            message: 'insertMenuMention',
            shortcut: '@',
            onClick: ()=>handleMentionClick()
        }
    ];
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...trigProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                isSelected: trigProps.isSelected,
                onClick: trigProps.onClick,
                onFocus: trigProps.onFocus,
                onBlur: trigProps.onBlur,
                testId: trigProps.testId,
                "aria-controls": trigProps['aria-controls'],
                "aria-expanded": trigProps['aria-expanded'],
                "aria-haspopup": trigProps['aria-haspopup'],
                "data-ds--level": trigProps['data-ds--level'],
                ref: triggerRef,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: trigProps['aria-expanded'] ? $e36b0c785ff8a212$var$rotatedIcon.rotated : $e36b0c785ff8a212$var$rotatedIcon.base,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                            label: iconProps.label
                        })
                    }),
                label: formatMessage((0, $77bf060bfae202f8$export$2e2bcd8739ae039).label),
                shape: "circle",
                isTooltipDisabled: false,
                tooltip: {
                    position: 'top'
                }
            }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $e36b0c785ff8a212$var$insertMenu.menuWidth,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: INSERT_ITEMS.map(({ Icon: Icon, message: message, shortcut: shortcut, onClick: onClick })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                        onClick: ()=>{
                            onClick();
                        },
                        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            alignBlock: "center",
                            space: "space.200",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
                                    label: ""
                                }),
                                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                    xcss: $e36b0c785ff8a212$var$insertMenuItem.grow,
                                    children: formatMessage((0, $77bf060bfae202f8$export$2e2bcd8739ae039)[message])
                                }),
                                shortcut && (isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jLnA6.default), {
                                    children: shortcut
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                    className: (0, $hekY6.default)([
                                        "_26BoRw8HPE"
                                    ]),
                                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6keIx.Shortcut), {
                                        children: shortcut
                                    })
                                }))
                            ]
                        })
                    }, message))
            })
        })
    });
};


/* LinkPickerButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $3k5Tv = parcelRequire("3k5Tv");








const $0c5ae2248266e0b4$var$message = (0, $kSwu1.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.linkPickerButton.label",
        defaultMessage: "Add link"
    }
});
var $0c5ae2248266e0b4$export$2e2bcd8739ae039 = $0c5ae2248266e0b4$var$message;


const $4c7f77a2d0456024$export$b665e181ecd1797 = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { activeLinkMark: activeLinkMark } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorApi, [
        'hyperlink'
    ], (states)=>{
        return {
            activeLinkMark: states.hyperlinkState?.activeLinkMark
        };
    });
    const fireAnalyticsEvent = (0, $c23d6b3ad07ff44c$export$eed8c476984ddfad)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (editorApi) {
            const showLinkToolbarAction = editorApi.hyperlink?.commands.showLinkToolbar((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
            if (showLinkToolbarAction) editorApi.core.actions.execute(showLinkToolbarAction);
        }
        fireAnalyticsEvent({
            payload: {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_PROMPT_LINK_PICKER_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    // The editor can be wrapped in a component that process keyboard events,
    // but we don't need to propagate `Enter`, `Space`, and `Tab` key event to the editor.
    const stopPropagationForActionKeys = (0, $cozmU.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $0c5ae2248266e0b4$export$2e2bcd8739ae039).label),
        testId: "link-picker-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        isSelected: !!activeLinkMark,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};


/* MentionButton.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $hMv2K = parcelRequire("hMv2K");





const $66de635e28320e5c$var$message = (0, $kSwu1.defineMessages)({
    label: {
        id: "fabric.editor.ai.screens.prompt.mentionButton.label",
        defaultMessage: "Mention someone or a team"
    }
});
var $66de635e28320e5c$export$2e2bcd8739ae039 = $66de635e28320e5c$var$message;


const $fbd8aa336152e2ef$export$d16f16312388c7e = ({ editorApi: editorApi, promptType: promptType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { currentHandler: currentHandler, typeAheadHandler: typeAheadHandler } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorApi, [
        'typeAhead',
        'mention'
    ], (states)=>{
        return {
            currentHandler: states.typeAheadState?.currentHandler,
            typeAheadHandler: states.mentionState?.typeAheadHandler
        };
    });
    const fireAnalyticsEvent = (0, $c23d6b3ad07ff44c$export$eed8c476984ddfad)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (editorApi) editorApi.mention?.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
        fireAnalyticsEvent({
            payload: {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_PROMPT_MENTION_BUTTON,
                attributes: {
                    promptType: promptType
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            }
        });
    }, [
        editorApi,
        fireAnalyticsEvent,
        promptType
    ]);
    const stopPropagationForActionKeys = (0, $cozmU.useCallback)((event)=>{
        if ([
            'Enter',
            ' ',
            'Tab'
        ].includes(event.key)) event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        isTooltipDisabled: false,
        label: formatMessage((0, $66de635e28320e5c$export$2e2bcd8739ae039).label),
        testId: "mention-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))),
        isSelected: currentHandler?.id && typeAheadHandler?.id && currentHandler.id === typeAheadHandler.id,
        spacing: "compact",
        appearance: "subtle",
        onClick: handleClick,
        onKeyDown: stopPropagationForActionKeys,
        onKeyUp: stopPropagationForActionKeys
    });
};



var $a31lS = parcelRequire("a31lS");


var $1CaNG = parcelRequire("1CaNG");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $40ukF = parcelRequire("40ukF");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $e6Dq9 = parcelRequire("e6Dq9");


var $1ZhW4 = parcelRequire("1ZhW4");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $h0KOi = parcelRequire("h0KOi");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $iVGec = parcelRequire("iVGec");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $2ZvWx = parcelRequire("2ZvWx");


var $hYOOW = parcelRequire("hYOOW");


var $f3DNZ = parcelRequire("f3DNZ");


var $jNalm = parcelRequire("jNalm");


var $fb3SZ = parcelRequire("fb3SZ");


var $d1HsG = parcelRequire("d1HsG");


var $abOD2 = parcelRequire("abOD2");


var $4lpx1 = parcelRequire("4lpx1");


var $lfQQe = parcelRequire("lfQQe");

function $f78b3d691d800c09$export$cd6e43a807ff0e0d(options) {
    const cardPluginData = {
        ...options.linking?.smartLinks,
        linkPicker: options.linking?.linkPicker,
        lpLinkPicker: options.featureFlags?.lpLinkPicker ?? false,
        disableFloatingToolbar: true,
        showUpgradeDiscoverability: false,
        // We don't want to show block cards and embed cards in prompt editor.
        allowBlockCards: false,
        allowEmbeds: false
    };
    const preset = new (0, $a31lS.EditorPresetBuilder)()// Handles feature flagging in Editor.
    .add([
        (0, $h0KOi.featureFlagsPlugin),
        options.featureFlags
    ])// Most of analytics events in editor are fired by appending
    //  AnalyticsStep in transaction.
    // Without this plugin, none of those events will be fired.
    // If allowAnalyticsGASV3 is truthy, then analytics plugin will be added.
    .maybeAdd([
        (0, $1CaNG.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent
        }
    ], Boolean(options.allowAnalyticsGASV3))// Dependency of paste plugin
    .add((0, $lK9Pz.betterTypeHistoryPlugin))// we need paste plugin to handle paste event.
    .add([
        (0, $hYOOW.pastePlugin),
        {}
    ])// We need clipboard to handle cut and copy and clipboard serialization.
    .add((0, $ifkCZ.default))// Handles focus and blur events.
    .add((0, $4Kyof.focusPlugin))// This plugin handles composition events and take care nuances of composition.
    // Need this plugin to have sleek composition support for languages such as Japanese, Chinese
    .add((0, $e6Dq9.compositionPlugin))// Editor can't function without this plugin.
    // It takes care of doc, paragraph and text nodes, backbone of any document.
    .add([
        (0, $7Upsh.default),
        {}
    ])// Dependency of cardPlugin, floatingToolbarPlugin
    .add((0, $2QN3e.decorationsPlugin))// Depdency of undoRedoButtons
    .add((0, $d1HsG.typeAheadPlugin))// Depdency of undoRedoButtons
    .maybeAdd((0, $6WRJZ.default), true)// We want to support undo/redo through shortcuts.
    .maybeAdd((0, $abOD2.undoRedoPlugin), true)// We should keep this plugin. It will remove all the marks when doc is empty.
    // It's very lightweight plugin.
    .add((0, $5VZEy.clearMarksOnEmptyDocPlugin))// Dependency of cardPlugin
    .maybeAdd([
        (0, $3HCXM.hyperlinkPlugin),
        {
            disableFloatingToolbar: !options.linkPicker,
            linkPicker: options.linkPicker
        }
    ], !!options.enableLinks).maybeAdd([
        (0, $2ZvWx.mentionsPlugin)
    ], !!options.mentionProvider)// Dependency of cardPlugin, gridPlugin
    .add((0, $lfQQe.widthPlugin))// Need placeholder plugin to show placeholder
    .add([
        (0, $f3DNZ.placeholderPlugin),
        options.placeholder
    ])// Dependency of floatingToolbarPlugin
    .add((0, $e273U.editorDisabledPlugin))// Dependency of floatingToolbarPlugin
    .add((0, $1ZhW4.copyButtonPlugin))// Dependency of cardPlugin
    .add((0, $5tMpU.floatingToolbarPlugin))// Need selections plugin to handle selection nuances in editor, support gap cursor and keyboard handling for selection.
    .add([
        (0, $fb3SZ.selectionPlugin),
        {}
    ])// Need to have save on enter functionality. Without this plugin, on enter editor will add line break and then prompt is submited.
    .maybeAdd([
        (0, $jNalm.saveOnEnterPlugin),
        options.onSave
    ], !!options.onSave)// Dependency of cardPlugin
    .maybeAdd([
        (0, $iVGec.gridPlugin),
        {}
    ], true)// Need card plugin to show smart links.
    .maybeAdd([
        (0, $40ukF.cardPlugin),
        cardPluginData
    ], !!options.enableLinks)// Need this plugin for adding new line on `Shift + Enter` keymap
    .add([
        (0, $fKdaf.blockTypePlugin),
        {
            allowBlockType: {
                exclude: [
                    'heading',
                    'blockquote'
                ]
            }
        }
    ])// Dependency for correct toolbars showing up
    .add((0, $4lpx1.userIntentPlugin));
    return preset;
}


const $3160ecc65fdf1937$export$4732a5aefd77a6d8 = (adf)=>{
    // Check if the first paragraph has content with hardBreak type
    const firstParagraph = adf.content?.[0];
    if (firstParagraph?.type === 'paragraph' && firstParagraph.content) return firstParagraph.content.some((item)=>item?.type === 'hardBreak');
    return false;
};



const $d034944da22b277c$var$styles = {
    insertMenuContainer: "_0GTcwRIZbP _43nrzTIZbP",
    editorBase: "_43nrzT1Y8M _3W2Oc8wPeg _2O5Vij7dHp _3YEZNO7dHp _1ANEUSlpBW _1T2N03wPeg _39xV02IZbP",
    editorMultiline: "_43nrzT1Y8M _3W2Oc8wPeg _2O5Vij7dHp _3YEZNO7dHp _1ANEUSlpBW _1T2N03wPeg _39xV02N91d"
};
const $d034944da22b277c$var$EditorWrapper = (props)=>{
    const appearance = 'chromeless';
    const { editorProps: editorProps, options: options } = props;
    const { type: type = 'user-input', onChange: onChange, onInputChange: onInputChange, onADFChange: onADFChange, defaultValue: defaultValue, enableLinks: enableLinks, setFocusHandlers: setFocusHandlers, setClearHandler: setClearHandler, ariaLabel: ariaLabel, submit: submit, isAIFC: isAIFC } = editorProps;
    const { onSubmit: onSubmit } = options;
    const adfRef = (0, $cozmU.useRef)(undefined);
    const textRef = (0, $cozmU.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $cozmU.useState)(true);
    const [hasLinebreak, setHasLinebreak] = (0, $cozmU.useState)(false);
    const handleChange = (0, $cozmU.useCallback)((editorView)=>{
        const textSerializer = (0, $at1wf.default).fromSchema(editorView.state.schema);
        const text = textSerializer.serializeFragment(editorView.state.doc.content);
        const adf = (0, $gWBVp.toJSON)(editorView.state.doc);
        onChange?.({
            text: text,
            adf: adf
        });
        onADFChange?.(adf);
        onInputChange?.(text);
        adfRef.current = adf;
        textRef.current = text;
        const hasHardBreak = (0, $3160ecc65fdf1937$export$4732a5aefd77a6d8)(adf);
        setHasLinebreak(hasHardBreak);
        if (text) setIsSubmitDisabled(false);
        else setIsSubmitDisabled(true);
    }, [
        onChange,
        onADFChange,
        onInputChange
    ]);
    const onSave = (0, $cozmU.useCallback)((editorView)=>{
        handleChange(editorView);
    }, [
        handleChange
    ]);
    const onSaveSubmit = (0, $cozmU.useCallback)(()=>{
        if (onSubmit) onSubmit?.({
            adf: adfRef.current,
            text: textRef.current
        });
        else submit?.();
    }, [
        submit,
        onSubmit
    ]); // We could have created preset outside PromptEditor component,
    //  but currently placeholder prop ComposableEditor is not working.
    // We have to pass placeholder to placeholder plugin.
    // That's why using usePreset, who memoize preset.
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>(0, $f78b3d691d800c09$export$cd6e43a807ff0e0d)({
            ...options,
            placeholder: {
                placeholder: editorProps.placeholder
            },
            onSave: editorProps.isAIFC ? onSaveSubmit : onSave,
            enableLinks: enableLinks
        }), [
        options,
        editorProps.placeholder,
        editorProps.isAIFC
    ]);
    const editorViewRef = (0, $cozmU.useRef)(null);
    const onEditorReady = (0, $cozmU.useCallback)((editorActions)=>{
        if (setClearHandler) setClearHandler(()=>editorActions.clear());
        const editorView = editorActions._privateGetEditorView();
        if (editorView) {
            editorViewRef.current = editorView;
            if (!editorActions.isDocumentEmpty()) editorView.dispatch(editorView.state.tr.setSelection(new (0, $kCECX.AllSelection)(editorView.state.doc)));
        }
    }, [
        setClearHandler
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (setFocusHandlers) /**
       * We need to expose clear function through ref because
       *  changing defaultValue does not clear editor.
       */ setFocusHandlers(editorApi?.core?.actions.blur, editorApi?.core?.actions.focus);
    }, [
        editorApi,
        setFocusHandlers
    ]); // Skip any toolbars that displays in the editor, like Link Picker toolbar
    // Yes, it's ugly, but it's easier way, because we can't have access to the PromptEditor
    // floating toolbar.
    const stopPropagationForFloatingToolbar = (0, $cozmU.useCallback)((event)=>{
        const eventFloatingToolbar = event.target instanceof HTMLElement ? event.target.closest('[data-testid="editor-floating-toolbar"]') : null; // Check that floating toolbar is a child of the current target,
        // i.e. it's a child of current the editor.
        if (eventFloatingToolbar && event.currentTarget.contains(eventFloatingToolbar)) event.stopPropagation();
    }, []);
    const addItemButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $e36b0c785ff8a212$export$6cb731ac7be1981a), {
        editorApi: editorApi,
        promptType: type
    });
    const submitButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        testId: "submit-icon-button",
        shape: "circle",
        appearance: "primary",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        isDisabled: isSubmitDisabled,
        onClick: isAIFC ? onSaveSubmit : submit,
        isTooltipDisabled: isSubmitDisabled,
        label: formatMessage((0, $77bf060bfae202f8$export$2e2bcd8739ae039).promptSubmit),
        tooltip: {
            position: 'top'
        }
    });
    const editor = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jlRK6.ComposableEditor), {
        mentionProvider: options.mentionProvider,
        appearance: appearance,
        minHeight: 20,
        maxHeight: 200,
        preset: preset,
        assistiveLabel: ariaLabel ?? formatMessage((0, $7ZL6d.aiMessages).promptbuilderAriaLabel),
        shouldFocus: editorProps.autoFocus ?? true,
        defaultValue: defaultValue,
        onChange: handleChange,
        onEditorReady: onEditorReady
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "presentation",
        onKeyDown: stopPropagationForFloatingToolbar,
        onKeyUp: stopPropagationForFloatingToolbar,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            gap: "space.050",
            /**
                          * Note wrap and direction is purely added for the new modals multiline behaviour
                          */ wrap: isAIFC ? 'wrap' : undefined,
            direction: isAIFC ? 'row' : undefined,
            children: [
                isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: hasLinebreak ? $d034944da22b277c$var$styles.editorMultiline : $d034944da22b277c$var$styles.editorBase,
                    children: editor
                }) : editor,
                isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    xcss: $d034944da22b277c$var$styles.insertMenuContainer,
                    space: "space.050",
                    children: [
                        addItemButton,
                        submitButton
                    ]
                }) : (type === 'user-input' || type === 'interrogate') && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
                    children: [
                        options.enableLinks && options.linkPicker && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4c7f77a2d0456024$export$b665e181ecd1797), {
                            editorApi: editorApi,
                            promptType: type
                        }),
                        options.mentionProvider && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fbd8aa336152e2ef$export$d16f16312388c7e), {
                            editorApi: editorApi,
                            promptType: type
                        })
                    ]
                })
            ]
        })
    });
};
function $d034944da22b277c$export$df4eed2eacb29ddb(options) {
    return (props)=>{
        const editorProps = {
            editorProps: props,
            options: options
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d7j1D.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($d034944da22b277c$var$EditorWrapper // Ignored via go/ees005
            , {
                ...editorProps
            })
        });
    };
}
module.exports["createPromptEditor"] = $d034944da22b277c$export$df4eed2eacb29ddb;

});

parcelRegister("llvMC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $93WrI = parcelRequire("93WrI");

var $7ZL6d = parcelRequire("7ZL6d");


var $f6j4r = parcelRequire("f6j4r");


var $33Ze6 = parcelRequire("33Ze6");


var $2MofN = parcelRequire("2MofN");

const $44f98a3cc5c4e3b7$export$5dae1cd728cdd936 = (options)=>({
        key: (0, $2MofN.CONFIG_ITEM_KEYS).SUMMARISE_WRITING,
        title: (0, $93WrI.aiConfigItemMessages).summarizeWritingtitle,
        description: (0, $93WrI.aiConfigItemMessages).summarizeWritingDescription,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6j4r.SummarizeIcon), null),
        showInRefineDropdown: true,
        intentSchemaId: 'summarize_intent_schema.json',
        featureId: 'summarize_writing',
        actions: {
            empty: [
                (0, $33Ze6.createInsertAtCurrentPosition)({
                    appearance: 'primary'
                })
            ],
            selection: [
                (0, $33Ze6.createInsertBelow)({
                    appearance: 'secondary',
                    factoryOptions: options
                }),
                (0, $33Ze6.createReplace)({
                    appearance: 'primary'
                })
            ]
        },
        getBackendModel: ()=>{
            return 'assistance-service';
        }
    });
const $44f98a3cc5c4e3b7$export$a0bf62522ec7a604 = (options)=>({
        config: $44f98a3cc5c4e3b7$export$5dae1cd728cdd936(options),
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: true
            }
        }
    });
const $44f98a3cc5c4e3b7$export$afe1e087747ab29 = (options)=>({
        config: {
            ...$44f98a3cc5c4e3b7$export$5dae1cd728cdd936(options),
            description: (0, $7ZL6d.aiMessages).atlasSummarizePageConfigItemDescription
        },
        triggers: {
            empty: {
                enabled: true,
                docMinSize: 1
            },
            selection: {
                enabled: false
            }
        }
    });
module.exports["summarizeWriting"] = $44f98a3cc5c4e3b7$export$5dae1cd728cdd936;
module.exports["summarizeWritingWithOptions"] = $44f98a3cc5c4e3b7$export$a0bf62522ec7a604;
module.exports["summarizeWritingWithOptionsForAtlas"] = $44f98a3cc5c4e3b7$export$afe1e087747ab29;

});

parcelRegister("c4mdU", function(module, exports) {
const $5b428d85e67fea49$export$198c236a78ec089b = {
    actor_type: 'AGENT',
    available_plugins: {
        'Content-Read-Plugin': {},
        'Ethical-Filtering-Plugin': {},
        'Jira-JQL-Plugin': {},
        'Jira-NL-JQL-Plugin': {},
        'Jira-Software-Plugin': {},
        'Page-Search-Plugin': {},
        'People-Plugin': {},
        'Search-QA-Plugin': {}
    },
    creator: 'mock',
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Mocking: Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
    external_files: null,
    follow_up_prompt_template: '\nYour task is to generate follow-up questions for the given conversation from the user\'s perspective.\nThe conversation history is provided in triple backticks.\n\nConversation History:\n```\n{message_history}\n```\n\nWhen you generate follow-up questions, follow these steps closely:\n1. Read the conversation history carefully to understand the user\'s intent. Keep it open and refer back to it as necessary.\n2. Pretend that you are the user and think about what you would ask next based on the conversation history and the original intent.\n3. Generate 3 follow-up questions from the perspective of the user that meet the following criteria.\n    - Relevant to the conversation.\n    - Unique and different from previously asked questions.\n    - Requests new information.\n    - Insightful and enhances the engagement of the conversation.\n    - Succinct and straight to the point.\n    - Specific and avoids being too general.\n    - Less than 9 words.\n    - When the subject of the question is the user asking questions, use the first-person pronoun "I".\n4. Read your follow-up questions again and remove the ones that do not meet ALL of the listed criteria.\n5. If there are no follow-up questions left, return an empty list.\n6. If there are follow-up questions left, paraphrase them to make them more concise.\n7. Return your paraphrased follow-up questions.\n',
    id: 'f3a534d9-1498-e0d4-8b50-e058a8fb8156',
    is_default: true,
    // model: null,
    name: 'Mock Chat',
    named_id: 'ai_mate_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: '\nYou are Rovo Chat, an AI assistant built by Atlassian, you can do everything in the list of functions available. \nTreat the human in a friendly and personalised way, if what they ask is completely nonsensical, ask for clarification.  \n\nFollowing are the details of the human user:\n\nName: {{ user_name }}\n{{ location_info }}\n\nCurrent Time: {{ current_time }}\n\n{{ browsing_context }}\n\nFollow these rules:\n- Respond with names in the following format [name](/people/id) when appropriate.\n- Always use a function to find information, even if you know the answer.\n- Prioritise the Search-QA-Plugin when the function to use is not obvious.\n- Never answer the user directly without results from a function, unless they asked to reformat an existing answer.\n- Do not use your pretrained knowledge to answer.\n- Do not return function details in your answer.\n- If the answer is not available from the current function, always call another function.\n',
    visibility: 'PUBLIC',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
const $5b428d85e67fea49$export$2036d10b5adbaa07 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {
            is_terminal: true,
            raise_no_answer_exception: true
        },
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: "Craft and refine all things blogs, external comms, and announcements. Align with your brand's voice.",
    external_files: null,
    follow_up_prompt_template: null,
    id: '3506f1fa-13ab-0c9c-d645-f26c759ef903',
    is_default: false,
    // model: null,
    name: 'Comms crafter',
    named_id: 'confluence_reviewer_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: 'You are the Comms crafter, a helpful assistant for reviewing Confluence documents. You are tasked with providing suggestions to improve a Confluence document.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- Always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\n',
    visibility: 'PRIVATE',
    user_defined_conversation_starters: [
        "Can you help me with this blog post I'm working on?",
        "Help me with this announcement I'm drafting."
    ],
    favourite: false,
    deactivated: false
};
const $5b428d85e67fea49$export$c6b96d4ac6b48aa6 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {},
        'Content-Read-Plugin': {},
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Crafts job descriptions that align with corporate guidelines and ensures they promote inclusivity and diversity.',
    external_files: null,
    follow_up_prompt_template: null,
    id: '5692d6dd-3045-499f-b08b-77ed2d253941',
    is_default: false,
    // model: 'gpt-3-5-turbo-atlassian-0125',
    name: 'Job writer',
    named_id: 'job_writer_agent',
    plugin_routing_type: 'DEFAULT',
    // preferred_plugin: null,
    system_prompt_template: 'You are the Job writer agent, a helpful assistant for hiring managers and recruitment teams to standardize on job descriptions which follow diversity and inclusion guidelines. \nYou are tasked with providing suggestions to improve a Confluence document for job descriptions.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- You must always provide a suggested replacement for insertion when asked to create, insert or draft job descriptions, summaries or any unique content.\n- You must always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\nBrowsing Context: {{ browsing_context }}',
    visibility: 'PRIVATE',
    user_defined_conversation_starters: [],
    favourite: false,
    deactivated: false
};
const $5b428d85e67fea49$export$3b92ff78ca28a6e3 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Search-QA-Plugin': {
            space_filter: [
                'A11YKB'
            ]
        }
    },
    creator: 'ari:cloud:identity::user/557057:db25fe7e-23f8-4e0f-aa1d-74a8c29bbc10',
    creator_cloud_id: 'a436116f-02ce-4520-8fbb-7301462a1674',
    creator_type: 'CUSTOMER',
    description: 'Accessibility help by Central Accessibility Team',
    external_files: [],
    follow_up_prompt_template: null,
    id: 'a7f547de-aa39-4d25-9234-65ac13c19acd',
    is_default: false,
    // model: null,
    name: 'A11Y Mate Long Name for Selection Toolbar',
    named_id: 'A11Y Mate',
    plugin_routing_type: null,
    // preferred_plugin: null,
    system_prompt_template: '',
    visibility: 'PUBLIC',
    user_defined_conversation_starters: [
        'What can you help me with?',
        'What can you help me with?',
        'What can you help me with?'
    ],
    favourite: false,
    deactivated: false
};
module.exports["ChatAgent"] = $5b428d85e67fea49$export$198c236a78ec089b;
module.exports["CommsCrafterAgent"] = $5b428d85e67fea49$export$2036d10b5adbaa07;
module.exports["JobWriterAgent"] = $5b428d85e67fea49$export$c6b96d4ac6b48aa6;
module.exports["A11yMateAgent"] = $5b428d85e67fea49$export$3b92ff78ca28a6e3;

});

parcelRegister("i2EU6", function(module, exports) {

var $2MofN = parcelRequire("2MofN");

const $19e58810aae96090$export$4f1ccf7e54aa16f6 = (configItemKey)=>{
    if (!configItemKey) return false;
    switch(configItemKey){
        case (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE:
        case (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE_AIFC:
            return true;
        default:
            return false;
    }
};
const $19e58810aae96090$export$847ade1abb79069a = (configItemKey)=>{
    if (!configItemKey) return false;
    switch(configItemKey){
        case (0, $2MofN.CONFIG_ITEM_KEYS).FREE_GENERATE:
            return true;
        default:
            return false;
    }
};
module.exports["configItemUsesRovo"] = $19e58810aae96090$export$4f1ccf7e54aa16f6;
module.exports["configItemUsesFreeGen"] = $19e58810aae96090$export$847ade1abb79069a;

});

parcelRegister("bVbtv", function(module, exports) {

var $2MofN = parcelRequire("2MofN");

const $c24186de31fa51c5$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
    if (!configItem || !lastTriggeredFrom) return false;
    return configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE && lastTriggeredFrom === 'confluenceTitleToolbar';
};
const $c24186de31fa51c5$export$bde142b94ad13256 = (configItem)=>{
    return configItem.key === (0, $2MofN.CONFIG_ITEM_KEYS).SUGGEST_A_TITLE;
};
module.exports["isConfluenceTitleToolbarSuggestTitle"] = $c24186de31fa51c5$export$fc21f0ec31fe4ec0;
module.exports["isSuggestTitleForConfluence"] = $c24186de31fa51c5$export$bde142b94ad13256;

});

parcelRegister("doWyc", function(module, exports) {

var $anBbz = parcelRequire("anBbz");

const $1300ae1c88acda3f$export$40965dc715d5173a = (state, from)=>{
    if (!(0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)) return undefined;
    const $pos = state.doc.resolve(from);
    const child = $pos.parent.maybeChild($pos.index());
    const linkMark = child?.marks.find((m)=>m.type === state.schema.marks.link);
    const url = typeof linkMark?.attrs?.href === 'string' ? linkMark.attrs.href : undefined;
    if (linkMark && url && child) {
        // Walk both directions from the cursor to find the contiguous run of
        // text nodes that share this exact link mark — that's the mark range.
        const parentStart = $pos.start();
        const childIndex = $pos.index();
        let runFrom = parentStart;
        for(let i = 0; i < childIndex; i++)runFrom += $pos.parent.child(i).nodeSize;
        let runTo = runFrom + child.nodeSize;
        for(let i = childIndex - 1; i >= 0; i--){
            const sibling = $pos.parent.child(i);
            if (sibling.marks.some((m)=>m.eq(linkMark))) runFrom -= sibling.nodeSize;
            else break;
        }
        for(let i = childIndex + 1; i < $pos.parent.childCount; i++){
            const sibling = $pos.parent.child(i);
            if (sibling.marks.some((m)=>m.eq(linkMark))) runTo += sibling.nodeSize;
            else break;
        }
        return {
            parentNode: $pos.parent,
            linkMark: linkMark,
            url: url,
            markRange: {
                from: runFrom,
                to: runTo
            }
        };
    }
    return undefined;
};
const $1300ae1c88acda3f$export$74e7028cbce2b0e1 = ({ schema: { nodes: nodes } })=>{
    if ((0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true)) return new Set([
        nodes.table,
        nodes.inlineCard,
        nodes.blockCard,
        nodes.embedCard
    ].filter(Boolean));
    else return new Set([
        nodes.table
    ]);
};
const $1300ae1c88acda3f$export$73f561bc8b894934 = (state, selection)=>{
    const { tableHeader: tableHeader, tableCell: tableCell, tabeRow: tabeRow, table: table } = state.schema.nodes;
    const { $from: $from } = selection || state.selection;
    const parent = $from.parent;
    return [
        tableHeader,
        tableCell,
        tabeRow,
        table
    ].includes(parent.type);
};
module.exports["getLinkMarkAtCursor"] = $1300ae1c88acda3f$export$40965dc715d5173a;
module.exports["getSupportedNodesForAIModal"] = $1300ae1c88acda3f$export$74e7028cbce2b0e1;
module.exports["isCellSelection"] = $1300ae1c88acda3f$export$73f561bc8b894934;

});

parcelRegister("l2lIz", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $iTJtk = parcelRequire("iTJtk");


var $krYZG = parcelRequire("krYZG");


var $cXtTj = parcelRequire("cXtTj");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $26Q4g = parcelRequire("26Q4g");


var $2MofN = parcelRequire("2MofN");


var $hZdqw = parcelRequire("hZdqw");

function $f92dba210d6ba10e$export$42373263ca9a5144(experienceName, invokedFrom) {
    // The Proactive Description Completer are using the shared config item key with issue reformatter
    // Need to get the correct experience name from invokedFrom
    // This is temp solution to distinguish two experience
    // We are planning to add a new config item key for Proactive Description Completer
    if (invokedFrom === 'jiraProactiveDescriptionCompleterFooterButton' && experienceName === (0, $2MofN.CONFIG_ITEM_KEYS).ADD_STRUCTURE) return 'proactiveDescriptionCompleter';
    if (experienceName === (0, $2MofN.CONFIG_ITEM_KEYS).EXPERIMENTAL_PROMPT_PLACEHOLDER) {
        /**
		 * We only check for experiment value here as the config item would not exist
		 * if the experiment is not enabled / is misconfigured.
		 */ const getExperimentValue = (0, $cXtTj.default).getExperimentValue;
        const analyticsExperienceName = getExperimentValue('platform_editor_ai-prompts-placeholder', 'analytics_experience_name', '');
        return analyticsExperienceName || experienceName;
    }
    return experienceName;
}
function $f92dba210d6ba10e$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes, canInlineStreamChanges: canInlineStreamChanges, onCommonAttributesUpdated: onCommonAttributesUpdated, isInDocumentStreamingEnabled: isInDocumentStreamingEnabled }) {
    const startTime = performance.now();
    const stepTracker = {};
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const aiSessionId = invokeAttributes.aiSessionId ?? (0, $03RpJ.default)();
    const aiGroupId = invokeAttributes.aiGroupId ?? aiSessionId;
    let prevStepEnd = performance.now();
    let prevStepName;
    let experienceName;
    let adhocAttributes = {};
    let commonAttributes = {};
    let dynamicAttributes = {};
    let aiLifeCycleDynamicAttributesGetter;
    const isSmartLinkToolbarExpEnabled = (0, $anBbz.expValEqualsNoExposure)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    let finished = false;
    let contentCopiedSometime = false;
    const sawAupViolation = false;
    let lastAiInteractionID;
    /** Tracks the stepName of the most recently enqueued step, for diagnostics on noEventExistsToBeFired */ let lastEnqueuedStepName;
    let queuedStepArgs = {
        stepName: 'invoke',
        attributes: invokeAttributes
    };
    /**
	 * A util function to get dynamic attributes for the AI lifecyle
	 * The previously registered getter is invoked when the lifecyle begins
	 * The resolved attributes are then used until the lifecycle ends
	 */ const getAiLifeCycleDynamicAttributes = ({ init: init })=>{
        if (init && aiLifeCycleDynamicAttributesGetter) dynamicAttributes = aiLifeCycleDynamicAttributesGetter();
        return dynamicAttributes;
    };
    const getAgentAttributes = ()=>{
        return {
            agentName: commonAttributes.agentName,
            agentId: commonAttributes.agentId,
            agentCreatorType: commonAttributes.agentCreatorType,
            agentExternalConfigReference: commonAttributes.agentExternalConfigReference,
            agentIsDefault: commonAttributes.agentIsDefault
        };
    };
    const analyticsFlow = {
        aiSessionId: aiSessionId,
        aiGroupId: aiGroupId,
        /**
		 * Add a step to the queue to be fired on next screen.
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * analyticsFlow.enqueueStep({ stepName, attributes });
		 * ```
		 */ enqueueStep: (stepArgs, callerComponent)=>{
            // Enqueue after the flow finished: no-op on the XState path (a second producer, e.g. the
            // AnalyticsBridge effect, can enqueue late) instead of emitting a spurious
            // `userFlowAlreadyFinished`. Mirrors the fireQueuedStep finished-branch below.
            if (finished) {
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return;
                fireAIAnalyticsEvent($f92dba210d6ba10e$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs,
                        callerComponent: callerComponent,
                        xstateMigrationEnabled: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
                    }
                }));
                return;
            }
            if (stepArgs.stepName === 'loading') {
                lastAiInteractionID = aiSessionId;
                if ((!isInDocumentStreamingEnabled || invokeAttributes.invokedFrom !== 'streamingApi') && invokeAttributes.invokedFrom !== 'confluenceTitleGenOnPaste') fireAIAnalyticsEvent({
                    payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                        action: (0, $krYZG.ACTION).INITIATED,
                        interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                        experienceName: $f92dba210d6ba10e$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                        isProactive: false,
                        invokedFrom: invokeAttributes.invokedFrom,
                        nudgeMetrics: commonAttributes.nudgeMetrics,
                        ...isSmartLinkToolbarExpEnabled && {
                            has3pSources: commonAttributes.has3pSources,
                            sourceProduct: commonAttributes.sourceProduct
                        },
                        attributes: {
                            ...getAiLifeCycleDynamicAttributes({
                                init: true
                            }),
                            ...getAgentAttributes()
                        }
                    })
                });
            }
            if (stepArgs.stepName === 'complete') // When behind the xstate migration flag, the ACTIONED event is already fired
            // by the ai-monitor-watchmen plugin, so we skip it here to prevent double firing.
            {
                if (!(0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
                    const attributes = stepArgs?.attributes ?? {};
                    const actionTaken = 'actionTaken' in attributes ? attributes.actionTaken : undefined;
                    const promptType = 'promptType' in attributes ? attributes.promptType : undefined;
                    const refinementCount = 'refinementCount' in attributes ? attributes.refinementCount : undefined;
                    fireAIAnalyticsEvent({
                        payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                            action: (0, $krYZG.ACTION).ACTIONED,
                            interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                            experienceName: $f92dba210d6ba10e$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                            isProactive: false,
                            invokedFrom: invokeAttributes.invokedFrom,
                            nudgeMetrics: commonAttributes.nudgeMetrics,
                            ...isSmartLinkToolbarExpEnabled && {
                                has3pSources: commonAttributes.has3pSources,
                                sourceProduct: commonAttributes.sourceProduct
                            },
                            attributes: {
                                ...getAiLifeCycleDynamicAttributes({
                                    init: false
                                }),
                                ...getAgentAttributes(),
                                promptType: promptType,
                                refinementCount: refinementCount,
                                aiResultAction: actionTaken?.toLowerCase()
                            },
                            traceIds: commonAttributes.traceIds
                        })
                    });
                }
            }
            // Slot already occupied. On the XState path two unsynchronised producers race, so flush
            // the stale step first (preserves its funnel event, avoids the spurious
            // `cannotEnqueueMoreThanOneEvent` that dominated the SLO burn on the migration ramp).
            // Gated: the legacy path keeps emitting the operational error unchanged.
            if (queuedStepArgs !== undefined && (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) analyticsFlow.fireQueuedStep(undefined, callerComponent);
            // Legacy path (or a failed XState flush) still emits the (attributed) operational error.
            if (queuedStepArgs !== undefined) {
                fireAIAnalyticsEvent($f92dba210d6ba10e$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'cannotEnqueueMoreThanOneEvent',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs,
                        callerComponent: callerComponent,
                        xstateMigrationEnabled: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
                    }
                }));
                return;
            }
            queuedStepArgs = stepArgs;
            lastEnqueuedStepName = stepArgs.stepName;
        },
        fireQueuedStep: (target, callerComponent)=>{
            // Fire after finished: no-op on the XState path (a second producer, e.g. the unmount
            // flush, can fire late) instead of emitting a spurious `userFlowAlreadyFinished`.
            if (finished) {
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return;
                fireAIAnalyticsEvent($f92dba210d6ba10e$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        target: target,
                        queuedStepArgs: queuedStepArgs,
                        callerComponent: callerComponent,
                        xstateMigrationEnabled: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
                    }
                }));
                return;
            }
            // Empty-slot fire: no-op on the XState path (the plugin may have already drained the
            // terminal step before a deferred/teardown fire) instead of the spurious
            // `noEventExistsToBeFired`. Callers should also guard with `hasQueuedStep()`.
            if (!queuedStepArgs) {
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) return;
                fireAIAnalyticsEvent($f92dba210d6ba10e$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'noEventExistsToBeFired',
                    errorProperties: {
                        aiSessionId: aiSessionId,
                        target: target,
                        callerComponent: callerComponent,
                        lastEnqueuedStep: lastEnqueuedStepName ?? 'none',
                        xstateMigrationEnabled: (0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)
                    }
                }));
                return;
            }
            queuedStepArgs.attributes = {
                ...queuedStepArgs.attributes,
                ...adhocAttributes,
                ...commonAttributes,
                invokedFrom: invokeAttributes.invokedFrom,
                nudgeMetrics: commonAttributes.nudgeMetrics,
                invokedFor: invokeAttributes.invokedFor,
                triggerMethod: invokeAttributes.triggerMethod,
                target: target,
                isStreamingEnded: !!commonAttributes.isStreamingEnded
            };
            if (target === 'failed' || target === 'apiError') fireAIAnalyticsEvent({
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).ERROR,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $f92dba210d6ba10e$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    ...isSmartLinkToolbarExpEnabled && {
                        has3pSources: commonAttributes.has3pSources,
                        sourceProduct: commonAttributes.sourceProduct
                    },
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes(),
                        aiErrorMessage: (0, $hZdqw.isErrorStepAttributes)(queuedStepArgs?.attributes) ? queuedStepArgs?.attributes?.errorKey ?? queuedStepArgs?.attributes?.errorType : 'Unknown error',
                        aiErrorCode: (0, $hZdqw.isErrorStepAttributes)(queuedStepArgs.attributes) ? queuedStepArgs.attributes?.statusCode ?? 500 : 500
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // By default, if the preview is shown then we can assume that the user will be given and accept/reject option
            // However, if canInlineStreamChanges() => true, then the preview will not be shown and the changes will be applied automatically
            // If the canInlineStreamChanges() => false, then the changes will not be applied automatically, and the user will have to accept/reject the changes.
            if (target === 'preview' && !canInlineStreamChanges()) fireAIAnalyticsEvent({
                payload: (0, $26Q4g.createUnifiedAnalyticsPayload)({
                    action: (0, $krYZG.ACTION).VIEWED,
                    interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                    experienceName: $f92dba210d6ba10e$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                    isProactive: false,
                    invokedFrom: invokeAttributes.invokedFrom,
                    nudgeMetrics: commonAttributes.nudgeMetrics,
                    ...isSmartLinkToolbarExpEnabled && {
                        has3pSources: commonAttributes.has3pSources,
                        sourceProduct: commonAttributes.sourceProduct
                    },
                    attributes: {
                        ...getAiLifeCycleDynamicAttributes({
                            init: false
                        }),
                        ...getAgentAttributes()
                    },
                    traceIds: commonAttributes.traceIds
                })
            });
            // Add target to attributes and fire the event
            fireUserFlowStep(queuedStepArgs);
            // Remove the queued event
            queuedStepArgs = undefined;
        },
        /**
		 * This is useful when you want to add attributes to the current step
		 * but you don't know them at the time of enqueuing the step.
		 *
		 * It's safe to fire this on dismount -- because the step is enqueued in the dismount
		 * of a parent component (where AnalyticsFlowContextProvider is setup).
		 *
		 * @example
		 * ```tsx
		 * const analyticsFlow = useAnalyticsFlow();
		 * React.useEffect(() => {
		 *  return () => {
		 *    // add attribute on dismount
		 *    analyticsFlow.addAttributes({ loadingTime })
		 *  }
		 * })
		 * ```
		 */ addAttributes: (attributes)=>{
            // The user copying the content is being treated as a potential success indicator
            // This is a weak signal as we don't know if the user actually used the copied content
            // and might expect the user to copy the content in cases where the generation failed.
            if ('contentCopied' in attributes && attributes.contentCopied) contentCopiedSometime = true;
            adhocAttributes = {
                ...adhocAttributes,
                ...attributes
            };
        },
        getAiLifeCycleDynamicAttributes: getAiLifeCycleDynamicAttributes,
        /**
		 * Editor-AI can be invoked in various contexts.
		 * In some of those scenarios, we want to register additional attributes to understand how the respective feature is performing.
		 *
		 * For example, when the Issue Reformatter is used, we want to understand analytics such as
		 *  - The issue-type of the issue where the issue reformatter was invoked
		 *  - Whether the feature was used from Issue-View or GIC
		 *  - Product type such as JWM and JSW
		 *
		 * This method registers a attribute getter function.
		 * The function will be invoked when the feature is first run (i.e. along with `aiInteraction Initiated`)
		 * The resolved values will then be unchanged until the AI lifecyle is completed
		 * i.e. The same values will be used for all events such as `aiResult Viewed` and `aiResult dismissed`
		 *
		 * In the current version, this method accepts one getter function, and assumes that there aren't multiple functions.
		 * In future, this can be tweaked to allow multiple getters.
		 * Such improvements need to be done carefully so that the getters are also unregistered accordingly
		 */ registerAiLifeCycleDynamicAttributesGetter: (getter)=>{
            aiLifeCycleDynamicAttributesGetter = getter;
        },
        /**
		 * Common attributes will be retained for the rest of the analytics flow
		 * until it is updated again
		 *
		 * Example uses: keeping track of which backendModel has been selected
		 */ updateCommonAttributes: (attributes)=>{
            const updatedCommonAttributes = {
                ...commonAttributes,
                ...attributes
            };
            commonAttributes = updatedCommonAttributes;
            onCommonAttributesUpdated?.(updatedCommonAttributes);
        },
        getLastAiInteractionId: ()=>lastAiInteractionID,
        getUnifiedEventData: ()=>{
            return {
                interactionID: commonAttributes.channelId ?? lastAiInteractionID,
                experienceName: $f92dba210d6ba10e$export$42373263ca9a5144(experienceName ?? '', invokeAttributes.invokedFrom),
                invokedFrom: invokeAttributes.invokedFrom,
                has3pSources: commonAttributes.has3pSources,
                sourceProduct: commonAttributes.sourceProduct,
                traceIds: commonAttributes.traceIds,
                attributes: {
                    ...getAiLifeCycleDynamicAttributes({
                        init: false
                    }),
                    ...getAgentAttributes()
                }
            };
        },
        getUserFlowCommonAttributes: (configItem)=>{
            return {
                agentName: configItem.agent?.creatorType === 'SYSTEM' ? configItem.agent?.name : undefined,
                agentId: configItem.agent?.id,
                agentCreatorType: configItem.agent?.creatorType,
                agentExternalConfigReference: configItem.agent?.externalConfigReference,
                agentIsDefault: configItem.agent?.isDefault,
                // Doing double negation to convert undefined to false
                adfPrompt: !!configItem.adfPrompt
            };
        },
        getCommonAttributes: ()=>commonAttributes,
        hasQueuedStep: ()=>queuedStepArgs !== undefined
    };
    return analyticsFlow;
    function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
        if (!stepTracker[stepName]) stepTracker[stepName] = 1;
        else stepTracker[stepName] = stepTracker[stepName] + 1;
        if (attributes.experienceName) experienceName = $f92dba210d6ba10e$export$42373263ca9a5144(attributes.experienceName, invokeAttributes.invokedFrom);
        const stepAttributes = {
            ...commonAttributes,
            // the duration is currently being overriden in the complete step
            duration: Math.round(performance.now() - prevStepEnd),
            ...attributes,
            aiSessionId: aiSessionId,
            aiGroupId: aiGroupId,
            experienceName: experienceName,
            featureId: attributes.featureId || invokeAttributes.featureId,
            source: prevStepName,
            invokedFrom: attributes.invokedFrom,
            nudgeMetrics: attributes.nudgeMetrics,
            triggerMethod: attributes.triggerMethod,
            isInvokedFromEmptyPage: attributes.isInvokedFromEmptyPage,
            stepOccurrence: String(stepTracker[stepName]),
            sawAupViolation: sawAupViolation,
            includeKnowledgeFromCurrentPage: attributes.includeKnowledgeFromCurrentPage
        };
        // add totalDuration only to the final step
        // and set the experience as finished
        if (!attributes.target) {
            stepAttributes.totalDuration = Math.round(performance.now() - startTime);
            stepAttributes.contentCopiedSometime = contentCopiedSometime;
            finished = true;
        }
        // adding interaction ID to the events coming after the loading step, + final complete step
        if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
        const payload = {
            action: stepName,
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: stepAttributes,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        };
        //each step is a starting point for measuring duration for next step
        prevStepEnd = performance.now();
        //reset previous step name and custom attributes
        prevStepName = stepName;
        const modelIO = 'modelIO' in adhocAttributes ? adhocAttributes.modelIO : undefined;
        adhocAttributes = {};
        fireAIAnalyticsEvent({
            payload: payload
        });
        if (finished) fireAIAnalyticsEvent({
            payload: {
                ...payload,
                action: 'finished',
                attributes: {
                    ...payload.attributes,
                    // override source to be the previous last step in the flow
                    source: stepName,
                    modelIO: modelIO
                }
            }
        });
    }
}
/**
 * Creates an operational error payload
 */ function $f92dba210d6ba10e$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
    return {
        payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
                errorType: 'userFlowAnalyticsError',
                errorSubType: errorSubType,
                ...errorProperties
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        },
        channel: (0, $iTJtk.FabricChannel).editor
    };
}
module.exports["convertExperienceName"] = $f92dba210d6ba10e$export$42373263ca9a5144;
module.exports["createAnalyticsFlow"] = $f92dba210d6ba10e$export$7e715b9b9acf423a;

});

parcelRegister("hZdqw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ePK6j = parcelRequire("ePK6j");


var $l5rX3 = parcelRequire("l5rX3");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $krYZG = parcelRequire("krYZG");

var $iLcY8 = parcelRequire("iLcY8");


var $ieeJu = parcelRequire("ieeJu");


var $NI1tt = parcelRequire("NI1tt");

const $bae90e7f3173eb7e$var$WHITESPACE_REGEX = /\s+/u;
function $bae90e7f3173eb7e$export$e65dc2451c080d01(payload) {
    const packageInfo = (0, $NI1tt.getPackageInfo)();
    const attributes = payload.attributes || {};
    return {
        ...payload,
        attributes: {
            ...attributes,
            aiPluginPackageName: packageInfo.packageName,
            aiPluginPackageVersion: packageInfo.packageVersion
        }
    };
}
// This utils is referenced from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
// Note: this adds extra step to a transaction which effectively marks it as docChanged and can cause editor onchange to fire on dispatch
function $bae90e7f3173eb7e$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $iTJtk.FabricChannel).editor }) {
    return (tr)=>{
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
        tr.step(new (0, $l5rX3.AnalyticsStep)([
            {
                payload: $bae90e7f3173eb7e$export$e65dc2451c080d01(payload),
                channel: channel
            }
        ], [], // We don't understand now why we need position in AnalyticsStep.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // We need to create the step based on a position, this prevent split history for relative changes.
        pos));
        // We don't understand now why we need to store marks again in transaction.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // When you add a new step all the storedMarks are removed it
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return true;
    };
}
function $bae90e7f3173eb7e$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $iTJtk.FabricChannel).editor, addToHistory: addToHistory = true }) {
    $bae90e7f3173eb7e$var$attachPayloadIntoTransaction({
        editorState: editorState,
        payload: payload,
        channel: channel
    })(tr);
    if (!addToHistory) tr.setMeta('addToHistory', false);
    return tr;
}
function $bae90e7f3173eb7e$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $iTJtk.FabricChannel).editor }) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) dispatch($bae90e7f3173eb7e$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: dynamicPayload,
                            channel: channel
                        }));
                    } else dispatch($bae90e7f3173eb7e$export$5bef18c22bfe95d({
                        editorState: state,
                        tr: tr,
                        payload: payload,
                        channel: channel
                    }));
                }
            }, view);
}
function $bae90e7f3173eb7e$export$12ef4e1e68d53406(createAnalyticsEvent) {
    return ({ payload: payload, channel: channel = (0, $iTJtk.FabricChannel).editor })=>{
        if (!createAnalyticsEvent) return;
        const fireEvent = ()=>createAnalyticsEvent($bae90e7f3173eb7e$export$e65dc2451c080d01(payload))?.fire(channel);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fireEvent);
        else if (window.requestAnimationFrame) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestAnimationFrame(fireEvent);
        else setTimeout(fireEvent, 0);
    };
}
function $bae90e7f3173eb7e$export$5098b64908ee530() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAIAnalyticsEvent = (0, $cozmU.useCallback)((args)=>$bae90e7f3173eb7e$export$12ef4e1e68d53406(createAnalyticsEvent)(args), [
        createAnalyticsEvent
    ]);
    return fireAIAnalyticsEvent;
}
function $bae90e7f3173eb7e$export$511854ca6705eca5(channelId, lastAiInteractionID) {
    return channelId ?? lastAiInteractionID ?? '';
}
function $bae90e7f3173eb7e$export$1256d4293be5e625(step) {
    if (!step) return false;
    return 'errorKey' in step || 'errorType' in step || 'statusCode' in step;
}
const $bae90e7f3173eb7e$export$2cdad03d12648c8e = ({ api: api, actionSubjectId: actionSubjectId, attributes: attributes })=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).VIEWED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
            mode: (0, $iLcY8.MODE).EDITOR,
            selectionCharCount: attributes.selectionCharCount,
            selectionWordCount: attributes.selectionWordCount
        }
    });
};
function $bae90e7f3173eb7e$var$countSegments(input, granularity) {
    const seg = new Intl.Segmenter('und', {
        granularity: granularity
    });
    let n = 0;
    for (const _ of seg.segment(input))n++;
    return n;
}
function $bae90e7f3173eb7e$var$countWordLike(input) {
    const seg = new Intl.Segmenter('und', {
        granularity: 'word'
    });
    let n = 0;
    for (const part of seg.segment(input))if (part.isWordLike) n++;
    return n;
}
const $bae90e7f3173eb7e$var$computeCharWordCounts = (raw)=>{
    // drop all whitespace for char count
    const noWhitespace = raw.replace(/\s+/gu, '');
    // normalize whitespace for word count
    const normalized = raw.replace(/\s+/gu, ' ').trim();
    const hasSegmenter = typeof Intl !== 'undefined' && typeof Intl.Segmenter === 'function';
    const charCount = hasSegmenter ? $bae90e7f3173eb7e$var$countSegments(noWhitespace, 'grapheme') : Array.from(noWhitespace).length;
    const wordCount = normalized === '' ? 0 : hasSegmenter ? $bae90e7f3173eb7e$var$countWordLike(normalized) : normalized.split($bae90e7f3173eb7e$var$WHITESPACE_REGEX).length;
    return {
        charCount: charCount,
        wordCount: wordCount
    };
};
const $bae90e7f3173eb7e$export$980a72be63484695 = (doc, from, to)=>{
    if (from === to) return {
        charCount: 0,
        wordCount: 0
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_ai_xstate_migration', 'isEnabled', true)) {
        // In-document streaming can leave positions stale relative to the live
        // doc. Reading textBetween with stale positions causes ProseMirror's
        // nodesBetween to crash on `undefined.nodeSize`, which then unmounts
        // the surrounding React subtree (including the AI loading screen) via
        // the error boundary. See getSelectionCategoryUsingState for the same
        // pattern.
        const docSize = doc.content.size;
        const safeFrom = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(from, 0, docSize);
        const safeTo = (0, (/*@__PURE__*/$parcel$interopDefault($ePK6j)))(to, safeFrom, docSize);
        if (safeFrom === safeTo) return {
            charCount: 0,
            wordCount: 0
        };
        // keep line breaks as newlines and leaf nodes as spaces
        const raw = doc.textBetween(safeFrom, safeTo, '\n', ' ');
        return $bae90e7f3173eb7e$var$computeCharWordCounts(raw);
    } else {
        // keep line breaks as newlines and leaf nodes as spaces
        const raw = doc.textBetween(from, to, '\n', ' ');
        return $bae90e7f3173eb7e$var$computeCharWordCounts(raw);
    }
};
const $bae90e7f3173eb7e$export$a78a3dabcec86737 = (state)=>{
    const { from: from, to: to } = state.selection;
    if (state.selection.empty) return {
        charCount: 0,
        wordCount: 0
    };
    const raw = state.doc.textBetween(from, to, '\n', ' ');
    return $bae90e7f3173eb7e$var$computeCharWordCounts(raw);
};
module.exports["addAnalytics"] = $bae90e7f3173eb7e$export$5bef18c22bfe95d;
module.exports["useFireAIAnalyticsEvent"] = $bae90e7f3173eb7e$export$5098b64908ee530;
module.exports["isErrorStepAttributes"] = $bae90e7f3173eb7e$export$1256d4293be5e625;
module.exports["fireButtonViewedAnalyticsEvent"] = $bae90e7f3173eb7e$export$2cdad03d12648c8e;
module.exports["rangeCharWordCount"] = $bae90e7f3173eb7e$export$980a72be63484695;
module.exports["selectionCharWordCount"] = $bae90e7f3173eb7e$export$a78a3dabcec86737;

});

parcelRegister("kEjH6", function(module, exports) {

var $kuJJh = parcelRequire("kuJJh");


var $3Bmdi = parcelRequire("3Bmdi");

const $36f0188d14629762$export$625aacfa684c775d = ({ from: from, to: to })=>(tr)=>{
        return tr.setMeta((0, $3Bmdi.aiAnnotationWatchmenPluginKey), {
            action: (0, $kuJJh.ACTIONS).START_WATCHING_REGION,
            from: from,
            to: to
        });
    };
const $36f0188d14629762$export$3047f3abb1985cb0 = (tr)=>{
    return tr.setMeta((0, $3Bmdi.aiAnnotationWatchmenPluginKey), {
        action: (0, $kuJJh.ACTIONS).END_WATCHING_REGION
    });
};
module.exports["startWatchingAnnotationChanges"] = $36f0188d14629762$export$625aacfa684c775d;
module.exports["endWatchingAnnotationChanges"] = $36f0188d14629762$export$3047f3abb1985cb0;

});

parcelRegister("iN8Pe", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $c0d1cde1c0c666c3$export$f6970e69e9507693 = new (0, $kCECX.PluginKey)('aiSessionContext');
module.exports["aiSessionContextPluginKey"] = $c0d1cde1c0c666c3$export$f6970e69e9507693;

});

parcelRegister("80W3l", function(module, exports) {

var $3Zd2B = parcelRequire("3Zd2B");


var $iDrrr = parcelRequire("iDrrr");


var $g8hEw = parcelRequire("g8hEw");


var $ix5ay = parcelRequire("ix5ay");

const $94dffb5172c0fe61$export$a7cd1c3a87df6616 = ({ start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos })=>(tr)=>{
        return tr.setMeta((0, $ix5ay.inEditorDirectStreamingPluginKey), {
            action: (0, $g8hEw.ACTIONS).INIT_POSITIONS,
            positions: {
                startPos: start,
                userContentEndPos: end,
                telepointerPos: telepointerPos
            },
            showHighlight: showHighlight,
            showAIContentHighlight: showAIContentHighlight,
            showTelepointer: showTelepointer
        });
    };
const $94dffb5172c0fe61$export$ce0702981dd140ff = ({ start: start, end: end })=>(tr)=>{
        return tr.setMeta((0, $ix5ay.inEditorDirectStreamingPluginKey), {
            action: (0, $g8hEw.ACTIONS).ADJUST_INIT_POSITIONS,
            positions: {
                startPos: start,
                userContentEndPos: end
            }
        });
    };
const $94dffb5172c0fe61$export$54977414c1e0bf76 = ({ aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream })=>(tr)=>{
        return tr.setMeta((0, $ix5ay.inEditorDirectStreamingPluginKey), {
            action: (0, $g8hEw.ACTIONS).UPDATE_STREAM_POSITIONS,
            positions: {
                aiContentEndPos: aiContentEndPos,
                telepointerPos: telepointerPos
            },
            isFinalStream: isFinalStream
        });
    };
const $94dffb5172c0fe61$export$2786c982b834f104 = (tr)=>{
    return tr.setMeta((0, $ix5ay.inEditorDirectStreamingPluginKey), {
        action: (0, $g8hEw.ACTIONS).UPDATE_LOADING_POSITIONS
    });
};
const $94dffb5172c0fe61$export$7dbd7b4332a8fca6 = (tr)=>{
    return tr.setMeta((0, $ix5ay.inEditorDirectStreamingPluginKey), {
        action: (0, $g8hEw.ACTIONS).END_STREAM
    });
};
const $94dffb5172c0fe61$export$a07eda0a8c017081 = ({ tr: tr, isFinalStream: isFinalStream, stackTime: stackTime, agentAttribution: agentAttribution })=>{
    tr = tr.setMeta('isAIStreamingTransformation', true).setMeta('isAIFinalStreamingTransformation', !!isFinalStream).setMeta('scrollIntoView', false);
    if ((0, $iDrrr.fg)('platform_editor_agentic_step_attribution') && agentAttribution) tr.setMeta((0, $3Zd2B.AGENT_ATTRIBUTION_META), agentAttribution);
    if (stackTime) tr.setTime(stackTime);
    return tr;
};
module.exports["initPositions"] = $94dffb5172c0fe61$export$a7cd1c3a87df6616;
module.exports["adjustInitPositions"] = $94dffb5172c0fe61$export$ce0702981dd140ff;
module.exports["updateStreamPositions"] = $94dffb5172c0fe61$export$54977414c1e0bf76;
module.exports["updateLoadingPositions"] = $94dffb5172c0fe61$export$2786c982b834f104;
module.exports["endStream"] = $94dffb5172c0fe61$export$7dbd7b4332a8fca6;
module.exports["metaTransaction"] = $94dffb5172c0fe61$export$a07eda0a8c017081;

});

parcelRegister("hivdp", function(module, exports) {
function $b5e1f279eaf322a4$export$fc8b8d4530cea304({ $from: $from, $to: $to, schema: schema }) {
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let startMaybeCellNode;
    for(let depth = $from.depth; depth > 0; depth--)if ([
        tableCell,
        tableHeader
    ].includes($from.node(depth).type)) {
        startMaybeCellNode = $from.node(depth);
        break;
    }
    if (!startMaybeCellNode) // Early exit as $from is not in a cell
    return false;
    let endMaybeCellNode;
    for(let depth = $to.depth; depth > 0; depth--)if ([
        tableCell,
        tableHeader
    ].includes($to.node(depth).type)) {
        endMaybeCellNode = $to.node(depth);
        break;
    }
    if (!endMaybeCellNode) // Early exit as $to is not in a cell
    return false;
    return startMaybeCellNode.eq(endMaybeCellNode);
}
function $b5e1f279eaf322a4$export$22042c55165155fc({ resolvedPos: resolvedPos, nodeType: nodeType }) {
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        if (resolvedPos.node(depth).type === nodeType) return depth;
    }
    return;
}
module.exports["isWithinSameCell"] = $b5e1f279eaf322a4$export$fc8b8d4530cea304;
module.exports["getPositionNodeTypeDepth"] = $b5e1f279eaf322a4$export$22042c55165155fc;

});

parcelRegister("277Za", function(module, exports) {

var $3Zd2B = parcelRequire("3Zd2B");


var $iDrrr = parcelRequire("iDrrr");


var $9ybcs = parcelRequire("9ybcs");

var $d3d6e6b439a7000e$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["INIT_POSITIONS"] = "INIT_POSITIONS";
    ACTIONS["ADJUST_INIT_POSITIONS"] = "ADJUST_INIT_POSITIONS";
    ACTIONS["UPDATE_LOADING_POSITIONS"] = "UPDATE_LOADING_POSITIONS";
    ACTIONS["UPDATE_STREAM_POSITIONS"] = "UPDATE_STREAM_POSITIONS";
    ACTIONS["END_STREAM"] = "END_STREAM";
    ACTIONS["SET_USER_HAS_SCROLLED_IN_SESSION"] = "SET_USER_HAS_SCROLLED_IN_SESSION";
    return ACTIONS;
}({});
const $d3d6e6b439a7000e$export$a7cd1c3a87df6616 = ({ start: start, end: end, showHighlight: showHighlight, showAIContentHighlight: showAIContentHighlight, showTelepointer: showTelepointer, telepointerPos: telepointerPos, originalUserContentSlice: originalUserContentSlice, streamStartPos: streamStartPos, sessionId: sessionId })=>(tr)=>{
        return tr.setMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey), {
            action: "INIT_POSITIONS",
            start: start,
            end: end,
            showHighlight: showHighlight,
            showAIContentHighlight: showAIContentHighlight,
            showTelepointer: showTelepointer,
            telepointerPos: telepointerPos,
            originalUserContentSlice: originalUserContentSlice,
            streamStartPos: streamStartPos,
            sessionId: sessionId
        });
    };
const $d3d6e6b439a7000e$export$ce0702981dd140ff = ({ start: start, end: end })=>(tr)=>{
        return tr.setMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey), {
            action: "ADJUST_INIT_POSITIONS",
            start: start,
            end: end
        });
    };
const $d3d6e6b439a7000e$export$2786c982b834f104 = (tr)=>{
    return tr.setMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey), {
        action: "UPDATE_LOADING_POSITIONS"
    });
};
const $d3d6e6b439a7000e$export$54977414c1e0bf76 = ({ aiContentEndPos: aiContentEndPos, telepointerPos: telepointerPos, isFinalStream: isFinalStream, lastProcessedVersion: lastProcessedVersion, aiContentSlice: aiContentSlice, scrollTargetPos: scrollTargetPos, posAdjusted: posAdjusted, startPos: startPos, userContentEndPos: userContentEndPos })=>(tr)=>{
        return tr.setMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey), {
            action: "UPDATE_STREAM_POSITIONS",
            positions: {
                aiContentEndPos: aiContentEndPos,
                telepointerPos: telepointerPos,
                isFinalStream: isFinalStream,
                lastProcessedVersion: lastProcessedVersion,
                aiContentSlice: aiContentSlice,
                scrollTargetPos: scrollTargetPos,
                posAdjusted: posAdjusted,
                startPos: startPos,
                userContentEndPos: userContentEndPos
            }
        });
    };
const $d3d6e6b439a7000e$export$7dbd7b4332a8fca6 = (tr)=>{
    return tr.setMeta((0, $9ybcs.purePmInEditorDirectStreamingPluginKey), {
        action: "END_STREAM"
    });
};
const $d3d6e6b439a7000e$export$a07eda0a8c017081 = ({ tr: tr, isFinalStream: isFinalStream, stackTime: stackTime, agentAttribution: agentAttribution })=>{
    tr = tr.setMeta('isAIStreamingTransformation', true).setMeta('isAIFinalStreamingTransformation', isFinalStream).setMeta('scrollIntoView', false);
    if ((0, $iDrrr.fg)('platform_editor_agentic_step_attribution') && agentAttribution) tr.setMeta((0, $3Zd2B.AGENT_ATTRIBUTION_META), agentAttribution);
    if (stackTime) tr.setTime(stackTime);
    return tr;
};
module.exports["ACTIONS"] = $d3d6e6b439a7000e$export$92a1a3b7554e9387;
module.exports["initPositions"] = $d3d6e6b439a7000e$export$a7cd1c3a87df6616;
module.exports["updateLoadingPositions"] = $d3d6e6b439a7000e$export$2786c982b834f104;
module.exports["updateStreamPositions"] = $d3d6e6b439a7000e$export$54977414c1e0bf76;
module.exports["endStream"] = $d3d6e6b439a7000e$export$7dbd7b4332a8fca6;
module.exports["metaTransaction"] = $d3d6e6b439a7000e$export$a07eda0a8c017081;

});

parcelRegister("iBAu1", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $38476626b2bb4ba2$export$e530ba00b008a680 = new (0, $kCECX.PluginKey)('aiExperienceSelection');
module.exports["selectionPluginKey"] = $38476626b2bb4ba2$export$e530ba00b008a680;

});

parcelRegister("C4yPo", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $cI8RZ = parcelRequire("cI8RZ");


var $8nvEM = parcelRequire("8nvEM");


var $1w4hj = parcelRequire("1w4hj");


var $4TgUg = parcelRequire("4TgUg");


var $9RRio = parcelRequire("9RRio");


var $f4xcc = parcelRequire("f4xcc");


var $dSwlt = parcelRequire("dSwlt");


var $hloAP = parcelRequire("hloAP");

/**
 * This creates a function which is called inside the prosemirror plugin state apply method via the
 * pluginFactory.
 *
 * The docChanged is called for every transaction where the docChanged property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * It takes a dispatchAnalyticsEvent in order to track whether the mapping we use to build a new PluginState
 * is throwing any errors.  This is a temporary measure to track whether we are hitting any edge cases
 * where the mapping is throwing errors. If we find that this is happening, we will revisit the approach
 * to building a new PluginState.
 *
 * The state being built here is used to  from the document used to;
 * - both apply and remove decorations to display the AI modal,
 * - apply decorations following the insertion of AI generated content, to highlight the inserted content (these are removed in the selectionChanged below).
 *
 * In future the intention is to seperate these concerns into seperate plugins.
 */ function $2ba3b9f1f15b02c1$var$onDocChangedModal(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // Check if transaction is from inserting AI generated content for blocks
        const isAiContentTransformationForBlocks = tr.getMeta('isAiContentTransformationForBlocks');
        // Return with generated content decoration for blocks
        if (isAiContentTransformationForBlocks) {
            const newDecorations = (0, $hloAP.getGeneratedNodeDecorationsFromTransaction)(tr);
            if (newDecorations.length) return {
                ...pluginState,
                modalDecorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, newDecorations)
            };
        }
        // Check if transaction is from inserting AI generated content
        const generatedContentMeta = tr.getMeta('isAiContentTransformation');
        // Return with generated content decoration
        if (generatedContentMeta) {
            const newDecoration = (0, $hloAP.getGeneratedDecorationFromTransaction)(tr, pluginState.isInDocumentStreamingEnabled);
            if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
            return {
                ...pluginState,
                modalDecorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, newDecoration)
            };
        }
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $8nvEM.DecorationSet).empty) return pluginState;
        // Check if generated AI decorations already exist
        const hasGeneratedContentDecoration = (0, $dSwlt.hasGeneratedContentDecorations)(pluginState);
        const isRemote = tr.getMeta('isRemote') ?? false;
        /**
		 * Make sure it isn't a selection change from an appendTransaction
		 */ const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
        /**
		 * Remove decorations if
		 * - current user interacts with doc
		 *   - and it is not an appendedTransaction
		 */ if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).empty
        };
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        // return mapped decoration set for case where other users in collab are making changes to doc
        if (hasGeneratedContentDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        // Find the start/inline/end decoration
        const decorations = mappedModalDecorationSet.find();
        let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
        let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
        let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
        const nodeDecoration = decorations.find((d)=>d.spec.key === 'ai-nodeDecoration');
        // AI experience was triggered by quick insert, no start widget or inline decoration
        if (nodeDecoration || endDecoration && !startDecoration && !inlineDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet
        };
        /**
		 * If document change, it will cause inlineDecoration to collapse to same position.
		 * We then won't need the AI model as all content between position has been deleted.
		 */ const inlineDecorationHasContent = !!inlineDecoration && inlineDecoration.from !== inlineDecoration.to;
        // Return with no decorations if inline decoration does not exist
        // Handles edge case where the inline decoration can't be deleted at the start
        // of a doc even when it has no content
        // OR if it has no content (eg. selection is just empty paragraphs)
        if (!inlineDecoration || !inlineDecorationHasContent) return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).empty
        };
        // Handle the case where doc changes move inlineDecoration to position 0
        // We cannot add text before inline decoration if from position is 0
        // Remove and recreate inline decoration starting at position 1
        if (inlineDecoration.from === 0) inlineDecoration = (0, $4TgUg.createInlineDecoration)(inlineDecoration.from || 1, inlineDecoration.to || 1);
        // Create and add start widget into DecorationSet if it's been deleted
        if (!startDecoration) startDecoration = (0, $4TgUg.createWidgetDecoration)(pluginState.isInDocumentStreamingEnabled)(inlineDecoration.from, 'start');
        // Create and add end widget into DecorationSet if it doesn't exist
        if (!endDecoration) endDecoration = (0, $4TgUg.createWidgetDecoration)(pluginState.isInDocumentStreamingEnabled)(inlineDecoration.to, 'end');
        return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, [
                startDecoration,
                inlineDecoration,
                endDecoration
            ])
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).empty
        };
    }
}
function $2ba3b9f1f15b02c1$var$onDocChangedStreaming(tr, pluginState) {
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pluginState;
    // In some collab edge cases mapping decorations could throw an error
    // The ProseMirror .mapping approach has a “dangerous” axiom:
    // Besides the initial state, a document will always “change” through a Transaction
    // However, in some conditions we may reconfigure the EditorState, and a new document
    // will be created without a transaction.
    // This try/catch intends to track cases of this happening and see if it impacts users
    try {
        // If there is no existing modal decoration -- exit early
        if (pluginState.modalDecorationSet === (0, $8nvEM.DecorationSet).empty) {
            if (!!pluginState.ignoredSpaceTriggerSelection) return {
                ...pluginState,
                ignoredSpaceTriggerSelection: undefined
            };
            return pluginState;
        }
        // Map the modal decorationSet against the transaction
        const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
        const decorations = mappedModalDecorationSet.find();
        const modalRangeMountPointDecorations = decorations.find((d)=>d.spec.key === 'modalMountPointRangeDecoration');
        const modalMountPointDecoration = decorations.find((d)=>d.spec.key === 'modalMountPointDecoration');
        if (modalMountPointDecoration) return {
            ...pluginState,
            modalDecorationSet: mappedModalDecorationSet,
            ignoredSpaceTriggerSelection: undefined
        };
        const hasRange = modalRangeMountPointDecorations && modalRangeMountPointDecorations.from !== modalRangeMountPointDecorations.to;
        // If there is no modal mount point decoration, we need to create one
        const appendedTransaction = tr.getMeta('appendedTransaction');
        if (tr.getMeta('isAIStreamingTransformation') || appendedTransaction && appendedTransaction.getMeta('isAIStreamingTransformation')) return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, [
                ...decorations,
                (0, $4TgUg.createModalMountPointDecoration)(Math.max(1, Math.min(tr.doc.content.size, tr.steps[0].to)), tr.doc)
            ]),
            ignoredSpaceTriggerSelection: undefined
        };
        else if (hasRange) return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).create(tr.doc, [
                ...decorations,
                (0, $4TgUg.createModalMountPointDecoration)(Math.max(1, Math.min(tr.doc.content.size, modalRangeMountPointDecorations.to)), tr.doc)
            ]),
            ignoredSpaceTriggerSelection: undefined
        };
        return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).empty,
            ignoredSpaceTriggerSelection: undefined
        };
    } catch (error) {
        const analyticsPayload = {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'decorationPluginFactory',
            attributes: {
                errorType: 'handleDocChangedError',
                errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error)
            },
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
        };
        dispatchAnalyticsEvent(analyticsPayload);
        return {
            ...pluginState,
            modalDecorationSet: (0, $8nvEM.DecorationSet).empty,
            ignoredSpaceTriggerSelection: undefined
        };
    }
}
function $2ba3b9f1f15b02c1$var$onDocChanged(tr, pluginState) {
    if (pluginState.isInDocumentStreamingEnabled) return $2ba3b9f1f15b02c1$var$onDocChangedStreaming(tr, pluginState);
    return $2ba3b9f1f15b02c1$var$onDocChangedModal(tr, pluginState);
}
/**
 * This function is called inside the prosemirror plugin state apply method via the pluginFactory.
 *
 * The docChanged is called for every transaction where the selectionSet property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * The state transformation here is being used to remove the decorations that are added when the AI experience has inserted content.
 *
 * These are added inside docChanged above.
 *
 * In future the intention is to seperate this concerns into seperate plugin (currently the majority of this file is dealing
 * with decorations related to the presentation of a modal for the AI experience).
 */ function $2ba3b9f1f15b02c1$var$onSelectionChanged(_tr, pluginState) {
    if (pluginState.modalDecorationSet === (0, $8nvEM.DecorationSet).empty || pluginState.configItem) return pluginState;
    if ((0, $dSwlt.hasGeneratedContentDecorations)(pluginState)) return {
        ...pluginState,
        modalDecorationSet: (0, $8nvEM.DecorationSet).empty
    };
    return pluginState;
}
// if in the future we need to map other state, we can rename this to mappingInitialPositions
// and add another mapping function for the other state
// this is to avoid having a single function that does too many things
function $2ba3b9f1f15b02c1$var$mapping(tr, pluginState) {
    const { initialPositions: initialPositions } = pluginState;
    if (!initialPositions) return pluginState;
    // do not map initial positions for streaming transactions
    // because after mapping, they are not initial positions anymore
    // but we do need to map the initial positions for non-streaming remote transactions
    if (pluginState.isInDocumentStreamingEnabled) {
        const appendedTransaction = tr.getMeta('appendedTransaction');
        if (tr.getMeta('isAIStreamingTransformation') || appendedTransaction && appendedTransaction.getMeta('isAIStreamingTransformation')) return pluginState;
    }
    const mappedInitialPositions = [
        tr.mapping.map(initialPositions[0]),
        tr.mapping.map(initialPositions[1])
    ];
    if (mappedInitialPositions[0] === initialPositions[0] && mappedInitialPositions[1] === initialPositions[1]) return pluginState;
    return {
        ...pluginState,
        initialPositions: mappedInitialPositions
    };
}
const $2ba3b9f1f15b02c1$export$de5e90bd767c5d82 = (dispatchAnalyticsEvent, isInDocumentStreamingEnabled, product)=>(state)=>{
        return {
            isRunning: false,
            /**
			 * Longer term it would be good to expand the decorationset to include
			 * the entire selection, as well as the 'valid inline position' to place
			 * an inline widget visualising start+end of valid selections
			 */ modalDecorationSet: (0, $8nvEM.DecorationSet).empty,
            dispatchAnalyticsEvent: /**
			 * This takes a dispatchAnalyticsEvent in order to support firing analytics events in case
			 * mapping logic used in the onDocChanged passed to the pluginFactory throws an error.
			 */ dispatchAnalyticsEvent,
            isInDocumentStreamingEnabled: isInDocumentStreamingEnabled,
            product: product
        };
    };
const $2ba3b9f1f15b02c1$var$dest = (0, $cI8RZ.pluginFactory)((0, $9RRio.aiExperienceDecorationPluginKey), (0, $f4xcc.reducer), {
    mapping: $2ba3b9f1f15b02c1$var$mapping,
    onDocChanged: $2ba3b9f1f15b02c1$var$onDocChanged,
    onSelectionChanged: $2ba3b9f1f15b02c1$var$onSelectionChanged
});
const $2ba3b9f1f15b02c1$export$656c7661095efe2e = $2ba3b9f1f15b02c1$var$dest.createPluginState;
const $2ba3b9f1f15b02c1$export$8d4021544bdece00 = $2ba3b9f1f15b02c1$var$dest.createCommand;
const $2ba3b9f1f15b02c1$export$f05434c51e3762e = $2ba3b9f1f15b02c1$var$dest.getPluginState;
module.exports["createInitialState"] = $2ba3b9f1f15b02c1$export$de5e90bd767c5d82;
module.exports["createPluginState"] = $2ba3b9f1f15b02c1$export$656c7661095efe2e;
module.exports["createCommand"] = $2ba3b9f1f15b02c1$export$8d4021544bdece00;
module.exports["getPluginState"] = $2ba3b9f1f15b02c1$export$f05434c51e3762e;

});

parcelRegister("jtPcJ", function(module, exports) {

var $9XB2W = parcelRequire("9XB2W");


var $9qe1v = parcelRequire("9qe1v");

function $e9b792e28481d460$export$acd864b9a56191f6({ editorView: editorView, pmFragment: pmFragment, isFinal: isFinal, fireUnifiedAnalyticsEvent: fireUnifiedAnalyticsEvent }) {
    const fragmentToInsert = pmFragment;
    let textContent = '';
    fragmentToInsert.forEach((node)=>{
        textContent += node.textContent;
    });
    const confluenceTitle = document.querySelector('textarea[data-ai-suggest-title-target="true"]');
    if (confluenceTitle) {
        const sourceEditorId = (0, $9qe1v.findEditorIdFromView)(editorView);
        if (sourceEditorId) {
            (0, $9XB2W.eventHub).publishFromEditor({
                event: 'replace title in confluence',
                data: {
                    analyticSourceId: 'confluenceTitleToolbar',
                    sourceEditorId: sourceEditorId,
                    title: textContent,
                    ...isFinal !== undefined && {
                        isFinal: isFinal
                    },
                    ...fireUnifiedAnalyticsEvent && {
                        fireUnifiedAnalyticsEvent: fireUnifiedAnalyticsEvent
                    }
                }
            });
            confluenceTitle.scrollIntoView({
                block: 'nearest'
            });
        }
    }
}
module.exports["replaceConfluenceTitle"] = $e9b792e28481d460$export$acd864b9a56191f6;

});

parcelRegister("9qe1v", function(module, exports) {
const $d7e726027aca472b$export$700cb401385d6bf2 = (editorView)=>{
    return editorView.dom?.dataset?.editorId;
};
module.exports["findEditorIdFromView"] = $d7e726027aca472b$export$700cb401385d6bf2;

});

parcelRegister("8F1y0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::903316e1daf2f6c27f61b3f789affb4b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64e35a5af7007116$var$_react = $64e35a5af7007116$var$_interopRequireDefault((parcelRequire("cozmU")));

var $64e35a5af7007116$var$_baseNew = $64e35a5af7007116$var$_interopRequireDefault((parcelRequire("gElAV")));
function $64e35a5af7007116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextConclusionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-conclusion-add
 * Usage guidance:
 * Confluence Editor AI action for generating a conclusion
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64e35a5af7007116$var$TextConclusionAddIcon = (props)=>/*#__PURE__*/ $64e35a5af7007116$var$_react.default.createElement($64e35a5af7007116$var$_baseNew.default, Object.assign({
        name: "TextConclusionAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 6.5H1V5h14zm0-4H1V1h14z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 11a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m0 4a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M4.88 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.87-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M8 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5m3.88-4.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m2.37.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"/>`
    }, props));
$64e35a5af7007116$var$TextConclusionAddIcon.displayName = 'TextConclusionAddIcon';
var $64e35a5af7007116$var$_default = module.exports.default = $64e35a5af7007116$var$TextConclusionAddIcon;

});

parcelRegister("3AeSY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b31f3d5a2e1071b2b74eca826f1e1bd9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29c047e3bbffe4aa$var$_react = $29c047e3bbffe4aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $29c047e3bbffe4aa$var$_baseNew = $29c047e3bbffe4aa$var$_interopRequireDefault((parcelRequire("gElAV")));
function $29c047e3bbffe4aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextIntroductionAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-introduction-add
 * Usage guidance:
 * Confluence Editor AI action for generating an introduction
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $29c047e3bbffe4aa$var$TextIntroductionAddIcon = (props)=>/*#__PURE__*/ $29c047e3bbffe4aa$var$_react.default.createElement($29c047e3bbffe4aa$var$_baseNew.default, Object.assign({
        name: "TextIntroductionAddIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 9.5H1V11h14zm-7 4H1V15h7z" clip-rule="evenodd"/><path fill="currentcolor" d="M1.75 5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m0-4a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M4.88 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5m3.87 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M8 1a.75.75 0 1 1 0 1.5A.75.75 0 0 1 8 1m3.88 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M11.13 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5M15 5.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M14.25 1a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5"/>`
    }, props));
$29c047e3bbffe4aa$var$TextIntroductionAddIcon.displayName = 'TextIntroductionAddIcon';
var $29c047e3bbffe4aa$var$_default = module.exports.default = $29c047e3bbffe4aa$var$TextIntroductionAddIcon;

});

parcelRegister("7qHrr", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8tXCb = parcelRequire("8tXCb");


var $euISL = parcelRequire("euISL");

var $is9bZ = parcelRequire("is9bZ");

var $hZ5o2 = parcelRequire("hZ5o2");


var $7SvWS = parcelRequire("7SvWS");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $iDrrr = parcelRequire("iDrrr");


var $mW7G5 = parcelRequire("mW7G5");


var $1w4hj = parcelRequire("1w4hj");


var $hloAP = parcelRequire("hloAP");


var $doWyc = parcelRequire("doWyc");


var $hZdqw = parcelRequire("hZdqw");

function $a8a64c2a4ad5b205$export$6dd1ce1e3de92002(tr, transformer) {
    if (!(0, $mW7G5.expVal)('cc-maui-experiment', 'isEnabled', false) || !transformer) return false;
    const schema = tr.doc.type.schema;
    const replacements = [];
    // Scope the walk to only the inserted range (derived from the transaction's
    // step mappings) so that pre-existing nodes elsewhere in the document are
    // not accidentally transformed — e.g. paragraphs containing a single
    // hyperlink being converted into native embeds.
    const stepRange = (0, $7SvWS.getStepRange)(tr);
    if (!stepRange) return false;
    const from = Math.max(0, stepRange.from);
    const to = Math.min(tr.doc.content.size, stepRange.to);
    if (from >= to) return false;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        try {
            const transformed = transformer(schema, node);
            if (transformed) {
                transformed.check();
                replacements.push({
                    pos: pos,
                    node: transformed,
                    size: node.nodeSize
                });
                return false;
            }
        } catch  {
        // If transformer throws or produces an invalid node, keep the original
        }
        return true;
    });
    // Apply replacements in reverse order to preserve positions
    for(let i = replacements.length - 1; i >= 0; i--){
        const { pos: pos, node: node, size: size } = replacements[i];
        tr.replaceWith(pos, pos + size, node);
    }
    return replacements.length > 0;
}
function $a8a64c2a4ad5b205$export$336eb673e6d24058(tr, editorState, insertedContentNodeTransformer) {
    /**
	 * DO NOT REMOVE isAiContentTransformation from transaction meta.
	 * Proactive AI S+G rely on isAiContentTransformation meta to
	 * 	ignore changes in document made by AI modal.
	 * Why ignore it?
	 * - Response returned from AI does not require Spelling and Grammar check.
	 * - We have assumed that it's already correct from S+G perspective.
	 */ tr.setMeta('isAiContentTransformation', true);
    const firstReplaceStep = (0, $hloAP.findFirstReplaceStep)(tr.steps);
    if (!firstReplaceStep) {
        // Ideally we should always have replace step for for AI transaction.
        // But in case if there isn't we want to fire analytic event so we can monitor it.
        (0, $hZdqw.addAnalytics)({
            editorState: editorState,
            tr: tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'experienceApplication',
                attributes: {
                    errorType: 'replaceStepNotFound'
                },
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
            }
        });
        return tr;
    }
    const validPositionToSet = (0, $hloAP.getValidEndTextPosition)({
        step: firstReplaceStep,
        doc: tr.doc
    });
    if (validPositionToSet !== 0) tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, validPositionToSet));
    if (insertedContentNodeTransformer) $a8a64c2a4ad5b205$export$6dd1ce1e3de92002(tr, insertedContentNodeTransformer);
    return tr;
}
function $a8a64c2a4ad5b205$export$7b46ef9a312ebccb(fragment, tr, state) {
    const supportedNodeTypes = (0, $doWyc.getSupportedNodesForAIModal)(state);
    // Here we are checking if there is text node at first level.
    // Then we will highlight all nodes.
    let areTopLevelBlockElements = true;
    fragment.forEach((node)=>{
        areTopLevelBlockElements = areTopLevelBlockElements && supportedNodeTypes.has(node.type);
    });
    if (areTopLevelBlockElements) return tr.setMeta('isAiContentTransformationForBlocks', true);
    return tr;
}
function $a8a64c2a4ad5b205$export$cfdd8b8691129358(tr) {
    /**
	 * DO NOT REMOVE
	 * This is used when distinguishing content generated by a Rovo agent
	 */ tr.setMeta('isAiRovoAgentContentTransformation', true);
    return tr;
}
function $a8a64c2a4ad5b205$var$getLastContentDepth({ pmFragment: pmFragment }) {
    let depth = 0;
    let currentNode = pmFragment;
    while(currentNode.firstChild){
        depth++;
        currentNode = currentNode.firstChild;
    }
    return depth;
}
function $a8a64c2a4ad5b205$var$isSelectionAtParagraphStart($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function $a8a64c2a4ad5b205$var$isFragmentSingleParagraph(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function $a8a64c2a4ad5b205$var$isSelectionInTaskOrDecisionNode($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}
function $a8a64c2a4ad5b205$export$f00c638dfda8b9e2({ selection: selection, tableSchema: tableSchema }) {
    const parentTableCount = (0, $euISL.getParentOfTypeCount)(tableSchema)(selection.$from);
    const hasParentTable = (0, $bjg0G.hasParentNodeOfType)(tableSchema)(selection);
    return hasParentTable && parentTableCount > 1;
}
const $a8a64c2a4ad5b205$export$a6a8eefd91a14ea5 = ({ pmFragment: pmFragment, transaction: transaction })=>{
    const tableSchema = transaction.doc.type.schema.nodes.table;
    const fromPos = transaction.selection.$from;
    const positionAfterTopTable = (0, $is9bZ.getPositionAfterTopParentNodeOfType)(tableSchema)(fromPos);
    return (0, $bjg0G.safeInsert)(pmFragment, positionAfterTopTable)(transaction);
};
const $a8a64c2a4ad5b205$export$841048b11479358 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, insertedContentNodeTransformer: insertedContentNodeTransformer })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const slice = pmFragment.size === 0 ? (0, $aPdNQ.Slice).empty : new (0, $aPdNQ.Slice)(pmFragment, 0, 0);
    if (pmFragment.size === 0) transaction = (0, $hZdqw.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: true,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    try {
        // If you can't replace the range, use safeInsert
        transaction = transaction.replaceRange(positions[0], positions[1], slice);
    } catch (error) {
        // If you can't replace the range, use safeInsert
        transaction = (0, $bjg0G.safeInsert)(pmFragment, undefined, true)((0, $hZdqw.addAnalytics)({
            editorState: state,
            tr: transaction,
            payload: {
                action: 'fallback',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'proseMirrorReplace',
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    target: 'replaceWithAIContentForBlock',
                    isSelectionEmpty: positions[0] === positions[1],
                    errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error),
                    isReplacementEmpty: pmFragment.size === 0
                }
            }
        }));
    }
    return $a8a64c2a4ad5b205$export$336eb673e6d24058($a8a64c2a4ad5b205$export$7b46ef9a312ebccb(pmFragment, transaction, state), state, insertedContentNodeTransformer);
};
const $a8a64c2a4ad5b205$export$60bccdedcf767536 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, selectionMetaData: selectionMetaData, insertedContentNodeTransformer: insertedContentNodeTransformer, options: options = {
    replaceDocOnEmptySelection: true
} })=>{
    const { state: state } = editorView;
    let transaction = state.tr;
    const endPositionDepth = state.doc.resolve(positions[1]).depth;
    const lastFragmentDepth = $a8a64c2a4ad5b205$var$getLastContentDepth({
        pmFragment: pmFragment
    });
    // selectionMetaData will always be undefined when adf streaming is disabled
    let sliceOpenStart = selectionMetaData?.sliceOpenStart || 1;
    let sliceOpenEnd = selectionMetaData?.sliceOpenEnd || Math.min(endPositionDepth, lastFragmentDepth);
    // if we're inserting a single empty block node, the slice openStart and openEnd should be 0
    // otherwise, if either openStart or openEnd is >=1, there will be no child nodes inserted
    if (pmFragment.childCount === 1 && pmFragment.firstChild?.isBlock && !pmFragment.firstChild.firstChild && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
        sliceOpenStart = 0;
        sliceOpenEnd = 0;
    }
    const slice = pmFragment.size === 0 ? (0, $aPdNQ.Slice).empty : new (0, $aPdNQ.Slice)(pmFragment, sliceOpenStart, sliceOpenEnd);
    if (pmFragment.size === 0) transaction = (0, $hZdqw.addAnalytics)({
        editorState: state,
        tr: transaction,
        payload: {
            action: 'fallback',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'replaceWithEmptyAIContent',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                isBlock: false,
                isSelectionEmpty: positions[0] === positions[1]
            }
        }
    });
    if ((0, $8tXCb.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $a8a64c2a4ad5b205$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $hZ5o2.isNestedTablesSupported)(state.schema)) return $a8a64c2a4ad5b205$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else {
        // We check if the positions are the same if so we replace the whole document
        // This is a quick spike so real implementation might need to be different
        // You might need to create a new replace action
        if (options.replaceDocOnEmptySelection && positions[0] === positions[1]) transaction = transaction.replaceRange(0, state.doc.content.size, slice);
        else try {
            transaction = transaction.replaceRange(positions[0], positions[1], slice);
        // If you can't replace the range, use safeInsert
        } catch (error) {
            transaction = (0, $bjg0G.safeInsert)(pmFragment, undefined, true)((0, $hZdqw.addAnalytics)({
                editorState: state,
                tr: transaction,
                payload: {
                    action: 'fallback',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'proseMirrorReplace',
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        target: 'replaceWithAIContent',
                        isSelectionEmpty: positions[0] === positions[1],
                        errorMessage: (0, $1w4hj.ErrorUtils).extractErrorMessage(error),
                        isReplacementEmpty: pmFragment.size === 0
                    }
                }
            }));
        }
        return $a8a64c2a4ad5b205$export$336eb673e6d24058(transaction, state, insertedContentNodeTransformer);
    }
};
const $a8a64c2a4ad5b205$export$7dc11dddc9c93a89 = ({ editorView: editorView, positions: positions, pmFragment: pmFragment, insertedContentNodeTransformer: insertedContentNodeTransformer })=>{
    const { state: state } = editorView;
    const transaction = state.tr;
    // when it's node selection and other similar situations
    // we should use positions[1] instead of positions[0]
    // to make the inserted content after the current node
    const pos = (0, $iDrrr.fg)('platform_editor_ai_remix_in_editor_loading') ? positions[1] : positions[0];
    const $pos = state.doc.resolve(pos);
    const isParagraphStart = $a8a64c2a4ad5b205$var$isSelectionAtParagraphStart($pos);
    // if selection is at the beginning of paragraph,
    // insert before the cursor so that it inserts without an extra new line
    const insertPos = isParagraphStart ? pos - 1 : pos;
    // if selection is inside decision or task node AND pmFragment is a single paragraph
    // strip the paragraph so it can insert inside the decision/task
    let fragmentToInsert = pmFragment;
    if ($a8a64c2a4ad5b205$var$isSelectionInTaskOrDecisionNode($pos) && $a8a64c2a4ad5b205$var$isFragmentSingleParagraph(pmFragment)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragmentToInsert = pmFragment.firstChild.content;
    if ((0, $8tXCb.fragmentContainsNodeType)(pmFragment, transaction.doc.type.schema.nodes.table) && $a8a64c2a4ad5b205$export$f00c638dfda8b9e2({
        selection: transaction.selection,
        tableSchema: transaction.doc.type.schema.nodes.table
    }) && (0, $hZ5o2.isNestedTablesSupported)(state.schema)) return $a8a64c2a4ad5b205$export$a6a8eefd91a14ea5({
        pmFragment: pmFragment,
        transaction: transaction
    });
    else return $a8a64c2a4ad5b205$export$336eb673e6d24058(transaction.insert(insertPos, fragmentToInsert), state, insertedContentNodeTransformer);
};
module.exports["beforeDispatchAITransaction"] = $a8a64c2a4ad5b205$export$336eb673e6d24058;
module.exports["beforeDispatchingTransactionForBlocks"] = $a8a64c2a4ad5b205$export$7b46ef9a312ebccb;
module.exports["beforeDispatchAIRovoAgentTransaction"] = $a8a64c2a4ad5b205$export$cfdd8b8691129358;
module.exports["shouldInsertAfterTable"] = $a8a64c2a4ad5b205$export$f00c638dfda8b9e2;
module.exports["insertContentAfterTable"] = $a8a64c2a4ad5b205$export$a6a8eefd91a14ea5;
module.exports["replaceWithAIContentForBlock"] = $a8a64c2a4ad5b205$export$841048b11479358;
module.exports["replaceWithAIContent"] = $a8a64c2a4ad5b205$export$60bccdedcf767536;
module.exports["insertAIContentAtCurrentPosition"] = $a8a64c2a4ad5b205$export$7dc11dddc9c93a89;

});

parcelRegister("eLVjp", function(module, exports) {

var $cI8RZ = parcelRequire("cI8RZ");


var $4xV3u = parcelRequire("4xV3u");


var $cRnaz = parcelRequire("cRnaz");

const $a41b2330e374cff3$var$dest = (0, $cI8RZ.pluginFactory)((0, $4xV3u.rovoAgentsPluginKey), (0, $cRnaz.reducer));
const $a41b2330e374cff3$export$656c7661095efe2e = $a41b2330e374cff3$var$dest.createPluginState;
const $a41b2330e374cff3$export$8d4021544bdece00 = $a41b2330e374cff3$var$dest.createCommand;
const $a41b2330e374cff3$export$a5538d14da6605ff = (state)=>{
    const pluginState = (0, $4xV3u.rovoAgentsPluginKey).getState(state);
    return pluginState;
};
module.exports["createPluginState"] = $a41b2330e374cff3$export$656c7661095efe2e;
module.exports["createCommand"] = $a41b2330e374cff3$export$8d4021544bdece00;
module.exports["getRovoAgentsPluginState"] = $a41b2330e374cff3$export$a5538d14da6605ff;

});

parcelRegister("lVanm", function(module, exports) {
var $916ee405fc31e980$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $916ee405fc31e980$export$92a1a3b7554e9387;

});

parcelRegister("amP3t", function(module, exports) {
var $277c2d08807bb0a6$export$ae8cf7712eb9509e = /*#__PURE__*/ function(AI_SUGGESTION_TRIGGERED_FROM) {
    AI_SUGGESTION_TRIGGERED_FROM["ENTER_BUTTON"] = "enterKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["TAB_BUTTON"] = "tabKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["ESCAPE_BUTTON"] = "escapeKeydown";
    AI_SUGGESTION_TRIGGERED_FROM["TOOLBAR"] = "toolbar";
    return AI_SUGGESTION_TRIGGERED_FROM;
}({});
module.exports["AI_SUGGESTION_TRIGGERED_FROM"] = $277c2d08807bb0a6$export$ae8cf7712eb9509e;

});

parcelRegister("35sTx", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $eEdSM = parcelRequire("eEdSM");


var $6U6f6 = parcelRequire("6U6f6");


var $gCEOR = parcelRequire("gCEOR");

const $3d70c6d0eb3f70bd$var$getInlineSuggestionDetails = (state)=>{
    const pluginState = (0, $6U6f6.getPluginState)(state);
    const { inlineSuggestion: inlineSuggestion, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = pluginState;
    return {
        matchedFormat: inlineSuggestion?.type === 'date' ? inlineSuggestion?.metadata.matchedFormat : undefined,
        suggestionType: inlineSuggestion?.type,
        locale: locale,
        inlineSuggestionSessionId: inlineSuggestionSessionId
    };
};
const $3d70c6d0eb3f70bd$var$getInlineSuggestionInsertPayload = ({ state: state, triggeredFrom: triggeredFrom })=>{
    const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $3d70c6d0eb3f70bd$var$getInlineSuggestionDetails(state);
    return {
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        action: (0, $krYZG.ACTION).SUGGESTION_INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
        attributes: {
            locale: locale,
            suggestionType: suggestionType,
            triggeredFrom: triggeredFrom,
            matchedFormat: matchedFormat,
            inlineSuggestionSessionId: inlineSuggestionSessionId
        }
    };
};
const $3d70c6d0eb3f70bd$export$d09baef8b6358b47 = (analyticsApi)=>(triggeredFrom)=>{
        /* This is a "curry" function to fire 2 events
		 * The reason we fire 2 so that we can track the suggestion inserted event
		 * and also the document event (wider editor analytics) for the date suggestion
		 */ const insertInlineSuggestionWithAnalyticsCommand = (0, $eEdSM.withAnalytics)(analyticsApi, (state)=>{
            return $3d70c6d0eb3f70bd$var$getInlineSuggestionInsertPayload({
                state: state,
                triggeredFrom: triggeredFrom
            });
        })((0, $gCEOR.insertInlineSuggestion)());
        return (0, $eEdSM.withAnalytics)(analyticsApi, ()=>{
            return {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DATE,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).INLINE_SUGGESTION_FLOATING_TB
                }
            };
        })(insertInlineSuggestionWithAnalyticsCommand);
    };
const $3d70c6d0eb3f70bd$export$be54d64153cbf00c = (analyticsApi)=>(triggeredFrom)=>(0, $eEdSM.withAnalytics)(analyticsApi, (state)=>{
            const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $3d70c6d0eb3f70bd$var$getInlineSuggestionDetails(state);
            return {
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                action: (0, $krYZG.ACTION).SUGGESTION_DISMISSED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
                attributes: {
                    locale: locale,
                    suggestionType: suggestionType,
                    triggeredFrom: triggeredFrom,
                    matchedFormat: matchedFormat,
                    inlineSuggestionSessionId: inlineSuggestionSessionId
                }
            };
        })((0, $gCEOR.clearSuggestion)());
const $3d70c6d0eb3f70bd$var$getNewSuggestionAnalytics = ()=>{
    return ({ analyticsApi: analyticsApi, state: state })=>{
        const { matchedFormat: matchedFormat, suggestionType: suggestionType, locale: locale, inlineSuggestionSessionId: inlineSuggestionSessionId } = $3d70c6d0eb3f70bd$var$getInlineSuggestionDetails(state);
        analyticsApi?.fireAnalyticsEvent({
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            action: (0, $krYZG.ACTION).SUGGESTION_VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR_PLUGIN_AI,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).AI_INLINE_SUGGESTION,
            attributes: {
                matchedFormat: matchedFormat,
                suggestionType: suggestionType,
                locale: locale,
                inlineSuggestionSessionId: inlineSuggestionSessionId
            }
        });
    };
};
const $3d70c6d0eb3f70bd$export$5029d42449df706e = $3d70c6d0eb3f70bd$var$getNewSuggestionAnalytics();
module.exports["insertInlineSuggestionWithAnalytics"] = $3d70c6d0eb3f70bd$export$d09baef8b6358b47;
module.exports["clearSuggestionWithAnalytics"] = $3d70c6d0eb3f70bd$export$be54d64153cbf00c;
module.exports["fireNewSuggestionAnalytics"] = $3d70c6d0eb3f70bd$export$5029d42449df706e;

});

parcelRegister("8Qy96", function(module, exports) {

var $kmQhR = parcelRequire("kmQhR");


var $8nvEM = parcelRequire("8nvEM");


var $gCEOR = parcelRequire("gCEOR");


var $6U6f6 = parcelRequire("6U6f6");


var $lxBhG = parcelRequire("lxBhG");


var $lr0VR = parcelRequire("lr0VR");

class $f9efea4032a61ab2$export$3582487b0804e1f6 {
    detectFirstSuggestion(state, cursorPhrases) {
        for (const handler of this.handlers){
            const match = handler.detect(state, cursorPhrases);
            if (match) {
                const node = handler.createReplacement(match, state.schema);
                return {
                    ...match,
                    suggestedNode: node
                };
            }
        }
        return null;
    }
    scheduleScanForSuggestions(view) {
        this.throttledDetection(view);
    }
    cancelSuggestionScans() {
        this.throttledDetection.cancel();
    }
    createMarkerDecoration(marker) {
        const addClass = $f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES[marker.style];
        const decoClass = [
            marker.cssClass,
            addClass
        ].filter(Boolean).join(' ');
        return (0, $8nvEM.Decoration).inline(marker.from, marker.to, {
            class: decoClass.trim()
        });
    }
    /**
   * Creates an inline decoration whose DOM element serves as a positioning
   * anchor for the Suggestion popup (i.e. the floating toolbar).
   */ createToolbarDecoration(from, to) {
        return (0, $8nvEM.Decoration).inline(from, to, {
            class: $f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.toolbarAnchor
        });
    }
    createCompletionHintDecorations(suggestion, state) {
        const handler = this.handlers.find((handler)=>handler.type === suggestion.type);
        if (handler && handler.createCompletionHint) {
            const hint = handler.createCompletionHint(suggestion, state);
            if (hint) return [
                (0, $8nvEM.Decoration).widget(suggestion.to, ()=>{
                    const container = document.createElement('span');
                    container.className = [
                        $f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.completionHint,
                        $f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.underline,
                        $f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES.highlight
                    ].join(' ');
                    const textSpan = document.createElement('span');
                    textSpan.textContent = hint.hintText;
                    container.appendChild(textSpan);
                    return container;
                }, {
                    side: 1,
                    type: $f9efea4032a61ab2$export$3582487b0804e1f6.DECORATION_TYPES.completionHint
                })
            ];
        }
        return [];
    }
    rebuildSuggestionDecorations(suggestion, state, prevDecoSet) {
        if (!suggestion) return (0, $8nvEM.DecorationSet).empty;
        const regionDecos = prevDecoSet.find(suggestion.from, suggestion.to);
        const cleanSet = prevDecoSet.remove(regionDecos);
        const handler = this.handlers.find((handler)=>handler.type === suggestion.type);
        if (!handler) return cleanSet;
        const markers = handler.createMarkers(suggestion, state);
        const markerDecos = markers.map((marker)=>this.createMarkerDecoration(marker));
        const toolbarDeco = this.createToolbarDecoration(suggestion.from, suggestion.to);
        const newDecos = [
            ...markerDecos,
            toolbarDeco
        ];
        const hintDecos = this.createCompletionHintDecorations(suggestion, state);
        newDecos.push(...hintDecos);
        return cleanSet.add(state.doc, newDecos);
    }
    constructor(){
        this.THROTTLE_MS = 100;
        this.handlers = [
            (0, $lxBhG.dateSuggestionHandler)
        ];
        this.throttledDetection = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((view)=>{
            try {
                const { state: state, dispatch: dispatch } = view;
                const pluginState = (0, $6U6f6.getPluginState)(state);
                const prevSug = pluginState.inlineSuggestion;
                const prevDecos = pluginState.decorationSet;
                const cursorPhrases = (0, $lr0VR.TextPhraseExtractor).getTextPhrasesAroundCursor(state);
                const currSug = this.detectFirstSuggestion(state, cursorPhrases);
                const isNoSuggestionChange = prevSug === null && currSug === null;
                if (isNoSuggestionChange) return;
                const updatedDecos = this.rebuildSuggestionDecorations(currSug, state, prevDecos);
                (0, $gCEOR.updateInlineSuggestion)(currSug, updatedDecos)(state, dispatch);
            } catch (err) {
            // HOT-118204: swallow uncaught errors for now to prevent collab catchup failures
            }
        }, this.THROTTLE_MS, {
            leading: false,
            trailing: true
        });
    }
}
$f9efea4032a61ab2$export$3582487b0804e1f6.INLINE_SUGGESTION_DECORATION_CLASSES = {
    underline: 'proactive-ai-inline-suggestion-underline',
    highlight: 'proactive-ai-inline-suggestion-highlight',
    toolbarAnchor: 'proactive-ai-inline-suggestion-floating-toolbar-anchor',
    completionHint: 'proactive-ai-inline-suggestion-completion-hint'
};
$f9efea4032a61ab2$export$3582487b0804e1f6.DECORATION_TYPES = {
    completionHint: 'completionHint'
};
const $f9efea4032a61ab2$export$fd041caf0943d29 = new $f9efea4032a61ab2$export$3582487b0804e1f6();
module.exports["SuggestionManager"] = $f9efea4032a61ab2$export$3582487b0804e1f6;
module.exports["suggestionManager"] = $f9efea4032a61ab2$export$fd041caf0943d29;

});

parcelRegister("6U6f6", function(module, exports) {

var $cI8RZ = parcelRequire("cI8RZ");


var $8nvEM = parcelRequire("8nvEM");


var $cg8YD = parcelRequire("cg8YD");


var $bJf0u = parcelRequire("bJf0u");

function $5d36485001bf3d92$var$isSelectionNotInSuggestion({ selectionFrom: selectionFrom, selectionTo: selectionTo, suggestionFrom: suggestionFrom, suggestionTo: suggestionTo }) {
    return selectionTo < suggestionFrom || selectionFrom > suggestionTo;
}
function $5d36485001bf3d92$var$onSelectionChanged(tr, pluginState) {
    const { inlineSuggestion: inlineSuggestion } = pluginState;
    if (!inlineSuggestion) return pluginState;
    const { from: from, to: to } = inlineSuggestion;
    const { from: selectionFrom, to: selectionTo } = tr.selection;
    if ($5d36485001bf3d92$var$isSelectionNotInSuggestion({
        selectionFrom: selectionFrom,
        selectionTo: selectionTo,
        suggestionFrom: from,
        suggestionTo: to
    })) return {
        ...pluginState,
        inlineSuggestion: null,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        inlineSuggestionSessionId: null
    };
    return pluginState;
}
function $5d36485001bf3d92$var$mapSuggestionPositions(tr, pluginState, _editorState) {
    const { inlineSuggestion: inlineSuggestion } = pluginState;
    if (!inlineSuggestion) return pluginState;
    return {
        ...pluginState,
        inlineSuggestion: {
            ...inlineSuggestion,
            from: tr.mapping.map(inlineSuggestion.from),
            to: tr.mapping.map(inlineSuggestion.to)
        },
        decorationSet: pluginState.decorationSet.map(tr.mapping, tr.doc)
    };
}
const $5d36485001bf3d92$export$de5e90bd767c5d82 = ({ locale: locale })=>{
    return {
        inlineSuggestion: null,
        locale: locale,
        decorationSet: (0, $8nvEM.DecorationSet).empty,
        inlineSuggestionSessionId: null
    };
};
const $5d36485001bf3d92$var$dest = (0, $cI8RZ.pluginFactory)((0, $cg8YD.inlineSuggestionPluginKey), (0, $bJf0u.reducer), {
    onSelectionChanged: $5d36485001bf3d92$var$onSelectionChanged,
    mapping: $5d36485001bf3d92$var$mapSuggestionPositions
});
const $5d36485001bf3d92$export$656c7661095efe2e = $5d36485001bf3d92$var$dest.createPluginState;
const $5d36485001bf3d92$export$8d4021544bdece00 = $5d36485001bf3d92$var$dest.createCommand;
const $5d36485001bf3d92$export$f05434c51e3762e = $5d36485001bf3d92$var$dest.getPluginState;
module.exports["createInitialState"] = $5d36485001bf3d92$export$de5e90bd767c5d82;
module.exports["createPluginState"] = $5d36485001bf3d92$export$656c7661095efe2e;
module.exports["createCommand"] = $5d36485001bf3d92$export$8d4021544bdece00;
module.exports["getPluginState"] = $5d36485001bf3d92$export$f05434c51e3762e;

});

parcelRegister("9lgy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6NNvG = parcelRequire("6NNvG");

var $cceb5e331951c994$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["SmallChromeless"] = 258] = "SmallChromeless";
    Breakpoint[Breakpoint["Small"] = 320] = "Small";
    Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
    return Breakpoint;
}({});
const $cceb5e331951c994$export$4d88d8cc8b24eb33 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useElementBreakpoints(t0) {
    const $ = (0, $bDgLe.c)(7);
    const smallBreakpoint = t0 === undefined ? 320 : t0;
    const [setElement, t1] = (0, $6NNvG.useElementSize)();
    const { width: width } = t1;
    const breakpoint = width < smallBreakpoint ? smallBreakpoint : Infinity;
    const t2 = breakpoint <= smallBreakpoint;
    const t3 = breakpoint > smallBreakpoint;
    let t4;
    if ($[0] !== breakpoint || $[1] !== t2 || $[2] !== t3) {
        t4 = {
            breakpoint: breakpoint,
            isSmall: t2,
            isLarge: t3
        };
        $[0] = breakpoint;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== setElement || $[5] !== t4) {
        t5 = [
            setElement,
            t4
        ];
        $[4] = setElement;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : function useElementBreakpoints(smallBreakpoint = 320) {
    const [setElement, { width: width }] = (0, $6NNvG.useElementSize)();
    const breakpoint = width < smallBreakpoint ? smallBreakpoint : Infinity;
    return (0, $cozmU.useMemo)(()=>[
            setElement,
            {
                breakpoint: breakpoint,
                isSmall: breakpoint <= smallBreakpoint,
                isLarge: breakpoint > smallBreakpoint
            }
        ], [
        breakpoint,
        setElement,
        smallBreakpoint
    ]);
};
module.exports["Breakpoint"] = $cceb5e331951c994$export$114247090b0aae30;
module.exports["useElementBreakpoints"] = $cceb5e331951c994$export$4d88d8cc8b24eb33;

});

parcelRegister("avQAT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $24dy7 = parcelRequire("24dy7");


var $lMGh1 = parcelRequire("lMGh1");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $5iPLS = parcelRequire("5iPLS");


var $btrDv = parcelRequire("btrDv");


var $9lgy7 = parcelRequire("9lgy7");


var $lM3rj = parcelRequire("lM3rj");

const $60b0f64593879f6d$var$buttonContainerStyles = null;
const $60b0f64593879f6d$var$cmdPaletteButtonContainerStyles = {
    container: "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT _2mpnYb1Y8M _1iJnp6Va5s _2dvbuWDIqT",
    primaryButton: "_03h5E8OeNX"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $60b0f64593879f6d$var$divWrapperContainerStyleUnbounded = null;
const $60b0f64593879f6d$var$divWrapperContainerStyle = null;
const $60b0f64593879f6d$var$smallBreakPointAlignItems = null;
const $60b0f64593879f6d$var$errorFloatingContainerStyle = null;
const $60b0f64593879f6d$var$smallErrorFloatingContainerStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $60b0f64593879f6d$var$spanWrapperStyleUnbounded = null;
const $60b0f64593879f6d$var$spanWrapperStyle = null;
const $60b0f64593879f6d$var$smallBreakPointTop = null;
const $60b0f64593879f6d$var$dangerIconPaddingStyle = null;
const $60b0f64593879f6d$export$915e9e7bd4f0f96d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorMessage(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { children: children, breakpoint: breakpoint, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const t1 = breakpoint <= (0, $9lgy7.Breakpoint).Small && "_0hPCNLchRC";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT",
            "_2mHwu8uFDC",
            t1
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2IhTonLl21";
    let t4;
    if ($[2] !== t3) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _3YEZNOdnbC _2IhTonPgdg",
            "_26BoRw7dHp",
            t3
        ]);
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== formatMessage || $[5] !== isAIFC) {
        t5 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: formatMessage((0, $lM3rj.default).warningIconLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            })
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
            label: formatMessage((0, $lM3rj.default).warningIconLabel),
            color: "var(--ds-icon-warning, #E06C00)"
        });
        $[4] = formatMessage;
        $[5] = isAIFC;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t4 || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t4,
            children: t5
        });
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== children) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            as: "p",
            children: children
        });
        $[10] = children;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t2 || $[13] !== t6 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t2,
            children: [
                t6,
                t7
            ]
        });
        $[12] = t2;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    return t8;
} : function ErrorMessage({ children: children, breakpoint: breakpoint, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuchRC _0hPCNLDIqT",
            "_2mHwu8uFDC",
            breakpoint <= (0, $9lgy7.Breakpoint).Small && "_0hPCNLchRC"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _1mT5xdRAKS _3YEZNOdnbC _2IhTonPgdg",
                    "_26BoRw7dHp",
                    breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2IhTonLl21"
                ]),
                children: isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    className: (0, $hekY6.default)([
                        "_0Of8r21Y8M _1Znuxb1Y8M _1wydGW1Y8M _2Zuz6Q1Y8M"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                        label: formatMessage((0, $lM3rj.default).warningIconLabel),
                        color: "var(--ds-icon-danger, #C9372C)"
                    })
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                    label: formatMessage((0, $lM3rj.default).warningIconLabel),
                    color: "var(--ds-icon-warning, #E06C00)"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                as: "p",
                children: children
            })
        ]
    });
};
const $60b0f64593879f6d$export$a359b30953f5499e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorButton(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: t1, isAIFC: isAIFC } = t0;
    const disabled = t1 === undefined ? false : t1;
    const shouldUseSubtleStyle = isAIFC && appearance === "primary";
    const finalAppearance = shouldUseSubtleStyle ? "subtle" : appearance;
    let t2;
    if ($[0] !== autoFocus || $[1] !== children || $[2] !== disabled || $[3] !== finalAppearance || $[4] !== onClick || $[5] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            autoFocus: autoFocus,
            testId: testId,
            spacing: "compact",
            onClick: onClick,
            type: "button",
            appearance: finalAppearance,
            isDisabled: disabled,
            children: children
        });
        $[0] = autoFocus;
        $[1] = children;
        $[2] = disabled;
        $[3] = finalAppearance;
        $[4] = onClick;
        $[5] = testId;
        $[6] = t2;
    } else t2 = $[6];
    const button = t2;
    if (shouldUseSubtleStyle) {
        let t3;
        if ($[7] !== button) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                xcss: $60b0f64593879f6d$var$cmdPaletteButtonContainerStyles.primaryButton,
                children: button
            });
            $[7] = button;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    return button;
} : function ErrorButton({ children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: disabled = false, isAIFC: isAIFC }) {
    const shouldUseSubtleStyle = isAIFC && appearance === 'primary';
    const finalAppearance = shouldUseSubtleStyle ? 'subtle' : appearance;
    const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        autoFocus: autoFocus,
        testId: testId,
        spacing: "compact",
        onClick: onClick,
        type: "button",
        appearance: finalAppearance,
        isDisabled: disabled,
        children: children
    });
    if (shouldUseSubtleStyle) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
        xcss: $60b0f64593879f6d$var$cmdPaletteButtonContainerStyles.primaryButton,
        children: button
    });
    return button;
};
const $60b0f64593879f6d$export$e7ce0c27e387222f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorButtonContainer(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, isAIFC: isAIFC } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isAIFC) {
        t1 = isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
            xcss: $60b0f64593879f6d$var$cmdPaletteButtonContainerStyles.container,
            children: children
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT"
            ]),
            children: children
        });
        $[0] = children;
        $[1] = isAIFC;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ErrorButtonContainer({ children: children, isAIFC: isAIFC }) {
    return isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
        xcss: $60b0f64593879f6d$var$cmdPaletteButtonContainerStyles.container,
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _3TGfC9HnLE _0aFT5v1qpb _37wbyuz9WS _0hPCNLDIqT"
        ]),
        children: children
    });
}; // Need to use forwardRef because functional component cannot be passed a ref
const $60b0f64593879f6d$export$f31c7963ee61af = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, breakpoint: breakpoint, appearance: appearance, isAIFC: isAIFC } = t0;
    const t1 = breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w";
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb",
            t1,
            `error-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== appearance || $[3] !== isAIFC) {
        t3 = isAIFC ? appearance === "chromeless" ? {
            right: 0,
            left: 0
        } : {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        };
        $[2] = appearance;
        $[3] = isAIFC;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== appearance || $[6] !== children || $[7] !== isAIFC || $[8] !== ref || $[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
            ref: ref,
            "data-testid": "error-screen",
            className: t2,
            paddingAdjustments: t3,
            rainbowBorder: false,
            appearance: appearance,
            isAIFC: isAIFC,
            children: children
        });
        $[5] = appearance;
        $[6] = children;
        $[7] = isAIFC;
        $[8] = ref;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ children: children, breakpoint: breakpoint, appearance: appearance, isAIFC: isAIFC }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $btrDv.FloatingContainer), {
        ref: ref,
        "data-testid": "error-screen",
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb",
            breakpoint <= (0, $9lgy7.Breakpoint).Small && "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w",
            `error-screen ${(0, $5iPLS.AI_MODAL_SCREEN_CLASS)}`
        ]),
        paddingAdjustments: isAIFC ? appearance === 'chromeless' ? {
            right: 0,
            left: 0
        } : {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        },
        rainbowBorder: false,
        appearance: appearance,
        isAIFC: isAIFC,
        children: children
    });
});
module.exports["ErrorMessage"] = $60b0f64593879f6d$export$915e9e7bd4f0f96d;
module.exports["ErrorButton"] = $60b0f64593879f6d$export$a359b30953f5499e;
module.exports["ErrorButtonContainer"] = $60b0f64593879f6d$export$e7ce0c27e387222f;
module.exports["ErrorFloatingContainer"] = $60b0f64593879f6d$export$f31c7963ee61af;

});

parcelRegister("lM3rj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d7fa64e0241f6e5f$var$message = (0, $kSwu1.defineMessages)({
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.error.cancelLabel",
        defaultMessage: "Cancel"
    },
    closeLabel: {
        id: "fabric.editor.ai.screens.error.closeLabel",
        defaultMessage: "Close"
    },
    retryLabel: {
        id: "fabric.editor.ai.screens.error.retryLabel",
        defaultMessage: "Try again"
    },
    warningIconLabel: {
        id: "fabric.editor.ai.screens.error.warningIconLabel",
        defaultMessage: "Warning"
    },
    ariaErrorTitle: {
        id: "fabric.editor.ai.screens.error.ariaErrorTitle",
        defaultMessage: "Error"
    }
});
var $d7fa64e0241f6e5f$export$2e2bcd8739ae039 = $d7fa64e0241f6e5f$var$message;
module.exports["default"] = $d7fa64e0241f6e5f$export$2e2bcd8739ae039;

});

parcelRegister("5iPLS", function(module, exports) {
// Request from Trello to add a single selector for all modal screens
// This is to prevent click events within the Editor AI plugin screens
// from triggering a “close” event hiding the Editor while in edit mode.
// See https://hello.atlassian.net/browse/EDITOR-75
const $1908bba16023d75d$export$9df59400d72ad68f = 'ai-modal-screen';
module.exports["AI_MODAL_SCREEN_CLASS"] = $1908bba16023d75d$export$9df59400d72ad68f;

});

parcelRegister("btrDv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1enXm = parcelRequire("1enXm");


var $1jz5K = parcelRequire("1jz5K");


var $aIj6m = parcelRequire("aIj6m");

const $2b059264fcabe527$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $2b059264fcabe527$var$PRISM_BORDER_STEP_1 = '#0065FF';
const $2b059264fcabe527$var$PRISM_BORDER_STEP_2 = '#0469FF';
const $2b059264fcabe527$var$PRISM_BORDER_STEP_3 = '#BF63F3';
const $2b059264fcabe527$var$PRISM_BORDER_STEP_4 = '#FFA900';
const $2b059264fcabe527$var$defaultPadding = {
    top: 12,
    bottom: 12,
    left: 12,
    right: 12
}; // ED-20633, DSP-14045: Avoid space tokens for now as space tokens are currently using rem units
// and Safari has a bug where rem is incorrectly calculated when there are
// animations involved
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2b059264fcabe527$var$prismBorderStyles = null;
const $2b059264fcabe527$var$newPrismBorderStyles = null;
const $2b059264fcabe527$var$staticStyles = {
    default: "_2OWEWsreue _4eDJc6reue",
    firefox: "_2OWEWsGSmP _4eDJc6GSmP _306CW9xxUt _34UJl7xxUt"
};
const $2b059264fcabe527$var$fireFoxBgPosition = null;
const $2b059264fcabe527$var$rotationAnimation = null;
const $2b059264fcabe527$var$animationStyles = {
    default: "_30VpOTViE0 _2ofBtgViE0 _1nw4qxFSlo _1iAcE9FSlo _2WuqwLHVQb _2lXp1JHVQb _2VLDZtSHWH _0YTlblSHWH",
    firefox: "_30VpOT7xEF _2ofBtg7xEF _1nw4qxipXj _1iAcE9ipXj _2WuqwLHVQb _2lXp1JHVQb _2VLDZtSHWH _0YTlblSHWH _21qtfOzUZr _0160FKzUZr"
};
const $2b059264fcabe527$var$rovoMosaicBorderStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2b059264fcabe527$var$constantStyles = null;
const $2b059264fcabe527$var$newConstantStyles = null;
const $2b059264fcabe527$var$maxHeightCSS = null;
const $2b059264fcabe527$var$centeringCSS = null;
const $2b059264fcabe527$var$fitContentWidthCSS = null;
const $2b059264fcabe527$var$maxWidthCSS = null; // EDITOR-3718: Responsive width fix for narrow screens.
// Clamp to 400px or the container width. Set both `width` (preferred/base size)
// and `maxWidth` (hard cap + overrides existing rules) to keep sizing consistent.
const $2b059264fcabe527$var$responsiveMaxWidthOverrideCSS = null; /**
                                             * FocusLock adds a focus trap so that users can keep tabbing through the
                                             * command palette without leaving it unless when pressing escape or clicking outside.
                                             */ 
const $2b059264fcabe527$var$GatedFocusLock = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, isAIFC: isAIFC } = t0;
    const scrollParentRef = (0, $cozmU.useRef)();
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if (ref.current) scrollParentRef.current = (0, $1jz5K.findOverflowScrollParent)(ref.current) || undefined;
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!isAIFC) {
        let t3;
        let t4;
        let t5;
        let t6;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                preventScroll: true
            };
            t4 = (activeElement)=>{
                if (activeElement === scrollParentRef.current) return false;
                return true;
            };
            t5 = {
                preventScroll: true
            };
            t6 = (0, $hekY6.default)([
                "_39xV02N91d"
            ]);
            $[2] = t3;
            $[3] = t4;
            $[4] = t5;
            $[5] = t6;
        } else {
            t3 = $[2];
            t4 = $[3];
            t5 = $[4];
            t6 = $[5];
        }
        let t7;
        if ($[6] !== children || $[7] !== t6) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                ref: ref,
                noFocusGuards: true,
                returnFocus: t3,
                whiteList: t4,
                focusOptions: t5,
                className: t6,
                children: children
            });
            $[6] = children;
            $[7] = t6;
            $[8] = t7;
        } else t7 = $[8];
        return t7;
    }
    return children;
} : ({ children: children, isAIFC: isAIFC })=>{
    const scrollParentRef = (0, $cozmU.useRef)();
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (ref.current) scrollParentRef.current = (0, $1jz5K.findOverflowScrollParent)(ref.current) || undefined;
    }, []);
    if (!isAIFC) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
        ref: ref,
        noFocusGuards: true,
        returnFocus: {
            preventScroll: true
        },
        whiteList: (activeElement)=>{
            if (activeElement === scrollParentRef.current) return false;
            return true;
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        focusOptions: {
            preventScroll: true
        },
        className: (0, $hekY6.default)([
            "_39xV02N91d"
        ]),
        children: children
    });
    return children;
};
const $2b059264fcabe527$export$4ddaad941c29ad29 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(49);
    let children;
    let className;
    let disablePadding;
    let enableMaxHeight;
    let enableMaxWidth;
    let isAIFC;
    let isPositionalOnly;
    let paddingAdjustments;
    let rainbowBorderAnimation;
    let rest;
    let rovoGradientBorder;
    let style;
    let t1;
    if ($[0] !== t0) {
        const { appearance: appearance, paddingAdjustments: t2, rainbowBorder: t3, rainbowBorderAnimation: t4, rovoGradientBorder: t5, disablePadding: t6, children: t7, enableMaxHeight: t8, enableMaxWidth: t9, className: t10, style: t11, isAIFC: t12, isPositionalOnly: t13, ...t14 } = t0;
        paddingAdjustments = t2;
        t1 = t3;
        rainbowBorderAnimation = t4;
        rovoGradientBorder = t5;
        disablePadding = t6;
        children = t7;
        enableMaxHeight = t8;
        enableMaxWidth = t9;
        className = t10;
        style = t11;
        isAIFC = t12;
        isPositionalOnly = t13;
        rest = t14;
        $[0] = t0;
        $[1] = children;
        $[2] = className;
        $[3] = disablePadding;
        $[4] = enableMaxHeight;
        $[5] = enableMaxWidth;
        $[6] = isAIFC;
        $[7] = isPositionalOnly;
        $[8] = paddingAdjustments;
        $[9] = rainbowBorderAnimation;
        $[10] = rest;
        $[11] = rovoGradientBorder;
        $[12] = style;
        $[13] = t1;
    } else {
        children = $[1];
        className = $[2];
        disablePadding = $[3];
        enableMaxHeight = $[4];
        enableMaxWidth = $[5];
        isAIFC = $[6];
        isPositionalOnly = $[7];
        paddingAdjustments = $[8];
        rainbowBorderAnimation = $[9];
        rest = $[10];
        rovoGradientBorder = $[11];
        style = $[12];
        t1 = $[13];
    }
    const rainbowBorder = t1 === undefined ? true : t1;
    let t2;
    if ($[14] !== disablePadding || $[15] !== isPositionalOnly || $[16] !== paddingAdjustments) {
        t2 = disablePadding || isPositionalOnly ? null : paddingAdjustments ? {
            paddingTop: `${$2b059264fcabe527$var$defaultPadding.top + (paddingAdjustments.top ?? 0)}px`,
            paddingRight: `${$2b059264fcabe527$var$defaultPadding.right + (paddingAdjustments.right ?? 0)}px`,
            paddingBottom: `${$2b059264fcabe527$var$defaultPadding.bottom + (paddingAdjustments.bottom ?? 0)}px`,
            paddingLeft: `${$2b059264fcabe527$var$defaultPadding.left + (paddingAdjustments.left ?? 0)}px`
        } : {
            padding: `${$2b059264fcabe527$var$defaultPadding.top}px ${$2b059264fcabe527$var$defaultPadding.left}px`
        };
        $[14] = disablePadding;
        $[15] = isPositionalOnly;
        $[16] = paddingAdjustments;
        $[17] = t2;
    } else t2 = $[17];
    let t3;
    if ($[18] !== style || $[19] !== t2) {
        t3 = {
            ...style,
            ...t2
        };
        $[18] = style;
        $[19] = t2;
        $[20] = t3;
    } else t3 = $[20];
    const t4 = !isPositionalOnly && rainbowBorder && !isAIFC && "_0bjKvD8fU6 _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iw5YI _1Oimfuw5YI _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9Q2FF _3ScelFQ2FF _47eTBtQ2FF _1lBcDcQ2FF _2KaDuOA17z _35I30BA17z _2ZHpDRA17z _1L3m71A17z _0PxRoQ24hy _0ue2N524hy _0cAGM7HZdu _4zi1EpHZdu _2KaCXrNpdy _43i6GSXvJ3 _1VPqc3YbGa";
    const t5 = !isPositionalOnly && rainbowBorder && isAIFC && "_0bjKvDQAma _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iIOo0 _1OimfuIOo0 _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9Q2FF _3ScelFQ2FF _47eTBtQ2FF _1lBcDcQ2FF _2KaDuOA17z _35I30BA17z _2ZHpDRA17z _1L3m71A17z _0PxRoQ24hy _0ue2N524hy _0cAGM7HZdu _4zi1EpHZdu _2KaCXrNpdy _43i6GSXvJ3 _1VPqc3YbGa";
    const t6 = !isPositionalOnly && rovoGradientBorder && "";
    const t7 = !isPositionalOnly && rovoGradientBorder && "_0bjKvDuMRm _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iASUJ _1OimfuASUJ _2OWEWsohwg _4eDJc6ohwg _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9UckC _3ScelFUckC _47eTBtUckC _1lBcDcUckC _2KaDuOpgTj _35I30BpgTj _2ZHpDRpgTj _1L3m71pgTj _30VpOTViE0 _2ofBtgViE0 _1nw4qxFSlo _1iAcE9FSlo _2WuqwLHVQb _2lXp1JHVQb _2VLDZtSHWH _0YTlblSHWH _2AwNtJYbGa _32JO6cYbGa";
    const t8 = !isPositionalOnly && !rovoGradientBorder && $2b059264fcabe527$var$staticStyles[$2b059264fcabe527$var$isFirefox ? "firefox" : "default"];
    const t9 = !isPositionalOnly && isAIFC && "_0bjKvDuMRm _2OUyjtGk8v _39xV02N91d _24h04i2Njc _0KLXruoI2d";
    const t10 = !isPositionalOnly && !isAIFC && "_0bjKvD8fU6 _2OUyjtGk8v _0jFU0VN91d _39xV02N91d _24h04i2Njc _0KLXruoI2d _2pELSPOLYo _1neijjOLYo";
    const t11 = !isPositionalOnly && rainbowBorderAnimation && $2b059264fcabe527$var$animationStyles[$2b059264fcabe527$var$isFirefox ? "firefox" : "default"];
    const t12 = enableMaxHeight && "_0NUa3r4DOi";
    const t13 = enableMaxWidth && "_39xV02Hakr _1EqgXlHakr _2p6ht9DIqT";
    const t14 = enableMaxWidth && "_39xV02la9Q _1EqgXlla9Q _24h04i2Njc";
    const t15 = isAIFC && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1ghwDKVa5s";
    const t16 = isAIFC && !enableMaxWidth && "_39xV02E6Kk";
    let t17;
    if ($[21] !== className || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t15 || $[28] !== t16 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
        t17 = (0, $hekY6.default)([
            t4,
            t5,
            t6,
            t7,
            t8,
            t9,
            t10,
            t11,
            t12,
            t13,
            t14,
            t15,
            t16,
            className
        ]);
        $[21] = className;
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
        $[25] = t13;
        $[26] = t14;
        $[27] = t15;
        $[28] = t16;
        $[29] = t4;
        $[30] = t5;
        $[31] = t6;
        $[32] = t7;
        $[33] = t8;
        $[34] = t9;
        $[35] = t17;
    } else t17 = $[35];
    let t18;
    if ($[36] !== isPositionalOnly || $[37] !== rovoGradientBorder) {
        t18 = !isPositionalOnly && rovoGradientBorder && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIj6m.RovoGradientKeyframesStyle), {});
        $[36] = isPositionalOnly;
        $[37] = rovoGradientBorder;
        $[38] = t18;
    } else t18 = $[38];
    let t19;
    if ($[39] !== children || $[40] !== ref || $[41] !== rest || $[42] !== t17 || $[43] !== t18 || $[44] !== t3) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            ref: ref,
            style: t3,
            className: t17,
            ...rest,
            children: [
                t18,
                children
            ]
        });
        $[39] = children;
        $[40] = ref;
        $[41] = rest;
        $[42] = t17;
        $[43] = t18;
        $[44] = t3;
        $[45] = t19;
    } else t19 = $[45];
    let t20;
    if ($[46] !== isAIFC || $[47] !== t19) {
        t20 = /*#__PURE__*/ (0, $8aG6j.jsx)($2b059264fcabe527$var$GatedFocusLock, {
            isAIFC: isAIFC,
            children: t19
        });
        $[46] = isAIFC;
        $[47] = t19;
        $[48] = t20;
    } else t20 = $[48];
    return t20;
} : ({ appearance: appearance, paddingAdjustments: paddingAdjustments, rainbowBorder: rainbowBorder = true, rainbowBorderAnimation: rainbowBorderAnimation, rovoGradientBorder: rovoGradientBorder, disablePadding: disablePadding, children: children, enableMaxHeight: enableMaxHeight, enableMaxWidth: enableMaxWidth, className: className, style: style, isAIFC: isAIFC, isPositionalOnly: isPositionalOnly, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($2b059264fcabe527$var$GatedFocusLock, {
        isAIFC: isAIFC,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            ref: ref,
            style: {
                ...style,
                ...disablePadding || isPositionalOnly ? null : paddingAdjustments ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingTop: `${$2b059264fcabe527$var$defaultPadding.top + (paddingAdjustments.top ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingRight: `${$2b059264fcabe527$var$defaultPadding.right + (paddingAdjustments.right ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingBottom: `${$2b059264fcabe527$var$defaultPadding.bottom + (paddingAdjustments.bottom ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingLeft: `${$2b059264fcabe527$var$defaultPadding.left + (paddingAdjustments.left ?? 0)}px`
                } : {
                    padding: `${$2b059264fcabe527$var$defaultPadding.top}px ${$2b059264fcabe527$var$defaultPadding.left}px`
                }
            },
            className: (0, $hekY6.default)([
                !isPositionalOnly && rainbowBorder && !isAIFC && "_0bjKvD8fU6 _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iw5YI _1Oimfuw5YI _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9Q2FF _3ScelFQ2FF _47eTBtQ2FF _1lBcDcQ2FF _2KaDuOA17z _35I30BA17z _2ZHpDRA17z _1L3m71A17z _0PxRoQ24hy _0ue2N524hy _0cAGM7HZdu _4zi1EpHZdu _2KaCXrNpdy _43i6GSXvJ3 _1VPqc3YbGa",
                !isPositionalOnly && rainbowBorder && isAIFC && "_0bjKvDQAma _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iIOo0 _1OimfuIOo0 _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9Q2FF _3ScelFQ2FF _47eTBtQ2FF _1lBcDcQ2FF _2KaDuOA17z _35I30BA17z _2ZHpDRA17z _1L3m71A17z _0PxRoQ24hy _0ue2N524hy _0cAGM7HZdu _4zi1EpHZdu _2KaCXrNpdy _43i6GSXvJ3 _1VPqc3YbGa",
                !isPositionalOnly && rovoGradientBorder && "",
                !isPositionalOnly && rovoGradientBorder && "_0bjKvDuMRm _1mT5xdRAKS _2OUyjtYbGa _2Gfj6iASUJ _1OimfuASUJ _2OWEWsohwg _4eDJc6ohwg _0GBAIrogpp _3Ku51Iogpp _2WYcYGWVPG _3dCYwDWVPG _39mJBjvQQr _3qT6l0vQQr _2jfUf9UckC _3ScelFUckC _47eTBtUckC _1lBcDcUckC _2KaDuOpgTj _35I30BpgTj _2ZHpDRpgTj _1L3m71pgTj _30VpOTViE0 _2ofBtgViE0 _1nw4qxFSlo _1iAcE9FSlo _2WuqwLHVQb _2lXp1JHVQb _2VLDZtSHWH _0YTlblSHWH _2AwNtJYbGa _32JO6cYbGa",
                !isPositionalOnly && !rovoGradientBorder && $2b059264fcabe527$var$staticStyles[$2b059264fcabe527$var$isFirefox ? 'firefox' : 'default'],
                !isPositionalOnly && isAIFC && "_0bjKvDuMRm _2OUyjtGk8v _39xV02N91d _24h04i2Njc _0KLXruoI2d",
                !isPositionalOnly && !isAIFC && "_0bjKvD8fU6 _2OUyjtGk8v _0jFU0VN91d _39xV02N91d _24h04i2Njc _0KLXruoI2d _2pELSPOLYo _1neijjOLYo",
                !isPositionalOnly && rainbowBorderAnimation && $2b059264fcabe527$var$animationStyles[$2b059264fcabe527$var$isFirefox ? 'firefox' : 'default'],
                enableMaxHeight && "_0NUa3r4DOi",
                enableMaxWidth && "_39xV02Hakr _1EqgXlHakr _2p6ht9DIqT",
                enableMaxWidth && "_39xV02la9Q _1EqgXlla9Q _24h04i2Njc",
                isAIFC && "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1ghwDKVa5s",
                isAIFC && !enableMaxWidth && "_39xV02E6Kk",
                className
            ]),
            ...rest,
            children: [
                !isPositionalOnly && rovoGradientBorder && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aIj6m.RovoGradientKeyframesStyle), {}),
                children
            ]
        })
    });
});
module.exports["FloatingContainer"] = $2b059264fcabe527$export$4ddaad941c29ad29;

});

parcelRegister("8W9nI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $6NNvG = parcelRequire("6NNvG");


var $4D2QO = parcelRequire("4D2QO");


var $9sR23 = parcelRequire("9sR23");


var $121e3 = parcelRequire("121e3");


var $161op = parcelRequire("161op");

const $bdfb2e9ca7cdb15f$var$footerStyles = {
    default: "_2mHwu81Y8M _3iDTPbQ4SZ _3TGfC9HnLE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r22ADO _1wydGW2ADO _2IVJ4M6wH8 _0hPCNLDIqT _37wbyuI7V3 _3zygPU9r67 _22sfPnNvrM"
};
const $bdfb2e9ca7cdb15f$export$a06f1c675e846f6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Footer(t0) {
    const $ = (0, $bDgLe.c)(25);
    const { brand: brand, showDisclaimer: showDisclaimer, disclaimer: disclaimer, showBetaLozenge: showBetaLozenge, showFeedback: showFeedback, feedbackForm: feedbackForm, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setElement, t1] = (0, $6NNvG.useElementSize)();
    const { width: width } = t1;
    let t2;
    bb0: if (brand === "atlassian-intelligence") {
        if (width < (0, $121e3.AI_BREAKPOINTS).medium) {
            t2 = "small";
            break bb0;
        }
        if (width < (0, $121e3.AI_BREAKPOINTS).large) {
            t2 = "medium";
            break bb0;
        }
        t2 = "large";
    } else {
        if (width < (0, $121e3.ROVO_BREAKPOINTS).medium) {
            t2 = "small";
            break bb0;
        }
        if (width < (0, $121e3.ROVO_BREAKPOINTS).large) {
            t2 = "medium";
            break bb0;
        }
        t2 = "large";
    }
    const appearance = t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== showBetaLozenge) {
        t3 = showBetaLozenge && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
            testId: "beta-lozenge",
            children: formatMessage((0, $161op.default).betaLabel)
        });
        $[0] = formatMessage;
        $[1] = showBetaLozenge;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== appearance || $[4] !== disclaimer || $[5] !== isAIFC || $[6] !== showDisclaimer) {
        t4 = showDisclaimer ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9sR23.FooterDisclaimer), {
            disclaimer: disclaimer,
            appearance: appearance,
            isAIFC: isAIFC
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {});
        $[3] = appearance;
        $[4] = disclaimer;
        $[5] = isAIFC;
        $[6] = showDisclaimer;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.050",
            children: [
                t3,
                t4
            ]
        });
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== appearance || $[12] !== brand || $[13] !== isAIFC || $[14] !== showFeedback) {
        t6 = !(0, $iDrrr.fg)("ai-smart-button-team-25") && !isAIFC && !showFeedback && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4D2QO.FooterAIBrand), {
            brand: brand,
            appearance: appearance
        });
        $[11] = appearance;
        $[12] = brand;
        $[13] = isAIFC;
        $[14] = showFeedback;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== feedbackForm || $[17] !== formatMessage || $[18] !== showFeedback) {
        t7 = showFeedback && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    children: formatMessage((0, $161op.default).compactFeedbackText)
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                    children: feedbackForm
                })
            ]
        });
        $[16] = feedbackForm;
        $[17] = formatMessage;
        $[18] = showFeedback;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== setElement || $[21] !== t5 || $[22] !== t6 || $[23] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            ref: setElement,
            xcss: $bdfb2e9ca7cdb15f$var$footerStyles.default,
            children: [
                t5,
                t6,
                t7
            ]
        });
        $[20] = setElement;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : function Footer({ brand: brand, showDisclaimer: showDisclaimer, disclaimer: disclaimer, showBetaLozenge: showBetaLozenge, showFeedback: showFeedback, feedbackForm: feedbackForm, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [setElement, { width: width }] = (0, $6NNvG.useElementSize)();
    const appearance = (0, $cozmU.useMemo)(()=>{
        if (brand === 'atlassian-intelligence') {
            if (width < (0, $121e3.AI_BREAKPOINTS).medium) return 'small';
            if (width < (0, $121e3.AI_BREAKPOINTS).large) return 'medium';
            return 'large';
        } else {
            if (width < (0, $121e3.ROVO_BREAKPOINTS).medium) return 'small';
            if (width < (0, $121e3.ROVO_BREAKPOINTS).large) return 'medium';
            return 'large';
        }
    }, [
        width,
        brand
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        ref: setElement,
        xcss: $bdfb2e9ca7cdb15f$var$footerStyles.default,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9KSWX.default), {
                        testId: "beta-lozenge",
                        children: formatMessage((0, $161op.default).betaLabel)
                    }),
                    showDisclaimer ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9sR23.FooterDisclaimer), {
                        disclaimer: disclaimer,
                        appearance: appearance,
                        isAIFC: isAIFC
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {})
                ]
            }),
            !(0, $iDrrr.fg)('ai-smart-button-team-25') && !isAIFC && !showFeedback && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4D2QO.FooterAIBrand), {
                brand: brand,
                appearance: appearance
            }),
            showFeedback && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                        children: formatMessage((0, $161op.default).compactFeedbackText)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1l0kj.Inline), {
                        children: feedbackForm
                    })
                ]
            })
        ]
    });
};
module.exports["Footer"] = $bdfb2e9ca7cdb15f$export$a06f1c675e846f6f;

});

parcelRegister("hUKxF", function(module, exports) {
/* LatestPromptHeader.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * Note: If deleting this file please also delete the exceptions in this file:
 * `packages/editor/generative-ai-modal/src/ui/screens/Preview/__tests__/vr-tests/Preview.vr.ts`
 * ```ts
 * a11y: {
 *	skip: true,
 * },
 * ```
 *
 * These exceptions were made because we have nested buttons inside the EditPrompt button which is a violation.
 * However, we expect these will be resolved with the completion of this work:
 * https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-96926/updates
 */ /** @jsxFrag */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");


var $iDrrr = parcelRequire("iDrrr");


var $eVwUu = parcelRequire("eVwUu");


var $gDDkj = parcelRequire("gDDkj");


var $lo86r = parcelRequire("lo86r");


var $7miJK = parcelRequire("7miJK");


var $hWovL = parcelRequire("hWovL");


var $bDDw8 = parcelRequire("bDDw8");


var $9iuHu = parcelRequire("9iuHu");

const $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID = 'ai-latest-prompt-content'; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $f30061bc2f95ed4b$var$headerEditStylesUnbounded = null;
const $f30061bc2f95ed4b$var$headerEditStyles = null;
const $f30061bc2f95ed4b$var$headerEditMotionStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $f30061bc2f95ed4b$var$contentContainerStylesUnbounded = null;
const $f30061bc2f95ed4b$var$contentContainerStyles = null;
const $f30061bc2f95ed4b$var$fullWidth = {
    default: "_39xV02N91d"
};
const $f30061bc2f95ed4b$var$titleContentWrapper = {
    default: "_2O5Vij7dHp _4ouGXIdnbC"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $f30061bc2f95ed4b$var$headerStylesUnbounded = null;
const $f30061bc2f95ed4b$var$headerStyles = null; // header has width/padding at the same time
// if there is very long prompt, header will be wider than parent
// so it should be border-box
const $f30061bc2f95ed4b$var$headerBoxSizingStyles = null;
const $f30061bc2f95ed4b$export$289e4ad0cf050b01 = ({ prompt: prompt, promptADF: promptADF, presetTitle: presetTitle, providerFactory: providerFactory, onEditPromptClick: onEditPromptClick, isClearTitle: isClearTitle, agent: agent, showBack: showBack, onBack: onBack, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)(); // when used in Loading screen, there is no onEditPromptClick
    const canEdit = !!onEditPromptClick;
    const promptContent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (promptADF) return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hWovL.LatestPromptRenderer), {
                    promptADF: promptADF,
                    providerFactory: providerFactory
                }),
                !presetTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7miJK.EditPromptHoverTag), {
                    isClearMode: !presetTitle && !prompt,
                    isPlaceholder: !canEdit
                })
            ]
        });
        if (prompt) return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _0QpwdFIZbP _1T2N03wPeg"
            ]),
            children: prompt
        });
        return null;
    }, [
        canEdit,
        prompt,
        promptADF,
        providerFactory,
        presetTitle
    ]);
    const refinementTagProps = (0, $eVwUu.useAgentRefinementTagProps)(agent);
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
            children: [
                showBack && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gDDkj.BackIconButton), {
                    inPromptHeader: true,
                    isDisabled: !canEdit,
                    stopPropagation: true,
                    onClick: onBack
                }),
                /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                    direction: "column",
                    gap: "space.050",
                    xcss: $f30061bc2f95ed4b$var$titleContentWrapper.default,
                    children: [
                        presetTitle && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $4ez2K.Flex), {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                                    children: isClearTitle ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: 'semibold',
                                        children: presetTitle
                                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bDDw8.RefinementTag), {
                                        label: presetTitle,
                                        ...refinementTagProps,
                                        onClick: canEdit ? ()=>{
                                            if (onBack) onBack();
                                        } : undefined
                                    })
                                }),
                                presetTitle && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7miJK.EditPromptHoverTag), {
                                    isClearMode: !!presetTitle && !prompt,
                                    isPlaceholder: !canEdit
                                })
                            ]
                        }),
                        promptContent
                    ]
                }),
                !!onClose && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lo86r.ClosePreviewIconButton), {
                    onClick: onClose
                })
            ]
        });
    }, [
        showBack,
        canEdit,
        onBack,
        presetTitle,
        isClearTitle,
        refinementTagProps,
        prompt,
        promptContent,
        onClose
    ]);
    if (!(prompt || presetTitle)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: "prompt-header",
        xcss: $f30061bc2f95ed4b$var$fullWidth.default,
        children: !canEdit ? /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            id: $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID,
            "data-testid": $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE _3zvHkHwPeg _39xV02N91d",
                "_15pjn9SPN1",
                "_24h04i2Njc",
                "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _0QpwdFIZbP _1T2N03wPeg",
                "_26BoRwSPN1"
            ]),
            children: header
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("button", {
            type: "button",
            "data-testid": "edit-prompt-button",
            onClick: onEditPromptClick,
            "aria-label": formatMessage((0, $9iuHu.messages).editPrompt),
            "aria-describedby": $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _0Of8r28HPE _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE _3zvHkHwPeg _39xV02N91d",
                "_15pjn9SPN1",
                "_24h04i2Njc",
                "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _0QpwdFIZbP _1T2N03wPeg",
                "_26BoRwSPN1",
                "_30huDKYbGa _0bjKvD8fU6 _0wOv4Q7zJH _39xV02N91d _0KLXrujOvk _2fwxA57p2s",
                "_23rrnHyKLB _1UtDYzOLYo _4ya3eEZqHV _26BoRwOLYo _1v9SsVdnbC _3XDz3BdnbC _158oJd7dHp _2fqI0WXzJH _38a67RLl21 _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS",
                (0, $iDrrr.fg)('platform-dst-motion-uplift-custom-button') && "_23rrnHyKLB _3sFUREiSCN"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                id: $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID,
                "data-testid": $f30061bc2f95ed4b$var$PROMPT_CONTENT_ID,
                children: header
            })
        })
    });
};
module.exports["LatestPromptHeader"] = $f30061bc2f95ed4b$export$289e4ad0cf050b01;

});

parcelRegister("iK8jT", function(module, exports) {

var $57Rmq = parcelRequire("57Rmq");


var $hbVVb = parcelRequire("hbVVb");


var $bvvw1 = parcelRequire("bvvw1");

/**
 * Attribute-aware token encoder for `prosemirror-changeset`. The default encoder
 * reduces a node to `node.type.name`, so an attribute-only change (e.g. a table
 * cell recolour) tokenises identically on both sides and goes undetected. This
 * folds the diffable attributes (from the shared `diffableAttrs` map) into the
 * open token so such changes register.
 */ // Stable composite token; attr names are pre-ordered by the caller.
const $7744e530f10b34fc$var$encodeNodeWithAttrs = (node, attrNames)=>{
    const attrs = node.attrs ?? {};
    const parts = attrNames.map((name)=>`${name}=${JSON.stringify(attrs[name] ?? null)}`);
    return `${node.type.name}|${parts.join('|')}`;
};
const $7744e530f10b34fc$export$a0344d03a0d191a6 = {
    encodeCharacter: (char, marks)=>(0, $bvvw1.encodeCharacterWithMarks)(char, marks),
    encodeNodeStart: (node)=>{
        // Normalise variants (e.g. `panel_c1` → `panel`) so `diffableAttrs` needs one entry.
        const attrNames = (0, $hbVVb.getDiffableAttrNames)((0, $57Rmq.getBaseNodeTypeName)(node.type), node.attrs ?? {});
        if (attrNames && attrNames.length > 0) return $7744e530f10b34fc$var$encodeNodeWithAttrs(node, attrNames);
        return node.type.name;
    },
    encodeNodeEnd: (node)=>-$7744e530f10b34fc$var$typeID(node.type),
    compareTokens: (a, b)=>a === b
};
// Mirrors the library's private (unexported) `typeID` so node-end tokens match.
function $7744e530f10b34fc$var$typeID(type) {
    const cache = type.schema.cached.changeSetIDs || (type.schema.cached.changeSetIDs = Object.create(null));
    let id = cache[type.name];
    if (id == null) cache[type.name] = id = Object.keys(type.schema.nodes).indexOf(type.name) + 1;
    return id;
}
module.exports["attrAwareTokenEncoder"] = $7744e530f10b34fc$export$a0344d03a0d191a6;

});

parcelRegister("bvvw1", function(module, exports) {
/** U+0000 cannot occur in ProseMirror text content, so a token can never be ambiguous. */ const $6b1343bbf8f02ebb$var$MARK_KEY_SEPARATOR = '\u0000';
const $6b1343bbf8f02ebb$var$buildMarkKey = (marks)=>marks.map((mark)=>{
        const attrs = mark.attrs ?? {};
        const attrParts = Object.keys(attrs).sort().map((key)=>`${key}=${JSON.stringify(attrs[key] ?? null)}`);
        return attrParts.length > 0 ? `${mark.type.name}(${attrParts.join(',')})` : mark.type.name;
    }).sort().join('&');
/**
 * Keyed on array identity: `prosemirror-changeset` passes the same `child.marks` reference for
 * every character in a text node, so this collapses the key building to once per node.
 */ const $6b1343bbf8f02ebb$var$markKeyCache = new WeakMap();
const $6b1343bbf8f02ebb$export$cf0df313aed5f32 = (char, marks)=>{
    if (marks.length === 0) return char;
    let markKey = $6b1343bbf8f02ebb$var$markKeyCache.get(marks);
    if (markKey === undefined) {
        markKey = $6b1343bbf8f02ebb$var$buildMarkKey(marks);
        $6b1343bbf8f02ebb$var$markKeyCache.set(marks, markKey);
    }
    return `${char}${$6b1343bbf8f02ebb$var$MARK_KEY_SEPARATOR}${markKey}`;
};
module.exports["encodeCharacterWithMarks"] = $6b1343bbf8f02ebb$export$cf0df313aed5f32;

});

parcelRegister("9uQOV", function(module, exports) {

var $93WrI = parcelRequire("93WrI");


var $ldqjS = parcelRequire("ldqjS");


var $iIBeI = parcelRequire("iIBeI");

const $2c00c43c4243bb59$export$8979ff6e494800b3 = ({ appearance: appearance, product: product, actionSideEffect: actionSideEffect, factoryOptions: factoryOptions })=>({
        type: 'generic-chat',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $93WrI.aiConfigItemMessages).configActionContinueChatLabel : (0, $93WrI.aiConfigItemMessages).configActionContinueInChatLabel,
        appearance: appearance,
        shortcut: (0, $ldqjS.continueInRovoChat),
        run: ({ name: name, dialogues: dialogues, publish: publish })=>{
            if (!publish || !dialogues.length) return;
            publish({
                type: 'chat-new',
                product: product,
                data: {
                    dialogues: dialogues,
                    name: name
                },
                source: 'editor'
            });
            actionSideEffect?.();
        },
        preserveEditorSelectionOnComplete: true,
        icon: (0, $iIBeI.ChatIcon)
    });
const $2c00c43c4243bb59$export$176ad462aa0e7770 = ({ appearance: appearance, agent: agent, product: product, actionSideEffect: actionSideEffect, actionOverride: actionOverride, factoryOptions: factoryOptions })=>({
        type: 'agent',
        title: factoryOptions?.isInDocumentStreamingEnabled ? (0, $93WrI.aiConfigItemMessages).configActionContinueChatLabel : (0, $93WrI.aiConfigItemMessages).configActionContinueInChatLabel,
        shortcut: (0, $ldqjS.continueInRovoChat),
        appearance: appearance,
        run: ({ channelId: channelId, publish: publish })=>{
            if (!channelId || !publish) return;
            if (typeof actionOverride === 'function') {
                actionOverride({
                    channelId: channelId
                });
                return;
            }
            publish({
                type: 'chat-open',
                product: product,
                data: {
                    channelId: channelId,
                    agentId: agent.namedId
                },
                source: 'editor'
            });
            actionSideEffect?.();
        },
        preserveEditorSelectionOnComplete: true,
        icon: (0, $iIBeI.ChatIcon)
    });
module.exports["createContinueInChat"] = $2c00c43c4243bb59$export$8979ff6e494800b3;
module.exports["createContinueInChatForAgent"] = $2c00c43c4243bb59$export$176ad462aa0e7770;

});

parcelRegister("fpmlf", function(module, exports) {
var $a1a46a58b68b28f1$export$c5e4fced70735903 = /*#__PURE__*/ function(SupportedTranslationLanguages) {
    SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
    SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
    SupportedTranslationLanguages["Czech"] = "czech";
    SupportedTranslationLanguages["Danish"] = "danish";
    SupportedTranslationLanguages["Dutch"] = "dutch";
    SupportedTranslationLanguages["English"] = "english";
    SupportedTranslationLanguages["Finnish"] = "finnish";
    SupportedTranslationLanguages["French"] = "french";
    SupportedTranslationLanguages["German"] = "german";
    SupportedTranslationLanguages["Hungarian"] = "hungarian";
    SupportedTranslationLanguages["Italian"] = "italian";
    SupportedTranslationLanguages["Japanese"] = "japanese";
    SupportedTranslationLanguages["Korean"] = "korean";
    SupportedTranslationLanguages["Norwegian"] = "norwegian";
    SupportedTranslationLanguages["Polish"] = "polish";
    SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
    SupportedTranslationLanguages["Russian"] = "russian";
    SupportedTranslationLanguages["Spanish"] = "spanish";
    SupportedTranslationLanguages["Swedish"] = "swedish";
    SupportedTranslationLanguages["Turkish"] = "turkish";
    SupportedTranslationLanguages["Thai"] = "thai";
    SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
    SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    return SupportedTranslationLanguages;
}({});
const $a1a46a58b68b28f1$export$20cfed69f1ef38ea = [
    "english",
    "german",
    "japanese",
    "french",
    "korean",
    "spanish",
    "portugueseBrazilian",
    "russian",
    "dutch",
    "chineseSimplified",
    "polish",
    "italian",
    "chineseTraditional",
    "norwegian",
    "swedish",
    "czech",
    "finnish",
    "danish",
    "hungarian",
    "turkish",
    "thai",
    "ukrainian",
    "vietnamese"
];
const $a1a46a58b68b28f1$export$9e88c4e080b12be6 = [
    "english",
    "german",
    "french",
    "spanish",
    "japanese",
    "portugueseBrazilian",
    "chineseSimplified",
    "korean"
];
module.exports["SupportedTranslationLanguages"] = $a1a46a58b68b28f1$export$c5e4fced70735903;
module.exports["supportedTranslationLanguagesPopularOrder"] = $a1a46a58b68b28f1$export$20cfed69f1ef38ea;
module.exports["refinementSupportedTranslationLanguages"] = $a1a46a58b68b28f1$export$9e88c4e080b12be6;

});

parcelRegister("f6j4r", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $f0b2F = parcelRequire("f0b2F");

const $594c1d8b9183a3bd$export$71f01d1a809741f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "",
        color: "currentColor",
        spacing: "spacious"
    });
module.exports["SummarizeIcon"] = $594c1d8b9183a3bd$export$71f01d1a809741f7;

});

parcelRegister("26Q4g", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

function $1a4bfc80a5a7a205$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics, has3pSources, promptVersion, sourceProduct) {
    return {
        singleInstrumentationID: interactionID ?? '',
        aiInteractionID: interactionID ?? '',
        aiFeatureName: 'Editor AI',
        aiExperienceName: experienceName ?? 'unknown',
        has3pSources: has3pSources,
        isAIFeature: 1,
        proactiveAIGenerated: !!isProactive ? 1 : 0,
        userGeneratedAI: !isProactive ? 1 : 0,
        sourceProduct: sourceProduct,
        traceIds: traceIds,
        invokedFrom: invokedFrom,
        nudgeMetrics: nudgeMetrics,
        promptVersion: promptVersion
    };
}
function $1a4bfc80a5a7a205$export$b0cd7b0ace1e359d({ action: action, interactionID: interactionID, attributes: attributes, experienceName: experienceName, has3pSources: has3pSources, isProactive: isProactive, invokedFrom: invokedFrom, traceIds: traceIds, nudgeMetrics: nudgeMetrics, isStreamingEnded: // Remove below flag when AIFC is fully rolled out in Jira, only required for old experience in Jira.
isStreamingEnded, aiGroupId: aiGroupId, isPayloadCreate: isPayloadCreate, promptVersion: promptVersion, sourceProduct: sourceProduct }) {
    let unifiedAnalyticsAttributes = $1a4bfc80a5a7a205$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics, has3pSources, promptVersion, sourceProduct);
    unifiedAnalyticsAttributes = {
        ...unifiedAnalyticsAttributes,
        isStreamingEnded: isStreamingEnded
    };
    switch(action){
        case (0, $krYZG.ACTION).ACTIONED:
            return {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    aiResultAction: 'unknown',
                    aiGroupId: aiGroupId,
                    ...isPayloadCreate !== undefined && {
                        isPayloadCreate: isPayloadCreate
                    },
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $krYZG.ACTION).VIEWED:
        case (0, $krYZG.ACTION).ERROR:
            return {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $krYZG.ACTION).INITIATED:
        case (0, $krYZG.ACTION).DISMISSED:
            return {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_INTERACTION,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $krYZG.ACTION).SUBMITTED:
            return {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_FEEDBACK,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    // If feedback result is not explicitly set then we should assume negative, since people are more likely to
                    // report negative experiences than they are positive ones.
                    aiFeedbackResult: 'down',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $krYZG.ACTION).DISCARDED:
            return {
                action: action,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
    }
}
module.exports["createUnifiedAnalyticsPayload"] = $1a4bfc80a5a7a205$export$b0cd7b0ace1e359d;

});

parcelRegister("NI1tt", function(module, exports) {
const $84cbbc69df2927ba$var$packageName = "platform-pkg";
const $84cbbc69df2927ba$var$packageVersion = "0.0.0-use.local";
function $84cbbc69df2927ba$export$cd17d76da7967240() {
    return {
        packageName: $84cbbc69df2927ba$var$packageName,
        packageVersion: $84cbbc69df2927ba$var$packageVersion
    };
}
module.exports["getPackageInfo"] = $84cbbc69df2927ba$export$cd17d76da7967240;

});

parcelRegister("kuJJh", function(module, exports) {
var $887a9227d0c6d54c$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["START_WATCHING_REGION"] = "START_WATCHING_REGION";
    ACTIONS["END_WATCHING_REGION"] = "END_WATCHING_REGION";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $887a9227d0c6d54c$export$92a1a3b7554e9387;

});

parcelRegister("3Bmdi", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $ef28d5ac5176acd5$export$3e0658d2a785b1da = new (0, $kCECX.PluginKey)('aiAnnotationWatchmen');
module.exports["aiAnnotationWatchmenPluginKey"] = $ef28d5ac5176acd5$export$3e0658d2a785b1da;

});

parcelRegister("g8hEw", function(module, exports) {
var $1073f37d163a941c$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["INIT_POSITIONS"] = "initPositions";
    ACTIONS["ADJUST_INIT_POSITIONS"] = "adjustInitPositions";
    ACTIONS["UPDATE_STREAM_POSITIONS"] = "updateStream";
    ACTIONS["UPDATE_LOADING_POSITIONS"] = "updateLoadingPos";
    ACTIONS["END_STREAM"] = "endStream";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $1073f37d163a941c$export$92a1a3b7554e9387;

});

parcelRegister("ix5ay", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $750e25d0de739100$export$a61c34149e930535 = new (0, $kCECX.PluginKey)('inEditorDirectStreaming');
module.exports["inEditorDirectStreamingPluginKey"] = $750e25d0de739100$export$a61c34149e930535;

});

parcelRegister("9ybcs", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $25f3f010c9471aa2$export$1a0aec8c8b578c93 = new (0, $kCECX.PluginKey)('purePmInEditorDirectStreaming');
module.exports["purePmInEditorDirectStreamingPluginKey"] = $25f3f010c9471aa2$export$1a0aec8c8b578c93;

});

parcelRegister("9RRio", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $812df0e4ea758146$export$32db9543f41e636c = new (0, $kCECX.PluginKey)('aiExperienceDecoration');
module.exports["aiExperienceDecorationPluginKey"] = $812df0e4ea758146$export$32db9543f41e636c;

});

parcelRegister("f4xcc", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $iDrrr = parcelRequire("iDrrr");

/**
 * Calculates positions from modalDecorationSet and initialPositions.
 * This logic mirrors the calculation done in ContentComponent.
 */ function $048be4ccb16dae4e$var$calculatePositions(modalDecorationSet, initialPositions) {
    // Prioritise getting position from inlineDecoration,
    // otherwise get decoration position from start or end widget
    let positions = [
        0,
        0
    ];
    const decoration = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'modalMountPointDecoration' || spec.key === 'modalMountPointRangeDecoration').shift();
    if (decoration) {
        // when there is decoration, it means it's text selection
        // we need to use the initial positions
        // as the decoration positions are not accurate when there the selection is empty
        if (!initialPositions) return undefined;
        positions = initialPositions;
    } else {
        const nodeDecorations = modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'ai-nodeDecoration');
        if (nodeDecorations.length > 0) {
            const startPos = Math.min(...nodeDecorations.map((decoration)=>decoration.from));
            const endPos = Math.max(...nodeDecorations.map((decoration)=>decoration.to));
            positions = [
                startPos,
                endPos
            ];
        } else return undefined;
    }
    return positions;
}
function $048be4ccb16dae4e$export$1650419e431d3ba3(state, action) {
    switch(action.type){
        case 'END_EXPERIENCE':
            // When the experience ends the plugin state needs to reset everything back to the initial plugin state
            return {
                modalDecorationSet: (0, $8nvEM.DecorationSet).empty,
                dispatchAnalyticsEvent: state.dispatchAnalyticsEvent,
                initialPositions: undefined,
                initialSelection: undefined,
                positions: undefined,
                ...action.data,
                isRunning: false,
                isShowingAcceptRejectScreen: false,
                targetId: state.targetId,
                currentSessionId: state.currentSessionId === state.nextSessionId ? state.currentSessionId : undefined,
                nextSessionId: state.nextSessionId,
                hideLoadingScreen: state.nextSessionId ? state.hideLoadingScreen : false,
                sessionEnded: false,
                isInDocumentStreamingEnabled: state.isInDocumentStreamingEnabled,
                isCreate: undefined,
                singleInstrumentationId: undefined,
                // Clear agent info so it doesn't leak into the next session if END_EXPERIENCE fires
                // before END_SESSION (which the SHOW_MODAL comment below acknowledges can happen).
                agentInfo: undefined,
                agentAttribution: undefined,
                // Preserve the inline-edit ready flag so the floating "ready" bar survives
                // the experience teardown that fires on completion (cleared on View/Close).
                isInlineEditReady: state.isInlineEditReady,
                inlineEditReadyTargetId: state.inlineEditReadyTargetId,
                product: state.product
            };
        case 'SHOW_MODAL':
            return {
                ...state,
                ...action.data,
                // Preserve the existing mount key when omitted so the modal re-anchors
                // without remounting; a new experience sends a fresh timestamp.
                modalMountedTimeStamp: action.data.modalMountedTimeStamp ?? state.modalMountedTimeStamp,
                isRunning: true,
                isShowingAcceptRejectScreen: action.data.withAcceptReject && !state.nextSessionId,
                currentSessionId: state.nextSessionId,
                // if somehow END_EXPERIENCE is called before END_SESSION, reset sessionEnded to false here
                sessionEnded: false,
                positions: $048be4ccb16dae4e$var$calculatePositions(action.data.modalDecorationSet, action.data.initialPositions),
                ignoredSpaceTriggerSelection: undefined,
                isCreate: action.data.isCreate,
                // A new experience starting dismisses any lingering inline-edit ready bar.
                isInlineEditReady: false,
                inlineEditReadyTargetId: undefined
            };
        case 'UPDATE_MODAL_DECORATION_SET':
            return {
                ...state,
                modalDecorationSet: action.data.modalDecorationSet,
                positions: $048be4ccb16dae4e$var$calculatePositions(action.data.modalDecorationSet, state.initialPositions)
            };
        case 'START_SESSION':
            return {
                ...state,
                nextSessionId: action.data.sessionId,
                traceId: action.data.traceId,
                promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? action.data.promptVersion : undefined,
                agentInfo: action.data.agentInfo,
                agentAttribution: action.data.agentAttribution,
                sessionStarted: true,
                sessionEnded: false,
                isShowingAcceptRejectScreen: false
            };
        case 'END_SESSION':
            return {
                ...state,
                nextSessionId: action.data.sessionId,
                currentSessionId: state.isRunning ? state.currentSessionId : action.data.sessionId,
                hideLoadingScreen: false,
                sessionStarted: false,
                sessionEnded: true,
                traceId: undefined,
                promptVersion: undefined,
                agentInfo: undefined,
                agentAttribution: undefined,
                singleInstrumentationId: undefined
            };
        case 'UPDATE_TARGET_ID':
            return {
                ...state,
                targetId: action.data.targetId
            };
        case 'END_INLINE_ROVO_STREAMING':
            return {
                ...state,
                inlineRovoStreamingTargetId: null,
                pendingInlineRovoStreamingTargetId: null
            };
        case 'SHOW_INLINE_EDIT_READY':
            return {
                ...state,
                isInlineEditReady: true,
                inlineEditReadyTargetId: action.data.targetId
            };
        case 'DISMISS_INLINE_EDIT_READY':
            return {
                ...state,
                isInlineEditReady: false,
                inlineEditReadyTargetId: undefined
            };
        case 'STAGE_INLINE_ROVO_STREAMING':
            return {
                ...state,
                pendingInlineRovoStreamingTargetId: action.data.targetId
            };
        case 'COMMIT_INLINE_ROVO_STREAMING':
            {
                const promoted = state.pendingInlineRovoStreamingTargetId ?? null;
                if (promoted == null) // Nothing to commit (e.g. modal opened via a non-toolbar path).
                return state;
                return {
                    ...state,
                    inlineRovoStreamingTargetId: promoted,
                    pendingInlineRovoStreamingTargetId: null
                };
            }
        default:
            return state;
    }
}
module.exports["reducer"] = $048be4ccb16dae4e$export$1650419e431d3ba3;

});

parcelRegister("dSwlt", function(module, exports) {
const $d811fda028b64155$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedNodeDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;
module.exports["hasGeneratedContentDecorations"] = $d811fda028b64155$export$4306d8811b2d2e31;

});

parcelRegister("hloAP", function(module, exports) {
/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */ 
var $eOaGc = parcelRequire("eOaGc");


var $4TgUg = parcelRequire("4TgUg");

function $1d1b8bba4e1f6335$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
    let validPos = pos;
    while(validPos > 0){
        if (doc.resolve(validPos).parent.inlineContent) break;
        validPos--;
    }
    return validPos;
}
function $1d1b8bba4e1f6335$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
    let validPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.resolve(validPos).parent.inlineContent) {
            isValidPos = true;
            break;
        }
        validPos++;
    }
    return validPos;
}
function $1d1b8bba4e1f6335$var$findLastChildWithTextContent(content) {
    if (content.childCount <= 0) return null;
    let count = content.childCount - 1;
    const validNode = content.child(count);
    while(count >= 0){
        if (content.child(count).textContent !== '') break;
        count--;
    }
    return validNode;
}
function $1d1b8bba4e1f6335$var$getEndPosition({ step: step, doc: doc }) {
    let validPos = step.from + step.slice.size;
    let isValidPos = false;
    // Fragments can contain empty nodes, find the last childNode that has textContent
    const validNode = $1d1b8bba4e1f6335$var$findLastChildWithTextContent(step.slice.content);
    // Return start position if there are no valid nodes
    if (!validNode) return step.from;
    // Find textContent of last childNode with textContent
    const textContent = validNode.textContent;
    // Loop through endPos and find position where textBetween start and endPos matches textContent from last childNode in step
    // Check slice created between the positions to ensure no empty child nodes
    while(isValidPos === false && validPos > 0){
        const textBetween = doc.textBetween(step.from, validPos);
        const slice = doc.slice(step.from, validPos);
        if (textBetween.endsWith(textContent) && slice.content.lastChild?.textContent !== '') {
            isValidPos = true;
            break;
        }
        validPos--;
    }
    return validPos;
}
function $1d1b8bba4e1f6335$var$getValidStartTextPosition({ pos: pos, doc: doc }) {
    let startPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.nodeAt(startPos)) {
            isValidPos = true;
            break;
        }
        startPos++;
    }
    return $1d1b8bba4e1f6335$var$getClosestValidTextPositionAfter({
        pos: startPos,
        doc: doc
    });
}
function $1d1b8bba4e1f6335$export$a2bf0757549da456({ step: step, doc: doc }) {
    const endPos = $1d1b8bba4e1f6335$var$getEndPosition({
        step: step,
        doc: doc
    });
    return $1d1b8bba4e1f6335$var$getClosestValidTextPositionBefore({
        pos: endPos,
        doc: doc
    });
}
function $1d1b8bba4e1f6335$export$ec5fde712084a8ed(steps) {
    const step = steps.find((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    if (!step) return null;
    return step;
}
function $1d1b8bba4e1f6335$export$9d1e89ce90c0a9a(transaction, isInDocumentStreamingEnabled) {
    const step = $1d1b8bba4e1f6335$export$ec5fde712084a8ed(transaction.steps);
    if (!step) return null;
    const validStartDecorationPos = $1d1b8bba4e1f6335$var$getValidStartTextPosition({
        pos: step.from,
        doc: transaction.doc
    });
    const validEndDecorationPos = $1d1b8bba4e1f6335$export$a2bf0757549da456({
        step: step,
        doc: transaction.doc
    });
    return (0, $4TgUg.createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos, isInDocumentStreamingEnabled);
}
function $1d1b8bba4e1f6335$export$a6a2b5778b599ea1(transaction) {
    const replaceSteps = transaction.steps.filter((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep));
    if (replaceSteps.length === 0) return [];
    return replaceSteps.map((step)=>{
        const startPos = step.from;
        const node = transaction.doc.nodeAt(startPos);
        if (node) {
            const endPos = startPos + node.nodeSize;
            return (0, $4TgUg.createGeneratedNodeDecorations)(startPos, endPos);
        }
    }).filter((decoration)=>decoration !== undefined);
}
module.exports["getValidEndTextPosition"] = $1d1b8bba4e1f6335$export$a2bf0757549da456;
module.exports["findFirstReplaceStep"] = $1d1b8bba4e1f6335$export$ec5fde712084a8ed;
module.exports["getGeneratedDecorationFromTransaction"] = $1d1b8bba4e1f6335$export$9d1e89ce90c0a9a;
module.exports["getGeneratedNodeDecorationsFromTransaction"] = $1d1b8bba4e1f6335$export$a6a2b5778b599ea1;

});

parcelRegister("4xV3u", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $534e5fbe2db00565$export$90eb11e11e5cf6f9 = new (0, $kCECX.PluginKey)('rovoAgentsPlugin');
module.exports["rovoAgentsPluginKey"] = $534e5fbe2db00565$export$90eb11e11e5cf6f9;

});

parcelRegister("cRnaz", function(module, exports) {

var $lVanm = parcelRequire("lVanm");

const $a2e5f350bf61f33c$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case (0, $lVanm.ACTIONS).UPDATE_PLUGIN_STATE:
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};
module.exports["reducer"] = $a2e5f350bf61f33c$export$1650419e431d3ba3;

});

parcelRegister("gCEOR", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $6U6f6 = parcelRequire("6U6f6");


var $jQvZn = parcelRequire("jQvZn");

function $f96f21d318a567b8$export$351bd6e47d1cc1d0() {
    return (0, $6U6f6.createCommand)(()=>({
            type: (0, $jQvZn.ACTIONS).CLEAR_INLINE_SUGGESTION
        }), (tr, state)=>{
        const { inlineSuggestion: inlineSuggestion } = (0, $6U6f6.getPluginState)(state);
        if (!inlineSuggestion) return tr;
        tr.replaceWith(inlineSuggestion.from, inlineSuggestion.to, inlineSuggestion.suggestedNode);
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(inlineSuggestion.from + inlineSuggestion.suggestedNode.nodeSize)));
        return tr;
    });
}
function $f96f21d318a567b8$export$8cf80a50b9a4edd8() {
    return (0, $6U6f6.createCommand)(()=>({
            type: (0, $jQvZn.ACTIONS).CLEAR_INLINE_SUGGESTION
        }));
}
function $f96f21d318a567b8$export$c0b81cca6dd83656(inlineSuggestion, decorationSet) {
    return (0, $6U6f6.createCommand)(()=>({
            type: (0, $jQvZn.ACTIONS).UPDATE_INLINE_SUGGESTION,
            payload: {
                inlineSuggestion: inlineSuggestion,
                decorationSet: decorationSet
            }
        }));
}
function $f96f21d318a567b8$export$c1428fdaca6ad73f(locale) {
    return (0, $6U6f6.createCommand)(()=>({
            type: (0, $jQvZn.ACTIONS).UPDATE_LOCALE,
            payload: {
                locale: locale
            }
        }));
}
module.exports["insertInlineSuggestion"] = $f96f21d318a567b8$export$351bd6e47d1cc1d0;
module.exports["clearSuggestion"] = $f96f21d318a567b8$export$8cf80a50b9a4edd8;
module.exports["updateInlineSuggestion"] = $f96f21d318a567b8$export$c0b81cca6dd83656;
module.exports["updateLocale"] = $f96f21d318a567b8$export$c1428fdaca6ad73f;

});

parcelRegister("lxBhG", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $Jpwyp = parcelRequire("Jpwyp");

const $84ad017e531bc094$export$d69b88be852b7d7f = {
    type: 'date',
    detect (state, cursorPhrases) {
        const locale = (0, $Jpwyp.LocaleManager).getSelectedLocale(state);
        const sortedPhrases = (0, $Jpwyp.CursorPhraseUtils).sortByDescendingRangeLength(cursorPhrases);
        const match = (0, $Jpwyp.CursorPhraseUtils).findFirstValidDatePhrase(sortedPhrases, locale);
        if (!match || !(0, $Jpwyp.DateUtils).canInsertDateNode(state, match.phrase.from)) return null;
        return {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            id: (0, $03RpJ.default)(),
            type: 'date',
            from: match.phrase.from,
            to: match.phrase.to,
            metadata: {
                date: match.result.date,
                matchedFormat: match.result.matchedFormat,
                trailingDelimiter: match.result.trailingDelimiter
            },
            isPartial: !match.result.matchedFormat.includes('y')
        };
    },
    createMarkers (suggestion) {
        const { from: from, to: to } = suggestion;
        return [
            {
                style: 'highlight',
                from: from,
                to: to
            },
            {
                style: 'underline',
                from: from,
                to: to
            }
        ];
    },
    createCompletionHint (suggestion) {
        if (!suggestion.isPartial) return null;
        const { date: date, matchedFormat: matchedFormat, trailingDelimiter: trailingDelimiter } = suggestion.metadata;
        const formatDelimiter = (0, $Jpwyp.DateParser).extractDelimiterFromFormat(matchedFormat);
        if (trailingDelimiter && trailingDelimiter === formatDelimiter) return {
            hintText: `${date.getFullYear()}`
        };
        else return {
            hintText: `${formatDelimiter}${date.getFullYear()}`
        };
    },
    createReplacement (suggestion, schema) {
        const { date: date } = suggestion.metadata;
        const timestamp = (0, $Jpwyp.DateUtils).getDateOnlyUtcTimestamp(date);
        return schema.nodes.date.create({
            timestamp: String(timestamp)
        });
    }
};
module.exports["dateSuggestionHandler"] = $84ad017e531bc094$export$d69b88be852b7d7f;

});

parcelRegister("lr0VR", function(module, exports) {
class $ec8ac47de3dbb32c$export$68c21ead5a95ee64 {
    static getTextPhrasesAroundCursor(state) {
        const { selection: selection } = state;
        if (!selection || selection.from !== selection.to) return [];
        const { $from: $from } = selection;
        const parent = $from.parent;
        const parentStart = $from.start($from.depth);
        const parentOffset = $from.parentOffset;
        const segments = this.extractPlainTextSegments(parent);
        const segment = this.findSegmentForCursor(segments, parentOffset);
        if (!segment) return [];
        const offsetInSegment = parentOffset - segment.from;
        const words = this.extractWordsFromSegment(segment);
        if (!words.length) return [];
        if (!this.isCursorTouchingWord(words, offsetInSegment)) return [];
        const centralWordIndex = this.findCentralWordIndex(words, offsetInSegment);
        const { nearbyWords: nearbyWords, centralWordPos: centralWordPos } = this.extractNearbyWords(words, centralWordIndex, parentStart, segment.from);
        return this.generateTextPhrases(nearbyWords, centralWordPos);
    }
    static extractPlainTextSegments(parent) {
        const segments = [];
        let currentSegment = null;
        const flushSegment = ()=>{
            if (currentSegment) {
                segments.push(currentSegment);
                currentSegment = null;
            }
        };
        const isPlainText = (child)=>child.isText && !child.marks?.some((mark)=>mark.type.name === 'link');
        parent.forEach((child, offset)=>{
            if (isPlainText(child)) {
                const text = child.text || '';
                if (currentSegment && offset === currentSegment.to) {
                    currentSegment.text += text;
                    currentSegment.to += text.length;
                } else {
                    flushSegment();
                    currentSegment = {
                        text: text,
                        from: offset,
                        to: offset + text.length
                    };
                }
            } else flushSegment();
        });
        flushSegment();
        return segments;
    }
    static findSegmentForCursor(segments, parentOffset) {
        return segments.find((seg)=>parentOffset >= seg.from && parentOffset <= seg.to) || null;
    }
    static isCursorTouchingWord(words, relativeOffset) {
        return words.some((word)=>relativeOffset >= word.start && relativeOffset <= word.end);
    }
    static extractWordsFromSegment(segment) {
        const words = [];
        for (const match of segment.text.matchAll(this.WORD_REGEX))words.push({
            text: match[0],
            start: match.index,
            end: match.index + match[0].length
        });
        return words;
    }
    static findCentralWordIndex(words, cursorOffset) {
        if (words.length === 0) return 0;
        const lastIndex = words.length - 1;
        if (cursorOffset > words[lastIndex].end) return lastIndex;
        let idx = words.findIndex((w)=>w.start <= cursorOffset && w.end >= cursorOffset);
        if (idx === -1) idx = words.findIndex((w)=>w.end === cursorOffset);
        return idx === -1 ? lastIndex : idx;
    }
    static extractNearbyWords(words, centralIndex, basePos, segmentFrom) {
        const adjustWord = (w)=>({
                word: w.text,
                from: basePos + segmentFrom + w.start,
                to: basePos + segmentFrom + w.end
            });
        const startIndex = Math.max(0, centralIndex - this.WORDS_BEFORE_CENTRAL);
        const leftWords = words.slice(startIndex, centralIndex + 1).map(adjustWord);
        const rightWords = words.slice(centralIndex + 1, centralIndex + 1 + this.WORDS_AFTER_CENTRAL).map(adjustWord);
        return {
            nearbyWords: leftWords.concat(rightWords),
            centralWordPos: leftWords.length - 1
        };
    }
    static generateTextPhrases(nearbyWords, centralIndex) {
        const phrases = [];
        for(let start = 0; start <= centralIndex; start++)for(let end = centralIndex; end < nearbyWords.length; end++){
            const phrase = nearbyWords.slice(start, end + 1).map((w)=>w.word).join(' ');
            phrases.push({
                phrase: phrase,
                from: nearbyWords[start].from,
                to: nearbyWords[end].to
            });
        }
        return phrases;
    }
}
// Matches any non-whitespace character
$ec8ac47de3dbb32c$export$68c21ead5a95ee64.WORD_REGEX = /\S+/gu;
$ec8ac47de3dbb32c$export$68c21ead5a95ee64.WORDS_BEFORE_CENTRAL = 4;
$ec8ac47de3dbb32c$export$68c21ead5a95ee64.WORDS_AFTER_CENTRAL = 2;
class $ec8ac47de3dbb32c$export$94affb487e701bf2 {
    get(key, compute) {
        if (this.store.has(key)) {
            const value = this.store.get(key);
            if (value) return value;
        }
        const value = compute();
        if (value) this.set(key, value);
        return value;
    }
    set(key, value) {
        if (this.store.size >= this.maxSize) {
            const oldestKey = this.store.keys().next().value;
            if (oldestKey) this.store.delete(oldestKey);
        }
        this.store.set(key, value);
    }
    constructor(maxSize = 10000){
        this.maxSize = maxSize;
        this.store = new Map();
        this.maxSize = maxSize;
    }
}
module.exports["TextPhraseExtractor"] = $ec8ac47de3dbb32c$export$68c21ead5a95ee64;
module.exports["Cache"] = $ec8ac47de3dbb32c$export$94affb487e701bf2;

});

parcelRegister("cg8YD", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $4c39624fd07b2324$export$75940366de9545d9 = new (0, $kCECX.PluginKey)('aiInlineSuggestion');
module.exports["inlineSuggestionPluginKey"] = $4c39624fd07b2324$export$75940366de9545d9;

});

parcelRegister("bJf0u", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $8nvEM = parcelRequire("8nvEM");


var $jQvZn = parcelRequire("jQvZn");

const $c9035ef9f888311e$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case (0, $jQvZn.ACTIONS).CLEAR_INLINE_SUGGESTION:
            return {
                ...pluginState,
                inlineSuggestion: null,
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                inlineSuggestionSessionId: null
            };
        case (0, $jQvZn.ACTIONS).UPDATE_INLINE_SUGGESTION:
            {
                let sessionID = null;
                if (action.payload.inlineSuggestion) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                sessionID = pluginState.inlineSuggestion ? pluginState.inlineSuggestionSessionId : (0, $03RpJ.default)();
                return {
                    ...pluginState,
                    inlineSuggestion: action.payload.inlineSuggestion,
                    decorationSet: action.payload.decorationSet,
                    inlineSuggestionSessionId: sessionID
                };
            }
        case (0, $jQvZn.ACTIONS).UPDATE_LOCALE:
            return {
                ...pluginState,
                locale: action.payload.locale
            };
        default:
            return pluginState;
    }
};
module.exports["reducer"] = $c9035ef9f888311e$export$1650419e431d3ba3;

});

parcelRegister("6NNvG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $ed8f7833d5364dd5$export$2b86bedf890eab8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useElementSize() {
    const $ = (0, $bDgLe.c)(6);
    const [element, setElement] = (0, $cozmU.useState)(null);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] !== element) {
        t0 = ()=>{
            if (!element) return;
            const updateSize = ()=>{
                const { width: width_0, height: height_0 } = element.getBoundingClientRect();
                setWidth(width_0);
                setHeight(height_0);
            };
            const resizeObserver = new ResizeObserver(updateSize);
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t1 = [
            element
        ];
        $[0] = element;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = [
            setElement,
            {
                width: width,
                height: height
            }
        ];
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function useElementSize() {
    const [element, setElement] = (0, $cozmU.useState)(null);
    const [width, setWidth] = (0, $cozmU.useState)(0);
    const [height, setHeight] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        if (!element) return;
        // Do no use here ResizeObserverEntry.contentRect as it is only a content size (without padding and border)
        // and we need the size of the whole element.
        const updateSize = ()=>{
            const { width: width_0, height: height_0 } = element.getBoundingClientRect();
            setWidth(width_0);
            setHeight(height_0);
        };
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return (0, $cozmU.useMemo)(()=>[
            setElement,
            {
                width: width,
                height: height
            }
        ], [
        width,
        height
    ]);
};
module.exports["useElementSize"] = $ed8f7833d5364dd5$export$2b86bedf890eab8;

});

parcelRegister("aIj6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0c3c34131e63d426$export$3c680cd252b2bab9 = `conic-gradient(
	from var(--gradient-angle, 45deg),
	#FCA700 0%,
	#6A9A23 25%,
	#1868DB 50%,
	#AF59E0 75%,
	#FCA700 100%
)`;
// ── Register @property imperatively ─────────────────────────────────────────
let $0c3c34131e63d426$var$propertyRegistered = false;
function $0c3c34131e63d426$var$ensureGradientAngleRegistered() {
    if ($0c3c34131e63d426$var$propertyRegistered) return;
    if (typeof window === 'undefined' || typeof CSS === 'undefined') return;
    $0c3c34131e63d426$var$propertyRegistered = true;
    try {
        if (typeof CSS.registerProperty === 'function') CSS.registerProperty({
            name: '--gradient-angle',
            syntax: '<angle>',
            initialValue: '270deg',
            inherits: false
        });
    } catch  {
    // Property may already be registered, or browser doesn't support it.
    // The gradient will still render but without rotation animation.
    }
}
// ── Component ───────────────────────────────────────────────────────────────
const $0c3c34131e63d426$var$KEYFRAMES_CSS = `
@keyframes rovoGradientRotation {
	0% { --gradient-angle: 0deg; }
	100% { --gradient-angle: 360deg; }
}
`;
const $0c3c34131e63d426$export$5df21a6b23721c17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useEffect)($0c3c34131e63d426$var$_temp, t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style", {
            dangerouslySetInnerHTML: {
                __html: $0c3c34131e63d426$var$KEYFRAMES_CSS
            }
        });
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    (0, $cozmU.useEffect)(()=>{
        $0c3c34131e63d426$var$ensureGradientAngleRegistered();
    }, []);
    // eslint-disable-next-line react/no-danger, @atlaskit/ui-styling-standard/no-global-styles -- @keyframes for CSS custom property animation
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement('style', {
        dangerouslySetInnerHTML: {
            __html: $0c3c34131e63d426$var$KEYFRAMES_CSS
        }
    });
};
function $0c3c34131e63d426$var$_temp() {
    $0c3c34131e63d426$var$ensureGradientAngleRegistered();
}
module.exports["ROVO_GRADIENT_BACKGROUND"] = $0c3c34131e63d426$export$3c680cd252b2bab9;
module.exports["RovoGradientKeyframesStyle"] = $0c3c34131e63d426$export$5df21a6b23721c17;

});

parcelRegister("4D2QO", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $161op = parcelRequire("161op");

const $b3bef3688438021d$export$e0578d9df5b50dd4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FooterAIBrand(t0) {
    const $ = (0, $bDgLe.c)(10);
    const { appearance: appearance } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== appearance || $[1] !== formatMessage) {
        t1 = appearance !== "small" && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtle",
                children: formatMessage((0, $161op.default).rovoCopyright)
            })
        });
        $[0] = appearance;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== formatMessage) {
        t2 = formatMessage((0, $161op.default).rovoCopyright);
        $[3] = formatMessage;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bltJZ.RovoIcon), {
            label: t2,
            appearance: "neutral",
            size: "small"
        });
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            children: [
                t1,
                t3
            ]
        });
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : function FooterAIBrand({ appearance: appearance }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        children: [
            appearance !== 'small' && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    size: "small",
                    color: "color.text.subtle",
                    children: formatMessage((0, $161op.default).rovoCopyright)
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bltJZ.RovoIcon), {
                label: formatMessage((0, $161op.default).rovoCopyright),
                appearance: "neutral",
                size: "small"
            })
        ]
    });
};
module.exports["FooterAIBrand"] = $b3bef3688438021d$export$e0578d9df5b50dd4;

});

parcelRegister("9sR23", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a1ZzW = parcelRequire("a1ZzW");


var $fodiz = parcelRequire("fodiz");


var $7vK9E = parcelRequire("7vK9E");

var $1l0kj = parcelRequire("1l0kj");


var $161op = parcelRequire("161op");


var $eTQ44 = parcelRequire("eTQ44");

const $0e890181b1a6ef4b$var$linkStyles = {
    default: "_2sNsIg7NXe _1UtDYzZpcK _2nTuUYZpcK"
};
const $0e890181b1a6ef4b$export$d8e84a6a42a1313b = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FooterDisclaimer(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { disclaimer: disclaimer, isAIFC: isAIFC } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== disclaimer || $[1] !== formatMessage || $[2] !== isAIFC) {
        t1 = disclaimer ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eTQ44.CustomDisclaimer), {
            disclaimer: disclaimer
        }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            children: [
                isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                    label: formatMessage((0, $161op.default).infoIconLabel),
                    color: "var(--ds-text-subtle, #505258)",
                    size: "small"
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: formatMessage((0, $161op.default).infoIconLabel),
                    color: "var(--ds-text-subtle, #505258)",
                    size: "small"
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                    color: "var(--ds-text-subtle, #505258)",
                    href: "https://www.atlassian.com/trust/atlassian-intelligence",
                    xcss: $0e890181b1a6ef4b$var$linkStyles.default,
                    children: formatMessage((0, $161op.default).disclaimerTextUpdated)
                })
            ]
        });
        $[0] = disclaimer;
        $[1] = formatMessage;
        $[2] = isAIFC;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function FooterDisclaimer({ disclaimer: disclaimer, appearance: appearance, isAIFC: isAIFC }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return disclaimer ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eTQ44.CustomDisclaimer), {
        disclaimer: disclaimer
    }) : /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center",
        children: [
            isAIFC ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                label: formatMessage((0, $161op.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                size: "small"
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                label: formatMessage((0, $161op.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                size: "small"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                color: "var(--ds-text-subtle, #505258)",
                href: "https://www.atlassian.com/trust/atlassian-intelligence",
                xcss: $0e890181b1a6ef4b$var$linkStyles.default,
                children: formatMessage((0, $161op.default).disclaimerTextUpdated)
            })
        ]
    });
};
module.exports["FooterDisclaimer"] = $0e890181b1a6ef4b$export$d8e84a6a42a1313b;

});

parcelRegister("121e3", function(module, exports) {
// Source: https://www.figma.com/design/2do7MeD1hEmSftXLGER1Xy/AI-Patterns-2024?node-id=82-12683&t=bPIR0f4r8UiwwCr1-4
const $58a0f16a63f1849e$export$3d1352baed9f774a = {
    medium: 328,
    large: 624
};
const $58a0f16a63f1849e$export$f859a198decf7af = {
    medium: 300,
    large: 480
};
module.exports["AI_BREAKPOINTS"] = $58a0f16a63f1849e$export$3d1352baed9f774a;
module.exports["ROVO_BREAKPOINTS"] = $58a0f16a63f1849e$export$f859a198decf7af;

});

parcelRegister("161op", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $70013ba6fcd77b65$var$message = (0, $kSwu1.defineMessages)({
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    infoIconLabel: {
        id: "fabric.editor.ai.commandPalette.footer.infoIconLabel",
        defaultMessage: "Information"
    },
    atlassianIntelligenceCopyrightShort: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    rovoCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.rovoCopyright",
        defaultMessage: "Rovo"
    },
    disclaimerTextUpdated: {
        id: "fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated",
        defaultMessage: "Uses AI. Verify results."
    },
    usePageKnowledgeToggleLabel: {
        id: "fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel",
        defaultMessage: "Include knowledge from current page"
    },
    compactFeedbackText: {
        id: "fabric.editor.ai.screens.preview.compactFeedbackText",
        defaultMessage: "Helpful?"
    }
});
var $70013ba6fcd77b65$export$2e2bcd8739ae039 = $70013ba6fcd77b65$var$message;
module.exports["default"] = $70013ba6fcd77b65$export$2e2bcd8739ae039;

});

parcelRegister("eVwUu", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $hq9Cp = parcelRequire("hq9Cp");


var $6gGPb = parcelRequire("6gGPb");

const $004ffa83d7a78cf2$export$e8e2b5fd4b3854f2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useAgentRefinementTagProps(agent) {
    const $ = (0, $bDgLe.c)(9);
    let t0;
    if (agent) {
        const t1 = agent.externalConfigReference ?? agent.namedId;
        let t2;
        if ($[0] !== agent.creatorType) {
            t2 = (0, $iDrrr.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creatorType) : agent.creatorType === "FORGE";
            $[0] = agent.creatorType;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== agent.icon || $[3] !== agent.id || $[4] !== agent.identityAccountId || $[5] !== agent.name || $[6] !== t1 || $[7] !== t2) {
            t3 = {
                elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    "data-testId": "command-palette-rovo-agent-icon",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                        agentId: agent.id,
                        agentNamedId: t1,
                        agentIdentityAccountId: agent.identityAccountId,
                        isForgeAgent: t2,
                        forgeAgentIconUrl: agent.icon,
                        label: agent.name,
                        size: "xxsmall"
                    })
                }),
                appearance: "rounded"
            };
            $[2] = agent.icon;
            $[3] = agent.id;
            $[4] = agent.identityAccountId;
            $[5] = agent.name;
            $[6] = t1;
            $[7] = t2;
            $[8] = t3;
        } else t3 = $[8];
        t0 = t3;
    } else t0 = undefined;
    const props = t0;
    return props;
} : function useAgentRefinementTagProps(agent) {
    const props = (0, $cozmU.useMemo)(()=>{
        if (agent) return {
            elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-testId": "command-palette-rovo-agent-icon",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6gGPb.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: (0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creatorType) : agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon,
                    label: agent.name,
                    size: "xxsmall"
                })
            }),
            appearance: 'rounded'
        };
        else return undefined;
    }, [
        agent
    ]);
    return props;
};
module.exports["useAgentRefinementTagProps"] = $004ffa83d7a78cf2$export$e8e2b5fd4b3854f2;

});

parcelRegister("gDDkj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $iW7aI = parcelRequire("iW7aI");


var $4ez2K = parcelRequire("4ez2K");


var $dPu8G = parcelRequire("dPu8G");

const $34c2306e769b1dde$var$inPromptHeaderStyles = {
    default: "_3iDTPbccYA _0adFHs1Y8M"
};
const $34c2306e769b1dde$var$toolTipProps = {
    position: 'top'
};
const $34c2306e769b1dde$export$dcf44e0bed76850 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { inPromptHeader: inPromptHeader, isDisabled: t1, stopPropagation: stopPropagation, onClick: onClick } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== onClick || $[1] !== stopPropagation) {
        t2 = (event)=>{
            if (stopPropagation) event.stopPropagation();
            onClick?.();
        };
        $[0] = onClick;
        $[1] = stopPropagation;
        $[2] = t2;
    } else t2 = $[2];
    const onClickIconButton = t2;
    let t3;
    if ($[3] !== formatMessage) {
        t3 = formatMessage((0, $dPu8G.default).backLabel);
        $[3] = formatMessage;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isDisabled || $[6] !== onClickIconButton || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            isDisabled: isDisabled,
            appearance: "subtle",
            icon: $34c2306e769b1dde$var$_temp,
            label: t3,
            spacing: "compact",
            isTooltipDisabled: isDisabled,
            onClick: onClickIconButton,
            testId: "back-icon-button",
            tooltip: $34c2306e769b1dde$var$toolTipProps
        });
        $[5] = isDisabled;
        $[6] = onClickIconButton;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const btn = t4;
    if (inPromptHeader) {
        let t5;
        if ($[9] !== btn) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
                xcss: $34c2306e769b1dde$var$inPromptHeaderStyles.default,
                children: btn
            });
            $[9] = btn;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    }
    return btn;
} : ({ inPromptHeader: inPromptHeader, isDisabled: isDisabled = false, stopPropagation: stopPropagation, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onClickIconButton = (0, $cozmU.useCallback)((event)=>{
        if (stopPropagation) event.stopPropagation();
        onClick?.();
    }, [
        stopPropagation,
        onClick
    ]);
    const btn = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        isDisabled: isDisabled,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
                label: iconProps.label,
                testId: iconProps.testId,
                size: "small"
            }),
        label: formatMessage((0, $dPu8G.default).backLabel),
        spacing: "compact",
        isTooltipDisabled: isDisabled,
        onClick: onClickIconButton,
        testId: "back-icon-button",
        tooltip: $34c2306e769b1dde$var$toolTipProps
    });
    if (inPromptHeader) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        xcss: $34c2306e769b1dde$var$inPromptHeaderStyles.default,
        children: btn
    });
    return btn;
};
function $34c2306e769b1dde$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
        label: iconProps.label,
        testId: iconProps.testId,
        size: "small"
    });
}
module.exports["BackIconButton"] = $34c2306e769b1dde$export$dcf44e0bed76850;

});

parcelRegister("lo86r", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $4ez2K = parcelRequire("4ez2K");


var $bsPKy = parcelRequire("bsPKy");

const $35e3bf8073c30c2c$var$inPromptHeaderStyles = {
    default: "_3iDTPbccYA _0adFHs1Y8M"
};
const $35e3bf8073c30c2c$var$toolTipProps = {
    position: 'top'
};
const $35e3bf8073c30c2c$export$d428cfd0d6a2b2ec = 'close-preview-icon-button';
const $35e3bf8073c30c2c$export$777abcc87b2abd7a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage((0, $bsPKy.default).closePreviewLabel);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClick || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $35e3bf8073c30c2c$var$inPromptHeaderStyles.default,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                label: t1,
                spacing: "compact",
                onClick: onClick,
                testId: $35e3bf8073c30c2c$export$d428cfd0d6a2b2ec,
                tooltip: $35e3bf8073c30c2c$var$toolTipProps,
                isTooltipDisabled: false
            })
        });
        $[2] = onClick;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
        xcss: $35e3bf8073c30c2c$var$inPromptHeaderStyles.default,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $bsPKy.default).closePreviewLabel),
            spacing: "compact",
            onClick: onClick,
            testId: $35e3bf8073c30c2c$export$d428cfd0d6a2b2ec,
            tooltip: $35e3bf8073c30c2c$var$toolTipProps,
            isTooltipDisabled: false
        })
    });
};
module.exports["ClosePreviewIconButton"] = $35e3bf8073c30c2c$export$777abcc87b2abd7a;

});

parcelRegister("7miJK", function(module, exports) {
/* EditPromptHoverTag.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $IOtUu = parcelRequire("IOtUu");


var $j9lWE = parcelRequire("j9lWE");

const $1921a2e0abcc8118$var$containerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $1921a2e0abcc8118$var$containerStylesUnbounded = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $1921a2e0abcc8118$var$placeholderStyles = null;
const $1921a2e0abcc8118$export$3a1fe5569d8f8994 = ({ isClearMode: isClearMode = false, isPlaceholder: isPlaceholder })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const text = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return isClearMode ? formatMessage((0, $j9lWE.messages).clearPromptHover) : formatMessage((0, $j9lWE.messages).editPromptHover);
    }, [
        isClearMode,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        id: "edit-prompt-hover-button",
        "data-testid": "edit-prompt-hover-button",
        className: (0, $hekY6.default)([
            "_3YEZNOdnbC _2XsHFMIZbP _313842Ll21 _1DCdHiLl21 _3iDTPbccYA _1YKVNsdnbC",
            "_3Wjuo9dnbC _3sShCTdnbC _3iDqfidnbC _3SBvTudnbC _4rSHuF7zJH _35yGzrFQfX _3cEQOEFQfX _4EhKlBgVvo _19L4DXgVvo",
            isPlaceholder && "_4rSHuF18ZR"
        ]),
        children: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            text: text,
            isRemovable: false
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            text: text,
            isRemovable: false
        })
    });
};
module.exports["EditPromptHoverTag"] = $1921a2e0abcc8118$export$3a1fe5569d8f8994;

});

parcelRegister("hWovL", function(module, exports) {
/* LatestPromptRenderer.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3BY7M = parcelRequire("3BY7M");


var $hRnS5 = parcelRequire("hRnS5");

const $7c5182516d9beb8f$var$rendererContainerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $7c5182516d9beb8f$var$rendererDocumentStyles = null;
const $7c5182516d9beb8f$var$RendererWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _1o0n5jnQyn _34okjnnQyn _0MmMevz8Lp _1GGjPKLRg7 _4yiHrEIZbP _21YEOJwPeg _0OLhWuTttU _19pQuJ2ADO _4sK56t7dHp _19pTuk7dHp _1FgFFOM8LS _3313pSogpp _3Ss5aYJ5bs _1IM3BULRg7",
            "_0NUa3rP4Mn _1uQyXF7nsb _4mcZYcoWWg"
        ]),
        children: children
    });
};
const $7c5182516d9beb8f$export$308e8087851b72a3 = ({ promptADF: promptADF, providerFactory: providerFactory })=>{
    const jsonDocument = promptADF;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hRnS5.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($7c5182516d9beb8f$var$RendererWrapper, {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3BY7M.default), {
                document: jsonDocument,
                media: {
                    // We don't currently support images with captions
                    allowLinking: false
                },
                // the nodes and marks the markdown transformer can create.
                // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
                useSpecBasedValidator: true,
                dataProviders: providerFactory,
                maxHeight: 20
            })
        })
    });
};
module.exports["LatestPromptRenderer"] = $7c5182516d9beb8f$export$308e8087851b72a3;

});

parcelRegister("bDDw8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $IOtUu = parcelRequire("IOtUu");


var $j9bxK = parcelRequire("j9bxK");

const $504c8f6bef1dfaa9$var$cssVars = {
    alignItems: '--align-items',
    elemBeforeHeight: '--elem-before-height'
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $504c8f6bef1dfaa9$var$refinementTagStylesVisualRefresh = null; /**
                                                * RefinementTag is the component which renders the
                                                * title of preset prompts such as
                                                * - Brainstorm
                                                * - Summarize
                                                *
                                                * When rendered as part of a user input field, it should provide an
                                                * onClick to display the remove button to allow users to remove the tag.
                                                * When rendered as a presentational element to show which
                                                * preset prompt has been used, it should not provide an onClick
                                                * to keep the tag presentational.
                                                */ 
const $504c8f6bef1dfaa9$export$21c661408d518ab6 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(18);
    const { label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance } = t0;
    const t1 = appearance === "rounded" ? "center" : "flex-start";
    const t2 = appearance === "rounded" ? "100%" : "auto";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            [$504c8f6bef1dfaa9$var$cssVars.alignItems]: t1,
            [$504c8f6bef1dfaa9$var$cssVars.elemBeforeHeight]: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const styles = t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4FNLNUdnbC _0wyYyZdnbC _05nT0YdnbC _08IXD0dnbC _2XEXRm8yf6 _3HqjNhdnbC _0JpzAPdnbC _1TvIKmdBwA _1McnIXBpy3",
            "refinement-tag"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== formatMessage || $[5] !== label) {
        t5 = formatMessage((0, $j9bxK.default).promptSelected, {
            promptName: label
        });
        $[4] = formatMessage;
        $[5] = label;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== appearance || $[8] !== elemBefore || $[9] !== formatMessage || $[10] !== label || $[11] !== onClick) {
        t6 = !onClick ? (0, $iDrrr.fg)("confluence_fronend_labels_categorization_migration") ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            testId: "refinement-tag",
            text: label,
            elemBefore: elemBefore,
            isRemovable: false
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            testId: "refinement-tag",
            text: label,
            elemBefore: elemBefore,
            appearance: appearance,
            isRemovable: false
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            appearance: (0, $iDrrr.fg)("confluence_fronend_labels_categorization_migration") ? undefined : appearance,
            elemBefore: elemBefore,
            testId: "refinement-tag",
            removeButtonLabel: formatMessage((0, $j9bxK.default).removeLabel),
            text: label,
            onBeforeRemoveAction: ()=>{
                onClick();
                return false;
            }
        });
        $[7] = appearance;
        $[8] = elemBefore;
        $[9] = formatMessage;
        $[10] = label;
        $[11] = onClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== ref || $[14] !== styles || $[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: styles,
            className: t4,
            "data-testid": "command-palette-refinement-tag",
            role: "status",
            "aria-atomic": "true",
            "aria-label": t5,
            "aria-live": "assertive",
            ref: ref,
            children: t6
        });
        $[13] = ref;
        $[14] = styles;
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance }, ref)=>{
    const styles = {
        [$504c8f6bef1dfaa9$var$cssVars.alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
        [$504c8f6bef1dfaa9$var$cssVars.elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4FNLNUdnbC _0wyYyZdnbC _05nT0YdnbC _08IXD0dnbC _2XEXRm8yf6 _3HqjNhdnbC _0JpzAPdnbC _1TvIKmdBwA _1McnIXBpy3",
            "refinement-tag"
        ]),
        "data-testid": "command-palette-refinement-tag",
        role: "status",
        "aria-atomic": "true",
        "aria-label": formatMessage((0, $j9bxK.default).promptSelected, {
            promptName: label
        }),
        "aria-live": "assertive",
        ref: ref,
        children: !onClick ? (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            testId: 'refinement-tag',
            text: label,
            elemBefore: elemBefore,
            isRemovable: false
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            testId: 'refinement-tag',
            text: label,
            elemBefore: elemBefore,
            appearance: appearance,
            isRemovable: false
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $IOtUu.default), {
            appearance: (0, $iDrrr.fg)('confluence_fronend_labels_categorization_migration') ? undefined : appearance,
            elemBefore: elemBefore,
            testId: 'refinement-tag',
            removeButtonLabel: formatMessage((0, $j9bxK.default).removeLabel),
            text: label,
            onBeforeRemoveAction: ()=>{
                onClick();
                return false;
            }
        })
    });
});
module.exports["RefinementTag"] = $504c8f6bef1dfaa9$export$21c661408d518ab6;

});

parcelRegister("9iuHu", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c2c7d133feb4e855$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    editPrompt: {
        id: "fabric.editor.ai.screens.preview.header.edit",
        defaultMessage: "Edit prompt"
    }
});
module.exports["messages"] = $c2c7d133feb4e855$export$defe85febe8b728c;

});

parcelRegister("iIBeI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");

const $eabfb517ca94209d$export$52cd484a7ef4f2b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        label: "",
        spacing: "spacious"
    });
module.exports["ChatIcon"] = $eabfb517ca94209d$export$52cd484a7ef4f2b9;

});

parcelRegister("jQvZn", function(module, exports) {
var $23055a4c2cd2a7c4$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["CLEAR_INLINE_SUGGESTION"] = "CLEAR_INLINE_SUGGESTION";
    ACTIONS["UPDATE_INLINE_SUGGESTION"] = "UPDATE_INLINE_SUGGESTION";
    ACTIONS["UPDATE_LOCALE"] = "UPDATE_LOCALE";
    return ACTIONS;
}({});
module.exports["ACTIONS"] = $23055a4c2cd2a7c4$export$92a1a3b7554e9387;

});

parcelRegister("Jpwyp", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $fDAOo = parcelRequire("fDAOo");

var $esV19 = parcelRequire("esV19");

var $hSoEi = parcelRequire("hSoEi");


var $6U6f6 = parcelRequire("6U6f6");


var $lr0VR = parcelRequire("lr0VR");


var $dXhIm = parcelRequire("dXhIm");

class $34e6c60de48f3e97$export$9a5c40674650b7fa {
    static getSelectedLocale(state) {
        const pluginState = (0, $6U6f6.getPluginState)(state);
        return pluginState?.locale || 'en-US';
    }
}
$34e6c60de48f3e97$export$9a5c40674650b7fa.LOCALES = (0, $dXhIm.LOCALES_LIST);
class $34e6c60de48f3e97$export$e8d4b28a20981dd2 {
    static isPotentialDateString(input) {
        return this.REGEXES.DIGITS.test(input) && input.length >= this.MIN_DATE_LENGTH && input.length <= this.MAX_DATE_LENGTH;
    }
    static containsAmbiguousMonth(input) {
        const matches = input.match(this.REGEXES.ALL_ALPHABET_CHARS);
        if (!matches) return false;
        const longestTokenLength = matches.reduce((max, token)=>Math.max(max, token.length), 0);
        return longestTokenLength <= 2;
    }
    static containsYear(format) {
        return format.includes('y');
    }
    static isEnteredDateAfterToday(date) {
        const today = new Date();
        const todayDate = today.getDate();
        const todayMonth = today.getMonth() + 1;
        // If it's the same month and day as today, consider it as "after or equal to" today
        if (todayMonth === date.getMonth() + 1 && todayDate === date.getDate()) return true;
        // Check if today's date is before the entered date (comparing month and day only)
        // Case 1: Today's month is earlier than the entered month
        // Case 2: Same month, but today's day is earlier than the entered day
        return todayMonth < date.getMonth() + 1 || todayMonth === date.getMonth() + 1 && todayDate < date.getDate();
    }
    static normaliseYear(date, format) {
        const year = date.getFullYear();
        const isEnteredDateAfterToday = this.isEnteredDateAfterToday(date);
        if (year < 100) date = (0, $fDAOo.default)(date, year < this.SHORT_YEAR_CUTOFF ? 2000 : 1900);
        else if (year < 1000) date = (0, $fDAOo.default)(date, 2000);
        else if (!this.containsYear(format)) // This only applies for partial numeric formats.
        // If the entered date is after today, add 0 years. Otherwise, add 1 year
        // If it's equal to today, add 0 years.
        date = (0, $fDAOo.default)(date, isEnteredDateAfterToday ? 0 : 1);
        return date;
    }
    static analyzeDelimiters(input) {
        const delimiterMatches = input.match(this.REGEXES.ALL_DATE_DELIMITERS_COMMA) || [];
        const uniqueDelims = new Set(delimiterMatches);
        const hasMixedDelimiters = uniqueDelims.size > 1;
        const trailingCharMatch = input.match(this.REGEXES.TRAILING_DATE_DELIMITER_COMMA);
        let trailingDelimiter = null;
        let strippedInput = input;
        if (trailingCharMatch) {
            trailingDelimiter = trailingCharMatch[0];
            strippedInput = input.slice(0, -1);
        }
        return {
            hasMixedDelimiters: hasMixedDelimiters,
            trailingDelimiter: trailingDelimiter,
            strippedInput: strippedInput
        };
    }
    static tryAllFormats(strippedInput, trailingDelimiter, locale) {
        if (!(0, $dXhIm.isSupportedLocale)(locale)) return null;
        const dateFnsLocale = $34e6c60de48f3e97$export$9a5c40674650b7fa.LOCALES[locale];
        const formats = this.DATE_FORMATS_BY_LOCALE[locale];
        for (const format of formats){
            const parsed = (0, $hSoEi.default)(strippedInput, format, new Date(), {
                locale: dateFnsLocale
            });
            if ((0, $esV19.default)(parsed)) return {
                date: this.normaliseYear(parsed, format),
                matchedFormat: format,
                trailingDelimiter: trailingDelimiter
            };
        }
        return null;
    }
    static parse(input, locale) {
        if (!this.isPotentialDateString(input) || this.containsAmbiguousMonth(input)) return null;
        const { hasMixedDelimiters: hasMixedDelimiters, trailingDelimiter: trailingDelimiter, strippedInput: strippedInput } = this.analyzeDelimiters(input);
        if (hasMixedDelimiters) return null;
        return this.cache.get(`${locale}:${input}`, ()=>{
            return this.tryAllFormats(strippedInput, trailingDelimiter, locale);
        });
    }
    static extractDelimiterFromFormat(matchedFormat) {
        return matchedFormat.match(this.REGEXES.NON_ALPHABET_CHARS)?.[0] ?? ' ';
    }
}
$34e6c60de48f3e97$export$e8d4b28a20981dd2.MIN_DATE_LENGTH = 3;
$34e6c60de48f3e97$export$e8d4b28a20981dd2.MAX_DATE_LENGTH = 20;
$34e6c60de48f3e97$export$e8d4b28a20981dd2.SHORT_YEAR_CUTOFF = 60;
$34e6c60de48f3e97$export$e8d4b28a20981dd2.DATE_FORMATS_BY_LOCALE = (0, $dXhIm.DATE_FORMATS_BY_LOCALE_LIST);
$34e6c60de48f3e97$export$e8d4b28a20981dd2.REGEXES = {
    TRAILING_DATE_DELIMITER_COMMA: /[-/.,]$/u,
    ALL_DATE_DELIMITERS_COMMA: /[-/.,]/gu,
    ALL_DATE_DELIMITERS: /[-/.]/gu,
    NON_ALPHABET_CHARS: /[^A-Za-z]/u,
    ALL_ALPHABET_CHARS: /[A-Za-z]+/gu,
    DIGITS: /\d/u
};
$34e6c60de48f3e97$export$e8d4b28a20981dd2.cache = new (0, $lr0VR.Cache)();
class $34e6c60de48f3e97$export$3e048df13f4eb60b {
    static getDateOnlyUtcTimestamp(date) {
        return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    }
    static canInsertDateNode(state, pos) {
        const dateType = state?.schema?.nodes?.date;
        if (!dateType) return false;
        const $pos = state.doc.resolve(pos);
        return $pos.parent.canReplaceWith($pos.index(), $pos.index(), dateType);
    }
}
class $34e6c60de48f3e97$export$cc88dec3a6065079 {
    static sortByDescendingRangeLength(phrases) {
        return phrases.slice().sort((a, b)=>{
            const aLength = a.to - a.from;
            const bLength = b.to - b.from;
            return bLength - aLength;
        });
    }
    static findFirstValidDatePhrase(phrases, locale) {
        for (const phrase of phrases){
            const result = $34e6c60de48f3e97$export$e8d4b28a20981dd2.parse(phrase.phrase, locale);
            if (result) return {
                phrase: phrase,
                result: result
            };
        }
        return null;
    }
}
module.exports["LocaleManager"] = $34e6c60de48f3e97$export$9a5c40674650b7fa;
module.exports["DateParser"] = $34e6c60de48f3e97$export$e8d4b28a20981dd2;
module.exports["DateUtils"] = $34e6c60de48f3e97$export$3e048df13f4eb60b;
module.exports["CursorPhraseUtils"] = $34e6c60de48f3e97$export$cc88dec3a6065079;

});

parcelRegister("eTQ44", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");


var $lpNn5 = parcelRequire("lpNn5");

const $72eaa8705263e129$var$footerInformationStylesUnbounded = null;
const $72eaa8705263e129$var$footerInformationStyles = null;
const $72eaa8705263e129$export$2cebd3bbd14f5ea6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CustomDisclaimer(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { disclaimer: disclaimer } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT",
            "_4ouGXIdnbC _4kiQYANHnM _4FihXq7NXe _0l4aCI7NXe _1XeKG3ZpcK _2Sx5g4ZpcK _37KmxRdnbC _4b5CpDdnbC _3Wjuo91Y8M _3sShCT1Y8M _3iDqfi1Y8M"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== disclaimer.text || $[2] !== disclaimer.url) {
        t2 = disclaimer.url ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
            href: disclaimer.url,
            target: "_blank",
            rel: "noopener noreferrer",
            children: disclaimer.text
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            children: disclaimer.text
        });
        $[1] = disclaimer.text;
        $[2] = disclaimer.url;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== disclaimer.tooltip || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t1,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                testId: "custom-disclaimer",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: disclaimer.tooltip,
                    position: "top",
                    children: t2
                })
            })
        });
        $[4] = disclaimer.tooltip;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : function CustomDisclaimer({ disclaimer: disclaimer }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT",
            "_4ouGXIdnbC _4kiQYANHnM _4FihXq7NXe _0l4aCI7NXe _1XeKG3ZpcK _2Sx5g4ZpcK _37KmxRdnbC _4b5CpDdnbC _3Wjuo91Y8M _3sShCT1Y8M _3iDqfi1Y8M"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: "custom-disclaimer",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: disclaimer.tooltip,
                position: "top",
                children: disclaimer.url ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $i1t43.default), {
                    href: disclaimer.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: disclaimer.text
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                    children: disclaimer.text
                })
            })
        })
    });
};
module.exports["CustomDisclaimer"] = $72eaa8705263e129$export$2cebd3bbd14f5ea6;

});

parcelRegister("dPu8G", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2a06f57ccab0ea68$var$message = (0, $kSwu1.defineMessages)({
    backLabel: {
        id: "fabric.editor.ai.components.backIconButton.backLabel",
        defaultMessage: "Back"
    }
});
var $2a06f57ccab0ea68$export$2e2bcd8739ae039 = $2a06f57ccab0ea68$var$message;
module.exports["default"] = $2a06f57ccab0ea68$export$2e2bcd8739ae039;

});

parcelRegister("bsPKy", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $55700e0910c48bdf$var$message = (0, $kSwu1.defineMessages)({
    closePreviewLabel: {
        id: "fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final",
        defaultMessage: "Close preview"
    }
});
var $55700e0910c48bdf$export$2e2bcd8739ae039 = $55700e0910c48bdf$var$message;
module.exports["default"] = $55700e0910c48bdf$export$2e2bcd8739ae039;

});

parcelRegister("j9lWE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $220253aa54aa850d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    editPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.edit.hover",
        defaultMessage: "Edit"
    },
    clearPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.clear.hover",
        defaultMessage: "Clear"
    }
});
module.exports["messages"] = $220253aa54aa850d$export$defe85febe8b728c;

});

parcelRegister("j9bxK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3f9cd3bb40fbbd00$var$message = (0, $kSwu1.defineMessages)({
    removeLabel: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.removeLabel",
        defaultMessage: "Remove"
    },
    promptSelected: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.promptSelected",
        defaultMessage: "{promptName} - Selected"
    }
});
var $3f9cd3bb40fbbd00$export$2e2bcd8739ae039 = $3f9cd3bb40fbbd00$var$message;
module.exports["default"] = $3f9cd3bb40fbbd00$export$2e2bcd8739ae039;

});

parcelRegister("dXhIm", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8HKXv = parcelRequire("8HKXv");

var $clx8d = parcelRequire("clx8d");

const $88f9724b27efdf03$export$94d2d72df36bbb16 = [
    'en-US',
    'en-GB'
];
const $88f9724b27efdf03$export$17a6a815985c8621 = (locale)=>$88f9724b27efdf03$export$94d2d72df36bbb16.includes(locale);
// Numeric Date Formats for en-US
const $88f9724b27efdf03$var$NUMERIC_FORMATS_EN_US = [
    // ====================================================
    // Numeric Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'M/d/yyyy',
    'M-d-yyyy',
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    // Partial Dates (Numeric, no year – defaults to current year)
    'M/d'
];
// Numeric Date Formats for en-GB
const $88f9724b27efdf03$var$NUMERIC_FORMATS_EN_GB = [
    // ====================================================
    // Numeric Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'd/M/yyyy',
    'd-M-yyyy',
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    // Partial Dates (Numeric, no year – defaults to current year)
    'd/M'
];
// Shared Month Name Formats (used by both en-US and en-GB)
const $88f9724b27efdf03$var$SHARED_MONTH_NAME_FORMATS = [
    // ====================================================
    // Month Name Date Formats
    // ====================================================
    // Full Dates (4-digit year)
    'd MMM yyyy',
    'd MMMM yyyy',
    "MMMM d', 'yyyy",
    'MMMM d yyyy',
    "MMM d', 'yyyy",
    'MMM d yyyy',
    // Full Dates (Month Name and ordinals, year)
    "do 'of' MMMM yyyy",
    // Partial Dates (Month Name, no year – defaults to current year)
    'd MMMM',
    'd MMM',
    'MMMM d',
    'MMM d',
    'do MMMM',
    'do MMM',
    'MMMM do',
    'MMM do',
    "do 'of' MMMM",
    "do 'of' MMM"
];
const $88f9724b27efdf03$export$45f7fd8a58803cb5 = {
    'en-US': [
        ...$88f9724b27efdf03$var$NUMERIC_FORMATS_EN_US,
        ...$88f9724b27efdf03$var$SHARED_MONTH_NAME_FORMATS
    ],
    'en-GB': [
        ...$88f9724b27efdf03$var$NUMERIC_FORMATS_EN_GB,
        ...$88f9724b27efdf03$var$SHARED_MONTH_NAME_FORMATS
    ]
};
const $88f9724b27efdf03$export$1ff91fc1b670f83b = {
    'en-US': (0, $clx8d.default),
    'en-GB': (0, $8HKXv.default)
};
module.exports["isSupportedLocale"] = $88f9724b27efdf03$export$17a6a815985c8621;
module.exports["DATE_FORMATS_BY_LOCALE_LIST"] = $88f9724b27efdf03$export$45f7fd8a58803cb5;
module.exports["LOCALES_LIST"] = $88f9724b27efdf03$export$1ff91fc1b670f83b;

});


//# sourceMappingURL=FullPageEditorComponent.165289a9.js.map
